/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://sandbrock-wp-assets.s3.amazonaws.com/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 99);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(37);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bed.svg?ae39f054eea0463b64f965837207ae5c";

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bath.svg?9561518b048234e17b0b66177635293e";

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "car.svg?8cd359034128ab07391a1a781b605edf";

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd21a64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(255);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd21a64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "next.svg?8b9b04837db3868482ca7725b6854615";

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
var axios = __webpack_require__(19);

var instance = axios.create({
  baseURL: "https://r6api.runwayproptech.com/runwaywsrest",
  headers: {
    'content-type': 'application/json',
    'securitytoken': "1607571860183428086352053805438377251616432916535",
    'Authorization': "Basic aG93YXJkaHVnaGVzcjZhcGk6SDB3YXJkMTczODU=",
    'accept': 'application/json'
  },
  data: {}
});

var instancev1 = axios.create({
  baseURL: "https://r6api.runwayproptech.com/runwaywsrest" + '_v1',
  headers: {
    'content-type': 'application/json',
    'securitytoken': "1607571860183428086352053805438377251616432916535",
    'Authorization': "Basic aG93YXJkaHVnaGVzcjZhcGk6SDB3YXJkMTczODU=",
    'accept': 'application/json'
  },
  data: {}
});

var pipelineInstance = axios.create({
  baseURL: "https://pipeline.runwayproptech.com",
  headers: {
    'content-type': 'application/json',
    'securitytoken': "1607571860183428086352053805438377251616432916535",
    'accept': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  data: {}
});

var fetchVpbInstance = axios.create({
  baseURL: "https://pipeline.runwayproptech.com",
  headers: {
    'content-type': 'application/json',
    'securitytoken': "1607571860183428086352053805438377251616432916535",
    'Authorization': "Basic aG93YXJkaHVnaGVzcjZhcGk6SDB3YXJkMTczODU="
  },
  data: {}
});

var trackingInstance = axios.create({
  baseURL: 'https://g11jbxr01k.execute-api.us-east-1.amazonaws.com/live/ustrackingservice/',
  headers: {
    'content-type': 'application/json',
    'x-api-key': 'OrXxHpntdY8ijxAM11Hkc1QGEeqarRJB3P6frMQm',
    'accept': 'application/json'
  },
  data: {}
});

var clientId = "730253786";
var estateCpId = "6683351610355423371";
var estateId = "6415636324453127871067414824255624701610355423180";
var capsuleId = "718850824";
var hutk = '';

var api = {
  fetchMasterplanConfig: function fetchMasterplanConfig() {
    return instance.get('/masterplanapi/masterplan/config/get?estatecpid=' + estateCpId, { data: {} });
  },

  fetchHomeGeojson: function fetchHomeGeojson() {
    return pipelineInstance.get('/siting/geolocation/estate/' + estateCpId + '/packages');
  },

  fetchLotSummary: function fetchLotSummary() {
    var modelHomeAPi = instance.get('/houseandlandapi/houseandlandsummary/list?statusid=4200111562122316041', { data: {} });
    var landApi = instancev1.get('/landapi/landsimplesummary/list?estatecpid=' + estateId, { data: {} });
    return axios.all([modelHomeAPi, landApi]).then(axios.spread(function () {
      for (var _len = arguments.length, responses = Array(_len), _key = 0; _key < _len; _key++) {
        responses[_key] = arguments[_key];
      }

      return {
        lotsummary: responses[1].data,
        homesummary: responses[0].data
      };
    }));
  },

  fetchCompatibleLotSummaryList: function fetchCompatibleLotSummaryList(homeid) {
    console.log(homeid);
    var homeApi = instance.get('/homeapi/homesummary/get?clientproductid=' + homeid.homeid, { data: {} });
    var landApi = instance.get('/homeapi/compatiblelands/simple/list?estatecpid=' + estateCpId + '&plancpid=' + homeid.plancpid, { data: {} });

    // return instance.get('/landapi/landsummary/list?estatecpid=' + estateId + '&plancpid=' + homeid.homeid + '&facadecpid=' + homeid.facadeid, {data: {}});
    return axios.all([homeApi, landApi]).then(axios.spread(function () {
      for (var _len2 = arguments.length, responses = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        responses[_key2] = arguments[_key2];
      }

      return {
        homesummary: responses[0].data,
        lotsummary: responses[1].data
      };
    }));
  },

  fetchHomeSummaryList: function fetchHomeSummaryList() {
    return instance.get('/homeapi/compatiblehomesummary/list', { data: {} });
  },

  fetchHomeSummaryDetail: function fetchHomeSummaryDetail(id) {
    return instance.get('/homeapi/homesummary/get?clientproductid=' + id, { data: {} });
  },

  createPackage: function createPackage(data) {
    return instance.post('/houseandlandapi/houseandland/create', data);
  },

  getSpecHomesList: function getSpecHomesList() {
    return instance.get('/houseandlandapi/houseandlandsummary/list?estatecpid=' + estateId + '&spechome=true' + '&statusid=7033741562122316063', { data: {} });
  },

  getPackageDetail: function getPackageDetail(id) {
    return instance.get('/houseandlandapi/houseandlandsummary/get?clientproductid=' + id, { data: {} });
  },

  getPackageDetailList: function getPackageDetailList() {
    return instance.get('houseandlandapi/houseandlandsummary/list?estatecpid=' + estateId, { data: {} });
  },

  getDesignSummaryDetail: function getDesignSummaryDetail(id) {
    return instance.get('/homeapi/designsummary/get?clientproductid=' + id, { data: {} });
  },

  publishContact: function publishContact(formData) {
    formData.clientid = clientId;
    formData.capsuleid = capsuleId;
    return instance.post('/crmapi/contact/publish', formData);
  },

  publishToHubspot: function publishToHubspot(formData) {
    var url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + "4151365" + '/' + "705623a9-d6de-419e-8149-c00478c26bf8";
    return axios.post(url, formData);
  },

  fetchClient: function fetchClient(clientId) {
    return instance.get('/clientapi/get?clientid=' + clientId, { data: {} });
  },

  fetchLotSummaryV2: function fetchLotSummaryV2(lotCpId) {
    return instance.get('/landapi-v2/landsummary/get?lotcpid=' + lotCpId, { data: {} });
  },

  fetchPartnerSummaryList: function fetchPartnerSummaryList(clientId, clientCompanyId) {
    return instance.get('/crmapi/partnersummary/list?clientid=' + clientId + '&clientcompanyid=' + clientCompanyId, { data: {} });
  },

  fetchCompatibleHomeSummaryListByLotCpIdAndOwnerCcId: function fetchCompatibleHomeSummaryListByLotCpIdAndOwnerCcId(lotCpId, ownerCcId) {
    return instance.get('/homeapi/compatiblehomesummary/list?lotcpid=' + lotCpId + '&ownerccid=' + ownerCcId, { data: {} });
    // return instance.get(`/homeapi/compatiblehomesummary/list?lotcpid=${lotCpId}`, {data: {}});
  },

  fetchPackageGeojson: function fetchPackageGeojson() {
    return pipelineInstance.get('/siting/geolocation/estate/' + estateCpId + '/packages?clearCache=false&cache=true', { data: {} });
  },

  fetchLotGeojson: function fetchLotGeojson() {
    return pipelineInstance.get('/siting/geolocation/estate/' + estateCpId + '/lots?clearCache=false&cache=true', { data: {} });
  },

  fetchHandlSummaryList: function fetchHandlSummaryList() {
    var estateCpId = estateId; // estatesummaryview returns clientproductid for estatecpid
    return instance.get('/houseandlandapi/houseandlandsummary/list?clientid=' + clientId + '&estatecpid=' + estateCpId, { data: {} });
  },

  listSalesProcessByPackageCpId: function listSalesProcessByPackageCpId(id) {
    return fetchVpbInstance.get('/runwaywsrest/processapi/salesprocess/listbypackagecpid?packagecpid=' + id);
  },


  fetchPackageGeojsonAndHandlSummaryList: function fetchPackageGeojsonAndHandlSummaryList() {
    var packageGeoJson = this.fetchPackageGeojson();
    var handlSummaryList = this.fetchHandlSummaryList();
    return axios.all([packageGeoJson, handlSummaryList]).then(axios.spread(function () {
      for (var _len3 = arguments.length, responses = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        responses[_key3] = arguments[_key3];
      }

      return {
        packageGeoJson: responses[0].data,
        handlSummaryList: responses[1].data
      };
    }));
  },

  postTracking: function postTracking(url, data) {
    return trackingInstance.post(url, data);
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = {"success":true,"messages":[],"geoJson":{"type":"FeatureCollection","features":[{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9084141,33.2616847],[-96.9084019,33.2617],[-96.9083713,33.2617377],[-96.9082924,33.2618298],[-96.9082924,33.2618298],[-96.9079617,33.2616285],[-96.9079617,33.2616285],[-96.9080741,33.2614939],[-96.9080741,33.2614939],[-96.9084141,33.2616847],[-96.9084141,33.2616847]]]},"properties":{"lotName":"9-A-5","lotCpId":"5638881610357575648","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9085265,33.2615464],[-96.9084392,33.2616536],[-96.9084141,33.2616847],[-96.9084141,33.2616847],[-96.9080741,33.2614939],[-96.9080741,33.2614939],[-96.9081936,33.2613479],[-96.9081936,33.2613479],[-96.9085265,33.2615464],[-96.9085265,33.2615464]]]},"properties":{"lotName":"9-A-6","lotCpId":"2108871610357575676","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9086428,33.2614172],[-96.9085265,33.2615464],[-96.9085265,33.2615464],[-96.9081936,33.2613479],[-96.9081936,33.2613479],[-96.9083208,33.2612059],[-96.9083208,33.2612059],[-96.9086428,33.2614172],[-96.9086428,33.2614172]]]},"properties":{"lotName":"9-A-7","lotCpId":"1566611610357575210","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9087656,33.2612922],[-96.9086428,33.2614172],[-96.9086428,33.2614172],[-96.9083208,33.2612059],[-96.9083208,33.2612059],[-96.9084556,33.2610686],[-96.9084556,33.2610686],[-96.9087656,33.2612922],[-96.9087656,33.2612922]]]},"properties":{"lotName":"9-A-8","lotCpId":"6227541610357575140","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9088949,33.2611722],[-96.9087656,33.2612922],[-96.9087656,33.2612922],[-96.9084556,33.2610686],[-96.9084556,33.2610686],[-96.9085975,33.2609371],[-96.9085975,33.2609371],[-96.9088949,33.2611722],[-96.9088949,33.2611722]]]},"properties":{"lotName":"9-A-9","lotCpId":"2275701610357575145","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9090346,33.2610544],[-96.9090237,33.2610631],[-96.9090098,33.2610744],[-96.9089759,33.2611023],[-96.9088949,33.2611722],[-96.9088949,33.2611722],[-96.9085975,33.2609371],[-96.9085975,33.2609371],[-96.9087476,33.2608103],[-96.9087476,33.2608103],[-96.9090346,33.2610544],[-96.9090346,33.2610544]]]},"properties":{"lotName":"9-A-10","lotCpId":"1343501610357575132","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9091869,33.2609171],[-96.9091729,33.2609305],[-96.9091369,33.2609644],[-96.9090346,33.2610544],[-96.9090346,33.2610544],[-96.9087476,33.2608103],[-96.9087476,33.2608103],[-96.9088753,33.2606953],[-96.9088753,33.2606953],[-96.9091869,33.2609171],[-96.9091869,33.2609171]]]},"properties":{"lotName":"9-A-11","lotCpId":"7005431610357575615","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.909325,33.2607692],[-96.9093122,33.260784],[-96.9092793,33.260821],[-96.9091869,33.2609171],[-96.9091869,33.2609171],[-96.9088753,33.2606953],[-96.9088753,33.2606953],[-96.908991,33.2605711],[-96.908991,33.2605711],[-96.909325,33.2607692],[-96.909325,33.2607692]]]},"properties":{"lotName":"9-A-12","lotCpId":"6582721610357575146","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9094462,33.2606113],[-96.9094328,33.2606297],[-96.9094004,33.2606734],[-96.9093606,33.2607256],[-96.909325,33.2607692],[-96.909325,33.2607692],[-96.908991,33.2605711],[-96.908991,33.2605711],[-96.909093,33.2604388],[-96.909093,33.2604388],[-96.9094462,33.2606113],[-96.9094462,33.2606113]]]},"properties":{"lotName":"9-A-13","lotCpId":"4275301610357575615","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9095504,33.2604456],[-96.9095418,33.2604611],[-96.9095188,33.2605007],[-96.9094462,33.2606113],[-96.9094462,33.2606113],[-96.909093,33.2604388],[-96.909093,33.2604388],[-96.9091804,33.2602996],[-96.9091804,33.2602996],[-96.9095504,33.2604456],[-96.9095504,33.2604456]]]},"properties":{"lotName":"9-A-14","lotCpId":"2826881610357575135","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9096372,33.2602727],[-96.9096294,33.2602898],[-96.9096091,33.2603327],[-96.9095504,33.2604456],[-96.9095504,33.2604456],[-96.9091804,33.2602996],[-96.9091804,33.2602996],[-96.909253,33.2601545],[-96.909253,33.2601545],[-96.9096372,33.2602727],[-96.9096372,33.2602727]]]},"properties":{"lotName":"9-A-15","lotCpId":"4610151610357575152","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9097048,33.2600938],[-96.9096992,33.2601114],[-96.909684,33.2601556],[-96.9096372,33.2602727],[-96.9096372,33.2602727],[-96.909253,33.2601545],[-96.909253,33.2601545],[-96.9093097,33.2600048],[-96.9093097,33.2600048],[-96.9097048,33.2600938],[-96.9097048,33.2600938]]]},"properties":{"lotName":"9-A-16","lotCpId":"2251051610357575133","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.909754,33.2599108],[-96.9097494,33.2599302],[-96.9097377,33.2599777],[-96.9097048,33.2600938],[-96.9097048,33.2600938],[-96.9093097,33.2600048],[-96.9093097,33.2600048],[-96.9093506,33.2598514],[-96.9093506,33.2598514],[-96.909754,33.2599108],[-96.909754,33.2599108]]]},"properties":{"lotName":"9-A-17","lotCpId":"8346871610357575198","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9097829,33.259725],[-96.909781,33.2597431],[-96.9097756,33.2597888],[-96.909754,33.2599108],[-96.909754,33.2599108],[-96.9093506,33.2598514],[-96.9093506,33.2598514],[-96.9093752,33.2596954],[-96.9093752,33.2596954],[-96.9097829,33.259725],[-96.9097829,33.259725]]]},"properties":{"lotName":"9-A-18","lotCpId":"5132001610357575664","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9097927,33.2595379],[-96.9097925,33.259556],[-96.9097914,33.2596017],[-96.9097829,33.259725],[-96.9097829,33.259725],[-96.9093752,33.2596954],[-96.9093752,33.2596954],[-96.9093834,33.2595384],[-96.9093834,33.2595384],[-96.9097927,33.2595379],[-96.9097927,33.2595379]]]},"properties":{"lotName":"9-A-19","lotCpId":"7821851610357575178","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9097922,33.2593736],[-96.9097927,33.2595379],[-96.9097927,33.2595379],[-96.9093834,33.2595384],[-96.9093834,33.2595384],[-96.9093828,33.2593741],[-96.9093828,33.2593741],[-96.9097922,33.2593736],[-96.9097922,33.2593736]]]},"properties":{"lotName":"9-A-20","lotCpId":"8808401610357575188","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9105044,33.2631459],[-96.9106283,33.2632326],[-96.9106283,33.2632326],[-96.9103925,33.2634996],[-96.9103925,33.2634996],[-96.9102523,33.2634014],[-96.9102441,33.2633951],[-96.9102441,33.2633951],[-96.9105044,33.2631459],[-96.9105044,33.2631459]]]},"properties":{"lotName":"9-B-17","lotCpId":"2886771610357575392","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9103827,33.2630528],[-96.910398,33.2630651],[-96.9105044,33.2631459],[-96.9105044,33.2631459],[-96.9102441,33.2633951],[-96.9102441,33.2633951],[-96.9101207,33.2633015],[-96.9101087,33.263291],[-96.9101087,33.263291],[-96.9103827,33.2630528],[-96.9103827,33.2630528]]]},"properties":{"lotName":"9-B-18","lotCpId":"2228281610357575387","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9102719,33.2629551],[-96.9102804,33.2629636],[-96.9103038,33.2629858],[-96.9103827,33.2630528],[-96.9103827,33.2630528],[-96.9101087,33.263291],[-96.9101087,33.263291],[-96.909987,33.2631861],[-96.9099734,33.2631724],[-96.9099734,33.2631724],[-96.9102719,33.2629551],[-96.9102719,33.2629551]]]},"properties":{"lotName":"9-B-19","lotCpId":"4040001610357575428","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9101715,33.2628502],[-96.9101774,33.2628576],[-96.9101958,33.2628787],[-96.910227,33.2629118],[-96.9102719,33.2629551],[-96.9102719,33.2629551],[-96.9099734,33.2631724],[-96.9099734,33.2631724],[-96.9098653,33.2630615],[-96.9098517,33.2630441],[-96.9098517,33.2630441],[-96.9101715,33.2628502],[-96.9101715,33.2628502]]]},"properties":{"lotName":"9-B-20","lotCpId":"1437301610357576241","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9100831,33.2627375],[-96.9100892,33.2627466],[-96.9101069,33.2627712],[-96.9101715,33.2628502],[-96.9101715,33.2628502],[-96.9098517,33.2630441],[-96.9098517,33.2630441],[-96.9097578,33.2629282],[-96.9097441,33.2629077],[-96.9097441,33.2629077],[-96.9100831,33.2627375],[-96.9100831,33.2627375]]]},"properties":{"lotName":"9-B-21","lotCpId":"5350741610357575408","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9100055,33.2626194],[-96.9100113,33.2626292],[-96.9100275,33.2626555],[-96.9100831,33.2627375],[-96.9100831,33.2627375],[-96.9097441,33.2629077],[-96.9097441,33.2629077],[-96.9096646,33.2627873],[-96.9096492,33.2627639],[-96.9096492,33.2627639],[-96.9100055,33.2626194],[-96.9100055,33.2626194]]]},"properties":{"lotName":"9-B-22","lotCpId":"6328211610357576094","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9099226,33.2624846],[-96.9099325,33.2624996],[-96.909956,33.2625357],[-96.9100055,33.2626194],[-96.9100055,33.2626194],[-96.9096492,33.2627639],[-96.9096492,33.2627639],[-96.9095897,33.2626658],[-96.9095755,33.2626448],[-96.9095755,33.2626448],[-96.9099226,33.2624846],[-96.9099226,33.2624846]]]},"properties":{"lotName":"9-B-23","lotCpId":"3255031610357575549","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9098309,33.2623537],[-96.90984,33.262366],[-96.9098627,33.2623976],[-96.9099226,33.2624846],[-96.9099226,33.2624846],[-96.9095755,33.2626448],[-96.9095755,33.2626448],[-96.9095078,33.2625472],[-96.9094931,33.2625296],[-96.9094931,33.2625296],[-96.9098309,33.2623537],[-96.9098309,33.2623537]]]},"properties":{"lotName":"9-B-24","lotCpId":"3103101610357576004","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.909731,33.2622268],[-96.909742,33.2622402],[-96.9097686,33.2622731],[-96.9098309,33.2623537],[-96.9098309,33.2623537],[-96.9094931,33.2625296],[-96.9094931,33.2625296],[-96.9094189,33.2624322],[-96.9094058,33.2624166],[-96.9094058,33.2624166],[-96.909731,33.2622268],[-96.909731,33.2622268]]]},"properties":{"lotName":"9-B-25","lotCpId":"8476141610357575423","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9096235,33.2621045],[-96.9096336,33.2621153],[-96.9096594,33.2621436],[-96.909731,33.2622268],[-96.909731,33.2622268],[-96.9094058,33.2624166],[-96.9094058,33.2624166],[-96.9093228,33.2623213],[-96.9093103,33.2623085],[-96.9093103,33.2623085],[-96.9096235,33.2621045],[-96.9096235,33.2621045]]]},"properties":{"lotName":"9-B-26","lotCpId":"2115771610357576097","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9095084,33.2619872],[-96.9095204,33.261999],[-96.9095499,33.2620284],[-96.9096235,33.2621045],[-96.9096235,33.2621045],[-96.9093103,33.2623085],[-96.9093103,33.2623085],[-96.9092197,33.2622149],[-96.9092082,33.2622044],[-96.9092082,33.2622044],[-96.9095084,33.2619872],[-96.9095084,33.2619872]]]},"properties":{"lotName":"9-B-27","lotCpId":"8510321610357575477","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9093861,33.2618754],[-96.9093995,33.2618873],[-96.9094321,33.2619163],[-96.9095084,33.2619872],[-96.9095084,33.2619872],[-96.9092082,33.2622044],[-96.9092082,33.2622044],[-96.90911,33.2621132],[-96.9091001,33.262105],[-96.9091001,33.262105],[-96.9093861,33.2618754],[-96.9093861,33.2618754]]]},"properties":{"lotName":"9-B-28","lotCpId":"6038471610357576775","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9092568,33.2617686],[-96.9092719,33.2617808],[-96.9093078,33.2618099],[-96.9093506,33.2618451],[-96.9093861,33.2618754],[-96.9093861,33.2618754],[-96.9091001,33.262105],[-96.9091001,33.262105],[-96.9089937,33.2620169],[-96.9089855,33.2620105],[-96.9089855,33.2620105],[-96.9092568,33.2617686],[-96.9092568,33.2617686]]]},"properties":{"lotName":"9-B-29","lotCpId":"8850801610357575393","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9091214,33.2616678],[-96.9091354,33.2616777],[-96.90917,33.2617027],[-96.9092568,33.2617686],[-96.9092568,33.2617686],[-96.9089855,33.2620105],[-96.9089855,33.2620105],[-96.9088715,33.2619256],[-96.9088655,33.2619215],[-96.9088655,33.2619215],[-96.9091214,33.2616678],[-96.9091214,33.2616678]]]},"properties":{"lotName":"9-B-30","lotCpId":"6365001610357576496","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9089844,33.261576],[-96.9090292,33.2616052],[-96.9090385,33.2616114],[-96.9090617,33.2616268],[-96.9091214,33.2616678],[-96.9091214,33.2616678],[-96.9088655,33.2619215],[-96.9088655,33.2619215],[-96.9087443,33.2618398],[-96.9087394,33.2618362],[-96.9087394,33.2618362],[-96.9089844,33.261576],[-96.9089844,33.261576]]]},"properties":{"lotName":"9-B-31","lotCpId":"6316751610357575395","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.908836,33.2614784],[-96.9089844,33.261576],[-96.9089844,33.261576],[-96.9087394,33.2618362],[-96.9087394,33.2618362],[-96.9085757,33.2617289],[-96.9085757,33.2617289],[-96.908581,33.2617224],[-96.9085957,33.2617044],[-96.908647,33.2616429],[-96.9087896,33.2614825],[-96.908836,33.2614784],[-96.908836,33.2614784]]]},"properties":{"lotName":"9-B-32","lotCpId":"3123001610357576763","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9104727,33.262847],[-96.9104907,33.2628352],[-96.9105432,33.2628059],[-96.9106281,33.2627676],[-96.9107434,33.2627292],[-96.9107434,33.2627292],[-96.9108641,33.263045],[-96.9108641,33.263045],[-96.9107658,33.2631491],[-96.9107658,33.2631491],[-96.9107441,33.2631348],[-96.9106865,33.2630956],[-96.9106048,33.2630372],[-96.9105104,33.2629652],[-96.9104931,33.2629525],[-96.9104656,33.2629287],[-96.9104589,33.2629219],[-96.9104482,33.2629039],[-96.910448,33.2628778],[-96.9104727,33.262847],[-96.9104727,33.262847]]]},"properties":{"lotName":"9-J-1","lotCpId":"5852171610357576846","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9110005,33.2626936],[-96.9110204,33.2626937],[-96.9110688,33.2626948],[-96.9111828,33.2627064],[-96.9112363,33.2627146],[-96.9112363,33.2627146],[-96.9111642,33.2630377],[-96.9111642,33.2630377],[-96.9110081,33.263025],[-96.9110081,33.263025],[-96.9110005,33.2626936],[-96.9110005,33.2626936]]]},"properties":{"lotName":"9-J-3","lotCpId":"6464451610357577076","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9107434,33.2627292],[-96.9107636,33.262724],[-96.9108185,33.2627122],[-96.9109002,33.2627001],[-96.9110005,33.2626936],[-96.9110005,33.2626936],[-96.9110081,33.263025],[-96.9110081,33.263025],[-96.9108641,33.263045],[-96.9108641,33.263045],[-96.9107434,33.2627292],[-96.9107434,33.2627292]]]},"properties":{"lotName":"9-J-2","lotCpId":"7301841610357576856","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.910959,33.2622619],[-96.9109687,33.2622725],[-96.9109815,33.2622866],[-96.9110133,33.2623279],[-96.9110537,33.2623956],[-96.9110928,33.2624885],[-96.9110928,33.2624885],[-96.9110942,33.2624983],[-96.911091,33.2625203],[-96.9110726,33.2625436],[-96.9110285,33.2625572],[-96.9109991,33.2625571],[-96.9109216,33.2625606],[-96.9108115,33.2625735],[-96.9106845,33.2626015],[-96.9106845,33.2626015],[-96.9106146,33.2624773],[-96.9106146,33.2624773],[-96.910959,33.2622619],[-96.910959,33.2622619]]]},"properties":{"lotName":"9-C-13","lotCpId":"2452471610357575404","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9108613,33.262152],[-96.910959,33.2622619],[-96.910959,33.2622619],[-96.9106146,33.2624773],[-96.9106146,33.2624773],[-96.9105437,33.2623505],[-96.9105437,33.2623505],[-96.9108613,33.262152],[-96.9108613,33.262152]]]},"properties":{"lotName":"9-C-14","lotCpId":"2210631610357576531","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9107631,33.2620424],[-96.9108613,33.262152],[-96.9108613,33.262152],[-96.9105437,33.2623505],[-96.9105437,33.2623505],[-96.910446,33.2622409],[-96.910446,33.2622409],[-96.9107631,33.2620424],[-96.9107631,33.2620424]]]},"properties":{"lotName":"9-C-15","lotCpId":"6642571610357575422","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9106649,33.2619329],[-96.9107631,33.2620424],[-96.9107631,33.2620424],[-96.910446,33.2622409],[-96.910446,33.2622409],[-96.9103789,33.2621666],[-96.9103478,33.2621314],[-96.9103478,33.2621314],[-96.9106649,33.2619329],[-96.9106649,33.2619329]]]},"properties":{"lotName":"9-C-16","lotCpId":"2726381610357576289","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9105666,33.2618234],[-96.9106649,33.2619329],[-96.9106649,33.2619329],[-96.9103478,33.2621314],[-96.9103478,33.2621314],[-96.9102648,33.2620392],[-96.9102495,33.2620219],[-96.9102495,33.2620219],[-96.9105666,33.2618234],[-96.9105666,33.2618234]]]},"properties":{"lotName":"9-C-17","lotCpId":"7381551610357575525","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9104684,33.2617139],[-96.9105666,33.2618234],[-96.9105666,33.2618234],[-96.9102495,33.2620219],[-96.9102495,33.2620219],[-96.9101507,33.2619124],[-96.9101507,33.2619124],[-96.9104684,33.2617139],[-96.9104684,33.2617139]]]},"properties":{"lotName":"9-C-18","lotCpId":"2028401610357575980","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9103647,33.2615993],[-96.9103785,33.2616137],[-96.9103981,33.2616348],[-96.910428,33.2616682],[-96.9104684,33.2617139],[-96.9104684,33.2617139],[-96.9101507,33.2619124],[-96.9101507,33.2619124],[-96.910053,33.2618047],[-96.910053,33.2618047],[-96.9103647,33.2615993],[-96.9103647,33.2615993]]]},"properties":{"lotName":"9-C-19","lotCpId":"3021481610357575395","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9102533,33.2614857],[-96.9102651,33.2614974],[-96.9102941,33.2615265],[-96.9103647,33.2615993],[-96.9103647,33.2615993],[-96.910053,33.2618047],[-96.910053,33.2618047],[-96.9100367,33.2617864],[-96.909951,33.2617011],[-96.909951,33.2617011],[-96.9102533,33.2614857],[-96.9102533,33.2614857]]]},"properties":{"lotName":"9-C-20","lotCpId":"4035501610357576073","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9101366,33.2613752],[-96.9101488,33.2613865],[-96.910179,33.2614145],[-96.9102533,33.2614857],[-96.9102533,33.2614857],[-96.909951,33.2617011],[-96.909951,33.2617011],[-96.9099155,33.2616655],[-96.9098446,33.2616007],[-96.9098446,33.2616007],[-96.9101366,33.2613752],[-96.9101366,33.2613752]]]},"properties":{"lotName":"9-C-21","lotCpId":"2368221610357575395","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9100143,33.2612689],[-96.9100285,33.261281],[-96.9100625,33.2613101],[-96.9101029,33.2613452],[-96.9101366,33.2613752],[-96.9101366,33.2613752],[-96.9098446,33.2616007],[-96.9098446,33.2616007],[-96.9097873,33.2615487],[-96.9097332,33.2615039],[-96.9097332,33.2615039],[-96.9100143,33.2612689],[-96.9100143,33.2612689]]]},"properties":{"lotName":"9-C-22","lotCpId":"3321421610357576121","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9098871,33.2611667],[-96.9099028,33.2611791],[-96.9099396,33.2612083],[-96.9099819,33.2612422],[-96.9100143,33.2612689],[-96.9100143,33.2612689],[-96.9097332,33.2615039],[-96.9097332,33.2615039],[-96.909653,33.2614378],[-96.9096175,33.2614108],[-96.9096175,33.2614108],[-96.9098871,33.2611667],[-96.9098871,33.2611667]]]},"properties":{"lotName":"9-C-23","lotCpId":"7713631610357575385","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9097551,33.261069],[-96.9097709,33.2610805],[-96.9098083,33.2611078],[-96.9098522,33.2611401],[-96.9098871,33.2611667],[-96.9098871,33.2611667],[-96.9096175,33.2614108],[-96.9096175,33.2614108],[-96.9095127,33.2613319],[-96.909498,33.2613214],[-96.909498,33.2613214],[-96.9097551,33.261069],[-96.9097551,33.261069]]]},"properties":{"lotName":"9-C-24","lotCpId":"5840211610357576533","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9096186,33.2609759],[-96.9096343,33.2609864],[-96.9096717,33.2610115],[-96.9097551,33.261069],[-96.9097551,33.261069],[-96.909498,33.2613214],[-96.909498,33.2613214],[-96.9093741,33.2612365],[-96.9093741,33.2612365],[-96.9096186,33.2609759],[-96.9096186,33.2609759]]]},"properties":{"lotName":"9-C-25","lotCpId":"2425601610357575543","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9094696,33.2608819],[-96.909487,33.2608927],[-96.9095284,33.2609184],[-96.9095777,33.2609494],[-96.9096186,33.2609759],[-96.9096186,33.2609759],[-96.9093741,33.2612365],[-96.9093741,33.2612365],[-96.9091946,33.2611137],[-96.9091946,33.2611137],[-96.9092001,33.2611089],[-96.9092157,33.2610953],[-96.9092699,33.2610457],[-96.9093438,33.2609738],[-96.9094238,33.2608883],[-96.9094696,33.2608819],[-96.9094696,33.2608819]]]},"properties":{"lotName":"9-C-26","lotCpId":"7682221610357576045","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9091192,33.2614902],[-96.9089413,33.2613734],[-96.9089413,33.2613734],[-96.9089375,33.261336],[-96.9089563,33.2613189],[-96.9090045,33.2612758],[-96.909139,33.2611589],[-96.9091588,33.2611433],[-96.9091946,33.2611137],[-96.9091946,33.2611137],[-96.9093643,33.2612301],[-96.9093643,33.2612301],[-96.9091192,33.2614902],[-96.9091192,33.2614902]]]},"properties":{"lotName":"9-C-1","lotCpId":"1271641610357575390","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9092546,33.2615829],[-96.9092438,33.2615753],[-96.9092155,33.2615555],[-96.9091302,33.2614975],[-96.9091192,33.2614902],[-96.9091192,33.2614902],[-96.9093643,33.2612301],[-96.9093643,33.2612301],[-96.9095127,33.2613319],[-96.9095127,33.2613319],[-96.9092546,33.2615829],[-96.9092546,33.2615829]]]},"properties":{"lotName":"9-C-2","lotCpId":"2442101610357576393","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9093812,33.2616783],[-96.9093678,33.2616678],[-96.9093348,33.2616424],[-96.9092546,33.2615829],[-96.9092546,33.2615829],[-96.9095127,33.2613319],[-96.9095127,33.2613319],[-96.909653,33.2614378],[-96.909653,33.2614378],[-96.9093812,33.2616783],[-96.9093812,33.2616783]]]},"properties":{"lotName":"9-C-3","lotCpId":"2332381610357575384","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9095018,33.2617787],[-96.9094882,33.261767],[-96.9094555,33.2617393],[-96.9093812,33.2616783],[-96.9093812,33.2616783],[-96.909653,33.2614378],[-96.909653,33.2614378],[-96.9097873,33.2615487],[-96.9097873,33.2615487],[-96.9095018,33.2617787],[-96.9095018,33.2617787]]]},"properties":{"lotName":"9-C-4","lotCpId":"7804411610357576021","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9096175,33.2618836],[-96.9096047,33.2618717],[-96.9095738,33.2618432],[-96.9095018,33.2617787],[-96.9095018,33.2617787],[-96.9097873,33.2615487],[-96.9097873,33.2615487],[-96.9099155,33.2616655],[-96.9099155,33.2616655],[-96.9096175,33.2618836],[-96.9096175,33.2618836]]]},"properties":{"lotName":"9-C-5","lotCpId":"6021531610357575425","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9097267,33.2619931],[-96.9097131,33.2619792],[-96.9096812,33.2619469],[-96.9096449,33.2619103],[-96.9096175,33.2618836],[-96.9096175,33.2618836],[-96.9099155,33.2616655],[-96.9099155,33.2616655],[-96.9100367,33.2617864],[-96.9100367,33.2617864],[-96.9097267,33.2619931],[-96.9097267,33.2619931]]]},"properties":{"lotName":"9-C-6","lotCpId":"8056871610357575997","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9098298,33.2621068],[-96.9098197,33.2620951],[-96.9097941,33.2620661],[-96.9097267,33.2619931],[-96.9097267,33.2619931],[-96.9100367,33.2617864],[-96.9100367,33.2617864],[-96.9101507,33.2619124],[-96.9101507,33.2619124],[-96.9098298,33.2621068],[-96.9098298,33.2621068]]]},"properties":{"lotName":"9-C-7","lotCpId":"3878001610357575394","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9099264,33.2622241],[-96.9099171,33.2622123],[-96.9098935,33.2621828],[-96.9098298,33.2621068],[-96.9098298,33.2621068],[-96.9101507,33.2619124],[-96.9101507,33.2619124],[-96.9102648,33.2620392],[-96.9102648,33.2620392],[-96.9099264,33.2622241],[-96.9099264,33.2622241]]]},"properties":{"lotName":"9-C-8","lotCpId":"8864521610357575996","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9100165,33.262345],[-96.9100061,33.2623307],[-96.9099812,33.2622968],[-96.9099515,33.2622568],[-96.9099264,33.2622241],[-96.9099264,33.2622241],[-96.9102648,33.2620392],[-96.9102648,33.2620392],[-96.9103789,33.2621666],[-96.9103789,33.2621666],[-96.9100165,33.262345],[-96.9100165,33.262345]]]},"properties":{"lotName":"9-C-9","lotCpId":"8514801610357575401","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9100994,33.2624696],[-96.9100899,33.2624548],[-96.910067,33.2624197],[-96.9100396,33.2623784],[-96.9100165,33.262345],[-96.9100165,33.262345],[-96.9103789,33.2621666],[-96.9103789,33.2621666],[-96.9104946,33.2622957],[-96.9104946,33.2622957],[-96.9100994,33.2624696],[-96.9100994,33.2624696]]]},"properties":{"lotName":"9-C-10","lotCpId":"2486051610357576362","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9101764,33.2625978],[-96.9101661,33.2625819],[-96.9101535,33.2625595],[-96.9101472,33.2625488],[-96.9101322,33.2625235],[-96.9100994,33.2624696],[-96.9100994,33.2624696],[-96.9104946,33.2622957],[-96.9104946,33.2622957],[-96.9105437,33.2623505],[-96.9105824,33.2624198],[-96.9105824,33.2624198],[-96.9101764,33.2625978],[-96.9101764,33.2625978]]]},"properties":{"lotName":"9-C-11","lotCpId":"4143831610357575389","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9102714,33.2627302],[-96.9102621,33.2627189],[-96.9102387,33.2626891],[-96.9101764,33.2625978],[-96.9101764,33.2625978],[-96.9105824,33.2624198],[-96.9105824,33.2624198],[-96.9106845,33.2626015],[-96.9106845,33.2626015],[-96.9106566,33.2626092],[-96.9105836,33.2626339],[-96.9104813,33.2626778],[-96.9103658,33.2627429],[-96.9103569,33.2627475],[-96.9103342,33.2627541],[-96.9103037,33.2627519],[-96.9102714,33.2627302],[-96.9102714,33.2627302]]]},"properties":{"lotName":"9-C-12","lotCpId":"6567241610357576514","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9108859,33.2619516],[-96.9107691,33.2618211],[-96.9107691,33.2618211],[-96.9107756,33.2617828],[-96.9110665,33.2616007],[-96.9110665,33.2616007],[-96.911203,33.2617531],[-96.911203,33.2617531],[-96.9108859,33.2619516],[-96.9108859,33.2619516]]]},"properties":{"lotName":"9-I-1","lotCpId":"1343001610357577070","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9109929,33.2620712],[-96.9108859,33.2619516],[-96.9108859,33.2619516],[-96.911203,33.2617531],[-96.911203,33.2617531],[-96.91131,33.2618727],[-96.91131,33.2618727],[-96.9109929,33.2620712],[-96.9109929,33.2620712]]]},"properties":{"lotName":"9-I-2","lotCpId":"3454001610357576540","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9110997,33.2621905],[-96.9109929,33.2620712],[-96.9109929,33.2620712],[-96.91131,33.2618727],[-96.91131,33.2618727],[-96.9114169,33.2619918],[-96.9114169,33.2619918],[-96.9110997,33.2621905],[-96.9110997,33.2621905]]]},"properties":{"lotName":"9-I-3","lotCpId":"2563381610357577008","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9111833,33.262303],[-96.9111785,33.2622946],[-96.9111635,33.2622712],[-96.9111375,33.2622356],[-96.9110997,33.2621905],[-96.9110997,33.2621905],[-96.9114169,33.2619918],[-96.9114169,33.2619918],[-96.9115555,33.2621465],[-96.9115555,33.2621465],[-96.9111833,33.262303],[-96.9111833,33.262303]]]},"properties":{"lotName":"9-I-4","lotCpId":"4182261610357576522","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9112417,33.2624267],[-96.911237,33.2624141],[-96.9112242,33.2623827],[-96.9111833,33.262303],[-96.9111833,33.262303],[-96.9115555,33.2621465],[-96.9115555,33.2621465],[-96.9117029,33.2623112],[-96.9117029,33.2623112],[-96.9112417,33.2624267],[-96.9112417,33.2624267]]]},"properties":{"lotName":"9-I-5","lotCpId":"2086831610357576531","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9112716,33.2625428],[-96.9112701,33.2625324],[-96.911265,33.2625054],[-96.9112417,33.2624267],[-96.9112417,33.2624267],[-96.9117029,33.2623112],[-96.9117029,33.2623112],[-96.9116303,33.2626371],[-96.9116303,33.2626371],[-96.9113243,33.2625896],[-96.9113008,33.2625819],[-96.911283,33.2625678],[-96.9112716,33.2625428],[-96.9112716,33.2625428]]]},"properties":{"lotName":"9-I-6","lotCpId":"6314781610357576861","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9111517,33.261143],[-96.9111937,33.261189],[-96.9112663,33.2612703],[-96.9112663,33.2612703],[-96.9112597,33.2613086],[-96.9109683,33.2614912],[-96.9109683,33.2614912],[-96.9108373,33.2613451],[-96.9108373,33.2613451],[-96.9111517,33.261143],[-96.9111517,33.261143]]]},"properties":{"lotName":"9-D-10","lotCpId":"6178541610357575981","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9110387,33.2610248],[-96.9110523,33.2610388],[-96.9110845,33.2610721],[-96.911122,33.2611113],[-96.9111517,33.261143],[-96.9111517,33.261143],[-96.9108373,33.2613451],[-96.9108373,33.2613451],[-96.9108302,33.2613374],[-96.9107331,33.2612356],[-96.9107331,33.2612356],[-96.9110387,33.2610248],[-96.9110387,33.2610248]]]},"properties":{"lotName":"9-D-11","lotCpId":"4671761610357575506","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9109214,33.2609098],[-96.9109334,33.2609212],[-96.9109632,33.2609499],[-96.9110387,33.2610248],[-96.9110387,33.2610248],[-96.9107331,33.2612356],[-96.9107331,33.2612356],[-96.9107183,33.2612205],[-96.9106239,33.2611288],[-96.9106239,33.2611288],[-96.9109214,33.2609098],[-96.9109214,33.2609098]]]},"properties":{"lotName":"9-D-12","lotCpId":"2276041610357576768","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9107997,33.2607979],[-96.9108126,33.2608095],[-96.9108442,33.2608382],[-96.9109214,33.2609098],[-96.9109214,33.2609098],[-96.9106239,33.2611288],[-96.9106239,33.2611288],[-96.9106015,33.2611074],[-96.9105109,33.2610257],[-96.9105109,33.2610257],[-96.9107997,33.2607979],[-96.9107997,33.2607979]]]},"properties":{"lotName":"9-D-13","lotCpId":"5054141610357575390","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9106736,33.2606898],[-96.9106873,33.2607013],[-96.9107207,33.2607295],[-96.9107997,33.2607979],[-96.9107997,33.2607979],[-96.9105109,33.2610257],[-96.9105109,33.2610257],[-96.9104798,33.2609974],[-96.9103942,33.2609253],[-96.9103942,33.2609253],[-96.9106736,33.2606898],[-96.9106736,33.2606898]]]},"properties":{"lotName":"9-D-14","lotCpId":"7370001610357576270","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9105426,33.2605848],[-96.910556,33.2605953],[-96.9105893,33.2606214],[-96.9106736,33.2606898],[-96.9106736,33.2606898],[-96.9103942,33.2609253],[-96.9103942,33.2609253],[-96.9103538,33.2608915],[-96.910273,33.2608285],[-96.910273,33.2608285],[-96.9105426,33.2605848],[-96.9105426,33.2605848]]]},"properties":{"lotName":"9-D-15","lotCpId":"2726131610357575397","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9104083,33.260484],[-96.9104238,33.2604954],[-96.9104608,33.2605229],[-96.9105052,33.2605562],[-96.9105426,33.2605848],[-96.9105426,33.2605848],[-96.910273,33.2608285],[-96.910273,33.2608285],[-96.9102233,33.2607893],[-96.910148,33.260735],[-96.910148,33.260735],[-96.9104083,33.260484],[-96.9104083,33.260484]]]},"properties":{"lotName":"9-D-16","lotCpId":"5882201610357576100","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9102697,33.2603872],[-96.9102844,33.2603972],[-96.9103204,33.2604218],[-96.9104083,33.260484],[-96.9104083,33.260484],[-96.910148,33.260735],[-96.910148,33.260735],[-96.910088,33.2606912],[-96.9100198,33.2606451],[-96.9100198,33.2606451],[-96.9102697,33.2603872],[-96.9102697,33.2603872]]]},"properties":{"lotName":"9-D-17","lotCpId":"8368341610357575392","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9101267,33.2602941],[-96.9101427,33.2603044],[-96.9101813,33.2603292],[-96.9102697,33.2603872],[-96.9102697,33.2603872],[-96.9100198,33.2606451],[-96.9100198,33.2606451],[-96.9099488,33.2605971],[-96.9098866,33.2605606],[-96.9098866,33.2605606],[-96.9101267,33.2602941],[-96.9101267,33.2602941]]]},"properties":{"lotName":"9-D-18","lotCpId":"2566001610357577219","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9098855,33.2601645],[-96.9098971,33.2601688],[-96.9099277,33.2601813],[-96.9100205,33.2602288],[-96.9101267,33.2602941],[-96.9101267,33.2602941],[-96.9098866,33.2605606],[-96.9098866,33.2605606],[-96.9097212,33.260463],[-96.9097212,33.260463],[-96.9097246,33.2604567],[-96.9097338,33.260439],[-96.9097651,33.2603755],[-96.9098057,33.2602851],[-96.9098462,33.2601805],[-96.9098855,33.2601645],[-96.9098855,33.2601645]]]},"properties":{"lotName":"9-D-19","lotCpId":"7718201610357576226","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9097054,33.2608586],[-96.9095619,33.2607687],[-96.9095619,33.2607687],[-96.9095526,33.2607295],[-96.9095575,33.2607228],[-96.9095708,33.2607043],[-96.9096153,33.26064],[-96.9096706,33.2605538],[-96.9097212,33.260463],[-96.9097212,33.260463],[-96.9099488,33.2605971],[-96.9099488,33.2605971],[-96.9097054,33.2608586],[-96.9097054,33.2608586]]]},"properties":{"lotName":"9-D-1","lotCpId":"5351421610357575388","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9098337,33.2609453],[-96.9097054,33.2608586],[-96.9097054,33.2608586],[-96.9099488,33.2605971],[-96.9099488,33.2605971],[-96.910088,33.2606912],[-96.910088,33.2606912],[-96.9098337,33.2609453],[-96.9098337,33.2609453]]]},"properties":{"lotName":"9-D-2","lotCpId":"6647661610357576028","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9099581,33.2610357],[-96.9099416,33.2610236],[-96.9099037,33.2609958],[-96.9098619,33.2609654],[-96.9098337,33.2609453],[-96.9098337,33.2609453],[-96.910088,33.2606912],[-96.910088,33.2606912],[-96.9102233,33.2607893],[-96.9102233,33.2607893],[-96.9099581,33.2610357],[-96.9099581,33.2610357]]]},"properties":{"lotName":"9-D-3","lotCpId":"6237461610357575404","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9100782,33.2611297],[-96.9100639,33.2611183],[-96.9100301,33.2610915],[-96.9099904,33.2610603],[-96.9099581,33.2610357],[-96.9099581,33.2610357],[-96.9102233,33.2607893],[-96.9102233,33.2607893],[-96.9103538,33.2608915],[-96.9103538,33.2608915],[-96.9100782,33.2611297],[-96.9100782,33.2611297]]]},"properties":{"lotName":"9-D-4","lotCpId":"3804751610357576499","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9101944,33.2612269],[-96.9101813,33.2612158],[-96.9101498,33.2611891],[-96.9100782,33.2611297],[-96.9100782,33.2611297],[-96.9103538,33.2608915],[-96.9103538,33.2608915],[-96.9104798,33.2609974],[-96.9104798,33.2609974],[-96.9101944,33.2612269],[-96.9101944,33.2612269]]]},"properties":{"lotName":"9-D-5","lotCpId":"6327531610357575288","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9103063,33.2613282],[-96.9102946,33.2613173],[-96.9102658,33.2612907],[-96.9101944,33.2612269],[-96.9101944,33.2612269],[-96.9104798,33.2609974],[-96.9104798,33.2609974],[-96.9106015,33.2611074],[-96.9106015,33.2611074],[-96.9103063,33.2613282],[-96.9103063,33.2613282]]]},"properties":{"lotName":"9-D-6","lotCpId":"4623301610357576037","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9104138,33.2614323],[-96.9104009,33.2614197],[-96.9103706,33.26139],[-96.9103349,33.2613555],[-96.9103063,33.2613282],[-96.9103063,33.2613282],[-96.9106015,33.2611074],[-96.9106015,33.2611074],[-96.9107183,33.2612205],[-96.9107183,33.2612205],[-96.9104138,33.2614323],[-96.9104138,33.2614323]]]},"properties":{"lotName":"9-D-7","lotCpId":"7050181610357575405","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.910517,33.26154],[-96.910504,33.2615262],[-96.9104737,33.2614943],[-96.9104393,33.2614583],[-96.9104138,33.2614323],[-96.9104138,33.2614323],[-96.9107183,33.2612205],[-96.9107183,33.2612205],[-96.9108302,33.2613374],[-96.9108302,33.2613374],[-96.910517,33.26154],[-96.910517,33.26154]]]},"properties":{"lotName":"9-D-8","lotCpId":"7403721610357576362","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9106316,33.2616678],[-96.910559,33.2615865],[-96.910517,33.26154],[-96.910517,33.26154],[-96.9108302,33.2613374],[-96.9108302,33.2613374],[-96.9109683,33.2614912],[-96.9109683,33.2614912],[-96.9106774,33.2616732],[-96.9106316,33.2616678],[-96.9106316,33.2616678]]]},"properties":{"lotName":"9-D-9","lotCpId":"7307041610357575423","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9126258,33.2612867],[-96.9126391,33.2612918],[-96.9126771,33.2613042],[-96.9127367,33.26132],[-96.9128148,33.261335],[-96.9128148,33.261335],[-96.912742,33.2616605],[-96.912742,33.2616605],[-96.9124572,33.2616153],[-96.9124572,33.2616153],[-96.9126258,33.2612867],[-96.9126258,33.2612867]]]},"properties":{"lotName":"9-H-4","lotCpId":"2067601610357577097","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9124533,33.261205],[-96.9124677,33.2612138],[-96.9125061,33.2612354],[-96.9126258,33.2612867],[-96.9126258,33.2612867],[-96.9124572,33.2616153],[-96.9124572,33.2616153],[-96.9123425,33.2615975],[-96.9122012,33.2614971],[-96.9122012,33.2614971],[-96.9124533,33.261205],[-96.9124533,33.261205]]]},"properties":{"lotName":"9-H-3","lotCpId":"2666411610357576938","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9123065,33.2610941],[-96.9123186,33.2611054],[-96.912351,33.2611335],[-96.9124533,33.261205],[-96.9124533,33.261205],[-96.9122012,33.2614971],[-96.9122012,33.2614971],[-96.9121122,33.2614341],[-96.9120063,33.2613159],[-96.9120063,33.2613159],[-96.9123065,33.2610941],[-96.9123065,33.2610941]]]},"properties":{"lotName":"9-H-2","lotCpId":"6806151610357577082","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.912169,33.2609449],[-96.9122596,33.2610457],[-96.9122723,33.2610602],[-96.9123065,33.2610941],[-96.9123065,33.2610941],[-96.9120063,33.2613159],[-96.9120063,33.2613159],[-96.9118323,33.2611215],[-96.9118323,33.2611215],[-96.9121231,33.2609394],[-96.912169,33.2609449],[-96.912169,33.2609449]]]},"properties":{"lotName":"9-H-1","lotCpId":"1618601610357576493","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9119168,33.2606638],[-96.9119289,33.2606771],[-96.9119589,33.2607103],[-96.912032,33.2607916],[-96.912032,33.2607916],[-96.9120255,33.2608299],[-96.9117335,33.2610124],[-96.9117335,33.2610124],[-96.9116025,33.260865],[-96.9116025,33.260865],[-96.9119168,33.2606638],[-96.9119168,33.2606638]]]},"properties":{"lotName":"9-E-13","lotCpId":"8716421610357576566","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9118061,33.260546],[-96.9118193,33.2605599],[-96.9118506,33.2605929],[-96.9118873,33.2606318],[-96.9119168,33.2606638],[-96.9119168,33.2606638],[-96.9116025,33.260865],[-96.9116025,33.260865],[-96.9114982,33.260755],[-96.9114982,33.260755],[-96.9118061,33.260546],[-96.9118061,33.260546]]]},"properties":{"lotName":"9-E-14","lotCpId":"3844311610357575625","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9116914,33.260431],[-96.9117029,33.2604422],[-96.9117316,33.2604704],[-96.9118061,33.260546],[-96.9118061,33.260546],[-96.9114982,33.260755],[-96.9114982,33.260755],[-96.9114906,33.2607468],[-96.9113907,33.2606473],[-96.9113907,33.2606473],[-96.9116914,33.260431],[-96.9116914,33.260431]]]},"properties":{"lotName":"9-E-15","lotCpId":"5515001610357577021","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9115725,33.2603188],[-96.9115836,33.2603289],[-96.911612,33.2603552],[-96.9116914,33.260431],[-96.9116914,33.260431],[-96.9113907,33.2606473],[-96.9113907,33.2606473],[-96.9113744,33.2606314],[-96.9112794,33.2605419],[-96.9112794,33.2605419],[-96.9115725,33.2603188],[-96.9115725,33.2603188]]]},"properties":{"lotName":"9-E-16","lotCpId":"6017701610357575765","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9114502,33.2602097],[-96.911462,33.26022],[-96.9114918,33.2602462],[-96.9115725,33.2603188],[-96.9115725,33.2603188],[-96.9112794,33.2605419],[-96.9112794,33.2605419],[-96.9112543,33.2605191],[-96.9111642,33.2604397],[-96.9111642,33.2604397],[-96.9114502,33.2602097],[-96.9114502,33.2602097]]]},"properties":{"lotName":"9-E-17","lotCpId":"8157301610357576708","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9113241,33.2601029],[-96.9113379,33.2601144],[-96.9113714,33.2601425],[-96.9114502,33.2602097],[-96.9114502,33.2602097],[-96.9111642,33.2604397],[-96.9111642,33.2604397],[-96.9111304,33.2604096],[-96.9110458,33.2603398],[-96.9110458,33.2603398],[-96.9113241,33.2601029],[-96.9113241,33.2601029]]]},"properties":{"lotName":"9-E-18","lotCpId":"8325601610357575932","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9111942,33.2599998],[-96.9112089,33.2600111],[-96.911244,33.2600387],[-96.9113241,33.2601029],[-96.9113241,33.2601029],[-96.9110458,33.2603398],[-96.9110458,33.2603398],[-96.9110021,33.2603037],[-96.9109246,33.260243],[-96.9109246,33.260243],[-96.9111942,33.2599998],[-96.9111942,33.2599998]]]},"properties":{"lotName":"9-E-19","lotCpId":"1706321610357576765","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9110611,33.2598994],[-96.9110756,33.2599102],[-96.911111,33.2599365],[-96.9111942,33.2599998],[-96.9111942,33.2599998],[-96.9109246,33.260243],[-96.9109246,33.260243],[-96.9108701,33.2602006],[-96.9107997,33.260149],[-96.9107997,33.260149],[-96.9110611,33.2598994],[-96.9110611,33.2598994]]]},"properties":{"lotName":"9-E-20","lotCpId":"1737561610357575804","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9109246,33.2598022],[-96.9109381,33.2598115],[-96.910972,33.2598352],[-96.9110611,33.2598994],[-96.9110611,33.2598994],[-96.9107997,33.260149],[-96.9107997,33.260149],[-96.9107347,33.2601015],[-96.9106719,33.2600582],[-96.9106719,33.2600582],[-96.9109246,33.2598022],[-96.9109246,33.2598022]]]},"properties":{"lotName":"9-E-21","lotCpId":"7013711610357577089","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9107849,33.2597086],[-96.9108006,33.2597189],[-96.9108384,33.259744],[-96.9109246,33.2598022],[-96.9109246,33.2598022],[-96.9106719,33.2600582],[-96.9106719,33.2600582],[-96.9105955,33.2600052],[-96.910541,33.2599701],[-96.910541,33.2599701],[-96.9107849,33.2597086],[-96.9107849,33.2597086]]]},"properties":{"lotName":"9-E-22","lotCpId":"6533011610357575823","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9106425,33.2596178],[-96.9106589,33.2596281],[-96.9106982,33.2596529],[-96.9107452,33.2596829],[-96.9107849,33.2597086],[-96.9107849,33.2597086],[-96.910541,33.2599701],[-96.910541,33.2599701],[-96.9104531,33.2599131],[-96.9104067,33.2598852],[-96.9104067,33.2598852],[-96.9106425,33.2596178],[-96.9106425,33.2596178]]]},"properties":{"lotName":"9-E-23","lotCpId":"3262461610357577104","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9104809,33.2595247],[-96.9104899,33.2595295],[-96.9105129,33.259542],[-96.9105776,33.259579],[-96.9106425,33.2596178],[-96.9106425,33.2596178],[-96.9104067,33.2598852],[-96.9104067,33.2598852],[-96.9102954,33.2598186],[-96.9102719,33.2598076],[-96.9102719,33.2598076],[-96.9104809,33.2595247],[-96.9104809,33.2595247]]]},"properties":{"lotName":"9-E-24","lotCpId":"8103601610357575934","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9102965,33.2594421],[-96.9103175,33.2594507],[-96.9103679,33.259472],[-96.9104287,33.259499],[-96.9104809,33.2595247],[-96.9104809,33.2595247],[-96.9102719,33.2598076],[-96.9102719,33.2598076],[-96.9101316,33.2597433],[-96.9101316,33.2597433],[-96.9102965,33.2594421],[-96.9102965,33.2594421]]]},"properties":{"lotName":"9-E-25","lotCpId":"2267101610357576857","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9100385,33.2593642],[-96.9100653,33.2593706],[-96.9101315,33.2593879],[-96.9102965,33.2594421],[-96.9102965,33.2594421],[-96.9101316,33.2597433],[-96.9101316,33.2597433],[-96.9099466,33.2597305],[-96.9099466,33.2597305],[-96.9099482,33.2597124],[-96.9099517,33.2596663],[-96.9099564,33.2595384],[-96.9099559,33.259417],[-96.9099569,33.2594077],[-96.9099655,33.2593877],[-96.90999,33.2593692],[-96.9100385,33.2593642],[-96.9100385,33.2593642]]]},"properties":{"lotName":"9-E-26","lotCpId":"8838021610357576049","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9100803,33.260097],[-96.91007,33.2600914],[-96.9100398,33.2600764],[-96.9099911,33.260055],[-96.9099253,33.2600299],[-96.9099253,33.2600299],[-96.9099019,33.2599934],[-96.9099034,33.2599868],[-96.9099077,33.2599684],[-96.9099211,33.2599049],[-96.9099466,33.2597305],[-96.9099466,33.2597305],[-96.9101316,33.2597433],[-96.9102954,33.2598186],[-96.9102954,33.2598186],[-96.9100803,33.260097],[-96.9100803,33.260097]]]},"properties":{"lotName":"9-E-1","lotCpId":"1632651610357576858","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9102151,33.2601782],[-96.9101159,33.2601175],[-96.9101038,33.2601103],[-96.9100803,33.260097],[-96.9100803,33.260097],[-96.9102954,33.2598186],[-96.9102954,33.2598186],[-96.9104531,33.2599131],[-96.9104531,33.2599131],[-96.9102151,33.2601782],[-96.9102151,33.2601782]]]},"properties":{"lotName":"9-E-2","lotCpId":"6643281610357576050","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9103483,33.260264],[-96.9102151,33.2601782],[-96.9102151,33.2601782],[-96.9104531,33.2599131],[-96.9104531,33.2599131],[-96.9105955,33.2600052],[-96.9105955,33.2600052],[-96.9103483,33.260264],[-96.9103483,33.260264]]]},"properties":{"lotName":"9-E-3","lotCpId":"5155871610357576975","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9104782,33.2603539],[-96.9103483,33.260264],[-96.9103483,33.260264],[-96.9105955,33.2600052],[-96.9105955,33.2600052],[-96.9107347,33.2601015],[-96.9107347,33.2601015],[-96.9104782,33.2603539],[-96.9104782,33.2603539]]]},"properties":{"lotName":"9-E-4","lotCpId":"8354761610357575684","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9106043,33.2604465],[-96.9104782,33.2603539],[-96.9104782,33.2603539],[-96.9107347,33.2601015],[-96.9107347,33.2601015],[-96.9108701,33.2602006],[-96.9108701,33.2602006],[-96.9106043,33.2604465],[-96.9106043,33.2604465]]]},"properties":{"lotName":"9-E-5","lotCpId":"2265271610357577113","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9107276,33.2605424],[-96.9106043,33.2604465],[-96.9106043,33.2604465],[-96.9108701,33.2602006],[-96.9108701,33.2602006],[-96.9110021,33.2603037],[-96.9110021,33.2603037],[-96.9107276,33.2605424],[-96.9107276,33.2605424]]]},"properties":{"lotName":"9-E-6","lotCpId":"7141711610357575570","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9108471,33.2606414],[-96.9108325,33.2606291],[-96.9107982,33.2606003],[-96.9107584,33.2605673],[-96.9107276,33.2605424],[-96.9107276,33.2605424],[-96.9110021,33.2603037],[-96.9110021,33.2603037],[-96.9111304,33.2604096],[-96.9111304,33.2604096],[-96.9108471,33.2606414],[-96.9108471,33.2606414]]]},"properties":{"lotName":"9-E-7","lotCpId":"1630801610357577114","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9109628,33.2607432],[-96.9108471,33.2606414],[-96.9108471,33.2606414],[-96.9111304,33.2604096],[-96.9111304,33.2604096],[-96.9112543,33.2605191],[-96.9112543,33.2605191],[-96.9109628,33.2607432],[-96.9109628,33.2607432]]]},"properties":{"lotName":"9-E-8","lotCpId":"7767841610357576039","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9110753,33.2608486],[-96.9109628,33.2607432],[-96.9109628,33.2607432],[-96.9112543,33.2605191],[-96.9112543,33.2605191],[-96.9113744,33.2606314],[-96.9113744,33.2606314],[-96.9110753,33.2608486],[-96.9110753,33.2608486]]]},"properties":{"lotName":"9-E-9","lotCpId":"7412401610357577041","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9111833,33.2609563],[-96.9111718,33.2609445],[-96.9111437,33.2609159],[-96.9110753,33.2608486],[-96.9110753,33.2608486],[-96.9113744,33.2606314],[-96.9113744,33.2606314],[-96.9114906,33.2607468],[-96.9114906,33.2607468],[-96.9111833,33.2609563],[-96.9111833,33.2609563]]]},"properties":{"lotName":"9-E-10","lotCpId":"5281301610357575933","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9112881,33.2610667],[-96.9112747,33.2610525],[-96.9112435,33.2610195],[-96.9112085,33.2609825],[-96.9111833,33.2609563],[-96.9111833,33.2609563],[-96.9114906,33.2607468],[-96.9114906,33.2607468],[-96.9116025,33.260865],[-96.9116025,33.260865],[-96.9112881,33.2610667],[-96.9112881,33.2610667]]]},"properties":{"lotName":"9-E-11","lotCpId":"2155541610357577093","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9113973,33.2611886],[-96.9113247,33.2611074],[-96.9112881,33.2610667],[-96.9112881,33.2610667],[-96.9116025,33.260865],[-96.9116025,33.260865],[-96.9117335,33.2610124],[-96.9117335,33.2610124],[-96.9114431,33.2611941],[-96.9113973,33.2611886],[-96.9113973,33.2611886]]]},"properties":{"lotName":"9-E-12","lotCpId":"1365801610357576135","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9124675,33.2601549],[-96.912432,33.2603128],[-96.912432,33.2603128],[-96.9123933,33.2603402],[-96.912385,33.2603404],[-96.9123617,33.2603414],[-96.912279,33.2603497],[-96.9121637,33.2603716],[-96.9120342,33.2604141],[-96.9120342,33.2604141],[-96.912103,33.2600979],[-96.912103,33.2600979],[-96.9124675,33.2601549],[-96.9124675,33.2601549]]]},"properties":{"lotName":"9-F-8","lotCpId":"7043601610357575626","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9125019,33.2599742],[-96.9125001,33.2599865],[-96.9124948,33.2600192],[-96.9124752,33.2601201],[-96.9124675,33.2601549],[-96.9124675,33.2601549],[-96.912103,33.2600979],[-96.912103,33.2600979],[-96.9120353,33.260002],[-96.9119993,33.2599254],[-96.9119993,33.2599254],[-96.9125019,33.2599742],[-96.9125019,33.2599742]]]},"properties":{"lotName":"9-F-9","lotCpId":"6216381610357577099","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9125177,33.2597876],[-96.912517,33.2598064],[-96.9125144,33.2598534],[-96.9125019,33.2599742],[-96.9125019,33.2599742],[-96.9119993,33.2599254],[-96.9119993,33.2599254],[-96.9119283,33.2597734],[-96.9119283,33.2597734],[-96.9125177,33.2597876],[-96.9125177,33.2597876]]]},"properties":{"lotName":"9-F-10","lotCpId":"6755451610357575905","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9125145,33.2596004],[-96.9125156,33.2596177],[-96.9125179,33.2596619],[-96.9125177,33.2597876],[-96.9125177,33.2597876],[-96.9119283,33.2597734],[-96.9119283,33.2597734],[-96.911877,33.2596639],[-96.911877,33.2596639],[-96.9120975,33.259621],[-96.9125145,33.2596004],[-96.9125145,33.2596004]]]},"properties":{"lotName":"9-F-11","lotCpId":"6571351610357576528","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9124915,33.2594142],[-96.9124946,33.2594324],[-96.9125015,33.2594781],[-96.9125145,33.2596004],[-96.9125145,33.2596004],[-96.9120975,33.259621],[-96.9120975,33.259621],[-96.9120506,33.2594686],[-96.9120506,33.2594686],[-96.9124915,33.2594142],[-96.9124915,33.2594142]]]},"properties":{"lotName":"9-F-12","lotCpId":"8664631610357575604","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.91244,33.2591986],[-96.9124461,33.2592189],[-96.9124604,33.2592707],[-96.9124915,33.2594142],[-96.9124915,33.2594142],[-96.9120506,33.2594686],[-96.9120506,33.2594686],[-96.9119883,33.2592682],[-96.9119883,33.2592682],[-96.9124004,33.2591788],[-96.91244,33.2591986],[-96.91244,33.2591986]]]},"properties":{"lotName":"9-F-13","lotCpId":"3341301610357576576","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9118295,33.2593024],[-96.9119883,33.2592682],[-96.9119883,33.2592682],[-96.9120975,33.259621],[-96.9120975,33.259621],[-96.9119381,33.2596516],[-96.9119381,33.2596516],[-96.9118295,33.2593024],[-96.9118295,33.2593024]]]},"properties":{"lotName":"9-F-14","lotCpId":"3870031610357576363","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9116712,33.2593371],[-96.9118295,33.2593024],[-96.9118295,33.2593024],[-96.9119381,33.2596516],[-96.9119381,33.2596516],[-96.9117788,33.2596826],[-96.9117788,33.2596826],[-96.9116712,33.2593371],[-96.9116712,33.2593371]]]},"properties":{"lotName":"9-F-15","lotCpId":"4155881610357576357","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9113733,33.259401],[-96.9116712,33.2593371],[-96.9116712,33.2593371],[-96.9117788,33.2596826],[-96.9117788,33.2596826],[-96.911656,33.2597068],[-96.911656,33.2597068],[-96.9114066,33.2595073],[-96.9113733,33.259401],[-96.9113733,33.259401]]]},"properties":{"lotName":"9-F-16","lotCpId":"6482481610357576518","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9111342,33.2597711],[-96.9109132,33.2596187],[-96.9109132,33.2596187],[-96.910911,33.2595822],[-96.9109165,33.2595775],[-96.9109329,33.2595649],[-96.9109964,33.2595236],[-96.9110981,33.2594739],[-96.9112346,33.2594316],[-96.9113733,33.259401],[-96.9113733,33.259401],[-96.9114066,33.2595073],[-96.9114066,33.2595073],[-96.9111342,33.2597711],[-96.9111342,33.2597711]]]},"properties":{"lotName":"9-F-1","lotCpId":"8840371610357576874","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9112559,33.259861],[-96.9111342,33.2597711],[-96.9111342,33.2597711],[-96.9114066,33.2595073],[-96.9114066,33.2595073],[-96.911531,33.2596073],[-96.911531,33.2596073],[-96.9112559,33.259861],[-96.9112559,33.259861]]]},"properties":{"lotName":"9-F-2","lotCpId":"3570851610357575997","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9113744,33.2599532],[-96.9112559,33.259861],[-96.9112559,33.259861],[-96.911531,33.2596073],[-96.911531,33.2596073],[-96.911656,33.2597068],[-96.911656,33.2597068],[-96.9113744,33.2599532],[-96.9113744,33.2599532]]]},"properties":{"lotName":"9-F-3","lotCpId":"7514261610357576766","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9114901,33.2600481],[-96.9113744,33.2599532],[-96.9113744,33.2599532],[-96.911656,33.2597068],[-96.911656,33.2597068],[-96.911877,33.2596639],[-96.9118977,33.2597086],[-96.9118977,33.2597086],[-96.9114901,33.2600481],[-96.9114901,33.2600481]]]},"properties":{"lotName":"9-F-4","lotCpId":"2806821610357575627","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.911603,33.2601453],[-96.9114901,33.2600481],[-96.9114901,33.2600481],[-96.9118977,33.2597086],[-96.9118977,33.2597086],[-96.9119671,33.2598569],[-96.9119671,33.2598569],[-96.911603,33.2601453],[-96.911603,33.2601453]]]},"properties":{"lotName":"9-F-5","lotCpId":"6632721610357576497","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9117133,33.2602448],[-96.911603,33.2601453],[-96.911603,33.2601453],[-96.9119671,33.2598569],[-96.9119671,33.2598569],[-96.9120353,33.260002],[-96.9120353,33.260002],[-96.9117133,33.2602448],[-96.9117133,33.2602448]]]},"properties":{"lotName":"9-F-6","lotCpId":"1542371610357575541","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9119136,33.2604397],[-96.9118952,33.2604209],[-96.9118478,33.2603733],[-96.9117133,33.2602448],[-96.9117133,33.2602448],[-96.9120353,33.260002],[-96.9120353,33.260002],[-96.912103,33.2600979],[-96.912103,33.2600979],[-96.9120342,33.2604141],[-96.9120109,33.2604237],[-96.9119621,33.2604465],[-96.9119136,33.2604397],[-96.9119136,33.2604397]]]},"properties":{"lotName":"9-F-7","lotCpId":"6783171610357577100","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9123333,33.2588538],[-96.9123829,33.2590126],[-96.9123829,33.2590126],[-96.9123595,33.2590464],[-96.9120107,33.2591217],[-96.9120107,33.2591217],[-96.9119529,33.2589364],[-96.9119529,33.2589364],[-96.9123333,33.2588538],[-96.9123333,33.2588538]]]},"properties":{"lotName":"9-A-29","lotCpId":"3072361610357575176","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9122841,33.258695],[-96.9123333,33.2588538],[-96.9123333,33.2588538],[-96.9119529,33.2589364],[-96.9119529,33.2589364],[-96.9119037,33.2587772],[-96.9119037,33.2587772],[-96.9122841,33.258695],[-96.9122841,33.258695]]]},"properties":{"lotName":"9-A-30","lotCpId":"8082601610357575161","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9122345,33.2585357],[-96.9122841,33.258695],[-96.9122841,33.258695],[-96.9119037,33.2587772],[-96.9119037,33.2587772],[-96.9118541,33.2586183],[-96.9118541,33.2586183],[-96.9122345,33.2585357],[-96.9122345,33.2585357]]]},"properties":{"lotName":"9-A-31","lotCpId":"8762821610357575163","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9121854,33.2583769],[-96.9122345,33.2585357],[-96.9122345,33.2585357],[-96.9118541,33.2586183],[-96.9118541,33.2586183],[-96.911805,33.2584591],[-96.911805,33.2584591],[-96.9121854,33.2583769],[-96.9121854,33.2583769]]]},"properties":{"lotName":"9-A-32","lotCpId":"2870071610357575394","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9133369,33.2604694],[-96.9130777,33.2604287],[-96.9130777,33.2604287],[-96.9131519,33.2600974],[-96.9131519,33.2600974],[-96.9134417,33.2601312],[-96.9134417,33.2601312],[-96.9134404,33.26014],[-96.913436,33.2601659],[-96.9134279,33.2602084],[-96.9134155,33.2602667],[-96.9133751,33.2604475],[-96.9133369,33.2604694],[-96.9133369,33.2604694]]]},"properties":{"lotName":"9-G-13","lotCpId":"2524841610357576789","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9128687,33.2603959],[-96.912622,33.2603576],[-96.912622,33.2603576],[-96.9125958,33.2603256],[-96.9126362,33.2601449],[-96.9126384,33.2601354],[-96.9126438,33.2601108],[-96.9126569,33.2600399],[-96.9126569,33.2600399],[-96.9129407,33.2600728],[-96.9129407,33.2600728],[-96.9128687,33.2603959],[-96.9128687,33.2603959]]]},"properties":{"lotName":"9-G-11","lotCpId":"1083761610357577236","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9130777,33.2604287],[-96.9128687,33.2603959],[-96.9128687,33.2603959],[-96.9129407,33.2600728],[-96.9129407,33.2600728],[-96.9131519,33.2600974],[-96.9131519,33.2600974],[-96.9130777,33.2604287],[-96.9130777,33.2604287]]]},"properties":{"lotName":"9-G-12","lotCpId":"8465681610357577121","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9134679,33.2599144],[-96.9134665,33.2599337],[-96.913462,33.2599839],[-96.9134417,33.2601312],[-96.9134417,33.2601312],[-96.9130493,33.2600856],[-96.9130493,33.2600856],[-96.9130728,33.2598934],[-96.9130728,33.2598934],[-96.9134679,33.2599144],[-96.9134679,33.2599144]]]},"properties":{"lotName":"9-G-14","lotCpId":"8763531610357576254","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.913475,33.2597077],[-96.9134753,33.2597251],[-96.9134751,33.2597713],[-96.9134732,33.2598374],[-96.9134679,33.2599144],[-96.9134679,33.2599144],[-96.9130728,33.2598934],[-96.9130728,33.2598934],[-96.9130788,33.2597095],[-96.9130788,33.2597095],[-96.913475,33.2597077],[-96.913475,33.2597077]]]},"properties":{"lotName":"9-G-15","lotCpId":"6108351610357576382","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9134652,33.2595005],[-96.9134669,33.2595172],[-96.9134705,33.2595622],[-96.9134739,33.2596282],[-96.913475,33.2597077],[-96.913475,33.2597077],[-96.9130788,33.2597095],[-96.9130788,33.2597095],[-96.9130701,33.2595261],[-96.9130701,33.2595261],[-96.9134652,33.2595005],[-96.9134652,33.2595005]]]},"properties":{"lotName":"9-G-16","lotCpId":"8447631610357576754","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9134374,33.2592951],[-96.9134408,33.2593162],[-96.9134489,33.2593685],[-96.9134652,33.2595005],[-96.9134652,33.2595005],[-96.9130701,33.2595261],[-96.9130701,33.2595261],[-96.9130455,33.2593435],[-96.9130455,33.2593435],[-96.9134374,33.2592951],[-96.9134374,33.2592951]]]},"properties":{"lotName":"9-G-17","lotCpId":"1807721610357577121","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9133926,33.2590911],[-96.9133977,33.259111],[-96.91341,33.2591612],[-96.9134374,33.2592951],[-96.9134374,33.2592951],[-96.9130455,33.2593435],[-96.9130455,33.2593435],[-96.9130057,33.2591628],[-96.9130057,33.2591628],[-96.9133926,33.2590911],[-96.9133926,33.2590911]]]},"properties":{"lotName":"9-G-18","lotCpId":"8021031610357576842","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9133386,33.25891],[-96.9133626,33.2589866],[-96.9133658,33.2589972],[-96.9133737,33.2590235],[-96.9133926,33.2590911],[-96.9133926,33.2590911],[-96.9130057,33.2591628],[-96.9130057,33.2591628],[-96.9129549,33.258993],[-96.9129549,33.258993],[-96.9133386,33.25891],[-96.9133386,33.25891]]]},"properties":{"lotName":"9-G-19","lotCpId":"8638581610357576950","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9132894,33.2587507],[-96.9133386,33.25891],[-96.9133386,33.25891],[-96.9129549,33.258993],[-96.9129549,33.258993],[-96.9129058,33.2588342],[-96.9129058,33.2588342],[-96.9132894,33.2587507],[-96.9132894,33.2587507]]]},"properties":{"lotName":"9-G-20","lotCpId":"3067051610357576847","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9132398,33.2585919],[-96.9132894,33.2587507],[-96.9132894,33.2587507],[-96.9129058,33.2588342],[-96.9129058,33.2588342],[-96.9128567,33.2586749],[-96.9128567,33.2586749],[-96.9132398,33.2585919],[-96.9132398,33.2585919]]]},"properties":{"lotName":"9-G-21","lotCpId":"6773221610357577098","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9131907,33.258433],[-96.9132398,33.2585919],[-96.9132398,33.2585919],[-96.9128567,33.2586749],[-96.9128567,33.2586749],[-96.912807,33.2585161],[-96.912807,33.2585161],[-96.9131907,33.258433],[-96.9131907,33.258433]]]},"properties":{"lotName":"9-G-22","lotCpId":"3541101610357577217","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.913141,33.2582738],[-96.9131907,33.258433],[-96.9131907,33.258433],[-96.912807,33.2585161],[-96.912807,33.2585161],[-96.9127497,33.2583304],[-96.9127497,33.2583304],[-96.9131012,33.2582541],[-96.913141,33.2582738],[-96.913141,33.2582738]]]},"properties":{"lotName":"9-G-23","lotCpId":"2305031610357576812","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9124233,33.2585992],[-96.9123742,33.2584404],[-96.9123742,33.2584404],[-96.9123977,33.258407],[-96.9127497,33.2583304],[-96.9127497,33.2583304],[-96.912807,33.2585161],[-96.912807,33.2585161],[-96.9124233,33.2585992],[-96.9124233,33.2585992]]]},"properties":{"lotName":"9-G-1","lotCpId":"8815461610357576775","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.912473,33.2587584],[-96.9124233,33.2585992],[-96.9124233,33.2585992],[-96.912807,33.2585161],[-96.912807,33.2585161],[-96.9128567,33.2586749],[-96.9128567,33.2586749],[-96.912473,33.2587584],[-96.912473,33.2587584]]]},"properties":{"lotName":"9-G-2","lotCpId":"7055331610357577226","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9125221,33.2589173],[-96.912473,33.2587584],[-96.912473,33.2587584],[-96.9128567,33.2586749],[-96.9128567,33.2586749],[-96.9129058,33.2588342],[-96.9129058,33.2588342],[-96.9125221,33.2589173],[-96.9125221,33.2589173]]]},"properties":{"lotName":"9-G-3","lotCpId":"6154861610357576965","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9125718,33.2590765],[-96.9125221,33.2589173],[-96.9125221,33.2589173],[-96.9129058,33.2588342],[-96.9129058,33.2588342],[-96.9129549,33.258993],[-96.9129549,33.258993],[-96.9125718,33.2590765],[-96.9125718,33.2590765]]]},"properties":{"lotName":"9-G-4","lotCpId":"5628111610357577111","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9126187,33.2592344],[-96.9126159,33.2592245],[-96.9126092,33.2592011],[-96.9125952,33.2591532],[-96.9125718,33.2590765],[-96.9125718,33.2590765],[-96.9129549,33.258993],[-96.9129549,33.258993],[-96.9130057,33.2591628],[-96.9130057,33.2591628],[-96.9126187,33.2592344],[-96.9126187,33.2592344]]]},"properties":{"lotName":"9-G-5","lotCpId":"5178131610357576341","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9126536,33.2593919],[-96.9126506,33.2593757],[-96.9126426,33.2593357],[-96.9126187,33.2592344],[-96.9126187,33.2592344],[-96.9130057,33.2591628],[-96.9130057,33.2591628],[-96.9130455,33.2593435],[-96.9130455,33.2593435],[-96.9126536,33.2593919],[-96.9126536,33.2593919]]]},"properties":{"lotName":"9-G-6","lotCpId":"8730381610357576940","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9126749,33.2595516],[-96.9126731,33.2595343],[-96.9126682,33.259492],[-96.9126536,33.2593919],[-96.9126536,33.2593919],[-96.9130455,33.2593435],[-96.9130455,33.2593435],[-96.9130701,33.2595261],[-96.9130701,33.2595261],[-96.9126749,33.2595516],[-96.9126749,33.2595516]]]},"properties":{"lotName":"9-G-7","lotCpId":"8082171610357576345","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9126826,33.2597118],[-96.9126825,33.2596965],[-96.9126817,33.2596575],[-96.9126749,33.2595516],[-96.9126749,33.2595516],[-96.9130701,33.2595261],[-96.9130701,33.2595261],[-96.9130788,33.2597095],[-96.9130788,33.2597095],[-96.9126826,33.2597118],[-96.9126826,33.2597118]]]},"properties":{"lotName":"9-G-8","lotCpId":"8060011610357576528","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9126771,33.259872],[-96.9126782,33.2598575],[-96.9126804,33.2598199],[-96.9126826,33.2597118],[-96.9126826,33.2597118],[-96.9130788,33.2597095],[-96.9130788,33.2597095],[-96.9130728,33.2598934],[-96.9130728,33.2598934],[-96.9126771,33.259872],[-96.9126771,33.259872]]]},"properties":{"lotName":"9-G-9","lotCpId":"8885781610357576563","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9126569,33.2600399],[-96.9126596,33.2600211],[-96.9126657,33.2599757],[-96.9126725,33.2599204],[-96.9126771,33.259872],[-96.9126771,33.259872],[-96.9130728,33.2598934],[-96.9130728,33.2598934],[-96.9130493,33.2600856],[-96.9130493,33.2600856],[-96.9126569,33.2600399],[-96.9126569,33.2600399]]]},"properties":{"lotName":"9-G-10","lotCpId":"7778761610357577084","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9066376,33.2674711],[-96.9067173,33.2673291],[-96.9067173,33.2673291],[-96.9070726,33.2674692],[-96.9070726,33.2674692],[-96.9069929,33.2676107],[-96.9069929,33.2676107],[-96.9066376,33.2674711],[-96.9066376,33.2674711]]]},"properties":{"lotName":"5-F-1","lotCpId":"2771031615890715875","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065678,33.2675947],[-96.9066376,33.2674711],[-96.9066376,33.2674711],[-96.9069929,33.2676107],[-96.9069929,33.2676107],[-96.9069231,33.2677348],[-96.9069231,33.2677348],[-96.9065678,33.2675947],[-96.9065678,33.2675947]]]},"properties":{"lotName":"5-F-2","lotCpId":"3222471615890715867","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9064979,33.2677188],[-96.9065678,33.2675947],[-96.9065678,33.2675947],[-96.9069231,33.2677348],[-96.9069231,33.2677348],[-96.9068538,33.2678585],[-96.9068538,33.2678585],[-96.9064979,33.2677188],[-96.9064979,33.2677188]]]},"properties":{"lotName":"5-F-3","lotCpId":"1871171615890715870","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9064281,33.2678425],[-96.9064979,33.2677188],[-96.9064979,33.2677188],[-96.9068538,33.2678585],[-96.9068538,33.2678585],[-96.9067839,33.2679826],[-96.9067839,33.2679826],[-96.9064281,33.2678425],[-96.9064281,33.2678425]]]},"properties":{"lotName":"5-F-4","lotCpId":"5122681615534248387","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9063587,33.2679662],[-96.9064281,33.2678425],[-96.9064281,33.2678425],[-96.9067839,33.2679826],[-96.9067839,33.2679826],[-96.906714,33.2681063],[-96.906714,33.2681063],[-96.9063587,33.2679662],[-96.9063587,33.2679662]]]},"properties":{"lotName":"5-F-5","lotCpId":"8284131615890715873","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9062889,33.2680903],[-96.9063587,33.2679662],[-96.9063587,33.2679662],[-96.906714,33.2681063],[-96.906714,33.2681063],[-96.9066442,33.2682299],[-96.9066442,33.2682299],[-96.9062889,33.2680903],[-96.9062889,33.2680903]]]},"properties":{"lotName":"5-F-6","lotCpId":"1765851615890715871","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906219,33.268214],[-96.9062889,33.2680903],[-96.9062889,33.2680903],[-96.9066442,33.2682299],[-96.9066442,33.2682299],[-96.9065749,33.268354],[-96.9065749,33.268354],[-96.906219,33.268214],[-96.906219,33.268214]]]},"properties":{"lotName":"5-F-7","lotCpId":"5555771615890715877","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9061493,33.2683383],[-96.906219,33.268214],[-96.906219,33.268214],[-96.9065749,33.268354],[-96.9065749,33.268354],[-96.906505,33.2684777],[-96.906505,33.2684777],[-96.9061493,33.2683383],[-96.9061493,33.2683383]]]},"properties":{"lotName":"5-F-8","lotCpId":"7710881615890715879","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906075,33.2684531],[-96.9060811,33.268445],[-96.9060974,33.2684219],[-96.9061211,33.2683857],[-96.9061493,33.2683383],[-96.9061493,33.2683383],[-96.906505,33.2684777],[-96.906505,33.2684777],[-96.9064324,33.2685982],[-96.9064122,33.2686269],[-96.9064122,33.2686269],[-96.906075,33.2684531],[-96.906075,33.2684531]]]},"properties":{"lotName":"5-F-9","lotCpId":"3752001615891789875","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9059854,33.2685603],[-96.9059948,33.2685501],[-96.9060179,33.2685241],[-96.906075,33.2684531],[-96.906075,33.2684531],[-96.9064122,33.2686269],[-96.9064122,33.2686269],[-96.9063527,33.26871],[-96.9062998,33.2687661],[-96.9062998,33.2687661],[-96.9059854,33.2685603],[-96.9059854,33.2685603]]]},"properties":{"lotName":"5-F-10","lotCpId":"5841641615891789878","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058823,33.2686584],[-96.9058916,33.2686508],[-96.9059157,33.2686299],[-96.9059854,33.2685603],[-96.9059854,33.2685603],[-96.9062998,33.2687661],[-96.9062998,33.2687661],[-96.9061759,33.2688998],[-96.9061759,33.2688998],[-96.9058823,33.2686584],[-96.9058823,33.2686584]]]},"properties":{"lotName":"5-F-11","lotCpId":"7302161615891789878","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057666,33.2687465],[-96.9057774,33.2687391],[-96.905805,33.2687195],[-96.9058823,33.2686584],[-96.9058823,33.2686584],[-96.9061759,33.2688998],[-96.9061759,33.2688998],[-96.9061623,33.2689149],[-96.9060264,33.2690143],[-96.9060264,33.2690143],[-96.9057666,33.2687465],[-96.9057666,33.2687465]]]},"properties":{"lotName":"5-F-12","lotCpId":"3075541615891790476","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.90564,33.2688227],[-96.9056511,33.268817],[-96.9056802,33.2688011],[-96.9057666,33.2687465],[-96.9057666,33.2687465],[-96.9060264,33.2690143],[-96.9060264,33.2690143],[-96.9059292,33.269086],[-96.9058654,33.2691175],[-96.9058654,33.2691175],[-96.90564,33.2688227],[-96.90564,33.2688227]]]},"properties":{"lotName":"5-F-13","lotCpId":"3607741615891790480","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9055035,33.268887],[-96.905514,33.2688831],[-96.9055429,33.2688711],[-96.9055862,33.268851],[-96.90564,33.2688227],[-96.90564,33.2688227],[-96.9058654,33.2691175],[-96.9058654,33.2691175],[-96.9056896,33.2692042],[-96.9056896,33.2692042],[-96.9055035,33.268887],[-96.9055035,33.268887]]]},"properties":{"lotName":"5-F-14","lotCpId":"6546151615891790520","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9053594,33.2689381],[-96.9053708,33.268935],[-96.9054017,33.2689255],[-96.9055035,33.268887],[-96.9055035,33.268887],[-96.9056896,33.2692042],[-96.9056896,33.2692042],[-96.9056618,33.2692179],[-96.9055003,33.2692662],[-96.9055003,33.2692662],[-96.9053594,33.2689381],[-96.9053594,33.2689381]]]},"properties":{"lotName":"5-F-15","lotCpId":"6548141615891790521","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052094,33.2689751],[-96.9052219,33.2689728],[-96.9052553,33.2689659],[-96.9053594,33.2689381],[-96.9053594,33.2689381],[-96.9055003,33.2692662],[-96.9055003,33.2692662],[-96.9053693,33.2693055],[-96.9053049,33.2693132],[-96.9053049,33.2693132],[-96.9052094,33.2689751],[-96.9052094,33.2689751]]]},"properties":{"lotName":"5-F-16","lotCpId":"1552001615891790520","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9050555,33.2689979],[-96.9050683,33.2689969],[-96.9051024,33.2689934],[-96.9052094,33.2689751],[-96.9052094,33.2689751],[-96.9053049,33.2693132],[-96.9053049,33.2693132],[-96.905104,33.2693374],[-96.905104,33.2693374],[-96.9050555,33.2689979],[-96.9050555,33.2689979]]]},"properties":{"lotName":"5-F-17","lotCpId":"4436701615891791136","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048994,33.2690061],[-96.9049114,33.2690063],[-96.9049444,33.2690058],[-96.9050555,33.2689979],[-96.9050555,33.2689979],[-96.905104,33.2693374],[-96.905104,33.2693374],[-96.9049021,33.2693616],[-96.9049021,33.2693616],[-96.9048994,33.2690061],[-96.9048994,33.2690061]]]},"properties":{"lotName":"5-F-18","lotCpId":"7114051615891791141","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047335,33.2690043],[-96.9048679,33.2690064],[-96.9048994,33.2690061],[-96.9048994,33.2690061],[-96.9049021,33.2693616],[-96.9049021,33.2693616],[-96.9047264,33.2693826],[-96.9047264,33.2693826],[-96.9047335,33.2690043],[-96.9047335,33.2690043]]]},"properties":{"lotName":"5-F-19","lotCpId":"2851241615891791133","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051422,33.2673784],[-96.904978,33.2673136],[-96.904978,33.2673136],[-96.9049621,33.2672776],[-96.905116,33.2670038],[-96.905116,33.2670038],[-96.9053103,33.26708],[-96.9053103,33.26708],[-96.9051422,33.2673784],[-96.9051422,33.2673784]]]},"properties":{"lotName":"5-G-1","lotCpId":"3465221615954471665","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054506,33.2674998],[-96.9052961,33.2674391],[-96.9052961,33.2674391],[-96.9054642,33.2671407],[-96.9054642,33.2671407],[-96.9056187,33.2672014],[-96.9056187,33.2672014],[-96.9054506,33.2674998],[-96.9054506,33.2674998]]]},"properties":{"lotName":"5-G-3","lotCpId":"2615681615534275124","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056045,33.2675605],[-96.9054506,33.2674998],[-96.9054506,33.2674998],[-96.9056187,33.2672014],[-96.9056187,33.2672014],[-96.9057726,33.2672616],[-96.9057726,33.2672616],[-96.9056045,33.2675605],[-96.9056045,33.2675605]]]},"properties":{"lotName":"5-G-4","lotCpId":"8552151615534273080","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906231,33.2678069],[-96.9060668,33.2677421],[-96.9060668,33.2677421],[-96.9062349,33.2674437],[-96.9062349,33.2674437],[-96.9064286,33.2675199],[-96.9064286,33.2675199],[-96.9062747,33.2677937],[-96.906231,33.2678069],[-96.906231,33.2678069]]]},"properties":{"lotName":"5-G-8","lotCpId":"8853271615891792085","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9063893,33.2671398],[-96.9065672,33.26721],[-96.9065672,33.26721],[-96.9065831,33.2672461],[-96.9064286,33.2675199],[-96.9064286,33.2675199],[-96.9062212,33.2674382],[-96.9062212,33.2674382],[-96.9063893,33.2671398],[-96.9063893,33.2671398]]]},"properties":{"lotName":"5-G-9","lotCpId":"7413131615891792089","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9075196,33.2649831],[-96.9073668,33.2648412],[-96.9073668,33.2648412],[-96.9073706,33.2648029],[-96.9076479,33.2646067],[-96.9076479,33.2646067],[-96.9078105,33.2647582],[-96.9078105,33.2647582],[-96.9075196,33.2649831],[-96.9075196,33.2649831]]]},"properties":{"lotName":"5-E-1","lotCpId":"6858581615534066015","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076626,33.2651086],[-96.9075196,33.2649831],[-96.9075196,33.2649831],[-96.9078105,33.2647582],[-96.9078105,33.2647582],[-96.9079284,33.2648622],[-96.9079458,33.2648768],[-96.9079458,33.2648768],[-96.9076626,33.2651086],[-96.9076626,33.2651086]]]},"properties":{"lotName":"5-E-2","lotCpId":"3464571615534245722","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9078089,33.2652305],[-96.907792,33.2652167],[-96.9077517,33.2651836],[-96.9077034,33.2651434],[-96.9076626,33.2651086],[-96.9076626,33.2651086],[-96.9079458,33.2648768],[-96.9079458,33.2648768],[-96.9080495,33.264964],[-96.908085,33.2649923],[-96.908085,33.2649923],[-96.9078089,33.2652305],[-96.9078089,33.2652305]]]},"properties":{"lotName":"5-E-3","lotCpId":"5500771615890713282","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9079338,33.2653295],[-96.90792,33.2653187],[-96.9078864,33.2652923],[-96.9078089,33.2652305],[-96.9078089,33.2652305],[-96.908085,33.2649923],[-96.908085,33.2649923],[-96.9081734,33.265063],[-96.9082034,33.2650863],[-96.9082034,33.2650863],[-96.9079338,33.2653295],[-96.9079338,33.2653295]]]},"properties":{"lotName":"5-E-4","lotCpId":"4362251615890713281","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9080621,33.2654262],[-96.9080459,33.2654141],[-96.9080082,33.2653859],[-96.9079654,33.2653537],[-96.9079338,33.2653295],[-96.9079338,33.2653295],[-96.9082034,33.2650863],[-96.9082034,33.2650863],[-96.9083,33.2651602],[-96.9083246,33.265178],[-96.9083246,33.265178],[-96.9080621,33.2654262],[-96.9080621,33.2654262]]]},"properties":{"lotName":"5-E-5","lotCpId":"4634051615534223680","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9081925,33.2655207],[-96.9081769,33.2655095],[-96.9081399,33.2654829],[-96.9080966,33.2654516],[-96.9080621,33.2654262],[-96.9080621,33.2654262],[-96.9083246,33.265178],[-96.9083246,33.265178],[-96.9084294,33.2652542],[-96.9084485,33.2652674],[-96.9084485,33.2652674],[-96.9081925,33.2655207],[-96.9081925,33.2655207]]]},"properties":{"lotName":"5-E-6","lotCpId":"8574021615534102465","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9083251,33.2656124],[-96.9081925,33.2655207],[-96.9081925,33.2655207],[-96.9084485,33.2652674],[-96.9084485,33.2652674],[-96.9085609,33.2653459],[-96.9085746,33.2653546],[-96.9085746,33.2653546],[-96.9083251,33.2656124],[-96.9083251,33.2656124]]]},"properties":{"lotName":"5-E-7","lotCpId":"1200621615890713292","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.908466,33.2657051],[-96.9083251,33.2656124],[-96.9083251,33.2656124],[-96.9085746,33.2653546],[-96.9085746,33.2653546],[-96.9087012,33.2654386],[-96.9087012,33.2654386],[-96.908466,33.2657051],[-96.908466,33.2657051]]]},"properties":{"lotName":"5-E-8","lotCpId":"6837251615890714669","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9088109,33.2650885],[-96.908937,33.2651721],[-96.908937,33.2651721],[-96.9087012,33.2654386],[-96.9087012,33.2654386],[-96.9085609,33.2653459],[-96.9085609,33.2653459],[-96.9088109,33.2650885],[-96.9088109,33.2650885]]]},"properties":{"lotName":"5-E-9","lotCpId":"5172261615534222362","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9086859,33.2650018],[-96.9088109,33.2650885],[-96.9088109,33.2650885],[-96.9085609,33.2653459],[-96.9085609,33.2653459],[-96.9084294,33.2652542],[-96.9084294,33.2652542],[-96.9086859,33.2650018],[-96.9086859,33.2650018]]]},"properties":{"lotName":"5-E-10","lotCpId":"6373351615890714675","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9085636,33.2649129],[-96.9086859,33.2650018],[-96.9086859,33.2650018],[-96.9084294,33.2652542],[-96.9084294,33.2652542],[-96.9083,33.2651602],[-96.9083,33.2651602],[-96.9085636,33.2649129],[-96.9085636,33.2649129]]]},"properties":{"lotName":"5-E-11","lotCpId":"8162781615534109763","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9084441,33.2648211],[-96.9085636,33.2649129],[-96.9085636,33.2649129],[-96.9083,33.2651602],[-96.9083,33.2651602],[-96.9081734,33.265063],[-96.9081734,33.265063],[-96.9084441,33.2648211],[-96.9084441,33.2648211]]]},"properties":{"lotName":"5-E-12","lotCpId":"4237821615890714684","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9083268,33.2647276],[-96.9084441,33.2648211],[-96.9084441,33.2648211],[-96.9081734,33.265063],[-96.9081734,33.265063],[-96.9080495,33.264964],[-96.9080495,33.264964],[-96.9083268,33.2647276],[-96.9083268,33.2647276]]]},"properties":{"lotName":"5-E-13","lotCpId":"1682101615534189826","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9081008,33.2645327],[-96.9082127,33.2646313],[-96.9082127,33.2646313],[-96.9079284,33.2648622],[-96.9079284,33.2648622],[-96.9078105,33.2647582],[-96.9078105,33.2647582],[-96.9081008,33.2645327],[-96.9081008,33.2645327]]]},"properties":{"lotName":"5-E-15","lotCpId":"4066801615890714685","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.907972,33.2644132],[-96.9081008,33.2645327],[-96.9081008,33.2645327],[-96.9078105,33.2647582],[-96.9078105,33.2647582],[-96.9076479,33.2646067],[-96.9076479,33.2646067],[-96.9079256,33.26441],[-96.907972,33.2644132],[-96.907972,33.2644132]]]},"properties":{"lotName":"5-E-16","lotCpId":"7010701615534218386","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070852,33.263249],[-96.9070698,33.2632635],[-96.9070414,33.263304],[-96.9070264,33.2633663],[-96.9070322,33.2634043],[-96.9070513,33.2634462],[-96.9070513,33.2634462],[-96.906761,33.2636264],[-96.906761,33.2636264],[-96.9066627,33.2635137],[-96.9066627,33.2635137],[-96.9069045,33.2633659],[-96.9070852,33.263249],[-96.9070852,33.263249]]]},"properties":{"lotName":"5-S-15","lotCpId":"7466801615534079275","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073537,33.2632472],[-96.9073362,33.263235],[-96.9072874,33.2632131],[-96.9072125,33.2632033],[-96.9071669,33.2632098],[-96.9071168,33.2632276],[-96.9071168,33.2632276],[-96.9075027,33.2629218],[-96.9075027,33.2629218],[-96.9076713,33.2630533],[-96.9076713,33.2630533],[-96.9073537,33.2632472],[-96.9073537,33.2632472]]]},"properties":{"lotName":"5-D-1","lotCpId":"8817781615534077280","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074154,33.2633805],[-96.9074163,33.2633677],[-96.9074128,33.2633353],[-96.9073952,33.2632921],[-96.9073537,33.2632472],[-96.9073537,33.2632472],[-96.9076713,33.2630533],[-96.9076713,33.2630533],[-96.9077685,33.2631646],[-96.9077685,33.2631646],[-96.9074154,33.2633805],[-96.9074154,33.2633805]]]},"properties":{"lotName":"5-D-2","lotCpId":"1378001615534087802","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073984,33.2635621],[-96.9073597,33.2635174],[-96.9073647,33.2634772],[-96.9073721,33.2634702],[-96.9073886,33.2634505],[-96.9074059,33.2634199],[-96.9074154,33.2633805],[-96.9074154,33.2633805],[-96.9077685,33.2631646],[-96.9077685,33.2631646],[-96.9078662,33.2632764],[-96.9078662,33.2632764],[-96.9073984,33.2635621],[-96.9073984,33.2635621]]]},"properties":{"lotName":"5-D-3","lotCpId":"2866171615534082539","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074989,33.2636771],[-96.9073984,33.2635621],[-96.9073984,33.2635621],[-96.9078165,33.2633065],[-96.9078165,33.2633065],[-96.9078951,33.2634352],[-96.9078951,33.2634352],[-96.9074989,33.2636771],[-96.9074989,33.2636771]]]},"properties":{"lotName":"5-D-4","lotCpId":"7403401615534249042","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9075993,33.2637916],[-96.9074989,33.2636771],[-96.9074989,33.2636771],[-96.9078951,33.2634352],[-96.9078951,33.2634352],[-96.9079737,33.263563],[-96.9079737,33.263563],[-96.9075993,33.2637916],[-96.9075993,33.2637916]]]},"properties":{"lotName":"5-D-5","lotCpId":"6435841615534191843","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076997,33.2639066],[-96.9075993,33.2637916],[-96.9075993,33.2637916],[-96.9079737,33.263563],[-96.9079737,33.263563],[-96.9080523,33.2636912],[-96.9080523,33.2636912],[-96.9076997,33.2639066],[-96.9076997,33.2639066]]]},"properties":{"lotName":"5-D-6","lotCpId":"4405201615534247720","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9078012,33.2640212],[-96.9077912,33.26401],[-96.9077685,33.2639846],[-96.9077442,33.2639573],[-96.9077292,33.2639404],[-96.9076997,33.2639066],[-96.9076997,33.2639066],[-96.9080523,33.2636912],[-96.9080523,33.2636912],[-96.9080959,33.2637629],[-96.9081325,33.2638112],[-96.9081325,33.2638112],[-96.9078012,33.2640212],[-96.9078012,33.2640212]]]},"properties":{"lotName":"5-D-7","lotCpId":"3302561615534219060","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9079087,33.2641366],[-96.9078964,33.2641236],[-96.9078669,33.2640923],[-96.9078012,33.2640212],[-96.9078012,33.2640212],[-96.9081325,33.2638112],[-96.9081325,33.2638112],[-96.9082215,33.2639272],[-96.9082215,33.2639272],[-96.9079087,33.2641366],[-96.9079087,33.2641366]]]},"properties":{"lotName":"5-D-8","lotCpId":"8082051615534273741","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9080206,33.2642503],[-96.9080088,33.2642385],[-96.9079798,33.2642095],[-96.9079087,33.2641366],[-96.9079087,33.2641366],[-96.9082215,33.2639272],[-96.9082215,33.2639272],[-96.9083246,33.2640353],[-96.9083246,33.2640353],[-96.9080206,33.2642503],[-96.9080206,33.2642503]]]},"properties":{"lotName":"5-D-9","lotCpId":"4567601615890712931","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9087563,33.2648722],[-96.9086259,33.2647755],[-96.9086259,33.2647755],[-96.9088933,33.26453],[-96.9088933,33.26453],[-96.9089446,33.2645692],[-96.9090161,33.2646208],[-96.9090161,33.2646208],[-96.9087563,33.2648722],[-96.9087563,33.2648722]]]},"properties":{"lotName":"5-D-15","lotCpId":"7224001615534098461","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9090341,33.2650621],[-96.90889,33.2649663],[-96.90889,33.2649663],[-96.9091416,33.2647093],[-96.9091416,33.2647093],[-96.9092699,33.2647951],[-96.9092699,33.2647951],[-96.9090341,33.2650621],[-96.9090341,33.2650621]]]},"properties":{"lotName":"5-D-17","lotCpId":"6043231615534194606","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9092077,33.2643219],[-96.909355,33.2644278],[-96.909355,33.2644278],[-96.9091018,33.2646824],[-96.9091018,33.2646824],[-96.9089446,33.2645692],[-96.9089446,33.2645692],[-96.9092077,33.2643219],[-96.9092077,33.2643219]]]},"properties":{"lotName":"5-D-19","lotCpId":"4866041615534068932","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9090647,33.2642119],[-96.9092077,33.2643219],[-96.9092077,33.2643219],[-96.9089446,33.2645692],[-96.9089446,33.2645692],[-96.9087918,33.264452],[-96.9087918,33.264452],[-96.9090647,33.2642119],[-96.9090647,33.2642119]]]},"properties":{"lotName":"5-D-20","lotCpId":"2317371615534079961","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9087923,33.2639801],[-96.908926,33.2640978],[-96.908926,33.2640978],[-96.9086439,33.2643301],[-96.9086439,33.2643301],[-96.9085009,33.2642046],[-96.9085009,33.2642046],[-96.9087923,33.2639801],[-96.9087923,33.2639801]]]},"properties":{"lotName":"5-D-22","lotCpId":"3286841615534099142","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.908663,33.2638587],[-96.9087923,33.2639801],[-96.9087923,33.2639801],[-96.9085009,33.2642046],[-96.9085009,33.2642046],[-96.9083628,33.264075],[-96.9083628,33.264075],[-96.908663,33.2638587],[-96.908663,33.2638587]]]},"properties":{"lotName":"5-D-23","lotCpId":"3530261615534244382","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9084414,33.2636004],[-96.9084493,33.2636125],[-96.908471,33.2636437],[-96.9085429,33.2637337],[-96.9085429,33.2637337],[-96.9082215,33.2639272],[-96.9082215,33.2639272],[-96.9080959,33.2637629],[-96.9080959,33.2637629],[-96.9084414,33.2636004],[-96.9084414,33.2636004]]]},"properties":{"lotName":"5-D-25","lotCpId":"3544011615534195946","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9082859,33.2630505],[-96.9082754,33.2630382],[-96.9082468,33.2630062],[-96.908152,33.2629124],[-96.908152,33.2629124],[-96.9084425,33.2626891],[-96.9084425,33.2626891],[-96.9085145,33.2627562],[-96.9086079,33.2628584],[-96.9086079,33.2628584],[-96.9082859,33.2630505],[-96.9082859,33.2630505]]]},"properties":{"lotName":"5-C-1","lotCpId":"5625521615534202662","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9084703,33.2633262],[-96.9084636,33.2633128],[-96.9084455,33.2632786],[-96.9083874,33.2631842],[-96.9083874,33.2631842],[-96.9087317,33.2630231],[-96.9087317,33.2630231],[-96.9087896,33.263113],[-96.9088409,33.2631956],[-96.9088409,33.2631956],[-96.9084703,33.2633262],[-96.9084703,33.2633262]]]},"properties":{"lotName":"5-C-3","lotCpId":"8784671615534113724","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9085647,33.2635037],[-96.908557,33.2634915],[-96.9085377,33.2634598],[-96.9084893,33.2633654],[-96.9084814,33.263349],[-96.9084703,33.2633262],[-96.9084703,33.2633262],[-96.9088409,33.2631956],[-96.9088409,33.2631956],[-96.908878,33.263255],[-96.908938,33.263338],[-96.908938,33.263338],[-96.9085647,33.2635037],[-96.9085647,33.2635037]]]},"properties":{"lotName":"5-C-4","lotCpId":"2314151615890712664","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9089801,33.2639477],[-96.9089613,33.2639308],[-96.9089184,33.263892],[-96.9088711,33.263849],[-96.9088393,33.2638195],[-96.9088393,33.2638195],[-96.9091476,33.2635908],[-96.9091476,33.2635908],[-96.9091864,33.2636333],[-96.9092715,33.2637154],[-96.9092715,33.2637154],[-96.9089801,33.2639477],[-96.9089801,33.2639477]]]},"properties":{"lotName":"5-C-7","lotCpId":"3087611615534195262","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9092775,33.2641905],[-96.9091263,33.2640714],[-96.9091263,33.2640714],[-96.9094036,33.2638332],[-96.9094036,33.2638332],[-96.9094336,33.2638583],[-96.9095406,33.263942],[-96.9095406,33.263942],[-96.9095438,33.2639445],[-96.9092775,33.2641905],[-96.9092775,33.2641905]]]},"properties":{"lotName":"5-C-9","lotCpId":"8006371615534226359","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9099494,33.2638012],[-96.9100732,33.2638856],[-96.9100732,33.2638856],[-96.909838,33.2641521],[-96.909838,33.2641521],[-96.909695,33.2640549],[-96.909695,33.2640549],[-96.9099494,33.2638012],[-96.9099494,33.2638012]]]},"properties":{"lotName":"5-C-12","lotCpId":"4055471615534066426","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9098276,33.2637127],[-96.9099494,33.2638012],[-96.9099494,33.2638012],[-96.909695,33.2640549],[-96.909695,33.2640549],[-96.9095629,33.2639591],[-96.9095629,33.2639591],[-96.9098276,33.2637127],[-96.9098276,33.2637127]]]},"properties":{"lotName":"5-C-13","lotCpId":"5572741615534060229","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9097098,33.263621],[-96.9097431,33.2636479],[-96.9098276,33.2637127],[-96.9098276,33.2637127],[-96.9095629,33.2639591],[-96.9095629,33.2639591],[-96.9094336,33.2638583],[-96.9094336,33.2638583],[-96.9097098,33.263621],[-96.9097098,33.263621]]]},"properties":{"lotName":"5-C-14","lotCpId":"6706601615534097800","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9095984,33.2635251],[-96.9096086,33.2635344],[-96.9096348,33.2635577],[-96.9097098,33.263621],[-96.9097098,33.263621],[-96.9094336,33.2638583],[-96.9094336,33.2638583],[-96.9093059,33.2637487],[-96.9093059,33.2637487],[-96.9095984,33.2635251],[-96.9095984,33.2635251]]]},"properties":{"lotName":"5-C-15","lotCpId":"8000671615534084521","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9094936,33.2634238],[-96.9095032,33.2634335],[-96.9095278,33.2634582],[-96.9095984,33.2635251],[-96.9095984,33.2635251],[-96.9093059,33.2637487],[-96.9093059,33.2637487],[-96.9091864,33.2636333],[-96.9091864,33.2636333],[-96.9094936,33.2634238],[-96.9094936,33.2634238]]]},"properties":{"lotName":"5-C-16","lotCpId":"4857801615534065187","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9093959,33.2633179],[-96.9094051,33.2633284],[-96.9094286,33.2633546],[-96.9094936,33.2634238],[-96.9094936,33.2634238],[-96.9091864,33.2636333],[-96.9091864,33.2636333],[-96.909075,33.2635123],[-96.909075,33.2635123],[-96.9093959,33.2633179],[-96.9093959,33.2633179]]]},"properties":{"lotName":"5-C-17","lotCpId":"5416551615534064746","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9093059,33.263207],[-96.9093151,33.2632189],[-96.9093378,33.2632478],[-96.9093959,33.2633179],[-96.9093959,33.2633179],[-96.909075,33.2635123],[-96.909075,33.2635123],[-96.9089724,33.2633859],[-96.9089724,33.2633859],[-96.9093059,33.263207],[-96.9093059,33.263207]]]},"properties":{"lotName":"5-C-18","lotCpId":"2246131615534085839","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9092235,33.2630925],[-96.9092322,33.263105],[-96.9092535,33.2631355],[-96.9093059,33.263207],[-96.9093059,33.263207],[-96.9089724,33.2633859],[-96.9089724,33.2633859],[-96.908878,33.263255],[-96.908878,33.263255],[-96.9092235,33.2630925],[-96.9092235,33.2630925]]]},"properties":{"lotName":"5-C-19","lotCpId":"8517041615534272423","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9091461,33.2629685],[-96.9092235,33.2630925],[-96.9092235,33.2630925],[-96.908878,33.263255],[-96.908878,33.263255],[-96.9087896,33.263113],[-96.9087896,33.263113],[-96.9091461,33.2629685],[-96.9091461,33.2629685]]]},"properties":{"lotName":"5-C-20","lotCpId":"7482181615534085182","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.909051,33.2628201],[-96.9090596,33.2628324],[-96.9090817,33.2628653],[-96.9091461,33.2629685],[-96.9091461,33.2629685],[-96.9087896,33.263113],[-96.9087896,33.263113],[-96.9087094,33.262988],[-96.9087094,33.262988],[-96.909051,33.2628201],[-96.909051,33.2628201]]]},"properties":{"lotName":"5-C-21","lotCpId":"4301801615534081904","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9089419,33.2626781],[-96.9089529,33.2626914],[-96.9089804,33.2627252],[-96.909051,33.2628201],[-96.909051,33.2628201],[-96.9087094,33.262988],[-96.9087094,33.262988],[-96.9086177,33.2628689],[-96.9086177,33.2628689],[-96.9089419,33.2626781],[-96.9089419,33.2626781]]]},"properties":{"lotName":"5-C-22","lotCpId":"6788781615534249703","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9086897,33.2624235],[-96.9087025,33.2624346],[-96.9087347,33.2624632],[-96.9088196,33.2625444],[-96.9088196,33.2625444],[-96.9085145,33.2627562],[-96.9085145,33.2627562],[-96.9084054,33.2626544],[-96.9084054,33.2626544],[-96.9086897,33.2624235],[-96.9086897,33.2624235]]]},"properties":{"lotName":"5-C-24","lotCpId":"4103401615534087139","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9085495,33.2623117],[-96.9085639,33.2623225],[-96.9085996,33.2623498],[-96.9086897,33.2624235],[-96.9086897,33.2624235],[-96.9084054,33.2626544],[-96.9084054,33.2626544],[-96.9082869,33.2625599],[-96.9082869,33.2625599],[-96.9085495,33.2623117],[-96.9085495,33.2623117]]]},"properties":{"lotName":"5-C-25","lotCpId":"3812031615534068517","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9083999,33.2622085],[-96.9084385,33.2622341],[-96.9084486,33.2622408],[-96.9084749,33.2622584],[-96.9085495,33.2623117],[-96.9085495,33.2623117],[-96.9082869,33.2625599],[-96.9082869,33.2625599],[-96.9081549,33.2624691],[-96.9081549,33.2624691],[-96.9083999,33.2622085],[-96.9083999,33.2622085]]]},"properties":{"lotName":"5-C-26","lotCpId":"2737481615534083882","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9082711,33.2621241],[-96.9083999,33.2622085],[-96.9083999,33.2622085],[-96.9081549,33.2624691],[-96.9081549,33.2624691],[-96.9080004,33.2623678],[-96.9080004,33.2623678],[-96.9082247,33.2621287],[-96.9082711,33.2621241],[-96.9082711,33.2621241]]]},"properties":{"lotName":"5-C-27","lotCpId":"6552581615534064334","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9084992,33.2620999],[-96.9083715,33.262016],[-96.9083715,33.262016],[-96.9083655,33.2619776],[-96.9083712,33.2619713],[-96.9083869,33.2619538],[-96.9084401,33.2618933],[-96.9085757,33.2617289],[-96.9085757,33.2617289],[-96.9087443,33.2618398],[-96.9087443,33.2618398],[-96.9084992,33.2620999],[-96.9084992,33.2620999]]]},"properties":{"lotName":"5-B-1","lotCpId":"3400051615534063929","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9086248,33.2621848],[-96.9086148,33.2621779],[-96.9085911,33.2621615],[-96.9085396,33.2621264],[-96.9084992,33.2620999],[-96.9084992,33.2620999],[-96.9087443,33.2618398],[-96.9087443,33.2618398],[-96.9088655,33.2619215],[-96.9088818,33.2619334],[-96.9088818,33.2619334],[-96.9086248,33.2621848],[-96.9086248,33.2621848]]]},"properties":{"lotName":"5-B-2","lotCpId":"8385421615534081259","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9087432,33.2622747],[-96.9087305,33.2622647],[-96.9086994,33.2622405],[-96.9086248,33.2621848],[-96.9086248,33.2621848],[-96.9088818,33.2619334],[-96.9088818,33.2619334],[-96.9089855,33.2620105],[-96.9090172,33.2620365],[-96.9090172,33.2620365],[-96.9087432,33.2622747],[-96.9087432,33.2622747]]]},"properties":{"lotName":"5-B-3","lotCpId":"4726281615534066840","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9088545,33.2623701],[-96.9088432,33.2623599],[-96.908815,33.262335],[-96.9087432,33.2622747],[-96.9087432,33.2622747],[-96.9090172,33.2620365],[-96.9090172,33.2620365],[-96.9091001,33.262105],[-96.9091454,33.2621465],[-96.9091454,33.2621465],[-96.9088545,33.2623701],[-96.9088545,33.2623701]]]},"properties":{"lotName":"5-B-4","lotCpId":"3337721615534067261","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9089593,33.2624714],[-96.9089489,33.2624608],[-96.9089227,33.2624347],[-96.9088545,33.2623701],[-96.9088545,33.2623701],[-96.9091454,33.2621465],[-96.9091454,33.2621465],[-96.9092082,33.2622044],[-96.9092655,33.2622624],[-96.9092655,33.2622624],[-96.9089593,33.2624714],[-96.9089593,33.2624714]]]},"properties":{"lotName":"5-B-5","lotCpId":"7168601615534107100","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9090565,33.2625773],[-96.9090473,33.2625667],[-96.9090238,33.2625402],[-96.9089593,33.2624714],[-96.9089593,33.2624714],[-96.9092655,33.2622624],[-96.9092655,33.2622624],[-96.9093103,33.2623085],[-96.9093774,33.2623838],[-96.9093774,33.2623838],[-96.9090565,33.2625773],[-96.9090565,33.2625773]]]},"properties":{"lotName":"5-B-6","lotCpId":"3873871615534097163","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.909146,33.2626877],[-96.9091376,33.2626768],[-96.9091162,33.2626494],[-96.9090565,33.2625773],[-96.9090565,33.2625773],[-96.9093774,33.2623838],[-96.9093774,33.2623838],[-96.9094189,33.2624322],[-96.90948,33.2625111],[-96.90948,33.2625111],[-96.909146,33.2626877],[-96.909146,33.2626877]]]},"properties":{"lotName":"5-B-7","lotCpId":"8346171615534251002","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9092278,33.2628027],[-96.9092192,33.2627901],[-96.909198,33.2627594],[-96.909146,33.2626877],[-96.909146,33.2626877],[-96.90948,33.2625111],[-96.90948,33.2625111],[-96.9095078,33.2625472],[-96.9095739,33.262643],[-96.9095739,33.262643],[-96.9092278,33.2628027],[-96.9092278,33.2628027]]]},"properties":{"lotName":"5-B-8","lotCpId":"6845411615534067675","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.909301,33.2629223],[-96.9092934,33.2629087],[-96.909287,33.2628977],[-96.9092708,33.2628705],[-96.9092278,33.2628027],[-96.9092278,33.2628027],[-96.9095739,33.262643],[-96.9095739,33.262643],[-96.9095897,33.2626658],[-96.9096568,33.2627758],[-96.9096568,33.2627758],[-96.909301,33.2629223],[-96.909301,33.2629223]]]},"properties":{"lotName":"5-B-9","lotCpId":"2224181615534068102","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9093932,33.2630642],[-96.9093837,33.2630503],[-96.90936,33.2630153],[-96.909301,33.2629223],[-96.909301,33.2629223],[-96.9096568,33.2627758],[-96.9096568,33.2627758],[-96.9097354,33.2628954],[-96.9097354,33.2628954],[-96.9093932,33.2630642],[-96.9093932,33.2630642]]]},"properties":{"lotName":"5-B-10","lotCpId":"3438481615534062295","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9094969,33.2632002],[-96.9094864,33.2631874],[-96.9094603,33.2631548],[-96.9093932,33.2630642],[-96.9093932,33.2630642],[-96.9097354,33.2628954],[-96.9097354,33.2628954],[-96.9097578,33.2629282],[-96.9098244,33.2630104],[-96.9098244,33.2630104],[-96.9094969,33.2632002],[-96.9094969,33.2632002]]]},"properties":{"lotName":"5-B-11","lotCpId":"8651051615534063103","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9096126,33.2633293],[-96.9095999,33.2633158],[-96.909569,33.2632825],[-96.9094969,33.2632002],[-96.9094969,33.2632002],[-96.9098244,33.2630104],[-96.9098244,33.2630104],[-96.9098653,33.2630615],[-96.9099226,33.2631199],[-96.9099226,33.2631199],[-96.9096126,33.2633293],[-96.9096126,33.2633293]]]},"properties":{"lotName":"5-B-12","lotCpId":"8108551615890712664","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9097392,33.2634507],[-96.9097263,33.2634391],[-96.9096941,33.2634096],[-96.9096126,33.2633293],[-96.9096126,33.2633293],[-96.9099226,33.2631199],[-96.9099226,33.2631199],[-96.9099734,33.2631724],[-96.9100296,33.263223],[-96.9100296,33.263223],[-96.9097392,33.2634507],[-96.9097392,33.2634507]]]},"properties":{"lotName":"5-B-13","lotCpId":"6886251615534101801","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9098746,33.263563],[-96.9098555,33.2635479],[-96.909843,33.2635379],[-96.9098125,33.2635131],[-96.9097392,33.2634507],[-96.9097392,33.2634507],[-96.9100296,33.263223],[-96.9100296,33.263223],[-96.9101087,33.263291],[-96.9101447,33.2633202],[-96.9101447,33.2633202],[-96.9098746,33.263563],[-96.9098746,33.263563]]]},"properties":{"lotName":"5-B-14","lotCpId":"2741251615534061880","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9100077,33.2636629],[-96.9099928,33.263652],[-96.9099568,33.2636254],[-96.9098746,33.263563],[-96.9098746,33.263563],[-96.9101447,33.2633202],[-96.9101447,33.2633202],[-96.9102441,33.2633951],[-96.910267,33.2634119],[-96.910267,33.2634119],[-96.9100077,33.2636629],[-96.9100077,33.2636629]]]},"properties":{"lotName":"5-B-15","lotCpId":"4840401615534190484","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9101453,33.2637583],[-96.9101317,33.2637492],[-96.9100976,33.2637261],[-96.9100077,33.2636629],[-96.9100077,33.2636629],[-96.910267,33.2634119],[-96.910267,33.2634119],[-96.9103925,33.2634996],[-96.9103925,33.2634996],[-96.9101453,33.2637583],[-96.9101453,33.2637583]]]},"properties":{"lotName":"5-B-16","lotCpId":"7163001615890712704","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9079202,33.2622318],[-96.9077985,33.262361],[-96.9077985,33.262361],[-96.907477,33.2621492],[-96.907477,33.2621492],[-96.9075982,33.2620201],[-96.9075982,33.2620201],[-96.9079202,33.2622318],[-96.9079202,33.2622318]]]},"properties":{"lotName":"5-A-1","lotCpId":"7073771615534089782","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9082924,33.2618298],[-96.908282,33.2618419],[-96.9082543,33.2618738],[-96.9081669,33.261969],[-96.9081669,33.261969],[-96.9078454,33.2617572],[-96.9078454,33.2617572],[-96.9079617,33.2616285],[-96.9079617,33.2616285],[-96.9082924,33.2618298],[-96.9082924,33.2618298]]]},"properties":{"lotName":"5-A-4","lotCpId":"8080751615534225667","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038526,33.2663581],[-96.9039304,33.2663709],[-96.9039531,33.2663733],[-96.9040069,33.2663692],[-96.9040707,33.2663413],[-96.9040997,33.266313],[-96.9041232,33.2662724],[-96.9041309,33.266249],[-96.904135,33.2662409],[-96.904149,33.2662243],[-96.9041754,33.2662106],[-96.9042165,33.2662116],[-96.9042772,33.2662308],[-96.9042936,33.2662659],[-96.9042936,33.2662659],[-96.9040098,33.2667706],[-96.9040098,33.2667706],[-96.9037773,33.2667359],[-96.9037773,33.2667359],[-96.9038526,33.2663581],[-96.9038526,33.2663581]]]},"properties":{"lotName":"3-X-15","lotCpId":"5678771615889547466","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035606,33.2663398],[-96.9035826,33.2663396],[-96.9036436,33.2663408],[-96.9037361,33.266346],[-96.9038526,33.2663581],[-96.9038526,33.2663581],[-96.9037773,33.2667359],[-96.9037773,33.2667359],[-96.9035682,33.2667231],[-96.9035682,33.2667231],[-96.9035606,33.2663398],[-96.9035606,33.2663398]]]},"properties":{"lotName":"3-X-14","lotCpId":"8581371615889547462","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9032697,33.2663663],[-96.9032975,33.2663617],[-96.903368,33.266352],[-96.9035606,33.2663398],[-96.9035606,33.2663398],[-96.9035682,33.2667231],[-96.9035682,33.2667231],[-96.9033587,33.2667336],[-96.9033587,33.2667336],[-96.9032697,33.2663663],[-96.9032697,33.2663663]]]},"properties":{"lotName":"3-X-13","lotCpId":"2037301615889547460","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9029903,33.2664361],[-96.9029941,33.2664347],[-96.9030197,33.2664265],[-96.9030853,33.266407],[-96.9032697,33.2663663],[-96.9032697,33.2663663],[-96.9033587,33.2667336],[-96.9033587,33.2667336],[-96.9031371,33.266745],[-96.9031371,33.266745],[-96.9029903,33.2664361],[-96.9029903,33.2664361]]]},"properties":{"lotName":"3-X-12","lotCpId":"2452201615889547239","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9027769,33.2665068],[-96.9028044,33.2664977],[-96.9028681,33.2664765],[-96.9029395,33.2664528],[-96.9029903,33.2664361],[-96.9029903,33.2664361],[-96.9031371,33.266745],[-96.9031371,33.266745],[-96.9029242,33.2668162],[-96.9029242,33.2668162],[-96.9027769,33.2665068],[-96.9027769,33.2665068]]]},"properties":{"lotName":"3-X-11","lotCpId":"8470531615889547233","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9025684,33.2665589],[-96.9025835,33.2665565],[-96.9026261,33.2665483],[-96.9026919,33.2665324],[-96.9027769,33.2665068],[-96.9027769,33.2665068],[-96.9029242,33.2668162],[-96.9029242,33.2668162],[-96.9026481,33.2668851],[-96.9026481,33.2668851],[-96.9025684,33.2665589],[-96.9025684,33.2665589]]]},"properties":{"lotName":"3-X-10","lotCpId":"7218601615889547227","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9023523,33.2665794],[-96.9023716,33.2665791],[-96.9024218,33.266577],[-96.9025684,33.2665589],[-96.9025684,33.2665589],[-96.9026481,33.2668851],[-96.9026481,33.2668851],[-96.9023626,33.2669121],[-96.9023615,33.266912],[-96.9023615,33.266912],[-96.9023523,33.2665794],[-96.9023523,33.2665794]]]},"properties":{"lotName":"3-X-9","lotCpId":"4163531615889547217","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9021351,33.2665675],[-96.9021547,33.2665701],[-96.9022054,33.2665752],[-96.9023523,33.2665794],[-96.9023523,33.2665794],[-96.9023615,33.266912],[-96.9023615,33.266912],[-96.9020739,33.2668965],[-96.9020739,33.2668965],[-96.9021351,33.2665675],[-96.9021351,33.2665675]]]},"properties":{"lotName":"3-X-8","lotCpId":"3027281615889547043","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9019091,33.2665365],[-96.90193,33.2665394],[-96.9019824,33.2665466],[-96.9021218,33.266566],[-96.9021351,33.2665675],[-96.9021351,33.2665675],[-96.9020739,33.2668965],[-96.9020739,33.2668965],[-96.9018469,33.2668651],[-96.9018469,33.2668651],[-96.9019091,33.2665365],[-96.9019091,33.2665365]]]},"properties":{"lotName":"3-X-7","lotCpId":"3088421615889547027","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9016264,33.2665155],[-96.9016469,33.2665155],[-96.9017031,33.2665171],[-96.9017871,33.2665224],[-96.9018911,33.2665338],[-96.9019091,33.2665365],[-96.9019091,33.2665365],[-96.9018469,33.2668651],[-96.9018469,33.2668651],[-96.9016269,33.2668856],[-96.9016269,33.2668856],[-96.9016264,33.2665155],[-96.9016264,33.2665155]]]},"properties":{"lotName":"3-X-6","lotCpId":"8732101615889547028","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013355,33.2665383],[-96.9013543,33.266535],[-96.9014099,33.2665275],[-96.901501,33.2665198],[-96.9016264,33.2665155],[-96.9016264,33.2665155],[-96.9016269,33.2668856],[-96.9016269,33.2668856],[-96.9014163,33.2669016],[-96.9014163,33.2669016],[-96.9013355,33.2665383],[-96.9013355,33.2665383]]]},"properties":{"lotName":"3-X-5","lotCpId":"8622841615889546978","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.901055,33.266604],[-96.9010743,33.2665978],[-96.9011298,33.2665821],[-96.901218,33.2665608],[-96.9013355,33.2665383],[-96.9013355,33.2665383],[-96.9014163,33.2669016],[-96.9014163,33.2669016],[-96.9012127,33.2669495],[-96.9012127,33.2669495],[-96.901055,33.266604],[-96.901055,33.266604]]]},"properties":{"lotName":"3-X-4","lotCpId":"3735301615889546759","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008007,33.2667081],[-96.9008193,33.2666988],[-96.9008716,33.2666746],[-96.9009519,33.2666411],[-96.901055,33.266604],[-96.901055,33.266604],[-96.9012127,33.2669495],[-96.9012127,33.2669495],[-96.9010206,33.2670284],[-96.9010206,33.2670284],[-96.9008007,33.2667081],[-96.9008007,33.2667081]]]},"properties":{"lotName":"3-X-3","lotCpId":"5311621615955283746","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005894,33.2667943],[-96.9006181,33.2667941],[-96.9006488,33.2667875],[-96.9006862,33.2667711],[-96.900727,33.2667473],[-96.9007376,33.2667416],[-96.9007616,33.2667289],[-96.9007866,33.2667155],[-96.9008007,33.2667081],[-96.9008007,33.2667081],[-96.9010206,33.2670284],[-96.9010206,33.2670284],[-96.9008116,33.2671083],[-96.9008116,33.2671083],[-96.9005894,33.2667943],[-96.9005894,33.2667943]]]},"properties":{"lotName":"3-X-2","lotCpId":"6224731615955202752","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9002811,33.2667359],[-96.9003492,33.2666975],[-96.9003581,33.2666937],[-96.9003804,33.2666886],[-96.9004098,33.2666915],[-96.9004399,33.2667117],[-96.9004585,33.2667345],[-96.9004662,33.2667435],[-96.9004901,33.2667633],[-96.9005309,33.2667837],[-96.9005894,33.2667943],[-96.9005894,33.2667943],[-96.9008116,33.2671083],[-96.9008116,33.2671083],[-96.9006014,33.2671881],[-96.9006014,33.2671881],[-96.9002811,33.2667359],[-96.9002811,33.2667359]]]},"properties":{"lotName":"3-X-1","lotCpId":"1861731615955085854","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057644,33.2652998],[-96.9057344,33.2654308],[-96.9057258,33.265464],[-96.9057213,33.2654792],[-96.9057213,33.2654792],[-96.90533,33.265397],[-96.90533,33.265397],[-96.9053551,33.2653131],[-96.9053736,33.2652369],[-96.9053736,33.2652369],[-96.9057644,33.2652998],[-96.9057644,33.2652998]]]},"properties":{"lotName":"3-T-20","lotCpId":"8537601615532625527","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058015,33.2651383],[-96.9057644,33.2652998],[-96.9057644,33.2652998],[-96.9053736,33.2652369],[-96.9053736,33.2652369],[-96.9053971,33.2651424],[-96.9054135,33.2650762],[-96.9054135,33.2650762],[-96.9058015,33.2651383],[-96.9058015,33.2651383]]]},"properties":{"lotName":"3-T-19","lotCpId":"1338381615532660128","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058501,33.2649882],[-96.9058458,33.2649986],[-96.9058348,33.2650277],[-96.9058201,33.265072],[-96.9058047,33.2651284],[-96.9058015,33.2651383],[-96.9058015,33.2651383],[-96.9054135,33.2650762],[-96.9054135,33.2650762],[-96.9054364,33.2649859],[-96.9054795,33.2648754],[-96.9054795,33.2648754],[-96.9058501,33.2649882],[-96.9058501,33.2649882]]]},"properties":{"lotName":"3-T-18","lotCpId":"4428881615532621319","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9059281,33.2648476],[-96.9059197,33.264861],[-96.9058991,33.264895],[-96.9058501,33.2649882],[-96.9058501,33.2649882],[-96.9054795,33.2648754],[-96.9054795,33.2648754],[-96.9054943,33.2648385],[-96.9055739,33.2646979],[-96.9055849,33.2646838],[-96.9055849,33.2646838],[-96.9059281,33.2648476],[-96.9059281,33.2648476]]]},"properties":{"lotName":"3-T-17","lotCpId":"7543551615532623817","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9060335,33.2647203],[-96.9060227,33.2647318],[-96.9059959,33.2647616],[-96.9059281,33.2648476],[-96.9059281,33.2648476],[-96.9055849,33.2646838],[-96.9055849,33.2646838],[-96.9056738,33.264567],[-96.9057295,33.2645108],[-96.9057295,33.2645108],[-96.9060335,33.2647203],[-96.9060335,33.2647203]]]},"properties":{"lotName":"3-T-16","lotCpId":"8187001615532637288","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9061628,33.2646094],[-96.9061501,33.2646192],[-96.9061182,33.2646447],[-96.9060335,33.2647203],[-96.9060335,33.2647203],[-96.9057295,33.2645108],[-96.9057295,33.2645108],[-96.9057928,33.2644474],[-96.9059052,33.2643593],[-96.9059052,33.2643593],[-96.9061628,33.2646094],[-96.9061628,33.2646094]]]},"properties":{"lotName":"3-T-15","lotCpId":"4863001615532653170","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9063151,33.2645126],[-96.9062322,33.2645641],[-96.9062237,33.2645694],[-96.9062038,33.2645819],[-96.9061628,33.2646094],[-96.9061628,33.2646094],[-96.9059052,33.2643593],[-96.9059052,33.2643593],[-96.9059281,33.2643415],[-96.9060815,33.2642452],[-96.9060815,33.2642452],[-96.9063151,33.2645126],[-96.9063151,33.2645126]]]},"properties":{"lotName":"3-T-14","lotCpId":"6111021615532626756","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9064739,33.2644159],[-96.9063151,33.2645126],[-96.9063151,33.2645126],[-96.9060815,33.2642452],[-96.9060815,33.2642452],[-96.9062403,33.2641485],[-96.9062403,33.2641485],[-96.9064739,33.2644159],[-96.9064739,33.2644159]]]},"properties":{"lotName":"3-T-13","lotCpId":"4167731615532642671","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9066327,33.2643187],[-96.9064739,33.2644159],[-96.9064739,33.2644159],[-96.9062403,33.2641485],[-96.9062403,33.2641485],[-96.9064253,33.2640353],[-96.9064253,33.2640353],[-96.9066398,33.2642808],[-96.9066327,33.2643187],[-96.9066327,33.2643187]]]},"properties":{"lotName":"3-T-12","lotCpId":"5144131615532625930","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9060062,33.2638806],[-96.906165,33.2637839],[-96.906165,33.2637839],[-96.9062108,33.2637898],[-96.9064253,33.2640353],[-96.9064253,33.2640353],[-96.9062403,33.2641485],[-96.9062403,33.2641485],[-96.9060062,33.2638806],[-96.9060062,33.2638806]]]},"properties":{"lotName":"3-T-11","lotCpId":"1141211615532640609","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058479,33.2639778],[-96.9060062,33.2638806],[-96.9060062,33.2638806],[-96.9062403,33.2641485],[-96.9062403,33.2641485],[-96.9060815,33.2642452],[-96.9060815,33.2642452],[-96.9058479,33.2639778],[-96.9058479,33.2639778]]]},"properties":{"lotName":"3-T-10","lotCpId":"3510541615532638610","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905676,33.264086],[-96.9056853,33.2640798],[-96.9057081,33.2640647],[-96.9057639,33.2640289],[-96.9058479,33.2639778],[-96.9058479,33.2639778],[-96.9060815,33.2642452],[-96.9060815,33.2642452],[-96.9059281,33.2643415],[-96.9059281,33.2643415],[-96.905676,33.264086],[-96.905676,33.264086]]]},"properties":{"lotName":"3-T-9","lotCpId":"8706321615532658048","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9055041,33.2642206],[-96.9055192,33.2642075],[-96.9055587,33.2641746],[-96.905676,33.264086],[-96.905676,33.264086],[-96.9059281,33.2643415],[-96.9059281,33.2643415],[-96.905926,33.2643432],[-96.9057928,33.2644474],[-96.9057928,33.2644474],[-96.9055041,33.2642206],[-96.9055041,33.2642206]]]},"properties":{"lotName":"3-T-8","lotCpId":"7021421615532641289","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905354,33.2643716],[-96.90537,33.2643543],[-96.9054093,33.2643128],[-96.9054584,33.2642629],[-96.9055041,33.2642206],[-96.9055041,33.2642206],[-96.9057928,33.2644474],[-96.9057928,33.2644474],[-96.9056738,33.264567],[-96.9056738,33.264567],[-96.905354,33.2643716],[-96.905354,33.2643716]]]},"properties":{"lotName":"3-T-7","lotCpId":"6858651615532639265","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052274,33.2645377],[-96.9052405,33.2645189],[-96.905273,33.2644736],[-96.9053143,33.2644189],[-96.905354,33.2643716],[-96.905354,33.2643716],[-96.9056738,33.264567],[-96.9056738,33.264567],[-96.9055739,33.2646979],[-96.9055739,33.2646979],[-96.9052274,33.2645377],[-96.9052274,33.2645377]]]},"properties":{"lotName":"3-T-6","lotCpId":"1671781615532645367","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051264,33.2647153],[-96.9051379,33.2646936],[-96.9051654,33.2646428],[-96.9051987,33.2645838],[-96.9052274,33.2645377],[-96.9052274,33.2645377],[-96.9055739,33.2646979],[-96.9055739,33.2646979],[-96.9054943,33.2648385],[-96.9054943,33.2648385],[-96.9051264,33.2647153],[-96.9051264,33.2647153]]]},"properties":{"lotName":"3-T-5","lotCpId":"6740651615532655986","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9050527,33.2649024],[-96.9050605,33.2648801],[-96.9050796,33.2648275],[-96.9051037,33.2647655],[-96.9051264,33.2647153],[-96.9051264,33.2647153],[-96.9054943,33.2648385],[-96.9054943,33.2648385],[-96.9054364,33.2649859],[-96.9054364,33.2649859],[-96.9050527,33.2649024],[-96.9050527,33.2649024]]]},"properties":{"lotName":"3-T-4","lotCpId":"1707321615532652206","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905008,33.2650799],[-96.9050254,33.2650032],[-96.9050284,33.2649913],[-96.9050355,33.264963],[-96.9050527,33.2649024],[-96.9050527,33.2649024],[-96.9054364,33.2649859],[-96.9054364,33.2649859],[-96.9053971,33.2651424],[-96.9053971,33.2651424],[-96.905008,33.2650799],[-96.905008,33.2650799]]]},"properties":{"lotName":"3-T-3","lotCpId":"1271631615532637928","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049692,33.2652387],[-96.9049952,33.2651378],[-96.905008,33.2650799],[-96.905008,33.2650799],[-96.9053971,33.2651424],[-96.9053971,33.2651424],[-96.9053551,33.2653131],[-96.9053551,33.2653131],[-96.9049692,33.2652387],[-96.9049692,33.2652387]]]},"properties":{"lotName":"3-T-2","lotCpId":"4880501615532646031","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049208,33.265395],[-96.9049268,33.2653769],[-96.9049407,33.2653338],[-96.9049568,33.2652822],[-96.9049692,33.2652387],[-96.9049692,33.2652387],[-96.9053551,33.2653131],[-96.9053551,33.2653131],[-96.9053021,33.2654878],[-96.9053021,33.2654878],[-96.9049208,33.265395],[-96.9049208,33.265395]]]},"properties":{"lotName":"3-T-1","lotCpId":"2656171615532655249","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8974818,33.2642046],[-96.8974621,33.2642027],[-96.8974129,33.2642052],[-96.8973498,33.2642241],[-96.8972881,33.2642717],[-96.8972881,33.2642717],[-96.8974087,33.263829],[-96.8974087,33.263829],[-96.8975697,33.2638833],[-96.8975697,33.2638833],[-96.8974818,33.2642046],[-96.8974818,33.2642046]]]},"properties":{"lotName":"1A-F-20","lotCpId":"5873001615535210809","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8976368,33.2642521],[-96.897619,33.2642491],[-96.8975697,33.2642387],[-96.8975464,33.2642242],[-96.8974818,33.2642046],[-96.8974818,33.2642046],[-96.8975697,33.2638833],[-96.8975697,33.2638833],[-96.8976767,33.2639194],[-96.8977258,33.2639267],[-96.8977258,33.2639267],[-96.8976368,33.2642521],[-96.8976368,33.2642521]]]},"properties":{"lotName":"1A-F-19","lotCpId":"7427001615535230751","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.897835,33.2642799],[-96.8978175,33.2642785],[-96.8977718,33.2642739],[-96.8976368,33.2642521],[-96.8976368,33.2642521],[-96.8977258,33.2639267],[-96.8977258,33.2639267],[-96.8978764,33.2639491],[-96.8978764,33.2639491],[-96.897835,33.2642799],[-96.897835,33.2642799]]]},"properties":{"lotName":"1A-F-18","lotCpId":"5055721615535215386","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980353,33.2642877],[-96.8980151,33.2642878],[-96.8979649,33.2642874],[-96.897835,33.2642799],[-96.897835,33.2642799],[-96.8978764,33.2639491],[-96.8978764,33.2639491],[-96.8978928,33.2639518],[-96.8980298,33.2639527],[-96.8980298,33.2639527],[-96.8980353,33.2642877],[-96.8980353,33.2642877]]]},"properties":{"lotName":"1A-F-17","lotCpId":"1376601615535348095","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898235,33.2642753],[-96.8982171,33.2642774],[-96.8981707,33.2642818],[-96.8980353,33.2642877],[-96.8980353,33.2642877],[-96.8980298,33.2639527],[-96.8980298,33.2639527],[-96.8981128,33.2639532],[-96.8981826,33.2639436],[-96.8981826,33.2639436],[-96.898235,33.2642753],[-96.898235,33.2642753]]]},"properties":{"lotName":"1A-F-16","lotCpId":"6625131615535318515","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898432,33.2642439],[-96.898414,33.2642476],[-96.8983676,33.2642564],[-96.898235,33.2642753],[-96.898235,33.2642753],[-96.8981826,33.2639436],[-96.8981826,33.2639436],[-96.8983294,33.2639235],[-96.8983338,33.2639226],[-96.8983338,33.2639226],[-96.898432,33.2642439],[-96.898432,33.2642439]]]},"properties":{"lotName":"1A-F-15","lotCpId":"1224021615535322531","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8986181,33.2641941],[-96.8985999,33.2641998],[-96.8985541,33.2642134],[-96.898432,33.2642439],[-96.898432,33.2642439],[-96.8983338,33.2639226],[-96.8983338,33.2639226],[-96.8984806,33.2638833],[-96.8984806,33.2638833],[-96.8986225,33.2641928],[-96.8986181,33.2641941],[-96.8986181,33.2641941]]]},"properties":{"lotName":"1A-F-14","lotCpId":"1402431615535397116","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987753,33.2641439],[-96.8986225,33.2641928],[-96.8986225,33.2641928],[-96.8984806,33.2638833],[-96.8984806,33.2638833],[-96.8985395,33.2638678],[-96.898635,33.2638373],[-96.898635,33.2638373],[-96.8987753,33.2641439],[-96.8987753,33.2641439]]]},"properties":{"lotName":"1A-F-13","lotCpId":"8188761615535294557","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989281,33.2640951],[-96.8987753,33.2641439],[-96.8987753,33.2641439],[-96.898635,33.2638373],[-96.898635,33.2638373],[-96.8987879,33.2637884],[-96.8987879,33.2637884],[-96.8989281,33.2640951],[-96.8989281,33.2640951]]]},"properties":{"lotName":"1A-F-12","lotCpId":"4208121615535283876","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990809,33.2640463],[-96.8989281,33.2640951],[-96.8989281,33.2640951],[-96.8987879,33.2637884],[-96.8987879,33.2637884],[-96.8989407,33.2637391],[-96.8989407,33.2637391],[-96.8990809,33.2640463],[-96.8990809,33.2640463]]]},"properties":{"lotName":"1A-F-11","lotCpId":"8531251615535217414","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8992327,33.2639979],[-96.8990809,33.2640463],[-96.8990809,33.2640463],[-96.8989407,33.2637391],[-96.8989407,33.2637391],[-96.899165,33.2636675],[-96.899165,33.2636675],[-96.8991711,33.2637014],[-96.8991724,33.263708],[-96.8991763,33.2637263],[-96.8991917,33.2637894],[-96.8992169,33.2638738],[-96.8992518,33.2639623],[-96.8992327,33.2639979],[-96.8992327,33.2639979]]]},"properties":{"lotName":"1A-F-10","lotCpId":"7534301615535286519","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988719,33.2633905],[-96.8988876,33.2633867],[-96.8989293,33.263377],[-96.8990602,33.2633499],[-96.8990602,33.2633499],[-96.8991071,33.2633768],[-96.899165,33.2636675],[-96.899165,33.2636675],[-96.8989903,33.2637232],[-96.8989903,33.2637232],[-96.8988719,33.2633905],[-96.8988719,33.2633905]]]},"properties":{"lotName":"1A-F-9","lotCpId":"5023411615535219460","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8986951,33.2634402],[-96.8987119,33.263435],[-96.8987547,33.2634221],[-96.8988719,33.2633905],[-96.8988719,33.2633905],[-96.8989903,33.2637232],[-96.8989903,33.2637232],[-96.8988446,33.2637697],[-96.8988446,33.2637697],[-96.8986951,33.2634402],[-96.8986951,33.2634402]]]},"properties":{"lotName":"1A-F-8","lotCpId":"3855861615535407154","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8985232,33.2635014],[-96.8985416,33.2634944],[-96.8985867,33.2634777],[-96.8986951,33.2634402],[-96.8986951,33.2634402],[-96.8988446,33.2637697],[-96.8988446,33.2637697],[-96.8986995,33.2638163],[-96.8986995,33.2638163],[-96.8985232,33.2635014],[-96.8985232,33.2635014]]]},"properties":{"lotName":"1A-F-7","lotCpId":"6054061615535557288","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8983774,33.2635607],[-96.898386,33.2635575],[-96.8984282,33.2635402],[-96.8984358,33.2635368],[-96.8984563,33.2635281],[-96.8985232,33.2635014],[-96.8985232,33.2635014],[-96.8986995,33.2638163],[-96.8986995,33.2638163],[-96.8985395,33.2638678],[-96.8985395,33.2638678],[-96.8983774,33.2635607],[-96.8983774,33.2635607]]]},"properties":{"lotName":"1A-F-6","lotCpId":"7424641615535343470","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982328,33.2636022],[-96.8982454,33.2635999],[-96.8982784,33.2635925],[-96.8983774,33.2635607],[-96.8983774,33.2635607],[-96.8985395,33.2638678],[-96.8985395,33.2638678],[-96.8983338,33.2639226],[-96.8983294,33.2639235],[-96.8983294,33.2639235],[-96.8982328,33.2636022],[-96.8982328,33.2636022]]]},"properties":{"lotName":"1A-F-5","lotCpId":"2560601615535229414","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980822,33.2636228],[-96.8980965,33.2636217],[-96.898133,33.2636181],[-96.8982328,33.2636022],[-96.8982328,33.2636022],[-96.8983294,33.2639235],[-96.8983294,33.2639235],[-96.8981128,33.2639532],[-96.8981128,33.2639532],[-96.8980822,33.2636228],[-96.8980822,33.2636228]]]},"properties":{"lotName":"1A-F-4","lotCpId":"1831751615535324538","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979294,33.2636219],[-96.8979445,33.2636228],[-96.8979825,33.2636246],[-96.8980822,33.2636228],[-96.8980822,33.2636228],[-96.8981128,33.2639532],[-96.8981128,33.2639532],[-96.8978928,33.2639518],[-96.8978928,33.2639518],[-96.8979294,33.2636219],[-96.8979294,33.2636219]]]},"properties":{"lotName":"1A-F-3","lotCpId":"7730881615535251910","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8977793,33.263599],[-96.8977943,33.2636022],[-96.8978319,33.2636094],[-96.8979294,33.2636219],[-96.8979294,33.2636219],[-96.8978928,33.2639518],[-96.8978928,33.2639518],[-96.8976767,33.2639194],[-96.8976767,33.2639194],[-96.8977793,33.263599],[-96.8977793,33.263599]]]},"properties":{"lotName":"1A-F-2","lotCpId":"8872481615535214098","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8976265,33.2635526],[-96.8976425,33.2635583],[-96.897682,33.2635717],[-96.8977793,33.263599],[-96.8977793,33.263599],[-96.8976767,33.2639194],[-96.8976767,33.2639194],[-96.8974087,33.263829],[-96.8974087,33.263829],[-96.8976265,33.2635526],[-96.8976265,33.2635526]]]},"properties":{"lotName":"1A-F-1","lotCpId":"6510541615535237494","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9034793,33.2634987],[-96.9036412,33.2634061],[-96.9036412,33.2634061],[-96.9039231,33.2637509],[-96.9039231,33.2637509],[-96.9037609,33.2638436],[-96.9037609,33.2638436],[-96.9034793,33.2634987],[-96.9034793,33.2634987]]]},"properties":{"lotName":"1B-R-28","lotCpId":"6741851615535768661","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9033172,33.2635913],[-96.9034793,33.2634987],[-96.9034793,33.2634987],[-96.9037609,33.2638436],[-96.9037609,33.2638436],[-96.9035983,33.2639363],[-96.9035983,33.2639363],[-96.9033172,33.2635913],[-96.9033172,33.2635913]]]},"properties":{"lotName":"1B-R-27","lotCpId":"6307411615535803383","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9031545,33.2636839],[-96.9033172,33.2635913],[-96.9033172,33.2635913],[-96.9035983,33.2639363],[-96.9035983,33.2639363],[-96.9034362,33.2640289],[-96.9034362,33.2640289],[-96.9031545,33.2636839],[-96.9031545,33.2636839]]]},"properties":{"lotName":"1B-R-26","lotCpId":"2786641615535780639","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9029925,33.2637766],[-96.9031545,33.2636839],[-96.9031545,33.2636839],[-96.9034362,33.2640289],[-96.9034362,33.2640289],[-96.9032735,33.2641216],[-96.9032735,33.2641216],[-96.9029925,33.2637766],[-96.9029925,33.2637766]]]},"properties":{"lotName":"1B-R-25","lotCpId":"4607251615535771974","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9028571,33.2638537],[-96.9029925,33.2637766],[-96.9029925,33.2637766],[-96.9032735,33.2641216],[-96.9032735,33.2641216],[-96.9031382,33.2641987],[-96.9031382,33.2641987],[-96.9028571,33.2638537],[-96.9028571,33.2638537]]]},"properties":{"lotName":"1A-R-24","lotCpId":"5084461615535242915","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9027218,33.2639308],[-96.9028571,33.2638537],[-96.9028571,33.2638537],[-96.9031382,33.2641987],[-96.9031382,33.2641987],[-96.9030028,33.2642758],[-96.9030028,33.2642758],[-96.9027218,33.2639308],[-96.9027218,33.2639308]]]},"properties":{"lotName":"1A-R-23","lotCpId":"7664011615535428693","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9025864,33.2640079],[-96.9025969,33.2640023],[-96.9027218,33.2639308],[-96.9027218,33.2639308],[-96.9030028,33.2642758],[-96.9030028,33.2642758],[-96.902868,33.2643529],[-96.902868,33.2643529],[-96.9025864,33.2640079],[-96.9025864,33.2640079]]]},"properties":{"lotName":"1A-R-22","lotCpId":"7705401615535342755","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9024074,33.2641448],[-96.9024243,33.2641289],[-96.902438,33.2641166],[-96.9024744,33.264086],[-96.9025864,33.2640079],[-96.9025864,33.2640079],[-96.902868,33.2643529],[-96.902868,33.2643529],[-96.9027894,33.264415],[-96.9027894,33.264415],[-96.9027807,33.2644218],[-96.9024074,33.2641448],[-96.9024074,33.2641448]]]},"properties":{"lotName":"1A-R-21","lotCpId":"3100661615535240870","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9022988,33.2642471],[-96.9024074,33.2641448],[-96.9024074,33.2641448],[-96.9027807,33.2644218],[-96.9027807,33.2644218],[-96.9026721,33.2645245],[-96.9026721,33.2645245],[-96.9022988,33.2642471],[-96.9022988,33.2642471]]]},"properties":{"lotName":"1A-R-20","lotCpId":"7117081615535408491","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9021902,33.2643493],[-96.9022988,33.2642471],[-96.9022988,33.2642471],[-96.9026721,33.2645245],[-96.9026721,33.2645245],[-96.9025635,33.2646267],[-96.9025635,33.2646267],[-96.9021902,33.2643493],[-96.9021902,33.2643493]]]},"properties":{"lotName":"1A-R-19","lotCpId":"3715261615535238832","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.902081,33.2644515],[-96.9021902,33.2643493],[-96.9021902,33.2643493],[-96.9025635,33.2646267],[-96.9025635,33.2646267],[-96.9024543,33.264729],[-96.9024543,33.264729],[-96.902081,33.2644515],[-96.902081,33.2644515]]]},"properties":{"lotName":"1A-R-18","lotCpId":"5427201615535257231","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9019724,33.2645537],[-96.902081,33.2644515],[-96.902081,33.2644515],[-96.9024543,33.264729],[-96.9024543,33.264729],[-96.9023457,33.2648312],[-96.9023457,33.2648312],[-96.9019724,33.2645537],[-96.9019724,33.2645537]]]},"properties":{"lotName":"1A-R-17","lotCpId":"1604171615535371871","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018638,33.2646564],[-96.9019724,33.2645537],[-96.9019724,33.2645537],[-96.9023457,33.2648312],[-96.9023457,33.2648312],[-96.9022366,33.2649339],[-96.9022366,33.2649339],[-96.9018638,33.2646564],[-96.9018638,33.2646564]]]},"properties":{"lotName":"1A-R-16","lotCpId":"2560161615535251232","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017547,33.2647586],[-96.9018638,33.2646564],[-96.9018638,33.2646564],[-96.9022366,33.2649339],[-96.9022366,33.2649339],[-96.902128,33.2650361],[-96.902128,33.2650361],[-96.9017547,33.2647586],[-96.9017547,33.2647586]]]},"properties":{"lotName":"1A-R-15","lotCpId":"3614701615535255911","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.901646,33.2648608],[-96.9017547,33.2647586],[-96.9017547,33.2647586],[-96.902128,33.2650361],[-96.902128,33.2650361],[-96.9020194,33.2651383],[-96.9020194,33.2651383],[-96.901646,33.2648608],[-96.901646,33.2648608]]]},"properties":{"lotName":"1A-R-14","lotCpId":"7786501615535249910","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015369,33.2649631],[-96.901646,33.2648608],[-96.901646,33.2648608],[-96.9020194,33.2651383],[-96.9020194,33.2651383],[-96.9019102,33.2652405],[-96.9019102,33.2652405],[-96.9015369,33.2649631],[-96.9015369,33.2649631]]]},"properties":{"lotName":"1A-R-13","lotCpId":"1360201615535240183","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9023223,33.263782],[-96.9024041,33.2638865],[-96.9024183,33.2639043],[-96.9024096,33.26395],[-96.9024096,33.26395],[-96.9024004,33.2639566],[-96.902376,33.2639751],[-96.9023018,33.2640384],[-96.9021596,33.2641718],[-96.9021596,33.2641718],[-96.9019866,33.2639586],[-96.9019866,33.2639586],[-96.9023223,33.263782],[-96.9023223,33.263782]]]},"properties":{"lotName":"1A-L-22","lotCpId":"6374731615535584315","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9022388,33.2636657],[-96.9023223,33.263782],[-96.9023223,33.263782],[-96.9019866,33.2639586],[-96.9019866,33.2639586],[-96.9018949,33.2638309],[-96.9018949,33.2638309],[-96.9022388,33.2636657],[-96.9022388,33.2636657]]]},"properties":{"lotName":"1A-L-21","lotCpId":"6642851615535245596","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9021607,33.2635466],[-96.9022388,33.2636657],[-96.9022388,33.2636657],[-96.9018949,33.2638309],[-96.9018949,33.2638309],[-96.9018092,33.2636999],[-96.9018092,33.2636999],[-96.9021607,33.2635466],[-96.9021607,33.2635466]]]},"properties":{"lotName":"1A-L-20","lotCpId":"6443401615535552994","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9020881,33.2634252],[-96.9021607,33.2635466],[-96.9021607,33.2635466],[-96.9018092,33.2636999],[-96.9018092,33.2636999],[-96.9017301,33.2635662],[-96.9017301,33.2635662],[-96.9020881,33.2634252],[-96.9020881,33.2634252]]]},"properties":{"lotName":"1A-L-19","lotCpId":"6554051615535321836","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9020221,33.2633011],[-96.9020881,33.2634252],[-96.9020881,33.2634252],[-96.9017301,33.2635662],[-96.9017301,33.2635662],[-96.901657,33.2634297],[-96.901657,33.2634297],[-96.9020221,33.2633011],[-96.9020221,33.2633011]]]},"properties":{"lotName":"1A-L-18","lotCpId":"7256711615535436535","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.901962,33.2631746],[-96.9020221,33.2633011],[-96.9020221,33.2633011],[-96.901657,33.2634297],[-96.901657,33.2634297],[-96.9015909,33.2632915],[-96.9015909,33.2632915],[-96.901962,33.2631746],[-96.901962,33.2631746]]]},"properties":{"lotName":"1A-L-17","lotCpId":"4380781615535314537","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018949,33.2630122],[-96.901962,33.2631746],[-96.901962,33.2631746],[-96.9015909,33.2632915],[-96.9015909,33.2632915],[-96.9014845,33.2630204],[-96.9014845,33.2630204],[-96.9016182,33.2630213],[-96.9018949,33.2630122],[-96.9018949,33.2630122]]]},"properties":{"lotName":"1A-L-16","lotCpId":"8807341615535290610","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015958,33.26268],[-96.9016105,33.2626792],[-96.9016479,33.2626771],[-96.9017503,33.2626695],[-96.9017945,33.2626959],[-96.9017945,33.2626959],[-96.9018949,33.2630122],[-96.9018949,33.2630122],[-96.9016182,33.2630213],[-96.9016182,33.2630213],[-96.9015958,33.26268],[-96.9015958,33.26268]]]},"properties":{"lotName":"1A-L-15","lotCpId":"2530421615535313213","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014343,33.2626836],[-96.9014513,33.2626835],[-96.901493,33.262683],[-96.9015958,33.26268],[-96.9015958,33.26268],[-96.9016182,33.2630213],[-96.9016182,33.2630213],[-96.9014348,33.2630204],[-96.9014348,33.2630204],[-96.9014343,33.2626836],[-96.9014343,33.2626836]]]},"properties":{"lotName":"1A-L-14","lotCpId":"7275621615535554264","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9012722,33.26268],[-96.9014343,33.2626836],[-96.9014343,33.2626836],[-96.9014348,33.2630204],[-96.9014348,33.2630204],[-96.9014277,33.2630199],[-96.9012515,33.2630126],[-96.9012515,33.2630126],[-96.9012722,33.26268],[-96.9012722,33.26268]]]},"properties":{"lotName":"1A-L-13","lotCpId":"2656181615535553834","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9011106,33.2626695],[-96.9011245,33.2626707],[-96.9011609,33.2626737],[-96.9012722,33.26268],[-96.9012722,33.26268],[-96.9012515,33.2630126],[-96.9012515,33.2630126],[-96.9010997,33.2630021],[-96.9010686,33.2629999],[-96.9010686,33.2629999],[-96.9011106,33.2626695],[-96.9011106,33.2626695]]]},"properties":{"lotName":"1A-L-12","lotCpId":"2643601615535321170","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9009584,33.2626526],[-96.9009715,33.2626544],[-96.9010061,33.2626588],[-96.9011106,33.2626695],[-96.9011106,33.2626695],[-96.9010686,33.2629999],[-96.9010686,33.2629999],[-96.9008514,33.2629752],[-96.9008514,33.2629752],[-96.9009125,33.26268],[-96.9009584,33.2626526],[-96.9009584,33.2626526]]]},"properties":{"lotName":"1A-L-11","lotCpId":"3766501615535562973","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010293,33.2633388],[-96.9008225,33.2633088],[-96.9007903,33.2632705],[-96.9007903,33.2632705],[-96.9008514,33.2629752],[-96.9008514,33.2629752],[-96.9010686,33.2629999],[-96.9010997,33.2630021],[-96.9010997,33.2630021],[-96.9010293,33.2633388],[-96.9010293,33.2633388]]]},"properties":{"lotName":"1A-L-10","lotCpId":"3161501615535295238","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9012012,33.2633508],[-96.9011776,33.2633384],[-96.9011167,33.2633239],[-96.9010894,33.2633241],[-96.9010293,33.2633388],[-96.9010293,33.2633388],[-96.9010997,33.2630021],[-96.9010997,33.2630021],[-96.9012515,33.2630126],[-96.9014277,33.2630199],[-96.9014277,33.2630199],[-96.9012012,33.2633508],[-96.9012012,33.2633508]]]},"properties":{"lotName":"1A-L-9","lotCpId":"1235501615535345481","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9012673,33.2634485],[-96.9012658,33.2634382],[-96.9012577,33.2634131],[-96.901238,33.2633812],[-96.9012012,33.2633508],[-96.9012012,33.2633508],[-96.9014277,33.2630199],[-96.9014845,33.2630204],[-96.9014845,33.2630204],[-96.9015909,33.2632915],[-96.9016073,33.2633257],[-96.9016073,33.2633257],[-96.9012673,33.2634485],[-96.9012673,33.2634485]]]},"properties":{"lotName":"1A-L-8","lotCpId":"7656611615535395113","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013049,33.263584],[-96.9012619,33.2634977],[-96.9012661,33.2634807],[-96.9012673,33.2634485],[-96.9012673,33.2634485],[-96.9016073,33.2633257],[-96.9016073,33.2633257],[-96.901657,33.2634297],[-96.9016695,33.2634526],[-96.9016695,33.2634526],[-96.9013049,33.263584],[-96.9013049,33.263584]]]},"properties":{"lotName":"1A-L-7","lotCpId":"3606701615535350078","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013775,33.2637182],[-96.9013679,33.2637005],[-96.9013457,33.26366],[-96.9013213,33.2636149],[-96.9013049,33.263584],[-96.9013049,33.263584],[-96.9016695,33.2634526],[-96.9016695,33.2634526],[-96.9017301,33.2635662],[-96.9017356,33.2635762],[-96.9017356,33.2635762],[-96.9013775,33.2637182],[-96.9013775,33.2637182]]]},"properties":{"lotName":"1A-L-6","lotCpId":"6706831615535258015","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014561,33.26385],[-96.9014473,33.2638356],[-96.901426,33.2638005],[-96.9013775,33.2637182],[-96.9013775,33.2637182],[-96.9017356,33.2635762],[-96.9017356,33.2635762],[-96.9018076,33.2636972],[-96.9018076,33.2636972],[-96.9014561,33.26385],[-96.9014561,33.26385]]]},"properties":{"lotName":"1A-L-5","lotCpId":"1284501615535405852","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015402,33.2639796],[-96.9015302,33.2639646],[-96.9015066,33.2639288],[-96.9014788,33.263886],[-96.9014561,33.26385],[-96.9014561,33.26385],[-96.9018076,33.2636972],[-96.9018076,33.2636972],[-96.9018092,33.2636999],[-96.9018851,33.2638158],[-96.9018851,33.2638158],[-96.9015402,33.2639796],[-96.9015402,33.2639796]]]},"properties":{"lotName":"1A-L-4","lotCpId":"6330011615535375175","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9016302,33.2641065],[-96.9016185,33.2640902],[-96.9015914,33.2640525],[-96.9015612,33.26401],[-96.9015402,33.2639796],[-96.9015402,33.2639796],[-96.9018851,33.2638158],[-96.9018851,33.2638158],[-96.9018949,33.2638309],[-96.9019681,33.2639322],[-96.9019681,33.2639322],[-96.9016302,33.2641065],[-96.9016302,33.2641065]]]},"properties":{"lotName":"1A-L-3","lotCpId":"7063101615535244230","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017257,33.2642306],[-96.9017141,33.2642159],[-96.9016869,33.2641809],[-96.9016551,33.2641398],[-96.9016302,33.2641065],[-96.9016302,33.2641065],[-96.9019681,33.2639322],[-96.9019681,33.2639322],[-96.9019866,33.2639586],[-96.902057,33.2640449],[-96.902057,33.2640449],[-96.9017257,33.2642306],[-96.9017257,33.2642306]]]},"properties":{"lotName":"1A-L-2","lotCpId":"5305201615535405196","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018627,33.2643931],[-96.9018454,33.2643729],[-96.901805,33.2643257],[-96.9017593,33.2642715],[-96.9017257,33.2642306],[-96.9017257,33.2642306],[-96.902057,33.2640449],[-96.902057,33.2640449],[-96.9021596,33.2641718],[-96.9021596,33.2641718],[-96.9019222,33.2643949],[-96.9018627,33.2643931],[-96.9018627,33.2643931]]]},"properties":{"lotName":"1A-L-1","lotCpId":"6314611615535315853","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987349,33.2632833],[-96.8986215,33.2633169],[-96.8985127,33.2633551],[-96.898431,33.2633862],[-96.8984073,33.2633957],[-96.8983987,33.2633992],[-96.8983987,33.2633992],[-96.8983442,33.2633777],[-96.8983169,33.2632785],[-96.8983031,33.2632121],[-96.8982985,33.2631601],[-96.8982989,33.2631261],[-96.8982999,33.2631139],[-96.8982999,33.2631139],[-96.8986956,33.2631295],[-96.8986956,33.2631295],[-96.8987349,33.2632833],[-96.8987349,33.2632833]]]},"properties":{"lotName":"1A-I-12","lotCpId":"6601881615535346150","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989936,33.2632221],[-96.898969,33.263227],[-96.8989064,33.2632402],[-96.8987349,33.2632833],[-96.8987349,33.2632833],[-96.8986956,33.2631295],[-96.8986956,33.2631295],[-96.8987267,33.2630231],[-96.8988037,33.2629341],[-96.8989008,33.2628839],[-96.8989008,33.2628839],[-96.8989936,33.2632221],[-96.8989936,33.2632221]]]},"properties":{"lotName":"1A-I-11","lotCpId":"6760171615535407816","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991503,33.2631961],[-96.8991353,33.2631982],[-96.8990974,33.2632039],[-96.8989936,33.2632221],[-96.8989936,33.2632221],[-96.8989008,33.2628839],[-96.8989008,33.2628839],[-96.898915,33.2628766],[-96.8990618,33.2628456],[-96.8990798,33.2628429],[-96.8990798,33.2628429],[-96.8991503,33.2631961],[-96.8991503,33.2631961]]]},"properties":{"lotName":"1A-I-10","lotCpId":"8503141615535253895","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8993091,33.2631778],[-96.899291,33.2631797],[-96.8992477,33.2631843],[-96.8991503,33.2631961],[-96.8991503,33.2631961],[-96.8990798,33.2628429],[-96.8990798,33.2628429],[-96.8992179,33.2628223],[-96.8992627,33.2628182],[-96.8992627,33.2628182],[-96.8993091,33.2631778],[-96.8993091,33.2631778]]]},"properties":{"lotName":"1A-I-9","lotCpId":"1341361615535316511","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8994684,33.2631673],[-96.899453,33.263168],[-96.899414,33.2631699],[-96.8993091,33.2631778],[-96.8993091,33.2631778],[-96.8992627,33.2628182],[-96.8992627,33.2628182],[-96.8993757,33.2628073],[-96.8994472,33.2628036],[-96.8994472,33.2628036],[-96.8994684,33.2631673],[-96.8994684,33.2631673]]]},"properties":{"lotName":"1A-I-8","lotCpId":"5446051615535379156","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996278,33.2631651],[-96.8996121,33.263165],[-96.8995727,33.263165],[-96.8994684,33.2631673],[-96.8994684,33.2631673],[-96.8994472,33.2628036],[-96.8994472,33.2628036],[-96.8995339,33.2627995],[-96.8996333,33.2628],[-96.8996333,33.2628],[-96.8996278,33.2631651],[-96.8996278,33.2631651]]]},"properties":{"lotName":"1A-I-7","lotCpId":"5325441615535228753","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997877,33.2631705],[-96.8997738,33.2631697],[-96.8997372,33.2631677],[-96.8996278,33.2631651],[-96.8996278,33.2631651],[-96.8996333,33.2628],[-96.8996333,33.2628],[-96.8996927,33.2628004],[-96.8998183,33.2628068],[-96.8998183,33.2628068],[-96.8997877,33.2631705],[-96.8997877,33.2631705]]]},"properties":{"lotName":"1A-I-6","lotCpId":"7606461615535217830","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999471,33.2631838],[-96.8999331,33.2631823],[-96.8998965,33.2631786],[-96.8997877,33.2631705],[-96.8997877,33.2631705],[-96.8998183,33.2628068],[-96.8998183,33.2628068],[-96.899851,33.2628086],[-96.9000027,33.2628242],[-96.9000027,33.2628242],[-96.8999471,33.2631838],[-96.8999471,33.2631838]]]},"properties":{"lotName":"1A-I-5","lotCpId":"6277771615535393076","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9001059,33.2632048],[-96.9000595,33.2631979],[-96.9000497,33.2631965],[-96.900024,33.2631929],[-96.8999471,33.2631838],[-96.8999471,33.2631838],[-96.9000027,33.2628242],[-96.9000027,33.2628242],[-96.9000087,33.2628251],[-96.9001648,33.2628488],[-96.900179,33.2628515],[-96.9001783,33.2628551],[-96.9001783,33.2628551],[-96.9001059,33.2632048],[-96.9001059,33.2632048]]]},"properties":{"lotName":"1A-I-4","lotCpId":"3332081615535214557","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9002674,33.263228],[-96.9002507,33.2632257],[-96.9002094,33.2632197],[-96.9001059,33.2632048],[-96.9001059,33.2632048],[-96.900179,33.2628515],[-96.900179,33.2628515],[-96.9003237,33.2628789],[-96.9003389,33.2628817],[-96.9003389,33.2628817],[-96.9002674,33.263228],[-96.9002674,33.263228]]]},"properties":{"lotName":"1A-I-3","lotCpId":"4243271615535393734","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004284,33.2632518],[-96.9002674,33.263228],[-96.9002674,33.263228],[-96.9003389,33.2628817],[-96.9003389,33.2628817],[-96.9004988,33.2629118],[-96.9004988,33.2629118],[-96.9004284,33.2632518],[-96.9004284,33.2632518]]]},"properties":{"lotName":"1A-I-2","lotCpId":"3234041615535213693","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005829,33.2632741],[-96.9004284,33.2632518],[-96.9004284,33.2632518],[-96.9004988,33.2629118],[-96.9004988,33.2629118],[-96.900691,33.2629474],[-96.900691,33.2629474],[-96.9006287,33.2632472],[-96.9005829,33.2632741],[-96.9005829,33.2632741]]]},"properties":{"lotName":"1A-I-1","lotCpId":"2503001615535161608","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005703,33.2625855],[-96.9007215,33.2626138],[-96.9007215,33.2626138],[-96.9007526,33.2626521],[-96.900691,33.2629474],[-96.900691,33.2629474],[-96.9004836,33.2629086],[-96.9004836,33.2629086],[-96.9005703,33.2625855],[-96.9005703,33.2625855]]]},"properties":{"lotName":"1A-I-26","lotCpId":"8005241615535558833","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004104,33.2625554],[-96.9005703,33.2625855],[-96.9005703,33.2625855],[-96.9004836,33.2629086],[-96.9004836,33.2629086],[-96.9003237,33.2628789],[-96.9003237,33.2628789],[-96.9004104,33.2625554],[-96.9004104,33.2625554]]]},"properties":{"lotName":"1A-I-25","lotCpId":"6604811615535378493","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9002483,33.2625253],[-96.9002724,33.2625294],[-96.9004104,33.2625554],[-96.9004104,33.2625554],[-96.9003237,33.2628789],[-96.9003237,33.2628789],[-96.9001648,33.2628488],[-96.9001648,33.2628488],[-96.9002483,33.2625253],[-96.9002483,33.2625253]]]},"properties":{"lotName":"1A-I-24","lotCpId":"2718481615535228056","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9000688,33.2624974],[-96.9000833,33.2624993],[-96.9001225,33.2625047],[-96.9002483,33.2625253],[-96.9002483,33.2625253],[-96.9001648,33.2628488],[-96.9001648,33.2628488],[-96.9000087,33.2628251],[-96.9000087,33.2628251],[-96.9000688,33.2624974],[-96.9000688,33.2624974]]]},"properties":{"lotName":"1A-I-23","lotCpId":"6352721615535232109","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998881,33.2624787],[-96.8999052,33.2624801],[-96.8999486,33.2624839],[-96.9000688,33.2624974],[-96.9000688,33.2624974],[-96.9000087,33.2628251],[-96.9000087,33.2628251],[-96.899851,33.2628086],[-96.899851,33.2628086],[-96.8998881,33.2624787],[-96.8998881,33.2624787]]]},"properties":{"lotName":"1A-I-22","lotCpId":"4267851615535396468","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997058,33.2624691],[-96.8997243,33.2624697],[-96.8997703,33.2624716],[-96.8998881,33.2624787],[-96.8998881,33.2624787],[-96.899851,33.2628086],[-96.899851,33.2628086],[-96.8996927,33.2628004],[-96.8996927,33.2628004],[-96.8997058,33.2624691],[-96.8997058,33.2624691]]]},"properties":{"lotName":"1A-I-21","lotCpId":"3148121615535397791","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8995236,33.2624687],[-96.8995417,33.2624683],[-96.8995872,33.2624678],[-96.8997058,33.2624691],[-96.8997058,33.2624691],[-96.8996927,33.2628004],[-96.8996927,33.2628004],[-96.8995339,33.2627995],[-96.8995339,33.2627995],[-96.8995236,33.2624687],[-96.8995236,33.2624687]]]},"properties":{"lotName":"1A-I-20","lotCpId":"5876721615535285216","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8993418,33.2624769],[-96.8993586,33.2624757],[-96.8994016,33.2624731],[-96.8995236,33.2624687],[-96.8995236,33.2624687],[-96.8995339,33.2627995],[-96.8995339,33.2627995],[-96.8993757,33.2628073],[-96.8993757,33.2628073],[-96.8993418,33.2624769],[-96.8993418,33.2624769]]]},"properties":{"lotName":"1A-I-19","lotCpId":"4682301615535315211","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991606,33.2624947],[-96.8991823,33.2624923],[-96.8992335,33.2624869],[-96.8992936,33.2624809],[-96.8993418,33.2624769],[-96.8993418,33.2624769],[-96.8993757,33.2628073],[-96.8993757,33.2628073],[-96.8992179,33.2628223],[-96.8992179,33.2628223],[-96.8991606,33.2624947],[-96.8991606,33.2624947]]]},"properties":{"lotName":"1A-I-18","lotCpId":"6532611615535349433","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989811,33.2625211],[-96.8989991,33.2625181],[-96.8990442,33.2625108],[-96.8991606,33.2624947],[-96.8991606,33.2624947],[-96.8992179,33.2628223],[-96.8992179,33.2628223],[-96.8990618,33.2628456],[-96.8990618,33.2628456],[-96.8989811,33.2625211],[-96.8989811,33.2625211]]]},"properties":{"lotName":"1A-I-17","lotCpId":"2632821615535374514","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987742,33.2625668],[-96.8988006,33.2625587],[-96.8988637,33.2625435],[-96.898889,33.2625386],[-96.8989811,33.2625211],[-96.8989811,33.2625211],[-96.8990618,33.2628456],[-96.8990618,33.2628456],[-96.898915,33.2628766],[-96.898915,33.2628766],[-96.8987742,33.2625668],[-96.8987742,33.2625668]]]},"properties":{"lotName":"1A-I-16","lotCpId":"2083551615535556846","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8985335,33.2626918],[-96.89855,33.262679],[-96.8985976,33.2626473],[-96.8986733,33.2626066],[-96.8987742,33.2625668],[-96.8987742,33.2625668],[-96.898915,33.2628766],[-96.898915,33.2628766],[-96.8988037,33.2629341],[-96.8988037,33.2629341],[-96.8985335,33.2626918],[-96.8985335,33.2626918]]]},"properties":{"lotName":"1A-I-15","lotCpId":"1781001615535319154","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8983676,33.2628839],[-96.8983769,33.2628669],[-96.8984062,33.2628224],[-96.8984577,33.2627607],[-96.8985335,33.2626918],[-96.8985335,33.2626918],[-96.8988037,33.2629341],[-96.8988037,33.2629341],[-96.8987267,33.2630231],[-96.8987267,33.2630231],[-96.8983676,33.2628839],[-96.8983676,33.2628839]]]},"properties":{"lotName":"1A-I-14","lotCpId":"3074551615535395796","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982999,33.2631139],[-96.8983009,33.2630944],[-96.8983082,33.2630427],[-96.8983282,33.2629691],[-96.8983676,33.2628839],[-96.8983676,33.2628839],[-96.8987267,33.2630231],[-96.8987267,33.2630231],[-96.8986956,33.2631295],[-96.8986956,33.2631295],[-96.8982999,33.2631139],[-96.8982999,33.2631139]]]},"properties":{"lotName":"1A-I-13","lotCpId":"4637001615535552136","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991803,33.2623541],[-96.8991628,33.2623562],[-96.8991155,33.2623621],[-96.8990463,33.2623717],[-96.8989631,33.2623847],[-96.8989631,33.2623847],[-96.8989232,33.2623637],[-96.8989085,33.2623117],[-96.8989054,33.2623023],[-96.8988985,33.2622759],[-96.8988914,33.2622354],[-96.8988874,33.2621834],[-96.8988871,33.2621722],[-96.8988863,33.2621428],[-96.8988839,33.2620566],[-96.8988839,33.2620566],[-96.8991279,33.2620255],[-96.8991279,33.2620255],[-96.8991803,33.2623541],[-96.8991803,33.2623541]]]},"properties":{"lotName":"1A-H-16","lotCpId":"1262181615535214962","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8995034,33.2623322],[-96.8994857,33.2623327],[-96.8994427,33.2623342],[-96.8993413,33.2623395],[-96.8993413,33.2623395],[-96.8993091,33.2620096],[-96.8993091,33.2620096],[-96.8994908,33.2620009],[-96.8994908,33.2620009],[-96.8995034,33.2623322],[-96.8995034,33.2623322]]]},"properties":{"lotName":"1A-H-14","lotCpId":"7224461615535392416","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996655,33.2623313],[-96.8996471,33.2623312],[-96.899603,33.2623312],[-96.8995034,33.2623322],[-96.8995034,33.2623322],[-96.8994908,33.2620009],[-96.8994908,33.2620009],[-96.8996731,33.262],[-96.8996731,33.262],[-96.8996655,33.2623313],[-96.8996655,33.2623313]]]},"properties":{"lotName":"1A-H-13","lotCpId":"3754821615535341384","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899827,33.2623372],[-96.8998108,33.2623363],[-96.8997704,33.2623343],[-96.8996655,33.2623313],[-96.8996655,33.2623313],[-96.8996731,33.262],[-96.8996731,33.262],[-96.8998548,33.2620068],[-96.8998548,33.2620068],[-96.899827,33.2623372],[-96.899827,33.2623372]]]},"properties":{"lotName":"1A-H-12","lotCpId":"7267201615535236815","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999886,33.26235],[-96.8999704,33.2623484],[-96.8999267,33.2623446],[-96.899827,33.2623372],[-96.899827,33.2623372],[-96.8998548,33.2620068],[-96.8998548,33.2620068],[-96.900036,33.262021],[-96.900036,33.262021],[-96.8999886,33.26235],[-96.8999886,33.26235]]]},"properties":{"lotName":"1A-H-11","lotCpId":"3021421615535232770","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9001485,33.2623696],[-96.9001296,33.2623671],[-96.9000849,33.2623613],[-96.900032,33.2623547],[-96.8999886,33.26235],[-96.8999886,33.26235],[-96.900036,33.262021],[-96.900036,33.262021],[-96.9002161,33.2620429],[-96.9002161,33.2620429],[-96.9001485,33.2623696],[-96.9001485,33.2623696]]]},"properties":{"lotName":"1A-H-10","lotCpId":"6071651615535287914","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9003078,33.2623961],[-96.9002885,33.2623927],[-96.9002429,33.2623848],[-96.90019,33.262376],[-96.9001485,33.2623696],[-96.9001485,33.2623696],[-96.9002161,33.2620429],[-96.9002161,33.2620429],[-96.9003946,33.2620726],[-96.9003946,33.2620726],[-96.9003078,33.2623961],[-96.9003078,33.2623961]]]},"properties":{"lotName":"1A-H-9","lotCpId":"3661741615535216194","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004677,33.2624258],[-96.9003078,33.2623961],[-96.9003078,33.2623961],[-96.9003946,33.2620726],[-96.9003946,33.2620726],[-96.9005545,33.2621027],[-96.9005545,33.2621027],[-96.9004677,33.2624258],[-96.9004677,33.2624258]]]},"properties":{"lotName":"1A-H-8","lotCpId":"5351451615535234784","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006276,33.2624559],[-96.9004677,33.2624258],[-96.9004677,33.2624258],[-96.9005545,33.2621027],[-96.9005545,33.2621027],[-96.9007144,33.2621323],[-96.9007144,33.2621323],[-96.9006276,33.2624559],[-96.9006276,33.2624559]]]},"properties":{"lotName":"1A-H-7","lotCpId":"1335481615535292574","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9007876,33.2624856],[-96.9006276,33.2624559],[-96.9006276,33.2624559],[-96.9007144,33.2621323],[-96.9007144,33.2621323],[-96.9008738,33.2621625],[-96.9008738,33.2621625],[-96.9007876,33.2624856],[-96.9007876,33.2624856]]]},"properties":{"lotName":"1A-H-6","lotCpId":"6878521615535377836","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9009682,33.2625152],[-96.9009554,33.2625135],[-96.9009202,33.2625085],[-96.9008034,33.2624887],[-96.9007876,33.2624856],[-96.9007876,33.2624856],[-96.9008738,33.2621625],[-96.9008738,33.2621625],[-96.9009213,33.2621711],[-96.9010321,33.2621871],[-96.9010321,33.2621871],[-96.9009682,33.2625152],[-96.9009682,33.2625152]]]},"properties":{"lotName":"1A-H-5","lotCpId":"2422521615535373853","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9011527,33.2625353],[-96.9011373,33.2625342],[-96.9010963,33.2625306],[-96.9009682,33.2625152],[-96.9009682,33.2625152],[-96.9010321,33.2621871],[-96.9010321,33.2621871],[-96.9011106,33.2621981],[-96.9011914,33.262204],[-96.9011914,33.262204],[-96.9011527,33.2625353],[-96.9011527,33.2625353]]]},"properties":{"lotName":"1A-H-4","lotCpId":"8161181615535371217","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013388,33.2625453],[-96.9013251,33.2625452],[-96.9012868,33.2625442],[-96.9012279,33.2625412],[-96.9011527,33.2625353],[-96.9011527,33.2625353],[-96.9011914,33.262204],[-96.9011914,33.262204],[-96.9013017,33.2622127],[-96.9013513,33.2622131],[-96.9013513,33.2622131],[-96.9013388,33.2625453],[-96.9013388,33.2625453]]]},"properties":{"lotName":"1A-H-3","lotCpId":"5120381615535375833","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015249,33.2625453],[-96.901505,33.2625459],[-96.9014564,33.2625468],[-96.9013388,33.2625453],[-96.9013388,33.2625453],[-96.9013513,33.2622131],[-96.9013513,33.2622131],[-96.9014938,33.2622145],[-96.9015118,33.2622136],[-96.9015118,33.2622136],[-96.9015249,33.2625453],[-96.9015249,33.2625453]]]},"properties":{"lotName":"1A-H-2","lotCpId":"1453171615535556396","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017165,33.2625348],[-96.9016996,33.2625363],[-96.9016556,33.2625396],[-96.9015249,33.2625453],[-96.9015249,33.2625453],[-96.9015118,33.2622136],[-96.9015118,33.2622136],[-96.9017137,33.2622008],[-96.9017137,33.2622008],[-96.9017142,33.2622079],[-96.9017158,33.2622278],[-96.9017223,33.2622975],[-96.901734,33.2623929],[-96.9017514,33.262497],[-96.9017165,33.2625348],[-96.9017165,33.2625348]]]},"properties":{"lotName":"1A-H-1","lotCpId":"2577801615535563656","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014834,33.2618836],[-96.9014925,33.2618833],[-96.9015137,33.2618826],[-96.901556,33.2618809],[-96.9016504,33.2618759],[-96.9016504,33.2618759],[-96.9016924,33.2619069],[-96.9017137,33.2622008],[-96.9017137,33.2622008],[-96.9014938,33.2622145],[-96.9014938,33.2622145],[-96.9014834,33.2618836],[-96.9014834,33.2618836]]]},"properties":{"lotName":"1A-H-32","lotCpId":"7502821615535246512","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013224,33.2618818],[-96.9013389,33.2618824],[-96.9013798,33.2618835],[-96.9014834,33.2618836],[-96.9014834,33.2618836],[-96.9014938,33.2622145],[-96.9014938,33.2622145],[-96.9013017,33.2622127],[-96.9013017,33.2622127],[-96.9013224,33.2618818],[-96.9013224,33.2618818]]]},"properties":{"lotName":"1A-H-31","lotCpId":"3328781615535259355","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.901162,33.2618695],[-96.9011792,33.2618712],[-96.9012214,33.261875],[-96.9013224,33.2618818],[-96.9013224,33.2618818],[-96.9013017,33.2622127],[-96.9013017,33.2622127],[-96.9011106,33.2621981],[-96.9011106,33.2621981],[-96.901162,33.2618695],[-96.901162,33.2618695]]]},"properties":{"lotName":"1A-H-30","lotCpId":"3003851615535289254","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010031,33.2618471],[-96.9010197,33.2618498],[-96.9010604,33.2618562],[-96.901162,33.2618695],[-96.901162,33.2618695],[-96.9011106,33.2621981],[-96.9011106,33.2621981],[-96.9009213,33.2621711],[-96.9009213,33.2621711],[-96.9010031,33.2618471],[-96.9010031,33.2618471]]]},"properties":{"lotName":"1A-H-29","lotCpId":"5451241615535291274","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008432,33.261817],[-96.9009764,33.2618421],[-96.9009758,33.2618424],[-96.9010031,33.2618471],[-96.9010031,33.2618471],[-96.9009213,33.2621711],[-96.9009213,33.2621711],[-96.900757,33.2621406],[-96.900757,33.2621406],[-96.9008432,33.261817],[-96.9008432,33.261817]]]},"properties":{"lotName":"1A-H-28","lotCpId":"2475781615535211219","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006839,33.2617873],[-96.9008432,33.261817],[-96.9008432,33.261817],[-96.900757,33.2621406],[-96.900757,33.2621406],[-96.9005971,33.2621104],[-96.9005971,33.2621104],[-96.9006839,33.2617873],[-96.9006839,33.2617873]]]},"properties":{"lotName":"1A-H-27","lotCpId":"2454131615535212032","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005239,33.2617572],[-96.9006839,33.2617873],[-96.9006839,33.2617873],[-96.9005971,33.2621104],[-96.9005971,33.2621104],[-96.9004372,33.2620808],[-96.9004372,33.2620808],[-96.9005239,33.2617572],[-96.9005239,33.2617572]]]},"properties":{"lotName":"1A-H-26","lotCpId":"1042231615535409134","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9003526,33.2617271],[-96.9003647,33.2617291],[-96.9003956,33.2617343],[-96.9004814,33.2617495],[-96.9005239,33.2617572],[-96.9005239,33.2617572],[-96.9004372,33.2620808],[-96.9004372,33.2620808],[-96.9003946,33.2620726],[-96.9002784,33.2620534],[-96.9002784,33.2620534],[-96.9003526,33.2617271],[-96.9003526,33.2617271]]]},"properties":{"lotName":"1A-H-25","lotCpId":"5471321615535319816","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9001757,33.2617024],[-96.9001921,33.2617044],[-96.9002341,33.2617096],[-96.9003526,33.2617271],[-96.9003526,33.2617271],[-96.9002784,33.2620534],[-96.9002784,33.2620534],[-96.9002161,33.2620429],[-96.900119,33.2620315],[-96.900119,33.2620315],[-96.9001757,33.2617024],[-96.9001757,33.2617024]]]},"properties":{"lotName":"1A-H-24","lotCpId":"5285651615535218240","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999984,33.2616842],[-96.9000166,33.2616859],[-96.9000618,33.2616902],[-96.9001757,33.2617024],[-96.9001757,33.2617024],[-96.900119,33.2620315],[-96.900119,33.2620315],[-96.900036,33.262021],[-96.8999591,33.2620151],[-96.8999591,33.2620151],[-96.8999984,33.2616842],[-96.8999984,33.2616842]]]},"properties":{"lotName":"1A-H-23","lotCpId":"7334511615535234093","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998194,33.2616728],[-96.8998358,33.2616735],[-96.8998781,33.2616756],[-96.8999984,33.2616842],[-96.8999984,33.2616842],[-96.8999591,33.2620151],[-96.8999591,33.2620151],[-96.8998548,33.2620068],[-96.8997981,33.2620046],[-96.8997981,33.2620046],[-96.8998194,33.2616728],[-96.8998194,33.2616728]]]},"properties":{"lotName":"1A-H-22","lotCpId":"4836131615535560215","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996404,33.2616682],[-96.8996622,33.2616687],[-96.8997135,33.2616698],[-96.899773,33.2616712],[-96.8998194,33.2616728],[-96.8998194,33.2616728],[-96.8997981,33.2620046],[-96.8997981,33.2620046],[-96.8996731,33.262],[-96.8996371,33.262],[-96.8996371,33.262],[-96.8996404,33.2616682],[-96.8996404,33.2616682]]]},"properties":{"lotName":"1A-H-21","lotCpId":"6148501615535429398","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8994613,33.26167],[-96.8994747,33.2616696],[-96.8995118,33.2616686],[-96.8995684,33.261668],[-96.8996404,33.2616682],[-96.8996404,33.2616682],[-96.8996371,33.262],[-96.8996371,33.262],[-96.8994908,33.2620009],[-96.8994755,33.2620018],[-96.8994755,33.2620018],[-96.8994613,33.26167],[-96.8994613,33.26167]]]},"properties":{"lotName":"1A-H-20","lotCpId":"4476601615535235454","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8992829,33.2616787],[-96.8993043,33.2616775],[-96.8993549,33.2616749],[-96.899414,33.261672],[-96.8994613,33.26167],[-96.8994613,33.26167],[-96.8994755,33.2620018],[-96.8994755,33.2620018],[-96.8993145,33.2620091],[-96.8993145,33.2620091],[-96.8992829,33.2616787],[-96.8992829,33.2616787]]]},"properties":{"lotName":"1A-H-19","lotCpId":"7234011615535218645","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991044,33.2616942],[-96.8991265,33.2616921],[-96.8991783,33.2616873],[-96.8992377,33.2616821],[-96.8992829,33.2616787],[-96.8992829,33.2616787],[-96.8993145,33.2620091],[-96.8993145,33.2620091],[-96.8993091,33.2620096],[-96.8991541,33.2620233],[-96.8991541,33.2620233],[-96.8991044,33.2616942],[-96.8991044,33.2616942]]]},"properties":{"lotName":"1A-H-18","lotCpId":"3413231615535238176","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989063,33.2617193],[-96.8989193,33.2617172],[-96.8989576,33.2617116],[-96.8990197,33.2617035],[-96.8991044,33.2616942],[-96.8991044,33.2616942],[-96.8991541,33.2620233],[-96.8991541,33.2620233],[-96.8991279,33.2620255],[-96.8988839,33.2620566],[-96.8988839,33.2620566],[-96.8988746,33.2617513],[-96.8989063,33.2617193],[-96.8989063,33.2617193]]]},"properties":{"lotName":"1A-H-17","lotCpId":"4820471615535239512","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945702,33.2586284],[-96.8945664,33.2587571],[-96.8945664,33.2587571],[-96.8941816,33.2587489],[-96.8941816,33.2587489],[-96.8941854,33.2586206],[-96.8941854,33.2586206],[-96.8945702,33.2586284],[-96.8945702,33.2586284]]]},"properties":{"lotName":"7-D-69","lotCpId":"4270561615534706370","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.894574,33.2584998],[-96.8945702,33.2586285],[-96.8945702,33.2586285],[-96.8941854,33.2586205],[-96.8941854,33.2586205],[-96.8941892,33.2584918],[-96.8941892,33.2584918],[-96.894574,33.2584998],[-96.894574,33.2584998]]]},"properties":{"lotName":"7-D-68","lotCpId":"5380001615534711047","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945855,33.2581137],[-96.8945816,33.2582424],[-96.8945816,33.2582424],[-96.8941969,33.2582344],[-96.8941969,33.2582344],[-96.8942007,33.2581057],[-96.8942007,33.2581057],[-96.8945855,33.2581137],[-96.8945855,33.2581137]]]},"properties":{"lotName":"7-D-65","lotCpId":"3310781615534713751","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8946002,33.2577617],[-96.894594,33.2577678],[-96.8945805,33.2577848],[-96.8945609,33.2578443],[-96.8945609,33.2578443],[-96.8942089,33.2578375],[-96.8942089,33.2578375],[-96.8942192,33.2574865],[-96.8942192,33.2574865],[-96.8946002,33.2577617],[-96.8946002,33.2577617]]]},"properties":{"lotName":"7-D-62","lotCpId":"5041561615534692875","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.894687,33.2577175],[-96.8946778,33.2577194],[-96.8946552,33.2577264],[-96.8946002,33.2577617],[-96.8946002,33.2577617],[-96.8942192,33.2574865],[-96.8942192,33.2574865],[-96.8942225,33.2573884],[-96.8945969,33.2573962],[-96.8945969,33.2573962],[-96.894687,33.2577175],[-96.894687,33.2577175]]]},"properties":{"lotName":"7-D-61","lotCpId":"8804681615534726573","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8948158,33.2577375],[-96.8948059,33.2577324],[-96.8947786,33.2577222],[-96.8947377,33.2577146],[-96.894687,33.2577175],[-96.894687,33.2577175],[-96.8945969,33.2573962],[-96.8945969,33.2573962],[-96.8948256,33.2574012],[-96.8948256,33.2574012],[-96.8948158,33.2577375],[-96.8948158,33.2577375]]]},"properties":{"lotName":"7-D-60","lotCpId":"5843301615534715100","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8949631,33.2577462],[-96.8948256,33.2577435],[-96.8948256,33.2577435],[-96.8948158,33.2577375],[-96.8948256,33.2574012],[-96.8948256,33.2574012],[-96.8949729,33.2574039],[-96.8949729,33.2574039],[-96.8949631,33.2577462],[-96.8949631,33.2577462]]]},"properties":{"lotName":"7-D-59","lotCpId":"8745181615534692468","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8951105,33.2577494],[-96.8949631,33.2577462],[-96.8949631,33.2577462],[-96.8949729,33.2574039],[-96.8949729,33.2574039],[-96.8951203,33.2574071],[-96.8951203,33.2574071],[-96.8951105,33.2577494],[-96.8951105,33.2577494]]]},"properties":{"lotName":"7-D-58","lotCpId":"6876741615534690829","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952578,33.2577526],[-96.8951105,33.2577494],[-96.8951105,33.2577494],[-96.8951203,33.2574071],[-96.8951203,33.2574071],[-96.8952677,33.2574103],[-96.8952677,33.2574103],[-96.8952578,33.2577526],[-96.8952578,33.2577526]]]},"properties":{"lotName":"7-D-57","lotCpId":"3188271615534705029","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954052,33.2577553],[-96.8952578,33.2577526],[-96.8952578,33.2577526],[-96.8952677,33.2574103],[-96.8952677,33.2574103],[-96.895415,33.2574135],[-96.895415,33.2574135],[-96.8954052,33.2577553],[-96.8954052,33.2577553]]]},"properties":{"lotName":"7-D-56","lotCpId":"3102651615534689213","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8955526,33.2577585],[-96.8954052,33.2577553],[-96.8954052,33.2577553],[-96.895415,33.2574135],[-96.895415,33.2574135],[-96.8955624,33.2574162],[-96.8955624,33.2574162],[-96.8955526,33.2577585],[-96.8955526,33.2577585]]]},"properties":{"lotName":"7-D-55","lotCpId":"6846401615890162258","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961413,33.2577708],[-96.895994,33.2577677],[-96.895994,33.2577677],[-96.8960046,33.2574254],[-96.8960046,33.2574254],[-96.8961519,33.2574286],[-96.8961519,33.2574286],[-96.8961413,33.2577708],[-96.8961413,33.2577708]]]},"properties":{"lotName":"7-D-51","lotCpId":"5635451615534687565","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8962888,33.2577736],[-96.8961414,33.2577708],[-96.8961414,33.2577708],[-96.8961518,33.2574286],[-96.8961518,33.2574286],[-96.8962992,33.2574318],[-96.8962992,33.2574318],[-96.8962888,33.2577736],[-96.8962888,33.2577736]]]},"properties":{"lotName":"7-D-50","lotCpId":"1771101615534690020","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8964362,33.2577768],[-96.8962888,33.2577736],[-96.8962888,33.2577736],[-96.8962992,33.2574318],[-96.8962992,33.2574318],[-96.8964465,33.2574345],[-96.8964465,33.2574345],[-96.8964362,33.2577768],[-96.8964362,33.2577768]]]},"properties":{"lotName":"7-D-49","lotCpId":"3611651615534715769","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8965834,33.25778],[-96.896436,33.2577768],[-96.896436,33.2577768],[-96.8964466,33.2574345],[-96.8964466,33.2574345],[-96.896594,33.2574377],[-96.896594,33.2574377],[-96.8965834,33.25778],[-96.8965834,33.25778]]]},"properties":{"lotName":"7-D-48","lotCpId":"8486071615534709710","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8968782,33.2577859],[-96.8967309,33.2577827],[-96.8967309,33.2577827],[-96.8967412,33.2574409],[-96.8967412,33.2574409],[-96.8968886,33.2574436],[-96.8968886,33.2574436],[-96.8968782,33.2577859],[-96.8968782,33.2577859]]]},"properties":{"lotName":"7-D-46","lotCpId":"5640631615534702991","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971729,33.2577923],[-96.8970256,33.2577891],[-96.8970256,33.2577891],[-96.897036,33.2574468],[-96.897036,33.2574468],[-96.8971828,33.25745],[-96.8971828,33.25745],[-96.8971729,33.2577923],[-96.8971729,33.2577923]]]},"properties":{"lotName":"7-D-44","lotCpId":"7224801615890162309","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8974677,33.2577982],[-96.8973203,33.257795],[-96.8973203,33.257795],[-96.8973301,33.2574528],[-96.8973301,33.2574528],[-96.8974775,33.2574559],[-96.8974775,33.2574559],[-96.8974677,33.2577982],[-96.8974677,33.2577982]]]},"properties":{"lotName":"7-D-42","lotCpId":"4688511615534716448","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8977624,33.2578042],[-96.897615,33.2578014],[-96.897615,33.2578014],[-96.8976248,33.2574591],[-96.8976248,33.2574591],[-96.8977722,33.2574623],[-96.8977722,33.2574623],[-96.8977624,33.2578042],[-96.8977624,33.2578042]]]},"properties":{"lotName":"7-D-40","lotCpId":"1783211615534724591","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980571,33.2578106],[-96.8979097,33.2578074],[-96.8979097,33.2578074],[-96.8979195,33.2574651],[-96.8979195,33.2574651],[-96.8980669,33.2574683],[-96.8980669,33.2574683],[-96.8980571,33.2578106],[-96.8980571,33.2578106]]]},"properties":{"lotName":"7-D-38","lotCpId":"8541321615534717768","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982039,33.2578133],[-96.8980571,33.2578106],[-96.8980571,33.2578106],[-96.8980669,33.2574683],[-96.8980669,33.2574683],[-96.8982143,33.2574715],[-96.8982143,33.2574715],[-96.8982039,33.2578133],[-96.8982039,33.2578133]]]},"properties":{"lotName":"7-D-37","lotCpId":"2750811615890162299","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8983513,33.2578165],[-96.8982039,33.2578133],[-96.8982039,33.2578133],[-96.8982143,33.2574715],[-96.8982143,33.2574715],[-96.8983616,33.2574742],[-96.8983616,33.2574742],[-96.8983513,33.2578165],[-96.8983513,33.2578165]]]},"properties":{"lotName":"7-D-36","lotCpId":"3548331615534721969","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8984985,33.2578197],[-96.8983511,33.2578165],[-96.8983511,33.2578165],[-96.8983617,33.2574742],[-96.8983617,33.2574742],[-96.8985091,33.2574774],[-96.8985091,33.2574774],[-96.8984985,33.2578197],[-96.8984985,33.2578197]]]},"properties":{"lotName":"7-D-35","lotCpId":"3230151615534721292","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898646,33.2578224],[-96.8984986,33.2578197],[-96.8984986,33.2578197],[-96.898509,33.2574774],[-96.898509,33.2574774],[-96.8986563,33.2574806],[-96.8986563,33.2574806],[-96.898646,33.2578224],[-96.898646,33.2578224]]]},"properties":{"lotName":"7-D-34","lotCpId":"5330601615534629467","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989691,33.2578854],[-96.8989656,33.2578787],[-96.8989544,33.257862],[-96.8989025,33.2578192],[-96.8989025,33.2578192],[-96.8991443,33.2574906],[-96.8991443,33.2574906],[-96.8993538,33.2574947],[-96.8993462,33.2577608],[-96.8993462,33.2577608],[-96.8989691,33.2578854],[-96.8989691,33.2578854]]]},"properties":{"lotName":"7-D-31","lotCpId":"6181511615534685109","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989385,33.2582394],[-96.8989423,33.2581162],[-96.8989423,33.2581162],[-96.8993353,33.2581247],[-96.8993353,33.2581247],[-96.8993314,33.2582479],[-96.8993314,33.2582479],[-96.8989385,33.2582394],[-96.8989385,33.2582394]]]},"properties":{"lotName":"7-D-28","lotCpId":"8411111615534720631","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989352,33.2583628],[-96.8989385,33.2582395],[-96.8989385,33.2582395],[-96.8993314,33.2582478],[-96.8993314,33.2582478],[-96.8993282,33.258371],[-96.8993282,33.258371],[-96.8989352,33.2583628],[-96.8989352,33.2583628]]]},"properties":{"lotName":"7-D-27","lotCpId":"1362761615534713072","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989314,33.2584858],[-96.8989352,33.2583626],[-96.8989352,33.2583626],[-96.8993282,33.2583711],[-96.8993282,33.2583711],[-96.8993243,33.2584944],[-96.8993243,33.2584944],[-96.8989314,33.2584858],[-96.8989314,33.2584858]]]},"properties":{"lotName":"7-D-26","lotCpId":"4810321615534688389","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989276,33.2586092],[-96.8989314,33.258486],[-96.8989314,33.258486],[-96.8993244,33.2584942],[-96.8993244,33.2584942],[-96.89932,33.2586443],[-96.89932,33.2586443],[-96.8989598,33.258637],[-96.8989276,33.2586092],[-96.8989276,33.2586092]]]},"properties":{"lotName":"7-D-25","lotCpId":"2267241615534688797","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947312,33.2587274],[-96.8947355,33.25857],[-96.8947355,33.25857],[-96.8951285,33.2585782],[-96.8951285,33.2585782],[-96.8951236,33.2587406],[-96.8951236,33.2587406],[-96.8951135,33.2587415],[-96.895086,33.2587436],[-96.8949932,33.2587498],[-96.8948754,33.258755],[-96.8947628,33.2587552],[-96.8947312,33.2587274],[-96.8947312,33.2587274]]]},"properties":{"lotName":"7-C-12","lotCpId":"8243681615534685926","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8955231,33.2585385],[-96.8955198,33.2586521],[-96.8955198,33.2586521],[-96.8954871,33.2586859],[-96.8954775,33.2586878],[-96.8954511,33.258693],[-96.8953608,33.2587095],[-96.8951236,33.2587406],[-96.8951236,33.2587406],[-96.8951301,33.2585303],[-96.8951301,33.2585303],[-96.8955231,33.2585385],[-96.8955231,33.2585385]]]},"properties":{"lotName":"7-C-1","lotCpId":"3241841615534685514","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947514,33.2580447],[-96.8947552,33.2579064],[-96.8947552,33.2579064],[-96.894789,33.2578795],[-96.8951492,33.2578872],[-96.8951492,33.2578872],[-96.8951443,33.2580529],[-96.8951443,33.2580529],[-96.8947514,33.2580447],[-96.8947514,33.2580447]]]},"properties":{"lotName":"7-C-7","lotCpId":"1865881615534689616","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947475,33.2581761],[-96.8947514,33.2580447],[-96.8947514,33.2580447],[-96.8951443,33.2580529],[-96.8951443,33.2580529],[-96.8951405,33.2581843],[-96.8951405,33.2581843],[-96.8947475,33.2581761],[-96.8947475,33.2581761]]]},"properties":{"lotName":"7-C-8","lotCpId":"7267271615534708368","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8958653,33.2585983],[-96.8958477,33.2586016],[-96.8958063,33.2586097],[-96.8957581,33.25862],[-96.8957201,33.2586297],[-96.8957201,33.2586297],[-96.8956846,33.2586106],[-96.8956961,33.2582272],[-96.8956961,33.2582272],[-96.8958762,33.2582309],[-96.8958762,33.2582309],[-96.8958653,33.2585983],[-96.8958653,33.2585983]]]},"properties":{"lotName":"7-B-14","lotCpId":"3231771615534691233","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8960132,33.2585777],[-96.8959974,33.2585795],[-96.8959586,33.2585843],[-96.8958653,33.2585983],[-96.8958653,33.2585983],[-96.8958762,33.2582309],[-96.8958762,33.2582309],[-96.8960236,33.2582341],[-96.8960236,33.2582341],[-96.8960132,33.2585777],[-96.8960132,33.2585777]]]},"properties":{"lotName":"7-B-13","lotCpId":"5423201615534692047","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961611,33.2585681],[-96.8960803,33.2585718],[-96.8960711,33.2585726],[-96.8960502,33.2585744],[-96.8960132,33.2585777],[-96.8960132,33.2585777],[-96.8960236,33.2582341],[-96.8960236,33.2582341],[-96.8961709,33.2582368],[-96.8961709,33.2582368],[-96.8961611,33.2585681],[-96.8961611,33.2585681]]]},"properties":{"lotName":"7-B-12","lotCpId":"6088001615534702311","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8964558,33.2585718],[-96.8963084,33.2585686],[-96.8963084,33.2585686],[-96.8963177,33.25824],[-96.8963177,33.25824],[-96.8964651,33.2582432],[-96.8964651,33.2582432],[-96.8964558,33.2585718],[-96.8964558,33.2585718]]]},"properties":{"lotName":"7-B-10","lotCpId":"5550001615534727249","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8968971,33.2585809],[-96.8967498,33.2585777],[-96.8967498,33.2585777],[-96.89676,33.2582491],[-96.89676,33.2582491],[-96.8969073,33.2582523],[-96.8969073,33.2582523],[-96.8968971,33.2585809],[-96.8968971,33.2585809]]]},"properties":{"lotName":"7-B-7","lotCpId":"7212121615534718451","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8970447,33.2585837],[-96.8968973,33.2585809],[-96.8968973,33.2585809],[-96.8969072,33.2582523],[-96.8969072,33.2582523],[-96.8970545,33.2582551],[-96.8970545,33.2582551],[-96.8970447,33.2585837],[-96.8970447,33.2585837]]]},"properties":{"lotName":"7-B-6","lotCpId":"8622611615534728567","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973392,33.25859],[-96.8971919,33.2585868],[-96.8971919,33.2585868],[-96.897202,33.2582583],[-96.897202,33.2582583],[-96.8973494,33.2582615],[-96.8973494,33.2582615],[-96.8973392,33.25859],[-96.8973392,33.25859]]]},"properties":{"lotName":"7-B-4","lotCpId":"3475221615534725251","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8974868,33.2585928],[-96.8973394,33.25859],[-96.8973394,33.25859],[-96.8973492,33.2582615],[-96.8973492,33.2582615],[-96.8974966,33.2582646],[-96.8974966,33.2582646],[-96.8974868,33.2585928],[-96.8974868,33.2585928]]]},"properties":{"lotName":"7-B-3","lotCpId":"3775361615534719811","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8976341,33.258596],[-96.8974868,33.2585928],[-96.8974868,33.2585928],[-96.8974966,33.2582646],[-96.8974966,33.2582646],[-96.8976439,33.2582674],[-96.8976439,33.2582674],[-96.8976341,33.258596],[-96.8976341,33.258596]]]},"properties":{"lotName":"7-B-2","lotCpId":"4860301615534722610","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8977815,33.2585992],[-96.8976341,33.258596],[-96.8976341,33.258596],[-96.8976439,33.2582674],[-96.8976439,33.2582674],[-96.897824,33.258271],[-96.897824,33.258271],[-96.8978153,33.2585722],[-96.8977815,33.2585992],[-96.8977815,33.2585992]]]},"properties":{"lotName":"7-B-1","lotCpId":"4488431615534687160","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8976538,33.2579388],[-96.8978011,33.257942],[-96.8978011,33.257942],[-96.8978328,33.2579703],[-96.897824,33.258271],[-96.897824,33.258271],[-96.8976439,33.2582674],[-96.8976439,33.2582674],[-96.8976538,33.2579388],[-96.8976538,33.2579388]]]},"properties":{"lotName":"7-B-28","lotCpId":"2420201615534690426","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973592,33.2579329],[-96.8975066,33.2579361],[-96.8975066,33.2579361],[-96.8974964,33.2582646],[-96.8974964,33.2582646],[-96.897349,33.2582614],[-96.897349,33.2582614],[-96.8973592,33.2579329],[-96.8973592,33.2579329]]]},"properties":{"lotName":"7-B-26","lotCpId":"8173831615534730633","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8972119,33.2579297],[-96.8973592,33.2579329],[-96.8973592,33.2579329],[-96.897349,33.2582614],[-96.897349,33.2582614],[-96.8972017,33.2582583],[-96.8972017,33.2582583],[-96.8972119,33.2579297],[-96.8972119,33.2579297]]]},"properties":{"lotName":"7-B-25","lotCpId":"3634611615534723931","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.896917,33.2579237],[-96.8970643,33.2579269],[-96.8970643,33.2579269],[-96.8970545,33.2582551],[-96.8970545,33.2582551],[-96.8969072,33.2582523],[-96.8969072,33.2582523],[-96.896917,33.2579237],[-96.896917,33.2579237]]]},"properties":{"lotName":"7-B-23","lotCpId":"5357111615890162006","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8966223,33.2579178],[-96.8967696,33.2579205],[-96.8967696,33.2579205],[-96.8967598,33.2582491],[-96.8967598,33.2582491],[-96.8966124,33.2582459],[-96.8966124,33.2582459],[-96.8966223,33.2579178],[-96.8966223,33.2579178]]]},"properties":{"lotName":"7-B-21","lotCpId":"8743101615890162034","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961802,33.2579087],[-96.8963275,33.2579114],[-96.8963275,33.2579114],[-96.8963177,33.25824],[-96.8963177,33.25824],[-96.8961709,33.2582368],[-96.8961709,33.2582368],[-96.8961802,33.2579087],[-96.8961802,33.2579087]]]},"properties":{"lotName":"7-B-18","lotCpId":"8734861615534729251","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8960328,33.2579055],[-96.8961802,33.2579087],[-96.8961802,33.2579087],[-96.8961709,33.2582368],[-96.8961709,33.2582368],[-96.8960236,33.2582341],[-96.8960236,33.2582341],[-96.8960328,33.2579055],[-96.8960328,33.2579055]]]},"properties":{"lotName":"7-B-17","lotCpId":"2031401615534729929","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8957387,33.2578995],[-96.8958855,33.2579023],[-96.8958855,33.2579023],[-96.8958762,33.2582309],[-96.8958762,33.2582309],[-96.8956961,33.2582272],[-96.8956961,33.2582272],[-96.8957048,33.257926],[-96.8957387,33.2578995],[-96.8957387,33.2578995]]]},"properties":{"lotName":"7-B-15","lotCpId":"7274241615534686756","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987622,33.2586603],[-96.8987584,33.2587972],[-96.8987584,33.2587972],[-96.8983654,33.258789],[-96.8983654,33.258789],[-96.8983698,33.2586521],[-96.8983698,33.2586521],[-96.8987622,33.2586603],[-96.8987622,33.2586603]]]},"properties":{"lotName":"7-A-1","lotCpId":"5314701615534694096","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987666,33.2585234],[-96.8987622,33.2586603],[-96.8987622,33.2586603],[-96.8983698,33.2586521],[-96.8983698,33.2586521],[-96.8983736,33.2585152],[-96.8983736,33.2585152],[-96.8987666,33.2585234],[-96.8987666,33.2585234]]]},"properties":{"lotName":"7-A-2","lotCpId":"2575831615534687975","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987704,33.2584002],[-96.8987666,33.2585234],[-96.8987666,33.2585234],[-96.8983736,33.2585152],[-96.8983736,33.2585152],[-96.8983774,33.2583924],[-96.8983774,33.2583924],[-96.8987704,33.2584002],[-96.8987704,33.2584002]]]},"properties":{"lotName":"7-A-3","lotCpId":"8477181615534723249","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987742,33.2582633],[-96.8987704,33.2584002],[-96.8987704,33.2584002],[-96.8983774,33.2583924],[-96.8983774,33.2583924],[-96.8983813,33.2582555],[-96.8983813,33.2582555],[-96.8987742,33.2582633],[-96.8987742,33.2582633]]]},"properties":{"lotName":"7-A-4","lotCpId":"3352501615534693279","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898778,33.2581268],[-96.8987742,33.2582633],[-96.8987742,33.2582633],[-96.8983813,33.2582555],[-96.8983813,33.2582555],[-96.8983856,33.2581186],[-96.8983856,33.2581186],[-96.898778,33.2581268],[-96.898778,33.2581268]]]},"properties":{"lotName":"7-A-5","lotCpId":"6830851615534707032","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987824,33.2579899],[-96.898778,33.2581268],[-96.898778,33.2581268],[-96.8983856,33.2581186],[-96.8983856,33.2581186],[-96.89839,33.2579543],[-96.89839,33.2579543],[-96.8987502,33.2579616],[-96.8987824,33.2579899],[-96.8987824,33.2579899]]]},"properties":{"lotName":"7-A-6","lotCpId":"6861401615534628934","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979927,33.2580967],[-96.8979965,33.2579735],[-96.8979965,33.2579735],[-96.8980303,33.257947],[-96.89839,33.2579543],[-96.89839,33.2579543],[-96.8983856,33.2581049],[-96.8983856,33.2581049],[-96.8979927,33.2580967],[-96.8979927,33.2580967]]]},"properties":{"lotName":"7-A-7","lotCpId":"2354301615534686349","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979894,33.2582199],[-96.8979927,33.2580967],[-96.8979927,33.2580967],[-96.8983856,33.2581049],[-96.8983856,33.2581049],[-96.8983824,33.2582281],[-96.8983824,33.2582281],[-96.8979894,33.2582199],[-96.8979894,33.2582199]]]},"properties":{"lotName":"7-A-8","lotCpId":"7754261615534691641","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979856,33.2583431],[-96.8979894,33.2582199],[-96.8979894,33.2582199],[-96.8983824,33.2582281],[-96.8983824,33.2582281],[-96.8983785,33.2583514],[-96.8983785,33.2583514],[-96.8979856,33.2583431],[-96.8979856,33.2583431]]]},"properties":{"lotName":"7-A-9","lotCpId":"2265151615534705712","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979818,33.2584664],[-96.8979856,33.2583431],[-96.8979856,33.2583431],[-96.8983785,33.2583514],[-96.8983785,33.2583514],[-96.8983747,33.2584746],[-96.8983747,33.2584746],[-96.8979818,33.2584664],[-96.8979818,33.2584664]]]},"properties":{"lotName":"7-A-10","lotCpId":"4007121615534704352","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979785,33.2585896],[-96.8979818,33.2584664],[-96.8979818,33.2584664],[-96.8983747,33.2584746],[-96.8983747,33.2584746],[-96.8983714,33.2585973],[-96.8983714,33.2585973],[-96.8979785,33.2585896],[-96.8979785,33.2585896]]]},"properties":{"lotName":"7-A-11","lotCpId":"4212701615534703667","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979741,33.258711],[-96.8979758,33.2586717],[-96.8979785,33.2585896],[-96.8979785,33.2585896],[-96.8983714,33.2585973],[-96.8983714,33.2585973],[-96.8983671,33.2587292],[-96.8983671,33.2587292],[-96.8979741,33.258711],[-96.8979741,33.258711]]]},"properties":{"lotName":"7-A-12","lotCpId":"5558661615534710374","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979332,33.2589446],[-96.8979367,33.2589311],[-96.8979447,33.2588989],[-96.8979599,33.2588287],[-96.8979599,33.2588287],[-96.8983485,33.2588762],[-96.8983485,33.2588762],[-96.8983147,33.2590218],[-96.8983147,33.2590218],[-96.8979332,33.2589446],[-96.8979332,33.2589446]]]},"properties":{"lotName":"7-A-14","lotCpId":"3345021615890162047","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8978934,33.2590583],[-96.8978982,33.2590458],[-96.8979097,33.2590157],[-96.8979332,33.2589446],[-96.8979332,33.2589446],[-96.8983147,33.2590218],[-96.8983147,33.2590218],[-96.8982656,33.2591637],[-96.8982656,33.2591637],[-96.8978934,33.2590583],[-96.8978934,33.2590583]]]},"properties":{"lotName":"7-A-15","lotCpId":"1774011615534719128","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8978421,33.2591683],[-96.8978468,33.2591597],[-96.897859,33.2591364],[-96.8978934,33.2590583],[-96.8978934,33.2590583],[-96.8982656,33.2591637],[-96.8982656,33.2591637],[-96.8982012,33.2593015],[-96.8982012,33.2593015],[-96.8978421,33.2591683],[-96.8978421,33.2591683]]]},"properties":{"lotName":"7-A-16","lotCpId":"5115801615534727913","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8977787,33.2592737],[-96.8977849,33.2592644],[-96.8978005,33.2592403],[-96.8978421,33.2591683],[-96.8978421,33.2591683],[-96.8982012,33.2593015],[-96.8982012,33.2593015],[-96.898122,33.2594343],[-96.898122,33.2594343],[-96.8977787,33.2592737],[-96.8977787,33.2592737]]]},"properties":{"lotName":"7-A-17","lotCpId":"8821001615534725908","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8976952,33.2593852],[-96.8977041,33.2593743],[-96.8977258,33.2593468],[-96.8977787,33.2592737],[-96.8977787,33.2592737],[-96.898122,33.2594343],[-96.898122,33.2594343],[-96.8980172,33.2595735],[-96.8980172,33.2595735],[-96.8976952,33.2593852],[-96.8976952,33.2593852]]]},"properties":{"lotName":"7-A-18","lotCpId":"8221211615534712432","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048432,33.2579507],[-96.9046958,33.2579475],[-96.9046958,33.2579475],[-96.9047062,33.2576052],[-96.9047062,33.2576052],[-96.9048535,33.2576084],[-96.9048535,33.2576084],[-96.9048432,33.2579507],[-96.9048432,33.2579507]]]},"properties":{"lotName":"2-A-49","lotCpId":"5566431615532054695","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049905,33.2579539],[-96.9048432,33.2579507],[-96.9048432,33.2579507],[-96.9048535,33.2576084],[-96.9048535,33.2576084],[-96.9050009,33.2576116],[-96.9050009,33.2576116],[-96.9049905,33.2579539],[-96.9049905,33.2579539]]]},"properties":{"lotName":"2-A-48","lotCpId":"7774771615532059958","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051379,33.2579566],[-96.9049905,33.2579539],[-96.9049905,33.2579539],[-96.9050009,33.2576116],[-96.9050009,33.2576116],[-96.9051482,33.2576143],[-96.9051482,33.2576143],[-96.9051379,33.2579566],[-96.9051379,33.2579566]]]},"properties":{"lotName":"2-A-47","lotCpId":"5137461615532039653","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052852,33.2579598],[-96.9051379,33.2579566],[-96.9051379,33.2579566],[-96.9051482,33.2576143],[-96.9051482,33.2576143],[-96.9052956,33.2576175],[-96.9052956,33.2576175],[-96.9052852,33.2579598],[-96.9052852,33.2579598]]]},"properties":{"lotName":"2-A-46","lotCpId":"6764421615530041411","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054326,33.257963],[-96.9052852,33.2579598],[-96.9052852,33.2579598],[-96.9052956,33.2576175],[-96.9052956,33.2576175],[-96.905443,33.2576207],[-96.905443,33.2576207],[-96.9054326,33.257963],[-96.9054326,33.257963]]]},"properties":{"lotName":"2-A-45","lotCpId":"3421871615532052053","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9055799,33.2579657],[-96.9054326,33.257963],[-96.9054326,33.257963],[-96.905443,33.2576207],[-96.905443,33.2576207],[-96.9055903,33.2576239],[-96.9055903,33.2576239],[-96.9055799,33.2579657],[-96.9055799,33.2579657]]]},"properties":{"lotName":"2-A-44","lotCpId":"4571451615532055337","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057273,33.2579689],[-96.9055799,33.2579657],[-96.9055799,33.2579657],[-96.9055903,33.2576239],[-96.9055903,33.2576239],[-96.9057366,33.2576266],[-96.9057366,33.2576266],[-96.9057273,33.2579689],[-96.9057273,33.2579689]]]},"properties":{"lotName":"2-A-43","lotCpId":"4474651615532057290","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9059401,33.2579735],[-96.9057928,33.2579703],[-96.9057928,33.2579703],[-96.9058026,33.257628],[-96.9058026,33.257628],[-96.9059494,33.2576312],[-96.9059494,33.2576312],[-96.9059401,33.2579735],[-96.9059401,33.2579735]]]},"properties":{"lotName":"2-A-42","lotCpId":"6377601615532079453","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9060875,33.2579762],[-96.9059401,33.2579735],[-96.9059401,33.2579735],[-96.9059494,33.2576312],[-96.9059494,33.2576312],[-96.9060973,33.2576344],[-96.9060973,33.2576344],[-96.9060875,33.2579762],[-96.9060875,33.2579762]]]},"properties":{"lotName":"2-A-41","lotCpId":"8410621615532053373","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9062349,33.2579794],[-96.9060875,33.2579762],[-96.9060875,33.2579762],[-96.9060973,33.2576344],[-96.9060973,33.2576344],[-96.9061252,33.2576348],[-96.9062447,33.2576371],[-96.9062447,33.2576371],[-96.9062349,33.2579794],[-96.9062349,33.2579794]]]},"properties":{"lotName":"2-A-40","lotCpId":"6225001615532062014","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9063822,33.2579826],[-96.9062349,33.2579794],[-96.9062349,33.2579794],[-96.9062447,33.2576371],[-96.9062447,33.2576371],[-96.906392,33.2576399],[-96.906392,33.2576399],[-96.9063822,33.2579826],[-96.9063822,33.2579826]]]},"properties":{"lotName":"2-A-39","lotCpId":"5862481615532068855","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065296,33.2579853],[-96.9063822,33.2579826],[-96.9063822,33.2579826],[-96.906392,33.2576399],[-96.906392,33.2576399],[-96.9065394,33.2576431],[-96.9065394,33.2576431],[-96.9065296,33.2579853],[-96.9065296,33.2579853]]]},"properties":{"lotName":"2-A-38","lotCpId":"3833331615532058615","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9066764,33.2579885],[-96.9065296,33.2579853],[-96.9065296,33.2579853],[-96.9065394,33.2576431],[-96.9065394,33.2576431],[-96.9066868,33.2576458],[-96.9066868,33.2576458],[-96.9066764,33.2579885],[-96.9066764,33.2579885]]]},"properties":{"lotName":"2-A-37","lotCpId":"4234161615532106044","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9068237,33.2579917],[-96.9066764,33.2579885],[-96.9066764,33.2579885],[-96.9066868,33.2576458],[-96.9066868,33.2576458],[-96.9068341,33.2576485],[-96.9068341,33.2576485],[-96.9068237,33.2579917],[-96.9068237,33.2579917]]]},"properties":{"lotName":"2-A-36","lotCpId":"6661641615532054030","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069711,33.2579945],[-96.9068237,33.2579917],[-96.9068237,33.2579917],[-96.9068341,33.2576485],[-96.9068341,33.2576485],[-96.9069815,33.2576517],[-96.9069815,33.2576517],[-96.9069711,33.2579945],[-96.9069711,33.2579945]]]},"properties":{"lotName":"2-A-35","lotCpId":"5888581615532060678","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9071185,33.2579977],[-96.9069711,33.2579945],[-96.9069711,33.2579945],[-96.9069815,33.2576517],[-96.9069815,33.2576517],[-96.9071288,33.2576545],[-96.9071288,33.2576545],[-96.9071185,33.2579977],[-96.9071185,33.2579977]]]},"properties":{"lotName":"2-A-34","lotCpId":"7832731615532107374","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072658,33.2580009],[-96.9071185,33.2579977],[-96.9071185,33.2579977],[-96.9071288,33.2576545],[-96.9071288,33.2576545],[-96.9072773,33.2576572],[-96.9072773,33.2576572],[-96.9072658,33.2580009],[-96.9072658,33.2580009]]]},"properties":{"lotName":"2-A-33","lotCpId":"2733251615529952703","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074132,33.2580041],[-96.9072658,33.2580009],[-96.9072658,33.2580009],[-96.9072773,33.2576572],[-96.9072773,33.2576572],[-96.9074235,33.2576604],[-96.9074235,33.2576604],[-96.9074132,33.2580041],[-96.9074132,33.2580041]]]},"properties":{"lotName":"2-A-32","lotCpId":"6300611615532051417","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9075605,33.2580068],[-96.9074132,33.2580041],[-96.9074132,33.2580041],[-96.9074235,33.2576604],[-96.9074235,33.2576604],[-96.9075709,33.2576631],[-96.9075709,33.2576631],[-96.9075605,33.2580068],[-96.9075605,33.2580068]]]},"properties":{"lotName":"2-A-31","lotCpId":"1638801615532065313","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9077079,33.25801],[-96.9075605,33.2580068],[-96.9075605,33.2580068],[-96.9075709,33.2576631],[-96.9075709,33.2576631],[-96.9077183,33.2576659],[-96.9077183,33.2576659],[-96.9077079,33.25801],[-96.9077079,33.25801]]]},"properties":{"lotName":"2-A-30","lotCpId":"4223611615532080818","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9078552,33.2580132],[-96.9077079,33.25801],[-96.9077079,33.25801],[-96.9077183,33.2576659],[-96.9077183,33.2576659],[-96.9078656,33.2576691],[-96.9078656,33.2576691],[-96.9078552,33.2580132],[-96.9078552,33.2580132]]]},"properties":{"lotName":"2-A-29","lotCpId":"4806601615529953249","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9080026,33.2580159],[-96.9078552,33.2580132],[-96.9078552,33.2580132],[-96.9078656,33.2576691],[-96.9078656,33.2576691],[-96.908013,33.2576718],[-96.908013,33.2576718],[-96.9080026,33.2580159],[-96.9080026,33.2580159]]]},"properties":{"lotName":"2-A-28","lotCpId":"8146601615532052733","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.90815,33.2580191],[-96.9080026,33.2580159],[-96.9080026,33.2580159],[-96.908013,33.2576718],[-96.908013,33.2576718],[-96.9081603,33.2576746],[-96.9081603,33.2576746],[-96.90815,33.2580191],[-96.90815,33.2580191]]]},"properties":{"lotName":"2-A-27","lotCpId":"5088381615532078795","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9082973,33.2580223],[-96.90815,33.2580191],[-96.90815,33.2580191],[-96.9081603,33.2576746],[-96.9081603,33.2576746],[-96.9083077,33.2576773],[-96.9083077,33.2576773],[-96.9082973,33.2580223],[-96.9082973,33.2580223]]]},"properties":{"lotName":"2-A-26","lotCpId":"5505231615532067516","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9084485,33.2580013],[-96.9084363,33.2579998],[-96.9084046,33.2579991],[-96.9083604,33.2580048],[-96.908311,33.2580223],[-96.9082973,33.2580223],[-96.9082973,33.2580223],[-96.9083077,33.2576773],[-96.9083077,33.2576773],[-96.90852,33.2576819],[-96.90852,33.2576819],[-96.9084485,33.2580013],[-96.9084485,33.2580013]]]},"properties":{"lotName":"2-A-25","lotCpId":"2114741615532038328","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9085527,33.2580483],[-96.9085454,33.2580424],[-96.9085246,33.2580287],[-96.9084485,33.2580013],[-96.9084485,33.2580013],[-96.90852,33.2576819],[-96.90852,33.2576819],[-96.9089975,33.257691],[-96.9089975,33.257691],[-96.9085527,33.2580483],[-96.9085527,33.2580483]]]},"properties":{"lotName":"2-A-24","lotCpId":"4532361615532215730","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.908604,33.2581337],[-96.9086022,33.2581255],[-96.9085948,33.2581048],[-96.9085527,33.2580483],[-96.9085527,33.2580483],[-96.9089975,33.257691],[-96.9089975,33.257691],[-96.9089866,33.2580789],[-96.9089866,33.2580789],[-96.908604,33.2581337],[-96.908604,33.2581337]]]},"properties":{"lotName":"2-A-23","lotCpId":"3071511615532037476","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9085898,33.2582286],[-96.9085939,33.2582204],[-96.9086018,33.2581988],[-96.908604,33.2581337],[-96.908604,33.2581337],[-96.9089866,33.2580789],[-96.9089866,33.2580789],[-96.9089784,33.2583755],[-96.9089784,33.2583755],[-96.9085898,33.2582286],[-96.9085898,33.2582286]]]},"properties":{"lotName":"2-A-22","lotCpId":"8153511615532234313","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9084894,33.2583112],[-96.9085012,33.2583066],[-96.9085293,33.2582921],[-96.9085625,33.2582665],[-96.9085898,33.2582286],[-96.9085898,33.2582286],[-96.9089784,33.2583755],[-96.9089784,33.2583755],[-96.9087159,33.2586224],[-96.9086499,33.2586211],[-96.9086499,33.2586211],[-96.9084894,33.2583112],[-96.9084894,33.2583112]]]},"properties":{"lotName":"2-A-21","lotCpId":"5777621615527779902","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9083634,33.258319],[-96.9083741,33.2583212],[-96.9084025,33.2583243],[-96.9084428,33.2583228],[-96.9084894,33.2583112],[-96.9084894,33.2583112],[-96.9086499,33.2586211],[-96.9086499,33.2586211],[-96.9083546,33.2586147],[-96.9083546,33.2586147],[-96.9083634,33.258319],[-96.9083634,33.258319]]]},"properties":{"lotName":"2-A-20","lotCpId":"1841701615532041698","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9082034,33.2581839],[-96.9082225,33.2581985],[-96.9082274,33.2582138],[-96.9082473,33.2582493],[-96.90829,33.2582895],[-96.9083634,33.258319],[-96.9083634,33.258319],[-96.9083546,33.2586147],[-96.9083546,33.2586147],[-96.9081909,33.2586115],[-96.9081909,33.2586115],[-96.9082034,33.2581839],[-96.9082034,33.2581839]]]},"properties":{"lotName":"2-A-19","lotCpId":"4816271615529083033","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9080408,33.2581537],[-96.9081685,33.2581565],[-96.9081685,33.2581565],[-96.9082034,33.2581839],[-96.9081909,33.2586115],[-96.9081909,33.2586115],[-96.9080272,33.2586078],[-96.9080272,33.2586078],[-96.9080408,33.2581537],[-96.9080408,33.2581537]]]},"properties":{"lotName":"2-A-18","lotCpId":"4458461615532037891","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076593,33.2583103],[-96.9076631,33.2581734],[-96.9076631,33.2581734],[-96.907697,33.2581464],[-96.9080408,33.2581537],[-96.9080408,33.2581537],[-96.9080359,33.258318],[-96.9080359,33.258318],[-96.9076593,33.2583103],[-96.9076593,33.2583103]]]},"properties":{"lotName":"2-A-17","lotCpId":"5661451615532040889","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076555,33.2584335],[-96.9076593,33.2583103],[-96.9076593,33.2583103],[-96.9080359,33.258318],[-96.9080359,33.258318],[-96.9080321,33.2584413],[-96.9080321,33.2584413],[-96.9076555,33.2584335],[-96.9076555,33.2584335]]]},"properties":{"lotName":"2-A-16","lotCpId":"7827121615532235635","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076522,33.2585567],[-96.9076555,33.2584335],[-96.9076555,33.2584335],[-96.9080321,33.2584413],[-96.9080321,33.2584413],[-96.9080283,33.2585645],[-96.9080283,33.2585645],[-96.9076522,33.2585567],[-96.9076522,33.2585567]]]},"properties":{"lotName":"2-A-15","lotCpId":"3778331615532216375","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076484,33.2586799],[-96.9076522,33.2585567],[-96.9076522,33.2585567],[-96.9080283,33.2585645],[-96.9080283,33.2585645],[-96.9080272,33.2586078],[-96.908025,33.2586877],[-96.908025,33.2586877],[-96.9076484,33.2586799],[-96.9076484,33.2586799]]]},"properties":{"lotName":"2-A-14","lotCpId":"2784041615531898747","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9075998,33.2589054],[-96.9076039,33.2588953],[-96.9076135,33.2588692],[-96.9076342,33.258794],[-96.9076342,33.258794],[-96.9080201,33.2588525],[-96.9080201,33.2588525],[-96.9079715,33.2590122],[-96.9079715,33.2590122],[-96.9075998,33.2589054],[-96.9075998,33.2589054]]]},"properties":{"lotName":"2-A-12","lotCpId":"8607661615532104716","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9075452,33.2590113],[-96.9075512,33.2590019],[-96.9075656,33.2589775],[-96.9075998,33.2589054],[-96.9075998,33.2589054],[-96.9079715,33.2590122],[-96.9079715,33.2590122],[-96.9078934,33.2591637],[-96.9078934,33.2591637],[-96.9075452,33.2590113],[-96.9075452,33.2590113]]]},"properties":{"lotName":"2-A-11","lotCpId":"2186811615532104074","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074721,33.2591085],[-96.9074809,33.2590981],[-96.9075017,33.2590726],[-96.9075452,33.2590113],[-96.9075452,33.2590113],[-96.9078934,33.2591637],[-96.9078934,33.2591637],[-96.9077887,33.2593038],[-96.9077887,33.2593038],[-96.9074721,33.2591085],[-96.9074721,33.2591085]]]},"properties":{"lotName":"2-A-10","lotCpId":"7270781615532059289","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073826,33.2591956],[-96.9073915,33.2591883],[-96.9074138,33.2591687],[-96.9074721,33.2591085],[-96.9074721,33.2591085],[-96.9077887,33.2593038],[-96.9077887,33.2593038],[-96.9076593,33.2594289],[-96.9076593,33.2594289],[-96.9073826,33.2591956],[-96.9073826,33.2591956]]]},"properties":{"lotName":"2-A-9","lotCpId":"4474041615532103424","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072778,33.25927],[-96.9072917,33.2592612],[-96.9073235,33.2592402],[-96.9073587,33.2592156],[-96.9073826,33.2591956],[-96.9073826,33.2591956],[-96.9076593,33.2594289],[-96.9076593,33.2594289],[-96.9075087,33.2595356],[-96.9075087,33.2595356],[-96.9072778,33.25927],[-96.9072778,33.25927]]]},"properties":{"lotName":"2-A-8","lotCpId":"4286841615532218336","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9071605,33.2593303],[-96.9071719,33.2593254],[-96.9072006,33.2593123],[-96.9072778,33.25927],[-96.9072778,33.25927],[-96.9075087,33.2595356],[-96.9075087,33.2595356],[-96.9073406,33.2596224],[-96.9073406,33.2596224],[-96.9071605,33.2593303],[-96.9071605,33.2593303]]]},"properties":{"lotName":"2-A-7","lotCpId":"3063041615532110014","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070339,33.259375],[-96.9070445,33.2593723],[-96.9070727,33.259364],[-96.9071605,33.2593303],[-96.9071605,33.2593303],[-96.9073406,33.2596224],[-96.9073406,33.2596224],[-96.9071556,33.2596789],[-96.9071556,33.2596789],[-96.9070339,33.259375],[-96.9070339,33.259375]]]},"properties":{"lotName":"2-A-6","lotCpId":"4273451615532233650","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069007,33.2594033],[-96.9069121,33.2594017],[-96.9069421,33.2593968],[-96.9070339,33.259375],[-96.9070339,33.259375],[-96.9071556,33.2596789],[-96.9071556,33.2596789],[-96.9069651,33.2597191],[-96.9069651,33.2597191],[-96.9069007,33.2594033],[-96.9069007,33.2594033]]]},"properties":{"lotName":"2-A-5","lotCpId":"4758241615532065971","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067315,33.2594138],[-96.9067433,33.2594143],[-96.906777,33.2594142],[-96.9068303,33.2594112],[-96.9069007,33.2594033],[-96.9069007,33.2594033],[-96.9069651,33.2597191],[-96.9069651,33.2597191],[-96.9067239,33.2597383],[-96.9067239,33.2597383],[-96.9067315,33.2594138],[-96.9067315,33.2594138]]]},"properties":{"lotName":"2-A-4","lotCpId":"6720031615532234993","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065912,33.2594038],[-96.9066427,33.2594091],[-96.9066674,33.2594115],[-96.9067315,33.2594138],[-96.9067315,33.2594138],[-96.9067239,33.2597383],[-96.9067239,33.2597383],[-96.906547,33.2597209],[-96.906547,33.2597209],[-96.9065912,33.2594038],[-96.9065912,33.2594038]]]},"properties":{"lotName":"2-A-3","lotCpId":"4555681615532075513","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906445,33.2593896],[-96.9065912,33.2594038],[-96.9065912,33.2594038],[-96.906547,33.2597209],[-96.906547,33.2597209],[-96.9064002,33.2597063],[-96.9064002,33.2597063],[-96.906445,33.2593896],[-96.906445,33.2593896]]]},"properties":{"lotName":"2-A-2","lotCpId":"6813571615532108035","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9062982,33.259375],[-96.906445,33.2593896],[-96.906445,33.2593896],[-96.9064002,33.2597063],[-96.9064002,33.2597063],[-96.906254,33.2596922],[-96.906254,33.2596922],[-96.9062982,33.259375],[-96.9062982,33.259375]]]},"properties":{"lotName":"2-A-1","lotCpId":"4042641615532113995","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074847,33.2586763],[-96.9074845,33.2586849],[-96.9074826,33.2587094],[-96.9074771,33.2587481],[-96.9074661,33.2587991],[-96.9074661,33.2587991],[-96.9071043,33.2587918],[-96.9071043,33.2587918],[-96.9071081,33.2586685],[-96.9071081,33.2586685],[-96.9074847,33.2586763],[-96.9074847,33.2586763]]]},"properties":{"lotName":"2-C-1","lotCpId":"2036261615530041951","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074885,33.2585531],[-96.9074847,33.2586763],[-96.9074847,33.2586763],[-96.9071081,33.2586685],[-96.9071081,33.2586685],[-96.9071119,33.2585453],[-96.9071119,33.2585453],[-96.9074885,33.2585531],[-96.9074885,33.2585531]]]},"properties":{"lotName":"2-C-2","lotCpId":"6473171615532112684","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074918,33.2584299],[-96.9074885,33.2585531],[-96.9074885,33.2585531],[-96.9071119,33.2585453],[-96.9071119,33.2585453],[-96.9071152,33.2584221],[-96.9071152,33.2584221],[-96.9074918,33.2584299],[-96.9074918,33.2584299]]]},"properties":{"lotName":"2-C-3","lotCpId":"5025431615532106716","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074956,33.2583066],[-96.9074918,33.2584299],[-96.9074918,33.2584299],[-96.9071152,33.2584221],[-96.9071152,33.2584221],[-96.907119,33.2582989],[-96.907119,33.2582989],[-96.9074956,33.2583066],[-96.9074956,33.2583066]]]},"properties":{"lotName":"2-C-4","lotCpId":"4243341615532076812","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074994,33.2581702],[-96.9074956,33.2583066],[-96.9074956,33.2583066],[-96.907119,33.2582989],[-96.907119,33.2582989],[-96.9071239,33.2581346],[-96.9071239,33.2581346],[-96.9074677,33.2581419],[-96.9074994,33.2581702],[-96.9074994,33.2581702]]]},"properties":{"lotName":"2-C-5","lotCpId":"5045041615532038782","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067424,33.2582911],[-96.9067468,33.2581542],[-96.9067468,33.2581542],[-96.9067801,33.2581277],[-96.9071239,33.2581346],[-96.9071239,33.2581346],[-96.907119,33.2582989],[-96.907119,33.2582989],[-96.9067424,33.2582911],[-96.9067424,33.2582911]]]},"properties":{"lotName":"2-C-6","lotCpId":"5263711615532109356","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067391,33.2584143],[-96.9067424,33.2582911],[-96.9067424,33.2582911],[-96.907119,33.2582989],[-96.907119,33.2582989],[-96.9071152,33.2584221],[-96.9071152,33.2584221],[-96.9067391,33.2584143],[-96.9067391,33.2584143]]]},"properties":{"lotName":"2-C-7","lotCpId":"1410331615532212477","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067353,33.2585376],[-96.9067391,33.2584143],[-96.9067391,33.2584143],[-96.9071152,33.2584221],[-96.9071152,33.2584221],[-96.9071119,33.2585453],[-96.9071119,33.2585453],[-96.9067353,33.2585376],[-96.9067353,33.2585376]]]},"properties":{"lotName":"2-C-8","lotCpId":"4482471615532232373","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067315,33.2586608],[-96.9067353,33.2585376],[-96.9067353,33.2585376],[-96.9071119,33.2585453],[-96.9071119,33.2585453],[-96.9071081,33.2586685],[-96.9071081,33.2586685],[-96.9067315,33.2586608],[-96.9067315,33.2586608]]]},"properties":{"lotName":"2-C-9","lotCpId":"7635611615532105374","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067282,33.258784],[-96.9067315,33.2586608],[-96.9067315,33.2586608],[-96.9071081,33.2586685],[-96.9071081,33.2586685],[-96.9071043,33.2587918],[-96.9071043,33.2587918],[-96.9067282,33.258784],[-96.9067282,33.258784]]]},"properties":{"lotName":"2-C-10","lotCpId":"3220241615532068153","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067244,33.2589072],[-96.9067282,33.258784],[-96.9067282,33.258784],[-96.9071043,33.2587918],[-96.9071043,33.2587918],[-96.907101,33.258915],[-96.907101,33.258915],[-96.9067244,33.2589072],[-96.9067244,33.2589072]]]},"properties":{"lotName":"2-C-11","lotCpId":"7584711615532213119","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067206,33.2590304],[-96.9067244,33.2589072],[-96.9067244,33.2589072],[-96.907101,33.258915],[-96.907101,33.258915],[-96.9070972,33.2590382],[-96.9070972,33.2590382],[-96.9067206,33.2590304],[-96.9067206,33.2590304]]]},"properties":{"lotName":"2-C-12","lotCpId":"4647371615532081473","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906714,33.259249],[-96.9067206,33.2590304],[-96.9067206,33.2590304],[-96.9070972,33.2590382],[-96.9070972,33.2590382],[-96.9071992,33.2591482],[-96.9071992,33.2591482],[-96.9071911,33.2591538],[-96.9071672,33.2591687],[-96.9070761,33.2592136],[-96.9069333,33.2592581],[-96.9068448,33.2592724],[-96.9067462,33.2592773],[-96.906714,33.259249],[-96.906714,33.259249]]]},"properties":{"lotName":"2-C-13","lotCpId":"2528271615532113350","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065574,33.2590131],[-96.9065536,33.2591363],[-96.9065536,33.2591363],[-96.906177,33.2591286],[-96.906177,33.2591286],[-96.9061808,33.2590053],[-96.9061808,33.2590053],[-96.9065574,33.2590131],[-96.9065574,33.2590131]]]},"properties":{"lotName":"2-D-1","lotCpId":"6016071615527779370","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065612,33.2588899],[-96.9065574,33.2590131],[-96.9065574,33.2590131],[-96.9061808,33.2590053],[-96.9061808,33.2590053],[-96.9061846,33.2588821],[-96.9061846,33.2588821],[-96.9065612,33.2588899],[-96.9065612,33.2588899]]]},"properties":{"lotName":"2-D-2","lotCpId":"4651281615532070833","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065645,33.2587667],[-96.9065612,33.2588899],[-96.9065612,33.2588899],[-96.9061846,33.2588821],[-96.9061846,33.2588821],[-96.9061885,33.2587589],[-96.9061885,33.2587589],[-96.9065645,33.2587667],[-96.9065645,33.2587667]]]},"properties":{"lotName":"2-D-3","lotCpId":"5100631615532055972","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065683,33.2586439],[-96.9065645,33.2587667],[-96.9065645,33.2587667],[-96.9061885,33.2587589],[-96.9061885,33.2587589],[-96.9061917,33.2586357],[-96.9061917,33.2586357],[-96.9065683,33.2586439],[-96.9065683,33.2586439]]]},"properties":{"lotName":"2-D-4","lotCpId":"6348141615532217030","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065721,33.2585207],[-96.9065683,33.2586439],[-96.9065683,33.2586439],[-96.9061917,33.2586357],[-96.9061917,33.2586357],[-96.9061956,33.2585129],[-96.9061956,33.2585129],[-96.9065721,33.2585207],[-96.9065721,33.2585207]]]},"properties":{"lotName":"2-D-5","lotCpId":"4456111615532064655","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065754,33.2583975],[-96.9065721,33.2585207],[-96.9065721,33.2585207],[-96.9061956,33.2585129],[-96.9061956,33.2585129],[-96.9061994,33.2583897],[-96.9061994,33.2583897],[-96.9065754,33.2583975],[-96.9065754,33.2583975]]]},"properties":{"lotName":"2-D-6","lotCpId":"4318281615532072162","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065792,33.2582742],[-96.9065754,33.2583975],[-96.9065754,33.2583975],[-96.9061994,33.2583897],[-96.9061994,33.2583897],[-96.9062027,33.2582665],[-96.9062027,33.2582665],[-96.9065792,33.2582742],[-96.9065792,33.2582742]]]},"properties":{"lotName":"2-D-7","lotCpId":"6357051615531899288","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065831,33.258151],[-96.9065792,33.2582742],[-96.9065792,33.2582742],[-96.9062027,33.2582665],[-96.9062027,33.2582665],[-96.906207,33.2581159],[-96.906207,33.2581159],[-96.9065509,33.2581227],[-96.9065831,33.258151],[-96.9065831,33.258151]]]},"properties":{"lotName":"2-D-8","lotCpId":"3216031615532041292","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058261,33.2582587],[-96.9058299,33.2581355],[-96.9058299,33.2581355],[-96.9058637,33.2581086],[-96.906207,33.2581159],[-96.906207,33.2581159],[-96.9062027,33.2582665],[-96.9062027,33.2582665],[-96.9058261,33.2582587],[-96.9058261,33.2582587]]]},"properties":{"lotName":"2-D-9","lotCpId":"6734161615532056637","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058228,33.2583819],[-96.9058261,33.2582587],[-96.9058261,33.2582587],[-96.9062027,33.2582665],[-96.9062027,33.2582665],[-96.9061994,33.2583897],[-96.9061994,33.2583897],[-96.9058228,33.2583819],[-96.9058228,33.2583819]]]},"properties":{"lotName":"2-D-10","lotCpId":"3374001615532063975","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905819,33.2585047],[-96.9058228,33.2583819],[-96.9058228,33.2583819],[-96.9061994,33.2583897],[-96.9061994,33.2583897],[-96.9061956,33.2585129],[-96.9061956,33.2585129],[-96.905819,33.2585047],[-96.905819,33.2585047]]]},"properties":{"lotName":"2-D-11","lotCpId":"7487011615532070174","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058152,33.2586279],[-96.905819,33.2585047],[-96.905819,33.2585047],[-96.9061956,33.2585129],[-96.9061956,33.2585129],[-96.9061917,33.2586357],[-96.9061917,33.2586357],[-96.9058152,33.2586279],[-96.9058152,33.2586279]]]},"properties":{"lotName":"2-D-12","lotCpId":"1652231615532108694","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058119,33.2587511],[-96.9058152,33.2586279],[-96.9058152,33.2586279],[-96.9061917,33.2586357],[-96.9061917,33.2586357],[-96.9061885,33.2587589],[-96.9061885,33.2587589],[-96.9058119,33.2587511],[-96.9058119,33.2587511]]]},"properties":{"lotName":"2-D-13","lotCpId":"8056631615532218990","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058081,33.2588744],[-96.9058119,33.2587511],[-96.9058119,33.2587511],[-96.9061885,33.2587589],[-96.9061885,33.2587589],[-96.9061846,33.2588821],[-96.9061846,33.2588821],[-96.9058081,33.2588744],[-96.9058081,33.2588744]]]},"properties":{"lotName":"2-D-14","lotCpId":"8724431615532236295","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058042,33.2589976],[-96.9058081,33.2588744],[-96.9058081,33.2588744],[-96.9061846,33.2588821],[-96.9061846,33.2588821],[-96.9061808,33.2590053],[-96.9061808,33.2590053],[-96.9058042,33.2589976],[-96.9058042,33.2589976]]]},"properties":{"lotName":"2-D-15","lotCpId":"8834421615532213788","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905801,33.2591208],[-96.9058042,33.2589976],[-96.9058042,33.2589976],[-96.9061808,33.2590053],[-96.9061808,33.2590053],[-96.906177,33.2591286],[-96.906177,33.2591286],[-96.905801,33.2591208],[-96.905801,33.2591208]]]},"properties":{"lotName":"2-D-16","lotCpId":"4871761615532050096","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056405,33.2589944],[-96.9056362,33.259145],[-96.9056362,33.259145],[-96.9056029,33.2591692],[-96.9055805,33.2591669],[-96.9055724,33.2591661],[-96.90555,33.259164],[-96.9054724,33.2591571],[-96.9052596,33.2591423],[-96.9052596,33.2591423],[-96.9052645,33.2589866],[-96.9052645,33.2589866],[-96.9056405,33.2589944],[-96.9056405,33.2589944]]]},"properties":{"lotName":"2-E-1","lotCpId":"6602311615532214453","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056443,33.2588712],[-96.9056405,33.2589944],[-96.9056405,33.2589944],[-96.9052645,33.2589866],[-96.9052645,33.2589866],[-96.9052678,33.2588634],[-96.9052678,33.2588634],[-96.9056443,33.2588712],[-96.9056443,33.2588712]]]},"properties":{"lotName":"2-E-2","lotCpId":"4530811615532074852","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056482,33.2587479],[-96.9056443,33.2588712],[-96.9056443,33.2588712],[-96.9052678,33.2588634],[-96.9052678,33.2588634],[-96.9052716,33.2587402],[-96.9052716,33.2587402],[-96.9056482,33.2587479],[-96.9056482,33.2587479]]]},"properties":{"lotName":"2-E-3","lotCpId":"7316111615532111992","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056514,33.2586247],[-96.9056482,33.2587479],[-96.9056482,33.2587479],[-96.9052716,33.2587402],[-96.9052716,33.2587402],[-96.9052754,33.258617],[-96.9052754,33.258617],[-96.9056514,33.2586247],[-96.9056514,33.2586247]]]},"properties":{"lotName":"2-E-4","lotCpId":"4041061615532074197","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056553,33.2585015],[-96.9056514,33.2586247],[-96.9056514,33.2586247],[-96.9052754,33.258617],[-96.9052754,33.258617],[-96.9052787,33.2584937],[-96.9052787,33.2584937],[-96.9056553,33.2585015],[-96.9056553,33.2585015]]]},"properties":{"lotName":"2-E-5","lotCpId":"3467341615532076175","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056591,33.2583783],[-96.9056553,33.2585015],[-96.9056553,33.2585015],[-96.9052787,33.2584937],[-96.9052787,33.2584937],[-96.9052825,33.2583705],[-96.9052825,33.2583705],[-96.9056591,33.2583783],[-96.9056591,33.2583783]]]},"properties":{"lotName":"2-E-6","lotCpId":"3524851615532080123","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056629,33.2582551],[-96.9056591,33.2583783],[-96.9056591,33.2583783],[-96.9052825,33.2583705],[-96.9052825,33.2583705],[-96.9052863,33.2582473],[-96.9052863,33.2582473],[-96.9056629,33.2582551],[-96.9056629,33.2582551]]]},"properties":{"lotName":"2-E-7","lotCpId":"7260601615532040482","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056662,33.2581318],[-96.9056629,33.2582551],[-96.9056629,33.2582551],[-96.9052863,33.2582473],[-96.9052863,33.2582473],[-96.9052907,33.2580967],[-96.9052907,33.2580967],[-96.9056345,33.258104],[-96.9056662,33.2581318],[-96.9056662,33.2581318]]]},"properties":{"lotName":"2-E-8","lotCpId":"8402041615532039208","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049097,33.2582395],[-96.9049127,33.2581177],[-96.9049127,33.2581177],[-96.9049468,33.2580899],[-96.9052907,33.2580967],[-96.9052907,33.2580967],[-96.9052863,33.2582473],[-96.9052863,33.2582473],[-96.9049097,33.2582395],[-96.9049097,33.2582395]]]},"properties":{"lotName":"2-E-9","lotCpId":"5463201615532040074","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049059,33.2583628],[-96.9049097,33.2582395],[-96.9049097,33.2582395],[-96.9052863,33.2582473],[-96.9052863,33.2582473],[-96.9052825,33.2583705],[-96.9052825,33.2583705],[-96.9049059,33.2583628],[-96.9049059,33.2583628]]]},"properties":{"lotName":"2-E-10","lotCpId":"6578501615532072836","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049021,33.258486],[-96.9049059,33.2583628],[-96.9049059,33.2583628],[-96.9052825,33.2583705],[-96.9052825,33.2583705],[-96.9052787,33.2584937],[-96.9052787,33.2584937],[-96.9049021,33.258486],[-96.9049021,33.258486]]]},"properties":{"lotName":"2-E-11","lotCpId":"6288001615532102752","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048988,33.2586092],[-96.9049021,33.258486],[-96.9049021,33.258486],[-96.9052787,33.2584937],[-96.9052787,33.2584937],[-96.9052754,33.258617],[-96.9052754,33.258617],[-96.9048988,33.2586092],[-96.9048988,33.2586092]]]},"properties":{"lotName":"2-E-12","lotCpId":"6671001615532211076","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.904895,33.2587324],[-96.9048988,33.2586092],[-96.9048988,33.2586092],[-96.9052754,33.258617],[-96.9052754,33.258617],[-96.9052716,33.2587402],[-96.9052716,33.2587402],[-96.904895,33.2587324],[-96.904895,33.2587324]]]},"properties":{"lotName":"2-E-13","lotCpId":"8246621615532210434","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048912,33.2588556],[-96.904895,33.2587324],[-96.904895,33.2587324],[-96.9052716,33.2587402],[-96.9052716,33.2587402],[-96.9052678,33.2588634],[-96.9052678,33.2588634],[-96.9048912,33.2588556],[-96.9048912,33.2588556]]]},"properties":{"lotName":"2-E-14","lotCpId":"7330671615532062674","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048879,33.2589789],[-96.9048912,33.2588556],[-96.9048912,33.2588556],[-96.9052678,33.2588634],[-96.9052678,33.2588634],[-96.9052645,33.2589866],[-96.9052645,33.2589866],[-96.9048879,33.2589789],[-96.9048879,33.2589789]]]},"properties":{"lotName":"2-E-15","lotCpId":"4657681615532077497","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048841,33.2591016],[-96.9048879,33.2589789],[-96.9048879,33.2589789],[-96.9052645,33.2589866],[-96.9052645,33.2589866],[-96.9052596,33.2591423],[-96.9052596,33.2591423],[-96.9052506,33.2591418],[-96.9052263,33.2591405],[-96.905147,33.2591368],[-96.9050523,33.259133],[-96.904973,33.2591313],[-96.9049163,33.2591299],[-96.9048841,33.2591016],[-96.9048841,33.2591016]]]},"properties":{"lotName":"2-E-16","lotCpId":"2677001615532057951","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047242,33.2589752],[-96.9047204,33.2590984],[-96.9047204,33.2590984],[-96.9046871,33.2591254],[-96.9043432,33.2591181],[-96.9043432,33.2591181],[-96.9043476,33.2589675],[-96.9043476,33.2589675],[-96.9047242,33.2589752],[-96.9047242,33.2589752]]]},"properties":{"lotName":"2-F-1","lotCpId":"1344541615532061354","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047275,33.258852],[-96.9047242,33.2589752],[-96.9047242,33.2589752],[-96.9043476,33.2589675],[-96.9043476,33.2589675],[-96.9043509,33.2588442],[-96.9043509,33.2588442],[-96.9047275,33.258852],[-96.9047275,33.258852]]]},"properties":{"lotName":"2-F-2","lotCpId":"6480101615532073499","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047313,33.2587288],[-96.9047275,33.258852],[-96.9047275,33.258852],[-96.9043509,33.2588442],[-96.9043509,33.2588442],[-96.9043547,33.258721],[-96.9043547,33.258721],[-96.9047313,33.2587288],[-96.9047313,33.2587288]]]},"properties":{"lotName":"2-F-3","lotCpId":"1826661615532066655","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047351,33.2586056],[-96.9047313,33.2587288],[-96.9047313,33.2587288],[-96.9043547,33.258721],[-96.9043547,33.258721],[-96.9043585,33.2585978],[-96.9043585,33.2585978],[-96.9047351,33.2586056],[-96.9047351,33.2586056]]]},"properties":{"lotName":"2-F-4","lotCpId":"3681001615532063331","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047389,33.2584823],[-96.9047351,33.2586056],[-96.9047351,33.2586056],[-96.9043585,33.2585978],[-96.9043585,33.2585978],[-96.9043623,33.2584746],[-96.9043623,33.2584746],[-96.9047389,33.2584823],[-96.9047389,33.2584823]]]},"properties":{"lotName":"2-F-5","lotCpId":"5234351615532219658","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047422,33.2583596],[-96.9047389,33.2584823],[-96.9047389,33.2584823],[-96.9043623,33.2584746],[-96.9043623,33.2584746],[-96.9043656,33.2583514],[-96.9043656,33.2583514],[-96.9047422,33.2583596],[-96.9047422,33.2583596]]]},"properties":{"lotName":"2-F-6","lotCpId":"2574131615532211801","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.904746,33.2582364],[-96.9047422,33.2583596],[-96.9047422,33.2583596],[-96.9043656,33.2583514],[-96.9043656,33.2583514],[-96.9043694,33.2582286],[-96.9043694,33.2582286],[-96.904746,33.2582364],[-96.904746,33.2582364]]]},"properties":{"lotName":"2-F-7","lotCpId":"7044721615532102118","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047498,33.2581131],[-96.904746,33.2582364],[-96.904746,33.2582364],[-96.9043694,33.2582286],[-96.9043694,33.2582286],[-96.9043738,33.258078],[-96.9043738,33.258078],[-96.9047176,33.2580848],[-96.9047498,33.2581131],[-96.9047498,33.2581131]]]},"properties":{"lotName":"2-F-8","lotCpId":"3265551615529082480","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056154,33.2593084],[-96.9057617,33.2593225],[-96.9057617,33.2593225],[-96.9057175,33.2596397],[-96.9057175,33.2596397],[-96.9055712,33.2596255],[-96.9055712,33.2596255],[-96.9056154,33.2593084],[-96.9056154,33.2593084]]]},"properties":{"lotName":"2-B-2","lotCpId":"3240081615532110675","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054626,33.2592938],[-96.9055614,33.2593029],[-96.9056154,33.2593084],[-96.9056154,33.2593084],[-96.9055712,33.2596255],[-96.9055712,33.2596255],[-96.9054238,33.2596114],[-96.9054238,33.2596114],[-96.9054626,33.2592938],[-96.9054626,33.2592938]]]},"properties":{"lotName":"2-B-3","lotCpId":"6455801615532215095","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9053065,33.2592824],[-96.9054626,33.2592938],[-96.9054626,33.2592938],[-96.9054238,33.2596114],[-96.9054238,33.2596114],[-96.905277,33.2596004],[-96.905277,33.2596004],[-96.9053065,33.2592824],[-96.9053065,33.2592824]]]},"properties":{"lotName":"2-B-4","lotCpId":"7474501615532042103","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051504,33.2592737],[-96.9053065,33.2592824],[-96.9053065,33.2592824],[-96.905277,33.2596004],[-96.905277,33.2596004],[-96.9051302,33.2595922],[-96.9051302,33.2595922],[-96.9051504,33.2592737],[-96.9051504,33.2592737]]]},"properties":{"lotName":"2-B-5","lotCpId":"8871701615532071492","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049938,33.2592687],[-96.9051504,33.2592737],[-96.9051504,33.2592737],[-96.9051302,33.2595922],[-96.9051302,33.2595922],[-96.9049829,33.2595872],[-96.9049829,33.2595872],[-96.9049938,33.2592687],[-96.9049938,33.2592687]]]},"properties":{"lotName":"2-B-6","lotCpId":"1057221615532069512","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048448,33.2592655],[-96.9049692,33.2592678],[-96.9049938,33.2592687],[-96.9049938,33.2592687],[-96.9049829,33.2595872],[-96.9049829,33.2595872],[-96.9048355,33.2595804],[-96.9048355,33.2595804],[-96.9048448,33.2592655],[-96.9048448,33.2592655]]]},"properties":{"lotName":"2-B-7","lotCpId":"5017001615532078152","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9046974,33.2592623],[-96.9048448,33.2592655],[-96.9048448,33.2592655],[-96.9048355,33.2595804],[-96.9048355,33.2595804],[-96.9046882,33.2595772],[-96.9046882,33.2595772],[-96.9046974,33.2592623],[-96.9046974,33.2592623]]]},"properties":{"lotName":"2-B-8","lotCpId":"2077261615532111335","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045501,33.2592595],[-96.9046974,33.2592623],[-96.9046974,33.2592623],[-96.9046882,33.2595772],[-96.9046882,33.2595772],[-96.9045408,33.259574],[-96.9045408,33.259574],[-96.9045501,33.2592595],[-96.9045501,33.2592595]]]},"properties":{"lotName":"2-B-9","lotCpId":"1026141615532233017","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8942865,33.273156],[-96.8942832,33.2732633],[-96.8942832,33.2732633],[-96.8942498,33.2732898],[-96.8938896,33.2732827],[-96.8938896,33.2732827],[-96.8938936,33.273148],[-96.8938936,33.273148],[-96.8942865,33.273156],[-96.8942865,33.273156]]]},"properties":{"lotName":"8-A-5","lotCpId":"6681771610356819210","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8942898,33.2730328],[-96.8942865,33.273156],[-96.8942865,33.273156],[-96.8938936,33.273148],[-96.8938936,33.273148],[-96.8938972,33.2730248],[-96.8938972,33.2730248],[-96.8942898,33.2730328],[-96.8942898,33.2730328]]]},"properties":{"lotName":"8-A-4","lotCpId":"5762681610356819258","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8942934,33.2729096],[-96.8942898,33.2730328],[-96.8942898,33.2730328],[-96.8938972,33.2730248],[-96.8938972,33.2730248],[-96.8939004,33.2729016],[-96.8939004,33.2729016],[-96.8942934,33.2729096],[-96.8942934,33.2729096]]]},"properties":{"lotName":"8-A-3","lotCpId":"3618401610356819219","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8942967,33.2727864],[-96.8942965,33.2727993],[-96.8942934,33.2729096],[-96.8942934,33.2729096],[-96.8939004,33.2729016],[-96.8939004,33.2729016],[-96.8939041,33.2727784],[-96.8939041,33.2727784],[-96.8942967,33.2727864],[-96.8942967,33.2727864]]]},"properties":{"lotName":"8-A-2","lotCpId":"5774701610356819212","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.894256,33.2725829],[-96.8942628,33.2725983],[-96.8942775,33.272641],[-96.8942916,33.2727055],[-96.8942967,33.2727864],[-96.8942967,33.2727864],[-96.8939041,33.2727784],[-96.8939041,33.2727784],[-96.8939077,33.2726511],[-96.8939077,33.2726511],[-96.8939156,33.2726508],[-96.8939379,33.2726496],[-96.8940172,33.2726414],[-96.8941289,33.272621],[-96.894256,33.2725829],[-96.894256,33.2725829]]]},"properties":{"lotName":"8-A-1","lotCpId":"4811531610356819049","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944394,33.2726226],[-96.8944375,33.2726144],[-96.8944312,33.272592],[-96.8944024,33.2725183],[-96.8944024,33.2725183],[-96.8944093,33.2725146],[-96.8944293,33.2725047],[-96.8945046,33.2724751],[-96.8946204,33.2724462],[-96.8947688,33.272435],[-96.8948638,33.2724367],[-96.8948638,33.2724367],[-96.8948583,33.2726311],[-96.8948583,33.2726311],[-96.8944394,33.2726226],[-96.8944394,33.2726226]]]},"properties":{"lotName":"8-C-18","lotCpId":"6535211610356819228","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944594,33.2727478],[-96.8944587,33.2727362],[-96.8944558,33.2727064],[-96.8944394,33.2726226],[-96.8944394,33.2726226],[-96.8948583,33.2726311],[-96.8948583,33.2726311],[-96.8948547,33.2727557],[-96.8948547,33.2727557],[-96.8944594,33.2727478],[-96.8944594,33.2727478]]]},"properties":{"lotName":"8-C-17","lotCpId":"5275271610356819104","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944584,33.2728723],[-96.8944604,33.2728025],[-96.8944609,33.2727871],[-96.8944594,33.2727478],[-96.8944594,33.2727478],[-96.8948547,33.2727557],[-96.8948547,33.2727557],[-96.8948511,33.2728803],[-96.8948511,33.2728803],[-96.8944584,33.2728723],[-96.8944584,33.2728723]]]},"properties":{"lotName":"8-C-16","lotCpId":"6052801610356819209","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944548,33.2729969],[-96.8944584,33.2728723],[-96.8944584,33.2728723],[-96.8948511,33.2728803],[-96.8948511,33.2728803],[-96.8948475,33.2730048],[-96.8948475,33.2730048],[-96.8944548,33.2729969],[-96.8944548,33.2729969]]]},"properties":{"lotName":"8-C-15","lotCpId":"7665201610356819058","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944512,33.2731215],[-96.8944548,33.2729969],[-96.8944548,33.2729969],[-96.8948475,33.2730048],[-96.8948475,33.2730048],[-96.8948442,33.2731294],[-96.8948442,33.2731294],[-96.8944512,33.2731215],[-96.8944512,33.2731215]]]},"properties":{"lotName":"8-C-14","lotCpId":"3065721610356818833","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944476,33.273246],[-96.8944512,33.2731215],[-96.8944512,33.2731215],[-96.8948442,33.2731294],[-96.8948442,33.2731294],[-96.8948406,33.273254],[-96.8948406,33.273254],[-96.8944476,33.273246],[-96.8944476,33.273246]]]},"properties":{"lotName":"8-C-13","lotCpId":"7217741610356819099","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.894444,33.2733706],[-96.8944476,33.273246],[-96.8944476,33.273246],[-96.8948406,33.273254],[-96.8948406,33.273254],[-96.894837,33.2733783],[-96.894837,33.2733783],[-96.894444,33.2733706],[-96.894444,33.2733706]]]},"properties":{"lotName":"8-C-12","lotCpId":"5511231610356819093","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944349,33.2734949],[-96.8944381,33.2734863],[-96.8944417,33.2734568],[-96.894444,33.2733706],[-96.894444,33.2733706],[-96.894837,33.2733783],[-96.894837,33.2733783],[-96.8948334,33.2735028],[-96.8948334,33.2735028],[-96.8944349,33.2734949],[-96.8944349,33.2734949]]]},"properties":{"lotName":"8-C-11","lotCpId":"8357271610356818985","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8942426,33.2736159],[-96.8942665,33.273615],[-96.8943224,33.2736035],[-96.8943864,33.2735679],[-96.8944141,33.2735369],[-96.8944349,33.2734949],[-96.8944349,33.2734949],[-96.8948334,33.2735028],[-96.8948334,33.2735028],[-96.8948298,33.2736274],[-96.8948298,33.2736274],[-96.8942426,33.2736159],[-96.8942426,33.2736159]]]},"properties":{"lotName":"8-C-10","lotCpId":"8310331610356819120","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952299,33.2735039],[-96.8952356,33.2735239],[-96.8952606,33.2735684],[-96.895317,33.2736145],[-96.8953607,33.273631],[-96.8954168,33.2736394],[-96.8954168,33.2736394],[-96.8948298,33.2736274],[-96.8948298,33.2736274],[-96.8948334,33.273496],[-96.8948334,33.273496],[-96.8952299,33.2735039],[-96.8952299,33.2735039]]]},"properties":{"lotName":"8-C-9","lotCpId":"6800081610356818939","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952303,33.2733725],[-96.8952273,33.2734724],[-96.8952274,33.2734825],[-96.8952299,33.2735039],[-96.8952299,33.2735039],[-96.8948334,33.273496],[-96.8948334,33.273496],[-96.8948373,33.2733646],[-96.8948373,33.2733646],[-96.8952303,33.2733725],[-96.8952303,33.2733725]]]},"properties":{"lotName":"8-C-8","lotCpId":"5125241610356819310","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952339,33.2732411],[-96.8952303,33.2733725],[-96.8952303,33.2733725],[-96.8948373,33.2733646],[-96.8948373,33.2733646],[-96.8948409,33.2732334],[-96.8948409,33.2732334],[-96.8952339,33.2732411],[-96.8952339,33.2732411]]]},"properties":{"lotName":"8-C-7","lotCpId":"1771831610356819318","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952378,33.2731097],[-96.8952339,33.2732411],[-96.8952339,33.2732411],[-96.8948409,33.2732334],[-96.8948409,33.2732334],[-96.8948448,33.273102],[-96.8948448,33.273102],[-96.8952378,33.2731097],[-96.8952378,33.2731097]]]},"properties":{"lotName":"8-C-6","lotCpId":"7876631610356819155","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952414,33.2729786],[-96.8952378,33.2731097],[-96.8952378,33.2731097],[-96.8948448,33.273102],[-96.8948448,33.273102],[-96.8948484,33.2729706],[-96.8948484,33.2729706],[-96.8952414,33.2729786],[-96.8952414,33.2729786]]]},"properties":{"lotName":"8-C-5","lotCpId":"4630671610356819214","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952453,33.2728471],[-96.8952414,33.2729786],[-96.8952414,33.2729786],[-96.8948484,33.2729706],[-96.8948484,33.2729706],[-96.8948524,33.2728392],[-96.8948524,33.2728392],[-96.8952453,33.2728471],[-96.8952453,33.2728471]]]},"properties":{"lotName":"8-C-4","lotCpId":"8738021610356819231","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952489,33.2727157],[-96.8952453,33.2728471],[-96.8952453,33.2728471],[-96.8948524,33.2728392],[-96.8948524,33.2728392],[-96.894856,33.2727078],[-96.894856,33.2727078],[-96.8952489,33.2727157],[-96.8952489,33.2727157]]]},"properties":{"lotName":"8-C-3","lotCpId":"2745001610356819218","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952529,33.2725843],[-96.8952489,33.2727157],[-96.8952489,33.2727157],[-96.894856,33.2727078],[-96.894856,33.2727078],[-96.8948599,33.2725764],[-96.8948599,33.2725764],[-96.8952529,33.2725843],[-96.8952529,33.2725843]]]},"properties":{"lotName":"8-C-2","lotCpId":"5758381610356819201","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952568,33.2724447],[-96.8952529,33.2725843],[-96.8952529,33.2725843],[-96.8948599,33.2725764],[-96.8948599,33.2725764],[-96.8948638,33.2724367],[-96.8948638,33.2724367],[-96.8952568,33.2724447],[-96.8952568,33.2724447]]]},"properties":{"lotName":"8-C-1","lotCpId":"1884721610356819415","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954169,33.2725712],[-96.8954205,33.272448],[-96.8954205,33.272448],[-96.8958135,33.2724559],[-96.8958135,33.2724559],[-96.8958099,33.2725791],[-96.8958099,33.2725791],[-96.8954169,33.2725712],[-96.8954169,33.2725712]]]},"properties":{"lotName":"8-D-16","lotCpId":"8011531610356819222","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954133,33.2726944],[-96.8954169,33.2725712],[-96.8954169,33.2725712],[-96.8958099,33.2725791],[-96.8958099,33.2725791],[-96.8958063,33.2727023],[-96.8958063,33.2727023],[-96.8954133,33.2726944],[-96.8954133,33.2726944]]]},"properties":{"lotName":"8-D-15","lotCpId":"2524421610356819207","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.89541,33.2728176],[-96.8954133,33.2726944],[-96.8954133,33.2726944],[-96.8958063,33.2727023],[-96.8958063,33.2727023],[-96.8958027,33.2728252],[-96.8958027,33.2728252],[-96.89541,33.2728176],[-96.89541,33.2728176]]]},"properties":{"lotName":"8-D-14","lotCpId":"4116681610356819256","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954064,33.2729408],[-96.89541,33.2728176],[-96.89541,33.2728176],[-96.8958027,33.2728252],[-96.8958027,33.2728252],[-96.8957991,33.2729484],[-96.8957991,33.2729484],[-96.8954064,33.2729408],[-96.8954064,33.2729408]]]},"properties":{"lotName":"8-D-13","lotCpId":"2072371610356819160","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954028,33.2730637],[-96.8954064,33.2729408],[-96.8954064,33.2729408],[-96.8957991,33.2729484],[-96.8957991,33.2729484],[-96.8957958,33.2730716],[-96.8957958,33.2730716],[-96.8954028,33.2730637],[-96.8954028,33.2730637]]]},"properties":{"lotName":"8-D-12","lotCpId":"7110381610356819194","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8953992,33.2731869],[-96.8954028,33.2730637],[-96.8954028,33.2730637],[-96.8957958,33.2730716],[-96.8957958,33.2730716],[-96.8957922,33.2731948],[-96.8957922,33.2731948],[-96.8953992,33.2731869],[-96.8953992,33.2731869]]]},"properties":{"lotName":"8-D-11","lotCpId":"6137801610356819201","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954168,33.2736394],[-96.8954435,33.2736383],[-96.8955049,33.2736244],[-96.8955725,33.2735813],[-96.8955998,33.2735438],[-96.895618,33.273493],[-96.8956184,33.2734861],[-96.8956176,33.2734678],[-96.8956011,33.2734107],[-96.8955457,33.27335],[-96.8954962,33.2733269],[-96.8954283,33.2733135],[-96.8953966,33.2732855],[-96.8953992,33.2731869],[-96.8953992,33.2731869],[-96.8957922,33.2731948],[-96.8957922,33.2731948],[-96.8957791,33.2736466],[-96.8957791,33.2736466],[-96.8954168,33.2736394],[-96.8954168,33.2736394]]]},"properties":{"lotName":"8-D-10","lotCpId":"6232011610356819199","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961809,33.2735286],[-96.8961865,33.2735474],[-96.8962114,33.2735896],[-96.8962673,33.2736337],[-96.8963106,33.2736499],[-96.8963661,33.2736586],[-96.8963661,33.2736586],[-96.8957791,33.2736466],[-96.8957791,33.2736466],[-96.8957827,33.2735206],[-96.8957827,33.2735206],[-96.8961809,33.2735286],[-96.8961809,33.2735286]]]},"properties":{"lotName":"8-D-9","lotCpId":"4300271610356819227","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961792,33.2734026],[-96.8961764,33.2734917],[-96.8961765,33.2735031],[-96.8961809,33.2735286],[-96.8961809,33.2735286],[-96.8957827,33.2735206],[-96.8957827,33.2735206],[-96.8957863,33.2733947],[-96.8957863,33.2733947],[-96.8961792,33.2734026],[-96.8961792,33.2734026]]]},"properties":{"lotName":"8-D-8","lotCpId":"7752701610356818949","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961828,33.2732767],[-96.8961792,33.2734026],[-96.8961792,33.2734026],[-96.8957863,33.2733947],[-96.8957863,33.2733947],[-96.8957899,33.2732688],[-96.8957899,33.2732688],[-96.8961828,33.2732767],[-96.8961828,33.2732767]]]},"properties":{"lotName":"8-D-7","lotCpId":"8884541610356819103","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961864,33.2731508],[-96.8961828,33.2732767],[-96.8961828,33.2732767],[-96.8957899,33.2732688],[-96.8957899,33.2732688],[-96.8957935,33.2731428],[-96.8957935,33.2731428],[-96.8961864,33.2731508],[-96.8961864,33.2731508]]]},"properties":{"lotName":"8-D-6","lotCpId":"2278881610356818966","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961901,33.2730248],[-96.8961864,33.2731508],[-96.8961864,33.2731508],[-96.8957935,33.2731428],[-96.8957935,33.2731428],[-96.8957971,33.2730169],[-96.8957971,33.2730169],[-96.8961901,33.2730248],[-96.8961901,33.2730248]]]},"properties":{"lotName":"8-D-5","lotCpId":"6702811610356819115","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961937,33.2728989],[-96.8961901,33.2730248],[-96.8961901,33.2730248],[-96.8957971,33.2730169],[-96.8957971,33.2730169],[-96.895801,33.2728909],[-96.895801,33.2728909],[-96.8961937,33.2728989],[-96.8961937,33.2728989]]]},"properties":{"lotName":"8-D-4","lotCpId":"6622861610356819198","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961973,33.2727729],[-96.8961937,33.2728989],[-96.8961937,33.2728989],[-96.895801,33.2728909],[-96.895801,33.2728909],[-96.8958046,33.272765],[-96.8958046,33.272765],[-96.8961973,33.2727729],[-96.8961973,33.2727729]]]},"properties":{"lotName":"8-D-3","lotCpId":"1563251610356819217","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8962009,33.272647],[-96.8961973,33.2727729],[-96.8961973,33.2727729],[-96.8958046,33.272765],[-96.8958046,33.272765],[-96.8958082,33.2726393],[-96.8958082,33.2726393],[-96.8962009,33.272647],[-96.8962009,33.272647]]]},"properties":{"lotName":"8-D-2","lotCpId":"4363631610356819206","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8962039,33.2725345],[-96.8962009,33.272647],[-96.8962009,33.272647],[-96.8958082,33.2726393],[-96.8958082,33.2726393],[-96.8958135,33.2724559],[-96.8958135,33.2724559],[-96.895815,33.2724559],[-96.8958323,33.2724563],[-96.8958536,33.272457],[-96.8959089,33.2724616],[-96.8959855,33.2724739],[-96.8960709,33.2724978],[-96.8960817,33.2725017],[-96.8961107,33.2725113],[-96.8962039,33.2725345],[-96.8962039,33.2725345]]]},"properties":{"lotName":"8-D-1","lotCpId":"3370851610356819320","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8963636,33.2726886],[-96.8963671,33.2725562],[-96.8963671,33.2725562],[-96.8963753,33.2725568],[-96.8963986,33.2725578],[-96.8964827,33.272557],[-96.8966038,33.2725457],[-96.8967463,33.2725156],[-96.8967463,33.2725156],[-96.8967605,33.2725501],[-96.8967566,33.2726966],[-96.8967566,33.2726966],[-96.8963636,33.2726886],[-96.8963636,33.2726886]]]},"properties":{"lotName":"8-E-1","lotCpId":"7408481610356818911","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.89636,33.2728173],[-96.8963636,33.2726886],[-96.8963636,33.2726886],[-96.8967566,33.2726966],[-96.8967566,33.2726966],[-96.8967526,33.2728252],[-96.8967526,33.2728252],[-96.89636,33.2728173],[-96.89636,33.2728173]]]},"properties":{"lotName":"8-E-2","lotCpId":"1387101610356819056","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8963561,33.272946],[-96.89636,33.2728173],[-96.89636,33.2728173],[-96.8967526,33.2728252],[-96.8967526,33.2728252],[-96.896749,33.2729539],[-96.896749,33.2729539],[-96.8963561,33.272946],[-96.8963561,33.272946]]]},"properties":{"lotName":"8-E-3","lotCpId":"2872451610356819065","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8963525,33.2730746],[-96.8963561,33.272946],[-96.8963561,33.272946],[-96.896749,33.2729539],[-96.896749,33.2729539],[-96.8967454,33.2730826],[-96.8967454,33.2730826],[-96.8963525,33.2730746],[-96.8963525,33.2730746]]]},"properties":{"lotName":"8-E-4","lotCpId":"1357141610356818798","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8963489,33.2732033],[-96.8963525,33.2730746],[-96.8963525,33.2730746],[-96.8967454,33.2730826],[-96.8967454,33.2730826],[-96.8967418,33.2732113],[-96.8967418,33.2732113],[-96.8963489,33.2732033],[-96.8963489,33.2732033]]]},"properties":{"lotName":"8-E-5","lotCpId":"4667101610356819011","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8963661,33.2736586],[-96.8963877,33.2736582],[-96.8964396,33.2736486],[-96.8965023,33.2736165],[-96.8965565,33.2735488],[-96.8965607,33.2735347],[-96.8965655,33.2734988],[-96.8965595,33.2734511],[-96.8965309,33.2734015],[-96.8965221,33.2733916],[-96.8964947,33.2733692],[-96.8964472,33.2733457],[-96.896378,33.2733325],[-96.8963459,33.2733046],[-96.8963489,33.2732033],[-96.8963489,33.2732033],[-96.8967418,33.2732113],[-96.8967418,33.2732113],[-96.8967281,33.2736808],[-96.8967281,33.2736808],[-96.8966675,33.2736644],[-96.8963661,33.2736586],[-96.8963661,33.2736586]]]},"properties":{"lotName":"8-E-6","lotCpId":"2520261610356818826","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971398,33.2734987],[-96.8971399,33.2735122],[-96.8971476,33.2735452],[-96.8971736,33.2735861],[-96.8972288,33.2736238],[-96.8972288,33.2736238],[-96.8967299,33.2736137],[-96.8967299,33.2736137],[-96.8967337,33.2734905],[-96.8967337,33.2734905],[-96.8971398,33.2734987],[-96.8971398,33.2734987]]]},"properties":{"lotName":"10-A-33","lotCpId":"3883311672819047269","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971436,33.2733755],[-96.8971398,33.2734987],[-96.8971398,33.2734987],[-96.8967337,33.2734905],[-96.8967337,33.2734905],[-96.896737,33.2733673],[-96.896737,33.2733673],[-96.8971436,33.2733755],[-96.8971436,33.2733755]]]},"properties":{"lotName":"10-A-34","lotCpId":"3805501672819048182","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971469,33.2732523],[-96.8971436,33.2733755],[-96.8971436,33.2733755],[-96.896737,33.2733673],[-96.896737,33.2733673],[-96.8967408,33.2732441],[-96.8967408,33.2732441],[-96.8971469,33.2732523],[-96.8971469,33.2732523]]]},"properties":{"lotName":"10-A-35","lotCpId":"6411301672819049067","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971507,33.2731291],[-96.8971469,33.2732523],[-96.8971469,33.2732523],[-96.8967408,33.2732441],[-96.8967408,33.2732441],[-96.8967441,33.2731209],[-96.8967441,33.2731209],[-96.8971507,33.2731291],[-96.8971507,33.2731291]]]},"properties":{"lotName":"10-A-36","lotCpId":"2763411672819049986","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.897154,33.2730059],[-96.8971507,33.2731291],[-96.8971507,33.2731291],[-96.8967441,33.2731209],[-96.8967441,33.2731209],[-96.8967479,33.2729977],[-96.8967479,33.2729977],[-96.897154,33.2730059],[-96.897154,33.2730059]]]},"properties":{"lotName":"10-A-37","lotCpId":"8416301672819050887","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971578,33.2728827],[-96.897154,33.2730059],[-96.897154,33.2730059],[-96.8967479,33.2729977],[-96.8967479,33.2729977],[-96.8967512,33.2728745],[-96.8967512,33.2728745],[-96.8971578,33.2728827],[-96.8971578,33.2728827]]]},"properties":{"lotName":"10-A-38","lotCpId":"8487801672819051791","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971611,33.2727595],[-96.8971578,33.2728827],[-96.8971578,33.2728827],[-96.8967512,33.2728745],[-96.8967512,33.2728745],[-96.896755,33.2727513],[-96.896755,33.2727513],[-96.8971611,33.2727595],[-96.8971611,33.2727595]]]},"properties":{"lotName":"10-A-39","lotCpId":"6003801672819052715","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971649,33.2726363],[-96.8971611,33.2727595],[-96.8971611,33.2727595],[-96.896755,33.2727513],[-96.896755,33.2727513],[-96.8967583,33.2726281],[-96.8967583,33.2726281],[-96.8971649,33.2726363],[-96.8971649,33.2726363]]]},"properties":{"lotName":"10-A-40","lotCpId":"1731501672819053612","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971201,33.2724095],[-96.8971277,33.2724277],[-96.897144,33.2724767],[-96.8971595,33.2725489],[-96.8971649,33.2726363],[-96.8971649,33.2726363],[-96.8967583,33.2726281],[-96.8967583,33.2726281],[-96.8967605,33.2725501],[-96.8967463,33.2725156],[-96.8967463,33.2725156],[-96.8971201,33.2724095],[-96.8971201,33.2724095]]]},"properties":{"lotName":"10-A-41","lotCpId":"5728641672819054524","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8981031,33.2732715],[-96.8980993,33.273402],[-96.8980993,33.273402],[-96.898066,33.2734285],[-96.8977025,33.2734212],[-96.8977025,33.2734212],[-96.8977068,33.2732633],[-96.8977068,33.2732633],[-96.8981031,33.2732715],[-96.8981031,33.2732715]]]},"properties":{"lotName":"10-D-9","lotCpId":"4157101672819119835","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8981064,33.2731483],[-96.8981031,33.2732715],[-96.8981031,33.2732715],[-96.8977068,33.2732633],[-96.8977068,33.2732633],[-96.8977107,33.2731401],[-96.8977107,33.2731401],[-96.8981064,33.2731483],[-96.8981064,33.2731483]]]},"properties":{"lotName":"10-D-8","lotCpId":"6415001672819118951","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8981102,33.2730251],[-96.8981064,33.2731483],[-96.8981064,33.2731483],[-96.8977107,33.2731401],[-96.8977107,33.2731401],[-96.8977139,33.2730169],[-96.8977139,33.2730169],[-96.8981102,33.2730251],[-96.8981102,33.2730251]]]},"properties":{"lotName":"10-D-7","lotCpId":"3140231672819118045","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8981134,33.2729019],[-96.8981102,33.2730251],[-96.8981102,33.2730251],[-96.8977139,33.2730169],[-96.8977139,33.2730169],[-96.8977172,33.2728937],[-96.8977172,33.2728937],[-96.8981134,33.2729019],[-96.8981134,33.2729019]]]},"properties":{"lotName":"10-D-6","lotCpId":"5356301672819117132","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8981173,33.2727787],[-96.8981134,33.2729019],[-96.8981134,33.2729019],[-96.8977172,33.2728937],[-96.8977172,33.2728937],[-96.897721,33.2727705],[-96.897721,33.2727705],[-96.8981173,33.2727787],[-96.8981173,33.2727787]]]},"properties":{"lotName":"10-D-5","lotCpId":"8606401672819116191","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8981205,33.2726555],[-96.8981173,33.2727787],[-96.8981173,33.2727787],[-96.897721,33.2727705],[-96.897721,33.2727705],[-96.8977243,33.2726477],[-96.8977243,33.2726477],[-96.8981205,33.2726555],[-96.8981205,33.2726555]]]},"properties":{"lotName":"10-D-4","lotCpId":"4458131672819115296","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8981129,33.2724835],[-96.8981146,33.2725006],[-96.8981182,33.2725434],[-96.8981205,33.2726555],[-96.8981205,33.2726555],[-96.8977243,33.2726477],[-96.8977243,33.2726477],[-96.8977156,33.2725163],[-96.8977156,33.2725163],[-96.8981129,33.2724835],[-96.8981129,33.2724835]]]},"properties":{"lotName":"10-D-3","lotCpId":"6824051672819114392","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980807,33.2723142],[-96.8980848,33.2723304],[-96.8980943,33.2723714],[-96.8981129,33.2724835],[-96.8981129,33.2724835],[-96.8977156,33.2725163],[-96.8977156,33.2725163],[-96.8977118,33.2724579],[-96.8976899,33.2723867],[-96.8976899,33.2723867],[-96.8980807,33.2723142],[-96.8980807,33.2723142]]]},"properties":{"lotName":"10-D-2","lotCpId":"1265701672819113488","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980261,33.2721531],[-96.8980323,33.2721684],[-96.8980473,33.2722074],[-96.8980807,33.2723142],[-96.8980807,33.2723142],[-96.8976899,33.2723867],[-96.8976899,33.2723867],[-96.8976506,33.2722594],[-96.8976506,33.2722594],[-96.8980261,33.2721531],[-96.8980261,33.2721531]]]},"properties":{"lotName":"10-D-1","lotCpId":"4805401672819112578","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973183,33.2725081],[-96.8972751,33.2723657],[-96.8972751,33.2723657],[-96.8976506,33.2722594],[-96.8976506,33.2722594],[-96.8977118,33.2724579],[-96.8977118,33.2724579],[-96.8973183,33.2725081],[-96.8973183,33.2725081]]]},"properties":{"lotName":"10-D-17","lotCpId":"2002631672819127124","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973286,33.2726395],[-96.8973287,33.2726264],[-96.8973279,33.2725937],[-96.8973183,33.2725081],[-96.8973183,33.2725081],[-96.8977118,33.2724579],[-96.8977118,33.2724579],[-96.8977243,33.2726477],[-96.8977243,33.2726477],[-96.8973286,33.2726395],[-96.8973286,33.2726395]]]},"properties":{"lotName":"10-D-16","lotCpId":"2507041672819126209","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973248,33.2727627],[-96.8973286,33.2726395],[-96.8973286,33.2726395],[-96.8977243,33.2726477],[-96.8977243,33.2726477],[-96.897721,33.2727705],[-96.897721,33.2727705],[-96.8973248,33.2727627],[-96.8973248,33.2727627]]]},"properties":{"lotName":"10-D-15","lotCpId":"6404461672819125292","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973215,33.2728859],[-96.8973248,33.2727627],[-96.8973248,33.2727627],[-96.897721,33.2727705],[-96.897721,33.2727705],[-96.8977172,33.2728937],[-96.8977172,33.2728937],[-96.8973215,33.2728859],[-96.8973215,33.2728859]]]},"properties":{"lotName":"10-D-14","lotCpId":"3882831672819124392","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973177,33.2730091],[-96.8973215,33.2728859],[-96.8973215,33.2728859],[-96.8977172,33.2728937],[-96.8977172,33.2728937],[-96.8977139,33.2730169],[-96.8977139,33.2730169],[-96.8973177,33.2730091],[-96.8973177,33.2730091]]]},"properties":{"lotName":"10-D-13","lotCpId":"8071051672819123499","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973144,33.2731323],[-96.8973177,33.2730091],[-96.8973177,33.2730091],[-96.8977139,33.2730169],[-96.8977139,33.2730169],[-96.8977107,33.2731401],[-96.8977107,33.2731401],[-96.8973144,33.2731323],[-96.8973144,33.2731323]]]},"properties":{"lotName":"10-D-12","lotCpId":"5280781672819122566","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973106,33.2732555],[-96.8973144,33.2731323],[-96.8973144,33.2731323],[-96.8977107,33.2731401],[-96.8977107,33.2731401],[-96.8977068,33.2732633],[-96.8977068,33.2732633],[-96.8973106,33.2732555],[-96.8973106,33.2732555]]]},"properties":{"lotName":"10-D-11","lotCpId":"7213151672819121656","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973068,33.273386],[-96.8973106,33.2732555],[-96.8973106,33.2732555],[-96.8977068,33.2732633],[-96.8977068,33.2732633],[-96.8977025,33.2734212],[-96.8977025,33.2734212],[-96.897339,33.2734139],[-96.8973068,33.273386],[-96.8973068,33.273386]]]},"properties":{"lotName":"10-D-10","lotCpId":"3431081672819120730","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990593,33.2732879],[-96.8990554,33.2734212],[-96.8990554,33.2734212],[-96.8990216,33.2734476],[-96.8986581,33.2734403],[-96.8986581,33.2734403],[-96.898663,33.2732802],[-96.898663,33.2732802],[-96.8990593,33.2732879],[-96.8990593,33.2732879]]]},"properties":{"lotName":"10-C-11","lotCpId":"5764611672819102556","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990625,33.273162],[-96.8990593,33.2732879],[-96.8990593,33.2732879],[-96.898663,33.2732802],[-96.898663,33.2732802],[-96.8986663,33.2731542],[-96.8986663,33.2731542],[-96.8990625,33.273162],[-96.8990625,33.273162]]]},"properties":{"lotName":"10-C-10","lotCpId":"2678671672819101633","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990664,33.273036],[-96.8990625,33.273162],[-96.8990625,33.273162],[-96.8986663,33.2731542],[-96.8986663,33.2731542],[-96.8986701,33.2730283],[-96.8986701,33.2730283],[-96.8990664,33.273036],[-96.8990664,33.273036]]]},"properties":{"lotName":"10-C-9","lotCpId":"3135771672819100709","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990702,33.2729101],[-96.8990664,33.273036],[-96.8990664,33.273036],[-96.8986701,33.2730283],[-96.8986701,33.2730283],[-96.8986739,33.2729024],[-96.8986739,33.2729024],[-96.8990702,33.2729101],[-96.8990702,33.2729101]]]},"properties":{"lotName":"10-C-8","lotCpId":"8512101672819099816","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990734,33.2727846],[-96.8990702,33.2729101],[-96.8990702,33.2729101],[-96.8986739,33.2729024],[-96.8986739,33.2729024],[-96.8986772,33.2727764],[-96.8986772,33.2727764],[-96.8990734,33.2727846],[-96.8990734,33.2727846]]]},"properties":{"lotName":"10-C-7","lotCpId":"7080551672819098911","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990773,33.272655],[-96.8990767,33.2726737],[-96.8990734,33.2727846],[-96.8990734,33.2727846],[-96.8986772,33.2727764],[-96.8986772,33.2727764],[-96.898681,33.27265],[-96.898681,33.27265],[-96.8990773,33.272655],[-96.8990773,33.272655]]]},"properties":{"lotName":"10-C-6","lotCpId":"6126401672819098021","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990729,33.2725067],[-96.8990739,33.2725178],[-96.899076,33.2725485],[-96.8990777,33.2725954],[-96.8990773,33.272655],[-96.8990773,33.272655],[-96.898681,33.27265],[-96.898681,33.27265],[-96.8986767,33.2725268],[-96.8986767,33.2725268],[-96.8990729,33.2725067],[-96.8990729,33.2725067]]]},"properties":{"lotName":"10-C-5","lotCpId":"4380271672819097089","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899056,33.2723589],[-96.8990581,33.2723732],[-96.8990629,33.2724092],[-96.8990729,33.2725067],[-96.8990729,33.2725067],[-96.8986767,33.2725268],[-96.8986767,33.2725268],[-96.8986756,33.2724899],[-96.8986641,33.2724036],[-96.8986641,33.2724036],[-96.899056,33.2723589],[-96.899056,33.2723589]]]},"properties":{"lotName":"10-C-4","lotCpId":"1803731672819096169","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990298,33.2722234],[-96.8990451,33.2722987],[-96.8990486,33.2723152],[-96.899056,33.2723589],[-96.899056,33.2723589],[-96.8986641,33.2724036],[-96.8986641,33.2724036],[-96.8986543,33.2723302],[-96.8986412,33.2722777],[-96.8986412,33.2722777],[-96.8990298,33.2722234],[-96.8990298,33.2722234]]]},"properties":{"lotName":"10-C-3","lotCpId":"2601021672819095271","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990047,33.2720965],[-96.8990298,33.2722234],[-96.8990298,33.2722234],[-96.8986412,33.2722777],[-96.8986412,33.2722777],[-96.8986166,33.2721732],[-96.8986106,33.2721513],[-96.8986106,33.2721513],[-96.8990047,33.2720965],[-96.8990047,33.2720965]]]},"properties":{"lotName":"10-C-2","lotCpId":"4151551672819094372","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989779,33.2719628],[-96.8990047,33.2720965],[-96.8990047,33.2720965],[-96.8986106,33.2721513],[-96.8986106,33.2721513],[-96.8985757,33.2720208],[-96.8985757,33.2720208],[-96.8986036,33.2720156],[-96.8986835,33.272002],[-96.8988101,33.2719834],[-96.8989779,33.2719628],[-96.8989779,33.2719628]]]},"properties":{"lotName":"10-C-1","lotCpId":"4826071672819093488","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982313,33.2722521],[-96.8981811,33.2721098],[-96.8981811,33.2721098],[-96.8982084,33.2721024],[-96.8982867,33.2720826],[-96.8984109,33.2720542],[-96.8985757,33.2720208],[-96.8985757,33.2720208],[-96.8986166,33.2721732],[-96.8986166,33.2721732],[-96.8982313,33.2722521],[-96.8982313,33.2722521]]]},"properties":{"lotName":"10-C-21","lotCpId":"2827801672819111650","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982624,33.2723817],[-96.8982596,33.2723677],[-96.8982522,33.2723336],[-96.8982313,33.2722521],[-96.8982313,33.2722521],[-96.8986166,33.2721732],[-96.8986166,33.2721732],[-96.8986543,33.2723302],[-96.8986543,33.2723302],[-96.8982624,33.2723817],[-96.8982624,33.2723817]]]},"properties":{"lotName":"10-C-20","lotCpId":"4730701672819110729","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982804,33.2725131],[-96.8982788,33.2724981],[-96.8982746,33.2724622],[-96.8982624,33.2723817],[-96.8982624,33.2723817],[-96.8986543,33.2723302],[-96.8986543,33.2723302],[-96.8986756,33.2724899],[-96.8986756,33.2724899],[-96.8982804,33.2725131],[-96.8982804,33.2725131]]]},"properties":{"lotName":"10-C-19","lotCpId":"5732001672819109806","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982848,33.272645],[-96.8982848,33.2726303],[-96.8982844,33.2725947],[-96.8982804,33.2725131],[-96.8982804,33.2725131],[-96.8986756,33.2724899],[-96.8986756,33.2724899],[-96.898681,33.27265],[-96.898681,33.27265],[-96.8982848,33.272645],[-96.8982848,33.272645]]]},"properties":{"lotName":"10-C-18","lotCpId":"5071381672819108895","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898281,33.2727687],[-96.8982843,33.2726587],[-96.8982848,33.272645],[-96.8982848,33.272645],[-96.898681,33.27265],[-96.898681,33.27265],[-96.8986772,33.2727764],[-96.8986772,33.2727764],[-96.898281,33.2727687],[-96.898281,33.2727687]]]},"properties":{"lotName":"10-C-17","lotCpId":"8004741672819107996","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982777,33.2728946],[-96.898281,33.2727687],[-96.898281,33.2727687],[-96.8986772,33.2727764],[-96.8986772,33.2727764],[-96.8986739,33.2729024],[-96.8986739,33.2729024],[-96.8982777,33.2728946],[-96.8982777,33.2728946]]]},"properties":{"lotName":"10-C-16","lotCpId":"1660611672819107089","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982739,33.2730205],[-96.8982777,33.2728946],[-96.8982777,33.2728946],[-96.8986739,33.2729024],[-96.8986739,33.2729024],[-96.8986701,33.2730283],[-96.8986701,33.2730283],[-96.8982739,33.2730205],[-96.8982739,33.2730205]]]},"properties":{"lotName":"10-C-15","lotCpId":"3838641672819106179","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982706,33.2731465],[-96.8982739,33.2730205],[-96.8982739,33.2730205],[-96.8986701,33.2730283],[-96.8986701,33.2730283],[-96.8986663,33.2731542],[-96.8986663,33.2731542],[-96.8982706,33.2731465],[-96.8982706,33.2731465]]]},"properties":{"lotName":"10-C-14","lotCpId":"3628281672819105253","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982668,33.273272],[-96.8982706,33.2731465],[-96.8982706,33.2731465],[-96.8986663,33.2731542],[-96.8986663,33.2731542],[-96.898663,33.2732802],[-96.898663,33.2732802],[-96.8982668,33.273272],[-96.8982668,33.273272]]]},"properties":{"lotName":"10-C-13","lotCpId":"5515751672819104376","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898263,33.2734052],[-96.8982668,33.273272],[-96.8982668,33.273272],[-96.898663,33.2732802],[-96.898663,33.2732802],[-96.8986581,33.2734403],[-96.8986581,33.2734403],[-96.8982952,33.273433],[-96.898263,33.2734052],[-96.898263,33.2734052]]]},"properties":{"lotName":"10-C-12","lotCpId":"3853761672819103475","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.901882,33.2724821],[-96.901881,33.2724687],[-96.9018807,33.272433],[-96.9018848,33.2723817],[-96.9018973,33.2723215],[-96.9019114,33.2722663],[-96.9019114,33.2722663],[-96.9023917,33.2723525],[-96.9023917,33.2723525],[-96.9023999,33.2724534],[-96.9023999,33.2724534],[-96.901882,33.2724821],[-96.901882,33.2724821]]]},"properties":{"lotName":"10-A-1","lotCpId":"2402701672819016430","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9019114,33.2726258],[-96.9019069,33.2726133],[-96.9018968,33.2725804],[-96.901882,33.2724821],[-96.901882,33.2724821],[-96.9023999,33.2724534],[-96.9023999,33.2724534],[-96.9024114,33.272598],[-96.9024114,33.272598],[-96.9019114,33.2726258],[-96.9019114,33.2726258]]]},"properties":{"lotName":"10-A-2","lotCpId":"5744381672819017352","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9020042,33.2727664],[-96.9020034,33.2727554],[-96.9019952,33.272728],[-96.9019713,33.2726925],[-96.9019234,33.2726573],[-96.9019216,33.272654],[-96.9019114,33.2726258],[-96.9019114,33.2726258],[-96.9024114,33.272598],[-96.9024114,33.272598],[-96.9024228,33.2727426],[-96.9024228,33.2727426],[-96.9020042,33.2727664],[-96.9020042,33.2727664]]]},"properties":{"lotName":"10-A-3","lotCpId":"3601601672819018249","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9019786,33.2728499],[-96.9019833,33.2728441],[-96.9019932,33.2728276],[-96.9020042,33.2727664],[-96.9020042,33.2727664],[-96.9024228,33.2727426],[-96.9024228,33.2727426],[-96.9024457,33.2730269],[-96.9023622,33.2730584],[-96.9023622,33.2730584],[-96.9019786,33.2728499],[-96.9019786,33.2728499]]]},"properties":{"lotName":"10-A-4","lotCpId":"2412531672819019143","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018929,33.2729051],[-96.9019024,33.2729023],[-96.9019253,33.272893],[-96.9019786,33.2728499],[-96.9019786,33.2728499],[-96.9023622,33.2730584],[-96.9023622,33.2730584],[-96.9020419,33.2731802],[-96.9020419,33.2731802],[-96.9018929,33.2729051],[-96.9018929,33.2729051]]]},"properties":{"lotName":"10-A-5","lotCpId":"3838771672819020031","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017412,33.2729334],[-96.9018054,33.2729096],[-96.901814,33.2729109],[-96.9018356,33.2729126],[-96.9018929,33.2729051],[-96.9018929,33.2729051],[-96.9020419,33.2731802],[-96.9020419,33.2731802],[-96.9019033,33.2732327],[-96.9019033,33.2732327],[-96.9017412,33.2729334],[-96.9017412,33.2729334]]]},"properties":{"lotName":"10-A-6","lotCpId":"5642721672819020926","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9016069,33.2729845],[-96.9017412,33.2729334],[-96.9017412,33.2729334],[-96.9019033,33.2732327],[-96.9019033,33.2732327],[-96.9017695,33.2732838],[-96.9017695,33.2732838],[-96.9016069,33.2729845],[-96.9016069,33.2729845]]]},"properties":{"lotName":"10-A-7","lotCpId":"4333761672819021846","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014726,33.2730356],[-96.9016069,33.2729845],[-96.9016069,33.2729845],[-96.9017695,33.2732838],[-96.9017695,33.2732838],[-96.9016353,33.2733345],[-96.9016353,33.2733345],[-96.9014726,33.2730356],[-96.9014726,33.2730356]]]},"properties":{"lotName":"10-A-8","lotCpId":"2730281672819022747","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013384,33.2730862],[-96.9014726,33.2730356],[-96.9014726,33.2730356],[-96.9016353,33.2733345],[-96.9016353,33.2733345],[-96.901501,33.2733856],[-96.901501,33.2733856],[-96.9013384,33.2730862],[-96.9013384,33.2730862]]]},"properties":{"lotName":"10-A-9","lotCpId":"3602211672819023648","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9011446,33.2731602],[-96.9012789,33.2731091],[-96.9012789,33.2731091],[-96.901441,33.2734084],[-96.901441,33.2734084],[-96.9013073,33.273459],[-96.9013073,33.273459],[-96.9011446,33.2731602],[-96.9011446,33.2731602]]]},"properties":{"lotName":"10-A-10","lotCpId":"7087281672819024547","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010104,33.2732108],[-96.9011446,33.2731602],[-96.9011446,33.2731602],[-96.9013073,33.273459],[-96.9013073,33.273459],[-96.901173,33.2735101],[-96.901173,33.2735101],[-96.9010104,33.2732108],[-96.9010104,33.2732108]]]},"properties":{"lotName":"10-A-11","lotCpId":"1287811672819025466","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008761,33.2732619],[-96.9010104,33.2732108],[-96.9010104,33.2732108],[-96.901173,33.2735101],[-96.901173,33.2735101],[-96.9010388,33.2735608],[-96.9010388,33.2735608],[-96.9008761,33.2732619],[-96.9008761,33.2732619]]]},"properties":{"lotName":"10-A-12","lotCpId":"1273711672819026383","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9007419,33.2733126],[-96.9008761,33.2732619],[-96.9008761,33.2732619],[-96.9010388,33.2735608],[-96.9010388,33.2735608],[-96.9009045,33.2736119],[-96.9009045,33.2736119],[-96.9007419,33.2733126],[-96.9007419,33.2733126]]]},"properties":{"lotName":"10-A-13","lotCpId":"8232251672819027263","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006076,33.2733637],[-96.9007419,33.2733126],[-96.9007419,33.2733126],[-96.9009045,33.2736119],[-96.9009045,33.2736119],[-96.9007702,33.273663],[-96.9007702,33.273663],[-96.9006076,33.2733637],[-96.9006076,33.2733637]]]},"properties":{"lotName":"10-A-14","lotCpId":"3836401672819028148","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004739,33.2734148],[-96.9006076,33.2733637],[-96.9006076,33.2733637],[-96.9007702,33.273663],[-96.9007702,33.273663],[-96.900636,33.2737136],[-96.900636,33.2737136],[-96.9004739,33.2734148],[-96.9004739,33.2734148]]]},"properties":{"lotName":"10-A-15","lotCpId":"8164011672819029048","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9003396,33.2734654],[-96.9004739,33.2734148],[-96.9004739,33.2734148],[-96.900636,33.2737136],[-96.900636,33.2737136],[-96.9005017,33.2737648],[-96.9005017,33.2737648],[-96.9003396,33.2734654],[-96.9003396,33.2734654]]]},"properties":{"lotName":"10-A-16","lotCpId":"7511351672819029963","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9001885,33.2735165],[-96.9001963,33.2735145],[-96.9002216,33.273507],[-96.9002665,33.2734921],[-96.9003336,33.2734677],[-96.9003396,33.2734654],[-96.9003396,33.2734654],[-96.9005017,33.2737648],[-96.9005017,33.2737648],[-96.9003374,33.2738273],[-96.9003374,33.2738273],[-96.9001885,33.2735165],[-96.9001885,33.2735165]]]},"properties":{"lotName":"10-A-17","lotCpId":"7820121672819030848","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9000553,33.2735503],[-96.9000656,33.2735483],[-96.9000938,33.2735422],[-96.9001885,33.2735165],[-96.9001885,33.2735165],[-96.9003374,33.2738273],[-96.9003374,33.2738273],[-96.9001623,33.2738934],[-96.9001623,33.2738934],[-96.9000553,33.2735503],[-96.9000553,33.2735503]]]},"properties":{"lotName":"10-A-18","lotCpId":"7217271672819031760","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999167,33.2735754],[-96.8999272,33.273574],[-96.8999562,33.2735697],[-96.9000553,33.2735503],[-96.9000553,33.2735503],[-96.9001623,33.2738934],[-96.9001623,33.2738934],[-96.8999865,33.2739117],[-96.8999865,33.2739117],[-96.8999167,33.2735754],[-96.8999167,33.2735754]]]},"properties":{"lotName":"10-A-19","lotCpId":"1032801672819032664","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997759,33.2735904],[-96.8997873,33.2735898],[-96.8998182,33.2735873],[-96.8999167,33.2735754],[-96.8999167,33.2735754],[-96.8999865,33.2739117],[-96.8999865,33.2739117],[-96.8998124,33.273929],[-96.8998124,33.273929],[-96.8997759,33.2735904],[-96.8997759,33.2735904]]]},"properties":{"lotName":"10-A-20","lotCpId":"8651501672819033564","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996345,33.2735964],[-96.8996436,33.2735966],[-96.8996706,33.2735965],[-96.8997149,33.2735949],[-96.8997759,33.2735904],[-96.8997759,33.2735904],[-96.8998124,33.273929],[-96.8998124,33.273929],[-96.8996361,33.2739258],[-96.8996361,33.2739258],[-96.8996345,33.2735964],[-96.8996345,33.2735964]]]},"properties":{"lotName":"10-A-21","lotCpId":"6888801672819034465","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8994888,33.2735941],[-96.8995816,33.2735959],[-96.8995991,33.273596],[-96.8996345,33.2735964],[-96.8996345,33.2735964],[-96.8996361,33.2739258],[-96.8996361,33.2739258],[-96.8994795,33.2739226],[-96.8994795,33.2739226],[-96.8994888,33.2735941],[-96.8994888,33.2735941]]]},"properties":{"lotName":"10-A-22","lotCpId":"1786001672819035370","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8993414,33.2735914],[-96.8994888,33.2735941],[-96.8994888,33.2735941],[-96.8994795,33.2739226],[-96.8994795,33.2739226],[-96.8993321,33.2739194],[-96.8993321,33.2739194],[-96.8993414,33.2735914],[-96.8993414,33.2735914]]]},"properties":{"lotName":"10-A-23","lotCpId":"6231351672819036267","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991941,33.2735882],[-96.8993414,33.2735914],[-96.8993414,33.2735914],[-96.8993321,33.2739194],[-96.8993321,33.2739194],[-96.8991848,33.2739167],[-96.8991848,33.2739167],[-96.8991941,33.2735882],[-96.8991941,33.2735882]]]},"properties":{"lotName":"10-A-24","lotCpId":"6810341672819037186","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990467,33.2735854],[-96.8991941,33.2735882],[-96.8991941,33.2735882],[-96.8991848,33.2739167],[-96.8991848,33.2739167],[-96.8990374,33.2739135],[-96.8990374,33.2739135],[-96.8990467,33.2735854],[-96.8990467,33.2735854]]]},"properties":{"lotName":"10-A-25","lotCpId":"4177501672819038073","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988993,33.2735822],[-96.8990467,33.2735854],[-96.8990467,33.2735854],[-96.8990374,33.2739135],[-96.8990374,33.2739135],[-96.8988901,33.2739108],[-96.8988901,33.2739108],[-96.8988993,33.2735822],[-96.8988993,33.2735822]]]},"properties":{"lotName":"10-A-26","lotCpId":"6708661672819038965","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898752,33.2735795],[-96.8988993,33.2735822],[-96.8988993,33.2735822],[-96.8988901,33.2739108],[-96.8988901,33.2739108],[-96.8987427,33.2739076],[-96.8987427,33.2739076],[-96.898752,33.2735795],[-96.898752,33.2735795]]]},"properties":{"lotName":"10-A-27","lotCpId":"5408261672819039850","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8986046,33.2735763],[-96.898752,33.2735795],[-96.898752,33.2735795],[-96.8987427,33.2739076],[-96.8987427,33.2739076],[-96.8985954,33.2739048],[-96.8985954,33.2739048],[-96.8986046,33.2735763],[-96.8986046,33.2735763]]]},"properties":{"lotName":"10-A-28","lotCpId":"1047521672819040751","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8984578,33.2735736],[-96.8986046,33.2735763],[-96.8986046,33.2735763],[-96.8985954,33.2739048],[-96.8985954,33.2739048],[-96.898448,33.2739021],[-96.898448,33.2739021],[-96.8984578,33.2735736],[-96.8984578,33.2735736]]]},"properties":{"lotName":"10-A-29","lotCpId":"2187501672819041643","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8983105,33.2735704],[-96.8984578,33.2735736],[-96.8984578,33.2735736],[-96.898448,33.2739021],[-96.898448,33.2739021],[-96.8983006,33.2738989],[-96.8983006,33.2738989],[-96.8983105,33.2735704],[-96.8983105,33.2735704]]]},"properties":{"lotName":"10-A-30","lotCpId":"5606641672819042569","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8981631,33.2735676],[-96.8983105,33.2735704],[-96.8983105,33.2735704],[-96.8983006,33.2738989],[-96.8983006,33.2738989],[-96.8981533,33.2738962],[-96.8981533,33.2738962],[-96.8981631,33.2735676],[-96.8981631,33.2735676]]]},"properties":{"lotName":"10-A-31","lotCpId":"3458271672819045474","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980158,33.2735644],[-96.8981631,33.2735676],[-96.8981631,33.2735676],[-96.8981533,33.2738962],[-96.8981533,33.2738962],[-96.8980059,33.273893],[-96.8980059,33.273893],[-96.8980158,33.2735644],[-96.8980158,33.2735644]]]},"properties":{"lotName":"10-A-32","lotCpId":"1007101672819046361","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991722,33.2721052],[-96.8991436,33.2719649],[-96.8991411,33.2719478],[-96.8991411,33.2719478],[-96.8991521,33.2719471],[-96.8991824,33.2719452],[-96.8992845,33.2719398],[-96.8994144,33.2719348],[-96.8995395,33.2719336],[-96.8995395,33.2719336],[-96.899563,33.2720509],[-96.899563,33.2720509],[-96.8991722,33.2721052],[-96.8991722,33.2721052]]]},"properties":{"lotName":"10-B-28","lotCpId":"3744081672819079809","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991979,33.272232],[-96.8991722,33.2721052],[-96.8991722,33.2721052],[-96.899563,33.2720509],[-96.899563,33.2720509],[-96.8995766,33.2721171],[-96.8995887,33.2721777],[-96.8995887,33.2721777],[-96.8991979,33.272232],[-96.8991979,33.272232]]]},"properties":{"lotName":"10-B-27","lotCpId":"8144701672819078905","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8992208,33.2723575],[-96.8992197,33.2723505],[-96.8992167,33.272332],[-96.8992066,33.2722763],[-96.8991979,33.272232],[-96.8991979,33.272232],[-96.8995887,33.2721777],[-96.8995887,33.2721777],[-96.8995996,33.2722389],[-96.8996138,33.2723155],[-96.8996138,33.2723155],[-96.8992208,33.2723575],[-96.8992208,33.2723575]]]},"properties":{"lotName":"10-B-26","lotCpId":"8887121672819078015","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8992355,33.2724826],[-96.8992343,33.2724695],[-96.899231,33.2724373],[-96.8992208,33.2723575],[-96.8992208,33.2723575],[-96.8996138,33.2723155],[-96.8996138,33.2723155],[-96.8996181,33.2723603],[-96.8996274,33.2724602],[-96.8996274,33.2724602],[-96.8992355,33.2724826],[-96.8992355,33.2724826]]]},"properties":{"lotName":"10-B-25","lotCpId":"1104671672819077107","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899241,33.2726076],[-96.8992407,33.2725935],[-96.8992397,33.2725595],[-96.8992355,33.2724826],[-96.8992355,33.2724826],[-96.8996274,33.2724602],[-96.8996274,33.2724602],[-96.8996285,33.272483],[-96.899634,33.2726048],[-96.899634,33.2726048],[-96.899241,33.2726076],[-96.899241,33.2726076]]]},"properties":{"lotName":"10-B-24","lotCpId":"7462721672819076165","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8992388,33.2727344],[-96.8992405,33.2726769],[-96.899241,33.2726524],[-96.899241,33.2726076],[-96.899241,33.2726076],[-96.899634,33.2726048],[-96.899634,33.2726048],[-96.899635,33.2727426],[-96.899635,33.2727426],[-96.8992388,33.2727344],[-96.8992388,33.2727344]]]},"properties":{"lotName":"10-B-23","lotCpId":"8205701672819075266","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899235,33.2728631],[-96.8992388,33.2727344],[-96.8992388,33.2727344],[-96.899635,33.2727426],[-96.899635,33.2727426],[-96.8996743,33.2727969],[-96.89973,33.2728731],[-96.89973,33.2728731],[-96.899235,33.2728631],[-96.899235,33.2728631]]]},"properties":{"lotName":"10-B-22","lotCpId":"6350671672819074364","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8992312,33.2729918],[-96.899235,33.2728631],[-96.899235,33.2728631],[-96.89973,33.2728731],[-96.89973,33.2728731],[-96.8998255,33.2730036],[-96.8998255,33.2730036],[-96.8997027,33.2730014],[-96.8992312,33.2729918],[-96.8992312,33.2729918]]]},"properties":{"lotName":"10-B-21","lotCpId":"8301201672819073468","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8992274,33.2731232],[-96.8992312,33.2729918],[-96.8992312,33.2729918],[-96.8997027,33.2730014],[-96.8997027,33.2730014],[-96.8997147,33.2731278],[-96.8997147,33.2731278],[-96.8995745,33.27313],[-96.8992274,33.2731232],[-96.8992274,33.2731232]]]},"properties":{"lotName":"10-B-20","lotCpId":"6232501672819072548","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8994146,33.2734558],[-96.8992508,33.2734522],[-96.8992508,33.2734522],[-96.8992192,33.2734244],[-96.8992274,33.2731232],[-96.8992274,33.2731232],[-96.8994238,33.2731273],[-96.8994238,33.2731273],[-96.8994146,33.2734558],[-96.8994146,33.2734558]]]},"properties":{"lotName":"10-B-19","lotCpId":"8168631672819071650","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8995652,33.2734586],[-96.8994146,33.2734558],[-96.8994146,33.2734558],[-96.8994238,33.2731273],[-96.8994238,33.2731273],[-96.8995745,33.27313],[-96.8995745,33.27313],[-96.8995652,33.2734586],[-96.8995652,33.2734586]]]},"properties":{"lotName":"10-B-18","lotCpId":"3718701672819070726","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997458,33.2734554],[-96.8997295,33.2734565],[-96.8996889,33.2734587],[-96.8995855,33.2734596],[-96.8995652,33.2734586],[-96.8995652,33.2734586],[-96.8995745,33.27313],[-96.8995745,33.27313],[-96.8997147,33.2731278],[-96.8997147,33.2731278],[-96.8997458,33.2734554],[-96.8997458,33.2734554]]]},"properties":{"lotName":"10-B-17","lotCpId":"2540581672819069825","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999287,33.2734339],[-96.8999143,33.2734366],[-96.899875,33.2734429],[-96.8998169,33.27345],[-96.8997458,33.2734554],[-96.8997458,33.2734554],[-96.8997027,33.2730014],[-96.8997027,33.2730014],[-96.8998255,33.2730036],[-96.8998255,33.2730036],[-96.8999287,33.2734339],[-96.8999287,33.2734339]]]},"properties":{"lotName":"10-B-16","lotCpId":"7011731672819068943","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9001071,33.2733947],[-96.9000927,33.2733988],[-96.9000537,33.2734089],[-96.8999287,33.2734339],[-96.8999287,33.2734339],[-96.8998255,33.2730036],[-96.8998255,33.2730036],[-96.89995,33.2729932],[-96.89995,33.2729932],[-96.9001071,33.2733947],[-96.9001071,33.2733947]]]},"properties":{"lotName":"10-B-15","lotCpId":"7503101672819068023","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900278,33.2733386],[-96.9002659,33.2733436],[-96.9002503,33.2733492],[-96.9002113,33.2733627],[-96.9001071,33.2733947],[-96.9001071,33.2733947],[-96.89995,33.2729932],[-96.89995,33.2729932],[-96.9000842,33.2729822],[-96.9000842,33.2729822],[-96.900278,33.2733386],[-96.900278,33.2733386]]]},"properties":{"lotName":"10-B-14","lotCpId":"6204021672819067124","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004122,33.2732875],[-96.900278,33.2733386],[-96.900278,33.2733386],[-96.9000842,33.2729822],[-96.9000842,33.2729822],[-96.9002387,33.272969],[-96.9002387,33.272969],[-96.9004122,33.2732875],[-96.9004122,33.2732875]]]},"properties":{"lotName":"10-B-13","lotCpId":"1385101672819066210","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005459,33.2732368],[-96.9004122,33.2732875],[-96.9004122,33.2732875],[-96.9002387,33.272969],[-96.9002387,33.272969],[-96.9003183,33.2729621],[-96.9003838,33.2729375],[-96.9003838,33.2729375],[-96.9005459,33.2732368],[-96.9005459,33.2732368]]]},"properties":{"lotName":"10-B-12","lotCpId":"7571671672819065310","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006802,33.2731857],[-96.9005459,33.2732368],[-96.9005459,33.2732368],[-96.9003838,33.2729375],[-96.9003838,33.2729375],[-96.9005181,33.2728868],[-96.9005181,33.2728868],[-96.9006802,33.2731857],[-96.9006802,33.2731857]]]},"properties":{"lotName":"10-B-11","lotCpId":"5218481672819064405","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008144,33.2731351],[-96.9006802,33.2731857],[-96.9006802,33.2731857],[-96.9005181,33.2728868],[-96.9005181,33.2728868],[-96.9006518,33.2728357],[-96.9006518,33.2728357],[-96.9008144,33.2731351],[-96.9008144,33.2731351]]]},"properties":{"lotName":"10-B-10","lotCpId":"3104861672819063506","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9009487,33.273084],[-96.9008144,33.2731351],[-96.9008144,33.2731351],[-96.9006518,33.2728357],[-96.9006518,33.2728357],[-96.9007861,33.2727846],[-96.9007861,33.2727846],[-96.9009487,33.273084],[-96.9009487,33.273084]]]},"properties":{"lotName":"10-B-9","lotCpId":"4018761672819062601","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.901083,33.2730329],[-96.9009487,33.273084],[-96.9009487,33.273084],[-96.9007861,33.2727846],[-96.9007861,33.2727846],[-96.9009203,33.272734],[-96.9009203,33.272734],[-96.901083,33.2730329],[-96.901083,33.2730329]]]},"properties":{"lotName":"10-B-8","lotCpId":"4144521672819061708","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9012172,33.2729822],[-96.901083,33.2730329],[-96.901083,33.2730329],[-96.9009203,33.272734],[-96.9009203,33.272734],[-96.9010546,33.2726829],[-96.9010546,33.2726829],[-96.9012172,33.2729822],[-96.9012172,33.2729822]]]},"properties":{"lotName":"10-B-7","lotCpId":"6361781672819060790","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013515,33.2729311],[-96.9012172,33.2729822],[-96.9012172,33.2729822],[-96.9010546,33.2726829],[-96.9010546,33.2726829],[-96.9011888,33.2726318],[-96.9011888,33.2726318],[-96.9013515,33.2729311],[-96.9013515,33.2729311]]]},"properties":{"lotName":"10-B-6","lotCpId":"8622001672819059868","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014852,33.2728804],[-96.9013515,33.2729311],[-96.9013515,33.2729311],[-96.9011888,33.2726318],[-96.9011888,33.2726318],[-96.9013231,33.2725811],[-96.9013231,33.2725811],[-96.9014852,33.2728804],[-96.9014852,33.2728804]]]},"properties":{"lotName":"10-B-5","lotCpId":"4088801672819058991","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9016195,33.2728293],[-96.9014852,33.2728804],[-96.9014852,33.2728804],[-96.9013231,33.2725811],[-96.9013231,33.2725811],[-96.9014574,33.27253],[-96.9014574,33.27253],[-96.9016195,33.2728293],[-96.9016195,33.2728293]]]},"properties":{"lotName":"10-B-4","lotCpId":"3568161672819058101","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017979,33.2727618],[-96.9016195,33.2728293],[-96.9016195,33.2728293],[-96.9014574,33.27253],[-96.9014574,33.27253],[-96.9015763,33.2724848],[-96.9017177,33.2724803],[-96.9017177,33.2724803],[-96.901718,33.2724871],[-96.9017194,33.2725061],[-96.901729,33.2725726],[-96.9017529,33.2726633],[-96.9017979,33.2727618],[-96.9017979,33.2727618]]]},"properties":{"lotName":"10-B-3","lotCpId":"2561881672819057201","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017242,33.2723552],[-96.9017226,33.2723675],[-96.9017192,33.2723984],[-96.9017177,33.2724803],[-96.9017177,33.2724803],[-96.9015763,33.2724848],[-96.9014574,33.27253],[-96.9013231,33.2725811],[-96.9013231,33.2725811],[-96.9013264,33.2723133],[-96.9013264,33.2723133],[-96.9017242,33.2723552],[-96.9017242,33.2723552]]]},"properties":{"lotName":"10-B-2","lotCpId":"1875301672819056315","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.901751,33.272238],[-96.9017365,33.2722932],[-96.901732,33.2723113],[-96.9017242,33.2723552],[-96.9017242,33.2723552],[-96.9013264,33.2723133],[-96.9013264,33.2723133],[-96.9013635,33.2721686],[-96.9013635,33.2721686],[-96.901751,33.272238],[-96.901751,33.272238]]]},"properties":{"lotName":"10-B-1","lotCpId":"4383201672819055407","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9009416,33.2722334],[-96.900976,33.2720993],[-96.900976,33.2720993],[-96.9013635,33.2721686],[-96.9013635,33.2721686],[-96.9013264,33.2723133],[-96.9013264,33.2723133],[-96.9009416,33.2722334],[-96.9009416,33.2722334]]]},"properties":{"lotName":"10-B-42","lotCpId":"8747001672819092582","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9009291,33.2723749],[-96.9009361,33.2723654],[-96.9009487,33.2723387],[-96.9009539,33.2722976],[-96.9009389,33.2722448],[-96.9009416,33.2722334],[-96.9009416,33.2722334],[-96.9013264,33.2723133],[-96.9013264,33.2723133],[-96.9013231,33.2725811],[-96.9013231,33.2725811],[-96.9009291,33.2723749],[-96.9009291,33.2723749]]]},"properties":{"lotName":"10-B-41","lotCpId":"6350181672819091693","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008232,33.272436],[-96.9008338,33.2724344],[-96.9008605,33.2724267],[-96.9008949,33.2724084],[-96.9009291,33.2723749],[-96.9009291,33.2723749],[-96.9013231,33.2725811],[-96.9013231,33.2725811],[-96.9009738,33.2727134],[-96.9009738,33.2727134],[-96.9008232,33.272436],[-96.9008232,33.272436]]]},"properties":{"lotName":"10-B-40","lotCpId":"4113121672819090785","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006704,33.272468],[-96.900755,33.272436],[-96.9007763,33.272439],[-96.9008232,33.272436],[-96.9008232,33.272436],[-96.9009738,33.2727134],[-96.9009738,33.2727134],[-96.900833,33.2727668],[-96.900833,33.2727668],[-96.9006704,33.272468],[-96.9006704,33.272468]]]},"properties":{"lotName":"10-B-39","lotCpId":"7287771672819089867","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900536,33.2725192],[-96.9006704,33.272468],[-96.9006704,33.272468],[-96.900833,33.2727668],[-96.900833,33.2727668],[-96.9006987,33.2728179],[-96.9006987,33.2728179],[-96.900536,33.2725192],[-96.900536,33.2725192]]]},"properties":{"lotName":"10-B-38","lotCpId":"4806281672819088949","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004046,33.2725588],[-96.9004153,33.2725563],[-96.9004442,33.272549],[-96.900536,33.2725192],[-96.900536,33.2725192],[-96.9006987,33.2728179],[-96.9006987,33.2728179],[-96.9005137,33.2728882],[-96.9005137,33.2728882],[-96.9004046,33.2725588],[-96.9004046,33.2725588]]]},"properties":{"lotName":"10-B-37","lotCpId":"1856471672819088017","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9002664,33.2725815],[-96.9002797,33.2725801],[-96.9003135,33.2725758],[-96.9004046,33.2725588],[-96.9004046,33.2725588],[-96.9005137,33.2728882],[-96.9005137,33.2728882],[-96.9003183,33.2729621],[-96.9003183,33.2729621],[-96.9002664,33.2725815],[-96.9002664,33.2725815]]]},"properties":{"lotName":"10-B-36","lotCpId":"1346851672819087097","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900129,33.2726117],[-96.9001413,33.2726134],[-96.9001734,33.2726138],[-96.9002176,33.2726056],[-96.9002664,33.2725815],[-96.9002664,33.2725815],[-96.9003183,33.2729621],[-96.9003183,33.2729621],[-96.9000433,33.2729854],[-96.9000433,33.2729854],[-96.900129,33.2726117],[-96.900129,33.2726117]]]},"properties":{"lotName":"10-B-35","lotCpId":"1316641672819086179","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9000313,33.272562],[-96.9000378,33.2725686],[-96.9000568,33.2725839],[-96.900129,33.2726117],[-96.900129,33.2726117],[-96.9000433,33.2729854],[-96.9000433,33.2729854],[-96.8998255,33.2730036],[-96.8996743,33.2727969],[-96.8996743,33.2727969],[-96.9000313,33.272562],[-96.9000313,33.272562]]]},"properties":{"lotName":"10-B-34","lotCpId":"8868521672819085258","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999969,33.2724648],[-96.899996,33.2724737],[-96.8999975,33.2724967],[-96.9000072,33.272528],[-96.9000313,33.272562],[-96.9000313,33.272562],[-96.8996743,33.2727969],[-96.8996743,33.2727969],[-96.899635,33.2727426],[-96.899634,33.2726048],[-96.8996285,33.272483],[-96.8996285,33.272483],[-96.8999969,33.2724648],[-96.8999969,33.2724648]]]},"properties":{"lotName":"10-B-33","lotCpId":"7688461672819084337","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9000138,33.2723242],[-96.9000225,33.2724022],[-96.9000101,33.2724219],[-96.8999969,33.2724648],[-96.8999969,33.2724648],[-96.8996285,33.272483],[-96.8996285,33.272483],[-96.8996274,33.2724602],[-96.8996181,33.2723603],[-96.8996181,33.2723603],[-96.9000138,33.2723242],[-96.9000138,33.2723242]]]},"properties":{"lotName":"10-B-32","lotCpId":"2642251672819083429","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999669,33.2720628],[-96.8999882,33.2721682],[-96.8999914,33.2721864],[-96.8999914,33.2721864],[-96.8995996,33.2722389],[-96.8995996,33.2722389],[-96.8995887,33.2721777],[-96.8995766,33.2721171],[-96.8995766,33.2721171],[-96.8999669,33.2720628],[-96.8999669,33.2720628]]]},"properties":{"lotName":"10-B-30","lotCpId":"2200061672819081644","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999445,33.2719491],[-96.8999669,33.2720628],[-96.8999669,33.2720628],[-96.8995766,33.2721171],[-96.8995766,33.2721171],[-96.8995395,33.2719336],[-96.8995395,33.2719336],[-96.899548,33.2719336],[-96.8995721,33.2719337],[-96.8996601,33.2719352],[-96.899789,33.2719397],[-96.8999445,33.2719491],[-96.8999445,33.2719491]]]},"properties":{"lotName":"10-B-29","lotCpId":"7521221672819080727","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9007244,33.2700614],[-96.9006917,33.2699231],[-96.9006917,33.2699231],[-96.9009836,33.2697976],[-96.9010704,33.2698154],[-96.9010704,33.2698154],[-96.901113,33.269998],[-96.901113,33.269998],[-96.9007244,33.2700614],[-96.9007244,33.2700614]]]},"properties":{"lotName":"10-F-1","lotCpId":"8805151672819128037","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9007571,33.2702015],[-96.9007244,33.2700614],[-96.9007244,33.2700614],[-96.901113,33.269998],[-96.901113,33.269998],[-96.9011457,33.2701376],[-96.9011457,33.2701376],[-96.9007571,33.2702015],[-96.9007571,33.2702015]]]},"properties":{"lotName":"10-F-2","lotCpId":"5520171672819128936","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900797,33.2703407],[-96.9007937,33.2703316],[-96.9007853,33.2703067],[-96.9007621,33.2702229],[-96.9007571,33.2702015],[-96.9007571,33.2702015],[-96.9011457,33.2701376],[-96.9011457,33.2701376],[-96.901197,33.2702001],[-96.9012145,33.2702722],[-96.9012145,33.2702722],[-96.900797,33.2703407],[-96.900797,33.2703407]]]},"properties":{"lotName":"10-F-3","lotCpId":"5045101672819129827","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008516,33.2704785],[-96.9008483,33.2704705],[-96.9008406,33.2704518],[-96.9008248,33.2704139],[-96.9008169,33.2703951],[-96.900797,33.2703407],[-96.900797,33.2703407],[-96.9012145,33.2702722],[-96.9012145,33.2702722],[-96.9012478,33.2704118],[-96.9012478,33.2704118],[-96.9008516,33.2704785],[-96.9008516,33.2704785]]]},"properties":{"lotName":"10-F-4","lotCpId":"8754031672819130732","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008929,33.2706173],[-96.9008897,33.2706041],[-96.9008808,33.2705705],[-96.9008516,33.2704785],[-96.9008516,33.2704785],[-96.9012478,33.2704118],[-96.9012478,33.2704118],[-96.9012816,33.2705515],[-96.9012816,33.2705515],[-96.9008929,33.2706173],[-96.9008929,33.2706173]]]},"properties":{"lotName":"10-F-5","lotCpId":"6804401672819131645","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9009263,33.2707536],[-96.9008929,33.2706173],[-96.9008929,33.2706173],[-96.9012816,33.2705515],[-96.9012816,33.2705515],[-96.9013149,33.2706884],[-96.9013149,33.2706884],[-96.9009263,33.2707536],[-96.9009263,33.2707536]]]},"properties":{"lotName":"10-F-6","lotCpId":"7877161672819132560","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9009596,33.2708905],[-96.9009263,33.2707536],[-96.9009263,33.2707536],[-96.9013149,33.2706884],[-96.9013149,33.2706884],[-96.9013477,33.2708253],[-96.9013477,33.2708253],[-96.9009596,33.2708905],[-96.9009596,33.2708905]]]},"properties":{"lotName":"10-F-7","lotCpId":"7203821672819133473","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9009924,33.2710274],[-96.9009596,33.2708905],[-96.9009596,33.2708905],[-96.9013477,33.2708253],[-96.9013477,33.2708253],[-96.901381,33.2709622],[-96.901381,33.2709622],[-96.9009924,33.2710274],[-96.9009924,33.2710274]]]},"properties":{"lotName":"10-F-8","lotCpId":"2537321672819134368","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010257,33.2711643],[-96.9009924,33.2710274],[-96.9009924,33.2710274],[-96.901381,33.2709622],[-96.901381,33.2709622],[-96.9014137,33.271099],[-96.9014137,33.271099],[-96.9010257,33.2711643],[-96.9010257,33.2711643]]]},"properties":{"lotName":"10-F-9","lotCpId":"5757771672819135269","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010573,33.2712998],[-96.9010468,33.2712539],[-96.9010257,33.2711643],[-96.9010257,33.2711643],[-96.9014137,33.271099],[-96.9014137,33.271099],[-96.9014492,33.2712446],[-96.9014492,33.2712446],[-96.9010573,33.2712998],[-96.9010573,33.2712998]]]},"properties":{"lotName":"10-F-10","lotCpId":"2237731672819136173","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.901077,33.2714385],[-96.901076,33.271426],[-96.9010727,33.2713934],[-96.9010573,33.2712998],[-96.9010573,33.2712998],[-96.9014492,33.2712446],[-96.9014492,33.2712446],[-96.9014721,33.2714157],[-96.9014721,33.2714157],[-96.901077,33.2714385],[-96.901077,33.2714385]]]},"properties":{"lotName":"10-F-11","lotCpId":"2310701672819137112","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010802,33.2715782],[-96.9010805,33.2715644],[-96.9010807,33.2715297],[-96.901077,33.2714385],[-96.901077,33.2714385],[-96.9014721,33.2714157],[-96.9014721,33.2714157],[-96.9014765,33.2715873],[-96.9014765,33.2715873],[-96.9010802,33.2715782],[-96.9010802,33.2715782]]]},"properties":{"lotName":"10-F-12","lotCpId":"5715671672819138025","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010677,33.2717173],[-96.9010696,33.2717029],[-96.9010738,33.2716673],[-96.9010802,33.2715782],[-96.9010802,33.2715782],[-96.9014765,33.2715873],[-96.9014765,33.2715873],[-96.9014606,33.2717589],[-96.9014606,33.2717589],[-96.9010677,33.2717173],[-96.9010677,33.2717173]]]},"properties":{"lotName":"10-F-13","lotCpId":"6140851672819138966","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010377,33.2718583],[-96.9010431,33.2718387],[-96.9010461,33.2718273],[-96.901053,33.271798],[-96.9010677,33.2717173],[-96.9010677,33.2717173],[-96.9014606,33.2717589],[-96.9014606,33.2717589],[-96.9014252,33.2719277],[-96.9014252,33.2719277],[-96.9010377,33.2718583],[-96.9010377,33.2718583]]]},"properties":{"lotName":"10-F-14","lotCpId":"7164601672819139883","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9009116,33.2716493],[-96.9009099,33.2716658],[-96.9009046,33.2717066],[-96.9008826,33.2718104],[-96.9008778,33.2718296],[-96.9008778,33.2718296],[-96.9004846,33.2717622],[-96.9004846,33.2717622],[-96.9004881,33.2716188],[-96.9004881,33.2716188],[-96.9009116,33.2716493],[-96.9009116,33.2716493]]]},"properties":{"lotName":"10-G-12","lotCpId":"7532541672819150779","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9009149,33.2714641],[-96.9009159,33.2714812],[-96.9009175,33.271525],[-96.9009116,33.2716493],[-96.9009116,33.2716493],[-96.9004881,33.2716188],[-96.9004881,33.2716188],[-96.9004911,33.2714999],[-96.9004886,33.2714842],[-96.9004886,33.2714842],[-96.9009149,33.2714641],[-96.9009149,33.2714641]]]},"properties":{"lotName":"10-G-11","lotCpId":"1387311672819149872","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008865,33.2712807],[-96.9008905,33.2712977],[-96.9008997,33.2713413],[-96.9009149,33.2714641],[-96.9009149,33.2714641],[-96.9004886,33.2714842],[-96.9004886,33.2714842],[-96.9004657,33.2713514],[-96.9004657,33.2713514],[-96.9008865,33.2712807],[-96.9008865,33.2712807]]]},"properties":{"lotName":"10-G-10","lotCpId":"4510681672819148971","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008472,33.2711191],[-96.9008865,33.2712807],[-96.9008865,33.2712807],[-96.9004657,33.2713514],[-96.9004657,33.2713514],[-96.9004613,33.2713263],[-96.9004373,33.271188],[-96.9004373,33.271188],[-96.9008472,33.2711191],[-96.9008472,33.2711191]]]},"properties":{"lotName":"10-G-9","lotCpId":"7777571672819148087","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008117,33.2709713],[-96.9008472,33.2711191],[-96.9008472,33.2711191],[-96.9004373,33.271188],[-96.9004373,33.271188],[-96.9004117,33.2710388],[-96.9004117,33.2710388],[-96.9008117,33.2709713],[-96.9008117,33.2709713]]]},"properties":{"lotName":"10-G-8","lotCpId":"1431211672819147167","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9007762,33.2708239],[-96.9008117,33.2709713],[-96.9008117,33.2709713],[-96.9004117,33.2710388],[-96.9004117,33.2710388],[-96.900398,33.2709603],[-96.9003811,33.2708905],[-96.9003811,33.2708905],[-96.9007762,33.2708239],[-96.9007762,33.2708239]]]},"properties":{"lotName":"10-G-7","lotCpId":"5202171672819146269","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005386,33.2699808],[-96.9005699,33.2701148],[-96.9005699,33.2701148],[-96.9001579,33.2701823],[-96.9001579,33.2701823],[-96.9001311,33.2700723],[-96.9001255,33.2700483],[-96.9001255,33.2700483],[-96.9005386,33.2699808],[-96.9005386,33.2699808]]]},"properties":{"lotName":"10-G-1","lotCpId":"3501741672819140814","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900601,33.2702493],[-96.9006041,33.2702622],[-96.900613,33.2702956],[-96.9006447,33.2703927],[-96.9006447,33.2703927],[-96.9002458,33.2704579],[-96.9002458,33.2704579],[-96.9002272,33.2704086],[-96.9001966,33.2703156],[-96.9001966,33.2703156],[-96.900601,33.2702493],[-96.900601,33.2702493]]]},"properties":{"lotName":"10-G-3","lotCpId":"1343501672819142613","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005699,33.2701148],[-96.900601,33.2702493],[-96.900601,33.2702493],[-96.9001966,33.2703156],[-96.9001966,33.2703156],[-96.9001721,33.2702416],[-96.9001579,33.2701823],[-96.9001579,33.2701823],[-96.9005699,33.2701148],[-96.9005699,33.2701148]]]},"properties":{"lotName":"10-G-2","lotCpId":"8701511672819141710","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9007408,33.270676],[-96.9007762,33.2708239],[-96.9007762,33.2708239],[-96.9003811,33.2708905],[-96.9003811,33.2708905],[-96.9003527,33.2707728],[-96.9003435,33.2707431],[-96.9003435,33.2707431],[-96.9007408,33.270676],[-96.9007408,33.270676]]]},"properties":{"lotName":"10-G-6","lotCpId":"1502431672819145347","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006998,33.2705328],[-96.9007036,33.2705442],[-96.9007125,33.2705727],[-96.9007324,33.2706444],[-96.9007408,33.270676],[-96.9007408,33.270676],[-96.9003435,33.2707431],[-96.9003435,33.2707431],[-96.9002992,33.2706003],[-96.9002992,33.2706003],[-96.9006998,33.2705328],[-96.9006998,33.2705328]]]},"properties":{"lotName":"10-G-5","lotCpId":"3413061672819144434","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006447,33.2703927],[-96.9006531,33.2704152],[-96.9006709,33.2704604],[-96.9006746,33.2704691],[-96.9006832,33.2704896],[-96.9006998,33.2705328],[-96.9006998,33.2705328],[-96.9002992,33.2706003],[-96.9002992,33.2706003],[-96.9002949,33.2705875],[-96.9002458,33.2704579],[-96.9002458,33.2704579],[-96.9006447,33.2703927],[-96.9006447,33.2703927]]]},"properties":{"lotName":"10-G-4","lotCpId":"3275661672819143527","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9104515,33.2593531],[-96.9104312,33.2593449],[-96.9103826,33.2593255],[-96.9103237,33.259303],[-96.9102724,33.2592851],[-96.9102724,33.2592851],[-96.9104089,33.2589958],[-96.9104089,33.2589958],[-96.9106485,33.2590377],[-96.9106485,33.2590377],[-96.9104515,33.2593531],[-96.9104515,33.2593531]]]},"properties":{"lotName":"9-A-21","lotCpId":"3245771610357575610","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9105928,33.259422],[-96.9105759,33.2594133],[-96.9105358,33.2593931],[-96.910489,33.2593701],[-96.9104515,33.2593531],[-96.9104515,33.2593531],[-96.9106485,33.2590377],[-96.9106485,33.2590377],[-96.9108411,33.2590359],[-96.9108619,33.2590711],[-96.9108619,33.2590711],[-96.9105928,33.259422],[-96.9105928,33.259422]]]},"properties":{"lotName":"9-A-22","lotCpId":"6071551610357575165","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9107303,33.2595019],[-96.910673,33.2594672],[-96.9106498,33.2594532],[-96.9105928,33.259422],[-96.9105928,33.259422],[-96.9108619,33.2590711],[-96.9108619,33.2590711],[-96.9110251,33.2593513],[-96.9110251,33.2593513],[-96.9110021,33.2593604],[-96.9109433,33.259388],[-96.9108638,33.259434],[-96.910779,33.2594986],[-96.9107303,33.2595019],[-96.9107303,33.2595019]]]},"properties":{"lotName":"9-A-23","lotCpId":"7680701610357575169","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9111779,33.2593024],[-96.9111625,33.2593064],[-96.9111242,33.2593171],[-96.9110251,33.2593513],[-96.9110251,33.2593513],[-96.9108619,33.2590711],[-96.9108411,33.2590359],[-96.9108411,33.2590359],[-96.9110725,33.2589857],[-96.9110725,33.2589857],[-96.9111779,33.2593024],[-96.9111779,33.2593024]]]},"properties":{"lotName":"9-A-24","lotCpId":"1781861610357575685","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9113367,33.2592682],[-96.9111932,33.2592992],[-96.9111779,33.2593024],[-96.9111779,33.2593024],[-96.9110725,33.2589857],[-96.9110725,33.2589857],[-96.9112379,33.2589501],[-96.9112379,33.2589501],[-96.9113367,33.2592682],[-96.9113367,33.2592682]]]},"properties":{"lotName":"9-A-25","lotCpId":"1537701610357575163","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.911495,33.2592335],[-96.9113367,33.2592682],[-96.9113367,33.2592682],[-96.9112379,33.2589501],[-96.9112379,33.2589501],[-96.9113962,33.2589154],[-96.9113962,33.2589154],[-96.911495,33.2592335],[-96.911495,33.2592335]]]},"properties":{"lotName":"9-A-26","lotCpId":"8522661610357575757","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9116532,33.2591993],[-96.911495,33.2592335],[-96.911495,33.2592335],[-96.9113962,33.2589154],[-96.9113962,33.2589154],[-96.911555,33.2588812],[-96.911555,33.2588812],[-96.9116532,33.2591993],[-96.9116532,33.2591993]]]},"properties":{"lotName":"9-A-27","lotCpId":"7184341610357575160","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9118121,33.2591651],[-96.9116532,33.2591993],[-96.9116532,33.2591993],[-96.911555,33.2588812],[-96.911555,33.2588812],[-96.9117133,33.258847],[-96.9117133,33.258847],[-96.9118121,33.2591651],[-96.9118121,33.2591651]]]},"properties":{"lotName":"9-A-28","lotCpId":"1337211610357575907","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997173,33.258502],[-96.8997135,33.2586252],[-96.8997135,33.2586252],[-96.8996802,33.2586517],[-96.89932,33.2586443],[-96.89932,33.2586443],[-96.8993244,33.2584942],[-96.8993244,33.2584942],[-96.8997173,33.258502],[-96.8997173,33.258502]]]},"properties":{"lotName":"4-D-24","lotCpId":"5732551615533281568","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997211,33.2583787],[-96.8997173,33.258502],[-96.8997173,33.258502],[-96.8993244,33.2584942],[-96.8993244,33.2584942],[-96.8993282,33.258371],[-96.8993282,33.258371],[-96.8997211,33.2583787],[-96.8997211,33.2583787]]]},"properties":{"lotName":"4-D-23","lotCpId":"5703811615533295087","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997244,33.2582555],[-96.8997211,33.2583787],[-96.8997211,33.2583787],[-96.8993282,33.258371],[-96.8993282,33.258371],[-96.8993314,33.2582478],[-96.8993314,33.2582478],[-96.8997244,33.2582555],[-96.8997244,33.2582555]]]},"properties":{"lotName":"4-D-22","lotCpId":"1358481615533297069","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997282,33.2581323],[-96.8997244,33.2582555],[-96.8997244,33.2582555],[-96.8993314,33.2582478],[-96.8993314,33.2582478],[-96.8993353,33.2581245],[-96.8993353,33.2581245],[-96.8997282,33.2581323],[-96.8997282,33.2581323]]]},"properties":{"lotName":"4-D-21","lotCpId":"6816311615533300337","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899732,33.2580091],[-96.8997282,33.2581323],[-96.8997282,33.2581323],[-96.8993353,33.2581245],[-96.8993353,33.2581245],[-96.8993391,33.2580013],[-96.8993391,33.2580013],[-96.899732,33.2580091],[-96.899732,33.2580091]]]},"properties":{"lotName":"4-D-20","lotCpId":"4748831615533275669","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997179,33.2578717],[-96.8997199,33.2578823],[-96.8997246,33.2579087],[-96.899732,33.2579753],[-96.899732,33.2580091],[-96.899732,33.2580091],[-96.8993391,33.2580013],[-96.8993391,33.2580013],[-96.8993431,33.2578644],[-96.8993431,33.2578644],[-96.8997179,33.2578717],[-96.8997179,33.2578717]]]},"properties":{"lotName":"4-D-19","lotCpId":"2860421615533223270","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998756,33.2576421],[-96.8998726,33.2576329],[-96.8998614,33.2576096],[-96.8998386,33.2575794],[-96.8998008,33.257549],[-96.8998008,33.257549],[-96.899839,33.2575048],[-96.9003035,33.2575144],[-96.9003035,33.2575144],[-96.9002996,33.2576508],[-96.9002996,33.2576508],[-96.8998756,33.2576421],[-96.8998756,33.2576421]]]},"properties":{"lotName":"4-D-18","lotCpId":"7765701615533230169","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998536,33.2577654],[-96.8998603,33.2577564],[-96.8998734,33.257731],[-96.899882,33.257692],[-96.8998756,33.2576421],[-96.8998756,33.2576421],[-96.9002996,33.2576508],[-96.9002996,33.2576508],[-96.9002958,33.257774],[-96.9002958,33.257774],[-96.8998536,33.2577654],[-96.8998536,33.2577654]]]},"properties":{"lotName":"4-D-17","lotCpId":"5215241615533297710","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899887,33.257889],[-96.8998834,33.2578686],[-96.8998756,33.2578343],[-96.8998729,33.2578255],[-96.8998667,33.2578052],[-96.8998536,33.2577654],[-96.8998536,33.2577654],[-96.9002958,33.257774],[-96.9002958,33.257774],[-96.900292,33.2578973],[-96.900292,33.2578973],[-96.899887,33.257889],[-96.899887,33.257889]]]},"properties":{"lotName":"4-D-16","lotCpId":"5415601615533298349","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998958,33.2580127],[-96.8998958,33.2580003],[-96.8998951,33.2579693],[-96.899887,33.257889],[-96.899887,33.257889],[-96.900292,33.2578973],[-96.900292,33.2578973],[-96.9002887,33.2580205],[-96.9002887,33.2580205],[-96.8998958,33.2580127],[-96.8998958,33.2580127]]]},"properties":{"lotName":"4-D-15","lotCpId":"3527331615533296394","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899892,33.2581355],[-96.8998958,33.2580127],[-96.8998958,33.2580127],[-96.9002887,33.2580205],[-96.9002887,33.2580205],[-96.9002849,33.2581437],[-96.9002849,33.2581437],[-96.899892,33.2581355],[-96.899892,33.2581355]]]},"properties":{"lotName":"4-D-14","lotCpId":"6312051615533237346","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998881,33.2582587],[-96.899892,33.2581355],[-96.899892,33.2581355],[-96.9002849,33.2581437],[-96.9002849,33.2581437],[-96.9002811,33.2582669],[-96.9002811,33.2582669],[-96.8998881,33.2582587],[-96.8998881,33.2582587]]]},"properties":{"lotName":"4-D-13","lotCpId":"8653851615533299640","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998849,33.2583819],[-96.8998881,33.2582587],[-96.8998881,33.2582587],[-96.9002811,33.2582669],[-96.9002811,33.2582669],[-96.9002778,33.2583901],[-96.9002778,33.2583901],[-96.8998849,33.2583819],[-96.8998849,33.2583819]]]},"properties":{"lotName":"4-D-12","lotCpId":"4371831615533225533","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899881,33.2585052],[-96.8998849,33.2583819],[-96.8998849,33.2583819],[-96.9002778,33.2583901],[-96.9002778,33.2583901],[-96.900274,33.2585134],[-96.900274,33.2585134],[-96.899881,33.2585052],[-96.899881,33.2585052]]]},"properties":{"lotName":"4-D-11","lotCpId":"4336451615533232789","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998772,33.2586284],[-96.899881,33.2585052],[-96.899881,33.2585052],[-96.900274,33.2585134],[-96.900274,33.2585134],[-96.9002696,33.258664],[-96.9002696,33.258664],[-96.8999094,33.2586567],[-96.8998772,33.2586284],[-96.8998772,33.2586284]]]},"properties":{"lotName":"4-D-10","lotCpId":"4216211615533337071","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006669,33.2585216],[-96.9006631,33.2586448],[-96.9006631,33.2586448],[-96.9006271,33.2586713],[-96.9002696,33.258664],[-96.9002696,33.258664],[-96.900274,33.2585134],[-96.900274,33.2585134],[-96.9006669,33.2585216],[-96.9006669,33.2585216]]]},"properties":{"lotName":"4-D-9","lotCpId":"8553631615533230822","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006702,33.2583984],[-96.9006669,33.2585216],[-96.9006669,33.2585216],[-96.900274,33.2585134],[-96.900274,33.2585134],[-96.9002778,33.2583901],[-96.9002778,33.2583901],[-96.9006702,33.2583984],[-96.9006702,33.2583984]]]},"properties":{"lotName":"4-D-8","lotCpId":"4325551615533232129","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900674,33.2582751],[-96.9006702,33.2583984],[-96.9006702,33.2583984],[-96.9002778,33.2583901],[-96.9002778,33.2583901],[-96.9002811,33.2582669],[-96.9002811,33.2582669],[-96.900674,33.2582751],[-96.900674,33.2582751]]]},"properties":{"lotName":"4-D-7","lotCpId":"5374271615533276968","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006779,33.2581519],[-96.900674,33.2582751],[-96.900674,33.2582751],[-96.9002811,33.2582669],[-96.9002811,33.2582669],[-96.9002849,33.2581437],[-96.9002849,33.2581437],[-96.9006779,33.2581519],[-96.9006779,33.2581519]]]},"properties":{"lotName":"4-D-6","lotCpId":"6874521615533217970","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006817,33.2580287],[-96.9006779,33.2581519],[-96.9006779,33.2581519],[-96.9002849,33.2581437],[-96.9002849,33.2581437],[-96.9002887,33.2580205],[-96.9002887,33.2580205],[-96.9006817,33.2580287],[-96.9006817,33.2580287]]]},"properties":{"lotName":"4-D-5","lotCpId":"2542481615533236051","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900685,33.2579055],[-96.9006817,33.2580287],[-96.9006817,33.2580287],[-96.9002887,33.2580205],[-96.9002887,33.2580205],[-96.900292,33.2578973],[-96.900292,33.2578973],[-96.900685,33.2579055],[-96.900685,33.2579055]]]},"properties":{"lotName":"4-D-4","lotCpId":"3212301615533218633","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006888,33.2577823],[-96.900685,33.2579055],[-96.900685,33.2579055],[-96.900292,33.2578973],[-96.900292,33.2578973],[-96.9002958,33.257774],[-96.9002958,33.257774],[-96.9006888,33.2577823],[-96.9006888,33.2577823]]]},"properties":{"lotName":"4-D-3","lotCpId":"1705601615533226831","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006926,33.257659],[-96.9006888,33.2577823],[-96.9006888,33.2577823],[-96.9002958,33.257774],[-96.9002958,33.257774],[-96.9002996,33.2576508],[-96.9002996,33.2576508],[-96.9006926,33.257659],[-96.9006926,33.257659]]]},"properties":{"lotName":"4-D-2","lotCpId":"7806261615533219282","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006964,33.2575221],[-96.9006926,33.257659],[-96.9006926,33.257659],[-96.9002996,33.2576508],[-96.9002996,33.2576508],[-96.9003035,33.2575144],[-96.9003035,33.2575144],[-96.9006964,33.2575221],[-96.9006964,33.2575221]]]},"properties":{"lotName":"4-D-1","lotCpId":"6250181615533220667","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9011439,33.2602115],[-96.9012995,33.2601759],[-96.9012995,33.2601759],[-96.9014032,33.2604931],[-96.9014032,33.2604931],[-96.9012345,33.2605269],[-96.9012345,33.2605269],[-96.9012247,33.2604744],[-96.9012225,33.2604651],[-96.9012165,33.260441],[-96.9011963,33.2603712],[-96.9011439,33.2602115],[-96.9011439,33.2602115]]]},"properties":{"lotName":"4-B-47","lotCpId":"3182851615533234090","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9019391,33.2600938],[-96.9020859,33.2600833],[-96.9020859,33.2600833],[-96.9021192,33.2604109],[-96.9021192,33.2604109],[-96.9019724,33.2604214],[-96.9019724,33.2604214],[-96.9019391,33.2600938],[-96.9019391,33.2600938]]]},"properties":{"lotName":"4-B-42","lotCpId":"7116571615533224208","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017923,33.2601043],[-96.9019391,33.2600938],[-96.9019391,33.2600938],[-96.9019724,33.2604214],[-96.9019724,33.2604214],[-96.9018256,33.2604315],[-96.9018256,33.2604315],[-96.9017923,33.2601043],[-96.9017923,33.2601043]]]},"properties":{"lotName":"4-B-43","lotCpId":"7053501615533228829","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9016269,33.2601193],[-96.9016428,33.2601177],[-96.9016813,33.2601137],[-96.901771,33.2601056],[-96.9017923,33.2601043],[-96.9017923,33.2601043],[-96.9018256,33.2604315],[-96.9018256,33.2604315],[-96.9016821,33.2604447],[-96.9016821,33.2604447],[-96.9016269,33.2601193],[-96.9016269,33.2601193]]]},"properties":{"lotName":"4-B-44","lotCpId":"8668231615533284211","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014621,33.2601435],[-96.9014788,33.2601407],[-96.9015204,33.260134],[-96.9016269,33.2601193],[-96.9016269,33.2601193],[-96.9016821,33.2604447],[-96.9016821,33.2604447],[-96.9015418,33.2604653],[-96.9015418,33.2604653],[-96.9014621,33.2601435],[-96.9014621,33.2601435]]]},"properties":{"lotName":"4-B-45","lotCpId":"4011231615533235391","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9012995,33.2601759],[-96.9013156,33.2601724],[-96.9013561,33.2601637],[-96.9014621,33.2601435],[-96.9014621,33.2601435],[-96.9015418,33.2604653],[-96.9015418,33.2604653],[-96.9014032,33.2604931],[-96.9014032,33.2604931],[-96.9012995,33.2601759],[-96.9012995,33.2601759]]]},"properties":{"lotName":"4-B-46","lotCpId":"3211741615533276311","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018087,33.2599655],[-96.9017568,33.2599692],[-96.9016668,33.2599769],[-96.9016668,33.2599769],[-96.9016291,33.2599532],[-96.9015724,33.2596566],[-96.9015724,33.2596566],[-96.9015762,33.2596525],[-96.9017754,33.2596383],[-96.9017754,33.2596383],[-96.9018087,33.2599655],[-96.9018087,33.2599655]]]},"properties":{"lotName":"4-B-37","lotCpId":"6725751615533196457","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9019555,33.2599555],[-96.9018087,33.2599655],[-96.9018087,33.2599655],[-96.9017754,33.2596383],[-96.9017754,33.2596383],[-96.9019222,33.2596278],[-96.9019222,33.2596278],[-96.9019555,33.2599555],[-96.9019555,33.2599555]]]},"properties":{"lotName":"4-B-38","lotCpId":"8885671615533227492","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9021023,33.259945],[-96.9019555,33.2599555],[-96.9019555,33.2599555],[-96.9019222,33.2596278],[-96.9019222,33.2596278],[-96.902069,33.2596173],[-96.902069,33.2596173],[-96.9021023,33.259945],[-96.9021023,33.259945]]]},"properties":{"lotName":"4-B-39","lotCpId":"8262831615533233428","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9022491,33.2599345],[-96.9021023,33.259945],[-96.9021023,33.259945],[-96.902069,33.2596173],[-96.902069,33.2596173],[-96.9022158,33.2596068],[-96.9022158,33.2596068],[-96.9022491,33.2599345],[-96.9022491,33.2599345]]]},"properties":{"lotName":"4-B-40","lotCpId":"1813811615533231493","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9023981,33.2599459],[-96.9023722,33.2599374],[-96.9022988,33.2599309],[-96.9022491,33.2599345],[-96.9022491,33.2599345],[-96.9022158,33.2596068],[-96.9022158,33.2596068],[-96.9023626,33.2595968],[-96.9023626,33.2595968],[-96.9023981,33.2599459],[-96.9023981,33.2599459]]]},"properties":{"lotName":"4-B-41","lotCpId":"8282371615533213252","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900966,33.2596698],[-96.9009432,33.2596],[-96.9009284,33.2595502],[-96.9009284,33.2595502],[-96.9013745,33.2594909],[-96.9013745,33.2594909],[-96.9013977,33.2596123],[-96.9013977,33.2596123],[-96.900966,33.2596698],[-96.900966,33.2596698]]]},"properties":{"lotName":"4-B-33","lotCpId":"6504061615533199297","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9011008,33.2600796],[-96.9010446,33.2599089],[-96.9010446,33.2599089],[-96.9014447,33.2598556],[-96.9014447,33.2598556],[-96.9014676,33.2599751],[-96.9014676,33.2599751],[-96.9014403,33.2600071],[-96.9014201,33.2600109],[-96.9013712,33.2600202],[-96.9012558,33.260044],[-96.9011008,33.2600796],[-96.9011008,33.2600796]]]},"properties":{"lotName":"4-B-36","lotCpId":"5843801615533197279","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010446,33.2599089],[-96.9010053,33.2597894],[-96.9010053,33.2597894],[-96.9014212,33.2597337],[-96.9014212,33.2597337],[-96.9014447,33.2598556],[-96.9014447,33.2598556],[-96.9010446,33.2599089],[-96.9010446,33.2599089]]]},"properties":{"lotName":"4-B-35","lotCpId":"8304851615533209968","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010053,33.2597894],[-96.900966,33.2596698],[-96.900966,33.2596698],[-96.9013977,33.2596123],[-96.9013977,33.2596123],[-96.9014212,33.2597337],[-96.9014212,33.2597337],[-96.9010053,33.2597894],[-96.9010053,33.2597894]]]},"properties":{"lotName":"4-B-34","lotCpId":"5443201615533200507","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.901598,33.2578836],[-96.9014507,33.2578804],[-96.9014507,33.2578804],[-96.9014605,33.2575381],[-96.9014605,33.2575381],[-96.9016078,33.2575413],[-96.9016078,33.2575413],[-96.901598,33.2578836],[-96.901598,33.2578836]]]},"properties":{"lotName":"4-C-7","lotCpId":"6440501615533194366","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017454,33.2578863],[-96.901598,33.2578836],[-96.901598,33.2578836],[-96.9016078,33.2575413],[-96.9016078,33.2575413],[-96.9017552,33.2575445],[-96.9017552,33.2575445],[-96.9017454,33.2578863],[-96.9017454,33.2578863]]]},"properties":{"lotName":"4-C-6","lotCpId":"6175071615533238012","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018927,33.2578895],[-96.9017454,33.2578863],[-96.9017454,33.2578863],[-96.9017552,33.2575445],[-96.9017552,33.2575445],[-96.9019026,33.2575472],[-96.9019026,33.2575472],[-96.9018927,33.2578895],[-96.9018927,33.2578895]]]},"properties":{"lotName":"4-C-5","lotCpId":"8535751615533210629","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9020401,33.2578927],[-96.9018927,33.2578895],[-96.9018927,33.2578895],[-96.9019026,33.2575472],[-96.9019026,33.2575472],[-96.9020499,33.2575504],[-96.9020499,33.2575504],[-96.9020401,33.2578927],[-96.9020401,33.2578927]]]},"properties":{"lotName":"4-C-4","lotCpId":"8075201615533280249","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9021874,33.2578954],[-96.9020401,33.2578927],[-96.9020401,33.2578927],[-96.9020499,33.2575504],[-96.9020499,33.2575504],[-96.9021973,33.2575536],[-96.9021973,33.2575536],[-96.9021874,33.2578954],[-96.9021874,33.2578954]]]},"properties":{"lotName":"4-C-3","lotCpId":"7022161615533209328","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9023343,33.2578986],[-96.9021874,33.2578954],[-96.9021874,33.2578954],[-96.9021973,33.2575536],[-96.9021973,33.2575536],[-96.9023446,33.2575563],[-96.9023446,33.2575563],[-96.9023343,33.2578986],[-96.9023343,33.2578986]]]},"properties":{"lotName":"4-C-2","lotCpId":"5304061615533216587","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9024816,33.2579018],[-96.9023343,33.2578986],[-96.9023343,33.2578986],[-96.9023446,33.2575563],[-96.9023446,33.2575563],[-96.9025247,33.25756],[-96.9025247,33.25756],[-96.9025155,33.2578749],[-96.9024816,33.2579018],[-96.9024816,33.2579018]]]},"properties":{"lotName":"4-C-1","lotCpId":"3204051615533196869","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9019631,33.2581784],[-96.9019593,33.2583016],[-96.9019593,33.2583016],[-96.9015664,33.2582939],[-96.9015664,33.2582939],[-96.9015702,33.2581706],[-96.9015702,33.2581706],[-96.9019631,33.2581784],[-96.9019631,33.2581784]]]},"properties":{"lotName":"4-B-29","lotCpId":"4671461615533193962","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9019664,33.2580552],[-96.9019631,33.2581784],[-96.9019631,33.2581784],[-96.9015702,33.2581706],[-96.9015702,33.2581706],[-96.9015746,33.25802],[-96.9015746,33.25802],[-96.9019348,33.2580273],[-96.9019664,33.2580552],[-96.9019664,33.2580552]]]},"properties":{"lotName":"4-B-30","lotCpId":"1881151615533195169","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9021269,33.258182],[-96.9021301,33.2580588],[-96.902164,33.2580319],[-96.902164,33.2580319],[-96.9025242,33.2580397],[-96.9025242,33.2580397],[-96.9025198,33.2581903],[-96.9025198,33.2581903],[-96.9021269,33.258182],[-96.9021269,33.258182]]]},"properties":{"lotName":"4-B-24","lotCpId":"3856181615533278273","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.902123,33.2583053],[-96.9021269,33.258182],[-96.9021269,33.258182],[-96.9025198,33.2581903],[-96.9025198,33.2581903],[-96.902516,33.2583135],[-96.902516,33.2583135],[-96.902123,33.2583053],[-96.902123,33.2583053]]]},"properties":{"lotName":"4-B-25","lotCpId":"8653421615533293749","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9021192,33.2584285],[-96.902123,33.2583053],[-96.902123,33.2583053],[-96.902516,33.2583135],[-96.902516,33.2583135],[-96.9025122,33.2584367],[-96.9025122,33.2584367],[-96.9021192,33.2584285],[-96.9021192,33.2584285]]]},"properties":{"lotName":"4-B-26","lotCpId":"2077771615533200106","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9021039,33.2585512],[-96.9021109,33.2585347],[-96.9021181,33.2584957],[-96.9021192,33.2584285],[-96.9021192,33.2584285],[-96.9025122,33.2584367],[-96.9025122,33.2584367],[-96.9025089,33.2585595],[-96.9025089,33.2585595],[-96.9021039,33.2585512],[-96.9021039,33.2585512]]]},"properties":{"lotName":"4-B-27","lotCpId":"7228371615533195993","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.902898,33.2586909],[-96.9028964,33.2587457],[-96.9028968,33.2587605],[-96.9029002,33.2588141],[-96.9029002,33.2588141],[-96.9025013,33.2588059],[-96.9025013,33.2588059],[-96.9025051,33.2586827],[-96.9025051,33.2586827],[-96.902898,33.2586909],[-96.902898,33.2586909]]]},"properties":{"lotName":"4-B-18","lotCpId":"8430751615533277618","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.902051,33.2586138],[-96.9020727,33.2585972],[-96.9021039,33.2585512],[-96.9021039,33.2585512],[-96.9025089,33.2585595],[-96.9025089,33.2585595],[-96.9025013,33.2588059],[-96.9025013,33.2588059],[-96.9020963,33.2586576],[-96.902051,33.2586138],[-96.902051,33.2586138]]]},"properties":{"lotName":"4-B-28","lotCpId":"3045511615533282888","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9029013,33.2585677],[-96.902898,33.2586909],[-96.902898,33.2586909],[-96.9025051,33.2586827],[-96.9025051,33.2586827],[-96.9025089,33.2585595],[-96.9025089,33.2585595],[-96.9029013,33.2585677],[-96.9029013,33.2585677]]]},"properties":{"lotName":"4-B-19","lotCpId":"4770001615533279608","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9029051,33.2584445],[-96.9029013,33.2585677],[-96.9029013,33.2585677],[-96.9025089,33.2585595],[-96.9025089,33.2585595],[-96.9025122,33.2584367],[-96.9025122,33.2584367],[-96.9029051,33.2584445],[-96.9029051,33.2584445]]]},"properties":{"lotName":"4-B-20","lotCpId":"4684731615533283548","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.902909,33.2583212],[-96.9029051,33.2584445],[-96.9029051,33.2584445],[-96.9025122,33.2584367],[-96.9025122,33.2584367],[-96.902516,33.2583135],[-96.902516,33.2583135],[-96.902909,33.2583212],[-96.902909,33.2583212]]]},"properties":{"lotName":"4-B-21","lotCpId":"1132551615533301008","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9029122,33.2581985],[-96.902909,33.2583212],[-96.902909,33.2583212],[-96.902516,33.2583135],[-96.902516,33.2583135],[-96.9025198,33.2581903],[-96.9025198,33.2581903],[-96.9029122,33.2581985],[-96.9029122,33.2581985]]]},"properties":{"lotName":"4-B-22","lotCpId":"8237141615533292471","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.902916,33.2580753],[-96.9029122,33.2581985],[-96.9029122,33.2581985],[-96.9025198,33.2581903],[-96.9025198,33.2581903],[-96.9025242,33.2580397],[-96.9025242,33.2580397],[-96.9028844,33.258047],[-96.902916,33.2580753],[-96.902916,33.2580753]]]},"properties":{"lotName":"4-B-23","lotCpId":"5003701615533211271","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9028582,33.2579096],[-96.9027108,33.2579064],[-96.9027108,33.2579064],[-96.9026792,33.2578786],[-96.9026885,33.2575637],[-96.9026885,33.2575637],[-96.9028691,33.2575673],[-96.9028691,33.2575673],[-96.9028582,33.2579096],[-96.9028582,33.2579096]]]},"properties":{"lotName":"4-A-75","lotCpId":"2313301615533194768","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9029903,33.2579155],[-96.9029789,33.2579136],[-96.9029537,33.2579114],[-96.9028582,33.2579096],[-96.9028582,33.2579096],[-96.9028691,33.2575673],[-96.9028691,33.2575673],[-96.9030951,33.2575719],[-96.9030951,33.2575719],[-96.9029903,33.2579155],[-96.9029903,33.2579155]]]},"properties":{"lotName":"4-A-74","lotCpId":"7136571615533298991","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9030781,33.2579639],[-96.9030725,33.2579579],[-96.9030557,33.257944],[-96.9029903,33.2579155],[-96.9029903,33.2579155],[-96.9030951,33.2575719],[-96.9030951,33.2575719],[-96.9034711,33.2575796],[-96.9034711,33.2575796],[-96.9034673,33.2577074],[-96.9030781,33.2579639],[-96.9030781,33.2579639]]]},"properties":{"lotName":"4-A-73","lotCpId":"8043401615533282232","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9031136,33.258052],[-96.9031141,33.2580444],[-96.903112,33.2580243],[-96.9031019,33.2579961],[-96.9030781,33.2579639],[-96.9030781,33.2579639],[-96.9034673,33.2577074],[-96.9034673,33.2577074],[-96.903458,33.2580209],[-96.903458,33.2580209],[-96.9031136,33.258052],[-96.9031136,33.258052]]]},"properties":{"lotName":"4-A-72","lotCpId":"2801811615533293109","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9030771,33.258167],[-96.9030789,33.2581335],[-96.9030847,33.2581272],[-96.9030973,33.2581099],[-96.9031136,33.258052],[-96.9031136,33.258052],[-96.903458,33.2580209],[-96.903458,33.2580209],[-96.9034536,33.2581747],[-96.9034536,33.2581747],[-96.9030771,33.258167],[-96.9030771,33.258167]]]},"properties":{"lotName":"4-A-71","lotCpId":"1534671615533301653","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9030738,33.2582902],[-96.9030771,33.258167],[-96.9030771,33.258167],[-96.9034536,33.2581747],[-96.9034536,33.2581747],[-96.9034498,33.258298],[-96.9034498,33.258298],[-96.9030738,33.2582902],[-96.9030738,33.2582902]]]},"properties":{"lotName":"4-A-70","lotCpId":"4805201615533278935","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.90307,33.2584134],[-96.9030738,33.2582902],[-96.9030738,33.2582902],[-96.9034498,33.258298],[-96.9034498,33.258298],[-96.9034465,33.2584212],[-96.9034465,33.2584212],[-96.90307,33.2584134],[-96.90307,33.2584134]]]},"properties":{"lotName":"4-A-69","lotCpId":"4710721615533211926","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9030661,33.2585366],[-96.90307,33.2584134],[-96.90307,33.2584134],[-96.9034465,33.2584212],[-96.9034465,33.2584212],[-96.9034427,33.2585444],[-96.9034427,33.2585444],[-96.9030661,33.2585366],[-96.9030661,33.2585366]]]},"properties":{"lotName":"4-A-68","lotCpId":"5033161615533234749","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9030629,33.2586599],[-96.9030661,33.2585366],[-96.9030661,33.2585366],[-96.9034427,33.2585444],[-96.9034427,33.2585444],[-96.9034389,33.2586676],[-96.9034389,33.2586676],[-96.9030629,33.2586599],[-96.9030629,33.2586599]]]},"properties":{"lotName":"4-A-67","lotCpId":"4168281615533284870","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9030612,33.2587831],[-96.9030605,33.2587739],[-96.9030601,33.2587493],[-96.9030629,33.2586599],[-96.9030629,33.2586599],[-96.9034389,33.2586676],[-96.9034389,33.2586676],[-96.9034356,33.2587908],[-96.9034356,33.2587908],[-96.9030612,33.2587831],[-96.9030612,33.2587831]]]},"properties":{"lotName":"4-A-66","lotCpId":"6207501615533294451","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9031278,33.2589465],[-96.9031185,33.2589344],[-96.9030974,33.2589007],[-96.9030748,33.258849],[-96.9030612,33.2587831],[-96.9030612,33.2587831],[-96.9034356,33.2587908],[-96.9034356,33.2587908],[-96.9034307,33.2589529],[-96.9034307,33.2589529],[-96.9031278,33.2589465],[-96.9031278,33.2589465]]]},"properties":{"lotName":"4-A-65","lotCpId":"4244631615533295730","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038095,33.2588912],[-96.9038056,33.2590145],[-96.9038056,33.2590145],[-96.9034291,33.2590063],[-96.9034291,33.2590063],[-96.9034329,33.2588835],[-96.9034329,33.2588835],[-96.9038095,33.2588912],[-96.9038095,33.2588912]]]},"properties":{"lotName":"4-A-64","lotCpId":"6464671615533192343","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038127,33.258768],[-96.9038095,33.2588912],[-96.9038095,33.2588912],[-96.9034329,33.2588835],[-96.9034329,33.2588835],[-96.9034362,33.2587603],[-96.9034362,33.2587603],[-96.9038127,33.258768],[-96.9038127,33.258768]]]},"properties":{"lotName":"4-A-63","lotCpId":"3305781615533229507","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038166,33.2586448],[-96.9038127,33.258768],[-96.9038127,33.258768],[-96.9034362,33.2587603],[-96.9034362,33.2587603],[-96.90344,33.258637],[-96.90344,33.258637],[-96.9038166,33.2586448],[-96.9038166,33.2586448]]]},"properties":{"lotName":"4-A-62","lotCpId":"5726121615533215270","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038204,33.2585216],[-96.9038166,33.2586448],[-96.9038166,33.2586448],[-96.90344,33.258637],[-96.90344,33.258637],[-96.9034438,33.2585138],[-96.9034438,33.2585138],[-96.9038204,33.2585216],[-96.9038204,33.2585216]]]},"properties":{"lotName":"4-A-61","lotCpId":"1736701615533197687","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038237,33.2583984],[-96.9038204,33.2585216],[-96.9038204,33.2585216],[-96.9034438,33.2585138],[-96.9034438,33.2585138],[-96.9034471,33.2583906],[-96.9034471,33.2583906],[-96.9038237,33.2583984],[-96.9038237,33.2583984]]]},"properties":{"lotName":"4-A-60","lotCpId":"3233831615533221312","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038275,33.2582751],[-96.9038237,33.2583984],[-96.9038237,33.2583984],[-96.9034471,33.2583906],[-96.9034471,33.2583906],[-96.9034509,33.2582674],[-96.9034509,33.2582674],[-96.9038275,33.2582751],[-96.9038275,33.2582751]]]},"properties":{"lotName":"4-A-59","lotCpId":"2485671615533215929","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038313,33.2581519],[-96.9038275,33.2582751],[-96.9038275,33.2582751],[-96.9034509,33.2582674],[-96.9034509,33.2582674],[-96.9034547,33.2581442],[-96.9034547,33.2581442],[-96.9038313,33.2581519],[-96.9038313,33.2581519]]]},"properties":{"lotName":"4-A-58","lotCpId":"2210701615533214626","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038084,33.2580282],[-96.9038049,33.2580387],[-96.9038011,33.2580662],[-96.9038067,33.2581048],[-96.9038313,33.2581487],[-96.9038313,33.2581519],[-96.9038313,33.2581519],[-96.9034547,33.2581442],[-96.9034547,33.2581442],[-96.9034585,33.2580068],[-96.9034585,33.2580068],[-96.9038084,33.2580282],[-96.9038084,33.2580282]]]},"properties":{"lotName":"4-A-57","lotCpId":"8627341615533228148","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9039688,33.2579324],[-96.9039587,33.2579325],[-96.9039327,33.2579352],[-96.9038973,33.2579447],[-96.9038591,33.2579648],[-96.9038591,33.2579648],[-96.9034711,33.2575796],[-96.9034711,33.2575796],[-96.9039192,33.2575892],[-96.9039192,33.2575892],[-96.9039688,33.2579324],[-96.9039688,33.2579324]]]},"properties":{"lotName":"4-A-55","lotCpId":"4058661615533220012","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9041064,33.2579351],[-96.9039688,33.2579324],[-96.9039688,33.2579324],[-96.9039192,33.2575892],[-96.9039192,33.2575892],[-96.9041167,33.2575933],[-96.9041167,33.2575933],[-96.9041064,33.2579351],[-96.9041064,33.2579351]]]},"properties":{"lotName":"4-A-54","lotCpId":"5630511615533191936","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9042537,33.2579383],[-96.9041064,33.2579351],[-96.9041064,33.2579351],[-96.9041167,33.2575933],[-96.9041167,33.2575933],[-96.9042641,33.2575961],[-96.9042641,33.2575961],[-96.9042537,33.2579383],[-96.9042537,33.2579383]]]},"properties":{"lotName":"4-A-53","lotCpId":"3660471615533224890","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9044011,33.2579415],[-96.9043782,33.2579411],[-96.9042537,33.2579383],[-96.9042537,33.2579383],[-96.9042641,33.2575961],[-96.9042641,33.2575961],[-96.9044115,33.2575993],[-96.9044115,33.2575993],[-96.9044011,33.2579415],[-96.9044011,33.2579415]]]},"properties":{"lotName":"4-A-52","lotCpId":"8435181615533128761","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045484,33.2579447],[-96.9044011,33.2579415],[-96.9044011,33.2579415],[-96.9044115,33.2575993],[-96.9044115,33.2575993],[-96.9045588,33.2576024],[-96.9045588,33.2576024],[-96.9045484,33.2579447],[-96.9045484,33.2579447]]]},"properties":{"lotName":"4-A-51","lotCpId":"1812701615533226169","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9046958,33.2579475],[-96.9045484,33.2579447],[-96.9045484,33.2579447],[-96.9045588,33.2576024],[-96.9045588,33.2576024],[-96.9047062,33.2576052],[-96.9047062,33.2576052],[-96.9046958,33.2579475],[-96.9046958,33.2579475]]]},"properties":{"lotName":"4-A-50","lotCpId":"5655001615533193152","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9039928,33.2582208],[-96.9039967,33.2580976],[-96.9039967,33.2580976],[-96.90403,33.2580707],[-96.9043738,33.258078],[-96.9043738,33.258078],[-96.9043694,33.2582286],[-96.9043694,33.2582286],[-96.9039928,33.2582208],[-96.9039928,33.2582208]]]},"properties":{"lotName":"4-F-9","lotCpId":"7766541615533191530","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.903989,33.2583436],[-96.9039928,33.2582208],[-96.9039928,33.2582208],[-96.9043694,33.2582286],[-96.9043694,33.2582286],[-96.9043656,33.2583514],[-96.9043656,33.2583514],[-96.903989,33.2583436],[-96.903989,33.2583436]]]},"properties":{"lotName":"4-F-10","lotCpId":"8106601615533213971","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9039858,33.2584668],[-96.903989,33.2583436],[-96.903989,33.2583436],[-96.9043656,33.2583514],[-96.9043656,33.2583514],[-96.9043623,33.2584746],[-96.9043623,33.2584746],[-96.9039858,33.2584668],[-96.9039858,33.2584668]]]},"properties":{"lotName":"4-F-11","lotCpId":"2685541615533212588","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9039819,33.25859],[-96.9039858,33.2584668],[-96.9039858,33.2584668],[-96.9043623,33.2584746],[-96.9043623,33.2584746],[-96.9043585,33.2585978],[-96.9043585,33.2585978],[-96.9039819,33.25859],[-96.9039819,33.25859]]]},"properties":{"lotName":"4-F-12","lotCpId":"2422171615533217249","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9039781,33.2587133],[-96.9039819,33.25859],[-96.9039819,33.25859],[-96.9043585,33.2585978],[-96.9043585,33.2585978],[-96.9043547,33.258721],[-96.9043547,33.258721],[-96.9039781,33.2587133],[-96.9039781,33.2587133]]]},"properties":{"lotName":"4-F-13","lotCpId":"7181711615533208649","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9039748,33.2588365],[-96.9039781,33.2587133],[-96.9039781,33.2587133],[-96.9043547,33.258721],[-96.9043547,33.258721],[-96.9043509,33.2588442],[-96.9043509,33.2588442],[-96.9039748,33.2588365],[-96.9039748,33.2588365]]]},"properties":{"lotName":"4-F-14","lotCpId":"3154681615533198496","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.903971,33.2589597],[-96.9039748,33.2588365],[-96.9039748,33.2588365],[-96.9043509,33.2588442],[-96.9043509,33.2588442],[-96.9043476,33.2589675],[-96.9043476,33.2589675],[-96.903971,33.2589597],[-96.903971,33.2589597]]]},"properties":{"lotName":"4-F-15","lotCpId":"1172711615533198097","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9039672,33.2590829],[-96.903971,33.2589597],[-96.903971,33.2589597],[-96.9043476,33.2589675],[-96.9043476,33.2589675],[-96.9043432,33.2591181],[-96.9043432,33.2591181],[-96.9039994,33.2591108],[-96.9039672,33.2590829],[-96.9039672,33.2590829]]]},"properties":{"lotName":"4-F-16","lotCpId":"6878501615533192751","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9044027,33.2592563],[-96.9045501,33.2592595],[-96.9045501,33.2592595],[-96.9045408,33.259574],[-96.9045408,33.259574],[-96.9043934,33.2595712],[-96.9043934,33.2595712],[-96.9044027,33.2592563],[-96.9044027,33.2592563]]]},"properties":{"lotName":"4-B-10","lotCpId":"4703241615533198903","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9042554,33.2592531],[-96.9043389,33.259255],[-96.9044027,33.2592563],[-96.9044027,33.2592563],[-96.9043934,33.2595712],[-96.9043934,33.2595712],[-96.9042461,33.259568],[-96.9042461,33.259568],[-96.9042554,33.2592531],[-96.9042554,33.2592531]]]},"properties":{"lotName":"4-B-11","lotCpId":"8670421615533199701","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.904108,33.2592504],[-96.9042554,33.2592531],[-96.9042554,33.2592531],[-96.9042461,33.259568],[-96.9042461,33.259568],[-96.9040987,33.2595648],[-96.9040987,33.2595648],[-96.904108,33.2592504],[-96.904108,33.2592504]]]},"properties":{"lotName":"4-B-12","lotCpId":"7227041615533280893","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9039606,33.2592472],[-96.904108,33.2592504],[-96.904108,33.2592504],[-96.9040987,33.2595648],[-96.9040987,33.2595648],[-96.9039514,33.2595621],[-96.9039514,33.2595621],[-96.9039606,33.2592472],[-96.9039606,33.2592472]]]},"properties":{"lotName":"4-B-13","lotCpId":"7223651615533275032","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038133,33.259244],[-96.9039606,33.2592472],[-96.9039606,33.2592472],[-96.9039514,33.2595621],[-96.9039514,33.2595621],[-96.903804,33.2595589],[-96.903804,33.2595589],[-96.9038133,33.259244],[-96.9038133,33.259244]]]},"properties":{"lotName":"4-B-14","lotCpId":"8364371615533221968","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9036659,33.2592408],[-96.9038133,33.259244],[-96.9038133,33.259244],[-96.903804,33.2595589],[-96.903804,33.2595589],[-96.9036567,33.2595557],[-96.9036567,33.2595557],[-96.9036659,33.2592408],[-96.9036659,33.2592408]]]},"properties":{"lotName":"4-B-15","lotCpId":"4224311615533195575","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035186,33.2592381],[-96.9036659,33.2592408],[-96.9036659,33.2592408],[-96.9036567,33.2595557],[-96.9036567,33.2595557],[-96.9035093,33.259553],[-96.9035093,33.259553],[-96.9035186,33.2592381],[-96.9035186,33.2592381]]]},"properties":{"lotName":"4-B-16","lotCpId":"5641271615533193560","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9033719,33.2592301],[-96.9033929,33.2592333],[-96.9034555,33.259237],[-96.9035186,33.2592381],[-96.9035186,33.2592381],[-96.9035093,33.259553],[-96.9035093,33.259553],[-96.9033619,33.2595498],[-96.9033619,33.2595498],[-96.9033719,33.2592301],[-96.9033719,33.2592301]]]},"properties":{"lotName":"4-B-17","lotCpId":"8527601615533128209","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038591,33.2579648],[-96.9038397,33.2579821],[-96.9038084,33.2580282],[-96.9038084,33.2580282],[-96.9034585,33.2580068],[-96.9034585,33.2580068],[-96.9034711,33.2575796],[-96.9034711,33.2575796],[-96.9038591,33.2579648],[-96.9038591,33.2579648]]]},"properties":{"lotName":"4-A-56","lotCpId":"5568431615533236710","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013884,33.2594001],[-96.9013777,33.2594231],[-96.9013724,33.2594515],[-96.9013745,33.2594909],[-96.9013745,33.2594909],[-96.9009284,33.2595502],[-96.9009284,33.2595502],[-96.9009264,33.2595433],[-96.9009212,33.2595238],[-96.9009063,33.2594539],[-96.9008932,33.2593547],[-96.9008915,33.2592404],[-96.9008918,33.2592207],[-96.9008918,33.2592207],[-96.9013884,33.2594001],[-96.9013884,33.2594001]]]},"properties":{"lotName":"4-B-32","lotCpId":"2220001615533222631","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014578,33.2593298],[-96.9014491,33.2593354],[-96.901429,33.2593507],[-96.9013884,33.2594001],[-96.9013884,33.2594001],[-96.9008918,33.2592207],[-96.9008918,33.2592207],[-96.9008962,33.2590825],[-96.9008962,33.2590825],[-96.9014059,33.2592664],[-96.9014578,33.2593298],[-96.9014578,33.2593298]]]},"properties":{"lotName":"4-B-31","lotCpId":"8382501615533274376","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8942994,33.269169],[-96.8941029,33.2691654],[-96.8941029,33.2691654],[-96.8940713,33.2691371],[-96.89408,33.2688364],[-96.89408,33.2688364],[-96.8943092,33.2688409],[-96.8943092,33.2688409],[-96.8942994,33.269169],[-96.8942994,33.269169]]]},"properties":{"lotName":"6-A-24","lotCpId":"1721601615542034453","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944631,33.2691727],[-96.8942994,33.269169],[-96.8942994,33.269169],[-96.8943092,33.2688409],[-96.8943092,33.2688409],[-96.8944724,33.2688441],[-96.8944724,33.2688441],[-96.8944631,33.2691727],[-96.8944631,33.2691727]]]},"properties":{"lotName":"6-A-23","lotCpId":"1657271615542034443","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8946269,33.2691759],[-96.8944631,33.2691727],[-96.8944631,33.2691727],[-96.8944724,33.2688441],[-96.8944724,33.2688441],[-96.8946361,33.2688473],[-96.8946361,33.2688473],[-96.8946269,33.2691759],[-96.8946269,33.2691759]]]},"properties":{"lotName":"6-A-22","lotCpId":"3845181615542034300","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947906,33.2691791],[-96.8946269,33.2691759],[-96.8946269,33.2691759],[-96.8946361,33.2688473],[-96.8946361,33.2688473],[-96.8947999,33.2688505],[-96.8947999,33.2688505],[-96.8947906,33.2691791],[-96.8947906,33.2691791]]]},"properties":{"lotName":"6-A-21","lotCpId":"7505181615542034230","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8949543,33.2691823],[-96.8947906,33.2691791],[-96.8947906,33.2691791],[-96.8947999,33.2688505],[-96.8947999,33.2688505],[-96.8949636,33.2688537],[-96.8949636,33.2688537],[-96.8949543,33.2691823],[-96.8949543,33.2691823]]]},"properties":{"lotName":"6-A-20","lotCpId":"6514351615542034254","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8951181,33.2691855],[-96.8949543,33.2691823],[-96.8949543,33.2691823],[-96.8949636,33.2688537],[-96.8949636,33.2688537],[-96.8951273,33.2688574],[-96.8951273,33.2688574],[-96.8951181,33.2691855],[-96.8951181,33.2691855]]]},"properties":{"lotName":"6-A-19","lotCpId":"4723781615542034257","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952818,33.2691891],[-96.8951181,33.2691855],[-96.8951181,33.2691855],[-96.8951273,33.2688574],[-96.8951273,33.2688574],[-96.8952911,33.2688606],[-96.8952911,33.2688606],[-96.8952818,33.2691891],[-96.8952818,33.2691891]]]},"properties":{"lotName":"6-A-18","lotCpId":"7118601615542034342","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954455,33.2691923],[-96.8952818,33.2691891],[-96.8952818,33.2691891],[-96.8952911,33.2688606],[-96.8952911,33.2688606],[-96.8954548,33.2688637],[-96.8954548,33.2688637],[-96.8954455,33.2691923],[-96.8954455,33.2691923]]]},"properties":{"lotName":"6-A-17","lotCpId":"2833151615542034275","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8956092,33.2691955],[-96.8954455,33.2691923],[-96.8954455,33.2691923],[-96.8954548,33.2688637],[-96.8954548,33.2688637],[-96.8956185,33.2688669],[-96.8956185,33.2688669],[-96.8956092,33.2691955],[-96.8956092,33.2691955]]]},"properties":{"lotName":"6-A-16","lotCpId":"3576021615542034294","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.895773,33.2691987],[-96.8956092,33.2691955],[-96.8956092,33.2691955],[-96.8956185,33.2688669],[-96.8956185,33.2688669],[-96.8957823,33.2688701],[-96.8957823,33.2688701],[-96.895773,33.2691987],[-96.895773,33.2691987]]]},"properties":{"lotName":"6-A-15","lotCpId":"8882201615542034245","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8959367,33.2692019],[-96.895773,33.2691987],[-96.895773,33.2691987],[-96.8957823,33.2688701],[-96.8957823,33.2688701],[-96.895946,33.2688738],[-96.895946,33.2688738],[-96.8959367,33.2692019],[-96.8959367,33.2692019]]]},"properties":{"lotName":"6-A-14","lotCpId":"4377841615542034279","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8960999,33.2692055],[-96.8959367,33.2692019],[-96.8959367,33.2692019],[-96.895946,33.2688738],[-96.895946,33.2688738],[-96.8961097,33.268877],[-96.8961097,33.268877],[-96.8960999,33.2692055],[-96.8960999,33.2692055]]]},"properties":{"lotName":"6-A-13","lotCpId":"2613131615542034290","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8962636,33.2692087],[-96.8960999,33.2692055],[-96.8960999,33.2692055],[-96.8961097,33.268877],[-96.8961097,33.268877],[-96.8962734,33.2688802],[-96.8962734,33.2688802],[-96.8962636,33.2692087],[-96.8962636,33.2692087]]]},"properties":{"lotName":"6-A-12","lotCpId":"7261421615542034225","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8960862,33.268548],[-96.8962827,33.2685516],[-96.8962827,33.2685516],[-96.8962734,33.2688802],[-96.8962734,33.2688802],[-96.896077,33.2688761],[-96.896077,33.2688761],[-96.8960862,33.268548],[-96.8960862,33.268548]]]},"properties":{"lotName":"6-A-11","lotCpId":"2027861615542034243","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8958898,33.2685439],[-96.8960862,33.268548],[-96.8960862,33.268548],[-96.896077,33.2688761],[-96.896077,33.2688761],[-96.8958805,33.2688724],[-96.8958805,33.2688724],[-96.8958898,33.2685439],[-96.8958898,33.2685439]]]},"properties":{"lotName":"6-A-10","lotCpId":"2531051615542034214","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8956933,33.2685398],[-96.8958898,33.2685439],[-96.8958898,33.2685439],[-96.8958805,33.2688724],[-96.8958805,33.2688724],[-96.895684,33.2688683],[-96.895684,33.2688683],[-96.8956933,33.2685398],[-96.8956933,33.2685398]]]},"properties":{"lotName":"6-A-9","lotCpId":"2774801615542034002","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954968,33.2685361],[-96.8956933,33.2685398],[-96.8956933,33.2685398],[-96.895684,33.2688683],[-96.895684,33.2688683],[-96.8954875,33.2688642],[-96.8954875,33.2688642],[-96.8954968,33.2685361],[-96.8954968,33.2685361]]]},"properties":{"lotName":"6-A-8","lotCpId":"2332521615542033991","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8953003,33.268532],[-96.8954968,33.2685361],[-96.8954968,33.2685361],[-96.8954875,33.2688642],[-96.8954875,33.2688642],[-96.8952911,33.2688606],[-96.8952911,33.2688606],[-96.8953003,33.268532],[-96.8953003,33.268532]]]},"properties":{"lotName":"6-A-7","lotCpId":"3386201615542034001","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8951039,33.2685279],[-96.8953003,33.268532],[-96.8953003,33.268532],[-96.8952911,33.2688606],[-96.8952911,33.2688606],[-96.8950946,33.2688564],[-96.8950946,33.2688564],[-96.8951039,33.2685279],[-96.8951039,33.2685279]]]},"properties":{"lotName":"6-A-6","lotCpId":"4601321615542033995","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8949079,33.2685242],[-96.8951039,33.2685279],[-96.8951039,33.2685279],[-96.8950946,33.2688564],[-96.8950946,33.2688564],[-96.8948981,33.2688528],[-96.8948981,33.2688528],[-96.8949079,33.2685242],[-96.8949079,33.2685242]]]},"properties":{"lotName":"6-A-5","lotCpId":"4673141615542033989","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947115,33.2685201],[-96.8949079,33.2685242],[-96.8949079,33.2685242],[-96.8948981,33.2688528],[-96.8948981,33.2688528],[-96.8947016,33.2688487],[-96.8947016,33.2688487],[-96.8947115,33.2685201],[-96.8947115,33.2685201]]]},"properties":{"lotName":"6-A-4","lotCpId":"4115001615542034037","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.894515,33.2685165],[-96.8947115,33.2685201],[-96.8947115,33.2685201],[-96.8947016,33.2688487],[-96.8947016,33.2688487],[-96.8945052,33.2688446],[-96.8945052,33.2688446],[-96.894515,33.2685165],[-96.894515,33.2685165]]]},"properties":{"lotName":"6-A-3","lotCpId":"1026221615542033904","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8943185,33.2685124],[-96.894515,33.2685165],[-96.894515,33.2685165],[-96.8945052,33.2688446],[-96.8945052,33.2688446],[-96.8943092,33.2688409],[-96.8943092,33.2688409],[-96.8943185,33.2685124],[-96.8943185,33.2685124]]]},"properties":{"lotName":"6-A-2","lotCpId":"8831401615542033917","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.894122,33.2685083],[-96.8943185,33.2685124],[-96.8943185,33.2685124],[-96.8943092,33.2688409],[-96.8943092,33.2688409],[-96.89408,33.2688364],[-96.89408,33.2688364],[-96.8940882,33.2685352],[-96.894122,33.2685083],[-96.894122,33.2685083]]]},"properties":{"lotName":"6-A-1","lotCpId":"5234831615542033907","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8941624,33.2699607],[-96.8939627,33.2699566],[-96.8939627,33.2699566],[-96.8939588,33.2696281],[-96.8939588,33.2696281],[-96.8941717,33.2696322],[-96.8941717,33.2696322],[-96.8941624,33.2699607],[-96.8941624,33.2699607]]]},"properties":{"lotName":"6-B-29","lotCpId":"1657001615542404389","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8943098,33.2699635],[-96.8941624,33.2699607],[-96.8941624,33.2699607],[-96.8941717,33.2696322],[-96.8941717,33.2696322],[-96.8943191,33.2696354],[-96.8943191,33.2696354],[-96.8943098,33.2699635],[-96.8943098,33.2699635]]]},"properties":{"lotName":"6-B-28","lotCpId":"2153231615542404383","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944566,33.2699667],[-96.8943098,33.2699635],[-96.8943098,33.2699635],[-96.8943191,33.2696354],[-96.8943191,33.2696354],[-96.8944664,33.2696381],[-96.8944664,33.2696381],[-96.8944566,33.2699667],[-96.8944566,33.2699667]]]},"properties":{"lotName":"6-B-27","lotCpId":"6847101615542404436","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8946039,33.2699694],[-96.8944566,33.2699667],[-96.8944566,33.2699667],[-96.8944664,33.2696381],[-96.8944664,33.2696381],[-96.8946138,33.2696413],[-96.8946138,33.2696413],[-96.8946039,33.2699694],[-96.8946039,33.2699694]]]},"properties":{"lotName":"6-B-26","lotCpId":"4478301615542404407","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947513,33.2699726],[-96.8946039,33.2699694],[-96.8946039,33.2699694],[-96.8946138,33.2696413],[-96.8946138,33.2696413],[-96.8947611,33.269644],[-96.8947611,33.269644],[-96.8947513,33.2699726],[-96.8947513,33.2699726]]]},"properties":{"lotName":"6-B-25","lotCpId":"8222361615542404381","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8948987,33.2699753],[-96.8947513,33.2699726],[-96.8947513,33.2699726],[-96.8947611,33.269644],[-96.8947611,33.269644],[-96.8949085,33.2696468],[-96.8949085,33.2696468],[-96.8948987,33.2699753],[-96.8948987,33.2699753]]]},"properties":{"lotName":"6-B-24","lotCpId":"6833221615542404394","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.895046,33.2699785],[-96.8948987,33.2699753],[-96.8948987,33.2699753],[-96.8949085,33.2696468],[-96.8949085,33.2696468],[-96.8950553,33.26965],[-96.8950553,33.26965],[-96.895046,33.2699785],[-96.895046,33.2699785]]]},"properties":{"lotName":"6-B-23","lotCpId":"1652171615542404409","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8951934,33.2699813],[-96.895046,33.2699785],[-96.895046,33.2699785],[-96.8950553,33.26965],[-96.8950553,33.26965],[-96.8952027,33.2696527],[-96.8952027,33.2696527],[-96.8951934,33.2699813],[-96.8951934,33.2699813]]]},"properties":{"lotName":"6-B-22","lotCpId":"4230381615542404368","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8953407,33.2699845],[-96.8951934,33.2699813],[-96.8951934,33.2699813],[-96.8952027,33.2696527],[-96.8952027,33.2696527],[-96.89535,33.2696559],[-96.89535,33.2696559],[-96.8953407,33.2699845],[-96.8953407,33.2699845]]]},"properties":{"lotName":"6-B-21","lotCpId":"2866761615542404407","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954881,33.2699872],[-96.8953407,33.2699845],[-96.8953407,33.2699845],[-96.89535,33.2696559],[-96.89535,33.2696559],[-96.8954974,33.2696587],[-96.8954974,33.2696587],[-96.8954881,33.2699872],[-96.8954881,33.2699872]]]},"properties":{"lotName":"6-B-20","lotCpId":"1751161615542404447","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8956354,33.2699904],[-96.8954881,33.2699872],[-96.8954881,33.2699872],[-96.8954974,33.2696587],[-96.8954974,33.2696587],[-96.8956447,33.2696618],[-96.8956447,33.2696618],[-96.8956354,33.2699904],[-96.8956354,33.2699904]]]},"properties":{"lotName":"6-B-19","lotCpId":"5801541615542404339","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8957828,33.2699931],[-96.8956354,33.2699904],[-96.8956354,33.2699904],[-96.8956447,33.2696618],[-96.8956447,33.2696618],[-96.8957921,33.2696646],[-96.8957921,33.2696646],[-96.8957828,33.2699931],[-96.8957828,33.2699931]]]},"properties":{"lotName":"6-B-18","lotCpId":"1382401615542404417","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8959302,33.2699963],[-96.8957828,33.2699931],[-96.8957828,33.2699931],[-96.8957921,33.2696646],[-96.8957921,33.2696646],[-96.8959394,33.2696678],[-96.8959394,33.2696678],[-96.8959302,33.2699963],[-96.8959302,33.2699963]]]},"properties":{"lotName":"6-B-17","lotCpId":"4143351615542404394","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8960775,33.2699991],[-96.8959302,33.2699963],[-96.8959302,33.2699963],[-96.8959394,33.2696678],[-96.8959394,33.2696678],[-96.8960868,33.2696705],[-96.8960868,33.2696705],[-96.8960775,33.2699991],[-96.8960775,33.2699991]]]},"properties":{"lotName":"6-B-16","lotCpId":"1534721615542404403","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8962412,33.2700023],[-96.8960775,33.2699991],[-96.8960775,33.2699991],[-96.8960868,33.2696705],[-96.8960868,33.2696705],[-96.8962505,33.2696737],[-96.8962505,33.2696737],[-96.8962412,33.2700023],[-96.8962412,33.2700023]]]},"properties":{"lotName":"6-B-15","lotCpId":"4082801615542404422","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8960961,33.269342],[-96.8962598,33.2693456],[-96.8962598,33.2693456],[-96.8962505,33.2696737],[-96.8962505,33.2696737],[-96.8960868,33.2696705],[-96.8960868,33.2696705],[-96.8960961,33.269342],[-96.8960961,33.269342]]]},"properties":{"lotName":"6-B-14","lotCpId":"1581561615542404428","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8959323,33.2693388],[-96.8960961,33.269342],[-96.8960961,33.269342],[-96.8960868,33.2696705],[-96.8960868,33.2696705],[-96.8959231,33.2696673],[-96.8959231,33.2696673],[-96.8959323,33.2693388],[-96.8959323,33.2693388]]]},"properties":{"lotName":"6-B-13","lotCpId":"2488111615542404407","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8957686,33.2693356],[-96.8959323,33.2693388],[-96.8959323,33.2693388],[-96.8959231,33.2696673],[-96.8959231,33.2696673],[-96.8957593,33.2696641],[-96.8957593,33.2696641],[-96.8957686,33.2693356],[-96.8957686,33.2693356]]]},"properties":{"lotName":"6-B-12","lotCpId":"8106601615542404417","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8956049,33.2693324],[-96.8957686,33.2693356],[-96.8957686,33.2693356],[-96.8957593,33.2696641],[-96.8957593,33.2696641],[-96.8955956,33.2696609],[-96.8955956,33.2696609],[-96.8956049,33.2693324],[-96.8956049,33.2693324]]]},"properties":{"lotName":"6-B-11","lotCpId":"5706111615542404421","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954417,33.2693292],[-96.8956049,33.2693324],[-96.8956049,33.2693324],[-96.8955956,33.2696609],[-96.8955956,33.2696609],[-96.8954319,33.2696577],[-96.8954319,33.2696577],[-96.8954417,33.2693292],[-96.8954417,33.2693292]]]},"properties":{"lotName":"6-B-10","lotCpId":"3605441615542404359","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.895278,33.269326],[-96.8954417,33.2693292],[-96.8954417,33.2693292],[-96.8954319,33.2696577],[-96.8954319,33.2696577],[-96.8952681,33.2696541],[-96.8952681,33.2696541],[-96.895278,33.269326],[-96.895278,33.269326]]]},"properties":{"lotName":"6-B-9","lotCpId":"1415071615542404369","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8951142,33.2693223],[-96.895278,33.269326],[-96.895278,33.269326],[-96.8952681,33.2696541],[-96.8952681,33.2696541],[-96.8951044,33.2696509],[-96.8951044,33.2696509],[-96.8951142,33.2693223],[-96.8951142,33.2693223]]]},"properties":{"lotName":"6-B-8","lotCpId":"5316601615542404366","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8949505,33.2693192],[-96.8951142,33.2693223],[-96.8951142,33.2693223],[-96.8951044,33.2696509],[-96.8951044,33.2696509],[-96.8949412,33.2696477],[-96.8949412,33.2696477],[-96.8949505,33.2693192],[-96.8949505,33.2693192]]]},"properties":{"lotName":"6-B-7","lotCpId":"5455151615542404417","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947868,33.269316],[-96.8949505,33.2693192],[-96.8949505,33.2693192],[-96.8949412,33.2696477],[-96.8949412,33.2696477],[-96.8947775,33.2696445],[-96.8947775,33.2696445],[-96.8947868,33.269316],[-96.8947868,33.269316]]]},"properties":{"lotName":"6-B-6","lotCpId":"5552311615542404423","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.894623,33.2693128],[-96.8947868,33.269316],[-96.8947868,33.269316],[-96.8947775,33.2696445],[-96.8947775,33.2696445],[-96.8946138,33.2696413],[-96.8946138,33.2696413],[-96.894623,33.2693128],[-96.894623,33.2693128]]]},"properties":{"lotName":"6-B-5","lotCpId":"4653841615542034455","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944593,33.2693096],[-96.894623,33.2693128],[-96.894623,33.2693128],[-96.8946138,33.2696413],[-96.8946138,33.2696413],[-96.89445,33.2696377],[-96.89445,33.2696377],[-96.8944593,33.2693096],[-96.8944593,33.2693096]]]},"properties":{"lotName":"6-B-4","lotCpId":"4880631615542034442","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8942956,33.2693059],[-96.8944593,33.2693096],[-96.8944593,33.2693096],[-96.89445,33.2696377],[-96.89445,33.2696377],[-96.8942863,33.2696345],[-96.8942863,33.2696345],[-96.8942956,33.2693059],[-96.8942956,33.2693059]]]},"properties":{"lotName":"6-B-3","lotCpId":"1250551615542034458","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8941319,33.2693027],[-96.8942956,33.2693059],[-96.8942956,33.2693059],[-96.8942863,33.2696345],[-96.8942863,33.2696345],[-96.8941226,33.2696313],[-96.8941226,33.2696313],[-96.8941319,33.2693027],[-96.8941319,33.2693027]]]},"properties":{"lotName":"6-B-2","lotCpId":"1256451615542034463","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8939681,33.2692995],[-96.8941319,33.2693027],[-96.8941319,33.2693027],[-96.8941226,33.2696313],[-96.8941226,33.2696313],[-96.8939588,33.2696281],[-96.8939588,33.2696281],[-96.8939681,33.2692995],[-96.8939681,33.2692995]]]},"properties":{"lotName":"6-B-1","lotCpId":"5680621615542034453","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8943032,33.2707634],[-96.8941362,33.2707597],[-96.8941362,33.2707597],[-96.894104,33.2707319],[-96.8941128,33.270428],[-96.8941128,33.270428],[-96.8943125,33.2704321],[-96.8943125,33.2704321],[-96.8943032,33.2707634],[-96.8943032,33.2707634]]]},"properties":{"lotName":"6-C-28","lotCpId":"6011161615542901368","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.89445,33.2707661],[-96.8943032,33.2707634],[-96.8943032,33.2707634],[-96.8943125,33.2704321],[-96.8943125,33.2704321],[-96.8944599,33.2704348],[-96.8944599,33.2704348],[-96.89445,33.2707661],[-96.89445,33.2707661]]]},"properties":{"lotName":"6-C-27","lotCpId":"1254431615542901306","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945974,33.2707693],[-96.89445,33.2707661],[-96.89445,33.2707661],[-96.8944599,33.2704348],[-96.8944599,33.2704348],[-96.8946072,33.270438],[-96.8946072,33.270438],[-96.8945974,33.2707693],[-96.8945974,33.2707693]]]},"properties":{"lotName":"6-C-26","lotCpId":"3475801615542901319","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947448,33.2707721],[-96.8945974,33.2707693],[-96.8945974,33.2707693],[-96.8946072,33.270438],[-96.8946072,33.270438],[-96.8947546,33.2704408],[-96.8947546,33.2704408],[-96.8947448,33.2707721],[-96.8947448,33.2707721]]]},"properties":{"lotName":"6-C-25","lotCpId":"8711811615542901359","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8948921,33.2707748],[-96.8947448,33.2707721],[-96.8947448,33.2707721],[-96.8947546,33.2704408],[-96.8947546,33.2704408],[-96.8949019,33.270444],[-96.8949019,33.270444],[-96.8948921,33.2707748],[-96.8948921,33.2707748]]]},"properties":{"lotName":"6-C-24","lotCpId":"6034301615542901309","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8950395,33.270778],[-96.8948921,33.2707748],[-96.8948921,33.2707748],[-96.8949019,33.270444],[-96.8949019,33.270444],[-96.8950493,33.2704467],[-96.8950493,33.2704467],[-96.8950395,33.270778],[-96.8950395,33.270778]]]},"properties":{"lotName":"6-C-23","lotCpId":"1046851615542901352","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8951868,33.2707807],[-96.8950395,33.270778],[-96.8950395,33.270778],[-96.8950493,33.2704467],[-96.8950493,33.2704467],[-96.8951966,33.2704499],[-96.8951966,33.2704499],[-96.8951868,33.2707807],[-96.8951868,33.2707807]]]},"properties":{"lotName":"6-C-22","lotCpId":"5561311615542901337","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8953342,33.2707839],[-96.8951868,33.2707807],[-96.8951868,33.2707807],[-96.8951966,33.2704499],[-96.8951966,33.2704499],[-96.8953435,33.2704526],[-96.8953435,33.2704526],[-96.8953342,33.2707839],[-96.8953342,33.2707839]]]},"properties":{"lotName":"6-C-21","lotCpId":"6515201615542901354","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954815,33.2707867],[-96.8953342,33.2707839],[-96.8953342,33.2707839],[-96.8953435,33.2704526],[-96.8953435,33.2704526],[-96.8954908,33.2704558],[-96.8954908,33.2704558],[-96.8954815,33.2707867],[-96.8954815,33.2707867]]]},"properties":{"lotName":"6-C-20","lotCpId":"2005351615542901329","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8956289,33.2707898],[-96.8954815,33.2707867],[-96.8954815,33.2707867],[-96.8954908,33.2704558],[-96.8954908,33.2704558],[-96.8956382,33.2704586],[-96.8956382,33.2704586],[-96.8956289,33.2707898],[-96.8956289,33.2707898]]]},"properties":{"lotName":"6-C-19","lotCpId":"7506601615542901365","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8957763,33.2707926],[-96.8956289,33.2707898],[-96.8956289,33.2707898],[-96.8956382,33.2704586],[-96.8956382,33.2704586],[-96.8957855,33.2704618],[-96.8957855,33.2704618],[-96.8957763,33.2707926],[-96.8957763,33.2707926]]]},"properties":{"lotName":"6-C-18","lotCpId":"1050131615542901355","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8959236,33.2707958],[-96.8957763,33.2707926],[-96.8957763,33.2707926],[-96.8957855,33.2704618],[-96.8957855,33.2704618],[-96.8959329,33.2704645],[-96.8959329,33.2704645],[-96.8959236,33.2707958],[-96.8959236,33.2707958]]]},"properties":{"lotName":"6-C-17","lotCpId":"7402821615542901282","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.896071,33.2707985],[-96.8959236,33.2707958],[-96.8959236,33.2707958],[-96.8959329,33.2704645],[-96.8959329,33.2704645],[-96.8960802,33.2704672],[-96.8960802,33.2704672],[-96.896071,33.2707985],[-96.896071,33.2707985]]]},"properties":{"lotName":"6-C-16","lotCpId":"8756451615542901401","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8962183,33.2708017],[-96.896071,33.2707985],[-96.896071,33.2707985],[-96.8960802,33.2704672],[-96.8960802,33.2704672],[-96.8962276,33.2704704],[-96.8962276,33.2704704],[-96.8962183,33.2708017],[-96.8962183,33.2708017]]]},"properties":{"lotName":"6-C-15","lotCpId":"2523581615542901392","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8960901,33.2701364],[-96.8962369,33.2701391],[-96.8962369,33.2701391],[-96.8962276,33.2704704],[-96.8962276,33.2704704],[-96.8960802,33.2704672],[-96.8960802,33.2704672],[-96.8960901,33.2701364],[-96.8960901,33.2701364]]]},"properties":{"lotName":"6-C-14","lotCpId":"2200361615542901406","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8959427,33.2701332],[-96.8960901,33.2701364],[-96.8960901,33.2701364],[-96.8960802,33.2704672],[-96.8960802,33.2704672],[-96.8959329,33.2704645],[-96.8959329,33.2704645],[-96.8959427,33.2701332],[-96.8959427,33.2701332]]]},"properties":{"lotName":"6-C-13","lotCpId":"4858601615542901340","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8957954,33.27013],[-96.8959427,33.2701332],[-96.8959427,33.2701332],[-96.8959329,33.2704645],[-96.8959329,33.2704645],[-96.8957855,33.2704618],[-96.8957855,33.2704618],[-96.8957954,33.27013],[-96.8957954,33.27013]]]},"properties":{"lotName":"6-C-12","lotCpId":"7226211615542901310","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.895648,33.2701273],[-96.8957954,33.27013],[-96.8957954,33.27013],[-96.8957855,33.2704618],[-96.8957855,33.2704618],[-96.8956382,33.2704586],[-96.8956382,33.2704586],[-96.895648,33.2701273],[-96.895648,33.2701273]]]},"properties":{"lotName":"6-C-11","lotCpId":"6525521615542901302","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8955006,33.2701245],[-96.895648,33.2701273],[-96.895648,33.2701273],[-96.8956382,33.2704586],[-96.8956382,33.2704586],[-96.8954908,33.2704558],[-96.8954908,33.2704558],[-96.8955006,33.2701245],[-96.8955006,33.2701245]]]},"properties":{"lotName":"6-C-10","lotCpId":"3847401615542901335","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8953533,33.2701214],[-96.8955006,33.2701245],[-96.8955006,33.2701245],[-96.8954908,33.2704558],[-96.8954908,33.2704558],[-96.8953435,33.2704526],[-96.8953435,33.2704526],[-96.8953533,33.2701214],[-96.8953533,33.2701214]]]},"properties":{"lotName":"6-C-9","lotCpId":"1188121615542901331","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8952059,33.2701186],[-96.8953533,33.2701214],[-96.8953533,33.2701214],[-96.8953435,33.2704526],[-96.8953435,33.2704526],[-96.8951966,33.2704499],[-96.8951966,33.2704499],[-96.8952059,33.2701186],[-96.8952059,33.2701186]]]},"properties":{"lotName":"6-C-8","lotCpId":"7260181615542901281","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8950586,33.2701154],[-96.8952059,33.2701186],[-96.8952059,33.2701186],[-96.8951966,33.2704499],[-96.8951966,33.2704499],[-96.8950493,33.2704467],[-96.8950493,33.2704467],[-96.8950586,33.2701154],[-96.8950586,33.2701154]]]},"properties":{"lotName":"6-C-7","lotCpId":"2146011615542901286","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8949112,33.2701127],[-96.8950586,33.2701154],[-96.8950586,33.2701154],[-96.8950493,33.2704467],[-96.8950493,33.2704467],[-96.8949019,33.270444],[-96.8949019,33.270444],[-96.8949112,33.2701127],[-96.8949112,33.2701127]]]},"properties":{"lotName":"6-C-6","lotCpId":"6233541615542901256","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947639,33.2701095],[-96.8949112,33.2701127],[-96.8949112,33.2701127],[-96.8949019,33.270444],[-96.8949019,33.270444],[-96.8947546,33.2704408],[-96.8947546,33.2704408],[-96.8947639,33.2701095],[-96.8947639,33.2701095]]]},"properties":{"lotName":"6-C-5","lotCpId":"1224741615542404457","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8946165,33.2701068],[-96.8947639,33.2701095],[-96.8947639,33.2701095],[-96.8947546,33.2704408],[-96.8947546,33.2704408],[-96.8946072,33.270438],[-96.8946072,33.270438],[-96.8946165,33.2701068],[-96.8946165,33.2701068]]]},"properties":{"lotName":"6-C-4","lotCpId":"2733311615542404459","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944691,33.2701036],[-96.8946165,33.2701068],[-96.8946165,33.2701068],[-96.8946072,33.270438],[-96.8946072,33.270438],[-96.8944599,33.2704348],[-96.8944599,33.2704348],[-96.8944691,33.2701036],[-96.8944691,33.2701036]]]},"properties":{"lotName":"6-C-3","lotCpId":"6686331615542404457","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8943218,33.2701008],[-96.8944691,33.2701036],[-96.8944691,33.2701036],[-96.8944599,33.2704348],[-96.8944599,33.2704348],[-96.8943125,33.2704321],[-96.8943125,33.2704321],[-96.8943218,33.2701008],[-96.8943218,33.2701008]]]},"properties":{"lotName":"6-C-2","lotCpId":"3058871615542404441","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8941548,33.2700976],[-96.8943218,33.2701008],[-96.8943218,33.2701008],[-96.8943125,33.2704321],[-96.8943125,33.2704321],[-96.8941128,33.270428],[-96.8941128,33.270428],[-96.8941215,33.2701241],[-96.8941548,33.2700976],[-96.8941548,33.2700976]]]},"properties":{"lotName":"6-C-1","lotCpId":"7881001615542404393","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8942803,33.2715624],[-96.8941133,33.2715592],[-96.8941133,33.2715592],[-96.8940811,33.2715309],[-96.8940898,33.2712274],[-96.8940898,33.2712274],[-96.8942896,33.2712311],[-96.8942896,33.2712311],[-96.8942803,33.2715624],[-96.8942803,33.2715624]]]},"properties":{"lotName":"6-D-28","lotCpId":"1361401615543275683","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944271,33.2715656],[-96.8942803,33.2715624],[-96.8942803,33.2715624],[-96.8942896,33.2712311],[-96.8942896,33.2712311],[-96.8944369,33.2712343],[-96.8944369,33.2712343],[-96.8944271,33.2715656],[-96.8944271,33.2715656]]]},"properties":{"lotName":"6-D-27","lotCpId":"4404261615543275663","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945745,33.2715683],[-96.8944271,33.2715656],[-96.8944271,33.2715656],[-96.8944369,33.2712343],[-96.8944369,33.2712343],[-96.8945843,33.271237],[-96.8945843,33.271237],[-96.8945745,33.2715683],[-96.8945745,33.2715683]]]},"properties":{"lotName":"6-D-26","lotCpId":"2147321615543275701","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947218,33.271571],[-96.8945745,33.2715683],[-96.8945745,33.2715683],[-96.8945843,33.271237],[-96.8945843,33.271237],[-96.8947317,33.2712402],[-96.8947317,33.2712402],[-96.8947218,33.271571],[-96.8947218,33.271571]]]},"properties":{"lotName":"6-D-25","lotCpId":"7111711615543275663","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8948692,33.2715742],[-96.8947218,33.271571],[-96.8947218,33.271571],[-96.8947317,33.2712402],[-96.8947317,33.2712402],[-96.894879,33.271243],[-96.894879,33.271243],[-96.8948692,33.2715742],[-96.8948692,33.2715742]]]},"properties":{"lotName":"6-D-24","lotCpId":"6870381615543275660","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8950165,33.271577],[-96.8948692,33.2715742],[-96.8948692,33.2715742],[-96.894879,33.271243],[-96.894879,33.271243],[-96.8950264,33.2712462],[-96.8950264,33.2712462],[-96.8950165,33.271577],[-96.8950165,33.271577]]]},"properties":{"lotName":"6-D-23","lotCpId":"2677851615543275648","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8951639,33.2715802],[-96.8950165,33.271577],[-96.8950165,33.271577],[-96.8950264,33.2712462],[-96.8950264,33.2712462],[-96.8951737,33.2712489],[-96.8951737,33.2712489],[-96.8951639,33.2715802],[-96.8951639,33.2715802]]]},"properties":{"lotName":"6-D-22","lotCpId":"4625131615543275661","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8953113,33.2715829],[-96.8951639,33.2715802],[-96.8951639,33.2715802],[-96.8951737,33.2712489],[-96.8951737,33.2712489],[-96.8953205,33.2712521],[-96.8953205,33.2712521],[-96.8953113,33.2715829],[-96.8953113,33.2715829]]]},"properties":{"lotName":"6-D-21","lotCpId":"5182801615543275591","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954586,33.2715861],[-96.8953113,33.2715829],[-96.8953113,33.2715829],[-96.8953205,33.2712521],[-96.8953205,33.2712521],[-96.8954679,33.2712548],[-96.8954679,33.2712548],[-96.8954586,33.2715861],[-96.8954586,33.2715861]]]},"properties":{"lotName":"6-D-20","lotCpId":"1317161615543275390","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.895606,33.2715888],[-96.8954586,33.2715861],[-96.8954586,33.2715861],[-96.8954679,33.2712548],[-96.8954679,33.2712548],[-96.8956152,33.271258],[-96.8956152,33.271258],[-96.895606,33.2715888],[-96.895606,33.2715888]]]},"properties":{"lotName":"6-D-19","lotCpId":"3362041615543275451","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8957533,33.271592],[-96.895606,33.2715888],[-96.895606,33.2715888],[-96.8956152,33.271258],[-96.8956152,33.271258],[-96.8957626,33.2712608],[-96.8957626,33.2712608],[-96.8957533,33.271592],[-96.8957533,33.271592]]]},"properties":{"lotName":"6-D-18","lotCpId":"8624021615543275411","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8959007,33.2715948],[-96.8957533,33.271592],[-96.8957533,33.271592],[-96.8957626,33.2712608],[-96.8957626,33.2712608],[-96.89591,33.2712635],[-96.89591,33.2712635],[-96.8959007,33.2715948],[-96.8959007,33.2715948]]]},"properties":{"lotName":"6-D-17","lotCpId":"5537121615543275449","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.896048,33.271598],[-96.8959007,33.2715948],[-96.8959007,33.2715948],[-96.89591,33.2712635],[-96.89591,33.2712635],[-96.8960573,33.2712667],[-96.8960573,33.2712667],[-96.896048,33.271598],[-96.896048,33.271598]]]},"properties":{"lotName":"6-D-16","lotCpId":"4122821615543275450","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961954,33.2716007],[-96.896048,33.271598],[-96.896048,33.271598],[-96.8960573,33.2712667],[-96.8960573,33.2712667],[-96.8962047,33.2712694],[-96.8962047,33.2712694],[-96.8961954,33.2716007],[-96.8961954,33.2716007]]]},"properties":{"lotName":"6-D-15","lotCpId":"4375261615543275446","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8960671,33.2709354],[-96.896214,33.2709386],[-96.896214,33.2709386],[-96.8962047,33.2712694],[-96.8962047,33.2712694],[-96.8960573,33.2712667],[-96.8960573,33.2712667],[-96.8960671,33.2709354],[-96.8960671,33.2709354]]]},"properties":{"lotName":"6-D-14","lotCpId":"8230601615543275500","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8959198,33.2709327],[-96.8960671,33.2709354],[-96.8960671,33.2709354],[-96.8960573,33.2712667],[-96.8960573,33.2712667],[-96.89591,33.2712635],[-96.89591,33.2712635],[-96.8959198,33.2709327],[-96.8959198,33.2709327]]]},"properties":{"lotName":"6-D-13","lotCpId":"3840241615543275463","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8957724,33.2709295],[-96.8959198,33.2709327],[-96.8959198,33.2709327],[-96.89591,33.2712635],[-96.89591,33.2712635],[-96.8957626,33.2712608],[-96.8957626,33.2712608],[-96.8957724,33.2709295],[-96.8957724,33.2709295]]]},"properties":{"lotName":"6-D-12","lotCpId":"7148721615543275421","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8956251,33.2709267],[-96.8957724,33.2709295],[-96.8957724,33.2709295],[-96.8957626,33.2712608],[-96.8957626,33.2712608],[-96.8956152,33.271258],[-96.8956152,33.271258],[-96.8956251,33.2709267],[-96.8956251,33.2709267]]]},"properties":{"lotName":"6-D-11","lotCpId":"2113041615543275412","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954777,33.2709235],[-96.8956251,33.2709267],[-96.8956251,33.2709267],[-96.8956152,33.271258],[-96.8956152,33.271258],[-96.8954679,33.2712548],[-96.8954679,33.2712548],[-96.8954777,33.2709235],[-96.8954777,33.2709235]]]},"properties":{"lotName":"6-D-10","lotCpId":"5100101615543275427","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8953304,33.2709208],[-96.8954777,33.2709235],[-96.8954777,33.2709235],[-96.8954679,33.2712548],[-96.8954679,33.2712548],[-96.8953205,33.2712521],[-96.8953205,33.2712521],[-96.8953304,33.2709208],[-96.8953304,33.2709208]]]},"properties":{"lotName":"6-D-9","lotCpId":"2630831615543275436","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.895183,33.2709176],[-96.8953304,33.2709208],[-96.8953304,33.2709208],[-96.8953205,33.2712521],[-96.8953205,33.2712521],[-96.8951737,33.2712489],[-96.8951737,33.2712489],[-96.895183,33.2709176],[-96.895183,33.2709176]]]},"properties":{"lotName":"6-D-8","lotCpId":"4706261615543275382","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8950356,33.2709149],[-96.895183,33.2709176],[-96.895183,33.2709176],[-96.8951737,33.2712489],[-96.8951737,33.2712489],[-96.8950264,33.2712462],[-96.8950264,33.2712462],[-96.8950356,33.2709149],[-96.8950356,33.2709149]]]},"properties":{"lotName":"6-D-7","lotCpId":"8841081615543275400","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8948883,33.2709117],[-96.8950356,33.2709149],[-96.8950356,33.2709149],[-96.8950264,33.2712462],[-96.8950264,33.2712462],[-96.894879,33.271243],[-96.894879,33.271243],[-96.8948883,33.2709117],[-96.8948883,33.2709117]]]},"properties":{"lotName":"6-D-6","lotCpId":"2071541615542901535","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947409,33.2709089],[-96.8948883,33.2709117],[-96.8948883,33.2709117],[-96.894879,33.271243],[-96.894879,33.271243],[-96.8947317,33.2712402],[-96.8947317,33.2712402],[-96.8947409,33.2709089],[-96.8947409,33.2709089]]]},"properties":{"lotName":"6-D-5","lotCpId":"2371541615542901520","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945936,33.2709058],[-96.8947409,33.2709089],[-96.8947409,33.2709089],[-96.8947317,33.2712402],[-96.8947317,33.2712402],[-96.8945843,33.271237],[-96.8945843,33.271237],[-96.8945936,33.2709058],[-96.8945936,33.2709058]]]},"properties":{"lotName":"6-D-4","lotCpId":"3200661615542901556","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944462,33.270903],[-96.8945936,33.2709058],[-96.8945936,33.2709058],[-96.8945843,33.271237],[-96.8945843,33.271237],[-96.8944369,33.2712343],[-96.8944369,33.2712343],[-96.8944462,33.270903],[-96.8944462,33.270903]]]},"properties":{"lotName":"6-D-3","lotCpId":"3304501615542901528","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8942989,33.2708998],[-96.8944462,33.270903],[-96.8944462,33.270903],[-96.8944369,33.2712343],[-96.8944369,33.2712343],[-96.8942896,33.2712311],[-96.8942896,33.2712311],[-96.8942989,33.2708998],[-96.8942989,33.2708998]]]},"properties":{"lotName":"6-D-2","lotCpId":"4443751615542901479","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8941319,33.2708966],[-96.8942989,33.2708998],[-96.8942989,33.2708998],[-96.8942896,33.2712311],[-96.8942896,33.2712311],[-96.8940898,33.2712274],[-96.8940898,33.2712274],[-96.8940986,33.2709235],[-96.8941319,33.2708966],[-96.8941319,33.2708966]]]},"properties":{"lotName":"6-D-1","lotCpId":"7067051615542901479","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.893913,33.271692],[-96.8940762,33.2716952],[-96.8940762,33.2716952],[-96.8940669,33.2720237],[-96.8940669,33.2720237],[-96.8939032,33.2720205],[-96.8939032,33.2720205],[-96.893913,33.271692],[-96.893913,33.271692]]]},"properties":{"lotName":"6-B-30","lotCpId":"4476431615544025491","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8969169,33.271994],[-96.8969276,33.2720061],[-96.896954,33.2720399],[-96.8969873,33.272092],[-96.8970188,33.2721591],[-96.8970261,33.2721761],[-96.8970261,33.2721761],[-96.8966468,33.2722838],[-96.8966468,33.2722838],[-96.8965964,33.272189],[-96.8965964,33.272189],[-96.8969169,33.271994],[-96.8969169,33.271994]]]},"properties":{"lotName":"6-B-49","lotCpId":"4412111615544025693","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.896733,33.2718457],[-96.8967498,33.2718554],[-96.8967932,33.2718839],[-96.8968525,33.2719304],[-96.8969169,33.271994],[-96.8969169,33.271994],[-96.8965964,33.272189],[-96.8965964,33.272189],[-96.8965113,33.2721203],[-96.8965113,33.2721203],[-96.896733,33.2718457],[-96.896733,33.2718457]]]},"properties":{"lotName":"6-B-48","lotCpId":"2870441615544025717","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8964994,33.2717586],[-96.8965217,33.2717637],[-96.8965782,33.2717795],[-96.8966538,33.2718066],[-96.896733,33.2718457],[-96.896733,33.2718457],[-96.8965113,33.2721203],[-96.8965113,33.2721203],[-96.8964033,33.2720803],[-96.8964033,33.2720803],[-96.8964994,33.2717586],[-96.8964994,33.2717586]]]},"properties":{"lotName":"6-B-47","lotCpId":"1467451615544025744","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.896286,33.2717394],[-96.8963383,33.271741],[-96.896355,33.2717416],[-96.8963962,33.271744],[-96.8964994,33.2717586],[-96.8964994,33.2717586],[-96.8964033,33.2720803],[-96.8964033,33.2720803],[-96.8962768,33.272068],[-96.8962768,33.272068],[-96.896286,33.2717394],[-96.896286,33.2717394]]]},"properties":{"lotName":"6-B-46","lotCpId":"1886511615544025660","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8961386,33.2717367],[-96.896286,33.2717394],[-96.896286,33.2717394],[-96.8962768,33.272068],[-96.8962768,33.272068],[-96.8961294,33.2720652],[-96.8961294,33.2720652],[-96.8961386,33.2717367],[-96.8961386,33.2717367]]]},"properties":{"lotName":"6-B-45","lotCpId":"2256201615544025668","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8959918,33.2717335],[-96.8961386,33.2717367],[-96.8961386,33.2717367],[-96.8961294,33.2720652],[-96.8961294,33.2720652],[-96.895982,33.272062],[-96.895982,33.272062],[-96.8959918,33.2717335],[-96.8959918,33.2717335]]]},"properties":{"lotName":"6-B-44","lotCpId":"7761541615544025550","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8958445,33.2717308],[-96.8959918,33.2717335],[-96.8959918,33.2717335],[-96.895982,33.272062],[-96.895982,33.272062],[-96.8958346,33.2720593],[-96.8958346,33.2720593],[-96.8958445,33.2717308],[-96.8958445,33.2717308]]]},"properties":{"lotName":"6-B-43","lotCpId":"2780751615544025569","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8956971,33.2717276],[-96.8958445,33.2717308],[-96.8958445,33.2717308],[-96.8958346,33.2720593],[-96.8958346,33.2720593],[-96.8956873,33.2720561],[-96.8956873,33.2720561],[-96.8956971,33.2717276],[-96.8956971,33.2717276]]]},"properties":{"lotName":"6-B-42","lotCpId":"4685311615544025496","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8955498,33.2717248],[-96.8956971,33.2717276],[-96.8956971,33.2717276],[-96.8956873,33.2720561],[-96.8956873,33.2720561],[-96.8955399,33.2720534],[-96.8955399,33.2720534],[-96.8955498,33.2717248],[-96.8955498,33.2717248]]]},"properties":{"lotName":"6-B-41","lotCpId":"3246511615544025529","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8954024,33.2717216],[-96.8955498,33.2717248],[-96.8955498,33.2717248],[-96.8955399,33.2720534],[-96.8955399,33.2720534],[-96.8953931,33.2720502],[-96.8953931,33.2720502],[-96.8954024,33.2717216],[-96.8954024,33.2717216]]]},"properties":{"lotName":"6-B-40","lotCpId":"3131461615544025454","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.895255,33.2717189],[-96.8954024,33.2717216],[-96.8954024,33.2717216],[-96.8953931,33.2720502],[-96.8953931,33.2720502],[-96.8952458,33.2720474],[-96.8952458,33.2720474],[-96.895255,33.2717189],[-96.895255,33.2717189]]]},"properties":{"lotName":"6-B-39","lotCpId":"7617671615544025541","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8951077,33.2717162],[-96.895255,33.2717189],[-96.895255,33.2717189],[-96.8952458,33.2720474],[-96.8952458,33.2720474],[-96.8950984,33.2720442],[-96.8950984,33.2720442],[-96.8951077,33.2717162],[-96.8951077,33.2717162]]]},"properties":{"lotName":"6-B-38","lotCpId":"6848361615544025513","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8949603,33.271713],[-96.8951077,33.2717162],[-96.8951077,33.2717162],[-96.8950984,33.2720442],[-96.8950984,33.2720442],[-96.8949511,33.2720415],[-96.8949512,33.2720374],[-96.8949512,33.2720374],[-96.8949603,33.271713],[-96.8949603,33.271713]]]},"properties":{"lotName":"6-B-37","lotCpId":"8416681615544025499","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.894813,33.2717102],[-96.8949603,33.271713],[-96.8949603,33.271713],[-96.8949511,33.2720415],[-96.8949511,33.2720415],[-96.8948037,33.2720383],[-96.8948037,33.2720383],[-96.894813,33.2717102],[-96.894813,33.2717102]]]},"properties":{"lotName":"6-B-36","lotCpId":"2588641615544025499","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8946656,33.271707],[-96.894813,33.2717102],[-96.894813,33.2717102],[-96.8948037,33.2720383],[-96.8948037,33.2720383],[-96.8946563,33.2720356],[-96.8946563,33.2720356],[-96.8946656,33.271707],[-96.8946656,33.271707]]]},"properties":{"lotName":"6-B-35","lotCpId":"7172121615544025462","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945183,33.2717043],[-96.8946656,33.271707],[-96.8946656,33.271707],[-96.8946563,33.2720356],[-96.8946563,33.2720356],[-96.894509,33.2720324],[-96.894509,33.2720324],[-96.8945183,33.2717043],[-96.8945183,33.2717043]]]},"properties":{"lotName":"6-B-34","lotCpId":"7116671615544025542","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8943709,33.2717011],[-96.8945183,33.2717043],[-96.8945183,33.2717043],[-96.894509,33.2720324],[-96.894509,33.2720324],[-96.8943616,33.2720296],[-96.8943618,33.2720242],[-96.8943618,33.2720242],[-96.8943709,33.2717011],[-96.8943709,33.2717011]]]},"properties":{"lotName":"6-B-33","lotCpId":"5262681615544025493","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8942235,33.2716984],[-96.8943709,33.2717011],[-96.8943709,33.2717011],[-96.8943616,33.2720296],[-96.8943616,33.2720296],[-96.8942143,33.2720264],[-96.8942143,33.2720264],[-96.8942235,33.2716984],[-96.8942235,33.2716984]]]},"properties":{"lotName":"6-B-32","lotCpId":"7016671615544025486","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8940762,33.2716952],[-96.8942235,33.2716984],[-96.8942235,33.2716984],[-96.8942143,33.2720264],[-96.8942143,33.2720264],[-96.8940669,33.2720237],[-96.8940669,33.2720237],[-96.8940762,33.2716952],[-96.8940762,33.2716952]]]},"properties":{"lotName":"6-B-31","lotCpId":"6467481615544025510","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8966222,33.2716468],[-96.8966144,33.2716442],[-96.896589,33.2716372],[-96.8965429,33.271627],[-96.8964728,33.2716147],[-96.8964728,33.2716147],[-96.8964415,33.2715829],[-96.8964503,33.2712744],[-96.8964503,33.2712744],[-96.8967543,33.2713347],[-96.8967543,33.2713347],[-96.8966222,33.2716468],[-96.8966222,33.2716468]]]},"properties":{"lotName":"6-E-16","lotCpId":"2734361615544025499","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8967472,33.2716933],[-96.8967339,33.2716878],[-96.8967014,33.2716747],[-96.8966222,33.2716468],[-96.8966222,33.2716468],[-96.8967543,33.2713347],[-96.8967543,33.2713347],[-96.8969349,33.2714013],[-96.8969349,33.2714013],[-96.8967472,33.2716933],[-96.8967472,33.2716933]]]},"properties":{"lotName":"6-E-15","lotCpId":"6364571615544025467","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8968629,33.2717549],[-96.8968505,33.2717477],[-96.8968203,33.2717304],[-96.8967472,33.2716933],[-96.8967472,33.2716933],[-96.8969349,33.2714013],[-96.8969349,33.2714013],[-96.8971014,33.2714907],[-96.8971014,33.2714907],[-96.8968629,33.2717549],[-96.8968629,33.2717549]]]},"properties":{"lotName":"6-E-14","lotCpId":"6306071615544025486","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.896966,33.2718311],[-96.8969553,33.2718224],[-96.896929,33.2718016],[-96.8968629,33.2717549],[-96.8968629,33.2717549],[-96.8971014,33.2714907],[-96.8971014,33.2714907],[-96.8972498,33.2715998],[-96.8972498,33.2715998],[-96.896966,33.2718311],[-96.896966,33.2718311]]]},"properties":{"lotName":"6-E-13","lotCpId":"1231581615544025458","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8970539,33.2719187],[-96.8970448,33.2719088],[-96.8970223,33.2718848],[-96.896966,33.2718311],[-96.896966,33.2718311],[-96.8972498,33.2715998],[-96.8972498,33.2715998],[-96.8973764,33.2717266],[-96.8973764,33.2717266],[-96.8970539,33.2719187],[-96.8970539,33.2719187]]]},"properties":{"lotName":"6-E-12","lotCpId":"8060651615544025471","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971248,33.2720169],[-96.8971182,33.2720063],[-96.8971012,33.2719806],[-96.8970539,33.2719187],[-96.8970539,33.2719187],[-96.8973764,33.2717266],[-96.8973764,33.2717266],[-96.8974785,33.2718676],[-96.8974785,33.2718676],[-96.8971248,33.2720169],[-96.8971248,33.2720169]]]},"properties":{"lotName":"6-E-11","lotCpId":"5042841615544025497","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971811,33.2721323],[-96.8971739,33.2721152],[-96.8971693,33.2721046],[-96.8971577,33.2720788],[-96.8971248,33.2720169],[-96.8971248,33.2720169],[-96.8974785,33.2718676],[-96.8974785,33.2718676],[-96.8975571,33.272026],[-96.8975571,33.272026],[-96.8971811,33.2721323],[-96.8971811,33.2721323]]]},"properties":{"lotName":"6-E-10","lotCpId":"8111441615544025513","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8978453,33.2717408],[-96.897853,33.2717542],[-96.8978726,33.2717901],[-96.897924,33.2719026],[-96.8979315,33.2719197],[-96.8979315,33.2719197],[-96.8975571,33.272026],[-96.8975571,33.272026],[-96.8974872,33.2718854],[-96.8974872,33.2718854],[-96.8978453,33.2717408],[-96.8978453,33.2717408]]]},"properties":{"lotName":"6-E-9","lotCpId":"4347281615544025461","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8977432,33.2715884],[-96.897754,33.2716028],[-96.8977806,33.2716395],[-96.8978453,33.2717408],[-96.8978453,33.2717408],[-96.8974872,33.2718854],[-96.8974872,33.2718854],[-96.8974785,33.2718676],[-96.8974076,33.2717695],[-96.8974076,33.2717695],[-96.8977432,33.2715884],[-96.8977432,33.2715884]]]},"properties":{"lotName":"6-E-8","lotCpId":"1358741615544025503","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8976193,33.2714478],[-96.8976329,33.2714619],[-96.8976659,33.2714971],[-96.8977432,33.2715884],[-96.8977432,33.2715884],[-96.8974076,33.2717695],[-96.8974076,33.2717695],[-96.8973764,33.2717266],[-96.8973126,33.2716623],[-96.8973126,33.2716623],[-96.8976193,33.2714478],[-96.8976193,33.2714478]]]},"properties":{"lotName":"6-E-7","lotCpId":"2881641615543275665","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8974752,33.271321],[-96.8974912,33.271334],[-96.89753,33.2713661],[-96.8976193,33.2714478],[-96.8976193,33.2714478],[-96.8973126,33.2716623],[-96.8973126,33.2716623],[-96.8972498,33.2715998],[-96.8972029,33.2715656],[-96.8972029,33.2715656],[-96.8974752,33.271321],[-96.8974752,33.271321]]]},"properties":{"lotName":"6-E-6","lotCpId":"6160171615543275718","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973142,33.2712101],[-96.8973318,33.2712212],[-96.8973745,33.2712489],[-96.8974752,33.271321],[-96.8974752,33.271321],[-96.8972029,33.2715656],[-96.8972029,33.2715656],[-96.8971014,33.2714907],[-96.8970806,33.2714793],[-96.8970806,33.2714793],[-96.8973142,33.2712101],[-96.8973142,33.2712101]]]},"properties":{"lotName":"6-E-5","lotCpId":"4653321615543275749","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971374,33.2711166],[-96.8971555,33.271125],[-96.8972004,33.2711469],[-96.8973142,33.2712101],[-96.8973142,33.2712101],[-96.8970806,33.2714793],[-96.8970806,33.2714793],[-96.8969458,33.2714072],[-96.8969458,33.2714072],[-96.8971374,33.2711166],[-96.8971374,33.2711166]]]},"properties":{"lotName":"6-E-4","lotCpId":"8122651615543275671","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8969486,33.2710417],[-96.8969722,33.2710506],[-96.8970272,33.2710717],[-96.8970902,33.2710964],[-96.8971374,33.2711166],[-96.8971374,33.2711166],[-96.8969458,33.2714072],[-96.8969458,33.2714072],[-96.8969349,33.2714013],[-96.8968007,33.2713516],[-96.8968007,33.2713516],[-96.8969486,33.2710417],[-96.8969486,33.2710417]]]},"properties":{"lotName":"6-E-3","lotCpId":"6164201615543275681","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8967499,33.270987],[-96.8967714,33.2709919],[-96.8968237,33.2710046],[-96.8969486,33.2710417],[-96.8969486,33.2710417],[-96.8968007,33.2713516],[-96.8968007,33.2713516],[-96.8967543,33.2713347],[-96.8966478,33.2713137],[-96.8966478,33.2713137],[-96.8967499,33.270987],[-96.8967499,33.270987]]]},"properties":{"lotName":"6-E-2","lotCpId":"4067101615543275666","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8964923,33.2709482],[-96.896517,33.2709504],[-96.8965797,33.2709573],[-96.8967499,33.270987],[-96.8967499,33.270987],[-96.8966478,33.2713137],[-96.8966478,33.2713137],[-96.8964503,33.2712744],[-96.8964503,33.2712744],[-96.896459,33.2709733],[-96.8964923,33.2709482],[-96.8964923,33.2709482]]]},"properties":{"lotName":"6-E-1","lotCpId":"2220381615543275671","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989084,33.2715542],[-96.8989292,33.2717193],[-96.8989292,33.2717193],[-96.8989167,33.2717209],[-96.8988827,33.2717251],[-96.8987706,33.2717398],[-96.8986343,33.2717593],[-96.8985149,33.2717796],[-96.8985149,33.2717796],[-96.8984314,33.2715961],[-96.8984314,33.2715961],[-96.8989084,33.2715542],[-96.8989084,33.2715542]]]},"properties":{"lotName":"6-G-10","lotCpId":"3115541615545103370","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988877,33.2713908],[-96.8989084,33.2715542],[-96.8989084,33.2715542],[-96.8984314,33.2715961],[-96.8984314,33.2715961],[-96.8983588,33.2714373],[-96.8983588,33.2714373],[-96.8988877,33.2713908],[-96.8988877,33.2713908]]]},"properties":{"lotName":"6-G-9","lotCpId":"6038041615545103366","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988615,33.2712115],[-96.898863,33.27122],[-96.8988671,33.2712431],[-96.8988784,33.2713201],[-96.8988877,33.2713908],[-96.8988877,33.2713908],[-96.8983588,33.2714373],[-96.8983588,33.2714373],[-96.8982906,33.2712872],[-96.8982906,33.2712872],[-96.8988615,33.2712115],[-96.8988615,33.2712115]]]},"properties":{"lotName":"6-G-8","lotCpId":"6476281615545103359","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988156,33.2710248],[-96.8988212,33.2710447],[-96.8988344,33.2710933],[-96.8988615,33.2712115],[-96.8988615,33.2712115],[-96.8982906,33.2712872],[-96.8982906,33.2712872],[-96.8982278,33.271149],[-96.8982278,33.271149],[-96.8988156,33.2710248],[-96.8988156,33.2710248]]]},"properties":{"lotName":"6-G-7","lotCpId":"7504551615545103099","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898749,33.2708405],[-96.8987589,33.2708651],[-96.8987648,33.2708794],[-96.8987795,33.2709165],[-96.8988156,33.2710248],[-96.8988156,33.2710248],[-96.8982278,33.271149],[-96.8982278,33.271149],[-96.8981613,33.2710034],[-96.8981613,33.2710034],[-96.898749,33.2708405],[-96.898749,33.2708405]]]},"properties":{"lotName":"6-G-6","lotCpId":"2214841615545103100","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898689,33.2706776],[-96.8986947,33.2706939],[-96.8987092,33.2707348],[-96.898749,33.2708405],[-96.898749,33.2708405],[-96.8981613,33.2710034],[-96.8981613,33.2710034],[-96.8980799,33.2708241],[-96.8980799,33.2708241],[-96.898689,33.2706776],[-96.898689,33.2706776]]]},"properties":{"lotName":"6-G-5","lotCpId":"3452081615545103098","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8986366,33.2705133],[-96.898642,33.270531],[-96.8986552,33.270574],[-96.898689,33.2706776],[-96.898689,33.2706776],[-96.8980799,33.2708241],[-96.8980799,33.2708241],[-96.8979975,33.2706438],[-96.8979975,33.2706438],[-96.8986366,33.2705133],[-96.8986366,33.2705133]]]},"properties":{"lotName":"6-G-4","lotCpId":"6372031615545103112","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8981913,33.2702062],[-96.8982136,33.2701976],[-96.8982771,33.2701762],[-96.8983761,33.2701487],[-96.8985053,33.2701221],[-96.8985053,33.2701221],[-96.8985444,33.2701433],[-96.898587,33.2703258],[-96.8985928,33.2703487],[-96.8986066,33.2704026],[-96.898623,33.2704649],[-96.8986366,33.2705133],[-96.8986366,33.2705133],[-96.8983861,33.2705644],[-96.8983861,33.2705644],[-96.8981913,33.2702062],[-96.8981913,33.2702062]]]},"properties":{"lotName":"6-G-3","lotCpId":"5886571615545103100","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980123,33.2702742],[-96.8981913,33.2702062],[-96.8981913,33.2702062],[-96.8983861,33.2705644],[-96.8983861,33.2705644],[-96.8981918,33.2706041],[-96.8981918,33.2706041],[-96.8980123,33.2702742],[-96.8980123,33.2702742]]]},"properties":{"lotName":"6-G-2","lotCpId":"7135821615545103099","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8978332,33.2703422],[-96.8980123,33.2702742],[-96.8980123,33.2702742],[-96.8981918,33.2706041],[-96.8981918,33.2706041],[-96.8979975,33.2706438],[-96.8979975,33.2706438],[-96.8978332,33.2703422],[-96.8978332,33.2703422]]]},"properties":{"lotName":"6-G-1","lotCpId":"7628411615545103057","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.897526,33.2706466],[-96.8975248,33.2706324],[-96.8975203,33.2705953],[-96.8974947,33.2704859],[-96.8974947,33.2704859],[-96.8975171,33.2704512],[-96.8975329,33.2704471],[-96.8975783,33.2704339],[-96.8976502,33.2704106],[-96.8977457,33.270376],[-96.8978332,33.2703422],[-96.8978332,33.2703422],[-96.8979866,33.2706228],[-96.8979866,33.2706228],[-96.897526,33.2706466],[-96.897526,33.2706466]]]},"properties":{"lotName":"6-G-19","lotCpId":"5753651615545103728","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8975222,33.2707871],[-96.8975236,33.2707727],[-96.8975263,33.2707369],[-96.897526,33.2706466],[-96.897526,33.2706466],[-96.8979866,33.2706228],[-96.8979866,33.2706228],[-96.8979975,33.2706438],[-96.8980865,33.2708382],[-96.8980865,33.2708382],[-96.8975222,33.2707871],[-96.8975222,33.2707871]]]},"properties":{"lotName":"6-G-18","lotCpId":"5477361615545103729","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.89749,33.2709254],[-96.8974943,33.2709121],[-96.8975043,33.2708786],[-96.8975222,33.2707871],[-96.8975222,33.2707871],[-96.8980865,33.2708382],[-96.8980865,33.2708382],[-96.8981149,33.2709012],[-96.89795,33.2710349],[-96.89795,33.2710349],[-96.89749,33.2709254],[-96.89749,33.2709254]]]},"properties":{"lotName":"6-G-17","lotCpId":"8647871615545103725","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8974212,33.2710723],[-96.8974292,33.2710586],[-96.8974484,33.2710234],[-96.89749,33.2709254],[-96.89749,33.2709254],[-96.89795,33.2710349],[-96.89795,33.2710349],[-96.8976537,33.2712754],[-96.8976537,33.2712754],[-96.8976388,33.2712625],[-96.8975956,33.2712274],[-96.8975259,33.2711757],[-96.8974318,33.2711128],[-96.8974212,33.2710723],[-96.8974212,33.2710723]]]},"properties":{"lotName":"6-G-16","lotCpId":"4021581615545103720","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8977628,33.271378],[-96.8977513,33.2713666],[-96.897723,33.2713391],[-96.8976537,33.2712754],[-96.8976537,33.2712754],[-96.8981149,33.2709012],[-96.8981149,33.2709012],[-96.8981978,33.2710828],[-96.8981978,33.2710828],[-96.8977628,33.271378],[-96.8977628,33.271378]]]},"properties":{"lotName":"6-G-15","lotCpId":"4773881615545103724","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8978605,33.2714885],[-96.8978494,33.2714753],[-96.8978228,33.2714441],[-96.8977906,33.2714075],[-96.8977628,33.271378],[-96.8977628,33.271378],[-96.8981978,33.2710828],[-96.8981978,33.2710828],[-96.8982759,33.2712544],[-96.8982759,33.2712544],[-96.8978605,33.2714885],[-96.8978605,33.2714885]]]},"properties":{"lotName":"6-G-14","lotCpId":"8613401615545103455","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979462,33.2716057],[-96.8979373,33.2715927],[-96.8979153,33.2715611],[-96.8978605,33.2714885],[-96.8978605,33.2714885],[-96.8982759,33.2712544],[-96.8982759,33.2712544],[-96.8983506,33.2714191],[-96.8983506,33.2714191],[-96.8979462,33.2716057],[-96.8979462,33.2716057]]]},"properties":{"lotName":"6-G-13","lotCpId":"1755721615545103384","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980194,33.2717289],[-96.898011,33.2717141],[-96.8979909,33.2716791],[-96.8979667,33.2716382],[-96.8979462,33.2716057],[-96.8979462,33.2716057],[-96.8983506,33.2714191],[-96.8983506,33.2714191],[-96.8984238,33.2715797],[-96.8984238,33.2715797],[-96.8980194,33.2717289],[-96.8980194,33.2717289]]]},"properties":{"lotName":"6-G-12","lotCpId":"1827801615545103385","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898087,33.2718763],[-96.8980794,33.2718585],[-96.898074,33.2718458],[-96.8980601,33.2718139],[-96.8980194,33.2717289],[-96.8980194,33.2717289],[-96.8984238,33.2715797],[-96.8984238,33.2715797],[-96.8985149,33.2717796],[-96.8985149,33.2717796],[-96.8985057,33.2717812],[-96.8984797,33.2717861],[-96.8983852,33.2718051],[-96.8982487,33.2718355],[-96.898087,33.2718763],[-96.898087,33.2718763]]]},"properties":{"lotName":"6-G-11","lotCpId":"6882741615545103361","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8967204,33.2704148],[-96.8965076,33.2704102],[-96.8965076,33.2704102],[-96.8964759,33.2703824],[-96.8964847,33.2700785],[-96.8964847,33.2700785],[-96.8967303,33.2700835],[-96.8967303,33.2700835],[-96.8967204,33.2704148],[-96.8967204,33.2704148]]]},"properties":{"lotName":"6-H-17","lotCpId":"8616431615545171805","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8969688,33.2704079],[-96.8969505,33.2704094],[-96.8968995,33.2704125],[-96.8968209,33.270415],[-96.8967204,33.2704148],[-96.8967204,33.2704148],[-96.8967303,33.2700835],[-96.8967303,33.2700835],[-96.8967499,33.2700839],[-96.8969327,33.2700734],[-96.8969327,33.2700734],[-96.8969688,33.2704079],[-96.8969688,33.2704079]]]},"properties":{"lotName":"6-H-16","lotCpId":"2176001615545171494","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8972116,33.2703778],[-96.8971899,33.2703816],[-96.8971334,33.2703905],[-96.8969688,33.2704079],[-96.8969688,33.2704079],[-96.8969327,33.2700734],[-96.8969327,33.2700734],[-96.897031,33.270068],[-96.8971314,33.2700493],[-96.8971314,33.2700493],[-96.8972116,33.2703778],[-96.8972116,33.2703778]]]},"properties":{"lotName":"6-H-15","lotCpId":"7055531615545171495","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8974496,33.2703253],[-96.897429,33.270331],[-96.897375,33.2703447],[-96.8972988,33.2703619],[-96.8972116,33.2703778],[-96.8972116,33.2703778],[-96.8971314,33.2700493],[-96.8971314,33.2700493],[-96.8973049,33.2700159],[-96.8973262,33.2700091],[-96.8973262,33.2700091],[-96.8974496,33.2703253],[-96.8974496,33.2703253]]]},"properties":{"lotName":"6-H-14","lotCpId":"5261041615545171495","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8976783,33.2702509],[-96.8976573,33.2702588],[-96.8976033,33.2702782],[-96.8974496,33.2703253],[-96.8974496,33.2703253],[-96.8973262,33.2700091],[-96.8973262,33.2700091],[-96.8975129,33.2699475],[-96.8975129,33.2699475],[-96.8976783,33.2702509],[-96.8976783,33.2702509]]]},"properties":{"lotName":"6-H-13","lotCpId":"4630851615545171042","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.897872,33.270177],[-96.8976783,33.2702509],[-96.8976783,33.2702509],[-96.8975129,33.2699475],[-96.8975129,33.2699475],[-96.8975565,33.2699329],[-96.8977077,33.2698754],[-96.8977077,33.2698754],[-96.897872,33.270177],[-96.897872,33.270177]]]},"properties":{"lotName":"6-H-12","lotCpId":"4312311615545171042","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980657,33.2701036],[-96.897872,33.270177],[-96.897872,33.270177],[-96.8977077,33.2698754],[-96.8977077,33.2698754],[-96.8979015,33.2698019],[-96.8979015,33.2698019],[-96.8980657,33.2701036],[-96.8980657,33.2701036]]]},"properties":{"lotName":"6-H-11","lotCpId":"5531361615545171042","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982606,33.2700356],[-96.8982488,33.270039],[-96.8982178,33.2700487],[-96.8981231,33.2700817],[-96.8980657,33.2701036],[-96.8980657,33.2701036],[-96.8979015,33.2698019],[-96.8979015,33.2698019],[-96.8981307,33.2697225],[-96.8981307,33.2697225],[-96.8982606,33.2700356],[-96.8982606,33.2700356]]]},"properties":{"lotName":"6-H-10","lotCpId":"7821501615545104569","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8984738,33.2699877],[-96.8984514,33.2699917],[-96.8983964,33.2700024],[-96.8982606,33.2700356],[-96.8982606,33.2700356],[-96.8981307,33.2697225],[-96.8981307,33.2697225],[-96.8984303,33.2696573],[-96.8984303,33.2696573],[-96.8985002,33.2699553],[-96.8984738,33.2699877],[-96.8984738,33.2699877]]]},"properties":{"lotName":"6-H-9","lotCpId":"2541031615545104353","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980625,33.2693926],[-96.898083,33.2693871],[-96.8981389,33.2693732],[-96.8982214,33.2693551],[-96.8983217,33.2693369],[-96.8983217,33.2693369],[-96.8983605,33.2693589],[-96.8984303,33.2696573],[-96.8984303,33.2696573],[-96.8981831,33.2697111],[-96.8981831,33.2697111],[-96.8980625,33.2693926],[-96.8980625,33.2693926]]]},"properties":{"lotName":"6-H-8","lotCpId":"4253451615545104352","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8978098,33.2694729],[-96.8978339,33.2694642],[-96.8978951,33.2694429],[-96.8980625,33.2693926],[-96.8980625,33.2693926],[-96.8981831,33.2697111],[-96.8981831,33.2697111],[-96.8981307,33.2697225],[-96.8979751,33.2697764],[-96.8979751,33.2697764],[-96.8978098,33.2694729],[-96.8978098,33.2694729]]]},"properties":{"lotName":"6-H-7","lotCpId":"5544231615545104349","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8976013,33.2695523],[-96.8977945,33.2694784],[-96.8978098,33.2694729],[-96.8978098,33.2694729],[-96.8979751,33.2697764],[-96.8979751,33.2697764],[-96.8979015,33.2698019],[-96.8977656,33.2698535],[-96.8977656,33.2698535],[-96.8976013,33.2695523],[-96.8976013,33.2695523]]]},"properties":{"lotName":"6-H-6","lotCpId":"8731421615545104347","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973928,33.2696317],[-96.8976013,33.2695523],[-96.8976013,33.2695523],[-96.8977656,33.2698535],[-96.8977656,33.2698535],[-96.8975565,33.2699329],[-96.8975565,33.2699329],[-96.8973928,33.2696317],[-96.8973928,33.2696317]]]},"properties":{"lotName":"6-H-5","lotCpId":"2072571615545104332","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971871,33.2696997],[-96.8971991,33.2696968],[-96.8972327,33.2696876],[-96.897284,33.2696717],[-96.8973493,33.2696484],[-96.8973928,33.2696317],[-96.8973928,33.2696317],[-96.8975565,33.2699329],[-96.8975565,33.2699329],[-96.8973049,33.2700159],[-96.8973049,33.2700159],[-96.8971871,33.2696997],[-96.8971871,33.2696997]]]},"properties":{"lotName":"6-H-4","lotCpId":"5263541615545104349","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8969737,33.2697403],[-96.8969936,33.2697379],[-96.8970446,33.2697303],[-96.8971871,33.2696997],[-96.8971871,33.2696997],[-96.8973049,33.2700159],[-96.8973049,33.2700159],[-96.897031,33.270068],[-96.897031,33.270068],[-96.8969737,33.2697403],[-96.8969737,33.2697403]]]},"properties":{"lotName":"6-H-3","lotCpId":"2070061615545104329","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8967554,33.2697527],[-96.8967753,33.2697528],[-96.8968268,33.2697521],[-96.8969737,33.2697403],[-96.8969737,33.2697403],[-96.897031,33.270068],[-96.897031,33.270068],[-96.8967499,33.2700839],[-96.8967499,33.2700839],[-96.8967554,33.2697527],[-96.8967554,33.2697527]]]},"properties":{"lotName":"6-H-2","lotCpId":"8506621615545103976","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8965267,33.2697481],[-96.8967395,33.2697522],[-96.8967554,33.2697527],[-96.8967554,33.2697527],[-96.8967499,33.2700839],[-96.8967499,33.2700839],[-96.8964847,33.2700785],[-96.8964847,33.2700785],[-96.8964934,33.2697746],[-96.8965267,33.2697481],[-96.8965267,33.2697481]]]},"properties":{"lotName":"6-H-1","lotCpId":"2102201615545103733","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999914,33.2721864],[-96.8999944,33.2722029],[-96.9000011,33.272242],[-96.9000086,33.2722877],[-96.9000138,33.2723242],[-96.9000138,33.2723242],[-96.8996181,33.2723603],[-96.8996181,33.2723603],[-96.8996138,33.2723155],[-96.8995996,33.2722389],[-96.8995996,33.2722389],[-96.8999914,33.2721864],[-96.8999914,33.2721864]]]},"properties":{"lotName":"10-B-31","lotCpId":"5434501672819082538","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005004,33.2698193],[-96.9005386,33.2699808],[-96.9005386,33.2699808],[-96.9001255,33.2700483],[-96.9001255,33.2700483],[-96.9000878,33.2698873],[-96.9000878,33.2698873],[-96.9005004,33.2698193],[-96.9005004,33.2698193]]]},"properties":{"lotName":"6-K-21","lotCpId":"3801421615545424097","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004628,33.2696582],[-96.9005004,33.2698193],[-96.9005004,33.2698193],[-96.9000878,33.2698873],[-96.9000878,33.2698873],[-96.9000502,33.2697257],[-96.9000502,33.2697257],[-96.9004628,33.2696582],[-96.9004628,33.2696582]]]},"properties":{"lotName":"6-K-20","lotCpId":"1243011615545424084","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004251,33.2694971],[-96.9004628,33.2696582],[-96.9004628,33.2696582],[-96.9000502,33.2697257],[-96.9000502,33.2697257],[-96.900012,33.2695646],[-96.900012,33.2695646],[-96.9004251,33.2694971],[-96.9004251,33.2694971]]]},"properties":{"lotName":"6-K-19","lotCpId":"7542261615545424097","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9003874,33.2693356],[-96.9004251,33.2694971],[-96.9004251,33.2694971],[-96.900012,33.2695646],[-96.900012,33.2695646],[-96.8999743,33.2694036],[-96.8999743,33.2694036],[-96.9003874,33.2693356],[-96.9003874,33.2693356]]]},"properties":{"lotName":"6-K-18","lotCpId":"4757361615545424114","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9003492,33.2691745],[-96.9003874,33.2693356],[-96.9003874,33.2693356],[-96.8999743,33.2694036],[-96.8999743,33.2694036],[-96.8999366,33.2692425],[-96.8999366,33.2692425],[-96.9003492,33.2691745],[-96.9003492,33.2691745]]]},"properties":{"lotName":"6-K-17","lotCpId":"7303781615545424085","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9002057,33.2689121],[-96.9002105,33.2689173],[-96.9002236,33.2689323],[-96.9002654,33.2689879],[-96.9003133,33.2690711],[-96.9003492,33.2691745],[-96.9003492,33.2691745],[-96.8999366,33.2692425],[-96.8999366,33.2692425],[-96.8998717,33.2690782],[-96.8998717,33.2690782],[-96.8998986,33.2690684],[-96.8999714,33.2690382],[-96.9000778,33.2689865],[-96.9002057,33.2689121],[-96.9002057,33.2689121]]]},"properties":{"lotName":"6-K-16","lotCpId":"1385051615545424084","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8995289,33.2693342],[-96.8994913,33.2691731],[-96.8994913,33.2691731],[-96.8995386,33.2691652],[-96.8995672,33.2691603],[-96.8996427,33.269145],[-96.8997494,33.269118],[-96.8998717,33.2690782],[-96.8998717,33.2690782],[-96.8999366,33.2692425],[-96.8999421,33.2692667],[-96.8999421,33.2692667],[-96.8995289,33.2693342],[-96.8995289,33.2693342]]]},"properties":{"lotName":"6-K-15","lotCpId":"5177371615545424112","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8995672,33.2694957],[-96.8995289,33.2693342],[-96.8995289,33.2693342],[-96.8999421,33.2692667],[-96.8999421,33.2692667],[-96.8999798,33.2694278],[-96.8999798,33.2694278],[-96.8995672,33.2694957],[-96.8995672,33.2694957]]]},"properties":{"lotName":"6-K-14","lotCpId":"1525721615545424084","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996048,33.2696568],[-96.8995672,33.2694957],[-96.8995672,33.2694957],[-96.8999798,33.2694278],[-96.8999798,33.2694278],[-96.900018,33.2695888],[-96.900018,33.2695888],[-96.8996048,33.2696568],[-96.8996048,33.2696568]]]},"properties":{"lotName":"6-K-13","lotCpId":"6825881615545424084","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996425,33.2698179],[-96.8996048,33.2696568],[-96.8996048,33.2696568],[-96.900018,33.2695888],[-96.900018,33.2695888],[-96.9000556,33.2697504],[-96.9000556,33.2697504],[-96.8996425,33.2698179],[-96.8996425,33.2698179]]]},"properties":{"lotName":"6-K-12","lotCpId":"1827101615545424095","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996807,33.269979],[-96.8996425,33.2698179],[-96.8996425,33.2698179],[-96.9000556,33.2697504],[-96.9000556,33.2697504],[-96.9000933,33.2699114],[-96.9000933,33.2699114],[-96.8996807,33.269979],[-96.8996807,33.269979]]]},"properties":{"lotName":"6-K-11","lotCpId":"4164201615545424114","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997183,33.2701405],[-96.8996807,33.269979],[-96.8996807,33.269979],[-96.9000933,33.2699114],[-96.9000933,33.2699114],[-96.9001311,33.2700723],[-96.9001311,33.2700723],[-96.8997183,33.2701405],[-96.8997183,33.2701405]]]},"properties":{"lotName":"6-K-10","lotCpId":"5315541615545424113","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997696,33.2703294],[-96.8997638,33.2703093],[-96.8997498,33.2702599],[-96.8997183,33.2701405],[-96.8997183,33.2701405],[-96.9001311,33.2700723],[-96.9001311,33.2700723],[-96.9001721,33.2702416],[-96.9001721,33.2702416],[-96.8997696,33.2703294],[-96.8997696,33.2703294]]]},"properties":{"lotName":"6-K-9","lotCpId":"2765171615545423564","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998346,33.2705151],[-96.899827,33.2704952],[-96.899809,33.2704465],[-96.8997696,33.2703294],[-96.8997696,33.2703294],[-96.9001721,33.2702416],[-96.9001721,33.2702416],[-96.9002272,33.2704086],[-96.9002272,33.2704086],[-96.8998346,33.2705151],[-96.8998346,33.2705151]]]},"properties":{"lotName":"6-K-8","lotCpId":"1188801615545423564","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899899,33.270684],[-96.8998929,33.2706669],[-96.8998788,33.2706277],[-96.8998626,33.2705846],[-96.8998504,33.2705558],[-96.8998346,33.2705151],[-96.8998346,33.2705151],[-96.9002272,33.2704086],[-96.9002272,33.2704086],[-96.9002949,33.2705875],[-96.9002949,33.2705875],[-96.899899,33.270684],[-96.899899,33.270684]]]},"properties":{"lotName":"6-K-7","lotCpId":"2438811615545423569","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999508,33.2708505],[-96.8999449,33.2708305],[-96.8999306,33.2707833],[-96.8999135,33.2707281],[-96.899899,33.270684],[-96.899899,33.270684],[-96.9002949,33.2705875],[-96.9002949,33.2705875],[-96.9003527,33.2707728],[-96.9003527,33.2707728],[-96.8999508,33.2708505],[-96.8999508,33.2708505]]]},"properties":{"lotName":"6-K-6","lotCpId":"2613651615545423566","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999918,33.2710189],[-96.8999884,33.2710028],[-96.8999795,33.270962],[-96.8999508,33.2708505],[-96.8999508,33.2708505],[-96.9003527,33.2707728],[-96.9003527,33.2707728],[-96.900398,33.2709603],[-96.900398,33.2709603],[-96.8999918,33.2710189],[-96.8999918,33.2710189]]]},"properties":{"lotName":"6-K-5","lotCpId":"7535101615545423564","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9000212,33.2711896],[-96.9000184,33.2711713],[-96.9000114,33.2711267],[-96.8999918,33.2710189],[-96.8999918,33.2710189],[-96.900398,33.2709603],[-96.900398,33.2709603],[-96.9004311,33.2711499],[-96.9004311,33.2711499],[-96.9000212,33.2711896],[-96.9000212,33.2711896]]]},"properties":{"lotName":"6-K-4","lotCpId":"6023371615545423560","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9000431,33.2713634],[-96.9000251,33.2712183],[-96.9000212,33.2711896],[-96.9000212,33.2711896],[-96.9004311,33.2711499],[-96.9004311,33.2711499],[-96.9004613,33.2713263],[-96.9004613,33.2713263],[-96.9000431,33.2713634],[-96.9000431,33.2713634]]]},"properties":{"lotName":"6-K-3","lotCpId":"3500341615545423560","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9000654,33.2715373],[-96.9000431,33.2713634],[-96.9000431,33.2713634],[-96.9004613,33.2713263],[-96.9004613,33.2713263],[-96.9004911,33.2714999],[-96.9004911,33.2714999],[-96.9000654,33.2715373],[-96.9000654,33.2715373]]]},"properties":{"lotName":"6-K-2","lotCpId":"3688401615545423567","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9000878,33.2717143],[-96.9000654,33.2715373],[-96.9000654,33.2715373],[-96.9004911,33.2714999],[-96.9004911,33.2714999],[-96.9004846,33.2717622],[-96.9004846,33.2717622],[-96.9002444,33.2717317],[-96.9000878,33.2717143],[-96.9000878,33.2717143]]]},"properties":{"lotName":"6-K-1","lotCpId":"3811231615545423113","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998902,33.2714551],[-96.8999214,33.2717002],[-96.8999214,33.2717002],[-96.89991,33.2716995],[-96.8998789,33.2716978],[-96.8997745,33.2716926],[-96.8996427,33.2716879],[-96.899518,33.2716869],[-96.899518,33.2716869],[-96.8994929,33.2714903],[-96.8994929,33.2714903],[-96.8998902,33.2714551],[-96.8998902,33.2714551]]]},"properties":{"lotName":"6-J-28","lotCpId":"2157451615545423119","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998679,33.2712781],[-96.8998902,33.2714551],[-96.8998902,33.2714551],[-96.8994929,33.2714903],[-96.8994929,33.2714903],[-96.8994706,33.2713132],[-96.8994706,33.2713132],[-96.8998679,33.2712781],[-96.8998679,33.2712781]]]},"properties":{"lotName":"6-J-27","lotCpId":"1548721615545423118","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998362,33.2710705],[-96.8998386,33.2710831],[-96.8998446,33.2711177],[-96.8998529,33.2711693],[-96.8998619,33.2712329],[-96.8998679,33.2712781],[-96.8998679,33.2712781],[-96.8994706,33.2713132],[-96.8994706,33.2713132],[-96.8994449,33.2711239],[-96.8994449,33.2711239],[-96.8998362,33.2710705],[-96.8998362,33.2710705]]]},"properties":{"lotName":"6-J-26","lotCpId":"3883001615545423060","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899792,33.2708829],[-96.8997968,33.2709001],[-96.8998086,33.2709442],[-96.8998362,33.2710705],[-96.8998362,33.2710705],[-96.8994449,33.2711239],[-96.8994449,33.2711239],[-96.8994045,33.2709578],[-96.8994045,33.2709578],[-96.899792,33.2708829],[-96.899792,33.2708829]]]},"properties":{"lotName":"6-J-25","lotCpId":"1073841615545422794","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997309,33.2706913],[-96.8997374,33.2707096],[-96.8997532,33.2707562],[-96.899792,33.2708829],[-96.899792,33.2708829],[-96.8994045,33.2709578],[-96.8994045,33.2709578],[-96.8993969,33.2709258],[-96.8993499,33.2707876],[-96.8993499,33.2707876],[-96.8997309,33.2706913],[-96.8997309,33.2706913]]]},"properties":{"lotName":"6-J-24","lotCpId":"7320641615545422792","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996616,33.2705115],[-96.8996954,33.2705996],[-96.8996993,33.2706092],[-96.8997088,33.2706329],[-96.8997309,33.2706913],[-96.8997309,33.2706913],[-96.8993499,33.2707876],[-96.8993499,33.2707876],[-96.8993325,33.270736],[-96.8992828,33.2706091],[-96.8992828,33.2706091],[-96.8996616,33.2705115],[-96.8996616,33.2705115]]]},"properties":{"lotName":"6-J-23","lotCpId":"5612601615545422553","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996043,33.2703404],[-96.8996102,33.2703591],[-96.8996247,33.2704047],[-96.8996616,33.2705115],[-96.8996616,33.2705115],[-96.8992828,33.2706091],[-96.8992828,33.2706091],[-96.89922,33.2704211],[-96.89922,33.2704211],[-96.8996043,33.2703404],[-96.8996043,33.2703404]]]},"properties":{"lotName":"6-J-22","lotCpId":"1860641615545172781","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8995579,33.2701665],[-96.8995624,33.270185],[-96.8995737,33.2702303],[-96.8996043,33.2703404],[-96.8996043,33.2703404],[-96.89922,33.2704211],[-96.89922,33.2704211],[-96.8991687,33.2702304],[-96.8991687,33.2702304],[-96.8995579,33.2701665],[-96.8995579,33.2701665]]]},"properties":{"lotName":"6-J-21","lotCpId":"7706471615545172703","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8995197,33.2700054],[-96.8995579,33.2701665],[-96.8995579,33.2701665],[-96.8991687,33.2702304],[-96.8991687,33.2702304],[-96.8991311,33.2700693],[-96.8991311,33.2700693],[-96.8995197,33.2700054],[-96.8995197,33.2700054]]]},"properties":{"lotName":"6-J-20","lotCpId":"3826571615545172711","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899482,33.2698444],[-96.8995197,33.2700054],[-96.8995197,33.2700054],[-96.8991311,33.2700693],[-96.8991311,33.2700693],[-96.8990934,33.2699083],[-96.8990934,33.2699083],[-96.899482,33.2698444],[-96.899482,33.2698444]]]},"properties":{"lotName":"6-J-19","lotCpId":"4207051615545172776","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8994444,33.2696833],[-96.899482,33.2698444],[-96.899482,33.2698444],[-96.8990934,33.2699083],[-96.8990934,33.2699083],[-96.8990552,33.2697467],[-96.8990552,33.2697467],[-96.8994444,33.2696833],[-96.8994444,33.2696833]]]},"properties":{"lotName":"6-J-18","lotCpId":"4468401615545172705","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8994062,33.2695218],[-96.8994444,33.2696833],[-96.8994444,33.2696833],[-96.8990552,33.2697467],[-96.8990552,33.2697467],[-96.8990176,33.2695856],[-96.8990176,33.2695856],[-96.8994062,33.2695218],[-96.8994062,33.2695218]]]},"properties":{"lotName":"6-J-17","lotCpId":"2758041615545172701","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8993685,33.2693607],[-96.8994062,33.2695218],[-96.8994062,33.2695218],[-96.8990176,33.2695856],[-96.8990176,33.2695856],[-96.8989799,33.2694246],[-96.8989799,33.2694246],[-96.8993685,33.2693607],[-96.8993685,33.2693607]]]},"properties":{"lotName":"6-J-16","lotCpId":"6133601615545172712","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8993308,33.2691996],[-96.8993685,33.2693607],[-96.8993685,33.2693607],[-96.8989799,33.2694246],[-96.8989799,33.2694246],[-96.8989417,33.2692635],[-96.8989417,33.2692635],[-96.8993308,33.2691996],[-96.8993308,33.2691996]]]},"properties":{"lotName":"6-J-15","lotCpId":"7323541615545172695","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8985908,33.2694884],[-96.8985531,33.2693269],[-96.8985531,33.2693269],[-96.8989417,33.2692635],[-96.8989417,33.2692635],[-96.8989799,33.2694246],[-96.8989799,33.2694246],[-96.8985908,33.2694884],[-96.8985908,33.2694884]]]},"properties":{"lotName":"6-J-14","lotCpId":"1874111615545172770","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8986284,33.2696495],[-96.8985908,33.2694884],[-96.8985908,33.2694884],[-96.8989799,33.2694246],[-96.8989799,33.2694246],[-96.8990176,33.2695856],[-96.8990176,33.2695856],[-96.8986284,33.2696495],[-96.8986284,33.2696495]]]},"properties":{"lotName":"6-J-13","lotCpId":"7487561615545172766","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8986666,33.2698106],[-96.8986284,33.2696495],[-96.8986284,33.2696495],[-96.8990176,33.2695856],[-96.8990176,33.2695856],[-96.8990552,33.2697467],[-96.8990552,33.2697467],[-96.8986666,33.2698106],[-96.8986666,33.2698106]]]},"properties":{"lotName":"6-J-12","lotCpId":"4672021615545172710","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987043,33.2699717],[-96.8986666,33.2698106],[-96.8986666,33.2698106],[-96.8990552,33.2697467],[-96.8990552,33.2697467],[-96.8990934,33.2699083],[-96.8990934,33.2699083],[-96.8987043,33.2699717],[-96.8987043,33.2699717]]]},"properties":{"lotName":"6-J-11","lotCpId":"8534301615545172698","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898742,33.2701332],[-96.8987043,33.2699717],[-96.8987043,33.2699717],[-96.8990934,33.2699083],[-96.8990934,33.2699083],[-96.8991311,33.2700693],[-96.8991311,33.2700693],[-96.898742,33.2701332],[-96.898742,33.2701332]]]},"properties":{"lotName":"6-J-10","lotCpId":"8006501615545172268","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987802,33.2702943],[-96.898742,33.2701332],[-96.898742,33.2701332],[-96.8991311,33.2700693],[-96.8991311,33.2700693],[-96.8991687,33.2702304],[-96.8991687,33.2702304],[-96.8987802,33.2702943],[-96.8987802,33.2702943]]]},"properties":{"lotName":"6-J-9","lotCpId":"8136041615545172209","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988287,33.2704786],[-96.8988231,33.270458],[-96.8988096,33.2704081],[-96.8987935,33.2703475],[-96.8987802,33.2702943],[-96.8987802,33.2702943],[-96.8991687,33.2702304],[-96.8991687,33.2702304],[-96.899214,33.2703997],[-96.899214,33.2703997],[-96.8988287,33.2704786],[-96.8988287,33.2704786]]]},"properties":{"lotName":"6-J-8","lotCpId":"8167721615545172263","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988877,33.2706612],[-96.8988813,33.270643],[-96.8988657,33.2705976],[-96.8988287,33.2704786],[-96.8988287,33.2704786],[-96.899214,33.2703997],[-96.899214,33.2703997],[-96.89922,33.2704211],[-96.8992686,33.2705667],[-96.8992686,33.2705667],[-96.8988877,33.2706612],[-96.8988877,33.2706612]]]},"properties":{"lotName":"6-J-7","lotCpId":"7528701615545172267","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989553,33.2708387],[-96.898945,33.2708122],[-96.8989395,33.2707986],[-96.8989255,33.2707634],[-96.8988877,33.2706612],[-96.8988877,33.2706612],[-96.8992686,33.2705667],[-96.8992686,33.2705667],[-96.8992828,33.2706091],[-96.8993325,33.270736],[-96.8993325,33.270736],[-96.8989553,33.2708387],[-96.8989553,33.2708387]]]},"properties":{"lotName":"6-J-6","lotCpId":"6173211615545172263","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990121,33.2710043],[-96.8990068,33.2709874],[-96.8989932,33.2709454],[-96.8989553,33.2708387],[-96.8989553,33.2708387],[-96.8993325,33.270736],[-96.8993325,33.270736],[-96.8993969,33.2709258],[-96.8993969,33.2709258],[-96.8990121,33.2710043],[-96.8990121,33.2710043]]]},"properties":{"lotName":"6-J-5","lotCpId":"1717371615545172265","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990536,33.2711773],[-96.89905,33.2711592],[-96.8990405,33.2711147],[-96.8990121,33.2710043],[-96.8990121,33.2710043],[-96.8993969,33.2709258],[-96.8993969,33.2709258],[-96.8994449,33.2711239],[-96.8994449,33.2711239],[-96.8990536,33.2711773],[-96.8990536,33.2711773]]]},"properties":{"lotName":"6-J-4","lotCpId":"6485501615545172267","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990798,33.2713479],[-96.8990738,33.2713027],[-96.8990721,33.2712904],[-96.8990677,33.2712595],[-96.8990536,33.2711773],[-96.8990536,33.2711773],[-96.8994449,33.2711239],[-96.8994449,33.2711239],[-96.8994706,33.2713132],[-96.8994706,33.2713132],[-96.8990798,33.2713479],[-96.8990798,33.2713479]]]},"properties":{"lotName":"6-J-3","lotCpId":"5841501615545171803","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991022,33.271525],[-96.8990798,33.2713479],[-96.8990798,33.2713479],[-96.8994706,33.2713132],[-96.8994706,33.2713132],[-96.8994929,33.2714903],[-96.8994929,33.2714903],[-96.8991022,33.271525],[-96.8991022,33.271525]]]},"properties":{"lotName":"6-J-2","lotCpId":"1820401615545171802","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991245,33.2717015],[-96.8991022,33.271525],[-96.8991022,33.271525],[-96.8994929,33.2714903],[-96.8994929,33.2714903],[-96.899518,33.2716869],[-96.899518,33.2716869],[-96.8995083,33.271687],[-96.8994812,33.2716872],[-96.899387,33.2716889],[-96.89926,33.2716932],[-96.8991245,33.2717015],[-96.8991245,33.2717015]]]},"properties":{"lotName":"6-J-1","lotCpId":"7007871615545171811","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057617,33.2593225],[-96.9059079,33.2593371],[-96.9059079,33.2593371],[-96.9058637,33.2596542],[-96.9058637,33.2596542],[-96.9057175,33.2596397],[-96.9057175,33.2596397],[-96.9057617,33.2593225],[-96.9057617,33.2593225]]]},"properties":{"lotName":"2-B-1","lotCpId":"4100671615532050763","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991388,33.264174],[-96.8992911,33.2641257],[-96.8992911,33.2641257],[-96.8993336,33.2641412],[-96.8995279,33.2645076],[-96.8995279,33.2645076],[-96.8993107,33.2645496],[-96.8993107,33.2645496],[-96.8991388,33.264174],[-96.8991388,33.264174]]]},"properties":{"lotName":"1A-F-33","lotCpId":"1440801615535323874","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.898986,33.2642233],[-96.8991388,33.264174],[-96.8991388,33.264174],[-96.8993107,33.2645496],[-96.8993107,33.2645496],[-96.8991503,33.2645811],[-96.8991503,33.2645811],[-96.898986,33.2642233],[-96.898986,33.2642233]]]},"properties":{"lotName":"1A-F-32","lotCpId":"8618771615535317172","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988332,33.2642722],[-96.898986,33.2642233],[-96.898986,33.2642233],[-96.8991503,33.2645811],[-96.8991503,33.2645811],[-96.8989893,33.2646135],[-96.8989893,33.2646135],[-96.8988332,33.2642722],[-96.8988332,33.2642722]]]},"properties":{"lotName":"1A-F-31","lotCpId":"5645461615535347432","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8986803,33.264321],[-96.8988332,33.2642722],[-96.8988332,33.2642722],[-96.8989893,33.2646135],[-96.8989893,33.2646135],[-96.8988288,33.264645],[-96.8988288,33.264645],[-96.8986803,33.264321],[-96.8986803,33.264321]]]},"properties":{"lotName":"1A-F-30","lotCpId":"1231001615535252574","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8985303,33.2643634],[-96.8985462,33.2643591],[-96.898585,33.2643486],[-96.8986766,33.2643222],[-96.8986803,33.264321],[-96.8986803,33.264321],[-96.8988288,33.264645],[-96.8988288,33.264645],[-96.8986411,33.2646824],[-96.8986411,33.2646824],[-96.8985303,33.2643634],[-96.8985303,33.2643634]]]},"properties":{"lotName":"1A-F-29","lotCpId":"4220631615535295891","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8983764,33.2643945],[-96.8983928,33.2643917],[-96.8984329,33.2643845],[-96.8985303,33.2643634],[-96.8985303,33.2643634],[-96.8986411,33.2646824],[-96.8986411,33.2646824],[-96.8984539,33.2647194],[-96.8984539,33.2647194],[-96.8983764,33.2643945],[-96.8983764,33.2643945]]]},"properties":{"lotName":"1A-F-28","lotCpId":"5334841615535291910","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982203,33.264415],[-96.8982358,33.2644134],[-96.8982748,33.2644089],[-96.8983764,33.2643945],[-96.8983764,33.2643945],[-96.8984539,33.2647194],[-96.8984539,33.2647194],[-96.8982645,33.2647426],[-96.8982645,33.2647426],[-96.8982203,33.264415],[-96.8982203,33.264415]]]},"properties":{"lotName":"1A-F-27","lotCpId":"2400001615535236111","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980625,33.2644241],[-96.8980796,33.2644235],[-96.8981213,33.2644218],[-96.8982203,33.264415],[-96.8982203,33.264415],[-96.8982645,33.2647426],[-96.8982645,33.2647426],[-96.8980735,33.2647655],[-96.8980735,33.2647655],[-96.8980625,33.2644241],[-96.8980625,33.2644241]]]},"properties":{"lotName":"1A-F-26","lotCpId":"7783581615535293911","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979043,33.2644218],[-96.8979214,33.2644224],[-96.8979631,33.2644237],[-96.8980625,33.2644241],[-96.8980625,33.2644241],[-96.8980735,33.2647655],[-96.8980735,33.2647655],[-96.8978786,33.2647892],[-96.8978786,33.2647892],[-96.8979043,33.2644218],[-96.8979043,33.2644218]]]},"properties":{"lotName":"1A-F-25","lotCpId":"3611431615535284553","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8977471,33.2644086],[-96.8977617,33.2644103],[-96.897799,33.2644143],[-96.8979043,33.2644218],[-96.8979043,33.2644218],[-96.8978786,33.2647892],[-96.8978786,33.2647892],[-96.8976767,33.2648134],[-96.8976767,33.2648134],[-96.8977471,33.2644086],[-96.8977471,33.2644086]]]},"properties":{"lotName":"1A-F-24","lotCpId":"3001051615535212858","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.897567,33.2644939],[-96.8975739,33.2644896],[-96.8975908,33.2644762],[-96.8976312,33.2644197],[-96.8976718,33.2643981],[-96.8977471,33.2644086],[-96.8977471,33.2644086],[-96.8976767,33.2648134],[-96.8976767,33.2648134],[-96.897508,33.2648339],[-96.897508,33.2648339],[-96.897567,33.2644939],[-96.897567,33.2644939]]]},"properties":{"lotName":"1A-F-23","lotCpId":"4460781615535219863","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973962,33.2645222],[-96.8974113,33.2645254],[-96.8974509,33.2645283],[-96.8975058,33.2645211],[-96.897567,33.2644939],[-96.897567,33.2644939],[-96.897508,33.2648339],[-96.897508,33.2648339],[-96.8973389,33.2648544],[-96.8973389,33.2648544],[-96.8973962,33.2645222],[-96.8973962,33.2645222]]]},"properties":{"lotName":"1A-F-22","lotCpId":"6444361615535346816","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8972543,33.2643872],[-96.8972579,33.2644039],[-96.8972758,33.2644431],[-96.8973184,33.264488],[-96.8973962,33.2645222],[-96.8973962,33.2645222],[-96.8973389,33.2648544],[-96.8973389,33.2648544],[-96.8971909,33.2648722],[-96.8971909,33.2648722],[-96.8971839,33.2647933],[-96.8972543,33.2643872],[-96.8972543,33.2643872]]]},"properties":{"lotName":"1A-F-21","lotCpId":"2606821615535243595","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8975004,33.2652496],[-96.8974316,33.2652784],[-96.8973241,33.2653245],[-96.8973241,33.2653245],[-96.8972073,33.2650575],[-96.8971909,33.2648722],[-96.8971909,33.2648722],[-96.8973285,33.2648558],[-96.8973285,33.2648558],[-96.8975004,33.2652496],[-96.8975004,33.2652496]]]},"properties":{"lotName":"1A-F-45","lotCpId":"2715571615888292035","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8976821,33.2651867],[-96.897663,33.2651926],[-96.8976159,33.2652078],[-96.8975004,33.2652496],[-96.8975004,33.2652496],[-96.8973285,33.2648558],[-96.8973285,33.2648558],[-96.8975271,33.2648316],[-96.8975271,33.2648316],[-96.8976821,33.2651867],[-96.8976821,33.2651867]]]},"properties":{"lotName":"1A-F-44","lotCpId":"6043531615535585701","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8978639,33.2651383],[-96.8978437,33.2651432],[-96.8977949,33.2651555],[-96.8976821,33.2651867],[-96.8976821,33.2651867],[-96.8975271,33.2648316],[-96.8975271,33.2648316],[-96.8977564,33.2648038],[-96.8977564,33.2648038],[-96.8978639,33.2651383],[-96.8978639,33.2651383]]]},"properties":{"lotName":"1A-F-43","lotCpId":"6267171615888292035","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8980505,33.2651036],[-96.8980291,33.2651071],[-96.8979778,33.2651158],[-96.8979162,33.2651271],[-96.8978639,33.2651383],[-96.8978639,33.2651383],[-96.8977564,33.2648038],[-96.8977564,33.2648038],[-96.8979801,33.2647768],[-96.8979801,33.2647768],[-96.8980505,33.2651036],[-96.8980505,33.2651036]]]},"properties":{"lotName":"1A-F-42","lotCpId":"2655271615888292000","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982394,33.2650822],[-96.8982193,33.2650839],[-96.8981701,33.2650887],[-96.8980505,33.2651036],[-96.8980505,33.2651036],[-96.8979801,33.2647768],[-96.8979801,33.2647768],[-96.8982033,33.2647499],[-96.8982033,33.2647499],[-96.8982394,33.2650822],[-96.8982394,33.2650822]]]},"properties":{"lotName":"1A-F-41","lotCpId":"4241601615888291783","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8984298,33.2650749],[-96.898408,33.2650753],[-96.8983558,33.2650765],[-96.898293,33.2650788],[-96.8982394,33.2650822],[-96.8982394,33.2650822],[-96.8982033,33.2647499],[-96.8982033,33.2647499],[-96.8984282,33.2647226],[-96.8984282,33.2647226],[-96.8984298,33.2650749],[-96.8984298,33.2650749]]]},"properties":{"lotName":"1A-F-40","lotCpId":"7008601615888291783","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8986236,33.265079],[-96.8985193,33.2650758],[-96.8984938,33.2650751],[-96.8984298,33.2650749],[-96.8984298,33.2650749],[-96.8984282,33.2647226],[-96.8984282,33.2647226],[-96.8984539,33.2647194],[-96.8986411,33.2646824],[-96.8986411,33.2646824],[-96.8986236,33.265079],[-96.8986236,33.265079]]]},"properties":{"lotName":"1A-F-39","lotCpId":"7761751615888291782","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988326,33.2650844],[-96.8988188,33.2650851],[-96.8987968,33.265085],[-96.8987606,33.2650838],[-96.8986236,33.265079],[-96.8986236,33.265079],[-96.8986411,33.2646824],[-96.8986411,33.2646824],[-96.8988321,33.2646445],[-96.8988321,33.264645],[-96.8988326,33.2650844],[-96.8988326,33.2650844]]]},"properties":{"lotName":"1A-F-38","lotCpId":"2684841615888291778","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8990657,33.2650726],[-96.8990443,33.2650747],[-96.8989893,33.2650792],[-96.8988326,33.2650844],[-96.8988326,33.2650844],[-96.8988321,33.2646445],[-96.8988321,33.2646445],[-96.8989991,33.2646112],[-96.8989991,33.2646112],[-96.8990657,33.2650726],[-96.8990657,33.2650726]]]},"properties":{"lotName":"1A-F-37","lotCpId":"6374711615535562293","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8992954,33.2650379],[-96.8992733,33.2650423],[-96.8992172,33.2650526],[-96.8990657,33.2650726],[-96.8990657,33.2650726],[-96.8989991,33.2646112],[-96.8989991,33.2646112],[-96.8991617,33.2645788],[-96.8991617,33.2645788],[-96.8992954,33.2650379],[-96.8992954,33.2650379]]]},"properties":{"lotName":"1A-F-36","lotCpId":"6565501615535584980","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8995181,33.2649804],[-96.8994999,33.2649863],[-96.899451,33.2650008],[-96.8993799,33.2650196],[-96.8992954,33.2650379],[-96.8992954,33.2650379],[-96.8991617,33.2645788],[-96.8991617,33.2645788],[-96.8993249,33.2645464],[-96.8993249,33.2645464],[-96.8995181,33.2649804],[-96.8995181,33.2649804]]]},"properties":{"lotName":"1A-F-35","lotCpId":"8154801615535377151","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997391,33.264899],[-96.8997219,33.2649068],[-96.8996749,33.2649264],[-96.8996047,33.2649527],[-96.8995181,33.2649804],[-96.8995181,33.2649804],[-96.8993249,33.2645464],[-96.8993249,33.2645464],[-96.8995279,33.2645076],[-96.8995279,33.2645076],[-96.8995328,33.2645161],[-96.8995466,33.2645397],[-96.8995964,33.2646227],[-96.8996679,33.2647367],[-96.8997517,33.2648617],[-96.8997391,33.264899],[-96.8997391,33.264899]]]},"properties":{"lotName":"1A-F-34","lotCpId":"6282301615535551715","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005622,33.2644907],[-96.9004082,33.2645674],[-96.9004082,33.2645674],[-96.9001987,33.264274],[-96.9001987,33.264274],[-96.9004055,33.2641886],[-96.9004055,33.2641886],[-96.900417,33.2642084],[-96.9004502,33.2642632],[-96.9005031,33.2643468],[-96.9005736,33.2644529],[-96.9005622,33.2644907],[-96.9005622,33.2644907]]]},"properties":{"lotName":"1A-J-1","lotCpId":"8725611615535394414","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9001261,33.2647084],[-96.8999378,33.2648024],[-96.8999378,33.2648024],[-96.899893,33.2647928],[-96.8998878,33.2647852],[-96.8998732,33.2647637],[-96.8998236,33.2646892],[-96.8997592,33.2645887],[-96.8996949,33.2644816],[-96.8996949,33.2644816],[-96.8999029,33.2643958],[-96.8999029,33.2643958],[-96.9001261,33.2647084],[-96.9001261,33.2647084]]]},"properties":{"lotName":"1A-J-4","lotCpId":"7701151615535253232","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9002669,33.2646381],[-96.9001261,33.2647084],[-96.9001261,33.2647084],[-96.8999029,33.2643958],[-96.8999029,33.2643958],[-96.9000502,33.2643351],[-96.9000502,33.2643351],[-96.9002669,33.2646381],[-96.9002669,33.2646381]]]},"properties":{"lotName":"1A-J-3","lotCpId":"1807051615535212448","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004082,33.2645674],[-96.9002669,33.2646381],[-96.9002669,33.2646381],[-96.9000502,33.2643351],[-96.9000502,33.2643351],[-96.9001987,33.264274],[-96.9001987,33.264274],[-96.9004082,33.2645674],[-96.9004082,33.2645674]]]},"properties":{"lotName":"1A-J-2","lotCpId":"4555101615535317833","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9003193,33.2640353],[-96.9004055,33.2641886],[-96.9004055,33.2641886],[-96.9000502,33.2643351],[-96.9000502,33.2643351],[-96.899958,33.2641718],[-96.899958,33.2641718],[-96.9003193,33.2640353],[-96.9003193,33.2640353]]]},"properties":{"lotName":"1A-J-18","lotCpId":"1858031615535247850","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9002494,33.2639016],[-96.9003193,33.2640353],[-96.9003193,33.2640353],[-96.899958,33.2641718],[-96.899958,33.2641718],[-96.8998838,33.2640289],[-96.8998838,33.2640289],[-96.9002494,33.2639016],[-96.9002494,33.2639016]]]},"properties":{"lotName":"1A-J-17","lotCpId":"1686071615535313875","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9001845,33.2637656],[-96.9002494,33.2639016],[-96.9002494,33.2639016],[-96.8998838,33.2640289],[-96.8998838,33.2640289],[-96.8998145,33.2638838],[-96.8998145,33.2638838],[-96.9001845,33.2637656],[-96.9001845,33.2637656]]]},"properties":{"lotName":"1A-J-16","lotCpId":"4440651615535258678","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900131,33.2636337],[-96.9001374,33.2636553],[-96.9001574,33.2637064],[-96.9001845,33.2637656],[-96.9001845,33.2637656],[-96.8998145,33.2638838],[-96.8998145,33.2638838],[-96.8997473,33.2637159],[-96.8997473,33.2637159],[-96.900131,33.2636337],[-96.900131,33.2636337]]]},"properties":{"lotName":"1A-J-15","lotCpId":"4724461615535289914","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9001043,33.2634955],[-96.9001053,33.2635085],[-96.9001094,33.2635416],[-96.900131,33.2636337],[-96.900131,33.2636337],[-96.8997473,33.2637159],[-96.8997473,33.2637159],[-96.8997091,33.2635174],[-96.8997091,33.2635174],[-96.9001043,33.2634955],[-96.9001043,33.2634955]]]},"properties":{"lotName":"1A-J-14","lotCpId":"7530061615535553417","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9001064,33.2633759],[-96.9001051,33.2633864],[-96.9001027,33.2634138],[-96.9001043,33.2634955],[-96.9001043,33.2634955],[-96.8997091,33.2635174],[-96.8997091,33.2635174],[-96.8996824,33.2633029],[-96.8996824,33.2633029],[-96.8997065,33.2633033],[-96.8997756,33.2633065],[-96.8998854,33.2633154],[-96.9000311,33.263333],[-96.9000737,33.2633389],[-96.9001064,33.2633759],[-96.9001064,33.2633759]]]},"properties":{"lotName":"1A-J-13","lotCpId":"8343401615535244893","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8992987,33.2635073],[-96.8992681,33.263354],[-96.8992681,33.263354],[-96.899302,33.2633161],[-96.8993188,33.2633139],[-96.8993784,33.2633091],[-96.8994287,33.2633066],[-96.899495,33.2633045],[-96.8995789,33.2633031],[-96.8996824,33.2633029],[-96.8996824,33.2633029],[-96.8997009,33.2634512],[-96.8997009,33.2634512],[-96.8992987,33.2635073],[-96.8992987,33.2635073]]]},"properties":{"lotName":"1A-J-12","lotCpId":"4276171615535437178","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899326,33.2636419],[-96.8992987,33.2635073],[-96.8992987,33.2635073],[-96.8997009,33.2634512],[-96.8997009,33.2634512],[-96.8997091,33.2635174],[-96.8997226,33.2635872],[-96.8997226,33.2635872],[-96.899326,33.2636419],[-96.899326,33.2636419]]]},"properties":{"lotName":"1A-J-11","lotCpId":"4365411615535241537","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8993631,33.2637985],[-96.8993598,33.2637877],[-96.8993518,33.2637599],[-96.8993326,33.2636789],[-96.8993328,33.263673],[-96.899326,33.2636419],[-96.899326,33.2636419],[-96.8997226,33.2635872],[-96.8997226,33.2635872],[-96.8997473,33.2637159],[-96.8997473,33.2637159],[-96.8993631,33.2637985],[-96.8993631,33.2637985]]]},"properties":{"lotName":"1A-J-10","lotCpId":"1145561615535373214","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8994231,33.263955],[-96.8994163,33.2639395],[-96.8993999,33.2639007],[-96.8993631,33.2637985],[-96.8993631,33.2637985],[-96.8997473,33.2637159],[-96.8997473,33.2637159],[-96.8997964,33.2638386],[-96.8997964,33.2638386],[-96.8994231,33.263955],[-96.8994231,33.263955]]]},"properties":{"lotName":"1A-J-9","lotCpId":"4763321615535348774","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8994848,33.2640887],[-96.8994231,33.263955],[-96.8994231,33.263955],[-96.8997964,33.2638386],[-96.8997964,33.2638386],[-96.8998145,33.2638838],[-96.8998532,33.263965],[-96.8998532,33.263965],[-96.8994848,33.2640887],[-96.8994848,33.2640887]]]},"properties":{"lotName":"1A-J-8","lotCpId":"3212811615535285852","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8995508,33.264221],[-96.8994848,33.2640887],[-96.8994848,33.2640887],[-96.8998532,33.263965],[-96.8998532,33.263965],[-96.8998838,33.2640289],[-96.8999154,33.2640898],[-96.8999154,33.2640898],[-96.8995508,33.264221],[-96.8995508,33.264221]]]},"properties":{"lotName":"1A-J-7","lotCpId":"1808211615535233413","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996207,33.2643525],[-96.8996125,33.2643373],[-96.8995929,33.2643011],[-96.8995698,33.2642577],[-96.8995508,33.264221],[-96.8995508,33.264221],[-96.8999154,33.2640898],[-96.8999154,33.2640898],[-96.899958,33.2641718],[-96.8999815,33.2642133],[-96.8999815,33.2642133],[-96.8996207,33.2643525],[-96.8996207,33.2643525]]]},"properties":{"lotName":"1A-J-6","lotCpId":"8168511615535255254","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996949,33.2644816],[-96.8996207,33.2643525],[-96.8996207,33.2643525],[-96.8999815,33.2642133],[-96.8999815,33.2642133],[-96.9000502,33.2643351],[-96.9000502,33.2643351],[-96.8996949,33.2644816],[-96.8996949,33.2644816]]]},"properties":{"lotName":"1A-J-5","lotCpId":"6614471615535248533","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014883,33.264175],[-96.9015756,33.2642895],[-96.9015756,33.2642895],[-96.9012455,33.2644725],[-96.9012455,33.2644725],[-96.9011505,33.2643488],[-96.9011505,33.2643488],[-96.9014883,33.264175],[-96.9014883,33.264175]]]},"properties":{"lotName":"1A-K-15","lotCpId":"6813461615535249215","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9016679,33.2644018],[-96.9017601,33.2645067],[-96.9017601,33.2645067],[-96.9017585,33.2645492],[-96.9015123,33.2647805],[-96.9015102,33.2647782],[-96.9015102,33.2647782],[-96.9013448,33.2645934],[-96.9013448,33.2645934],[-96.9016679,33.2644018],[-96.9016679,33.2644018]]]},"properties":{"lotName":"1A-K-17","lotCpId":"7815601615535287231","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015756,33.2642895],[-96.9016679,33.2644018],[-96.9016679,33.2644018],[-96.9013448,33.2645934],[-96.9013448,33.2645934],[-96.9012455,33.2644725],[-96.9012455,33.2644725],[-96.9015756,33.2642895],[-96.9015756,33.2642895]]]},"properties":{"lotName":"1A-K-16","lotCpId":"3857061615535217011","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014048,33.2640577],[-96.9014883,33.264175],[-96.9014883,33.264175],[-96.9011505,33.2643488],[-96.9011505,33.2643488],[-96.901061,33.2642224],[-96.901061,33.2642224],[-96.9014048,33.2640577],[-96.9014048,33.2640577]]]},"properties":{"lotName":"1A-K-14","lotCpId":"3518161615535254576","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013268,33.2639386],[-96.9014048,33.2640577],[-96.9014048,33.2640577],[-96.901061,33.2642224],[-96.901061,33.2642224],[-96.9009764,33.2640937],[-96.9009764,33.2640937],[-96.9013268,33.2639386],[-96.9013268,33.2639386]]]},"properties":{"lotName":"1A-K-13","lotCpId":"5368181615535288571","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9012531,33.2638176],[-96.9013268,33.2639386],[-96.9013268,33.2639386],[-96.9009764,33.2640937],[-96.9009764,33.2640937],[-96.9008967,33.2639628],[-96.9008967,33.2639628],[-96.9012531,33.2638176],[-96.9012531,33.2638176]]]},"properties":{"lotName":"1A-K-12","lotCpId":"2347381615535323211","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9011838,33.2636944],[-96.9012531,33.2638176],[-96.9012531,33.2638176],[-96.9008967,33.2639628],[-96.9008967,33.2639628],[-96.9008225,33.26383],[-96.9008225,33.26383],[-96.9011838,33.2636944],[-96.9011838,33.2636944]]]},"properties":{"lotName":"1A-K-11","lotCpId":"5782561615535250574","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9011199,33.2635694],[-96.9011838,33.2636944],[-96.9011838,33.2636944],[-96.9008225,33.26383],[-96.9008225,33.26383],[-96.9007532,33.2636949],[-96.9007532,33.2636949],[-96.9011199,33.2635694],[-96.9011199,33.2635694]]]},"properties":{"lotName":"1A-K-10","lotCpId":"2081661615535161066","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004568,33.2639577],[-96.9003864,33.2638204],[-96.9003864,33.2638204],[-96.9007532,33.2636949],[-96.9007532,33.2636949],[-96.9008187,33.2638227],[-96.9008187,33.2638227],[-96.9004568,33.2639577],[-96.9004568,33.2639577]]]},"properties":{"lotName":"1A-K-9","lotCpId":"5013151615535555548","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005305,33.264091],[-96.9004568,33.2639577],[-96.9004568,33.2639577],[-96.9008187,33.2638227],[-96.9008187,33.2638227],[-96.9008225,33.26383],[-96.900888,33.2639468],[-96.900888,33.2639468],[-96.9005305,33.264091],[-96.9005305,33.264091]]]},"properties":{"lotName":"1A-K-8","lotCpId":"3347071615535340716","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006096,33.264222],[-96.9005305,33.264091],[-96.9005305,33.264091],[-96.900888,33.2639468],[-96.900888,33.2639468],[-96.9008967,33.2639628],[-96.9009617,33.2640691],[-96.9009617,33.2640691],[-96.9006096,33.264222],[-96.9006096,33.264222]]]},"properties":{"lotName":"1A-K-7","lotCpId":"5672521615535260012","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006931,33.2643516],[-96.9006096,33.264222],[-96.9006096,33.264222],[-96.9009617,33.2640691],[-96.9009617,33.2640691],[-96.9009764,33.2640937],[-96.9010392,33.2641891],[-96.9010392,33.2641891],[-96.9006931,33.2643516],[-96.9006931,33.2643516]]]},"properties":{"lotName":"1A-K-6","lotCpId":"6416801615535320494","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9007816,33.2644784],[-96.9006931,33.2643516],[-96.9006931,33.2643516],[-96.9010392,33.2641891],[-96.9010392,33.2641891],[-96.901061,33.2642224],[-96.9011216,33.2643077],[-96.9011216,33.2643077],[-96.9007816,33.2644784],[-96.9007816,33.2644784]]]},"properties":{"lotName":"1A-K-5","lotCpId":"3425441615535242212","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008743,33.2646035],[-96.9007816,33.2644784],[-96.9007816,33.2644784],[-96.9011216,33.2643077],[-96.9011216,33.2643077],[-96.9011505,33.2643488],[-96.9012083,33.2644237],[-96.9012083,33.2644237],[-96.9008743,33.2646035],[-96.9008743,33.2646035]]]},"properties":{"lotName":"1A-K-4","lotCpId":"4510311615535406518","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900972,33.2647258],[-96.9008743,33.2646035],[-96.9008743,33.2646035],[-96.9012083,33.2644237],[-96.9012083,33.2644237],[-96.9012455,33.2644725],[-96.9012989,33.2645377],[-96.9012989,33.2645377],[-96.900972,33.2647258],[-96.900972,33.2647258]]]},"properties":{"lotName":"1A-K-3","lotCpId":"1582751615535344774","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010735,33.2648458],[-96.900972,33.2647258],[-96.900972,33.2647258],[-96.9012989,33.2645377],[-96.9012989,33.2645377],[-96.9013448,33.2645934],[-96.9013944,33.2646491],[-96.9013944,33.2646491],[-96.9010735,33.2648458],[-96.9010735,33.2648458]]]},"properties":{"lotName":"1A-K-2","lotCpId":"3033601615535213268","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9012231,33.2650082],[-96.9012078,33.2649924],[-96.9011698,33.2649525],[-96.9010735,33.2648458],[-96.9010735,33.2648458],[-96.9013944,33.2646491],[-96.9013944,33.2646491],[-96.9015123,33.2647805],[-96.9015123,33.2647805],[-96.9012951,33.2649845],[-96.9012667,33.2650101],[-96.9012231,33.2650082],[-96.9012231,33.2650082]]]},"properties":{"lotName":"1A-K-1","lotCpId":"2215011615535211631","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018409,33.261697],[-96.9018305,33.2615537],[-96.9018305,33.2615537],[-96.9018611,33.2615231],[-96.9018707,33.261522],[-96.9018974,33.2615188],[-96.9019879,33.2615064],[-96.9022207,33.2614597],[-96.9022207,33.2614597],[-96.9022366,33.2616769],[-96.9022366,33.2616769],[-96.9018409,33.261697],[-96.9018409,33.261697]]]},"properties":{"lotName":"1A-M-16","lotCpId":"5280711615888291325","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018507,33.2618339],[-96.9018409,33.261697],[-96.9018409,33.261697],[-96.9022366,33.2616769],[-96.9022366,33.2616769],[-96.9022464,33.2618133],[-96.9022464,33.2618133],[-96.9018507,33.2618339],[-96.9018507,33.2618339]]]},"properties":{"lotName":"1A-M-15","lotCpId":"4427801615888291287","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018611,33.2619703],[-96.9018507,33.2618339],[-96.9018507,33.2618339],[-96.9022464,33.2618133],[-96.9022464,33.2618133],[-96.9022562,33.2619503],[-96.9022562,33.2619503],[-96.9018611,33.2619703],[-96.9018611,33.2619703]]]},"properties":{"lotName":"1A-M-14","lotCpId":"1647761615888291067","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018709,33.2621068],[-96.9018611,33.2619703],[-96.9018611,33.2619703],[-96.9022562,33.2619503],[-96.9022562,33.2619503],[-96.9022666,33.2620867],[-96.9022666,33.2620867],[-96.9018709,33.2621068],[-96.9018709,33.2621068]]]},"properties":{"lotName":"1A-M-13","lotCpId":"4547711615888291066","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018818,33.2622487],[-96.9018769,33.2621921],[-96.9018709,33.2621068],[-96.9018709,33.2621068],[-96.9022666,33.2620867],[-96.9022666,33.2620867],[-96.9022688,33.2621186],[-96.902278,33.2622227],[-96.902278,33.2622227],[-96.9018818,33.2622487],[-96.9018818,33.2622487]]]},"properties":{"lotName":"1A-M-12","lotCpId":"5070081615535564316","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018998,33.2623984],[-96.9018975,33.262381],[-96.9018922,33.2623396],[-96.9018862,33.2622901],[-96.9018818,33.2622487],[-96.9018818,33.2622487],[-96.902278,33.2622227],[-96.902278,33.2622227],[-96.9022846,33.2622943],[-96.902295,33.2623564],[-96.902295,33.2623564],[-96.9018998,33.2623984],[-96.9018998,33.2623984]]]},"properties":{"lotName":"1A-M-11","lotCpId":"8123671615535552554","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9019266,33.2625467],[-96.9019235,33.262532],[-96.9019161,33.2624951],[-96.9018998,33.2623984],[-96.9018998,33.2623984],[-96.902295,33.2623564],[-96.902295,33.2623564],[-96.9023141,33.2624741],[-96.9023179,33.2624901],[-96.9023179,33.2624901],[-96.9019266,33.2625467],[-96.9019266,33.2625467]]]},"properties":{"lotName":"1A-M-10","lotCpId":"6640001615535376479","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9019615,33.2626946],[-96.9019574,33.2626781],[-96.9019476,33.2626383],[-96.9019266,33.2625467],[-96.9019266,33.2625467],[-96.9023179,33.2624901],[-96.9023179,33.2624901],[-96.9023495,33.2626225],[-96.9023495,33.2626225],[-96.9019615,33.2626946],[-96.9019615,33.2626946]]]},"properties":{"lotName":"1A-M-9","lotCpId":"4462441615535559494","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9020046,33.2628401],[-96.9019997,33.2628248],[-96.9019879,33.2627871],[-96.9019615,33.2626946],[-96.9019615,33.2626946],[-96.9023495,33.2626225],[-96.9023495,33.2626225],[-96.9023566,33.2626521],[-96.9023888,33.262753],[-96.9023888,33.262753],[-96.9020046,33.2628401],[-96.9020046,33.2628401]]]},"properties":{"lotName":"1A-M-8","lotCpId":"8456841615535561557","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9020559,33.2629843],[-96.9020507,33.2629708],[-96.9020378,33.2629363],[-96.9020046,33.2628401],[-96.9020046,33.2628401],[-96.9023888,33.262753],[-96.9023888,33.262753],[-96.9024129,33.2628278],[-96.9024347,33.2628821],[-96.9024347,33.2628821],[-96.9020559,33.2629843],[-96.9020559,33.2629843]]]},"properties":{"lotName":"1A-M-7","lotCpId":"8811201615535555106","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9021154,33.2631263],[-96.9021099,33.2631142],[-96.9020957,33.2630823],[-96.9020559,33.2629843],[-96.9020559,33.2629843],[-96.9024347,33.2628821],[-96.9024347,33.2628821],[-96.9024816,33.2630003],[-96.9024865,33.2630099],[-96.9024865,33.2630099],[-96.9021154,33.2631263],[-96.9021154,33.2631263]]]},"properties":{"lotName":"1A-M-6","lotCpId":"8808531615535554685","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.902182,33.2632659],[-96.9021761,33.2632544],[-96.9021607,33.2632235],[-96.9021154,33.2631263],[-96.9021154,33.2631263],[-96.9024865,33.2630099],[-96.9024865,33.2630099],[-96.9025477,33.2631345],[-96.9025477,33.2631345],[-96.902182,33.2632659],[-96.902182,33.2632659]]]},"properties":{"lotName":"1A-M-5","lotCpId":"1540301615535560872","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9022568,33.2634024],[-96.9022501,33.2633912],[-96.9022328,33.2633614],[-96.902182,33.2632659],[-96.902182,33.2632659],[-96.9025477,33.2631345],[-96.9025477,33.2631345],[-96.902564,33.2631683],[-96.9026148,33.2632572],[-96.9026148,33.2632572],[-96.9022568,33.2634024],[-96.9022568,33.2634024]]]},"properties":{"lotName":"1A-M-4","lotCpId":"2015001615535564992","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9023392,33.2635361],[-96.9023316,33.2635244],[-96.9023121,33.2634938],[-96.9022568,33.2634024],[-96.9022568,33.2634024],[-96.9026148,33.2632572],[-96.9026148,33.2632572],[-96.9026584,33.2633321],[-96.9026885,33.2633773],[-96.9026885,33.2633773],[-96.9023392,33.2635361],[-96.9023392,33.2635361]]]},"properties":{"lotName":"1A-M-3","lotCpId":"5875021615535555969","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9024292,33.2636666],[-96.9024208,33.263655],[-96.9023991,33.2636248],[-96.9023392,33.2635361],[-96.9023392,33.2635361],[-96.9026885,33.2633773],[-96.9026885,33.2633773],[-96.9027649,33.2634904],[-96.9027681,33.2634945],[-96.9027681,33.2634945],[-96.9024292,33.2636666],[-96.9024292,33.2636666]]]},"properties":{"lotName":"1A-M-2","lotCpId":"5338751615535342094","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9025515,33.2638245],[-96.9025389,33.2638094],[-96.9025275,33.2637951],[-96.9024993,33.2637593],[-96.9024292,33.2636666],[-96.9024292,33.2636666],[-96.9027681,33.2634945],[-96.9027681,33.2634945],[-96.9029002,33.2636634],[-96.9029002,33.2636634],[-96.9026066,33.2638309],[-96.9025515,33.2638245],[-96.9025515,33.2638245]]]},"properties":{"lotName":"1A-M-1","lotCpId":"3834271615535372538","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9031043,33.2633188],[-96.9031087,33.2633253],[-96.9031233,33.2633457],[-96.9031508,33.2633819],[-96.9031938,33.2634357],[-96.9032091,33.2634539],[-96.9032091,33.2634539],[-96.9032004,33.2634923],[-96.9029002,33.2636634],[-96.9029002,33.2636634],[-96.9027649,33.2634904],[-96.9027649,33.2634904],[-96.9031043,33.2633188],[-96.9031043,33.2633188]]]},"properties":{"lotName":"1B-M-29","lotCpId":"4558771615535797403","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9030099,33.2631787],[-96.9030175,33.263191],[-96.9030381,33.2632231],[-96.9031043,33.2633188],[-96.9031043,33.2633188],[-96.9027649,33.2634904],[-96.9027649,33.2634904],[-96.9026584,33.2633321],[-96.9026584,33.2633321],[-96.9030099,33.2631787],[-96.9030099,33.2631787]]]},"properties":{"lotName":"1B-M-28","lotCpId":"3450631615535801381","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9029259,33.2630336],[-96.9029334,33.2630476],[-96.902953,33.2630829],[-96.9030099,33.2631787],[-96.9030099,33.2631787],[-96.9026584,33.2633321],[-96.9026584,33.2633321],[-96.902564,33.2631683],[-96.902564,33.2631683],[-96.9029259,33.2630336],[-96.9029259,33.2630336]]]},"properties":{"lotName":"1B-M-27","lotCpId":"2634831615535848883","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9028533,33.2628849],[-96.902861,33.2629013],[-96.9028798,33.2629411],[-96.9029259,33.2630336],[-96.9029259,33.2630336],[-96.902564,33.2631683],[-96.902564,33.2631683],[-96.9024816,33.2630003],[-96.9024816,33.2630003],[-96.9028533,33.2628849],[-96.9028533,33.2628849]]]},"properties":{"lotName":"1B-M-26","lotCpId":"8577461615535770739","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9027922,33.2627324],[-96.9027971,33.2627465],[-96.9028104,33.2627825],[-96.9028533,33.2628849],[-96.9028533,33.2628849],[-96.9024816,33.2630003],[-96.9024816,33.2630003],[-96.9024129,33.2628278],[-96.9024129,33.2628278],[-96.9027922,33.2627324],[-96.9027922,33.2627324]]]},"properties":{"lotName":"1B-M-25","lotCpId":"2654551615535852160","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9027425,33.2625768],[-96.9027465,33.262591],[-96.9027573,33.2626276],[-96.9027922,33.2627324],[-96.9027922,33.2627324],[-96.9024129,33.2628278],[-96.9024129,33.2628278],[-96.9023566,33.2626521],[-96.9023566,33.2626521],[-96.9027425,33.2625768],[-96.9027425,33.2625768]]]},"properties":{"lotName":"1B-M-24","lotCpId":"4856141615535800080","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9027048,33.2624194],[-96.9027076,33.2624335],[-96.9027153,33.2624701],[-96.9027425,33.2625768],[-96.9027425,33.2625768],[-96.9023566,33.2626521],[-96.9023566,33.2626521],[-96.9023141,33.2624741],[-96.9023141,33.2624741],[-96.9027048,33.2624194],[-96.9027048,33.2624194]]]},"properties":{"lotName":"1B-M-23","lotCpId":"3576471615535798746","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9026792,33.2622597],[-96.9026806,33.2622725],[-96.902685,33.2623071],[-96.9026929,33.262358],[-96.9027048,33.2624194],[-96.9027048,33.2624194],[-96.9023141,33.2624741],[-96.9023141,33.2624741],[-96.9022846,33.2622943],[-96.9022846,33.2622943],[-96.9026792,33.2622597],[-96.9026792,33.2622597]]]},"properties":{"lotName":"1B-M-22","lotCpId":"6635861615535765343","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9026645,33.2620986],[-96.9026683,33.2621515],[-96.9026688,33.2621591],[-96.9026705,33.2621808],[-96.9026792,33.2622597],[-96.9026792,33.2622597],[-96.9022846,33.2622943],[-96.9022846,33.2622943],[-96.9022688,33.2621186],[-96.9022688,33.2621186],[-96.9026645,33.2620986],[-96.9026645,33.2620986]]]},"properties":{"lotName":"1B-M-21","lotCpId":"1380821615535768252","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9026524,33.2619343],[-96.9026645,33.2620986],[-96.9026645,33.2620986],[-96.9022688,33.2621186],[-96.9022688,33.2621186],[-96.9022568,33.2619544],[-96.9022568,33.2619544],[-96.9026524,33.2619343],[-96.9026524,33.2619343]]]},"properties":{"lotName":"1B-M-20","lotCpId":"5670821615535848224","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9026404,33.2617704],[-96.9026524,33.2619343],[-96.9026524,33.2619343],[-96.9022568,33.2619544],[-96.9022568,33.2619544],[-96.9022448,33.2617905],[-96.9022448,33.2617905],[-96.9026404,33.2617704],[-96.9026404,33.2617704]]]},"properties":{"lotName":"1B-M-19","lotCpId":"8577161615535793083","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9026284,33.2616062],[-96.9026404,33.2617704],[-96.9026404,33.2617704],[-96.9022448,33.2617905],[-96.9022448,33.2617905],[-96.9022327,33.2616267],[-96.9022327,33.2616267],[-96.9026284,33.2616062],[-96.9026284,33.2616062]]]},"properties":{"lotName":"1B-M-18","lotCpId":"4551641615535783285","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9025951,33.2613643],[-96.9025982,33.2613738],[-96.9026055,33.2614003],[-96.90262,33.2614908],[-96.9026284,33.2616062],[-96.9026284,33.2616062],[-96.9022327,33.2616267],[-96.9022327,33.2616267],[-96.9022207,33.2614597],[-96.9022207,33.2614597],[-96.9022469,33.2614531],[-96.9023185,33.261433],[-96.9024251,33.2613988],[-96.9025564,33.2613501],[-96.9025951,33.2613643],[-96.9025951,33.2613643]]]},"properties":{"lotName":"1B-M-17","lotCpId":"5224131615535770308","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9002767,33.2648243],[-96.900417,33.2647545],[-96.900417,33.2647545],[-96.9006648,33.2651009],[-96.9006648,33.2651009],[-96.9005245,33.2651711],[-96.9005245,33.2651711],[-96.9002767,33.2648243],[-96.9002767,33.2648243]]]},"properties":{"lotName":"1A-R-12","lotCpId":"2830501615535293249","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9001359,33.2648946],[-96.9002767,33.2648243],[-96.9002767,33.2648243],[-96.9005245,33.2651711],[-96.9005245,33.2651711],[-96.9003837,33.2652414],[-96.9003837,33.2652414],[-96.9001359,33.2648946],[-96.9001359,33.2648946]]]},"properties":{"lotName":"1A-R-11","lotCpId":"1851551615535215792","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8999956,33.2649649],[-96.9001359,33.2648946],[-96.9001359,33.2648946],[-96.9003837,33.2652414],[-96.9003837,33.2652414],[-96.9002434,33.2653117],[-96.9002434,33.2653117],[-96.8999956,33.2649649],[-96.8999956,33.2649649]]]},"properties":{"lotName":"1A-R-10","lotCpId":"1506851615535216602","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998565,33.2650324],[-96.8998795,33.2650225],[-96.8999395,33.2649936],[-96.8999956,33.2649649],[-96.8999956,33.2649649],[-96.9002434,33.2653117],[-96.9002434,33.2653117],[-96.9000868,33.2653897],[-96.9000868,33.2653897],[-96.8998565,33.2650324],[-96.8998565,33.2650324]]]},"properties":{"lotName":"1A-R-9","lotCpId":"5325161615535344135","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8997135,33.2650913],[-96.8997261,33.2650867],[-96.899759,33.2650741],[-96.8998565,33.2650324],[-96.8998565,33.2650324],[-96.9000868,33.2653897],[-96.9000868,33.2653897],[-96.8999187,33.2654737],[-96.8999187,33.2654737],[-96.8997135,33.2650913],[-96.8997135,33.2650913]]]},"properties":{"lotName":"1A-R-8","lotCpId":"6855781615535247174","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8995661,33.265141],[-96.8995809,33.2651366],[-96.8996178,33.2651251],[-96.8997135,33.2650913],[-96.8997135,33.2650913],[-96.8999187,33.2654737],[-96.8999187,33.2654737],[-96.8997359,33.2655335],[-96.8997359,33.2655335],[-96.8995661,33.265141],[-96.8995661,33.265141]]]},"properties":{"lotName":"1A-R-7","lotCpId":"7456341615535256575","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.899415,33.2651812],[-96.8994294,33.2651778],[-96.8994662,33.2651688],[-96.8995661,33.265141],[-96.8995661,33.265141],[-96.8997359,33.2655335],[-96.8997359,33.2655335],[-96.8995498,33.2655832],[-96.8995498,33.2655832],[-96.899415,33.2651812],[-96.899415,33.2651812]]]},"properties":{"lotName":"1A-R-6","lotCpId":"3307521615535219052","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8992605,33.2652127],[-96.8992725,33.2652108],[-96.8993054,33.2652051],[-96.899415,33.2651812],[-96.899415,33.2651812],[-96.8995498,33.2655832],[-96.8995498,33.2655832],[-96.8993598,33.2656216],[-96.8993598,33.2656216],[-96.8992605,33.2652127],[-96.8992605,33.2652127]]]},"properties":{"lotName":"1A-R-5","lotCpId":"6132461615535230096","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8991039,33.2652341],[-96.8991183,33.2652325],[-96.8991555,33.2652281],[-96.8992605,33.2652127],[-96.8992605,33.2652127],[-96.8993598,33.2656216],[-96.8993598,33.2656216],[-96.8991666,33.265648],[-96.8991666,33.265648],[-96.8991039,33.2652341],[-96.8991039,33.2652341]]]},"properties":{"lotName":"1A-R-4","lotCpId":"8672361615888291551","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989456,33.265246],[-96.8989612,33.2652452],[-96.8990005,33.2652429],[-96.8991039,33.2652341],[-96.8991039,33.2652341],[-96.8991666,33.265648],[-96.8991666,33.265648],[-96.8989718,33.2656631],[-96.8989718,33.2656631],[-96.8989456,33.265246],[-96.8989456,33.265246]]]},"properties":{"lotName":"1A-R-3","lotCpId":"2812051615888291551","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987868,33.2652483],[-96.898801,33.2652485],[-96.8988378,33.2652486],[-96.8989456,33.265246],[-96.8989456,33.265246],[-96.8989718,33.2656631],[-96.8989718,33.2656631],[-96.8987764,33.2656658],[-96.8987764,33.2656658],[-96.8987868,33.2652483],[-96.8987868,33.2652483]]]},"properties":{"lotName":"1A-R-2","lotCpId":"3612281615888291522","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8986236,33.2652432],[-96.898754,33.2652474],[-96.8987868,33.2652483],[-96.8987868,33.2652483],[-96.8987764,33.2656658],[-96.8987764,33.2656658],[-96.8986061,33.2656608],[-96.8986061,33.2656608],[-96.8986236,33.2652432],[-96.8986236,33.2652432]]]},"properties":{"lotName":"1A-R-1","lotCpId":"1721441615888291324","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038968,33.2628684],[-96.9039035,33.2628786],[-96.9039219,33.2629052],[-96.9039841,33.2629853],[-96.9039989,33.2630035],[-96.9039989,33.2630035],[-96.9039901,33.2630414],[-96.9036899,33.263213],[-96.9036899,33.263213],[-96.9035513,33.2630341],[-96.9035513,33.2630341],[-96.9038968,33.2628684],[-96.9038968,33.2628684]]]},"properties":{"lotName":"1B-N-24","lotCpId":"6752781615535764103","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038095,33.262727],[-96.9038169,33.2627403],[-96.9038366,33.2627742],[-96.9038968,33.2628684],[-96.9038968,33.2628684],[-96.9035513,33.2630341],[-96.9035513,33.2630341],[-96.9034493,33.2628648],[-96.9034493,33.2628648],[-96.9038095,33.262727],[-96.9038095,33.262727]]]},"properties":{"lotName":"1B-N-23","lotCpId":"3813141615535764926","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.903738,33.2625791],[-96.903743,33.2625914],[-96.9037573,33.2626243],[-96.9038095,33.262727],[-96.9038095,33.262727],[-96.9034493,33.2628648],[-96.9034493,33.2628648],[-96.9033641,33.2626891],[-96.9033641,33.2626891],[-96.903738,33.2625791],[-96.903738,33.2625791]]]},"properties":{"lotName":"1B-N-22","lotCpId":"3147281615535787904","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9036829,33.2624267],[-96.903687,33.2624403],[-96.9036985,33.2624758],[-96.903738,33.2625791],[-96.903738,33.2625791],[-96.9033641,33.2626891],[-96.9033641,33.2626891],[-96.9032986,33.2625079],[-96.9032986,33.2625079],[-96.9036829,33.2624267],[-96.9036829,33.2624267]]]},"properties":{"lotName":"1B-N-21","lotCpId":"6756521615535769488","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9036446,33.2622706],[-96.9036478,33.2622863],[-96.9036563,33.2623256],[-96.9036829,33.2624267],[-96.9036829,33.2624267],[-96.9032986,33.2625079],[-96.9032986,33.2625079],[-96.9032533,33.2623222],[-96.9032533,33.2623222],[-96.9036446,33.2622706],[-96.9036446,33.2622706]]]},"properties":{"lotName":"1B-N-20","lotCpId":"5602711615535766994","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9036228,33.2621031],[-96.9036237,33.262118],[-96.9036271,33.2621566],[-96.9036446,33.2622706],[-96.9036446,33.2622706],[-96.9032533,33.2623222],[-96.9032533,33.2623222],[-96.9032271,33.2621232],[-96.9032271,33.2621232],[-96.9036228,33.2621031],[-96.9036228,33.2621031]]]},"properties":{"lotName":"1B-N-19","lotCpId":"4246851615535769074","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9036108,33.2619388],[-96.9036228,33.2621031],[-96.9036228,33.2621031],[-96.9032271,33.2621232],[-96.9032271,33.2621232],[-96.9032151,33.2619594],[-96.9032151,33.2619594],[-96.9036108,33.2619388],[-96.9036108,33.2619388]]]},"properties":{"lotName":"1B-N-18","lotCpId":"8728241615535791139","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035988,33.261775],[-96.9036108,33.2619388],[-96.9036108,33.2619388],[-96.9032151,33.2619594],[-96.9032151,33.2619594],[-96.9032031,33.2617951],[-96.9032031,33.2617951],[-96.9035988,33.261775],[-96.9035988,33.261775]]]},"properties":{"lotName":"1B-N-17","lotCpId":"5860841615535804044","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035868,33.2616112],[-96.9035988,33.261775],[-96.9035988,33.261775],[-96.9032031,33.2617951],[-96.9032031,33.2617951],[-96.9031911,33.2616313],[-96.9031911,33.2616313],[-96.9035868,33.2616112],[-96.9035868,33.2616112]]]},"properties":{"lotName":"1B-N-16","lotCpId":"8471471615535782601","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035726,33.2614359],[-96.9035742,33.2614523],[-96.9035782,33.2614964],[-96.9035868,33.2616112],[-96.9035868,33.2616112],[-96.9031911,33.2616313],[-96.9031911,33.2616313],[-96.9031786,33.2614702],[-96.9031786,33.2614702],[-96.9035726,33.2614359],[-96.9035726,33.2614359]]]},"properties":{"lotName":"1B-N-15","lotCpId":"1714201615535783965","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035306,33.2612379],[-96.9035361,33.2612572],[-96.9035489,33.2613059],[-96.9035726,33.2614359],[-96.9035726,33.2614359],[-96.9031786,33.2614702],[-96.9031786,33.2614702],[-96.9031464,33.2613187],[-96.9031464,33.2613187],[-96.9035306,33.2612379],[-96.9035306,33.2612379]]]},"properties":{"lotName":"1B-N-14","lotCpId":"4454581615535844384","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9034602,33.2610562],[-96.9034685,33.2610744],[-96.9034881,33.2611198],[-96.9035306,33.2612379],[-96.9035306,33.2612379],[-96.9031464,33.2613187],[-96.9031464,33.2613187],[-96.9030885,33.2611694],[-96.9030885,33.2611694],[-96.9034602,33.2610562],[-96.9034602,33.2610562]]]},"properties":{"lotName":"1B-N-13","lotCpId":"4180221615535796726","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9027982,33.2616833],[-96.9027862,33.2615194],[-96.9027862,33.2615194],[-96.9031807,33.2614994],[-96.9031807,33.2614994],[-96.9031911,33.2616313],[-96.9031938,33.2616632],[-96.9031938,33.2616632],[-96.9027982,33.2616833],[-96.9027982,33.2616833]]]},"properties":{"lotName":"1B-N-11","lotCpId":"3285311615535804706","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9028102,33.2618476],[-96.9027982,33.2616833],[-96.9027982,33.2616833],[-96.9031938,33.2616632],[-96.9031938,33.2616632],[-96.9032059,33.2618275],[-96.9032059,33.2618275],[-96.9028102,33.2618476],[-96.9028102,33.2618476]]]},"properties":{"lotName":"1B-N-10","lotCpId":"3603211615535791802","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9028222,33.2620114],[-96.9028102,33.2618476],[-96.9028102,33.2618476],[-96.9032059,33.2618275],[-96.9032059,33.2618275],[-96.9032179,33.2619913],[-96.9032179,33.2619913],[-96.9028222,33.2620114],[-96.9028222,33.2620114]]]},"properties":{"lotName":"1B-N-9","lotCpId":"8825381615535789862","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9028347,33.2621793],[-96.902832,33.2621433],[-96.9028222,33.2620114],[-96.9028222,33.2620114],[-96.9032179,33.2619913],[-96.9032179,33.2619913],[-96.9032271,33.2621232],[-96.9032315,33.2621542],[-96.9032315,33.2621542],[-96.9028347,33.2621793],[-96.9028347,33.2621793]]]},"properties":{"lotName":"1B-N-8","lotCpId":"5262301615535867960","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9028598,33.2623623],[-96.9028569,33.2623476],[-96.90285,33.2623077],[-96.9028418,33.2622494],[-96.9028347,33.2621793],[-96.9028347,33.2621793],[-96.9032315,33.2621542],[-96.9032315,33.2621542],[-96.9032522,33.2623117],[-96.9032522,33.2623117],[-96.9028598,33.2623623],[-96.9028598,33.2623623]]]},"properties":{"lotName":"1B-N-7","lotCpId":"2130501615535802069","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9029013,33.2625431],[-96.902897,33.2625281],[-96.9028864,33.262488],[-96.9028729,33.2624303],[-96.9028598,33.2623623],[-96.9028598,33.2623623],[-96.9032522,33.2623117],[-96.9032522,33.2623117],[-96.9032533,33.2623222],[-96.9032888,33.2624678],[-96.9032888,33.2624678],[-96.9029013,33.2625431],[-96.9029013,33.2625431]]]},"properties":{"lotName":"1B-N-6","lotCpId":"3647811615535788561","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9029592,33.2627206],[-96.902953,33.262704],[-96.902938,33.2626615],[-96.9029013,33.2625431],[-96.9029013,33.2625431],[-96.9032888,33.2624678],[-96.9032888,33.2624678],[-96.9032986,33.2625079],[-96.9033396,33.2626206],[-96.9033396,33.2626206],[-96.9029592,33.2627206],[-96.9029592,33.2627206]]]},"properties":{"lotName":"1B-N-5","lotCpId":"4305201615535772399","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9030334,33.262894],[-96.9030258,33.2628783],[-96.903007,33.2628377],[-96.9029592,33.2627206],[-96.9029592,33.2627206],[-96.9033326,33.2626225],[-96.9033326,33.2626225],[-96.9033396,33.2626206],[-96.9033641,33.2626891],[-96.9034034,33.2627699],[-96.9034034,33.2627699],[-96.9030334,33.262894],[-96.9030334,33.262894]]]},"properties":{"lotName":"1B-N-4","lotCpId":"3301211615535867304","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9031229,33.2630619],[-96.9031153,33.2630497],[-96.9030951,33.2630152],[-96.9030665,33.2629621],[-96.9030334,33.262894],[-96.9030334,33.262894],[-96.9034034,33.2627699],[-96.9034034,33.2627699],[-96.9034493,33.2628648],[-96.9034798,33.2629154],[-96.9034798,33.2629154],[-96.9031229,33.2630619],[-96.9031229,33.2630619]]]},"properties":{"lotName":"1B-N-3","lotCpId":"8517151615535846285","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9032271,33.2632239],[-96.9032182,33.2632115],[-96.9031945,33.2631772],[-96.9031611,33.2631258],[-96.9031229,33.2630619],[-96.9031229,33.2630619],[-96.9034798,33.2629154],[-96.9034798,33.2629154],[-96.9035513,33.2630341],[-96.9035682,33.263056],[-96.9035682,33.263056],[-96.9032271,33.2632239],[-96.9032271,33.2632239]]]},"properties":{"lotName":"1B-N-2","lotCpId":"3608731615535790504","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9033445,33.2633768],[-96.9033292,33.2633586],[-96.9033206,33.2633483],[-96.9032977,33.2633199],[-96.9032651,33.2632772],[-96.9032271,33.2632239],[-96.9032271,33.2632239],[-96.9035682,33.263056],[-96.9035682,33.263056],[-96.9036899,33.263213],[-96.9036899,33.263213],[-96.9033898,33.2633841],[-96.9033445,33.2633768],[-96.9033445,33.2633768]]]},"properties":{"lotName":"1B-N-1","lotCpId":"4865041615535794742","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9039836,33.2616481],[-96.9037871,33.2616582],[-96.9037871,33.2616582],[-96.9037527,33.2616326],[-96.9037416,33.261488],[-96.9037406,33.2614738],[-96.9037372,33.2614374],[-96.9037216,33.261336],[-96.9037216,33.261336],[-96.9039552,33.2613045],[-96.9039585,33.2613045],[-96.9039585,33.2613045],[-96.9039836,33.2616481],[-96.9039836,33.2616481]]]},"properties":{"lotName":"1B-P-25","lotCpId":"4026801615535764514","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9041795,33.2616381],[-96.9039836,33.2616481],[-96.9039836,33.2616481],[-96.9039585,33.2613045],[-96.9039585,33.2613045],[-96.9041418,33.2612826],[-96.9041533,33.2612821],[-96.9041533,33.2612821],[-96.9041795,33.2616381],[-96.9041795,33.2616381]]]},"properties":{"lotName":"1B-P-24","lotCpId":"1764301615535798101","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9043738,33.2616285],[-96.9043345,33.2616304],[-96.9041795,33.2616381],[-96.9041795,33.2616381],[-96.9041533,33.2612821],[-96.9041533,33.2612821],[-96.9043301,33.261273],[-96.9043596,33.2612739],[-96.9043596,33.2612739],[-96.9043738,33.2616285],[-96.9043738,33.2616285]]]},"properties":{"lotName":"1B-P-23","lotCpId":"7272461615535781283","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045621,33.2616335],[-96.9045426,33.2616323],[-96.9044944,33.2616297],[-96.9043738,33.2616285],[-96.9043738,33.2616285],[-96.9043596,33.2612739],[-96.9043596,33.2612739],[-96.9045179,33.2612785],[-96.9046008,33.2612872],[-96.9046008,33.2612872],[-96.9045621,33.2616335],[-96.9045621,33.2616335]]]},"properties":{"lotName":"1B-P-22","lotCpId":"2336501615535779985","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047476,33.2616582],[-96.9047317,33.261655],[-96.9046895,33.2616476],[-96.9045621,33.2616335],[-96.9045621,33.2616335],[-96.9046008,33.2612872],[-96.9046008,33.2612872],[-96.9047051,33.2612986],[-96.9048377,33.2613241],[-96.9048377,33.2613241],[-96.9047476,33.2616582],[-96.9047476,33.2616582]]]},"properties":{"lotName":"1B-P-21","lotCpId":"3862541615535781945","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049283,33.2617024],[-96.9049114,33.2616975],[-96.9048681,33.2616855],[-96.9047476,33.2616582],[-96.9047476,33.2616582],[-96.9048377,33.2613241],[-96.9048377,33.2613241],[-96.9048885,33.2613342],[-96.9050669,33.2613839],[-96.9050669,33.2613839],[-96.9049283,33.2617024],[-96.9049283,33.2617024]]]},"properties":{"lotName":"1B-P-20","lotCpId":"1735031615535766582","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051008,33.2617654],[-96.9050861,33.261759],[-96.9050474,33.2617429],[-96.9049283,33.2617024],[-96.9049283,33.2617024],[-96.9050669,33.2613839],[-96.9050669,33.2613839],[-96.9052388,33.2614478],[-96.9052836,33.2614688],[-96.9052836,33.2614688],[-96.9051008,33.2617654],[-96.9051008,33.2617654]]]},"properties":{"lotName":"1B-P-19","lotCpId":"4846231615535786602","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052618,33.2618462],[-96.9052474,33.261838],[-96.90521,33.2618176],[-96.9051008,33.2617654],[-96.9051008,33.2617654],[-96.9052836,33.2614688],[-96.9052836,33.2614688],[-96.9054031,33.2615254],[-96.9054866,33.2615742],[-96.9054866,33.2615742],[-96.9052618,33.2618462],[-96.9052618,33.2618462]]]},"properties":{"lotName":"1B-P-18","lotCpId":"6404681615535765754","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054097,33.2619439],[-96.9053952,33.2619333],[-96.9053588,33.2619077],[-96.9052618,33.2618462],[-96.9052618,33.2618462],[-96.9054866,33.2615742],[-96.9054866,33.2615742],[-96.9055576,33.2616153],[-96.9056738,33.2616983],[-96.9056738,33.2616983],[-96.9054097,33.2619439],[-96.9054097,33.2619439]]]},"properties":{"lotName":"1B-P-17","lotCpId":"3253301615535869263","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9055412,33.2620561],[-96.9055294,33.2620448],[-96.9054988,33.2620165],[-96.9054097,33.2619439],[-96.9054097,33.2619439],[-96.9056738,33.2616983],[-96.9056738,33.2616983],[-96.9057006,33.2617175],[-96.9058283,33.2618279],[-96.9058403,33.2618407],[-96.9058403,33.2618407],[-96.9055412,33.2620561],[-96.9055412,33.2620561]]]},"properties":{"lotName":"1B-P-16","lotCpId":"2224701615535800741","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056613,33.262183],[-96.9056483,33.2621686],[-96.9056167,33.262134],[-96.9055412,33.2620561],[-96.9055412,33.2620561],[-96.9058403,33.2618407],[-96.9058403,33.2618407],[-96.9059713,33.2619813],[-96.9059713,33.2619813],[-96.9056613,33.262183],[-96.9056613,33.262183]]]},"properties":{"lotName":"1B-P-15","lotCpId":"2024311615535784623","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9062769,33.261744],[-96.9062894,33.2617492],[-96.9063236,33.2617575],[-96.9063743,33.2617579],[-96.9064363,33.2617394],[-96.9064363,33.2617394],[-96.9064705,33.2617214],[-96.9064788,33.2617183],[-96.9065,33.2617143],[-96.9065286,33.261718],[-96.906559,33.2617376],[-96.906576,33.2617577],[-96.9065689,33.2617965],[-96.9060897,33.2621086],[-96.9060897,33.2621086],[-96.9059489,33.2619576],[-96.9059489,33.2619576],[-96.9062769,33.261744],[-96.9062769,33.261744]]]},"properties":{"lotName":"1B-P-14","lotCpId":"5336181615535719311","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9061415,33.261624],[-96.90615,33.2616326],[-96.9061708,33.2616538],[-96.9062215,33.2617062],[-96.906236,33.2617205],[-96.9062769,33.261744],[-96.9062769,33.261744],[-96.9059489,33.2619576],[-96.9059489,33.2619576],[-96.9058283,33.2618279],[-96.9058283,33.2618279],[-96.9061415,33.261624],[-96.9061415,33.261624]]]},"properties":{"lotName":"1B-P-13","lotCpId":"6145411615535787259","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9059718,33.2614761],[-96.9059906,33.2614913],[-96.906036,33.2615289],[-96.9061415,33.261624],[-96.9061415,33.261624],[-96.9058283,33.2618279],[-96.9058283,33.2618279],[-96.9057006,33.2617175],[-96.9057006,33.2617175],[-96.9059718,33.2614761],[-96.9059718,33.2614761]]]},"properties":{"lotName":"1B-P-12","lotCpId":"5088071615535789221","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057999,33.2613533],[-96.9058173,33.2613648],[-96.9058608,33.2613941],[-96.9059718,33.2614761],[-96.9059718,33.2614761],[-96.9057006,33.2617175],[-96.9057006,33.2617175],[-96.9055576,33.2616153],[-96.9055576,33.2616153],[-96.9057999,33.2613533],[-96.9057999,33.2613533]]]},"properties":{"lotName":"1B-P-11","lotCpId":"1755521615535850863","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056143,33.2612447],[-96.9056387,33.2612586],[-96.9056948,33.2612909],[-96.905757,33.2613272],[-96.9057999,33.2613533],[-96.9057999,33.2613533],[-96.9055576,33.2616153],[-96.9055576,33.2616153],[-96.9054031,33.2615254],[-96.9054031,33.2615254],[-96.9056143,33.2612447],[-96.9056143,33.2612447]]]},"properties":{"lotName":"1B-P-10","lotCpId":"8607671615535763262","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054173,33.2611521],[-96.9054417,33.2611629],[-96.9054987,33.2611886],[-96.9055643,33.2612192],[-96.9056143,33.2612447],[-96.9056143,33.2612447],[-96.9054031,33.2615254],[-96.9054031,33.2615254],[-96.9052388,33.2614478],[-96.9052388,33.2614478],[-96.9054173,33.2611521],[-96.9054173,33.2611521]]]},"properties":{"lotName":"1B-P-9","lotCpId":"6111651615535866683","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052105,33.261075],[-96.9052323,33.2610823],[-96.9052859,33.261101],[-96.9054173,33.2611521],[-96.9054173,33.2611521],[-96.9052388,33.2614478],[-96.9052388,33.2614478],[-96.9050669,33.2613839],[-96.9050669,33.2613839],[-96.9052105,33.261075],[-96.9052105,33.261075]]]},"properties":{"lotName":"1B-P-8","lotCpId":"8234131615535845642","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049954,33.2610152],[-96.9050179,33.2610207],[-96.9050732,33.2610348],[-96.9052105,33.261075],[-96.9052105,33.261075],[-96.9050669,33.2613839],[-96.9050669,33.2613839],[-96.9048885,33.2613342],[-96.9048885,33.2613342],[-96.9049954,33.2610152],[-96.9049954,33.2610152]]]},"properties":{"lotName":"1B-P-7","lotCpId":"7588511615535866005","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047749,33.2609727],[-96.9047952,33.2609757],[-96.9048473,33.2609843],[-96.9049954,33.2610152],[-96.9049954,33.2610152],[-96.9048885,33.2613342],[-96.9048885,33.2613342],[-96.9047051,33.2612986],[-96.9047051,33.2612986],[-96.9047749,33.2609727],[-96.9047749,33.2609727]]]},"properties":{"lotName":"1B-P-6","lotCpId":"5731031615535847580","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045506,33.2609481],[-96.9045723,33.2609497],[-96.9046271,33.2609546],[-96.9047749,33.2609727],[-96.9047749,33.2609727],[-96.9047051,33.2612986],[-96.9047051,33.2612986],[-96.9045179,33.2612785],[-96.9045179,33.2612785],[-96.9045506,33.2609481],[-96.9045506,33.2609481]]]},"properties":{"lotName":"1B-P-5","lotCpId":"8083021615535845001","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9043241,33.2609417],[-96.9043463,33.2609416],[-96.9044022,33.2609418],[-96.9045506,33.2609481],[-96.9045506,33.2609481],[-96.9045179,33.2612785],[-96.9045179,33.2612785],[-96.9043301,33.261273],[-96.9043301,33.261273],[-96.9043241,33.2609417],[-96.9043241,33.2609417]]]},"properties":{"lotName":"1B-P-4","lotCpId":"5326781615535785283","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9040982,33.2609536],[-96.9041197,33.2609516],[-96.9041743,33.2609475],[-96.9043241,33.2609417],[-96.9043241,33.2609417],[-96.9043301,33.261273],[-96.9043301,33.261273],[-96.9041418,33.2612826],[-96.9041418,33.2612826],[-96.9040982,33.2609536],[-96.9040982,33.2609536]]]},"properties":{"lotName":"1B-P-3","lotCpId":"1874601615535785961","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038744,33.2609832],[-96.9038816,33.2609827],[-96.9039024,33.2609792],[-96.9039551,33.2609708],[-96.9040982,33.2609536],[-96.9040982,33.2609536],[-96.9041418,33.2612826],[-96.9041418,33.2612826],[-96.9039552,33.2613045],[-96.9039552,33.2613045],[-96.9038744,33.2609832],[-96.9038744,33.2609832]]]},"properties":{"lotName":"1B-P-2","lotCpId":"6826751615535795403","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9036943,33.2608942],[-96.9037024,33.2609101],[-96.903731,33.260944],[-96.9037863,33.2609753],[-96.9038744,33.2609832],[-96.9038744,33.2609832],[-96.9039552,33.2613045],[-96.9039552,33.2613045],[-96.9037216,33.261336],[-96.9037216,33.261336],[-96.9037199,33.2613264],[-96.9037144,33.2612991],[-96.9037042,33.2612566],[-96.9036885,33.2612012],[-96.9036375,33.2610613],[-96.903555,33.2608982],[-96.9035704,33.2608623],[-96.9036009,33.2608507],[-96.9036103,33.2608483],[-96.9036334,33.2608469],[-96.9036623,33.2608553],[-96.9036893,33.2608822],[-96.9036943,33.2608942],[-96.9036943,33.2608942]]]},"properties":{"lotName":"1B-P-1","lotCpId":"1132231615535799404","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9055527,33.2624363],[-96.90557,33.2624282],[-96.9056183,33.2624092],[-96.9056918,33.2623867],[-96.9057846,33.2623683],[-96.9057846,33.2623683],[-96.9060258,33.2626275],[-96.9060258,33.2626275],[-96.9058326,33.2627365],[-96.9058326,33.2627365],[-96.9055527,33.2624363],[-96.9055527,33.2624363]]]},"properties":{"lotName":"1B-R-45","lotCpId":"4300731615535767400","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9053922,33.2625312],[-96.9054565,33.2624892],[-96.9054664,33.2624831],[-96.9054909,33.2624687],[-96.9055527,33.2624363],[-96.9055527,33.2624363],[-96.9058326,33.2627365],[-96.9058326,33.2627365],[-96.9056334,33.2627904],[-96.9056334,33.2627904],[-96.9053922,33.2625312],[-96.9053922,33.2625312]]]},"properties":{"lotName":"1B-R-44","lotCpId":"1838721615535793787","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052372,33.262632],[-96.9053922,33.2625312],[-96.9053922,33.2625312],[-96.9056334,33.2627904],[-96.9056334,33.2627904],[-96.9054784,33.2628912],[-96.9054784,33.2628912],[-96.9052372,33.262632],[-96.9052372,33.262632]]]},"properties":{"lotName":"1B-R-43","lotCpId":"5265641615535767818","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9050871,33.2627607],[-96.9050972,33.2627569],[-96.9051212,33.2627431],[-96.90515,33.2627163],[-96.9051744,33.2626731],[-96.9052372,33.262632],[-96.9052372,33.262632],[-96.9054784,33.2628912],[-96.9054784,33.2628912],[-96.9053109,33.2630008],[-96.9053109,33.2630008],[-96.9050871,33.2627607],[-96.9050871,33.2627607]]]},"properties":{"lotName":"1B-R-42","lotCpId":"1660481615535769897","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047837,33.2625467],[-96.904853,33.2626311],[-96.9048523,33.2626405],[-96.9048549,33.2626643],[-96.9048672,33.2626962],[-96.9048961,33.2627297],[-96.9048961,33.2627297],[-96.9045937,33.2629017],[-96.9045937,33.2629017],[-96.9044567,33.2627334],[-96.9044567,33.2627334],[-96.9047837,33.2625467],[-96.9047837,33.2625467]]]},"properties":{"lotName":"1B-R-41","lotCpId":"6084861615535718749","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9046892,33.2624121],[-96.904694,33.2624208],[-96.9047089,33.2624455],[-96.9047351,33.262484],[-96.9047738,33.2625344],[-96.9047837,33.2625467],[-96.9047837,33.2625467],[-96.9044567,33.2627334],[-96.9044567,33.2627334],[-96.9043449,33.2625741],[-96.9043323,33.2625563],[-96.9043323,33.2625563],[-96.9046892,33.2624121],[-96.9046892,33.2624121]]]},"properties":{"lotName":"1B-R-40","lotCpId":"2175161615535792440","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9046221,33.262267],[-96.9046269,33.2622805],[-96.9046404,33.2623153],[-96.9046892,33.2624121],[-96.9046892,33.2624121],[-96.9043323,33.2625563],[-96.9043323,33.2625563],[-96.9042745,33.2624303],[-96.9042423,33.262361],[-96.9042423,33.262361],[-96.9046221,33.262267],[-96.9046221,33.262267]]]},"properties":{"lotName":"1B-R-39","lotCpId":"2076471615535763685","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045839,33.262115],[-96.904586,33.2621289],[-96.9045926,33.2621647],[-96.9046221,33.262267],[-96.9046221,33.262267],[-96.9042423,33.262361],[-96.9042423,33.262361],[-96.904191,33.2621561],[-96.904191,33.2621561],[-96.9045839,33.262115],[-96.9045839,33.262115]]]},"properties":{"lotName":"1B-R-38","lotCpId":"5632141615535771562","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045703,33.2619544],[-96.9045774,33.2620543],[-96.9045791,33.2620749],[-96.9045839,33.262115],[-96.9045839,33.262115],[-96.904191,33.2621561],[-96.904191,33.2621561],[-96.9041746,33.2619749],[-96.9041746,33.2619749],[-96.9045703,33.2619544],[-96.9045703,33.2619544]]]},"properties":{"lotName":"1B-R-37","lotCpId":"6378501615535850181","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045588,33.2617978],[-96.9045703,33.2619544],[-96.9045703,33.2619544],[-96.9041746,33.2619749],[-96.9041746,33.2619749],[-96.9041599,33.2617764],[-96.9041599,33.2617764],[-96.9041708,33.2617758],[-96.9042045,33.2617741],[-96.904262,33.2617711],[-96.9043443,33.2617668],[-96.9043706,33.2617662],[-96.9044292,33.2617652],[-96.9044896,33.2617653],[-96.9045212,33.261768],[-96.9045588,33.2617978],[-96.9045588,33.2617978]]]},"properties":{"lotName":"1B-R-36","lotCpId":"6677801615535846943","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037784,33.2619877],[-96.9037664,33.2618238],[-96.9037664,33.2618238],[-96.9037969,33.2617951],[-96.9041599,33.2617764],[-96.9041599,33.2617764],[-96.904174,33.2619676],[-96.904174,33.2619676],[-96.9037784,33.2619877],[-96.9037784,33.2619877]]]},"properties":{"lotName":"1B-R-35","lotCpId":"6365641615535849526","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037931,33.2621629],[-96.9037906,33.2621434],[-96.903786,33.2620945],[-96.9037784,33.2619877],[-96.9037784,33.2619877],[-96.904174,33.2619676],[-96.904174,33.2619676],[-96.9041746,33.2619749],[-96.9041882,33.2621287],[-96.9041882,33.2621287],[-96.9037931,33.2621629],[-96.9037931,33.2621629]]]},"properties":{"lotName":"1B-R-34","lotCpId":"3183511615535802703","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038313,33.2623559],[-96.9038266,33.2623386],[-96.9038155,33.2622937],[-96.9037931,33.2621629],[-96.9037931,33.2621629],[-96.9041882,33.2621287],[-96.9041882,33.2621287],[-96.904191,33.2621561],[-96.9042223,33.2622811],[-96.9042223,33.2622811],[-96.9038313,33.2623559],[-96.9038313,33.2623559]]]},"properties":{"lotName":"1B-R-33","lotCpId":"8853701615535851525","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038968,33.262544],[-96.9038895,33.2625265],[-96.9038718,33.2624817],[-96.9038313,33.2623559],[-96.9038313,33.2623559],[-96.9042223,33.2622811],[-96.9042223,33.2622811],[-96.9042423,33.262361],[-96.9042745,33.2624303],[-96.9042745,33.2624303],[-96.9038968,33.262544],[-96.9038968,33.262544]]]},"properties":{"lotName":"1B-R-32","lotCpId":"2417461615535843745","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.903989,33.2627233],[-96.9039789,33.262706],[-96.9039542,33.2626622],[-96.9038968,33.262544],[-96.9038968,33.262544],[-96.9042745,33.2624303],[-96.9042745,33.2624303],[-96.9043323,33.2625563],[-96.9043449,33.2625741],[-96.9043449,33.2625741],[-96.903989,33.2627233],[-96.903989,33.2627233]]]},"properties":{"lotName":"1B-R-31","lotCpId":"5554131615535766169","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9041069,33.2628926],[-96.9040948,33.2628773],[-96.9040647,33.2628377],[-96.903989,33.2627233],[-96.903989,33.2627233],[-96.9043449,33.2625741],[-96.9043449,33.2625741],[-96.9044387,33.2627083],[-96.9044387,33.2627083],[-96.9041069,33.2628926],[-96.9041069,33.2628926]]]},"properties":{"lotName":"1B-R-30","lotCpId":"3632341615535796060","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9042248,33.2630122],[-96.9042222,33.2630001],[-96.9042088,33.2629709],[-96.9041761,33.2629352],[-96.9041154,33.2629036],[-96.9041069,33.2628926],[-96.9041069,33.2628926],[-96.9044387,33.2627083],[-96.9044387,33.2627083],[-96.9044567,33.2627334],[-96.9045937,33.2629017],[-96.9045937,33.2629017],[-96.9044518,33.262983],[-96.9042248,33.2630122],[-96.9042248,33.2630122]]]},"properties":{"lotName":"1B-R-29","lotCpId":"7263201615535868600","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9034978,33.2656859],[-96.9034951,33.2657041],[-96.9034889,33.265748],[-96.9034793,33.2658493],[-96.9034793,33.2658493],[-96.903082,33.2658351],[-96.903082,33.2658351],[-96.9031043,33.2656371],[-96.9031043,33.2656371],[-96.9034978,33.2656859],[-96.9034978,33.2656859]]]},"properties":{"lotName":"3-R-74","lotCpId":"6325101615532561753","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035366,33.2655248],[-96.9035318,33.2655413],[-96.9035205,33.2655822],[-96.9034978,33.2656859],[-96.9034978,33.2656859],[-96.9031043,33.2656371],[-96.9031043,33.2656371],[-96.9031513,33.2654418],[-96.9031513,33.2654418],[-96.9035366,33.2655248],[-96.9035366,33.2655248]]]},"properties":{"lotName":"3-R-73","lotCpId":"7315731615532561208","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.904531,33.2658447],[-96.9044469,33.2659935],[-96.9044469,33.2659935],[-96.9040545,33.2658639],[-96.9040545,33.2658639],[-96.9041397,33.2656909],[-96.9041397,33.2656909],[-96.904531,33.2658447],[-96.904531,33.2658447]]]},"properties":{"lotName":"3-R-67","lotCpId":"6886501615532647390","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9046167,33.2656909],[-96.9046118,33.2657015],[-96.9046031,33.265718],[-96.9045878,33.2657449],[-96.904531,33.2658447],[-96.904531,33.2658447],[-96.9041397,33.2656909],[-96.9041397,33.2656909],[-96.9042139,33.2655412],[-96.9042139,33.2655412],[-96.9046167,33.2656909],[-96.9046167,33.2656909]]]},"properties":{"lotName":"3-R-66","lotCpId":"7255381615532661508","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.904698,33.2655221],[-96.9046923,33.2655357],[-96.904676,33.2655725],[-96.9046504,33.2656262],[-96.9046167,33.2656909],[-96.9046167,33.2656909],[-96.9042139,33.2655412],[-96.9042139,33.2655412],[-96.9042854,33.2653961],[-96.9042854,33.2653961],[-96.904698,33.2655221],[-96.904698,33.2655221]]]},"properties":{"lotName":"3-R-65","lotCpId":"2106551615532662209","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047657,33.2653491],[-96.9047609,33.2653633],[-96.9047473,33.2654014],[-96.9047259,33.2654566],[-96.904698,33.2655221],[-96.904698,33.2655221],[-96.9042854,33.2653961],[-96.9042854,33.2653961],[-96.9043569,33.2652501],[-96.9043569,33.2652501],[-96.9047657,33.2653491],[-96.9047657,33.2653491]]]},"properties":{"lotName":"3-R-64","lotCpId":"5577441615532648768","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048191,33.2651725],[-96.9048151,33.2651883],[-96.9048038,33.2652293],[-96.9047657,33.2653491],[-96.9047657,33.2653491],[-96.9043569,33.2652501],[-96.9043569,33.2652501],[-96.90443,33.2651022],[-96.90443,33.2651022],[-96.9048191,33.2651725],[-96.9048191,33.2651725]]]},"properties":{"lotName":"3-R-63","lotCpId":"1254711615532626341","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048584,33.2650055],[-96.9048344,33.2651119],[-96.9048191,33.2651725],[-96.9048191,33.2651725],[-96.90443,33.2651022],[-96.90443,33.2651022],[-96.9044387,33.2650657],[-96.9044677,33.2649425],[-96.9044677,33.2649425],[-96.9048584,33.2650055],[-96.9048584,33.2650055]]]},"properties":{"lotName":"3-R-62","lotCpId":"8466371615532644671","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049005,33.264849],[-96.904898,33.2648567],[-96.9048909,33.2648802],[-96.90488,33.2649203],[-96.9048657,33.2649776],[-96.9048584,33.2650055],[-96.9048584,33.2650055],[-96.9044677,33.2649425],[-96.9044677,33.2649425],[-96.9045162,33.2647614],[-96.9045162,33.2647614],[-96.9049005,33.264849],[-96.9049005,33.264849]]]},"properties":{"lotName":"3-R-61","lotCpId":"3007611615532649471","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049589,33.2646979],[-96.9049508,33.264718],[-96.9049325,33.2647642],[-96.9049128,33.2648149],[-96.9049005,33.264849],[-96.9049005,33.264849],[-96.9045162,33.2647614],[-96.9045162,33.2647614],[-96.9045866,33.2645806],[-96.9045866,33.2645806],[-96.9049589,33.2646979],[-96.9049589,33.2646979]]]},"properties":{"lotName":"3-R-60","lotCpId":"3800061615532659448","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9050342,33.2645514],[-96.9050264,33.2645662],[-96.9050073,33.264603],[-96.9049589,33.2646979],[-96.9049589,33.2646979],[-96.9045866,33.2645806],[-96.9045866,33.2645806],[-96.9046767,33.2644059],[-96.9046767,33.2644059],[-96.9050342,33.2645514],[-96.9050342,33.2645514]]]},"properties":{"lotName":"3-R-59","lotCpId":"7265121615532662925","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051253,33.2644118],[-96.9051149,33.2644271],[-96.90509,33.2644642],[-96.9050342,33.2645514],[-96.9050342,33.2645514],[-96.9046767,33.2644059],[-96.9046767,33.2644059],[-96.9047853,33.2642388],[-96.9047853,33.2642388],[-96.9051253,33.2644118],[-96.9051253,33.2644118]]]},"properties":{"lotName":"3-R-58","lotCpId":"5753321615532686719","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052317,33.2642795],[-96.9052191,33.2642943],[-96.9051891,33.2643301],[-96.9051538,33.2643736],[-96.9051253,33.2644118],[-96.9051253,33.2644118],[-96.9047853,33.2642388],[-96.9047853,33.2642388],[-96.9049125,33.2640814],[-96.9049125,33.2640814],[-96.9052317,33.2642795],[-96.9052317,33.2642795]]]},"properties":{"lotName":"3-R-57","lotCpId":"3828851615532654572","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9053524,33.2641562],[-96.905338,33.2641701],[-96.9053042,33.2642036],[-96.9052642,33.2642441],[-96.9052317,33.2642795],[-96.9052317,33.2642795],[-96.9049125,33.2640814],[-96.9049125,33.2640814],[-96.905056,33.263934],[-96.905056,33.263934],[-96.9053524,33.2641562],[-96.9053524,33.2641562]]]},"properties":{"lotName":"3-R-56","lotCpId":"8004051615532641968","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054861,33.2640431],[-96.9054699,33.2640562],[-96.9054317,33.2640875],[-96.9053873,33.2641248],[-96.9053524,33.2641562],[-96.9053524,33.2641562],[-96.905056,33.263934],[-96.905056,33.263934],[-96.9052159,33.2637989],[-96.9052159,33.2637989],[-96.9054861,33.2640431],[-96.9054861,33.2640431]]]},"properties":{"lotName":"3-R-55","lotCpId":"2241361615532656710","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056318,33.2639408],[-96.9056142,33.2639526],[-96.9055727,33.2639808],[-96.9055243,33.2640145],[-96.9054861,33.2640431],[-96.9054861,33.2640431],[-96.9052159,33.2637989],[-96.9052159,33.2637989],[-96.9053895,33.2636762],[-96.9053895,33.2636762],[-96.9056318,33.2639408],[-96.9056318,33.2639408]]]},"properties":{"lotName":"3-R-54","lotCpId":"4261601615532658766","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905789,33.2638441],[-96.9056673,33.2639185],[-96.9056318,33.2639408],[-96.9056318,33.2639408],[-96.9053895,33.2636762],[-96.9053895,33.2636762],[-96.9055543,33.2635753],[-96.9055543,33.2635753],[-96.905789,33.2638441],[-96.905789,33.2638441]]]},"properties":{"lotName":"3-R-53","lotCpId":"8332521615532639926","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9059478,33.2637474],[-96.905789,33.2638441],[-96.905789,33.2638441],[-96.9055543,33.2635753],[-96.9055543,33.2635753],[-96.9057126,33.2634786],[-96.9057126,33.2634786],[-96.9059478,33.2637474],[-96.9059478,33.2637474]]]},"properties":{"lotName":"3-R-52","lotCpId":"2428261615532660829","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9061061,33.2636502],[-96.9059478,33.2637474],[-96.9059478,33.2637474],[-96.9057126,33.2634786],[-96.9057126,33.2634786],[-96.9058714,33.2633818],[-96.9058714,33.2633818],[-96.9061061,33.2636502],[-96.9061061,33.2636502]]]},"properties":{"lotName":"3-R-51","lotCpId":"6358181615532624289","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037958,33.2651593],[-96.90379,33.2651515],[-96.9037727,33.2651327],[-96.9037058,33.2650913],[-96.9037058,33.2650913],[-96.9039405,33.264984],[-96.9044387,33.2650657],[-96.9044387,33.2650657],[-96.90443,33.2651022],[-96.9043569,33.2652501],[-96.9043569,33.2652501],[-96.9038526,33.2651324],[-96.9037958,33.2651593],[-96.9037958,33.2651593]]]},"properties":{"lotName":"3-R-72","lotCpId":"4307601615532619670","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038127,33.2652861],[-96.9038163,33.265277],[-96.9038209,33.2652511],[-96.9038171,33.2652111],[-96.9037958,33.2651593],[-96.9037958,33.2651593],[-96.9038526,33.2651324],[-96.9043569,33.2652501],[-96.9043569,33.2652501],[-96.904263,33.2654413],[-96.904263,33.2654413],[-96.9038127,33.2652861],[-96.9038127,33.2652861]]]},"properties":{"lotName":"3-R-71","lotCpId":"7244101615532650839","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037325,33.2654545],[-96.9037379,33.2654418],[-96.9037528,33.2654084],[-96.9038027,33.2653088],[-96.9038057,33.2653034],[-96.9038127,33.2652861],[-96.9038127,33.2652861],[-96.904263,33.2654413],[-96.904263,33.2654413],[-96.9041921,33.2655846],[-96.9041921,33.2655846],[-96.9037325,33.2654545],[-96.9037325,33.2654545]]]},"properties":{"lotName":"3-R-70","lotCpId":"2147181615532621746","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9036714,33.2656485],[-96.9036768,33.2656274],[-96.9036909,33.2655762],[-96.9037325,33.2654545],[-96.9037325,33.2654545],[-96.9041921,33.2655846],[-96.9041921,33.2655846],[-96.9041255,33.2657201],[-96.9041255,33.2657201],[-96.9036714,33.2656485],[-96.9036714,33.2656485]]]},"properties":{"lotName":"3-R-69","lotCpId":"3446801615532625118","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9036436,33.2658474],[-96.9036455,33.2658255],[-96.9036509,33.2657723],[-96.9036597,33.265707],[-96.9036714,33.2656485],[-96.9036714,33.2656485],[-96.9041255,33.2657201],[-96.9041255,33.2657201],[-96.9040545,33.2658639],[-96.9040545,33.2658639],[-96.9036436,33.2658474],[-96.9036436,33.2658474]]]},"properties":{"lotName":"3-R-68","lotCpId":"8824231615532622573","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067271,33.2632709],[-96.9065689,33.2633677],[-96.9065689,33.2633677],[-96.9063342,33.2630993],[-96.9063342,33.2630993],[-96.9064925,33.2630021],[-96.9064925,33.2630021],[-96.9067271,33.2632709],[-96.9067271,33.2632709]]]},"properties":{"lotName":"3-R-50","lotCpId":"2450261615532624702","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9068936,33.2631669],[-96.9067894,33.2632331],[-96.9067271,33.2632709],[-96.9067271,33.2632709],[-96.9064925,33.2630021],[-96.9064925,33.2630021],[-96.9066486,33.2629049],[-96.9066486,33.2629049],[-96.9068936,33.2631669],[-96.9068936,33.2631669]]]},"properties":{"lotName":"3-R-49","lotCpId":"2678771615532663592","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070579,33.2630537],[-96.9070433,33.2630644],[-96.9070052,33.2630916],[-96.9068936,33.2631669],[-96.9068936,33.2631669],[-96.9066486,33.2629049],[-96.9066486,33.2629049],[-96.9067965,33.2628027],[-96.9067965,33.2628027],[-96.9070579,33.2630537],[-96.9070579,33.2630537]]]},"properties":{"lotName":"3-R-48","lotCpId":"3872771615532646707","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072151,33.2629332],[-96.9072022,33.2629437],[-96.9071678,33.2629712],[-96.9070579,33.2630537],[-96.9070579,33.2630537],[-96.9067965,33.2628027],[-96.9067965,33.2628027],[-96.9069378,33.2626941],[-96.9069378,33.2626941],[-96.9072151,33.2629332],[-96.9072151,33.2629332]]]},"properties":{"lotName":"3-R-47","lotCpId":"3285221615889546759","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073641,33.2628059],[-96.9073512,33.2628176],[-96.9073173,33.2628476],[-96.9072151,33.2629332],[-96.9072151,33.2629332],[-96.9069378,33.2626941],[-96.9069378,33.2626941],[-96.9070732,33.2625805],[-96.9070732,33.2625805],[-96.9073641,33.2628059],[-96.9073641,33.2628059]]]},"properties":{"lotName":"3-R-46","lotCpId":"5776321615532687389","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051957,33.2682769],[-96.9050598,33.2682235],[-96.9050467,33.2682185],[-96.9050467,33.2682185],[-96.9052088,33.2679192],[-96.9052088,33.2679192],[-96.9053633,33.2679799],[-96.9053633,33.2679799],[-96.9051957,33.2682769],[-96.9051957,33.2682769]]]},"properties":{"lotName":"5-H-3","lotCpId":"4274061615891792606","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056356,33.2684599],[-96.905622,33.2684526],[-96.9055893,33.2684358],[-96.9055163,33.2684034],[-96.9054921,33.2683937],[-96.9054921,33.2683937],[-96.9056591,33.2680962],[-96.9056591,33.2680962],[-96.9058075,33.2681546],[-96.9058075,33.2681546],[-96.9056356,33.2684599],[-96.9056356,33.2684599]]]},"properties":{"lotName":"5-H-6","lotCpId":"1703181615891793475","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057502,33.2685361],[-96.9057395,33.2685279],[-96.905712,33.2685079],[-96.9056356,33.2684599],[-96.9056356,33.2684599],[-96.9058075,33.2681546],[-96.9058075,33.2681546],[-96.9060236,33.2682395],[-96.9060236,33.2682395],[-96.9060011,33.26828],[-96.9059977,33.2682864],[-96.9059875,33.268304],[-96.9059475,33.2683652],[-96.9058832,33.2684478],[-96.9057961,33.2685359],[-96.9057502,33.2685361],[-96.9057502,33.2685361]]]},"properties":{"lotName":"5-H-7","lotCpId":"8864651615891793794","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9060073,33.2678703],[-96.9061612,33.2679306],[-96.9061612,33.2679306],[-96.906177,33.2679671],[-96.9060236,33.2682395],[-96.9060236,33.2682395],[-96.9058403,33.2681674],[-96.9058403,33.2681674],[-96.9060073,33.2678703],[-96.9060073,33.2678703]]]},"properties":{"lotName":"5-H-8","lotCpId":"2150401615891793797","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058594,33.2678119],[-96.9060073,33.2678703],[-96.9060073,33.2678703],[-96.9058403,33.2681674],[-96.9058403,33.2681674],[-96.9056918,33.268109],[-96.9056918,33.268109],[-96.9058594,33.2678119],[-96.9058594,33.2678119]]]},"properties":{"lotName":"5-H-9","lotCpId":"4157121615891793792","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051646,33.2684161],[-96.9053131,33.2684745],[-96.9053131,33.2684745],[-96.9051455,33.2687716],[-96.9051455,33.2687716],[-96.9049976,33.2687136],[-96.9049976,33.2687136],[-96.9051646,33.2684161],[-96.9051646,33.2684161]]]},"properties":{"lotName":"5-I-3","lotCpId":"3645321615892539167","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9050167,33.2683577],[-96.9051646,33.2684161],[-96.9051646,33.2684161],[-96.9049976,33.2687136],[-96.9049976,33.2687136],[-96.9048492,33.2686552],[-96.9048492,33.2686552],[-96.9050167,33.2683577],[-96.9050167,33.2683577]]]},"properties":{"lotName":"5-I-2","lotCpId":"3025821615534271022","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9046976,33.2682891],[-96.9048139,33.2682997],[-96.9049065,33.2683196],[-96.9049677,33.2683388],[-96.9049897,33.2683475],[-96.90501,33.2683552],[-96.9050167,33.2683577],[-96.9050167,33.2683577],[-96.9048492,33.2686552],[-96.9048492,33.2686552],[-96.9046581,33.2686525],[-96.9046581,33.2686525],[-96.9046647,33.2683162],[-96.9046976,33.2682891],[-96.9046976,33.2682891]]]},"properties":{"lotName":"5-I-1","lotCpId":"5246531615892539172","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9053131,33.2684745],[-96.9054482,33.2685276],[-96.9054657,33.2685348],[-96.9055099,33.2685552],[-96.9056285,33.2686287],[-96.9056285,33.2686287],[-96.9056262,33.2686647],[-96.9056168,33.2686706],[-96.9055899,33.2686865],[-96.9055474,33.2687098],[-96.905491,33.2687378],[-96.9053445,33.2687972],[-96.9051652,33.2688432],[-96.9051652,33.2688432],[-96.9051455,33.2687716],[-96.9051455,33.2687716],[-96.9053131,33.2684745],[-96.9053131,33.2684745]]]},"properties":{"lotName":"5-I-4","lotCpId":"8463181615892539240","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9044944,33.2686726],[-96.9044917,33.2688177],[-96.9044917,33.2688177],[-96.9040955,33.2688122],[-96.9040955,33.2688122],[-96.9040982,33.2686671],[-96.9040982,33.2686671],[-96.9044944,33.2686726],[-96.9044944,33.2686726]]]},"properties":{"lotName":"5-J-14","lotCpId":"1860271615892539235","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9044966,33.2685329],[-96.9044944,33.2686726],[-96.9044944,33.2686726],[-96.9040982,33.2686671],[-96.9040982,33.2686671],[-96.9041004,33.2685275],[-96.9041004,33.2685275],[-96.9044966,33.2685329],[-96.9044966,33.2685329]]]},"properties":{"lotName":"5-J-15","lotCpId":"8742451615892539224","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9044993,33.2683933],[-96.9044966,33.2685329],[-96.9044966,33.2685329],[-96.9041004,33.2685275],[-96.9041004,33.2685275],[-96.9041031,33.2683878],[-96.9041031,33.2683878],[-96.9044993,33.2683933],[-96.9044993,33.2683933]]]},"properties":{"lotName":"5-J-16","lotCpId":"1771321615892539209","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.904502,33.2682537],[-96.9044993,33.2683933],[-96.9044993,33.2683933],[-96.9041031,33.2683878],[-96.9041031,33.2683878],[-96.9041058,33.2682482],[-96.9041058,33.2682482],[-96.904502,33.2682537],[-96.904502,33.2682537]]]},"properties":{"lotName":"5-J-17","lotCpId":"3483361615892539261","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045048,33.268114],[-96.904502,33.2682537],[-96.904502,33.2682537],[-96.9041058,33.2682482],[-96.9041058,33.2682482],[-96.9041085,33.268109],[-96.9041085,33.268109],[-96.9045048,33.268114],[-96.9045048,33.268114]]]},"properties":{"lotName":"5-J-18","lotCpId":"1708131615892539248","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045075,33.2679758],[-96.904506,33.268001],[-96.9045048,33.268114],[-96.9045048,33.268114],[-96.9041085,33.268109],[-96.9041085,33.268109],[-96.9041113,33.267963],[-96.9041113,33.267963],[-96.9045075,33.2679758],[-96.9045075,33.2679758]]]},"properties":{"lotName":"5-J-19","lotCpId":"8313271615892539274","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045228,33.2678457],[-96.9045207,33.2678552],[-96.9045159,33.2678817],[-96.9045108,33.2679228],[-96.9045075,33.2679758],[-96.9045075,33.2679758],[-96.9041113,33.267963],[-96.9041113,33.267963],[-96.9041309,33.2677951],[-96.9041309,33.2677951],[-96.9045228,33.2678457],[-96.9045228,33.2678457]]]},"properties":{"lotName":"5-J-20","lotCpId":"2527771615892539173","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.904555,33.2677179],[-96.9045514,33.2677289],[-96.9045429,33.2677579],[-96.9045228,33.2678457],[-96.9045228,33.2678457],[-96.9041309,33.2677951],[-96.9041309,33.2677951],[-96.904173,33.2676299],[-96.904173,33.2676299],[-96.904555,33.2677179],[-96.904555,33.2677179]]]},"properties":{"lotName":"5-J-21","lotCpId":"1141441615892539296","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9046052,33.2675943],[-96.9046,33.2676044],[-96.9045872,33.2676317],[-96.904555,33.2677179],[-96.904555,33.2677179],[-96.904173,33.2676299],[-96.904173,33.2676299],[-96.9042379,33.2674701],[-96.9042379,33.2674701],[-96.9046052,33.2675943],[-96.9046052,33.2675943]]]},"properties":{"lotName":"5-J-22","lotCpId":"2265601615892539244","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9046712,33.2674724],[-96.9046358,33.2675359],[-96.9046279,33.2675496],[-96.9046052,33.2675943],[-96.9046052,33.2675943],[-96.9042379,33.2674701],[-96.9042379,33.2674701],[-96.904299,33.2673561],[-96.9043132,33.2673314],[-96.9043132,33.2673314],[-96.9046712,33.2674724],[-96.9046712,33.2674724]]]},"properties":{"lotName":"5-J-23","lotCpId":"5386371615892539264","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047411,33.2673483],[-96.9046712,33.2674724],[-96.9046712,33.2674724],[-96.9043132,33.2673314],[-96.9043132,33.2673314],[-96.9043825,33.2672073],[-96.9043825,33.2672073],[-96.9047411,33.2673483],[-96.9047411,33.2673483]]]},"properties":{"lotName":"5-J-24","lotCpId":"5312221615892539322","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.904811,33.2672246],[-96.9047411,33.2673483],[-96.9047411,33.2673483],[-96.9043825,33.2672073],[-96.9043825,33.2672073],[-96.9044524,33.2670836],[-96.9044524,33.2670836],[-96.904811,33.2672246],[-96.904811,33.2672246]]]},"properties":{"lotName":"5-J-25","lotCpId":"5887541615892870633","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048808,33.267101],[-96.904811,33.2672246],[-96.904811,33.2672246],[-96.9044524,33.2670836],[-96.9044524,33.2670836],[-96.9045222,33.2669595],[-96.9045222,33.2669595],[-96.9048808,33.267101],[-96.9048808,33.267101]]]},"properties":{"lotName":"5-J-26","lotCpId":"2080671615534274433","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049501,33.2669769],[-96.9048808,33.267101],[-96.9048808,33.267101],[-96.9045222,33.2669595],[-96.9045222,33.2669595],[-96.9045921,33.2668359],[-96.9045921,33.2668359],[-96.9049501,33.2669769],[-96.9049501,33.2669769]]]},"properties":{"lotName":"5-J-27","lotCpId":"7012101615534224999","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.90502,33.2668532],[-96.9049501,33.2669769],[-96.9049501,33.2669769],[-96.9045921,33.2668359],[-96.9045921,33.2668359],[-96.9046614,33.2667122],[-96.9046614,33.2667122],[-96.90502,33.2668532],[-96.90502,33.2668532]]]},"properties":{"lotName":"5-J-28","lotCpId":"6044041615534224343","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9050898,33.2667291],[-96.90502,33.2668532],[-96.90502,33.2668532],[-96.9046614,33.2667122],[-96.9046614,33.2667122],[-96.9047313,33.2665881],[-96.9047313,33.2665881],[-96.9050898,33.2667291],[-96.9050898,33.2667291]]]},"properties":{"lotName":"5-J-29","lotCpId":"8183461615534219724","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051597,33.2666054],[-96.9050898,33.2667291],[-96.9050898,33.2667291],[-96.9047313,33.2665881],[-96.9047313,33.2665881],[-96.9048011,33.2664644],[-96.9048011,33.2664644],[-96.9051597,33.2666054],[-96.9051597,33.2666054]]]},"properties":{"lotName":"5-J-30","lotCpId":"4401471615534103779","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9043449,33.2664963],[-96.9044426,33.2663229],[-96.9044426,33.2663229],[-96.9048011,33.2664644],[-96.9048011,33.2664644],[-96.9047034,33.2666378],[-96.9047034,33.2666378],[-96.9043449,33.2664963],[-96.9043449,33.2664963]]]},"properties":{"lotName":"5-J-1","lotCpId":"6102401615892539179","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9042472,33.2666702],[-96.9043449,33.2664963],[-96.9043449,33.2664963],[-96.9047034,33.2666378],[-96.9047034,33.2666378],[-96.9046057,33.2668112],[-96.9046057,33.2668112],[-96.9042472,33.2666702],[-96.9042472,33.2666702]]]},"properties":{"lotName":"5-J-2","lotCpId":"2055511615892539260","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9041495,33.2668436],[-96.9042472,33.2666702],[-96.9042472,33.2666702],[-96.9046057,33.2668112],[-96.9046057,33.2668112],[-96.9045081,33.2669846],[-96.9045081,33.2669846],[-96.9041495,33.2668436],[-96.9041495,33.2668436]]]},"properties":{"lotName":"5-J-3","lotCpId":"2047001615892539229","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9040518,33.267017],[-96.9041495,33.2668436],[-96.9041495,33.2668436],[-96.9045081,33.2669846],[-96.9045081,33.2669846],[-96.9044104,33.267158],[-96.9044104,33.267158],[-96.9040518,33.267017],[-96.9040518,33.267017]]]},"properties":{"lotName":"5-J-4","lotCpId":"4762001615534106443","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9039546,33.2671904],[-96.9040518,33.267017],[-96.9040518,33.267017],[-96.9044104,33.267158],[-96.9044104,33.267158],[-96.9043132,33.2673314],[-96.9043132,33.2673314],[-96.9039546,33.2671904],[-96.9039546,33.2671904]]]},"properties":{"lotName":"5-J-5","lotCpId":"3322531615892539258","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.903852,33.2673862],[-96.903855,33.2673786],[-96.9038655,33.267355],[-96.903886,33.2673139],[-96.9039186,33.2672538],[-96.9039546,33.2671904],[-96.9039546,33.2671904],[-96.9043132,33.2673314],[-96.9043132,33.2673314],[-96.904299,33.2673561],[-96.9042379,33.2674701],[-96.9042243,33.2675035],[-96.9042243,33.2675035],[-96.903852,33.2673862],[-96.903852,33.2673862]]]},"properties":{"lotName":"5-J-6","lotCpId":"2544341615892539245","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037729,33.2676007],[-96.9037767,33.2675857],[-96.9037895,33.267543],[-96.9038139,33.2674754],[-96.903852,33.2673862],[-96.903852,33.2673862],[-96.9042243,33.2675035],[-96.9042243,33.2675035],[-96.904173,33.2676299],[-96.9041609,33.2676782],[-96.9041609,33.2676782],[-96.9037729,33.2676007],[-96.9037729,33.2676007]]]},"properties":{"lotName":"5-J-7","lotCpId":"3763311615534193159","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037271,33.2678215],[-96.9037297,33.2678015],[-96.9037378,33.2677496],[-96.9037729,33.2676007],[-96.9037729,33.2676007],[-96.9041609,33.2676782],[-96.9041609,33.2676782],[-96.9041309,33.2677951],[-96.9041233,33.267858],[-96.9041233,33.267858],[-96.9037271,33.2678215],[-96.9037271,33.2678215]]]},"properties":{"lotName":"5-J-8","lotCpId":"8220581615892539253","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037134,33.2680396],[-96.9037145,33.2679904],[-96.9037143,33.2679775],[-96.9037151,33.2679421],[-96.9037187,33.2678886],[-96.9037271,33.2678215],[-96.9037271,33.2678215],[-96.9041233,33.267858],[-96.9041233,33.267858],[-96.9041113,33.267963],[-96.9041096,33.2680451],[-96.9041096,33.2680451],[-96.9037134,33.2680396],[-96.9037134,33.2680396]]]},"properties":{"lotName":"5-J-9","lotCpId":"1805101615892539249","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037101,33.2682313],[-96.9037134,33.2680396],[-96.9037134,33.2680396],[-96.9041096,33.2680451],[-96.9041096,33.2680451],[-96.9041058,33.2682368],[-96.9041058,33.2682368],[-96.9037101,33.2682313],[-96.9037101,33.2682313]]]},"properties":{"lotName":"5-J-10","lotCpId":"3434381615892539230","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037063,33.268423],[-96.9037101,33.2682313],[-96.9037101,33.2682313],[-96.9041058,33.2682368],[-96.9041058,33.2682368],[-96.9041025,33.2684284],[-96.9041025,33.2684284],[-96.9037063,33.268423],[-96.9037063,33.268423]]]},"properties":{"lotName":"5-J-11","lotCpId":"6214141615892539194","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037025,33.2686146],[-96.9037063,33.268423],[-96.9037063,33.268423],[-96.9041025,33.2684284],[-96.9041025,33.2684284],[-96.9040987,33.2686201],[-96.9040987,33.2686201],[-96.9037025,33.2686146],[-96.9037025,33.2686146]]]},"properties":{"lotName":"5-J-12","lotCpId":"3244251615892539232","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9036992,33.2688072],[-96.9037025,33.2686146],[-96.9037025,33.2686146],[-96.9040987,33.2686201],[-96.9040987,33.2686201],[-96.9040955,33.2688122],[-96.9040955,33.2688122],[-96.9036992,33.2688072],[-96.9036992,33.2688072]]]},"properties":{"lotName":"5-J-13","lotCpId":"1608481615892539236","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017699,33.2679187],[-96.9017705,33.2678992],[-96.901771,33.2678502],[-96.9017656,33.2677202],[-96.9017656,33.2677202],[-96.9021613,33.2677125],[-96.9021613,33.2677125],[-96.9021662,33.2679278],[-96.9021662,33.2679278],[-96.9017699,33.2679187],[-96.9017699,33.2679187]]]},"properties":{"lotName":"5-K-11","lotCpId":"2554811615534270341","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017525,33.2681172],[-96.9017551,33.268098],[-96.9017608,33.2680495],[-96.9017699,33.2679187],[-96.9017699,33.2679187],[-96.9021662,33.2679278],[-96.9021662,33.2679278],[-96.902146,33.2681569],[-96.902146,33.2681569],[-96.9017525,33.2681172],[-96.9017525,33.2681172]]]},"properties":{"lotName":"5-K-10","lotCpId":"5442201615534088482","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017132,33.268313],[-96.901718,33.268293],[-96.9017294,33.2682435],[-96.9017525,33.2681172],[-96.9017525,33.2681172],[-96.902146,33.2681569],[-96.902146,33.2681569],[-96.9021001,33.2683833],[-96.9021001,33.2683833],[-96.9017132,33.268313],[-96.9017132,33.268313]]]},"properties":{"lotName":"5-K-9","lotCpId":"4642601615892870658","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9016515,33.2685051],[-96.9016586,33.2684862],[-96.9016755,33.2684386],[-96.9017132,33.268313],[-96.9017132,33.268313],[-96.9021001,33.2683833],[-96.9021001,33.2683833],[-96.9020292,33.2686055],[-96.9020292,33.2686055],[-96.9016515,33.2685051],[-96.9016515,33.2685051]]]},"properties":{"lotName":"5-K-8","lotCpId":"4757231615892870662","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015691,33.2686913],[-96.9015774,33.2686751],[-96.9015981,33.2686326],[-96.9016515,33.2685051],[-96.9016515,33.2685051],[-96.9020292,33.2686055],[-96.9020292,33.2686055],[-96.9019337,33.2688209],[-96.9019337,33.2688209],[-96.9015691,33.2686913],[-96.9015691,33.2686913]]]},"properties":{"lotName":"5-K-7","lotCpId":"3761001615892870616","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014659,33.2688706],[-96.9014772,33.2688526],[-96.9015044,33.2688077],[-96.9015691,33.2686913],[-96.9015691,33.2686913],[-96.9019337,33.2688209],[-96.9019337,33.2688209],[-96.9018147,33.269028],[-96.9018147,33.269028],[-96.9014659,33.2688706],[-96.9014659,33.2688706]]]},"properties":{"lotName":"5-K-6","lotCpId":"7345081615892870666","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013431,33.2690408],[-96.9013577,33.2690217],[-96.9013923,33.2689757],[-96.901433,33.2689196],[-96.9014659,33.2688706],[-96.9014659,33.2688706],[-96.9018147,33.269028],[-96.9018147,33.269028],[-96.9016728,33.2692247],[-96.9016728,33.2692247],[-96.9013431,33.2690408],[-96.9013431,33.2690408]]]},"properties":{"lotName":"5-K-5","lotCpId":"4340521615534111058","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9012023,33.2692005],[-96.9012169,33.2691852],[-96.9012529,33.2691463],[-96.9013431,33.2690408],[-96.9013431,33.2690408],[-96.9016728,33.2692247],[-96.9016728,33.2692247],[-96.9015096,33.26941],[-96.9015096,33.26941],[-96.9012023,33.2692005],[-96.9012023,33.2692005]]]},"properties":{"lotName":"5-K-4","lotCpId":"4868101615534093081","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010435,33.2693488],[-96.9010597,33.2693349],[-96.9011,33.2692994],[-96.9012023,33.2692005],[-96.9012023,33.2692005],[-96.9015096,33.26941],[-96.9015096,33.26941],[-96.9013262,33.2695811],[-96.9013262,33.2695811],[-96.9010435,33.2693488],[-96.9010435,33.2693488]]]},"properties":{"lotName":"5-K-3","lotCpId":"4212101615892870659","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008683,33.2694775],[-96.9008773,33.2694725],[-96.9009009,33.2694582],[-96.9009737,33.2694063],[-96.9010435,33.2693488],[-96.9010435,33.2693488],[-96.9013262,33.2695811],[-96.9013262,33.2695811],[-96.9010932,33.2697504],[-96.9010932,33.2697504],[-96.9008683,33.2694775],[-96.9008683,33.2694775]]]},"properties":{"lotName":"5-K-2","lotCpId":"6477571615534112363","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035464,33.2682272],[-96.9035426,33.2684216],[-96.9035426,33.2684216],[-96.9031464,33.2684166],[-96.9031464,33.2684166],[-96.9031502,33.2682222],[-96.9031502,33.2682222],[-96.9035464,33.2682272],[-96.9035464,33.2682272]]]},"properties":{"lotName":"5-K-22","lotCpId":"7416531615534228446","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035497,33.2680328],[-96.9035464,33.2682272],[-96.9035464,33.2682272],[-96.9031502,33.2682222],[-96.9031502,33.2682222],[-96.9031535,33.2680278],[-96.9031535,33.2680278],[-96.9035497,33.2680328],[-96.9035497,33.2680328]]]},"properties":{"lotName":"5-K-21","lotCpId":"8426741615892870718","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035601,33.2678402],[-96.9035588,33.2678572],[-96.9035558,33.2678978],[-96.9035508,33.2679885],[-96.9035497,33.2680328],[-96.9035497,33.2680328],[-96.9031535,33.2680278],[-96.9031535,33.2680278],[-96.9031578,33.2678092],[-96.9031578,33.2678092],[-96.9035601,33.2678402],[-96.9035601,33.2678402]]]},"properties":{"lotName":"5-K-20","lotCpId":"2528831615534095723","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9036043,33.2676048],[-96.9036026,33.2676116],[-96.9035982,33.2676303],[-96.9035843,33.2676926],[-96.9035694,33.2677698],[-96.9035601,33.2678402],[-96.9035601,33.2678402],[-96.9031578,33.2678092],[-96.9031578,33.2678092],[-96.9031614,33.2676089],[-96.9031616,33.2676002],[-96.9031616,33.2676002],[-96.9036043,33.2676048],[-96.9036043,33.2676048]]]},"properties":{"lotName":"5-K-19","lotCpId":"7486651615892870740","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9033085,33.2672169],[-96.9033168,33.2672159],[-96.9033407,33.2672139],[-96.9034275,33.2672118],[-96.9035539,33.2672207],[-96.9037046,33.2672508],[-96.9037046,33.2672508],[-96.9037232,33.2672853],[-96.9037193,33.2672936],[-96.9037087,33.2673166],[-96.9036746,33.2673953],[-96.9036351,33.2674989],[-96.9036043,33.2676048],[-96.9036043,33.2676048],[-96.9033647,33.267602],[-96.9033647,33.267602],[-96.9033085,33.2672169],[-96.9033085,33.2672169]]]},"properties":{"lotName":"5-K-18","lotCpId":"4685841615892870690","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9030137,33.2672853],[-96.9030373,33.2672792],[-96.9030976,33.2672605],[-96.9031114,33.2672558],[-96.903152,33.2672444],[-96.9032181,33.2672301],[-96.9033085,33.2672169],[-96.9033085,33.2672169],[-96.9033647,33.267602],[-96.9033647,33.267602],[-96.9031393,33.2676002],[-96.9031393,33.2676002],[-96.9030137,33.2672853],[-96.9030137,33.2672853]]]},"properties":{"lotName":"5-K-17","lotCpId":"6163531615892870632","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9027998,33.2673355],[-96.9028141,33.2673331],[-96.9028558,33.267325],[-96.902923,33.2673095],[-96.9030137,33.2672853],[-96.9030137,33.2672853],[-96.9031393,33.2676002],[-96.9031393,33.2676002],[-96.902886,33.2676586],[-96.902886,33.2676586],[-96.9027998,33.2673355],[-96.9027998,33.2673355]]]},"properties":{"lotName":"5-K-16","lotCpId":"7076331615534192484","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9025809,33.2673666],[-96.9026002,33.2673648],[-96.9026506,33.2673592],[-96.9027998,33.2673355],[-96.9027998,33.2673355],[-96.902886,33.2676586],[-96.902886,33.2676586],[-96.9026235,33.2676974],[-96.9026235,33.2676974],[-96.9025809,33.2673666],[-96.9025809,33.2673666]]]},"properties":{"lotName":"5-K-15","lotCpId":"8402841615534103120","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9023108,33.2673793],[-96.9023278,33.2673798],[-96.9023747,33.26738],[-96.9024451,33.2673778],[-96.9025324,33.2673711],[-96.9025324,33.2673711],[-96.9025749,33.2677042],[-96.9025749,33.2677042],[-96.9023086,33.2677097],[-96.9023086,33.2677097],[-96.9023108,33.2673793],[-96.9023108,33.2673793]]]},"properties":{"lotName":"5-K-14","lotCpId":"3627351615534275766","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9020887,33.2673688],[-96.9021071,33.2673706],[-96.9021563,33.2673744],[-96.9022272,33.267378],[-96.9023108,33.2673793],[-96.9023108,33.2673793],[-96.9023086,33.2677097],[-96.9023086,33.2677097],[-96.9020439,33.2677147],[-96.9020439,33.2677147],[-96.9020887,33.2673688],[-96.9020887,33.2673688]]]},"properties":{"lotName":"5-K-13","lotCpId":"8620311615534276440","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006422,33.2695725],[-96.9006652,33.2695658],[-96.9007223,33.2695465],[-96.9008683,33.2694775],[-96.9008683,33.2694775],[-96.9010932,33.2697504],[-96.9010932,33.2697504],[-96.9006917,33.2699231],[-96.9006917,33.2699231],[-96.9006178,33.2696071],[-96.9006422,33.2695725],[-96.9006422,33.2695725]]]},"properties":{"lotName":"5-K-1","lotCpId":"1342181615534110424","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9017334,33.2673483],[-96.9017521,33.267347],[-96.9018039,33.2673454],[-96.9018823,33.2673475],[-96.9019807,33.2673573],[-96.9019898,33.2673584],[-96.9020139,33.2673613],[-96.9020887,33.2673688],[-96.9020887,33.2673688],[-96.9020439,33.2677147],[-96.9020439,33.2677147],[-96.9017656,33.2677202],[-96.9017656,33.2677202],[-96.901765,33.2677134],[-96.9017633,33.2676946],[-96.9017563,33.2676315],[-96.9017285,33.2674738],[-96.9017066,33.267378],[-96.9017334,33.2673483],[-96.9017334,33.2673483]]]},"properties":{"lotName":"5-K-12","lotCpId":"4523481615534245060","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035426,33.2684216],[-96.9035388,33.268616],[-96.9035388,33.268616],[-96.9031425,33.268611],[-96.9031425,33.268611],[-96.9031464,33.2684166],[-96.9031464,33.2684166],[-96.9035426,33.2684216],[-96.9035426,33.2684216]]]},"properties":{"lotName":"5-K-23","lotCpId":"1314701615534095063","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035388,33.268616],[-96.9035349,33.2688241],[-96.9035349,33.2688241],[-96.9035017,33.268851],[-96.9031382,33.2688464],[-96.9031382,33.2688464],[-96.9031425,33.268611],[-96.9031425,33.268611],[-96.9035388,33.268616],[-96.9035388,33.268616]]]},"properties":{"lotName":"5-K-24","lotCpId":"2247701615892870721","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010015,33.2691864],[-96.9009865,33.2692002],[-96.9009498,33.2692333],[-96.900861,33.269307],[-96.9008479,33.2693177],[-96.9008091,33.269345],[-96.9007452,33.2693816],[-96.9006571,33.2694205],[-96.9006571,33.2694205],[-96.90059,33.2691348],[-96.9005875,33.2691247],[-96.9005806,33.2690993],[-96.9005583,33.269034],[-96.9005583,33.269034],[-96.9006964,33.2689582],[-96.9006964,33.2689582],[-96.9010015,33.2691864],[-96.9010015,33.2691864]]]},"properties":{"lotName":"5-L-15","lotCpId":"4301371615892870737","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9011685,33.2690116],[-96.9011543,33.2690282],[-96.9011168,33.2690705],[-96.9010015,33.2691864],[-96.9010015,33.2691864],[-96.9006964,33.2689582],[-96.9006964,33.2689582],[-96.9008345,33.2688131],[-96.9008345,33.2688131],[-96.9011685,33.2690116],[-96.9011685,33.2690116]]]},"properties":{"lotName":"5-L-14","lotCpId":"6305031615534109098","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9013115,33.2688218],[-96.9012984,33.2688411],[-96.9012646,33.2688891],[-96.9011685,33.2690116],[-96.9011685,33.2690116],[-96.9008345,33.2688131],[-96.9008345,33.2688131],[-96.9008432,33.2688035],[-96.9009496,33.2686548],[-96.9009496,33.2686548],[-96.9013115,33.2688218],[-96.9013115,33.2688218]]]},"properties":{"lotName":"5-L-13","lotCpId":"7244721615534199963","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014272,33.2686201],[-96.9014168,33.2686407],[-96.9013898,33.2686918],[-96.9013115,33.2688218],[-96.9013115,33.2688218],[-96.9009496,33.2686548],[-96.9009496,33.2686548],[-96.9009884,33.2686],[-96.9010441,33.2684878],[-96.9010441,33.2684878],[-96.9014272,33.2686201],[-96.9014272,33.2686201]]]},"properties":{"lotName":"5-L-12","lotCpId":"2748731615534083208","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015156,33.2684084],[-96.9015081,33.2684294],[-96.9014883,33.2684821],[-96.9014272,33.2686201],[-96.9014272,33.2686201],[-96.9010441,33.2684878],[-96.9010441,33.2684878],[-96.901097,33.268381],[-96.9011177,33.2683134],[-96.9011177,33.2683134],[-96.9015156,33.2684084],[-96.9015156,33.2684084]]]},"properties":{"lotName":"5-L-11","lotCpId":"1240811615534196620","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015746,33.2681902],[-96.9015691,33.2682143],[-96.9015552,33.2682727],[-96.9015362,33.2683443],[-96.9015156,33.2684084],[-96.9015156,33.2684084],[-96.9011177,33.2683134],[-96.9011177,33.2683134],[-96.9011674,33.2681514],[-96.9011696,33.2681332],[-96.9011696,33.2681332],[-96.9015746,33.2681902],[-96.9015746,33.2681902]]]},"properties":{"lotName":"5-L-10","lotCpId":"3728241615534227784","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.901604,33.2679675],[-96.9016021,33.2679904],[-96.9015965,33.2680471],[-96.9015746,33.2681902],[-96.9015746,33.2681902],[-96.9011696,33.2681332],[-96.9011696,33.2681332],[-96.9011925,33.2679493],[-96.9011925,33.2679493],[-96.901604,33.2679675],[-96.901604,33.2679675]]]},"properties":{"lotName":"5-L-9","lotCpId":"5428731615534113022","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9016029,33.2677435],[-96.9016042,33.2677674],[-96.9016063,33.2678259],[-96.901604,33.2679675],[-96.901604,33.2679675],[-96.9011925,33.2679493],[-96.9011925,33.2679493],[-96.9011969,33.2679151],[-96.9011942,33.267764],[-96.9011942,33.267764],[-96.9016029,33.2677435],[-96.9016029,33.2677435]]]},"properties":{"lotName":"5-L-8","lotCpId":"2450661615534105119","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015548,33.2674437],[-96.9015675,33.2674989],[-96.9015725,33.2675227],[-96.9015838,33.2675827],[-96.9016029,33.2677435],[-96.9016029,33.2677435],[-96.9011942,33.267764],[-96.9011942,33.267764],[-96.9011761,33.2675934],[-96.9011761,33.2675934],[-96.9011845,33.2675899],[-96.9012093,33.267579],[-96.9012499,33.2675604],[-96.9013056,33.2675334],[-96.9013241,33.2675238],[-96.9013757,33.2675003],[-96.9014545,33.2674709],[-96.9015548,33.2674437],[-96.9015548,33.2674437]]]},"properties":{"lotName":"5-L-7","lotCpId":"3774851615892870800","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9007876,33.267905],[-96.9007884,33.2678881],[-96.900789,33.2678443],[-96.9007788,33.2677175],[-96.9007788,33.2677175],[-96.9007872,33.2677159],[-96.900811,33.267711],[-96.9008979,33.2676898],[-96.9010245,33.2676515],[-96.9011761,33.2675934],[-96.9011761,33.2675934],[-96.9011942,33.267764],[-96.9011969,33.2679151],[-96.9011969,33.2679151],[-96.9007876,33.267905],[-96.9007876,33.267905]]]},"properties":{"lotName":"5-L-6","lotCpId":"4343001615534271759","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9007641,33.2680912],[-96.9007676,33.2680725],[-96.9007754,33.2680258],[-96.9007876,33.267905],[-96.9007876,33.267905],[-96.9011969,33.2679151],[-96.9011969,33.2679151],[-96.9011674,33.2681514],[-96.9011674,33.2681514],[-96.9007641,33.2680912],[-96.9007641,33.2680912]]]},"properties":{"lotName":"5-L-5","lotCpId":"7041711615892870782","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900709,33.2682728],[-96.9007157,33.2682555],[-96.9007315,33.2682116],[-96.9007641,33.2680912],[-96.9007641,33.2680912],[-96.9011674,33.2681514],[-96.9011674,33.2681514],[-96.901097,33.268381],[-96.901097,33.268381],[-96.900709,33.2682728],[-96.900709,33.2682728]]]},"properties":{"lotName":"5-L-4","lotCpId":"7264701615892870723","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9006227,33.2684462],[-96.9006326,33.2684289],[-96.9006563,33.2683856],[-96.900709,33.2682728],[-96.900709,33.2682728],[-96.901097,33.268381],[-96.901097,33.268381],[-96.9009884,33.2686],[-96.9009884,33.2686],[-96.9006227,33.2684462],[-96.9006227,33.2684462]]]},"properties":{"lotName":"5-L-3","lotCpId":"8167251615534229826","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9005076,33.2686073],[-96.9005207,33.268591],[-96.900552,33.2685505],[-96.9006227,33.2684462],[-96.9006227,33.2684462],[-96.9009884,33.2686],[-96.9009884,33.2686],[-96.9008432,33.2688035],[-96.9008432,33.2688035],[-96.9005076,33.2686073],[-96.9005076,33.2686073]]]},"properties":{"lotName":"5-L-2","lotCpId":"7873401615892870734","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9003662,33.2687529],[-96.9003823,33.2687379],[-96.9004208,33.2687007],[-96.9005076,33.2686073],[-96.9005076,33.2686073],[-96.9008432,33.2688035],[-96.9008432,33.2688035],[-96.9006964,33.2689582],[-96.9005583,33.269034],[-96.9005583,33.269034],[-96.9005557,33.269027],[-96.9005475,33.2690077],[-96.9005135,33.2689405],[-96.9004539,33.2688498],[-96.9003662,33.2687529],[-96.9003662,33.2687529]]]},"properties":{"lotName":"5-L-1","lotCpId":"3463231615892870723","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070612,33.2645282],[-96.9070479,33.2645135],[-96.9070172,33.2644794],[-96.9069824,33.2644406],[-96.9069569,33.2644118],[-96.9069225,33.2643725],[-96.9069225,33.2643725],[-96.9072423,33.2641768],[-96.9072423,33.2641768],[-96.9073755,33.2643269],[-96.9073755,33.2643269],[-96.9070612,33.2645282],[-96.9070612,33.2645282]]]},"properties":{"lotName":"5-S-6","lotCpId":"4883571615534246381","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072189,33.2646947],[-96.907161,33.2646349],[-96.9071476,33.2646207],[-96.9071169,33.2645879],[-96.9070832,33.264552],[-96.9070612,33.2645282],[-96.9070612,33.2645282],[-96.9073755,33.2643269],[-96.9073755,33.2643269],[-96.9075425,33.2645022],[-96.9075425,33.2645022],[-96.9072647,33.2646984],[-96.9072189,33.2646947],[-96.9072189,33.2646947]]]},"properties":{"lotName":"5-S-7","lotCpId":"8527711615534092421","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9077188,33.2641562],[-96.9078241,33.2642667],[-96.9078241,33.2642667],[-96.9078198,33.2643055],[-96.9075425,33.2645022],[-96.9075425,33.2645022],[-96.9074061,33.2643593],[-96.9074061,33.2643593],[-96.9077188,33.2641562],[-96.9077188,33.2641562]]]},"properties":{"lotName":"5-S-8","lotCpId":"2278341615892870730","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076107,33.2640371],[-96.9077188,33.2641562],[-96.9077188,33.2641562],[-96.9074061,33.2643593],[-96.9074061,33.2643593],[-96.9073755,33.2643269],[-96.9072926,33.2642334],[-96.9072926,33.2642334],[-96.9076107,33.2640371],[-96.9076107,33.2640371]]]},"properties":{"lotName":"5-S-9","lotCpId":"2463651615534078620","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9075049,33.2639158],[-96.9075965,33.2640212],[-96.9076107,33.2640371],[-96.9076107,33.2640371],[-96.9072926,33.2642334],[-96.9072926,33.2642334],[-96.9072423,33.2641768],[-96.907185,33.2641111],[-96.907185,33.2641111],[-96.9075049,33.2639158],[-96.9075049,33.2639158]]]},"properties":{"lotName":"5-S-10","lotCpId":"7601771615892870951","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073984,33.2637944],[-96.9075049,33.2639158],[-96.9075049,33.2639158],[-96.907185,33.2641111],[-96.907185,33.2641111],[-96.9070786,33.2639897],[-96.9070786,33.2639897],[-96.9073984,33.2637944],[-96.9073984,33.2637944]]]},"properties":{"lotName":"5-S-11","lotCpId":"4806561615534090441","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072926,33.2636725],[-96.9073984,33.2637944],[-96.9073984,33.2637944],[-96.9070786,33.2639897],[-96.9070786,33.2639897],[-96.9069722,33.2638678],[-96.9069722,33.2638678],[-96.9072926,33.2636725],[-96.9072926,33.2636725]]]},"properties":{"lotName":"5-S-12","lotCpId":"6303441615534229161","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9071861,33.2635511],[-96.9072926,33.2636725],[-96.9072926,33.2636725],[-96.9069722,33.2638678],[-96.9069722,33.2638678],[-96.9068663,33.2637464],[-96.9068663,33.2637464],[-96.9071861,33.2635511],[-96.9071861,33.2635511]]]},"properties":{"lotName":"5-S-13","lotCpId":"8346521615534077951","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070513,33.2634462],[-96.9070568,33.2634545],[-96.907075,33.2634747],[-96.9071085,33.2634994],[-96.9071598,33.2635214],[-96.9071861,33.2635511],[-96.9071861,33.2635511],[-96.9068663,33.2637464],[-96.9068663,33.2637464],[-96.906761,33.2636264],[-96.906761,33.2636264],[-96.9070513,33.2634462],[-96.9070513,33.2634462]]]},"properties":{"lotName":"5-S-14","lotCpId":"5164361615892871001","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9064592,33.2638418],[-96.9063429,33.263709],[-96.9063429,33.263709],[-96.9066627,33.2635137],[-96.9066627,33.2635137],[-96.906779,33.2636465],[-96.906779,33.2636465],[-96.9064592,33.2638418],[-96.9064592,33.2638418]]]},"properties":{"lotName":"3-S-1","lotCpId":"7045431615532643325","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065749,33.2639746],[-96.9064592,33.2638418],[-96.9064592,33.2638418],[-96.906779,33.2636465],[-96.906779,33.2636465],[-96.9068947,33.2637788],[-96.9068947,33.2637788],[-96.9065749,33.2639746],[-96.9065749,33.2639746]]]},"properties":{"lotName":"3-S-2","lotCpId":"5170401615532644004","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9066906,33.264107],[-96.9065749,33.2639746],[-96.9065749,33.2639746],[-96.9068947,33.2637788],[-96.9068947,33.2637788],[-96.9070109,33.2639116],[-96.9070109,33.2639116],[-96.9066906,33.264107],[-96.9066906,33.264107]]]},"properties":{"lotName":"3-S-3","lotCpId":"2060001615532651527","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9068068,33.2642398],[-96.9066906,33.264107],[-96.9066906,33.264107],[-96.9070109,33.2639116],[-96.9070109,33.2639116],[-96.9071266,33.2640444],[-96.9071266,33.2640444],[-96.9068068,33.2642398],[-96.9068068,33.2642398]]]},"properties":{"lotName":"3-S-4","lotCpId":"2153831615532648048","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069225,33.2643725],[-96.9068068,33.2642398],[-96.9068068,33.2642398],[-96.9071266,33.2640444],[-96.9071266,33.2640444],[-96.9072423,33.2641768],[-96.9072423,33.2641768],[-96.9069225,33.2643725],[-96.9069225,33.2643725]]]},"properties":{"lotName":"3-S-5","lotCpId":"2053121615532628398","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076244,33.2672607],[-96.907554,33.2673862],[-96.907554,33.2673862],[-96.9071981,33.2672461],[-96.9071981,33.2672461],[-96.9072685,33.2671211],[-96.9072685,33.2671211],[-96.9076244,33.2672607],[-96.9076244,33.2672607]]]},"properties":{"lotName":"5-U-25","lotCpId":"7321701615892273453","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076942,33.267137],[-96.9076244,33.2672607],[-96.9076244,33.2672607],[-96.9072685,33.2671211],[-96.9072685,33.2671211],[-96.9073384,33.2669969],[-96.9073384,33.2669969],[-96.9076942,33.267137],[-96.9076942,33.267137]]]},"properties":{"lotName":"5-U-24","lotCpId":"2705111615892273488","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9077636,33.2670129],[-96.9076942,33.267137],[-96.9076942,33.267137],[-96.9073384,33.2669969],[-96.9073384,33.2669969],[-96.9074083,33.2668733],[-96.9074083,33.2668733],[-96.9077636,33.2670129],[-96.9077636,33.2670129]]]},"properties":{"lotName":"5-U-23","lotCpId":"2274561615892871002","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9078334,33.2668892],[-96.9077636,33.2670129],[-96.9077636,33.2670129],[-96.9074083,33.2668733],[-96.9074083,33.2668733],[-96.9074781,33.2667492],[-96.9074781,33.2667492],[-96.9078334,33.2668892],[-96.9078334,33.2668892]]]},"properties":{"lotName":"5-U-22","lotCpId":"4231701615892870945","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9079033,33.2667651],[-96.9078334,33.2668892],[-96.9078334,33.2668892],[-96.9074781,33.2667492],[-96.9074781,33.2667492],[-96.9075474,33.2666255],[-96.9075474,33.2666255],[-96.9079033,33.2667651],[-96.9079033,33.2667651]]]},"properties":{"lotName":"5-U-21","lotCpId":"8641181615892871002","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9079731,33.2666415],[-96.9079033,33.2667651],[-96.9079033,33.2667651],[-96.9075474,33.2666255],[-96.9075474,33.2666255],[-96.9076173,33.2665014],[-96.9076173,33.2665014],[-96.9079731,33.2666415],[-96.9079731,33.2666415]]]},"properties":{"lotName":"5-U-20","lotCpId":"3254601615534223023","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9080424,33.2665178],[-96.9079731,33.2666415],[-96.9079731,33.2666415],[-96.9076173,33.2665014],[-96.9076173,33.2665014],[-96.9076871,33.2663777],[-96.9076871,33.2663777],[-96.9080424,33.2665178],[-96.9080424,33.2665178]]]},"properties":{"lotName":"5-U-19","lotCpId":"5210601615534251648","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9081123,33.2663937],[-96.9080424,33.2665178],[-96.9080424,33.2665178],[-96.9076871,33.2663777],[-96.9076871,33.2663777],[-96.907757,33.266254],[-96.907757,33.266254],[-96.9081123,33.2663937],[-96.9081123,33.2663937]]]},"properties":{"lotName":"5-U-18","lotCpId":"8215421615534221043","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9081822,33.26627],[-96.9081123,33.2663937],[-96.9081123,33.2663937],[-96.907757,33.266254],[-96.907757,33.266254],[-96.9078263,33.2661299],[-96.9078263,33.2661299],[-96.9081822,33.26627],[-96.9081822,33.26627]]]},"properties":{"lotName":"5-U-17","lotCpId":"8824081615892870935","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9082526,33.2661472],[-96.9081822,33.26627],[-96.9081822,33.26627],[-96.9078263,33.2661299],[-96.9078263,33.2661299],[-96.9078989,33.2660008],[-96.9078989,33.2660008],[-96.9082526,33.2661472],[-96.9082526,33.2661472]]]},"properties":{"lotName":"5-U-16","lotCpId":"8877701615534189127","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9083262,33.2660272],[-96.9082526,33.2661472],[-96.9082526,33.2661472],[-96.9078989,33.2660008],[-96.9078989,33.2660008],[-96.9078716,33.2659387],[-96.9079513,33.2658584],[-96.9079513,33.2658584],[-96.9083262,33.2660272],[-96.9083262,33.2660272]]]},"properties":{"lotName":"5-U-15","lotCpId":"8872641615534200602","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9084228,33.2658839],[-96.9083262,33.2660272],[-96.9083262,33.2660272],[-96.9079513,33.2658584],[-96.9079513,33.2658584],[-96.9081429,33.2656649],[-96.9081429,33.2656649],[-96.9081524,33.2656714],[-96.9081781,33.2656888],[-96.9082593,33.2657436],[-96.9083499,33.2658038],[-96.9083874,33.2658279],[-96.9084136,33.2658438],[-96.9084228,33.2658839],[-96.9084228,33.2658839]]]},"properties":{"lotName":"5-U-14","lotCpId":"2888551615534104462","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.908019,33.2655773],[-96.9081429,33.2656649],[-96.9081429,33.2656649],[-96.9078716,33.2659387],[-96.9078716,33.2659387],[-96.9077477,33.2658397],[-96.9077477,33.2658397],[-96.908019,33.2655773],[-96.908019,33.2655773]]]},"properties":{"lotName":"5-U-13","lotCpId":"3138181615892870995","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9078973,33.2654874],[-96.908019,33.2655773],[-96.908019,33.2655773],[-96.9077477,33.2658397],[-96.9077477,33.2658397],[-96.9076238,33.2657407],[-96.9076238,33.2657407],[-96.9078973,33.2654874],[-96.9078973,33.2654874]]]},"properties":{"lotName":"5-U-12","lotCpId":"7732021615892870945","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9077783,33.2653952],[-96.9078973,33.2654874],[-96.9078973,33.2654874],[-96.9076238,33.2657407],[-96.9076238,33.2657407],[-96.9075005,33.2656421],[-96.9075005,33.2656421],[-96.9077783,33.2653952],[-96.9077783,33.2653952]]]},"properties":{"lotName":"5-U-11","lotCpId":"2827211615534252322","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.907638,33.265282],[-96.9077783,33.2653952],[-96.9077783,33.2653952],[-96.9075005,33.2656421],[-96.9075005,33.2656421],[-96.907352,33.2655234],[-96.907352,33.2655234],[-96.907638,33.265282],[-96.907638,33.265282]]]},"properties":{"lotName":"5-U-10","lotCpId":"2356621615892870999","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.907501,33.2651661],[-96.907638,33.265282],[-96.907638,33.265282],[-96.907352,33.2655234],[-96.907352,33.2655234],[-96.9072041,33.2654052],[-96.9072041,33.2654052],[-96.907501,33.2651661],[-96.907501,33.2651661]]]},"properties":{"lotName":"5-U-9","lotCpId":"5548111615892870965","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073679,33.2650475],[-96.907501,33.2651661],[-96.907501,33.2651661],[-96.9072041,33.2654052],[-96.9072041,33.2654052],[-96.9070557,33.2652861],[-96.9070557,33.2652861],[-96.9073679,33.2650475],[-96.9073679,33.2650475]]]},"properties":{"lotName":"5-U-8","lotCpId":"8435011615534069342","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.907238,33.2649256],[-96.9073679,33.2650475],[-96.9073679,33.2650475],[-96.9070557,33.2652861],[-96.9070557,33.2652861],[-96.9069062,33.265167],[-96.9069062,33.265167],[-96.907238,33.2649256],[-96.907238,33.2649256]]]},"properties":{"lotName":"5-U-7","lotCpId":"6836181615892870991","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9071119,33.2648015],[-96.907238,33.2649256],[-96.907238,33.2649256],[-96.9069062,33.265167],[-96.9069062,33.265167],[-96.9067566,33.2650475],[-96.9067566,33.2650475],[-96.9071119,33.2648015],[-96.9071119,33.2648015]]]},"properties":{"lotName":"5-U-6","lotCpId":"8135821615534062700","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069913,33.264676],[-96.9071119,33.2648015],[-96.9071119,33.2648015],[-96.9067566,33.2650475],[-96.9067566,33.2650475],[-96.9065956,33.2649179],[-96.9065956,33.2649179],[-96.9069913,33.264676],[-96.9069913,33.264676]]]},"properties":{"lotName":"5-U-5","lotCpId":"6235101615534199282","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9064799,33.2652921],[-96.9064653,33.2652819],[-96.9064268,33.2652569],[-96.9063091,33.265194],[-96.9063091,33.265194],[-96.9065956,33.2649179],[-96.9065956,33.2649179],[-96.9067353,33.2650301],[-96.9067353,33.2650301],[-96.9064799,33.2652921],[-96.9064799,33.2652921]]]},"properties":{"lotName":"5-U-42","lotCpId":"5674841615534105764","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9066202,33.2654002],[-96.9065601,33.2653509],[-96.9065527,33.2653452],[-96.9065335,33.2653306],[-96.9064799,33.2652921],[-96.9064799,33.2652921],[-96.9067353,33.2650301],[-96.9067353,33.2650301],[-96.906898,33.2651602],[-96.906898,33.2651602],[-96.9066202,33.2654002],[-96.9066202,33.2654002]]]},"properties":{"lotName":"5-U-41","lotCpId":"4740561615534101142","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906761,33.2655143],[-96.9066202,33.2654002],[-96.9066202,33.2654002],[-96.906898,33.2651602],[-96.906898,33.2651602],[-96.9070404,33.2652738],[-96.9070404,33.2652738],[-96.906761,33.2655143],[-96.906761,33.2655143]]]},"properties":{"lotName":"5-U-40","lotCpId":"8084401615892273497","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069018,33.2656289],[-96.9068893,33.2656186],[-96.9068568,33.265592],[-96.906761,33.2655143],[-96.906761,33.2655143],[-96.9070404,33.2652738],[-96.9070404,33.2652738],[-96.9071823,33.2653875],[-96.9071823,33.2653875],[-96.9069018,33.2656289],[-96.9069018,33.2656289]]]},"properties":{"lotName":"5-U-39","lotCpId":"2311811615534096479","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070431,33.2657434],[-96.9069018,33.2656289],[-96.9069018,33.2656289],[-96.9071823,33.2653875],[-96.9071823,33.2653875],[-96.9073242,33.2655011],[-96.9073242,33.2655011],[-96.9070431,33.2657434],[-96.9070431,33.2657434]]]},"properties":{"lotName":"5-U-38","lotCpId":"5248201615534203324","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9071839,33.2658575],[-96.9070431,33.2657434],[-96.9070431,33.2657434],[-96.9073242,33.2655011],[-96.9073242,33.2655011],[-96.9074661,33.2656147],[-96.9074661,33.2656147],[-96.9071839,33.2658575],[-96.9071839,33.2658575]]]},"properties":{"lotName":"5-U-37","lotCpId":"1557711615534193883","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073548,33.2659643],[-96.907343,33.2659586],[-96.9072945,33.2659471],[-96.9071839,33.2658575],[-96.9071839,33.2658575],[-96.9074661,33.2656147],[-96.9074661,33.2656147],[-96.9076189,33.265737],[-96.9076189,33.265737],[-96.9073548,33.2659643],[-96.9073548,33.2659643]]]},"properties":{"lotName":"5-U-36","lotCpId":"4766221615534243085","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074301,33.2660427],[-96.9074273,33.2660349],[-96.9074165,33.2660154],[-96.9073936,33.2659899],[-96.9073548,33.2659643],[-96.9073548,33.2659643],[-96.9076189,33.265737],[-96.9076189,33.265737],[-96.9078618,33.2659309],[-96.9078618,33.2659309],[-96.9074301,33.2660427],[-96.9074301,33.2660427]]]},"properties":{"lotName":"5-U-35","lotCpId":"4264571615892273565","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074285,33.2661276],[-96.9074314,33.2661211],[-96.9074365,33.2661032],[-96.9074301,33.2660427],[-96.9074301,33.2660427],[-96.9078618,33.2659309],[-96.9078618,33.2659309],[-96.9078716,33.2659387],[-96.9078989,33.2660008],[-96.9077717,33.2662271],[-96.9077717,33.2662271],[-96.9074285,33.2661276],[-96.9074285,33.2661276]]]},"properties":{"lotName":"5-U-34","lotCpId":"6170041615892273558","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073313,33.2662376],[-96.9073505,33.2662043],[-96.90736,33.2661999],[-96.9073821,33.2661861],[-96.907408,33.2661623],[-96.9074285,33.2661276],[-96.9074285,33.2661276],[-96.9077717,33.2662271],[-96.9077717,33.2662271],[-96.9076871,33.2663777],[-96.9076871,33.2663777],[-96.9073313,33.2662376],[-96.9073313,33.2662376]]]},"properties":{"lotName":"5-U-33","lotCpId":"8311751615892273576","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072614,33.2663626],[-96.9073313,33.2662376],[-96.9073313,33.2662376],[-96.9076871,33.2663777],[-96.9076871,33.2663777],[-96.9076173,33.2665014],[-96.9076173,33.2665014],[-96.9072614,33.2663626],[-96.9072614,33.2663626]]]},"properties":{"lotName":"5-U-32","lotCpId":"8540311615534091781","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9071921,33.2664854],[-96.9072614,33.2663626],[-96.9072614,33.2663626],[-96.9076173,33.2665014],[-96.9076173,33.2665014],[-96.9075474,33.2666255],[-96.9075474,33.2666255],[-96.9071921,33.2664854],[-96.9071921,33.2664854]]]},"properties":{"lotName":"5-U-31","lotCpId":"6456171615892273502","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9071223,33.2666095],[-96.9071921,33.2664854],[-96.9071921,33.2664854],[-96.9075474,33.2666255],[-96.9075474,33.2666255],[-96.9074781,33.2667492],[-96.9074781,33.2667492],[-96.9071223,33.2666095],[-96.9071223,33.2666095]]]},"properties":{"lotName":"5-U-30","lotCpId":"7048511615892273503","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070524,33.2667332],[-96.9071223,33.2666095],[-96.9071223,33.2666095],[-96.9074781,33.2667492],[-96.9074781,33.2667492],[-96.9074083,33.2668733],[-96.9074083,33.2668733],[-96.9070524,33.2667332],[-96.9070524,33.2667332]]]},"properties":{"lotName":"5-U-29","lotCpId":"4536311615892273573","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069831,33.2668573],[-96.9070524,33.2667332],[-96.9070524,33.2667332],[-96.9074083,33.2668733],[-96.9074083,33.2668733],[-96.9073384,33.2669969],[-96.9073384,33.2669969],[-96.9069831,33.2668573],[-96.9069831,33.2668573]]]},"properties":{"lotName":"5-U-28","lotCpId":"6080451615892273526","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069132,33.266981],[-96.9069831,33.2668573],[-96.9069831,33.2668573],[-96.9073384,33.2669969],[-96.9073384,33.2669969],[-96.9072685,33.2671211],[-96.9072685,33.2671211],[-96.9069132,33.266981],[-96.9069132,33.266981]]]},"properties":{"lotName":"5-U-27","lotCpId":"2766241615892273601","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9068428,33.2671065],[-96.9069132,33.266981],[-96.9069132,33.266981],[-96.9072685,33.2671211],[-96.9072685,33.2671211],[-96.9071981,33.2672461],[-96.9071981,33.2672461],[-96.9068428,33.2671065],[-96.9068428,33.2671065]]]},"properties":{"lotName":"5-U-26","lotCpId":"4418341615534220382","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065574,33.2645346],[-96.9067293,33.2644296],[-96.9067293,33.2644296],[-96.9067752,33.2644355],[-96.9069913,33.264676],[-96.9069913,33.264676],[-96.906789,33.2647997],[-96.906789,33.2647997],[-96.9065574,33.2645346],[-96.9065574,33.2645346]]]},"properties":{"lotName":"3-U-4","lotCpId":"6340871615532620082","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9063637,33.2646527],[-96.9065574,33.2645346],[-96.9065574,33.2645346],[-96.906789,33.2647997],[-96.906789,33.2647997],[-96.9065956,33.2649179],[-96.9065956,33.2649179],[-96.9063637,33.2646527],[-96.9063637,33.2646527]]]},"properties":{"lotName":"3-U-3","lotCpId":"1562011615532620491","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9061415,33.2648262],[-96.9061545,33.2648125],[-96.9061917,33.2647771],[-96.9062507,33.2647284],[-96.9063288,33.2646747],[-96.9063637,33.2646527],[-96.9063637,33.2646527],[-96.9065956,33.2649179],[-96.9065956,33.2649179],[-96.9064701,33.2650384],[-96.9064701,33.2650384],[-96.9061415,33.2648262],[-96.9061415,33.2648262]]]},"properties":{"lotName":"3-U-2","lotCpId":"2461011615532620909","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9059938,33.2650621],[-96.9060022,33.2650412],[-96.9060284,33.2649868],[-96.9060743,33.264911],[-96.9061415,33.2648262],[-96.9061415,33.2648262],[-96.9064701,33.2650384],[-96.9064701,33.2650384],[-96.9063091,33.265194],[-96.9063091,33.265194],[-96.9062905,33.2651847],[-96.906235,33.265161],[-96.9061432,33.2651289],[-96.9060154,33.2650945],[-96.9059938,33.2650621],[-96.9059938,33.2650621]]]},"properties":{"lotName":"3-U-1","lotCpId":"3513171615532627160","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9062654,33.2669098],[-96.906088,33.2668395],[-96.906088,33.2668395],[-96.9062551,33.2665424],[-96.9062551,33.2665424],[-96.906433,33.2666123],[-96.906433,33.2666123],[-96.9062654,33.2669098],[-96.9062654,33.2669098]]]},"properties":{"lotName":"5-W-19","lotCpId":"4282571615892273585","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9064433,33.2669796],[-96.9062654,33.2669098],[-96.9062654,33.2669098],[-96.906433,33.2666123],[-96.906433,33.2666123],[-96.9066109,33.2666825],[-96.9066109,33.2666825],[-96.9064433,33.2669796],[-96.9064433,33.2669796]]]},"properties":{"lotName":"5-W-18","lotCpId":"1687231615892273577","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9066507,33.2670613],[-96.9064433,33.2669796],[-96.9064433,33.2669796],[-96.9066109,33.2666825],[-96.9066109,33.2666825],[-96.9068478,33.2667756],[-96.9068478,33.2667756],[-96.9066944,33.267048],[-96.9066507,33.2670613],[-96.9066507,33.2670613]]]},"properties":{"lotName":"5-W-17","lotCpId":"8202461615534252988","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069334,33.2666232],[-96.9068478,33.2667756],[-96.9068478,33.2667756],[-96.9064925,33.2666355],[-96.9064925,33.2666355],[-96.9065781,33.2664831],[-96.9065781,33.2664831],[-96.9069334,33.2666232],[-96.9069334,33.2666232]]]},"properties":{"lotName":"5-W-16","lotCpId":"4757101615534201279","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070033,33.2664991],[-96.9069334,33.2666232],[-96.9069334,33.2666232],[-96.9065781,33.2664831],[-96.9065781,33.2664831],[-96.906648,33.2663594],[-96.906648,33.2663594],[-96.9070033,33.2664991],[-96.9070033,33.2664991]]]},"properties":{"lotName":"5-W-15","lotCpId":"8637561615534091100","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070732,33.2663754],[-96.9070033,33.2664991],[-96.9070033,33.2664991],[-96.906648,33.2663594],[-96.906648,33.2663594],[-96.9067173,33.2662353],[-96.9067173,33.2662353],[-96.9070732,33.2663754],[-96.9070732,33.2663754]]]},"properties":{"lotName":"5-W-14","lotCpId":"6801001615534247047","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.907143,33.2662513],[-96.9070732,33.2663754],[-96.9070732,33.2663754],[-96.9067173,33.2662353],[-96.9067173,33.2662353],[-96.9067872,33.2661117],[-96.9067872,33.2661117],[-96.907143,33.2662513],[-96.907143,33.2662513]]]},"properties":{"lotName":"5-W-13","lotCpId":"7443821615534227066","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072205,33.2661139],[-96.907143,33.2662513],[-96.907143,33.2662513],[-96.9067872,33.2661117],[-96.9067872,33.2661117],[-96.9069362,33.265847],[-96.9069362,33.265847],[-96.9072107,33.2660701],[-96.9072205,33.2661139],[-96.9072205,33.2661139]]]},"properties":{"lotName":"5-W-12","lotCpId":"8751711615534221703","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9064319,33.2658109],[-96.9065058,33.2656806],[-96.9065108,33.2656719],[-96.9065246,33.2656495],[-96.9065705,33.2655876],[-96.9065705,33.2655876],[-96.9066125,33.2655846],[-96.9069362,33.265847],[-96.9069362,33.265847],[-96.9068614,33.2659802],[-96.9068614,33.2659802],[-96.9064319,33.2658109],[-96.9064319,33.2658109]]]},"properties":{"lotName":"3-W-11","lotCpId":"2447751615532622162","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9063598,33.2659392],[-96.9064319,33.2658109],[-96.9064319,33.2658109],[-96.9068614,33.2659802],[-96.9068614,33.2659802],[-96.906719,33.2662326],[-96.906719,33.2662326],[-96.9063598,33.2659392],[-96.9063598,33.2659392]]]},"properties":{"lotName":"3-W-10","lotCpId":"2220301615532650150","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9062834,33.2660843],[-96.906298,33.2660765],[-96.9063288,33.2660513],[-96.9063559,33.2660064],[-96.9063598,33.2659392],[-96.9063598,33.2659392],[-96.906719,33.2662326],[-96.906719,33.2662326],[-96.9067173,33.2662353],[-96.9065623,33.2665119],[-96.9065623,33.2665119],[-96.9062834,33.2660843],[-96.9062834,33.2660843]]]},"properties":{"lotName":"3-W-9","lotCpId":"8757161615532623405","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9061497,33.2660975],[-96.9061619,33.2661004],[-96.9061932,33.2661041],[-96.9062363,33.2661012],[-96.9062834,33.2660843],[-96.9062834,33.2660843],[-96.9065623,33.2665119],[-96.9065623,33.2665119],[-96.9064925,33.2666355],[-96.9062108,33.2665246],[-96.9060744,33.266463],[-96.9059625,33.2663999],[-96.9059625,33.2663999],[-96.9061497,33.2660975],[-96.9061497,33.2660975]]]},"properties":{"lotName":"3-W-8","lotCpId":"1875501615532619257","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9059887,33.2659994],[-96.9060525,33.266027],[-96.9060578,33.2660354],[-96.9060748,33.2660554],[-96.9061049,33.2660788],[-96.9061497,33.2660975],[-96.9061497,33.2660975],[-96.9059625,33.2663999],[-96.9059625,33.2663999],[-96.9057988,33.266307],[-96.9057988,33.266307],[-96.9059887,33.2659994],[-96.9059887,33.2659994]]]},"properties":{"lotName":"3-W-7","lotCpId":"2816221615532664250","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058146,33.2659241],[-96.9059887,33.2659994],[-96.9059887,33.2659994],[-96.9057988,33.266307],[-96.9057988,33.266307],[-96.9056553,33.2662253],[-96.905634,33.2662166],[-96.905634,33.2662166],[-96.9058146,33.2659241],[-96.9058146,33.2659241]]]},"properties":{"lotName":"3-W-6","lotCpId":"3863081615532627574","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.90564,33.2658488],[-96.9058146,33.2659241],[-96.9058146,33.2659241],[-96.905634,33.2662166],[-96.905634,33.2662166],[-96.905456,33.2661468],[-96.905456,33.2661468],[-96.90564,33.2658488],[-96.90564,33.2658488]]]},"properties":{"lotName":"3-W-5","lotCpId":"8137111615532636610","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054653,33.2657735],[-96.90564,33.2658488],[-96.90564,33.2658488],[-96.905456,33.2661468],[-96.905456,33.2661468],[-96.9052781,33.2660765],[-96.9052781,33.2660765],[-96.9054653,33.2657735],[-96.9054653,33.2657735]]]},"properties":{"lotName":"3-W-4","lotCpId":"4337001615532627983","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052869,33.2656964],[-96.9054653,33.2657735],[-96.9054653,33.2657735],[-96.9052781,33.2660765],[-96.9052781,33.2660765],[-96.9051035,33.2660081],[-96.9051013,33.2660072],[-96.9051013,33.2660072],[-96.9052869,33.2656964],[-96.9052869,33.2656964]]]},"properties":{"lotName":"3-W-3","lotCpId":"4873361615532653846","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9050882,33.2656197],[-96.9051059,33.2656259],[-96.9051519,33.2656427],[-96.9052869,33.2656964],[-96.9052869,33.2656964],[-96.9051013,33.2660072],[-96.9051013,33.2660072],[-96.9049305,33.2659401],[-96.9049305,33.2659401],[-96.9050882,33.2656197],[-96.9050882,33.2656197]]]},"properties":{"lotName":"3-W-2","lotCpId":"2845001615532657365","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048906,33.2655595],[-96.9049168,33.2655668],[-96.9049357,33.2655722],[-96.9049813,33.2655857],[-96.9050882,33.2656197],[-96.9050882,33.2656197],[-96.9049305,33.2659401],[-96.9049305,33.2659401],[-96.9047373,33.2658643],[-96.9047373,33.2658643],[-96.9047651,33.2658146],[-96.9047757,33.2657964],[-96.9048038,33.2657448],[-96.9048439,33.2656644],[-96.9048906,33.2655595],[-96.9048906,33.2655595]]]},"properties":{"lotName":"3-W-1","lotCpId":"1234041615532622981","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.909355,33.2644278],[-96.9093743,33.2644411],[-96.9094189,33.2644716],[-96.9094691,33.2645055],[-96.9095051,33.2645286],[-96.9095051,33.2645286],[-96.9092699,33.2647951],[-96.9092699,33.2647951],[-96.9091018,33.2646824],[-96.9091018,33.2646824],[-96.909355,33.2644278],[-96.909355,33.2644278]]]},"properties":{"lotName":"5-D-18","lotCpId":"6205531615890713275","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.908926,33.2640978],[-96.9090647,33.2642119],[-96.9090647,33.2642119],[-96.9087918,33.264452],[-96.9087918,33.264452],[-96.9086439,33.2643301],[-96.9086439,33.2643301],[-96.908926,33.2640978],[-96.908926,33.2640978]]]},"properties":{"lotName":"5-D-21","lotCpId":"3448371615890713281","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9085429,33.2637337],[-96.9085516,33.2637436],[-96.9085731,33.2637675],[-96.9086263,33.2638234],[-96.908663,33.2638587],[-96.908663,33.2638587],[-96.9083628,33.264075],[-96.9083628,33.264075],[-96.9082215,33.2639272],[-96.9082215,33.2639272],[-96.9085429,33.2637337],[-96.9085429,33.2637337]]]},"properties":{"lotName":"5-D-24","lotCpId":"7576411615534080602","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9083579,33.2634585],[-96.908365,33.2634722],[-96.9083839,33.2635068],[-96.9084414,33.2636004],[-96.9084414,33.2636004],[-96.9080959,33.2637629],[-96.9080959,33.2637629],[-96.9079895,33.2635895],[-96.9079895,33.2635895],[-96.9083579,33.2634585],[-96.9083579,33.2634585]]]},"properties":{"lotName":"5-D-26","lotCpId":"2113841615534086484","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9082651,33.2632837],[-96.9082738,33.2632979],[-96.9082941,33.2633326],[-96.9083362,33.2634151],[-96.9083579,33.2634585],[-96.9083579,33.2634585],[-96.9079895,33.2635895],[-96.9079895,33.2635895],[-96.9079,33.263443],[-96.9079,33.263443],[-96.9082651,33.2632837],[-96.9082651,33.2632837]]]},"properties":{"lotName":"5-D-27","lotCpId":"7430171615534197963","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9081363,33.2631112],[-96.9081503,33.2631277],[-96.9081844,33.2631695],[-96.9082651,33.2632837],[-96.9082651,33.2632837],[-96.9079,33.263443],[-96.9079,33.263443],[-96.9078165,33.2633065],[-96.9078165,33.2633065],[-96.9081363,33.2631112],[-96.9081363,33.2631112]]]},"properties":{"lotName":"5-D-28","lotCpId":"2156621615890713281","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9082127,33.2646313],[-96.9083268,33.2647276],[-96.9083268,33.2647276],[-96.9080495,33.264964],[-96.9080495,33.264964],[-96.9079284,33.2648622],[-96.9079284,33.2648622],[-96.9082127,33.2646313],[-96.9082127,33.2646313]]]},"properties":{"lotName":"5-E-14","lotCpId":"1325371615890714676","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9062114,33.2670699],[-96.9063893,33.2671398],[-96.9063893,33.2671398],[-96.9062212,33.2674382],[-96.9062212,33.2674382],[-96.9060438,33.2673684],[-96.9060438,33.2673684],[-96.9062114,33.2670699],[-96.9062114,33.2670699]]]},"properties":{"lotName":"5-G-10","lotCpId":"6886371615891792088","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906034,33.2670001],[-96.9062114,33.2670699],[-96.9062114,33.2670699],[-96.9060438,33.2673684],[-96.9060438,33.2673684],[-96.9058659,33.2672986],[-96.9058659,33.2672986],[-96.906034,33.2670001],[-96.906034,33.2670001]]]},"properties":{"lotName":"5-G-11","lotCpId":"3561371615534099801","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058566,33.2669289],[-96.9058705,33.2669353],[-96.9059107,33.2669513],[-96.906034,33.2670001],[-96.906034,33.2670001],[-96.9058659,33.2672986],[-96.9058659,33.2672986],[-96.905688,33.2672288],[-96.905688,33.2672288],[-96.9058566,33.2669289],[-96.9058566,33.2669289]]]},"properties":{"lotName":"5-G-12","lotCpId":"2038721615891792089","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056875,33.2668441],[-96.9056969,33.2668505],[-96.9057135,33.2668596],[-96.9057546,33.2668813],[-96.9058566,33.2669289],[-96.9058566,33.2669289],[-96.905688,33.2672288],[-96.905688,33.2672288],[-96.9055101,33.2671585],[-96.9055101,33.2671585],[-96.9056875,33.2668441],[-96.9056875,33.2668441]]]},"properties":{"lotName":"5-G-13","lotCpId":"2558171615534201966","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9055226,33.266751],[-96.9056875,33.2668441],[-96.9056875,33.2668441],[-96.9055101,33.2671585],[-96.9055101,33.2671585],[-96.9053327,33.2670887],[-96.9053327,33.2670887],[-96.9055226,33.266751],[-96.9055226,33.266751]]]},"properties":{"lotName":"5-G-14","lotCpId":"2834861615891792594","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9053491,33.2666547],[-96.9053568,33.2666587],[-96.9053749,33.2666681],[-96.905412,33.266688],[-96.9055226,33.266751],[-96.9055226,33.266751],[-96.9053327,33.2670887],[-96.9053327,33.2670887],[-96.905116,33.2670038],[-96.905116,33.2670038],[-96.9053065,33.2666656],[-96.9053491,33.2666547],[-96.9053491,33.2666547]]]},"properties":{"lotName":"5-G-15","lotCpId":"2648151615534198625","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052961,33.2674391],[-96.9051422,33.2673784],[-96.9051422,33.2673784],[-96.9053103,33.26708],[-96.9053103,33.26708],[-96.9054642,33.2671407],[-96.9054642,33.2671407],[-96.9052961,33.2674391],[-96.9052961,33.2674391]]]},"properties":{"lotName":"5-G-2","lotCpId":"1544311615954752067","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057584,33.2676212],[-96.9056045,33.2675605],[-96.9056045,33.2675605],[-96.9057726,33.2672616],[-96.9057726,33.2672616],[-96.9059265,33.2673223],[-96.9059265,33.2673223],[-96.9057584,33.2676212],[-96.9057584,33.2676212]]]},"properties":{"lotName":"5-G-5","lotCpId":"7866561615891791134","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9060668,33.2677421],[-96.9059129,33.2676814],[-96.9059129,33.2676814],[-96.906081,33.267383],[-96.906081,33.267383],[-96.9062349,33.2674437],[-96.9062349,33.2674437],[-96.9060668,33.2677421],[-96.9060668,33.2677421]]]},"properties":{"lotName":"5-G-7","lotCpId":"4061321615891792084","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049016,33.2681756],[-96.9048862,33.2681727],[-96.9048481,33.2681659],[-96.9047498,33.2681542],[-96.9047498,33.2681542],[-96.9047526,33.268004],[-96.9047534,33.26798],[-96.9047584,33.2679193],[-96.9047717,33.2678393],[-96.9047973,33.2677572],[-96.9047973,33.2677572],[-96.9050058,33.2678393],[-96.9050058,33.2678393],[-96.9049016,33.2681756],[-96.9049016,33.2681756]]]},"properties":{"lotName":"5-H-1","lotCpId":"5850511615891792592","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905563,33.2676951],[-96.9057109,33.2677535],[-96.9057109,33.2677535],[-96.9055439,33.2680511],[-96.9055439,33.2680511],[-96.9053955,33.2679926],[-96.9053955,33.2679926],[-96.905563,33.2676951],[-96.905563,33.2676951]]]},"properties":{"lotName":"5-H-11","lotCpId":"7705421615891793797","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054146,33.2676372],[-96.905563,33.2676951],[-96.905563,33.2676951],[-96.9053955,33.2679926],[-96.9053955,33.2679926],[-96.9052476,33.2679342],[-96.9052476,33.2679342],[-96.9054146,33.2676372],[-96.9054146,33.2676372]]]},"properties":{"lotName":"5-H-12","lotCpId":"2530301615892539136","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052667,33.2675788],[-96.9054146,33.2676372],[-96.9054146,33.2676372],[-96.9052476,33.2679342],[-96.9052476,33.2679342],[-96.9050991,33.2678758],[-96.9050991,33.2678758],[-96.9052667,33.2675788],[-96.9052667,33.2675788]]]},"properties":{"lotName":"5-H-13","lotCpId":"7140311615892539129","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051182,33.2675203],[-96.9052667,33.2675788],[-96.9052667,33.2675788],[-96.9050991,33.2678758],[-96.9050991,33.2678758],[-96.9049512,33.2678179],[-96.9049512,33.2678179],[-96.9051182,33.2675203],[-96.9051182,33.2675203]]]},"properties":{"lotName":"5-H-14","lotCpId":"6256501615892539152","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9050467,33.2682185],[-96.9050316,33.2682132],[-96.9049943,33.2682007],[-96.9049016,33.2681756],[-96.9049016,33.2681756],[-96.9050058,33.2678393],[-96.9050058,33.2678393],[-96.9052088,33.2679192],[-96.9052088,33.2679192],[-96.9050467,33.2682185],[-96.9050467,33.2682185]]]},"properties":{"lotName":"5-H-2","lotCpId":"6838551615891792594","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9053436,33.2683353],[-96.9051957,33.2682769],[-96.9051957,33.2682769],[-96.9053633,33.2679799],[-96.9053633,33.2679799],[-96.9055112,33.2680378],[-96.9055112,33.2680378],[-96.9053436,33.2683353],[-96.9053436,33.2683353]]]},"properties":{"lotName":"5-H-4","lotCpId":"2310601615891792603","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054921,33.2683937],[-96.9053436,33.2683353],[-96.9053436,33.2683353],[-96.9055112,33.2680378],[-96.9055112,33.2680378],[-96.9056591,33.2680962],[-96.9056591,33.2680962],[-96.9054921,33.2683937],[-96.9054921,33.2683937]]]},"properties":{"lotName":"5-H-5","lotCpId":"5616871615891793473","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049529,33.2674551],[-96.9051182,33.2675203],[-96.9051182,33.2675203],[-96.9049512,33.2678179],[-96.9049512,33.2678179],[-96.9047973,33.2677572],[-96.9047973,33.2677572],[-96.9048007,33.267747],[-96.9048114,33.2677187],[-96.9048302,33.2676762],[-96.9048579,33.267623],[-96.9049529,33.2674551],[-96.9049529,33.2674551]]]},"properties":{"lotName":"5-H-15","lotCpId":"6237531615892539374","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9010086,33.2674327],[-96.9009891,33.2674406],[-96.9009363,33.2674601],[-96.9008584,33.267485],[-96.900764,33.2675093],[-96.900764,33.2675093],[-96.9007613,33.2675012],[-96.9007533,33.2674785],[-96.900722,33.2674004],[-96.900671,33.2672965],[-96.9006014,33.2671881],[-96.9006014,33.2671881],[-96.9008263,33.2671028],[-96.9008263,33.2671028],[-96.9010086,33.2674327],[-96.9010086,33.2674327]]]},"properties":{"lotName":"5-X-28","lotCpId":"5318641615892273577","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9012378,33.2673291],[-96.9012166,33.2673391],[-96.9011783,33.2673576],[-96.9011651,33.2673644],[-96.901129,33.267382],[-96.9010086,33.2674327],[-96.9010086,33.2674327],[-96.9008263,33.2671028],[-96.9008263,33.2671028],[-96.9010206,33.2670284],[-96.9010413,33.2670202],[-96.9010413,33.2670202],[-96.9012378,33.2673291],[-96.9012378,33.2673291]]]},"properties":{"lotName":"5-X-27","lotCpId":"6187681615892273548","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9014381,33.2672584],[-96.9014223,33.2672627],[-96.9013793,33.2672757],[-96.9013156,33.2672978],[-96.9012378,33.2673291],[-96.9012378,33.2673291],[-96.9010413,33.2670202],[-96.9010413,33.2670202],[-96.9012127,33.2669495],[-96.9013104,33.2669267],[-96.9013104,33.2669267],[-96.9014381,33.2672584],[-96.9014381,33.2672584]]]},"properties":{"lotName":"5-X-26","lotCpId":"2540011615892273630","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9016499,33.2672183],[-96.9016291,33.2672208],[-96.9015768,33.2672283],[-96.9014381,33.2672584],[-96.9014381,33.2672584],[-96.9013104,33.2669267],[-96.9013104,33.2669267],[-96.9014163,33.2669016],[-96.9015969,33.2668879],[-96.9015969,33.2668879],[-96.9016499,33.2672183],[-96.9016499,33.2672183]]]},"properties":{"lotName":"5-X-25","lotCpId":"7704841615892273562","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9018671,33.26721],[-96.9018464,33.2672094],[-96.9017937,33.2672091],[-96.9016499,33.2672183],[-96.9016499,33.2672183],[-96.9015969,33.2668879],[-96.9015969,33.2668879],[-96.9016269,33.2668856],[-96.9018469,33.2668651],[-96.9018845,33.2668705],[-96.9018845,33.2668705],[-96.9018671,33.26721],[-96.9018671,33.26721]]]},"properties":{"lotName":"5-X-24","lotCpId":"1445501615534108464","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9021029,33.2672324],[-96.9020942,33.2672318],[-96.9020717,33.2672298],[-96.9020073,33.2672222],[-96.9019945,33.2672205],[-96.9019615,33.2672165],[-96.9018671,33.26721],[-96.9018671,33.26721],[-96.9018845,33.2668705],[-96.9018845,33.2668705],[-96.9020739,33.2668965],[-96.902146,33.2669007],[-96.902146,33.2669007],[-96.9021029,33.2672324],[-96.9021029,33.2672324]]]},"properties":{"lotName":"5-X-23","lotCpId":"6450411615892273520","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9023736,33.267242],[-96.9023477,33.2672423],[-96.902282,33.2672421],[-96.9021029,33.2672324],[-96.9021029,33.2672324],[-96.902146,33.2669007],[-96.902146,33.2669007],[-96.9023615,33.266912],[-96.9023626,33.2669121],[-96.9023626,33.2669121],[-96.9023736,33.267242],[-96.9023736,33.267242]]]},"properties":{"lotName":"5-X-22","lotCpId":"1762001615534253646","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9026437,33.267221],[-96.9026198,33.2672243],[-96.9025575,33.2672315],[-96.9024708,33.2672387],[-96.9023736,33.267242],[-96.9023736,33.267242],[-96.9023626,33.2669121],[-96.9023626,33.2669121],[-96.9025804,33.2668915],[-96.9025804,33.2668915],[-96.9026437,33.267221],[-96.9026437,33.267221]]]},"properties":{"lotName":"5-X-21","lotCpId":"2422041615892273519","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9029084,33.2671699],[-96.9028847,33.2671759],[-96.902823,33.2671901],[-96.9026437,33.267221],[-96.9026437,33.267221],[-96.9025804,33.2668915],[-96.9025804,33.2668915],[-96.9026481,33.2668851],[-96.9027922,33.2668491],[-96.9027922,33.2668491],[-96.9029084,33.2671699],[-96.9029084,33.2671699]]]},"properties":{"lotName":"5-X-20","lotCpId":"6165761615892273551","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.903142,33.2671051],[-96.9031169,33.2671112],[-96.9030398,33.2671329],[-96.9030273,33.2671367],[-96.9029955,33.2671462],[-96.9029084,33.2671699],[-96.9029084,33.2671699],[-96.9027922,33.2668491],[-96.9027922,33.2668491],[-96.9029242,33.2668162],[-96.9030372,33.2667784],[-96.9030372,33.2667784],[-96.903142,33.2671051],[-96.903142,33.2671051]]]},"properties":{"lotName":"5-X-19","lotCpId":"6650851615534094401","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9033548,33.2670759],[-96.9033338,33.2670773],[-96.903281,33.2670821],[-96.903142,33.2671051],[-96.903142,33.2671051],[-96.9030372,33.2667784],[-96.9030372,33.2667784],[-96.9031371,33.266745],[-96.9033308,33.2667355],[-96.9033308,33.2667355],[-96.9033548,33.2670759],[-96.9033548,33.2670759]]]},"properties":{"lotName":"5-X-18","lotCpId":"1110321615534093740","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035704,33.2670836],[-96.9035493,33.2670814],[-96.903496,33.2670769],[-96.9033548,33.2670759],[-96.9033548,33.2670759],[-96.9033308,33.2667355],[-96.9033308,33.2667355],[-96.9035682,33.2667231],[-96.9036315,33.2667272],[-96.9036315,33.2667272],[-96.9035704,33.2670836],[-96.9035704,33.2670836]]]},"properties":{"lotName":"5-X-17","lotCpId":"2003831615892273571","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037734,33.2671256],[-96.9037536,33.2671201],[-96.9037035,33.2671074],[-96.9035704,33.2670836],[-96.9035704,33.2670836],[-96.9036315,33.2667272],[-96.9036315,33.2667272],[-96.9037773,33.2667359],[-96.9040098,33.2667706],[-96.9040098,33.2667706],[-96.9038182,33.2671106],[-96.9037734,33.2671256],[-96.9037734,33.2671256]]]},"properties":{"lotName":"5-X-16","lotCpId":"3048751615534243723","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058839,33.2667542],[-96.9058749,33.2667501],[-96.9058536,33.26674],[-96.9058072,33.2667146],[-96.9056984,33.266652],[-96.9056984,33.266652],[-96.9059216,33.2663768],[-96.9059216,33.2663768],[-96.9060744,33.266463],[-96.9060848,33.2664681],[-96.9060848,33.2664681],[-96.9058839,33.2667542],[-96.9058839,33.2667542]]]},"properties":{"lotName":"5-W-21","lotCpId":"1002421615892273485","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906088,33.2668395],[-96.9059942,33.266803],[-96.9059841,33.2667989],[-96.9059582,33.2667881],[-96.9058839,33.2667542],[-96.9058866,33.2667504],[-96.9058866,33.2667504],[-96.9060848,33.2664681],[-96.9060848,33.2664681],[-96.9062108,33.2665246],[-96.9062551,33.2665424],[-96.9062551,33.2665424],[-96.906088,33.2668395],[-96.906088,33.2668395]]]},"properties":{"lotName":"5-W-20","lotCpId":"8143321615892273487","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9047798,33.266244],[-96.9045697,33.2661614],[-96.9045697,33.2661614],[-96.9047373,33.2658643],[-96.9047373,33.2658643],[-96.9049474,33.2659469],[-96.9049474,33.2659469],[-96.9047798,33.266244],[-96.9047798,33.266244]]]},"properties":{"lotName":"5-W-27","lotCpId":"8103251615892273565","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049638,33.2663165],[-96.9047798,33.266244],[-96.9047798,33.266244],[-96.9049474,33.2659469],[-96.9049474,33.2659469],[-96.9051313,33.266019],[-96.9051313,33.266019],[-96.9049638,33.2663165],[-96.9049638,33.2663165]]]},"properties":{"lotName":"5-W-26","lotCpId":"4524661615534197285","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051477,33.2663886],[-96.9049638,33.2663165],[-96.9049638,33.2663165],[-96.9051313,33.266019],[-96.9051313,33.266019],[-96.9053147,33.2660916],[-96.9053147,33.2660916],[-96.9051477,33.2663886],[-96.9051477,33.2663886]]]},"properties":{"lotName":"5-W-25","lotCpId":"3214361615892273561","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9053312,33.266461],[-96.9051477,33.2663886],[-96.9051477,33.2663886],[-96.9053147,33.2660916],[-96.9053147,33.2660916],[-96.9054986,33.2661637],[-96.9054986,33.2661637],[-96.9053312,33.266461],[-96.9053312,33.266461]]]},"properties":{"lotName":"5-W-24","lotCpId":"1283001615892273567","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9055221,33.266552],[-96.9055093,33.2665445],[-96.9054722,33.2665245],[-96.9054122,33.2664954],[-96.9053312,33.266461],[-96.9053312,33.266461],[-96.9054986,33.2661637],[-96.9054986,33.2661637],[-96.9056553,33.2662253],[-96.9057459,33.2662768],[-96.9057459,33.2662768],[-96.9055221,33.266552],[-96.9055221,33.266552]]]},"properties":{"lotName":"5-W-23","lotCpId":"2263151615534100462","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9080413,33.2621027],[-96.9079202,33.2622318],[-96.9079202,33.2622318],[-96.9075982,33.2620201],[-96.9075982,33.2620201],[-96.9077193,33.2618909],[-96.9077193,33.2618909],[-96.9080413,33.2621027],[-96.9080413,33.2621027]]]},"properties":{"lotName":"5-A-2","lotCpId":"2358151615534061472","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9081669,33.261969],[-96.9080413,33.2621027],[-96.9080413,33.2621027],[-96.9077193,33.2618909],[-96.9077193,33.2618909],[-96.9078454,33.2617572],[-96.9078454,33.2617572],[-96.9081669,33.261969],[-96.9081669,33.261969]]]},"properties":{"lotName":"5-A-3","lotCpId":"1876761615534061063","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9083874,33.2631842],[-96.9083783,33.2631709],[-96.9083546,33.2631376],[-96.9082859,33.2630505],[-96.9082859,33.2630505],[-96.9086079,33.2628584],[-96.9086079,33.2628584],[-96.9086177,33.2628689],[-96.9087094,33.262988],[-96.9087317,33.2630231],[-96.9087317,33.2630231],[-96.9083874,33.2631842],[-96.9083874,33.2631842]]]},"properties":{"lotName":"5-C-2","lotCpId":"8555431615534065607","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9086963,33.2636771],[-96.9086824,33.2636614],[-96.9086485,33.2636208],[-96.9085647,33.2635037],[-96.9085647,33.2635037],[-96.908938,33.263338],[-96.908938,33.263338],[-96.9089724,33.2633859],[-96.9090357,33.2634635],[-96.9090357,33.2634635],[-96.9086963,33.2636771],[-96.9086963,33.2636771]]]},"properties":{"lotName":"5-C-5","lotCpId":"7486411615534063512","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9088393,33.2638195],[-96.9087514,33.2637346],[-96.9087351,33.2637188],[-96.9086963,33.2636771],[-96.9086963,33.2636771],[-96.9090357,33.2634635],[-96.9090357,33.2634635],[-96.909075,33.2635123],[-96.9091476,33.2635908],[-96.9091476,33.2635908],[-96.9088393,33.2638195],[-96.9088393,33.2638195]]]},"properties":{"lotName":"5-C-6","lotCpId":"2235001615534089121","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9091263,33.2640714],[-96.9089801,33.2639477],[-96.9089801,33.2639477],[-96.9092715,33.2637154],[-96.9092715,33.2637154],[-96.9093059,33.2637487],[-96.9094036,33.2638332],[-96.9094036,33.2638332],[-96.9091263,33.2640714],[-96.9091263,33.2640714]]]},"properties":{"lotName":"5-C-8","lotCpId":"2303641615890712701","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9094341,33.2643046],[-96.9092775,33.2641905],[-96.9092775,33.2641905],[-96.9095438,33.2639445],[-96.9095438,33.2639445],[-96.9095629,33.2639591],[-96.9096896,33.2640513],[-96.9096896,33.2640513],[-96.9094341,33.2643046],[-96.9094341,33.2643046]]]},"properties":{"lotName":"5-C-10","lotCpId":"2203451615890712915","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9096022,33.2644186],[-96.9094341,33.2643046],[-96.9094341,33.2643046],[-96.9096896,33.2640513],[-96.9096896,33.2640513],[-96.909695,33.2640549],[-96.909838,33.2641521],[-96.909838,33.2641521],[-96.9096022,33.2644186],[-96.9096022,33.2644186]]]},"properties":{"lotName":"5-C-11","lotCpId":"2868411615534060649","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9088196,33.2625444],[-96.9088319,33.2625569],[-96.9088625,33.2625889],[-96.9089419,33.2626781],[-96.9089419,33.2626781],[-96.9086177,33.2628689],[-96.9086177,33.2628689],[-96.9085145,33.2627562],[-96.9085145,33.2627562],[-96.9088196,33.2625444],[-96.9088196,33.2625444]]]},"properties":{"lotName":"5-C-23","lotCpId":"1482051615890712913","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9081347,33.2643607],[-96.9081202,33.2643468],[-96.9080867,33.2643144],[-96.9080486,33.2642776],[-96.9080206,33.2642503],[-96.9080206,33.2642503],[-96.9083246,33.2640353],[-96.9083246,33.2640353],[-96.9083628,33.264075],[-96.9084316,33.2641398],[-96.9084316,33.2641398],[-96.9081347,33.2643607],[-96.9081347,33.2643607]]]},"properties":{"lotName":"5-D-10","lotCpId":"1452771615890712927","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9082526,33.2644684],[-96.9081347,33.2643607],[-96.9081347,33.2643607],[-96.9084316,33.2641398],[-96.9084316,33.2641398],[-96.9085009,33.2642046],[-96.9085418,33.2642411],[-96.9085418,33.2642411],[-96.9082526,33.2644684],[-96.9082526,33.2644684]]]},"properties":{"lotName":"5-D-11","lotCpId":"6865781615890712933","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9086259,33.2647755],[-96.9084982,33.2646756],[-96.9084982,33.2646756],[-96.9087727,33.2644364],[-96.9087727,33.2644364],[-96.9087918,33.264452],[-96.9088933,33.26453],[-96.9088933,33.26453],[-96.9086259,33.2647755],[-96.9086259,33.2647755]]]},"properties":{"lotName":"5-D-14","lotCpId":"1755611615890712933","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.90889,33.2649663],[-96.9087563,33.2648722],[-96.9087563,33.2648722],[-96.9090161,33.2646208],[-96.9090161,33.2646208],[-96.9091018,33.2646824],[-96.9091416,33.2647093],[-96.9091416,33.2647093],[-96.90889,33.2649663],[-96.90889,33.2649663]]]},"properties":{"lotName":"5-D-16","lotCpId":"4446071615890713121","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979599,33.2588287],[-96.8979619,33.2588158],[-96.8979664,33.2587846],[-96.8979741,33.258711],[-96.8979741,33.258711],[-96.8983671,33.2587292],[-96.8983671,33.2587292],[-96.8983654,33.258789],[-96.8983485,33.2588762],[-96.8983485,33.2588762],[-96.8979599,33.2588287],[-96.8979599,33.2588287]]]},"properties":{"lotName":"7-A-13","lotCpId":"2325201615890161980","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8963084,33.2585686],[-96.8962642,33.2585677],[-96.8961611,33.2585681],[-96.8961611,33.2585681],[-96.8961709,33.2582368],[-96.8961709,33.2582368],[-96.8963177,33.25824],[-96.8963177,33.25824],[-96.8963084,33.2585686],[-96.8963084,33.2585686]]]},"properties":{"lotName":"7-B-11","lotCpId":"7061501615534717112","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8966032,33.2585745],[-96.8964558,33.2585718],[-96.8964558,33.2585718],[-96.8964651,33.2582432],[-96.8964651,33.2582432],[-96.8966124,33.2582459],[-96.8966124,33.2582459],[-96.8966032,33.2585745],[-96.8966032,33.2585745]]]},"properties":{"lotName":"7-B-9","lotCpId":"8664541615890161991","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.89675,33.2585777],[-96.8966032,33.2585745],[-96.8966032,33.2585745],[-96.8966124,33.2582459],[-96.8966124,33.2582459],[-96.8967598,33.2582491],[-96.8967598,33.2582491],[-96.89675,33.2585777],[-96.89675,33.2585777]]]},"properties":{"lotName":"7-B-8","lotCpId":"2270231615890162027","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8971919,33.2585868],[-96.8970445,33.2585836],[-96.8970445,33.2585836],[-96.8970547,33.2582551],[-96.8970547,33.2582551],[-96.897202,33.2582583],[-96.897202,33.2582583],[-96.8971919,33.2585868],[-96.8971919,33.2585868]]]},"properties":{"lotName":"7-B-5","lotCpId":"8312601615890161988","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8975064,33.2579361],[-96.8976538,33.2579388],[-96.8976538,33.2579388],[-96.8976439,33.2582674],[-96.8976439,33.2582674],[-96.8974966,33.2582646],[-96.8974966,33.2582646],[-96.8975064,33.2579361],[-96.8975064,33.2579361]]]},"properties":{"lotName":"7-B-27","lotCpId":"5448071615890162006","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8970643,33.2579269],[-96.8972117,33.2579297],[-96.8972117,33.2579297],[-96.8972019,33.2582583],[-96.8972019,33.2582583],[-96.8970545,33.2582551],[-96.8970545,33.2582551],[-96.8970643,33.2579269],[-96.8970643,33.2579269]]]},"properties":{"lotName":"7-B-24","lotCpId":"4745731615890162008","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8967698,33.2579205],[-96.8969172,33.2579237],[-96.8969172,33.2579237],[-96.896907,33.2582523],[-96.896907,33.2582523],[-96.8967596,33.2582491],[-96.8967596,33.2582491],[-96.8967698,33.2579205],[-96.8967698,33.2579205]]]},"properties":{"lotName":"7-B-22","lotCpId":"7816131615890162033","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8964749,33.2579146],[-96.8966223,33.2579178],[-96.8966223,33.2579178],[-96.8966124,33.2582459],[-96.8966124,33.2582459],[-96.8964651,33.2582432],[-96.8964651,33.2582432],[-96.8964749,33.2579146],[-96.8964749,33.2579146]]]},"properties":{"lotName":"7-B-20","lotCpId":"6185101615890162032","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8963277,33.2579114],[-96.8964751,33.2579146],[-96.8964751,33.2579146],[-96.8964649,33.2582432],[-96.8964649,33.2582432],[-96.8963175,33.25824],[-96.8963175,33.25824],[-96.8963277,33.2579114],[-96.8963277,33.2579114]]]},"properties":{"lotName":"7-B-19","lotCpId":"6686751615890161993","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8958855,33.2579023],[-96.8960328,33.2579055],[-96.8960328,33.2579055],[-96.8960236,33.2582341],[-96.8960236,33.2582341],[-96.8958762,33.2582309],[-96.8958762,33.2582309],[-96.8958855,33.2579023],[-96.8958855,33.2579023]]]},"properties":{"lotName":"7-B-16","lotCpId":"2733151615890161988","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8955264,33.2584153],[-96.8955231,33.2585385],[-96.8955231,33.2585385],[-96.8951301,33.2585303],[-96.8951301,33.2585303],[-96.895134,33.258407],[-96.895134,33.258407],[-96.8955264,33.2584153],[-96.8955264,33.2584153]]]},"properties":{"lotName":"7-C-2","lotCpId":"6688251615890162046","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8955302,33.258292],[-96.8955264,33.2584153],[-96.8955264,33.2584153],[-96.895134,33.258407],[-96.895134,33.258407],[-96.8951372,33.2582843],[-96.8951372,33.2582843],[-96.8955302,33.258292],[-96.8955302,33.258292]]]},"properties":{"lotName":"7-C-3","lotCpId":"5738601615890162031","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.895534,33.2581688],[-96.8955302,33.258292],[-96.8955302,33.258292],[-96.8951372,33.2582843],[-96.8951372,33.2582843],[-96.895141,33.2581611],[-96.895141,33.2581611],[-96.895534,33.2581688],[-96.895534,33.2581688]]]},"properties":{"lotName":"7-C-4","lotCpId":"7522521615890162279","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8955373,33.258046],[-96.895534,33.2581688],[-96.895534,33.2581688],[-96.895141,33.2581611],[-96.895141,33.2581611],[-96.8951449,33.2580378],[-96.8951449,33.2580378],[-96.8955373,33.258046],[-96.8955373,33.258046]]]},"properties":{"lotName":"7-C-5","lotCpId":"4143581615890162308","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947437,33.2583075],[-96.8947475,33.2581761],[-96.8947475,33.2581761],[-96.8951405,33.2581843],[-96.8951405,33.2581843],[-96.8951367,33.2583153],[-96.8951367,33.2583153],[-96.8947437,33.2583075],[-96.8947437,33.2583075]]]},"properties":{"lotName":"7-C-9","lotCpId":"8123441615890162286","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947399,33.258439],[-96.8947437,33.2583075],[-96.8947437,33.2583075],[-96.8951367,33.2583153],[-96.8951367,33.2583153],[-96.8951323,33.2584467],[-96.8951323,33.2584467],[-96.8947399,33.258439],[-96.8947399,33.258439]]]},"properties":{"lotName":"7-C-10","lotCpId":"3572341615890162270","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8947355,33.25857],[-96.8947399,33.258439],[-96.8947399,33.258439],[-96.8951323,33.2584467],[-96.8951323,33.2584467],[-96.8951285,33.2585782],[-96.8951285,33.2585782],[-96.8947355,33.25857],[-96.8947355,33.25857]]]},"properties":{"lotName":"7-C-11","lotCpId":"1513821615890162332","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945664,33.2587571],[-96.8945625,33.2588885],[-96.8945625,33.2588885],[-96.8941778,33.2588803],[-96.8941778,33.2588803],[-96.8941816,33.2587489],[-96.8941816,33.2587489],[-96.8945664,33.2587571],[-96.8945664,33.2587571]]]},"properties":{"lotName":"7-D-70","lotCpId":"5808331615890162368","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945778,33.2583711],[-96.894574,33.2584998],[-96.894574,33.2584998],[-96.8941892,33.2584918],[-96.8941892,33.2584918],[-96.8941931,33.2583631],[-96.8941931,33.2583631],[-96.8945778,33.2583711],[-96.8945778,33.2583711]]]},"properties":{"lotName":"7-D-67","lotCpId":"5835501615534711734","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945816,33.2582424],[-96.8945778,33.2583711],[-96.8945778,33.2583711],[-96.8941931,33.2583631],[-96.8941931,33.2583631],[-96.8941969,33.2582344],[-96.8941969,33.2582344],[-96.8945816,33.2582424],[-96.8945816,33.2582424]]]},"properties":{"lotName":"7-D-66","lotCpId":"6545751615534707688","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945893,33.257985],[-96.8945855,33.2581137],[-96.8945855,33.2581137],[-96.8942007,33.2581057],[-96.8942007,33.2581057],[-96.8942045,33.257977],[-96.8942045,33.257977],[-96.8945893,33.257985],[-96.8945893,33.257985]]]},"properties":{"lotName":"7-D-64","lotCpId":"2536641615534714409","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8945609,33.2578443],[-96.8945603,33.2578514],[-96.8945618,33.2578705],[-96.8945703,33.2578978],[-96.8945909,33.2579301],[-96.8945893,33.2579849],[-96.8945893,33.2579849],[-96.8942045,33.2579771],[-96.8942045,33.2579771],[-96.8942089,33.2578375],[-96.8942089,33.2578375],[-96.8945609,33.2578443],[-96.8945609,33.2578443]]]},"properties":{"lotName":"7-D-63","lotCpId":"6488051615890162322","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8956994,33.2577617],[-96.8955526,33.2577585],[-96.8955526,33.2577585],[-96.8955624,33.2574162],[-96.8955624,33.2574162],[-96.8957097,33.2574194],[-96.8957097,33.2574194],[-96.8956994,33.2577617],[-96.8956994,33.2577617]]]},"properties":{"lotName":"7-D-54","lotCpId":"8856351615890162319","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8958467,33.2577645],[-96.8956994,33.2577617],[-96.8956994,33.2577617],[-96.8957097,33.2574194],[-96.8957097,33.2574194],[-96.8958571,33.2574226],[-96.8958571,33.2574226],[-96.8958467,33.2577645],[-96.8958467,33.2577645]]]},"properties":{"lotName":"7-D-53","lotCpId":"3070651615890162253","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8959941,33.2577677],[-96.8958467,33.2577645],[-96.8958467,33.2577645],[-96.8958571,33.2574226],[-96.8958571,33.2574226],[-96.8960045,33.2574254],[-96.8960045,33.2574254],[-96.8959941,33.2577677],[-96.8959941,33.2577677]]]},"properties":{"lotName":"7-D-52","lotCpId":"6811231615890162262","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8967309,33.2577827],[-96.8965835,33.25778],[-96.8965835,33.25778],[-96.8965939,33.2574377],[-96.8965939,33.2574377],[-96.8967412,33.2574409],[-96.8967412,33.2574409],[-96.8967309,33.2577827],[-96.8967309,33.2577827]]]},"properties":{"lotName":"7-D-47","lotCpId":"1776751615890162289","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8970255,33.2577891],[-96.8968781,33.2577859],[-96.8968781,33.2577859],[-96.8968887,33.2574436],[-96.8968887,33.2574436],[-96.8970361,33.2574468],[-96.8970361,33.2574468],[-96.8970255,33.2577891],[-96.8970255,33.2577891]]]},"properties":{"lotName":"7-D-45","lotCpId":"3051861615890162277","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8973203,33.257795],[-96.8971729,33.2577923],[-96.8971729,33.2577923],[-96.8971828,33.25745],[-96.8971828,33.25745],[-96.8973301,33.2574528],[-96.8973301,33.2574528],[-96.8973203,33.257795],[-96.8973203,33.257795]]]},"properties":{"lotName":"7-D-43","lotCpId":"4627801615890162298","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.897615,33.2578014],[-96.8974677,33.2577982],[-96.8974677,33.2577982],[-96.8974775,33.2574559],[-96.8974775,33.2574559],[-96.8976248,33.2574591],[-96.8976248,33.2574591],[-96.897615,33.2578014],[-96.897615,33.2578014]]]},"properties":{"lotName":"7-D-41","lotCpId":"7671101615890162289","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8979097,33.2578074],[-96.8977624,33.2578042],[-96.8977624,33.2578042],[-96.8977722,33.2574623],[-96.8977722,33.2574623],[-96.8979195,33.2574651],[-96.8979195,33.2574651],[-96.8979097,33.2578074],[-96.8979097,33.2578074]]]},"properties":{"lotName":"7-D-39","lotCpId":"1188101615890162284","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8987944,33.2578001],[-96.8987704,33.2578042],[-96.8987218,33.2578242],[-96.898646,33.2578224],[-96.898646,33.2578224],[-96.8986563,33.2574806],[-96.8986563,33.2574806],[-96.8988037,33.2574833],[-96.8988037,33.2574833],[-96.8987944,33.2578001],[-96.8987944,33.2578001]]]},"properties":{"lotName":"7-D-33","lotCpId":"7842311615890162345","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989652,33.2579936],[-96.8989699,33.2579853],[-96.898978,33.2579626],[-96.8989807,33.2579283],[-96.8989691,33.2578854],[-96.8989691,33.2578854],[-96.8993462,33.2577608],[-96.8993462,33.2577608],[-96.8993391,33.2580013],[-96.8993391,33.2580013],[-96.8989652,33.2579936],[-96.8989652,33.2579936]]]},"properties":{"lotName":"7-D-30","lotCpId":"3775641615890162316","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989423,33.2581163],[-96.898945,33.2580205],[-96.898945,33.2580205],[-96.898954,33.2580109],[-96.8989652,33.2579936],[-96.8993391,33.2580013],[-96.8993391,33.2580013],[-96.8993353,33.2581245],[-96.8993353,33.2581245],[-96.8989423,33.2581163],[-96.8989423,33.2581163]]]},"properties":{"lotName":"7-D-29","lotCpId":"4816771615890162287","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8989025,33.2578192],[-96.898892,33.2578146],[-96.8988654,33.2578052],[-96.8987944,33.2578001],[-96.8987944,33.2578001],[-96.8988037,33.2574833],[-96.8988037,33.2574833],[-96.8991443,33.2574906],[-96.8991443,33.2574906],[-96.8989025,33.2578192],[-96.8989025,33.2578192]]]},"properties":{"lotName":"7-D-32","lotCpId":"6060401615534709032","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8993413,33.2623395],[-96.8993235,33.2623409],[-96.8992805,33.2623444],[-96.8991803,33.2623541],[-96.8991803,33.2623541],[-96.8991279,33.2620255],[-96.8991279,33.2620255],[-96.8993091,33.2620096],[-96.8993091,33.2620096],[-96.8993413,33.2623395],[-96.8993413,33.2623395]]]},"properties":{"lotName":"1A-H-15","lotCpId":"4643261615535231438","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057109,33.2677535],[-96.9058594,33.2678119],[-96.9058594,33.2678119],[-96.9056918,33.268109],[-96.9056918,33.268109],[-96.9055439,33.2680511],[-96.9055439,33.2680511],[-96.9057109,33.2677535],[-96.9057109,33.2677535]]]},"properties":{"lotName":"5-H-10","lotCpId":"6376481615534250341","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9059129,33.2676814],[-96.9057584,33.2676212],[-96.9057584,33.2676212],[-96.9059265,33.2673223],[-96.9059265,33.2673223],[-96.906081,33.267383],[-96.906081,33.267383],[-96.9059129,33.2676814],[-96.9059129,33.2676814]]]},"properties":{"lotName":"5-G-6","lotCpId":"3744301615891791139","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056984,33.266652],[-96.9055221,33.266552],[-96.9055221,33.266552],[-96.9057459,33.2662768],[-96.9057459,33.2662768],[-96.9059216,33.2663768],[-96.9059216,33.2663768],[-96.9056984,33.266652],[-96.9056984,33.266652]]]},"properties":{"lotName":"5-W-22","lotCpId":"1782411615534107800","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9083737,33.2645733],[-96.9082526,33.2644684],[-96.9082526,33.2644684],[-96.9085418,33.2642411],[-96.9085418,33.2642411],[-96.9086439,33.2643301],[-96.9086559,33.2643401],[-96.9086559,33.2643401],[-96.9083737,33.2645733],[-96.9083737,33.2645733]]]},"properties":{"lotName":"5-D-12","lotCpId":"6105101615534191162","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9084982,33.2646756],[-96.9084849,33.264665],[-96.9084525,33.2646388],[-96.9083737,33.2645733],[-96.9083737,33.2645733],[-96.9086559,33.2643401],[-96.9086559,33.2643401],[-96.9087727,33.2644364],[-96.9087727,33.2644364],[-96.9084982,33.2646756],[-96.9084982,33.2646756]]]},"properties":{"lotName":"5-D-13","lotCpId":"3370801615534111721","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8955411,33.2579228],[-96.8955373,33.258046],[-96.8955373,33.258046],[-96.8951449,33.2580378],[-96.8951449,33.2580378],[-96.8951492,33.2578872],[-96.8951492,33.2578872],[-96.8955094,33.2578945],[-96.8955411,33.2579228],[-96.8955411,33.2579228]]]},"properties":{"lotName":"7-C-6","lotCpId":"2075671615534693688","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076342,33.258794],[-96.9076366,33.258783],[-96.9076417,33.2587551],[-96.9076484,33.2586799],[-96.9076484,33.2586799],[-96.908025,33.2586877],[-96.908025,33.2586877],[-96.9080201,33.2588525],[-96.9080201,33.2588525],[-96.9076342,33.258794],[-96.9076342,33.258794]]]},"properties":{"lotName":"2-A-13","lotCpId":"8606001615532217672","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9027862,33.2615194],[-96.9027834,33.2614824],[-96.9027823,33.2614704],[-96.9027788,33.2614405],[-96.9027638,33.2613647],[-96.9027638,33.2613647],[-96.9030885,33.2611694],[-96.9030885,33.2611694],[-96.9031464,33.2613187],[-96.9031786,33.2614702],[-96.9031807,33.2614994],[-96.9031807,33.2614994],[-96.9027862,33.2615194],[-96.9027862,33.2615194]]]},"properties":{"lotName":"1B-N-12","lotCpId":"6672771615535771155","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9128148,33.261335],[-96.91312,33.2613829],[-96.91312,33.2613829],[-96.9130476,33.2617078],[-96.9130476,33.2617078],[-96.912742,33.2616605],[-96.912742,33.2616605],[-96.9128148,33.261335],[-96.9128148,33.261335]]]},"properties":{"lotName":"11-H-5","lotCpId":"2134761672815240264","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.91312,33.2613829],[-96.9133931,33.2614253],[-96.9133931,33.2614253],[-96.9134192,33.2614572],[-96.9133527,33.2617556],[-96.9133527,33.2617556],[-96.9130476,33.2617078],[-96.9130476,33.2617078],[-96.91312,33.2613829],[-96.91312,33.2613829]]]},"properties":{"lotName":"11-H-6","lotCpId":"8380071672815241021","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9132481,33.262076],[-96.9130067,33.2620382],[-96.9130067,33.2620382],[-96.9130797,33.2617128],[-96.9130797,33.2617128],[-96.9133527,33.2617556],[-96.9133527,33.2617556],[-96.9132863,33.2620541],[-96.9132481,33.262076],[-96.9132481,33.262076]]]},"properties":{"lotName":"11-H-7","lotCpId":"4626151672815241813","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9130067,33.2620382],[-96.9127494,33.2619981],[-96.9127494,33.2619981],[-96.9128225,33.2616727],[-96.9128225,33.2616727],[-96.9130797,33.2617128],[-96.9130797,33.2617128],[-96.9130067,33.2620382],[-96.9130067,33.2620382]]]},"properties":{"lotName":"11-H-8","lotCpId":"1822241672815242563","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9127494,33.2619981],[-96.9124927,33.261958],[-96.9124927,33.261958],[-96.9125651,33.2616328],[-96.9125651,33.2616328],[-96.9128224,33.261673],[-96.9128224,33.261673],[-96.9127494,33.2619981],[-96.9127494,33.2619981]]]},"properties":{"lotName":"11-H-9","lotCpId":"7206311672815243311","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9124927,33.261958],[-96.9122355,33.2619174],[-96.9122355,33.2619174],[-96.9123425,33.2615975],[-96.9123425,33.2615975],[-96.9125652,33.2616324],[-96.9125652,33.2616324],[-96.9124927,33.261958],[-96.9124927,33.261958]]]},"properties":{"lotName":"11-H-10","lotCpId":"2340751672815244047","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9122355,33.2619174],[-96.9120535,33.2618892],[-96.9120017,33.2618623],[-96.9118638,33.2617083],[-96.9118638,33.2617083],[-96.9122016,33.2614974],[-96.9122016,33.2614974],[-96.9123425,33.2615975],[-96.9123425,33.2615975],[-96.9122355,33.2619174],[-96.9122355,33.2619174]]]},"properties":{"lotName":"11-H-11","lotCpId":"1223701672815244784","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9118638,33.2617083],[-96.9116905,33.2615146],[-96.9116905,33.2615146],[-96.9120069,33.2613165],[-96.9120069,33.2613165],[-96.9121122,33.2614341],[-96.9122016,33.2614974],[-96.9122016,33.2614974],[-96.9118638,33.2617083],[-96.9118638,33.2617083]]]},"properties":{"lotName":"11-H-12","lotCpId":"1787661672815245508","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9116905,33.2615146],[-96.9115363,33.2613419],[-96.9115363,33.2613419],[-96.9115428,33.2613036],[-96.9118323,33.2611215],[-96.9118323,33.2611215],[-96.9120069,33.2613165],[-96.9120069,33.2613165],[-96.9116905,33.2615146],[-96.9116905,33.2615146]]]},"properties":{"lotName":"11-H-13","lotCpId":"4646401672815246262","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9133691,33.2624287],[-96.9134051,33.2622674],[-96.9134051,33.2622674],[-96.9134432,33.2622455],[-96.9138002,33.2623011],[-96.9138002,33.2623011],[-96.9137582,33.2624893],[-96.9137582,33.2624893],[-96.9133691,33.2624287],[-96.9133691,33.2624287]]]},"properties":{"lotName":"11-F-1","lotCpId":"1466701672815226899","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9133331,33.2625901],[-96.9133691,33.2624287],[-96.9133691,33.2624287],[-96.9137582,33.2624893],[-96.9137582,33.2624893],[-96.9137223,33.2626507],[-96.9137223,33.2626507],[-96.9133331,33.2625901],[-96.9133331,33.2625901]]]},"properties":{"lotName":"11-F-2","lotCpId":"8530871672815227639","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9132863,33.2627418],[-96.9132918,33.2627273],[-96.9133047,33.2626913],[-96.9133308,33.2625995],[-96.9133331,33.2625901],[-96.9133331,33.2625901],[-96.9137223,33.2626507],[-96.9137223,33.2626507],[-96.9136776,33.2628494],[-96.9136776,33.2628494],[-96.9132863,33.2627418],[-96.9132863,33.2627418]]]},"properties":{"lotName":"11-F-3","lotCpId":"7624801672815228388","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9132121,33.2628863],[-96.913222,33.2628696],[-96.9132446,33.2628297],[-96.9132695,33.262782],[-96.9132863,33.2627418],[-96.9132863,33.2627418],[-96.9136776,33.2628494],[-96.9136776,33.2628494],[-96.9136536,33.2630795],[-96.9136536,33.2630795],[-96.9132121,33.2628863],[-96.9132121,33.2628863]]]},"properties":{"lotName":"11-F-4","lotCpId":"8414341672815229108","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9131119,33.2630198],[-96.9131237,33.2630056],[-96.9131517,33.2629709],[-96.9132121,33.2628863],[-96.9132121,33.2628863],[-96.9136536,33.2630795],[-96.9136536,33.2630795],[-96.9136285,33.2633174],[-96.9136073,33.2633256],[-96.9136073,33.2633256],[-96.9131119,33.2630198],[-96.9131119,33.2630198]]]},"properties":{"lotName":"11-F-5","lotCpId":"3258151672815229852","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9129887,33.2631392],[-96.9130022,33.2631276],[-96.913035,33.2630983],[-96.9131119,33.2630198],[-96.9131119,33.2630198],[-96.9136073,33.2633256],[-96.9136073,33.2633256],[-96.9133348,33.2634317],[-96.9133348,33.2634317],[-96.9129887,33.2631392],[-96.9129887,33.2631392]]]},"properties":{"lotName":"11-F-6","lotCpId":"7241871672815230583","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9128443,33.2632413],[-96.9128558,33.2632344],[-96.912887,33.2632144],[-96.912933,33.2631823],[-96.9129887,33.2631392],[-96.9129887,33.2631392],[-96.9133348,33.2634317],[-96.9133348,33.2634317],[-96.9130917,33.2635265],[-96.9130917,33.2635265],[-96.9128443,33.2632413],[-96.9128443,33.2632413]]]},"properties":{"lotName":"11-F-7","lotCpId":"2111601672815231355","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9126835,33.2633237],[-96.9126992,33.2633169],[-96.9127389,33.2632987],[-96.9128443,33.2632413],[-96.9128443,33.2632413],[-96.9130917,33.2635265],[-96.9130917,33.2635265],[-96.9128623,33.2636159],[-96.9128623,33.2636159],[-96.9126835,33.2633237],[-96.9126835,33.2633237]]]},"properties":{"lotName":"11-F-8","lotCpId":"8073811672815232124","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9125058,33.263393],[-96.912635,33.2633438],[-96.9126835,33.2633237],[-96.9126835,33.2633237],[-96.9128623,33.2636159],[-96.9128623,33.2636159],[-96.9126688,33.2636915],[-96.9126688,33.2636915],[-96.9125058,33.263393],[-96.9125058,33.263393]]]},"properties":{"lotName":"11-F-9","lotCpId":"1661861672815232886","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9123249,33.2634618],[-96.9125058,33.263393],[-96.9125058,33.263393],[-96.9126688,33.2636915],[-96.9126688,33.2636915],[-96.9124889,33.2637617],[-96.9124889,33.2637617],[-96.9123249,33.2634618],[-96.9123249,33.2634618]]]},"properties":{"lotName":"11-F-10","lotCpId":"5650861672815233612","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9121439,33.2635311],[-96.9123249,33.2634618],[-96.9123249,33.2634618],[-96.9124889,33.2637617],[-96.9124889,33.2637617],[-96.9123085,33.2638319],[-96.9123085,33.2638319],[-96.9121439,33.2635311],[-96.9121439,33.2635311]]]},"properties":{"lotName":"11-F-11","lotCpId":"4313311672815234343","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9119674,33.2635862],[-96.9119782,33.2635839],[-96.9120099,33.2635759],[-96.9120616,33.2635604],[-96.9121321,33.2635357],[-96.9121439,33.2635311],[-96.9121439,33.2635311],[-96.9123085,33.2638319],[-96.9123085,33.2638319],[-96.9120742,33.2639034],[-96.9120742,33.2639034],[-96.9119674,33.2635862],[-96.9119674,33.2635862]]]},"properties":{"lotName":"11-F-12","lotCpId":"1267531672815235089","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9117826,33.2636163],[-96.9117989,33.2636145],[-96.9118415,33.2636091],[-96.9119674,33.2635862],[-96.9119674,33.2635862],[-96.9120742,33.2639034],[-96.9120742,33.2639034],[-96.9118262,33.2639444],[-96.9118262,33.2639444],[-96.9117826,33.2636163],[-96.9117826,33.2636163]]]},"properties":{"lotName":"11-F-13","lotCpId":"7651101672815235824","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9115946,33.2636204],[-96.9116126,33.2636212],[-96.9116582,33.2636223],[-96.9117826,33.2636163],[-96.9117826,33.2636163],[-96.9118262,33.2639444],[-96.9118262,33.2639444],[-96.9115728,33.2639508],[-96.9115728,33.2639508],[-96.9115946,33.2636204],[-96.9115946,33.2636204]]]},"properties":{"lotName":"11-F-14","lotCpId":"1876381672815236572","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9114082,33.263599],[-96.911425,33.2636021],[-96.9114686,33.263609],[-96.9115946,33.2636204],[-96.9115946,33.2636204],[-96.9115728,33.2639508],[-96.9115728,33.2639508],[-96.9113221,33.2639221],[-96.9113221,33.2639221],[-96.9114082,33.263599],[-96.9114082,33.263599]]]},"properties":{"lotName":"11-F-15","lotCpId":"4547071672815237310","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9112283,33.2635525],[-96.9112459,33.2635584],[-96.9112901,33.2635722],[-96.9114082,33.263599],[-96.9114082,33.263599],[-96.9113221,33.2639221],[-96.9113221,33.2639221],[-96.9110807,33.2638592],[-96.9110807,33.2638592],[-96.9112283,33.2635525],[-96.9112283,33.2635525]]]},"properties":{"lotName":"11-F-16","lotCpId":"2641311672815238036","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9110638,33.2634837],[-96.9110797,33.2634914],[-96.91112,33.2635099],[-96.9112283,33.2635525],[-96.9112283,33.2635525],[-96.9110807,33.2638592],[-96.9110807,33.2638592],[-96.9108577,33.2637685],[-96.9108577,33.2637685],[-96.9110638,33.2634837],[-96.9110638,33.2634837]]]},"properties":{"lotName":"11-F-17","lotCpId":"6521171672815238777","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9108817,33.2633857],[-96.9110638,33.2634837],[-96.9110638,33.2634837],[-96.9108577,33.2637685],[-96.9108577,33.2637685],[-96.9106539,33.2636427],[-96.9106539,33.2636427],[-96.9108817,33.2633857],[-96.9108817,33.2633857]]]},"properties":{"lotName":"11-F-18","lotCpId":"8546531672815239523","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9112363,33.2627146],[-96.9114338,33.2627436],[-96.9114338,33.2627436],[-96.9113613,33.2630663],[-96.9113613,33.2630663],[-96.9111642,33.2630377],[-96.9111642,33.2630377],[-96.9112363,33.2627146],[-96.9112363,33.2627146]]]},"properties":{"lotName":"11-J-4","lotCpId":"8115421672815258764","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9114338,33.2627436],[-96.9116289,33.2627742],[-96.9116289,33.2627742],[-96.911557,33.2630968],[-96.911557,33.2630968],[-96.9113613,33.2630663],[-96.9113613,33.2630663],[-96.9114338,33.2627436],[-96.9114338,33.2627436]]]},"properties":{"lotName":"11-J-5","lotCpId":"7162261672815259503","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9116289,33.2627742],[-96.911824,33.2628047],[-96.911824,33.2628047],[-96.9117521,33.2631273],[-96.9117521,33.2631273],[-96.911557,33.2630968],[-96.911557,33.2630968],[-96.9116289,33.2627742],[-96.9116289,33.2627742]]]},"properties":{"lotName":"11-J-6","lotCpId":"8037401672815260245","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.911824,33.2628047],[-96.9120197,33.2628352],[-96.9120197,33.2628352],[-96.9119472,33.2631579],[-96.9119472,33.2631579],[-96.9117521,33.2631273],[-96.9117521,33.2631273],[-96.911824,33.2628047],[-96.911824,33.2628047]]]},"properties":{"lotName":"11-J-7","lotCpId":"3500121672815260986","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9120197,33.2628352],[-96.9122148,33.2628658],[-96.9122148,33.2628658],[-96.9121429,33.2631884],[-96.9121429,33.2631884],[-96.9119472,33.2631579],[-96.9119472,33.2631579],[-96.9120197,33.2628352],[-96.9120197,33.2628352]]]},"properties":{"lotName":"11-J-8","lotCpId":"5302331672815261698","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9122148,33.2628658],[-96.9124099,33.2628963],[-96.9124099,33.2628963],[-96.912338,33.2632189],[-96.912338,33.2632189],[-96.9121429,33.2631884],[-96.9121429,33.2631884],[-96.9122148,33.2628658],[-96.9122148,33.2628658]]]},"properties":{"lotName":"11-J-9","lotCpId":"4155171672815262444","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9124099,33.2628963],[-96.9124936,33.2629099],[-96.9125204,33.2629144],[-96.9125897,33.2629306],[-96.912685,33.2629631],[-96.9127898,33.2630162],[-96.9127898,33.2630162],[-96.9127987,33.2630232],[-96.9128137,33.2630419],[-96.9128174,33.2630694],[-96.9127926,33.2631027],[-96.9127774,33.2631132],[-96.9127335,33.2631405],[-96.9126626,33.2631781],[-96.9125669,33.2632194],[-96.9125015,33.2632445],[-96.9125015,33.2632445],[-96.912338,33.2632189],[-96.912338,33.2632189],[-96.9124099,33.2628963],[-96.9124099,33.2628963]]]},"properties":{"lotName":"11-J-10","lotCpId":"7861211672815263185","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9118246,33.2626672],[-96.9116303,33.2626371],[-96.9116303,33.2626371],[-96.9117029,33.2623112],[-96.9117029,33.2623112],[-96.9118976,33.262341],[-96.9118976,33.262341],[-96.9118246,33.2626672],[-96.9118246,33.2626672]]]},"properties":{"lotName":"11-I-7","lotCpId":"5561401672815246983","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9120175,33.2626958],[-96.9118246,33.2626672],[-96.9118246,33.2626672],[-96.9118976,33.262341],[-96.9118976,33.262341],[-96.9120905,33.2623709],[-96.9120905,33.2623709],[-96.9120175,33.2626958],[-96.9120175,33.2626958]]]},"properties":{"lotName":"11-I-8","lotCpId":"3217701672815247724","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9122104,33.2627259],[-96.9120175,33.2626958],[-96.9120175,33.2626958],[-96.9120905,33.2623709],[-96.9120905,33.2623709],[-96.9122835,33.2624009],[-96.9122835,33.2624009],[-96.9122104,33.2627259],[-96.9122104,33.2627259]]]},"properties":{"lotName":"11-I-9","lotCpId":"1308731672815248463","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9124034,33.2627559],[-96.9122104,33.2627259],[-96.9122104,33.2627259],[-96.9122835,33.2624009],[-96.9122835,33.2624009],[-96.9124758,33.262431],[-96.9124758,33.262431],[-96.9124034,33.2627559],[-96.9124034,33.2627559]]]},"properties":{"lotName":"11-I-10","lotCpId":"3334731672815249184","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9125908,33.2627878],[-96.9125238,33.2627751],[-96.9124034,33.2627559],[-96.9124034,33.2627559],[-96.9124758,33.262431],[-96.9124758,33.262431],[-96.9126938,33.2624652],[-96.9126938,33.2624652],[-96.9125908,33.2627878],[-96.9125908,33.2627878]]]},"properties":{"lotName":"11-I-11","lotCpId":"3672681672815249900","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.912762,33.2628421],[-96.9127433,33.2628351],[-96.9126979,33.262819],[-96.9125908,33.2627878],[-96.9125908,33.2627878],[-96.9126938,33.2624652],[-96.9126938,33.2624652],[-96.9127636,33.2624757],[-96.9129538,33.2625217],[-96.9129538,33.2625217],[-96.912762,33.2628421],[-96.912762,33.2628421]]]},"properties":{"lotName":"11-I-12","lotCpId":"6833431672815250657","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9129114,33.2629216],[-96.9128959,33.2629121],[-96.9128565,33.2628893],[-96.912762,33.2628421],[-96.912762,33.2628421],[-96.9129538,33.2625217],[-96.9129538,33.2625217],[-96.9131701,33.2625744],[-96.9131701,33.2625744],[-96.9131683,33.2625825],[-96.9131626,33.2626052],[-96.9131364,33.2626845],[-96.913086,33.2627923],[-96.9130058,33.2629088],[-96.9129985,33.2629156],[-96.9129786,33.2629279],[-96.9129487,33.2629339],[-96.9129114,33.2629216],[-96.9129114,33.2629216]]]},"properties":{"lotName":"11-I-13","lotCpId":"2336041672815251409","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9129931,33.2621754],[-96.9132181,33.2622104],[-96.9132181,33.2622104],[-96.9132443,33.2622423],[-96.9131701,33.2625744],[-96.9131701,33.2625744],[-96.9129178,33.262513],[-96.9129178,33.262513],[-96.9129931,33.2621754],[-96.9129931,33.2621754]]]},"properties":{"lotName":"11-I-14","lotCpId":"7846851672815252157","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9127358,33.2621348],[-96.9129931,33.2621754],[-96.9129931,33.2621754],[-96.9129178,33.262513],[-96.9129178,33.262513],[-96.9127636,33.2624757],[-96.9126633,33.2624604],[-96.9126633,33.2624604],[-96.9127358,33.2621348],[-96.9127358,33.2621348]]]},"properties":{"lotName":"11-I-15","lotCpId":"1466281672815252901","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9124786,33.2620947],[-96.9127358,33.2621348],[-96.9127358,33.2621348],[-96.9126633,33.2624604],[-96.9126633,33.2624604],[-96.9124059,33.2624201],[-96.9124059,33.2624201],[-96.9124786,33.2620947],[-96.9124786,33.2620947]]]},"properties":{"lotName":"11-I-16","lotCpId":"4348801672815253643","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9122219,33.2620546],[-96.9124786,33.2620947],[-96.9124786,33.2620947],[-96.9124059,33.2624201],[-96.9124059,33.2624201],[-96.9121489,33.26238],[-96.9121489,33.26238],[-96.9122219,33.2620546],[-96.9122219,33.2620546]]]},"properties":{"lotName":"11-I-17","lotCpId":"6005441672815254401","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9119385,33.262035],[-96.9119493,33.2620388],[-96.9119787,33.2620448],[-96.9120223,33.2620452],[-96.9120756,33.2620318],[-96.9122219,33.2620546],[-96.9122219,33.2620546],[-96.9121489,33.26238],[-96.9121489,33.26238],[-96.9117893,33.2623242],[-96.9117893,33.2623242],[-96.9119385,33.262035],[-96.9119385,33.262035]]]},"properties":{"lotName":"11-I-18","lotCpId":"2245381672815255130","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9118169,33.2618837],[-96.9118398,33.2619092],[-96.9118399,33.2619226],[-96.9118481,33.2619553],[-96.9118769,33.2619964],[-96.9119385,33.262035],[-96.9119385,33.262035],[-96.9117893,33.2623242],[-96.9117893,33.2623242],[-96.9117029,33.2623112],[-96.9114986,33.262083],[-96.9114986,33.262083],[-96.9118169,33.2618837],[-96.9118169,33.2618837]]]},"properties":{"lotName":"11-I-19","lotCpId":"7406761672815255874","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9116796,33.2617306],[-96.9118169,33.2618837],[-96.9118169,33.2618837],[-96.9114986,33.262083],[-96.9114986,33.262083],[-96.9113613,33.2619299],[-96.9113613,33.2619299],[-96.9116796,33.2617306],[-96.9116796,33.2617306]]]},"properties":{"lotName":"11-I-20","lotCpId":"5488501672815256605","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9115428,33.2615775],[-96.9116796,33.2617306],[-96.9116796,33.2617306],[-96.9113613,33.2619299],[-96.9113613,33.2619299],[-96.9112242,33.2617766],[-96.9112242,33.2617766],[-96.9115428,33.2615775],[-96.9115428,33.2615775]]]},"properties":{"lotName":"11-I-21","lotCpId":"1215801672815257322","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9114055,33.2614243],[-96.9115428,33.2615775],[-96.9115428,33.2615775],[-96.9112242,33.2617766],[-96.9112242,33.2617766],[-96.9110665,33.2616007],[-96.9110665,33.2616007],[-96.9113597,33.2614184],[-96.9114055,33.2614243],[-96.9114055,33.2614243]]]},"properties":{"lotName":"11-I-22","lotCpId":"6235761672815258042","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9142149,33.2613906],[-96.914144,33.2613887],[-96.9141255,33.2613879],[-96.9140791,33.2613853],[-96.9139577,33.2613738],[-96.9139577,33.2613738],[-96.914016,33.2610497],[-96.914016,33.2610497],[-96.9143179,33.2610671],[-96.9143179,33.2610671],[-96.9143162,33.2610768],[-96.9143113,33.261103],[-96.9142948,33.2611879],[-96.9142742,33.2612868],[-96.9142547,33.2613651],[-96.9142149,33.2613906],[-96.9142149,33.2613906]]]},"properties":{"lotName":"11-D-1","lotCpId":"5816781672815206204","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9139577,33.2613738],[-96.9139005,33.2613656],[-96.9136917,33.2613332],[-96.9136917,33.2613332],[-96.9137637,33.2610106],[-96.9137637,33.2610106],[-96.914016,33.2610497],[-96.914016,33.2610497],[-96.9139577,33.2613738],[-96.9139577,33.2613738]]]},"properties":{"lotName":"11-D-2","lotCpId":"8301201672815206937","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9136917,33.2613332],[-96.9134508,33.2612954],[-96.9134508,33.2612954],[-96.9135228,33.2609727],[-96.9135228,33.2609727],[-96.9137637,33.2610106],[-96.9137637,33.2610106],[-96.9136917,33.2613332],[-96.9136917,33.2613332]]]},"properties":{"lotName":"11-D-3","lotCpId":"6607641672815207704","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9134508,33.2612954],[-96.9132094,33.2612576],[-96.9132094,33.2612576],[-96.9132819,33.2609349],[-96.9132819,33.2609349],[-96.9135228,33.2609727],[-96.9135228,33.2609727],[-96.9134508,33.2612954],[-96.9134508,33.2612954]]]},"properties":{"lotName":"11-D-4","lotCpId":"4832621672815208442","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9132094,33.2612576],[-96.9129849,33.2612225],[-96.9129849,33.2612225],[-96.9129587,33.2611906],[-96.9130247,33.2608948],[-96.9130247,33.2608948],[-96.9132819,33.2609349],[-96.9132819,33.2609349],[-96.9132094,33.2612576],[-96.9132094,33.2612576]]]},"properties":{"lotName":"11-D-5","lotCpId":"1218001672815209187","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9131288,33.2605772],[-96.9133538,33.2606127],[-96.9133538,33.2606127],[-96.9132819,33.2609349],[-96.9132819,33.2609349],[-96.9130247,33.2608948],[-96.9130247,33.2608948],[-96.9130906,33.260599],[-96.9131288,33.2605772],[-96.9131288,33.2605772]]]},"properties":{"lotName":"11-D-6","lotCpId":"6404311672815209926","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9133538,33.2606127],[-96.9135947,33.2606501],[-96.9135947,33.2606501],[-96.9135228,33.2609727],[-96.9135228,33.2609727],[-96.9132819,33.2609349],[-96.9132819,33.2609349],[-96.9133538,33.2606127],[-96.9133538,33.2606127]]]},"properties":{"lotName":"11-D-7","lotCpId":"7707101672815210668","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9135947,33.2606501],[-96.9138362,33.2606879],[-96.9138362,33.2606879],[-96.9137637,33.2610106],[-96.9137637,33.2610106],[-96.9135228,33.2609727],[-96.9135228,33.2609727],[-96.9135947,33.2606501],[-96.9135947,33.2606501]]]},"properties":{"lotName":"11-D-8","lotCpId":"1617281672815211408","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9138362,33.2606879],[-96.9138445,33.2606892],[-96.9138667,33.2606926],[-96.913935,33.2607031],[-96.914006,33.2607142],[-96.9140449,33.2607207],[-96.9140748,33.260725],[-96.9140748,33.260725],[-96.914016,33.2610497],[-96.914016,33.2610497],[-96.9137637,33.2610106],[-96.9137637,33.2610106],[-96.9138362,33.2606879],[-96.9138362,33.2606879]]]},"properties":{"lotName":"11-D-9","lotCpId":"3372681672815212143","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9140749,33.2607248],[-96.9140836,33.2607258],[-96.9141065,33.2607281],[-96.9141752,33.2607326],[-96.9143234,33.2607376],[-96.9143234,33.2607376],[-96.9143539,33.2607658],[-96.9143531,33.260775],[-96.9143507,33.2608],[-96.9143424,33.2608821],[-96.9143309,33.2609813],[-96.9143179,33.2610671],[-96.9143179,33.2610671],[-96.914016,33.2610497],[-96.914016,33.2610497],[-96.9140749,33.2607248],[-96.9140749,33.2607248]]]},"properties":{"lotName":"11-D-10","lotCpId":"3857751672815212880","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9136067,33.2593326],[-96.9136054,33.2593249],[-96.9136017,33.2593041],[-96.9135889,33.2592352],[-96.9135719,33.2591513],[-96.9135544,33.2590774],[-96.9135544,33.2590774],[-96.9135795,33.2590478],[-96.9135912,33.259047],[-96.9136231,33.2590459],[-96.9137267,33.2590487],[-96.9140678,33.2590801],[-96.9140678,33.2590801],[-96.9140389,33.2592975],[-96.9140389,33.2592975],[-96.9136067,33.2593326],[-96.9136067,33.2593326]]]},"properties":{"lotName":"11-C-1","lotCpId":"3303201672815195844","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9136291,33.2595231],[-96.913627,33.2595017],[-96.9136217,33.2594503],[-96.9136145,33.2593876],[-96.9136067,33.2593326],[-96.9136067,33.2593326],[-96.9140389,33.2592975],[-96.9140389,33.2592975],[-96.9140335,33.2595008],[-96.9140335,33.2595008],[-96.9136291,33.2595231],[-96.9136291,33.2595231]]]},"properties":{"lotName":"11-C-2","lotCpId":"1162041672815196580","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9136372,33.2597145],[-96.9136367,33.2596917],[-96.913635,33.2596377],[-96.9136325,33.2595743],[-96.9136291,33.2595231],[-96.9136291,33.2595231],[-96.9140335,33.2595008],[-96.9140335,33.2595008],[-96.9140269,33.2597154],[-96.9140269,33.2597154],[-96.9136372,33.2597145],[-96.9136372,33.2597145]]]},"properties":{"lotName":"11-C-3","lotCpId":"4801351672815197326","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9136312,33.2599059],[-96.9136324,33.259886],[-96.9136348,33.2598369],[-96.9136372,33.2597145],[-96.9136372,33.2597145],[-96.9140269,33.2597154],[-96.9140269,33.2597154],[-96.9140117,33.2599241],[-96.9140117,33.2599241],[-96.9136312,33.2599059],[-96.9136312,33.2599059]]]},"properties":{"lotName":"11-C-4","lotCpId":"1442681672815198067","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9136111,33.2600964],[-96.9136137,33.2600771],[-96.9136197,33.2600291],[-96.9136312,33.2599059],[-96.9136312,33.2599059],[-96.9140117,33.2599241],[-96.9140117,33.2599241],[-96.9139958,33.2601351],[-96.9139958,33.2601351],[-96.9136111,33.2600964],[-96.9136111,33.2600964]]]},"properties":{"lotName":"11-C-5","lotCpId":"8870581672815198804","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9135767,33.2602855],[-96.9135808,33.2602659],[-96.9135905,33.2602174],[-96.9136111,33.2600964],[-96.9136111,33.2600964],[-96.9139958,33.2601351],[-96.9139958,33.2601351],[-96.9139702,33.2603461],[-96.9139702,33.2603461],[-96.9135767,33.2602855],[-96.9135767,33.2602855]]]},"properties":{"lotName":"11-C-6","lotCpId":"7788471672815199538","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9135348,33.2604737],[-96.9135767,33.2602855],[-96.9135767,33.2602855],[-96.9139702,33.2603461],[-96.9139702,33.2603461],[-96.913943,33.2605653],[-96.913943,33.2605653],[-96.9135609,33.2605056],[-96.9135348,33.2604737],[-96.9135348,33.2604737]]]},"properties":{"lotName":"11-C-7","lotCpId":"7172251672815200285","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9143735,33.2603712],[-96.9143643,33.2605744],[-96.9143643,33.2605744],[-96.9143305,33.2606009],[-96.9141811,33.2605959],[-96.914172,33.2605955],[-96.9141478,33.2605942],[-96.9140743,33.2605863],[-96.913943,33.2605653],[-96.913943,33.2605653],[-96.9139686,33.260358],[-96.9139686,33.260358],[-96.9143735,33.2603712],[-96.9143735,33.2603712]]]},"properties":{"lotName":"11-C-8","lotCpId":"6537441672815201022","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9143833,33.2601629],[-96.9143735,33.2603712],[-96.9143735,33.2603712],[-96.9139691,33.260358],[-96.9139691,33.260358],[-96.9139942,33.2601502],[-96.9139942,33.2601502],[-96.9143833,33.2601629],[-96.9143833,33.2601629]]]},"properties":{"lotName":"11-C-9","lotCpId":"4830681672815201765","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9143964,33.2599592],[-96.9143948,33.2599812],[-96.9143911,33.2600349],[-96.9143833,33.2601629],[-96.9143833,33.2601629],[-96.9139942,33.2601502],[-96.9139942,33.2601502],[-96.9140106,33.2599369],[-96.9140106,33.2599369],[-96.9143964,33.2599592],[-96.9143964,33.2599592]]]},"properties":{"lotName":"11-C-10","lotCpId":"6514601672815202498","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9144177,33.2597532],[-96.9144169,33.2597601],[-96.9144148,33.2597786],[-96.9144083,33.259838],[-96.9144011,33.2599066],[-96.9143964,33.2599592],[-96.9143964,33.2599592],[-96.9140106,33.2599369],[-96.9140106,33.2599369],[-96.9140269,33.2597154],[-96.9140269,33.2597154],[-96.9144177,33.2597532],[-96.9144177,33.2597532]]]},"properties":{"lotName":"11-C-11","lotCpId":"3887731672815203251","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9144444,33.2595463],[-96.9144411,33.2595704],[-96.9144335,33.2596277],[-96.9144247,33.2596961],[-96.9144177,33.2597532],[-96.9144177,33.2597532],[-96.9140269,33.2597154],[-96.9140269,33.2597154],[-96.9140335,33.259503],[-96.9140335,33.259503],[-96.9144444,33.2595463],[-96.9144444,33.2595463]]]},"properties":{"lotName":"11-C-12","lotCpId":"7255871672815203979","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9144716,33.2593376],[-96.9144444,33.2595463],[-96.9144444,33.2595463],[-96.9140335,33.259503],[-96.9140335,33.259503],[-96.9140389,33.2592975],[-96.9140389,33.2592975],[-96.9144716,33.2593376],[-96.9144716,33.2593376]]]},"properties":{"lotName":"11-C-13","lotCpId":"5167631672815204738","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9140678,33.2590801],[-96.9144678,33.259117],[-96.9144678,33.259117],[-96.9144967,33.2591471],[-96.9144936,33.2591704],[-96.9144864,33.2592251],[-96.9144781,33.2592884],[-96.9144716,33.2593376],[-96.9144716,33.2593376],[-96.9140389,33.2592975],[-96.9140389,33.2592975],[-96.9140678,33.2590801],[-96.9140678,33.2590801]]]},"properties":{"lotName":"11-C-14","lotCpId":"7543871672815205466","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9135408,33.2580825],[-96.9135086,33.2580798],[-96.9134909,33.2580784],[-96.9134461,33.2580758],[-96.9133261,33.2580785],[-96.9133261,33.2580785],[-96.9132895,33.2577489],[-96.9132895,33.2577489],[-96.9135844,33.2577539],[-96.9135844,33.2577539],[-96.9135408,33.2580825],[-96.9135408,33.2580825]]]},"properties":{"lotName":"11-A-1","lotCpId":"3856071672815181130","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9137686,33.2581035],[-96.9135408,33.2580825],[-96.9135408,33.2580825],[-96.9135844,33.2577539],[-96.9135844,33.2577539],[-96.9138116,33.2577749],[-96.9138116,33.2577749],[-96.9137686,33.2581035],[-96.9137686,33.2581035]]]},"properties":{"lotName":"11-A-2","lotCpId":"5301481672815181853","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9139958,33.2581245],[-96.9137686,33.2581035],[-96.9137686,33.2581035],[-96.9138116,33.2577749],[-96.9138116,33.2577749],[-96.9140394,33.2577959],[-96.9140394,33.2577959],[-96.9139958,33.2581245],[-96.9139958,33.2581245]]]},"properties":{"lotName":"11-A-3","lotCpId":"1884021672815182582","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9142237,33.2581454],[-96.9139958,33.2581245],[-96.9139958,33.2581245],[-96.9140394,33.2577959],[-96.9140394,33.2577959],[-96.9142667,33.2578164],[-96.9142667,33.2578164],[-96.9142237,33.2581454],[-96.9142237,33.2581454]]]},"properties":{"lotName":"11-A-4","lotCpId":"6410571672815183307","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9144509,33.2581664],[-96.9142237,33.2581454],[-96.9142237,33.2581454],[-96.9142667,33.2578164],[-96.9142667,33.2578164],[-96.9144945,33.2578373],[-96.9144945,33.2578373],[-96.9144509,33.2581664],[-96.9144509,33.2581664]]]},"properties":{"lotName":"11-A-5","lotCpId":"6331601672815184039","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9146787,33.2581873],[-96.9144509,33.2581664],[-96.9144509,33.2581664],[-96.9144945,33.2578373],[-96.9144945,33.2578373],[-96.9147218,33.2578583],[-96.9147218,33.2578583],[-96.9146787,33.2581873],[-96.9146787,33.2581873]]]},"properties":{"lotName":"11-A-6","lotCpId":"5766721672815184766","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.914906,33.2582083],[-96.9146787,33.2581873],[-96.9146787,33.2581873],[-96.9147218,33.2578583],[-96.9147218,33.2578583],[-96.9149496,33.2578793],[-96.9149496,33.2578793],[-96.914906,33.2582083],[-96.914906,33.2582083]]]},"properties":{"lotName":"11-A-7","lotCpId":"7448641672815185505","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9151338,33.2582293],[-96.914906,33.2582083],[-96.914906,33.2582083],[-96.9149496,33.2578793],[-96.9149496,33.2578793],[-96.9151769,33.2579002],[-96.9151769,33.2579002],[-96.9151338,33.2582293],[-96.9151338,33.2582293]]]},"properties":{"lotName":"11-A-8","lotCpId":"3148701672815186241","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9148826,33.2590177],[-96.9146553,33.2589967],[-96.9146553,33.2589967],[-96.9146989,33.2586636],[-96.9146989,33.2586636],[-96.9149589,33.2586877],[-96.9149589,33.2586877],[-96.9149185,33.2589935],[-96.9148826,33.2590177],[-96.9148826,33.2590177]]]},"properties":{"lotName":"11-B-1","lotCpId":"1468241672815186977","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9146553,33.2589967],[-96.9144275,33.2589758],[-96.9144275,33.2589758],[-96.9144716,33.2586426],[-96.9144716,33.2586426],[-96.9146989,33.2586636],[-96.9146989,33.2586636],[-96.9146553,33.2589967],[-96.9146553,33.2589967]]]},"properties":{"lotName":"11-B-2","lotCpId":"7682801672815187702","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9144275,33.2589758],[-96.9142002,33.2589548],[-96.9142002,33.2589548],[-96.9142438,33.2586221],[-96.9142438,33.2586221],[-96.9144716,33.2586426],[-96.9144716,33.2586426],[-96.9144275,33.2589758],[-96.9144275,33.2589758]]]},"properties":{"lotName":"11-B-3","lotCpId":"6077051672815188438","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9142002,33.2589548],[-96.9139724,33.2589338],[-96.9139724,33.2589338],[-96.9140166,33.2586011],[-96.9140166,33.2586011],[-96.9142438,33.2586221],[-96.9142438,33.2586221],[-96.9142002,33.2589548],[-96.9142002,33.2589548]]]},"properties":{"lotName":"11-B-4","lotCpId":"3237721672815189191","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9139724,33.2589338],[-96.9137446,33.2589128],[-96.9137446,33.2589128],[-96.9137887,33.2585802],[-96.9137887,33.2585802],[-96.9140166,33.2586011],[-96.9140166,33.2586011],[-96.9139724,33.2589338],[-96.9139724,33.2589338]]]},"properties":{"lotName":"11-B-5","lotCpId":"8246721672815189939","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9137446,33.2589128],[-96.9137374,33.258912],[-96.9137153,33.2589103],[-96.9136778,33.2589088],[-96.9136242,33.2589085],[-96.9135994,33.2589092],[-96.9135397,33.2589136],[-96.9135397,33.2589136],[-96.9134994,33.258891],[-96.9133914,33.2585433],[-96.9133914,33.2585433],[-96.9137887,33.2585802],[-96.9137887,33.2585802],[-96.9137446,33.2589128],[-96.9137446,33.2589128]]]},"properties":{"lotName":"11-B-6","lotCpId":"6870331672815190686","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9133232,33.2582162],[-96.9133303,33.258215],[-96.9133561,33.2582129],[-96.9134073,33.2582123],[-96.9134906,33.2582156],[-96.9136956,33.2582343],[-96.9136956,33.2582343],[-96.913652,33.2585674],[-96.913652,33.2585674],[-96.9133914,33.2585433],[-96.9133914,33.2585433],[-96.9132993,33.2582466],[-96.9133232,33.2582162],[-96.9133232,33.2582162]]]},"properties":{"lotName":"11-B-7","lotCpId":"8616341672815191403","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9136956,33.2582343],[-96.9139561,33.2582584],[-96.9139561,33.2582584],[-96.9139119,33.2585916],[-96.9139119,33.2585916],[-96.913652,33.2585674],[-96.913652,33.2585674],[-96.9136956,33.2582343],[-96.9136956,33.2582343]]]},"properties":{"lotName":"11-B-8","lotCpId":"2706401672815192146","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9139561,33.2582584],[-96.914216,33.2582821],[-96.914216,33.2582821],[-96.9141719,33.2586153],[-96.9141719,33.2586153],[-96.9139119,33.2585916],[-96.9139119,33.2585916],[-96.9139561,33.2582584],[-96.9139561,33.2582584]]]},"properties":{"lotName":"11-B-9","lotCpId":"8362471672815192898","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.914216,33.2582821],[-96.914476,33.2583063],[-96.914476,33.2583063],[-96.9144318,33.2586394],[-96.9144318,33.2586394],[-96.9141719,33.2586153],[-96.9141719,33.2586153],[-96.914216,33.2582821],[-96.914216,33.2582821]]]},"properties":{"lotName":"11-B-10","lotCpId":"3630801672815193642","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.914476,33.2583063],[-96.9147314,33.2583296],[-96.9147314,33.2583296],[-96.914736,33.25833],[-96.9146924,33.2586631],[-96.9146924,33.2586631],[-96.9144318,33.2586394],[-96.9144318,33.2586394],[-96.914476,33.2583063],[-96.914476,33.2583063]]]},"properties":{"lotName":"11-B-11","lotCpId":"3445441672815194383","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.914736,33.25833],[-96.9149703,33.2583519],[-96.9149703,33.2583519],[-96.9149992,33.2583819],[-96.9149589,33.2586877],[-96.9149589,33.2586877],[-96.9146924,33.2586631],[-96.9146924,33.2586631],[-96.914736,33.25833],[-96.914736,33.25833]]]},"properties":{"lotName":"11-B-12","lotCpId":"4130631672815195100","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9146346,33.2593526],[-96.9146591,33.2591621],[-96.9146591,33.2591621],[-96.9146956,33.259138],[-96.9150597,33.2591717],[-96.9150597,33.2591717],[-96.9150286,33.2593886],[-96.9150286,33.2593886],[-96.9146346,33.2593526],[-96.9146346,33.2593526]]]},"properties":{"lotName":"11-E-1","lotCpId":"8281601672815213617","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9146084,33.2595472],[-96.9146346,33.2593526],[-96.9146346,33.2593526],[-96.9150286,33.2593886],[-96.9150286,33.2593886],[-96.9150008,33.2595837],[-96.9150008,33.2595837],[-96.9146084,33.2595472],[-96.9146084,33.2595472]]]},"properties":{"lotName":"11-E-2","lotCpId":"4252641672815214342","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9145828,33.2597441],[-96.9145888,33.2596981],[-96.9145902,33.2596868],[-96.9145942,33.2596554],[-96.9146004,33.2596077],[-96.9146084,33.2595472],[-96.9146084,33.2595472],[-96.9150008,33.2595837],[-96.9150008,33.2595837],[-96.9149736,33.2597778],[-96.9149736,33.2597778],[-96.9145828,33.2597441],[-96.9145828,33.2597441]]]},"properties":{"lotName":"11-E-3","lotCpId":"1250801672815215082","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9145616,33.2599474],[-96.9145828,33.2597441],[-96.9145828,33.2597441],[-96.9149736,33.2597778],[-96.9149736,33.2597778],[-96.9149529,33.2599711],[-96.9149529,33.2599711],[-96.9145616,33.2599474],[-96.9145616,33.2599474]]]},"properties":{"lotName":"11-E-4","lotCpId":"3716811672815215821","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9145474,33.2601524],[-96.9145483,33.2601328],[-96.9145511,33.260083],[-96.9145616,33.2599474],[-96.9145616,33.2599474],[-96.9149529,33.2599711],[-96.9149529,33.2599711],[-96.9149431,33.2601666],[-96.9149431,33.2601666],[-96.9145474,33.2601524],[-96.9145474,33.2601524]]]},"properties":{"lotName":"11-E-5","lotCpId":"1568211672815216563","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9145381,33.2603475],[-96.9145474,33.2601524],[-96.9145474,33.2601524],[-96.9149431,33.2601666],[-96.9149431,33.2601666],[-96.9149327,33.2603602],[-96.9149327,33.2603602],[-96.9145381,33.2603475],[-96.9145381,33.2603475]]]},"properties":{"lotName":"11-E-6","lotCpId":"6040111672815217302","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9145278,33.2605817],[-96.9145365,33.2603885],[-96.9145365,33.2603885],[-96.9149305,33.2604013],[-96.9149305,33.2604013],[-96.9149207,33.2605945],[-96.9149207,33.2605945],[-96.9145278,33.2605817],[-96.9145278,33.2605817]]]},"properties":{"lotName":"11-E-7","lotCpId":"7424581672815218035","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9145174,33.2607718],[-96.9145234,33.2606756],[-96.9145278,33.2605817],[-96.9145278,33.2605817],[-96.9149207,33.2605945],[-96.9149207,33.2605945],[-96.9149104,33.2607918],[-96.9149104,33.2607918],[-96.9145174,33.2607718],[-96.9145174,33.2607718]]]},"properties":{"lotName":"11-E-8","lotCpId":"3087841672815218767","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9144978,33.2609622],[-96.9145003,33.2609413],[-96.9145061,33.2608905],[-96.9145174,33.2607718],[-96.9145174,33.2607718],[-96.9149104,33.2607918],[-96.9149104,33.2607918],[-96.9148902,33.2609978],[-96.9148902,33.2609978],[-96.9144978,33.2609622],[-96.9144978,33.2609622]]]},"properties":{"lotName":"11-E-9","lotCpId":"4882871672815219504","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9144684,33.2611523],[-96.9144695,33.2611452],[-96.9144725,33.2611262],[-96.9144819,33.2610669],[-96.9144918,33.2610028],[-96.9144978,33.2609622],[-96.9144978,33.2609622],[-96.9148902,33.2609978],[-96.9148902,33.2609978],[-96.9148697,33.2612023],[-96.9148697,33.2612023],[-96.9148695,33.2612042],[-96.9144684,33.2611523],[-96.9144684,33.2611523]]]},"properties":{"lotName":"11-E-10","lotCpId":"4344421672815220249","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.914428,33.2613405],[-96.9144323,33.2613232],[-96.9144428,33.2612786],[-96.9144684,33.2611523],[-96.9144684,33.2611523],[-96.9148695,33.2612042],[-96.9148695,33.2612042],[-96.9148499,33.2614043],[-96.9148499,33.2614043],[-96.914428,33.2613405],[-96.914428,33.2613405]]]},"properties":{"lotName":"11-E-11","lotCpId":"1405631672815220978","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9144204,33.2615036],[-96.9144303,33.2614917],[-96.9144474,33.2614586],[-96.9144526,33.2614085],[-96.9144269,33.2613455],[-96.914428,33.2613405],[-96.914428,33.2613405],[-96.9148499,33.2614043],[-96.9148499,33.2614043],[-96.9148052,33.2617488],[-96.9148052,33.2617488],[-96.9144204,33.2615036],[-96.9144204,33.2615036]]]},"properties":{"lotName":"11-E-12","lotCpId":"2165201672815221720","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9142885,33.2615574],[-96.9143006,33.2615576],[-96.9143318,33.2615533],[-96.9143744,33.2615377],[-96.9144204,33.2615036],[-96.9144204,33.2615036],[-96.9148052,33.2617488],[-96.9148052,33.2617488],[-96.9147757,33.261978],[-96.9142722,33.2618992],[-96.9142722,33.2618992],[-96.9142885,33.2615574],[-96.9142885,33.2615574]]]},"properties":{"lotName":"11-E-13","lotCpId":"6127641672815222462","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9140634,33.2615214],[-96.9141381,33.2615251],[-96.9141871,33.2615269],[-96.9141951,33.2615318],[-96.9142169,33.2615425],[-96.9142885,33.2615574],[-96.9142885,33.2615574],[-96.9142722,33.2618992],[-96.9142722,33.2618992],[-96.9140313,33.2618618],[-96.9140313,33.2618618],[-96.9140634,33.2615214],[-96.9140634,33.2615214]]]},"properties":{"lotName":"11-E-14","lotCpId":"2362271672815223200","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9138432,33.2614959],[-96.91387,33.2615],[-96.9138879,33.2615028],[-96.9139339,33.2615092],[-96.9140634,33.2615214],[-96.9140634,33.2615214],[-96.9140313,33.2618618],[-96.9140313,33.2618618],[-96.9137708,33.2618208],[-96.9137708,33.2618208],[-96.9138432,33.2614959],[-96.9138432,33.2614959]]]},"properties":{"lotName":"11-E-15","lotCpId":"8057301672815223944","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9136182,33.2614608],[-96.9138432,33.2614959],[-96.9138432,33.2614959],[-96.9137708,33.2618208],[-96.9137708,33.2618208],[-96.9135135,33.2617807],[-96.9135135,33.2617807],[-96.91358,33.2614822],[-96.9136182,33.2614608],[-96.9136182,33.2614608]]]},"properties":{"lotName":"11-E-16","lotCpId":"8257151672815224679","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9136656,33.2621412],[-96.9134732,33.2621111],[-96.9134732,33.2621111],[-96.913447,33.2620792],[-96.9135135,33.2617807],[-96.9135135,33.2617807],[-96.9137386,33.2618158],[-96.9137386,33.2618158],[-96.9136656,33.2621412],[-96.9136656,33.2621412]]]},"properties":{"lotName":"11-E-17","lotCpId":"3201411672815225422","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9138585,33.2621713],[-96.9136656,33.2621412],[-96.9136656,33.2621412],[-96.9137386,33.2618158],[-96.9137386,33.2618158],[-96.9139315,33.2618463],[-96.9139315,33.2618463],[-96.9138585,33.2621713],[-96.9138585,33.2621713]]]},"properties":{"lotName":"11-E-18","lotCpId":"4156221672815226166","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9078623,33.269091],[-96.9078858,33.2690504],[-96.9079444,33.2689464],[-96.9079444,33.2689464],[-96.9083293,33.2690982],[-96.9083293,33.2690982],[-96.9081877,33.2693495],[-96.9081877,33.2693495],[-96.9080523,33.2692398],[-96.908038,33.2692284],[-96.9079995,33.2692003],[-96.9078765,33.2691289],[-96.9078623,33.269091],[-96.9078623,33.269091]]]},"properties":{"lotName":"12-A-1","lotCpId":"6074731686915230346","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9079444,33.2689464],[-96.9080279,33.2687981],[-96.9080279,33.2687981],[-96.908413,33.2689495],[-96.908413,33.2689495],[-96.9083293,33.2690982],[-96.9083293,33.2690982],[-96.9079444,33.2689464],[-96.9079444,33.2689464]]]},"properties":{"lotName":"12-A-2","lotCpId":"7388001686915230714","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9080279,33.2687981],[-96.9080624,33.2687368],[-96.9080722,33.2687322],[-96.9080952,33.2687174],[-96.9081222,33.2686909],[-96.908144,33.2686511],[-96.908144,33.2686511],[-96.908502,33.2687921],[-96.908502,33.2687921],[-96.908413,33.2689495],[-96.908413,33.2689495],[-96.9080279,33.2687981],[-96.9080279,33.2687981]]]},"properties":{"lotName":"12-A-3","lotCpId":"8451631686915231050","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.908144,33.2686511],[-96.9081466,33.2686421],[-96.9081495,33.2686183],[-96.9081451,33.2685843],[-96.9081259,33.2685448],[-96.9081259,33.2685448],[-96.9085249,33.2683436],[-96.9085249,33.2683436],[-96.9087126,33.2684175],[-96.908502,33.2687921],[-96.908502,33.2687921],[-96.908144,33.2686511],[-96.908144,33.2686511]]]},"properties":{"lotName":"12-A-4","lotCpId":"3283501686915231428","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9081259,33.2685448],[-96.9081181,33.2685351],[-96.9080941,33.2685133],[-96.9080535,33.2684909],[-96.9079956,33.2684789],[-96.9079956,33.2684789],[-96.9081538,33.2681975],[-96.9081538,33.2681975],[-96.9085249,33.2683436],[-96.9085249,33.2683436],[-96.9081259,33.2685448],[-96.9081259,33.2685448]]]},"properties":{"lotName":"12-A-5","lotCpId":"5184251686915231756","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9079956,33.2684789],[-96.907984,33.2684786],[-96.9079529,33.2684814],[-96.9078028,33.2684225],[-96.9078028,33.2684225],[-96.9079699,33.268125],[-96.9079699,33.268125],[-96.9081538,33.2681975],[-96.9081538,33.2681975],[-96.9079956,33.2684789],[-96.9079956,33.2684789]]]},"properties":{"lotName":"12-A-6","lotCpId":"3808671686915232068","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9078028,33.2684225],[-96.9076249,33.2683527],[-96.9076249,33.2683527],[-96.9077923,33.2680551],[-96.9077923,33.2680551],[-96.9079699,33.268125],[-96.9079699,33.268125],[-96.9078028,33.2684225],[-96.9078028,33.2684225]]]},"properties":{"lotName":"12-A-7","lotCpId":"3652541686915232385","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072833,33.2681879],[-96.9073881,33.2680022],[-96.9073881,33.2680022],[-96.9077435,33.2681419],[-96.9077435,33.2681419],[-96.9076249,33.2683527],[-96.9076249,33.2683527],[-96.9072991,33.2682245],[-96.9072833,33.2681879],[-96.9072833,33.2681879]]]},"properties":{"lotName":"12-A-8","lotCpId":"6142641686915232704","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073881,33.2680022],[-96.9074858,33.2678288],[-96.9074858,33.2678288],[-96.9078411,33.2679685],[-96.9078411,33.2679685],[-96.9077435,33.2681419],[-96.9077435,33.2681419],[-96.9073881,33.2680022],[-96.9073881,33.2680022]]]},"properties":{"lotName":"12-A-9","lotCpId":"8315521686915233033","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074279,33.2676093],[-96.9073444,33.2677581],[-96.9073444,33.2677581],[-96.9069886,33.267618],[-96.9069886,33.267618],[-96.9070726,33.2674692],[-96.9070726,33.2674692],[-96.9074279,33.2676093],[-96.9074279,33.2676093]]]},"properties":{"lotName":"12-B-1","lotCpId":"5387151686915233344","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073444,33.2677581],[-96.9072609,33.2679064],[-96.9072609,33.2679064],[-96.9069051,33.2677668],[-96.9069051,33.2677668],[-96.9069886,33.267618],[-96.9069886,33.267618],[-96.9073444,33.2677581],[-96.9073444,33.2677581]]]},"properties":{"lotName":"12-B-2","lotCpId":"8617761686915233663","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072609,33.2679064],[-96.9071769,33.2680552],[-96.9071769,33.2680552],[-96.9068216,33.2679155],[-96.9068216,33.2679155],[-96.9069051,33.2677668],[-96.9069051,33.2677668],[-96.9072609,33.2679064],[-96.9072609,33.2679064]]]},"properties":{"lotName":"12-B-3","lotCpId":"2047471686915233992","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9071769,33.2680552],[-96.9070934,33.2682039],[-96.9070934,33.2682039],[-96.9067375,33.2680638],[-96.9067375,33.2680638],[-96.9068216,33.2679155],[-96.9068216,33.2679155],[-96.9071769,33.2680552],[-96.9071769,33.2680552]]]},"properties":{"lotName":"12-B-4","lotCpId":"2433611686915234327","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070934,33.2682039],[-96.9070241,33.2683261],[-96.9070184,33.2683365],[-96.9070104,33.2683527],[-96.9070104,33.2683527],[-96.906654,33.2682126],[-96.906654,33.2682126],[-96.9067375,33.2680638],[-96.9067375,33.2680638],[-96.9070934,33.2682039],[-96.9070934,33.2682039]]]},"properties":{"lotName":"12-B-5","lotCpId":"4125721686915234661","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070104,33.2683527],[-96.9070006,33.2683719],[-96.9069804,33.2684202],[-96.9069771,33.2684284],[-96.9069686,33.2684498],[-96.9069422,33.2685138],[-96.9069422,33.2685138],[-96.906553,33.2683919],[-96.906553,33.2683919],[-96.906654,33.2682126],[-96.906654,33.2682126],[-96.9070104,33.2683527],[-96.9070104,33.2683527]]]},"properties":{"lotName":"12-B-6","lotCpId":"1701551686915234984","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069422,33.2685138],[-96.9069338,33.2685316],[-96.9069121,33.2685759],[-96.9068505,33.2686894],[-96.9068505,33.2686894],[-96.9064723,33.2685316],[-96.9064723,33.2685316],[-96.9065045,33.2684782],[-96.906553,33.2683919],[-96.906553,33.2683919],[-96.9069422,33.2685138],[-96.9069422,33.2685138]]]},"properties":{"lotName":"12-B-7","lotCpId":"2533151686915235305","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9068505,33.2686894],[-96.9068411,33.2687048],[-96.9068162,33.2687443],[-96.9067381,33.268856],[-96.9067381,33.268856],[-96.9063828,33.2686675],[-96.9063828,33.2686675],[-96.9064324,33.2685982],[-96.9064723,33.2685316],[-96.9064723,33.2685316],[-96.9068505,33.2686894],[-96.9068505,33.2686894]]]},"properties":{"lotName":"12-B-8","lotCpId":"2027751686915235623","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067381,33.268856],[-96.9067264,33.268871],[-96.9066958,33.268909],[-96.9066054,33.2690121],[-96.9066054,33.2690121],[-96.9062747,33.2687935],[-96.9062747,33.2687935],[-96.9063522,33.26871],[-96.9063828,33.2686675],[-96.9063828,33.2686675],[-96.9067381,33.268856],[-96.9067381,33.268856]]]},"properties":{"lotName":"12-B-9","lotCpId":"1048641686915235944","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9066054,33.2690121],[-96.9065957,33.2690223],[-96.9065688,33.2690496],[-96.9065279,33.2690892],[-96.9064766,33.2691362],[-96.9064766,33.2691362],[-96.906177,33.2688984],[-96.906177,33.2688984],[-96.9062747,33.2687935],[-96.9062747,33.2687935],[-96.9066054,33.2690121],[-96.9066054,33.2690121]]]},"properties":{"lotName":"12-B-10","lotCpId":"7631201686915236261","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9064766,33.2691362],[-96.9064643,33.2691469],[-96.906432,33.2691743],[-96.9063358,33.2692503],[-96.9063358,33.2692503],[-96.9060602,33.2689897],[-96.9060602,33.2689897],[-96.9061617,33.2689149],[-96.906177,33.2688984],[-96.906177,33.2688984],[-96.9064766,33.2691362],[-96.9064766,33.2691362]]]},"properties":{"lotName":"12-B-11","lotCpId":"7540701686915236584","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9063358,33.2692503],[-96.9063203,33.2692614],[-96.9062817,33.2692886],[-96.906183,33.2693534],[-96.906183,33.2693534],[-96.9059401,33.2690778],[-96.9059401,33.2690778],[-96.9060602,33.2689897],[-96.9060602,33.2689897],[-96.9063358,33.2692503],[-96.9063358,33.2692503]]]},"properties":{"lotName":"12-B-12","lotCpId":"3112531686915236905","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906183,33.2693534],[-96.9061703,33.2693611],[-96.9061355,33.2693816],[-96.9060836,33.2694108],[-96.9060198,33.2694447],[-96.9060198,33.2694447],[-96.9058044,33.2691477],[-96.9058044,33.2691477],[-96.9059287,33.2690864],[-96.9059401,33.2690778],[-96.9059401,33.2690778],[-96.906183,33.2693534],[-96.906183,33.2693534]]]},"properties":{"lotName":"12-B-13","lotCpId":"8882251686915237229","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9060198,33.2694447],[-96.9060033,33.2694529],[-96.9059614,33.2694732],[-96.9058474,33.2695236],[-96.9058474,33.2695236],[-96.9056663,33.2692158],[-96.9056663,33.2692158],[-96.9058044,33.2691477],[-96.9058044,33.2691477],[-96.9060198,33.2694447],[-96.9060198,33.2694447]]]},"properties":{"lotName":"12-B-14","lotCpId":"7485541686915237546","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058474,33.2695236],[-96.9058317,33.2695301],[-96.9057907,33.2695463],[-96.9056678,33.2695893],[-96.9056678,33.2695893],[-96.9055166,33.2692617],[-96.9055166,33.2692617],[-96.9056613,33.2692183],[-96.9056663,33.2692158],[-96.9056663,33.2692158],[-96.9058474,33.2695236],[-96.9058474,33.2695236]]]},"properties":{"lotName":"12-B-15","lotCpId":"7464821686915237889","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056678,33.2695893],[-96.9056486,33.2695953],[-96.9056011,33.2696098],[-96.9054814,33.2696419],[-96.9054814,33.2696419],[-96.9053665,33.2693059],[-96.9053665,33.2693059],[-96.9053693,33.2693055],[-96.9055166,33.2692617],[-96.9055166,33.2692617],[-96.9056678,33.2695893],[-96.9056678,33.2695893]]]},"properties":{"lotName":"12-B-16","lotCpId":"3425621686915238231","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054814,33.2696419],[-96.9054672,33.2696453],[-96.9054277,33.2696541],[-96.9053674,33.2696662],[-96.9052907,33.2696797],[-96.9052907,33.2696797],[-96.9052087,33.2693247],[-96.9052087,33.2693247],[-96.9053665,33.2693059],[-96.9053665,33.2693059],[-96.9054814,33.2696419],[-96.9054814,33.2696419]]]},"properties":{"lotName":"12-B-17","lotCpId":"6606721686915238554","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052907,33.2696797],[-96.9052746,33.2696823],[-96.9052316,33.2696887],[-96.9050964,33.2697039],[-96.9050964,33.2697039],[-96.9050522,33.2693435],[-96.9050522,33.2693435],[-96.9052087,33.2693247],[-96.9052087,33.2693247],[-96.9052907,33.2696797],[-96.9052907,33.2696797]]]},"properties":{"lotName":"12-B-18","lotCpId":"5521321686915238897","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9050964,33.2697039],[-96.9050795,33.2697053],[-96.905035,33.2697083],[-96.9048999,33.2697133],[-96.9048999,33.2697133],[-96.904895,33.2693624],[-96.904895,33.2693624],[-96.9050522,33.2693435],[-96.9050522,33.2693435],[-96.9050964,33.2697039],[-96.9050964,33.2697039]]]},"properties":{"lotName":"12-B-19","lotCpId":"5047151686915239224","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048999,33.2697133],[-96.9048377,33.269713],[-96.9047197,33.2697114],[-96.9047197,33.2697114],[-96.9047264,33.2693826],[-96.9047264,33.2693826],[-96.904895,33.2693624],[-96.904895,33.2693624],[-96.9048999,33.2697133],[-96.9048999,33.2697133]]]},"properties":{"lotName":"12-B-20","lotCpId":"1574601686915239546","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9079284,33.2686534],[-96.9078411,33.2688081],[-96.9078411,33.2688081],[-96.9074765,33.2686643],[-96.9074765,33.2686643],[-96.9075709,33.2684827],[-96.9075709,33.2684827],[-96.9079125,33.2686169],[-96.9079284,33.2686534],[-96.9079284,33.2686534]]]},"properties":{"lotName":"12-C-1","lotCpId":"4168441686915239871","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9078411,33.2688081],[-96.9077576,33.2689568],[-96.9077576,33.2689568],[-96.9073984,33.2688154],[-96.9073984,33.2688154],[-96.9074765,33.2686643],[-96.9074765,33.2686643],[-96.9078411,33.2688081],[-96.9078411,33.2688081]]]},"properties":{"lotName":"12-C-2","lotCpId":"5186311686915240193","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9077576,33.2689568],[-96.9077374,33.2689924],[-96.9077317,33.2690025],[-96.9077158,33.2690299],[-96.9076604,33.2691202],[-96.9076604,33.2691202],[-96.9073117,33.2689605],[-96.9073117,33.2689605],[-96.9073968,33.2688186],[-96.9073984,33.2688154],[-96.9073984,33.2688154],[-96.9077576,33.2689568],[-96.9077576,33.2689568]]]},"properties":{"lotName":"12-C-3","lotCpId":"8053401686915240524","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076604,33.2691202],[-96.9076496,33.2691369],[-96.9076225,33.2691777],[-96.9075518,33.2692758],[-96.9075518,33.2692758],[-96.9072145,33.2690983],[-96.9072145,33.2690983],[-96.9072969,33.2689851],[-96.9073117,33.2689605],[-96.9073117,33.2689605],[-96.9076604,33.2691202],[-96.9076604,33.2691202]]]},"properties":{"lotName":"12-C-4","lotCpId":"3856531686915240845","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9075518,33.2692758],[-96.9075421,33.2692885],[-96.9075175,33.2693203],[-96.9074492,33.2694036],[-96.9074492,33.2694036],[-96.9071239,33.2692092],[-96.9071239,33.2692092],[-96.9071812,33.2691449],[-96.9072145,33.2690983],[-96.9072145,33.2690983],[-96.9075518,33.2692758],[-96.9075518,33.2692758]]]},"properties":{"lotName":"12-C-5","lotCpId":"4378631686915241163","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074492,33.2694036],[-96.9074398,33.2694147],[-96.9074148,33.2694435],[-96.9073384,33.2695259],[-96.9073384,33.2695259],[-96.907029,33.2693178],[-96.907029,33.2693178],[-96.9071239,33.2692092],[-96.9071239,33.2692092],[-96.9074492,33.2694036],[-96.9074492,33.2694036]]]},"properties":{"lotName":"12-C-6","lotCpId":"5887281686915241517","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9073384,33.2695259],[-96.9073294,33.2695354],[-96.9073043,33.269561],[-96.9072665,33.2695983],[-96.9072189,33.2696431],[-96.9072189,33.2696431],[-96.9069245,33.2694198],[-96.9069245,33.2694198],[-96.906928,33.2694168],[-96.907029,33.2693178],[-96.907029,33.2693178],[-96.9073384,33.2695259],[-96.9073384,33.2695259]]]},"properties":{"lotName":"12-C-7","lotCpId":"1610511686915241869","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072189,33.2696431],[-96.9072049,33.2696557],[-96.9071709,33.2696858],[-96.9070912,33.269754],[-96.9070912,33.269754],[-96.9068128,33.2695167],[-96.9068128,33.2695167],[-96.9069245,33.2694198],[-96.9069245,33.2694198],[-96.9072189,33.2696431],[-96.9072189,33.2696431]]]},"properties":{"lotName":"12-C-8","lotCpId":"5085231686915242184","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9070912,33.269754],[-96.9070765,33.2697658],[-96.9070408,33.2697941],[-96.9069564,33.2698585],[-96.9069564,33.2698585],[-96.9066944,33.269608],[-96.9066944,33.269608],[-96.9067965,33.2695309],[-96.9068128,33.2695167],[-96.9068128,33.2695167],[-96.9070912,33.269754],[-96.9070912,33.269754]]]},"properties":{"lotName":"12-C-9","lotCpId":"1350601686915242511","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069564,33.2698585],[-96.9069466,33.2698658],[-96.9069185,33.2698861],[-96.9068738,33.269917],[-96.9068145,33.2699562],[-96.9068145,33.2699562],[-96.90657,33.2696933],[-96.90657,33.2696933],[-96.9066556,33.2696372],[-96.9066944,33.269608],[-96.9066944,33.269608],[-96.9069564,33.2698585],[-96.9069564,33.2698585]]]},"properties":{"lotName":"12-C-10","lotCpId":"6736081686915242838","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9068145,33.2699562],[-96.9067986,33.2699664],[-96.9067599,33.2699909],[-96.906666,33.270047],[-96.906666,33.270047],[-96.9064406,33.2697727],[-96.9064406,33.2697727],[-96.9065067,33.2697349],[-96.90657,33.2696933],[-96.90657,33.2696933],[-96.9068145,33.2699562],[-96.9068145,33.2699562]]]},"properties":{"lotName":"12-C-11","lotCpId":"5064561686915243195","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906666,33.270047],[-96.9066546,33.2700534],[-96.9066228,33.270071],[-96.906574,33.2700975],[-96.9065116,33.2701305],[-96.9065116,33.2701305],[-96.9063053,33.2698458],[-96.9063053,33.2698458],[-96.90635,33.2698243],[-96.9064406,33.2697727],[-96.9064406,33.2697727],[-96.906666,33.270047],[-96.906666,33.270047]]]},"properties":{"lotName":"12-C-12","lotCpId":"2585701686915243582","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065116,33.2701305],[-96.906496,33.2701382],[-96.9064567,33.2701575],[-96.9063511,33.2702062],[-96.9063511,33.2702062],[-96.9061655,33.2699124],[-96.9061655,33.2699124],[-96.9061857,33.2699042],[-96.9063053,33.2698458],[-96.9063053,33.2698458],[-96.9065116,33.2701305],[-96.9065116,33.2701305]]]},"properties":{"lotName":"12-C-13","lotCpId":"7880481686915243904","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9063511,33.2702062],[-96.9063327,33.2702143],[-96.9062884,33.2702333],[-96.9061863,33.2702738],[-96.9061863,33.2702738],[-96.906022,33.2699726],[-96.906022,33.2699726],[-96.9061655,33.2699124],[-96.9061655,33.2699124],[-96.9063511,33.2702062],[-96.9063511,33.2702062]]]},"properties":{"lotName":"12-C-14","lotCpId":"6137841686915244244","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9061863,33.2702738],[-96.9061726,33.2702791],[-96.9061357,33.2702929],[-96.9060166,33.2703336],[-96.9060166,33.2703336],[-96.905873,33.2700237],[-96.905873,33.2700237],[-96.906016,33.2699744],[-96.906022,33.2699726],[-96.906022,33.2699726],[-96.9061863,33.2702738],[-96.9061863,33.2702738]]]},"properties":{"lotName":"12-C-15","lotCpId":"3210551686915244572","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9060166,33.2703336],[-96.9060001,33.2703389],[-96.9059584,33.270352],[-96.9058435,33.2703851],[-96.9058435,33.2703851],[-96.9057213,33.2700684],[-96.9057213,33.2700684],[-96.9058408,33.2700347],[-96.905873,33.2700237],[-96.905873,33.2700237],[-96.9060166,33.2703336],[-96.9060166,33.2703336]]]},"properties":{"lotName":"12-C-16","lotCpId":"3201771686915244909","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058435,33.2703851],[-96.9058273,33.2703895],[-96.9057854,33.2704003],[-96.9056667,33.270428],[-96.9056667,33.270428],[-96.9055668,33.2701059],[-96.9055668,33.2701059],[-96.9056613,33.2700853],[-96.9057213,33.2700684],[-96.9057213,33.2700684],[-96.9058435,33.2703851],[-96.9058435,33.2703851]]]},"properties":{"lotName":"12-C-17","lotCpId":"3271851686915245235","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056667,33.270428],[-96.9056525,33.270431],[-96.9056149,33.2704388],[-96.9054986,33.2704604],[-96.9054833,33.2704627],[-96.9054833,33.2704627],[-96.9054042,33.2701355],[-96.9054042,33.2701355],[-96.9054773,33.270125],[-96.9055668,33.2701059],[-96.9055668,33.2701059],[-96.9056667,33.270428],[-96.9056667,33.270428]]]},"properties":{"lotName":"12-C-18","lotCpId":"7250511686915245553","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9054833,33.2704627],[-96.9053212,33.2704901],[-96.9053212,33.2704901],[-96.9052416,33.2701592],[-96.9052416,33.2701592],[-96.9054042,33.2701355],[-96.9054042,33.2701355],[-96.9054833,33.2704627],[-96.9054833,33.2704627]]]},"properties":{"lotName":"12-C-19","lotCpId":"4156501686915245871","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9053212,33.2704901],[-96.9051592,33.2705174],[-96.9051592,33.2705174],[-96.9050784,33.270183],[-96.9050784,33.270183],[-96.9052416,33.2701592],[-96.9052416,33.2701592],[-96.9053212,33.2704901],[-96.9053212,33.2704901]]]},"properties":{"lotName":"12-C-20","lotCpId":"2777061686915246201","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9051592,33.2705174],[-96.9049971,33.2705448],[-96.9049971,33.2705448],[-96.9049152,33.2702062],[-96.9049152,33.2702062],[-96.9050784,33.270183],[-96.9050784,33.270183],[-96.9051592,33.2705174],[-96.9051592,33.2705174]]]},"properties":{"lotName":"12-C-21","lotCpId":"5644121686915246526","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049971,33.2705448],[-96.904818,33.2705749],[-96.904818,33.2705749],[-96.9047798,33.2705535],[-96.9047034,33.2702373],[-96.9047034,33.2702373],[-96.9049152,33.2702062],[-96.9049152,33.2702062],[-96.9049971,33.2705448],[-96.9049971,33.2705448]]]},"properties":{"lotName":"12-C-22","lotCpId":"5425801686915246841","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9046685,33.2698476],[-96.9048345,33.2698501],[-96.9049076,33.2698499],[-96.9049076,33.2698499],[-96.9049152,33.2702062],[-96.9049152,33.2702062],[-96.9047034,33.2702373],[-96.9047034,33.2702373],[-96.9046494,33.2700141],[-96.9046465,33.2700021],[-96.9046404,33.2699711],[-96.9046342,33.2698828],[-96.9046685,33.2698476],[-96.9046685,33.2698476]]]},"properties":{"lotName":"12-C-23","lotCpId":"6727361686915247170","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049076,33.2698499],[-96.9049217,33.2698497],[-96.9049588,33.2698489],[-96.9050702,33.269843],[-96.9050702,33.269843],[-96.9051035,33.2701793],[-96.9051035,33.2701793],[-96.9049152,33.2702062],[-96.9049152,33.2702062],[-96.9049076,33.2698499],[-96.9049076,33.2698499]]]},"properties":{"lotName":"12-C-24","lotCpId":"2120601686915247498","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9050702,33.269843],[-96.9050862,33.2698419],[-96.9051262,33.2698388],[-96.9052312,33.269827],[-96.9052312,33.269827],[-96.9052906,33.2701521],[-96.9052906,33.2701521],[-96.9051035,33.2701793],[-96.9051035,33.2701793],[-96.9050702,33.269843],[-96.9050702,33.269843]]]},"properties":{"lotName":"12-C-25","lotCpId":"8445061686915247835","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9052312,33.269827],[-96.9052434,33.2698256],[-96.905277,33.2698212],[-96.9053911,33.2698019],[-96.9053911,33.2698019],[-96.9054773,33.270125],[-96.9054773,33.270125],[-96.9052906,33.2701521],[-96.9052906,33.2701521],[-96.9052312,33.269827],[-96.9052312,33.269827]]]},"properties":{"lotName":"12-C-26","lotCpId":"8760481686915248172","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9053911,33.2698019],[-96.9054065,33.2697991],[-96.9054451,33.2697915],[-96.9055483,33.2697677],[-96.9055483,33.2697677],[-96.9056613,33.2700853],[-96.9056613,33.2700853],[-96.9054773,33.270125],[-96.9054773,33.270125],[-96.9053911,33.2698019],[-96.9053911,33.2698019]]]},"properties":{"lotName":"12-C-27","lotCpId":"4218871686915248483","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9055483,33.2697677],[-96.9055609,33.2697647],[-96.9055948,33.2697561],[-96.9057022,33.2697248],[-96.9057022,33.2697248],[-96.9058408,33.2700347],[-96.9058408,33.2700347],[-96.9056613,33.2700853],[-96.9056613,33.2700853],[-96.9055483,33.2697677],[-96.9055483,33.2697677]]]},"properties":{"lotName":"12-C-28","lotCpId":"6822871686915248803","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057022,33.2697248],[-96.905718,33.2697199],[-96.905757,33.2697073],[-96.9058528,33.2696728],[-96.9058528,33.2696728],[-96.906016,33.2699744],[-96.906016,33.2699744],[-96.9058408,33.2700347],[-96.9058408,33.2700347],[-96.9057022,33.2697248],[-96.9057022,33.2697248]]]},"properties":{"lotName":"12-C-29","lotCpId":"1326021686915249131","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058528,33.2696728],[-96.9058665,33.2696675],[-96.9059015,33.2696537],[-96.905998,33.2696126],[-96.905998,33.2696126],[-96.9061857,33.2699042],[-96.9061857,33.2699042],[-96.906016,33.2699744],[-96.906016,33.2699744],[-96.9058528,33.2696728],[-96.9058528,33.2696728]]]},"properties":{"lotName":"12-C-30","lotCpId":"2584111686915249461","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905998,33.2696126],[-96.9060139,33.2696052],[-96.9060522,33.2695871],[-96.9061388,33.2695441],[-96.9061388,33.2695441],[-96.90635,33.2698243],[-96.90635,33.2698243],[-96.9061857,33.2699042],[-96.9061857,33.2699042],[-96.905998,33.2696126],[-96.905998,33.2696126]]]},"properties":{"lotName":"12-C-31","lotCpId":"4525121686915249806","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9061388,33.2695441],[-96.9061547,33.2695354],[-96.9061924,33.2695145],[-96.9062369,33.2694894],[-96.9062731,33.2694679],[-96.9062731,33.2694679],[-96.9065067,33.2697349],[-96.9065067,33.2697349],[-96.90635,33.2698243],[-96.90635,33.2698243],[-96.9061388,33.2695441],[-96.9061388,33.2695441]]]},"properties":{"lotName":"12-C-32","lotCpId":"1305511686915250127","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9062731,33.2694679],[-96.9062866,33.2694595],[-96.9063197,33.2694384],[-96.9064008,33.269384],[-96.9064008,33.269384],[-96.9066556,33.2696372],[-96.9066556,33.2696372],[-96.9065067,33.2697349],[-96.9065067,33.2697349],[-96.9062731,33.2694679],[-96.9062731,33.2694679]]]},"properties":{"lotName":"12-C-33","lotCpId":"3617721686915250446","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9064008,33.269384],[-96.9064137,33.2693746],[-96.9064452,33.2693513],[-96.9065214,33.2692927],[-96.9065214,33.2692927],[-96.9067965,33.2695309],[-96.9067965,33.2695309],[-96.9066556,33.2696372],[-96.9066556,33.2696372],[-96.9064008,33.269384],[-96.9064008,33.269384]]]},"properties":{"lotName":"12-C-34","lotCpId":"4674741686915250768","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065214,33.2692927],[-96.9065329,33.2692833],[-96.9065614,33.2692594],[-96.9066344,33.269195],[-96.9066344,33.269195],[-96.906928,33.2694168],[-96.906928,33.2694168],[-96.9067965,33.2695309],[-96.9067965,33.2695309],[-96.9065214,33.2692927],[-96.9065214,33.2692927]]]},"properties":{"lotName":"12-C-35","lotCpId":"3735221686915251088","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9066344,33.269195],[-96.9066457,33.2691843],[-96.9066734,33.2691579],[-96.9067391,33.2690915],[-96.9067391,33.2690915],[-96.907049,33.2692949],[-96.907049,33.2692949],[-96.907029,33.2693178],[-96.906928,33.2694168],[-96.906928,33.2694168],[-96.9066344,33.269195],[-96.9066344,33.269195]]]},"properties":{"lotName":"12-C-36","lotCpId":"1706421686915251408","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067391,33.2690915],[-96.9067519,33.2690774],[-96.9067824,33.2690431],[-96.906851,33.2689619],[-96.906851,33.2689619],[-96.9071812,33.2691449],[-96.9071812,33.2691449],[-96.907049,33.2692949],[-96.907049,33.2692949],[-96.9067391,33.2690915],[-96.9067391,33.2690915]]]},"properties":{"lotName":"12-C-37","lotCpId":"8411221686915251722","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906851,33.2689619],[-96.9068613,33.2689487],[-96.9068867,33.2689153],[-96.9069504,33.268825],[-96.9069504,33.268825],[-96.9072969,33.2689851],[-96.9072969,33.2689851],[-96.9071812,33.2691449],[-96.9071812,33.2691449],[-96.906851,33.2689619],[-96.906851,33.2689619]]]},"properties":{"lotName":"12-C-38","lotCpId":"5214401686915252043","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069504,33.268825],[-96.9069607,33.2688086],[-96.906985,33.2687694],[-96.9070134,33.2687223],[-96.907036,33.2686821],[-96.907036,33.2686821],[-96.9073968,33.2688186],[-96.9073968,33.2688186],[-96.9072969,33.2689851],[-96.9072969,33.2689851],[-96.9069504,33.268825],[-96.9069504,33.268825]]]},"properties":{"lotName":"12-C-39","lotCpId":"7500841686915252364","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.907036,33.2686821],[-96.9070436,33.2686675],[-96.9070624,33.2686305],[-96.9071086,33.268532],[-96.9071086,33.268532],[-96.9074801,33.2686574],[-96.9074801,33.2686574],[-96.9073968,33.2688186],[-96.9073968,33.2688186],[-96.907036,33.2686821],[-96.907036,33.2686821]]]},"properties":{"lotName":"12-C-40","lotCpId":"3165441686915252681","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9071086,33.268532],[-96.907137,33.2684613],[-96.9071402,33.2684528],[-96.9071484,33.2684322],[-96.907173,33.2683842],[-96.9071856,33.2683614],[-96.9071856,33.2683614],[-96.9072292,33.2683481],[-96.9075709,33.2684827],[-96.9075709,33.2684827],[-96.9074801,33.2686574],[-96.9074801,33.2686574],[-96.9071086,33.268532],[-96.9071086,33.268532]]]},"properties":{"lotName":"12-C-41","lotCpId":"2848681686915252999","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9087126,33.2699653],[-96.9088535,33.2700794],[-96.9088535,33.2700794],[-96.90858,33.2703158],[-96.90858,33.2703158],[-96.9084392,33.2702012],[-96.9084392,33.2702012],[-96.9087126,33.2699653],[-96.9087126,33.2699653]]]},"properties":{"lotName":"12-D-1","lotCpId":"3651101686915253323","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9085713,33.2698508],[-96.9087126,33.2699653],[-96.9087126,33.2699653],[-96.9084392,33.2702012],[-96.9084392,33.2702012],[-96.9082979,33.2700871],[-96.9082979,33.2700871],[-96.9085713,33.2698508],[-96.9085713,33.2698508]]]},"properties":{"lotName":"12-D-2","lotCpId":"6418071686915253647","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9084305,33.2697367],[-96.9085713,33.2698508],[-96.9085713,33.2698508],[-96.9082979,33.2700871],[-96.9082979,33.2700871],[-96.9081571,33.2699726],[-96.9081571,33.2699726],[-96.9084305,33.2697367],[-96.9084305,33.2697367]]]},"properties":{"lotName":"12-D-3","lotCpId":"8830031686915253968","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9082891,33.2696222],[-96.9084305,33.2697367],[-96.9084305,33.2697367],[-96.9081571,33.2699726],[-96.9081571,33.2699726],[-96.9080157,33.2698585],[-96.9080157,33.2698585],[-96.9082891,33.2696222],[-96.9082891,33.2696222]]]},"properties":{"lotName":"12-D-4","lotCpId":"8832431686915254307","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9081483,33.2695081],[-96.9082891,33.2696222],[-96.9082891,33.2696222],[-96.9080157,33.2698585],[-96.9080157,33.2698585],[-96.9078749,33.269744],[-96.9078749,33.269744],[-96.9081483,33.2695081],[-96.9081483,33.2695081]]]},"properties":{"lotName":"12-D-5","lotCpId":"1626061686915254641","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.908007,33.2693935],[-96.9081483,33.2695081],[-96.9081483,33.2695081],[-96.9078749,33.269744],[-96.9078749,33.269744],[-96.9077335,33.2696299],[-96.9077335,33.2696299],[-96.908007,33.2693935],[-96.908007,33.2693935]]]},"properties":{"lotName":"12-D-6","lotCpId":"7062371686915254992","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9077995,33.2692497],[-96.9078115,33.2692557],[-96.9078431,33.2692729],[-96.9079382,33.2693379],[-96.908007,33.2693935],[-96.908007,33.2693935],[-96.9077335,33.2696299],[-96.9077335,33.2696299],[-96.9075704,33.2694976],[-96.9075704,33.2694976],[-96.9075759,33.269491],[-96.9075909,33.269473],[-96.9076406,33.2694123],[-96.9077012,33.2693348],[-96.9077548,33.2692598],[-96.9077995,33.2692497],[-96.9077995,33.2692497]]]},"properties":{"lotName":"12-D-7","lotCpId":"4701411686915255341","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074601,33.2698658],[-96.9073439,33.2697718],[-96.9073439,33.2697718],[-96.9073428,33.2697326],[-96.9073497,33.269726],[-96.9073684,33.2697079],[-96.9074302,33.2696471],[-96.9075051,33.2695703],[-96.9075704,33.2694976],[-96.9075704,33.2694976],[-96.9077335,33.2696299],[-96.9077335,33.2696299],[-96.9074601,33.2698658],[-96.9074601,33.2698658]]]},"properties":{"lotName":"12-D-8","lotCpId":"4767081686915255689","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9075774,33.2699607],[-96.9074601,33.2698658],[-96.9074601,33.2698658],[-96.9077335,33.2696299],[-96.9077335,33.2696299],[-96.9078508,33.2697245],[-96.9078508,33.2697245],[-96.9075774,33.2699607],[-96.9075774,33.2699607]]]},"properties":{"lotName":"12-D-9","lotCpId":"3655821686915256031","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076953,33.2700561],[-96.9075774,33.2699607],[-96.9075774,33.2699607],[-96.9078508,33.2697245],[-96.9078508,33.2697245],[-96.9079687,33.2698203],[-96.9079687,33.2698203],[-96.9076953,33.2700561],[-96.9076953,33.2700561]]]},"properties":{"lotName":"12-D-10","lotCpId":"6547781686915256381","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9078127,33.2701515],[-96.9076953,33.2700561],[-96.9076953,33.2700561],[-96.9079687,33.2698203],[-96.9079687,33.2698203],[-96.9080862,33.2699154],[-96.9080862,33.2699154],[-96.9078127,33.2701515],[-96.9078127,33.2701515]]]},"properties":{"lotName":"12-D-11","lotCpId":"4186081686915256743","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9079306,33.2702469],[-96.9078127,33.2701515],[-96.9078127,33.2701515],[-96.9080862,33.2699154],[-96.9080862,33.2699154],[-96.9082042,33.2700109],[-96.9082042,33.2700109],[-96.9079306,33.2702469],[-96.9079306,33.2702469]]]},"properties":{"lotName":"12-D-12","lotCpId":"7883221686915257086","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9080479,33.2703418],[-96.9079306,33.2702469],[-96.9079306,33.2702469],[-96.9082042,33.2700109],[-96.9082042,33.2700109],[-96.9083212,33.270106],[-96.9083212,33.270106],[-96.9080479,33.2703418],[-96.9080479,33.2703418]]]},"properties":{"lotName":"12-D-13","lotCpId":"2766661686915257419","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9078164,33.2703449],[-96.9079343,33.2704402],[-96.9079343,33.2704402],[-96.9076607,33.2706766],[-96.9076607,33.2706766],[-96.9075431,33.2705809],[-96.9075431,33.2705809],[-96.9078164,33.2703449],[-96.9078164,33.2703449]]]},"properties":{"lotName":"12-D-14","lotCpId":"5880681686915257763","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9076992,33.2702496],[-96.9078164,33.2703449],[-96.9078164,33.2703449],[-96.9075431,33.2705809],[-96.9075431,33.2705809],[-96.9074257,33.270486],[-96.9074257,33.270486],[-96.9076992,33.2702496],[-96.9076992,33.2702496]]]},"properties":{"lotName":"12-D-15","lotCpId":"2830501686915258235","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9075813,33.2701547],[-96.9076992,33.2702496],[-96.9076992,33.2702496],[-96.9074257,33.270486],[-96.9074257,33.270486],[-96.9073078,33.2703906],[-96.9073078,33.2703906],[-96.9075813,33.2701547],[-96.9075813,33.2701547]]]},"properties":{"lotName":"12-D-16","lotCpId":"5507601686915258605","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9074639,33.2700593],[-96.9075813,33.2701547],[-96.9075813,33.2701547],[-96.9073078,33.2703906],[-96.9073078,33.2703906],[-96.9071905,33.2702952],[-96.9071905,33.2702952],[-96.9074639,33.2700593],[-96.9074639,33.2700593]]]},"properties":{"lotName":"12-D-17","lotCpId":"6008131686915258940","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.907346,33.2699639],[-96.9074639,33.2700593],[-96.9074639,33.2700593],[-96.9071905,33.2702952],[-96.9071905,33.2702952],[-96.9070726,33.2701999],[-96.9070726,33.2701999],[-96.907346,33.2699639],[-96.907346,33.2699639]]]},"properties":{"lotName":"12-D-18","lotCpId":"8358201686915259282","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072303,33.2698699],[-96.907346,33.2699639],[-96.907346,33.2699639],[-96.9070726,33.2701999],[-96.9070726,33.2701999],[-96.9069094,33.270068],[-96.9069094,33.270068],[-96.9069183,33.2700621],[-96.9069422,33.2700461],[-96.9070195,33.2699931],[-96.9071102,33.2699282],[-96.9071826,33.2698705],[-96.9072303,33.2698699],[-96.9072303,33.2698699]]]},"properties":{"lotName":"12-D-19","lotCpId":"7088461686915259678","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067157,33.2703764],[-96.9066344,33.2702601],[-96.9066344,33.2702601],[-96.9066458,33.2702218],[-96.9069094,33.270068],[-96.9069094,33.270068],[-96.9070745,33.2702014],[-96.9070745,33.2702014],[-96.9067157,33.2703764],[-96.9067157,33.2703764]]]},"properties":{"lotName":"12-D-20","lotCpId":"6735411686915260043","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067981,33.2704951],[-96.9067157,33.2703764],[-96.9067157,33.2703764],[-96.9070745,33.2702014],[-96.9070745,33.2702014],[-96.9071969,33.2703005],[-96.9071969,33.2703005],[-96.9067981,33.2704951],[-96.9067981,33.2704951]]]},"properties":{"lotName":"12-D-21","lotCpId":"3255421686915260364","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9068805,33.2706133],[-96.9067981,33.2704951],[-96.9067981,33.2704951],[-96.9071969,33.2703005],[-96.9071969,33.2703005],[-96.9073192,33.2703998],[-96.9073192,33.2703998],[-96.9068805,33.2706133],[-96.9068805,33.2706133]]]},"properties":{"lotName":"12-D-22","lotCpId":"3427701686915260720","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069465,33.2707077],[-96.9068805,33.2706133],[-96.9068805,33.2706133],[-96.9073192,33.2703998],[-96.9073192,33.2703998],[-96.9074415,33.2704987],[-96.9074415,33.2704987],[-96.9069909,33.2707178],[-96.9069465,33.2707077],[-96.9069465,33.2707077]]]},"properties":{"lotName":"12-D-23","lotCpId":"7104721686915261083","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072385,33.2707561],[-96.9072214,33.2707409],[-96.9071721,33.2707125],[-96.9070942,33.2706963],[-96.9070455,33.2707007],[-96.9069909,33.2707178],[-96.9069909,33.2707178],[-96.9074415,33.2704987],[-96.9074415,33.2704987],[-96.9075637,33.2705976],[-96.9075637,33.2705976],[-96.9072385,33.2707561],[-96.9072385,33.2707561]]]},"properties":{"lotName":"12-D-24","lotCpId":"1076201686915261419","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9072778,33.2708953],[-96.9072807,33.2708828],[-96.9072821,33.2708505],[-96.9072716,33.2708058],[-96.9072385,33.2707561],[-96.9072385,33.2707561],[-96.9075637,33.2705976],[-96.9075637,33.2705976],[-96.9076855,33.2706968],[-96.9076855,33.2706968],[-96.9072778,33.2708953],[-96.9072778,33.2708953]]]},"properties":{"lotName":"12-D-25","lotCpId":"5262641686915261768","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9069111,33.2709295],[-96.9069193,33.2709414],[-96.9069291,33.2709545],[-96.9069602,33.2709831],[-96.9070152,33.271011],[-96.9070966,33.2710221],[-96.9070966,33.2710221],[-96.9066458,33.2712416],[-96.9066458,33.2712416],[-96.9065509,33.2711047],[-96.9065509,33.2711047],[-96.9069111,33.2709295],[-96.9069111,33.2709295]]]},"properties":{"lotName":"12-D-26","lotCpId":"3877801686915262106","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906827,33.2708086],[-96.9069111,33.2709295],[-96.9069111,33.2709295],[-96.9065509,33.2711047],[-96.9065509,33.2711047],[-96.9064668,33.2709842],[-96.9064668,33.2709842],[-96.906827,33.2708086],[-96.906827,33.2708086]]]},"properties":{"lotName":"12-D-27","lotCpId":"8087411686915262425","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906743,33.2706881],[-96.906827,33.2708086],[-96.906827,33.2708086],[-96.9064668,33.2709842],[-96.9064668,33.2709842],[-96.9063828,33.2708633],[-96.9063828,33.2708633],[-96.906743,33.2706881],[-96.906743,33.2706881]]]},"properties":{"lotName":"12-D-28","lotCpId":"6044631686915262765","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9066589,33.2705672],[-96.906743,33.2706881],[-96.906743,33.2706881],[-96.9063828,33.2708633],[-96.9063828,33.2708633],[-96.9062987,33.2707429],[-96.9062987,33.2707429],[-96.9066589,33.2705672],[-96.9066589,33.2705672]]]},"properties":{"lotName":"12-D-29","lotCpId":"3027271686915263096","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9065749,33.2704467],[-96.9066589,33.2705672],[-96.9066589,33.2705672],[-96.9062987,33.2707429],[-96.9062987,33.2707429],[-96.9062147,33.2706219],[-96.9062147,33.2706219],[-96.9065749,33.2704467],[-96.9065749,33.2704467]]]},"properties":{"lotName":"12-D-30","lotCpId":"6410371686915263422","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.906493,33.270329],[-96.9065749,33.2704467],[-96.9065749,33.2704467],[-96.9062147,33.2706219],[-96.9062147,33.2706219],[-96.9060979,33.270454],[-96.9060979,33.270454],[-96.9061077,33.2704507],[-96.9061348,33.2704413],[-96.9062255,33.2704088],[-96.9063398,33.2703649],[-96.9064477,33.270318],[-96.906493,33.270329],[-96.906493,33.270329]]]},"properties":{"lotName":"12-D-31","lotCpId":"6516381686915263739","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905789,33.2707118],[-96.9057502,33.2705795],[-96.9057502,33.2705795],[-96.9057742,33.2705453],[-96.9057819,33.2705435],[-96.9058034,33.2705385],[-96.905879,33.2705195],[-96.9059831,33.2704906],[-96.9060979,33.270454],[-96.9060979,33.270454],[-96.9062164,33.2706245],[-96.9062164,33.2706245],[-96.905789,33.2707118],[-96.905789,33.2707118]]]},"properties":{"lotName":"12-D-32","lotCpId":"3515631686915264063","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058277,33.2708451],[-96.905789,33.2707118],[-96.905789,33.2707118],[-96.9062164,33.2706245],[-96.9062164,33.2706245],[-96.9063023,33.2707479],[-96.9063023,33.2707479],[-96.9058277,33.2708451],[-96.9058277,33.2708451]]]},"properties":{"lotName":"12-D-33","lotCpId":"2506651686915264402","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905867,33.2709779],[-96.9058277,33.2708451],[-96.9058277,33.2708451],[-96.9063023,33.2707479],[-96.9063023,33.2707479],[-96.9063882,33.2708711],[-96.9063882,33.2708711],[-96.905867,33.2709779],[-96.905867,33.2709779]]]},"properties":{"lotName":"12-D-34","lotCpId":"7220711686915264735","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9059058,33.2711111],[-96.905867,33.2709779],[-96.905867,33.2709779],[-96.9063882,33.2708711],[-96.9063882,33.2708711],[-96.9064739,33.2709944],[-96.9064739,33.2709944],[-96.9059058,33.2711111],[-96.9059058,33.2711111]]]},"properties":{"lotName":"12-D-35","lotCpId":"6873181686915265063","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9059292,33.2711919],[-96.9059058,33.2711111],[-96.9059058,33.2711111],[-96.9064739,33.2709944],[-96.9064739,33.2709944],[-96.9065601,33.271118],[-96.9065601,33.271118],[-96.9060771,33.271217],[-96.9060695,33.2712145],[-96.9060477,33.2712099],[-96.9059691,33.2712119],[-96.9059292,33.2711919],[-96.9059292,33.2711919]]]},"properties":{"lotName":"12-D-36","lotCpId":"2107151686915265409","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9062027,33.271332],[-96.9061981,33.2713184],[-96.9061799,33.2712863],[-96.9061418,33.2712483],[-96.9060771,33.271217],[-96.9060771,33.271217],[-96.9065601,33.271118],[-96.9065601,33.271118],[-96.9066458,33.2712416],[-96.9066458,33.2712416],[-96.9062027,33.271332],[-96.9062027,33.271332]]]},"properties":{"lotName":"12-D-37","lotCpId":"7475101686915265726","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9058244,33.2714095],[-96.905829,33.2714233],[-96.905847,33.2714557],[-96.9058851,33.2714938],[-96.90595,33.2715245],[-96.90595,33.2715245],[-96.9054817,33.2716203],[-96.9054817,33.2716203],[-96.9054424,33.2714876],[-96.9054424,33.2714876],[-96.9058244,33.2714095],[-96.9058244,33.2714095]]]},"properties":{"lotName":"12-D-38","lotCpId":"1871201686915266077","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057851,33.2712763],[-96.9058244,33.2714095],[-96.9058244,33.2714095],[-96.9054424,33.2714876],[-96.9054424,33.2714876],[-96.9054037,33.2713543],[-96.9054037,33.2713543],[-96.9057851,33.2712763],[-96.9057851,33.2712763]]]},"properties":{"lotName":"12-D-39","lotCpId":"2325401686915266400","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057464,33.271143],[-96.9057851,33.2712763],[-96.9057851,33.2712763],[-96.9054037,33.2713543],[-96.9054037,33.2713543],[-96.9053649,33.2712211],[-96.9053649,33.2712211],[-96.9057464,33.271143],[-96.9057464,33.271143]]]},"properties":{"lotName":"12-D-40","lotCpId":"3421001686915266722","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9057076,33.2710098],[-96.9057464,33.271143],[-96.9057464,33.271143],[-96.9053649,33.2712211],[-96.9053649,33.2712211],[-96.9053256,33.2710878],[-96.9053256,33.2710878],[-96.9057076,33.2710098],[-96.9057076,33.2710098]]]},"properties":{"lotName":"12-D-41","lotCpId":"5440201686915267043","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056684,33.2708766],[-96.9057076,33.2710098],[-96.9057076,33.2710098],[-96.9053256,33.2710878],[-96.9053256,33.2710878],[-96.9052869,33.2709546],[-96.9052869,33.2709546],[-96.9056684,33.2708766],[-96.9056684,33.2708766]]]},"properties":{"lotName":"12-D-42","lotCpId":"8746731686915267366","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9056296,33.2707433],[-96.9056684,33.2708766],[-96.9056684,33.2708766],[-96.9052869,33.2709546],[-96.9052869,33.2709546],[-96.9052476,33.2708213],[-96.9052476,33.2708213],[-96.9056296,33.2707433],[-96.9056296,33.2707433]]]},"properties":{"lotName":"12-D-43","lotCpId":"4340511686915267699","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9055914,33.2706119],[-96.9056296,33.2707433],[-96.9056296,33.2707433],[-96.9052476,33.2708213],[-96.9052476,33.2708213],[-96.9051979,33.2706507],[-96.9051979,33.2706507],[-96.9055314,33.2705946],[-96.9055516,33.2705909],[-96.9055914,33.2706119],[-96.9055914,33.2706119]]]},"properties":{"lotName":"12-D-44","lotCpId":"5322661686915268026","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048601,33.2708866],[-96.9048251,33.2707415],[-96.9048251,33.2707415],[-96.9048508,33.2707091],[-96.9051979,33.2706507],[-96.9051979,33.2706507],[-96.9052476,33.2708213],[-96.9052476,33.2708213],[-96.9048601,33.2708866],[-96.9048601,33.2708866]]]},"properties":{"lotName":"12-D-45","lotCpId":"7858741686915268341","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9048923,33.2710208],[-96.9048601,33.2708866],[-96.9048601,33.2708866],[-96.9052476,33.2708213],[-96.9052476,33.2708213],[-96.9052869,33.2709546],[-96.9052869,33.2709546],[-96.9048923,33.2710208],[-96.9048923,33.2710208]]]},"properties":{"lotName":"12-D-46","lotCpId":"3736101686915268661","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.904925,33.2711554],[-96.9048923,33.2710208],[-96.9048923,33.2710208],[-96.9052869,33.2709546],[-96.9052869,33.2709546],[-96.9053256,33.2710878],[-96.9053256,33.2710878],[-96.904925,33.2711554],[-96.904925,33.2711554]]]},"properties":{"lotName":"12-D-47","lotCpId":"5755501686915268980","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9049572,33.2712895],[-96.904925,33.2711554],[-96.904925,33.2711554],[-96.9053256,33.2710878],[-96.9053256,33.2710878],[-96.9053649,33.2712211],[-96.9053649,33.2712211],[-96.9049572,33.2712895],[-96.9049572,33.2712895]]]},"properties":{"lotName":"12-D-48","lotCpId":"4737621686915269347","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.90499,33.2714241],[-96.9049572,33.2712895],[-96.9049572,33.2712895],[-96.9053649,33.2712211],[-96.9053649,33.2712211],[-96.9054037,33.2713543],[-96.9054037,33.2713543],[-96.90499,33.2714241],[-96.90499,33.2714241]]]},"properties":{"lotName":"12-D-49","lotCpId":"8114731686915269713","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.905026,33.2715724],[-96.90499,33.2714241],[-96.90499,33.2714241],[-96.9054037,33.2713543],[-96.9054037,33.2713543],[-96.9054424,33.2714876],[-96.9054424,33.2714876],[-96.905026,33.2715724],[-96.905026,33.2715724]]]},"properties":{"lotName":"12-D-50","lotCpId":"3171841686915270073","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9046729,33.271681],[-96.9046576,33.2716865],[-96.9046473,33.2716903],[-96.9046178,33.2717021],[-96.9045711,33.2717229],[-96.9045091,33.2717536],[-96.9045091,33.2717536],[-96.9042586,33.271425],[-96.9042586,33.271425],[-96.904519,33.2713812],[-96.904519,33.2713812],[-96.9046729,33.271681],[-96.9046729,33.271681]]]},"properties":{"lotName":"12-E-1","lotCpId":"1388031686915270422","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9045091,33.2717536],[-96.9044935,33.2717623],[-96.904456,33.2717839],[-96.9043727,33.2718389],[-96.9043616,33.2718472],[-96.9043302,33.2718695],[-96.9042812,33.271902],[-96.9042172,33.2719411],[-96.9042172,33.2719411],[-96.9041732,33.2719333],[-96.9041642,33.2719197],[-96.9041427,33.2718821],[-96.9041165,33.2718252],[-96.9040936,33.2717539],[-96.904024,33.2714647],[-96.904024,33.2714647],[-96.9042586,33.271425],[-96.9042586,33.271425],[-96.9045091,33.2717536],[-96.9045091,33.2717536]]]},"properties":{"lotName":"12-E-2","lotCpId":"6172301686915270747","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9040223,33.2720424],[-96.9040052,33.2720504],[-96.9039585,33.2720707],[-96.9038896,33.2720981],[-96.9038056,33.2721273],[-96.9038056,33.2721273],[-96.9036463,33.2717905],[-96.9036463,33.2717905],[-96.9039246,33.2717435],[-96.9039246,33.2717435],[-96.9039331,33.271781],[-96.9039378,33.2717998],[-96.9039541,33.2718499],[-96.9039851,33.2719217],[-96.9040341,33.2720058],[-96.9040223,33.2720424],[-96.9040223,33.2720424]]]},"properties":{"lotName":"12-F-1","lotCpId":"7044481686915271065","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9038056,33.2721273],[-96.9037842,33.2721343],[-96.9037299,33.272151],[-96.9035835,33.2721884],[-96.9035835,33.2721884],[-96.9034776,33.2718517],[-96.9034776,33.2718517],[-96.903536,33.2718092],[-96.9036463,33.2717905],[-96.9036463,33.2717905],[-96.9038056,33.2721273],[-96.9038056,33.2721273]]]},"properties":{"lotName":"12-F-2","lotCpId":"4720471686915271382","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9035835,33.2721884],[-96.903564,33.2721926],[-96.9035125,33.2722028],[-96.9034391,33.2722153],[-96.9033543,33.2722268],[-96.9033543,33.2722268],[-96.903291,33.2718471],[-96.903291,33.2718471],[-96.9034776,33.2718517],[-96.9034776,33.2718517],[-96.9035835,33.2721884],[-96.9035835,33.2721884]]]},"properties":{"lotName":"12-F-3","lotCpId":"2582781686915271720","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9033543,33.2722268],[-96.9033301,33.2722297],[-96.9032646,33.2722358],[-96.9031688,33.2722414],[-96.9030536,33.2722427],[-96.9030536,33.2722427],[-96.9030239,33.2722148],[-96.9030326,33.2721688],[-96.9030343,33.2721623],[-96.9030387,33.2721436],[-96.9030526,33.2720745],[-96.9030676,33.2719708],[-96.903077,33.2718421],[-96.903077,33.2718421],[-96.903291,33.2718471],[-96.903291,33.2718471],[-96.9033543,33.2722268],[-96.9033543,33.2722268]]]},"properties":{"lotName":"12-F-4","lotCpId":"8215841686915272051","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9028252,33.2722291],[-96.902809,33.2722273],[-96.902769,33.2722224],[-96.902671,33.2722067],[-96.9025864,33.2721912],[-96.9025864,33.2721912],[-96.9026836,33.2718129],[-96.9026836,33.2718129],[-96.9029133,33.2718316],[-96.9029133,33.2718316],[-96.902913,33.2718394],[-96.9029119,33.271861],[-96.9029062,33.2719359],[-96.9028937,33.2720363],[-96.902872,33.2721423],[-96.9028609,33.2722049],[-96.9028252,33.2722291],[-96.9028252,33.2722291]]]},"properties":{"lotName":"12-H-1","lotCpId":"2600201686915272366","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9025864,33.2721912],[-96.902439,33.2721652],[-96.9023943,33.272157],[-96.9023943,33.272157],[-96.9024865,33.2717965],[-96.9024865,33.2717965],[-96.9026836,33.2718129],[-96.9026836,33.2718129],[-96.9025864,33.2721912],[-96.9025864,33.2721912]]]},"properties":{"lotName":"12-H-2","lotCpId":"4123831686915272689","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9023943,33.272157],[-96.9022022,33.2721227],[-96.9022022,33.2721227],[-96.9022901,33.27178],[-96.9022901,33.27178],[-96.9024865,33.2717965],[-96.9024865,33.2717965],[-96.9023943,33.272157],[-96.9023943,33.272157]]]},"properties":{"lotName":"12-H-3","lotCpId":"3868461686915273004","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9022022,33.2721227],[-96.901991,33.2720849],[-96.901991,33.2720849],[-96.9019659,33.2720525],[-96.9019724,33.2720255],[-96.9019763,33.2720124],[-96.9019871,33.2719681],[-96.9020034,33.2718858],[-96.9020237,33.2717581],[-96.9020237,33.2717581],[-96.9022901,33.27178],[-96.9022901,33.27178],[-96.9022022,33.2721227],[-96.9022022,33.2721227]]]},"properties":{"lotName":"12-H-4","lotCpId":"4014701686915273330","type":"Vertex"}}]}}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "check.svg?7f3b2358b5395b5c4d160136659a390c";

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Gotham-Medium.otf?27a90e8757eda1edc9872eebec18ba64";

/***/ }),
/* 11 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_api__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    initConfig: function initConfig() {
      var _this = this;

      var bounds = new mapboxgl.LngLatBounds();
      this.svgConfig.svgFileConfigs.forEach(function (svgConfig) {
        if (svgConfig.svgFileType.fileType === 'MASTER') {
          _this.masterBound = new mapboxgl.LngLatBounds(new mapboxgl.LngLat(svgConfig.neLongBound, svgConfig.neLatBound), new mapboxgl.LngLat(svgConfig.swLongBound, svgConfig.swLatBound));

          if (svgConfig.poe && svgConfig.poe.lat && svgConfig.poe.lng) {
            var poe = new mapboxgl.LngLat(svgConfig.poe.lng, svgConfig.poe.lat);
            _this.origin = poe;
          }
        }
        if (svgConfig.neLongBound && svgConfig.neLongBound !== 0) {
          var bound = new mapboxgl.LngLatBounds(new mapboxgl.LngLat(svgConfig.neLongBound, svgConfig.neLatBound), new mapboxgl.LngLat(svgConfig.swLongBound, svgConfig.swLatBound));
          bounds.extend(bound);
          if (svgConfig.baseLayerUrl && svgConfig.baseLayerUrl !== '') {
            _this.baseLayers.push({
              bound: bound,
              url: svgConfig.baseLayerUrl
            });
          }

          if (svgConfig.detailLayerUrl && svgConfig.detailLayerUrl !== '') {
            _this.detailLayers.push({
              bound: bound,
              url: svgConfig.detailLayerUrl
            });
          }
        }
      });

      this.svgConfig.polygons.forEach(function (item) {
        var geojson = [];
        item.geojson[0].forEach(function (coord, index) {
          geojson.push([coord.lng, coord.lat]);
          if (index + 1 === item.geojson[0].length) {
            geojson.push([item.geojson[0][0].lng, item.geojson[0][0].lat]);
          }
        });

        var feature = {
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            properties: {},
            coordinates: [geojson]
          }
        };
        _this.stageGeoJson.features.push(feature);
      });

      var minZoom = 11;

      if (window.innerWidth < 600) {
        minZoom = 7;
      }

      if (this.map === null || this.map === undefined) {
        this.map = new mapboxgl.Map({
          container: this.$refs[this.container],
          style: 'mapbox://styles/mapbox/streets-v11',
          center: bounds.getCenter(),
          zoom: 18,
          minZoom: minZoom,
          pitchWithRotate: true
        });
      }

      this.map.addControl(new mapboxgl.NavigationControl());

      this.map.on('error', function () {
        return null;
      });

      this.map.on('load', function () {
        _this.placeLayer();
        _this.fetchGeoJsonLots();
        _this.fetchGeoJsonHome();
        _this.mapObjects(_this.svgConfig.objects);
      });
    },

    fetchGeoJsonLots: function fetchGeoJsonLots() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__store_api__["a" /* api */].fetchLotGeojson().then(function (res) {
        _this2.lotGeoJson = res.data.geoJson;
        _this2.addLotShapes();
      });
    },

    fetchGeoJsonHome: function fetchGeoJsonHome() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__store_api__["a" /* api */].fetchPackageGeojsonAndHandlSummaryList().then(function (res) {
        if (res && res.packageGeoJson) {
          _this3.addHomesShapes(res.packageGeoJson.geoJson, res.handlSummaryList);
        }
      });
    },

    mapObjects: function mapObjects(objects) {
      var _this4 = this;

      objects.forEach(function (obj, index) {
        var coords = [[]];
        obj.geojson[0].forEach(function (g) {
          var coord = [g.lng, g.lat];
          coords[0].push(coord);
        });
        coords[0].push(coords[0][0]);
        var baseHeight = 0;
        var storeyHeight = obj.storeyHeight || 5;
        if (obj.baseHeight) {
          baseHeight = obj.baseHeight;
        }
        for (var i = baseHeight; i <= obj.height; i++) {
          var feature = {
            type: 'Feature',
            id: Math.floor(Math.random() * Math.floor(99999)) + i + index + 1,
            geometry: {
              type: 'Polygon',
              coordinates: coords
            },
            properties: {
              height: storeyHeight * (i + 1),
              base_height: i * storeyHeight + 1 / 5,
              color: 'grey',
              interact: true,
              description: 'Level ' + i
            }
          };
          _this4.apartmentGeoJson.features.push(feature);
        }
      });

      this.addApartmentShapes();
    },

    placeLayer: function placeLayer() {
      var _this5 = this;

      if (this.baseLayers.length > 0) {
        this.baseLayers.forEach(function (layer) {
          _this5.map.addSource('raster-tiles', {
            type: 'raster',
            tiles: [layer.url + '/{z}/{x}/{y}.png'],
            tileSize: 256,
            minZoom: 16,
            maxZoom: 22
          });
        });

        this.map.addLayer({
          id: 'terrain-data',
          type: 'raster',
          source: 'raster-tiles',
          minZoom: 16,
          maxZoom: 22,
          paint: {
            'raster-opacity': 1
          }
        });
      }
    },

    assignColor: function assignColor(status) {
      status = status.toLowerCase();
      if (status === 'available') {
        return '#f0cd89';
      } else if (status === 'sold' || status === 'closed' || status === 'unknown') {
        return '#c3958e';
      } else if (status === 'future release' || status === 'unavailable') {
        return '#fff7eb';
      } else if (status === 'model') {
        return '#8b586a';
      } else if (status === 'hold' || status === 'reserved') {
        return '#86ABB5';
      } else if (status === 'spec' || status === 'contingent spec') {
        return '#688e9f';
      } else {
        console.log(status);
        return '#fff7eb';
      }
    },

    placeDetailLayer: function placeDetailLayer() {
      var _this6 = this;

      if (this.detailLayers.length > 0) {
        this.detailLayers.forEach(function (layer) {
          _this6.map.addSource('detail-tiles', {
            type: 'raster',
            tiles: [
            // 'assets/detail/{z}/{x}/{y}.png'
            layer.url + '/{z}/{x}/{y}.png'],
            tileSize: 256,
            minZoom: 16,
            maxZoom: 23
          });
        });

        this.map.addLayer({
          id: 'detail-data',
          type: 'raster',
          source: 'detail-tiles',
          minZoom: 16,
          maxZoom: 22,
          paint: {
            'raster-opacity': 1
          }
        });
      }
    },

    addApartmentShapes: function addApartmentShapes() {
      var _this7 = this;

      var hoveredObjectId = void 0;
      if (this.map.getSource('objects')) {
        this.map.removeLayer('obj');
        this.map.removeSource('objects');
      }

      this.map.addSource('objects', {
        type: 'geojson',
        data: this.apartmentGeoJson
      });

      this.map.addLayer({
        id: 'obj',
        type: 'fill-extrusion',
        source: 'objects',
        minzoom: 15,
        paint: {
          'fill-extrusion-color': ['case', ['boolean', ['feature-state', 'hover'], false], '#e05858', '#f1f1f1'],
          'fill-extrusion-height': ['get', 'height'],
          'fill-extrusion-base': ['get', 'base_height'],
          'fill-extrusion-opacity': 0.9
        }
      });

      this.map.on('mousemove', 'obj', function (e) {
        if (e.features.length > 0) {
          var description = e.features[0].properties.description;
          _this7.map.getCanvas().style.cursor = 'pointer';
          if (hoveredObjectId) {
            _this7.map.setFeatureState({ source: 'objects', id: hoveredObjectId }, { hover: false });
          }

          hoveredObjectId = e.features[0].id;
          _this7.map.setFeatureState({ source: 'objects', id: hoveredObjectId }, { hover: true });
        }
      });

      this.map.on('mouseleave', 'obj', function () {
        _this7.map.getCanvas().style.cursor = '';
        if (hoveredObjectId) {
          _this7.map.setFeatureState({ source: 'objects', id: hoveredObjectId }, { hover: false });
        }
        hoveredObjectId = null;
      });
    },

    flyTo: function flyTo(lotId, mark) {
      this.viewBasedFilterLot.features = [];
      var lotGeo = this.filteredlotGeoJson.features.find(function (item) {
        return item.id === lotId;
      });
      if (lotGeo) {
        var bounds = new mapboxgl.LngLatBounds();
        lotGeo.geometry.coordinates[0].forEach(function (cord) {
          bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
        });
        var payload = {
          point: bounds.getCenter(),
          features: {
            properties: {
              hnlproperties: JSON.stringify(lotGeo.properties.hnlproperties)
            }
          }
        };
        this.createLotMarker(payload);
        this.map.fitBounds(bounds, {
          maxZoom: 19
        });
      }
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      homeGeoJson: {
        type: 'FeatureCollection',
        features: []
      }
    };
  },

  methods: {
    addHomesShapes: function addHomesShapes(geojson, packageSummaryList) {
      var _this = this;

      return;
      packageSummaryList.forEach(function (hnl) {
        var homejson = geojson.features.find(function (item) {
          return item.properties.lotCpId === hnl.lotproductcpid;
        });
        if (homejson) {
          homejson.properties.level = 0;
          homejson.properties.height = 4;
          homejson.properties.base_height = 4;
          homejson.color = 'grey';
          _this.homeGeoJson.features.push(homejson);
        }
      });

      this.map.addSource('homes', {
        type: 'geojson',
        data: this.homeGeoJson
      });

      this.map.addLayer({
        id: 'homegeo',
        type: 'fill-extrusion',
        source: 'homes',
        minzoom: 15,
        paint: {
          'fill-extrusion-color': '#ddd',
          'fill-extrusion-height': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'height']],
          'fill-extrusion-base': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'min_height']],
          'fill-extrusion-opacity': 0.9
        }
      });
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    getTime: function getTime(t, short) {
      var time = '';
      var h = Math.floor(t / 3600);
      var m = Math.floor(t % 3600 / 60);
      if (h > 0) {
        if (h > 1) {
          time = h + ' hrs';
        } else {
          time = h + ' hr';
        }
      }

      if (h > 0 && short) {
        return time;
      } else {
        if (m > 0) {
          time += ' ';
          if (m > 1) {
            time += m + ' mins';
          } else {
            time += m + ' min';
          }
        }
        return time;
      }
    },

    getDistance: function getDistance(d) {
      var k = d / 1000 * 0.62137;
      if (d < 1000) {
        return Math.round(k * 10) / 10 + ' mile';
      }
      // const k = d / 1000;
      // return Math.round(((k * 1000 * 0.62137) / 1000)) + ' m';
      return Math.round(k * 10) / 10 + ' miles';
    },

    setIcons: function setIcons(steps) {
      steps.forEach(function (step) {
        var icon = step.maneuver.type.replace(/ /g, '_');
        if (step.maneuver.modifier) {
          icon += '_' + step.maneuver.modifier.replace(/ /g, '_');
        }
        step['icon'] = icon + '.svg';
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLabel_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd9d1290_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLabel_vue__ = __webpack_require__(143);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd9d1290_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "td.svg?55acac9b3af1347c53218d8b12e52b97";

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "development" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "development" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (true) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if ("development" !== 'production' && !config.async) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if ("development" !== 'production' && customSetter) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if ("development" !== 'production' &&
    (isUndef(target) || isPrimitive(target))
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "development" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if ("development" !== 'production' &&
    (isUndef(target) || isPrimitive(target))
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "development" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (true) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "development" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "development" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (true) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "development" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (true) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (true) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (true) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (true) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if ("development" !== 'production' && warnMissing && !res) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    true
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if ("development" !== 'production' && isObject(def)) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (true) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (true) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (true) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "development" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (true) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (true) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (true) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if ("development" !== 'production' && !isObject(bindObject)) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "development" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "development" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if ("development" !== 'production' && key !== '' && key !== null) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (true) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (true) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "development" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if ("development" !== 'production' &&
    isDef(data) && isDef(data.key) && !isPrimitive(data.key)
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if ("development" !== 'production' && isDef(data) && isDef(data.nativeOn)) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (true) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if ("development" !== 'production' && vm.$options.renderError) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if ("development" !== 'production' && Array.isArray(vnode)) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "development" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 true
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (true) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (true) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if ("development" !== 'production' && config.performance && mark) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (true) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (true) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (true) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if ("development" !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if ("development" !== 'production' && !config.async) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  true
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "development" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (true) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "development" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (true) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "development" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if ("development" !== 'production' && getter == null) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (true) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if ("development" !== 'production' &&
      sharedPropertyDefinition.set === noop) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (true) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (true) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if ("development" !== 'production' && config.performance && mark) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (true) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if ("development" !== 'production' && config.performance && mark) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if ("development" !== 'production' &&
    !(this instanceof Vue)
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if ("development" !== 'production' && name) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if ("development" !== 'production' && type === 'component') {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (true) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "development" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (true) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if ("development" !== 'production' && data && data.pre) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (true) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (true) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (true) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (true) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if ("development" !== 'production' &&
                typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if ("development" !== 'production' &&
                typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (true) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    "development" !== 'production' && warn &&
    modifiers.prevent && modifiers.passive
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (true) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (true) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (true) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if ("development" !== 'production' && explicitEnterDuration != null) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if ("development" !== 'production' && isDef(explicitLeaveDuration)) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "development" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if ("development" !== 'production' && children.length > 1) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if ("development" !== 'production' &&
      mode && mode !== 'in-out' && mode !== 'out-in'
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (true) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        true
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if ("development" !== 'production' &&
      "development" !== 'test' &&
      config.productionTip !== false &&
      typeof console !== 'undefined'
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if ("development" !== 'production' && staticClass) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (true) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if ("development" !== 'production' && !stack.length && options.warn) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if ("development" !== 'production' && options.outputSourceRange) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if ("development" !== 'production' &&
          (i > pos || !tagName) &&
          options.warn
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (true) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (true) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (true) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "development" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (true) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if ("development" !== 'production' && options.outputSourceRange) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (true) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if ("development" !== 'production' && options.outputSourceRange) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if ("development" !== 'production' && options.outputSourceRange) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (true) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (true) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (true) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if ("development" !== 'production' && children[i].text !== ' ') {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if ("development" !== 'production' && slotScope) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if ("development" !== 'production' && el.attrsMap['v-for']) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (true) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (true) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (true) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if ("development" !== 'production' && el.key) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          "development" !== 'production' &&
          value.trim().length === 0
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if ("development" !== 'production' && name === 'model') {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (true) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      "development" !== 'production' &&
      map[attrs[i].name] && !isIE && !isEdge
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if ("development" !== 'production' && dir.modifiers) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "development" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if ("development" !== 'production' &&
    state.maybeComponent(el) &&
    el.tag !== 'slot' &&
    el.tag !== 'template' &&
    !el.key
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if ("development" !== 'production' && (
    el.children.length !== 1 || ast.type !== 1
  )) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (true) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (true) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (true) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if ("development" !== 'production' && options.outputSourceRange) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (true) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "development" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if ("development" !== 'production' && !template) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (true) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if ("development" !== 'production' && config.performance && mark) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "development" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if ("development" !== 'production' && config.performance && mark) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11), __webpack_require__(100).setImmediate))

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_Poi__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_TravelMarker__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_map_Direction__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_map_Config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_map_Home__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeVenue: null,
      apartmentGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      baseLayers: [],
      container: 'amenity-map',
      detailLayers: [],
      filteredGroupMarkers: [],
      filteredlotGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      groupMarkers: [],
      groups: [],
      groupVenueMarkers: [],
      lotSummaryList: [],
      lotgeo: __webpack_require__(8),
      map: null,
      mapLoad: false,
      masterBound: false,
      objects: [],
      objectGeojson: {
        type: 'FeatureCollection',
        features: []
      },
      poi: null,
      padding: {
        top: 100,
        left: 100,
        right: 100,
        bottom: 100
      },
      route: null,
      svgConfig: null,
      stageGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      travelMark: __WEBPACK_IMPORTED_MODULE_1__model_TravelMarker__["a" /* TravelMarker */],
      travelMethod: 'driving',
      venues: null,
      venueMarkers: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_map_Config__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_map_Direction__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_map_Home__["a" /* default */]],
  computed: {},
  created: function created() {},

  methods: {
    initMap: function initMap(svgConfig, lotsummarylist) {
      var _this = this;

      var poe = null;
      if (window.location.pathname.includes('amenities')) {
        this.venues = [];
        var precinct = svgConfig.precincts.find(function (item) {
          return item.name.toLowerCase() === 'amenities';
        });
        if (precinct) {
          svgConfig.venue.forEach(function (venue) {
            if (precinct.venues.includes(venue.id)) {
              _this.venues.push(venue);
            }
          });
        }
      } else {
        this.venues = JSON.parse(JSON.stringify(svgConfig.venue));
      }
      this.venues = this.venues.sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      });
      this.groups = JSON.parse(JSON.stringify(svgConfig.poiGroups));
      this.lotSummaryList = lotsummarylist;
      mapboxgl.accessToken = 'pk.eyJ1Ijoic2FpbGVzaGtjIiwiYSI6ImNrZGo1Y2l5dTBibGIzMXBmbzM5Z2Q3Z2MifQ.hq_fP_fYTmUm_LJNRl23Cw';
      this.svgConfig = svgConfig;
      this.initConfig();
      this.map.flyTo({
        pitch: 60
      });
    },

    addOutine: function addOutine() {
      if (this.map.getSource('raster-tiles')) {
        this.map.removeLayer('terrain-data');
        this.map.removeSource('raster-tiles');
      }
      if (this.baseLayer) {
        this.map.addSource('raster-tiles', {
          type: 'raster',
          tiles: [this.baseLayer + '/{z}/{x}/{y}.png'],
          tileSize: 256,
          minZoom: 16,
          maxZoom: 22
        });

        this.map.addLayer({
          id: 'terrain-data',
          type: 'raster',
          source: 'raster-tiles',
          minZoom: 16,
          maxZoom: 22,
          paint: {
            'raster-opacity': 1
          }
        });

        this.map.fitBounds(this.masterBound, {
          padding: 20
        });
      }
      this.mapLoad = true;
      this.mapObjects();
    },

    addLotShapes: function addLotShapes() {
      var _this2 = this;

      this.mapLoad = true;
      this.lotgeo.geoJson.features.forEach(function (feature) {
        var lotname = feature.properties.lotName;
        var lotcpid = feature.properties.lotCpId;
        var lot = _this2.lotSummaryList.find(function (item) {
          return item.productname === lotname && item.lotcpid === lotcpid;
        });
        if (lot) {
          feature.properties.lotproperties = lot;
          feature.id = lot.lotcpid;
          feature.properties.color = _this2.asignLotColor(lot.lotgroup);
          feature.properties.status = lot.currentstatusname;
          _this2.filteredlotGeoJson.features.push(feature);
        }
      });

      this.map.addSource('lots', {
        type: 'geojson',
        data: this.filteredlotGeoJson
      });

      this.map.addLayer({
        id: 'lot-fills',
        type: 'fill',
        source: 'lots',
        layout: {},
        paint: {
          'fill-color': ['case', ['boolean', ['get', 'isActive'], false], '#fff', ['get', 'color']],
          'fill-outline-color': '#333333',
          'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.4, 0.9]
        }
      });
    },

    asignLotColor: function asignLotColor(size) {
      size = size.replace('ft', "'");
      if (size === "60'") {
        return '#ffab97';
      }
      if (size === "45'") {
        return '#EEBE64';
      }
      if (size === "50'") {
        return '#add5ee';
      }
      if (size === "70'") {
        return '#e6ceba';
      }
    },

    clearRoutes: function clearRoutes() {
      this.removeTravelMarker();
      var activeMarker = document.getElementById('marker-is-active');
      if (activeMarker) {
        activeMarker.id = '';
      }
      if (this.map.getSource('LineString')) {
        this.map.removeLayer('LineString');
        this.map.removeSource('LineString');
      }
    },

    clearMarkers: function clearMarkers() {
      var activeEl = document.getElementById('marker-is-active');
      if (activeEl) {
        activeEl.id = '';
      }
      this.markerBounds = null;

      this.filteredGroupMarkers.forEach(function (marker) {
        marker.remove();
      });

      this.groupVenueMarkers.forEach(function (marker) {
        marker.remove();
      });

      this.venueMarkers.forEach(function (marker) {
        marker.remove();
      });

      this.groupVenueMarkers = [];
      this.filteredGroupMarkers = [];
      this.venueMarkers = [];

      this.map.off('zoom');
    },

    addMarkers: function addMarkers(markers) {
      var _this3 = this;

      var page = this.$route.name;
      var ids = [];
      var groupMarkers = [];
      this.resize();
      this.clearMarkers();
      var bounds = new mapboxgl.LngLatBounds();
      bounds.extend(this.masterBound);
      if (markers.length) {
        markers.forEach(function (m) {
          _this3.poi[m].venue.forEach(function (venue) {
            return ids.push(venue.id);
          });
          _this3.poi[m].groupedMarkers.forEach(function (marker) {
            bounds.extend(marker.getLngLat());
            _this3.groupVenueMarkers.push(marker);
          });
          _this3.poi[m].markers.forEach(function (marker) {
            _this3.venueMarkers.push(marker);
            marker.addTo(_this3.map);
            bounds.extend(marker.getLngLat());
          });
        });

        this.groupMarkers.forEach(function (marker) {
          var groupVenues = marker.venues.filter(function (id) {
            return ids.includes(id);
          });
          if (groupVenues.length > 0) {
            _this3.filteredGroupMarkers.push(marker.marker);
            bounds.extend(marker.marker.getLngLat());
          }
        });

        this.toggleGroupMarkers();
      }

      this.markerBounds = bounds;
      this.currentBounds = bounds;

      this.map.fitBounds(this.masterBound);
      // if (page === 'places') {
      //   this.map.fitBounds(bounds, {
      //     padding: this.padding
      //   });
      // } else {
      // }
    },

    zoomToCategory: function zoomToCategory(m) {
      var _this4 = this;

      var bounds = new mapboxgl.LngLatBounds();
      this.poi[m].groupedMarkers.forEach(function (marker) {
        bounds.extend(marker.getLngLat());
      });
      this.poi[m].markers.forEach(function (marker) {
        _this4.venueMarkers.push(marker);
        bounds.extend(marker.getLngLat());
      });
      this.map.fitBounds(bounds, {
        padding: this.padding,
        maxZoom: 16
      });
    },

    toggleGroupMarkers: function toggleGroupMarkers() {
      var _this5 = this;

      var showPoi = false;
      var showGroup = false;

      this.map.on('zoom', function () {
        if (_this5.map.getZoom() > 12) {
          if (!showPoi) {
            showPoi = true;
            showGroup = false;
            _this5.filteredGroupMarkers.forEach(function (marker) {
              marker.remove();
            });
            _this5.groupVenueMarkers.forEach(function (marker) {
              marker.addTo(_this5.map);
            });
          }
        } else {
          if (!showGroup) {
            showPoi = false;
            showGroup = true;
            _this5.filteredGroupMarkers.forEach(function (marker) {
              marker.addTo(_this5.map);
            });
            _this5.groupVenueMarkers.forEach(function (marker) {
              marker.remove();
            });
          }
        }

        if (_this5.map.getZoom() > 14) {
          _this5.venueMarkers.forEach(function (marker) {
            marker.getElement().classList.add('marker-is-active');
          });
          _this5.groupVenueMarkers.forEach(function (marker) {
            marker.getElement().classList.add('marker-is-active');
          });
        } else {
          _this5.venueMarkers.forEach(function (marker) {
            marker.getElement().classList.remove('marker-is-active');
          });
          _this5.groupVenueMarkers.forEach(function (marker) {
            marker.getElement().classList.remove('marker-is-active');
          });
        }
      });
    },


    categorisePoi: function categorisePoi() {
      var _this6 = this;

      var groupVenues = [];
      var venues = this.venues;
      var poi = __WEBPACK_IMPORTED_MODULE_0__model_Poi__["a" /* default */];
      var count = 0;

      this.groups.forEach(function (group) {
        var bounds = new mapboxgl.LngLatBounds();
        group.geojson[0].forEach(function (coord) {
          bounds.extend([coord.lng, coord.lat]);
        });
        var center = bounds.getCenter();
        group.center = center;
        // const marker = new mapboxgl.Marker().setLngLat([center.lng, center.lat]);
        var marker = _this6.createGroupMarker(group);
        var groupVenue = {
          marker: marker,
          venues: []
        };

        group.venues.forEach(function (venueId) {
          groupVenues.push(venueId);
          groupVenue.venues.push(venueId);
        });
        _this6.groupMarkers.push(groupVenue);
      });

      venues.forEach(function (venue) {
        if (venue) {
          if (groupVenues.includes(venue.id)) {
            venue.hasParent = true;
          }
          _this6.categoryCheck(venue, poi);

          count += 1;
          if (venues.length === count) {
            _this6.poi = poi;
            _this6.$store.commit("setPoi", poi);
          }
        }
      });
    },

    categoryCheck: function categoryCheck(venue, poi) {
      var icon = void 0;
      var type = void 0;

      if (venue.subtype === 'Travel & Transport') {
        poi.transport.venue.push(venue);
        icon = poi.transport.iconUrl;
        type = 'transport';
      }

      if (venue.subtype === 'School') {
        poi.education.venue.push(venue);
        icon = poi.education.iconUrl;
        type = 'education';
      }

      if (venue.subtype === 'University & College') {
        poi.education.venue.push(venue);
        icon = poi.education.iconUrl;
        type = 'education';
      }

      if (venue.subtype === 'Outdoors & Recreation') {
        poi.outdoor.venue.push(venue);
        icon = poi.outdoor.iconUrl;
        type = 'outdoor';
      }

      if (venue.subtype === 'Food') {
        poi.food.venue.push(venue);
        icon = poi.food.iconUrl;
        type = 'food';
      }

      if (venue.poisubcategory === 'Child Care Service') {
        poi.childcare.venue.push(venue);
        icon = poi.childcare.iconUrl;
        type = 'childcare';
      }

      if (venue.subtype === 'Medical Center') {
        poi.health.venue.push(venue);
        icon = poi.health.iconUrl;
        type = 'health';
      }

      if (venue.subtype === 'Shop & Service') {
        poi.shopping.venue.push(venue);
        icon = poi.shopping.iconUrl;
        type = 'shopping';
      }

      if (venue && icon && type) {
        var pin = this.createMarker(venue, icon, type);
        if (venue.hasParent) {
          poi[type].groupedMarkers.push(pin);
        } else {
          poi[type].markers.push(pin);
        }
      }
    },

    createGroupMarker: function createGroupMarker(venue) {
      var _this7 = this;

      var el = document.createElement('div');
      var pEl = document.createElement('p');
      var imgEl = document.createElement('img');
      var iEl = document.createElement('i');
      iEl.classList.add('fas', 'fa-map-marker-alt', 'fa-2x');
      pEl.innerText = venue.name;
      imgEl.src = __webpack_require__(132);
      imgEl.style.height = '32px';
      imgEl.style.width = '32px';
      el.className = 'marker';
      el.classList.add('marker-is-active');
      el.style.height = '32px';
      el.appendChild(iEl);
      // el.appendChild(imgEl);
      el.appendChild(pEl);

      el.addEventListener('click', function (e) {
        var activeEl = document.getElementById('marker-is-active');
        if (activeEl) {
          activeEl.id = '';
        }
        _this7.map.flyTo({
          center: [venue.center.lng, venue.center.lat],
          zoom: 15,
          essential: true
        });
      });

      return new mapboxgl.Marker(el).setLngLat([venue.center.lng, venue.center.lat]);
    },

    createMarker: function createMarker(venue, icon, type) {
      var _this8 = this;

      // let showRoute = true;
      var el = document.createElement('div');
      var pEl = document.createElement('p');
      var imgEl = document.createElement('img');
      pEl.innerText = venue.name;
      imgEl.src = icon + '.svg';
      imgEl.style.height = '32px';
      imgEl.style.width = '32px';
      el.className = 'marker';
      el.classList.add(venue.id);
      // el.style.width = 'auto';
      el.style.height = '32px';
      el.appendChild(imgEl);
      el.appendChild(pEl);
      // if (venue.hasOwnProperty('showRoute')) {
      //   showRoute = venue.showRoute;
      // }
      el.addEventListener('click', function (e) {
        _this8.activeVenue = venue;
        _this8.$store.commit("setActiveVenue", venue);
        _this8.$store.dispatch('productTracking', {
          product: {
            productName: venue.name,
            category: venue.poisubcategory
          },
          page: 'poi-click'
        });
        var activeEl = document.getElementById('marker-is-active');
        if (activeEl) {
          activeEl.id = '';
        }
        el.id = 'marker-is-active';
      });
      el.addEventListener('mouseenter', function (e) {
        el.classList.add('is-hovered');
      });
      el.addEventListener('mouseout', function (e) {
        el.classList.remove('is-hovered');
      });

      var pin = new mapboxgl.Marker(el).setLngLat([venue.longitude, venue.latitude]);
      return pin;
    },

    highlightPoi: function highlightPoi(venue) {
      var activeEl = document.getElementById('marker-is-active');
      if (activeEl) {
        activeEl.id = '';
      }
      var clickedEl = document.getElementsByClassName(venue.id);
      if (clickedEl) {
        clickedEl[0].id = 'marker-is-active';
      }
    },


    flyToPoint: function flyToPoint(coord) {
      this.clearRoutes();
      this.map.flyTo({
        center: coord,
        zoom: 18,
        essential: true
      });
    },

    resize: function resize() {
      if (this.map) {
        this.map.resize();
      }
    },

    clearMap: function clearMap() {
      if (this.map) {
        this.travelMethod = 'driving';
        this.activeVenue = null;
        this.route = null;
        this.clearMarkers();
        this.clearRoutes();
      }
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(115);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arrive.svg": 145,
	"./arrive_left.svg": 146,
	"./arrive_right.svg": 147,
	"./arrive_straight.svg": 148,
	"./close.svg": 149,
	"./continue.svg": 150,
	"./continue_left.svg": 151,
	"./continue_right.svg": 152,
	"./continue_slight_left.svg": 153,
	"./continue_slight_right.svg": 154,
	"./continue_straight.svg": 155,
	"./continue_uturn.svg": 156,
	"./depart.svg": 157,
	"./depart_left.svg": 158,
	"./depart_right.svg": 159,
	"./depart_straight.svg": 160,
	"./end_of_road_left.svg": 161,
	"./end_of_road_right.svg": 162,
	"./flag.svg": 163,
	"./fork.svg": 164,
	"./fork_left.svg": 165,
	"./fork_right.svg": 166,
	"./fork_slight_left.svg": 167,
	"./fork_slight_right.svg": 168,
	"./fork_straight.svg": 169,
	"./invalid.svg": 170,
	"./invalid_left.svg": 171,
	"./invalid_right.svg": 172,
	"./invalid_slight_left.svg": 173,
	"./invalid_slight_right.svg": 174,
	"./invalid_straight.svg": 175,
	"./invalid_uturn.svg": 176,
	"./merge_left.svg": 177,
	"./merge_right.svg": 178,
	"./merge_slight_left.svg": 179,
	"./merge_slight_right.svg": 180,
	"./merge_straight.svg": 181,
	"./new_name_left.svg": 182,
	"./new_name_right.svg": 183,
	"./new_name_sharp_left.svg": 184,
	"./new_name_sharp_right.svg": 185,
	"./new_name_slight_left.svg": 186,
	"./new_name_slight_right.svg": 187,
	"./new_name_straight.svg": 188,
	"./notificaiton_sharp_right.svg": 189,
	"./notification_left.svg": 190,
	"./notification_right.svg": 191,
	"./notification_sharp_left.svg": 192,
	"./notification_slight_left.svg": 193,
	"./notification_slight_right.svg": 194,
	"./notification_straight.svg": 195,
	"./off_ramp_left.svg": 196,
	"./off_ramp_right.svg": 197,
	"./off_ramp_slight_left.svg": 198,
	"./off_ramp_slight_right.svg": 199,
	"./on_ramp_left.svg": 200,
	"./on_ramp_right.svg": 201,
	"./on_ramp_sharp_left.svg": 202,
	"./on_ramp_sharp_right.svg": 203,
	"./on_ramp_slight_left.svg": 204,
	"./on_ramp_slight_right.svg": 205,
	"./on_ramp_straight.svg": 206,
	"./rotary.svg": 207,
	"./rotary_left.svg": 208,
	"./rotary_right.svg": 209,
	"./rotary_sharp_left.svg": 210,
	"./rotary_sharp_right.svg": 211,
	"./rotary_slight_left.svg": 212,
	"./rotary_slight_right.svg": 213,
	"./rotary_straight.svg": 214,
	"./roundabout.svg": 215,
	"./roundabout_left.svg": 216,
	"./roundabout_right.svg": 217,
	"./roundabout_sharp_left.svg": 218,
	"./roundabout_sharp_right.svg": 219,
	"./roundabout_slight_left.svg": 220,
	"./roundabout_slight_right.svg": 221,
	"./roundabout_straight.svg": 222,
	"./roundabout_turn_left.svg": 223,
	"./turn_left.svg": 224,
	"./turn_right.svg": 225,
	"./turn_sharp_left.svg": 226,
	"./turn_sharp_right.svg": 227,
	"./turn_slight_left.svg": 228,
	"./turn_slight_right.svg": 229,
	"./turn_straight.svg": 230,
	"./updown.svg": 231,
	"./uturn.svg": 232
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getPackageTile: function getPackageTile(hnlSummary) {
      var el = document.createElement('div');
      el.classList.add('home-select-popup', 'card');
      el.innerHTML = '<div class="facade-image">\n          <figure class="image">\n            <img src="' + hnlSummary.imagepath + '" alt="">\n          </figure>\n        </div>';

      var infoEl = document.createElement('div');
      infoEl.classList.add('card-info');
      infoEl.classList.add('pb-0');
      infoEl.classList.add('pt-2');
      infoEl.innerHTML = '\n        <div class="columns is-mobile is-gapless">\n          <div class="column design">\n            <p class="design">' + hnlSummary.designproductname + '</p>\n            <p class="d">' + hnlSummary.buildername + '</p>\n            <p class="mt-2 pr-1">' + hnlSummary.productaddress + '</p>\n          </div>\n          <div class="column is-narrow">\n            <div class="amenities">\n              <div class="amenity">\n                <img src="' + __webpack_require__(2) + '" alt="">\n                  <span>' + hnlSummary.noofbedrooms + '</span>\n              </div>\n              <div class="amenity">\n                <img src="' + __webpack_require__(3) + '" alt="">\n                  <span>' + hnlSummary.noofbathrooms + '</span>\n              </div>\n              <div class="amenity">\n                <img src="' + __webpack_require__(4) + '" alt="">\n                  <span>' + hnlSummary.noofcarparks + '</span>\n              </div>\n            </div>\n            <div class="price">\n              <p class="p">$' + (hnlSummary.planPrice < hnlSummary.productprice ? hnlSummary.planPrice.toLocaleString() : hnlSummary.productprice.toLocaleString()) + '</p>\n            </div>\n          </div>\n        </div>\n      ';
      el.appendChild(infoEl);
      return el;
    },

    getPackageDetailTile: function getPackageDetailTile(hnlSummary) {
      var el = document.createElement('div');
      el.classList.add('home-select-popup', 'card');
      el.innerHTML = '<div class="facade-image">\n          <figure class="image">\n            <img src="' + hnlSummary.imagepath + '" alt="">\n          </figure>\n        </div>';

      var infoEl = document.createElement('div');
      infoEl.classList.add('card-info');
      infoEl.classList.add('pb-0');
      infoEl.classList.add('pt-2');
      infoEl.innerHTML = '\n        <div class="columns is-mobile is-gapless">\n          <div class="column design">\n            <p class="design">' + hnlSummary.designproductname + '</p>\n            <p class="d">' + hnlSummary.buildername + '</p>\n            <p class="mt-2 pr-1">' + hnlSummary.productaddress + '</p>\n          </div>\n          <div class="column is-narrow">\n            <div class="amenities">\n              <div class="amenity">\n                <img src="' + __webpack_require__(2) + '" alt="">\n                  <span>' + hnlSummary.noofbedrooms + '</span>\n              </div>\n              <div class="amenity">\n                <img src="' + __webpack_require__(3) + '" alt="">\n                  <span>' + hnlSummary.noofbathrooms + '</span>\n              </div>\n              <div class="amenity">\n                <img src="' + __webpack_require__(4) + '" alt="">\n                  <span>' + hnlSummary.noofcarparks + '</span>\n              </div>\n            </div>\n          </div>\n        </div>\n      ';
      el.appendChild(infoEl);
      return el;
    },

    getPackageDimensionTile: function getPackageDimensionTile(hnlSummary) {
      return '<div class="columns is-mobile is-gapless">\n            <div class="column dimensions">\n              <div class="dimension">\n                <p class="t">Home Area</p>\n                <p class="d">' + hnlSummary.homesize + '<small> sq ft</small></p>\n              </div>\n\n              <div class="dimension">\n                <p class="t">Elevation</p>\n                <p class="d">' + hnlSummary.facadeproductname + '</p>\n              </div>\n\n              <div class="dimension">\n                <p class="t">Frontage</p>\n                <p class="d">' + hnlSummary.homewidth + '\'</p>\n              </div>\n\n              <div class="dimension">\n                <p class="t">Lot Area</p>\n                <p class="d">' + hnlSummary.lotsize + ' sq ft</p>\n              </div>\n\n              <div class="dimension">\n                <p class="t">Stories</p>\n                <p class="d">' + hnlSummary.noofstoreys + '</p>\n              </div>\n\n              <div class="dimension">\n                <p class="t">Completion</p>\n                <p class="d">' + (hnlSummary.estimatedcompletiondate || 'N/A') + '</p>\n              </div>\n            </div>\n          </div>';
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9099c52e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(256);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9099c52e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeCard_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_989f13e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeCard_vue__ = __webpack_require__(260);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_989f13e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_api__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    favoriteHnl: [],
    favoriteHomes: [],
    favoriteHnlDetail: []
  },
  getters: {
    favoriteHnlIds: function favoriteHnlIds(state) {
      var list = localStorage.getItem('runwayhnllist');
      if (list) {
        return list.split(',');
      }
      return [];
    },

    favoriteHnl: function favoriteHnl(state) {
      return state.favoriteHnl;
    },
    favoriteHnlDetail: function favoriteHnlDetail(state) {
      return state.favoriteHnlDetail;
    },
    favoriteHomes: function favoriteHomes(state) {
      return state.favoriteHomes;
    }
  },
  mutations: {
    setFavoriteHnl: function setFavoriteHnl(state, payload) {
      state.favoriteHnl = payload;
    },
    setFavoriteHnlDetailList: function setFavoriteHnlDetailList(state, payload) {
      state.favoriteHnlDetail = payload;
    },
    setFavoriteHome: function setFavoriteHome(state, payload) {
      state.favoriteHomes = payload;
    }
  },
  actions: {
    removeFavoritesHnl: function removeFavoritesHnl(_ref, id) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          state = _ref.state;

      var list = localStorage.getItem('runwayhnllist');
      if (list) {
        var listArray = list.split(',');
        var index = listArray.indexOf(id);
        if (index > -1) {
          listArray.splice(index, 1);
          var runwayhnllist = listArray.join(',');
          localStorage.setItem('runwayhnllist', runwayhnllist);
          commit('setFavoriteHnl', listArray);
          var hnlIndex = state.favoriteHnlDetail.findIndex(function (item) {
            return item.cpidstring === id;
          });
          if (hnlIndex > -1) {
            state.favoriteHnlDetail.splice(hnlIndex, 1);
            commit('setFavoriteHnlDetailList', state.favoriteHnlDetail);
          }
        }
      }
    },
    setFavoriteHnl: function setFavoriteHnl(_ref2, id) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          state = _ref2.state;

      var list = localStorage.getItem('runwayhnllist');
      if (list) {
        var listArray = list.split(',');
        if (listArray.includes(id)) {
          return;
        } else {
          listArray.push(id);
          commit('setFavoriteHnl', listArray);
          var runwayhnllist = listArray.join(',');
          localStorage.setItem('runwayhnllist', runwayhnllist);
        }
      } else {
        commit('setFavoriteHnl', [id]);
        localStorage.setItem('runwayhnllist', id);
      }
    },
    setFavoriteHome: function setFavoriteHome(_ref3, id) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state;

      var list = localStorage.getItem('runwayhomes');
      if (list) {
        var listArray = list.split(',');
        if (listArray.includes(id)) {
          return;
        } else {
          listArray.push(id);
          commit('setFavoriteHome', listArray);
          var runwayhnllist = listArray.join(',');
          localStorage.setItem('runwayhomes', runwayhnllist);
        }
      } else {
        commit('setFavoriteHome', [id]);
        localStorage.setItem('runwayhomes', id);
      }
    },
    fetchAllFavoritePackageDetail: function fetchAllFavoritePackageDetail(_ref4, payload) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          state = _ref4.state;

      var list = localStorage.getItem('runwayhnllist');
      if (list) {
        var listArray = list.split(',');
        listArray.forEach(function (id) {
          var hnl = state.favoriteHnlDetail.findIndex(function (hnl) {
            return hnl.cpidstring === id;
          });
          if (hnl < 0) {
            dispatch('getFavoritePackageDetail', id);
          }
        });
      }
    },
    setFavoritePackageDetail: function setFavoritePackageDetail(_ref5, payload) {
      var dipatch = _ref5.dipatch,
          commit = _ref5.commit,
          state = _ref5.state;

      var index = state.favoriteHnlDetail.findIndex(function (item) {
        return item.cpidsstrin === payload.cpidstring;
      });
      if (index < 0) {
        state.favoriteHnlDetail.push(payload);
        commit('setFavoriteHnlDetailList', state.favoriteHnlDetail);
      }
    },
    getFavoritePackageDetail: function getFavoritePackageDetail(_ref6, id) {
      var dispatch = _ref6.dispatch,
          commit = _ref6.commit,
          state = _ref6.state;

      __WEBPACK_IMPORTED_MODULE_0__store_api__["a" /* api */].getPackageDetail(id).then(function (res) {
        dispatch("setFavoritePackageDetail", res.data);
      });
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Amenity__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_Tracking__ = __webpack_require__(45);
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'amenity',
  mixins: [],
  data: function data() {
    return {
      poi: null,
      markers: ['transport', 'health', 'education', 'outdoor', 'food', 'shopping', 'childcare']
    };
  },

  components: {
    'app-tracking': __WEBPACK_IMPORTED_MODULE_1__components_journey_Tracking__["a" /* default */]
  },
  watch: {
    poi: function poi(val, oldval) {
      if (val) {
        this.$store.commit("setActivePoi", this.markers);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.poi = this.$store.getters.getPoi;
    this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'setPoi') {
        _this.poi = state.amenityStore.poi;
      }
    });
  },

  methods: {}
});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "transport_line.svg?4f4775dc84f545cc00a6a6b99222c8ff";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "education_line.svg?059c809e4b8ffdee4958bde0576b8338";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "health_line.svg?10c5ccd61f99dffa7ddec99a14678727";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "recreation_line.svg?69ae23ebfeb11b8a009fbda33b4c45f3";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "shop_line.svg?4b0004792c400a66ca896108ed4c026b";

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "food.svg?e5221fc07412f56a3abf74720a24e673";

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "food_line.svg?e1a14706a7b9877c4f75f3c8553f4194";

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TravelMarker; });
var TravelMarker = {
  type: 'FeatureCollection',
  features: [{
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: []
    },
    properties: {
      title: '',
      description: '',
      color: '#4981d4'
    }
  }, {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: []
    },
    properties: {
      title: '',
      description: '',
      color: '#db6363'
    }
  }]
};

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_TravelMarker__ = __webpack_require__(35);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      origin: null,
      travelMethod: 'driving',
      currentBounds: null,
      travelMark: __WEBPACK_IMPORTED_MODULE_0__model_TravelMarker__["a" /* TravelMarker */],
      padding: { top: 100, left: 100, right: 300, bottom: 100 },
      route: null
    };
  },

  watch: {
    route: function route(val, oldVal) {
      if (val) {
        this.setIcons(val.legs[0].steps);
      }
    }
  },
  methods: {
    getDirection: function getDirection(coord, method, reverse, marker) {
      var _this = this;

      if (window.innerWidth < 600) {
        this.padding = { top: 5, left: 50, right: 50, bottom: 5 };
      }
      this.removeTravelMarker();
      this.route = null;
      var end = void 0;
      var origin = void 0;

      if (reverse) {
        end = [this.origin.lng, this.origin.lat];
        origin = coord;
      } else {
        end = coord;
        origin = [this.origin.lng, this.origin.lat];
      }

      if (method) {
        this.travelMethod = method;
      }

      var url = 'https://api.mapbox.com/directions/v5/mapbox/' + this.travelMethod + '/' + origin[0] + ',' + origin[1] + ';' + end[0] + ',' + end[1] + '?steps=true&geometries=geojson&access_token=' + mapboxgl.accessToken;
      fetch(url).then(function (res) {
        if (res.status === 200) {
          return res.json();
        }
      }).then(function (res) {
        var routeInfo = JSON.parse(JSON.stringify(res.routes[0]));
        routeInfo['method'] = _this.travelMethod;
        routeInfo['glink'] = 'https://www.google.com/maps/dir/?api=1&origin=' + origin[0] + ',' + origin[1] + '&destination=' + end[1] + ',' + end[0];
        _this.$store.commit("setRouteInfo", routeInfo);
        var routeData = res.routes[0].geometry.coordinates;
        _this.route = routeInfo;
        var geojson = {
          type: 'FeatureCollection',
          features: [{
            type: 'Feature',
            geometry: {
              type: 'LineString',
              properties: {},
              coordinates: routeData
            }
          }]
        };

        if (_this.map.getSource('LineString')) {
          _this.map.removeLayer('LineString');
          _this.map.removeSource('LineString');
        }

        _this.map.addSource('LineString', {
          type: 'geojson',
          data: geojson
        });

        _this.map.addLayer({
          id: 'LineString',
          type: 'line',
          source: 'LineString',
          layout: {
            'line-join': 'round',
            'line-cap': 'round'
          },
          paint: {
            'line-color': '#406750',
            'line-width': 5
          }
        });

        var routeBounds = new mapboxgl.LngLatBounds();
        _this.currentBounds = routeBounds;

        routeData.forEach(function (coordinate) {
          routeBounds.extend(new mapboxgl.LngLat(coordinate[0], coordinate[1]));
        });

        if (marker) {
          var start = [routeData[0][0], routeData[0][1]];
          var _end = [routeData[routeData.length - 1][0], routeData[routeData.length - 1][1]];
          if (reverse) {
            start = [routeData[routeData.length - 1][0], routeData[routeData.length - 1][1]];
            _end = [routeData[0][0], routeData[0][1]];
          }
          _this.travelMark.features[0].geometry.coordinates = start;
          _this.travelMark.features[1].geometry.coordinates = _end;
          _this.addTravelMarker();
        }

        _this.map.fitBounds(routeBounds, {
          padding: _this.padding
        });
      }).catch(function (err) {
        return err;
      });
    },

    removeDirection: function removeDirection() {
      this.removeTravelMarker();
      this.route = null;

      if (this.map.getSource('LineString')) {
        this.map.removeLayer('LineString');
        this.map.removeSource('LineString');
      }

      if (this.lotBounds) {
        this.map.fitBounds(this.lotBounds, {
          padding: this.padding
        });
      }
    },

    removeTravelMarker: function removeTravelMarker() {
      if (this.map.getSource('travelMarker')) {
        this.map.removeLayer('markerlayer');
        this.map.removeSource('travelMarker');
      }
    },

    addTravelMarker: function addTravelMarker() {
      this.map.addSource('travelMarker', {
        type: 'geojson',
        data: this.travelMark
      });

      this.map.addLayer({
        id: 'markerlayer',
        type: 'circle',
        source: 'travelMarker',
        paint: {
          'circle-radius': 8,
          'circle-color': ['get', 'color'],
          'circle-opacity': 0.8
        }
      });
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(120);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(41);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(41);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(121);
var cookies = __webpack_require__(123);
var buildURL = __webpack_require__(38);
var buildFullPath = __webpack_require__(124);
var parseHeaders = __webpack_require__(127);
var isURLSameOrigin = __webpack_require__(128);
var createError = __webpack_require__(42);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(122);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tracking_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdc6bfce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tracking_vue__ = __webpack_require__(134);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tracking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdc6bfce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tracking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Tracking__ = __webpack_require__(133);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tracking',
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Tracking__["a" /* default */]],
  data: function data() {
    return {
      currentPage: '',
      event: 'Page View',
      productreference: '',
      productId: null,
      productType: null
    };
  },

  watch: {},
  created: function created() {
    this.routeCheck();
  },
  mounted: function mounted() {},

  methods: {
    routeCheck: function routeCheck() {
      var _this = this;

      this.currentPage = this.$route.fullPath;
      var productreference = {
        'Web Page': this.currentPage
      };
      this.$store.dispatch('checkSession', { event: this.event, productreference: productreference, productid: this.productId, producttype: this.productType });

      this.$router.afterEach(function (to, from) {
        _this.productReference = JSON.stringify({
          'Web Page': to.fullPath
        });
        _this.$store.dispatch('checkSession', { event: _this.event, productreference: productreference, productid: _this.productId, producttype: _this.productType });
      });
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  request_type: '',
  capsuleid: '',
  clientid: '',
  fingerprint: '',
  referrer: '',
  trackermessage: '',
  trackersource: '',
  trackeragent: '',
  trackerip: ''
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5795f864_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(144);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5795f864_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Amenity__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nav__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_journey_MapLabel__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'amenity-map',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Amenity__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Common__["a" /* default */]],
  components: {
    'app-sidenav': __WEBPACK_IMPORTED_MODULE_1__Nav__["a" /* default */],
    'app-map-label': __WEBPACK_IMPORTED_MODULE_3__components_journey_MapLabel__["a" /* default */]
  },
  data: function data() {
    return {
      activeMenu: '',
      activePoi: null,
      isPitched: true,
      lotload: null,
      method: 'driving',
      mobileView: false,
      routeInfo: null,
      showRoute: false,
      venues: [],
      isSidebarActive: false
    };
  },

  watch: {
    mapLoad: function mapLoad(val, oldVal) {
      if (val) {
        this.categorisePoi();
      }
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'setActivePoi') {
        _this.clearMap();
        _this.addMarkers(state.amenityStore.activePoi);
      }

      if (mutation.type === 'setActiveVenue') {
        _this.getActiveVenue(state.amenityStore.activeVenue);
      }

      if (mutation.type === 'setDirectionMethod') {
        if (state.amenityStore.directionMethod) {
          _this.travelMethod = state.amenityStore.directionMethod;
          _this.getActiveVenue(state.amenityStore.activeVenue);
        }
      }

      if (mutation.type === 'setActiveTravel') {
        var travel = state.amenityStore.activeTravel;
        if (travel) {
          _this.getDirection(travel.coord, travel.method, travel.swapped, true);
        }
      }

      if (mutation.type === "setRouteInfo") {
        _this.routeInfo = state.amenityStore.routeInfo;
        if (_this.routeInfo && _this.routeInfo.legs && _this.routeInfo.legs.length && _this.routeInfo.legs.length) {
          _this.setIcons(_this.routeInfo.legs[0].steps);
        }
      }

      if (mutation.type === 'zoomToCategory') {
        if (state.amenityStore.category) {
          _this.zoomToCategory(state.amenityStore.category);
        }
      }

      if (mutation.type === 'setMasterplanConfig') {
        if (state.communityStore.masterplanConfig) {
          _this.masterplanConfig = state.communityStore.masterplanConfig;
          _this.loadMap();
        }
      }

      if (mutation.type === 'setUnfilteredSummaryList') {
        _this.lotload = state.communityStore.unfilteredLotSummary;
        _this.loadMap();
      }
    });

    this.$store.dispatch('fetchMasterplanConfig');
    this.$store.dispatch('fetchLotSummaryList');

    this.$router.afterEach(function (to, from) {
      _this.clearMap();
    });
    this.activeMenu = this.$route.name;
    this.mobileView = window.innerWidth <= 600;
  },

  methods: {
    getActiveVenue: function getActiveVenue(activeVenue) {
      var _this2 = this;

      this.activeVenue = activeVenue;
      if (this.activeVenue) {
        if (this.mobileView) {
          this.map.dragPan.disable();
          this.map.scrollZoom.disable();
        }
        this.$store.dispatch('productTracking', { page: 'poi-click', product: { productName: activeVenue.name, category: activeVenue.category } });
        if (this.activeVenue.hasOwnProperty('showRoute')) {
          if (this.activeVenue.showRoute) {
            this.padding = { top: 100, left: 100, right: 400, bottom: 100 };
            this.getDirection([this.activeVenue.longitude, this.activeVenue.latitude]);
          } else {
            this.flyToPoint([this.activeVenue.longitude, this.activeVenue.latitude]);
            this.route = null;
          }
          this.highlightPoi(this.activeVenue);
        }
      } else {
        this.map.scrollZoom.enable();
        this.map.dragPan.enable();
        this.padding = { top: 100, left: 100, right: 100, bottom: 100 };
        this.map.fitBounds(this.masterBound);
        // if (this.markerBounds) {
        //   this.map.fitBounds(this.markerBounds);
        // } else {
        //   this.map.fitBounds(this.masterBound)
        // }
        setTimeout(function () {
          _this2.resize();
        });
      }
    },

    loadMap: function loadMap() {
      if (this.masterplanConfig && this.lotload) {
        this.initMap(this.masterplanConfig, this.lotload);
      }
    },

    changeMethod: function changeMethod(method) {
      this.method = method;
      this.$store.commit("setDirectionMethod", this.method);
    },
    toggle3d: function toggle3d() {
      var pitch = this.isPitched ? 0 : 60;
      this.isPitched = !this.isPitched;
      this.map.flyTo({
        pitch: pitch
      });
    },


    closeRoute: function closeRoute() {
      this.route = null;
      this.clearRoutes();
      this.$store.commit("setActiveVenue", null);
      this.$store.commit("setRouteInfo", null);
    },

    isImage: function isImage(url) {
      return url.match(/\.(jpeg|jpg|gif|png|svg)$/) != null;
    },


    toggleSidebar: function toggleSidebar() {
      this.isSidebarActive = !this.isSidebarActive;
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Amenity__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidenav',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Amenity__["a" /* default */]],
  data: function data() {
    return {
      activeMenu: ''
    };
  },
  mounted: function mounted() {
    this.activeMenu = this.$route.name;
  },

  methods: {
    navigateTo: function navigateTo(url) {
      if (url === '') {
        this.$emit('resetClick', true);
      }
      if (this.activeMenu !== url) {
        this.activeMenu = url;
        var path = '/amenities/' + url;
        this.$router.push({
          path: path
        });
      } else {
        this.$emit('resetClick', true);
      }
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-community-map",
  props: {
    labels: {
      type: Object,
      default: function _default() {
        return {
          available: true,
          sold: true,
          model: true,
          future: true,
          spec: true,
          favorites: false,
          lotsize: false
        };
      }
    }
  },
  mounted: function mounted() {
    // console.log(this.labels);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "driving.svg?cd4520b8aa6b25b207f30a0c6e2aa7ca";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "driving_white.svg?e20e6919ba7f6366ef5b25a092cbdf6c";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cycling.svg?3fc6699fa7fbcff2f331bded5e3281d3";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cycling_white.svg?9a52a3b5b6b0ea62f4af88f6eaa5790d";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "walking.svg?be82c9ebe3b009792593384d624a0530";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "walking_white.svg?d825080d2acea9f8aa4af4cfc68cc606";

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Places__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Common__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'places',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Places__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Common__["a" /* default */]],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.poi = this.$store.getters.getPoi;
    this.checkMutations();
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Travel__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Common__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'travel',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Travel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Common__["a" /* default */]],
  data: function data() {
    return {
      destination: null,
      isSwapped: false
    };
  },

  computed: {},
  watch: {
    masterplanConfig: function masterplanConfig(val, oldval) {
      if (val) {
        this.getOrigin();
      }
    },

    poi: function poi(val, oldVal) {
      if (val) {
        this.$store.commit("setActivePoi", []);
      }
    },

    route: function route(val, oldVal) {
      if (val) {
        this.setIcons(val.legs[0].steps);
      }
      if (!val) {
        this.destination = null;
        this.$store.commit("setActivePoi", []);
      }
    }
  },
  mounted: function mounted() {
    this.listenToMutation();
  },

  methods: {
    swapPlace: function swapPlace() {
      this.isSwapped = !this.isSwapped;
    },

    setDirection: function setDirection() {
      if (this.destinationObject) {
        this.$store.commit("setActiveTravel", {
          coord: this.destinationObject.geometry.coordinates,
          method: this.method,
          swapped: this.isSwapped,
          marker: true
        });
      }
    },

    setDestination: function setDestination(place) {
      this.destinationObject = place;
      this.destination = this.destinationObject.place_name;
      this.predictions = null;
    },

    changeMethod: function changeMethod(method) {
      this.method = method;
      this.setDirection();
    },

    placesSearch: function placesSearch() {
      if (this.destination.length > 2) {
        this.fetchPlacesPrediction(this.destination);
      }
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Community_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd8b6b5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Community_vue__ = __webpack_require__(244);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Community_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd8b6b5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Community_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_journey_Journey__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_Header__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_journey_Disclaimer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_journey_Tracking__ = __webpack_require__(45);
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'community',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_journey_Journey__["a" /* default */]],
  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_1__components_journey_Header__["a" /* default */],
    'app-disclaimer': __WEBPACK_IMPORTED_MODULE_2__components_journey_Disclaimer__["a" /* default */],
    'app-tracking': __WEBPACK_IMPORTED_MODULE_3__components_journey_Tracking__["a" /* default */]
  },
  data: function data() {
    return {
      loaded: false,
      sub: null
    };
  },

  watch: {},
  created: function created() {
    // this.$store.dispatch('fetchMasterplanConfig');
    this.$store.dispatch('fetchHomeSummary');
  },

  methods: {},
  mounted: function mounted() {
    this.$router.afterEach(function (to, from) {
      document.getElementById("header-bar").scrollIntoView();
    });
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeProducts: {
        home: null,
        lot: null,
        facade: null
      },
      activeIds: {
        homeid: null,
        lotid: null,
        lotcpid: null,
        facadeid: null
      },
      sub: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.sub = this.$store.subscribe(function (mutation, state) {
      if (mutation.type === "setHomeDetail") {
        _this.activeProducts.home = state.communityStore.homeDetail;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.sub();
  },

  methods: {
    getIds: function getIds() {
      var query = this.$route.query;
      if (query.homeid) {
        this.activeIds.homeid = query.homeid;
      }
      if (query.lotid) {
        this.activeIds.lotid = query.lotid;
      }
      if (query.lotcpid) {
        this.activeIds.lotcpid = query.lotcpid;
      }
      if (query.facadeid) {
        this.activeIds.facadeid = query.facadeid;
      }
      return this.activeIds;
    },

    goToFacade: function goToFacade() {
      this.getIds();
      if (this.activeIds.lotid && this.activeIds.lotcpid && this.activeIds.homeid) {
        return this.$router.push({
          path: '/community/facade',
          query: {
            homeid: this.activeIds.homeid,
            lotid: this.activeIds.lotid,
            lotcpid: this.activeIds.lotcpid
          }
        });
      } else if (this.activeIds.homeid) {
        return this.$router.push({
          path: '/community/facade',
          query: {
            homeid: this.activeIds.homeid
          }
        });
      }
    },

    goToPackage: function goToPackage() {
      this.getIds();
      if (this.activeIds.lotid && this.activeIds.facadeid && this.activeIds.homeid) {
        var ids = {
          'plancpid': this.activeIds.homeid,
          'lotcpid': this.activeIds.lotid,
          'facadecpid': this.activeIds.facadeid,
          'customerCreated': true,
          'customprice': this.activeProducts.home ? this.activeProducts.home.productprice : null
        };
        this.$store.dispatch('createPackage', ids);
      }
    },

    setIds: function setIds(ids) {
      var _this2 = this;

      ids.forEach(function (id) {
        if (_this2.activeIds.hasOwnProperty(id.key)) {
          _this2.activeIds[id.key] = id.value;
        }
      });
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_659cb7ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(241);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_659cb7ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app-header',
  mixins: [],
  components: {},
  data: function data() {
    return {};
  },

  props: {
    showFavorites: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  created: function created() {},

  methods: {
    startAgain: function startAgain() {
      var origin = this.$route.params.origin;
      if (origin) {
        return this.$router.push({
          path: '/community/move-in/' + origin
        });
      }
      this.$router.push({
        path: '/community'
      });
    },

    viewFavorites: function viewFavorites() {
      var origin = this.$route.params.origin;
      if (origin) {
        return this.$router.push({
          path: '/favorite/' + origin
        });
      }
      this.$router.push({
        path: '/favorite'
      });
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-disclaimer',
  data: function data() {
    return {
      showDisclaimer: false
    };
  },
  mounted: function mounted() {
    this.checkPageView();
  },

  methods: {
    checkPageView: function checkPageView() {
      var view = localStorage.getItem('pageView');
      if (!view) {
        localStorage.setItem('pageView', '1');
        this.showDisclaimer = true;
      }
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_journey_Map__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_land_LandPanel__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_journey_nav_Navigation__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_journey_Loading__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_journey_MapLabel__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-community-map',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_journey_Map__["a" /* default */]],
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_2__components_journey_nav_Navigation__["a" /* default */],
    'app-land-list': __WEBPACK_IMPORTED_MODULE_1__components_journey_land_LandPanel__["a" /* default */],
    'app-loading': __WEBPACK_IMPORTED_MODULE_3__components_journey_Loading__["a" /* default */],
    'app-map-label': __WEBPACK_IMPORTED_MODULE_4__components_journey_MapLabel__["a" /* default */]
  },
  data: function data() {
    return {
      activeClick: null,
      activeHome: null,
      container: 'community-map',
      homesummary: null,
      initiatedMap: false,
      isPitched: false,
      loading: true,
      lotload: null,
      lotView: true,
      masterplanConfig: null,
      masterplanResources: null,
      modelHomes: [],
      sub: null
    };
  },

  watch: {},
  beforeDestroy: function beforeDestroy() {
    if (this.map) {
      this.map.remove();
    }
    this.sub();
  },

  mounted: function mounted() {
    if (this.$store.getters.masterplanConfig) {
      this.masterplanConfig = this.$store.getters.masterplanConfig;
      this.loadMap();
    } else {
      this.$store.dispatch('fetchMasterplanConfig');
    }
    this.initSubscription();
    this.$store.dispatch('getPackageDetailList');
  },
  created: function created() {},

  methods: {
    initSubscription: function initSubscription() {
      var _this = this;

      this.sub = this.$store.subscribe(function (mutation, state) {
        if (mutation.type === 'setMasterplanConfig') {
          _this.masterplanConfig = _this.$store.getters.masterplanConfig;
          _this.loadMap();
        }
        if (mutation.type === 'setPackageDetailList') {
          if (state.communityStore.packageDetailList && state.communityStore.packageDetailList.length) {
            _this.loading = false;
            _this.packageSummaryList = state.communityStore.packageDetailList;
          }
        }

        if (mutation.type === 'setCompatibleLotSummaryList') {
          _this.homesummary = state.communityStore.homeDetail;
          var lotsummary = state.communityStore.compatibleLotSummary;
          _this.lotload = [];
          if (lotsummary) {
            _this.lotload = lotsummary.filter(function (item) {
              return item.monotonyConflict === false && item.active;
            });
          }
          if (_this.lotload.length === 0) {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
              icon: "error",
              title: "There are no compatible lots for the floorplan you have selected. ",
              allowOutsideClick: 'false'
            }).then(function (res) {
              if (res.isConfirmed) {
                _this.goBack();
              }
            });
          }
          _this.loadMap();
        }

        if (mutation.type === 'setUnfilteredSummaryList') {
          _this.lotload = [];
          _this.modelHomes = state.communityStore.modelHomes;
          state.communityStore.unfilteredLotSummary.forEach(function (item) {
            if (item.lotgroup) {
              item.lotgroup = item.lotgroup.replace('ft', "'");
            }
            _this.lotload.push(item);
          });
          _this.loadMap();
        }

        if (mutation.type === 'setLotSummaryList') {
          _this.filterMapLots(state.communityStore.lotsummary);
        }
      });
      this.getIds();
    },

    getIds: function getIds() {
      var query = this.$route.query;
      if (query.homeid && query.facadeid) {
        this.activeHome = {
          homeid: query.homeid,
          facadeid: query.facadeid,
          plancpid: query.plancpid
        };
        this.getCompatibleLots();
        return this.selector = 'lot';
      }
      this.getLots();
      return this.selector = 'home';
    },

    getCompatibleLots: function getCompatibleLots() {
      this.$store.dispatch('fetchCompatibleLotSummaryList', this.activeHome);
    },

    getLots: function getLots() {
      this.$store.dispatch('fetchLotSummaryList');
    },

    selectLot: function selectLot() {
      this.activeClick = null;
    },

    loadMap: function loadMap() {
      if (!this.initiatedMap && this.masterplanConfig && this.lotload) {
        this.initiatedMap = true;
        this.initMap(this.masterplanConfig, this.lotload, this.modelHomes);
      }
    },

    toggle3d: function toggle3d() {
      var pitch = this.isPitched ? 0 : 60;
      this.isPitched = !this.isPitched;
      this.map.flyTo({
        pitch: pitch
      });
    },

    goBack: function goBack() {
      return this.$router.push({
        path: '/community/homes'
      });
    }
  }
});

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

/*!
* sweetalert2 v10.16.9
* Released under the MIT License.
*/
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Sweetalert2 = factory());
}(this, function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  var consolePrefix = 'SweetAlert2:';
  /**
   * Filter the unique values into a new array
   * @param arr
   */

  var uniqueArray = function uniqueArray(arr) {
    var result = [];

    for (var i = 0; i < arr.length; i++) {
      if (result.indexOf(arr[i]) === -1) {
        result.push(arr[i]);
      }
    }

    return result;
  };
  /**
   * Capitalize the first letter of a string
   * @param str
   */

  var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  /**
   * Returns the array of object values (Object.values isn't supported in IE11)
   * @param obj
   */

  var objectValues = function objectValues(obj) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    });
  };
  /**
   * Convert NodeList to Array
   * @param nodeList
   */

  var toArray = function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  };
  /**
   * Standardise console warnings
   * @param message
   */

  var warn = function warn(message) {
    console.warn("".concat(consolePrefix, " ").concat(_typeof(message) === 'object' ? message.join(' ') : message));
  };
  /**
   * Standardise console errors
   * @param message
   */

  var error = function error(message) {
    console.error("".concat(consolePrefix, " ").concat(message));
  };
  /**
   * Private global state for `warnOnce`
   * @type {Array}
   * @private
   */

  var previousWarnOnceMessages = [];
  /**
   * Show a console warning, but only if it hasn't already been shown
   * @param message
   */

  var warnOnce = function warnOnce(message) {
    if (!(previousWarnOnceMessages.indexOf(message) !== -1)) {
      previousWarnOnceMessages.push(message);
      warn(message);
    }
  };
  /**
   * Show a one-time console warning about deprecated params/methods
   */

  var warnAboutDeprecation = function warnAboutDeprecation(deprecatedParam, useInstead) {
    warnOnce("\"".concat(deprecatedParam, "\" is deprecated and will be removed in the next major release. Please use \"").concat(useInstead, "\" instead."));
  };
  /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   * @param arg
   */

  var callIfFunction = function callIfFunction(arg) {
    return typeof arg === 'function' ? arg() : arg;
  };
  var hasToPromiseFn = function hasToPromiseFn(arg) {
    return arg && typeof arg.toPromise === 'function';
  };
  var asPromise = function asPromise(arg) {
    return hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
  };
  var isPromise = function isPromise(arg) {
    return arg && Promise.resolve(arg) === arg;
  };

  var DismissReason = Object.freeze({
    cancel: 'cancel',
    backdrop: 'backdrop',
    close: 'close',
    esc: 'esc',
    timer: 'timer'
  });

  var isJqueryElement = function isJqueryElement(elem) {
    return _typeof(elem) === 'object' && elem.jquery;
  };

  var isElement = function isElement(elem) {
    return elem instanceof Element || isJqueryElement(elem);
  };

  var argsToParams = function argsToParams(args) {
    var params = {};

    if (_typeof(args[0]) === 'object' && !isElement(args[0])) {
      _extends(params, args[0]);
    } else {
      ['title', 'html', 'icon'].forEach(function (name, index) {
        var arg = args[index];

        if (typeof arg === 'string' || isElement(arg)) {
          params[name] = arg;
        } else if (arg !== undefined) {
          error("Unexpected type of ".concat(name, "! Expected \"string\" or \"Element\", got ").concat(_typeof(arg)));
        }
      });
    }

    return params;
  };

  var swalPrefix = 'swal2-';
  var prefix = function prefix(items) {
    var result = {};

    for (var i in items) {
      result[items[i]] = swalPrefix + items[i];
    }

    return result;
  };
  var swalClasses = prefix(['container', 'shown', 'height-auto', 'iosfix', 'popup', 'modal', 'no-backdrop', 'no-transition', 'toast', 'toast-shown', 'show', 'hide', 'close', 'title', 'header', 'content', 'html-container', 'actions', 'confirm', 'deny', 'cancel', 'footer', 'icon', 'icon-content', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'label', 'textarea', 'inputerror', 'input-label', 'validation-message', 'progress-steps', 'active-progress-step', 'progress-step', 'progress-step-line', 'loader', 'loading', 'styled', 'top', 'top-start', 'top-end', 'top-left', 'top-right', 'center', 'center-start', 'center-end', 'center-left', 'center-right', 'bottom', 'bottom-start', 'bottom-end', 'bottom-left', 'bottom-right', 'grow-row', 'grow-column', 'grow-fullscreen', 'rtl', 'timer-progress-bar', 'timer-progress-bar-container', 'scrollbar-measure', 'icon-success', 'icon-warning', 'icon-info', 'icon-question', 'icon-error']);
  var iconTypes = prefix(['success', 'warning', 'info', 'question', 'error']);

  var getContainer = function getContainer() {
    return document.body.querySelector(".".concat(swalClasses.container));
  };
  var elementBySelector = function elementBySelector(selectorString) {
    var container = getContainer();
    return container ? container.querySelector(selectorString) : null;
  };

  var elementByClass = function elementByClass(className) {
    return elementBySelector(".".concat(className));
  };

  var getPopup = function getPopup() {
    return elementByClass(swalClasses.popup);
  };
  var getIcon = function getIcon() {
    return elementByClass(swalClasses.icon);
  };
  var getTitle = function getTitle() {
    return elementByClass(swalClasses.title);
  };
  var getContent = function getContent() {
    return elementByClass(swalClasses.content);
  };
  var getHtmlContainer = function getHtmlContainer() {
    return elementByClass(swalClasses['html-container']);
  };
  var getImage = function getImage() {
    return elementByClass(swalClasses.image);
  };
  var getProgressSteps = function getProgressSteps() {
    return elementByClass(swalClasses['progress-steps']);
  };
  var getValidationMessage = function getValidationMessage() {
    return elementByClass(swalClasses['validation-message']);
  };
  var getConfirmButton = function getConfirmButton() {
    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.confirm));
  };
  var getDenyButton = function getDenyButton() {
    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.deny));
  };
  var getInputLabel = function getInputLabel() {
    return elementByClass(swalClasses['input-label']);
  };
  var getLoader = function getLoader() {
    return elementBySelector(".".concat(swalClasses.loader));
  };
  var getCancelButton = function getCancelButton() {
    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.cancel));
  };
  var getActions = function getActions() {
    return elementByClass(swalClasses.actions);
  };
  var getHeader = function getHeader() {
    return elementByClass(swalClasses.header);
  };
  var getFooter = function getFooter() {
    return elementByClass(swalClasses.footer);
  };
  var getTimerProgressBar = function getTimerProgressBar() {
    return elementByClass(swalClasses['timer-progress-bar']);
  };
  var getCloseButton = function getCloseButton() {
    return elementByClass(swalClasses.close);
  }; // https://github.com/jkup/focusable/blob/master/index.js

  var focusable = "\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex=\"0\"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n";
  var getFocusableElements = function getFocusableElements() {
    var focusableElementsWithTabindex = toArray(getPopup().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])')) // sort according to tabindex
    .sort(function (a, b) {
      a = parseInt(a.getAttribute('tabindex'));
      b = parseInt(b.getAttribute('tabindex'));

      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      }

      return 0;
    });
    var otherFocusableElements = toArray(getPopup().querySelectorAll(focusable)).filter(function (el) {
      return el.getAttribute('tabindex') !== '-1';
    });
    return uniqueArray(focusableElementsWithTabindex.concat(otherFocusableElements)).filter(function (el) {
      return isVisible(el);
    });
  };
  var isModal = function isModal() {
    return !isToast() && !document.body.classList.contains(swalClasses['no-backdrop']);
  };
  var isToast = function isToast() {
    return document.body.classList.contains(swalClasses['toast-shown']);
  };
  var isLoading = function isLoading() {
    return getPopup().hasAttribute('data-loading');
  };

  var states = {
    previousBodyPadding: null
  };
  var setInnerHtml = function setInnerHtml(elem, html) {
    // #1926
    elem.textContent = '';

    if (html) {
      var parser = new DOMParser();
      var parsed = parser.parseFromString(html, "text/html");
      toArray(parsed.querySelector('head').childNodes).forEach(function (child) {
        elem.appendChild(child);
      });
      toArray(parsed.querySelector('body').childNodes).forEach(function (child) {
        elem.appendChild(child);
      });
    }
  };
  var hasClass = function hasClass(elem, className) {
    if (!className) {
      return false;
    }

    var classList = className.split(/\s+/);

    for (var i = 0; i < classList.length; i++) {
      if (!elem.classList.contains(classList[i])) {
        return false;
      }
    }

    return true;
  };

  var removeCustomClasses = function removeCustomClasses(elem, params) {
    toArray(elem.classList).forEach(function (className) {
      if (!(objectValues(swalClasses).indexOf(className) !== -1) && !(objectValues(iconTypes).indexOf(className) !== -1) && !(objectValues(params.showClass).indexOf(className) !== -1)) {
        elem.classList.remove(className);
      }
    });
  };

  var applyCustomClass = function applyCustomClass(elem, params, className) {
    removeCustomClasses(elem, params);

    if (params.customClass && params.customClass[className]) {
      if (typeof params.customClass[className] !== 'string' && !params.customClass[className].forEach) {
        return warn("Invalid type of customClass.".concat(className, "! Expected string or iterable object, got \"").concat(_typeof(params.customClass[className]), "\""));
      }

      addClass(elem, params.customClass[className]);
    }
  };
  function getInput(content, inputType) {
    if (!inputType) {
      return null;
    }

    switch (inputType) {
      case 'select':
      case 'textarea':
      case 'file':
        return getChildByClass(content, swalClasses[inputType]);

      case 'checkbox':
        return content.querySelector(".".concat(swalClasses.checkbox, " input"));

      case 'radio':
        return content.querySelector(".".concat(swalClasses.radio, " input:checked")) || content.querySelector(".".concat(swalClasses.radio, " input:first-child"));

      case 'range':
        return content.querySelector(".".concat(swalClasses.range, " input"));

      default:
        return getChildByClass(content, swalClasses.input);
    }
  }
  var focusInput = function focusInput(input) {
    input.focus(); // place cursor at end of text in text input

    if (input.type !== 'file') {
      // http://stackoverflow.com/a/2345915
      var val = input.value;
      input.value = '';
      input.value = val;
    }
  };
  var toggleClass = function toggleClass(target, classList, condition) {
    if (!target || !classList) {
      return;
    }

    if (typeof classList === 'string') {
      classList = classList.split(/\s+/).filter(Boolean);
    }

    classList.forEach(function (className) {
      if (target.forEach) {
        target.forEach(function (elem) {
          condition ? elem.classList.add(className) : elem.classList.remove(className);
        });
      } else {
        condition ? target.classList.add(className) : target.classList.remove(className);
      }
    });
  };
  var addClass = function addClass(target, classList) {
    toggleClass(target, classList, true);
  };
  var removeClass = function removeClass(target, classList) {
    toggleClass(target, classList, false);
  };
  var getChildByClass = function getChildByClass(elem, className) {
    for (var i = 0; i < elem.childNodes.length; i++) {
      if (hasClass(elem.childNodes[i], className)) {
        return elem.childNodes[i];
      }
    }
  };
  var applyNumericalStyle = function applyNumericalStyle(elem, property, value) {
    if (value === "".concat(parseInt(value))) {
      value = parseInt(value);
    }

    if (value || parseInt(value) === 0) {
      elem.style[property] = typeof value === 'number' ? "".concat(value, "px") : value;
    } else {
      elem.style.removeProperty(property);
    }
  };
  var show = function show(elem) {
    var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
    elem.style.display = display;
  };
  var hide = function hide(elem) {
    elem.style.display = 'none';
  };
  var setStyle = function setStyle(parent, selector, property, value) {
    var el = parent.querySelector(selector);

    if (el) {
      el.style[property] = value;
    }
  };
  var toggle = function toggle(elem, condition, display) {
    condition ? show(elem, display) : hide(elem);
  }; // borrowed from jquery $(elem).is(':visible') implementation

  var isVisible = function isVisible(elem) {
    return !!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
  };
  var allButtonsAreHidden = function allButtonsAreHidden() {
    return !isVisible(getConfirmButton()) && !isVisible(getDenyButton()) && !isVisible(getCancelButton());
  };
  var isScrollable = function isScrollable(elem) {
    return !!(elem.scrollHeight > elem.clientHeight);
  }; // borrowed from https://stackoverflow.com/a/46352119

  var hasCssAnimation = function hasCssAnimation(elem) {
    var style = window.getComputedStyle(elem);
    var animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
    var transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
    return animDuration > 0 || transDuration > 0;
  };
  var contains = function contains(haystack, needle) {
    if (typeof haystack.contains === 'function') {
      return haystack.contains(needle);
    }
  };
  var animateTimerProgressBar = function animateTimerProgressBar(timer) {
    var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var timerProgressBar = getTimerProgressBar();

    if (isVisible(timerProgressBar)) {
      if (reset) {
        timerProgressBar.style.transition = 'none';
        timerProgressBar.style.width = '100%';
      }

      setTimeout(function () {
        timerProgressBar.style.transition = "width ".concat(timer / 1000, "s linear");
        timerProgressBar.style.width = '0%';
      }, 10);
    }
  };
  var stopTimerProgressBar = function stopTimerProgressBar() {
    var timerProgressBar = getTimerProgressBar();
    var timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
    timerProgressBar.style.removeProperty('transition');
    timerProgressBar.style.width = '100%';
    var timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
    var timerProgressBarPercent = parseInt(timerProgressBarWidth / timerProgressBarFullWidth * 100);
    timerProgressBar.style.removeProperty('transition');
    timerProgressBar.style.width = "".concat(timerProgressBarPercent, "%");
  };

  // Detect Node env
  var isNodeEnv = function isNodeEnv() {
    return typeof window === 'undefined' || typeof document === 'undefined';
  };

  var sweetHTML = "\n <div aria-labelledby=\"".concat(swalClasses.title, "\" aria-describedby=\"").concat(swalClasses.content, "\" class=\"").concat(swalClasses.popup, "\" tabindex=\"-1\">\n   <div class=\"").concat(swalClasses.header, "\">\n     <ul class=\"").concat(swalClasses['progress-steps'], "\"></ul>\n     <div class=\"").concat(swalClasses.icon, "\"></div>\n     <img class=\"").concat(swalClasses.image, "\" />\n     <h2 class=\"").concat(swalClasses.title, "\" id=\"").concat(swalClasses.title, "\"></h2>\n     <button type=\"button\" class=\"").concat(swalClasses.close, "\"></button>\n   </div>\n   <div class=\"").concat(swalClasses.content, "\">\n     <div id=\"").concat(swalClasses.content, "\" class=\"").concat(swalClasses['html-container'], "\"></div>\n     <input class=\"").concat(swalClasses.input, "\" />\n     <input type=\"file\" class=\"").concat(swalClasses.file, "\" />\n     <div class=\"").concat(swalClasses.range, "\">\n       <input type=\"range\" />\n       <output></output>\n     </div>\n     <select class=\"").concat(swalClasses.select, "\"></select>\n     <div class=\"").concat(swalClasses.radio, "\"></div>\n     <label for=\"").concat(swalClasses.checkbox, "\" class=\"").concat(swalClasses.checkbox, "\">\n       <input type=\"checkbox\" />\n       <span class=\"").concat(swalClasses.label, "\"></span>\n     </label>\n     <textarea class=\"").concat(swalClasses.textarea, "\"></textarea>\n     <div class=\"").concat(swalClasses['validation-message'], "\" id=\"").concat(swalClasses['validation-message'], "\"></div>\n   </div>\n   <div class=\"").concat(swalClasses.actions, "\">\n     <div class=\"").concat(swalClasses.loader, "\"></div>\n     <button type=\"button\" class=\"").concat(swalClasses.confirm, "\"></button>\n     <button type=\"button\" class=\"").concat(swalClasses.deny, "\"></button>\n     <button type=\"button\" class=\"").concat(swalClasses.cancel, "\"></button>\n   </div>\n   <div class=\"").concat(swalClasses.footer, "\"></div>\n   <div class=\"").concat(swalClasses['timer-progress-bar-container'], "\">\n     <div class=\"").concat(swalClasses['timer-progress-bar'], "\"></div>\n   </div>\n </div>\n").replace(/(^|\n)\s*/g, '');

  var resetOldContainer = function resetOldContainer() {
    var oldContainer = getContainer();

    if (!oldContainer) {
      return false;
    }

    oldContainer.parentNode.removeChild(oldContainer);
    removeClass([document.documentElement, document.body], [swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['has-column']]);
    return true;
  };

  var oldInputVal; // IE11 workaround, see #1109 for details

  var resetValidationMessage = function resetValidationMessage(e) {
    if (Swal.isVisible() && oldInputVal !== e.target.value) {
      Swal.resetValidationMessage();
    }

    oldInputVal = e.target.value;
  };

  var addInputChangeListeners = function addInputChangeListeners() {
    var content = getContent();
    var input = getChildByClass(content, swalClasses.input);
    var file = getChildByClass(content, swalClasses.file);
    var range = content.querySelector(".".concat(swalClasses.range, " input"));
    var rangeOutput = content.querySelector(".".concat(swalClasses.range, " output"));
    var select = getChildByClass(content, swalClasses.select);
    var checkbox = content.querySelector(".".concat(swalClasses.checkbox, " input"));
    var textarea = getChildByClass(content, swalClasses.textarea);
    input.oninput = resetValidationMessage;
    file.onchange = resetValidationMessage;
    select.onchange = resetValidationMessage;
    checkbox.onchange = resetValidationMessage;
    textarea.oninput = resetValidationMessage;

    range.oninput = function (e) {
      resetValidationMessage(e);
      rangeOutput.value = range.value;
    };

    range.onchange = function (e) {
      resetValidationMessage(e);
      range.nextSibling.value = range.value;
    };
  };

  var getTarget = function getTarget(target) {
    return typeof target === 'string' ? document.querySelector(target) : target;
  };

  var setupAccessibility = function setupAccessibility(params) {
    var popup = getPopup();
    popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
    popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');

    if (!params.toast) {
      popup.setAttribute('aria-modal', 'true');
    }
  };

  var setupRTL = function setupRTL(targetElement) {
    if (window.getComputedStyle(targetElement).direction === 'rtl') {
      addClass(getContainer(), swalClasses.rtl);
    }
  };
  /*
   * Add modal + backdrop to DOM
   */


  var init = function init(params) {
    // Clean up the old popup container if it exists
    var oldContainerExisted = resetOldContainer();
    /* istanbul ignore if */

    if (isNodeEnv()) {
      error('SweetAlert2 requires document to initialize');
      return;
    }

    var container = document.createElement('div');
    container.className = swalClasses.container;

    if (oldContainerExisted) {
      addClass(container, swalClasses['no-transition']);
    }

    setInnerHtml(container, sweetHTML);
    var targetElement = getTarget(params.target);
    targetElement.appendChild(container);
    setupAccessibility(params);
    setupRTL(targetElement);
    addInputChangeListeners();
  };

  var parseHtmlToContainer = function parseHtmlToContainer(param, target) {
    // DOM element
    if (param instanceof HTMLElement) {
      target.appendChild(param); // Object
    } else if (_typeof(param) === 'object') {
      handleObject(param, target); // Plain string
    } else if (param) {
      setInnerHtml(target, param);
    }
  };

  var handleObject = function handleObject(param, target) {
    // JQuery element(s)
    if (param.jquery) {
      handleJqueryElem(target, param); // For other objects use their string representation
    } else {
      setInnerHtml(target, param.toString());
    }
  };

  var handleJqueryElem = function handleJqueryElem(target, elem) {
    target.textContent = '';

    if (0 in elem) {
      for (var i = 0; (i in elem); i++) {
        target.appendChild(elem[i].cloneNode(true));
      }
    } else {
      target.appendChild(elem.cloneNode(true));
    }
  };

  var animationEndEvent = function () {
    // Prevent run in Node env

    /* istanbul ignore if */
    if (isNodeEnv()) {
      return false;
    }

    var testEl = document.createElement('div');
    var transEndEventNames = {
      WebkitAnimation: 'webkitAnimationEnd',
      OAnimation: 'oAnimationEnd oanimationend',
      animation: 'animationend'
    };

    for (var i in transEndEventNames) {
      if (Object.prototype.hasOwnProperty.call(transEndEventNames, i) && typeof testEl.style[i] !== 'undefined') {
        return transEndEventNames[i];
      }
    }

    return false;
  }();

  // https://github.com/twbs/bootstrap/blob/master/js/src/modal.js

  var measureScrollbar = function measureScrollbar() {
    var scrollDiv = document.createElement('div');
    scrollDiv.className = swalClasses['scrollbar-measure'];
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  };

  var renderActions = function renderActions(instance, params) {
    var actions = getActions();
    var loader = getLoader();
    var confirmButton = getConfirmButton();
    var denyButton = getDenyButton();
    var cancelButton = getCancelButton(); // Actions (buttons) wrapper

    if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) {
      hide(actions);
    } // Custom class


    applyCustomClass(actions, params, 'actions'); // Render buttons

    renderButton(confirmButton, 'confirm', params);
    renderButton(denyButton, 'deny', params);
    renderButton(cancelButton, 'cancel', params);
    handleButtonsStyling(confirmButton, denyButton, cancelButton, params);

    if (params.reverseButtons) {
      actions.insertBefore(cancelButton, loader);
      actions.insertBefore(denyButton, loader);
      actions.insertBefore(confirmButton, loader);
    } // Loader


    setInnerHtml(loader, params.loaderHtml);
    applyCustomClass(loader, params, 'loader');
  };

  function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
    if (!params.buttonsStyling) {
      return removeClass([confirmButton, denyButton, cancelButton], swalClasses.styled);
    }

    addClass([confirmButton, denyButton, cancelButton], swalClasses.styled); // Buttons background colors

    if (params.confirmButtonColor) {
      confirmButton.style.backgroundColor = params.confirmButtonColor;
    }

    if (params.denyButtonColor) {
      denyButton.style.backgroundColor = params.denyButtonColor;
    }

    if (params.cancelButtonColor) {
      cancelButton.style.backgroundColor = params.cancelButtonColor;
    }
  }

  function renderButton(button, buttonType, params) {
    toggle(button, params["show".concat(capitalizeFirstLetter(buttonType), "Button")], 'inline-block');
    setInnerHtml(button, params["".concat(buttonType, "ButtonText")]); // Set caption text

    button.setAttribute('aria-label', params["".concat(buttonType, "ButtonAriaLabel")]); // ARIA label
    // Add buttons custom classes

    button.className = swalClasses[buttonType];
    applyCustomClass(button, params, "".concat(buttonType, "Button"));
    addClass(button, params["".concat(buttonType, "ButtonClass")]);
  }

  function handleBackdropParam(container, backdrop) {
    if (typeof backdrop === 'string') {
      container.style.background = backdrop;
    } else if (!backdrop) {
      addClass([document.documentElement, document.body], swalClasses['no-backdrop']);
    }
  }

  function handlePositionParam(container, position) {
    if (position in swalClasses) {
      addClass(container, swalClasses[position]);
    } else {
      warn('The "position" parameter is not valid, defaulting to "center"');
      addClass(container, swalClasses.center);
    }
  }

  function handleGrowParam(container, grow) {
    if (grow && typeof grow === 'string') {
      var growClass = "grow-".concat(grow);

      if (growClass in swalClasses) {
        addClass(container, swalClasses[growClass]);
      }
    }
  }

  var renderContainer = function renderContainer(instance, params) {
    var container = getContainer();

    if (!container) {
      return;
    }

    handleBackdropParam(container, params.backdrop);

    if (!params.backdrop && params.allowOutsideClick) {
      warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
    }

    handlePositionParam(container, params.position);
    handleGrowParam(container, params.grow); // Custom class

    applyCustomClass(container, params, 'container'); // Set queue step attribute for getQueueStep() method

    var queueStep = document.body.getAttribute('data-swal2-queue-step');

    if (queueStep) {
      container.setAttribute('data-queue-step', queueStep);
      document.body.removeAttribute('data-swal2-queue-step');
    }
  };

  /**
   * This module containts `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */
  var privateProps = {
    promise: new WeakMap(),
    innerParams: new WeakMap(),
    domCache: new WeakMap()
  };

  var inputTypes = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];
  var renderInput = function renderInput(instance, params) {
    var content = getContent();
    var innerParams = privateProps.innerParams.get(instance);
    var rerender = !innerParams || params.input !== innerParams.input;
    inputTypes.forEach(function (inputType) {
      var inputClass = swalClasses[inputType];
      var inputContainer = getChildByClass(content, inputClass); // set attributes

      setAttributes(inputType, params.inputAttributes); // set class

      inputContainer.className = inputClass;

      if (rerender) {
        hide(inputContainer);
      }
    });

    if (params.input) {
      if (rerender) {
        showInput(params);
      } // set custom class


      setCustomClass(params);
    }
  };

  var showInput = function showInput(params) {
    if (!renderInputType[params.input]) {
      return error("Unexpected type of input! Expected \"text\", \"email\", \"password\", \"number\", \"tel\", \"select\", \"radio\", \"checkbox\", \"textarea\", \"file\" or \"url\", got \"".concat(params.input, "\""));
    }

    var inputContainer = getInputContainer(params.input);
    var input = renderInputType[params.input](inputContainer, params);
    show(input); // input autofocus

    setTimeout(function () {
      focusInput(input);
    });
  };

  var removeAttributes = function removeAttributes(input) {
    for (var i = 0; i < input.attributes.length; i++) {
      var attrName = input.attributes[i].name;

      if (!(['type', 'value', 'style'].indexOf(attrName) !== -1)) {
        input.removeAttribute(attrName);
      }
    }
  };

  var setAttributes = function setAttributes(inputType, inputAttributes) {
    var input = getInput(getContent(), inputType);

    if (!input) {
      return;
    }

    removeAttributes(input);

    for (var attr in inputAttributes) {
      // Do not set a placeholder for <input type="range">
      // it'll crash Edge, #1298
      if (inputType === 'range' && attr === 'placeholder') {
        continue;
      }

      input.setAttribute(attr, inputAttributes[attr]);
    }
  };

  var setCustomClass = function setCustomClass(params) {
    var inputContainer = getInputContainer(params.input);

    if (params.customClass) {
      addClass(inputContainer, params.customClass.input);
    }
  };

  var setInputPlaceholder = function setInputPlaceholder(input, params) {
    if (!input.placeholder || params.inputPlaceholder) {
      input.placeholder = params.inputPlaceholder;
    }
  };

  var setInputLabel = function setInputLabel(input, prependTo, params) {
    if (params.inputLabel) {
      input.id = swalClasses.input;
      var label = document.createElement('label');
      var labelClass = swalClasses['input-label'];
      label.setAttribute('for', input.id);
      label.className = labelClass;
      addClass(label, params.customClass.inputLabel);
      label.innerText = params.inputLabel;
      prependTo.insertAdjacentElement('beforebegin', label);
    }
  };

  var getInputContainer = function getInputContainer(inputType) {
    var inputClass = swalClasses[inputType] ? swalClasses[inputType] : swalClasses.input;
    return getChildByClass(getContent(), inputClass);
  };

  var renderInputType = {};

  renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = function (input, params) {
    if (typeof params.inputValue === 'string' || typeof params.inputValue === 'number') {
      input.value = params.inputValue;
    } else if (!isPromise(params.inputValue)) {
      warn("Unexpected type of inputValue! Expected \"string\", \"number\" or \"Promise\", got \"".concat(_typeof(params.inputValue), "\""));
    }

    setInputLabel(input, input, params);
    setInputPlaceholder(input, params);
    input.type = params.input;
    return input;
  };

  renderInputType.file = function (input, params) {
    setInputLabel(input, input, params);
    setInputPlaceholder(input, params);
    return input;
  };

  renderInputType.range = function (range, params) {
    var rangeInput = range.querySelector('input');
    var rangeOutput = range.querySelector('output');
    rangeInput.value = params.inputValue;
    rangeInput.type = params.input;
    rangeOutput.value = params.inputValue;
    setInputLabel(rangeInput, range, params);
    return range;
  };

  renderInputType.select = function (select, params) {
    select.textContent = '';

    if (params.inputPlaceholder) {
      var placeholder = document.createElement('option');
      setInnerHtml(placeholder, params.inputPlaceholder);
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.selected = true;
      select.appendChild(placeholder);
    }

    setInputLabel(select, select, params);
    return select;
  };

  renderInputType.radio = function (radio) {
    radio.textContent = '';
    return radio;
  };

  renderInputType.checkbox = function (checkboxContainer, params) {
    var checkbox = getInput(getContent(), 'checkbox');
    checkbox.value = 1;
    checkbox.id = swalClasses.checkbox;
    checkbox.checked = Boolean(params.inputValue);
    var label = checkboxContainer.querySelector('span');
    setInnerHtml(label, params.inputPlaceholder);
    return checkboxContainer;
  };

  renderInputType.textarea = function (textarea, params) {
    textarea.value = params.inputValue;
    setInputPlaceholder(textarea, params);
    setInputLabel(textarea, textarea, params);

    var getPadding = function getPadding(el) {
      return parseInt(window.getComputedStyle(el).paddingLeft) + parseInt(window.getComputedStyle(el).paddingRight);
    };

    if ('MutationObserver' in window) {
      // #1699
      var initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);

      var outputsize = function outputsize() {
        var contentWidth = textarea.offsetWidth + getPadding(getPopup()) + getPadding(getContent());

        if (contentWidth > initialPopupWidth) {
          getPopup().style.width = "".concat(contentWidth, "px");
        } else {
          getPopup().style.width = null;
        }
      };

      new MutationObserver(outputsize).observe(textarea, {
        attributes: true,
        attributeFilter: ['style']
      });
    }

    return textarea;
  };

  var renderContent = function renderContent(instance, params) {
    var htmlContainer = getHtmlContainer();
    applyCustomClass(htmlContainer, params, 'htmlContainer'); // Content as HTML

    if (params.html) {
      parseHtmlToContainer(params.html, htmlContainer);
      show(htmlContainer, 'block'); // Content as plain text
    } else if (params.text) {
      htmlContainer.textContent = params.text;
      show(htmlContainer, 'block'); // No content
    } else {
      hide(htmlContainer);
    }

    renderInput(instance, params); // Custom class

    applyCustomClass(getContent(), params, 'content');
  };

  var renderFooter = function renderFooter(instance, params) {
    var footer = getFooter();
    toggle(footer, params.footer);

    if (params.footer) {
      parseHtmlToContainer(params.footer, footer);
    } // Custom class


    applyCustomClass(footer, params, 'footer');
  };

  var renderCloseButton = function renderCloseButton(instance, params) {
    var closeButton = getCloseButton();
    setInnerHtml(closeButton, params.closeButtonHtml); // Custom class

    applyCustomClass(closeButton, params, 'closeButton');
    toggle(closeButton, params.showCloseButton);
    closeButton.setAttribute('aria-label', params.closeButtonAriaLabel);
  };

  var renderIcon = function renderIcon(instance, params) {
    var innerParams = privateProps.innerParams.get(instance);
    var icon = getIcon(); // if the given icon already rendered, apply the styling without re-rendering the icon

    if (innerParams && params.icon === innerParams.icon) {
      // Custom or default content
      setContent(icon, params);
      applyStyles(icon, params);
      return;
    }

    if (!params.icon && !params.iconHtml) {
      return hide(icon);
    }

    if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
      error("Unknown icon! Expected \"success\", \"error\", \"warning\", \"info\" or \"question\", got \"".concat(params.icon, "\""));
      return hide(icon);
    }

    show(icon); // Custom or default content

    setContent(icon, params);
    applyStyles(icon, params); // Animate icon

    addClass(icon, params.showClass.icon);
  };

  var applyStyles = function applyStyles(icon, params) {
    for (var iconType in iconTypes) {
      if (params.icon !== iconType) {
        removeClass(icon, iconTypes[iconType]);
      }
    }

    addClass(icon, iconTypes[params.icon]); // Icon color

    setColor(icon, params); // Success icon background color

    adjustSuccessIconBackgoundColor(); // Custom class

    applyCustomClass(icon, params, 'icon');
  }; // Adjust success icon background color to match the popup background color


  var adjustSuccessIconBackgoundColor = function adjustSuccessIconBackgoundColor() {
    var popup = getPopup();
    var popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
    var successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');

    for (var i = 0; i < successIconParts.length; i++) {
      successIconParts[i].style.backgroundColor = popupBackgroundColor;
    }
  };

  var setContent = function setContent(icon, params) {
    icon.textContent = '';

    if (params.iconHtml) {
      setInnerHtml(icon, iconContent(params.iconHtml));
    } else if (params.icon === 'success') {
      setInnerHtml(icon, "\n      <div class=\"swal2-success-circular-line-left\"></div>\n      <span class=\"swal2-success-line-tip\"></span> <span class=\"swal2-success-line-long\"></span>\n      <div class=\"swal2-success-ring\"></div> <div class=\"swal2-success-fix\"></div>\n      <div class=\"swal2-success-circular-line-right\"></div>\n    ");
    } else if (params.icon === 'error') {
      setInnerHtml(icon, "\n      <span class=\"swal2-x-mark\">\n        <span class=\"swal2-x-mark-line-left\"></span>\n        <span class=\"swal2-x-mark-line-right\"></span>\n      </span>\n    ");
    } else {
      var defaultIconHtml = {
        question: '?',
        warning: '!',
        info: 'i'
      };
      setInnerHtml(icon, iconContent(defaultIconHtml[params.icon]));
    }
  };

  var setColor = function setColor(icon, params) {
    if (!params.iconColor) {
      return;
    }

    icon.style.color = params.iconColor;
    icon.style.borderColor = params.iconColor;

    for (var _i = 0, _arr = ['.swal2-success-line-tip', '.swal2-success-line-long', '.swal2-x-mark-line-left', '.swal2-x-mark-line-right']; _i < _arr.length; _i++) {
      var sel = _arr[_i];
      setStyle(icon, sel, 'backgroundColor', params.iconColor);
    }

    setStyle(icon, '.swal2-success-ring', 'borderColor', params.iconColor);
  };

  var iconContent = function iconContent(content) {
    return "<div class=\"".concat(swalClasses['icon-content'], "\">").concat(content, "</div>");
  };

  var renderImage = function renderImage(instance, params) {
    var image = getImage();

    if (!params.imageUrl) {
      return hide(image);
    }

    show(image, ''); // Src, alt

    image.setAttribute('src', params.imageUrl);
    image.setAttribute('alt', params.imageAlt); // Width, height

    applyNumericalStyle(image, 'width', params.imageWidth);
    applyNumericalStyle(image, 'height', params.imageHeight); // Class

    image.className = swalClasses.image;
    applyCustomClass(image, params, 'image');
  };

  var currentSteps = [];
  /*
   * Global function for chaining sweetAlert popups
   */

  var queue = function queue(steps) {
    warnAboutDeprecation('Swal.queue()', "async/await");
    var Swal = this;
    currentSteps = steps;

    var resetAndResolve = function resetAndResolve(resolve, value) {
      currentSteps = [];
      resolve(value);
    };

    var queueResult = [];
    return new Promise(function (resolve) {
      (function step(i, callback) {
        if (i < currentSteps.length) {
          document.body.setAttribute('data-swal2-queue-step', i);
          Swal.fire(currentSteps[i]).then(function (result) {
            if (typeof result.value !== 'undefined') {
              queueResult.push(result.value);
              step(i + 1, callback);
            } else {
              resetAndResolve(resolve, {
                dismiss: result.dismiss
              });
            }
          });
        } else {
          resetAndResolve(resolve, {
            value: queueResult
          });
        }
      })(0);
    });
  };
  /*
   * Global function for getting the index of current popup in queue
   */

  var getQueueStep = function getQueueStep() {
    return getContainer() && getContainer().getAttribute('data-queue-step');
  };
  /*
   * Global function for inserting a popup to the queue
   */

  var insertQueueStep = function insertQueueStep(step, index) {
    if (index && index < currentSteps.length) {
      return currentSteps.splice(index, 0, step);
    }

    return currentSteps.push(step);
  };
  /*
   * Global function for deleting a popup from the queue
   */

  var deleteQueueStep = function deleteQueueStep(index) {
    if (typeof currentSteps[index] !== 'undefined') {
      currentSteps.splice(index, 1);
    }
  };

  var createStepElement = function createStepElement(step) {
    var stepEl = document.createElement('li');
    addClass(stepEl, swalClasses['progress-step']);
    setInnerHtml(stepEl, step);
    return stepEl;
  };

  var createLineElement = function createLineElement(params) {
    var lineEl = document.createElement('li');
    addClass(lineEl, swalClasses['progress-step-line']);

    if (params.progressStepsDistance) {
      lineEl.style.width = params.progressStepsDistance;
    }

    return lineEl;
  };

  var renderProgressSteps = function renderProgressSteps(instance, params) {
    var progressStepsContainer = getProgressSteps();

    if (!params.progressSteps || params.progressSteps.length === 0) {
      return hide(progressStepsContainer);
    }

    show(progressStepsContainer);
    progressStepsContainer.textContent = '';
    var currentProgressStep = parseInt(params.currentProgressStep === undefined ? getQueueStep() : params.currentProgressStep);

    if (currentProgressStep >= params.progressSteps.length) {
      warn('Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
    }

    params.progressSteps.forEach(function (step, index) {
      var stepEl = createStepElement(step);
      progressStepsContainer.appendChild(stepEl);

      if (index === currentProgressStep) {
        addClass(stepEl, swalClasses['active-progress-step']);
      }

      if (index !== params.progressSteps.length - 1) {
        var lineEl = createLineElement(params);
        progressStepsContainer.appendChild(lineEl);
      }
    });
  };

  var renderTitle = function renderTitle(instance, params) {
    var title = getTitle();
    toggle(title, params.title || params.titleText, 'block');

    if (params.title) {
      parseHtmlToContainer(params.title, title);
    }

    if (params.titleText) {
      title.innerText = params.titleText;
    } // Custom class


    applyCustomClass(title, params, 'title');
  };

  var renderHeader = function renderHeader(instance, params) {
    var header = getHeader(); // Custom class

    applyCustomClass(header, params, 'header'); // Progress steps

    renderProgressSteps(instance, params); // Icon

    renderIcon(instance, params); // Image

    renderImage(instance, params); // Title

    renderTitle(instance, params); // Close button

    renderCloseButton(instance, params);
  };

  var renderPopup = function renderPopup(instance, params) {
    var container = getContainer();
    var popup = getPopup(); // Width

    if (params.toast) {
      // #2170
      applyNumericalStyle(container, 'width', params.width);
      popup.style.width = '100%';
    } else {
      applyNumericalStyle(popup, 'width', params.width);
    } // Padding


    applyNumericalStyle(popup, 'padding', params.padding); // Background

    if (params.background) {
      popup.style.background = params.background;
    }

    hide(getValidationMessage()); // Classes

    addClasses(popup, params);
  };

  var addClasses = function addClasses(popup, params) {
    // Default Class + showClass when updating Swal.update({})
    popup.className = "".concat(swalClasses.popup, " ").concat(isVisible(popup) ? params.showClass.popup : '');

    if (params.toast) {
      addClass([document.documentElement, document.body], swalClasses['toast-shown']);
      addClass(popup, swalClasses.toast);
    } else {
      addClass(popup, swalClasses.modal);
    } // Custom class


    applyCustomClass(popup, params, 'popup');

    if (typeof params.customClass === 'string') {
      addClass(popup, params.customClass);
    } // Icon class (#1842)


    if (params.icon) {
      addClass(popup, swalClasses["icon-".concat(params.icon)]);
    }
  };

  var render = function render(instance, params) {
    renderPopup(instance, params);
    renderContainer(instance, params);
    renderHeader(instance, params);
    renderContent(instance, params);
    renderActions(instance, params);
    renderFooter(instance, params);

    if (typeof params.didRender === 'function') {
      params.didRender(getPopup());
    } else if (typeof params.onRender === 'function') {
      params.onRender(getPopup()); // @deprecated
    }
  };

  /*
   * Global function to determine if SweetAlert2 popup is shown
   */

  var isVisible$1 = function isVisible$$1() {
    return isVisible(getPopup());
  };
  /*
   * Global function to click 'Confirm' button
   */

  var clickConfirm = function clickConfirm() {
    return getConfirmButton() && getConfirmButton().click();
  };
  /*
   * Global function to click 'Deny' button
   */

  var clickDeny = function clickDeny() {
    return getDenyButton() && getDenyButton().click();
  };
  /*
   * Global function to click 'Cancel' button
   */

  var clickCancel = function clickCancel() {
    return getCancelButton() && getCancelButton().click();
  };

  function fire() {
    var Swal = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _construct(Swal, args);
  }

  /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param mixinParams
   */
  function mixin(mixinParams) {
    var MixinSwal = /*#__PURE__*/function (_this) {
      _inherits(MixinSwal, _this);

      var _super = _createSuper(MixinSwal);

      function MixinSwal() {
        _classCallCheck(this, MixinSwal);

        return _super.apply(this, arguments);
      }

      _createClass(MixinSwal, [{
        key: "_main",
        value: function _main(params, priorityMixinParams) {
          return _get(_getPrototypeOf(MixinSwal.prototype), "_main", this).call(this, params, _extends({}, mixinParams, priorityMixinParams));
        }
      }]);

      return MixinSwal;
    }(this);

    return MixinSwal;
  }

  /**
   * Shows loader (spinner), this is useful with AJAX requests.
   * By default the loader be shown instead of the "Confirm" button.
   */

  var showLoading = function showLoading(buttonToReplace) {
    var popup = getPopup();

    if (!popup) {
      Swal.fire();
    }

    popup = getPopup();
    var actions = getActions();
    var loader = getLoader();

    if (!buttonToReplace && isVisible(getConfirmButton())) {
      buttonToReplace = getConfirmButton();
    }

    show(actions);

    if (buttonToReplace) {
      hide(buttonToReplace);
      loader.setAttribute('data-button-to-replace', buttonToReplace.className);
    }

    loader.parentNode.insertBefore(loader, buttonToReplace);
    addClass([popup, actions], swalClasses.loading);
    show(loader);
    popup.setAttribute('data-loading', true);
    popup.setAttribute('aria-busy', true);
    popup.focus();
  };

  var RESTORE_FOCUS_TIMEOUT = 100;

  var globalState = {};

  var focusPreviousActiveElement = function focusPreviousActiveElement() {
    if (globalState.previousActiveElement && globalState.previousActiveElement.focus) {
      globalState.previousActiveElement.focus();
      globalState.previousActiveElement = null;
    } else if (document.body) {
      document.body.focus();
    }
  }; // Restore previous active (focused) element


  var restoreActiveElement = function restoreActiveElement(returnFocus) {
    return new Promise(function (resolve) {
      if (!returnFocus) {
        return resolve();
      }

      var x = window.scrollX;
      var y = window.scrollY;
      globalState.restoreFocusTimeout = setTimeout(function () {
        focusPreviousActiveElement();
        resolve();
      }, RESTORE_FOCUS_TIMEOUT); // issues/900

      if (typeof x !== 'undefined' && typeof y !== 'undefined') {
        // IE doesn't have scrollX/scrollY support
        window.scrollTo(x, y);
      }
    });
  };

  /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   */

  var getTimerLeft = function getTimerLeft() {
    return globalState.timeout && globalState.timeout.getTimerLeft();
  };
  /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   */

  var stopTimer = function stopTimer() {
    if (globalState.timeout) {
      stopTimerProgressBar();
      return globalState.timeout.stop();
    }
  };
  /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   */

  var resumeTimer = function resumeTimer() {
    if (globalState.timeout) {
      var remaining = globalState.timeout.start();
      animateTimerProgressBar(remaining);
      return remaining;
    }
  };
  /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   */

  var toggleTimer = function toggleTimer() {
    var timer = globalState.timeout;
    return timer && (timer.running ? stopTimer() : resumeTimer());
  };
  /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   */

  var increaseTimer = function increaseTimer(n) {
    if (globalState.timeout) {
      var remaining = globalState.timeout.increase(n);
      animateTimerProgressBar(remaining, true);
      return remaining;
    }
  };
  /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   */

  var isTimerRunning = function isTimerRunning() {
    return globalState.timeout && globalState.timeout.isRunning();
  };

  var bodyClickListenerAdded = false;
  var clickHandlers = {};
  function bindClickHandler() {
    var attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-swal-template';
    clickHandlers[attr] = this;

    if (!bodyClickListenerAdded) {
      document.body.addEventListener('click', bodyClickListener);
      bodyClickListenerAdded = true;
    }
  }

  var bodyClickListener = function bodyClickListener(event) {
    // 1. using .parentNode instead of event.path because of better support by old browsers https://stackoverflow.com/a/39245638
    // 2. using .parentNode instead of .parentElement because of IE11 + SVG https://stackoverflow.com/a/36270354
    for (var el = event.target; el && el !== document; el = el.parentNode) {
      for (var attr in clickHandlers) {
        var template = el.getAttribute(attr);

        if (template) {
          clickHandlers[attr].fire({
            template: template
          });
          return;
        }
      }
    }
  };

  var defaultParams = {
    title: '',
    titleText: '',
    text: '',
    html: '',
    footer: '',
    icon: undefined,
    iconColor: undefined,
    iconHtml: undefined,
    template: undefined,
    toast: false,
    animation: true,
    showClass: {
      popup: 'swal2-show',
      backdrop: 'swal2-backdrop-show',
      icon: 'swal2-icon-show'
    },
    hideClass: {
      popup: 'swal2-hide',
      backdrop: 'swal2-backdrop-hide',
      icon: 'swal2-icon-hide'
    },
    customClass: {},
    target: 'body',
    backdrop: true,
    heightAuto: true,
    allowOutsideClick: true,
    allowEscapeKey: true,
    allowEnterKey: true,
    stopKeydownPropagation: true,
    keydownListenerCapture: false,
    showConfirmButton: true,
    showDenyButton: false,
    showCancelButton: false,
    preConfirm: undefined,
    preDeny: undefined,
    confirmButtonText: 'OK',
    confirmButtonAriaLabel: '',
    confirmButtonColor: undefined,
    denyButtonText: 'No',
    denyButtonAriaLabel: '',
    denyButtonColor: undefined,
    cancelButtonText: 'Cancel',
    cancelButtonAriaLabel: '',
    cancelButtonColor: undefined,
    buttonsStyling: true,
    reverseButtons: false,
    focusConfirm: true,
    focusDeny: false,
    focusCancel: false,
    returnFocus: true,
    showCloseButton: false,
    closeButtonHtml: '&times;',
    closeButtonAriaLabel: 'Close this dialog',
    loaderHtml: '',
    showLoaderOnConfirm: false,
    showLoaderOnDeny: false,
    imageUrl: undefined,
    imageWidth: undefined,
    imageHeight: undefined,
    imageAlt: '',
    timer: undefined,
    timerProgressBar: false,
    width: undefined,
    padding: undefined,
    background: undefined,
    input: undefined,
    inputPlaceholder: '',
    inputLabel: '',
    inputValue: '',
    inputOptions: {},
    inputAutoTrim: true,
    inputAttributes: {},
    inputValidator: undefined,
    returnInputValueOnDeny: false,
    validationMessage: undefined,
    grow: false,
    position: 'center',
    progressSteps: [],
    currentProgressStep: undefined,
    progressStepsDistance: undefined,
    onBeforeOpen: undefined,
    onOpen: undefined,
    willOpen: undefined,
    didOpen: undefined,
    onRender: undefined,
    didRender: undefined,
    onClose: undefined,
    onAfterClose: undefined,
    willClose: undefined,
    didClose: undefined,
    onDestroy: undefined,
    didDestroy: undefined,
    scrollbarPadding: true
  };
  var updatableParams = ['allowEscapeKey', 'allowOutsideClick', 'background', 'buttonsStyling', 'cancelButtonAriaLabel', 'cancelButtonColor', 'cancelButtonText', 'closeButtonAriaLabel', 'closeButtonHtml', 'confirmButtonAriaLabel', 'confirmButtonColor', 'confirmButtonText', 'currentProgressStep', 'customClass', 'denyButtonAriaLabel', 'denyButtonColor', 'denyButtonText', 'didClose', 'didDestroy', 'footer', 'hideClass', 'html', 'icon', 'iconColor', 'iconHtml', 'imageAlt', 'imageHeight', 'imageUrl', 'imageWidth', 'onAfterClose', 'onClose', 'onDestroy', 'progressSteps', 'returnFocus', 'reverseButtons', 'showCancelButton', 'showCloseButton', 'showConfirmButton', 'showDenyButton', 'text', 'title', 'titleText', 'willClose'];
  var deprecatedParams = {
    animation: 'showClass" and "hideClass',
    onBeforeOpen: 'willOpen',
    onOpen: 'didOpen',
    onRender: 'didRender',
    onClose: 'willClose',
    onAfterClose: 'didClose',
    onDestroy: 'didDestroy'
  };
  var toastIncompatibleParams = ['allowOutsideClick', 'allowEnterKey', 'backdrop', 'focusConfirm', 'focusDeny', 'focusCancel', 'returnFocus', 'heightAuto', 'keydownListenerCapture'];
  /**
   * Is valid parameter
   * @param {String} paramName
   */

  var isValidParameter = function isValidParameter(paramName) {
    return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
  };
  /**
   * Is valid parameter for Swal.update() method
   * @param {String} paramName
   */

  var isUpdatableParameter = function isUpdatableParameter(paramName) {
    return updatableParams.indexOf(paramName) !== -1;
  };
  /**
   * Is deprecated parameter
   * @param {String} paramName
   */

  var isDeprecatedParameter = function isDeprecatedParameter(paramName) {
    return deprecatedParams[paramName];
  };

  var checkIfParamIsValid = function checkIfParamIsValid(param) {
    if (!isValidParameter(param)) {
      warn("Unknown parameter \"".concat(param, "\""));
    }
  };

  var checkIfToastParamIsValid = function checkIfToastParamIsValid(param) {
    if (toastIncompatibleParams.indexOf(param) !== -1) {
      warn("The parameter \"".concat(param, "\" is incompatible with toasts"));
    }
  };

  var checkIfParamIsDeprecated = function checkIfParamIsDeprecated(param) {
    if (isDeprecatedParameter(param)) {
      warnAboutDeprecation(param, isDeprecatedParameter(param));
    }
  };
  /**
   * Show relevant warnings for given params
   *
   * @param params
   */


  var showWarningsForParams = function showWarningsForParams(params) {
    for (var param in params) {
      checkIfParamIsValid(param);

      if (params.toast) {
        checkIfToastParamIsValid(param);
      }

      checkIfParamIsDeprecated(param);
    }
  };



  var staticMethods = /*#__PURE__*/Object.freeze({
    isValidParameter: isValidParameter,
    isUpdatableParameter: isUpdatableParameter,
    isDeprecatedParameter: isDeprecatedParameter,
    argsToParams: argsToParams,
    isVisible: isVisible$1,
    clickConfirm: clickConfirm,
    clickDeny: clickDeny,
    clickCancel: clickCancel,
    getContainer: getContainer,
    getPopup: getPopup,
    getTitle: getTitle,
    getContent: getContent,
    getHtmlContainer: getHtmlContainer,
    getImage: getImage,
    getIcon: getIcon,
    getInputLabel: getInputLabel,
    getCloseButton: getCloseButton,
    getActions: getActions,
    getConfirmButton: getConfirmButton,
    getDenyButton: getDenyButton,
    getCancelButton: getCancelButton,
    getLoader: getLoader,
    getHeader: getHeader,
    getFooter: getFooter,
    getTimerProgressBar: getTimerProgressBar,
    getFocusableElements: getFocusableElements,
    getValidationMessage: getValidationMessage,
    isLoading: isLoading,
    fire: fire,
    mixin: mixin,
    queue: queue,
    getQueueStep: getQueueStep,
    insertQueueStep: insertQueueStep,
    deleteQueueStep: deleteQueueStep,
    showLoading: showLoading,
    enableLoading: showLoading,
    getTimerLeft: getTimerLeft,
    stopTimer: stopTimer,
    resumeTimer: resumeTimer,
    toggleTimer: toggleTimer,
    increaseTimer: increaseTimer,
    isTimerRunning: isTimerRunning,
    bindClickHandler: bindClickHandler
  });

  /**
   * Hides loader and shows back the button which was hidden by .showLoading()
   */

  function hideLoading() {
    // do nothing if popup is closed
    var innerParams = privateProps.innerParams.get(this);

    if (!innerParams) {
      return;
    }

    var domCache = privateProps.domCache.get(this);
    hide(domCache.loader);
    var buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute('data-button-to-replace'));

    if (buttonToReplace.length) {
      show(buttonToReplace[0], 'inline-block');
    } else if (allButtonsAreHidden()) {
      hide(domCache.actions);
    }

    removeClass([domCache.popup, domCache.actions], swalClasses.loading);
    domCache.popup.removeAttribute('aria-busy');
    domCache.popup.removeAttribute('data-loading');
    domCache.confirmButton.disabled = false;
    domCache.denyButton.disabled = false;
    domCache.cancelButton.disabled = false;
  }

  function getInput$1(instance) {
    var innerParams = privateProps.innerParams.get(instance || this);
    var domCache = privateProps.domCache.get(instance || this);

    if (!domCache) {
      return null;
    }

    return getInput(domCache.content, innerParams.input);
  }

  var fixScrollbar = function fixScrollbar() {
    // for queues, do not do this more than once
    if (states.previousBodyPadding !== null) {
      return;
    } // if the body has overflow


    if (document.body.scrollHeight > window.innerHeight) {
      // add padding so the content doesn't shift after removal of scrollbar
      states.previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
      document.body.style.paddingRight = "".concat(states.previousBodyPadding + measureScrollbar(), "px");
    }
  };
  var undoScrollbar = function undoScrollbar() {
    if (states.previousBodyPadding !== null) {
      document.body.style.paddingRight = "".concat(states.previousBodyPadding, "px");
      states.previousBodyPadding = null;
    }
  };

  /* istanbul ignore file */

  var iOSfix = function iOSfix() {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
      var offset = document.body.scrollTop;
      document.body.style.top = "".concat(offset * -1, "px");
      addClass(document.body, swalClasses.iosfix);
      lockBodyScroll();
      addBottomPaddingForTallPopups(); // #1948
    }
  };

  var addBottomPaddingForTallPopups = function addBottomPaddingForTallPopups() {
    var safari = !navigator.userAgent.match(/(CriOS|FxiOS|EdgiOS|YaBrowser|UCBrowser)/i);

    if (safari) {
      var bottomPanelHeight = 44;

      if (getPopup().scrollHeight > window.innerHeight - bottomPanelHeight) {
        getContainer().style.paddingBottom = "".concat(bottomPanelHeight, "px");
      }
    }
  };

  var lockBodyScroll = function lockBodyScroll() {
    // #1246
    var container = getContainer();
    var preventTouchMove;

    container.ontouchstart = function (e) {
      preventTouchMove = shouldPreventTouchMove(e);
    };

    container.ontouchmove = function (e) {
      if (preventTouchMove) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
  };

  var shouldPreventTouchMove = function shouldPreventTouchMove(event) {
    var target = event.target;
    var container = getContainer();

    if (isStylys(event) || isZoom(event)) {
      return false;
    }

    if (target === container) {
      return true;
    }

    if (!isScrollable(container) && target.tagName !== 'INPUT' && // #1603
    !(isScrollable(getContent()) && // #1944
    getContent().contains(target))) {
      return true;
    }

    return false;
  };

  var isStylys = function isStylys(event) {
    // #1786
    return event.touches && event.touches.length && event.touches[0].touchType === 'stylus';
  };

  var isZoom = function isZoom(event) {
    // #1891
    return event.touches && event.touches.length > 1;
  };

  var undoIOSfix = function undoIOSfix() {
    if (hasClass(document.body, swalClasses.iosfix)) {
      var offset = parseInt(document.body.style.top, 10);
      removeClass(document.body, swalClasses.iosfix);
      document.body.style.top = '';
      document.body.scrollTop = offset * -1;
    }
  };

  /* istanbul ignore file */

  var isIE11 = function isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
  }; // Fix IE11 centering sweetalert2/issues/933


  var fixVerticalPositionIE = function fixVerticalPositionIE() {
    var container = getContainer();
    var popup = getPopup();
    container.style.removeProperty('align-items');

    if (popup.offsetTop < 0) {
      container.style.alignItems = 'flex-start';
    }
  };

  var IEfix = function IEfix() {
    if (typeof window !== 'undefined' && isIE11()) {
      fixVerticalPositionIE();
      window.addEventListener('resize', fixVerticalPositionIE);
    }
  };
  var undoIEfix = function undoIEfix() {
    if (typeof window !== 'undefined' && isIE11()) {
      window.removeEventListener('resize', fixVerticalPositionIE);
    }
  };

  // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
  // elements not within the active modal dialog will not be surfaced if a user opens a screen
  // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.

  var setAriaHidden = function setAriaHidden() {
    var bodyChildren = toArray(document.body.children);
    bodyChildren.forEach(function (el) {
      if (el === getContainer() || contains(el, getContainer())) {
        return;
      }

      if (el.hasAttribute('aria-hidden')) {
        el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden'));
      }

      el.setAttribute('aria-hidden', 'true');
    });
  };
  var unsetAriaHidden = function unsetAriaHidden() {
    var bodyChildren = toArray(document.body.children);
    bodyChildren.forEach(function (el) {
      if (el.hasAttribute('data-previous-aria-hidden')) {
        el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden'));
        el.removeAttribute('data-previous-aria-hidden');
      } else {
        el.removeAttribute('aria-hidden');
      }
    });
  };

  /**
   * This module containts `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */
  var privateMethods = {
    swalPromiseResolve: new WeakMap()
  };

  /*
   * Instance method to close sweetAlert
   */

  function removePopupAndResetState(instance, container, returnFocus, didClose) {
    if (isToast()) {
      triggerDidCloseAndDispose(instance, didClose);
    } else {
      restoreActiveElement(returnFocus).then(function () {
        return triggerDidCloseAndDispose(instance, didClose);
      });
      globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = false;
    }

    if (container.parentNode && !document.body.getAttribute('data-swal2-queue-step')) {
      container.parentNode.removeChild(container);
    }

    if (isModal()) {
      undoScrollbar();
      undoIOSfix();
      undoIEfix();
      unsetAriaHidden();
    }

    removeBodyClasses();
  }

  function removeBodyClasses() {
    removeClass([document.documentElement, document.body], [swalClasses.shown, swalClasses['height-auto'], swalClasses['no-backdrop'], swalClasses['toast-shown']]);
  }

  function close(resolveValue) {
    var popup = getPopup();

    if (!popup) {
      return;
    }

    resolveValue = prepareResolveValue(resolveValue);
    var innerParams = privateProps.innerParams.get(this);

    if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) {
      return;
    }

    var swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
    removeClass(popup, innerParams.showClass.popup);
    addClass(popup, innerParams.hideClass.popup);
    var backdrop = getContainer();
    removeClass(backdrop, innerParams.showClass.backdrop);
    addClass(backdrop, innerParams.hideClass.backdrop);
    handlePopupAnimation(this, popup, innerParams); // Resolve Swal promise

    swalPromiseResolve(resolveValue);
  }

  var prepareResolveValue = function prepareResolveValue(resolveValue) {
    // When user calls Swal.close()
    if (typeof resolveValue === 'undefined') {
      return {
        isConfirmed: false,
        isDenied: false,
        isDismissed: true
      };
    }

    return _extends({
      isConfirmed: false,
      isDenied: false,
      isDismissed: false
    }, resolveValue);
  };

  var handlePopupAnimation = function handlePopupAnimation(instance, popup, innerParams) {
    var container = getContainer(); // If animation is supported, animate

    var animationIsSupported = animationEndEvent && hasCssAnimation(popup);
    var onClose = innerParams.onClose,
        onAfterClose = innerParams.onAfterClose,
        willClose = innerParams.willClose,
        didClose = innerParams.didClose;
    runDidClose(popup, willClose, onClose);

    if (animationIsSupported) {
      animatePopup(instance, popup, container, innerParams.returnFocus, didClose || onAfterClose);
    } else {
      // Otherwise, remove immediately
      removePopupAndResetState(instance, container, innerParams.returnFocus, didClose || onAfterClose);
    }
  };

  var runDidClose = function runDidClose(popup, willClose, onClose) {
    if (willClose !== null && typeof willClose === 'function') {
      willClose(popup);
    } else if (onClose !== null && typeof onClose === 'function') {
      onClose(popup); // @deprecated
    }
  };

  var animatePopup = function animatePopup(instance, popup, container, returnFocus, didClose) {
    globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
    popup.addEventListener(animationEndEvent, function (e) {
      if (e.target === popup) {
        globalState.swalCloseEventFinishedCallback();
        delete globalState.swalCloseEventFinishedCallback;
      }
    });
  };

  var triggerDidCloseAndDispose = function triggerDidCloseAndDispose(instance, didClose) {
    setTimeout(function () {
      if (typeof didClose === 'function') {
        didClose();
      }

      instance._destroy();
    });
  };

  function setButtonsDisabled(instance, buttons, disabled) {
    var domCache = privateProps.domCache.get(instance);
    buttons.forEach(function (button) {
      domCache[button].disabled = disabled;
    });
  }

  function setInputDisabled(input, disabled) {
    if (!input) {
      return false;
    }

    if (input.type === 'radio') {
      var radiosContainer = input.parentNode.parentNode;
      var radios = radiosContainer.querySelectorAll('input');

      for (var i = 0; i < radios.length; i++) {
        radios[i].disabled = disabled;
      }
    } else {
      input.disabled = disabled;
    }
  }

  function enableButtons() {
    setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], false);
  }
  function disableButtons() {
    setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], true);
  }
  function enableInput() {
    return setInputDisabled(this.getInput(), false);
  }
  function disableInput() {
    return setInputDisabled(this.getInput(), true);
  }

  function showValidationMessage(error) {
    var domCache = privateProps.domCache.get(this);
    var params = privateProps.innerParams.get(this);
    setInnerHtml(domCache.validationMessage, error);
    domCache.validationMessage.className = swalClasses['validation-message'];

    if (params.customClass && params.customClass.validationMessage) {
      addClass(domCache.validationMessage, params.customClass.validationMessage);
    }

    show(domCache.validationMessage);
    var input = this.getInput();

    if (input) {
      input.setAttribute('aria-invalid', true);
      input.setAttribute('aria-describedBy', swalClasses['validation-message']);
      focusInput(input);
      addClass(input, swalClasses.inputerror);
    }
  } // Hide block with validation message

  function resetValidationMessage$1() {
    var domCache = privateProps.domCache.get(this);

    if (domCache.validationMessage) {
      hide(domCache.validationMessage);
    }

    var input = this.getInput();

    if (input) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedBy');
      removeClass(input, swalClasses.inputerror);
    }
  }

  function getProgressSteps$1() {
    var domCache = privateProps.domCache.get(this);
    return domCache.progressSteps;
  }

  var Timer = /*#__PURE__*/function () {
    function Timer(callback, delay) {
      _classCallCheck(this, Timer);

      this.callback = callback;
      this.remaining = delay;
      this.running = false;
      this.start();
    }

    _createClass(Timer, [{
      key: "start",
      value: function start() {
        if (!this.running) {
          this.running = true;
          this.started = new Date();
          this.id = setTimeout(this.callback, this.remaining);
        }

        return this.remaining;
      }
    }, {
      key: "stop",
      value: function stop() {
        if (this.running) {
          this.running = false;
          clearTimeout(this.id);
          this.remaining -= new Date() - this.started;
        }

        return this.remaining;
      }
    }, {
      key: "increase",
      value: function increase(n) {
        var running = this.running;

        if (running) {
          this.stop();
        }

        this.remaining += n;

        if (running) {
          this.start();
        }

        return this.remaining;
      }
    }, {
      key: "getTimerLeft",
      value: function getTimerLeft() {
        if (this.running) {
          this.stop();
          this.start();
        }

        return this.remaining;
      }
    }, {
      key: "isRunning",
      value: function isRunning() {
        return this.running;
      }
    }]);

    return Timer;
  }();

  var defaultInputValidators = {
    email: function email(string, validationMessage) {
      return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
    },
    url: function url(string, validationMessage) {
      // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
      return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
    }
  };

  function setDefaultInputValidators(params) {
    // Use default `inputValidator` for supported input types if not provided
    if (!params.inputValidator) {
      Object.keys(defaultInputValidators).forEach(function (key) {
        if (params.input === key) {
          params.inputValidator = defaultInputValidators[key];
        }
      });
    }
  }

  function validateCustomTargetElement(params) {
    // Determine if the custom target element is valid
    if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
      warn('Target parameter is not valid, defaulting to "body"');
      params.target = 'body';
    }
  }
  /**
   * Set type, text and actions on popup
   *
   * @param params
   * @returns {boolean}
   */


  function setParameters(params) {
    setDefaultInputValidators(params); // showLoaderOnConfirm && preConfirm

    if (params.showLoaderOnConfirm && !params.preConfirm) {
      warn('showLoaderOnConfirm is set to true, but preConfirm is not defined.\n' + 'showLoaderOnConfirm should be used together with preConfirm, see usage example:\n' + 'https://sweetalert2.github.io/#ajax-request');
    } // params.animation will be actually used in renderPopup.js
    // but in case when params.animation is a function, we need to call that function
    // before popup (re)initialization, so it'll be possible to check Swal.isVisible()
    // inside the params.animation function


    params.animation = callIfFunction(params.animation);
    validateCustomTargetElement(params); // Replace newlines with <br> in title

    if (typeof params.title === 'string') {
      params.title = params.title.split('\n').join('<br />');
    }

    init(params);
  }

  var swalStringParams = ['swal-title', 'swal-html', 'swal-footer'];
  var getTemplateParams = function getTemplateParams(params) {
    var template = typeof params.template === 'string' ? document.querySelector(params.template) : params.template;

    if (!template) {
      return {};
    }

    var templateContent = template.content || template; // IE11

    showWarningsForElements(templateContent);

    var result = _extends(getSwalParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));

    return result;
  };

  var getSwalParams = function getSwalParams(templateContent) {
    var result = {};
    toArray(templateContent.querySelectorAll('swal-param')).forEach(function (param) {
      showWarningsForAttributes(param, ['name', 'value']);
      var paramName = param.getAttribute('name');
      var value = param.getAttribute('value');

      if (typeof defaultParams[paramName] === 'boolean' && value === 'false') {
        value = false;
      }

      if (_typeof(defaultParams[paramName]) === 'object') {
        value = JSON.parse(value);
      }

      result[paramName] = value;
    });
    return result;
  };

  var getSwalButtons = function getSwalButtons(templateContent) {
    var result = {};
    toArray(templateContent.querySelectorAll('swal-button')).forEach(function (button) {
      showWarningsForAttributes(button, ['type', 'color', 'aria-label']);
      var type = button.getAttribute('type');
      result["".concat(type, "ButtonText")] = button.innerHTML;
      result["show".concat(capitalizeFirstLetter(type), "Button")] = true;

      if (button.hasAttribute('color')) {
        result["".concat(type, "ButtonColor")] = button.getAttribute('color');
      }

      if (button.hasAttribute('aria-label')) {
        result["".concat(type, "ButtonAriaLabel")] = button.getAttribute('aria-label');
      }
    });
    return result;
  };

  var getSwalImage = function getSwalImage(templateContent) {
    var result = {};
    var image = templateContent.querySelector('swal-image');

    if (image) {
      showWarningsForAttributes(image, ['src', 'width', 'height', 'alt']);

      if (image.hasAttribute('src')) {
        result.imageUrl = image.getAttribute('src');
      }

      if (image.hasAttribute('width')) {
        result.imageWidth = image.getAttribute('width');
      }

      if (image.hasAttribute('height')) {
        result.imageHeight = image.getAttribute('height');
      }

      if (image.hasAttribute('alt')) {
        result.imageAlt = image.getAttribute('alt');
      }
    }

    return result;
  };

  var getSwalIcon = function getSwalIcon(templateContent) {
    var result = {};
    var icon = templateContent.querySelector('swal-icon');

    if (icon) {
      showWarningsForAttributes(icon, ['type', 'color']);

      if (icon.hasAttribute('type')) {
        result.icon = icon.getAttribute('type');
      }

      if (icon.hasAttribute('color')) {
        result.iconColor = icon.getAttribute('color');
      }

      result.iconHtml = icon.innerHTML;
    }

    return result;
  };

  var getSwalInput = function getSwalInput(templateContent) {
    var result = {};
    var input = templateContent.querySelector('swal-input');

    if (input) {
      showWarningsForAttributes(input, ['type', 'label', 'placeholder', 'value']);
      result.input = input.getAttribute('type') || 'text';

      if (input.hasAttribute('label')) {
        result.inputLabel = input.getAttribute('label');
      }

      if (input.hasAttribute('placeholder')) {
        result.inputPlaceholder = input.getAttribute('placeholder');
      }

      if (input.hasAttribute('value')) {
        result.inputValue = input.getAttribute('value');
      }
    }

    var inputOptions = templateContent.querySelectorAll('swal-input-option');

    if (inputOptions.length) {
      result.inputOptions = {};
      toArray(inputOptions).forEach(function (option) {
        showWarningsForAttributes(option, ['value']);
        var optionValue = option.getAttribute('value');
        var optionName = option.innerHTML;
        result.inputOptions[optionValue] = optionName;
      });
    }

    return result;
  };

  var getSwalStringParams = function getSwalStringParams(templateContent, paramNames) {
    var result = {};

    for (var i in paramNames) {
      var paramName = paramNames[i];
      var tag = templateContent.querySelector(paramName);

      if (tag) {
        showWarningsForAttributes(tag, []);
        result[paramName.replace(/^swal-/, '')] = tag.innerHTML.trim();
      }
    }

    return result;
  };

  var showWarningsForElements = function showWarningsForElements(template) {
    var allowedElements = swalStringParams.concat(['swal-param', 'swal-button', 'swal-image', 'swal-icon', 'swal-input', 'swal-input-option']);
    toArray(template.querySelectorAll('*')).forEach(function (el) {
      if (el.parentNode !== template) {
        // can't use template.children because of IE11
        return;
      }

      var tagName = el.tagName.toLowerCase();

      if (allowedElements.indexOf(tagName) === -1) {
        warn("Unrecognized element <".concat(tagName, ">"));
      }
    });
  };

  var showWarningsForAttributes = function showWarningsForAttributes(el, allowedAttributes) {
    toArray(el.attributes).forEach(function (attribute) {
      if (allowedAttributes.indexOf(attribute.name) === -1) {
        warn(["Unrecognized attribute \"".concat(attribute.name, "\" on <").concat(el.tagName.toLowerCase(), ">."), "".concat(allowedAttributes.length ? "Allowed attributes are: ".concat(allowedAttributes.join(', ')) : 'To set the value, use HTML within the element.')]);
      }
    });
  };

  var SHOW_CLASS_TIMEOUT = 10;
  /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param params
   */

  var openPopup = function openPopup(params) {
    var container = getContainer();
    var popup = getPopup();

    if (typeof params.willOpen === 'function') {
      params.willOpen(popup);
    } else if (typeof params.onBeforeOpen === 'function') {
      params.onBeforeOpen(popup); // @deprecated
    }

    var bodyStyles = window.getComputedStyle(document.body);
    var initialBodyOverflow = bodyStyles.overflowY;
    addClasses$1(container, popup, params); // scrolling is 'hidden' until animation is done, after that 'auto'

    setTimeout(function () {
      setScrollingVisibility(container, popup);
    }, SHOW_CLASS_TIMEOUT);

    if (isModal()) {
      fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
      setAriaHidden();
    }

    if (!isToast() && !globalState.previousActiveElement) {
      globalState.previousActiveElement = document.activeElement;
    }

    runDidOpen(popup, params);
    removeClass(container, swalClasses['no-transition']);
  };

  var runDidOpen = function runDidOpen(popup, params) {
    if (typeof params.didOpen === 'function') {
      setTimeout(function () {
        return params.didOpen(popup);
      });
    } else if (typeof params.onOpen === 'function') {
      setTimeout(function () {
        return params.onOpen(popup);
      }); // @deprecated
    }
  };

  var swalOpenAnimationFinished = function swalOpenAnimationFinished(event) {
    var popup = getPopup();

    if (event.target !== popup) {
      return;
    }

    var container = getContainer();
    popup.removeEventListener(animationEndEvent, swalOpenAnimationFinished);
    container.style.overflowY = 'auto';
  };

  var setScrollingVisibility = function setScrollingVisibility(container, popup) {
    if (animationEndEvent && hasCssAnimation(popup)) {
      container.style.overflowY = 'hidden';
      popup.addEventListener(animationEndEvent, swalOpenAnimationFinished);
    } else {
      container.style.overflowY = 'auto';
    }
  };

  var fixScrollContainer = function fixScrollContainer(container, scrollbarPadding, initialBodyOverflow) {
    iOSfix();
    IEfix();

    if (scrollbarPadding && initialBodyOverflow !== 'hidden') {
      fixScrollbar();
    } // sweetalert2/issues/1247


    setTimeout(function () {
      container.scrollTop = 0;
    });
  };

  var addClasses$1 = function addClasses(container, popup, params) {
    addClass(container, params.showClass.backdrop); // the workaround with setting/unsetting opacity is needed for #2019 and 2059

    popup.style.setProperty('opacity', '0', 'important');
    show(popup);
    setTimeout(function () {
      // Animate popup right after showing it
      addClass(popup, params.showClass.popup); // and remove the opacity workaround

      popup.style.removeProperty('opacity');
    }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062

    addClass([document.documentElement, document.body], swalClasses.shown);

    if (params.heightAuto && params.backdrop && !params.toast) {
      addClass([document.documentElement, document.body], swalClasses['height-auto']);
    }
  };

  var handleInputOptionsAndValue = function handleInputOptionsAndValue(instance, params) {
    if (params.input === 'select' || params.input === 'radio') {
      handleInputOptions(instance, params);
    } else if (['text', 'email', 'number', 'tel', 'textarea'].indexOf(params.input) !== -1 && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
      handleInputValue(instance, params);
    }
  };
  var getInputValue = function getInputValue(instance, innerParams) {
    var input = instance.getInput();

    if (!input) {
      return null;
    }

    switch (innerParams.input) {
      case 'checkbox':
        return getCheckboxValue(input);

      case 'radio':
        return getRadioValue(input);

      case 'file':
        return getFileValue(input);

      default:
        return innerParams.inputAutoTrim ? input.value.trim() : input.value;
    }
  };

  var getCheckboxValue = function getCheckboxValue(input) {
    return input.checked ? 1 : 0;
  };

  var getRadioValue = function getRadioValue(input) {
    return input.checked ? input.value : null;
  };

  var getFileValue = function getFileValue(input) {
    return input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
  };

  var handleInputOptions = function handleInputOptions(instance, params) {
    var content = getContent();

    var processInputOptions = function processInputOptions(inputOptions) {
      return populateInputOptions[params.input](content, formatInputOptions(inputOptions), params);
    };

    if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
      showLoading(getConfirmButton());
      asPromise(params.inputOptions).then(function (inputOptions) {
        instance.hideLoading();
        processInputOptions(inputOptions);
      });
    } else if (_typeof(params.inputOptions) === 'object') {
      processInputOptions(params.inputOptions);
    } else {
      error("Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(_typeof(params.inputOptions)));
    }
  };

  var handleInputValue = function handleInputValue(instance, params) {
    var input = instance.getInput();
    hide(input);
    asPromise(params.inputValue).then(function (inputValue) {
      input.value = params.input === 'number' ? parseFloat(inputValue) || 0 : "".concat(inputValue);
      show(input);
      input.focus();
      instance.hideLoading();
    })["catch"](function (err) {
      error("Error in inputValue promise: ".concat(err));
      input.value = '';
      show(input);
      input.focus();
      instance.hideLoading();
    });
  };

  var populateInputOptions = {
    select: function select(content, inputOptions, params) {
      var select = getChildByClass(content, swalClasses.select);

      var renderOption = function renderOption(parent, optionLabel, optionValue) {
        var option = document.createElement('option');
        option.value = optionValue;
        setInnerHtml(option, optionLabel);
        option.selected = isSelected(optionValue, params.inputValue);
        parent.appendChild(option);
      };

      inputOptions.forEach(function (inputOption) {
        var optionValue = inputOption[0];
        var optionLabel = inputOption[1]; // <optgroup> spec:
        // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
        // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
        // check whether this is a <optgroup>

        if (Array.isArray(optionLabel)) {
          // if it is an array, then it is an <optgroup>
          var optgroup = document.createElement('optgroup');
          optgroup.label = optionValue;
          optgroup.disabled = false; // not configurable for now

          select.appendChild(optgroup);
          optionLabel.forEach(function (o) {
            return renderOption(optgroup, o[1], o[0]);
          });
        } else {
          // case of <option>
          renderOption(select, optionLabel, optionValue);
        }
      });
      select.focus();
    },
    radio: function radio(content, inputOptions, params) {
      var radio = getChildByClass(content, swalClasses.radio);
      inputOptions.forEach(function (inputOption) {
        var radioValue = inputOption[0];
        var radioLabel = inputOption[1];
        var radioInput = document.createElement('input');
        var radioLabelElement = document.createElement('label');
        radioInput.type = 'radio';
        radioInput.name = swalClasses.radio;
        radioInput.value = radioValue;

        if (isSelected(radioValue, params.inputValue)) {
          radioInput.checked = true;
        }

        var label = document.createElement('span');
        setInnerHtml(label, radioLabel);
        label.className = swalClasses.label;
        radioLabelElement.appendChild(radioInput);
        radioLabelElement.appendChild(label);
        radio.appendChild(radioLabelElement);
      });
      var radios = radio.querySelectorAll('input');

      if (radios.length) {
        radios[0].focus();
      }
    }
  };
  /**
   * Converts `inputOptions` into an array of `[value, label]`s
   * @param inputOptions
   */

  var formatInputOptions = function formatInputOptions(inputOptions) {
    var result = [];

    if (typeof Map !== 'undefined' && inputOptions instanceof Map) {
      inputOptions.forEach(function (value, key) {
        var valueFormatted = value;

        if (_typeof(valueFormatted) === 'object') {
          // case of <optgroup>
          valueFormatted = formatInputOptions(valueFormatted);
        }

        result.push([key, valueFormatted]);
      });
    } else {
      Object.keys(inputOptions).forEach(function (key) {
        var valueFormatted = inputOptions[key];

        if (_typeof(valueFormatted) === 'object') {
          // case of <optgroup>
          valueFormatted = formatInputOptions(valueFormatted);
        }

        result.push([key, valueFormatted]);
      });
    }

    return result;
  };

  var isSelected = function isSelected(optionValue, inputValue) {
    return inputValue && inputValue.toString() === optionValue.toString();
  };

  var handleConfirmButtonClick = function handleConfirmButtonClick(instance, innerParams) {
    instance.disableButtons();

    if (innerParams.input) {
      handleConfirmOrDenyWithInput(instance, innerParams, 'confirm');
    } else {
      confirm(instance, innerParams, true);
    }
  };
  var handleDenyButtonClick = function handleDenyButtonClick(instance, innerParams) {
    instance.disableButtons();

    if (innerParams.returnInputValueOnDeny) {
      handleConfirmOrDenyWithInput(instance, innerParams, 'deny');
    } else {
      deny(instance, innerParams, false);
    }
  };
  var handleCancelButtonClick = function handleCancelButtonClick(instance, dismissWith) {
    instance.disableButtons();
    dismissWith(DismissReason.cancel);
  };

  var handleConfirmOrDenyWithInput = function handleConfirmOrDenyWithInput(instance, innerParams, type
  /* type is either 'confirm' or 'deny' */
  ) {
    var inputValue = getInputValue(instance, innerParams);

    if (innerParams.inputValidator) {
      handleInputValidator(instance, innerParams, inputValue);
    } else if (!instance.getInput().checkValidity()) {
      instance.enableButtons();
      instance.showValidationMessage(innerParams.validationMessage);
    } else if (type === 'deny') {
      deny(instance, innerParams, inputValue);
    } else {
      confirm(instance, innerParams, inputValue);
    }
  };

  var handleInputValidator = function handleInputValidator(instance, innerParams, inputValue) {
    instance.disableInput();
    var validationPromise = Promise.resolve().then(function () {
      return asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage));
    });
    validationPromise.then(function (validationMessage) {
      instance.enableButtons();
      instance.enableInput();

      if (validationMessage) {
        instance.showValidationMessage(validationMessage);
      } else {
        confirm(instance, innerParams, inputValue);
      }
    });
  };

  var deny = function deny(instance, innerParams, value) {
    if (innerParams.showLoaderOnDeny) {
      showLoading(getDenyButton());
    }

    if (innerParams.preDeny) {
      var preDenyPromise = Promise.resolve().then(function () {
        return asPromise(innerParams.preDeny(value, innerParams.validationMessage));
      });
      preDenyPromise.then(function (preDenyValue) {
        if (preDenyValue === false) {
          instance.hideLoading();
        } else {
          instance.closePopup({
            isDenied: true,
            value: typeof preDenyValue === 'undefined' ? value : preDenyValue
          });
        }
      });
    } else {
      instance.closePopup({
        isDenied: true,
        value: value
      });
    }
  };

  var succeedWith = function succeedWith(instance, value) {
    instance.closePopup({
      isConfirmed: true,
      value: value
    });
  };

  var confirm = function confirm(instance, innerParams, value) {
    if (innerParams.showLoaderOnConfirm) {
      showLoading(); // TODO: make showLoading an *instance* method
    }

    if (innerParams.preConfirm) {
      instance.resetValidationMessage();
      var preConfirmPromise = Promise.resolve().then(function () {
        return asPromise(innerParams.preConfirm(value, innerParams.validationMessage));
      });
      preConfirmPromise.then(function (preConfirmValue) {
        if (isVisible(getValidationMessage()) || preConfirmValue === false) {
          instance.hideLoading();
        } else {
          succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
        }
      });
    } else {
      succeedWith(instance, value);
    }
  };

  var addKeydownHandler = function addKeydownHandler(instance, globalState, innerParams, dismissWith) {
    if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
      globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = false;
    }

    if (!innerParams.toast) {
      globalState.keydownHandler = function (e) {
        return keydownHandler(instance, e, dismissWith);
      };

      globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
      globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
      globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = true;
    }
  }; // Focus handling

  var setFocus = function setFocus(innerParams, index, increment) {
    var focusableElements = getFocusableElements(); // search for visible elements and select the next possible match

    if (focusableElements.length) {
      index = index + increment; // rollover to first item

      if (index === focusableElements.length) {
        index = 0; // go to last item
      } else if (index === -1) {
        index = focusableElements.length - 1;
      }

      return focusableElements[index].focus();
    } // no visible focusable elements, focus the popup


    getPopup().focus();
  };
  var arrowKeysNextButton = ['ArrowRight', 'ArrowDown', 'Right', 'Down' // IE11
  ];
  var arrowKeysPreviousButton = ['ArrowLeft', 'ArrowUp', 'Left', 'Up' // IE11
  ];
  var escKeys = ['Escape', 'Esc' // IE11
  ];

  var keydownHandler = function keydownHandler(instance, e, dismissWith) {
    var innerParams = privateProps.innerParams.get(instance);

    if (!innerParams) {
      return; // This instance has already been destroyed
    }

    if (innerParams.stopKeydownPropagation) {
      e.stopPropagation();
    } // ENTER


    if (e.key === 'Enter') {
      handleEnter(instance, e, innerParams); // TAB
    } else if (e.key === 'Tab') {
      handleTab(e, innerParams); // ARROWS - switch focus between buttons
    } else if ([].concat(arrowKeysNextButton, arrowKeysPreviousButton).indexOf(e.key) !== -1) {
      handleArrows(e.key); // ESC
    } else if (escKeys.indexOf(e.key) !== -1) {
      handleEsc(e, innerParams, dismissWith);
    }
  };

  var handleEnter = function handleEnter(instance, e, innerParams) {
    // #720 #721
    if (e.isComposing) {
      return;
    }

    if (e.target && instance.getInput() && e.target.outerHTML === instance.getInput().outerHTML) {
      if (['textarea', 'file'].indexOf(innerParams.input) !== -1) {
        return; // do not submit
      }

      clickConfirm();
      e.preventDefault();
    }
  };

  var handleTab = function handleTab(e, innerParams) {
    var targetElement = e.target;
    var focusableElements = getFocusableElements();
    var btnIndex = -1;

    for (var i = 0; i < focusableElements.length; i++) {
      if (targetElement === focusableElements[i]) {
        btnIndex = i;
        break;
      }
    }

    if (!e.shiftKey) {
      // Cycle to the next button
      setFocus(innerParams, btnIndex, 1);
    } else {
      // Cycle to the prev button
      setFocus(innerParams, btnIndex, -1);
    }

    e.stopPropagation();
    e.preventDefault();
  };

  var handleArrows = function handleArrows(key) {
    var confirmButton = getConfirmButton();
    var denyButton = getDenyButton();
    var cancelButton = getCancelButton();

    if (!([confirmButton, denyButton, cancelButton].indexOf(document.activeElement) !== -1)) {
      return;
    }

    var sibling = arrowKeysNextButton.indexOf(key) !== -1 ? 'nextElementSibling' : 'previousElementSibling';
    var buttonToFocus = document.activeElement[sibling];

    if (buttonToFocus) {
      buttonToFocus.focus();
    }
  };

  var handleEsc = function handleEsc(e, innerParams, dismissWith) {
    if (callIfFunction(innerParams.allowEscapeKey)) {
      e.preventDefault();
      dismissWith(DismissReason.esc);
    }
  };

  var handlePopupClick = function handlePopupClick(instance, domCache, dismissWith) {
    var innerParams = privateProps.innerParams.get(instance);

    if (innerParams.toast) {
      handleToastClick(instance, domCache, dismissWith);
    } else {
      // Ignore click events that had mousedown on the popup but mouseup on the container
      // This can happen when the user drags a slider
      handleModalMousedown(domCache); // Ignore click events that had mousedown on the container but mouseup on the popup

      handleContainerMousedown(domCache);
      handleModalClick(instance, domCache, dismissWith);
    }
  };

  var handleToastClick = function handleToastClick(instance, domCache, dismissWith) {
    // Closing toast by internal click
    domCache.popup.onclick = function () {
      var innerParams = privateProps.innerParams.get(instance);

      if (innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton || innerParams.timer || innerParams.input) {
        return;
      }

      dismissWith(DismissReason.close);
    };
  };

  var ignoreOutsideClick = false;

  var handleModalMousedown = function handleModalMousedown(domCache) {
    domCache.popup.onmousedown = function () {
      domCache.container.onmouseup = function (e) {
        domCache.container.onmouseup = undefined; // We only check if the mouseup target is the container because usually it doesn't
        // have any other direct children aside of the popup

        if (e.target === domCache.container) {
          ignoreOutsideClick = true;
        }
      };
    };
  };

  var handleContainerMousedown = function handleContainerMousedown(domCache) {
    domCache.container.onmousedown = function () {
      domCache.popup.onmouseup = function (e) {
        domCache.popup.onmouseup = undefined; // We also need to check if the mouseup target is a child of the popup

        if (e.target === domCache.popup || domCache.popup.contains(e.target)) {
          ignoreOutsideClick = true;
        }
      };
    };
  };

  var handleModalClick = function handleModalClick(instance, domCache, dismissWith) {
    domCache.container.onclick = function (e) {
      var innerParams = privateProps.innerParams.get(instance);

      if (ignoreOutsideClick) {
        ignoreOutsideClick = false;
        return;
      }

      if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) {
        dismissWith(DismissReason.backdrop);
      }
    };
  };

  function _main(userParams) {
    var mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    showWarningsForParams(_extends({}, mixinParams, userParams));

    if (globalState.currentInstance) {
      globalState.currentInstance._destroy();
    }

    globalState.currentInstance = this;
    var innerParams = prepareParams(userParams, mixinParams);
    setParameters(innerParams);
    Object.freeze(innerParams); // clear the previous timer

    if (globalState.timeout) {
      globalState.timeout.stop();
      delete globalState.timeout;
    } // clear the restore focus timeout


    clearTimeout(globalState.restoreFocusTimeout);
    var domCache = populateDomCache(this);
    render(this, innerParams);
    privateProps.innerParams.set(this, innerParams);
    return swalPromise(this, domCache, innerParams);
  }

  var prepareParams = function prepareParams(userParams, mixinParams) {
    var templateParams = getTemplateParams(userParams);

    var params = _extends({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131


    params.showClass = _extends({}, defaultParams.showClass, params.showClass);
    params.hideClass = _extends({}, defaultParams.hideClass, params.hideClass); // @deprecated

    if (userParams.animation === false) {
      params.showClass = {
        popup: 'swal2-noanimation',
        backdrop: 'swal2-noanimation'
      };
      params.hideClass = {};
    }

    return params;
  };

  var swalPromise = function swalPromise(instance, domCache, innerParams) {
    return new Promise(function (resolve) {
      // functions to handle all closings/dismissals
      var dismissWith = function dismissWith(dismiss) {
        instance.closePopup({
          isDismissed: true,
          dismiss: dismiss
        });
      };

      privateMethods.swalPromiseResolve.set(instance, resolve);

      domCache.confirmButton.onclick = function () {
        return handleConfirmButtonClick(instance, innerParams);
      };

      domCache.denyButton.onclick = function () {
        return handleDenyButtonClick(instance, innerParams);
      };

      domCache.cancelButton.onclick = function () {
        return handleCancelButtonClick(instance, dismissWith);
      };

      domCache.closeButton.onclick = function () {
        return dismissWith(DismissReason.close);
      };

      handlePopupClick(instance, domCache, dismissWith);
      addKeydownHandler(instance, globalState, innerParams, dismissWith);
      handleInputOptionsAndValue(instance, innerParams);
      openPopup(innerParams);
      setupTimer(globalState, innerParams, dismissWith);
      initFocus(domCache, innerParams); // Scroll container to top on open (#1247, #1946)

      setTimeout(function () {
        domCache.container.scrollTop = 0;
      });
    });
  };

  var populateDomCache = function populateDomCache(instance) {
    var domCache = {
      popup: getPopup(),
      container: getContainer(),
      content: getContent(),
      actions: getActions(),
      confirmButton: getConfirmButton(),
      denyButton: getDenyButton(),
      cancelButton: getCancelButton(),
      loader: getLoader(),
      closeButton: getCloseButton(),
      validationMessage: getValidationMessage(),
      progressSteps: getProgressSteps()
    };
    privateProps.domCache.set(instance, domCache);
    return domCache;
  };

  var setupTimer = function setupTimer(globalState$$1, innerParams, dismissWith) {
    var timerProgressBar = getTimerProgressBar();
    hide(timerProgressBar);

    if (innerParams.timer) {
      globalState$$1.timeout = new Timer(function () {
        dismissWith('timer');
        delete globalState$$1.timeout;
      }, innerParams.timer);

      if (innerParams.timerProgressBar) {
        show(timerProgressBar);
        setTimeout(function () {
          if (globalState$$1.timeout && globalState$$1.timeout.running) {
            // timer can be already stopped or unset at this point
            animateTimerProgressBar(innerParams.timer);
          }
        });
      }
    }
  };

  var initFocus = function initFocus(domCache, innerParams) {
    if (innerParams.toast) {
      return;
    }

    if (!callIfFunction(innerParams.allowEnterKey)) {
      return blurActiveElement();
    }

    if (!focusButton(domCache, innerParams)) {
      setFocus(innerParams, -1, 1);
    }
  };

  var focusButton = function focusButton(domCache, innerParams) {
    if (innerParams.focusDeny && isVisible(domCache.denyButton)) {
      domCache.denyButton.focus();
      return true;
    }

    if (innerParams.focusCancel && isVisible(domCache.cancelButton)) {
      domCache.cancelButton.focus();
      return true;
    }

    if (innerParams.focusConfirm && isVisible(domCache.confirmButton)) {
      domCache.confirmButton.focus();
      return true;
    }

    return false;
  };

  var blurActiveElement = function blurActiveElement() {
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
  };

  /**
   * Updates popup parameters.
   */

  function update(params) {
    var popup = getPopup();
    var innerParams = privateProps.innerParams.get(this);

    if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
      return warn("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    }

    var validUpdatableParams = {}; // assign valid params from `params` to `defaults`

    Object.keys(params).forEach(function (param) {
      if (Swal.isUpdatableParameter(param)) {
        validUpdatableParams[param] = params[param];
      } else {
        warn("Invalid parameter to update: \"".concat(param, "\". Updatable params are listed here: https://github.com/sweetalert2/sweetalert2/blob/master/src/utils/params.js\n\nIf you think this parameter should be updatable, request it here: https://github.com/sweetalert2/sweetalert2/issues/new?template=02_feature_request.md"));
      }
    });

    var updatedParams = _extends({}, innerParams, validUpdatableParams);

    render(this, updatedParams);
    privateProps.innerParams.set(this, updatedParams);
    Object.defineProperties(this, {
      params: {
        value: _extends({}, this.params, params),
        writable: false,
        enumerable: true
      }
    });
  }

  function _destroy() {
    var domCache = privateProps.domCache.get(this);
    var innerParams = privateProps.innerParams.get(this);

    if (!innerParams) {
      return; // This instance has already been destroyed
    } // Check if there is another Swal closing


    if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
      globalState.swalCloseEventFinishedCallback();
      delete globalState.swalCloseEventFinishedCallback;
    } // Check if there is a swal disposal defer timer


    if (globalState.deferDisposalTimer) {
      clearTimeout(globalState.deferDisposalTimer);
      delete globalState.deferDisposalTimer;
    }

    runDidDestroy(innerParams);
    disposeSwal(this);
  }

  var runDidDestroy = function runDidDestroy(innerParams) {
    if (typeof innerParams.didDestroy === 'function') {
      innerParams.didDestroy();
    } else if (typeof innerParams.onDestroy === 'function') {
      innerParams.onDestroy(); // @deprecated
    }
  };

  var disposeSwal = function disposeSwal(instance) {
    // Unset this.params so GC will dispose it (#1569)
    delete instance.params; // Unset globalState props so GC will dispose globalState (#1569)

    delete globalState.keydownHandler;
    delete globalState.keydownTarget; // Unset WeakMaps so GC will be able to dispose them (#1569)

    unsetWeakMaps(privateProps);
    unsetWeakMaps(privateMethods);
  };

  var unsetWeakMaps = function unsetWeakMaps(obj) {
    for (var i in obj) {
      obj[i] = new WeakMap();
    }
  };



  var instanceMethods = /*#__PURE__*/Object.freeze({
    hideLoading: hideLoading,
    disableLoading: hideLoading,
    getInput: getInput$1,
    close: close,
    closePopup: close,
    closeModal: close,
    closeToast: close,
    enableButtons: enableButtons,
    disableButtons: disableButtons,
    enableInput: enableInput,
    disableInput: disableInput,
    showValidationMessage: showValidationMessage,
    resetValidationMessage: resetValidationMessage$1,
    getProgressSteps: getProgressSteps$1,
    _main: _main,
    update: update,
    _destroy: _destroy
  });

  var currentInstance;

  var SweetAlert = /*#__PURE__*/function () {
    function SweetAlert() {
      _classCallCheck(this, SweetAlert);

      // Prevent run in Node env
      if (typeof window === 'undefined') {
        return;
      } // Check for the existence of Promise


      if (typeof Promise === 'undefined') {
        error('This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/sweetalert2/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)');
      }

      currentInstance = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var outerParams = Object.freeze(this.constructor.argsToParams(args));
      Object.defineProperties(this, {
        params: {
          value: outerParams,
          writable: false,
          enumerable: true,
          configurable: true
        }
      });

      var promise = this._main(this.params);

      privateProps.promise.set(this, promise);
    } // `catch` cannot be the name of a module export, so we define our thenable methods here instead


    _createClass(SweetAlert, [{
      key: "then",
      value: function then(onFulfilled) {
        var promise = privateProps.promise.get(this);
        return promise.then(onFulfilled);
      }
    }, {
      key: "finally",
      value: function _finally(onFinally) {
        var promise = privateProps.promise.get(this);
        return promise["finally"](onFinally);
      }
    }]);

    return SweetAlert;
  }(); // Assign instance methods from src/instanceMethods/*.js to prototype


  _extends(SweetAlert.prototype, instanceMethods); // Assign static methods from src/staticMethods/*.js to constructor


  _extends(SweetAlert, staticMethods); // Proxy to instance methods to constructor, for now, for backwards compatibility


  Object.keys(instanceMethods).forEach(function (key) {
    SweetAlert[key] = function () {
      if (currentInstance) {
        var _currentInstance;

        return (_currentInstance = currentInstance)[key].apply(_currentInstance, arguments);
      }
    };
  });
  SweetAlert.DismissReason = DismissReason;
  SweetAlert.version = '10.16.9';

  var Swal = SweetAlert;
  Swal["default"] = Swal;

  return Swal;

}));
if (typeof this !== 'undefined' && this.Sweetalert2){  this.swal = this.sweetAlert = this.Swal = this.SweetAlert = this.Sweetalert2}

"undefined"!=typeof document&&function(e,t){var n=e.createElement("style");if(e.getElementsByTagName("head")[0].appendChild(n),n.styleSheet)n.styleSheet.disabled||(n.styleSheet.cssText=t);else try{n.innerHTML=t}catch(e){n.innerText=t}}(document,".swal2-popup.swal2-toast{flex-direction:column;align-items:stretch;width:auto;padding:1.25em;overflow-y:hidden;background:#fff;box-shadow:0 0 .625em #d9d9d9}.swal2-popup.swal2-toast .swal2-header{flex-direction:row;padding:0}.swal2-popup.swal2-toast .swal2-title{flex-grow:1;justify-content:flex-start;margin:0 .625em;font-size:1em}.swal2-popup.swal2-toast .swal2-loading{justify-content:center}.swal2-popup.swal2-toast .swal2-input{height:2em;margin:.3125em auto;font-size:1em}.swal2-popup.swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{position:static;width:.8em;height:.8em;line-height:.8}.swal2-popup.swal2-toast .swal2-content{justify-content:flex-start;margin:0 .625em;padding:0;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-html-container{padding:.625em 0 0}.swal2-popup.swal2-toast .swal2-html-container:empty{padding:0}.swal2-popup.swal2-toast .swal2-icon{width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:700}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{font-size:.25em}}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{flex:1;flex-basis:auto!important;align-self:stretch;width:auto;height:2.2em;height:auto;margin:0 .3125em;margin-top:.3125em;padding:0}.swal2-popup.swal2-toast .swal2-styled{margin:.125em .3125em;padding:.3125em .625em;font-size:1em}.swal2-popup.swal2-toast .swal2-styled:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(100,150,200,.5)}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.8em;left:-.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{-webkit-animation:swal2-toast-animate-success-line-tip .75s;animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{-webkit-animation:swal2-toast-animate-success-line-long .75s;animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{-webkit-animation:swal2-toast-show .5s;animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{-webkit-animation:swal2-toast-hide .1s forwards;animation:swal2-toast-hide .1s forwards}.swal2-container{display:flex;position:fixed;z-index:1060;top:0;right:0;bottom:0;left:0;flex-direction:row;align-items:center;justify-content:center;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}.swal2-container.swal2-backdrop-show,.swal2-container.swal2-noanimation{background:rgba(0,0,0,.4)}.swal2-container.swal2-backdrop-hide{background:0 0!important}.swal2-container.swal2-top{align-items:flex-start}.swal2-container.swal2-top-left,.swal2-container.swal2-top-start{align-items:flex-start;justify-content:flex-start}.swal2-container.swal2-top-end,.swal2-container.swal2-top-right{align-items:flex-start;justify-content:flex-end}.swal2-container.swal2-center{align-items:center}.swal2-container.swal2-center-left,.swal2-container.swal2-center-start{align-items:center;justify-content:flex-start}.swal2-container.swal2-center-end,.swal2-container.swal2-center-right{align-items:center;justify-content:flex-end}.swal2-container.swal2-bottom{align-items:flex-end}.swal2-container.swal2-bottom-left,.swal2-container.swal2-bottom-start{align-items:flex-end;justify-content:flex-start}.swal2-container.swal2-bottom-end,.swal2-container.swal2-bottom-right{align-items:flex-end;justify-content:flex-end}.swal2-container.swal2-bottom-end>:first-child,.swal2-container.swal2-bottom-left>:first-child,.swal2-container.swal2-bottom-right>:first-child,.swal2-container.swal2-bottom-start>:first-child,.swal2-container.swal2-bottom>:first-child{margin-top:auto}.swal2-container.swal2-grow-fullscreen>.swal2-modal{display:flex!important;flex:1;align-self:stretch;justify-content:center}.swal2-container.swal2-grow-row>.swal2-modal{display:flex!important;flex:1;align-content:center;justify-content:center}.swal2-container.swal2-grow-column{flex:1;flex-direction:column}.swal2-container.swal2-grow-column.swal2-bottom,.swal2-container.swal2-grow-column.swal2-center,.swal2-container.swal2-grow-column.swal2-top{align-items:center}.swal2-container.swal2-grow-column.swal2-bottom-left,.swal2-container.swal2-grow-column.swal2-bottom-start,.swal2-container.swal2-grow-column.swal2-center-left,.swal2-container.swal2-grow-column.swal2-center-start,.swal2-container.swal2-grow-column.swal2-top-left,.swal2-container.swal2-grow-column.swal2-top-start{align-items:flex-start}.swal2-container.swal2-grow-column.swal2-bottom-end,.swal2-container.swal2-grow-column.swal2-bottom-right,.swal2-container.swal2-grow-column.swal2-center-end,.swal2-container.swal2-grow-column.swal2-center-right,.swal2-container.swal2-grow-column.swal2-top-end,.swal2-container.swal2-grow-column.swal2-top-right{align-items:flex-end}.swal2-container.swal2-grow-column>.swal2-modal{display:flex!important;flex:1;align-content:center;justify-content:center}.swal2-container.swal2-no-transition{transition:none!important}.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen)>.swal2-modal{margin:auto}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-container .swal2-modal{margin:0!important}}.swal2-popup{display:none;position:relative;box-sizing:border-box;flex-direction:column;justify-content:center;width:32em;max-width:100%;padding:1.25em;border:none;border-radius:5px;background:#fff;font-family:inherit;font-size:1rem}.swal2-popup:focus{outline:0}.swal2-popup.swal2-loading{overflow-y:hidden}.swal2-header{display:flex;flex-direction:column;align-items:center;padding:0 1.8em}.swal2-title{position:relative;max-width:100%;margin:0 0 .4em;padding:0;color:#595959;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}.swal2-actions{display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:100%;margin:1.25em auto 0;padding:0}.swal2-actions:not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}.swal2-actions:not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}.swal2-actions:not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.2))}.swal2-loader{display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 transparent #2778c4 transparent}.swal2-styled{margin:.3125em;padding:.625em 1.1em;box-shadow:none;font-weight:500}.swal2-styled:not([disabled]){cursor:pointer}.swal2-styled.swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#2778c4;color:#fff;font-size:1em}.swal2-styled.swal2-deny{border:0;border-radius:.25em;background:initial;background-color:#d14529;color:#fff;font-size:1em}.swal2-styled.swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#757575;color:#fff;font-size:1em}.swal2-styled:focus{outline:0;box-shadow:0 0 0 3px rgba(100,150,200,.5)}.swal2-styled::-moz-focus-inner{border:0}.swal2-footer{justify-content:center;margin:1.25em 0 0;padding:1em 0 0;border-top:1px solid #eee;color:#545454;font-size:1em}.swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;height:.25em;overflow:hidden;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.swal2-timer-progress-bar{width:100%;height:.25em;background:rgba(0,0,0,.2)}.swal2-image{max-width:100%;margin:1.25em auto}.swal2-close{position:absolute;z-index:2;top:0;right:0;align-items:center;justify-content:center;width:1.2em;height:1.2em;padding:0;overflow:hidden;transition:color .1s ease-out;border:none;border-radius:5px;background:0 0;color:#ccc;font-family:serif;font-size:2.5em;line-height:1.2;cursor:pointer}.swal2-close:hover{transform:none;background:0 0;color:#f27474}.swal2-close:focus{outline:0;box-shadow:inset 0 0 0 3px rgba(100,150,200,.5)}.swal2-close::-moz-focus-inner{border:0}.swal2-content{z-index:1;justify-content:center;margin:0;padding:0 1.6em;color:#545454;font-size:1.125em;font-weight:400;line-height:normal;text-align:center;word-wrap:break-word}.swal2-checkbox,.swal2-file,.swal2-input,.swal2-radio,.swal2-select,.swal2-textarea{margin:1em auto}.swal2-file,.swal2-input,.swal2-textarea{box-sizing:border-box;width:100%;transition:border-color .3s,box-shadow .3s;border:1px solid #d9d9d9;border-radius:.1875em;background:inherit;box-shadow:inset 0 1px 1px rgba(0,0,0,.06);color:inherit;font-size:1.125em}.swal2-file.swal2-inputerror,.swal2-input.swal2-inputerror,.swal2-textarea.swal2-inputerror{border-color:#f27474!important;box-shadow:0 0 2px #f27474!important}.swal2-file:focus,.swal2-input:focus,.swal2-textarea:focus{border:1px solid #b4dbed;outline:0;box-shadow:0 0 0 3px rgba(100,150,200,.5)}.swal2-file::-moz-placeholder,.swal2-input::-moz-placeholder,.swal2-textarea::-moz-placeholder{color:#ccc}.swal2-file:-ms-input-placeholder,.swal2-input:-ms-input-placeholder,.swal2-textarea:-ms-input-placeholder{color:#ccc}.swal2-file::placeholder,.swal2-input::placeholder,.swal2-textarea::placeholder{color:#ccc}.swal2-range{margin:1em auto;background:#fff}.swal2-range input{width:80%}.swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}.swal2-range input,.swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}.swal2-input{height:2.625em;padding:0 .75em}.swal2-input[type=number]{max-width:10em}.swal2-file{background:inherit;font-size:1.125em}.swal2-textarea{height:6.75em;padding:.75em}.swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:inherit;color:inherit;font-size:1.125em}.swal2-checkbox,.swal2-radio{align-items:center;justify-content:center;background:#fff;color:inherit}.swal2-checkbox label,.swal2-radio label{margin:0 .6em;font-size:1.125em}.swal2-checkbox input,.swal2-radio input{flex-shrink:0;margin:0 .4em}.swal2-input-label{display:flex;justify-content:center;margin:1em auto}.swal2-validation-message{align-items:center;justify-content:center;margin:0 -2.7em;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}.swal2-validation-message::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}.swal2-icon{position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:1.25em auto 1.875em;border:.25em solid transparent;border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}.swal2-icon.swal2-error{border-color:#f27474;color:#f27474}.swal2-icon.swal2-error .swal2-x-mark{position:relative;flex-grow:1}.swal2-icon.swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}.swal2-icon.swal2-error.swal2-icon-show{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-error.swal2-icon-show .swal2-x-mark{-webkit-animation:swal2-animate-error-x-mark .5s;animation:swal2-animate-error-x-mark .5s}.swal2-icon.swal2-warning{border-color:#facea8;color:#f8bb86}.swal2-icon.swal2-info{border-color:#9de0f6;color:#3fc3ee}.swal2-icon.swal2-question{border-color:#c9dae1;color:#87adbd}.swal2-icon.swal2-success{border-color:#a5dc86;color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;transform:rotate(45deg);border-radius:50%}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}.swal2-icon.swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-.25em;left:-.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}.swal2-icon.swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}.swal2-icon.swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip{-webkit-animation:swal2-animate-success-line-tip .75s;animation:swal2-animate-success-line-tip .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long{-webkit-animation:swal2-animate-success-line-long .75s;animation:swal2-animate-success-line-long .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right{-webkit-animation:swal2-rotate-success-circular-line 4.25s ease-in;animation:swal2-rotate-success-circular-line 4.25s ease-in}.swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:0 0 1.25em;padding:0;background:inherit;font-weight:600}.swal2-progress-steps li{display:inline-block;position:relative}.swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}.swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}[class^=swal2]{-webkit-tap-highlight-color:transparent}.swal2-show{-webkit-animation:swal2-show .3s;animation:swal2-show .3s}.swal2-hide{-webkit-animation:swal2-hide .15s forwards;animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{right:auto;left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@supports (-ms-accelerator:true){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@-webkit-keyframes swal2-toast-show{0%{transform:translateY(-.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0)}}@keyframes swal2-toast-show{0%{transform:translateY(-.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0)}}@-webkit-keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@-webkit-keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@-webkit-keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@-webkit-keyframes swal2-show{0%{transform:scale(.7)}45%{transform:scale(1.05)}80%{transform:scale(.95)}100%{transform:scale(1)}}@keyframes swal2-show{0%{transform:scale(.7)}45%{transform:scale(1.05)}80%{transform:scale(.95)}100%{transform:scale(1)}}@-webkit-keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(.5);opacity:0}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(.5);opacity:0}}@-webkit-keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@-webkit-keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@-webkit-keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@-webkit-keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(.4);opacity:0}50%{margin-top:1.625em;transform:scale(.4);opacity:0}80%{margin-top:-.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(.4);opacity:0}50%{margin-top:1.625em;transform:scale(.4);opacity:0}80%{margin-top:-.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@-webkit-keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0);opacity:1}}@-webkit-keyframes swal2-rotate-loading{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes swal2-rotate-loading{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto!important}body.swal2-no-backdrop .swal2-container{top:auto;right:auto;bottom:auto;left:auto;max-width:calc(100% - .625em * 2);background-color:transparent!important}body.swal2-no-backdrop .swal2-container>.swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}body.swal2-no-backdrop .swal2-container.swal2-top{top:0;left:50%;transform:translateX(-50%)}body.swal2-no-backdrop .swal2-container.swal2-top-left,body.swal2-no-backdrop .swal2-container.swal2-top-start{top:0;left:0}body.swal2-no-backdrop .swal2-container.swal2-top-end,body.swal2-no-backdrop .swal2-container.swal2-top-right{top:0;right:0}body.swal2-no-backdrop .swal2-container.swal2-center{top:50%;left:50%;transform:translate(-50%,-50%)}body.swal2-no-backdrop .swal2-container.swal2-center-left,body.swal2-no-backdrop .swal2-container.swal2-center-start{top:50%;left:0;transform:translateY(-50%)}body.swal2-no-backdrop .swal2-container.swal2-center-end,body.swal2-no-backdrop .swal2-container.swal2-center-right{top:50%;right:0;transform:translateY(-50%)}body.swal2-no-backdrop .swal2-container.swal2-bottom{bottom:0;left:50%;transform:translateX(-50%)}body.swal2-no-backdrop .swal2-container.swal2-bottom-left,body.swal2-no-backdrop .swal2-container.swal2-bottom-start{bottom:0;left:0}body.swal2-no-backdrop .swal2-container.swal2-bottom-end,body.swal2-no-backdrop .swal2-container.swal2-bottom-right{right:0;bottom:0}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll!important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static!important}}body.swal2-toast-shown .swal2-container{background-color:transparent}body.swal2-toast-shown .swal2-container.swal2-top{top:0;right:auto;bottom:auto;left:50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{top:0;right:0;bottom:auto;left:auto}body.swal2-toast-shown .swal2-container.swal2-top-left,body.swal2-toast-shown .swal2-container.swal2-top-start{top:0;right:auto;bottom:auto;left:0}body.swal2-toast-shown .swal2-container.swal2-center-left,body.swal2-toast-shown .swal2-container.swal2-center-start{top:50%;right:auto;bottom:auto;left:0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{top:50%;right:auto;bottom:auto;left:50%;transform:translate(-50%,-50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{top:50%;right:0;bottom:auto;left:auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-left,body.swal2-toast-shown .swal2-container.swal2-bottom-start{top:auto;right:auto;bottom:0;left:0}body.swal2-toast-shown .swal2-container.swal2-bottom{top:auto;right:auto;bottom:0;left:50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{top:auto;right:0;bottom:0;left:auto}");

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_LandFilter__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_land_LandList__ = __webpack_require__(250);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app-map',
  mixins: [],
  components: {
    'app-land-list': __WEBPACK_IMPORTED_MODULE_1__components_journey_land_LandList__["a" /* default */]
  },
  props: {
    landSummary: {
      type: Array
    }
  },
  data: function data() {
    return {
      filteredLandSummary: [],
      builders: [],
      lotgroups: [],
      filter: null,
      filterToggle: false,
      priceSlider: null,
      areaSlider: null,
      activeLot: null
    };
  },

  watch: {
    activeLot: function activeLot(val, oldval) {
      if (val) {
        this.$emit("setActiveLot", val);
      }
    }
  },
  created: function created() {
    var homeSelected = this.$route.query.homeid;

    if (homeSelected) {
      document.getElementById('map-legend').classList.add('is-hidden');
    }
  },
  mounted: function mounted() {
    if (this.landSummary.length) {
      this.filteredLandSummary = this.landSummary.filter(function (lot) {
        return lot.currentstatusname === 'Available' && lot.allocatedBuilderName && lot.currentstatusname !== 'sold' && lot.currentstatusname !== 'closed' && lot.currentstatusname !== 'unknown';
      });
      this.initFilter();
    }
  },
  destroyed: function destroyed() {},

  methods: {
    resetFilter: function resetFilter() {
      this.filter.landAreaFrom = this.filter.landAreaMin;
      this.filter.landAreaTo = this.filter.landAreaMax;
      this.filter.builder = '';
      this.filter.lotgroup = '';
      this.filter.stage = '';
      this.areaSlider.reset();
      this.filterLots();
    },

    initFilter: function initFilter() {
      var _this = this;

      this.filter = __WEBPACK_IMPORTED_MODULE_0__model_LandFilter__["a" /* default */];
      this.filteredLandSummary.forEach(function (lot) {
        if (lot.allocatedBuilderName && lot.allocatedBuilderName !== '' && !_this.builders.includes(lot.allocatedBuilderName)) {
          _this.builders.push(lot.allocatedBuilderName);
        }

        if (lot.lotgroup && !_this.lotgroups.includes(lot.lotgroup)) {
          _this.lotgroups.push(lot.lotgroup);
        }

        if (!_this.filter.stages.includes(lot.stageproductname)) {
          _this.filter.stages.push(lot.stageproductname);
        }

        if (lot.productsize && (_this.filter.landAreaMin === 0 || lot.productsize < _this.filter.landAreaMin)) {
          _this.filter.landAreaMin = lot.productsize;
        }

        if (lot.productsize && lot.productsize < _this.filter.landAreaMin) {
          _this.filter.areaMin = lot.productsize;
        }

        if (lot.productsize && (_this.filter.landAreaMax === 0 || lot.productsize > _this.filter.landAreaMax)) {
          _this.filter.landAreaMax = lot.productsize;
        }

        if (lot.productprice && lot.productprice < _this.filter.landPriceMin) {
          _this.filter.landPriceMin = lot.productprice;
        }

        if (lot.productprice && lot.productprice > _this.filter.landPriceMax) {
          _this.filter.landPriceMax = lot.productprice;
        }

        // if (lot.productwidth < this.filter.landWidthMin) {
        //   this.filter.landWidthMin = lot.productwidth;
        // }
        //
        // if (lot.productwidth > this.filter.landWidthMax) {
        //   this.filter.landWidthMax = lot.productwidth;
        // }
      });

      // this.filter.landWidthFrom = this.filter.landWidthMin;
      // this.filter.landWidthTo = this.filter.landWidthMax;
      this.filter.landPriceFrom = this.filter.landPriceMin;
      this.filter.landPriceTo = this.filter.landPriceMax;
      this.filter.landAreaFrom = this.filter.landAreaMin;
      this.filter.landAreaTo = this.filter.landAreaMax;
      this.filter.stages.sort();
      this.builders.sort();
      this.lotgroups.sort();
      this.initSliders();
    },

    initSliders: function initSliders() {
      var _this2 = this;

      this.areaSlider = jQuery('#area').ionRangeSlider({
        postfix: 'sqft',
        type: "double",
        min: this.filter.landAreaMin,
        max: this.filter.landAreaMax,
        from: this.filter.landAreaFrom,
        to: this.filter.landAreaTo,
        force_edges: true,
        prettify_separator: ',',
        onFinish: function onFinish(data) {
          _this2.filter.landAreaFrom = data.from;
          _this2.filter.landAreaTo = data.to;
          _this2.filterLots();
        }
      }).data("ionRangeSlider");
    },

    filterByLotGroup: function filterByLotGroup(group) {
      if (this.filter.lotgroup === group) {
        this.filter.lotgroup = '';
      } else {
        this.filter.lotgroup = group;
      }
      this.filterLots();
    },

    filterLots: function filterLots() {
      var _this3 = this;

      var filteredList = [];
      this.landSummary.forEach(function (lot) {
        if (!lot) return;

        if (lot.currentstatusname !== 'Available') {
          return filteredList.push(lot);
        }

        if (_this3.filter.builder !== '' && lot.allocatedBuilderName !== _this3.filter.builder) {
          return;
        }

        if (_this3.filter.lotgroup !== '' && lot.lotgroup !== _this3.filter.lotgroup) {
          return;
        }

        if (_this3.filter.stage !== '' && lot.stageproductname !== _this3.filter.stage) {
          return;
        }

        if (lot.productsize && lot.productsize < _this3.filter.landAreaFrom) {
          return;
        }

        if (lot.productsize && lot.productsize > _this3.filter.landAreaTo) {
          return;
        }

        filteredList.push(lot);
      });
      this.filteredLandSummary = filteredList;
      this.$store.dispatch("setFilteredLotList", this.filteredLandSummary);
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app-land-list',
  mixins: [],
  props: {
    landSummary: {
      type: Array
    }
  },
  data: function data() {
    return {
      activeLot: null
    };
  },

  watch: {},
  created: function created() {},

  methods: {
    selectLot: function selectLot(lot) {
      this.activeLot = lot;
      this.$store.dispatch('productTracking', { page: 'lot-click', product: lot });
      this.$emit("setLotNameClick", lot);
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_journey_Journey__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_nav_Selector__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_journey_Loading__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'community',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_journey_Journey__["a" /* default */]],
  data: function data() {
    return {
      currentPage: null,
      listeningToMutation: false,
      loading: false,
      selector: null,
      sub: null
    };
  },

  components: {
    'app-selector': __WEBPACK_IMPORTED_MODULE_1__components_journey_nav_Selector__["a" /* default */],
    'app-loading': __WEBPACK_IMPORTED_MODULE_2__components_journey_Loading__["a" /* default */]
  },
  props: {
    activeHome: {
      type: Object
    },
    activeFacade: {
      type: Object
    },
    activeLot: {
      type: Object
    },
    nextTrigger: Boolean
  },
  watch: {
    activeHome: function activeHome(val, oldval) {
      if (val) {
        this.activeIds.homeid = val.cpidstring;
      }
    },
    activeFacade: function activeFacade(val, oldval) {
      if (val) {
        this.activeIds.facadeid = val.cpidstring;
      }
    },
    activeLot: function activeLot(val, oldval) {
      if (val) {
        this.activeIds.lotid = val.cpidstring;
        this.activeIds.lotcpid = val.lotcpid;
        return this.checkLotPage();
      }
    },
    nextTrigger: function nextTrigger(val, oldval) {
      if (val) {
        switch (this.currentPage) {
          case 'homes':
            return this.selectFacade();
          case 'facade':
            // this.checkFacadePage();
            return this.checkFacadePage();
          case 'map':
          // return this.checkLotPage();
          default:
            return this.reset();
        }
      }
    }
  },
  created: function created() {
    this.getCurrentPage();
    this.getIds();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.sub) {
      this.sub();
    }
  },

  methods: {
    getCreatedPackage: function getCreatedPackage() {
      var _this = this;

      if (!this.listeningToMutation) {
        this.listeningToMutation = true;
        this.sub = this.$store.subscribe(function (mutation, state) {
          if (mutation.type === 'setPackageCreation') {
            return _this.$router.push({
              path: '/community/package/' + state.communityStore.packageRecordId
            });
          }
        });
      }
    },

    getCurrentPage: function getCurrentPage() {
      this.currentPage = this.$route.name;
      if (this.currentPage === 'homes' || this.currentPage === 'facade') {
        if (this.$route.query.lotid && this.$route.query.lotcpid) {
          this.selector = 'lot';
        } else {
          this.selector = 'home';
        }
      }

      if (this.currentPage === 'map') {
        if (this.$route.query.homeid && this.$route.query.facadeid) {
          this.selector = 'home';
        } else {
          this.selector = 'lot';
        }
      }
    },

    selectHome: function selectHome() {
      if (this.activeIds.lotid) {
        return this.$router.push({
          path: '/community/homes',
          query: {
            lotid: this.activeIds.lotid,
            lotcpid: this.activeIds.lotcpid
          }
        });
      } else {
        return this.$router.push({
          path: '/community/homes'
        });
      }
    },

    selectLot: function selectLot() {
      return this.$router.push({
        path: '/community/lot'
      });
    },

    selectFacade: function selectFacade() {
      if (this.activeIds.homeid) {
        var id = [{
          key: 'homeid',
          value: this.activeIds.home
        }];
        this.setIds(id);
        this.goToFacade();
      }
    },

    checkFacadePage: function checkFacadePage() {
      if (this.activeIds.lotid && this.activeIds.lotcpid) {
        return this.createPackage();
      }
    },

    checkLotPage: function checkLotPage() {
      if (this.activeIds.lotid && this.activeIds.lotcpid && this.activeIds.facadeid && this.activeIds.homeid) {
        this.createPackage();
      } else {
        return this.$router.push({
          path: '/community/homes',
          query: { lotid: this.activeIds.lotid, lotcpid: this.activeIds.lotcpid }
        });
      }
    },

    createPackage: function createPackage() {
      this.loading = true;
      this.goToPackage();
      this.getCreatedPackage();
    },

    reset: function reset() {
      this.$router.push({
        path: '/community/'
      });
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app-selector',
  mixins: [],
  components: {},
  data: function data() {
    return {};
  },

  props: {
    name: String,
    number: String

  },
  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app-header',
  mixins: [],
  components: {},
  data: function data() {
    return {};
  },

  props: {
    loading: Boolean
  },
  watch: {
    loading: function loading(val, oldval) {
      if (!val) {
        document.getElementById("header-bar").scrollIntoView();
      }
    }
  },
  created: function created() {},

  methods: {}
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_journey_home_CompatibleHomeList__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_nav_Navigation__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_journey_Loading__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_journey_home_HomeList__ = __webpack_require__(266);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-community-homes',
  mixins: [],
  components: {
    'app-compatible-home-list': __WEBPACK_IMPORTED_MODULE_0__components_journey_home_CompatibleHomeList__["a" /* default */],
    'app-home-list': __WEBPACK_IMPORTED_MODULE_3__components_journey_home_HomeList__["a" /* default */],
    'app-navigation': __WEBPACK_IMPORTED_MODULE_1__components_journey_nav_Navigation__["a" /* default */],
    'app-loading': __WEBPACK_IMPORTED_MODULE_2__components_journey_Loading__["a" /* default */]
  },
  data: function data() {
    return {
      activeHome: null,
      loading: true,
      next: false,
      selector: null
    };
  },

  watch: {
    activeHome: function activeHome(val, oldVal) {
      if (val && !oldVal) {}
    }
  },
  created: function created() {
    this.getIds();
  },

  methods: {
    getIds: function getIds() {
      var query = this.$route.query;
      if (query.lotid && query.lotcpid) {
        return this.selector = 'lot';
      }
      return this.selector = 'home';
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_journey_home_HomeCard__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_home_HomeDetail__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_journey_home_HomeFilter__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app-map',
  mixins: [],
  components: {
    'app-home-card': __WEBPACK_IMPORTED_MODULE_0__components_journey_home_HomeCard__["a" /* default */],
    'app-home-detail': __WEBPACK_IMPORTED_MODULE_1__components_journey_home_HomeDetail__["a" /* default */],
    'app-home-filter': __WEBPACK_IMPORTED_MODULE_2__components_journey_home_HomeFilter__["a" /* default */]
  },
  data: function data() {
    return {
      activeHome: null,
      lotid: null,
      lotcpid: null,
      lotsummary: null,
      homeSummaryList: [],
      filteredHomeList: null,
      activeHomeDetail: null,
      locatedHnlSummary: null,
      sub: null
    };
  },

  watch: {
    activeHomeDetail: function activeHomeDetail(val, oldval) {
      this.$emit("setActiveHome", val);
    }
  },
  created: function created() {
    this.lotid = this.$route.query.lotid;
    this.lotcpid = this.$route.query.lotcpid;
    this.initCompatibleHomeSummaryList(this.lotcpid);
  },
  destroyed: function destroyed() {
    this.sub();
  },

  methods: {
    selectHome: function selectHome(hnlSummary) {
      this.activeHome = hnlSummary;
    },

    nextPage: function nextPage(ev) {
      this.activeHomeDetail = ev;
      this.$emit('goNext', true);
    },

    initCompatibleHomeSummaryList: function initCompatibleHomeSummaryList(lotCpId) {
      var _this = this;

      if (lotCpId) {
        this.$store.dispatch('fetchCompatibleHomeSummaryList', { lotCpId: lotCpId });
        this.sub = this.$store.subscribe(function (mutation, state) {
          if (mutation.type === 'setCompatibleHomeSummaryList') {
            _this.homeSummaryList = state.communityStore.homeSummary;
            _this.filteredHomeList = _this.homeSummaryList;
            _this.$emit('homesLoaded', true);
          }
        });
      }
    }
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // homeSummaryList: []
    };
  },

  props: {
    homeSummary: {
      type: Object
    },
    triggerSelect: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    locatePackage: function locatePackage(hnl) {},
    viewDetail: function viewDetail(hnl) {},
    goToNext: function goToNext(homesummary) {
      this.$store.dispatch('productTracking', { product: homesummary, page: 'home-design' });
      if (this.triggerSelect) {
        this.$emit('homeSelected', homesummary);
      }
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeDetail_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23497632_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeDetail_vue__ = __webpack_require__(263);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23497632_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_journey_home_SimilarHomes__ = __webpack_require__(261);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home-detail',
  props: {
    activeHomeDetail: {
      type: Object
    }
  },
  components: {
    'app-similar-homes': __WEBPACK_IMPORTED_MODULE_0__components_journey_home_SimilarHomes__["a" /* default */]
  },
  data: function data() {
    return {
      showDetail: false
    };
  },

  watch: {
    activeHomeDetail: function activeHomeDetail(val, oldval) {
      if (val) {
        this.showDetail = true;
      }
    }
  },
  methods: {
    goBack: function goBack() {
      this.showDetail = false;
      this.$emit('close-detail');
    },

    replaceActiveDetail: function replaceActiveDetail(homeSummary) {
      for (var key in this.activeHomeDetail) {
        this.activeHomeDetail[key] = homeSummary[key];
      }
    },

    goToNext: function goToNext() {
      var lotid = void 0;
      var lotcpid = void 0;
      var query = this.$route.query;
      if (query.lotid) {
        lotid = query.lotid;
      }
      if (query.lotcpid) {
        lotcpid = query.lotcpid;
      }
      console.log(this.activeHomeDetail);
      this.$router.push({
        path: '/community/facade',
        query: {
          homeid: this.activeHomeDetail.cpidstring,
          lotid: lotid,
          lotcpid: lotcpid,
          plancpid: this.activeHomeDetail.planProductCpIdString
        }
      });
    }
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_journey_home_HomeCard__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'similar-homes',
  props: {
    activeHomeDetail: {
      type: Object
    }
  },
  components: {
    'app-home-card': __WEBPACK_IMPORTED_MODULE_0__components_journey_home_HomeCard__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    if (this.activeHomeDetail) {
      this.homeSummaryList = this.$store.getters.homeSummary.filter(function (item) {
        return item.noofbedrooms === _this.activeHomeDetail.noofbedrooms && item.ownername === _this.activeHomeDetail.ownername;
      });
    }
  },
  data: function data() {
    return {
      homeSummaryList: []
    };
  },

  watch: {},
  methods: {
    selectHome: function selectHome(homesummary) {
      this.$store.dispatch('productTracking', { product: homesummary, page: 'home-design' });
      this.$emit('similarhome', homesummary);
    },

    viewHome: function viewHome() {}
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeFilter_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1101863c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeFilter_vue__ = __webpack_require__(264);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1101863c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__ = __webpack_require__(81);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home-filter',
  props: {
    homeSummaryList: {
      type: Array
    }
  },
  data: function data() {
    return {
      builders: [],
      filter: null,
      filterToggle: false
    };
  },
  mounted: function mounted() {
    if (this.homeSummaryList.length) {
      this.initFilters();
    }
  },

  methods: {
    initFilters: function initFilters() {
      var _this = this;

      this.filter = __WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__["a" /* default */];
      var minPrice = 0;
      var maxPrice = 0;
      var minArea = 0;
      var maxArea = 0;
      var minBed = 0;
      var maxBed = 0;
      var minBath = 0;
      var maxBath = 0;

      this.homeSummaryList.forEach(function (home) {
        if (!_this.builders.includes(home.ownername)) {
          _this.builders.push(home.ownername);
        }

        if ((minArea === 0 || home.productsize < minArea) && home.productsize !== null) {
          minArea = home.productsize;
        }
        if ((maxArea === 0 || home.productsize > maxArea) && home.productsize !== null) {
          maxArea = home.productsize;
        }

        if ((minPrice === 0 || home.productprice < minPrice) && home.productprice !== null) {
          minPrice = home.productprice;
        }
        if ((maxPrice === 0 || home.productprice > maxPrice) && home.productprice !== null) {
          maxPrice = home.productprice;
        }

        if ((minBed === 0 || home.noofbedrooms < minBed) && home.noofbedrooms !== null) {
          minBed = home.noofbedrooms;
        }
        if ((maxBed === 0 || home.noofbedrooms > maxBed) && home.noofbedrooms !== null) {
          maxBed = home.noofbedrooms;
        }
      });

      this.filter.homePriceMin = minPrice;
      this.filter.homePriceMax = maxPrice;
      this.filter.homePriceFrom = minPrice;
      this.filter.homePriceTo = maxPrice;
      this.filter.homeAreaMin = minArea;
      this.filter.homeAreaMax = maxArea;
      this.filter.homeAreaFrom = minArea;
      this.filter.homeAreaTo = maxArea;
      this.filter.minBed = minBed;
      this.filter.maxBed = maxBed;
      this.filter.minBath = minBath;
      this.filter.maxBath = maxBath;
      this.filter.bedArray = ['Any'];
      this.filter.bathArray = ['Any'];
      this.filter.carArray = ['Any'];
      this.filter.storeyArray = [];
      this.filter.buildersArray = [];

      this.builders.sort();
      this.filterHomes();
      this.initRangeSliders();
    },

    filterByBuilders: function filterByBuilders(builder) {
      var index = this.filter.buildersArray.indexOf(builder);
      if (index < 0) {
        this.filter.buildersArray.push(builder);
      } else {
        this.filter.buildersArray.splice(index, 1);
      }
      this.filterHomes();
    },

    initRangeSliders: function initRangeSliders() {
      var _this2 = this;

      this.priceSlider = jQuery(this.$refs['home-price']).ionRangeSlider({
        prefix: '$',
        type: "double",
        min: this.filter.homePriceMin,
        max: this.filter.homePriceMax,
        from: this.filter.homePriceFrom,
        force_edges: true,
        to: this.filter.homePriceTo,
        prettify_separator: ',',
        onFinish: function onFinish(data) {
          _this2.filter.homePriceFrom = data.from;
          _this2.filter.homePriceTo = data.to;
          _this2.filterHomes();
        }
      });

      this.areaSlider = jQuery(this.$refs['home-area']).ionRangeSlider({
        postfix: 'SQ FT',
        type: "double",
        min: this.filter.homeAreaMin,
        max: this.filter.homeAreaMax,
        from: this.filter.homeAreaFrom,
        to: this.filter.homeAreaTo,
        force_edges: true,
        prettify_separator: ',',
        onFinish: function onFinish(data) {
          _this2.filter.homeAreaFrom = data.from;
          _this2.filter.homeAreaTo = data.to;
          _this2.filterHomes();
        }
      });
    },

    filterByBed: function filterByBed(bed) {
      if (!this.filter.bedArray.includes(bed)) {
        this.filter.bedArray = [];
        this.filter.bedArray.push(bed);
        if (bed === 'Any') {
          this.filter.bedFrom = 0;
          return this.filterHomes();
        }
        this.filter.bedFrom = parseInt(bed.split('+')[0], 10);
        this.filterHomes();
      }
    },

    filterByBath: function filterByBath(bath) {
      if (!this.filter.bathArray.includes(bath)) {
        this.filter.bathArray = [];
        this.filter.bathArray.push(bath);
        if (bath === 'Any') {
          this.filter.bathFrom = 0;
          return this.filterHomes();
        }
        this.filter.bathFrom = parseInt(bath.split('+')[0], 10);
        this.filterHomes();
      }
    },

    filterByStorey: function filterByStorey(storey) {
      this.filter.storeyArray = [storey];
      this.filterHomes();
    },

    filterByCar: function filterByCar(car) {
      if (!this.filter.carArray.includes(car)) {
        this.filter.carArray = [];
        this.filter.carArray.push(car);
        this.filterHomes();
      }
    },

    resetFilters: function resetFilters() {
      this.filter.buildersArray = [];
      this.filter.bedArray = ['Any'];
      this.filter.bathArray = ['Any'];
      this.filter.storeyArray = [];
      this.filter.carArray = ['Any'];
      this.filter.bedFrom = 0;
      this.filter.bathFrom = 0;
      this.filter.tour = false;
      this.filter.homePriceFrom = this.filter.homePriceMin;
      this.filter.homePriceTo = this.filter.homePriceMax;
      this.filter.homeAreaFrom = this.filter.homeAreaMin;
      this.filter.homeAreaTo = this.filter.homeAreaMax;
      this.priceSlider.data('ionRangeSlider').update({
        from: this.filter.homePriceMin,
        to: this.filter.homePriceMax
      });
      this.areaSlider.data('ionRangeSlider').update({
        from: this.filter.homeAreaMin,
        to: this.filter.homeAreaMax
      });
      this.filter.quickMovein = false;
      this.filter.tour = false;
      this.filter.sortBy = '';
      this.filterHomes();
      this.sort(null);
    },

    filterHomes: function filterHomes() {
      var _this3 = this;

      this.filteredHomeList = [];
      this.homeSummaryList.forEach(function (home) {
        if (_this3.filter.buildersArray.length > 0 && _this3.filter.buildersArray.indexOf(home.ownername) < 0) {
          return;
        }
        if (home.noofbedrooms < _this3.filter.bedFrom) {
          return;
        }
        if (home.noofbathrooms < _this3.filter.bathFrom) {
          return;
        }
        if (home.productsize && home.productsize < _this3.filter.homeAreaFrom) {
          return;
        }
        if (home.productsize && home.productsize > _this3.filter.homeAreaTo) {
          return;
        }
        if (home.productprice && home.productprice !== 0 && home.productprice < _this3.filter.homePriceFrom) {
          return;
        }
        if (home.productprice && home.productprice !== 0 && home.productprice > _this3.filter.homePriceTo) {
          return;
        }
        if (__WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__["a" /* default */].storeyArray.length > 0 && __WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__["a" /* default */].storeyArray.indexOf(home.noofstoreys) < 0) {
          return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__["a" /* default */].carArray.includes('Any') && __WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__["a" /* default */].carArray.indexOf(home.noofcarparks) < 0) {
          return;
        }
        _this3.filteredHomeList.push(home);
      });
      this.$emit('filteredHomes', this.filteredHomeList);
    },

    sort: function sort(sortValue) {
      if (sortValue) {
        this.filter.sortBy = sortValue;
      }
      switch (this.filter.sortBy) {
        case 'price-low':
          this.filteredHomeList = this.filteredHomeList.sort(function (a, b) {
            var priceA = a.productprice;
            var priceB = b.productprice;
            if (priceA < priceB) {
              return -1;
            }
            if (priceA > priceB) {
              return 1;
            }
            return 0;
          });
          break;
        case 'price-high':
          this.filteredHomeList = this.filteredHomeList.sort(function (a, b) {
            var priceA = a.productprice;
            var priceB = b.productprice;
            if (priceA > priceB) {
              return -1;
            }
            if (priceA < priceB) {
              return 1;
            }
            return 0;
          });
          break;
        default:
          this.filteredHomeList = this.filteredHomeList.sort(function (a, b) {
            var nameA = a.designproductname.toLowerCase();
            var nameB = b.designproductname.toLowerCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          break;
      }
      this.$emit('filteredHomes', this.filteredHomeList);
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  homePriceMin: 0,
  homePriceMax: 10000000,
  homePriceFrom: 0,
  homePriceTo: 10000000,
  homeAreaMin: 0,
  homeAreaMax: 100000,
  homeAreaFrom: 0,
  homeAreaTo: 100000,
  buildersArray: [],
  bedMin: 0,
  bedMax: 10,
  bedFrom: 0,
  bedTo: 10,
  bedArray: [],
  bathMin: 0,
  bathMax: 0,
  bathFrom: 0,
  bathTo: 0,
  bathArray: [],
  storeyArray: [],
  carArray: [],
  carFrom: 0,
  tour: false,
  quickMovein: false,
  sortBy: 'price-low'
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_journey_home_HomeCard__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_home_HomeDetail__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_journey_home_HomeFilter__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-map",
  mixins: [],
  components: {
    "app-home-card": __WEBPACK_IMPORTED_MODULE_0__components_journey_home_HomeCard__["a" /* default */],
    "app-home-detail": __WEBPACK_IMPORTED_MODULE_1__components_journey_home_HomeDetail__["a" /* default */],
    "app-home-filter": __WEBPACK_IMPORTED_MODULE_2__components_journey_home_HomeFilter__["a" /* default */]
  },
  data: function data() {
    return {
      activeHome: null,
      homeSummaryList: [],
      filteredHomeList: null,
      areaSlider: null,
      priceSlider: null,
      builders: [],
      filter: null,
      sub: null
    };
  },

  watch: {},
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch("fetchHomeSummary");
    this.sub = this.$store.subscribe(function (mutation, state) {
      if (mutation.type === "setHomeSummaryList") {
        _this.homeSummaryList = state.communityStore.homeSummary.filter(function (home) {
          return home.facadelist.length > 0;
        });
        _this.filteredHomeList = _this.homeSummaryList;
        _this.$emit("homesLoaded", true);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.sub();
  },

  methods: {
    selectHome: function selectHome(hnlSummary) {
      this.activeHome = hnlSummary;
    },

    nextPage: function nextPage(ev) {
      this.activeHomeDetail = ev;
      this.$emit("goNext", true);
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_journey_nav_Navigation__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-community-facade",
  mixins: [],
  components: {
    "app-navigation": __WEBPACK_IMPORTED_MODULE_0__components_journey_nav_Navigation__["a" /* default */]
  },
  data: function data() {
    return {
      activeHome: null,
      activeFacade: null,
      sub: null,
      next: false
    };
  },

  watch: {},
  created: function created() {
    this.getActiveHome();
  },
  beforeDestroy: function beforeDestroy() {
    this.sub();
  },

  methods: {
    getActiveHome: function getActiveHome() {
      var _this = this;

      this.$store.dispatch("getActiveHome", this.$route.query.homeid);
      this.sub = this.$store.subscribe(function (mutation, state) {
        if (mutation.type === "setActiveHome") {
          _this.activeHome = state.communityStore.activeProduct.home;
          if (_this.activeHome && _this.activeHome.facadelist.length) {
            _this.activeFacade = _this.activeHome.facadelist[0];
          }
        }
      });
    },

    goBack: function goBack() {
      return this.$router.push({
        path: "/community/homes",
        query: {
          lotid: this.$route.query.lotid,
          lotcpid: this.$route.query.lotcpid
        }
      });
    },

    goNext: function goNext() {
      this.$store.dispatch("productEvent", this.activeFacade);
      if (this.$route.query.lotid && this.$route.query.lotcpid) {
        return this.next = true;
      } else {
        return this.$router.push({
          path: "/community/lot",
          query: {
            homeid: this.$route.query.homeid,
            facadeid: this.activeFacade.cpidstring,
            plancpid: this.$route.query.plancpid
          }
        });
      }
    },


    selectFacade: function selectFacade(facade) {
      this.activeFacade = facade;
      this.$store.dispatch("productTracking", { product: facade, page: "" });
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_journey_package_LocationMap__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_Loading__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_favorite__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_journey_Enquiry__ = __webpack_require__(273);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-community-homes",
  mixins: [],
  components: {
    "app-loading": __WEBPACK_IMPORTED_MODULE_1__components_journey_Loading__["a" /* default */],
    "app-location-map": __WEBPACK_IMPORTED_MODULE_0__components_journey_package_LocationMap__["a" /* default */],
    "app-enquire": __WEBPACK_IMPORTED_MODULE_3__components_journey_Enquiry__["a" /* default */]
  },
  data: function data() {
    return {
      packageId: null,
      packageDetail: null,
      galleries: [],
      showShare: false,
      sub: null,
      count: 0,
      loading: true,
      loaded: false,
      favoriteHnl: [],
      showEnquire: false
    };
  },

  watch: {
    "$route.params": {
      handler: function handler(n, o) {
        if (n !== o) {
          this.packageDetail = null;
          this.packageId = this.$route.params.id;
          this.getPackageDetail();
        }
      },

      immediate: true
    }
  },
  mounted: function mounted() {
    this.favoriteHnl = this.$store.getters.favoriteHnl;
  },
  destroyed: function destroyed() {
    this.sub();
  },

  methods: {
    getPackageDetail: function getPackageDetail() {
      var _this = this;

      this.favoriteHnl = this.$store.getters.favoriteHnlIds;
      this.$store.dispatch("getPackageDetail", this.packageId);
      this.sub = this.$store.subscribe(function (mutation, state) {
        if (mutation.type === "setPackageDetail") {
          _this.packageDetail = state.communityStore.packageDetail;
          _this.$store.dispatch("productTracking", {
            page: "hnl-package",
            product: _this.packageDetail
          });
          _this.loading = false;
          if (_this.packageDetail.buildername !== "Highland Homes") {
            return _this.checkSiting();
          }
          _this.loaded = true;
        }

        if (mutation.type === "setFavoriteHnl") {
          _this.favoriteHnl = state.favoriteStore.favoriteHnl;
        }
      });
    },

    addToFavorite: function addToFavorite() {
      this.$store.dispatch("setFavoriteHnl", this.packageDetail.cpidstring);
    },

    openPackageEnquiry: function openPackageEnquiry() {},

    packagePdfPrintEvent: function packagePdfPrintEvent() {},

    toggleShare: function toggleShare() {
      this.showShare = !this.showShare;
    },

    isFavorite: function isFavorite() {},

    zoomIn: function zoomIn() {},

    zoomOut: function zoomOut() {},

    shareFb: function shareFb() {},

    checkSiting: function checkSiting() {
      var _this2 = this;

      if (this.count < 5) {
        setTimeout(function () {
          if (_this2.packageDetail.siteplansvgurl === null) {
            _this2.count += 1;
            _this2.$store.dispatch("getPackageDetail", _this2.packageId);
          } else {
            _this2.loaded = true;
          }
        }, 5000);
      }
    },

    copyLink: function copyLink() {
      var url = window.location.href;
      var el = document.getElementById("paste-box");
      el.value = url;
      el.select();
      document.execCommand("copy");
      var flashel = document.getElementById("linkcp");
      flashel.classList.add("is-visible");
      setTimeout(function () {
        flashel.classList.remove("is-visible");
      }, 2000);
    },

    shareEmail: function shareEmail() {
      var url = window.location.href;
      var subject = "Check out this home";
      var body = "Check out this home: " + url;
      window.location.href = "mailto:?subject=" + subject + "&body=" + body;
    },

    goBack: function goBack() {
      var url = "/community/move-in/";
      var origin = this.$route.params.origin;
      if (origin) {
        url = url + origin;
      }
      return this.$router.push({
        path: url
      });
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationMap_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c861f2be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationMap_vue__ = __webpack_require__(272);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c861f2be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-location-map',
  data: function data() {
    return {
      locationMap: null,
      masterplanResources: null,
      masterplanConfig: null,
      lotconfig: null,
      masterplanBounds: null,
      masterLayer: null,
      lotGeo: null,
      lotfeature: null,
      lotgeojsons: __webpack_require__(8),
      sub: null
    };
  },

  props: {
    lotId: String
  },
  created: function created() {},

  mounted: function mounted() {
    this.getMapsConfig();
  },
  destroyed: function destroyed() {
    this.sub();
  },

  methods: {
    getMapsConfig: function getMapsConfig() {
      var _this = this;

      this.sub = this.$store.subscribe(function (mutation, state) {
        if (mutation.type === 'setMasterplanConfig') {
          _this.masterplanConfig = state.communityStore.masterplanConfig;
          _this.initLocationMap();
        }
      });
      this.$store.dispatch('fetchMasterplanConfig');
    },

    initLocationMap: function initLocationMap() {
      if (!this.locationMap) {
        var mastererLayer = this.masterplanConfig.svgFileConfigs.find(function (item) {
          return item.svgFileType.fileType.toLowerCase() === 'master' || item.svgFileType.label.toLowerCase() === 'master';
        });
        if (mastererLayer) {
          var corner1 = L.latLng(mastererLayer.neLatBound, mastererLayer.neLongBound);
          var corner2 = L.latLng(mastererLayer.swLatBound, mastererLayer.swLongBound);
          this.masterplanBounds = L.latLngBounds(corner1, corner2);
        }

        this.locationMap = L.map('leaflet-map', {
          center: this.masterplanBounds.getCenter(),
          minZoom: 14,
          zoom: 18,
          maxZoom: 20,
          maxBounds: this.masterplanBounds
        });

        L.tileLayer(mastererLayer.baseLayerUrl + '/{z}/{x}/{y}.png', {
          maxZoom: 21
        }).addTo(this.locationMap);

        this.addDetailLayer(mastererLayer);
      }

      this.zoomToLot();
    },

    zoomToLot: function zoomToLot() {
      var _this2 = this;

      if (this.lotfeature) {
        this.locationMap.removeLayer(this.lotfeature);
      }

      this.lotgeojsons = this.lotgeojsons.geoJson;

      var geojson = {
        type: 'FeatureCollection',
        features: []
      };
      var feature = this.lotgeojsons.features.find(function (item) {
        return item.properties.lotCpId === _this2.lotId;
      });
      if (feature) {
        geojson.features.push(feature);
      }

      this.lotGeo = geojson;
      this.lotfeature = L.geoJSON(this.lotGeo, {
        style: {
          fillColor: "#ff7800",
          fillOpacity: '0.6',
          weight: '1'
        }
      }).addTo(this.locationMap);

      this.locationMap.flyToBounds(this.lotfeature.getBounds(), { padding: [200, 200] });
      this.initMasonry();
    },

    addDetailLayer: function addDetailLayer(layer) {
      this.locationMap.createPane('detailPane');
      this.locationMap.getPane('detailPane').style.zIndex = 500;
      L.tileLayer(layer.detailLayerUrl + '/{z}/{x}/{y}.png', {
        pane: 'detailPane',
        maxZoom: 21,
        detectRetina: true,
        errorTileUrl: '',
        transparent: true
      }).addTo(this.locationMap);
    },

    initMasonry: function initMasonry() {
      $('#masonry-boxes').imagesLoaded(function () {
        $('#masonry-boxes').masonry({
          itemSelector: '.grid-box'
        });
      });
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-enquiry',
  data: function data() {
    return {
      enquiry: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        pricerange: '',
        squarefootage: '',
        timeframe: '',
        bedrooms: '',
        bathrooms: '',
        builder: ''
      },
      isLoading: false,
      response: null,
      sub: null,
      showThankyou: false,
      namePattern: /^[a-zA-Z]+$/,
      emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      formValid: false,
      submitClicked: false
    };
  },

  props: {
    product: {
      type: Object
    },
    showEnquiry: {
      type: Boolean
    }
  },
  watch: {},
  mounted: function mounted() {
    var _this = this;

    this.sub = this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'setPublishedContact') {
        // this.response = state.communityStore.publishedContact;
        _this.isLoading = false;
        _this.showThankyou = true;
        _this.closeEnquiry();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.sub();
  },

  methods: {
    submitEnquiry: function submitEnquiry() {
      if (!this.formValid) {
        this.submitClicked = true;
      } else {
        var enquiryProduct = [{
          clientProductId: this.product.cpidstring,
          productName: this.product.productname,
          productPrice: this.product.productprice,
          productTypeId: '3850781445676667734',
          productStatus: this.product.currentstatusname,
          productStatusId: this.product.currentstatusid,
          active: true,
          lotCpId: null
        }];
        this.isLoading = true;
        var formData = {
          'clientid': '',
          'capsuleid': '',
          'contact': this.enquiry,
          'shortlistedProducts': enquiryProduct
        };

        var hubspotformData = {
          "fields": [{
            "name": "email",
            "value": this.enquiry.email
          }, {
            "name": "firstname",
            "value": this.enquiry.firstname
          }, {
            "name": "lastname",
            "value": this.enquiry.lastname
          }, {
            "name": "phone",
            "value": this.enquiry.phone
          }, {
            "name": "price_range_checkbox",
            "value": this.enquiry.pricerange
          }, {
            "name": "square_footage",
            "value": this.enquiry.squarefootage
          }, {
            "name": "time_frame_to_move",
            "value": this.enquiry.timeframe
          }, {
            "name": "bedrooms",
            "value": this.enquiry.bedrooms
          }, {
            "name": "bathrooms",
            "value": this.enquiry.bathrooms
          }, {
            "name": "test_builder_multi",
            "value": this.product.buildername
          }],
          "context": {
            "pageUri": window.location.href,
            "pageName": "Package Detail Page"
          }
        };

        this.$store.dispatch('productTracking', {
          page: 'enquiry-submit',
          product: {
            firstName: this.enquiry.firstname,
            lastName: this.enquiry.lastname,
            mobile: this.enquiry.phone,
            email: this.enquiry.email
          }
        });
        this.$store.dispatch('submitEnquiry', { formData: formData, hubspotFormData: hubspotformData });
      }
    },

    closeEnquiry: function closeEnquiry() {
      this.enquiry = {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        productId: ''
      };
      this.showEnquiry = false;
      this.$emit('closeEnquiry', 1);
    },

    checkValidation: function checkValidation() {
      if (this.enquiry.firstname !== '' && this.validName(this.enquiry.firstname) && this.enquiry.lastname !== '' && this.validName(this.enquiry.lastname) && this.validEmail(this.enquiry.email)) {
        this.formValid = true;
      } else {
        this.formValid = false;
      }
    },

    validName: function validName(name) {
      var re = this.namePattern;
      return re.test(name);
    },

    validEmail: function validEmail(email) {
      var re = this.emailPattern;
      return re.test(email);
    }

  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_journey_Header__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'community',
  mixins: [],
  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_0__components_journey_Header__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_journey_spec_PackageCard__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_Loading__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_journey_spec_PackageFilter__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_journey_spec_SpecMap__ = __webpack_require__(281);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app-map',
  mixins: [],
  components: {
    'app-package-card': __WEBPACK_IMPORTED_MODULE_0__components_journey_spec_PackageCard__["a" /* default */],
    'app-package-filter': __WEBPACK_IMPORTED_MODULE_2__components_journey_spec_PackageFilter__["a" /* default */],
    'app-spec-map': __WEBPACK_IMPORTED_MODULE_3__components_journey_spec_SpecMap__["a" /* default */],
    'app-loading': __WEBPACK_IMPORTED_MODULE_1__components_journey_Loading__["a" /* default */]
  },
  data: function data() {
    return {
      favoriteHnl: [],
      filteredHnlList: null,
      hnlSummaryList: [],
      loading: true,
      sub: null,
      tileView: true
    };
  },

  watch: {},
  mounted: function mounted() {
    var _this = this;

    var list = this.$store.state.communityStore.specHomesList;
    if (list && list.length) {
      this.hnlSummaryList = list;
      this.loading = false;
    } else {
      this.$store.dispatch('getSpecHomesList');
    }
    this.favoriteHnl = this.$store.state.favoriteStore.favoriteHnl;

    this.sub = this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'setSpecHomesList') {
        _this.hnlSummaryList = state.communityStore.specHomesList;
        _this.filteredHnlList = _this.hnlSummaryList;
        _this.loading = false;
        _this.$emit('homesLoaded', true);
      }

      if (mutation.type === "setFavoriteHnl") {
        _this.favoriteHnl = state.favoriteStore.favoriteHnl;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.sub();
  },

  methods: {
    selectHome: function selectHome(hnlSummary) {
      this.activeHome = hnlSummary;
    },

    nextPage: function nextPage(ev) {
      this.activeHomeDetail = ev;
      this.$emit('goNext', true);
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageCard_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7142d259_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageCard_vue__ = __webpack_require__(279);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7142d259_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: {
    hnlSummary: {
      type: Object
    },
    isFavorite: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    locatePackage: function locatePackage(lotcpid) {
      this.$emit("locatePackage", lotcpid);
    },

    addToFavorites: function addToFavorites(hnlsummary) {
      this.$store.dispatch("setFavoritePackageDetail", hnlsummary);
      this.$store.dispatch("setFavoriteHnl", hnlsummary.cpidstring);
    },

    removeFromFavorites: function removeFromFavorites(id) {
      this.$store.dispatch("removeFavoritesHnl", id);
    },

    viewDetail: function viewDetail(hnl) {},

    goToNext: function goToNext(id) {
      var path = "/community/package/" + id;
      var origin = this.$route.params.origin;
      if (origin) {
        path = path + "/" + origin;
      }
      return this.$router.push({
        path: path
      });
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageFilter_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fab82fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageFilter_vue__ = __webpack_require__(280);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fab82fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__ = __webpack_require__(81);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'package-filter',
  props: {
    hnlSummaryList: {
      type: Array
    }
  },
  data: function data() {
    return {
      builders: [],
      filter: null,
      tileView: true,
      filterToggle: false
    };
  },
  mounted: function mounted() {
    if (this.hnlSummaryList.length) {
      this.initFilters();
    }
  },

  methods: {
    initFilters: function initFilters() {
      var _this = this;

      this.filter = __WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__["a" /* default */];
      var minPrice = 0;
      var maxPrice = 0;
      var minArea = 0;
      var maxArea = 0;
      var minBed = 0;
      var maxBed = 0;
      var minBath = 0;
      var maxBath = 0;

      this.hnlSummaryList.forEach(function (home) {
        if (!_this.builders.includes(home.buildername)) {
          _this.builders.push(home.buildername);
        }

        if ((minArea === 0 || home.homesize < minArea) && home.homesize !== null) {
          minArea = home.homesize;
        }
        if ((maxArea === 0 || home.homesize > maxArea) && home.homesize !== null) {
          maxArea = home.homesize;
        }

        if ((minPrice === 0 || home.productprice < minPrice) && home.productprice !== null) {
          minPrice = home.productprice;
        }
        if ((maxPrice === 0 || home.productprice > maxPrice) && home.productprice !== null) {
          maxPrice = home.productprice;
        }

        if ((minBed === 0 || home.noofbedrooms < minBed) && home.noofbedrooms !== null) {
          minBed = home.noofbedrooms;
        }
        if ((maxBed === 0 || home.noofbedrooms > maxBed) && home.noofbedrooms !== null) {
          maxBed = home.noofbedrooms;
        }
      });

      this.filter.homePriceMin = minPrice;
      this.filter.homePriceMax = maxPrice;
      this.filter.homePriceFrom = minPrice;
      this.filter.homePriceTo = maxPrice;
      this.filter.homeAreaMin = minArea;
      this.filter.homeAreaMax = maxArea;
      this.filter.homeAreaFrom = minArea;
      this.filter.homeAreaTo = maxArea;
      this.filter.minBed = minBed;
      this.filter.maxBed = maxBed;
      this.filter.minBath = minBath;
      this.filter.maxBath = maxBath;
      this.filter.bedArray = ['Any'];
      this.filter.bathArray = ['Any'];
      this.filter.carArray = ['Any'];
      this.filter.storeyArray = [];
      this.filter.buildersArray = [];

      this.builders.sort();
      this.filterHomes();
      this.initRangeSliders();
    },

    filterByBuilders: function filterByBuilders(builder) {
      var index = this.filter.buildersArray.indexOf(builder);
      if (index < 0) {
        this.filter.buildersArray.push(builder);
      } else {
        this.filter.buildersArray.splice(index, 1);
      }
      this.filterHomes();
    },

    initRangeSliders: function initRangeSliders() {
      var _this2 = this;

      this.priceSlider = $(this.$refs['home-price']).ionRangeSlider({
        prefix: '$',
        type: "double",
        min: this.filter.homePriceMin,
        max: this.filter.homePriceMax,
        from: this.filter.homePriceFrom,
        force_edges: true,
        to: this.filter.homePriceTo,
        prettify_separator: ',',
        onFinish: function onFinish(data) {
          _this2.filter.homePriceFrom = data.from;
          _this2.filter.homePriceTo = data.to;
          _this2.filterHomes();
        }
      });

      this.areaSlider = $(this.$refs['home-area']).ionRangeSlider({
        postfix: 'SQFT',
        type: "double",
        min: this.filter.homeAreaMin,
        max: this.filter.homeAreaMax,
        from: this.filter.homeAreaFrom,
        to: this.filter.homeAreaTo,
        force_edges: true,
        prettify_separator: ',',
        onFinish: function onFinish(data) {
          _this2.filter.homeAreaFrom = data.from;
          _this2.filter.homeAreaTo = data.to;
          _this2.filterHomes();
        }
      });
    },

    filterByBed: function filterByBed(bed) {
      if (!this.filter.bedArray.includes(bed)) {
        this.filter.bedArray = [];
        this.filter.bedArray.push(bed);
        if (bed === 'Any') {
          this.filter.bedFrom = 0;
          return this.filterHomes();
        }
        this.filter.bedFrom = parseInt(bed.split('+')[0], 10);
        this.filterHomes();
      }
    },

    filterByBath: function filterByBath(bath) {
      if (!this.filter.bathArray.includes(bath)) {
        this.filter.bathArray = [];
        this.filter.bathArray.push(bath);
        if (bath === 'Any') {
          this.filter.bathFrom = 0;
          return this.filterHomes();
        }
        this.filter.bathFrom = parseInt(bath.split('+')[0], 10);
        this.filterHomes();
      }
    },

    filterByStorey: function filterByStorey(storey) {
      var index = this.filter.storeyArray.indexOf(storey);
      if (index < 0) {
        this.filter.storeyArray.push(storey);
      } else {
        this.filter.storeyArray.splice(index, 1);
      }
      this.filterHomes();
    },

    filterByCar: function filterByCar(car) {
      if (!this.filter.carArray.includes(car)) {
        this.filter.carArray = [];
        this.filter.carArray.push(car);
        this.filterHomes();
      }
    },

    resetFilters: function resetFilters() {
      this.filter.buildersArray = [];
      this.filter.bedArray = ['Any'];
      this.filter.bathArray = ['Any'];
      this.filter.storeyArray = [];
      this.filter.carArray = ['Any'];
      this.filter.bedFrom = 0;
      this.filter.bathFrom = 0;
      this.filter.tour = false;
      this.filter.homePriceFrom = this.filter.homePriceMin;
      this.filter.homePriceTo = this.filter.homePriceMax;
      this.filter.homeAreaFrom = this.filter.homeAreaMin;
      this.filter.homeAreaTo = this.filter.homeAreaMax;
      this.priceSlider.data('ionRangeSlider').update({
        from: this.filter.homePriceMin,
        to: this.filter.homePriceMax
      });
      this.areaSlider.data('ionRangeSlider').update({
        from: this.filter.homeAreaMin,
        to: this.filter.homeAreaMax
      });
      this.filter.quickMovein = false;
      this.filter.tour = false;
      this.filter.sortBy = 'price-low';
      this.filterHomes();
    },

    filterHomes: function filterHomes() {
      var _this3 = this;

      this.filteredHomeList = [];
      this.hnlSummaryList.forEach(function (home) {
        if (_this3.filter.buildersArray.length > 0 && _this3.filter.buildersArray.indexOf(home.buildername) < 0) {
          return;
        }
        if (home.noofbedrooms < _this3.filter.bedFrom) {
          return;
        }
        if (home.noofbathrooms < _this3.filter.bathFrom) {
          return;
        }
        if (home.homesize && home.homesize < _this3.filter.homeAreaFrom) {
          return;
        }
        if (home.homesize && home.homesize > _this3.filter.homeAreaTo) {
          return;
        }
        if (home.productprice && home.productprice !== 0 && home.productprice < _this3.filter.homePriceFrom) {
          return;
        }
        if (home.productprice && home.productprice !== 0 && home.productprice > _this3.filter.homePriceTo) {
          return;
        }
        if (__WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__["a" /* default */].storeyArray.length > 0 && __WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__["a" /* default */].storeyArray.indexOf(home.noofstoreys) < 0) {
          return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__["a" /* default */].carArray.includes('Any') && __WEBPACK_IMPORTED_MODULE_0__model_HomeFilter__["a" /* default */].carArray.indexOf(home.noofcarparks) < 0) {
          return;
        }
        _this3.filteredHomeList.push(home);
      });
      this.sort(this.filter.sortBy);
    },

    sort: function sort(sortValue) {
      if (sortValue) {
        this.filter.sortBy = sortValue;
      }
      switch (this.filter.sortBy) {
        case 'price-low':
          this.filteredHomeList = this.filteredHomeList.sort(function (a, b) {
            var priceA = a.productprice;
            var priceB = b.productprice;
            if (priceA < priceB) {
              return -1;
            }
            if (priceA > priceB) {
              return 1;
            }
            return 0;
          });
          break;
        case 'price-high':
          this.filteredHomeList = this.filteredHomeList.sort(function (a, b) {
            var priceA = a.productprice;
            var priceB = b.productprice;
            if (priceA > priceB) {
              return -1;
            }
            if (priceA < priceB) {
              return 1;
            }
            return 0;
          });
          break;
        default:
          this.filteredHomeList = this.filteredHomeList.sort(function (a, b) {
            var nameA = a.designproductname.toLowerCase();
            var nameB = b.designproductname.toLowerCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          break;
      }
      this.$emit('filteredPackages', this.filteredHomeList);
    },

    filterTileView: function filterTileView(view) {
      this.tileView = view;
      this.$emit('tileView', view);
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_journey_SpecMap__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_Loading__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_journey_spec_PackageCard__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_journey_spec_PackageFilter__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_journey_MapLabel__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-community-map',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_journey_SpecMap__["a" /* default */]],
  components: {
    'app-package-filter': __WEBPACK_IMPORTED_MODULE_3__components_journey_spec_PackageFilter__["a" /* default */],
    'app-package-card': __WEBPACK_IMPORTED_MODULE_2__components_journey_spec_PackageCard__["a" /* default */],
    'app-loading': __WEBPACK_IMPORTED_MODULE_1__components_journey_Loading__["a" /* default */],
    'app-map-label': __WEBPACK_IMPORTED_MODULE_4__components_journey_MapLabel__["a" /* default */]
  },
  data: function data() {
    return {
      initiatedMap: false,
      isPitched: true,
      sub: null
    };
  },

  props: {
    filteredHnlList: {
      type: Array
    }
  },
  watch: {
    filteredHnlList: {
      deep: true,
      handler: function handler(val, oldval) {
        if (val !== oldval) {
          this.filterPackages(val);
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.favoriteHnl = this.$store.state.favoriteStore.favoriteHnl;

    this.sub = this.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'setMasterplanConfig') {
        _this.masterplanConfig = _this.$store.getters.masterplanConfig;
        _this.loadMap();
      }

      if (mutation.type === 'setHomeGeoJson') {
        // console.log(this.$store.getters.homeGeoJson);
      }
    });

    this.$store.dispatch('fetchMasterplanConfig');
    this.$store.dispatch('fetchHomeGeoJson');
  },
  beforeDestroy: function beforeDestroy() {
    this.sub();
  },

  methods: {
    selectHome: function selectHome(hnlSummary) {
      this.activeHome = hnlSummary;
    },

    nextPage: function nextPage(ev) {
      this.activeHomeDetail = ev;
      this.$emit('goNext', true);
    },

    loadMap: function loadMap() {
      if (!this.initiatedMap && this.masterplanConfig && this.filteredHnlList) {
        this.loading = false;
        this.initiatedMap = true;
        this.initMap(this.masterplanConfig, this.filteredHnlList);
      }
    },


    filterPackages: function filterPackages() {
      if (this.initiatedMap) {
        this.filterMapLots(this.filteredHnlList);
      }
    },

    toggle3d: function toggle3d() {
      var pitch = this.isPitched ? 0 : 60;
      this.isPitched = !this.isPitched;
      this.map.flyTo({
        pitch: pitch
      });
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_favorites_FavoritePackageCards__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_favorites_FavoritesMap__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_favorite__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-favorites',
  data: function data() {
    return {
      favoriteHnl: [],
      activeLot: null,
      lotIds: [],
      favoriteHomes: [],
      count: 0,
      loaded: false,
      loading: true,
      tileView: true
    };
  },

  components: {
    'app-package-card': __WEBPACK_IMPORTED_MODULE_0__components_favorites_FavoritePackageCards__["a" /* default */],
    'app-favorites-map': __WEBPACK_IMPORTED_MODULE_1__components_favorites_FavoritesMap__["a" /* default */]
  },
  props: {
    showFavorites: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    favoriteHnl: {
      handler: function handler(val, oldval) {
        if (val) {
          var ids = this.favoriteHnl.map(function (item) {
            return item.lotproductcpid;
          });
          this.lotIds = ids.filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
        }
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.favoriteHnl = this.$store.getters.favoriteHnlDetail;
    this.fetchFavorites();
  },

  methods: {
    fetchFavorites: function fetchFavorites() {
      var _this = this;

      this.sub = this.$store.subscribe(function (mutation, state) {
        if (mutation.type === 'setFavoriteHnlDetailList') {
          _this.favoriteHnl = state.favoriteStore.favoriteHnlDetail;
        }
      });
      this.$store.dispatch('fetchAllFavoritePackageDetail');
    },

    filterTileView: function filterTileView(view) {
      this.tileView = view;
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: {
    hnlSummary: {
      type: Object
    }
  },
  methods: {
    locatePackage: function locatePackage(lotcpid) {
      this.$emit("locatePackage", lotcpid);
    },
    removeFromFavorites: function removeFromFavorites(id) {
      this.$store.dispatch("removeFavoritesHnl", id);
    },
    viewDetail: function viewDetail(hnl) {},
    goToNext: function goToNext(id) {
      var origin = this.$route.params.origin;
      var path = "/community/package/" + id;
      if (origin) {
        path = path + "/" + origin;
      }
      return this.$router.push({
        path: path
      });
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_favorites_FavoriteMap__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_map_Direction__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Common__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_journey_Loading__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_journey_MapLabel__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-community-map',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_favorites_FavoriteMap__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_map_Direction__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Common__["a" /* default */]],
  components: {
    'app-loading': __WEBPACK_IMPORTED_MODULE_3__components_journey_Loading__["a" /* default */],
    'app-map-label': __WEBPACK_IMPORTED_MODULE_4__components_journey_MapLabel__["a" /* default */]
  },
  data: function data() {
    return {
      initiatedMap: false,
      masterplanConfig: null,
      sub: null,
      isPitched: true
    };
  },

  props: {
    favoriteHnl: {
      type: Array
    }
  },
  watch: {
    favoriteHnl: {
      handler: function handler(val, oldval) {
        if (val) {
          this.mapLots();
        }
      },

      deep: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.map) {
      this.map.remove();
    }
    this.sub();
  },

  mounted: function mounted() {
    this.masterplanConfig = this.$store.getters.masterplanConfig;
    this.fetchMasterplanConfig();
  },
  created: function created() {},

  methods: {
    fetchMasterplanConfig: function fetchMasterplanConfig() {
      var _this = this;

      this.sub = this.$store.subscribe(function (mutation, state) {
        if (mutation.type === 'setMasterplanConfig') {
          _this.masterplanConfig = _this.$store.getters.masterplanConfig;
          _this.loadMap();
        }
      });
      this.$store.dispatch('fetchMasterplanConfig');
    },

    mapLots: function mapLots() {
      // const ids = this.favoriteHnl.map(item => item.lotproductcpid);
      // this.lotIds = ids.filter((value, index, self) => {
      //   return self.indexOf(value) === index
      // });

      if (!this.initiatedMap) {
        return this.loadMap();
      }

      this.filterMapLots(this.favoriteHnl);
    },


    loadMap: function loadMap() {
      if (!this.initiatedMap && this.masterplanConfig && this.favoriteHnl) {
        this.loading = false;
        this.initiatedMap = true;
        this.initMap(this.masterplanConfig, this.favoriteHnl);
      }
    },

    toggle3d: function toggle3d() {
      var pitch = this.isPitched ? 0 : 60;
      this.isPitched = !this.isPitched;
      this.map.flyTo({
        pitch: pitch
      });
    }
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_amenities_Map__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_journey_Community__ = __webpack_require__(60);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'app-map': __WEBPACK_IMPORTED_MODULE_0__components_amenities_Map__["a" /* default */],
    'app-community': __WEBPACK_IMPORTED_MODULE_1__components_journey_Community__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ion_rangeslider__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ion_rangeslider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ion_rangeslider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(303);








window.$ = window.jQuery = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a;



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */]);
  },
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */]
}).$mount('#runway-app');

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(101);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(26)))

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_amenities_Amenity__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_amenities_Map__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_amenities_Places__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_amenities_Travel__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_journey_Community__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_journey_Map__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_journey_home_Home__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_journey_home_Facade__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_journey_package_Package__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_journey_package_LocationMap__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_journey_Selection__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_journey_spec_Spec__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_favorites_Favorites__ = __webpack_require__(286);


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    // path: '/', redirect: '/community'
    path: '/', redirect: '/community/move-in/home'
    // path: '/', redirect: '/amenities/places'
  }, {
    path: '/community',
    component: __WEBPACK_IMPORTED_MODULE_6__components_journey_Community__["a" /* default */],
    children: [{
      path: '',
      name: 'selection',
      component: __WEBPACK_IMPORTED_MODULE_12__components_journey_Selection__["a" /* default */]
    }, {
      path: 'lot',
      name: 'map',
      component: __WEBPACK_IMPORTED_MODULE_7__components_journey_Map__["a" /* default */]
    }, {
      path: 'homes',
      name: 'homes',
      component: __WEBPACK_IMPORTED_MODULE_8__components_journey_home_Home__["a" /* default */]
    }, {
      path: 'facade',
      name: 'facade',
      component: __WEBPACK_IMPORTED_MODULE_9__components_journey_home_Facade__["a" /* default */]
    }, {
      path: 'location',
      name: 'leaflet',
      component: __WEBPACK_IMPORTED_MODULE_11__components_journey_package_LocationMap__["a" /* default */]
    }, {
      path: 'move-in',
      name: 'move-in',
      component: __WEBPACK_IMPORTED_MODULE_13__components_journey_spec_Spec__["a" /* default */]
    }, {
      path: 'move-in/:origin',
      name: 'move-in',
      component: __WEBPACK_IMPORTED_MODULE_13__components_journey_spec_Spec__["a" /* default */]
    }, {
      path: 'package/:id',
      name: 'package',
      component: __WEBPACK_IMPORTED_MODULE_10__components_journey_package_Package__["a" /* default */]
    }, {
      path: 'package/:id/:origin',
      name: 'package',
      component: __WEBPACK_IMPORTED_MODULE_10__components_journey_package_Package__["a" /* default */]
    }]
  }, {
    path: '/amenities',
    component: __WEBPACK_IMPORTED_MODULE_3__components_amenities_Map__["a" /* default */],
    children: [{
      path: '',
      name: 'amenities',
      component: __WEBPACK_IMPORTED_MODULE_2__components_amenities_Amenity__["a" /* default */]
    }, {
      path: 'places',
      name: 'places',
      component: __WEBPACK_IMPORTED_MODULE_4__components_amenities_Places__["a" /* default */]
    }, {
      path: 'travel',
      name: 'travel',
      component: __WEBPACK_IMPORTED_MODULE_5__components_amenities_Travel__["a" /* default */]
    }]
  }, {
    path: '/favorite',
    name: 'favorite',
    component: __WEBPACK_IMPORTED_MODULE_14__components_favorites_Favorites__["a" /* default */]
  }, {
    path: '/favorite/:origin',
    name: 'favorite',
    component: __WEBPACK_IMPORTED_MODULE_14__components_favorites_Favorites__["a" /* default */]
  }]
}));

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.5.1
  * (c) 2021 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if ("development" !== 'production' && !condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (true) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "development" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (true) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (true) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (true) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if ("development" !== 'production' && !this.custom) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (true) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (true) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (true) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (true) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (true) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if ("development" !== 'production' && alias === path) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if ("development" !== 'production' && !matchAs) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (true) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (true) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (true) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (true) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (true) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (true) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (true) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "development" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.toLowerCase().indexOf(base.toLowerCase()) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (true) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "development" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (true) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.5.1';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Amenity_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_126020f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Amenity_vue__ = __webpack_require__(135);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Amenity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_126020f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Amenity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  transport: {
    name: 'Transport',
    displayName: 'Transport',
    iconUrl: __webpack_require__(106),
    lineIconUrl: __webpack_require__(28),
    listIcon: __webpack_require__(28),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  education: {
    name: 'Schools & Universities',
    displayName: 'Education',
    iconUrl: __webpack_require__(107),
    lineIconUrl: __webpack_require__(29),
    listIcon: __webpack_require__(29),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  health: {
    name: 'Hospitals',
    displayName: 'Hospitals',
    iconUrl: __webpack_require__(108),
    lineIconUrl: __webpack_require__(30),
    listIcon: __webpack_require__(30),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  outdoor: {
    name: 'Parks, Playgrounds, Recreational',
    displayName: 'Amenities',
    iconUrl: __webpack_require__(109),
    lineIconUrl: __webpack_require__(31),
    listIcon: __webpack_require__(31),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  childcare: {
    name: 'Childcare & Early Learning',
    displayName: 'Childcare & Early Learning',
    iconUrl: __webpack_require__(110),
    lineIconUrl: __webpack_require__(111),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  shopping: {
    name: 'Retail',
    displayName: 'Shopping',
    iconUrl: __webpack_require__(112),
    lineIconUrl: __webpack_require__(32),
    listIcon: __webpack_require__(32),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  food: {
    name: 'Food & Drink',
    displayName: 'Food & Drink',
    iconUrl: __webpack_require__(33),
    lineIconUrl: __webpack_require__(34),
    listIcon: __webpack_require__(113),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  professional: {
    name: 'Career Hubs',
    displayName: 'Career Hubs',
    iconUrl: __webpack_require__(33),
    lineIconUrl: __webpack_require__(34),
    listIcon: __webpack_require__(114),
    venue: [],
    groupedMarkers: [],
    markers: []
  }
});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "transport.svg?015a0fb1d2b3aaeb4175b5fc7bd45897";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "education.svg?ad5b8eb291aeeb7ccb7e20b264fd7278";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "health.svg?c24fccac7858d71def0f706dd46d67a1";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "recreation.svg?d27c22246502edb594f5c20d405a86bb";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "childcare.svg?fd8cc69a6553f1a30b4bdb24361491fd";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "childcare_line.svg?ad468f1bf561fe34843e6b4a9c948f7c";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "shop.svg?75df2b30a329170d4bda5b166056a192";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cat_food.svg?6d808cc29c6a1436f1841d81f4922f67";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cat_professional.svg?9bf95e36be6904a672a6eef34ca995bb";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(37);
var Axios = __webpack_require__(116);
var mergeConfig = __webpack_require__(43);
var defaults = __webpack_require__(40);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(44);
axios.CancelToken = __webpack_require__(129);
axios.isCancel = __webpack_require__(39);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(130);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(131);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(38);
var InterceptorManager = __webpack_require__(117);
var dispatchRequest = __webpack_require__(118);
var mergeConfig = __webpack_require__(43);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(119);
var isCancel = __webpack_require__(39);
var defaults = __webpack_require__(40);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(42);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(125);
var combineURLs = __webpack_require__(126);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(44);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cluster.svg?9f750c22bdc13c335e3b6347096c636e";

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_Tracking__ = __webpack_require__(47);


var axios = __webpack_require__(19);
var instance = axios.create({
  baseURL: 'https://g11jbxr01k.execute-api.us-east-1.amazonaws.com/live/ustrackingservice/',
  headers: {
    'content-type': 'application/json',
    'x-api-key': 'OrXxHpntdY8ijxAM11Hkc1QGEeqarRJB3P6frMQm',
    'accept': 'application/json'
  },
  data: {}
});

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      capsuleid: "718850824",
      initTrackingUrl: 'initiatetrackerlog',
      eventTrackingUrl: 'publisheventlogtracker',
      finishTrackingUrl: 'finishtrackerlog'
    };
  },

  methods: {
    productTracking: function productTracking(page, product) {
      var event = void 0;
      var productReference = void 0;
      var productId = void 0;
      var productType = void 0;

      switch (page) {
        case 'home-design':
          productId = product.cpidstring;
          productReference = product.designproductname + ' ' + product.productname;
          event = 'View Home Design on page';
          productType = 'Home Design';
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'elevation':
          productId = product.productid;
          productReference = product.productname;
          event = 'Select Elevation';
          productType = 'Elevation';
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'hnl-package':
          productId = product.cpidstring;
          productReference = product.productname;
          event = 'View Package on page';
          productType = 'Package';
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'brochure':
          productId = product.cpidstring;
          productReference = product.productname;
          event = 'Downloaded Brochure on page';
          productType = 'Brochure';
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'documents-library':
          productId = product.cpidstring;
          productReference = product.productname;
          event = 'View Documents Library on Page';
          productType = product.producttype;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'download':
          productId = product.productId;
          productReference = JSON.stringify({
            DocumentType: product.type,
            DocumentSubType: product.subType,
            DocumentShortDescription: product.productName + ' Package PDF',
            DocumentFilename: product.productName + '.pdf',
            BuilderName: product.builderName
          });
          event = product.event;
          productType = product.producttype;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'contact':
          productId = product.productid;
          productReference = product.contactid;
          event = 'Submitted Contact on Page';
          productType = 'Contact';
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'lot-click':
          productId = product.productId;
          productReference = JSON.stringify({
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.productName
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'handl-click':
          productId = product.productId;
          productReference = JSON.stringify({
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.lotProductName,
            Range: product.rangeProductName,
            Design: product.designProductName,
            Builder: product.builderName,
            Plan: product.productName
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'home-click':
          productId = product.productId;
          productReference = JSON.stringify({
            Range: product.rangeProductName,
            Design: product.designProductName,
            Plan: product.productName
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'poi-click':
          productReference = JSON.stringify({
            Name: product.productName,
            Category: product.category,
            Featured: product.isFeatured
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'enquiry-submit':
          productId = product.productId;
          productReference = JSON.stringify({
            FirstName: product.firstName,
            LastName: product.lastName,
            Mobile: product.mobile,
            Email: product.email,
            productId: product.shortListedProducts,
            productCount: product.productCount
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'create-package':
          productId = product.productId;
          productReference = JSON.stringify({
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.lotProductName,
            Range: product.rangeProductName,
            Design: product.designProductName,
            Plan: product.planProductName,
            Facade: product.productName
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'create-package':
          productId = product.productId;
          productReference = JSON.stringify({
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.lotProductName,
            Range: product.rangeProductName,
            Design: product.designProductName,
            Plan: product.planProductName,
            Facade: product.productName
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        default:
          break;
      }
    },

    checkSession: function checkSession(event, productreference, productid, producttype) {
      if (sessionStorage.getItem('trackerid')) {
        this.eventTracking(event, productreference, productid, producttype);
      } else {
        this.initiateTracking(event, productreference, productid, producttype);
      }
    },

    initiateTracking: function initiateTracking(event, reference, productId, productType) {
      var _this = this;

      var trackingItems = __WEBPACK_IMPORTED_MODULE_0__model_Tracking__["a" /* default */];
      return FingerprintJS.load().then(function (fp) {
        fp.get().then(function (result) {
          trackingItems.fingerprint = result.visitorId;
          trackingItems.request_type = 'initiate_tracker';
          trackingItems.capsuleid = _this.capsuleid;
          trackingItems.referrer = _this.getReferrer();
          trackingItems.trackersource = _this.getSource();
          trackingItems.trackeragent = _this.getUserAgent();
          trackingItems.trackermessage = _this.setTrackerMessage('Initiated tracker');

          _this.postTracking(_this.initTrackingUrl, trackingItems).then(function (res) {
            if (res && res.data) {
              var response = JSON.parse(res.data);
              if (response.trackerid) {
                sessionStorage.setItem('trackerid', response.trackerid);
                _this.eventTracking(event, reference, productId, productType);
              }
            }
          });
        });
      });
    },

    eventTracking: function eventTracking(event, reference, productId, productType) {
      var eventItems = {
        request_type: 'initiate_tracker_event',
        trackerid: this.getTrackerId(),
        productreference: this.getReference(reference),
        capsuleid: this.capsuleid,
        productid: this.getProductId(productId),
        producttype: this.getProductType(productType),
        eventname: this.setTrackerMessage(event)
      };
      this.postTracking(this.eventTrackingUrl, eventItems).then(function (res) {
        console.log(res);
        return res;
      });
    },

    stopTracking: function stopTracking() {
      var trackerid = this.getTrackerId();
      this.http.get(this.finishTrackingUrl + '?request_type="finish_tracker"&trackerid=' + trackerid).subscribe();
      sessionStorage.removeItem('trackerid');
    },
    getClientId: function getClientId() {
      if (!isNullOrUndefined(this.trackingApiParams.getClientTokens()[0])) {
        return this.trackingApiParams.getClientTokens()[0].clientId;
      } else {
        return this.trackingApiParams.getClientId();
      }
    },
    getCurrentTime: function getCurrentTime() {
      var now = new Date();
      return new Date(now).toISOString();
    },
    getReferrer: function getReferrer() {
      if (document.referrer !== '') {
        return document.referrer;
      } else {
        return document.baseURI;
      }
    },
    getIp: function getIp() {
      // No free IP tracking API available
      return '';
    },
    getProductId: function getProductId(productId) {
      if (productId) {
        return productId;
      }
      return '';
    },
    getProductType: function getProductType(productType) {
      if (productType) {
        return productType;
      }
      return '';
    },
    getUserAgent: function getUserAgent() {
      return navigator.userAgent;
    },
    getSource: function getSource() {
      return window.location.href;
    },
    getReference: function getReference(reference) {
      if (reference) {
        return reference;
      }
      return '';
    },


    setTrackerMessage: function setTrackerMessage(event) {
      var message = '';
      if (event) {
        message = event + ' ' + window.location.href;
      } else {
        message = 'Viewed page on ' + window.location.href;
      }
      return message;
    },

    getTrackerId: function getTrackerId() {
      return sessionStorage.getItem('trackerid');
    },

    postTracking: function postTracking(url, data) {
      return instance.post(url, data);
    }
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-tracking')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae3c924_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__(137);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae3c924_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"menu-items"},[_c('a',{staticClass:"menu-item",class:{'is-active': _vm.activeMenu === 'places'},on:{"click":function($event){return _vm.navigateTo('places')}}},[(_vm.activeMenu !== 'places')?_c('img',{attrs:{"src":__webpack_require__(138),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.activeMenu === 'places')?_c('img',{attrs:{"src":__webpack_require__(139),"alt":""}}):_vm._e(),_vm._v("\n      Places\n    ")]),_vm._v(" "),_c('a',{staticClass:"menu-item",class:{'is-active': _vm.activeMenu === 'travel'},on:{"click":function($event){return _vm.navigateTo('travel')}}},[(_vm.activeMenu !== 'travel')?_c('img',{attrs:{"src":__webpack_require__(140),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.activeMenu === 'travel')?_c('img',{attrs:{"src":__webpack_require__(141),"alt":""}}):_vm._e(),_vm._v("\n      Travel\n    ")]),_vm._v(" "),_c('a',{staticClass:"menu-item",on:{"click":function($event){return _vm.navigateTo('')}}},[_c('img',{attrs:{"src":__webpack_require__(142),"alt":""}}),_vm._v("\n      Reset\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "places.svg?78121c9789a9e02e83bdcb7fca693abb";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "places_white.svg?8d58429d98848bde683a8b574c9b28f1";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "travel.svg?4136a9d4501aec9ab9a24c6e2b0f7f16";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "travel_white.svg?bc021902fc5ddcd1e90ca3292c3fedfa";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "reset.svg?b61e3613018a524e0e4e6dc5edf3b10b";

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"is-hidden-x"},[_c('div',{staticClass:"map-labels desktop-label"},[(_vm.labels.available)?_c('div',{staticClass:"label-item available"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Available")])]):_vm._e(),_vm._v(" "),(_vm.labels.available)?_c('div',{staticClass:"label-item model"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Model")])]):_vm._e(),_vm._v(" "),(_vm.labels.sold)?_c('div',{staticClass:"label-item sold"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Sold")])]):_vm._e(),_vm._v(" "),(_vm.labels.future)?_c('div',{staticClass:"label-item future-release"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Future")])]):_vm._e(),_vm._v(" "),(_vm.labels.spec)?_c('div',{staticClass:"label-item spec"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Inventory")])]):_vm._e(),_vm._v(" "),(_vm.labels.favorites)?_c('div',{staticClass:"label-item spec"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Favorites")])]):_vm._e(),_vm._v(" "),(_vm.labels.lotsize)?_c('div',{staticClass:"label-item lotsize-45"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("45'")])]):_vm._e(),_vm._v(" "),(_vm.labels.lotsize)?_c('div',{staticClass:"label-item lotsize-50"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("50'")])]):_vm._e(),_vm._v(" "),(_vm.labels.lotsize)?_c('div',{staticClass:"label-item lotsize-60"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("60'")])]):_vm._e(),_vm._v(" "),(_vm.labels.lotsize)?_c('div',{staticClass:"label-item lotsize-70"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("70'")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"map-labels mobile-label-header"},[(_vm.labels.available)?_c('div',{staticClass:"label-item available"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Available")])]):_vm._e(),_vm._v(" "),(_vm.labels.available)?_c('div',{staticClass:"label-item model"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Model")])]):_vm._e(),_vm._v(" "),(_vm.labels.sold)?_c('div',{staticClass:"label-item sold"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Sold")])]):_vm._e(),_vm._v(" "),(_vm.labels.future)?_c('div',{staticClass:"label-item future-release"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Future")])]):_vm._e(),_vm._v(" "),(_vm.labels.spec)?_c('div',{staticClass:"label-item spec"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Move-in Ready")])]):_vm._e(),_vm._v(" "),(_vm.labels.favorites)?_c('div',{staticClass:"label-item spec"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("Favorites")])]):_vm._e(),_vm._v(" "),(_vm.labels.lotsize)?_c('div',{staticClass:"label-item lotsize-45"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("45'")])]):_vm._e(),_vm._v(" "),(_vm.labels.lotsize)?_c('div',{staticClass:"label-item lotsize-50"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("50'")])]):_vm._e(),_vm._v(" "),(_vm.labels.lotsize)?_c('div',{staticClass:"label-item lotsize-60"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("60'")])]):_vm._e(),_vm._v(" "),(_vm.labels.lotsize)?_c('div',{staticClass:"label-item lotsize-70"},[_c('span'),_vm._v(" "),_c('p',[_vm._v("70'")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mobile-menu",class:{'is-active': _vm.isSidebarActive}},[_c('app-sidenav',{on:{"resetClick":_vm.closeRoute}})],1),_vm._v(" "),_c('div',{staticClass:"layout"},[_c('div',{staticClass:"layout-item is-hidden-x"},[_c('div',{staticClass:"side-panel"},[_c('app-sidenav',{on:{"resetClick":_vm.closeRoute}})],1)]),_vm._v(" "),_c('div',{staticClass:"layout-item"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"layout-item grow amenity-map-container",class:{'active-venue': _vm.activeVenue}},[_c('div',{ref:"amenity-map",attrs:{"id":"amenity-map"}},[_c('div',{staticClass:"custom-control"},[_c('a',{on:{"click":function($event){return _vm.toggle3d()}}},[_c('img',{attrs:{"src":__webpack_require__(16),"alt":""}})])]),_vm._v(" "),(!_vm.mobileView || !_vm.activeVenue)?_c('app-map-label',{attrs:{"labels":{lotsize: true}}}):_vm._e()],1)]),_vm._v(" "),(_vm.activeVenue)?_c('div',{staticClass:"layout-item place-info"},[_c('button',{staticClass:"modal-close is-large",attrs:{"aria-label":"close"},on:{"click":function($event){return _vm.closeRoute()}}}),_vm._v(" "),_c('p',{staticClass:"places-info-title"},[_vm._v("\n        "+_vm._s(_vm.activeVenue.name)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"places-info-subtitle"},[_vm._v("\n        "+_vm._s(_vm.activeVenue.subtype)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"places-info-description"},[_vm._v("\n        "+_vm._s(_vm.activeVenue.description)+"\n      ")]),_vm._v(" "),(_vm.activeVenue.url)?_c('a',{attrs:{"target":"_blank","href":_vm.activeVenue.url}},[_vm._v("\n        View Website\n      ")]):_vm._e(),_vm._v(" "),(_vm.route)?_c('div',{staticClass:"sidepanel-route"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"direction-buttons"},[_c('div',{staticClass:"buttons has-addons"},[_c('div',{staticClass:"buttons has-addons is-fullwidth"},[_c('button',{staticClass:"button is-small",class:{'is-active': _vm.method === 'driving'},on:{"click":function($event){return _vm.changeMethod('driving')}}},[(_vm.method !== 'driving')?_c('img',{attrs:{"src":__webpack_require__(52),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.method === 'driving')?_c('img',{attrs:{"src":__webpack_require__(53),"alt":""}}):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"button is-small",class:{'is-active': _vm.method === 'cycling'},on:{"click":function($event){return _vm.changeMethod('cycling')}}},[(_vm.method !== 'cycling')?_c('img',{attrs:{"src":__webpack_require__(54),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.method === 'cycling')?_c('img',{attrs:{"src":__webpack_require__(55),"alt":""}}):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"button is-small",class:{'is-active': _vm.method === 'walking'},on:{"click":function($event){return _vm.changeMethod('walking')}}},[(_vm.method !== 'walking')?_c('img',{attrs:{"src":__webpack_require__(56),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.method === 'walking')?_c('img',{attrs:{"src":__webpack_require__(57),"alt":""}}):_vm._e()])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"route-summary"},[_c('div',{staticClass:"left-item"},[_c('p',[_vm._v("Via "+_vm._s(_vm.routeInfo.legs[0].summary))]),_vm._v(" "),_c('a',{staticClass:"small is-ghost",on:{"click":function($event){_vm.showRoute = !_vm.showRoute}}},[(!_vm.showRoute)?_c('span',[_vm._v("Show")]):_vm._e(),_vm._v(" "),(_vm.showRoute)?_c('span',[_vm._v("Hide")]):_vm._e(),_vm._v("\n              Route\n            ")])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('p',[_vm._v("\n              "+_vm._s(_vm.getTime(_vm.route.duration, true))+"\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(_vm.getDistance(_vm.route.distance))+"\n            ")])])]),_vm._v(" "),(_vm.showRoute && _vm.routeInfo && _vm.routeInfo.legs && _vm.routeInfo.legs.length && _vm.routeInfo.legs[0].steps)?_c('div',{staticClass:"steps"},[_c('table',{staticClass:"table is-fullwidth"},_vm._l((_vm.routeInfo.legs[0].steps),function(steps){return _c('tr',[_c('td',[(steps['icon'])?_c('img',{attrs:{"src":__webpack_require__(20)("./" + steps.icon),"alt":""}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"instruction"},[_vm._v(_vm._s(steps.maneuver.instruction))])])}),0)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"gallery",attrs:{"uk-lightbox":""}},[(_vm.activeVenue.gallery.length > 0)?_c('div',{staticClass:"columns is-multiline is-variable is-1"},[_vm._l((_vm.activeVenue.gallery.filter(function (item) { return item.primary; })),function(image){return _c('div',{staticClass:"column is-12"},[(_vm.isImage(image.url))?_c('a',{attrs:{"href":image.url}},[_c('figure',{staticClass:"image is-3by2"},[_c('img',{attrs:{"src":image.url,"alt":""}})])]):_vm._e(),_vm._v(" "),(!_vm.isImage(image.url))?_c('a',{attrs:{"href":image.url,"data-type":"video"}},[_c('video',{attrs:{"src":image.url,"loop":"","muted":"","playsinline":"","uk-video":"autoplay: inview"},domProps:{"muted":true}})]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.activeVenue.gallery.filter(function (item) { return item.secondary; })),function(image){return _c('div',{staticClass:"column is-12"},[(_vm.isImage(image.url))?_c('a',{attrs:{"href":image.url}},[_c('figure',{staticClass:"image is-3by2"},[_c('img',{attrs:{"src":image.url,"alt":""}})])]):_vm._e(),_vm._v(" "),(!_vm.isImage(image.url))?_c('a',{attrs:{"href":image.url,"data-type":"video"}},[_c('video',{attrs:{"src":image.url,"loop":"","muted":"","playsinline":"","uk-video":"autoplay: inview"},domProps:{"muted":true}})]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.activeVenue.gallery.length > 0)?_c('div',{staticClass:"columns is-variable is-1 is-multiline"},_vm._l((_vm.activeVenue.gallery.filter(function (item) { return !item.primary && !item.secondary; })),function(image){return _c('div',{staticClass:"column is-6"},[(_vm.isImage(image.url))?_c('a',{attrs:{"href":image.url,"data-lightbox":"amenity"}},[_c('figure',{staticClass:"image is-3by2"},[_c('img',{attrs:{"src":image.url,"alt":""}})])]):_vm._e()])}),0):_vm._e()])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrive.svg?e0c08eba7d32a1841ed2d9f6b380e7a2";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrive_left.svg?8265a0ccae2e434ee8eca2222bf8d8f8";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrive_right.svg?f677bb7c0598c70be21e38e121a0c0d8";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrive_straight.svg?e0c08eba7d32a1841ed2d9f6b380e7a2";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "close.svg?383f87ce2ea94c6a61434db967828fde";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "continue.svg?b7e61e48934d98628a4ddcf670a3e2ac";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "continue_left.svg?e9afd8032b0244d4fc1c6412b9526e92";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "continue_right.svg?9e2d9b9c11c21c4d5dacd8fabe0aa586";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "continue_slight_left.svg?208680ae93fb67d1131c7329d0a32911";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "continue_slight_right.svg?1e934867aff25b829a83c03631af2b92";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "continue_straight.svg?b7e61e48934d98628a4ddcf670a3e2ac";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "continue_uturn.svg?f8e15e21b0434271879cfb6d9a07d324";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "depart.svg?b9e6c633801db4df54422c659f758304";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "depart_left.svg?3efafb540f73e4e38391d63ced85a78f";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "depart_right.svg?d0854d6d7eda2be1f041ff0aab91eb7e";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "depart_straight.svg?fb13d58773429a22c7c3ebaed5f2c0ec";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "end_of_road_left.svg?28b471d097202596bdf6b80314fa6e50";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "end_of_road_right.svg?4a38890d52ae3a42a4819dcc87f8ed20";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flag.svg?b868d851116fd8ecd2f2b9c83b44115c";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fork.svg?89d600db395727a591db86687833650b";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fork_left.svg?b13e1e26f418bee17e5de99439e42d92";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fork_right.svg?a4926862a886ce28d7ffcb9761eedab3";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fork_slight_left.svg?cf02bc0dfe809432f4ba0121f3f99007";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fork_slight_right.svg?a51173a25b9eb73238e6eb091dc7d630";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fork_straight.svg?f2fc01fe1bef6592999d67bc646e4df5";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "invalid.svg?b7e61e48934d98628a4ddcf670a3e2ac";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "invalid_left.svg?e9afd8032b0244d4fc1c6412b9526e92";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "invalid_right.svg?9e2d9b9c11c21c4d5dacd8fabe0aa586";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "invalid_slight_left.svg?208680ae93fb67d1131c7329d0a32911";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "invalid_slight_right.svg?1e934867aff25b829a83c03631af2b92";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "invalid_straight.svg?b7e61e48934d98628a4ddcf670a3e2ac";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "invalid_uturn.svg?f8e15e21b0434271879cfb6d9a07d324";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "merge_left.svg?c48131e0c321569193f96b09410dc842";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "merge_right.svg?1053f907482e1792894617b5ba036a82";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "merge_slight_left.svg?e8be2f0b1793555b23bb1201073bfd2e";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "merge_slight_right.svg?951b644b750cc13190f3be78c10c8831";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "merge_straight.svg?58fc304a97ea343fd44a639f190fe08a";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "new_name_left.svg?e9afd8032b0244d4fc1c6412b9526e92";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "new_name_right.svg?9e2d9b9c11c21c4d5dacd8fabe0aa586";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "new_name_sharp_left.svg?e5eb4af976ecee97e5cb11334f12bdd8";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "new_name_sharp_right.svg?0bd06c3c09fdbb084a877cf48d43b814";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "new_name_slight_left.svg?208680ae93fb67d1131c7329d0a32911";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "new_name_slight_right.svg?1e934867aff25b829a83c03631af2b92";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "new_name_straight.svg?b7e61e48934d98628a4ddcf670a3e2ac";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "notificaiton_sharp_right.svg?30fa12fe2bf23bd3ece8fcf120e4afbc";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "notification_left.svg?e9afd8032b0244d4fc1c6412b9526e92";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "notification_right.svg?9e2d9b9c11c21c4d5dacd8fabe0aa586";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "notification_sharp_left.svg?812bdcdfb29cd5a5a588a6d7d9fee781";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "notification_slight_left.svg?208680ae93fb67d1131c7329d0a32911";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "notification_slight_right.svg?1e934867aff25b829a83c03631af2b92";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "notification_straight.svg?b7e61e48934d98628a4ddcf670a3e2ac";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "off_ramp_left.svg?4c13d5b761feed5a20d87d0cb8f17b59";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "off_ramp_right.svg?509e8f309ad55a548e7de7cb8d1ba1bd";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "off_ramp_slight_left.svg?a79674b5443acfa9a7cd2bf362d2f181";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "off_ramp_slight_right.svg?be92376cc395d0297af81bcb7aea14da";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "on_ramp_left.svg?abb0c355c7aab0203cc0b4fce93cb79f";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "on_ramp_right.svg?b37738446542bc9900b82ddfd35d438b";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "on_ramp_sharp_left.svg?e5eb4af976ecee97e5cb11334f12bdd8";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "on_ramp_sharp_right.svg?30fa12fe2bf23bd3ece8fcf120e4afbc";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "on_ramp_slight_left.svg?d9dc2dbc16d6e4276fa4bddf240f025b";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "on_ramp_slight_right.svg?d3cd2e26f64d869a6cc79c801bb4750b";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "on_ramp_straight.svg?b7e61e48934d98628a4ddcf670a3e2ac";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rotary.svg?7bef3b9d274f5678b3b2f1c158939bb1";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rotary_left.svg?e7708af219a7e085983685012d49bb11";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rotary_right.svg?a1bd4d2d0ac422b59e086419ac39a158";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rotary_sharp_left.svg?a78bfdef3403dacb4afd8ce915905557";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rotary_sharp_right.svg?ee9d0fd5437e39326654bb12ddd6b604";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rotary_slight_left.svg?916599fbe79fbfe3899f1857e63bbc2a";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rotary_slight_right.svg?b79f47a6e86ac0c7262f9e616efc1f58";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rotary_straight.svg?1c43db7b72ab11c3f7a833b6484c6bc5";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roundabout.svg?d1071b2d76bb1b662d4bdca0963dc953";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roundabout_left.svg?b6119797ffed248b70f1f69274c3fe5c";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roundabout_right.svg?a6528d4784a130e8abe5d0cea1c27471";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roundabout_sharp_left.svg?d16bf0c09fc79d542a67d91e6c7ccdd6";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roundabout_sharp_right.svg?c9047ebe800c416075ccc5987cab5da6";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roundabout_slight_left.svg?ade85425fa54405938cdac5e32d281f8";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roundabout_slight_right.svg?f10dcdef491f32ecf537aa70f826e02b";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roundabout_straight.svg?45617bd0bd3eb31ef8bb6f91449da0d1";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roundabout_turn_left.svg?b6119797ffed248b70f1f69274c3fe5c";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "turn_left.svg?e9afd8032b0244d4fc1c6412b9526e92";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "turn_right.svg?9e2d9b9c11c21c4d5dacd8fabe0aa586";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "turn_sharp_left.svg?812bdcdfb29cd5a5a588a6d7d9fee781";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "turn_sharp_right.svg?30fa12fe2bf23bd3ece8fcf120e4afbc";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "turn_slight_left.svg?208680ae93fb67d1131c7329d0a32911";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "turn_slight_right.svg?1e934867aff25b829a83c03631af2b92";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "turn_straight.svg?b7e61e48934d98628a4ddcf670a3e2ac";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "updown.svg?fcc7a0cfc7f048ccd0867a7161dc33c9";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "uturn.svg?7618f3805a1363f4d94b3ed40d0f4555";

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Places_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_584dd762_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Places_vue__ = __webpack_require__(236);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Places_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_584dd762_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Places_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_poiCategories__ = __webpack_require__(235);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activePoi: ['transport', 'health', 'education', 'outdoor', 'food', 'shopping', 'childcare'],
      activeVenue: null,
      categoryTypes: __WEBPACK_IMPORTED_MODULE_0__constants_poiCategories__["a" /* CategoryTypes */],
      method: 'driving',
      mobileView: false,
      poi: null,
      poiCategories: __WEBPACK_IMPORTED_MODULE_0__constants_poiCategories__["b" /* PoiCategories */],
      poiDisplayNames: __WEBPACK_IMPORTED_MODULE_0__constants_poiCategories__["c" /* PoiDisplayNames */],
      poiList: null,
      routeInfo: null,
      selectedPoi: null

    };
  },

  watch: {
    poi: function poi(val, oldval) {
      if (val) {
        this.$store.commit("setActivePoi", this.activePoi);
      }
    },

    routeInfo: function routeInfo(val, oldval) {
      if (!val) {
        this.$store.commit("setActivePoi", this.activePoi);
      }
    }
  },
  mounted: function mounted() {
    this.mobileView = window.innerWidth <= 600;
  },

  methods: {
    checkMutations: function checkMutations() {
      var _this = this;

      this.$store.subscribe(function (mutation, state) {
        if (mutation.type === 'setPoi') {
          _this.poi = state.amenityStore.poi;
        }
        if (mutation.type === 'setActiveVenue') {
          _this.activeVenue = state.amenityStore.activeVenue;
        }
        if (mutation.type === 'setRouteInfo') {
          _this.routeInfo = state.amenityStore.routeInfo;
        }
      });
    },
    changeMethod: function changeMethod(method) {
      this.method = method;
      this.$store.commit("setDirectionMethod", this.method);
    },
    setActivePoi: function setActivePoi(category) {
      console.log('category', category);
      var categoryName = void 0;
      if (category.displayName === this.selectedPoi) {
        this.activePoi = this.categoryTypes;
        this.selectedPoi = this.categoryTypes;
      } else {
        switch (category.displayName) {
          case this.poiDisplayNames.childcare:
            this.activePoi = [this.this.poiCategories.childcare];
            categoryName = this.poiCategories.childcare;
            break;
          case this.poiDisplayNames.health:
            this.activePoi = [this.poiCategories.health];
            categoryName = this.poiCategories.health;
            break;
          case this.poiDisplayNames.education:
            this.activePoi = [this.poiCategories.education];
            categoryName = this.poiCategories.education;
            break;
          case this.poiDisplayNames.transport:
            this.activePoi = [this.poiCategories.transport];
            categoryName = this.poiCategories.transport;
            break;
          case this.poiDisplayNames.outdoor:
            this.activePoi = [this.poiCategories.outdoor];
            categoryName = this.poiCategories.outdoor;
            break;
          case this.poiDisplayNames.food:
            this.activePoi = [this.poiCategories.food];
            categoryName = this.poiCategories.food;
            break;
          case this.poiDisplayNames.shopping:
            this.activePoi = [this.poiCategories.shopping];
            categoryName = this.poiCategories.shopping;
            break;
          case this.poiDisplayNames.professional:
            this.activePoi = [this.poiCategories.professional];
            categoryName = this.poiCategories.professional;
            break;
          default:
            this.activePoi = categoryTypes;
            break;
        }
        this.selectedPoi = category.displayName;
      }
      this.$store.commit("setActiveVenue", null);
      this.$store.commit("setActivePoi", this.activePoi);
      this.$store.commit("zoomToCategory", categoryName);
    },
    selectActiveVenue: function selectActiveVenue(venue) {
      this.$store.commit("setActiveVenue", venue);
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PoiCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PoiDisplayNames; });
var PoiCategories = {
  transport: "transport",
  health: "health",
  education: "education",
  outdoor: "outdoor",
  food: "food",
  shopping: "shopping",
  childcare: "childcare",
  professional: "professional"
};

var CategoryTypes = ["transport", "health", "education", "outdoor", "food", "shopping", "childcare", "professional"];

var PoiDisplayNames = {
  transport: "Transport",
  health: "Hospitals",
  education: "Education",
  outdoor: "Amenities",
  food: "Food & Drink",
  shopping: "Shopping",
  childcare: "Childcare & Early Learning",
  professional: "Career Hubs"
};

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.activeVenue || !_vm.mobileView)?_c('div',{staticClass:"is-expanded extended-panel"},[_c('p',{staticClass:"panel-title"},[_vm._v("What's Nearby")]),_vm._v(" "),_c('div',{staticClass:"panel-subtitle"},[_vm._v(" ")]),_vm._v(" "),(_vm.poi)?_c('div',{staticClass:"categories places"},[_c('ul',_vm._l((_vm.poi),function(value,property){return (value.venue.length > 0)?_c('li',{staticClass:"uk-open"},[_c('a',{staticClass:"categories-title",on:{"click":function($event){return _vm.setActivePoi(value)}}},[_c('img',{attrs:{"src":value.listIcon,"alt":""}}),_vm._v("\n            "+_vm._s(value.displayName)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"uk-accordion-content"},_vm._l((value.venue),function(venue){return _c('a',{class:{'is-active': _vm.activeVenue && _vm.activeVenue.id === venue.id},on:{"click":function($event){return _vm.selectActiveVenue(venue)}}},[_vm._v(_vm._s(venue.name))])}),0)]):_vm._e()}),0)]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Travel_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15e75b02_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Travel_vue__ = __webpack_require__(239);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Travel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15e75b02_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Travel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var axios = __webpack_require__(19);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      destinationObject: null,
      glink: null,
      masterplanConfig: null,
      method: 'driving',
      origin: null,
      poi: null,
      predictions: null,
      route: null,
      sub: null
    };
  },

  methods: {
    listenToMutation: function listenToMutation() {
      var _this = this;

      this.masterplanConfig = this.$store.state.amenityStore.masterplanConfig;
      this.poi = this.$store.state.amenityStore.poi;
      this.sub = this.$store.subscribe(function (mutation, state) {
        if (mutation.type === "setMasterplanConfig") {
          _this.masterplanConfig = state.amenityStore.masterplanConfig;
        }

        if (mutation.type === "setPoi") {
          _this.poi = state.amenityStore.poi;
        }

        if (mutation.type === "setRouteInfo") {
          _this.route = state.amenityStore.routeInfo;
        }
      });
    },

    getOrigin: function getOrigin() {
      var master = this.masterplanConfig.svgFileConfigs.find(function (item) {
        return item.svgFileType.fileType === 'MASTER';
      });
      if (master && master.poe) {
        this.origin = { lng: master.poe.lng, lat: master.poe.lat };
      }
    },

    fetchPlacesPrediction: function fetchPlacesPrediction(val) {
      var _this2 = this;

      var place = encodeURI(val.trim());
      var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + place + '.json?types=address&proximity=' + this.origin.lng + ',' + this.origin.lat + '&access_token=' + mapboxgl.accessToken;
      axios.get(url).then(function (res) {
        _this2.predictions = res.data.features;
      }).catch(function (err) {
        return err;
      });
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"is-expanded extended-panel travel-panel"},[_c('p',{staticClass:"panel-title"},[_vm._v("Travel Directions")]),_vm._v(" "),_c('div',{staticClass:"panel-subtitle is-hidden-x"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"direction-buttons"},[_c('div',{staticClass:"buttons has-addons"},[_c('div',{staticClass:"buttons has-addons is-fullwidth"},[_c('button',{staticClass:"button is-small",class:{'is-active': _vm.method === 'driving'},on:{"click":function($event){return _vm.changeMethod('driving')}}},[(_vm.method !== 'driving')?_c('img',{attrs:{"src":__webpack_require__(52),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.method === 'driving')?_c('img',{attrs:{"src":__webpack_require__(53),"alt":""}}):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"button is-small",class:{'is-active': _vm.method === 'cycling'},on:{"click":function($event){return _vm.changeMethod('cycling')}}},[(_vm.method !== 'cycling')?_c('img',{attrs:{"src":__webpack_require__(54),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.method === 'cycling')?_c('img',{attrs:{"src":__webpack_require__(55),"alt":""}}):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"button is-small",class:{'is-active': _vm.method === 'walking'},on:{"click":function($event){return _vm.changeMethod('walking')}}},[(_vm.method !== 'walking')?_c('img',{attrs:{"src":__webpack_require__(56),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.method === 'walking')?_c('img',{attrs:{"src":__webpack_require__(57),"alt":""}}):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"places-search"},[(!_vm.route)?_c('div',{staticClass:"flex-item",class:{'is-reverse': _vm.isSwapped}},[_c('div',{staticClass:"left-item"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[(!_vm.isSwapped)?_c('small',[_vm._v("From")]):_vm._e(),(_vm.isSwapped)?_c('small',[_vm._v("To")]):_vm._e()]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[(!_vm.isSwapped)?_c('small',[_vm._v("To")]):_vm._e(),(_vm.isSwapped)?_c('small',[_vm._v("From")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.destination),expression:"destination"}],staticClass:"input is-small",attrs:{"type":"text","placeholder":"address"},domProps:{"value":(_vm.destination)},on:{"keyup":function($event){return _vm.placesSearch()},"input":function($event){if($event.target.composing){ return; }_vm.destination=$event.target.value}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.predictions && _vm.predictions.length > 0)?_c('div',{staticClass:"box prediction-box"},[_c('table',{staticClass:"table is-fullwidth"},_vm._l((_vm.predictions),function(prediction){return _c('tr',{on:{"click":function($event){return _vm.setDestination(prediction)}}},[_vm._m(2,true),_vm._v(" "),_c('td',[_c('p',[_vm._v("\n                        "+_vm._s(prediction.place_name)+"\n                      ")])])])}),0)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"right-item swap-item"},[_c('a',{on:{"click":function($event){return _vm.swapPlace()}}},[_c('img',{attrs:{"src":__webpack_require__(240),"alt":""}})])])]):_vm._e(),_vm._v(" "),(!_vm.route)?_c('a',{staticClass:"button is-small app-primary is-fullwidth",on:{"click":function($event){return _vm.setDirection()}}},[_vm._v("Go")]):_vm._e(),_vm._v(" "),(_vm.route)?_c('a',{staticClass:"button is-small app-primary is-fullwidth is-hidden-t",on:{"click":function($event){_vm.route = null}}},[_vm._v("Clear")]):_vm._e(),_vm._v(" "),(_vm.route)?_c('div',{staticClass:"travel-time"},[_c('div',{staticClass:"left"},[_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.getTime(_vm.route.duration)))]),_vm._v(" "),_c('p',{staticClass:"distance"},[_vm._v(_vm._s(_vm.getDistance(_vm.route.distance)))])]),_vm._v(" "),(_vm.glink)?_c('a',{attrs:{"target":"_blank","href":_vm.glink}},[_c('i',{staticClass:"fas fa-link"})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.route && _vm.route.legs && _vm.route.legs.length && _vm.route.legs[0].steps)?_c('div',{staticClass:"steps"},[_c('table',{staticClass:"table is-fullwidth"},_vm._l((_vm.route.legs[0].steps),function(steps){return _c('tr',[_c('td',[(steps['icon'])?_c('img',{attrs:{"src":__webpack_require__(20)("./" + steps.icon),"alt":""}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"instruction"},[_vm._v(_vm._s(steps.maneuver.instruction))])])}),0)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control has-icons-left"},[_c('input',{staticClass:"input is-small is-disabled",attrs:{"type":"text","value":"Sandbrock Ranch","disabled":""}}),_vm._v(" "),_c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-map-marker-alt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"is-narrow"},[_c('i',{staticClass:"fas fa-map-marker-alt"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "route.svg?1f2ba943742bd469e59abc8d1db503f0";

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"border-bar",attrs:{"id":"header-bar"}},[_c('div',{staticClass:"left-item"},[_c('a',{staticClass:"button app-primary",on:{"click":function($event){return _vm.startAgain()}}},[_c('i',{staticClass:"fas fa-sync"}),_vm._v("\n        Start Again\n      ")])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('a',{staticClass:"button app-accent",on:{"click":function($event){return _vm.viewFavorites()}}},[_c('i',{staticClass:"fas fa-heart"}),_vm._v("\n        View Favorites\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Disclaimer_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65c959a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Disclaimer_vue__ = __webpack_require__(243);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Disclaimer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65c959a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Disclaimer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal info-modal",class:{'is-active': _vm.showDisclaimer}},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.showDisclaimer = false}}}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"box"},[_c('p',{staticClass:"modal-title"},[_vm._v("Disclaimer")]),_vm._v(" "),_c('p',[_vm._v("\n          All pricing and availability subject to change; to confirm pricing please visit the builder's website or\n          with a sales counselor on-site.\n        ")]),_vm._v(" "),_c('a',{staticClass:"button app-accent",on:{"click":function($event){_vm.showDisclaimer = false}}},[_vm._v("Got It")])]),_vm._v(" "),_c('button',{staticClass:"modal-close is-large",attrs:{"aria-label":"close"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-tracking'),_vm._v(" "),_c('app-disclaimer'),_vm._v(" "),_c('app-header'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_486ff2f5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(257);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_486ff2f5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_map_Config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_map_Home__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_map_Popup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_api__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_map_Config__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_map_Home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_map_Popup__["a" /* default */]],
  data: function data() {
    return {
      activeLot: null,
      showDetail: false,
      lotmarkers: [],

      apartmentGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      baseLayers: [],
      container: 'community-map',
      detailLayers: [],
      filteredlotGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      layers: [],
      lotSummaryList: null,
      packageSummaryList: [],
      lotgeo: __webpack_require__(8),
      lotGeoJson: null,
      lotPanelMarker: null,
      masterBound: null,
      modelHomes: null,
      padding: {
        top: 10,
        bottom: 10,
        left: 15,
        right: 315
      },
      sources: [],
      svgConfig: null,
      arcApprovalProcessData: {},
      activeSalesProcess: {},
      stageGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      viewBasedFilterLot: {
        type: 'FeatureCollection',
        features: []
      }
    };
  },

  methods: {
    initMap: function initMap(config, lotsummary, modelHomes) {
      if (window.innerWidth < 600) {
        this.padding = 5;
      }
      mapboxgl.accessToken = 'pk.eyJ1Ijoic2FpbGVzaGtjIiwiYSI6ImNrZGo1Y2l5dTBibGIzMXBmbzM5Z2Q3Z2MifQ.hq_fP_fYTmUm_LJNRl23Cw';
      if (config && lotsummary) {
        this.lotSummaryList = lotsummary;
        this.modelHomes = modelHomes;
        this.svgConfig = config;
        this.initConfig();
      }
    },

    addLotShapes: function addLotShapes() {
      var _this = this;

      var bounds = new mapboxgl.LngLatBounds();
      this.lotGeoJson.features.forEach(function (feature) {
        var lotname = feature.properties.lotName;
        var lotcpid = feature.properties.lotCpId;
        var lot = _this.lotSummaryList.find(function (item) {
          return item.productname === lotname || item.lotcpid === lotcpid;
        });
        if (lot) {
          feature.properties.lotproperties = lot;
          feature.id = lot.lotcpid;
          feature.properties.color = _this.assignColor(lot.currentstatusname);
          feature.properties.interact = false;
          feature.properties.hoverable = null;
          feature.properties.status = lot.currentstatusname;
          feature.properties.subtype = lot.lotsubtype;
          feature.properties.isActive = false;

          if (lot.currentstatusname === 'available' || lot.currentstatusname === 'Available' || lot.currentstatusname === 'Model') {
            feature.properties.status = 'available';
            feature.properties.hoverable = 'allow';
            feature.properties.interact = true;
          }
          feature.geometry.coordinates[0].forEach(function (cord) {
            bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
          });
          _this.filteredlotGeoJson.features.push(feature);
        }
      });

      this.map.addSource('lots', {
        type: 'geojson',
        data: this.filteredlotGeoJson
      });

      this.map.addLayer({
        id: 'lot-fills',
        type: 'fill',
        source: 'lots',
        layout: {},
        paint: {
          // 'fill-color': {
          //   type: 'identity',
          //   property: 'color',
          // },
          'fill-color': ['case', ['boolean', ['get', 'isActive'], false], '#fff', ['get', 'color']],
          'fill-outline-color': '#333333',
          'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.4, 0.9]
        }
      });

      this.map.on('mousemove', 'lot-fills', function (e) {
        if (e.features.length > 0) {
          if (e.features[0].properties.color === '#8b586a' || e.features[0].properties.color === '#688e9f' || e.features[0].properties.color === '#c3958e' || e.features[0].properties.color === '#f0cd89') {
            _this.map.getCanvas().style.cursor = 'pointer';
            if (_this.hoveredLotId) {
              _this.map.setFeatureState({
                source: 'lots',
                id: _this.hoveredLotId
              }, {
                hover: false
              });
            }
            _this.hoveredLotId = e.features[0].id;
            _this.map.setFeatureState({
              source: 'lots',
              id: _this.hoveredLotId
            }, {
              hover: true
            });
          }
        }
      });

      this.map.on('mouseleave', 'lot-fills', function () {
        _this.map.getCanvas().style.cursor = '';
        if (_this.hoveredLotId) {
          _this.map.setFeatureState({
            source: 'lots',
            id: _this.hoveredLotId
          }, {
            hover: false
          });
        }
        _this.hoveredLotId = null;
      });

      this.map.on('click', function (e) {
        if (_this.lotPanelMarker) {
          _this.lotPanelMarker.remove();
        }
      });

      this.map.on('click', 'lot-fills', function (e) {
        if (e.features.length > 0) {
          var lot = JSON.parse(e.features[0].properties.lotproperties);
          if (e.features[0].properties.interact && lot.currentstatusname !== 'Model') {
            var _bounds = new mapboxgl.LngLatBounds();
            e.features[0].geometry.coordinates[0].forEach(function (cord) {
              _bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
            });
            var payload = {
              point: _bounds.getCenter(),
              features: JSON.parse(JSON.stringify(e.features[0]))
            };
            _this.$store.dispatch('productTracking', {
              page: 'lot-click',
              product: JSON.parse(payload.features.properties.lotproperties)
            });
            _this.createLotMarker(payload);
          } else {
            if (lot.currentstatusname === "Spec" || lot.currentstatusname === "Sold" || lot.currentstatusname === 'Model' || lot.currentstatusname === "Closed" || lot.currentstatusname === 'Contingent Spec') {
              if (lot !== null && lot !== undefined) {
                var hnl = _this.findSpecOrModelHome(_this.packageSummaryList, lot.productname);
                if (hnl) {
                  var lotfeature = _this.lotGeoJson.features.find(function (feature) {
                    return feature.properties.lotCpId === hnl.lotproductcpid;
                  });
                  if (lotfeature) {
                    var markerBound = new mapboxgl.LngLatBounds();
                    lotfeature.geometry.coordinates[0].forEach(function (cord) {
                      markerBound.extend(new mapboxgl.LngLat(cord[0], cord[1]));
                    });
                    _this.createPackageDetailMarker(hnl, lotfeature.geometry.coordinates[0]);
                  } else if (!lotfeature) {
                    _this.packageNotFound();
                  }
                } else if (!hnl) {
                  _this.packageNotFound();
                }
              }
            } else {
              return;
            }
          }
        }
      });

      this.placeDetailLayer();
      this.addApartmentShapes();
      if (bounds) {
        this.map.fitBounds(bounds, {
          padding: this.padding,
          maxZoom: 18
        });
      } else {
        this.map.fitBounds(this.masterBound);
      }
    },

    packageNotFound: function packageNotFound() {
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
        icon: 'error',
        title: 'Error 404',
        text: "Sorry, we're having trouble locating this package."
      });
    },

    findSpecOrModelHome: function findSpecOrModelHome(handlSummaries, lotProductName) {
      handlSummaries = handlSummaries.filter(function (handlSummary) {
        return handlSummary.lotproductname === lotProductName && ["Model", "Spec", "Contingent Spec", "Sold", "Closed"].includes(handlSummary.currentstatusname);
      });
      if (handlSummaries && handlSummaries.length > 0) {
        if (handlSummaries.length > 1) {
          handlSummaries.sort(function (a, b) {
            return compareNumbers(a.createddate, b.createddate, -1);
          });
        }
        return handlSummaries[0];
      }
      return null;
    },


    processActiveSalesProcess: function processActiveSalesProcess(processes) {
      var activeProcesses = processes.filter(function (process) {
        return process.active === true;
      });
      if (activeProcesses === undefined || activeProcesses.length === 0) {
        console.log('No active sales processes found');
        return;
      }
      if (activeProcesses.length > 1) {
        console.error('More than one active sales processes found. Please contact runway. Meantime, using the latest as the active one');
      }

      var arcApprovalProcesses = activeProcesses.filter(function (salesProcess) {
        return salesProcess.processId === '' + 135;
      });
      if (arcApprovalProcesses !== null && arcApprovalProcesses !== undefined && arcApprovalProcesses.length > 0) {
        this.arcApprovalProcessData = arcApprovalProcesses[arcApprovalProcesses.length - 1];
        //this.changeToInProgress();
      }

      var salesProcesses = activeProcesses.filter(function (salesProcess) {
        return salesProcess.processId === '' + 128;
      });
      if (salesProcesses !== null && salesProcesses !== undefined && salesProcesses.length > 0) {
        this.activeSalesProcess = salesProcesses[salesProcesses.length - 1];
      } else {
        this.activeSalesProcess = activeProcesses[0];
      }
    },

    createPackageDetailMarker: function createPackageDetailMarker(hnlSummary, coord) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__store_api__["a" /* api */].listSalesProcessByPackageCpId(hnlSummary.cpidstring).then(function (processes) {
        var salesProcesses = processes.data;
        if (salesProcesses !== null && salesProcesses !== undefined && salesProcesses.length > 0) {
          _this2.processActiveSalesProcess(salesProcesses);
          _this2.generatePopup(hnlSummary, coord);
        } else {
          _this2.generatePopup(hnlSummary, coord);
        }
      });
    },

    generatePopup: function generatePopup(hnlSummary, coord) {
      var _this3 = this;

      this.showDetail = true;
      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }
      this.lotmarkers.forEach(function (m) {
        m.remove();
      });
      var markerBound = new mapboxgl.LngLatBounds();
      coord.forEach(function (cord) {
        markerBound.extend(new mapboxgl.LngLat(cord[0], cord[1]));
      });
      var el = void 0;
      if (hnlSummary.currentstatusname === "Spec" || hnlSummary.currentstatusname === "Available" || hnlSummary.currentstatusname === 'Contingent Spec') {
        el = this.getPackageTile(hnlSummary);
      } else {
        el = this.getPackageDetailTile(hnlSummary);
      }

      if (this.activeSalesProcess.salesProcessVpbs && this.activeSalesProcess.salesProcessVpbs.length > 0) {
        var columnsDiv = document.createElement('div');
        columnsDiv.classList.add('columns');
        columnsDiv.classList.add('is-flex');
        columnsDiv.style.flexDirection = 'column';
        columnsDiv.style.margin = '0px';
        this.activeSalesProcess.salesProcessVpbs.forEach(function (item) {
          if (item.active === true) {
            var columnEl = document.createElement('div');
            columnEl.classList.add('column');
            columnEl.classList.add('pb-1');
            columnEl.classList.add('pt-1');
            columnEl.innerHTML = _this3.generateVpb(item);
            columnsDiv.appendChild(columnEl);
          }
        });
        el.appendChild(columnsDiv);
      }

      if (hnlSummary.currentstatusname === "Spec" || hnlSummary.currentstatusname === "Available") {
        var aDetailEl = document.createElement('a');
        aDetailEl.classList.add('explore');
        aDetailEl.classList.add('mb-3');
        aDetailEl.classList.add('mt-3');
        aDetailEl.innerHTML = 'EXPLORE THIS HOME';

        el.lastElementChild.appendChild(aDetailEl);
        aDetailEl.addEventListener('click', function () {
          _this3.$router.push({
            path: '/community/package/' + hnlSummary.cpidstring
          });
          setTimeout(function () {
            if (_this3.lotPanelMarker) {
              _this3.lotPanelMarker.remove();
            }
          });
        });
      }

      var aEl = document.createElement('a');
      aEl.classList.add('modal-close');
      aEl.addEventListener('click', function (e) {
        e.stopPropagation();
        _this3.showDetail = false;
        _this3.reset();
      }, true);

      el.appendChild(aEl);

      this.map.flyTo({
        center: markerBound.getCenter(),
        zoom: 18,
        essential: true
      });

      this.lotPanelMarker = new mapboxgl.Marker({
        element: el,
        anchor: 'bottom',
        offset: [0, -40]
      });
      this.lotPanelMarker.setLngLat(markerBound.getCenter());
      this.lotPanelMarker.addTo(this.map);
    },
    generateVpb: function generateVpb(item) {
      var vpb = '';
      if (item.vpbCategoryName) {
        vpb = vpb + (item.vpbCategoryName + " - ");
      }
      if (item.vpbSubCategoryName) {
        vpb = vpb + (item.vpbSubCategoryName + " - ");
      }
      if (item.salesProcessVpbDescription) {
        vpb = vpb + ("" + item.salesProcessVpbDescription);
      }
      return vpb;
    },


    reset: function reset() {
      this.resetTileView();
    },

    resetTileView: function resetTileView() {
      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }
    },

    createLotMarker: function createLotMarker(e) {
      var lotFeatures = JSON.parse(e.features.properties.lotproperties);
      var el = void 0;
      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }
      if (lotFeatures.currentstatusname === 'Model') {
        if (this.modelHomes && this.modelHomes.length) {
          el = this.createModeHomePopup(lotFeatures);
        }
      } else {
        el = this.createLotPopup(lotFeatures);
      }

      this.map.flyTo({
        center: [e.point.lng, e.point.lat],
        zoom: 18,
        essential: true
      });

      if (el) {
        this.lotPanelMarker = new mapboxgl.Marker({
          element: el,
          anchor: 'bottom',
          offset: [0, -40]
        }).setLngLat([e.point.lng, e.point.lat]);
        this.lotPanelMarker.addTo(this.map);
      }
    },

    createModeHomePopup: function createModeHomePopup(lotFeatures) {
      var hnlSummary = this.modelHomes.find(function (item) {
        return item.lotproductcpid === lotFeatures.lotcpid;
      });
      if (!hnlSummary) return null;

      var el = document.createElement('div');
      el.classList.add('home-select-popup', 'card');
      el.innerHTML = "<div class=\"facade-image\">\n          <figure class=\"image is-3by2\">\n            <img src=\"" + hnlSummary.imagepath + "\" alt=\"\">\n          </figure>\n        </div>";

      var infoEl = document.createElement('div');
      infoEl.classList.add('card-info');
      infoEl.innerHTML = "<div class=\"columns is-mobile is-gapless\">\n            <div class=\"column design\">\n              <p class=\"design\">" + hnlSummary.designproductname + "</p>\n              <p class=\"d\">" + hnlSummary.buildername + "</p>\n              <p class=\"mt-2 pr-1\">" + hnlSummary.productaddress + "</p>\n            </div>\n            <div class=\"column is-narrow\">\n              <div class=\"amenities\">\n                <div class=\"amenity\">\n                  <img src=\"" + __webpack_require__(2) + "\" alt=\"\">\n                  <span>" + hnlSummary.noofbedrooms + "</span>\n                </div>\n                <div class=\"amenity\">\n                  <img src=\"" + __webpack_require__(3) + "\" alt=\"\">\n                  <span>" + hnlSummary.noofbathrooms + "</span>\n                </div>\n                <div class=\"amenity\">\n                  <img src=\"" + __webpack_require__(4) + "\" alt=\"\">\n                  <span>" + hnlSummary.noofcarparks + "</span>\n                </div>\n              </div>\n              <div class=\"price\" id=\"runway-price\">\n              <p class=\"p\">$" + showPackagePrice(hnlSummary) + "</p>\n            </div>\n            <div id=\"call-builder-for-price\">\n              <p class=\"is-size-6\">" + showPackagePrice(hnlSummary) + "</p>\n            </div>\n            </div>\n          </div>";

      el.appendChild(infoEl);
      return el;
    },

    createLotPopup: function createLotPopup(lotFeatures) {
      var _this4 = this;

      var sqft = 'n/a';
      if (lotFeatures.productsize && lotFeatures.productsize != 0) {
        sqft = lotFeatures.productsize + ' sqft';
      }
      var el = document.createElement('div');
      el.classList.add('lot-select-popup');
      var htmlcontent = "\n      <div class=\"pop-title\">Homesite " + lotFeatures.productname + "</div>\n        <div class=\"pop-dim\">\n          <div>\n            <p>Area</p>\n            <p>" + sqft + "</p>\n          </div>\n          <div>\n            <p>Lot Size</p>\n            <p>" + lotFeatures.lotgroup + "</p>\n          </div>\n          <div>\n            <p>Builder</p>\n            <p>" + lotFeatures.allocatedBuilderName + "</p>\n          </div>\n        </div>\n      ";
      el.innerHTML = htmlcontent;
      var aEl = document.createElement('a');
      var imgEl = document.createElement('img');
      imgEl.src = __webpack_require__(247);
      el.appendChild(aEl);
      aEl.appendChild(imgEl);

      aEl.addEventListener('click', function () {
        _this4.activeLot = lotFeatures;
      });
      return el;
    },

    filterMapLots: function filterMapLots(lotsummary) {
      var _this5 = this;

      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }
      this.viewBasedFilterLot.features = [];
      this.filteredlotGeoJson.features.forEach(function (feature) {
        feature.properties.isActive = false;
        var lot = lotsummary.find(function (item) {
          return item.productname === feature.properties.lotName && item.lotcpid === feature.properties.lotCpId;
        });
        if (lot) {
          feature.properties.color = _this5.assignColor(lot.currentstatusname);
          if (feature.properties.status === 'available') {
            feature.properties.interact = true;
            _this5.viewBasedFilterLot.features.push(feature);
          } else {
            feature.properties.interact = false;
          }
        } else {
          feature.properties.color = '#333333';
          feature.properties.interact = false;
        }
      });

      this.map.getSource('lots').setData(this.filteredlotGeoJson);

      var bounds = new mapboxgl.LngLatBounds();
      this.viewBasedFilterLot.features.forEach(function (feature) {
        feature.geometry.coordinates[0].forEach(function (cord) {
          bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
        });
      });
      if (this.viewBasedFilterLot.features.length > 0) {
        this.map.fitBounds(bounds, {
          padding: 20,
          maxZoom: 18
        });
      } else {
        this.map.fitBounds(this.masterBound, {
          padding: 20
        });
      }
    },

    flyTo: function flyTo(lotId, mark) {
      this.viewBasedFilterLot.features = [];
      var lotGeo = this.filteredlotGeoJson.features.find(function (item) {
        return lotId === item.properties.lotCpId;
      });

      if (lotGeo) {
        var bounds = new mapboxgl.LngLatBounds();
        lotGeo.geometry.coordinates[0].forEach(function (cord) {
          bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
        });
        // const point = item.geometry.coordinates[0][0];
        var m = {
          point: bounds.getCenter(),
          features: {
            properties: {
              lotproperties: JSON.stringify(lotGeo.properties.lotproperties)
            }
          }
        };
        this.createLotMarker(m);
        // item.properties.isActive = true;
        this.map.fitBounds(bounds, {
          maxZoom: 19
        });
      }
    },

    showPackagePrice: function showPackagePrice(hnlSummary) {
      var specStatusId = '7033741562122316063';
      var modelStatusId = '4200111562122316041';
      var priceString = '';
      if (hnlSummary.currentstatusid === specStatusId) {
        priceString = hnlSummary.productprice.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      } else {
        priceString = hnlSummary.planPrice.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      }
      if (window.location.href.includes('favorite')) {
        if (hnlSummary.planPrice <= 0 || !hnlSummary.planPrice || !hnlSummary.productprice || hnlSummary.productprice <= 0) {
          setTimeout(function () {
            var priceEl = document.getElementById('runway-price');
            var callBuilderEl = document.getElementById('call-builder-for-price');
            priceEl.style.display = 'none';
            callBuilderEl.style.display = 'block';
          }, 50);
          priceString = "Call Builder for Pricing";
        }
      }
      return priceString;
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "select_home.svg?54c673144a1c6d7426b79f5bf327c502";

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandPanel_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d71697e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandPanel_vue__ = __webpack_require__(252);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d71697e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  landAreaMin: 0,
  landAreaFrom: 0,
  landAreaMax: 0,
  landAreaTo: 0,
  landPriceMin: 0,
  landPriceMax: 0,
  landPriceFrom: 0,
  landPriceTo: 0,
  landWidthMin: 0,
  landWidthFrom: 0,
  landWidthMax: 0,
  landWidthTo: 0,
  stages: [],
  stage: '',
  builder: '',
  lotgroup: ''
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandList_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d461086a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandList_vue__ = __webpack_require__(251);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d461086a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"scrollable is-hidden-x"},[_c('table',{staticClass:"table is-fullwidth is-marginless"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.landSummary),function(lot){return (lot.currentstatusname === 'Available')?_c('tr',{staticClass:"is-hoverable",class:{'is-active': _vm.activeLot && _vm.activeLot.cpidstring === lot.cpidstring},on:{"click":function($event){return _vm.selectLot(lot)}}},[_c('td',[_vm._v(_vm._s(lot.productname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(lot.productsize)+" sqft")]),_vm._v(" "),_c('td',{staticClass:"price-filter-landlist-item"},[(lot.lotgroup)?_c('span',[_vm._v("\n                    "+_vm._s(lot.lotgroup)+"\n                  ")]):_vm._e()])]):_vm._e()})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("\n          LOT\n        ")]),_vm._v(" "),_c('th',[_vm._v("\n          SQUARE FOOTAGE\n        ")]),_vm._v(" "),_c('th',{staticClass:"price-filter-landlist"},[_vm._v("\n          LOT SIZE\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"spacer"},[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',{staticClass:"price-filter-landlist-spacer"},[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map-legend"}},[(_vm.filterToggle === false)?_c('a',{staticClass:"filter-collapse",on:{"click":function($event){_vm.filterToggle = true}}},[_c('i',{staticClass:"fas fa-search"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"is-expanded extended-panel lot-filter-panel",class:{'is-active': _vm.filterToggle}},[_c('button',{staticClass:"delete is-hidden-t",on:{"click":function($event){_vm.filterToggle = false}}}),_vm._v(" "),_c('div',{staticClass:"panel-header-section"},[_c('div',{staticClass:"left-item"},[_c('p',{staticClass:"panel-title"},[_vm._v("Find Your Lot")]),_vm._v(" "),(_vm.landSummary)?_c('p',{staticClass:"panel-subtitle"},[_vm._v(_vm._s(_vm.filteredLandSummary.length)+" lot"),(_vm.filteredLandSummary.length > 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(" available")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('a',{staticClass:"button is-small app-highlight",on:{"click":function($event){return _vm.resetFilter()}}},[_vm._v("\n            RESTART\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"filter-section"},[(_vm.filter)?_c('div',{staticClass:"filter-item"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"select is-small is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.stage),expression:"filter.stage"}],attrs:{"name":"","id":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filter, "stage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.filterLots()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.filter.stages),function(stage){return _c('option',{model:{value:(_vm.filter.stage),callback:function ($$v) {_vm.$set(_vm.filter, "stage", $$v)},expression:"filter.stage"}},[_vm._v(_vm._s(stage))])})],2)])]):_vm._e(),_vm._v(" "),(_vm.filter && _vm.builders.length > 1)?_c('div',{staticClass:"filter-item"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"select is-small is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.builder),expression:"filter.builder"}],attrs:{"name":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filter, "builder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.filterLots()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.builders),function(builder){return _c('option',{model:{value:(_vm.filter.builder),callback:function ($$v) {_vm.$set(_vm.filter, "builder", $$v)},expression:"filter.builder"}},[_vm._v(_vm._s(builder))])})],2)])]):_vm._e(),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"filter-item"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"buttons has-addons"},_vm._l((_vm.lotgroups),function(group){return _c('button',{staticClass:"button",class:{'is-active': _vm.filter.lotgroup === group},on:{"click":function($event){return _vm.filterByLotGroup(group)}}},[_vm._v(_vm._s(group))])}),0)]):_vm._e(),_vm._v(" "),_c('div',{class:{'active': _vm.landSummary.length > 0},attrs:{"id":"filter-sliders"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"filter-item"})])]),_vm._v(" "),_c('a',{staticClass:"button app-highlight is-hidden-t",on:{"click":function($event){_vm.filterToggle = false}}},[_vm._v("Search")]),_vm._v(" "),_c('app-land-list',{attrs:{"landSummary":_vm.filteredLandSummary},on:{"setLotNameClick":function($event){_vm.activeLot = $event}}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"label"},[_c('small',[_vm._v("PHASE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"label"},[_c('small',[_vm._v("BUILDER")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"label"},[_c('small',[_vm._v("LOT SIZE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-item"},[_c('p',{staticClass:"label"},[_c('small',[_vm._v("SQUARE FOOTAGE")])]),_vm._v(" "),_c('input',{staticClass:"range-slider",attrs:{"type":"text","id":"area"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Selector_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d20da92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selector_vue__ = __webpack_require__(254);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d20da92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.name !== 'explore')?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 276.89004 52.64014"}},[_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticStyle:{"fill":"none","stroke":"#345d48"},attrs:{"id":"Path_28289","data-name":"Path 28289","d":"M17.09393,52.14014l-6.51908-6.281v-4.353l-9.9766-15.186,9.9766-15.186V6.781L17.09393.5H259.79609l6.518,6.281v4.353l9.97771,15.186-9.97771,15.186v4.353l-6.518,6.281Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#cfd6cb","stroke":"#345d48","stroke-miterlimit":"10","stroke-width":"2px"},attrs:{"id":"Path_28290","data-name":"Path 28290","d":"M257.8457,4.436l4.0272,3.87988V12.1958l9.27948,14.12305-9.27948,14.123v3.87989l-4.0272,3.87988H19.04212l-4.0272-3.87988V40.44189l-9.27948-14.123,9.27948-14.123V8.31592L19.04212,4.436Z"}}),_vm._v(" "),_c('circle',{staticStyle:{"fill":"#cfd6cb","stroke":"#345d48","stroke-width":"0.5px"},attrs:{"id":"Ellipse_9423","data-name":"Ellipse 9423","cx":"260.6785","cy":"26.31902","r":"3.67331"}}),_vm._v(" "),_c('circle',{staticStyle:{"fill":"#cfd6cb","stroke":"#345d48","stroke-width":"0.5px"},attrs:{"id":"Ellipse_9423-2","data-name":"Ellipse 9423","cx":"16.6785","cy":"26.31902","r":"3.67331"}}),_vm._v(" "),(_vm.name === 'lot')?_c('text',{staticStyle:{"font-size":"19px","font-family":"Didot-Bold, Didot","font-weight":"700","text-align":"center"},attrs:{"transform":"translate(60 31.69683)"}},[_c('tspan',[_vm._v(_vm._s(_vm.number)+". ")]),_vm._v("SELECT LOT\n          ")]):_vm._e(),_vm._v(" "),(_vm.name === 'home')?_c('text',{staticStyle:{"font-size":"19px","font-family":"Didot-Bold, Didot","font-weight":"700","text-align":"center"},attrs:{"transform":"translate(21.5 31.69683)"}},[_c('tspan',[_vm._v(_vm._s(_vm.number)+". ")]),_vm._v("SELECT FLOORPLAN\n          ")]):_vm._e(),_vm._v(" "),(_vm.name === 'exterior')?_c('text',{staticStyle:{"font-size":"19px","font-family":"Didot-Bold, Didot","font-weight":"700","text-align":"center"},attrs:{"transform":"translate(30 31.69683)"}},[_c('tspan',[_vm._v(_vm._s(_vm.number)+". ")]),_vm._v("SELECT EXTERIOR\n          ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.name === 'explore')?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 348.9922 52.64014"}},[_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticStyle:{"fill":"none","stroke":"#345d48"},attrs:{"id":"Path_28289","data-name":"Path 28289","d":"M21.453,52.14014l-8.2216-6.281v-4.353L.64932,26.32007,13.23141,11.134V6.781L21.453.5H327.53916l8.22021,6.281v4.353l12.58348,15.186-12.58348,15.186v4.353l-8.22021,6.281Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#cfd6cb","stroke":"#345d48","stroke-miterlimit":"10","stroke-width":"2px"},attrs:{"id":"Path_28290","data-name":"Path 28290","d":"M325.0794,4.436l5.07894,3.87988V12.1958l11.70291,14.12305-11.70291,14.123v3.87989l-5.07894,3.87988H23.91l-5.07894-3.87988V40.44189L7.12814,26.31885l11.70291-14.123V8.31592L23.91,4.436Z"}}),_vm._v(" "),_c('circle',{staticStyle:{"fill":"#cfd6cb","stroke":"#345d48","stroke-width":"0.5px"},attrs:{"id":"Ellipse_9423","data-name":"Ellipse 9423","cx":"329.72958","cy":"26.31902","r":"3.67331"}}),_vm._v(" "),_c('circle',{staticStyle:{"fill":"#cfd6cb","stroke":"#345d48","stroke-width":"0.5px"},attrs:{"id":"Ellipse_9423-2","data-name":"Ellipse 9423","cx":"19.72958","cy":"26.31902","r":"3.67331"}}),_vm._v(" "),_c('text',{staticStyle:{"font-size":"19px","font-family":"Didot-Bold, Didot","font-weight":"700"},attrs:{"transform":"translate(27 32.69683)"}},[_vm._v("4. EXPLORE YOUR NEW HOME\n          ")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal loading-modal",class:{'is-active': _vm.loading}},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"sp sp-circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-loading',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('div',{staticClass:"journey-nav-container"},[_c('div',{staticClass:"container"},[(_vm.selector && _vm.selector === 'lot')?_c('div',{staticClass:"navigation-bar"},[_c('div',{staticClass:"nav",class:{'prev': _vm.activeIds.lotid, 'current': _vm.currentPage === 'map'}},[_c('a',{on:{"click":function($event){return _vm.selectLot()}}},[_c('app-selector',{attrs:{"name":'lot',"number":'1'}})],1)]),_vm._v(" "),_c('div',{staticClass:"nav"},[(_vm.activeIds.lotid)?_c('img',{attrs:{"src":__webpack_require__(9),"alt":""}}):_vm._e(),_vm._v(" "),(!_vm.activeIds.lotid)?_c('img',{attrs:{"src":__webpack_require__(6),"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nav is-disabled",class:{'prev': _vm.activeIds.homeid && _vm.currentPage !== 'homes', 'current': _vm.currentPage === 'homes'}},[(_vm.currentPage === 'map')?_c('a',{attrs:{"uk-tooltip":"title: Select a lot from the map below in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'home',"number":'2'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'homes')?_c('a',[_c('app-selector',{attrs:{"name":'home',"number":'2'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage !== 'homes' && _vm.activeIds.homeid)?_c('a',{on:{"click":function($event){return _vm.selectHome()}}},[_c('app-selector',{attrs:{"name":'home',"number":'2'}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nav"},[(_vm.activeIds.homeid && _vm.currentPage !== 'homes')?_c('img',{attrs:{"src":__webpack_require__(9),"alt":""}}):_vm._e(),_vm._v(" "),(!_vm.activeIds.homeid || _vm.currentPage === 'homes')?_c('img',{attrs:{"src":__webpack_require__(6),"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nav",class:{'prev': _vm.activeIds.facadeid && _vm.currentPage !== 'facade', 'current': _vm.currentPage === 'facade', 'next': _vm.currentPage === 'homes' && _vm.activeIds.homeid}},[(_vm.currentPage === 'map')?_c('a',{attrs:{"uk-tooltip":"title: Select a lot from the map below in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'exterior',"number":'3'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'homes' && !_vm.activeIds.homeid)?_c('a',{attrs:{"uk-tooltip":"title: Select a home and confirm in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'exterior',"number":'3'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'facade')?_c('a',[_c('app-selector',{attrs:{"name":'exterior',"number":'3'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'homes' && _vm.activeIds.homeid)?_c('a',{on:{"click":function($event){return _vm.selectFacade()}}},[_c('app-selector',{attrs:{"name":'exterior',"number":'3'}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nav"},[_c('img',{attrs:{"src":__webpack_require__(6),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"nav",class:{'next': _vm.currentPage === 'facade'}},[(!_vm.activeIds.lotid)?_c('a',{attrs:{"uk-tooltip":"title: Select a lot from the map below in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'explore',"number":'4'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'homes' && _vm.activeIds.lotid)?_c('a',{attrs:{"uk-tooltip":"title: Select a home and confirm in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'explore',"number":'4'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'facade')?_c('a',{on:{"click":function($event){return _vm.createPackage()}}},[_c('app-selector',{attrs:{"name":'explore',"number":'4'}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selector && _vm.selector === 'home')?_c('div',{staticClass:"navigation-bar"},[_c('div',{staticClass:"nav",class:{'prev': _vm.activeIds.homeid && _vm.currentPage !== 'homes', 'current': _vm.currentPage === 'homes'},on:{"click":function($event){return _vm.selectHome()}}},[_c('a',[_c('app-selector',{attrs:{"name":'home',"number":'1'}})],1)]),_vm._v(" "),_c('div',{staticClass:"nav"},[(_vm.activeIds.homeid && _vm.currentPage !== 'homes')?_c('img',{attrs:{"src":__webpack_require__(9),"alt":""}}):_vm._e(),_vm._v(" "),(!_vm.activeIds.homeid || _vm.currentPage === 'homes')?_c('img',{attrs:{"src":__webpack_require__(6),"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nav",class:{'prev': _vm.activeIds.facadeid && _vm.currentPage !== 'facade', 'current': _vm.currentPage === 'facade', 'next': _vm.currentPage === 'homes' && _vm.activeIds.homeid}},[(!_vm.activeIds.homeid)?_c('a',{attrs:{"uk-tooltip":"title: Select a home and confirm in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'exterior',"number":'2'}})],1):_vm._e(),_vm._v(" "),(_vm.activeIds.homeid)?_c('a',{on:{"click":function($event){return _vm.selectFacade()}}},[_c('app-selector',{attrs:{"name":'exterior',"number":'2'}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nav"},[(_vm.activeIds.facadeid && _vm.currentPage !== 'facade')?_c('img',{attrs:{"src":__webpack_require__(9),"alt":""}}):_vm._e(),_vm._v(" "),(!_vm.activeIds.facadeid || _vm.currentPage === 'facade')?_c('img',{attrs:{"src":__webpack_require__(6),"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nav",class:{'prev': _vm.activeIds.lotid, 'current': _vm.currentPage === 'map'}},[(_vm.currentPage === 'homes')?_c('a',{attrs:{"uk-tooltip":"title: Select home and matching exterior in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'lot',"number":'3'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'facade')?_c('a',{attrs:{"uk-tooltip":"title: Select and confirm exterior in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'lot',"number":'3'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'map')?_c('a',[_c('app-selector',{attrs:{"name":'lot',"number":'3'}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nav"},[(_vm.activeIds.lotid)?_c('img',{attrs:{"src":__webpack_require__(9),"alt":""}}):_vm._e(),_vm._v(" "),(!_vm.activeIds.lotid)?_c('img',{attrs:{"src":__webpack_require__(6),"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"nav",class:{'next': _vm.currentPage === 'map'}},[(_vm.currentPage === 'homes')?_c('a',{attrs:{"uk-tooltip":"title: Select home and matching exterior in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'explore',"number":'4'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'facade')?_c('a',{attrs:{"uk-tooltip":"title: Select and confirm exterior in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'explore',"number":'4'}})],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'map')?_c('a',{attrs:{"uk-tooltip":"title: Select lot from the map below in order to continue; pos: bottom"}},[_c('app-selector',{attrs:{"name":'explore',"number":'4'}})],1):_vm._e()])]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-loading',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('app-navigation',{attrs:{"active-lot":_vm.activeLot}}),_vm._v(" "),_c('div',{staticClass:"layout"},[(_vm.lotView)?_c('div',{staticClass:"layout-item lot-panel"},[(_vm.lotload)?_c('app-land-list',{attrs:{"landSummary":_vm.lotload},on:{"setActiveLot":function($event){return _vm.flyTo($event.lotcpid, false)}}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"layout-item grow"},[_c('div',{ref:"community-map",attrs:{"id":"map"}},[_c('div',{staticClass:"custom-control"},[_c('a',{on:{"click":function($event){return _vm.toggle3d()}}},[_c('img',{attrs:{"src":__webpack_require__(16),"alt":""}})])]),_vm._v(" "),_c('app-map-label')],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565b4c60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(268);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565b4c60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompatibleHomeList_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9980e1c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompatibleHomeList_vue__ = __webpack_require__(265);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompatibleHomeList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9980e1c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompatibleHomeList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"home-card card",on:{"click":function($event){return _vm.goToNext(_vm.homeSummary)}}},[_c('div',{staticClass:"facade-image"},[(_vm.homeSummary.facadelist.length)?_c('figure',{staticClass:"image is-3by2"},[_c('img',{attrs:{"src":_vm.homeSummary.facadelist[0].imageurl,"alt":""}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('div',{staticClass:"columns is-mobile is-gapless"},[_c('div',{staticClass:"column design"},[_c('p',{staticClass:"design"},[_vm._v(_vm._s(_vm.homeSummary.designproductname))]),_vm._v(" "),_c('p',{staticClass:"d"},[_vm._v(_vm._s(_vm.homeSummary.ownername))])]),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_c('div',{staticClass:"amenities"},[_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(2),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.homeSummary.noofbedrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(3),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.homeSummary.noofbathrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(4),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.homeSummary.noofcarparks))])])]),_vm._v(" "),_c('div',{staticClass:"price"},[_c('p',{staticClass:"p"},[_vm._v("$"+_vm._s(_vm.homeSummary.productprice.toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"columns is-mobile is-gapless"},[_c('div',{staticClass:"column dimensions"},[_c('div',{staticClass:"dimension"},[_c('p',{staticClass:"t"},[_vm._v("Home Area")]),_vm._v(" "),_c('p',{staticClass:"d"},[_vm._v(_vm._s(_vm.homeSummary.productsize.toLocaleString())),_c('small',[_vm._v(" sq ft")])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-narrow"},[_c('a',{staticClass:"button app-accent"},[_vm._v("\n            Select Home\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimilarHomes_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4978fb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimilarHomes_vue__ = __webpack_require__(262);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimilarHomes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4978fb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimilarHomes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.homeSummaryList.length > 0)?_c('div',{staticClass:"uk-slider-container-offset slider-container",attrs:{"uk-slider":"finite: true"}},[_c('p',{staticClass:"title"},[_vm._v("There are "+_vm._s(_vm.homeSummaryList.length)+" similar homes")]),_vm._v(" "),_c('div',{staticClass:"uk-slider-items r-columns"},[_c('div',{staticClass:"r-column"}),_vm._v(" "),_vm._l((_vm.homeSummaryList),function(homeSummary,index){return _c('div',{key:index,staticClass:"r-column is-narrow"},[_c('a',{class:{'is-active': _vm.activeHomeDetail && _vm.activeHomeDetail.cpidstring === homeSummary.cpidstring},on:{"click":function($event){return _vm.selectHome(homeSummary)}}},[_c('app-home-card',{attrs:{"homeSummary":homeSummary,"triggerSelect":false},on:{"homeSelected":function($event){return _vm.selectHome($event)}}})],1)])}),_vm._v(" "),_c('div',{staticClass:"r-column"})],2),_vm._v(" "),_c('a',{staticClass:"slidenav-buttons slidenav-left uk-visible@m",attrs:{"href":"#","uk-slidenav-previous":"","uk-slider-item":"previous"}}),_vm._v(" "),_c('a',{staticClass:"slidenav-buttons slidenav-right uk-visible@m",attrs:{"href":"#","uk-slidenav-next":"","uk-slider-item":"next"}})]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"uk-slider-nav uk-dotnav uk-flex-center uk-margin"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeHomeDetail)?_c('div',{staticClass:"home-detail",attrs:{"id":"package-detail"}},[_c('div',{staticClass:"header-bar"},[_c('div',{staticClass:"back-box"},[_c('a',{staticClass:"button app-accent",on:{"click":_vm.goBack}},[_vm._v("BACK TO LIST")]),_vm._v(" "),_c('a',{staticClass:"button app-primary pulse",on:{"click":function($event){return _vm.goToNext()}}},[_vm._v("CONFIRM SELECTION")])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline is-variable is-6 boxes"},[_c('div',{staticClass:"column is-6-desktop is-12-tablet is-12-mobile grid-box"},[_c('div',{staticClass:"facade-box box"},[_c('img',{attrs:{"src":_vm.activeHomeDetail.facadelist[0].imageurl,"alt":"Placeholder image"}}),_vm._v(" "),_c('div',{staticClass:"columns package-detail is-gapless"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"product"},[_vm._v("\n                    "+_vm._s(_vm.activeHomeDetail.designproductname)+" "+_vm._s(_vm.activeHomeDetail.facadeproductname)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"builder-name"},[_vm._v("\n                    "+_vm._s(_vm.activeHomeDetail.ownername)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"column is-narrow has-text-right"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"amenities ml-0"},[_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(2),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.activeHomeDetail.noofbedrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(3),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.activeHomeDetail.noofbathrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(4),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.activeHomeDetail.noofcarparks))])])]),_vm._v(" "),_c('p',{staticClass:"price"},[_c('span',{staticClass:"from"},[_vm._v("From")]),_vm._v("\n                    $"+_vm._s(_vm.activeHomeDetail.productprice.toLocaleString())+"\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"lot-fit-dimensions"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('p',{staticClass:"dim-title"},[_vm._v("Square Footage")]),_vm._v(" "),_c('p',{staticClass:"dim"},[_vm._v(_vm._s(_vm.activeHomeDetail.productsize.toLocaleString())+"\n                        "),_c('small',[_vm._v(" sq ft")])])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('p',{staticClass:"dim-title"},[_vm._v("Home Width")]),_vm._v(" "),_c('p',{staticClass:"dim"},[_vm._v(_vm._s(Math.floor(_vm.activeHomeDetail.productwidth/12))+" "),_c('small',[_vm._v("ft")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"column is-6-desktop is-12-tablet is-12-mobile grid-box"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"floorplan-section"},[_c('a',{attrs:{"href":_vm.activeHomeDetail.imagepath,"data-lightbox":"floorplan","data-title":"Floorplan"}},[_c('img',{attrs:{"src":_vm.activeHomeDetail.imagepath}})])])])])])]),_vm._v(" "),_c('app-similar-homes',{attrs:{"activeHomeDetail":_vm.activeHomeDetail},on:{"similarhome":function($event){return _vm.replaceActiveDetail($event)}}})],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('p',{staticClass:"s-title"},[_vm._v("\n                    Dimensions\n                  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"filter-section"},[(_vm.filterToggle === false)?_c('a',{staticClass:"filter-collapse",on:{"click":function($event){_vm.filterToggle = true}}},[_c('i',{staticClass:"fas fa-search"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filters",class:{'is-active': _vm.filterToggle}},[_c('button',{staticClass:"delete is-hidden-t",on:{"click":function($event){_vm.filterToggle = false}}}),_vm._v(" "),_c('div',{staticClass:"filter-content"},[_c('div',{staticClass:"columns is-multiline is-mobile is-variable is-5"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"slider"},[_c('label',{staticClass:"label"},[_vm._v("\n                Square Footage\n              ")]),_vm._v(" "),_c('input',{ref:"home-area",staticClass:"range-slider",attrs:{"type":"text","id":"area","name":"area_range","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"slider"},[_c('label',{staticClass:"label"},[_vm._v("\n                Price\n              ")]),_vm._v(" "),_c('input',{ref:"home-price",staticClass:"range-slider home-area",attrs:{"type":"text","id":"price","name":"price_range","value":""}})])]),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"column is-narrow"},[_c('label',{staticClass:"label"},[_vm._v("\n              Bedrooms\n            ")]),_vm._v(" "),_c('div',{staticClass:"buttons has-addons"},_vm._l((['Any','2+','3+','4+','5+']),function(bed,index){return _c('span',{key:index,staticClass:"button",class:{ 'is-active': _vm.filter.bedArray.includes(bed) },on:{"click":function($event){return _vm.filterByBed(bed)}}},[_vm._v("\n                  "+_vm._s(bed.toUpperCase())+"\n              ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"column is-narrow"},[_c('label',{staticClass:"label"},[_vm._v("\n              Bathrooms\n            ")]),_vm._v(" "),_c('div',{staticClass:"buttons has-addons"},_vm._l((['Any','2+','3+','4+']),function(bath,index){return _c('span',{key:index,staticClass:"button",class:{ 'is-active': _vm.filter.bathArray.includes(bath) },on:{"click":function($event){return _vm.filterByBath(bath)}}},[_vm._v("\n                  "+_vm._s(bath.toUpperCase())+"\n              ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"column is-narrow"},[_c('label',{staticClass:"label"},[_vm._v("\n              Garages\n            ")]),_vm._v(" "),_c('div',{staticClass:"buttons has-addons"},_vm._l((['Any', 2, 3]),function(car,index){return _c('span',{key:index,staticClass:"button",class:{ 'is-active': _vm.filter.carArray.includes(car) },on:{"click":function($event){return _vm.filterByCar(car)}}},[_vm._v(_vm._s(car))])}),0)]):_vm._e(),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"column is-narrow"},[_c('label',{staticClass:"label"},[_vm._v("\n              Stories\n            ")]),_vm._v(" "),_c('div',{staticClass:"buttons has-addons"},_vm._l(([1, 2]),function(storey,index){return _c('span',{key:index,staticClass:"button",class:{ 'is-active': _vm.filter.storeyArray.includes(storey) },on:{"click":function($event){return _vm.filterByStorey(storey)}}},[_vm._v(_vm._s(storey))])}),0)]):_vm._e(),_vm._v(" "),(_vm.filter && _vm.builders.length > 1)?_c('div',{staticClass:"column is-narrow builder-width"},[_c('label',{staticClass:"label"},[_vm._v("\n              BUILDERS\n            ")]),_vm._v(" "),_c('div',{staticClass:"builders-section"},[_c('div',{staticClass:"buttons has-addons"},_vm._l((_vm.builders),function(builder,index){return _c('a',{key:index,staticClass:"button",class:{'is-active': _vm.filter.buildersArray.includes(builder)},on:{"click":function($event){return _vm.filterByBuilders(builder)}}},[_vm._v("\n                  "+_vm._s(builder)+"\n                ")])}),0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[(_vm.filter)?_c('div',{staticClass:"sortby-section"},[_c('label',{staticClass:"label"},[_vm._v("\n                SORT BY\n              ")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"buttons has-addons"},[_c('span',{staticClass:"button",class:{ 'is-active': _vm.filter.sortBy === 'price-low'},on:{"click":function($event){return _vm.sort('price-low')}}},[_vm._v("\n                      Low to High\n                  ")]),_vm._v(" "),_c('span',{staticClass:"button",class:{ 'is-active': _vm.filter.sortBy === 'price-high'},on:{"click":function($event){return _vm.sort('price-high')}}},[_vm._v("\n                      High to Low\n                  ")])])])]):_vm._e()]),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"column is-narrow"},[_c('label',{staticClass:"label"},[_vm._v("\n               \n            ")]),_vm._v(" "),_c('span',{staticClass:"button is-small app-highlight",on:{"click":function($event){return _vm.resetFilters()}}},[_vm._v("RESTART")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeHome)?_c('app-home-detail',{attrs:{"activeHomeDetail":_vm.activeHome},on:{"close-detail":function($event){_vm.activeHome = null}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"homes-list",class:{'is-hidden': _vm.activeHome}},[_c('div',{staticClass:"container"},[(_vm.homeSummaryList.length)?_c('app-home-filter',{attrs:{"homeSummaryList":_vm.homeSummaryList},on:{"filteredHomes":function($event){_vm.filteredHomeList=$event}}}):_vm._e(),_vm._v(" "),(_vm.filteredHomeList)?_c('div',{staticClass:"columns is-multiline is-variable is-6 boxes",attrs:{"id":"masonry-boxes"}},_vm._l((_vm.filteredHomeList),function(homeSummary){return _c('div',{staticClass:"column is-3-widescreen is-4-desktop is-6-tablet is-12-mobile"},[_c('app-home-card',{attrs:{"homeSummary":JSON.parse(JSON.stringify(homeSummary))},on:{"homeSelected":function($event){_vm.activeHome = $event}}})],1)}),0):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeList_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6568f0cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeList_vue__ = __webpack_require__(267);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6568f0cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeHome)?_c('app-home-detail',{attrs:{"activeHomeDetail":_vm.activeHome},on:{"close-detail":function($event){_vm.activeHome = null}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"homes-list",class:{ 'is-hidden': _vm.activeHome }},[_c('div',{staticClass:"container"},[(_vm.homeSummaryList.length)?_c('app-home-filter',{attrs:{"homeSummaryList":_vm.homeSummaryList},on:{"filteredHomes":function($event){_vm.filteredHomeList = $event}}}):_vm._e(),_vm._v(" "),(_vm.filteredHomeList)?_c('div',{staticClass:"columns is-multiline is-variable is-6"},_vm._l((_vm.filteredHomeList),function(homeSummary){return _c('div',{staticClass:"column is-3-widescreen is-4-desktop is-6-tablet is-12-mobile"},[_c('app-home-card',{attrs:{"homeSummary":JSON.parse(JSON.stringify(homeSummary))},on:{"homeSelected":function($event){_vm.activeHome = $event}}})],1)}),0):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-loading',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('app-navigation',{attrs:{"activeHome":_vm.activeHome}}),_vm._v(" "),(_vm.selector && _vm.selector === 'lot')?_c('div',{staticClass:"compatible-homes-list"},[_c('div',[_c('app-compatible-home-list',{on:{"homesLoaded":function($event){_vm.loading = false},"setActiveHome":function($event){_vm.activeHome = $event}}})],1)]):_vm._e(),_vm._v(" "),(_vm.selector && _vm.selector === 'home')?_c('div',{staticClass:"home-list"},[_c('div',[_c('app-home-list',{on:{"homesLoaded":function($event){_vm.loading = false}}})],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facade_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fba969_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facade_vue__ = __webpack_require__(270);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fba969_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-navigation',{attrs:{"activeFacade":_vm.activeFacade,"nextTrigger":_vm.next}}),_vm._v(" "),(_vm.activeHome)?_c('div',{staticClass:"header-bar"},[_c('div',{staticClass:"back-box"},[_c('a',{staticClass:"button app-accent",on:{"click":_vm.goBack}},[_vm._v("BACK TO LIST")]),_vm._v(" "),_c('a',{staticClass:"button app-primary pulse",on:{"click":function($event){return _vm.goNext()}}},[_vm._v("CONFIRM SELECTION")])])]):_vm._e(),_vm._v(" "),(_vm.activeHome)?_c('div',{staticClass:"facade-list-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"facade-list"},_vm._l((_vm.activeHome.facadelist),function(facade){return _c('div',{on:{"click":function($event){return _vm.selectFacade(facade)}}},[_c('img',{class:{
              'is-active': facade.cpidstring === _vm.activeFacade.cpidstring
            },attrs:{"src":facade.imageurl}})])}),0),_vm._v(" "),_c('div',[_c('div',{staticClass:"info"},[_c('div',{staticClass:"left-item"},[_c('p',[_vm._v(_vm._s(_vm.activeHome.designproductname))]),_vm._v(" "),_c('div',{staticClass:"amenities"},[_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(2),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.activeHome.noofbedrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(3),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.activeHome.noofbathrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(4),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.activeHome.noofcarparks))])])])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('p',[_vm._v("$"+_vm._s(_vm.activeHome.productprice.toLocaleString()))])])]),_vm._v(" "),_c('div',{staticClass:"active-facade"},[_c('img',{attrs:{"src":_vm.activeFacade.imageurl,"alt":""}})])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Package_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_745197b5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Package_vue__ = __webpack_require__(275);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Package_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_745197b5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Package_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"leaflet-map"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Enquiry_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_940e7fe4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Enquiry_vue__ = __webpack_require__(274);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Enquiry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_940e7fe4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Enquiry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"enquire-modal modal",class:{'is-active': _vm.showThankyou}},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.showThankyou=false}}}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"box has-text-centered"},[_c('h4',[_vm._v("Thank you!")]),_vm._v(" "),_c('p',{staticClass:"pb-2"},[_vm._v("We will be in touch with you shortly.")]),_vm._v(" "),_c('p',{staticClass:"control my-2"},[_c('a',{staticClass:"button app-primary",on:{"click":function($event){_vm.showThankyou = false}}},[_vm._v("Ok")])])])])]),_vm._v(" "),_c('div',{staticClass:"enquire-modal modal",class:{'is-active': _vm.showEnquiry}},[_c('div',{staticClass:"modal-background",on:{"click":function($event){return _vm.closeEnquiry()}}}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"box"},[_c('h4',[_vm._v("Can't Find What You're Looking For? Let Us Help You!")]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[_vm._v("First Name*")]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.firstname),expression:"enquiry.firstname"}],staticClass:"input",attrs:{"type":"text","placeholder":"First Name","change":_vm.checkValidation(),"required":""},domProps:{"value":(_vm.enquiry.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.enquiry, "firstname", $event.target.value)}}})]),_vm._v(" "),(!_vm.validName(_vm.enquiry.firstname) && _vm.submitClicked)?_c('p',{staticClass:"pt-2 has-text-danger"},[_vm._v("*Please enter a valid First Name")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[_vm._v("Last Name*")]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.lastname),expression:"enquiry.lastname"}],staticClass:"input",attrs:{"type":"text","placeholder":"Last Name","change":_vm.checkValidation(),"required":""},domProps:{"value":(_vm.enquiry.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.enquiry, "lastname", $event.target.value)}}})]),_vm._v(" "),(!_vm.validName(_vm.enquiry.lastname) && _vm.submitClicked)?_c('p',{staticClass:"pt-2 has-text-danger"},[_vm._v("*Please enter a valid Last Name")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[_vm._v("Email*")]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.email),expression:"enquiry.email"}],staticClass:"input",attrs:{"type":"email","placeholder":"Email","change":_vm.checkValidation(),"required":""},domProps:{"value":(_vm.enquiry.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.enquiry, "email", $event.target.value)}}})]),_vm._v(" "),(!_vm.validEmail(_vm.enquiry.email) && _vm.submitClicked)?_c('p',{staticClass:"pt-2 has-text-danger"},[_vm._v("*Please enter a valid Email")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[_vm._v("Phone")]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.phone),expression:"enquiry.phone"}],staticClass:"input",attrs:{"type":"email","placeholder":"Phone"},domProps:{"value":(_vm.enquiry.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.enquiry, "phone", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[_vm._v("Price Range")]),_vm._v(" "),_c('div',{staticClass:"control radio-group"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.pricerange),expression:"enquiry.pricerange"}],attrs:{"type":"radio","name":"price","value":"$300,000 - $400,000"},domProps:{"checked":_vm._q(_vm.enquiry.pricerange,"$300,000 - $400,000")},on:{"change":function($event){return _vm.$set(_vm.enquiry, "pricerange", "$300,000 - $400,000")}}}),_vm._v("\n                  $300,000 - $400,000\n                ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.pricerange),expression:"enquiry.pricerange"}],attrs:{"type":"radio","name":"price","value":"$400,000 - $500,000"},domProps:{"checked":_vm._q(_vm.enquiry.pricerange,"$400,000 - $500,000")},on:{"change":function($event){return _vm.$set(_vm.enquiry, "pricerange", "$400,000 - $500,000")}}}),_vm._v("\n                  $400,000 - $500,000\n                ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.pricerange),expression:"enquiry.pricerange"}],attrs:{"type":"radio","name":"price","value":"$500,000 - $600,000"},domProps:{"checked":_vm._q(_vm.enquiry.pricerange,"$500,000 - $600,000")},on:{"change":function($event){return _vm.$set(_vm.enquiry, "pricerange", "$500,000 - $600,000")}}}),_vm._v("\n                  $500,000 - $600,000\n                ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.pricerange),expression:"enquiry.pricerange"}],attrs:{"type":"radio","name":"price","value":"$600,000 - $700,000"},domProps:{"checked":_vm._q(_vm.enquiry.pricerange,"$600,000 - $700,000")},on:{"change":function($event){return _vm.$set(_vm.enquiry, "pricerange", "$600,000 - $700,000")}}}),_vm._v("\n                  $600,000 - $700,000\n                ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.pricerange),expression:"enquiry.pricerange"}],attrs:{"type":"radio","name":"price","value":"$700,000 - $800,000"},domProps:{"checked":_vm._q(_vm.enquiry.pricerange,"$700,000 - $800,000")},on:{"change":function($event){return _vm.$set(_vm.enquiry, "pricerange", "$700,000 - $800,000")}}}),_vm._v("\n                  $700,000 - $800,000\n                ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.pricerange),expression:"enquiry.pricerange"}],attrs:{"type":"radio","name":"price","value":"$800,000+"},domProps:{"checked":_vm._q(_vm.enquiry.pricerange,"$800,000+")},on:{"change":function($event){return _vm.$set(_vm.enquiry, "pricerange", "$800,000+")}}}),_vm._v("\n                  $800,000+\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[_vm._v("Square Footage")]),_vm._v(" "),_c('p',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.squarefootage),expression:"enquiry.squarefootage"}],attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.enquiry, "squarefootage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Square Footage")]),_vm._v(" "),_c('option',{attrs:{"value":"1,500-1,999 square feet"}},[_vm._v("1,500-1,999 square feet")]),_vm._v(" "),_c('option',{attrs:{"value":"2,000-2,499 square feet"}},[_vm._v("2,000-2,499 square feet")]),_vm._v(" "),_c('option',{attrs:{"value":"2,500-2,999 square feet"}},[_vm._v("2,500-2,999 square feet")]),_vm._v(" "),_c('option',{attrs:{"value":"3,000-3,499 square feet"}},[_vm._v("3,000-3,499 square feet")]),_vm._v(" "),_c('option',{attrs:{"value":"3,500-3,999 square feet"}},[_vm._v("3,500-3,999 square feet")]),_vm._v(" "),_c('option',{attrs:{"value":"4,000+ square feet"}},[_vm._v("4,000+ square feet")])])])])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[_vm._v("Time Frame to Move")]),_vm._v(" "),_c('p',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.timeframe),expression:"enquiry.timeframe"}],attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.enquiry, "timeframe", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Time Frame to Move")]),_vm._v(" "),_c('option',{attrs:{"value":"In the next month"}},[_vm._v("In the next month")]),_vm._v(" "),_c('option',{attrs:{"value":"2-3 months"}},[_vm._v("2-3 months")]),_vm._v(" "),_c('option',{attrs:{"value":"6 months"}},[_vm._v("6 months")]),_vm._v(" "),_c('option',{attrs:{"value":"Sometime this year"}},[_vm._v("Sometime this year")]),_vm._v(" "),_c('option',{attrs:{"value":"1 year"}},[_vm._v("1 year")]),_vm._v(" "),_c('option',{attrs:{"value":"No rush"}},[_vm._v("No rush")]),_vm._v(" "),_c('option',{attrs:{"value":"Other"}},[_vm._v("Other")])])])])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[_vm._v("Bedrooms")]),_vm._v(" "),_c('p',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.bedrooms),expression:"enquiry.bedrooms"}],attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.enquiry, "bedrooms", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Bedrooms")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4+"}},[_vm._v("4+")])])])])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"label"},[_vm._v("Bathrooms")]),_vm._v(" "),_c('p',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.enquiry.bathrooms),expression:"enquiry.bathrooms"}],attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.enquiry, "bathrooms", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Bathrooms")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4+"}},[_vm._v("4+")])])])])])]),_vm._v(" "),_c('a',{staticClass:"button app-primary",on:{"click":_vm.closeEnquiry}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"button app-highlight",class:{'is-loading': _vm.isLoading},attrs:{"disabled":!_vm.formValid},on:{"click":_vm.submitEnquiry}},[_vm._v("Submit")])])]),_vm._v(" "),_c('button',{staticClass:"modal-close is-large",attrs:{"aria-label":"close"},on:{"click":function($event){return _vm.closeEnquiry()}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-loading',{attrs:{"loading":_vm.loading}}),_vm._v(" "),(_vm.packageDetail)?_c('app-enquire',{attrs:{"showEnquiry":_vm.showEnquire,"product":_vm.packageDetail},on:{"closeEnquiry":function($event){_vm.showEnquire = false}}}):_vm._e(),_vm._v(" "),(_vm.packageDetail)?_c('div',{staticClass:"package-detail-grid",attrs:{"id":"package-detail"}},[_c('div',{staticClass:"header-bar"},[_c('div',{staticClass:"container header-container"},[(_vm.packageDetail.spechome)?_c('a',{staticClass:"button app-secondary",on:{"click":_vm.goBack}},[_vm._v("\n          Go Back\n        ")]):_vm._e(),_vm._v(" "),(_vm.favoriteHnl.includes(_vm.packageDetail.cpidstring))?_c('a',{staticClass:"button app-primary"},[_c('i',{staticClass:"fas fa-heart"}),_vm._v("\n          THIS IS SAVED IN YOUR FAVORITES\n        ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"button app-accent",on:{"click":function($event){return _vm.toggleShare()}}},[_c('i',{staticClass:"fas fa-link"}),_vm._v(" "),_c('div',{staticClass:"share-box",class:{ 'is-visible': _vm.showShare }},[_c('i',{staticClass:"fas fa-link",on:{"click":function($event){return _vm.copyLink()}}}),_vm._v(" "),_c('i',{staticClass:"fas fa-envelope",on:{"click":function($event){return _vm.shareEmail()}}}),_vm._v(" "),_c('input',{attrs:{"id":"paste-box","type":"text","value":""}})]),_vm._v(" "),_c('div',{staticClass:"px-3",attrs:{"id":"linkcp"}},[_vm._v("Link Copied!")]),_vm._v("\n          SHARE\n        ")]),_vm._v(" "),(_vm.loaded)?_c('a',{staticClass:"button app-accent",attrs:{"href":_vm.packageDetail.builderpdfurl,"target":"_blank"},on:{"click":function($event){return _vm.packagePdfPrintEvent()}}},[_c('i',{staticClass:"fas fa-file-pdf"}),_vm._v("\n          Print\n        ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"button app-enquiry",on:{"click":function($event){_vm.showEnquire = true}}},[_c('i',{staticClass:"fas fa-envelope"}),_vm._v("\n          Let us help you!\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline is-variable is-6 boxes"},[_c('div',{staticClass:"column is-6-desktop is-12-tablet is-12-mobile grid-box"},[(_vm.packageDetail.estimatedcompletiondate)?_c('div',{staticClass:"facade-header"},[_c('p',{staticClass:"available-date"},[_vm._v("\n              Available\n              "+_vm._s(new Date(_vm.packageDetail.estimatedcompletiondate).toDateString())+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"facade-box box"},[_c('img',{attrs:{"src":_vm.packageDetail.imagepath,"alt":"Placeholder image"}}),_vm._v(" "),_c('div',{staticClass:"columns package-detail is-gapless"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"product"},[_vm._v("\n                  "+_vm._s(_vm.packageDetail.designproductname)+"\n                  "+_vm._s(_vm.packageDetail.facadeproductname)+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"builder-name"},[_vm._v("\n                  "+_vm._s(_vm.packageDetail.buildername)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"column is-narrow has-text-right"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"amenities ml-0"},[_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(2),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.packageDetail.noofbedrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(3),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.packageDetail.noofbathrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(4),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.packageDetail.noofcarparks))])])]),_vm._v(" "),_c('p',{staticClass:"price"},[_c('span',{staticClass:"from"},[_vm._v("From")]),_vm._v("\n                  $"+_vm._s(_vm.packageDetail.planPrice < _vm.packageDetail.productprice
                      ? _vm.packageDetail.planPrice.toLocaleString()
                      : _vm.packageDetail.productprice.toLocaleString())+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"lot-fit-dimensions"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('p',{staticClass:"dim-title"},[_vm._v("Square Footage")]),_vm._v(" "),_c('p',{staticClass:"dim"},[_vm._v("\n                      "+_vm._s(_vm.packageDetail.homesize.toLocaleString())+"\n                      "),_c('small',[_vm._v("sqft")])])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('p',{staticClass:"dim-title"},[_vm._v("Home Width")]),_vm._v(" "),_c('p',{staticClass:"dim"},[_vm._v("\n                      "+_vm._s(_vm.packageDetail.homeWidthFormatted.replace("'", ""))+"\n                      "),_c('small',[_vm._v("ft")])])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('p',{staticClass:"dim-title"},[_vm._v("Lot Area")]),_vm._v(" "),_c('p',{staticClass:"dim"},[_vm._v("\n                      "+_vm._s(_vm.packageDetail.lotsize.toLocaleString())+"\n                      "),_c('small',[_vm._v("sqft")])])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('p',{staticClass:"dim-title"},[_vm._v("Lot Width")]),_vm._v(" "),_c('p',{staticClass:"dim"},[_vm._v("\n                      "+_vm._s(_vm.packageDetail.lotWidthFormatted.replace("'", ""))+"\n                      "),_c('small',[_vm._v("ft")])])])])])])]),_vm._v(" "),(_vm.packageDetail)?_c('div',{staticClass:"box location-box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('p',{staticClass:"address"},[_vm._v("\n                "+_vm._s(_vm.packageDetail.productaddress)+"\n              ")]),_vm._v(" "),_c('app-location-map',{attrs:{"lotId":_vm.packageDetail.lotproductcpid}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column is-6-desktop is-12-tablet is-12-mobile grid-box"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"floorplan-section"},[_c('a',{attrs:{"href":_vm.packageDetail.floorplanimageurl,"data-lightbox":"floorplan","data-title":"Floorplan"}},[_c('img',{attrs:{"src":_vm.packageDetail.floorplanimageurl}})])])]),_vm._v(" "),(
              _vm.packageDetail.siteplansvgurl &&
                _vm.packageDetail.buildername !== 'Highland Homes'
            )?_c('div',{staticClass:"box"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"box-body floorplan-section"},[_c('a',{attrs:{"href":_vm.packageDetail.siteplansvgurl,"data-lightbox":"floorplan","data-title":"Siting"}},[_c('img',{attrs:{"src":_vm.packageDetail.siteplansvgurl}})])])]):_vm._e(),_vm._v(" "),(_vm.galleries.length > 0)?_c('div',{staticClass:"box gallery-section"},[_c('p',{staticClass:"s-title"},[_vm._v("\n              Gallery\n            ")]),_vm._v(" "),_c('div',{staticClass:"columns is-mobile is-multiline is-variable is-2"},_vm._l((_vm.galleries),function(gallery){return _c('div',{staticClass:"column is-6"},[_c('a',{attrs:{"href":gallery.url,"data-lightbox":"interior","data-title":"Interior"}},[_c('img',{attrs:{"src":gallery.url,"alt":""}})])])}),0)]):_vm._e()])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('p',{staticClass:"s-title"},[_vm._v("\n                Details\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('p',{staticClass:"s-title"},[_vm._v("\n                Location\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('p',{staticClass:"s-title"},[_vm._v("\n                Lot Fit\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Selection_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d70c21_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selection_vue__ = __webpack_require__(277);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Selection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d70c21_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"selector is-hidden-x"},[_c('router-link',{attrs:{"to":"/community/lot"}},[_c('div',{staticClass:"selector-container"},[_c('div',{staticClass:"journey-selector-tile"},[_c('div',{staticClass:"journey-selector-inner"},[_c('p',{staticClass:"selector-title"},[_vm._v("\n                EXPLORE\n              ")]),_vm._v(" "),_c('p',{staticClass:"selector-title"},[_vm._v("\n                HOMESITES MAP\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"selector-tooltip"},[_c('p',[_vm._v("\n              Start your journey with the perfect lot and then find the perfect home and options to match it.\n            ")])])])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/community/homes"}},[_c('div',{staticClass:"selector-container"},[_c('div',{staticClass:"journey-selector-tile"},[_c('div',{staticClass:"journey-selector-inner"},[_c('p',{staticClass:"selector-title"},[_vm._v("\n                DISCOVER\n              ")]),_vm._v(" "),_c('p',{staticClass:"selector-title"},[_vm._v("\n                HOME DESIGNS\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"selector-tooltip"},[_c('p',[_vm._v("\n              Start your journey with the perfect home and then find the perfect lot and options to match it.\n            ")])])])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/community/move-in"}},[_c('div',{staticClass:"selector-container"},[_c('div',{staticClass:"journey-selector-tile"},[_c('div',{staticClass:"journey-selector-inner"},[_c('p',{staticClass:"selector-title"},[_vm._v("\n                MOVE-IN\n              ")]),_vm._v(" "),_c('p',{staticClass:"selector-title"},[_vm._v("\n                READY HOMES\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"selector-tooltip"},[_c('p',[_vm._v("\n              Browse move-in homes that are already under construction or completed.\n            ")])])])])],1),_vm._v(" "),_c('div',{staticClass:"selector is-hidden-t"},[_c('router-link',{attrs:{"to":"/community/lot"}},[_c('div',{staticClass:"selector-container"},[_c('div',{staticClass:"journey-selector-tile"},[_c('div',{staticClass:"journey-selector-inner"},[_c('p',{staticClass:"selector-title"},[_vm._v("\n                EXPLORE\n              ")]),_vm._v(" "),_c('p',{staticClass:"selector-title"},[_vm._v("\n                HOMESITES MAP\n              ")])])])])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/community/homes"}},[_c('div',{staticClass:"selector-container"},[_c('div',{staticClass:"journey-selector-tile"},[_c('div',{staticClass:"journey-selector-inner"},[_c('p',{staticClass:"selector-title"},[_vm._v("\n                DISCOVER\n              ")]),_vm._v(" "),_c('p',{staticClass:"selector-title"},[_vm._v("\n                HOME DESIGNS\n              ")])])])])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/community/move-in"}},[_c('div',{staticClass:"selector-container"},[_c('div',{staticClass:"journey-selector-tile"},[_c('div',{staticClass:"journey-selector-inner"},[_c('p',{staticClass:"selector-title"},[_vm._v("\n                MOVE-IN\n              ")]),_vm._v(" "),_c('p',{staticClass:"selector-title"},[_vm._v("\n                READY HOMES\n              ")])])])])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-section"},[_c('h3',[_vm._v("Build Your New Home!")]),_vm._v(" "),_c('p',[_vm._v("Our easy selection tools guide you through the process of finding the perfect homesite, floorplan, and exterior.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spec_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1e01b90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spec_vue__ = __webpack_require__(285);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spec_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1e01b90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spec_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"package-card card",on:{"click":function($event){return _vm.goToNext(_vm.hnlSummary.cpidstring)}}},[_c('div',{staticClass:"facade-image"},[(_vm.hnlSummary.imagepath)?_c('figure',{staticClass:"image is-3by2"},[_c('img',{attrs:{"src":_vm.hnlSummary.imagepath,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"marker-overlay right"},[(!_vm.isFavorite)?_c('a',{on:{"click":function($event){return _vm.addToFavorites(_vm.hnlSummary)}}},[_c('i',{staticClass:"far fa-heart"})]):_vm._e(),_vm._v(" "),(_vm.isFavorite)?_c('a',{on:{"click":function($event){return _vm.removeFromFavorites(_vm.hnlSummary.cpidstring)}}},[_c('i',{staticClass:"fas fa-heart"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('div',{staticClass:"columns is-mobile is-gapless"},[_c('div',{staticClass:"column design"},[_c('p',{staticClass:"design"},[_vm._v(_vm._s(_vm.hnlSummary.designproductname))]),_vm._v(" "),_c('p',{staticClass:"d"},[_vm._v(_vm._s(_vm.hnlSummary.buildername))])]),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_c('div',{staticClass:"amenities"},[_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(2),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hnlSummary.noofbedrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(3),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hnlSummary.noofbathrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(4),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hnlSummary.noofcarparks))])])]),_vm._v(" "),_c('div',{staticClass:"price"},[(_vm.hnlSummary.planPrice || _vm.hnlSummary.productprice)?_c('p',{staticClass:"p"},[_vm._v("\n              $"+_vm._s(_vm.hnlSummary.planPrice < _vm.hnlSummary.productprice
                  ? _vm.hnlSummary.planPrice.toLocaleString()
                  : _vm.hnlSummary.productprice.toLocaleString())+"\n            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"columns is-mobile is-gapless"},[_c('div',{staticClass:"column dimensions"},[_c('div',{staticClass:"dimension"},[_c('p',{staticClass:"t"},[_vm._v("Home Area")]),_vm._v(" "),_c('p',{staticClass:"d"},[_vm._v("\n              "+_vm._s(_vm.hnlSummary.homesize.toLocaleString())),_c('small',[_vm._v(" sqft")])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-narrow"},[_c('a',{staticClass:"button app-accent"},[_vm._v("\n            View Home\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"filter-section"},[(_vm.filterToggle === false)?_c('a',{staticClass:"filter-collapse",on:{"click":function($event){_vm.filterToggle = true}}},[_c('i',{staticClass:"fas fa-search"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filters",class:{'is-active': _vm.filterToggle}},[_c('button',{staticClass:"delete is-hidden-t",on:{"click":function($event){_vm.filterToggle = false}}}),_vm._v(" "),_c('div',{staticClass:"filter-content"},[_c('div',{staticClass:"columns is-multiline is-mobile is-variable is-5"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"slider"},[_c('label',{staticClass:"label"},[_vm._v("\n                Square Feet\n              ")]),_vm._v(" "),_c('input',{ref:"home-area",staticClass:"range-slider",attrs:{"type":"text","id":"area","name":"area_range","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"slider"},[_c('label',{staticClass:"label"},[_vm._v("\n                Price\n              ")]),_vm._v(" "),_c('input',{ref:"home-price",staticClass:"range-slider home-area",attrs:{"type":"text","id":"price","name":"price_range","value":""}})])]),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"column is-narrow"},[_c('label',{staticClass:"label"},[_vm._v("\n              Bedrooms\n            ")]),_vm._v(" "),_c('div',{staticClass:"buttons has-addons"},_vm._l((['Any','2+','3+','4+','5+']),function(bed){return _c('span',{staticClass:"button",class:{ 'is-active': _vm.filter.bedArray.includes(bed) },on:{"click":function($event){return _vm.filterByBed(bed)}}},[_vm._v("\n                  "+_vm._s(bed.toUpperCase())+"\n              ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"column is-narrow"},[_c('label',{staticClass:"label"},[_vm._v("\n              Bathrooms\n            ")]),_vm._v(" "),_c('div',{staticClass:"buttons has-addons"},_vm._l((['Any','2+','3+','4+']),function(bath){return _c('span',{staticClass:"button",class:{ 'is-active': _vm.filter.bathArray.includes(bath) },on:{"click":function($event){return _vm.filterByBath(bath)}}},[_vm._v("\n                  "+_vm._s(bath.toUpperCase())+"\n              ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"column is-narrow"},[_c('label',{staticClass:"label"},[_vm._v("\n              Garages\n            ")]),_vm._v(" "),_c('div',{staticClass:"buttons has-addons"},_vm._l((['Any', 2, 3]),function(car){return _c('span',{staticClass:"button",class:{ 'is-active': _vm.filter.carArray.includes(car) },on:{"click":function($event){return _vm.filterByCar(car)}}},[_vm._v(_vm._s(car))])}),0)]):_vm._e(),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"column is-narrow"},[_c('label',{staticClass:"label"},[_vm._v("\n              Stories\n            ")]),_vm._v(" "),_c('div',{staticClass:"buttons has-addons"},_vm._l(([1, 2]),function(storey){return _c('span',{staticClass:"button",class:{ 'is-active': _vm.filter.storeyArray.includes(storey) },on:{"click":function($event){return _vm.filterByStorey(storey)}}},[_vm._v(_vm._s(storey))])}),0)]):_vm._e(),_vm._v(" "),(_vm.filter && _vm.builders.length > 1)?_c('div',{staticClass:"column is-narrow builder-width"},[_c('label',{staticClass:"label"},[_vm._v("\n              BUILDERS\n            ")]),_vm._v(" "),_c('div',{staticClass:"builders-section"},[_c('div',{staticClass:"buttons has-addons"},_vm._l((_vm.builders),function(builder){return _c('a',{staticClass:"button",class:{'is-active': _vm.filter.buildersArray.includes(builder)},on:{"click":function($event){return _vm.filterByBuilders(builder)}}},[_vm._v("\n                  "+_vm._s(builder)+"\n                ")])}),0)])]):_vm._e(),_vm._v(" "),(_vm.tileView)?_c('div',{staticClass:"column is-narrow"},[(_vm.filter)?_c('div',{staticClass:"sortby-section"},[_c('label',{staticClass:"label"},[_vm._v("\n                SORT BY\n              ")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"buttons has-addons"},[_c('span',{staticClass:"button",class:{ 'is-active': _vm.filter.sortBy === 'price-low'},on:{"click":function($event){return _vm.sort('price-low')}}},[_vm._v("\n                      Low to High\n                  ")]),_vm._v(" "),_c('span',{staticClass:"button",class:{ 'is-active': _vm.filter.sortBy === 'price-high'},on:{"click":function($event){return _vm.sort('price-high')}}},[_vm._v("\n                      High to Low\n                  ")])])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_c('div',{staticClass:"sortby-section"},[_c('label',{staticClass:"label"},[_vm._v("\n                VIEW\n              ")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"buttons has-addons"},[_c('span',{staticClass:"button",class:{ 'is-active': !_vm.tileView},on:{"click":function($event){return _vm.filterTileView(false)}}},[_vm._v("\n                  Map\n                  ")]),_vm._v(" "),_c('span',{staticClass:"button",class:{ 'is-active': _vm.tileView},on:{"click":function($event){return _vm.filterTileView(true)}}},[_vm._v("\n                      Tile\n                  ")])])])])]),_vm._v(" "),(_vm.filter)?_c('div',{staticClass:"column is-narrow"},[_c('label',{staticClass:"label"},[_vm._v("\n               \n            ")]),_vm._v(" "),_c('span',{staticClass:"button is-small app-highlight",on:{"click":function($event){return _vm.resetFilters()}}},[_vm._v("RESTART")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecMap_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cba6541_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecMap_vue__ = __webpack_require__(284);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cba6541_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_map_Home__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_map_Config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_map_Popup__ = __webpack_require__(21);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map',
  data: function data() {
    return {
      activeLot: null,
      apartmentGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      baseLayers: [],
      container: 'spec-map',
      creatingMarkers: false,
      detailLayers: [],
      filteredlotGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      layers: [],
      lotBounds: null,
      lotgeo: __webpack_require__(8),
      homegeo: __webpack_require__(283),
      lotGeoJson: null,
      lotmarkers: [],
      lotPanelMarker: null,
      masterBound: null,
      packageSummaryList: null,
      sources: [],
      showMarkers: false,
      showDetail: false,
      specHnlList: null,
      stageGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      svgConfig: null,
      viewBasedFilterLot: {
        type: 'FeatureCollection',
        features: []
      }
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_map_Home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_map_Config__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_map_Popup__["a" /* default */]],
  methods: {
    initMap: function initMap(config, specHnl) {
      mapboxgl.accessToken = 'pk.eyJ1Ijoic2FpbGVzaGtjIiwiYSI6ImNrZGo1Y2l5dTBibGIzMXBmbzM5Z2Q3Z2MifQ.hq_fP_fYTmUm_LJNRl23Cw';
      if (config && specHnl) {
        this.specHnlList = specHnl;
        this.svgConfig = config;
        this.initConfig();
      }
    },

    addLotShapes: function addLotShapes() {
      var _this = this;

      var bounds = new mapboxgl.LngLatBounds();

      this.specHnlList.forEach(function (hnl) {
        var lotfeature = _this.lotGeoJson.features.find(function (feature) {
          return feature.properties.lotCpId === hnl.lotproductcpid;
        });
        if (lotfeature) {
          lotfeature.properties.hnlproperties = hnl;
          lotfeature.id = hnl.lotproductcpid;
          lotfeature.properties.hoverable = 'allow';
          lotfeature.properties.isActive = true;
          lotfeature.properties.interact = true;
          lotfeature.geometry.coordinates[0].forEach(function (cord) {
            bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
          });
          _this.filteredlotGeoJson.features.push(lotfeature);
        }
      });

      this.map.addSource('lots', {
        type: 'geojson',
        data: this.filteredlotGeoJson
      });

      this.addLotFills();

      this.placeDetailLayer();
      if (bounds && this.filteredlotGeoJson.features.length > 0) {
        this.lotBounds = bounds;
        this.map.fitBounds(bounds, {
          padding: 60,
          pitch: 60
        });
      } else {
        this.map.fitBounds(this.masterBound);
      }

      if (this.specHnlList && this.homegeo) {
        this.addHomesShapes(this.homegeo.geoJson, this.specHnlList);
      }
    },

    addLotFills: function addLotFills() {
      var _this2 = this;

      this.map.addLayer({
        id: 'lot-fills',
        type: 'fill',
        source: 'lots',
        layout: {},
        paint: {
          'fill-color': ['case', ['boolean', ['get', 'isActive'], false], '#688e9f', '#fff7ed'],
          'fill-outline-color': '#333333',
          'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.4, 0.9]
        }
      });

      this.map.on('mousemove', 'lot-fills', function (e) {
        if (e.features.length > 0) {
          if (e.features[0].properties.interact) {
            _this2.map.getCanvas().style.cursor = 'pointer';
            if (_this2.hoveredLotId) {
              _this2.map.setFeatureState({ source: 'lots', id: _this2.hoveredLotId }, { hover: false });
            }
            _this2.hoveredLotId = e.features[0].id;
            _this2.map.setFeatureState({ source: 'lots', id: _this2.hoveredLotId }, { hover: true });
          }
        }
      });

      this.map.on('mouseleave', 'lot-fills', function () {
        _this2.map.getCanvas().style.cursor = '';
        if (_this2.hoveredLotId) {
          _this2.map.setFeatureState({ source: 'lots', id: _this2.hoveredLotId }, { hover: false });
        }
        _this2.hoveredLotId = null;
      });

      this.map.on('click', 'lot-fills', function (e) {
        if (e.features.length > 0) {
          if (e.features[0].properties.interact) {
            var hnl = JSON.parse(e.features[0].properties.hnlproperties);
            _this2.createPackageDetailMarker(hnl, e.features[0].geometry.coordinates[0]);
            _this2.$store.dispatch('productTracking', { page: 'hnl-package', product: hnl });
            _this2.lotmarkers.forEach(function (m) {
              m.remove();
            });
          }
        }
      });

      this.map.on('zoom', function () {
        if (_this2.map.getZoom() > 17) {
          if (!_this2.showMarkers) {
            _this2.showMarkers = true;
            if (!_this2.showDetail) {
              _this2.createLotMarkers(_this2.filteredHnlList);
            }
          }
        } else {
          _this2.showMarkers = false;
          _this2.lotmarkers.forEach(function (m) {
            m.remove();
          });
        }
      });
    },

    createLotMarkers: function createLotMarkers(specHnlList) {
      var _this3 = this;

      this.creatingMarkers = true;
      this.lotmarkers.forEach(function (m) {
        m.remove();
      });

      specHnlList.forEach(function (hnl) {
        var lotfeature = _this3.lotGeoJson.features.find(function (feature) {
          return feature.properties.lotCpId === hnl.lotproductcpid;
        });
        if (lotfeature) {
          var markerBound = new mapboxgl.LngLatBounds();
          lotfeature.geometry.coordinates[0].forEach(function (cord) {
            markerBound.extend(new mapboxgl.LngLat(cord[0], cord[1]));
          });

          var el = document.createElement('div');
          var img = document.createElement('img');
          el.className = 'facade-popup';
          img.src = hnl.imagepath;
          img.style.width = '100px';
          img.style.height = 'auto';
          el.appendChild(img);

          el.addEventListener('click', function () {
            _this3.createPackageDetailMarker(hnl, lotfeature.geometry.coordinates[0]);
          });

          var m = new mapboxgl.Marker({
            element: el,
            anchor: 'bottom',
            offset: [0, -40]
          });
          m.setLngLat(markerBound.getCenter());
          _this3.lotmarkers.push(m);
          m.addTo(_this3.map);
        }
      });

      this.creatingMarkers = false;
    },

    createPackageDetailMarker: function createPackageDetailMarker(hnlSummary, coord) {
      var _this4 = this;

      this.showDetail = true;
      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }
      this.lotmarkers.forEach(function (m) {
        m.remove();
      });
      var markerBound = new mapboxgl.LngLatBounds();
      coord.forEach(function (cord) {
        markerBound.extend(new mapboxgl.LngLat(cord[0], cord[1]));
      });

      var el = this.getPackageTile(hnlSummary);

      var aDetailEl = document.createElement('a');
      aDetailEl.classList.add('explore');
      aDetailEl.innerHTML = 'EXPLORE THIS HOME';

      el.lastElementChild.appendChild(aDetailEl);

      var aEl = document.createElement('a');
      aEl.classList.add('modal-close');
      aEl.addEventListener('click', function () {
        _this4.showDetail = false;
        _this4.reset();
      });

      el.appendChild(aEl);

      aDetailEl.addEventListener('click', function () {
        _this4.$router.push({
          path: '/community/package/' + hnlSummary.cpidstring
        });
        setTimeout(function () {
          if (_this4.lotPanelMarker) {
            _this4.lotPanelMarker.remove();
          }
        });
      });

      this.map.flyTo({
        center: markerBound.getCenter(),
        zoom: 18,
        essential: true
      });

      this.lotPanelMarker = new mapboxgl.Marker({
        element: el,
        anchor: 'bottom',
        offset: [0, -40]
      });
      this.lotPanelMarker.setLngLat(markerBound.getCenter());
      this.lotPanelMarker.addTo(this.map);
    },

    filterMapLots: function filterMapLots(specHnl) {
      var _this5 = this;

      if (!this.map || !this.map.getSource('lots')) return;
      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }

      this.viewBasedFilterLot.features = [];

      this.filteredlotGeoJson.features.forEach(function (feature) {
        feature.properties.isActive = false;
        var lot = specHnl.find(function (item) {
          return item.lotproductcpid === feature.properties.lotCpId;
        });
        if (lot) {
          feature.properties.interact = true;
          feature.properties.isActive = true;
          _this5.viewBasedFilterLot.features.push(feature);
        } else {
          feature.properties.color = '#333333';
          feature.properties.interact = false;
        }
      });

      this.map.getSource('lots').setData(this.filteredlotGeoJson);

      var bounds = new mapboxgl.LngLatBounds();
      this.viewBasedFilterLot.features.forEach(function (feature) {
        feature.geometry.coordinates[0].forEach(function (cord) {
          bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
        });
      });
      if (this.viewBasedFilterLot.features.length > 0) {
        this.map.fitBounds(bounds, {
          padding: 20,
          maxZoom: 20
        });
      } else {
        this.map.fitBounds(this.masterBound, {
          padding: 20
        });
      }
    },

    reset: function reset() {
      this.resetTileView();
    },

    resetTileView: function resetTileView() {
      if (this.lotPanelMarker) {
        this.lotPanelMarker.remove();
      }

      if (!this.showDetail && this.showMarkers && !this.creatingMarkers) {
        this.createLotMarkers(this.filteredHnlList);
      }
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = {"success":true,"messages":[],"geoJson":{"type":"FeatureCollection","features":[{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988958,33.2639283],[-96.8990147,33.2638903],[-96.8990881,33.2640507],[-96.8990498,33.2640629],[-96.8990485,33.2640601],[-96.8990288,33.2640665],[-96.8990288,33.2640665],[-96.8989679,33.2640859],[-96.8988958,33.2639283]]]},"properties":{"lotName":"1A-F-11","lotCpId":"8531251615535217414","facadeCpId":"5064715315643847573110125233353855451616043160608","planName":"Braysrays B","designName":"Brays","homeName":"Brays Brays B","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004623,33.2624309],[-96.9004042,33.26242],[-96.9004073,33.2624086],[-96.9004104,33.2624091],[-96.9004108,33.2624076],[-96.9003483,33.2623958],[-96.9003897,33.2622415],[-96.900462,33.262255],[-96.9004594,33.2622645],[-96.9005047,33.262273],[-96.9004623,33.2624309]]]},"properties":{"lotName":"1A-H-8","lotCpId":"5351451615535234784","facadeCpId":"1415058716171054458382072103258406221610006190334","planName":"Waverley Waverley","designName":"Waverley","homeName":"Waverley Waverley A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9003809,33.2632461],[-96.9003815,33.2632435],[-96.9003671,33.2632414],[-96.9003666,33.2632442],[-96.9003652,33.263244],[-96.9003686,33.2632276],[-96.9003652,33.263244],[-96.900359,33.2632431],[-96.9003592,33.2632421],[-96.9003079,33.2632347],[-96.9003077,33.2632357],[-96.9003002,33.2632346],[-96.9003123,33.2631761],[-96.9003119,33.263176],[-96.9003273,33.2631016],[-96.9003277,33.2631016],[-96.900339,33.263047],[-96.9004334,33.2630607],[-96.9004312,33.2630714],[-96.9004628,33.263076],[-96.9004618,33.2630811],[-96.9004636,33.2630814],[-96.9004577,33.2631102],[-96.9004558,33.2631099],[-96.9004481,33.2631473],[-96.9004484,33.2631473],[-96.9004463,33.2631572],[-96.900446,33.2631572],[-96.9004349,33.2632112],[-96.9004352,33.2632113],[-96.9004331,33.2632212],[-96.9004328,33.2632212],[-96.9004262,33.2632528],[-96.9004094,33.2632503],[-96.9004093,33.2632506],[-96.9003977,33.2632489],[-96.9003978,33.2632486],[-96.9003823,33.2632464],[-96.9003823,33.2632463],[-96.9003809,33.2632461]]]},"properties":{"lotName":"1A-I-2","lotCpId":"3234041615535213693","facadeCpId":"8804548344805145433517812877170501221616049694490","planName":"Davenport Davenport","designName":"Davenport","homeName":"Davenport Davenport A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9004233,33.2632525],[-96.9003646,33.2632441],[-96.900367,33.2632325],[-96.9003701,33.263233],[-96.9003704,33.2632314],[-96.9003073,33.2632223],[-96.9003395,33.2630664],[-96.9004125,33.2630769],[-96.9004105,33.2630865],[-96.9004562,33.2630931],[-96.9004233,33.2632525]]]},"properties":{"lotName":"1A-I-2","lotCpId":"3234041615535213693","facadeCpId":"1415058716171054458382072103258406221610006190334","planName":"Waverley Waverley","designName":"Waverley","homeName":"Waverley Waverley A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8996245,33.2637661],[-96.8996627,33.2638677],[-96.8994325,33.2639281],[-96.8994203,33.2638955],[-96.8994245,33.2638944],[-96.8993986,33.2638254],[-96.8996245,33.2637661]]]},"properties":{"lotName":"1A-J-9","lotCpId":"4763321615535348774","facadeCpId":"5011878647857144622626212378822428671609927280267","planName":"Malinda Malinda","designName":"Malinda","homeName":"Malinda Malinda D","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.900727,33.2643012],[-96.9006933,33.2643165],[-96.9006773,33.2642916],[-96.9006718,33.2642941],[-96.9006697,33.2642909],[-96.9006707,33.2642904],[-96.9006461,33.2642524],[-96.9006452,33.2642528],[-96.9006425,33.2642486],[-96.9008397,33.2641596],[-96.9008442,33.2641666],[-96.9008459,33.2641659],[-96.9008582,33.2641849],[-96.9008565,33.2641856],[-96.9008654,33.2641994],[-96.9008656,33.2641993],[-96.9008687,33.2642041],[-96.9008685,33.2642042],[-96.9008703,33.2642069],[-96.9008585,33.2642122],[-96.9008602,33.2642149],[-96.9008604,33.2642148],[-96.9008703,33.2642301],[-96.90087,33.2642302],[-96.9008732,33.2642351],[-96.900859,33.2642416],[-96.9008599,33.264243],[-96.9008272,33.2642577],[-96.9008263,33.2642563],[-96.9007954,33.2642703],[-96.9007956,33.2642706],[-96.9007388,33.2642962],[-96.9007386,33.264296],[-96.900727,33.2643012],[-96.900727,33.2643012]]]},"properties":{"lotName":"1A-K-6","lotCpId":"6416801615535320494","facadeCpId":"1372676087104240045752126572628053501610097813562","planName":"Everleigh Everleigh","designName":"Everleigh","homeName":"Everleigh Everleigh C","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015272,33.2627071],[-96.9015275,33.2627137],[-96.9015885,33.2627122],[-96.9015949,33.262901],[-96.9014676,33.262904],[-96.9014604,33.2626914],[-96.9015026,33.2626904],[-96.9015031,33.2627077],[-96.9015272,33.2627071]]]},"properties":{"lotName":"1A-L-14","lotCpId":"7275621615535554264","facadeCpId":"5742133312136737081484651848101143131609914900949","planName":"Walmsley Walmsley","designName":"Walmsley","homeName":"Walmsley Walmsley B","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9066488,33.2673908],[-96.9066559,33.2673781],[-96.9066614,33.2673802],[-96.9066845,33.2673393],[-96.9069073,33.267427],[-96.90686,33.267511],[-96.9066372,33.2674232],[-96.9066543,33.2673929],[-96.9066488,33.2673908]]]},"properties":{"lotName":"5-F-1","lotCpId":"2771031615890715875","facadeCpId":"6050428105454473887708082761041172281616044784214","planName":"Forreston Forreston","designName":"Forreston","homeName":"Forreston Forreston A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9037728,33.2681253],[-96.903776,33.2681254],[-96.9037763,33.2681132],[-96.9037729,33.2681131],[-96.9037729,33.268112],[-96.9037928,33.2681123],[-96.9037729,33.268112],[-96.903773,33.2681067],[-96.9037742,33.2681068],[-96.9037751,33.2680632],[-96.903774,33.2680632],[-96.9037741,33.2680568],[-96.903845,33.2680578],[-96.9038451,33.2680575],[-96.9039354,33.2680587],[-96.9039354,33.2680591],[-96.9040017,33.26806],[-96.9040001,33.2681401],[-96.9039871,33.2681399],[-96.9039865,33.2681668],[-96.9039803,33.2681667],[-96.9039803,33.2681683],[-96.9039453,33.2681678],[-96.9039453,33.2681662],[-96.9039,33.2681656],[-96.9039,33.2681658],[-96.903888,33.2681657],[-96.903888,33.2681654],[-96.9038224,33.2681645],[-96.9038224,33.2681648],[-96.9038103,33.2681646],[-96.9038103,33.2681643],[-96.903772,33.2681638],[-96.9037723,33.2681495],[-96.903772,33.2681495],[-96.9037722,33.2681396],[-96.9037725,33.2681396],[-96.9037728,33.2681264],[-96.9037728,33.2681264],[-96.9037728,33.2681253]]]},"properties":{"lotName":"5-J-10","lotCpId":"3434381615892539230","facadeCpId":"6731562363205330861771278048538842461616049734829","planName":"Davenport Davenport","designName":"Davenport","homeName":"Davenport Davenport C","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9008082,33.2682205],[-96.9008177,33.2681894],[-96.9008121,33.2681882],[-96.9008182,33.2681682],[-96.9008276,33.2681702],[-96.9008282,33.2681685],[-96.9008305,33.268169],[-96.9008423,33.2681302],[-96.90084,33.2681297],[-96.9008418,33.2681238],[-96.9010121,33.2681601],[-96.9010037,33.2681878],[-96.9009889,33.2681846],[-96.900978,33.2682205],[-96.9009928,33.2682236],[-96.9009824,33.2682577],[-96.9008245,33.2682241],[-96.9008246,33.268224],[-96.9008082,33.2682205]]]},"properties":{"lotName":"5-L-4","lotCpId":"7264701615892870723","facadeCpId":"7335533452281605747062524303122566011610094100868","planName":"Westbury Westbury","designName":"Westbury","homeName":"Westbury Westbury A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9067111,33.2665068],[-96.9067101,33.2665086],[-96.9066785,33.2664962],[-96.9066794,33.2664947],[-96.9066752,33.266493],[-96.9066902,33.2664663],[-96.9067027,33.2664712],[-96.9067198,33.2664409],[-96.9067073,33.266436],[-96.9067256,33.2664034],[-96.9069112,33.2664764],[-96.9068934,33.2665081],[-96.9068881,33.2665061],[-96.9068816,33.2665177],[-96.9068847,33.2665189],[-96.9068821,33.2665237],[-96.9068806,33.2665231],[-96.9068607,33.2665583],[-96.9068622,33.2665589],[-96.9068588,33.266565],[-96.9067111,33.2665068]]]},"properties":{"lotName":"5-W-15","lotCpId":"8637561615534091100","facadeCpId":"3322071215740382417523326517731006061610102756733","planName":"Denton Denton","designName":"Denton","homeName":"Denton Denton A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9060313,33.2665355],[-96.9060959,33.2665639],[-96.9060884,33.2665758],[-96.9061238,33.2665914],[-96.9061264,33.2665873],[-96.9061405,33.2665836],[-96.9061635,33.2665937],[-96.9061679,33.2666055],[-96.9060679,33.2667643],[-96.906055,33.2667586],[-96.9060548,33.2667588],[-96.9060449,33.2667544],[-96.9060451,33.2667542],[-96.9060324,33.2667486],[-96.9060345,33.2667452],[-96.9060275,33.2667422],[-96.9060254,33.2667455],[-96.905983,33.2667268],[-96.905985,33.2667237],[-96.9059825,33.2667226],[-96.9059831,33.2667217],[-96.9059371,33.2667014],[-96.9059365,33.2667023],[-96.9059285,33.2666988],[-96.9060313,33.2665355]]]},"properties":{"lotName":"5-W-20","lotCpId":"8143321615892273487","facadeCpId":"8187774412218344555687800143073381221616051858523","planName":"Fleetwood Fleetwood","designName":"Fleetwood","homeName":"Fleetwood Fleetwood P","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9020775,33.2671493],[-96.9020454,33.2671472],[-96.9020452,33.2671497],[-96.9020194,33.267148],[-96.9020196,33.2671456],[-96.9019801,33.2671431],[-96.9019805,33.2671382],[-96.9019153,33.267134],[-96.9019306,33.2669647],[-96.9019907,33.2669685],[-96.9019877,33.2670011],[-96.9020532,33.2670053],[-96.9020542,33.2669942],[-96.9020913,33.2669965],[-96.9020775,33.2671493]]]},"properties":{"lotName":"5-X-23","lotCpId":"6450411615892273520","facadeCpId":"1586507627408043622812451455810032721610003926756","planName":"Yorkshire Yorkshire","designName":"Yorkshire","homeName":"Yorkshire Yorkshire A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9011579,33.2672863],[-96.9011235,33.2673005],[-96.9011261,33.2673049],[-96.9011039,33.2673141],[-96.9010995,33.2673068],[-96.9010977,33.2673075],[-96.9010966,33.2673057],[-96.9010537,33.2673235],[-96.9010548,33.2673253],[-96.9010483,33.267328],[-96.9009702,33.2671963],[-96.9010008,33.2671836],[-96.9010076,33.267195],[-96.9010472,33.2671786],[-96.9010405,33.2671672],[-96.9010781,33.2671516],[-96.9011505,33.2672736],[-96.9011504,33.2672736],[-96.9011579,33.2672863]]]},"properties":{"lotName":"5-X-27","lotCpId":"6187681615892273548","facadeCpId":"7335533452281605747062524303122566011610094100868","planName":"Westbury Westbury","designName":"Westbury","homeName":"Westbury Westbury A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.89597,33.2685217],[-96.8960084,33.2685225],[-96.8960085,33.2685176],[-96.8960333,33.2685181],[-96.8960331,33.2685262],[-96.8960351,33.2685263],[-96.8960351,33.2685283],[-96.896083,33.2685293],[-96.896083,33.2685272],[-96.8960903,33.2685274],[-96.8960861,33.2686743],[-96.8960519,33.2686736],[-96.8960523,33.2686609],[-96.8960081,33.26866],[-96.8960077,33.2686728],[-96.8959657,33.2686719],[-96.8959695,33.2685358],[-96.8959696,33.2685358],[-96.89597,33.2685217]]]},"properties":{"lotName":"6-A-10","lotCpId":"2531051615542034214","facadeCpId":"5038038256131468383333708586361610821610094204172","planName":"Westbury Westbury","designName":"Westbury","homeName":"Westbury Westbury C","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8966789,33.2702868],[-96.8966791,33.2702819],[-96.8966406,33.2702811],[-96.8966411,33.270267],[-96.896641,33.270267],[-96.896645,33.2701309],[-96.8966871,33.2701318],[-96.8966867,33.2701445],[-96.8967309,33.2701454],[-96.8967313,33.2701327],[-96.8967655,33.2701334],[-96.8967611,33.2702803],[-96.8967539,33.2702802],[-96.8967539,33.2702781],[-96.896706,33.2702771],[-96.896706,33.2702792],[-96.8967039,33.2702791],[-96.8967037,33.2702873],[-96.8966789,33.2702868]]]},"properties":{"lotName":"6-H-17","lotCpId":"8616431615545171805","facadeCpId":"7335533452281605747062524303122566011610094100868","planName":"Westbury Westbury","designName":"Westbury","homeName":"Westbury Westbury A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8998939,33.2715007],[-96.8998945,33.2715165],[-96.8999208,33.2715157],[-96.899922,33.2715448],[-96.8999251,33.2715447],[-96.8999253,33.2715499],[-96.8999271,33.2715499],[-96.8999288,33.271593],[-96.899927,33.2715931],[-96.8999272,33.2715983],[-96.8997507,33.2716031],[-96.89975,33.2715838],[-96.8997496,33.2715838],[-96.8997485,33.2715556],[-96.8997489,33.2715556],[-96.8997487,33.2715505],[-96.8997689,33.2715499],[-96.8997687,33.2715455],[-96.8997683,33.2715456],[-96.8997669,33.2715076],[-96.8997672,33.2715076],[-96.8997671,33.2715042],[-96.8997469,33.2715047],[-96.8997468,33.2715027],[-96.8997464,33.2715027],[-96.8997453,33.2714745],[-96.8997458,33.2714745],[-96.8997457,33.2714725],[-96.8997527,33.2714723],[-96.8997526,33.2714697],[-96.8997562,33.2714696],[-96.8997561,33.2714692],[-96.8997767,33.2714686],[-96.8997767,33.271469],[-96.8997799,33.2714689],[-96.89978,33.2714715],[-96.8998506,33.2714696],[-96.8998506,33.2714692],[-96.8998778,33.2714685],[-96.8998778,33.2714688],[-96.8998849,33.2714686],[-96.899886,33.271497],[-96.8998938,33.2714968],[-96.8998939,33.2715007],[-96.8998939,33.2715007]]]},"properties":{"lotName":"6-J-28","lotCpId":"2157451615545423119","facadeCpId":"6337142634628753688157728686154684851615539128532","planName":"Frost 3118","designName":"Frost","homeName":"Frost 3118 D","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9000062,33.2709546],[-96.8999962,33.2709129],[-96.9000108,33.2709104],[-96.9000262,33.2708963],[-96.9000238,33.2708862],[-96.9000162,33.2708875],[-96.9000083,33.2708545],[-96.8999875,33.270858],[-96.8999805,33.2708289],[-96.9001734,33.2707963],[-96.9001726,33.2707933],[-96.9002123,33.2707867],[-96.900213,33.2707897],[-96.9002244,33.2707878],[-96.9002251,33.270791],[-96.9002294,33.2707903],[-96.9002394,33.2708319],[-96.900235,33.2708326],[-96.9002515,33.2709009],[-96.9002489,33.2709077],[-96.900241,33.2709149],[-96.9002381,33.2709154],[-96.9002388,33.2709182],[-96.9002346,33.2709189],[-96.9002346,33.2709193],[-96.9002086,33.2709237],[-96.9002085,33.2709233],[-96.9002041,33.2709241],[-96.9002035,33.2709214],[-96.9001149,33.2709363],[-96.900115,33.2709369],[-96.9000179,33.2709532],[-96.9000178,33.2709526],[-96.9000062,33.2709546]]]},"properties":{"lotName":"6-K-5","lotCpId":"7535101615545423564","facadeCpId":"6553488806118126857230545335504841301615539570924","planName":"Lockhart 3767","designName":"Lockhart","homeName":"Lockhart 3767 A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.897976,33.2589321],[-96.897978,33.2589324],[-96.8979802,33.2589229],[-96.8979782,33.2589226],[-96.8979784,33.2589215],[-96.8979771,33.2589213],[-96.8979779,33.2589177],[-96.8979792,33.2589179],[-96.897989,33.2588756],[-96.897988,33.2588755],[-96.8979892,33.2588705],[-96.8982088,33.258906],[-96.898207,33.258914],[-96.898209,33.2589144],[-96.898202,33.2589447],[-96.8981986,33.2589442],[-96.8981948,33.2589604],[-96.8981792,33.2589579],[-96.8981705,33.2589953],[-96.8981212,33.2589874],[-96.8981209,33.2589887],[-96.8980885,33.2589834],[-96.8980888,33.2589821],[-96.8979676,33.2589625],[-96.8979744,33.258933],[-96.8979757,33.2589332],[-96.897976,33.2589321]]]},"properties":{"lotName":"7-A-14","lotCpId":"3345021615890162047","facadeCpId":"7822335651752275126685256320676284401610430965567","planName":"Bentley Bentley","designName":"Bentley","homeName":"Bentley Bentley A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8963276,33.2584782],[-96.8963276,33.2584782],[-96.8963257,33.2585455],[-96.8963184,33.2585454],[-96.8963184,33.2585457],[-96.8962961,33.2585452],[-96.8962961,33.2585449],[-96.8962891,33.2585447],[-96.8962891,33.2585431],[-96.8962876,33.258543],[-96.8962876,33.2585421],[-96.8962358,33.258541],[-96.8962358,33.2585421],[-96.8962304,33.258542],[-96.8962327,33.2584613],[-96.8962324,33.2584613],[-96.8962332,33.2584345],[-96.8962334,33.2584345],[-96.8962346,33.258393],[-96.8962328,33.258393],[-96.8962334,33.2583715],[-96.8962352,33.2583716],[-96.8962353,33.2583681],[-96.8962409,33.2583682],[-96.896241,33.2583679],[-96.8962622,33.2583684],[-96.8962622,33.2583686],[-96.8962645,33.2583687],[-96.8962646,33.2583675],[-96.8962642,33.2583675],[-96.8962645,33.2583595],[-96.8962648,33.2583595],[-96.8962649,33.2583569],[-96.8962864,33.2583574],[-96.8962864,33.2583559],[-96.8963231,33.2583566],[-96.896323,33.2583581],[-96.8963311,33.2583583],[-96.89633,33.2583966],[-96.8963302,33.2583966],[-96.8963299,33.258406],[-96.8963297,33.258406],[-96.8963286,33.2584439],[-96.8963288,33.2584439],[-96.8963286,33.2584521],[-96.8963284,33.2584521],[-96.8963276,33.2584782]]]},"properties":{"lotName":"7-B-11","lotCpId":"7061501615534717112","facadeCpId":"1440417470531571254425647708320605601610434926815","planName":"Wales Wales","designName":"Wales","homeName":"Wales Wales A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8944895,33.258169],[-96.8944895,33.258169],[-96.89457,33.2581707],[-96.8945698,33.2581768],[-96.8945702,33.2581768],[-96.8945696,33.2581954],[-96.8945692,33.2581954],[-96.894569,33.2582013],[-96.894567,33.2582012],[-96.894567,33.2582025],[-96.8945658,33.2582025],[-96.8945646,33.2582458],[-96.8945658,33.2582458],[-96.8945657,33.2582504],[-96.8944693,33.2582484],[-96.8944693,33.2582486],[-96.8944372,33.2582479],[-96.8944372,33.2582478],[-96.8943876,33.2582467],[-96.8943875,33.2582482],[-96.8943619,33.2582477],[-96.8943619,33.2582462],[-96.8943577,33.2582461],[-96.8943579,33.2582414],[-96.8943576,33.2582414],[-96.8943581,33.2582236],[-96.8943584,33.2582236],[-96.8943585,33.2582217],[-96.8943571,33.2582217],[-96.8943571,33.2582219],[-96.8943475,33.2582217],[-96.8943475,33.2582215],[-96.8943444,33.2582214],[-96.894345,33.2582034],[-96.8943432,33.2582034],[-96.8943441,33.2581727],[-96.8943459,33.2581728],[-96.8943461,33.258166],[-96.8943919,33.258167],[-96.8943919,33.2581668],[-96.8944032,33.2581671],[-96.8944032,33.2581672],[-96.8944485,33.2581682],[-96.8944485,33.258168],[-96.8944582,33.2581682],[-96.8944582,33.2581684],[-96.8944895,33.258169]]]},"properties":{"lotName":"7-D-65","lotCpId":"3310781615534713751","facadeCpId":"1440417470531571254425647708320605601610434926815","planName":"Wales Wales","designName":"Wales","homeName":"Wales Wales A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8982514,33.264604],[-96.8981944,33.2646073],[-96.8981914,33.2645706],[-96.8981612,33.2645724],[-96.8981633,33.2645974],[-96.8981205,33.2645998],[-96.8981058,33.2644213],[-96.898151,33.2644187],[-96.8981512,33.2644214],[-96.898169,33.2644204],[-96.8981688,33.2644178],[-96.8981754,33.2644174],[-96.8981756,33.2644194],[-96.8982274,33.2644164],[-96.8982272,33.2644144],[-96.8982357,33.2644139],[-96.8982514,33.264604]]]},"properties":{"lotName":"1A-F-26","lotCpId":"7783581615535293911","facadeCpId":"1237072661234084864062627220166528171610424354840","planName":"Ashwoodshwood A","designName":"Ashwood","homeName":"Ashwood Ashwood A","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8981787,33.2650254],[-96.8981792,33.2650288],[-96.8981734,33.2650295],[-96.8981731,33.2650281],[-96.8981226,33.2650338],[-96.8981229,33.2650352],[-96.898117,33.2650358],[-96.8980868,33.2648487],[-96.8980961,33.2648477],[-96.8980958,33.2648462],[-96.8981216,33.2648433],[-96.8981218,33.2648447],[-96.8981597,33.2648405],[-96.89816,33.2648427],[-96.8981651,33.2648421],[-96.8981662,33.2648485],[-96.8981794,33.264847],[-96.8981803,33.2648529],[-96.8981857,33.2648523],[-96.8981907,33.2648837],[-96.8981887,33.2648839],[-96.8982106,33.2650195],[-96.8981964,33.2650211],[-96.8981968,33.2650234],[-96.898194,33.2650237],[-96.898194,33.2650237],[-96.8981787,33.2650254]]]},"properties":{"lotName":"1A-F-41","lotCpId":"4241601615888291783","facadeCpId":"7447417524551512645717407577480803151610095513106","planName":"Ellington Ellington","designName":"Ellington","homeName":"Ellington Ellington B","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8986667,33.2652368],[-96.8987135,33.2652378],[-96.8987134,33.26524],[-96.8987275,33.2652403],[-96.8987274,33.2652435],[-96.8987293,33.2652435],[-96.8987295,33.265238],[-96.8987358,33.2652382],[-96.8987358,33.2652393],[-96.8987876,33.2652405],[-96.8987876,33.2652396],[-96.8987961,33.2652398],[-96.8987897,33.2654328],[-96.8987324,33.2654315],[-96.8987336,33.2653954],[-96.8987053,33.2653947],[-96.8987048,33.2654118],[-96.8986944,33.2654201],[-96.8986702,33.2654195],[-96.898661,33.2654113],[-96.8986639,33.265326],[-96.898663,33.265326],[-96.8986633,33.2653157],[-96.8986641,33.2653157],[-96.8986667,33.2652368]]]},"properties":{"lotName":"1A-R-1","lotCpId":"1721441615888291324","facadeCpId":"3002288203640541574763827836777472671610429102505","planName":"Amberley Amberley","designName":"Amberley","homeName":"Amberley Amberley C","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.8988309,33.2652411],[-96.8988904,33.2652404],[-96.8988907,33.2652521],[-96.8988875,33.2652521],[-96.8988876,33.2652537],[-96.8989516,33.2652529],[-96.8989546,33.265411],[-96.8988805,33.265412],[-96.8988804,33.2654023],[-96.898834,33.2654029],[-96.8988309,33.2652411]]]},"properties":{"lotName":"1A-R-2","lotCpId":"3612281615888291522","facadeCpId":"1061334763248308087611054206107061541610006204610","planName":"Waverley Waverley","designName":"Waverley","homeName":"Waverley Waverley B","type":"Vertex"}},{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-96.9015922,33.266708],[-96.9015858,33.2667085],[-96.9015859,33.2667093],[-96.9015566,33.2667115],[-96.9015565,33.2667108],[-96.9015505,33.2667113],[-96.9015499,33.2667059],[-96.9015491,33.266706],[-96.9015482,33.2666978],[-96.901549,33.2666977],[-96.9015488,33.2666959],[-96.9015475,33.266696],[-96.9015467,33.2666885],[-96.901548,33.2666884],[-96.9015477,33.2666863],[-96.9015417,33.2666868],[-96.9015418,33.2666871],[-96.9014973,33.2666906],[-96.9014973,33.2666902],[-96.9014849,33.2666912],[-96.9014877,33.2667162],[-96.901477,33.266717],[-96.9014771,33.2667177],[-96.9014442,33.2667203],[-96.9014441,33.2667195],[-96.9014334,33.2667204],[-96.901422,33.2666175],[-96.9014216,33.2666175],[-96.9014186,33.26659],[-96.901419,33.26659],[-96.9014113,33.2665202],[-96.9014297,33.2665188],[-96.9014288,33.2665106],[-96.9014701,33.2665074],[-96.9014724,33.2665281],[-96.9015035,33.2665257],[-96.9015019,33.2665111],[-96.9015094,33.2665105],[-96.9015092,33.2665088],[-96.9015616,33.2665047],[-96.9015618,33.2665064],[-96.9015698,33.2665058],[-96.9015922,33.266708]]]},"properties":{"lotName":"3-X-5","lotCpId":"8622841615889546978","facadeCpId":"5311556014883664880527214718857734501615540062154","planName":"Newark 2859","designName":"Newark","homeName":"Newark 2859 E","type":"Vertex"}}]}}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"spec-map",staticClass:"map"},[_c('div',{staticClass:"custom-control"},[_c('a',{on:{"click":function($event){return _vm.toggle3d()}}},[_c('img',{attrs:{"src":__webpack_require__(16),"alt":""}})])]),_vm._v(" "),_c('app-map-label',{attrs:{"labels":{available: false, sold: false, favorites: false, spec: true}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-loading',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('div',{staticClass:"container spechomes-list"},[(_vm.hnlSummaryList.length)?_c('app-package-filter',{attrs:{"hnlSummaryList":_vm.hnlSummaryList},on:{"filteredPackages":function($event){_vm.filteredHnlList=$event},"tileView":function($event){_vm.tileView = $event}}}):_vm._e(),_vm._v(" "),(_vm.filteredHnlList && _vm.tileView)?_c('div',{staticClass:"columns is-multiline is-variable is-6"},_vm._l((_vm.filteredHnlList),function(hnlSummary){return _c('div',{staticClass:"column is-3-widescreen is-4-desktop is-6-tablet is-12-mobile"},[_c('app-package-card',{attrs:{"isFavorite":_vm.favoriteHnl && _vm.favoriteHnl.includes(hnlSummary.cpidstring),"hnlSummary":JSON.parse(JSON.stringify(hnlSummary))}})],1)}),0):_vm._e()],1),_vm._v(" "),(!_vm.tileView && _vm.filteredHnlList)?_c('app-spec-map',{attrs:{"filteredHnlList":_vm.filteredHnlList}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Favorites_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63af5ec2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Favorites_vue__ = __webpack_require__(292);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Favorites_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63af5ec2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Favorites_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FavoritePackageCards_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cae7696e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FavoritePackageCards_vue__ = __webpack_require__(288);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FavoritePackageCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cae7696e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FavoritePackageCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"package-card card",on:{"click":function($event){return _vm.goToNext(_vm.hnlSummary.cpidstring)}}},[_c('div',{staticClass:"facade-image"},[(_vm.hnlSummary.imagepath)?_c('figure',{staticClass:"image is-3by2"},[_c('img',{attrs:{"src":_vm.hnlSummary.imagepath,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"marker-overlay left"},[_c('a',{on:{"click":function($event){return _vm.removeFromFavorites(_vm.hnlSummary.cpidstring)}}},[_c('i',{staticClass:"fas fa-times"})])])]),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('div',{staticClass:"columns is-mobile is-gapless"},[_c('div',{staticClass:"column design"},[_c('p',{staticClass:"design"},[_vm._v(_vm._s(_vm.hnlSummary.designproductname))]),_vm._v(" "),_c('p',{staticClass:"d"},[_vm._v(_vm._s(_vm.hnlSummary.buildername))])]),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_c('div',{staticClass:"amenities"},[_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(2),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hnlSummary.noofbedrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(3),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hnlSummary.noofbathrooms))])]),_vm._v(" "),_c('div',{staticClass:"amenity"},[_c('img',{attrs:{"src":__webpack_require__(4),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hnlSummary.noofcarparks))])])]),_vm._v(" "),_c('div',{staticClass:"price"},[_c('p',{staticClass:"p"},[_vm._v("\n              $"+_vm._s(_vm.hnlSummary.planPrice < _vm.hnlSummary.productprice
                  ? _vm.hnlSummary.planPrice.toLocaleString()
                  : _vm.hnlSummary.productprice.toLocaleString())+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"columns is-mobile is-gapless"},[_c('div',{staticClass:"column dimensions"},[_c('div',{staticClass:"dimension"},[_c('p',{staticClass:"t"},[_vm._v("Home Area")]),_vm._v(" "),_c('p',{staticClass:"d"},[_vm._v("\n              "+_vm._s(_vm.hnlSummary.homesize.toLocaleString())),_c('small',[_vm._v(" sq ft")])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-narrow"},[_c('a',{staticClass:"button app-accent"},[_vm._v("\n            View Home\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FavoritesMap_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1383abfc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FavoritesMap_vue__ = __webpack_require__(291);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FavoritesMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1383abfc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FavoritesMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_map_Config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_map_Popup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_map_Home__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map',
  data: function data() {
    return {
      activeLot: null,
      apartmentGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      baseLayers: [],
      container: 'favorites-map',
      lotBounds: null,
      detailLayers: [],
      filteredlotGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      layers: [],
      favoriteHnlList: null,
      lotgeo: __webpack_require__(8),
      lotGeoJson: null,
      lotPanelMarker: [],
      detailPanelMaker: null,
      masterBound: null,
      packageSummaryList: null,
      sources: [],
      svgConfig: null,
      stageGeoJson: {
        type: 'FeatureCollection',
        features: []
      },
      viewBasedFilterLot: {
        type: 'FeatureCollection',
        features: []
      }
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_map_Config__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_map_Popup__["a" /* default */]],
  methods: {
    initMap: function initMap(config, hnlsummary) {
      mapboxgl.accessToken = 'pk.eyJ1Ijoic2FpbGVzaGtjIiwiYSI6ImNrZGo1Y2l5dTBibGIzMXBmbzM5Z2Q3Z2MifQ.hq_fP_fYTmUm_LJNRl23Cw';
      if (config && hnlsummary) {
        this.favoriteHnlList = hnlsummary;
        this.svgConfig = config;
        this.initConfig();
      }
    },

    addLotShapes: function addLotShapes() {
      var _this = this;

      var bounds = new mapboxgl.LngLatBounds();

      this.favoriteHnl.forEach(function (hnl) {
        var lotfeature = _this.lotGeoJson.features.find(function (feature) {
          return feature.properties.lotCpId === hnl.lotproductcpid;
        });
        var filteredfeature = _this.filteredlotGeoJson.features.find(function (feature) {
          return feature.properties.lotCpId === hnl.lotproductcpid;
        });

        if (filteredfeature) {
          return filteredfeature.properties.hnlproperties.push(hnl);
        }

        if (lotfeature) {
          lotfeature.properties.hnlproperties = [hnl];
          lotfeature.id = hnl.lotproductcpid;
          lotfeature.properties.hoverable = 'allow';
          lotfeature.properties.isActive = true;
          lotfeature.properties.interact = true;
          lotfeature.geometry.coordinates[0].forEach(function (cord) {
            bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
          });

          _this.filteredlotGeoJson.features.push(lotfeature);
        }
      });

      this.map.addSource('lots', {
        type: 'geojson',
        data: this.filteredlotGeoJson
      });

      this.addLotFills();

      this.placeDetailLayer();
      this.addApartmentShapes();
      if (bounds && this.filteredlotGeoJson.features.length > 0) {
        this.lotBounds = bounds;
        this.map.fitBounds(bounds, {
          maxZoom: 19,
          padding: 60,
          pitch: 60
        });
      } else {
        this.map.fitBounds(this.masterBound, {
          pitch: 60
        });
      }
    },

    addLotFills: function addLotFills() {
      var _this2 = this;

      this.map.addLayer({
        id: 'lot-fills',
        type: 'fill',
        source: 'lots',
        layout: {},
        paint: {
          'fill-color': '#688e9f',
          'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.4, 0.9]
        }
      });

      this.map.on('mousemove', 'lot-fills', function (e) {
        if (e.features.length > 0) {
          if (e.features[0].properties.interact) {
            _this2.map.getCanvas().style.cursor = 'pointer';
            if (_this2.hoveredLotId) {
              _this2.map.setFeatureState({ source: 'lots', id: _this2.hoveredLotId }, { hover: false });
            }
            _this2.hoveredLotId = e.features[0].id;
            _this2.map.setFeatureState({ source: 'lots', id: _this2.hoveredLotId }, { hover: true });
          }
        }
      });

      this.map.on('mouseleave', 'lot-fills', function () {
        _this2.map.getCanvas().style.cursor = '';
        if (_this2.hoveredLotId) {
          _this2.map.setFeatureState({ source: 'lots', id: _this2.hoveredLotId }, { hover: false });
        }
        _this2.hoveredLotId = null;
      });

      this.map.on('click', 'lot-fills', function (e) {
        if (e.features.length > 0) {
          if (e.features[0].properties.interact) {
            var hnl = JSON.parse(e.features[0].properties.hnlproperties)[0];
            _this2.createPackageDetailMarker(hnl, e.features[0].geometry.coordinates[0]);
          }
        }
      });

      this.createLotMarker();
    },

    addHomesShapes: function addHomesShapes() {},

    createLotMarker: function createLotMarker() {
      var _this3 = this;

      this.lotPanelMarker.forEach(function (m) {
        m.remove();
      });

      this.favoriteHnl.forEach(function (hnl) {
        var lotfeature = _this3.lotGeoJson.features.find(function (feature) {
          return feature.properties.lotCpId === hnl.lotproductcpid;
        });
        if (lotfeature) {
          var markerBound = new mapboxgl.LngLatBounds();
          lotfeature.geometry.coordinates[0].forEach(function (cord) {
            markerBound.extend(new mapboxgl.LngLat(cord[0], cord[1]));
          });

          var el = document.createElement('div');
          var img = document.createElement('img');
          el.className = 'facade-popup';
          img.src = hnl.imagepath;
          img.style.width = '100px';
          img.style.height = 'auto';
          el.appendChild(img);

          el.addEventListener('click', function () {
            _this3.createPackageDetailMarker(hnl, lotfeature.geometry.coordinates[0]);
          });

          var m = new mapboxgl.Marker({
            element: el,
            anchor: 'bottom',
            offset: [0, -40]
          });
          m.setLngLat(markerBound.getCenter());
          _this3.lotPanelMarker.push(m);
          m.addTo(_this3.map);
        }
      });
    },

    resetTileView: function resetTileView() {
      var _this4 = this;

      if (this.detailPanelMaker) {
        this.detailPanelMaker.remove();
      }

      this.lotPanelMarker.forEach(function (m) {
        m.addTo(_this4.map);
      });
    },

    createPackageDetailMarker: function createPackageDetailMarker(hnlSummary, coord) {
      var _this5 = this;

      if (this.detailPanelMaker) {
        this.detailPanelMaker.remove();
      }
      this.lotPanelMarker.forEach(function (m) {
        m.remove();
      });
      var markerBound = new mapboxgl.LngLatBounds();
      coord.forEach(function (cord) {
        markerBound.extend(new mapboxgl.LngLat(cord[0], cord[1]));
      });
      if (this.detailPanelMaker) {
        this.detailPanelMaker.remove();
      }

      var el = this.getPackageTile(hnlSummary);

      var buttonsEl = document.createElement('div');
      buttonsEl.classList.add('explore-btns');

      var aEl = document.createElement('a');
      aEl.classList.add('modal-close');
      aEl.addEventListener('click', function () {
        _this5.resetTileView();
      });

      var aDetailEl = document.createElement('a');
      aDetailEl.classList.add('explore');
      aDetailEl.innerHTML = 'EXPLORE THIS HOME';

      buttonsEl.appendChild(aDetailEl);

      el.lastElementChild.appendChild(buttonsEl);
      el.appendChild(aEl);

      aDetailEl.addEventListener('click', function () {

        _this5.$router.push({
          path: '/community/package/' + hnlSummary.cpidstring
        });
        setTimeout(function () {
          if (_this5.detailPanelMaker) {
            _this5.detailPanelMaker.remove();
          }
        });
      });

      this.map.flyTo({
        center: markerBound.getCenter(),
        zoom: 18,
        essential: true
      });

      this.detailPanelMaker = new mapboxgl.Marker({
        element: el,
        anchor: 'bottom',
        offset: [0, -40]
      }).setLngLat(markerBound.getCenter());
      this.detailPanelMaker.addTo(this.map);
    },

    filterMapLots: function filterMapLots(hnllist) {
      var _this6 = this;

      this.specHomesList = hnllist;
      if (!this.map || !this.map.getSource('lots')) return;

      var bounds = new mapboxgl.LngLatBounds();

      this.filteredlotGeoJson.features.forEach(function (feature) {
        feature.properties.isActive = false;
        feature.properties.interact = false;
      });

      this.filteredlotGeoJson.features = [];

      hnllist.forEach(function (hnl) {
        var filteredfeature = _this6.filteredlotGeoJson.features.find(function (feature) {
          return feature.properties.lotCpId === hnl.lotproductcpid;
        });

        if (filteredfeature) {
          return filteredfeature.properties.hnlproperties.push(hnl);
        }

        var lotfeature = _this6.lotgeo.geoJson.features.find(function (feature) {
          return feature.properties.lotCpId === hnl.lotproductcpid;
        });

        if (lotfeature) {
          lotfeature.properties.hnlproperties = [hnl];
          lotfeature.id = hnl.lotproductcpid;
          lotfeature.properties.hoverable = 'allow';
          lotfeature.properties.isActive = true;
          lotfeature.properties.interact = true;
          lotfeature.geometry.coordinates[0].forEach(function (cord) {
            bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
          });
          _this6.filteredlotGeoJson.features.push(lotfeature);
        }
      });

      this.map.getSource('lots').setData(this.filteredlotGeoJson);

      if (bounds && this.filteredlotGeoJson.features.length > 0 && hnllist.length) {
        this.lotBounds = bounds;
        this.map.fitBounds(bounds, {
          maxZoom: 19,
          padding: 60
        });
      } else {
        this.map.fitBounds(this.masterBound);
      }
    },

    reset: function reset() {
      this.resetTileView();
      var bounds = this.masterBound;
      if (this.lotBounds) {
        bounds = this.lotBounds;
      }

      this.map.fitBounds(bounds, {
        maxZoom: 19
      });

      this.removeDirection();
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"layout favorites-page"},[_c('div',{staticClass:"layout-item grow"},[_c('div',{ref:"favorites-map",staticClass:"map"},[_c('div',{staticClass:"custom-control"},[_c('a',{on:{"click":function($event){return _vm.toggle3d()}}},[_c('img',{attrs:{"src":__webpack_require__(16),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"custom-control mt-6"},[_c('a',{on:{"click":function($event){return _vm.reset()}}},[_c('i',{staticClass:"fas fa-sync"})])]),_vm._v(" "),_c('app-map-label',{attrs:{"labels":{available: false, sold: false, favorites: true, spec: false}}})],1)]),_vm._v(" "),(_vm.route)?_c('div',{staticClass:"layout-item direction-panel"},[_c('div',{staticClass:"heading"},[_c('p',[_vm._v("Direction from Welcome Center")]),_vm._v(" "),_c('button',{staticClass:"delete",on:{"click":_vm.removeDirection}})]),_vm._v(" "),(_vm.route && _vm.route.legs && _vm.route.legs.length && _vm.route.legs[0].steps)?_c('div',{staticClass:"steps"},[_c('table',{staticClass:"table is-fullwidth"},_vm._l((_vm.route.legs[0].steps),function(steps){return _c('tr',[_c('td',[(steps['icon'])?_c('img',{attrs:{"src":__webpack_require__(20)("./" + steps.icon),"alt":""}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"instruction"},[_vm._v(_vm._s(steps.maneuver.instruction))])])}),0)]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"border-bar"},[_c('div',{staticClass:"left-item"},[_c('a',{staticClass:"button app-primary",on:{"click":function($event){return _vm.$router.back()}}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v("\n          GO Back\n        ")]),_vm._v(" "),_c('p',{staticClass:"title is-hidden-x"},[_vm._v("Your Favorites")])]),_vm._v(" "),_c('div',{staticClass:"right-item"},[_c('div',{staticClass:"buttons has-addons"},[_c('span',{staticClass:"button",class:{ 'is-active': _vm.tileView},on:{"click":function($event){return _vm.filterTileView(true)}}},[_vm._v("\n                        Tile View\n                    ")]),_vm._v(" "),_c('span',{staticClass:"button",class:{ 'is-active': !_vm.tileView},on:{"click":function($event){return _vm.filterTileView(false)}}},[_vm._v("\n                    Map View\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"favorites-container"},[(_vm.favoriteHnl && _vm.tileView)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline is-variable is-6"},_vm._l((_vm.favoriteHnl),function(hnlSummary){return _c('div',{staticClass:"column is-3-widescreen is-4-desktop is-6-tablet is-12-mobile"},[_c('app-package-card',{attrs:{"hnlSummary":JSON.parse(JSON.stringify(hnlSummary))}})],1)}),0)]):_vm._e(),_vm._v(" "),(!_vm.tileView && _vm.favoriteHnl)?_c('app-favorites-map',{attrs:{"favoriteHnl":_vm.favoriteHnl}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules__ = __webpack_require__(295);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: __WEBPACK_IMPORTED_MODULE_2__store_modules__["a" /* default */]
}));

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export createLogger */
/* unused harmony export createNamespacedHelpers */
/* unused harmony export install */
/* unused harmony export mapActions */
/* unused harmony export mapGetters */
/* unused harmony export mapMutations */
/* unused harmony export mapState */
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((true)) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((true)) {
      console.warn(
        "[vuex] trying to unregister module '" + key + "', which is " +
        "not registered"
      );
    }
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {
  if ((true)) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((true)) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((true)) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((true)) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((true)) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    ("development" !== 'production') &&
    options && options.silent
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((true)) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((true)) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((true)) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((true)) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((true)) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((true)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((true)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((true)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("development" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((true)) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (("development" !== 'production') && !store._actions[type]) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (("development" !== 'production') && !store._mutations[type]) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((true)) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((true)) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((true)) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((true)) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (("development" !== 'production') && !isValidMap(states)) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (("development" !== 'production') && !isValidMap(mutations)) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (("development" !== 'production') && !isValidMap(getters)) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (("development" !== 'production') && !(val in this.$store.getters)) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (("development" !== 'production') && !isValidMap(actions)) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (("development" !== 'production') && !module) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__community_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amenity__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__favorite__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_r6analytics__ = __webpack_require__(298);





/* harmony default export */ __webpack_exports__["a"] = ({
  communityStore: __WEBPACK_IMPORTED_MODULE_0__community_js__["a" /* default */],
  amenityStore: __WEBPACK_IMPORTED_MODULE_1__amenity__["a" /* default */],
  favoriteStore: __WEBPACK_IMPORTED_MODULE_2__favorite__["a" /* default */],
  r6analytics: __WEBPACK_IMPORTED_MODULE_3__store_r6analytics__["a" /* default */]
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    fetchingMasterplan: false,
    activeProduct: {
      home: null,
      lot: null,
      facade: null
    },
    enquirySubmission: null,
    homeDetail: null,
    homeSummary: [],
    homeGeojson: null,
    lotClick: null,
    modelHomes: [],
    unfilteredLotSummary: null,
    lotsummary: null,
    lotDetail: null,
    compatibleLotSummary: null,
    masterplanConfig: null,
    masterplanResources: null,
    packageRecordId: null,
    packageSummary: [],
    specHomesList: null,
    packageDetailList: []
  },
  getters: {
    masterplanResources: function masterplanResources(state) {
      return state.masterplanResources;
    },
    masterplanConfig: function masterplanConfig(state) {
      return state.masterplanConfig;
    },
    homeGeoJson: function homeGeoJson(state) {
      return state.homeGeojson;
    },
    homeSummary: function homeSummary(state) {
      return state.homeSummary;
    },
    modelHomes: function modelHomes(state) {
      return state.modelHomes;
    },
    unfilteredLot: function unfilteredLot(state) {
      return state.unfilteredLotSummary;
    }
  },
  mutations: {
    setMasterplanConfig: function setMasterplanConfig(state, payload) {
      state.masterplanConfig = payload;
    },
    getHomeGeoJson: function getHomeGeoJson(state, payload) {
      state.homeGeojson = payload;
    },
    setMasterplanResource: function setMasterplanResource(state, payload) {
      state.masterplanResources = payload;
    },
    setHomeSummaryList: function setHomeSummaryList(state, payload) {
      state.homeSummary = payload;
    },
    setSpecHomesList: function setSpecHomesList(state, payload) {
      state.specHomesList = payload;
    },
    setHomeDetail: function setHomeDetail(state, payload) {
      state.homeDetail = payload;
    },
    setUnfilteredSummaryList: function setUnfilteredSummaryList(state, payload) {
      state.unfilteredLotSummary = payload;
    },
    setLotSummaryList: function setLotSummaryList(state, payload) {
      state.lotsummary = payload;
    },
    setLotDetail: function setLotDetail(state, payload) {
      state.lotDetail = payload;
    },
    setModelHomes: function setModelHomes(state, payload) {
      state.modelHomes = payload;
    },
    setCompatibleLotSummaryList: function setCompatibleLotSummaryList(state, payload) {
      state.compatibleLotSummary = payload;
    },
    setCompatibleHomeSummaryList: function setCompatibleHomeSummaryList(state, payload) {
      state.homeSummary = payload;
    },
    setActiveHome: function setActiveHome(state, payload) {
      state.activeProduct.home = payload;
    },
    setPackageCreation: function setPackageCreation(state, payload) {
      state.packageRecordId = payload;
    },
    setPackageDetail: function setPackageDetail(state, payload) {
      state.packageDetail = payload;
    },
    setPackageDetailList: function setPackageDetailList(state, payload) {
      state.packageDetailList = payload;
    },
    setPublishedContact: function setPublishedContact(state, payload) {
      state.enquirySubmission = payload;
    }
  },
  actions: {
    fetchMasterplanConfig: function fetchMasterplanConfig(_ref) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          state = _ref.state;

      if (state.masterplanConfig) {
        return commit("setMasterplanConfig", state.masterplanConfig);
      }
      if (!this.fetchingMasterplan) {
        this.fetchingMasterplan = true;
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].fetchMasterplanConfig().then(function (res) {
          return commit("setMasterplanConfig", res.data.estate.config);
        });
      }
    },
    fetchHomeGeoJson: function fetchHomeGeoJson(_ref2) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          state = _ref2.state;

      if (state.homeGeojson) {
        return commit("setHomeGeoJson", state.homeGeojson);
      }
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].fetchHomeGeojson().then(function (res) {
        return commit("setHomeGeoJson", res.data);
      });
    },
    fetchHomeSummary: function fetchHomeSummary(_ref3) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state;

      if (state.homeSummary) {
        commit("setHomeSummaryList", state.homeSummary);
      }
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].fetchHomeSummaryList().then(function (res) {
        commit("setHomeSummaryList", res.data);
      });
    },
    fetchCompatibleHomeSummaryList: function fetchCompatibleHomeSummaryList(_ref4, data) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          state = _ref4.state;

      var lotCpId = data.lotCpId;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].fetchLotSummaryV2(lotCpId).then(function (lotSummaryRes) {
        var lotSummary = lotSummaryRes.data;
        var clientId = lotSummary.clientid;
        var allocatedBuilderName = lotSummary.allocatedbuildername;
        if (allocatedBuilderName) {
          __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].fetchClient(clientId).then(function (clientRes) {
            var client = clientRes.data;
            var clientCompanyId = client.defaultccid;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].fetchPartnerSummaryList(clientId, clientCompanyId).then(function (partnerSummaryListRes) {
              var partnerSummaryList = partnerSummaryListRes.data;
              var builderClientCompany = partnerSummaryList.partnerList.find(function (clientCompany) {
                return clientCompany.partnercompanyname === allocatedBuilderName;
              });
              if (builderClientCompany) {
                var ownerCcId = builderClientCompany.clientcompanyid;
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].fetchCompatibleHomeSummaryListByLotCpIdAndOwnerCcId(lotCpId, ownerCcId).then(function (compatibleHomeSummaryListRes) {
                  commit("setCompatibleHomeSummaryList", compatibleHomeSummaryListRes.data);
                });
              }
            });
          });
        }
      });
    },
    fetchCompatibleLotSummaryList: function fetchCompatibleLotSummaryList(_ref5, homeid) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit,
          state = _ref5.state;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].fetchCompatibleLotSummaryList(homeid).then(function (res) {
        commit("setHomeDetail", res.homesummary);
        commit("setCompatibleLotSummaryList", res.lotsummary);
      });
    },
    fetchLotSummaryList: function fetchLotSummaryList(_ref6) {
      var dispatch = _ref6.dispatch,
          commit = _ref6.commit,
          state = _ref6.state;

      if (state.unfilteredLotSummary && state.modelHomes) {
        commit("setModelHomes", state.modelHomes);
        return commit("setUnfilteredSummaryList", state.unfilteredLotSummary);
      }
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].fetchLotSummary().then(function (res) {
        state.unfilteredLotSummary = res.lotsummary;
        state.modelHomes = res.homesummary;
        commit("setModelHomes", res.homesummary);
        commit("setUnfilteredSummaryList", res.lotsummary);
      });
    },
    getPackageSummaryList: function getPackageSummaryList(_ref7) {
      var dispatch = _ref7.dispatch,
          commit = _ref7.commit;
    },
    getSpecHomesList: function getSpecHomesList(_ref8) {
      var dipatch = _ref8.dipatch,
          commit = _ref8.commit,
          state = _ref8.state;

      if (state.specHomesList) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].getSpecHomesList().then(function (res) {
        var publishedList = res.data.filter(function (hnl) {
          if (hnl.marketingstatus === "Publish on Website" || hnl.marketingstatus === "Publish On Website") {
            return hnl;
          }
        });
        commit("setSpecHomesList", publishedList);
      });
    },
    getActiveHome: function getActiveHome(_ref9, id) {
      var dipatch = _ref9.dipatch,
          commit = _ref9.commit,
          state = _ref9.state;

      if (state.activeHome) {
        commit("setActiveHome", activeHome);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].fetchHomeSummaryDetail(id).then(function (res) {
          commit("setActiveHome", res.data);
        });
      }
    },
    getPackageDetail: function getPackageDetail(_ref10, id) {
      var dipatch = _ref10.dipatch,
          commit = _ref10.commit,
          state = _ref10.state;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].getPackageDetail(id).then(function (res) {
        commit("setPackageDetail", res.data);
      });
    },
    getPackageDetailList: function getPackageDetailList(_ref11) {
      var dipatch = _ref11.dipatch,
          commit = _ref11.commit,
          state = _ref11.state;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].getPackageDetailList().then(function (res) {
        commit("setPackageDetailList", res.data);
      });
    },
    createPackage: function createPackage(_ref12, ids) {
      var dispatch = _ref12.dispatch,
          commit = _ref12.commit,
          state = _ref12.state;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].createPackage(ids).then(function (res) {
        if (res.data.recordid) {
          dispatch("setFavoriteHnl", res.data.recordid);
          dispatch("goToPackage", res.data.recordid);
        }
      });
    },
    goToPackage: function goToPackage(_ref13, packageid) {
      var dispatch = _ref13.dispatch,
          commit = _ref13.commit,
          state = _ref13.state;

      commit("setPackageCreation", packageid);
    },
    setFilteredLotList: function setFilteredLotList(_ref14, lotlist) {
      var dispatch = _ref14.dispatch,
          commit = _ref14.commit,
          state = _ref14.state;

      commit("setLotSummaryList", lotlist);
    },
    submitEnquiry: function submitEnquiry(_ref15, formData) {
      var dispatch = _ref15.dispatch,
          commit = _ref15.commit,
          state = _ref15.state;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].publishToHubspot(formData.hubspotFormData).then(function (res) {
        console.log(res);
      });
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* api */].publishContact(formData.formData).then(function (res) {
        console.log(res.data);
        commit("setPublishedContact", res.data);
      });
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    activePoi: null,
    activeVenue: null,
    activeTravel: null,
    directionMethod: 'driving',
    mapLoad: false,
    masterplanConfig: null,
    poi: null,
    routeInfo: null,
    category: null
  },
  getters: {
    getTime: function getTime(state) {},
    getPoi: function getPoi(state) {
      return state.poi;
    }
  },
  mutations: {
    setActivePoi: function setActivePoi(state, payload) {
      state.activePoi = payload;
    },
    setActiveVenue: function setActiveVenue(state, payload) {
      state.activeVenue = payload;
    },
    setActiveTravel: function setActiveTravel(state, payload) {
      state.activeTravel = payload;
    },
    setDirectionMethod: function setDirectionMethod(state, payload) {
      state.directionMethod = payload;
    },
    setMapLoad: function setMapLoad(state, payload) {
      state.mapLoad = payload;
    },
    setMasterplanConfig: function setMasterplanConfig(state, payload) {
      state.masterplanConfig = payload;
    },
    setPoi: function setPoi(state, payload) {
      state.poi = payload;
    },
    setRouteInfo: function setRouteInfo(state, payload) {
      state.routeInfo = payload;
    },
    zoomToCategory: function zoomToCategory(state, payload) {
      state.category = payload;
    }
  },
  actions: {}
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Tracking__ = __webpack_require__(47);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    event: null,
    product: null,
    productType: null,
    productReference: null,
    productId: null
  },
  getters: {
    getEventProduct: function getEventProduct(state) {
      return state.product;
    },

    getReferrer: function getReferrer(state) {
      if (document.referrer !== '') {
        return document.referrer;
      } else {
        return document.baseURI;
      }
    }
  },
  mutations: {},
  actions: {
    productTracking: function productTracking(_ref, payload) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          state = _ref.state;

      var page = payload.page;
      var product = payload.product;

      switch (page) {
        case 'home-design':
          state.productId = product.cpidstring;
          state.productReference = {
            design: product.designproductname,
            plan: product.productname
          };
          state.event = 'View Home Design on page';
          state.productType = 'Home Design';
          break;
        case 'elevation':
          state.productId = product.productid;
          state.productReference = product.productname;
          state.event = 'Select Elevation';
          state.productType = 'Elevation';
          break;
        case 'hnl-package':
          state.productId = product.cpidstring;
          state.productReference = product.productname;
          state.event = 'View Package on page';
          state.productType = 'Package';
          break;
        case 'brochure':
          state.productId = product.cpidstring;
          state.productReference = product.productname;
          state.event = 'Downloaded Brochure on page';
          state.productType = 'Brochure';
          break;
        case 'documents-library':
          state.productId = product.cpidstring;
          state.productReference = product.productname;
          state.event = 'View Documents Library on Page';
          state.productType = product.producttype;
          break;
        case 'download':
          state.productId = product.productId;
          state.productReference = {
            DocumentType: product.type,
            DocumentSubType: product.subType,
            DocumentShortDescription: product.productName + ' Package PDF',
            DocumentFilename: product.productName + '.pdf',
            BuilderName: product.builderName
          };
          state.event = product.event;
          state.productType = product.producttype;
          break;
        case 'contact':
          state.productId = product.productid;
          state.productReference = product.contactid;
          state.event = 'Submitted Contact on Page';
          state.productType = 'Contact';
          break;
        case 'lot-click':
          state.productId = product.productId;
          state.productReference = {
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.productName
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        case 'handl-click':
          state.productId = product.productId;
          state.productReference = {
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.lotProductName,
            Range: product.rangeProductName,
            Design: product.designProductName,
            Builder: product.builderName,
            Plan: product.productName
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        case 'home-click':
          state.productId = product.productId;
          state.productReference = {
            Range: product.rangeProductName,
            Design: product.designProductName,
            Plan: product.productName
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        case 'poi-click':
          state.productReference = {
            Name: product.productName,
            Category: product.category
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        case 'enquiry-submit':
          state.productId = product.productId;
          state.productReference = {
            FirstName: product.firstName,
            LastName: product.lastName,
            Mobile: product.mobile,
            Email: product.email,
            productId: product.shortListedProducts,
            productCount: product.productCount
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        case 'create-package':
          state.productId = product.productId;
          state.productReference = {
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.lotProductName,
            Range: product.rangeProductName,
            Design: product.designProductName,
            Plan: product.planProductName,
            Facade: product.productName
          };
          state.event = product.event;
          state.productType = product.productType;
          break;
        default:
          state.event = 'Page View';
          state.productType = null;
          state.productId = null;
          break;
      }

      if (sessionStorage.getItem('trackerid')) {
        dispatch('eventTracking');
      }
    },
    checkSession: function checkSession(_ref2, payload) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          state = _ref2.state,
          getters = _ref2.getters;

      state.event = payload.event;
      state.productReference = payload.productreference;
      state.productId = payload.productid;
      state.productType = payload.producttype;
      if (!sessionStorage.getItem('trackerid')) {
        dispatch('initiateTracking');
      } else {
        dispatch('eventTracking');
      }
    },
    initiateTracking: function initiateTracking(_ref3, payload) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state,
          getters = _ref3.getters;

      var trackingItems = __WEBPACK_IMPORTED_MODULE_1__model_Tracking__["a" /* default */];
      return FingerprintJS.load().then(function (fp) {
        fp.get().then(function (result) {
          trackingItems.fingerprint = result.visitorId;
          trackingItems.request_type = 'initiate_tracker';
          trackingItems.capsuleid = "718850824";
          trackingItems.referrer = getters.getReferrer;
          trackingItems.trackersource = window.location.href;
          trackingItems.trackeragent = navigator.userAgent;
          trackingItems.trackermessage = 'Initiated tracker';

          __WEBPACK_IMPORTED_MODULE_0__store_api__["a" /* api */].postTracking('initiatetrackerlog', trackingItems).then(function (res) {
            if (res && res.data) {
              var response = JSON.parse(res.data);
              if (response.trackerid) {
                sessionStorage.setItem('trackerid', response.trackerid);
                dispatch('eventTracking');
                // this.eventTracking(event, reference, productId, productType);
              }
            }
          });
        });
      });
    },
    eventTracking: function eventTracking(_ref4, payload) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          state = _ref4.state,
          getters = _ref4.getters;

      var eventItems = {
        request_type: 'initiate_tracker_event',
        trackerid: sessionStorage.getItem('trackerid'),
        productreference: state.productReference,
        capsuleid: "718850824",
        productid: state.productId,
        producttype: state.productType,
        eventname: state.event
      };
      __WEBPACK_IMPORTED_MODULE_0__store_api__["a" /* api */].postTracking('publisheventlogtracker', eventItems).then(function (res) {
        return res;
      });
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_js__);
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

var VueSweetalert2 = (function () {
    function VueSweetalert2() {
    }
    VueSweetalert2.install = function (vue, options) {
        var _a;
        if (options === void 0) { options = {}; }
        var swalLocalInstance = __WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_js___default.a.mixin(options);
        var swalFunction = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (_a = swalLocalInstance.fire).call.apply(_a, __spreadArray([swalLocalInstance], args));
        };
        Object.assign(swalFunction, __WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_js___default.a);
        var methodName;
        for (methodName in __WEBPACK_IMPORTED_MODULE_0_sweetalert2_dist_sweetalert2_js___default.a) {
            if (Object.prototype.hasOwnProperty.call(swalLocalInstance, methodName) &&
                typeof swalLocalInstance[methodName] === 'function') {
                swalFunction[methodName] = swalLocalInstance[methodName].bind(swalLocalInstance);
            }
        }
        if (((_a = vue.config) === null || _a === void 0 ? void 0 : _a.globalProperties) && !vue.config.globalProperties.$swal) {
            vue.config.globalProperties.$swal = swalFunction;
            vue.provide('$swal', swalFunction);
        }
        else if (!Object.prototype.hasOwnProperty.call(vue, '$swal')) {
            vue.prototype.$swal = swalFunction;
            vue['swal'] = swalFunction;
        }
    };
    return VueSweetalert2;
}());
/* harmony default export */ __webpack_exports__["a"] = (VueSweetalert2);
//# sourceMappingURL=index.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

/*!
* sweetalert2 v10.16.9
* Released under the MIT License.
*/
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Sweetalert2 = factory());
}(this, function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  var consolePrefix = 'SweetAlert2:';
  /**
   * Filter the unique values into a new array
   * @param arr
   */

  var uniqueArray = function uniqueArray(arr) {
    var result = [];

    for (var i = 0; i < arr.length; i++) {
      if (result.indexOf(arr[i]) === -1) {
        result.push(arr[i]);
      }
    }

    return result;
  };
  /**
   * Capitalize the first letter of a string
   * @param str
   */

  var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  /**
   * Returns the array of object values (Object.values isn't supported in IE11)
   * @param obj
   */

  var objectValues = function objectValues(obj) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    });
  };
  /**
   * Convert NodeList to Array
   * @param nodeList
   */

  var toArray = function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  };
  /**
   * Standardise console warnings
   * @param message
   */

  var warn = function warn(message) {
    console.warn("".concat(consolePrefix, " ").concat(_typeof(message) === 'object' ? message.join(' ') : message));
  };
  /**
   * Standardise console errors
   * @param message
   */

  var error = function error(message) {
    console.error("".concat(consolePrefix, " ").concat(message));
  };
  /**
   * Private global state for `warnOnce`
   * @type {Array}
   * @private
   */

  var previousWarnOnceMessages = [];
  /**
   * Show a console warning, but only if it hasn't already been shown
   * @param message
   */

  var warnOnce = function warnOnce(message) {
    if (!(previousWarnOnceMessages.indexOf(message) !== -1)) {
      previousWarnOnceMessages.push(message);
      warn(message);
    }
  };
  /**
   * Show a one-time console warning about deprecated params/methods
   */

  var warnAboutDeprecation = function warnAboutDeprecation(deprecatedParam, useInstead) {
    warnOnce("\"".concat(deprecatedParam, "\" is deprecated and will be removed in the next major release. Please use \"").concat(useInstead, "\" instead."));
  };
  /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   * @param arg
   */

  var callIfFunction = function callIfFunction(arg) {
    return typeof arg === 'function' ? arg() : arg;
  };
  var hasToPromiseFn = function hasToPromiseFn(arg) {
    return arg && typeof arg.toPromise === 'function';
  };
  var asPromise = function asPromise(arg) {
    return hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
  };
  var isPromise = function isPromise(arg) {
    return arg && Promise.resolve(arg) === arg;
  };

  var DismissReason = Object.freeze({
    cancel: 'cancel',
    backdrop: 'backdrop',
    close: 'close',
    esc: 'esc',
    timer: 'timer'
  });

  var isJqueryElement = function isJqueryElement(elem) {
    return _typeof(elem) === 'object' && elem.jquery;
  };

  var isElement = function isElement(elem) {
    return elem instanceof Element || isJqueryElement(elem);
  };

  var argsToParams = function argsToParams(args) {
    var params = {};

    if (_typeof(args[0]) === 'object' && !isElement(args[0])) {
      _extends(params, args[0]);
    } else {
      ['title', 'html', 'icon'].forEach(function (name, index) {
        var arg = args[index];

        if (typeof arg === 'string' || isElement(arg)) {
          params[name] = arg;
        } else if (arg !== undefined) {
          error("Unexpected type of ".concat(name, "! Expected \"string\" or \"Element\", got ").concat(_typeof(arg)));
        }
      });
    }

    return params;
  };

  var swalPrefix = 'swal2-';
  var prefix = function prefix(items) {
    var result = {};

    for (var i in items) {
      result[items[i]] = swalPrefix + items[i];
    }

    return result;
  };
  var swalClasses = prefix(['container', 'shown', 'height-auto', 'iosfix', 'popup', 'modal', 'no-backdrop', 'no-transition', 'toast', 'toast-shown', 'show', 'hide', 'close', 'title', 'header', 'content', 'html-container', 'actions', 'confirm', 'deny', 'cancel', 'footer', 'icon', 'icon-content', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'label', 'textarea', 'inputerror', 'input-label', 'validation-message', 'progress-steps', 'active-progress-step', 'progress-step', 'progress-step-line', 'loader', 'loading', 'styled', 'top', 'top-start', 'top-end', 'top-left', 'top-right', 'center', 'center-start', 'center-end', 'center-left', 'center-right', 'bottom', 'bottom-start', 'bottom-end', 'bottom-left', 'bottom-right', 'grow-row', 'grow-column', 'grow-fullscreen', 'rtl', 'timer-progress-bar', 'timer-progress-bar-container', 'scrollbar-measure', 'icon-success', 'icon-warning', 'icon-info', 'icon-question', 'icon-error']);
  var iconTypes = prefix(['success', 'warning', 'info', 'question', 'error']);

  var getContainer = function getContainer() {
    return document.body.querySelector(".".concat(swalClasses.container));
  };
  var elementBySelector = function elementBySelector(selectorString) {
    var container = getContainer();
    return container ? container.querySelector(selectorString) : null;
  };

  var elementByClass = function elementByClass(className) {
    return elementBySelector(".".concat(className));
  };

  var getPopup = function getPopup() {
    return elementByClass(swalClasses.popup);
  };
  var getIcon = function getIcon() {
    return elementByClass(swalClasses.icon);
  };
  var getTitle = function getTitle() {
    return elementByClass(swalClasses.title);
  };
  var getContent = function getContent() {
    return elementByClass(swalClasses.content);
  };
  var getHtmlContainer = function getHtmlContainer() {
    return elementByClass(swalClasses['html-container']);
  };
  var getImage = function getImage() {
    return elementByClass(swalClasses.image);
  };
  var getProgressSteps = function getProgressSteps() {
    return elementByClass(swalClasses['progress-steps']);
  };
  var getValidationMessage = function getValidationMessage() {
    return elementByClass(swalClasses['validation-message']);
  };
  var getConfirmButton = function getConfirmButton() {
    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.confirm));
  };
  var getDenyButton = function getDenyButton() {
    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.deny));
  };
  var getInputLabel = function getInputLabel() {
    return elementByClass(swalClasses['input-label']);
  };
  var getLoader = function getLoader() {
    return elementBySelector(".".concat(swalClasses.loader));
  };
  var getCancelButton = function getCancelButton() {
    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.cancel));
  };
  var getActions = function getActions() {
    return elementByClass(swalClasses.actions);
  };
  var getHeader = function getHeader() {
    return elementByClass(swalClasses.header);
  };
  var getFooter = function getFooter() {
    return elementByClass(swalClasses.footer);
  };
  var getTimerProgressBar = function getTimerProgressBar() {
    return elementByClass(swalClasses['timer-progress-bar']);
  };
  var getCloseButton = function getCloseButton() {
    return elementByClass(swalClasses.close);
  }; // https://github.com/jkup/focusable/blob/master/index.js

  var focusable = "\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex=\"0\"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n";
  var getFocusableElements = function getFocusableElements() {
    var focusableElementsWithTabindex = toArray(getPopup().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])')) // sort according to tabindex
    .sort(function (a, b) {
      a = parseInt(a.getAttribute('tabindex'));
      b = parseInt(b.getAttribute('tabindex'));

      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      }

      return 0;
    });
    var otherFocusableElements = toArray(getPopup().querySelectorAll(focusable)).filter(function (el) {
      return el.getAttribute('tabindex') !== '-1';
    });
    return uniqueArray(focusableElementsWithTabindex.concat(otherFocusableElements)).filter(function (el) {
      return isVisible(el);
    });
  };
  var isModal = function isModal() {
    return !isToast() && !document.body.classList.contains(swalClasses['no-backdrop']);
  };
  var isToast = function isToast() {
    return document.body.classList.contains(swalClasses['toast-shown']);
  };
  var isLoading = function isLoading() {
    return getPopup().hasAttribute('data-loading');
  };

  var states = {
    previousBodyPadding: null
  };
  var setInnerHtml = function setInnerHtml(elem, html) {
    // #1926
    elem.textContent = '';

    if (html) {
      var parser = new DOMParser();
      var parsed = parser.parseFromString(html, "text/html");
      toArray(parsed.querySelector('head').childNodes).forEach(function (child) {
        elem.appendChild(child);
      });
      toArray(parsed.querySelector('body').childNodes).forEach(function (child) {
        elem.appendChild(child);
      });
    }
  };
  var hasClass = function hasClass(elem, className) {
    if (!className) {
      return false;
    }

    var classList = className.split(/\s+/);

    for (var i = 0; i < classList.length; i++) {
      if (!elem.classList.contains(classList[i])) {
        return false;
      }
    }

    return true;
  };

  var removeCustomClasses = function removeCustomClasses(elem, params) {
    toArray(elem.classList).forEach(function (className) {
      if (!(objectValues(swalClasses).indexOf(className) !== -1) && !(objectValues(iconTypes).indexOf(className) !== -1) && !(objectValues(params.showClass).indexOf(className) !== -1)) {
        elem.classList.remove(className);
      }
    });
  };

  var applyCustomClass = function applyCustomClass(elem, params, className) {
    removeCustomClasses(elem, params);

    if (params.customClass && params.customClass[className]) {
      if (typeof params.customClass[className] !== 'string' && !params.customClass[className].forEach) {
        return warn("Invalid type of customClass.".concat(className, "! Expected string or iterable object, got \"").concat(_typeof(params.customClass[className]), "\""));
      }

      addClass(elem, params.customClass[className]);
    }
  };
  function getInput(content, inputType) {
    if (!inputType) {
      return null;
    }

    switch (inputType) {
      case 'select':
      case 'textarea':
      case 'file':
        return getChildByClass(content, swalClasses[inputType]);

      case 'checkbox':
        return content.querySelector(".".concat(swalClasses.checkbox, " input"));

      case 'radio':
        return content.querySelector(".".concat(swalClasses.radio, " input:checked")) || content.querySelector(".".concat(swalClasses.radio, " input:first-child"));

      case 'range':
        return content.querySelector(".".concat(swalClasses.range, " input"));

      default:
        return getChildByClass(content, swalClasses.input);
    }
  }
  var focusInput = function focusInput(input) {
    input.focus(); // place cursor at end of text in text input

    if (input.type !== 'file') {
      // http://stackoverflow.com/a/2345915
      var val = input.value;
      input.value = '';
      input.value = val;
    }
  };
  var toggleClass = function toggleClass(target, classList, condition) {
    if (!target || !classList) {
      return;
    }

    if (typeof classList === 'string') {
      classList = classList.split(/\s+/).filter(Boolean);
    }

    classList.forEach(function (className) {
      if (target.forEach) {
        target.forEach(function (elem) {
          condition ? elem.classList.add(className) : elem.classList.remove(className);
        });
      } else {
        condition ? target.classList.add(className) : target.classList.remove(className);
      }
    });
  };
  var addClass = function addClass(target, classList) {
    toggleClass(target, classList, true);
  };
  var removeClass = function removeClass(target, classList) {
    toggleClass(target, classList, false);
  };
  var getChildByClass = function getChildByClass(elem, className) {
    for (var i = 0; i < elem.childNodes.length; i++) {
      if (hasClass(elem.childNodes[i], className)) {
        return elem.childNodes[i];
      }
    }
  };
  var applyNumericalStyle = function applyNumericalStyle(elem, property, value) {
    if (value === "".concat(parseInt(value))) {
      value = parseInt(value);
    }

    if (value || parseInt(value) === 0) {
      elem.style[property] = typeof value === 'number' ? "".concat(value, "px") : value;
    } else {
      elem.style.removeProperty(property);
    }
  };
  var show = function show(elem) {
    var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
    elem.style.display = display;
  };
  var hide = function hide(elem) {
    elem.style.display = 'none';
  };
  var setStyle = function setStyle(parent, selector, property, value) {
    var el = parent.querySelector(selector);

    if (el) {
      el.style[property] = value;
    }
  };
  var toggle = function toggle(elem, condition, display) {
    condition ? show(elem, display) : hide(elem);
  }; // borrowed from jquery $(elem).is(':visible') implementation

  var isVisible = function isVisible(elem) {
    return !!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
  };
  var allButtonsAreHidden = function allButtonsAreHidden() {
    return !isVisible(getConfirmButton()) && !isVisible(getDenyButton()) && !isVisible(getCancelButton());
  };
  var isScrollable = function isScrollable(elem) {
    return !!(elem.scrollHeight > elem.clientHeight);
  }; // borrowed from https://stackoverflow.com/a/46352119

  var hasCssAnimation = function hasCssAnimation(elem) {
    var style = window.getComputedStyle(elem);
    var animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
    var transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
    return animDuration > 0 || transDuration > 0;
  };
  var contains = function contains(haystack, needle) {
    if (typeof haystack.contains === 'function') {
      return haystack.contains(needle);
    }
  };
  var animateTimerProgressBar = function animateTimerProgressBar(timer) {
    var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var timerProgressBar = getTimerProgressBar();

    if (isVisible(timerProgressBar)) {
      if (reset) {
        timerProgressBar.style.transition = 'none';
        timerProgressBar.style.width = '100%';
      }

      setTimeout(function () {
        timerProgressBar.style.transition = "width ".concat(timer / 1000, "s linear");
        timerProgressBar.style.width = '0%';
      }, 10);
    }
  };
  var stopTimerProgressBar = function stopTimerProgressBar() {
    var timerProgressBar = getTimerProgressBar();
    var timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
    timerProgressBar.style.removeProperty('transition');
    timerProgressBar.style.width = '100%';
    var timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
    var timerProgressBarPercent = parseInt(timerProgressBarWidth / timerProgressBarFullWidth * 100);
    timerProgressBar.style.removeProperty('transition');
    timerProgressBar.style.width = "".concat(timerProgressBarPercent, "%");
  };

  // Detect Node env
  var isNodeEnv = function isNodeEnv() {
    return typeof window === 'undefined' || typeof document === 'undefined';
  };

  var sweetHTML = "\n <div aria-labelledby=\"".concat(swalClasses.title, "\" aria-describedby=\"").concat(swalClasses.content, "\" class=\"").concat(swalClasses.popup, "\" tabindex=\"-1\">\n   <div class=\"").concat(swalClasses.header, "\">\n     <ul class=\"").concat(swalClasses['progress-steps'], "\"></ul>\n     <div class=\"").concat(swalClasses.icon, "\"></div>\n     <img class=\"").concat(swalClasses.image, "\" />\n     <h2 class=\"").concat(swalClasses.title, "\" id=\"").concat(swalClasses.title, "\"></h2>\n     <button type=\"button\" class=\"").concat(swalClasses.close, "\"></button>\n   </div>\n   <div class=\"").concat(swalClasses.content, "\">\n     <div id=\"").concat(swalClasses.content, "\" class=\"").concat(swalClasses['html-container'], "\"></div>\n     <input class=\"").concat(swalClasses.input, "\" />\n     <input type=\"file\" class=\"").concat(swalClasses.file, "\" />\n     <div class=\"").concat(swalClasses.range, "\">\n       <input type=\"range\" />\n       <output></output>\n     </div>\n     <select class=\"").concat(swalClasses.select, "\"></select>\n     <div class=\"").concat(swalClasses.radio, "\"></div>\n     <label for=\"").concat(swalClasses.checkbox, "\" class=\"").concat(swalClasses.checkbox, "\">\n       <input type=\"checkbox\" />\n       <span class=\"").concat(swalClasses.label, "\"></span>\n     </label>\n     <textarea class=\"").concat(swalClasses.textarea, "\"></textarea>\n     <div class=\"").concat(swalClasses['validation-message'], "\" id=\"").concat(swalClasses['validation-message'], "\"></div>\n   </div>\n   <div class=\"").concat(swalClasses.actions, "\">\n     <div class=\"").concat(swalClasses.loader, "\"></div>\n     <button type=\"button\" class=\"").concat(swalClasses.confirm, "\"></button>\n     <button type=\"button\" class=\"").concat(swalClasses.deny, "\"></button>\n     <button type=\"button\" class=\"").concat(swalClasses.cancel, "\"></button>\n   </div>\n   <div class=\"").concat(swalClasses.footer, "\"></div>\n   <div class=\"").concat(swalClasses['timer-progress-bar-container'], "\">\n     <div class=\"").concat(swalClasses['timer-progress-bar'], "\"></div>\n   </div>\n </div>\n").replace(/(^|\n)\s*/g, '');

  var resetOldContainer = function resetOldContainer() {
    var oldContainer = getContainer();

    if (!oldContainer) {
      return false;
    }

    oldContainer.parentNode.removeChild(oldContainer);
    removeClass([document.documentElement, document.body], [swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['has-column']]);
    return true;
  };

  var oldInputVal; // IE11 workaround, see #1109 for details

  var resetValidationMessage = function resetValidationMessage(e) {
    if (Swal.isVisible() && oldInputVal !== e.target.value) {
      Swal.resetValidationMessage();
    }

    oldInputVal = e.target.value;
  };

  var addInputChangeListeners = function addInputChangeListeners() {
    var content = getContent();
    var input = getChildByClass(content, swalClasses.input);
    var file = getChildByClass(content, swalClasses.file);
    var range = content.querySelector(".".concat(swalClasses.range, " input"));
    var rangeOutput = content.querySelector(".".concat(swalClasses.range, " output"));
    var select = getChildByClass(content, swalClasses.select);
    var checkbox = content.querySelector(".".concat(swalClasses.checkbox, " input"));
    var textarea = getChildByClass(content, swalClasses.textarea);
    input.oninput = resetValidationMessage;
    file.onchange = resetValidationMessage;
    select.onchange = resetValidationMessage;
    checkbox.onchange = resetValidationMessage;
    textarea.oninput = resetValidationMessage;

    range.oninput = function (e) {
      resetValidationMessage(e);
      rangeOutput.value = range.value;
    };

    range.onchange = function (e) {
      resetValidationMessage(e);
      range.nextSibling.value = range.value;
    };
  };

  var getTarget = function getTarget(target) {
    return typeof target === 'string' ? document.querySelector(target) : target;
  };

  var setupAccessibility = function setupAccessibility(params) {
    var popup = getPopup();
    popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
    popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');

    if (!params.toast) {
      popup.setAttribute('aria-modal', 'true');
    }
  };

  var setupRTL = function setupRTL(targetElement) {
    if (window.getComputedStyle(targetElement).direction === 'rtl') {
      addClass(getContainer(), swalClasses.rtl);
    }
  };
  /*
   * Add modal + backdrop to DOM
   */


  var init = function init(params) {
    // Clean up the old popup container if it exists
    var oldContainerExisted = resetOldContainer();
    /* istanbul ignore if */

    if (isNodeEnv()) {
      error('SweetAlert2 requires document to initialize');
      return;
    }

    var container = document.createElement('div');
    container.className = swalClasses.container;

    if (oldContainerExisted) {
      addClass(container, swalClasses['no-transition']);
    }

    setInnerHtml(container, sweetHTML);
    var targetElement = getTarget(params.target);
    targetElement.appendChild(container);
    setupAccessibility(params);
    setupRTL(targetElement);
    addInputChangeListeners();
  };

  var parseHtmlToContainer = function parseHtmlToContainer(param, target) {
    // DOM element
    if (param instanceof HTMLElement) {
      target.appendChild(param); // Object
    } else if (_typeof(param) === 'object') {
      handleObject(param, target); // Plain string
    } else if (param) {
      setInnerHtml(target, param);
    }
  };

  var handleObject = function handleObject(param, target) {
    // JQuery element(s)
    if (param.jquery) {
      handleJqueryElem(target, param); // For other objects use their string representation
    } else {
      setInnerHtml(target, param.toString());
    }
  };

  var handleJqueryElem = function handleJqueryElem(target, elem) {
    target.textContent = '';

    if (0 in elem) {
      for (var i = 0; (i in elem); i++) {
        target.appendChild(elem[i].cloneNode(true));
      }
    } else {
      target.appendChild(elem.cloneNode(true));
    }
  };

  var animationEndEvent = function () {
    // Prevent run in Node env

    /* istanbul ignore if */
    if (isNodeEnv()) {
      return false;
    }

    var testEl = document.createElement('div');
    var transEndEventNames = {
      WebkitAnimation: 'webkitAnimationEnd',
      OAnimation: 'oAnimationEnd oanimationend',
      animation: 'animationend'
    };

    for (var i in transEndEventNames) {
      if (Object.prototype.hasOwnProperty.call(transEndEventNames, i) && typeof testEl.style[i] !== 'undefined') {
        return transEndEventNames[i];
      }
    }

    return false;
  }();

  // https://github.com/twbs/bootstrap/blob/master/js/src/modal.js

  var measureScrollbar = function measureScrollbar() {
    var scrollDiv = document.createElement('div');
    scrollDiv.className = swalClasses['scrollbar-measure'];
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  };

  var renderActions = function renderActions(instance, params) {
    var actions = getActions();
    var loader = getLoader();
    var confirmButton = getConfirmButton();
    var denyButton = getDenyButton();
    var cancelButton = getCancelButton(); // Actions (buttons) wrapper

    if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) {
      hide(actions);
    } // Custom class


    applyCustomClass(actions, params, 'actions'); // Render buttons

    renderButton(confirmButton, 'confirm', params);
    renderButton(denyButton, 'deny', params);
    renderButton(cancelButton, 'cancel', params);
    handleButtonsStyling(confirmButton, denyButton, cancelButton, params);

    if (params.reverseButtons) {
      actions.insertBefore(cancelButton, loader);
      actions.insertBefore(denyButton, loader);
      actions.insertBefore(confirmButton, loader);
    } // Loader


    setInnerHtml(loader, params.loaderHtml);
    applyCustomClass(loader, params, 'loader');
  };

  function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
    if (!params.buttonsStyling) {
      return removeClass([confirmButton, denyButton, cancelButton], swalClasses.styled);
    }

    addClass([confirmButton, denyButton, cancelButton], swalClasses.styled); // Buttons background colors

    if (params.confirmButtonColor) {
      confirmButton.style.backgroundColor = params.confirmButtonColor;
    }

    if (params.denyButtonColor) {
      denyButton.style.backgroundColor = params.denyButtonColor;
    }

    if (params.cancelButtonColor) {
      cancelButton.style.backgroundColor = params.cancelButtonColor;
    }
  }

  function renderButton(button, buttonType, params) {
    toggle(button, params["show".concat(capitalizeFirstLetter(buttonType), "Button")], 'inline-block');
    setInnerHtml(button, params["".concat(buttonType, "ButtonText")]); // Set caption text

    button.setAttribute('aria-label', params["".concat(buttonType, "ButtonAriaLabel")]); // ARIA label
    // Add buttons custom classes

    button.className = swalClasses[buttonType];
    applyCustomClass(button, params, "".concat(buttonType, "Button"));
    addClass(button, params["".concat(buttonType, "ButtonClass")]);
  }

  function handleBackdropParam(container, backdrop) {
    if (typeof backdrop === 'string') {
      container.style.background = backdrop;
    } else if (!backdrop) {
      addClass([document.documentElement, document.body], swalClasses['no-backdrop']);
    }
  }

  function handlePositionParam(container, position) {
    if (position in swalClasses) {
      addClass(container, swalClasses[position]);
    } else {
      warn('The "position" parameter is not valid, defaulting to "center"');
      addClass(container, swalClasses.center);
    }
  }

  function handleGrowParam(container, grow) {
    if (grow && typeof grow === 'string') {
      var growClass = "grow-".concat(grow);

      if (growClass in swalClasses) {
        addClass(container, swalClasses[growClass]);
      }
    }
  }

  var renderContainer = function renderContainer(instance, params) {
    var container = getContainer();

    if (!container) {
      return;
    }

    handleBackdropParam(container, params.backdrop);

    if (!params.backdrop && params.allowOutsideClick) {
      warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
    }

    handlePositionParam(container, params.position);
    handleGrowParam(container, params.grow); // Custom class

    applyCustomClass(container, params, 'container'); // Set queue step attribute for getQueueStep() method

    var queueStep = document.body.getAttribute('data-swal2-queue-step');

    if (queueStep) {
      container.setAttribute('data-queue-step', queueStep);
      document.body.removeAttribute('data-swal2-queue-step');
    }
  };

  /**
   * This module containts `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */
  var privateProps = {
    promise: new WeakMap(),
    innerParams: new WeakMap(),
    domCache: new WeakMap()
  };

  var inputTypes = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];
  var renderInput = function renderInput(instance, params) {
    var content = getContent();
    var innerParams = privateProps.innerParams.get(instance);
    var rerender = !innerParams || params.input !== innerParams.input;
    inputTypes.forEach(function (inputType) {
      var inputClass = swalClasses[inputType];
      var inputContainer = getChildByClass(content, inputClass); // set attributes

      setAttributes(inputType, params.inputAttributes); // set class

      inputContainer.className = inputClass;

      if (rerender) {
        hide(inputContainer);
      }
    });

    if (params.input) {
      if (rerender) {
        showInput(params);
      } // set custom class


      setCustomClass(params);
    }
  };

  var showInput = function showInput(params) {
    if (!renderInputType[params.input]) {
      return error("Unexpected type of input! Expected \"text\", \"email\", \"password\", \"number\", \"tel\", \"select\", \"radio\", \"checkbox\", \"textarea\", \"file\" or \"url\", got \"".concat(params.input, "\""));
    }

    var inputContainer = getInputContainer(params.input);
    var input = renderInputType[params.input](inputContainer, params);
    show(input); // input autofocus

    setTimeout(function () {
      focusInput(input);
    });
  };

  var removeAttributes = function removeAttributes(input) {
    for (var i = 0; i < input.attributes.length; i++) {
      var attrName = input.attributes[i].name;

      if (!(['type', 'value', 'style'].indexOf(attrName) !== -1)) {
        input.removeAttribute(attrName);
      }
    }
  };

  var setAttributes = function setAttributes(inputType, inputAttributes) {
    var input = getInput(getContent(), inputType);

    if (!input) {
      return;
    }

    removeAttributes(input);

    for (var attr in inputAttributes) {
      // Do not set a placeholder for <input type="range">
      // it'll crash Edge, #1298
      if (inputType === 'range' && attr === 'placeholder') {
        continue;
      }

      input.setAttribute(attr, inputAttributes[attr]);
    }
  };

  var setCustomClass = function setCustomClass(params) {
    var inputContainer = getInputContainer(params.input);

    if (params.customClass) {
      addClass(inputContainer, params.customClass.input);
    }
  };

  var setInputPlaceholder = function setInputPlaceholder(input, params) {
    if (!input.placeholder || params.inputPlaceholder) {
      input.placeholder = params.inputPlaceholder;
    }
  };

  var setInputLabel = function setInputLabel(input, prependTo, params) {
    if (params.inputLabel) {
      input.id = swalClasses.input;
      var label = document.createElement('label');
      var labelClass = swalClasses['input-label'];
      label.setAttribute('for', input.id);
      label.className = labelClass;
      addClass(label, params.customClass.inputLabel);
      label.innerText = params.inputLabel;
      prependTo.insertAdjacentElement('beforebegin', label);
    }
  };

  var getInputContainer = function getInputContainer(inputType) {
    var inputClass = swalClasses[inputType] ? swalClasses[inputType] : swalClasses.input;
    return getChildByClass(getContent(), inputClass);
  };

  var renderInputType = {};

  renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = function (input, params) {
    if (typeof params.inputValue === 'string' || typeof params.inputValue === 'number') {
      input.value = params.inputValue;
    } else if (!isPromise(params.inputValue)) {
      warn("Unexpected type of inputValue! Expected \"string\", \"number\" or \"Promise\", got \"".concat(_typeof(params.inputValue), "\""));
    }

    setInputLabel(input, input, params);
    setInputPlaceholder(input, params);
    input.type = params.input;
    return input;
  };

  renderInputType.file = function (input, params) {
    setInputLabel(input, input, params);
    setInputPlaceholder(input, params);
    return input;
  };

  renderInputType.range = function (range, params) {
    var rangeInput = range.querySelector('input');
    var rangeOutput = range.querySelector('output');
    rangeInput.value = params.inputValue;
    rangeInput.type = params.input;
    rangeOutput.value = params.inputValue;
    setInputLabel(rangeInput, range, params);
    return range;
  };

  renderInputType.select = function (select, params) {
    select.textContent = '';

    if (params.inputPlaceholder) {
      var placeholder = document.createElement('option');
      setInnerHtml(placeholder, params.inputPlaceholder);
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.selected = true;
      select.appendChild(placeholder);
    }

    setInputLabel(select, select, params);
    return select;
  };

  renderInputType.radio = function (radio) {
    radio.textContent = '';
    return radio;
  };

  renderInputType.checkbox = function (checkboxContainer, params) {
    var checkbox = getInput(getContent(), 'checkbox');
    checkbox.value = 1;
    checkbox.id = swalClasses.checkbox;
    checkbox.checked = Boolean(params.inputValue);
    var label = checkboxContainer.querySelector('span');
    setInnerHtml(label, params.inputPlaceholder);
    return checkboxContainer;
  };

  renderInputType.textarea = function (textarea, params) {
    textarea.value = params.inputValue;
    setInputPlaceholder(textarea, params);
    setInputLabel(textarea, textarea, params);

    var getPadding = function getPadding(el) {
      return parseInt(window.getComputedStyle(el).paddingLeft) + parseInt(window.getComputedStyle(el).paddingRight);
    };

    if ('MutationObserver' in window) {
      // #1699
      var initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);

      var outputsize = function outputsize() {
        var contentWidth = textarea.offsetWidth + getPadding(getPopup()) + getPadding(getContent());

        if (contentWidth > initialPopupWidth) {
          getPopup().style.width = "".concat(contentWidth, "px");
        } else {
          getPopup().style.width = null;
        }
      };

      new MutationObserver(outputsize).observe(textarea, {
        attributes: true,
        attributeFilter: ['style']
      });
    }

    return textarea;
  };

  var renderContent = function renderContent(instance, params) {
    var htmlContainer = getHtmlContainer();
    applyCustomClass(htmlContainer, params, 'htmlContainer'); // Content as HTML

    if (params.html) {
      parseHtmlToContainer(params.html, htmlContainer);
      show(htmlContainer, 'block'); // Content as plain text
    } else if (params.text) {
      htmlContainer.textContent = params.text;
      show(htmlContainer, 'block'); // No content
    } else {
      hide(htmlContainer);
    }

    renderInput(instance, params); // Custom class

    applyCustomClass(getContent(), params, 'content');
  };

  var renderFooter = function renderFooter(instance, params) {
    var footer = getFooter();
    toggle(footer, params.footer);

    if (params.footer) {
      parseHtmlToContainer(params.footer, footer);
    } // Custom class


    applyCustomClass(footer, params, 'footer');
  };

  var renderCloseButton = function renderCloseButton(instance, params) {
    var closeButton = getCloseButton();
    setInnerHtml(closeButton, params.closeButtonHtml); // Custom class

    applyCustomClass(closeButton, params, 'closeButton');
    toggle(closeButton, params.showCloseButton);
    closeButton.setAttribute('aria-label', params.closeButtonAriaLabel);
  };

  var renderIcon = function renderIcon(instance, params) {
    var innerParams = privateProps.innerParams.get(instance);
    var icon = getIcon(); // if the given icon already rendered, apply the styling without re-rendering the icon

    if (innerParams && params.icon === innerParams.icon) {
      // Custom or default content
      setContent(icon, params);
      applyStyles(icon, params);
      return;
    }

    if (!params.icon && !params.iconHtml) {
      return hide(icon);
    }

    if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
      error("Unknown icon! Expected \"success\", \"error\", \"warning\", \"info\" or \"question\", got \"".concat(params.icon, "\""));
      return hide(icon);
    }

    show(icon); // Custom or default content

    setContent(icon, params);
    applyStyles(icon, params); // Animate icon

    addClass(icon, params.showClass.icon);
  };

  var applyStyles = function applyStyles(icon, params) {
    for (var iconType in iconTypes) {
      if (params.icon !== iconType) {
        removeClass(icon, iconTypes[iconType]);
      }
    }

    addClass(icon, iconTypes[params.icon]); // Icon color

    setColor(icon, params); // Success icon background color

    adjustSuccessIconBackgoundColor(); // Custom class

    applyCustomClass(icon, params, 'icon');
  }; // Adjust success icon background color to match the popup background color


  var adjustSuccessIconBackgoundColor = function adjustSuccessIconBackgoundColor() {
    var popup = getPopup();
    var popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
    var successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');

    for (var i = 0; i < successIconParts.length; i++) {
      successIconParts[i].style.backgroundColor = popupBackgroundColor;
    }
  };

  var setContent = function setContent(icon, params) {
    icon.textContent = '';

    if (params.iconHtml) {
      setInnerHtml(icon, iconContent(params.iconHtml));
    } else if (params.icon === 'success') {
      setInnerHtml(icon, "\n      <div class=\"swal2-success-circular-line-left\"></div>\n      <span class=\"swal2-success-line-tip\"></span> <span class=\"swal2-success-line-long\"></span>\n      <div class=\"swal2-success-ring\"></div> <div class=\"swal2-success-fix\"></div>\n      <div class=\"swal2-success-circular-line-right\"></div>\n    ");
    } else if (params.icon === 'error') {
      setInnerHtml(icon, "\n      <span class=\"swal2-x-mark\">\n        <span class=\"swal2-x-mark-line-left\"></span>\n        <span class=\"swal2-x-mark-line-right\"></span>\n      </span>\n    ");
    } else {
      var defaultIconHtml = {
        question: '?',
        warning: '!',
        info: 'i'
      };
      setInnerHtml(icon, iconContent(defaultIconHtml[params.icon]));
    }
  };

  var setColor = function setColor(icon, params) {
    if (!params.iconColor) {
      return;
    }

    icon.style.color = params.iconColor;
    icon.style.borderColor = params.iconColor;

    for (var _i = 0, _arr = ['.swal2-success-line-tip', '.swal2-success-line-long', '.swal2-x-mark-line-left', '.swal2-x-mark-line-right']; _i < _arr.length; _i++) {
      var sel = _arr[_i];
      setStyle(icon, sel, 'backgroundColor', params.iconColor);
    }

    setStyle(icon, '.swal2-success-ring', 'borderColor', params.iconColor);
  };

  var iconContent = function iconContent(content) {
    return "<div class=\"".concat(swalClasses['icon-content'], "\">").concat(content, "</div>");
  };

  var renderImage = function renderImage(instance, params) {
    var image = getImage();

    if (!params.imageUrl) {
      return hide(image);
    }

    show(image, ''); // Src, alt

    image.setAttribute('src', params.imageUrl);
    image.setAttribute('alt', params.imageAlt); // Width, height

    applyNumericalStyle(image, 'width', params.imageWidth);
    applyNumericalStyle(image, 'height', params.imageHeight); // Class

    image.className = swalClasses.image;
    applyCustomClass(image, params, 'image');
  };

  var currentSteps = [];
  /*
   * Global function for chaining sweetAlert popups
   */

  var queue = function queue(steps) {
    warnAboutDeprecation('Swal.queue()', "async/await");
    var Swal = this;
    currentSteps = steps;

    var resetAndResolve = function resetAndResolve(resolve, value) {
      currentSteps = [];
      resolve(value);
    };

    var queueResult = [];
    return new Promise(function (resolve) {
      (function step(i, callback) {
        if (i < currentSteps.length) {
          document.body.setAttribute('data-swal2-queue-step', i);
          Swal.fire(currentSteps[i]).then(function (result) {
            if (typeof result.value !== 'undefined') {
              queueResult.push(result.value);
              step(i + 1, callback);
            } else {
              resetAndResolve(resolve, {
                dismiss: result.dismiss
              });
            }
          });
        } else {
          resetAndResolve(resolve, {
            value: queueResult
          });
        }
      })(0);
    });
  };
  /*
   * Global function for getting the index of current popup in queue
   */

  var getQueueStep = function getQueueStep() {
    return getContainer() && getContainer().getAttribute('data-queue-step');
  };
  /*
   * Global function for inserting a popup to the queue
   */

  var insertQueueStep = function insertQueueStep(step, index) {
    if (index && index < currentSteps.length) {
      return currentSteps.splice(index, 0, step);
    }

    return currentSteps.push(step);
  };
  /*
   * Global function for deleting a popup from the queue
   */

  var deleteQueueStep = function deleteQueueStep(index) {
    if (typeof currentSteps[index] !== 'undefined') {
      currentSteps.splice(index, 1);
    }
  };

  var createStepElement = function createStepElement(step) {
    var stepEl = document.createElement('li');
    addClass(stepEl, swalClasses['progress-step']);
    setInnerHtml(stepEl, step);
    return stepEl;
  };

  var createLineElement = function createLineElement(params) {
    var lineEl = document.createElement('li');
    addClass(lineEl, swalClasses['progress-step-line']);

    if (params.progressStepsDistance) {
      lineEl.style.width = params.progressStepsDistance;
    }

    return lineEl;
  };

  var renderProgressSteps = function renderProgressSteps(instance, params) {
    var progressStepsContainer = getProgressSteps();

    if (!params.progressSteps || params.progressSteps.length === 0) {
      return hide(progressStepsContainer);
    }

    show(progressStepsContainer);
    progressStepsContainer.textContent = '';
    var currentProgressStep = parseInt(params.currentProgressStep === undefined ? getQueueStep() : params.currentProgressStep);

    if (currentProgressStep >= params.progressSteps.length) {
      warn('Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
    }

    params.progressSteps.forEach(function (step, index) {
      var stepEl = createStepElement(step);
      progressStepsContainer.appendChild(stepEl);

      if (index === currentProgressStep) {
        addClass(stepEl, swalClasses['active-progress-step']);
      }

      if (index !== params.progressSteps.length - 1) {
        var lineEl = createLineElement(params);
        progressStepsContainer.appendChild(lineEl);
      }
    });
  };

  var renderTitle = function renderTitle(instance, params) {
    var title = getTitle();
    toggle(title, params.title || params.titleText, 'block');

    if (params.title) {
      parseHtmlToContainer(params.title, title);
    }

    if (params.titleText) {
      title.innerText = params.titleText;
    } // Custom class


    applyCustomClass(title, params, 'title');
  };

  var renderHeader = function renderHeader(instance, params) {
    var header = getHeader(); // Custom class

    applyCustomClass(header, params, 'header'); // Progress steps

    renderProgressSteps(instance, params); // Icon

    renderIcon(instance, params); // Image

    renderImage(instance, params); // Title

    renderTitle(instance, params); // Close button

    renderCloseButton(instance, params);
  };

  var renderPopup = function renderPopup(instance, params) {
    var container = getContainer();
    var popup = getPopup(); // Width

    if (params.toast) {
      // #2170
      applyNumericalStyle(container, 'width', params.width);
      popup.style.width = '100%';
    } else {
      applyNumericalStyle(popup, 'width', params.width);
    } // Padding


    applyNumericalStyle(popup, 'padding', params.padding); // Background

    if (params.background) {
      popup.style.background = params.background;
    }

    hide(getValidationMessage()); // Classes

    addClasses(popup, params);
  };

  var addClasses = function addClasses(popup, params) {
    // Default Class + showClass when updating Swal.update({})
    popup.className = "".concat(swalClasses.popup, " ").concat(isVisible(popup) ? params.showClass.popup : '');

    if (params.toast) {
      addClass([document.documentElement, document.body], swalClasses['toast-shown']);
      addClass(popup, swalClasses.toast);
    } else {
      addClass(popup, swalClasses.modal);
    } // Custom class


    applyCustomClass(popup, params, 'popup');

    if (typeof params.customClass === 'string') {
      addClass(popup, params.customClass);
    } // Icon class (#1842)


    if (params.icon) {
      addClass(popup, swalClasses["icon-".concat(params.icon)]);
    }
  };

  var render = function render(instance, params) {
    renderPopup(instance, params);
    renderContainer(instance, params);
    renderHeader(instance, params);
    renderContent(instance, params);
    renderActions(instance, params);
    renderFooter(instance, params);

    if (typeof params.didRender === 'function') {
      params.didRender(getPopup());
    } else if (typeof params.onRender === 'function') {
      params.onRender(getPopup()); // @deprecated
    }
  };

  /*
   * Global function to determine if SweetAlert2 popup is shown
   */

  var isVisible$1 = function isVisible$$1() {
    return isVisible(getPopup());
  };
  /*
   * Global function to click 'Confirm' button
   */

  var clickConfirm = function clickConfirm() {
    return getConfirmButton() && getConfirmButton().click();
  };
  /*
   * Global function to click 'Deny' button
   */

  var clickDeny = function clickDeny() {
    return getDenyButton() && getDenyButton().click();
  };
  /*
   * Global function to click 'Cancel' button
   */

  var clickCancel = function clickCancel() {
    return getCancelButton() && getCancelButton().click();
  };

  function fire() {
    var Swal = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _construct(Swal, args);
  }

  /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param mixinParams
   */
  function mixin(mixinParams) {
    var MixinSwal = /*#__PURE__*/function (_this) {
      _inherits(MixinSwal, _this);

      var _super = _createSuper(MixinSwal);

      function MixinSwal() {
        _classCallCheck(this, MixinSwal);

        return _super.apply(this, arguments);
      }

      _createClass(MixinSwal, [{
        key: "_main",
        value: function _main(params, priorityMixinParams) {
          return _get(_getPrototypeOf(MixinSwal.prototype), "_main", this).call(this, params, _extends({}, mixinParams, priorityMixinParams));
        }
      }]);

      return MixinSwal;
    }(this);

    return MixinSwal;
  }

  /**
   * Shows loader (spinner), this is useful with AJAX requests.
   * By default the loader be shown instead of the "Confirm" button.
   */

  var showLoading = function showLoading(buttonToReplace) {
    var popup = getPopup();

    if (!popup) {
      Swal.fire();
    }

    popup = getPopup();
    var actions = getActions();
    var loader = getLoader();

    if (!buttonToReplace && isVisible(getConfirmButton())) {
      buttonToReplace = getConfirmButton();
    }

    show(actions);

    if (buttonToReplace) {
      hide(buttonToReplace);
      loader.setAttribute('data-button-to-replace', buttonToReplace.className);
    }

    loader.parentNode.insertBefore(loader, buttonToReplace);
    addClass([popup, actions], swalClasses.loading);
    show(loader);
    popup.setAttribute('data-loading', true);
    popup.setAttribute('aria-busy', true);
    popup.focus();
  };

  var RESTORE_FOCUS_TIMEOUT = 100;

  var globalState = {};

  var focusPreviousActiveElement = function focusPreviousActiveElement() {
    if (globalState.previousActiveElement && globalState.previousActiveElement.focus) {
      globalState.previousActiveElement.focus();
      globalState.previousActiveElement = null;
    } else if (document.body) {
      document.body.focus();
    }
  }; // Restore previous active (focused) element


  var restoreActiveElement = function restoreActiveElement(returnFocus) {
    return new Promise(function (resolve) {
      if (!returnFocus) {
        return resolve();
      }

      var x = window.scrollX;
      var y = window.scrollY;
      globalState.restoreFocusTimeout = setTimeout(function () {
        focusPreviousActiveElement();
        resolve();
      }, RESTORE_FOCUS_TIMEOUT); // issues/900

      if (typeof x !== 'undefined' && typeof y !== 'undefined') {
        // IE doesn't have scrollX/scrollY support
        window.scrollTo(x, y);
      }
    });
  };

  /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   */

  var getTimerLeft = function getTimerLeft() {
    return globalState.timeout && globalState.timeout.getTimerLeft();
  };
  /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   */

  var stopTimer = function stopTimer() {
    if (globalState.timeout) {
      stopTimerProgressBar();
      return globalState.timeout.stop();
    }
  };
  /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   */

  var resumeTimer = function resumeTimer() {
    if (globalState.timeout) {
      var remaining = globalState.timeout.start();
      animateTimerProgressBar(remaining);
      return remaining;
    }
  };
  /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   */

  var toggleTimer = function toggleTimer() {
    var timer = globalState.timeout;
    return timer && (timer.running ? stopTimer() : resumeTimer());
  };
  /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   */

  var increaseTimer = function increaseTimer(n) {
    if (globalState.timeout) {
      var remaining = globalState.timeout.increase(n);
      animateTimerProgressBar(remaining, true);
      return remaining;
    }
  };
  /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   */

  var isTimerRunning = function isTimerRunning() {
    return globalState.timeout && globalState.timeout.isRunning();
  };

  var bodyClickListenerAdded = false;
  var clickHandlers = {};
  function bindClickHandler() {
    var attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-swal-template';
    clickHandlers[attr] = this;

    if (!bodyClickListenerAdded) {
      document.body.addEventListener('click', bodyClickListener);
      bodyClickListenerAdded = true;
    }
  }

  var bodyClickListener = function bodyClickListener(event) {
    // 1. using .parentNode instead of event.path because of better support by old browsers https://stackoverflow.com/a/39245638
    // 2. using .parentNode instead of .parentElement because of IE11 + SVG https://stackoverflow.com/a/36270354
    for (var el = event.target; el && el !== document; el = el.parentNode) {
      for (var attr in clickHandlers) {
        var template = el.getAttribute(attr);

        if (template) {
          clickHandlers[attr].fire({
            template: template
          });
          return;
        }
      }
    }
  };

  var defaultParams = {
    title: '',
    titleText: '',
    text: '',
    html: '',
    footer: '',
    icon: undefined,
    iconColor: undefined,
    iconHtml: undefined,
    template: undefined,
    toast: false,
    animation: true,
    showClass: {
      popup: 'swal2-show',
      backdrop: 'swal2-backdrop-show',
      icon: 'swal2-icon-show'
    },
    hideClass: {
      popup: 'swal2-hide',
      backdrop: 'swal2-backdrop-hide',
      icon: 'swal2-icon-hide'
    },
    customClass: {},
    target: 'body',
    backdrop: true,
    heightAuto: true,
    allowOutsideClick: true,
    allowEscapeKey: true,
    allowEnterKey: true,
    stopKeydownPropagation: true,
    keydownListenerCapture: false,
    showConfirmButton: true,
    showDenyButton: false,
    showCancelButton: false,
    preConfirm: undefined,
    preDeny: undefined,
    confirmButtonText: 'OK',
    confirmButtonAriaLabel: '',
    confirmButtonColor: undefined,
    denyButtonText: 'No',
    denyButtonAriaLabel: '',
    denyButtonColor: undefined,
    cancelButtonText: 'Cancel',
    cancelButtonAriaLabel: '',
    cancelButtonColor: undefined,
    buttonsStyling: true,
    reverseButtons: false,
    focusConfirm: true,
    focusDeny: false,
    focusCancel: false,
    returnFocus: true,
    showCloseButton: false,
    closeButtonHtml: '&times;',
    closeButtonAriaLabel: 'Close this dialog',
    loaderHtml: '',
    showLoaderOnConfirm: false,
    showLoaderOnDeny: false,
    imageUrl: undefined,
    imageWidth: undefined,
    imageHeight: undefined,
    imageAlt: '',
    timer: undefined,
    timerProgressBar: false,
    width: undefined,
    padding: undefined,
    background: undefined,
    input: undefined,
    inputPlaceholder: '',
    inputLabel: '',
    inputValue: '',
    inputOptions: {},
    inputAutoTrim: true,
    inputAttributes: {},
    inputValidator: undefined,
    returnInputValueOnDeny: false,
    validationMessage: undefined,
    grow: false,
    position: 'center',
    progressSteps: [],
    currentProgressStep: undefined,
    progressStepsDistance: undefined,
    onBeforeOpen: undefined,
    onOpen: undefined,
    willOpen: undefined,
    didOpen: undefined,
    onRender: undefined,
    didRender: undefined,
    onClose: undefined,
    onAfterClose: undefined,
    willClose: undefined,
    didClose: undefined,
    onDestroy: undefined,
    didDestroy: undefined,
    scrollbarPadding: true
  };
  var updatableParams = ['allowEscapeKey', 'allowOutsideClick', 'background', 'buttonsStyling', 'cancelButtonAriaLabel', 'cancelButtonColor', 'cancelButtonText', 'closeButtonAriaLabel', 'closeButtonHtml', 'confirmButtonAriaLabel', 'confirmButtonColor', 'confirmButtonText', 'currentProgressStep', 'customClass', 'denyButtonAriaLabel', 'denyButtonColor', 'denyButtonText', 'didClose', 'didDestroy', 'footer', 'hideClass', 'html', 'icon', 'iconColor', 'iconHtml', 'imageAlt', 'imageHeight', 'imageUrl', 'imageWidth', 'onAfterClose', 'onClose', 'onDestroy', 'progressSteps', 'returnFocus', 'reverseButtons', 'showCancelButton', 'showCloseButton', 'showConfirmButton', 'showDenyButton', 'text', 'title', 'titleText', 'willClose'];
  var deprecatedParams = {
    animation: 'showClass" and "hideClass',
    onBeforeOpen: 'willOpen',
    onOpen: 'didOpen',
    onRender: 'didRender',
    onClose: 'willClose',
    onAfterClose: 'didClose',
    onDestroy: 'didDestroy'
  };
  var toastIncompatibleParams = ['allowOutsideClick', 'allowEnterKey', 'backdrop', 'focusConfirm', 'focusDeny', 'focusCancel', 'returnFocus', 'heightAuto', 'keydownListenerCapture'];
  /**
   * Is valid parameter
   * @param {String} paramName
   */

  var isValidParameter = function isValidParameter(paramName) {
    return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
  };
  /**
   * Is valid parameter for Swal.update() method
   * @param {String} paramName
   */

  var isUpdatableParameter = function isUpdatableParameter(paramName) {
    return updatableParams.indexOf(paramName) !== -1;
  };
  /**
   * Is deprecated parameter
   * @param {String} paramName
   */

  var isDeprecatedParameter = function isDeprecatedParameter(paramName) {
    return deprecatedParams[paramName];
  };

  var checkIfParamIsValid = function checkIfParamIsValid(param) {
    if (!isValidParameter(param)) {
      warn("Unknown parameter \"".concat(param, "\""));
    }
  };

  var checkIfToastParamIsValid = function checkIfToastParamIsValid(param) {
    if (toastIncompatibleParams.indexOf(param) !== -1) {
      warn("The parameter \"".concat(param, "\" is incompatible with toasts"));
    }
  };

  var checkIfParamIsDeprecated = function checkIfParamIsDeprecated(param) {
    if (isDeprecatedParameter(param)) {
      warnAboutDeprecation(param, isDeprecatedParameter(param));
    }
  };
  /**
   * Show relevant warnings for given params
   *
   * @param params
   */


  var showWarningsForParams = function showWarningsForParams(params) {
    for (var param in params) {
      checkIfParamIsValid(param);

      if (params.toast) {
        checkIfToastParamIsValid(param);
      }

      checkIfParamIsDeprecated(param);
    }
  };



  var staticMethods = /*#__PURE__*/Object.freeze({
    isValidParameter: isValidParameter,
    isUpdatableParameter: isUpdatableParameter,
    isDeprecatedParameter: isDeprecatedParameter,
    argsToParams: argsToParams,
    isVisible: isVisible$1,
    clickConfirm: clickConfirm,
    clickDeny: clickDeny,
    clickCancel: clickCancel,
    getContainer: getContainer,
    getPopup: getPopup,
    getTitle: getTitle,
    getContent: getContent,
    getHtmlContainer: getHtmlContainer,
    getImage: getImage,
    getIcon: getIcon,
    getInputLabel: getInputLabel,
    getCloseButton: getCloseButton,
    getActions: getActions,
    getConfirmButton: getConfirmButton,
    getDenyButton: getDenyButton,
    getCancelButton: getCancelButton,
    getLoader: getLoader,
    getHeader: getHeader,
    getFooter: getFooter,
    getTimerProgressBar: getTimerProgressBar,
    getFocusableElements: getFocusableElements,
    getValidationMessage: getValidationMessage,
    isLoading: isLoading,
    fire: fire,
    mixin: mixin,
    queue: queue,
    getQueueStep: getQueueStep,
    insertQueueStep: insertQueueStep,
    deleteQueueStep: deleteQueueStep,
    showLoading: showLoading,
    enableLoading: showLoading,
    getTimerLeft: getTimerLeft,
    stopTimer: stopTimer,
    resumeTimer: resumeTimer,
    toggleTimer: toggleTimer,
    increaseTimer: increaseTimer,
    isTimerRunning: isTimerRunning,
    bindClickHandler: bindClickHandler
  });

  /**
   * Hides loader and shows back the button which was hidden by .showLoading()
   */

  function hideLoading() {
    // do nothing if popup is closed
    var innerParams = privateProps.innerParams.get(this);

    if (!innerParams) {
      return;
    }

    var domCache = privateProps.domCache.get(this);
    hide(domCache.loader);
    var buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute('data-button-to-replace'));

    if (buttonToReplace.length) {
      show(buttonToReplace[0], 'inline-block');
    } else if (allButtonsAreHidden()) {
      hide(domCache.actions);
    }

    removeClass([domCache.popup, domCache.actions], swalClasses.loading);
    domCache.popup.removeAttribute('aria-busy');
    domCache.popup.removeAttribute('data-loading');
    domCache.confirmButton.disabled = false;
    domCache.denyButton.disabled = false;
    domCache.cancelButton.disabled = false;
  }

  function getInput$1(instance) {
    var innerParams = privateProps.innerParams.get(instance || this);
    var domCache = privateProps.domCache.get(instance || this);

    if (!domCache) {
      return null;
    }

    return getInput(domCache.content, innerParams.input);
  }

  var fixScrollbar = function fixScrollbar() {
    // for queues, do not do this more than once
    if (states.previousBodyPadding !== null) {
      return;
    } // if the body has overflow


    if (document.body.scrollHeight > window.innerHeight) {
      // add padding so the content doesn't shift after removal of scrollbar
      states.previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
      document.body.style.paddingRight = "".concat(states.previousBodyPadding + measureScrollbar(), "px");
    }
  };
  var undoScrollbar = function undoScrollbar() {
    if (states.previousBodyPadding !== null) {
      document.body.style.paddingRight = "".concat(states.previousBodyPadding, "px");
      states.previousBodyPadding = null;
    }
  };

  /* istanbul ignore file */

  var iOSfix = function iOSfix() {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
      var offset = document.body.scrollTop;
      document.body.style.top = "".concat(offset * -1, "px");
      addClass(document.body, swalClasses.iosfix);
      lockBodyScroll();
      addBottomPaddingForTallPopups(); // #1948
    }
  };

  var addBottomPaddingForTallPopups = function addBottomPaddingForTallPopups() {
    var safari = !navigator.userAgent.match(/(CriOS|FxiOS|EdgiOS|YaBrowser|UCBrowser)/i);

    if (safari) {
      var bottomPanelHeight = 44;

      if (getPopup().scrollHeight > window.innerHeight - bottomPanelHeight) {
        getContainer().style.paddingBottom = "".concat(bottomPanelHeight, "px");
      }
    }
  };

  var lockBodyScroll = function lockBodyScroll() {
    // #1246
    var container = getContainer();
    var preventTouchMove;

    container.ontouchstart = function (e) {
      preventTouchMove = shouldPreventTouchMove(e);
    };

    container.ontouchmove = function (e) {
      if (preventTouchMove) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
  };

  var shouldPreventTouchMove = function shouldPreventTouchMove(event) {
    var target = event.target;
    var container = getContainer();

    if (isStylys(event) || isZoom(event)) {
      return false;
    }

    if (target === container) {
      return true;
    }

    if (!isScrollable(container) && target.tagName !== 'INPUT' && // #1603
    !(isScrollable(getContent()) && // #1944
    getContent().contains(target))) {
      return true;
    }

    return false;
  };

  var isStylys = function isStylys(event) {
    // #1786
    return event.touches && event.touches.length && event.touches[0].touchType === 'stylus';
  };

  var isZoom = function isZoom(event) {
    // #1891
    return event.touches && event.touches.length > 1;
  };

  var undoIOSfix = function undoIOSfix() {
    if (hasClass(document.body, swalClasses.iosfix)) {
      var offset = parseInt(document.body.style.top, 10);
      removeClass(document.body, swalClasses.iosfix);
      document.body.style.top = '';
      document.body.scrollTop = offset * -1;
    }
  };

  /* istanbul ignore file */

  var isIE11 = function isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
  }; // Fix IE11 centering sweetalert2/issues/933


  var fixVerticalPositionIE = function fixVerticalPositionIE() {
    var container = getContainer();
    var popup = getPopup();
    container.style.removeProperty('align-items');

    if (popup.offsetTop < 0) {
      container.style.alignItems = 'flex-start';
    }
  };

  var IEfix = function IEfix() {
    if (typeof window !== 'undefined' && isIE11()) {
      fixVerticalPositionIE();
      window.addEventListener('resize', fixVerticalPositionIE);
    }
  };
  var undoIEfix = function undoIEfix() {
    if (typeof window !== 'undefined' && isIE11()) {
      window.removeEventListener('resize', fixVerticalPositionIE);
    }
  };

  // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
  // elements not within the active modal dialog will not be surfaced if a user opens a screen
  // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.

  var setAriaHidden = function setAriaHidden() {
    var bodyChildren = toArray(document.body.children);
    bodyChildren.forEach(function (el) {
      if (el === getContainer() || contains(el, getContainer())) {
        return;
      }

      if (el.hasAttribute('aria-hidden')) {
        el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden'));
      }

      el.setAttribute('aria-hidden', 'true');
    });
  };
  var unsetAriaHidden = function unsetAriaHidden() {
    var bodyChildren = toArray(document.body.children);
    bodyChildren.forEach(function (el) {
      if (el.hasAttribute('data-previous-aria-hidden')) {
        el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden'));
        el.removeAttribute('data-previous-aria-hidden');
      } else {
        el.removeAttribute('aria-hidden');
      }
    });
  };

  /**
   * This module containts `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */
  var privateMethods = {
    swalPromiseResolve: new WeakMap()
  };

  /*
   * Instance method to close sweetAlert
   */

  function removePopupAndResetState(instance, container, returnFocus, didClose) {
    if (isToast()) {
      triggerDidCloseAndDispose(instance, didClose);
    } else {
      restoreActiveElement(returnFocus).then(function () {
        return triggerDidCloseAndDispose(instance, didClose);
      });
      globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = false;
    }

    if (container.parentNode && !document.body.getAttribute('data-swal2-queue-step')) {
      container.parentNode.removeChild(container);
    }

    if (isModal()) {
      undoScrollbar();
      undoIOSfix();
      undoIEfix();
      unsetAriaHidden();
    }

    removeBodyClasses();
  }

  function removeBodyClasses() {
    removeClass([document.documentElement, document.body], [swalClasses.shown, swalClasses['height-auto'], swalClasses['no-backdrop'], swalClasses['toast-shown']]);
  }

  function close(resolveValue) {
    var popup = getPopup();

    if (!popup) {
      return;
    }

    resolveValue = prepareResolveValue(resolveValue);
    var innerParams = privateProps.innerParams.get(this);

    if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) {
      return;
    }

    var swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
    removeClass(popup, innerParams.showClass.popup);
    addClass(popup, innerParams.hideClass.popup);
    var backdrop = getContainer();
    removeClass(backdrop, innerParams.showClass.backdrop);
    addClass(backdrop, innerParams.hideClass.backdrop);
    handlePopupAnimation(this, popup, innerParams); // Resolve Swal promise

    swalPromiseResolve(resolveValue);
  }

  var prepareResolveValue = function prepareResolveValue(resolveValue) {
    // When user calls Swal.close()
    if (typeof resolveValue === 'undefined') {
      return {
        isConfirmed: false,
        isDenied: false,
        isDismissed: true
      };
    }

    return _extends({
      isConfirmed: false,
      isDenied: false,
      isDismissed: false
    }, resolveValue);
  };

  var handlePopupAnimation = function handlePopupAnimation(instance, popup, innerParams) {
    var container = getContainer(); // If animation is supported, animate

    var animationIsSupported = animationEndEvent && hasCssAnimation(popup);
    var onClose = innerParams.onClose,
        onAfterClose = innerParams.onAfterClose,
        willClose = innerParams.willClose,
        didClose = innerParams.didClose;
    runDidClose(popup, willClose, onClose);

    if (animationIsSupported) {
      animatePopup(instance, popup, container, innerParams.returnFocus, didClose || onAfterClose);
    } else {
      // Otherwise, remove immediately
      removePopupAndResetState(instance, container, innerParams.returnFocus, didClose || onAfterClose);
    }
  };

  var runDidClose = function runDidClose(popup, willClose, onClose) {
    if (willClose !== null && typeof willClose === 'function') {
      willClose(popup);
    } else if (onClose !== null && typeof onClose === 'function') {
      onClose(popup); // @deprecated
    }
  };

  var animatePopup = function animatePopup(instance, popup, container, returnFocus, didClose) {
    globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
    popup.addEventListener(animationEndEvent, function (e) {
      if (e.target === popup) {
        globalState.swalCloseEventFinishedCallback();
        delete globalState.swalCloseEventFinishedCallback;
      }
    });
  };

  var triggerDidCloseAndDispose = function triggerDidCloseAndDispose(instance, didClose) {
    setTimeout(function () {
      if (typeof didClose === 'function') {
        didClose();
      }

      instance._destroy();
    });
  };

  function setButtonsDisabled(instance, buttons, disabled) {
    var domCache = privateProps.domCache.get(instance);
    buttons.forEach(function (button) {
      domCache[button].disabled = disabled;
    });
  }

  function setInputDisabled(input, disabled) {
    if (!input) {
      return false;
    }

    if (input.type === 'radio') {
      var radiosContainer = input.parentNode.parentNode;
      var radios = radiosContainer.querySelectorAll('input');

      for (var i = 0; i < radios.length; i++) {
        radios[i].disabled = disabled;
      }
    } else {
      input.disabled = disabled;
    }
  }

  function enableButtons() {
    setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], false);
  }
  function disableButtons() {
    setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], true);
  }
  function enableInput() {
    return setInputDisabled(this.getInput(), false);
  }
  function disableInput() {
    return setInputDisabled(this.getInput(), true);
  }

  function showValidationMessage(error) {
    var domCache = privateProps.domCache.get(this);
    var params = privateProps.innerParams.get(this);
    setInnerHtml(domCache.validationMessage, error);
    domCache.validationMessage.className = swalClasses['validation-message'];

    if (params.customClass && params.customClass.validationMessage) {
      addClass(domCache.validationMessage, params.customClass.validationMessage);
    }

    show(domCache.validationMessage);
    var input = this.getInput();

    if (input) {
      input.setAttribute('aria-invalid', true);
      input.setAttribute('aria-describedBy', swalClasses['validation-message']);
      focusInput(input);
      addClass(input, swalClasses.inputerror);
    }
  } // Hide block with validation message

  function resetValidationMessage$1() {
    var domCache = privateProps.domCache.get(this);

    if (domCache.validationMessage) {
      hide(domCache.validationMessage);
    }

    var input = this.getInput();

    if (input) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedBy');
      removeClass(input, swalClasses.inputerror);
    }
  }

  function getProgressSteps$1() {
    var domCache = privateProps.domCache.get(this);
    return domCache.progressSteps;
  }

  var Timer = /*#__PURE__*/function () {
    function Timer(callback, delay) {
      _classCallCheck(this, Timer);

      this.callback = callback;
      this.remaining = delay;
      this.running = false;
      this.start();
    }

    _createClass(Timer, [{
      key: "start",
      value: function start() {
        if (!this.running) {
          this.running = true;
          this.started = new Date();
          this.id = setTimeout(this.callback, this.remaining);
        }

        return this.remaining;
      }
    }, {
      key: "stop",
      value: function stop() {
        if (this.running) {
          this.running = false;
          clearTimeout(this.id);
          this.remaining -= new Date() - this.started;
        }

        return this.remaining;
      }
    }, {
      key: "increase",
      value: function increase(n) {
        var running = this.running;

        if (running) {
          this.stop();
        }

        this.remaining += n;

        if (running) {
          this.start();
        }

        return this.remaining;
      }
    }, {
      key: "getTimerLeft",
      value: function getTimerLeft() {
        if (this.running) {
          this.stop();
          this.start();
        }

        return this.remaining;
      }
    }, {
      key: "isRunning",
      value: function isRunning() {
        return this.running;
      }
    }]);

    return Timer;
  }();

  var defaultInputValidators = {
    email: function email(string, validationMessage) {
      return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
    },
    url: function url(string, validationMessage) {
      // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
      return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
    }
  };

  function setDefaultInputValidators(params) {
    // Use default `inputValidator` for supported input types if not provided
    if (!params.inputValidator) {
      Object.keys(defaultInputValidators).forEach(function (key) {
        if (params.input === key) {
          params.inputValidator = defaultInputValidators[key];
        }
      });
    }
  }

  function validateCustomTargetElement(params) {
    // Determine if the custom target element is valid
    if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
      warn('Target parameter is not valid, defaulting to "body"');
      params.target = 'body';
    }
  }
  /**
   * Set type, text and actions on popup
   *
   * @param params
   * @returns {boolean}
   */


  function setParameters(params) {
    setDefaultInputValidators(params); // showLoaderOnConfirm && preConfirm

    if (params.showLoaderOnConfirm && !params.preConfirm) {
      warn('showLoaderOnConfirm is set to true, but preConfirm is not defined.\n' + 'showLoaderOnConfirm should be used together with preConfirm, see usage example:\n' + 'https://sweetalert2.github.io/#ajax-request');
    } // params.animation will be actually used in renderPopup.js
    // but in case when params.animation is a function, we need to call that function
    // before popup (re)initialization, so it'll be possible to check Swal.isVisible()
    // inside the params.animation function


    params.animation = callIfFunction(params.animation);
    validateCustomTargetElement(params); // Replace newlines with <br> in title

    if (typeof params.title === 'string') {
      params.title = params.title.split('\n').join('<br />');
    }

    init(params);
  }

  var swalStringParams = ['swal-title', 'swal-html', 'swal-footer'];
  var getTemplateParams = function getTemplateParams(params) {
    var template = typeof params.template === 'string' ? document.querySelector(params.template) : params.template;

    if (!template) {
      return {};
    }

    var templateContent = template.content || template; // IE11

    showWarningsForElements(templateContent);

    var result = _extends(getSwalParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));

    return result;
  };

  var getSwalParams = function getSwalParams(templateContent) {
    var result = {};
    toArray(templateContent.querySelectorAll('swal-param')).forEach(function (param) {
      showWarningsForAttributes(param, ['name', 'value']);
      var paramName = param.getAttribute('name');
      var value = param.getAttribute('value');

      if (typeof defaultParams[paramName] === 'boolean' && value === 'false') {
        value = false;
      }

      if (_typeof(defaultParams[paramName]) === 'object') {
        value = JSON.parse(value);
      }

      result[paramName] = value;
    });
    return result;
  };

  var getSwalButtons = function getSwalButtons(templateContent) {
    var result = {};
    toArray(templateContent.querySelectorAll('swal-button')).forEach(function (button) {
      showWarningsForAttributes(button, ['type', 'color', 'aria-label']);
      var type = button.getAttribute('type');
      result["".concat(type, "ButtonText")] = button.innerHTML;
      result["show".concat(capitalizeFirstLetter(type), "Button")] = true;

      if (button.hasAttribute('color')) {
        result["".concat(type, "ButtonColor")] = button.getAttribute('color');
      }

      if (button.hasAttribute('aria-label')) {
        result["".concat(type, "ButtonAriaLabel")] = button.getAttribute('aria-label');
      }
    });
    return result;
  };

  var getSwalImage = function getSwalImage(templateContent) {
    var result = {};
    var image = templateContent.querySelector('swal-image');

    if (image) {
      showWarningsForAttributes(image, ['src', 'width', 'height', 'alt']);

      if (image.hasAttribute('src')) {
        result.imageUrl = image.getAttribute('src');
      }

      if (image.hasAttribute('width')) {
        result.imageWidth = image.getAttribute('width');
      }

      if (image.hasAttribute('height')) {
        result.imageHeight = image.getAttribute('height');
      }

      if (image.hasAttribute('alt')) {
        result.imageAlt = image.getAttribute('alt');
      }
    }

    return result;
  };

  var getSwalIcon = function getSwalIcon(templateContent) {
    var result = {};
    var icon = templateContent.querySelector('swal-icon');

    if (icon) {
      showWarningsForAttributes(icon, ['type', 'color']);

      if (icon.hasAttribute('type')) {
        result.icon = icon.getAttribute('type');
      }

      if (icon.hasAttribute('color')) {
        result.iconColor = icon.getAttribute('color');
      }

      result.iconHtml = icon.innerHTML;
    }

    return result;
  };

  var getSwalInput = function getSwalInput(templateContent) {
    var result = {};
    var input = templateContent.querySelector('swal-input');

    if (input) {
      showWarningsForAttributes(input, ['type', 'label', 'placeholder', 'value']);
      result.input = input.getAttribute('type') || 'text';

      if (input.hasAttribute('label')) {
        result.inputLabel = input.getAttribute('label');
      }

      if (input.hasAttribute('placeholder')) {
        result.inputPlaceholder = input.getAttribute('placeholder');
      }

      if (input.hasAttribute('value')) {
        result.inputValue = input.getAttribute('value');
      }
    }

    var inputOptions = templateContent.querySelectorAll('swal-input-option');

    if (inputOptions.length) {
      result.inputOptions = {};
      toArray(inputOptions).forEach(function (option) {
        showWarningsForAttributes(option, ['value']);
        var optionValue = option.getAttribute('value');
        var optionName = option.innerHTML;
        result.inputOptions[optionValue] = optionName;
      });
    }

    return result;
  };

  var getSwalStringParams = function getSwalStringParams(templateContent, paramNames) {
    var result = {};

    for (var i in paramNames) {
      var paramName = paramNames[i];
      var tag = templateContent.querySelector(paramName);

      if (tag) {
        showWarningsForAttributes(tag, []);
        result[paramName.replace(/^swal-/, '')] = tag.innerHTML.trim();
      }
    }

    return result;
  };

  var showWarningsForElements = function showWarningsForElements(template) {
    var allowedElements = swalStringParams.concat(['swal-param', 'swal-button', 'swal-image', 'swal-icon', 'swal-input', 'swal-input-option']);
    toArray(template.querySelectorAll('*')).forEach(function (el) {
      if (el.parentNode !== template) {
        // can't use template.children because of IE11
        return;
      }

      var tagName = el.tagName.toLowerCase();

      if (allowedElements.indexOf(tagName) === -1) {
        warn("Unrecognized element <".concat(tagName, ">"));
      }
    });
  };

  var showWarningsForAttributes = function showWarningsForAttributes(el, allowedAttributes) {
    toArray(el.attributes).forEach(function (attribute) {
      if (allowedAttributes.indexOf(attribute.name) === -1) {
        warn(["Unrecognized attribute \"".concat(attribute.name, "\" on <").concat(el.tagName.toLowerCase(), ">."), "".concat(allowedAttributes.length ? "Allowed attributes are: ".concat(allowedAttributes.join(', ')) : 'To set the value, use HTML within the element.')]);
      }
    });
  };

  var SHOW_CLASS_TIMEOUT = 10;
  /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param params
   */

  var openPopup = function openPopup(params) {
    var container = getContainer();
    var popup = getPopup();

    if (typeof params.willOpen === 'function') {
      params.willOpen(popup);
    } else if (typeof params.onBeforeOpen === 'function') {
      params.onBeforeOpen(popup); // @deprecated
    }

    var bodyStyles = window.getComputedStyle(document.body);
    var initialBodyOverflow = bodyStyles.overflowY;
    addClasses$1(container, popup, params); // scrolling is 'hidden' until animation is done, after that 'auto'

    setTimeout(function () {
      setScrollingVisibility(container, popup);
    }, SHOW_CLASS_TIMEOUT);

    if (isModal()) {
      fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
      setAriaHidden();
    }

    if (!isToast() && !globalState.previousActiveElement) {
      globalState.previousActiveElement = document.activeElement;
    }

    runDidOpen(popup, params);
    removeClass(container, swalClasses['no-transition']);
  };

  var runDidOpen = function runDidOpen(popup, params) {
    if (typeof params.didOpen === 'function') {
      setTimeout(function () {
        return params.didOpen(popup);
      });
    } else if (typeof params.onOpen === 'function') {
      setTimeout(function () {
        return params.onOpen(popup);
      }); // @deprecated
    }
  };

  var swalOpenAnimationFinished = function swalOpenAnimationFinished(event) {
    var popup = getPopup();

    if (event.target !== popup) {
      return;
    }

    var container = getContainer();
    popup.removeEventListener(animationEndEvent, swalOpenAnimationFinished);
    container.style.overflowY = 'auto';
  };

  var setScrollingVisibility = function setScrollingVisibility(container, popup) {
    if (animationEndEvent && hasCssAnimation(popup)) {
      container.style.overflowY = 'hidden';
      popup.addEventListener(animationEndEvent, swalOpenAnimationFinished);
    } else {
      container.style.overflowY = 'auto';
    }
  };

  var fixScrollContainer = function fixScrollContainer(container, scrollbarPadding, initialBodyOverflow) {
    iOSfix();
    IEfix();

    if (scrollbarPadding && initialBodyOverflow !== 'hidden') {
      fixScrollbar();
    } // sweetalert2/issues/1247


    setTimeout(function () {
      container.scrollTop = 0;
    });
  };

  var addClasses$1 = function addClasses(container, popup, params) {
    addClass(container, params.showClass.backdrop); // the workaround with setting/unsetting opacity is needed for #2019 and 2059

    popup.style.setProperty('opacity', '0', 'important');
    show(popup);
    setTimeout(function () {
      // Animate popup right after showing it
      addClass(popup, params.showClass.popup); // and remove the opacity workaround

      popup.style.removeProperty('opacity');
    }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062

    addClass([document.documentElement, document.body], swalClasses.shown);

    if (params.heightAuto && params.backdrop && !params.toast) {
      addClass([document.documentElement, document.body], swalClasses['height-auto']);
    }
  };

  var handleInputOptionsAndValue = function handleInputOptionsAndValue(instance, params) {
    if (params.input === 'select' || params.input === 'radio') {
      handleInputOptions(instance, params);
    } else if (['text', 'email', 'number', 'tel', 'textarea'].indexOf(params.input) !== -1 && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
      handleInputValue(instance, params);
    }
  };
  var getInputValue = function getInputValue(instance, innerParams) {
    var input = instance.getInput();

    if (!input) {
      return null;
    }

    switch (innerParams.input) {
      case 'checkbox':
        return getCheckboxValue(input);

      case 'radio':
        return getRadioValue(input);

      case 'file':
        return getFileValue(input);

      default:
        return innerParams.inputAutoTrim ? input.value.trim() : input.value;
    }
  };

  var getCheckboxValue = function getCheckboxValue(input) {
    return input.checked ? 1 : 0;
  };

  var getRadioValue = function getRadioValue(input) {
    return input.checked ? input.value : null;
  };

  var getFileValue = function getFileValue(input) {
    return input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
  };

  var handleInputOptions = function handleInputOptions(instance, params) {
    var content = getContent();

    var processInputOptions = function processInputOptions(inputOptions) {
      return populateInputOptions[params.input](content, formatInputOptions(inputOptions), params);
    };

    if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
      showLoading(getConfirmButton());
      asPromise(params.inputOptions).then(function (inputOptions) {
        instance.hideLoading();
        processInputOptions(inputOptions);
      });
    } else if (_typeof(params.inputOptions) === 'object') {
      processInputOptions(params.inputOptions);
    } else {
      error("Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(_typeof(params.inputOptions)));
    }
  };

  var handleInputValue = function handleInputValue(instance, params) {
    var input = instance.getInput();
    hide(input);
    asPromise(params.inputValue).then(function (inputValue) {
      input.value = params.input === 'number' ? parseFloat(inputValue) || 0 : "".concat(inputValue);
      show(input);
      input.focus();
      instance.hideLoading();
    })["catch"](function (err) {
      error("Error in inputValue promise: ".concat(err));
      input.value = '';
      show(input);
      input.focus();
      instance.hideLoading();
    });
  };

  var populateInputOptions = {
    select: function select(content, inputOptions, params) {
      var select = getChildByClass(content, swalClasses.select);

      var renderOption = function renderOption(parent, optionLabel, optionValue) {
        var option = document.createElement('option');
        option.value = optionValue;
        setInnerHtml(option, optionLabel);
        option.selected = isSelected(optionValue, params.inputValue);
        parent.appendChild(option);
      };

      inputOptions.forEach(function (inputOption) {
        var optionValue = inputOption[0];
        var optionLabel = inputOption[1]; // <optgroup> spec:
        // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
        // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
        // check whether this is a <optgroup>

        if (Array.isArray(optionLabel)) {
          // if it is an array, then it is an <optgroup>
          var optgroup = document.createElement('optgroup');
          optgroup.label = optionValue;
          optgroup.disabled = false; // not configurable for now

          select.appendChild(optgroup);
          optionLabel.forEach(function (o) {
            return renderOption(optgroup, o[1], o[0]);
          });
        } else {
          // case of <option>
          renderOption(select, optionLabel, optionValue);
        }
      });
      select.focus();
    },
    radio: function radio(content, inputOptions, params) {
      var radio = getChildByClass(content, swalClasses.radio);
      inputOptions.forEach(function (inputOption) {
        var radioValue = inputOption[0];
        var radioLabel = inputOption[1];
        var radioInput = document.createElement('input');
        var radioLabelElement = document.createElement('label');
        radioInput.type = 'radio';
        radioInput.name = swalClasses.radio;
        radioInput.value = radioValue;

        if (isSelected(radioValue, params.inputValue)) {
          radioInput.checked = true;
        }

        var label = document.createElement('span');
        setInnerHtml(label, radioLabel);
        label.className = swalClasses.label;
        radioLabelElement.appendChild(radioInput);
        radioLabelElement.appendChild(label);
        radio.appendChild(radioLabelElement);
      });
      var radios = radio.querySelectorAll('input');

      if (radios.length) {
        radios[0].focus();
      }
    }
  };
  /**
   * Converts `inputOptions` into an array of `[value, label]`s
   * @param inputOptions
   */

  var formatInputOptions = function formatInputOptions(inputOptions) {
    var result = [];

    if (typeof Map !== 'undefined' && inputOptions instanceof Map) {
      inputOptions.forEach(function (value, key) {
        var valueFormatted = value;

        if (_typeof(valueFormatted) === 'object') {
          // case of <optgroup>
          valueFormatted = formatInputOptions(valueFormatted);
        }

        result.push([key, valueFormatted]);
      });
    } else {
      Object.keys(inputOptions).forEach(function (key) {
        var valueFormatted = inputOptions[key];

        if (_typeof(valueFormatted) === 'object') {
          // case of <optgroup>
          valueFormatted = formatInputOptions(valueFormatted);
        }

        result.push([key, valueFormatted]);
      });
    }

    return result;
  };

  var isSelected = function isSelected(optionValue, inputValue) {
    return inputValue && inputValue.toString() === optionValue.toString();
  };

  var handleConfirmButtonClick = function handleConfirmButtonClick(instance, innerParams) {
    instance.disableButtons();

    if (innerParams.input) {
      handleConfirmOrDenyWithInput(instance, innerParams, 'confirm');
    } else {
      confirm(instance, innerParams, true);
    }
  };
  var handleDenyButtonClick = function handleDenyButtonClick(instance, innerParams) {
    instance.disableButtons();

    if (innerParams.returnInputValueOnDeny) {
      handleConfirmOrDenyWithInput(instance, innerParams, 'deny');
    } else {
      deny(instance, innerParams, false);
    }
  };
  var handleCancelButtonClick = function handleCancelButtonClick(instance, dismissWith) {
    instance.disableButtons();
    dismissWith(DismissReason.cancel);
  };

  var handleConfirmOrDenyWithInput = function handleConfirmOrDenyWithInput(instance, innerParams, type
  /* type is either 'confirm' or 'deny' */
  ) {
    var inputValue = getInputValue(instance, innerParams);

    if (innerParams.inputValidator) {
      handleInputValidator(instance, innerParams, inputValue);
    } else if (!instance.getInput().checkValidity()) {
      instance.enableButtons();
      instance.showValidationMessage(innerParams.validationMessage);
    } else if (type === 'deny') {
      deny(instance, innerParams, inputValue);
    } else {
      confirm(instance, innerParams, inputValue);
    }
  };

  var handleInputValidator = function handleInputValidator(instance, innerParams, inputValue) {
    instance.disableInput();
    var validationPromise = Promise.resolve().then(function () {
      return asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage));
    });
    validationPromise.then(function (validationMessage) {
      instance.enableButtons();
      instance.enableInput();

      if (validationMessage) {
        instance.showValidationMessage(validationMessage);
      } else {
        confirm(instance, innerParams, inputValue);
      }
    });
  };

  var deny = function deny(instance, innerParams, value) {
    if (innerParams.showLoaderOnDeny) {
      showLoading(getDenyButton());
    }

    if (innerParams.preDeny) {
      var preDenyPromise = Promise.resolve().then(function () {
        return asPromise(innerParams.preDeny(value, innerParams.validationMessage));
      });
      preDenyPromise.then(function (preDenyValue) {
        if (preDenyValue === false) {
          instance.hideLoading();
        } else {
          instance.closePopup({
            isDenied: true,
            value: typeof preDenyValue === 'undefined' ? value : preDenyValue
          });
        }
      });
    } else {
      instance.closePopup({
        isDenied: true,
        value: value
      });
    }
  };

  var succeedWith = function succeedWith(instance, value) {
    instance.closePopup({
      isConfirmed: true,
      value: value
    });
  };

  var confirm = function confirm(instance, innerParams, value) {
    if (innerParams.showLoaderOnConfirm) {
      showLoading(); // TODO: make showLoading an *instance* method
    }

    if (innerParams.preConfirm) {
      instance.resetValidationMessage();
      var preConfirmPromise = Promise.resolve().then(function () {
        return asPromise(innerParams.preConfirm(value, innerParams.validationMessage));
      });
      preConfirmPromise.then(function (preConfirmValue) {
        if (isVisible(getValidationMessage()) || preConfirmValue === false) {
          instance.hideLoading();
        } else {
          succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
        }
      });
    } else {
      succeedWith(instance, value);
    }
  };

  var addKeydownHandler = function addKeydownHandler(instance, globalState, innerParams, dismissWith) {
    if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
      globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = false;
    }

    if (!innerParams.toast) {
      globalState.keydownHandler = function (e) {
        return keydownHandler(instance, e, dismissWith);
      };

      globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
      globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
      globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = true;
    }
  }; // Focus handling

  var setFocus = function setFocus(innerParams, index, increment) {
    var focusableElements = getFocusableElements(); // search for visible elements and select the next possible match

    if (focusableElements.length) {
      index = index + increment; // rollover to first item

      if (index === focusableElements.length) {
        index = 0; // go to last item
      } else if (index === -1) {
        index = focusableElements.length - 1;
      }

      return focusableElements[index].focus();
    } // no visible focusable elements, focus the popup


    getPopup().focus();
  };
  var arrowKeysNextButton = ['ArrowRight', 'ArrowDown', 'Right', 'Down' // IE11
  ];
  var arrowKeysPreviousButton = ['ArrowLeft', 'ArrowUp', 'Left', 'Up' // IE11
  ];
  var escKeys = ['Escape', 'Esc' // IE11
  ];

  var keydownHandler = function keydownHandler(instance, e, dismissWith) {
    var innerParams = privateProps.innerParams.get(instance);

    if (!innerParams) {
      return; // This instance has already been destroyed
    }

    if (innerParams.stopKeydownPropagation) {
      e.stopPropagation();
    } // ENTER


    if (e.key === 'Enter') {
      handleEnter(instance, e, innerParams); // TAB
    } else if (e.key === 'Tab') {
      handleTab(e, innerParams); // ARROWS - switch focus between buttons
    } else if ([].concat(arrowKeysNextButton, arrowKeysPreviousButton).indexOf(e.key) !== -1) {
      handleArrows(e.key); // ESC
    } else if (escKeys.indexOf(e.key) !== -1) {
      handleEsc(e, innerParams, dismissWith);
    }
  };

  var handleEnter = function handleEnter(instance, e, innerParams) {
    // #720 #721
    if (e.isComposing) {
      return;
    }

    if (e.target && instance.getInput() && e.target.outerHTML === instance.getInput().outerHTML) {
      if (['textarea', 'file'].indexOf(innerParams.input) !== -1) {
        return; // do not submit
      }

      clickConfirm();
      e.preventDefault();
    }
  };

  var handleTab = function handleTab(e, innerParams) {
    var targetElement = e.target;
    var focusableElements = getFocusableElements();
    var btnIndex = -1;

    for (var i = 0; i < focusableElements.length; i++) {
      if (targetElement === focusableElements[i]) {
        btnIndex = i;
        break;
      }
    }

    if (!e.shiftKey) {
      // Cycle to the next button
      setFocus(innerParams, btnIndex, 1);
    } else {
      // Cycle to the prev button
      setFocus(innerParams, btnIndex, -1);
    }

    e.stopPropagation();
    e.preventDefault();
  };

  var handleArrows = function handleArrows(key) {
    var confirmButton = getConfirmButton();
    var denyButton = getDenyButton();
    var cancelButton = getCancelButton();

    if (!([confirmButton, denyButton, cancelButton].indexOf(document.activeElement) !== -1)) {
      return;
    }

    var sibling = arrowKeysNextButton.indexOf(key) !== -1 ? 'nextElementSibling' : 'previousElementSibling';
    var buttonToFocus = document.activeElement[sibling];

    if (buttonToFocus) {
      buttonToFocus.focus();
    }
  };

  var handleEsc = function handleEsc(e, innerParams, dismissWith) {
    if (callIfFunction(innerParams.allowEscapeKey)) {
      e.preventDefault();
      dismissWith(DismissReason.esc);
    }
  };

  var handlePopupClick = function handlePopupClick(instance, domCache, dismissWith) {
    var innerParams = privateProps.innerParams.get(instance);

    if (innerParams.toast) {
      handleToastClick(instance, domCache, dismissWith);
    } else {
      // Ignore click events that had mousedown on the popup but mouseup on the container
      // This can happen when the user drags a slider
      handleModalMousedown(domCache); // Ignore click events that had mousedown on the container but mouseup on the popup

      handleContainerMousedown(domCache);
      handleModalClick(instance, domCache, dismissWith);
    }
  };

  var handleToastClick = function handleToastClick(instance, domCache, dismissWith) {
    // Closing toast by internal click
    domCache.popup.onclick = function () {
      var innerParams = privateProps.innerParams.get(instance);

      if (innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton || innerParams.timer || innerParams.input) {
        return;
      }

      dismissWith(DismissReason.close);
    };
  };

  var ignoreOutsideClick = false;

  var handleModalMousedown = function handleModalMousedown(domCache) {
    domCache.popup.onmousedown = function () {
      domCache.container.onmouseup = function (e) {
        domCache.container.onmouseup = undefined; // We only check if the mouseup target is the container because usually it doesn't
        // have any other direct children aside of the popup

        if (e.target === domCache.container) {
          ignoreOutsideClick = true;
        }
      };
    };
  };

  var handleContainerMousedown = function handleContainerMousedown(domCache) {
    domCache.container.onmousedown = function () {
      domCache.popup.onmouseup = function (e) {
        domCache.popup.onmouseup = undefined; // We also need to check if the mouseup target is a child of the popup

        if (e.target === domCache.popup || domCache.popup.contains(e.target)) {
          ignoreOutsideClick = true;
        }
      };
    };
  };

  var handleModalClick = function handleModalClick(instance, domCache, dismissWith) {
    domCache.container.onclick = function (e) {
      var innerParams = privateProps.innerParams.get(instance);

      if (ignoreOutsideClick) {
        ignoreOutsideClick = false;
        return;
      }

      if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) {
        dismissWith(DismissReason.backdrop);
      }
    };
  };

  function _main(userParams) {
    var mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    showWarningsForParams(_extends({}, mixinParams, userParams));

    if (globalState.currentInstance) {
      globalState.currentInstance._destroy();
    }

    globalState.currentInstance = this;
    var innerParams = prepareParams(userParams, mixinParams);
    setParameters(innerParams);
    Object.freeze(innerParams); // clear the previous timer

    if (globalState.timeout) {
      globalState.timeout.stop();
      delete globalState.timeout;
    } // clear the restore focus timeout


    clearTimeout(globalState.restoreFocusTimeout);
    var domCache = populateDomCache(this);
    render(this, innerParams);
    privateProps.innerParams.set(this, innerParams);
    return swalPromise(this, domCache, innerParams);
  }

  var prepareParams = function prepareParams(userParams, mixinParams) {
    var templateParams = getTemplateParams(userParams);

    var params = _extends({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131


    params.showClass = _extends({}, defaultParams.showClass, params.showClass);
    params.hideClass = _extends({}, defaultParams.hideClass, params.hideClass); // @deprecated

    if (userParams.animation === false) {
      params.showClass = {
        popup: 'swal2-noanimation',
        backdrop: 'swal2-noanimation'
      };
      params.hideClass = {};
    }

    return params;
  };

  var swalPromise = function swalPromise(instance, domCache, innerParams) {
    return new Promise(function (resolve) {
      // functions to handle all closings/dismissals
      var dismissWith = function dismissWith(dismiss) {
        instance.closePopup({
          isDismissed: true,
          dismiss: dismiss
        });
      };

      privateMethods.swalPromiseResolve.set(instance, resolve);

      domCache.confirmButton.onclick = function () {
        return handleConfirmButtonClick(instance, innerParams);
      };

      domCache.denyButton.onclick = function () {
        return handleDenyButtonClick(instance, innerParams);
      };

      domCache.cancelButton.onclick = function () {
        return handleCancelButtonClick(instance, dismissWith);
      };

      domCache.closeButton.onclick = function () {
        return dismissWith(DismissReason.close);
      };

      handlePopupClick(instance, domCache, dismissWith);
      addKeydownHandler(instance, globalState, innerParams, dismissWith);
      handleInputOptionsAndValue(instance, innerParams);
      openPopup(innerParams);
      setupTimer(globalState, innerParams, dismissWith);
      initFocus(domCache, innerParams); // Scroll container to top on open (#1247, #1946)

      setTimeout(function () {
        domCache.container.scrollTop = 0;
      });
    });
  };

  var populateDomCache = function populateDomCache(instance) {
    var domCache = {
      popup: getPopup(),
      container: getContainer(),
      content: getContent(),
      actions: getActions(),
      confirmButton: getConfirmButton(),
      denyButton: getDenyButton(),
      cancelButton: getCancelButton(),
      loader: getLoader(),
      closeButton: getCloseButton(),
      validationMessage: getValidationMessage(),
      progressSteps: getProgressSteps()
    };
    privateProps.domCache.set(instance, domCache);
    return domCache;
  };

  var setupTimer = function setupTimer(globalState$$1, innerParams, dismissWith) {
    var timerProgressBar = getTimerProgressBar();
    hide(timerProgressBar);

    if (innerParams.timer) {
      globalState$$1.timeout = new Timer(function () {
        dismissWith('timer');
        delete globalState$$1.timeout;
      }, innerParams.timer);

      if (innerParams.timerProgressBar) {
        show(timerProgressBar);
        setTimeout(function () {
          if (globalState$$1.timeout && globalState$$1.timeout.running) {
            // timer can be already stopped or unset at this point
            animateTimerProgressBar(innerParams.timer);
          }
        });
      }
    }
  };

  var initFocus = function initFocus(domCache, innerParams) {
    if (innerParams.toast) {
      return;
    }

    if (!callIfFunction(innerParams.allowEnterKey)) {
      return blurActiveElement();
    }

    if (!focusButton(domCache, innerParams)) {
      setFocus(innerParams, -1, 1);
    }
  };

  var focusButton = function focusButton(domCache, innerParams) {
    if (innerParams.focusDeny && isVisible(domCache.denyButton)) {
      domCache.denyButton.focus();
      return true;
    }

    if (innerParams.focusCancel && isVisible(domCache.cancelButton)) {
      domCache.cancelButton.focus();
      return true;
    }

    if (innerParams.focusConfirm && isVisible(domCache.confirmButton)) {
      domCache.confirmButton.focus();
      return true;
    }

    return false;
  };

  var blurActiveElement = function blurActiveElement() {
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
  };

  /**
   * Updates popup parameters.
   */

  function update(params) {
    var popup = getPopup();
    var innerParams = privateProps.innerParams.get(this);

    if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
      return warn("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    }

    var validUpdatableParams = {}; // assign valid params from `params` to `defaults`

    Object.keys(params).forEach(function (param) {
      if (Swal.isUpdatableParameter(param)) {
        validUpdatableParams[param] = params[param];
      } else {
        warn("Invalid parameter to update: \"".concat(param, "\". Updatable params are listed here: https://github.com/sweetalert2/sweetalert2/blob/master/src/utils/params.js\n\nIf you think this parameter should be updatable, request it here: https://github.com/sweetalert2/sweetalert2/issues/new?template=02_feature_request.md"));
      }
    });

    var updatedParams = _extends({}, innerParams, validUpdatableParams);

    render(this, updatedParams);
    privateProps.innerParams.set(this, updatedParams);
    Object.defineProperties(this, {
      params: {
        value: _extends({}, this.params, params),
        writable: false,
        enumerable: true
      }
    });
  }

  function _destroy() {
    var domCache = privateProps.domCache.get(this);
    var innerParams = privateProps.innerParams.get(this);

    if (!innerParams) {
      return; // This instance has already been destroyed
    } // Check if there is another Swal closing


    if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
      globalState.swalCloseEventFinishedCallback();
      delete globalState.swalCloseEventFinishedCallback;
    } // Check if there is a swal disposal defer timer


    if (globalState.deferDisposalTimer) {
      clearTimeout(globalState.deferDisposalTimer);
      delete globalState.deferDisposalTimer;
    }

    runDidDestroy(innerParams);
    disposeSwal(this);
  }

  var runDidDestroy = function runDidDestroy(innerParams) {
    if (typeof innerParams.didDestroy === 'function') {
      innerParams.didDestroy();
    } else if (typeof innerParams.onDestroy === 'function') {
      innerParams.onDestroy(); // @deprecated
    }
  };

  var disposeSwal = function disposeSwal(instance) {
    // Unset this.params so GC will dispose it (#1569)
    delete instance.params; // Unset globalState props so GC will dispose globalState (#1569)

    delete globalState.keydownHandler;
    delete globalState.keydownTarget; // Unset WeakMaps so GC will be able to dispose them (#1569)

    unsetWeakMaps(privateProps);
    unsetWeakMaps(privateMethods);
  };

  var unsetWeakMaps = function unsetWeakMaps(obj) {
    for (var i in obj) {
      obj[i] = new WeakMap();
    }
  };



  var instanceMethods = /*#__PURE__*/Object.freeze({
    hideLoading: hideLoading,
    disableLoading: hideLoading,
    getInput: getInput$1,
    close: close,
    closePopup: close,
    closeModal: close,
    closeToast: close,
    enableButtons: enableButtons,
    disableButtons: disableButtons,
    enableInput: enableInput,
    disableInput: disableInput,
    showValidationMessage: showValidationMessage,
    resetValidationMessage: resetValidationMessage$1,
    getProgressSteps: getProgressSteps$1,
    _main: _main,
    update: update,
    _destroy: _destroy
  });

  var currentInstance;

  var SweetAlert = /*#__PURE__*/function () {
    function SweetAlert() {
      _classCallCheck(this, SweetAlert);

      // Prevent run in Node env
      if (typeof window === 'undefined') {
        return;
      } // Check for the existence of Promise


      if (typeof Promise === 'undefined') {
        error('This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/sweetalert2/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)');
      }

      currentInstance = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var outerParams = Object.freeze(this.constructor.argsToParams(args));
      Object.defineProperties(this, {
        params: {
          value: outerParams,
          writable: false,
          enumerable: true,
          configurable: true
        }
      });

      var promise = this._main(this.params);

      privateProps.promise.set(this, promise);
    } // `catch` cannot be the name of a module export, so we define our thenable methods here instead


    _createClass(SweetAlert, [{
      key: "then",
      value: function then(onFulfilled) {
        var promise = privateProps.promise.get(this);
        return promise.then(onFulfilled);
      }
    }, {
      key: "finally",
      value: function _finally(onFinally) {
        var promise = privateProps.promise.get(this);
        return promise["finally"](onFinally);
      }
    }]);

    return SweetAlert;
  }(); // Assign instance methods from src/instanceMethods/*.js to prototype


  _extends(SweetAlert.prototype, instanceMethods); // Assign static methods from src/staticMethods/*.js to constructor


  _extends(SweetAlert, staticMethods); // Proxy to instance methods to constructor, for now, for backwards compatibility


  Object.keys(instanceMethods).forEach(function (key) {
    SweetAlert[key] = function () {
      if (currentInstance) {
        var _currentInstance;

        return (_currentInstance = currentInstance)[key].apply(_currentInstance, arguments);
      }
    };
  });
  SweetAlert.DismissReason = DismissReason;
  SweetAlert.version = '10.16.9';

  var Swal = SweetAlert;
  Swal["default"] = Swal;

  return Swal;

}));
if (typeof this !== 'undefined' && this.Sweetalert2){  this.swal = this.sweetAlert = this.Swal = this.SweetAlert = this.Sweetalert2}


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Ion.RangeSlider
// version 2.3.1 Build: 382
// © Denis Ineshin, 2019
// https://github.com/IonDen
//
// Project page:    http://ionden.com/a/plugins/ion.rangeSlider/en.html
// GitHub page:     https://github.com/IonDen/ion.rangeSlider
//
// Released under MIT licence:
// http://ionden.com/a/plugins/licence-en.html
// =====================================================================================================================

;(function(factory) {
    if ((typeof jQuery === 'undefined' || !jQuery) && "function" === "function" && __webpack_require__(302)) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (jQuery) {
            return factory(jQuery, document, window, navigator);
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof jQuery === 'undefined' || !jQuery) && typeof exports === "object") {
        factory(__webpack_require__(25), document, window, navigator);
    } else {
        factory(jQuery, document, window, navigator);
    }
} (function ($, document, window, navigator, undefined) {
    "use strict";

    // =================================================================================================================
    // Service

    var plugin_count = 0;

    // IE8 fix
    var is_old_ie = (function () {
        var n = navigator.userAgent,
            r = /msie\s\d+/i,
            v;
        if (n.search(r) > 0) {
            v = r.exec(n).toString();
            v = v.split(" ")[1];
            if (v < 9) {
                $("html").addClass("lt-ie9");
                return true;
            }
        }
        return false;
    } ());
    if (!Function.prototype.bind) {
        Function.prototype.bind = function bind(that) {

            var target = this;
            var slice = [].slice;

            if (typeof target != "function") {
                throw new TypeError();
            }

            var args = slice.call(arguments, 1),
                bound = function () {

                    if (this instanceof bound) {

                        var F = function(){};
                        F.prototype = target.prototype;
                        var self = new F();

                        var result = target.apply(
                            self,
                            args.concat(slice.call(arguments))
                        );
                        if (Object(result) === result) {
                            return result;
                        }
                        return self;

                    } else {

                        return target.apply(
                            that,
                            args.concat(slice.call(arguments))
                        );

                    }

                };

            return bound;
        };
    }
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function(searchElement, fromIndex) {
            var k;
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var O = Object(this);
            var len = O.length >>> 0;
            if (len === 0) {
                return -1;
            }
            var n = +fromIndex || 0;
            if (Math.abs(n) === Infinity) {
                n = 0;
            }
            if (n >= len) {
                return -1;
            }
            k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
            while (k < len) {
                if (k in O && O[k] === searchElement) {
                    return k;
                }
                k++;
            }
            return -1;
        };
    }



    // =================================================================================================================
    // Template

    var base_html =
        '<span class="irs">' +
        '<span class="irs-line" tabindex="0"></span>' +
        '<span class="irs-min">0</span><span class="irs-max">1</span>' +
        '<span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span>' +
        '</span>' +
        '<span class="irs-grid"></span>';

    var single_html =
        '<span class="irs-bar irs-bar--single"></span>' +
        '<span class="irs-shadow shadow-single"></span>' +
        '<span class="irs-handle single"><i></i><i></i><i></i></span>';

    var double_html =
        '<span class="irs-bar"></span>' +
        '<span class="irs-shadow shadow-from"></span>' +
        '<span class="irs-shadow shadow-to"></span>' +
        '<span class="irs-handle from"><i></i><i></i><i></i></span>' +
        '<span class="irs-handle to"><i></i><i></i><i></i></span>';

    var disable_html =
        '<span class="irs-disable-mask"></span>';



    // =================================================================================================================
    // Core

    /**
     * Main plugin constructor
     *
     * @param input {Object} link to base input element
     * @param options {Object} slider config
     * @param plugin_count {Number}
     * @constructor
     */
    var IonRangeSlider = function (input, options, plugin_count) {
        this.VERSION = "2.3.1";
        this.input = input;
        this.plugin_count = plugin_count;
        this.current_plugin = 0;
        this.calc_count = 0;
        this.update_tm = 0;
        this.old_from = 0;
        this.old_to = 0;
        this.old_min_interval = null;
        this.raf_id = null;
        this.dragging = false;
        this.force_redraw = false;
        this.no_diapason = false;
        this.has_tab_index = true;
        this.is_key = false;
        this.is_update = false;
        this.is_start = true;
        this.is_finish = false;
        this.is_active = false;
        this.is_resize = false;
        this.is_click = false;

        options = options || {};

        // cache for links to all DOM elements
        this.$cache = {
            win: $(window),
            body: $(document.body),
            input: $(input),
            cont: null,
            rs: null,
            min: null,
            max: null,
            from: null,
            to: null,
            single: null,
            bar: null,
            line: null,
            s_single: null,
            s_from: null,
            s_to: null,
            shad_single: null,
            shad_from: null,
            shad_to: null,
            edge: null,
            grid: null,
            grid_labels: []
        };

        // storage for measure variables
        this.coords = {
            // left
            x_gap: 0,
            x_pointer: 0,

            // width
            w_rs: 0,
            w_rs_old: 0,
            w_handle: 0,

            // percents
            p_gap: 0,
            p_gap_left: 0,
            p_gap_right: 0,
            p_step: 0,
            p_pointer: 0,
            p_handle: 0,
            p_single_fake: 0,
            p_single_real: 0,
            p_from_fake: 0,
            p_from_real: 0,
            p_to_fake: 0,
            p_to_real: 0,
            p_bar_x: 0,
            p_bar_w: 0,

            // grid
            grid_gap: 0,
            big_num: 0,
            big: [],
            big_w: [],
            big_p: [],
            big_x: []
        };

        // storage for labels measure variables
        this.labels = {
            // width
            w_min: 0,
            w_max: 0,
            w_from: 0,
            w_to: 0,
            w_single: 0,

            // percents
            p_min: 0,
            p_max: 0,
            p_from_fake: 0,
            p_from_left: 0,
            p_to_fake: 0,
            p_to_left: 0,
            p_single_fake: 0,
            p_single_left: 0
        };



        /**
         * get and validate config
         */
        var $inp = this.$cache.input,
            val = $inp.prop("value"),
            config, config_from_data, prop;

        // default config
        config = {
            skin: "flat",
            type: "single",

            min: 10,
            max: 100,
            from: null,
            to: null,
            step: 1,

            min_interval: 0,
            max_interval: 0,
            drag_interval: false,

            values: [],
            p_values: [],

            from_fixed: false,
            from_min: null,
            from_max: null,
            from_shadow: false,

            to_fixed: false,
            to_min: null,
            to_max: null,
            to_shadow: false,

            prettify_enabled: true,
            prettify_separator: " ",
            prettify: null,

            force_edges: false,

            keyboard: true,

            grid: false,
            grid_margin: true,
            grid_num: 4,
            grid_snap: false,

            hide_min_max: false,
            hide_from_to: false,

            prefix: "",
            postfix: "",
            max_postfix: "",
            decorate_both: true,
            values_separator: " — ",

            input_values_separator: ";",

            disable: false,
            block: false,

            extra_classes: "",

            scope: null,
            onStart: null,
            onChange: null,
            onFinish: null,
            onUpdate: null
        };


        // check if base element is input
        if ($inp[0].nodeName !== "INPUT") {
            console && console.warn && console.warn("Base element should be <input>!", $inp[0]);
        }


        // config from data-attributes extends js config
        config_from_data = {
            skin: $inp.data("skin"),
            type: $inp.data("type"),

            min: $inp.data("min"),
            max: $inp.data("max"),
            from: $inp.data("from"),
            to: $inp.data("to"),
            step: $inp.data("step"),

            min_interval: $inp.data("minInterval"),
            max_interval: $inp.data("maxInterval"),
            drag_interval: $inp.data("dragInterval"),

            values: $inp.data("values"),

            from_fixed: $inp.data("fromFixed"),
            from_min: $inp.data("fromMin"),
            from_max: $inp.data("fromMax"),
            from_shadow: $inp.data("fromShadow"),

            to_fixed: $inp.data("toFixed"),
            to_min: $inp.data("toMin"),
            to_max: $inp.data("toMax"),
            to_shadow: $inp.data("toShadow"),

            prettify_enabled: $inp.data("prettifyEnabled"),
            prettify_separator: $inp.data("prettifySeparator"),

            force_edges: $inp.data("forceEdges"),

            keyboard: $inp.data("keyboard"),

            grid: $inp.data("grid"),
            grid_margin: $inp.data("gridMargin"),
            grid_num: $inp.data("gridNum"),
            grid_snap: $inp.data("gridSnap"),

            hide_min_max: $inp.data("hideMinMax"),
            hide_from_to: $inp.data("hideFromTo"),

            prefix: $inp.data("prefix"),
            postfix: $inp.data("postfix"),
            max_postfix: $inp.data("maxPostfix"),
            decorate_both: $inp.data("decorateBoth"),
            values_separator: $inp.data("valuesSeparator"),

            input_values_separator: $inp.data("inputValuesSeparator"),

            disable: $inp.data("disable"),
            block: $inp.data("block"),

            extra_classes: $inp.data("extraClasses"),
        };
        config_from_data.values = config_from_data.values && config_from_data.values.split(",");

        for (prop in config_from_data) {
            if (config_from_data.hasOwnProperty(prop)) {
                if (config_from_data[prop] === undefined || config_from_data[prop] === "") {
                    delete config_from_data[prop];
                }
            }
        }


        // input value extends default config
        if (val !== undefined && val !== "") {
            val = val.split(config_from_data.input_values_separator || options.input_values_separator || ";");

            if (val[0] && val[0] == +val[0]) {
                val[0] = +val[0];
            }
            if (val[1] && val[1] == +val[1]) {
                val[1] = +val[1];
            }

            if (options && options.values && options.values.length) {
                config.from = val[0] && options.values.indexOf(val[0]);
                config.to = val[1] && options.values.indexOf(val[1]);
            } else {
                config.from = val[0] && +val[0];
                config.to = val[1] && +val[1];
            }
        }



        // js config extends default config
        $.extend(config, options);


        // data config extends config
        $.extend(config, config_from_data);
        this.options = config;



        // validate config, to be sure that all data types are correct
        this.update_check = {};
        this.validate();



        // default result object, returned to callbacks
        this.result = {
            input: this.$cache.input,
            slider: null,

            min: this.options.min,
            max: this.options.max,

            from: this.options.from,
            from_percent: 0,
            from_value: null,

            to: this.options.to,
            to_percent: 0,
            to_value: null
        };



        this.init();
    };

    IonRangeSlider.prototype = {

        /**
         * Starts or updates the plugin instance
         *
         * @param [is_update] {boolean}
         */
        init: function (is_update) {
            this.no_diapason = false;
            this.coords.p_step = this.convertToPercent(this.options.step, true);

            this.target = "base";

            this.toggleInput();
            this.append();
            this.setMinMax();

            if (is_update) {
                this.force_redraw = true;
                this.calc(true);

                // callbacks called
                this.callOnUpdate();
            } else {
                this.force_redraw = true;
                this.calc(true);

                // callbacks called
                this.callOnStart();
            }

            this.updateScene();
        },

        /**
         * Appends slider template to a DOM
         */
        append: function () {
            var container_html = '<span class="irs irs--' + this.options.skin + ' js-irs-' + this.plugin_count + ' ' + this.options.extra_classes + '"></span>';
            this.$cache.input.before(container_html);
            this.$cache.input.prop("readonly", true);
            this.$cache.cont = this.$cache.input.prev();
            this.result.slider = this.$cache.cont;

            this.$cache.cont.html(base_html);
            this.$cache.rs = this.$cache.cont.find(".irs");
            this.$cache.min = this.$cache.cont.find(".irs-min");
            this.$cache.max = this.$cache.cont.find(".irs-max");
            this.$cache.from = this.$cache.cont.find(".irs-from");
            this.$cache.to = this.$cache.cont.find(".irs-to");
            this.$cache.single = this.$cache.cont.find(".irs-single");
            this.$cache.line = this.$cache.cont.find(".irs-line");
            this.$cache.grid = this.$cache.cont.find(".irs-grid");

            if (this.options.type === "single") {
                this.$cache.cont.append(single_html);
                this.$cache.bar = this.$cache.cont.find(".irs-bar");
                this.$cache.edge = this.$cache.cont.find(".irs-bar-edge");
                this.$cache.s_single = this.$cache.cont.find(".single");
                this.$cache.from[0].style.visibility = "hidden";
                this.$cache.to[0].style.visibility = "hidden";
                this.$cache.shad_single = this.$cache.cont.find(".shadow-single");
            } else {
                this.$cache.cont.append(double_html);
                this.$cache.bar = this.$cache.cont.find(".irs-bar");
                this.$cache.s_from = this.$cache.cont.find(".from");
                this.$cache.s_to = this.$cache.cont.find(".to");
                this.$cache.shad_from = this.$cache.cont.find(".shadow-from");
                this.$cache.shad_to = this.$cache.cont.find(".shadow-to");

                this.setTopHandler();
            }

            if (this.options.hide_from_to) {
                this.$cache.from[0].style.display = "none";
                this.$cache.to[0].style.display = "none";
                this.$cache.single[0].style.display = "none";
            }

            this.appendGrid();

            if (this.options.disable) {
                this.appendDisableMask();
                this.$cache.input[0].disabled = true;
            } else {
                this.$cache.input[0].disabled = false;
                this.removeDisableMask();
                this.bindEvents();
            }

            // block only if not disabled
            if (!this.options.disable) {
                if (this.options.block) {
                    this.appendDisableMask();
                } else {
                    this.removeDisableMask();
                }
            }

            if (this.options.drag_interval) {
                this.$cache.bar[0].style.cursor = "ew-resize";
            }
        },

        /**
         * Determine which handler has a priority
         * works only for double slider type
         */
        setTopHandler: function () {
            var min = this.options.min,
                max = this.options.max,
                from = this.options.from,
                to = this.options.to;

            if (from > min && to === max) {
                this.$cache.s_from.addClass("type_last");
            } else if (to < max) {
                this.$cache.s_to.addClass("type_last");
            }
        },

        /**
         * Determine which handles was clicked last
         * and which handler should have hover effect
         *
         * @param target {String}
         */
        changeLevel: function (target) {
            switch (target) {
                case "single":
                    this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_single_fake);
                    this.$cache.s_single.addClass("state_hover");
                    break;
                case "from":
                    this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake);
                    this.$cache.s_from.addClass("state_hover");
                    this.$cache.s_from.addClass("type_last");
                    this.$cache.s_to.removeClass("type_last");
                    break;
                case "to":
                    this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_to_fake);
                    this.$cache.s_to.addClass("state_hover");
                    this.$cache.s_to.addClass("type_last");
                    this.$cache.s_from.removeClass("type_last");
                    break;
                case "both":
                    this.coords.p_gap_left = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake);
                    this.coords.p_gap_right = this.toFixed(this.coords.p_to_fake - this.coords.p_pointer);
                    this.$cache.s_to.removeClass("type_last");
                    this.$cache.s_from.removeClass("type_last");
                    break;
            }
        },

        /**
         * Then slider is disabled
         * appends extra layer with opacity
         */
        appendDisableMask: function () {
            this.$cache.cont.append(disable_html);
            this.$cache.cont.addClass("irs-disabled");
        },

        /**
         * Then slider is not disabled
         * remove disable mask
         */
        removeDisableMask: function () {
            this.$cache.cont.remove(".irs-disable-mask");
            this.$cache.cont.removeClass("irs-disabled");
        },

        /**
         * Remove slider instance
         * and unbind all events
         */
        remove: function () {
            this.$cache.cont.remove();
            this.$cache.cont = null;

            this.$cache.line.off("keydown.irs_" + this.plugin_count);

            this.$cache.body.off("touchmove.irs_" + this.plugin_count);
            this.$cache.body.off("mousemove.irs_" + this.plugin_count);

            this.$cache.win.off("touchend.irs_" + this.plugin_count);
            this.$cache.win.off("mouseup.irs_" + this.plugin_count);

            if (is_old_ie) {
                this.$cache.body.off("mouseup.irs_" + this.plugin_count);
                this.$cache.body.off("mouseleave.irs_" + this.plugin_count);
            }

            this.$cache.grid_labels = [];
            this.coords.big = [];
            this.coords.big_w = [];
            this.coords.big_p = [];
            this.coords.big_x = [];

            cancelAnimationFrame(this.raf_id);
        },

        /**
         * bind all slider events
         */
        bindEvents: function () {
            if (this.no_diapason) {
                return;
            }

            this.$cache.body.on("touchmove.irs_" + this.plugin_count, this.pointerMove.bind(this));
            this.$cache.body.on("mousemove.irs_" + this.plugin_count, this.pointerMove.bind(this));

            this.$cache.win.on("touchend.irs_" + this.plugin_count, this.pointerUp.bind(this));
            this.$cache.win.on("mouseup.irs_" + this.plugin_count, this.pointerUp.bind(this));

            this.$cache.line.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
            this.$cache.line.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));

            this.$cache.line.on("focus.irs_" + this.plugin_count, this.pointerFocus.bind(this));

            if (this.options.drag_interval && this.options.type === "double") {
                this.$cache.bar.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "both"));
                this.$cache.bar.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "both"));
            } else {
                this.$cache.bar.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
                this.$cache.bar.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
            }

            if (this.options.type === "single") {
                this.$cache.single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
                this.$cache.s_single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
                this.$cache.shad_single.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));

                this.$cache.single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
                this.$cache.s_single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
                this.$cache.edge.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
                this.$cache.shad_single.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
            } else {
                this.$cache.single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, null));
                this.$cache.single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, null));

                this.$cache.from.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
                this.$cache.s_from.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
                this.$cache.to.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
                this.$cache.s_to.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
                this.$cache.shad_from.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
                this.$cache.shad_to.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));

                this.$cache.from.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
                this.$cache.s_from.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
                this.$cache.to.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
                this.$cache.s_to.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
                this.$cache.shad_from.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
                this.$cache.shad_to.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
            }

            if (this.options.keyboard) {
                this.$cache.line.on("keydown.irs_" + this.plugin_count, this.key.bind(this, "keyboard"));
            }

            if (is_old_ie) {
                this.$cache.body.on("mouseup.irs_" + this.plugin_count, this.pointerUp.bind(this));
                this.$cache.body.on("mouseleave.irs_" + this.plugin_count, this.pointerUp.bind(this));
            }
        },

        /**
         * Focus with tabIndex
         *
         * @param e {Object} event object
         */
        pointerFocus: function (e) {
            if (!this.target) {
                var x;
                var $handle;

                if (this.options.type === "single") {
                    $handle = this.$cache.single;
                } else {
                    $handle = this.$cache.from;
                }

                x = $handle.offset().left;
                x += ($handle.width() / 2) - 1;

                this.pointerClick("single", {preventDefault: function () {}, pageX: x});
            }
        },

        /**
         * Mousemove or touchmove
         * only for handlers
         *
         * @param e {Object} event object
         */
        pointerMove: function (e) {
            if (!this.dragging) {
                return;
            }

            var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;
            this.coords.x_pointer = x - this.coords.x_gap;

            this.calc();
        },

        /**
         * Mouseup or touchend
         * only for handlers
         *
         * @param e {Object} event object
         */
        pointerUp: function (e) {
            if (this.current_plugin !== this.plugin_count) {
                return;
            }

            if (this.is_active) {
                this.is_active = false;
            } else {
                return;
            }

            this.$cache.cont.find(".state_hover").removeClass("state_hover");

            this.force_redraw = true;

            if (is_old_ie) {
                $("*").prop("unselectable", false);
            }

            this.updateScene();
            this.restoreOriginalMinInterval();

            // callbacks call
            if ($.contains(this.$cache.cont[0], e.target) || this.dragging) {
                this.callOnFinish();
            }

            this.dragging = false;
        },

        /**
         * Mousedown or touchstart
         * only for handlers
         *
         * @param target {String|null}
         * @param e {Object} event object
         */
        pointerDown: function (target, e) {
            e.preventDefault();
            var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;
            if (e.button === 2) {
                return;
            }

            if (target === "both") {
                this.setTempMinInterval();
            }

            if (!target) {
                target = this.target || "from";
            }

            this.current_plugin = this.plugin_count;
            this.target = target;

            this.is_active = true;
            this.dragging = true;

            this.coords.x_gap = this.$cache.rs.offset().left;
            this.coords.x_pointer = x - this.coords.x_gap;

            this.calcPointerPercent();
            this.changeLevel(target);

            if (is_old_ie) {
                $("*").prop("unselectable", true);
            }

            this.$cache.line.trigger("focus");

            this.updateScene();
        },

        /**
         * Mousedown or touchstart
         * for other slider elements, like diapason line
         *
         * @param target {String}
         * @param e {Object} event object
         */
        pointerClick: function (target, e) {
            e.preventDefault();
            var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;
            if (e.button === 2) {
                return;
            }

            this.current_plugin = this.plugin_count;
            this.target = target;

            this.is_click = true;
            this.coords.x_gap = this.$cache.rs.offset().left;
            this.coords.x_pointer = +(x - this.coords.x_gap).toFixed();

            this.force_redraw = true;
            this.calc();

            this.$cache.line.trigger("focus");
        },

        /**
         * Keyborard controls for focused slider
         *
         * @param target {String}
         * @param e {Object} event object
         * @returns {boolean|undefined}
         */
        key: function (target, e) {
            if (this.current_plugin !== this.plugin_count || e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
                return;
            }

            switch (e.which) {
                case 83: // W
                case 65: // A
                case 40: // DOWN
                case 37: // LEFT
                    e.preventDefault();
                    this.moveByKey(false);
                    break;

                case 87: // S
                case 68: // D
                case 38: // UP
                case 39: // RIGHT
                    e.preventDefault();
                    this.moveByKey(true);
                    break;
            }

            return true;
        },

        /**
         * Move by key
         *
         * @param right {boolean} direction to move
         */
        moveByKey: function (right) {
            var p = this.coords.p_pointer;
            var p_step = (this.options.max - this.options.min) / 100;
            p_step = this.options.step / p_step;

            if (right) {
                p += p_step;
            } else {
                p -= p_step;
            }

            this.coords.x_pointer = this.toFixed(this.coords.w_rs / 100 * p);
            this.is_key = true;
            this.calc();
        },

        /**
         * Set visibility and content
         * of Min and Max labels
         */
        setMinMax: function () {
            if (!this.options) {
                return;
            }

            if (this.options.hide_min_max) {
                this.$cache.min[0].style.display = "none";
                this.$cache.max[0].style.display = "none";
                return;
            }

            if (this.options.values.length) {
                this.$cache.min.html(this.decorate(this.options.p_values[this.options.min]));
                this.$cache.max.html(this.decorate(this.options.p_values[this.options.max]));
            } else {
                var min_pretty = this._prettify(this.options.min);
                var max_pretty = this._prettify(this.options.max);

                this.result.min_pretty = min_pretty;
                this.result.max_pretty = max_pretty;

                this.$cache.min.html(this.decorate(min_pretty, this.options.min));
                this.$cache.max.html(this.decorate(max_pretty, this.options.max));
            }

            this.labels.w_min = this.$cache.min.outerWidth(false);
            this.labels.w_max = this.$cache.max.outerWidth(false);
        },

        /**
         * Then dragging interval, prevent interval collapsing
         * using min_interval option
         */
        setTempMinInterval: function () {
            var interval = this.result.to - this.result.from;

            if (this.old_min_interval === null) {
                this.old_min_interval = this.options.min_interval;
            }

            this.options.min_interval = interval;
        },

        /**
         * Restore min_interval option to original
         */
        restoreOriginalMinInterval: function () {
            if (this.old_min_interval !== null) {
                this.options.min_interval = this.old_min_interval;
                this.old_min_interval = null;
            }
        },



        // =============================================================================================================
        // Calculations

        /**
         * All calculations and measures start here
         *
         * @param update {boolean=}
         */
        calc: function (update) {
            if (!this.options) {
                return;
            }

            this.calc_count++;

            if (this.calc_count === 10 || update) {
                this.calc_count = 0;
                this.coords.w_rs = this.$cache.rs.outerWidth(false);

                this.calcHandlePercent();
            }

            if (!this.coords.w_rs) {
                return;
            }

            this.calcPointerPercent();
            var handle_x = this.getHandleX();


            if (this.target === "both") {
                this.coords.p_gap = 0;
                handle_x = this.getHandleX();
            }

            if (this.target === "click") {
                this.coords.p_gap = this.coords.p_handle / 2;
                handle_x = this.getHandleX();

                if (this.options.drag_interval) {
                    this.target = "both_one";
                } else {
                    this.target = this.chooseHandle(handle_x);
                }
            }

            switch (this.target) {
                case "base":
                    var w = (this.options.max - this.options.min) / 100,
                        f = (this.result.from - this.options.min) / w,
                        t = (this.result.to - this.options.min) / w;

                    this.coords.p_single_real = this.toFixed(f);
                    this.coords.p_from_real = this.toFixed(f);
                    this.coords.p_to_real = this.toFixed(t);

                    this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max);
                    this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                    this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);

                    this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);
                    this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
                    this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);

                    this.target = null;

                    break;

                case "single":
                    if (this.options.from_fixed) {
                        break;
                    }

                    this.coords.p_single_real = this.convertToRealPercent(handle_x);
                    this.coords.p_single_real = this.calcWithStep(this.coords.p_single_real);
                    this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max);

                    this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);

                    break;

                case "from":
                    if (this.options.from_fixed) {
                        break;
                    }

                    this.coords.p_from_real = this.convertToRealPercent(handle_x);
                    this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);
                    if (this.coords.p_from_real > this.coords.p_to_real) {
                        this.coords.p_from_real = this.coords.p_to_real;
                    }
                    this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                    this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from");
                    this.coords.p_from_real = this.checkMaxInterval(this.coords.p_from_real, this.coords.p_to_real, "from");

                    this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);

                    break;

                case "to":
                    if (this.options.to_fixed) {
                        break;
                    }

                    this.coords.p_to_real = this.convertToRealPercent(handle_x);
                    this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);
                    if (this.coords.p_to_real < this.coords.p_from_real) {
                        this.coords.p_to_real = this.coords.p_from_real;
                    }
                    this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
                    this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to");
                    this.coords.p_to_real = this.checkMaxInterval(this.coords.p_to_real, this.coords.p_from_real, "to");

                    this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);

                    break;

                case "both":
                    if (this.options.from_fixed || this.options.to_fixed) {
                        break;
                    }

                    handle_x = this.toFixed(handle_x + (this.coords.p_handle * 0.001));

                    this.coords.p_from_real = this.convertToRealPercent(handle_x) - this.coords.p_gap_left;
                    this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);
                    this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                    this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from");
                    this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);

                    this.coords.p_to_real = this.convertToRealPercent(handle_x) + this.coords.p_gap_right;
                    this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);
                    this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
                    this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to");
                    this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);

                    break;

                case "both_one":
                    if (this.options.from_fixed || this.options.to_fixed) {
                        break;
                    }

                    var real_x = this.convertToRealPercent(handle_x),
                        from = this.result.from_percent,
                        to = this.result.to_percent,
                        full = to - from,
                        half = full / 2,
                        new_from = real_x - half,
                        new_to = real_x + half;

                    if (new_from < 0) {
                        new_from = 0;
                        new_to = new_from + full;
                    }

                    if (new_to > 100) {
                        new_to = 100;
                        new_from = new_to - full;
                    }

                    this.coords.p_from_real = this.calcWithStep(new_from);
                    this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                    this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);

                    this.coords.p_to_real = this.calcWithStep(new_to);
                    this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
                    this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);

                    break;
            }

            if (this.options.type === "single") {
                this.coords.p_bar_x = (this.coords.p_handle / 2);
                this.coords.p_bar_w = this.coords.p_single_fake;

                this.result.from_percent = this.coords.p_single_real;
                this.result.from = this.convertToValue(this.coords.p_single_real);
                this.result.from_pretty = this._prettify(this.result.from);

                if (this.options.values.length) {
                    this.result.from_value = this.options.values[this.result.from];
                }
            } else {
                this.coords.p_bar_x = this.toFixed(this.coords.p_from_fake + (this.coords.p_handle / 2));
                this.coords.p_bar_w = this.toFixed(this.coords.p_to_fake - this.coords.p_from_fake);

                this.result.from_percent = this.coords.p_from_real;
                this.result.from = this.convertToValue(this.coords.p_from_real);
                this.result.from_pretty = this._prettify(this.result.from);
                this.result.to_percent = this.coords.p_to_real;
                this.result.to = this.convertToValue(this.coords.p_to_real);
                this.result.to_pretty = this._prettify(this.result.to);

                if (this.options.values.length) {
                    this.result.from_value = this.options.values[this.result.from];
                    this.result.to_value = this.options.values[this.result.to];
                }
            }

            this.calcMinMax();
            this.calcLabels();
        },


        /**
         * calculates pointer X in percent
         */
        calcPointerPercent: function () {
            if (!this.coords.w_rs) {
                this.coords.p_pointer = 0;
                return;
            }

            if (this.coords.x_pointer < 0 || isNaN(this.coords.x_pointer)  ) {
                this.coords.x_pointer = 0;
            } else if (this.coords.x_pointer > this.coords.w_rs) {
                this.coords.x_pointer = this.coords.w_rs;
            }

            this.coords.p_pointer = this.toFixed(this.coords.x_pointer / this.coords.w_rs * 100);
        },

        convertToRealPercent: function (fake) {
            var full = 100 - this.coords.p_handle;
            return fake / full * 100;
        },

        convertToFakePercent: function (real) {
            var full = 100 - this.coords.p_handle;
            return real / 100 * full;
        },

        getHandleX: function () {
            var max = 100 - this.coords.p_handle,
                x = this.toFixed(this.coords.p_pointer - this.coords.p_gap);

            if (x < 0) {
                x = 0;
            } else if (x > max) {
                x = max;
            }

            return x;
        },

        calcHandlePercent: function () {
            if (this.options.type === "single") {
                this.coords.w_handle = this.$cache.s_single.outerWidth(false);
            } else {
                this.coords.w_handle = this.$cache.s_from.outerWidth(false);
            }

            this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100);
        },

        /**
         * Find closest handle to pointer click
         *
         * @param real_x {Number}
         * @returns {String}
         */
        chooseHandle: function (real_x) {
            if (this.options.type === "single") {
                return "single";
            } else {
                var m_point = this.coords.p_from_real + ((this.coords.p_to_real - this.coords.p_from_real) / 2);
                if (real_x >= m_point) {
                    return this.options.to_fixed ? "from" : "to";
                } else {
                    return this.options.from_fixed ? "to" : "from";
                }
            }
        },

        /**
         * Measure Min and Max labels width in percent
         */
        calcMinMax: function () {
            if (!this.coords.w_rs) {
                return;
            }

            this.labels.p_min = this.labels.w_min / this.coords.w_rs * 100;
            this.labels.p_max = this.labels.w_max / this.coords.w_rs * 100;
        },

        /**
         * Measure labels width and X in percent
         */
        calcLabels: function () {
            if (!this.coords.w_rs || this.options.hide_from_to) {
                return;
            }

            if (this.options.type === "single") {

                this.labels.w_single = this.$cache.single.outerWidth(false);
                this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100;
                this.labels.p_single_left = this.coords.p_single_fake + (this.coords.p_handle / 2) - (this.labels.p_single_fake / 2);
                this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake);

            } else {

                this.labels.w_from = this.$cache.from.outerWidth(false);
                this.labels.p_from_fake = this.labels.w_from / this.coords.w_rs * 100;
                this.labels.p_from_left = this.coords.p_from_fake + (this.coords.p_handle / 2) - (this.labels.p_from_fake / 2);
                this.labels.p_from_left = this.toFixed(this.labels.p_from_left);
                this.labels.p_from_left = this.checkEdges(this.labels.p_from_left, this.labels.p_from_fake);

                this.labels.w_to = this.$cache.to.outerWidth(false);
                this.labels.p_to_fake = this.labels.w_to / this.coords.w_rs * 100;
                this.labels.p_to_left = this.coords.p_to_fake + (this.coords.p_handle / 2) - (this.labels.p_to_fake / 2);
                this.labels.p_to_left = this.toFixed(this.labels.p_to_left);
                this.labels.p_to_left = this.checkEdges(this.labels.p_to_left, this.labels.p_to_fake);

                this.labels.w_single = this.$cache.single.outerWidth(false);
                this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100;
                this.labels.p_single_left = ((this.labels.p_from_left + this.labels.p_to_left + this.labels.p_to_fake) / 2) - (this.labels.p_single_fake / 2);
                this.labels.p_single_left = this.toFixed(this.labels.p_single_left);
                this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake);

            }
        },



        // =============================================================================================================
        // Drawings

        /**
         * Main function called in request animation frame
         * to update everything
         */
        updateScene: function () {
            if (this.raf_id) {
                cancelAnimationFrame(this.raf_id);
                this.raf_id = null;
            }

            clearTimeout(this.update_tm);
            this.update_tm = null;

            if (!this.options) {
                return;
            }

            this.drawHandles();

            if (this.is_active) {
                this.raf_id = requestAnimationFrame(this.updateScene.bind(this));
            } else {
                this.update_tm = setTimeout(this.updateScene.bind(this), 300);
            }
        },

        /**
         * Draw handles
         */
        drawHandles: function () {
            this.coords.w_rs = this.$cache.rs.outerWidth(false);

            if (!this.coords.w_rs) {
                return;
            }

            if (this.coords.w_rs !== this.coords.w_rs_old) {
                this.target = "base";
                this.is_resize = true;
            }

            if (this.coords.w_rs !== this.coords.w_rs_old || this.force_redraw) {
                this.setMinMax();
                this.calc(true);
                this.drawLabels();
                if (this.options.grid) {
                    this.calcGridMargin();
                    this.calcGridLabels();
                }
                this.force_redraw = true;
                this.coords.w_rs_old = this.coords.w_rs;
                this.drawShadow();
            }

            if (!this.coords.w_rs) {
                return;
            }

            if (!this.dragging && !this.force_redraw && !this.is_key) {
                return;
            }

            if (this.old_from !== this.result.from || this.old_to !== this.result.to || this.force_redraw || this.is_key) {

                this.drawLabels();

                this.$cache.bar[0].style.left = this.coords.p_bar_x + "%";
                this.$cache.bar[0].style.width = this.coords.p_bar_w + "%";

                if (this.options.type === "single") {
                    this.$cache.bar[0].style.left = 0;
                    this.$cache.bar[0].style.width = this.coords.p_bar_w + this.coords.p_bar_x + "%";

                    this.$cache.s_single[0].style.left = this.coords.p_single_fake + "%";

                    this.$cache.single[0].style.left = this.labels.p_single_left + "%";
                } else {
                    this.$cache.s_from[0].style.left = this.coords.p_from_fake + "%";
                    this.$cache.s_to[0].style.left = this.coords.p_to_fake + "%";

                    if (this.old_from !== this.result.from || this.force_redraw) {
                        this.$cache.from[0].style.left = this.labels.p_from_left + "%";
                    }
                    if (this.old_to !== this.result.to || this.force_redraw) {
                        this.$cache.to[0].style.left = this.labels.p_to_left + "%";
                    }

                    this.$cache.single[0].style.left = this.labels.p_single_left + "%";
                }

                this.writeToInput();

                if ((this.old_from !== this.result.from || this.old_to !== this.result.to) && !this.is_start) {
                    this.$cache.input.trigger("change");
                    this.$cache.input.trigger("input");
                }

                this.old_from = this.result.from;
                this.old_to = this.result.to;

                // callbacks call
                if (!this.is_resize && !this.is_update && !this.is_start && !this.is_finish) {
                    this.callOnChange();
                }
                if (this.is_key || this.is_click) {
                    this.is_key = false;
                    this.is_click = false;
                    this.callOnFinish();
                }

                this.is_update = false;
                this.is_resize = false;
                this.is_finish = false;
            }

            this.is_start = false;
            this.is_key = false;
            this.is_click = false;
            this.force_redraw = false;
        },

        /**
         * Draw labels
         * measure labels collisions
         * collapse close labels
         */
        drawLabels: function () {
            if (!this.options) {
                return;
            }

            var values_num = this.options.values.length;
            var p_values = this.options.p_values;
            var text_single;
            var text_from;
            var text_to;
            var from_pretty;
            var to_pretty;

            if (this.options.hide_from_to) {
                return;
            }

            if (this.options.type === "single") {

                if (values_num) {
                    text_single = this.decorate(p_values[this.result.from]);
                    this.$cache.single.html(text_single);
                } else {
                    from_pretty = this._prettify(this.result.from);

                    text_single = this.decorate(from_pretty, this.result.from);
                    this.$cache.single.html(text_single);
                }

                this.calcLabels();

                if (this.labels.p_single_left < this.labels.p_min + 1) {
                    this.$cache.min[0].style.visibility = "hidden";
                } else {
                    this.$cache.min[0].style.visibility = "visible";
                }

                if (this.labels.p_single_left + this.labels.p_single_fake > 100 - this.labels.p_max - 1) {
                    this.$cache.max[0].style.visibility = "hidden";
                } else {
                    this.$cache.max[0].style.visibility = "visible";
                }

            } else {

                if (values_num) {

                    if (this.options.decorate_both) {
                        text_single = this.decorate(p_values[this.result.from]);
                        text_single += this.options.values_separator;
                        text_single += this.decorate(p_values[this.result.to]);
                    } else {
                        text_single = this.decorate(p_values[this.result.from] + this.options.values_separator + p_values[this.result.to]);
                    }
                    text_from = this.decorate(p_values[this.result.from]);
                    text_to = this.decorate(p_values[this.result.to]);

                    this.$cache.single.html(text_single);
                    this.$cache.from.html(text_from);
                    this.$cache.to.html(text_to);

                } else {
                    from_pretty = this._prettify(this.result.from);
                    to_pretty = this._prettify(this.result.to);

                    if (this.options.decorate_both) {
                        text_single = this.decorate(from_pretty, this.result.from);
                        text_single += this.options.values_separator;
                        text_single += this.decorate(to_pretty, this.result.to);
                    } else {
                        text_single = this.decorate(from_pretty + this.options.values_separator + to_pretty, this.result.to);
                    }
                    text_from = this.decorate(from_pretty, this.result.from);
                    text_to = this.decorate(to_pretty, this.result.to);

                    this.$cache.single.html(text_single);
                    this.$cache.from.html(text_from);
                    this.$cache.to.html(text_to);

                }

                this.calcLabels();

                var min = Math.min(this.labels.p_single_left, this.labels.p_from_left),
                    single_left = this.labels.p_single_left + this.labels.p_single_fake,
                    to_left = this.labels.p_to_left + this.labels.p_to_fake,
                    max = Math.max(single_left, to_left);

                if (this.labels.p_from_left + this.labels.p_from_fake >= this.labels.p_to_left) {
                    this.$cache.from[0].style.visibility = "hidden";
                    this.$cache.to[0].style.visibility = "hidden";
                    this.$cache.single[0].style.visibility = "visible";

                    if (this.result.from === this.result.to) {
                        if (this.target === "from") {
                            this.$cache.from[0].style.visibility = "visible";
                        } else if (this.target === "to") {
                            this.$cache.to[0].style.visibility = "visible";
                        } else if (!this.target) {
                            this.$cache.from[0].style.visibility = "visible";
                        }
                        this.$cache.single[0].style.visibility = "hidden";
                        max = to_left;
                    } else {
                        this.$cache.from[0].style.visibility = "hidden";
                        this.$cache.to[0].style.visibility = "hidden";
                        this.$cache.single[0].style.visibility = "visible";
                        max = Math.max(single_left, to_left);
                    }
                } else {
                    this.$cache.from[0].style.visibility = "visible";
                    this.$cache.to[0].style.visibility = "visible";
                    this.$cache.single[0].style.visibility = "hidden";
                }

                if (min < this.labels.p_min + 1) {
                    this.$cache.min[0].style.visibility = "hidden";
                } else {
                    this.$cache.min[0].style.visibility = "visible";
                }

                if (max > 100 - this.labels.p_max - 1) {
                    this.$cache.max[0].style.visibility = "hidden";
                } else {
                    this.$cache.max[0].style.visibility = "visible";
                }

            }
        },

        /**
         * Draw shadow intervals
         */
        drawShadow: function () {
            var o = this.options,
                c = this.$cache,

                is_from_min = typeof o.from_min === "number" && !isNaN(o.from_min),
                is_from_max = typeof o.from_max === "number" && !isNaN(o.from_max),
                is_to_min = typeof o.to_min === "number" && !isNaN(o.to_min),
                is_to_max = typeof o.to_max === "number" && !isNaN(o.to_max),

                from_min,
                from_max,
                to_min,
                to_max;

            if (o.type === "single") {
                if (o.from_shadow && (is_from_min || is_from_max)) {
                    from_min = this.convertToPercent(is_from_min ? o.from_min : o.min);
                    from_max = this.convertToPercent(is_from_max ? o.from_max : o.max) - from_min;
                    from_min = this.toFixed(from_min - (this.coords.p_handle / 100 * from_min));
                    from_max = this.toFixed(from_max - (this.coords.p_handle / 100 * from_max));
                    from_min = from_min + (this.coords.p_handle / 2);

                    c.shad_single[0].style.display = "block";
                    c.shad_single[0].style.left = from_min + "%";
                    c.shad_single[0].style.width = from_max + "%";
                } else {
                    c.shad_single[0].style.display = "none";
                }
            } else {
                if (o.from_shadow && (is_from_min || is_from_max)) {
                    from_min = this.convertToPercent(is_from_min ? o.from_min : o.min);
                    from_max = this.convertToPercent(is_from_max ? o.from_max : o.max) - from_min;
                    from_min = this.toFixed(from_min - (this.coords.p_handle / 100 * from_min));
                    from_max = this.toFixed(from_max - (this.coords.p_handle / 100 * from_max));
                    from_min = from_min + (this.coords.p_handle / 2);

                    c.shad_from[0].style.display = "block";
                    c.shad_from[0].style.left = from_min + "%";
                    c.shad_from[0].style.width = from_max + "%";
                } else {
                    c.shad_from[0].style.display = "none";
                }

                if (o.to_shadow && (is_to_min || is_to_max)) {
                    to_min = this.convertToPercent(is_to_min ? o.to_min : o.min);
                    to_max = this.convertToPercent(is_to_max ? o.to_max : o.max) - to_min;
                    to_min = this.toFixed(to_min - (this.coords.p_handle / 100 * to_min));
                    to_max = this.toFixed(to_max - (this.coords.p_handle / 100 * to_max));
                    to_min = to_min + (this.coords.p_handle / 2);

                    c.shad_to[0].style.display = "block";
                    c.shad_to[0].style.left = to_min + "%";
                    c.shad_to[0].style.width = to_max + "%";
                } else {
                    c.shad_to[0].style.display = "none";
                }
            }
        },



        /**
         * Write values to input element
         */
        writeToInput: function () {
            if (this.options.type === "single") {
                if (this.options.values.length) {
                    this.$cache.input.prop("value", this.result.from_value);
                } else {
                    this.$cache.input.prop("value", this.result.from);
                }
                this.$cache.input.data("from", this.result.from);
            } else {
                if (this.options.values.length) {
                    this.$cache.input.prop("value", this.result.from_value + this.options.input_values_separator + this.result.to_value);
                } else {
                    this.$cache.input.prop("value", this.result.from + this.options.input_values_separator + this.result.to);
                }
                this.$cache.input.data("from", this.result.from);
                this.$cache.input.data("to", this.result.to);
            }
        },



        // =============================================================================================================
        // Callbacks

        callOnStart: function () {
            this.writeToInput();

            if (this.options.onStart && typeof this.options.onStart === "function") {
                if (this.options.scope) {
                    this.options.onStart.call(this.options.scope, this.result);
                } else {
                    this.options.onStart(this.result);
                }
            }
        },
        callOnChange: function () {
            this.writeToInput();

            if (this.options.onChange && typeof this.options.onChange === "function") {
                if (this.options.scope) {
                    this.options.onChange.call(this.options.scope, this.result);
                } else {
                    this.options.onChange(this.result);
                }
            }
        },
        callOnFinish: function () {
            this.writeToInput();

            if (this.options.onFinish && typeof this.options.onFinish === "function") {
                if (this.options.scope) {
                    this.options.onFinish.call(this.options.scope, this.result);
                } else {
                    this.options.onFinish(this.result);
                }
            }
        },
        callOnUpdate: function () {
            this.writeToInput();

            if (this.options.onUpdate && typeof this.options.onUpdate === "function") {
                if (this.options.scope) {
                    this.options.onUpdate.call(this.options.scope, this.result);
                } else {
                    this.options.onUpdate(this.result);
                }
            }
        },




        // =============================================================================================================
        // Service methods

        toggleInput: function () {
            this.$cache.input.toggleClass("irs-hidden-input");

            if (this.has_tab_index) {
                this.$cache.input.prop("tabindex", -1);
            } else {
                this.$cache.input.removeProp("tabindex");
            }

            this.has_tab_index = !this.has_tab_index;
        },

        /**
         * Convert real value to percent
         *
         * @param value {Number} X in real
         * @param no_min {boolean=} don't use min value
         * @returns {Number} X in percent
         */
        convertToPercent: function (value, no_min) {
            var diapason = this.options.max - this.options.min,
                one_percent = diapason / 100,
                val, percent;

            if (!diapason) {
                this.no_diapason = true;
                return 0;
            }

            if (no_min) {
                val = value;
            } else {
                val = value - this.options.min;
            }

            percent = val / one_percent;

            return this.toFixed(percent);
        },

        /**
         * Convert percent to real values
         *
         * @param percent {Number} X in percent
         * @returns {Number} X in real
         */
        convertToValue: function (percent) {
            var min = this.options.min,
                max = this.options.max,
                min_decimals = min.toString().split(".")[1],
                max_decimals = max.toString().split(".")[1],
                min_length, max_length,
                avg_decimals = 0,
                abs = 0;

            if (percent === 0) {
                return this.options.min;
            }
            if (percent === 100) {
                return this.options.max;
            }


            if (min_decimals) {
                min_length = min_decimals.length;
                avg_decimals = min_length;
            }
            if (max_decimals) {
                max_length = max_decimals.length;
                avg_decimals = max_length;
            }
            if (min_length && max_length) {
                avg_decimals = (min_length >= max_length) ? min_length : max_length;
            }

            if (min < 0) {
                abs = Math.abs(min);
                min = +(min + abs).toFixed(avg_decimals);
                max = +(max + abs).toFixed(avg_decimals);
            }

            var number = ((max - min) / 100 * percent) + min,
                string = this.options.step.toString().split(".")[1],
                result;

            if (string) {
                number = +number.toFixed(string.length);
            } else {
                number = number / this.options.step;
                number = number * this.options.step;

                number = +number.toFixed(0);
            }

            if (abs) {
                number -= abs;
            }

            if (string) {
                result = +number.toFixed(string.length);
            } else {
                result = this.toFixed(number);
            }

            if (result < this.options.min) {
                result = this.options.min;
            } else if (result > this.options.max) {
                result = this.options.max;
            }

            return result;
        },

        /**
         * Round percent value with step
         *
         * @param percent {Number}
         * @returns percent {Number} rounded
         */
        calcWithStep: function (percent) {
            var rounded = Math.round(percent / this.coords.p_step) * this.coords.p_step;

            if (rounded > 100) {
                rounded = 100;
            }
            if (percent === 100) {
                rounded = 100;
            }

            return this.toFixed(rounded);
        },

        checkMinInterval: function (p_current, p_next, type) {
            var o = this.options,
                current,
                next;

            if (!o.min_interval) {
                return p_current;
            }

            current = this.convertToValue(p_current);
            next = this.convertToValue(p_next);

            if (type === "from") {

                if (next - current < o.min_interval) {
                    current = next - o.min_interval;
                }

            } else {

                if (current - next < o.min_interval) {
                    current = next + o.min_interval;
                }

            }

            return this.convertToPercent(current);
        },

        checkMaxInterval: function (p_current, p_next, type) {
            var o = this.options,
                current,
                next;

            if (!o.max_interval) {
                return p_current;
            }

            current = this.convertToValue(p_current);
            next = this.convertToValue(p_next);

            if (type === "from") {

                if (next - current > o.max_interval) {
                    current = next - o.max_interval;
                }

            } else {

                if (current - next > o.max_interval) {
                    current = next + o.max_interval;
                }

            }

            return this.convertToPercent(current);
        },

        checkDiapason: function (p_num, min, max) {
            var num = this.convertToValue(p_num),
                o = this.options;

            if (typeof min !== "number") {
                min = o.min;
            }

            if (typeof max !== "number") {
                max = o.max;
            }

            if (num < min) {
                num = min;
            }

            if (num > max) {
                num = max;
            }

            return this.convertToPercent(num);
        },

        toFixed: function (num) {
            num = num.toFixed(20);
            return +num;
        },

        _prettify: function (num) {
            if (!this.options.prettify_enabled) {
                return num;
            }

            if (this.options.prettify && typeof this.options.prettify === "function") {
                return this.options.prettify(num);
            } else {
                return this.prettify(num);
            }
        },

        prettify: function (num) {
            var n = num.toString();
            return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + this.options.prettify_separator);
        },

        checkEdges: function (left, width) {
            if (!this.options.force_edges) {
                return this.toFixed(left);
            }

            if (left < 0) {
                left = 0;
            } else if (left > 100 - width) {
                left = 100 - width;
            }

            return this.toFixed(left);
        },

        validate: function () {
            var o = this.options,
                r = this.result,
                v = o.values,
                vl = v.length,
                value,
                i;

            if (typeof o.min === "string") o.min = +o.min;
            if (typeof o.max === "string") o.max = +o.max;
            if (typeof o.from === "string") o.from = +o.from;
            if (typeof o.to === "string") o.to = +o.to;
            if (typeof o.step === "string") o.step = +o.step;

            if (typeof o.from_min === "string") o.from_min = +o.from_min;
            if (typeof o.from_max === "string") o.from_max = +o.from_max;
            if (typeof o.to_min === "string") o.to_min = +o.to_min;
            if (typeof o.to_max === "string") o.to_max = +o.to_max;

            if (typeof o.grid_num === "string") o.grid_num = +o.grid_num;

            if (o.max < o.min) {
                o.max = o.min;
            }

            if (vl) {
                o.p_values = [];
                o.min = 0;
                o.max = vl - 1;
                o.step = 1;
                o.grid_num = o.max;
                o.grid_snap = true;

                for (i = 0; i < vl; i++) {
                    value = +v[i];

                    if (!isNaN(value)) {
                        v[i] = value;
                        value = this._prettify(value);
                    } else {
                        value = v[i];
                    }

                    o.p_values.push(value);
                }
            }

            if (typeof o.from !== "number" || isNaN(o.from)) {
                o.from = o.min;
            }

            if (typeof o.to !== "number" || isNaN(o.to)) {
                o.to = o.max;
            }

            if (o.type === "single") {

                if (o.from < o.min) o.from = o.min;
                if (o.from > o.max) o.from = o.max;

            } else {

                if (o.from < o.min) o.from = o.min;
                if (o.from > o.max) o.from = o.max;

                if (o.to < o.min) o.to = o.min;
                if (o.to > o.max) o.to = o.max;

                if (this.update_check.from) {

                    if (this.update_check.from !== o.from) {
                        if (o.from > o.to) o.from = o.to;
                    }
                    if (this.update_check.to !== o.to) {
                        if (o.to < o.from) o.to = o.from;
                    }

                }

                if (o.from > o.to) o.from = o.to;
                if (o.to < o.from) o.to = o.from;

            }

            if (typeof o.step !== "number" || isNaN(o.step) || !o.step || o.step < 0) {
                o.step = 1;
            }

            if (typeof o.from_min === "number" && o.from < o.from_min) {
                o.from = o.from_min;
            }

            if (typeof o.from_max === "number" && o.from > o.from_max) {
                o.from = o.from_max;
            }

            if (typeof o.to_min === "number" && o.to < o.to_min) {
                o.to = o.to_min;
            }

            if (typeof o.to_max === "number" && o.from > o.to_max) {
                o.to = o.to_max;
            }

            if (r) {
                if (r.min !== o.min) {
                    r.min = o.min;
                }

                if (r.max !== o.max) {
                    r.max = o.max;
                }

                if (r.from < r.min || r.from > r.max) {
                    r.from = o.from;
                }

                if (r.to < r.min || r.to > r.max) {
                    r.to = o.to;
                }
            }

            if (typeof o.min_interval !== "number" || isNaN(o.min_interval) || !o.min_interval || o.min_interval < 0) {
                o.min_interval = 0;
            }

            if (typeof o.max_interval !== "number" || isNaN(o.max_interval) || !o.max_interval || o.max_interval < 0) {
                o.max_interval = 0;
            }

            if (o.min_interval && o.min_interval > o.max - o.min) {
                o.min_interval = o.max - o.min;
            }

            if (o.max_interval && o.max_interval > o.max - o.min) {
                o.max_interval = o.max - o.min;
            }
        },

        decorate: function (num, original) {
            var decorated = "",
                o = this.options;

            if (o.prefix) {
                decorated += o.prefix;
            }

            decorated += num;

            if (o.max_postfix) {
                if (o.values.length && num === o.p_values[o.max]) {
                    decorated += o.max_postfix;
                    if (o.postfix) {
                        decorated += " ";
                    }
                } else if (original === o.max) {
                    decorated += o.max_postfix;
                    if (o.postfix) {
                        decorated += " ";
                    }
                }
            }

            if (o.postfix) {
                decorated += o.postfix;
            }

            return decorated;
        },

        updateFrom: function () {
            this.result.from = this.options.from;
            this.result.from_percent = this.convertToPercent(this.result.from);
            this.result.from_pretty = this._prettify(this.result.from);
            if (this.options.values) {
                this.result.from_value = this.options.values[this.result.from];
            }
        },

        updateTo: function () {
            this.result.to = this.options.to;
            this.result.to_percent = this.convertToPercent(this.result.to);
            this.result.to_pretty = this._prettify(this.result.to);
            if (this.options.values) {
                this.result.to_value = this.options.values[this.result.to];
            }
        },

        updateResult: function () {
            this.result.min = this.options.min;
            this.result.max = this.options.max;
            this.updateFrom();
            this.updateTo();
        },


        // =============================================================================================================
        // Grid

        appendGrid: function () {
            if (!this.options.grid) {
                return;
            }

            var o = this.options,
                i, z,

                total = o.max - o.min,
                big_num = o.grid_num,
                big_p = 0,
                big_w = 0,

                small_max = 4,
                local_small_max,
                small_p,
                small_w = 0,

                result,
                html = '';



            this.calcGridMargin();

            if (o.grid_snap) {
                big_num = total / o.step;
            }

            if (big_num > 50) big_num = 50;
            big_p = this.toFixed(100 / big_num);

            if (big_num > 4) {
                small_max = 3;
            }
            if (big_num > 7) {
                small_max = 2;
            }
            if (big_num > 14) {
                small_max = 1;
            }
            if (big_num > 28) {
                small_max = 0;
            }

            for (i = 0; i < big_num + 1; i++) {
                local_small_max = small_max;

                big_w = this.toFixed(big_p * i);

                if (big_w > 100) {
                    big_w = 100;
                }
                this.coords.big[i] = big_w;

                small_p = (big_w - (big_p * (i - 1))) / (local_small_max + 1);

                for (z = 1; z <= local_small_max; z++) {
                    if (big_w === 0) {
                        break;
                    }

                    small_w = this.toFixed(big_w - (small_p * z));

                    html += '<span class="irs-grid-pol small" style="left: ' + small_w + '%"></span>';
                }

                html += '<span class="irs-grid-pol" style="left: ' + big_w + '%"></span>';

                result = this.convertToValue(big_w);
                if (o.values.length) {
                    result = o.p_values[result];
                } else {
                    result = this._prettify(result);
                }

                html += '<span class="irs-grid-text js-grid-text-' + i + '" style="left: ' + big_w + '%">' + result + '</span>';
            }
            this.coords.big_num = Math.ceil(big_num + 1);



            this.$cache.cont.addClass("irs-with-grid");
            this.$cache.grid.html(html);
            this.cacheGridLabels();
        },

        cacheGridLabels: function () {
            var $label, i,
                num = this.coords.big_num;

            for (i = 0; i < num; i++) {
                $label = this.$cache.grid.find(".js-grid-text-" + i);
                this.$cache.grid_labels.push($label);
            }

            this.calcGridLabels();
        },

        calcGridLabels: function () {
            var i, label, start = [], finish = [],
                num = this.coords.big_num;

            for (i = 0; i < num; i++) {
                this.coords.big_w[i] = this.$cache.grid_labels[i].outerWidth(false);
                this.coords.big_p[i] = this.toFixed(this.coords.big_w[i] / this.coords.w_rs * 100);
                this.coords.big_x[i] = this.toFixed(this.coords.big_p[i] / 2);

                start[i] = this.toFixed(this.coords.big[i] - this.coords.big_x[i]);
                finish[i] = this.toFixed(start[i] + this.coords.big_p[i]);
            }

            if (this.options.force_edges) {
                if (start[0] < -this.coords.grid_gap) {
                    start[0] = -this.coords.grid_gap;
                    finish[0] = this.toFixed(start[0] + this.coords.big_p[0]);

                    this.coords.big_x[0] = this.coords.grid_gap;
                }

                if (finish[num - 1] > 100 + this.coords.grid_gap) {
                    finish[num - 1] = 100 + this.coords.grid_gap;
                    start[num - 1] = this.toFixed(finish[num - 1] - this.coords.big_p[num - 1]);

                    this.coords.big_x[num - 1] = this.toFixed(this.coords.big_p[num - 1] - this.coords.grid_gap);
                }
            }

            this.calcGridCollision(2, start, finish);
            this.calcGridCollision(4, start, finish);

            for (i = 0; i < num; i++) {
                label = this.$cache.grid_labels[i][0];

                if (this.coords.big_x[i] !== Number.POSITIVE_INFINITY) {
                    label.style.marginLeft = -this.coords.big_x[i] + "%";
                }
            }
        },

        // Collisions Calc Beta
        // TODO: Refactor then have plenty of time
        calcGridCollision: function (step, start, finish) {
            var i, next_i, label,
                num = this.coords.big_num;

            for (i = 0; i < num; i += step) {
                next_i = i + (step / 2);
                if (next_i >= num) {
                    break;
                }

                label = this.$cache.grid_labels[next_i][0];

                if (finish[i] <= start[next_i]) {
                    label.style.visibility = "visible";
                } else {
                    label.style.visibility = "hidden";
                }
            }
        },

        calcGridMargin: function () {
            if (!this.options.grid_margin) {
                return;
            }

            this.coords.w_rs = this.$cache.rs.outerWidth(false);
            if (!this.coords.w_rs) {
                return;
            }

            if (this.options.type === "single") {
                this.coords.w_handle = this.$cache.s_single.outerWidth(false);
            } else {
                this.coords.w_handle = this.$cache.s_from.outerWidth(false);
            }
            this.coords.p_handle = this.toFixed(this.coords.w_handle  / this.coords.w_rs * 100);
            this.coords.grid_gap = this.toFixed((this.coords.p_handle / 2) - 0.1);

            this.$cache.grid[0].style.width = this.toFixed(100 - this.coords.p_handle) + "%";
            this.$cache.grid[0].style.left = this.coords.grid_gap + "%";
        },



        // =============================================================================================================
        // Public methods

        update: function (options) {
            if (!this.input) {
                return;
            }

            this.is_update = true;

            this.options.from = this.result.from;
            this.options.to = this.result.to;
            this.update_check.from = this.result.from;
            this.update_check.to = this.result.to;

            this.options = $.extend(this.options, options);
            this.validate();
            this.updateResult(options);

            this.toggleInput();
            this.remove();
            this.init(true);
        },

        reset: function () {
            if (!this.input) {
                return;
            }

            this.updateResult();
            this.update();
        },

        destroy: function () {
            if (!this.input) {
                return;
            }

            this.toggleInput();
            this.$cache.input.prop("readonly", false);
            $.data(this.input, "ionRangeSlider", null);

            this.remove();
            this.input = null;
            this.options = null;
        }
    };

    $.fn.ionRangeSlider = function (options) {
        return this.each(function() {
            if (!$.data(this, "ionRangeSlider")) {
                $.data(this, "ionRangeSlider", new IonRangeSlider(this, options, plugin_count++));
            }
        });
    };



    // =================================================================================================================
    // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
    // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

    // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

    // MIT license

    (function() {
        var lastTime = 0;
        var vendors = ['ms', 'moz', 'webkit', 'o'];
        for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
            window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
            window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                || window[vendors[x]+'CancelRequestAnimationFrame'];
        }

        if (!window.requestAnimationFrame)
            window.requestAnimationFrame = function(callback, element) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                var id = window.setTimeout(function() { callback(currTime + timeToCall); },
                    timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };

        if (!window.cancelAnimationFrame)
            window.cancelAnimationFrame = function(id) {
                clearTimeout(id);
            };
    }());

}));


/***/ }),
/* 302 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8a6645_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(321);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8a6645_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(305);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(319)("30f94697", content, true, {});

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(306);
exports = module.exports = __webpack_require__(307)(false);
// imports


// module
exports.push([module.i, "@font-face{font-family:Gotham Book;src:url(" + escape(__webpack_require__(308)) + ");font-weight:400}@font-face{font-family:Gotham Book;src:url(" + escape(__webpack_require__(10)) + ");font-weight:500}@font-face{font-family:Gotham-Medium;src:url(" + escape(__webpack_require__(10)) + ");font-weight:500}@font-face{font-family:Gotham Medium;src:url(" + escape(__webpack_require__(10)) + ");font-weight:500}@font-face{font-family:Gotham-Bold;src:url(" + escape(__webpack_require__(10)) + ");font-weight:700}@font-face{font-family:Gotham Bold;src:url(" + escape(__webpack_require__(10)) + ");font-weight:700}.uk-breakpoint-s:before{content:\"640px\"}.uk-breakpoint-m:before{content:\"960px\"}.uk-breakpoint-l:before{content:\"1200px\"}.uk-breakpoint-xl:before{content:\"1600px\"}:root{--uk-breakpoint-s:640px;--uk-breakpoint-m:960px;--uk-breakpoint-l:1200px;--uk-breakpoint-xl:1600px}.uk-link-muted a,a.uk-link-muted{color:#999}.uk-link-muted a:hover,.uk-link-toggle:focus .uk-link-muted,.uk-link-toggle:hover .uk-link-muted,a.uk-link-muted:hover{color:#666}.uk-link-text a,a.uk-link-text{color:inherit}.uk-link-text a:hover,.uk-link-toggle:focus .uk-link-text,.uk-link-toggle:hover .uk-link-text,a.uk-link-text:hover{color:#999}.uk-link-heading a,a.uk-link-heading{color:inherit}.uk-link-heading a:hover,.uk-link-toggle:focus .uk-link-heading,.uk-link-toggle:hover .uk-link-heading,a.uk-link-heading:hover{color:#1e87f0;text-decoration:none}.uk-link-reset a,.uk-link-toggle,a.uk-link-reset{color:inherit!important;text-decoration:none!important}.uk-link-toggle:focus{outline:none}.uk-heading-small{font-size:2.6rem;line-height:1.2}.uk-heading-medium{font-size:2.8875rem;line-height:1.1}.uk-heading-large{font-size:3.4rem;line-height:1.1}.uk-heading-xlarge{font-size:4rem;line-height:1}.uk-heading-2xlarge{font-size:6rem;line-height:1}@media (min-width:960px){.uk-heading-small{font-size:3.25rem}.uk-heading-medium{font-size:3.5rem}.uk-heading-large{font-size:4rem}.uk-heading-xlarge{font-size:6rem}.uk-heading-2xlarge{font-size:8rem}}@media (min-width:1200px){.uk-heading-medium{font-size:4rem}.uk-heading-large{font-size:6rem}.uk-heading-xlarge{font-size:8rem}.uk-heading-2xlarge{font-size:11rem}}.uk-heading-divider{padding-bottom:calc(5px + .1em);border-bottom:calc(.2px + .05em) solid #e5e5e5}.uk-heading-bullet{position:relative}.uk-heading-bullet:before{content:\"\";display:inline-block;position:relative;top:-0.1em;vertical-align:middle;height:calc(4px + .7em);margin-right:calc(5px + .2em);border-left:calc(5px + .1em) solid #e5e5e5}.uk-heading-line{overflow:hidden}.uk-heading-line>*{display:inline-block;position:relative}.uk-heading-line>:after,.uk-heading-line>:before{content:\"\";position:absolute;top:calc(50% - ((.2px + .05em) / 2));width:2000px;border-bottom:calc(.2px + .05em) solid #e5e5e5}.uk-heading-line>:before{right:100%;margin-right:calc(5px + .3em)}.uk-heading-line>:after{left:100%;margin-left:calc(5px + .3em)}[class*=uk-divider]{border:none;margin-bottom:20px}*+[class*=uk-divider]{margin-top:20px}.uk-divider-icon{position:relative;height:20px;background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22none%22%20stroke%3D%22%23e5e5e5%22%20stroke-width%3D%222%22%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%227%22%20%2F%3E%0A%3C%2Fsvg%3E%0A\");background-repeat:no-repeat;background-position:50% 50%}.uk-divider-icon:after,.uk-divider-icon:before{content:\"\";position:absolute;top:50%;max-width:calc(50% - 25px);border-bottom:1px solid #e5e5e5}.uk-divider-icon:before{right:calc(50% + 25px);width:100%}.uk-divider-icon:after{left:calc(50% + 25px);width:100%}.uk-divider-small{line-height:0}.uk-divider-small:after{content:\"\";display:inline-block;width:100px;max-width:100%;border-top:1px solid #e5e5e5;vertical-align:top}.uk-divider-vertical{width:1px;height:100px;margin-left:auto;margin-right:auto;border-left:1px solid #e5e5e5}.uk-list{padding:0;list-style:none}.uk-list>*>:last-child{margin-bottom:0}.uk-list>*>ul,.uk-list>:nth-child(n+2){margin-top:10px}.uk-list-circle>*,.uk-list-decimal>*,.uk-list-disc>*,.uk-list-hyphen>*,.uk-list-square>*{padding-left:30px}.uk-list-decimal{counter-reset:decimal}.uk-list-decimal>*{counter-increment:decimal}[class*=uk-list]>:before{content:\"\";position:relative;left:-30px;width:30px;height:1.5em;margin-bottom:-1.5em;display:list-item;list-style-position:inside;text-align:right}.uk-list-disc>:before{list-style-type:disc}.uk-list-circle>:before{list-style-type:circle}.uk-list-square>:before{list-style-type:square}.uk-list-decimal>:before{content:counter(decimal,decimal) \"\\200A.\\A0\"}.uk-list-hyphen>:before{content:\"\\2013\\A0\\A0\"}.uk-list-muted>:before{color:#999!important}.uk-list-emphasis>:before{color:#333!important}.uk-list-primary>:before{color:#1e87f0!important}.uk-list-secondary>:before{color:#222!important}.uk-list-bullet>*{padding-left:30px}.uk-list-bullet>:before{content:\"\";position:relative;left:-30px;width:30px;height:1.5em;margin-bottom:-1.5em;background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%226%22%20height%3D%226%22%20viewBox%3D%220%200%206%206%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22%23666%22%20cx%3D%223%22%20cy%3D%223%22%20r%3D%223%22%20%2F%3E%0A%3C%2Fsvg%3E\");background-repeat:no-repeat;background-position:50% 50%}.uk-list-divider>:nth-child(n+2){margin-top:10px;padding-top:10px;border-top:1px solid #e5e5e5}.uk-list-striped>*{padding:10px}.uk-list-striped>:nth-of-type(odd){border-top:1px solid #e5e5e5;border-bottom:1px solid #e5e5e5;background:#f8f8f8}.uk-list-striped>:nth-child(n+2){margin-top:0}.uk-list-large>*>ul,.uk-list-large>:nth-child(n+2){margin-top:20px}.uk-list-collapse>*>ul,.uk-list-collapse>:nth-child(n+2){margin-top:0}.uk-list-large.uk-list-divider>:nth-child(n+2){margin-top:20px;padding-top:20px}.uk-list-collapse.uk-list-divider>:nth-child(n+2){margin-top:0;padding-top:0}.uk-list-large.uk-list-striped>*{padding:20px 10px}.uk-list-collapse.uk-list-striped>*{padding-top:0;padding-bottom:0}.uk-list-collapse.uk-list-striped>:nth-child(n+2),.uk-list-large.uk-list-striped>:nth-child(n+2){margin-top:0}.uk-description-list>dt{color:#333;font-size:.875rem;font-weight:400;text-transform:uppercase}.uk-description-list>dt:nth-child(n+2){margin-top:20px}.uk-description-list-divider>dt:nth-child(n+2){margin-top:20px;padding-top:20px;border-top:1px solid #e5e5e5}.uk-table{border-collapse:collapse;border-spacing:0;width:100%;margin-bottom:20px}*+.uk-table{margin-top:20px}.uk-table th{padding:16px 12px;text-align:left;vertical-align:bottom;font-size:.875rem;font-weight:400;color:#999;text-transform:uppercase}.uk-table td{padding:16px 12px;vertical-align:top}.uk-table td>:last-child{margin-bottom:0}.uk-table tfoot{font-size:.875rem}.uk-table caption{font-size:.875rem;text-align:left;color:#999}.uk-table-middle,.uk-table-middle td{vertical-align:middle!important}.uk-table-divider>:first-child>tr:not(:first-child),.uk-table-divider>:not(:first-child)>tr,.uk-table-divider>tr:not(:first-child){border-top:1px solid #e5e5e5}.uk-table-striped>tr:nth-of-type(odd),.uk-table-striped tbody tr:nth-of-type(odd){background:#f8f8f8;border-top:1px solid #e5e5e5;border-bottom:1px solid #e5e5e5}.uk-table-hover>tr:hover,.uk-table-hover tbody tr:hover,.uk-table>tr.uk-active,.uk-table tbody tr.uk-active{background:#ffd}.uk-table-small td,.uk-table-small th{padding:10px 12px}.uk-table-large td,.uk-table-large th{padding:22px 12px}.uk-table-justify td:first-child,.uk-table-justify th:first-child{padding-left:0}.uk-table-justify td:last-child,.uk-table-justify th:last-child{padding-right:0}.uk-table-shrink{width:1px}.uk-table-expand{min-width:150px}.uk-table-link{padding:0!important}.uk-table-link>a{display:block;padding:16px 12px}.uk-table-small .uk-table-link>a{padding:10px 12px}@media (max-width:959px){.uk-table-responsive,.uk-table-responsive tbody,.uk-table-responsive td,.uk-table-responsive th,.uk-table-responsive tr{display:block}.uk-table-responsive thead{display:none}.uk-table-responsive td,.uk-table-responsive th{width:auto!important;max-width:none!important;min-width:0!important;overflow:visible!important;white-space:normal!important}.uk-table-responsive .uk-table-link:not(:first-child)>a,.uk-table-responsive td:not(:first-child):not(.uk-table-link),.uk-table-responsive th:not(:first-child):not(.uk-table-link){padding-top:5px!important}.uk-table-responsive .uk-table-link:not(:last-child)>a,.uk-table-responsive td:not(:last-child):not(.uk-table-link),.uk-table-responsive th:not(:last-child):not(.uk-table-link){padding-bottom:5px!important}.uk-table-justify.uk-table-responsive td,.uk-table-justify.uk-table-responsive th{padding-left:0;padding-right:0}}.uk-table tbody tr{transition:background-color .1s linear}.uk-icon{margin:0;border:none;border-radius:0;overflow:visible;font:inherit;color:inherit;text-transform:none;padding:0;background-color:transparent;display:inline-block;fill:currentcolor;line-height:0}button.uk-icon:not(:disabled){cursor:pointer}.uk-icon::-moz-focus-inner{border:0;padding:0}.uk-icon:not(.uk-preserve) [fill*=\"#\"]:not(.uk-preserve){fill:currentcolor}.uk-icon:not(.uk-preserve) [stroke*=\"#\"]:not(.uk-preserve){stroke:currentcolor}.uk-icon>*{transform:translate(0)}.uk-icon-image{width:20px;height:20px;background-position:50% 50%;background-repeat:no-repeat;background-size:contain;vertical-align:middle}.uk-icon-link{color:#999}.uk-icon-link:focus,.uk-icon-link:hover{color:#666;outline:none}.uk-active>.uk-icon-link,.uk-icon-link:active{color:#595959}.uk-icon-button{box-sizing:border-box;width:36px;height:36px;border-radius:500px;background:#f8f8f8;color:#999;vertical-align:middle;display:inline-flex;justify-content:center;align-items:center;transition:.1s ease-in-out;transition-property:color,background-color}.uk-icon-button:focus,.uk-icon-button:hover{background-color:#ebebeb;color:#666;outline:none}.uk-active>.uk-icon-button,.uk-icon-button:active{background-color:#dfdfdf;color:#666}.uk-range{box-sizing:border-box;margin:0;vertical-align:middle;max-width:100%;width:100%;-webkit-appearance:none;background:transparent;padding:0}.uk-range:focus{outline:none}.uk-range::-moz-focus-outer{border:none}.uk-range::-ms-track{height:15px;background:transparent;border-color:transparent;color:transparent}.uk-range:not(:disabled)::-webkit-slider-thumb{cursor:pointer}.uk-range:not(:disabled)::-moz-range-thumb{cursor:pointer}.uk-range:not(:disabled)::-ms-thumb{cursor:pointer}.uk-range::-webkit-slider-thumb{-webkit-appearance:none;margin-top:-7px;height:15px;width:15px;border-radius:500px;background:#fff;border:1px solid #ccc}.uk-range::-moz-range-thumb{border:none;height:15px;width:15px;border-radius:500px;background:#fff;border:1px solid #ccc}.uk-range::-ms-thumb{margin-top:0;border:none;height:15px;width:15px;border-radius:500px;background:#fff;border:1px solid #ccc}.uk-range::-ms-tooltip{display:none}.uk-range::-webkit-slider-runnable-track{height:3px;background:#ebebeb;border-radius:500px}.uk-range:active::-webkit-slider-runnable-track,.uk-range:focus::-webkit-slider-runnable-track{background:#d2d2d2}.uk-range::-moz-range-track{height:3px;background:#ebebeb;border-radius:500px}.uk-range:focus::-moz-range-track{background:#d2d2d2}.uk-range::-ms-fill-lower,.uk-range::-ms-fill-upper{height:3px;background:#ebebeb;border-radius:500px}.uk-range:focus::-ms-fill-lower,.uk-range:focus::-ms-fill-upper{background:#d2d2d2}.uk-checkbox,.uk-input,.uk-radio,.uk-select,.uk-textarea{box-sizing:border-box;margin:0;border-radius:0;font:inherit}.uk-input{overflow:visible}.uk-select{text-transform:none}.uk-select optgroup{font:inherit;font-weight:700}.uk-textarea{overflow:auto}.uk-input[type=search]::-webkit-search-cancel-button,.uk-input[type=search]::-webkit-search-decoration{-webkit-appearance:none}.uk-input[type=number]::-webkit-inner-spin-button,.uk-input[type=number]::-webkit-outer-spin-button{height:auto}.uk-input::-moz-placeholder,.uk-textarea::-moz-placeholder{opacity:1}.uk-checkbox:not(:disabled),.uk-radio:not(:disabled){cursor:pointer}.uk-fieldset{border:none;margin:0;padding:0}.uk-input,.uk-textarea{-webkit-appearance:none}.uk-input,.uk-select,.uk-textarea{max-width:100%;width:100%;border:0 none;padding:0 10px;background:#fff;color:#666;border:1px solid #e5e5e5;transition:.2s ease-in-out;transition-property:color,background-color,border}.uk-input,.uk-select:not([multiple]):not([size]){height:40px;vertical-align:middle;display:inline-block}.uk-input:not(input),.uk-select:not(select){line-height:38px}.uk-select[multiple],.uk-select[size],.uk-textarea{padding-top:4px;padding-bottom:4px;vertical-align:top}.uk-select[multiple],.uk-select[size]{resize:vertical}.uk-input:focus,.uk-select:focus,.uk-textarea:focus{outline:none;background-color:#fff;color:#666;border-color:#1e87f0}.uk-input:disabled,.uk-select:disabled,.uk-textarea:disabled{background-color:#f8f8f8;color:#999;border-color:#e5e5e5}.uk-input::-ms-input-placeholder{color:#999!important}.uk-input::placeholder{color:#999}.uk-textarea::-ms-input-placeholder{color:#999!important}.uk-textarea::placeholder{color:#999}.uk-form-small{font-size:.875rem}.uk-form-small:not(textarea):not([multiple]):not([size]){height:30px;padding-left:8px;padding-right:8px}.uk-form-small:not(select):not(input):not(textarea){line-height:28px}.uk-form-large{font-size:1.25rem}.uk-form-large:not(textarea):not([multiple]):not([size]){height:55px;padding-left:12px;padding-right:12px}.uk-form-large:not(select):not(input):not(textarea){line-height:53px}.uk-form-danger,.uk-form-danger:focus{color:#f0506e;border-color:#f0506e}.uk-form-success,.uk-form-success:focus{color:#32d296;border-color:#32d296}.uk-form-blank{background:none;border-color:transparent}.uk-form-blank:focus{border-color:#e5e5e5;border-style:dashed}input.uk-form-width-xsmall{width:50px}select.uk-form-width-xsmall{width:75px}.uk-form-width-small{width:130px}.uk-form-width-medium{width:200px}.uk-form-width-large{width:500px}.uk-select:not([multiple]):not([size]){-webkit-appearance:none;-moz-appearance:none;padding-right:20px;background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2224%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23666%22%20points%3D%2212%201%209%206%2015%206%22%20%2F%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23666%22%20points%3D%2212%2013%209%208%2015%208%22%20%2F%3E%0A%3C%2Fsvg%3E%0A\");background-repeat:no-repeat;background-position:100% 50%}.uk-select:not([multiple]):not([size])::-ms-expand{display:none}.uk-select:not([multiple]):not([size]) option{color:#444}.uk-select:not([multiple]):not([size]):disabled{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2224%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23999%22%20points%3D%2212%201%209%206%2015%206%22%20%2F%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23999%22%20points%3D%2212%2013%209%208%2015%208%22%20%2F%3E%0A%3C%2Fsvg%3E%0A\")}.uk-input[list]{padding-right:20px;background-repeat:no-repeat;background-position:100% 50%}.uk-input[list]:focus,.uk-input[list]:hover{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2224%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23666%22%20points%3D%2212%2012%208%206%2016%206%22%20%2F%3E%0A%3C%2Fsvg%3E%0A\")}.uk-input[list]::-webkit-calendar-picker-indicator{display:none}.uk-checkbox,.uk-radio{display:inline-block;height:16px;width:16px;overflow:hidden;margin-top:-4px;vertical-align:middle;-webkit-appearance:none;-moz-appearance:none;background-color:transparent;background-repeat:no-repeat;background-position:50% 50%;border:1px solid #ccc;transition:.2s ease-in-out;transition-property:background-color,border}.uk-radio{border-radius:50%}.uk-checkbox:focus,.uk-radio:focus{outline:none;border-color:#1e87f0}.uk-checkbox:checked,.uk-checkbox:indeterminate,.uk-radio:checked{background-color:#1e87f0;border-color:transparent}.uk-checkbox:checked:focus,.uk-checkbox:indeterminate:focus,.uk-radio:checked:focus{background-color:#0e6dcd}.uk-radio:checked{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22%23fff%22%20cx%3D%228%22%20cy%3D%228%22%20r%3D%222%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-checkbox:checked{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2211%22%20viewBox%3D%220%200%2014%2011%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23fff%22%20points%3D%2212%201%205%207.5%202%205%201%205.5%205%2010%2013%201.5%22%20%2F%3E%0A%3C%2Fsvg%3E%0A\")}.uk-checkbox:indeterminate{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Crect%20fill%3D%22%23fff%22%20x%3D%223%22%20y%3D%228%22%20width%3D%2210%22%20height%3D%221%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-checkbox:disabled,.uk-radio:disabled{background-color:#f8f8f8;border-color:#e5e5e5}.uk-radio:disabled:checked{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22%23999%22%20cx%3D%228%22%20cy%3D%228%22%20r%3D%222%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-checkbox:disabled:checked{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2211%22%20viewBox%3D%220%200%2014%2011%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23999%22%20points%3D%2212%201%205%207.5%202%205%201%205.5%205%2010%2013%201.5%22%20%2F%3E%0A%3C%2Fsvg%3E%0A\")}.uk-checkbox:disabled:indeterminate{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Crect%20fill%3D%22%23999%22%20x%3D%223%22%20y%3D%228%22%20width%3D%2210%22%20height%3D%221%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-legend{width:100%;color:inherit;padding:0;font-size:1.5rem;line-height:1.4}.uk-form-custom{display:inline-block;position:relative;max-width:100%;vertical-align:middle}.uk-form-custom input[type=file],.uk-form-custom select{position:absolute;top:0;z-index:1;width:100%;height:100%;left:0;-webkit-appearance:none;opacity:0;cursor:pointer}.uk-form-custom input[type=file]{font-size:500px;overflow:hidden}.uk-form-label{color:#333;font-size:.875rem}.uk-form-stacked .uk-form-label{display:block;margin-bottom:5px}@media (max-width:959px){.uk-form-horizontal .uk-form-label{display:block;margin-bottom:5px}}@media (min-width:960px){.uk-form-horizontal .uk-form-label{width:200px;margin-top:7px;float:left}.uk-form-horizontal .uk-form-controls{margin-left:215px}.uk-form-horizontal .uk-form-controls-text{padding-top:7px}}.uk-form-icon{position:absolute;top:0;bottom:0;left:0;width:40px;display:inline-flex;justify-content:center;align-items:center;color:#999}.uk-form-icon:hover{color:#666}.uk-form-icon:not(a):not(button):not(input){pointer-events:none}.uk-form-icon:not(.uk-form-icon-flip)~.uk-input{padding-left:40px!important}.uk-form-icon-flip{right:0;left:auto}.uk-form-icon-flip~.uk-input{padding-right:40px!important}.uk-button{margin:0;border:none;overflow:visible;font:inherit;color:inherit;text-transform:none;-webkit-appearance:none;border-radius:0;display:inline-block;box-sizing:border-box;padding:0 30px;vertical-align:middle;font-size:.875rem;line-height:38px;text-align:center;text-decoration:none;text-transform:uppercase;transition:.1s ease-in-out;transition-property:color,background-color,border-color}.uk-button:not(:disabled){cursor:pointer}.uk-button::-moz-focus-inner{border:0;padding:0}.uk-button:hover{text-decoration:none}.uk-button:focus{outline:none}.uk-button-default{background-color:transparent;color:#333;border:1px solid #e5e5e5}.uk-button-default:focus,.uk-button-default:hover{background-color:transparent;color:#333;border-color:#b2b2b2}.uk-button-default.uk-active,.uk-button-default:active{background-color:transparent;color:#333;border-color:#999}.uk-button-primary{background-color:#1e87f0;color:#fff;border:1px solid transparent}.uk-button-primary:focus,.uk-button-primary:hover{background-color:#0f7ae5;color:#fff}.uk-button-primary.uk-active,.uk-button-primary:active{background-color:#0e6dcd;color:#fff}.uk-button-secondary{background-color:#222;color:#fff;border:1px solid transparent}.uk-button-secondary:focus,.uk-button-secondary:hover{background-color:#151515;color:#fff}.uk-button-secondary.uk-active,.uk-button-secondary:active{background-color:#080808;color:#fff}.uk-button-danger{background-color:#f0506e;color:#fff;border:1px solid transparent}.uk-button-danger:focus,.uk-button-danger:hover{background-color:#ee395b;color:#fff}.uk-button-danger.uk-active,.uk-button-danger:active{background-color:#ec2147;color:#fff}.uk-button-danger:disabled,.uk-button-default:disabled,.uk-button-primary:disabled,.uk-button-secondary:disabled{background-color:transparent;color:#999;border-color:#e5e5e5}.uk-button-small{padding:0 15px;line-height:28px;font-size:.875rem}.uk-button-large{padding:0 40px;line-height:53px;font-size:.875rem}.uk-button-text{padding:0;line-height:1.5;background:none;color:#333;position:relative}.uk-button-text:before{content:\"\";position:absolute;bottom:0;left:0;right:100%;border-bottom:1px solid #333;transition:right .3s ease-out}.uk-button-text:focus,.uk-button-text:hover{color:#333}.uk-button-text:focus:before,.uk-button-text:hover:before{right:0}.uk-button-text:disabled{color:#999}.uk-button-text:disabled:before{display:none}.uk-button-link{padding:0;line-height:1.5;background:none;color:#1e87f0}.uk-button-link:focus,.uk-button-link:hover{color:#0f6ecd;text-decoration:underline}.uk-button-link:disabled{color:#999;text-decoration:none}.uk-button-group{display:inline-flex;vertical-align:middle;position:relative}.uk-button-group>.uk-button:nth-child(n+2),.uk-button-group>div:nth-child(n+2) .uk-button{margin-left:-1px}.uk-button-group .uk-button.uk-active,.uk-button-group .uk-button:active,.uk-button-group .uk-button:focus,.uk-button-group .uk-button:hover{position:relative;z-index:1}.uk-progress{vertical-align:baseline;-webkit-appearance:none;-moz-appearance:none;display:block;width:100%;border:0;background-color:#f8f8f8;margin-bottom:20px;height:15px;border-radius:500px;overflow:hidden}*+.uk-progress{margin-top:20px}.uk-progress:indeterminate{color:transparent}.uk-progress::-webkit-progress-bar{background-color:#f8f8f8;border-radius:500px;overflow:hidden}.uk-progress:indeterminate::-moz-progress-bar{width:0}.uk-progress::-webkit-progress-value{background-color:#1e87f0;transition:width .6s ease}.uk-progress::-moz-progress-bar{background-color:#1e87f0}.uk-progress::-ms-fill{background-color:#1e87f0;transition:width .6s ease;border:0}.uk-section{display:flow-root;box-sizing:border-box;padding-top:40px;padding-bottom:40px}@media (min-width:960px){.uk-section{padding-top:70px;padding-bottom:70px}}.uk-section>:last-child{margin-bottom:0}.uk-section-xsmall{padding-top:20px;padding-bottom:20px}.uk-section-small{padding-top:40px;padding-bottom:40px}.uk-section-large{padding-top:70px;padding-bottom:70px}@media (min-width:960px){.uk-section-large{padding-top:140px;padding-bottom:140px}}.uk-section-xlarge{padding-top:140px;padding-bottom:140px}@media (min-width:960px){.uk-section-xlarge{padding-top:210px;padding-bottom:210px}}.uk-section-default{background:#fff}.uk-section-muted{background:#f8f8f8}.uk-section-primary{background:#1e87f0}.uk-section-secondary{background:#222}.uk-container{display:flow-root;box-sizing:content-box;max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media (min-width:640px){.uk-container{padding-left:30px;padding-right:30px}}@media (min-width:960px){.uk-container{padding-left:40px;padding-right:40px}}.uk-container>:last-child{margin-bottom:0}.uk-container .uk-container{padding-left:0;padding-right:0}.uk-container-xsmall{max-width:750px}.uk-container-small{max-width:900px}.uk-container-large{max-width:1400px}.uk-container-xlarge{max-width:1600px}.uk-container-expand{max-width:none}.uk-container-expand-left{margin-left:0}.uk-container-expand-right{margin-right:0}@media (min-width:640px){.uk-container-expand-left.uk-container-xsmall,.uk-container-expand-right.uk-container-xsmall{max-width:calc(50% + 375px - 30px)}.uk-container-expand-left.uk-container-small,.uk-container-expand-right.uk-container-small{max-width:calc(50% + 450px - 30px)}}@media (min-width:960px){.uk-container-expand-left,.uk-container-expand-right{max-width:calc(50% + 600px - 40px)}.uk-container-expand-left.uk-container-xsmall,.uk-container-expand-right.uk-container-xsmall{max-width:calc(50% + 375px - 40px)}.uk-container-expand-left.uk-container-small,.uk-container-expand-right.uk-container-small{max-width:calc(50% + 450px - 40px)}.uk-container-expand-left.uk-container-large,.uk-container-expand-right.uk-container-large{max-width:calc(50% + 700px - 40px)}.uk-container-expand-left.uk-container-xlarge,.uk-container-expand-right.uk-container-xlarge{max-width:calc(50% + 800px - 40px)}}.uk-container-item-padding-remove-left,.uk-container-item-padding-remove-right{width:calc(100% + 15px)}.uk-container-item-padding-remove-left{margin-left:-15px}.uk-container-item-padding-remove-right{margin-right:-15px}@media (min-width:640px){.uk-container-item-padding-remove-left,.uk-container-item-padding-remove-right{width:calc(100% + 30px)}.uk-container-item-padding-remove-left{margin-left:-30px}.uk-container-item-padding-remove-right{margin-right:-30px}}@media (min-width:960px){.uk-container-item-padding-remove-left,.uk-container-item-padding-remove-right{width:calc(100% + 40px)}.uk-container-item-padding-remove-left{margin-left:-40px}.uk-container-item-padding-remove-right{margin-right:-40px}}.uk-tile{display:flow-root;position:relative;box-sizing:border-box;padding:40px 15px}@media (min-width:640px){.uk-tile{padding-left:30px;padding-right:30px}}@media (min-width:960px){.uk-tile{padding:70px 40px}}.uk-tile>:last-child{margin-bottom:0}.uk-tile-xsmall{padding-top:20px;padding-bottom:20px}.uk-tile-small{padding-top:40px;padding-bottom:40px}.uk-tile-large{padding-top:70px;padding-bottom:70px}@media (min-width:960px){.uk-tile-large{padding-top:140px;padding-bottom:140px}}.uk-tile-xlarge{padding-top:140px;padding-bottom:140px}@media (min-width:960px){.uk-tile-xlarge{padding-top:210px;padding-bottom:210px}}.uk-tile-default{background:#fff}.uk-tile-muted{background:#f8f8f8}.uk-tile-primary{background:#1e87f0}.uk-tile-secondary{background:#222}.uk-card{position:relative;box-sizing:border-box;transition:box-shadow .1s ease-in-out}.uk-card-body{display:flow-root;padding:30px}.uk-card-footer,.uk-card-header{display:flow-root;padding:15px 30px}@media (min-width:1200px){.uk-card-body{padding:40px}.uk-card-footer,.uk-card-header{padding:20px 40px}}.uk-card-body>:last-child,.uk-card-footer>:last-child,.uk-card-header>:last-child{margin-bottom:0}.uk-card-title{font-size:1.5rem;line-height:1.4}.uk-card-badge{position:absolute;top:15px;right:15px;z-index:1;height:30px;padding-left:10px;padding-right:10px;background:#1e87f0;color:#fff;font-size:.875rem;display:flex;justify-content:center;align-items:center}.uk-card-badge:first-child+*{margin-top:0}.uk-card-hover:not(.uk-card-default):not(.uk-card-primary):not(.uk-card-secondary):hover{background:#fff;box-shadow:0 14px 25px rgba(0,0,0,.16)}.uk-card-default{background:#fff;color:#666;box-shadow:0 5px 15px rgba(0,0,0,.08)}.uk-card-default .uk-card-title{color:#333}.uk-card-default.uk-card-hover:hover{background-color:#fff;box-shadow:0 14px 25px rgba(0,0,0,.16)}.uk-card-default .uk-card-header{border-bottom:1px solid #e5e5e5}.uk-card-default .uk-card-footer{border-top:1px solid #e5e5e5}.uk-card-primary{background:#1e87f0;color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.08)}.uk-card-primary .uk-card-title{color:#fff}.uk-card-primary.uk-card-hover:hover{background-color:#1e87f0;box-shadow:0 14px 25px rgba(0,0,0,.16)}.uk-card-secondary{background:#222;color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.08)}.uk-card-secondary .uk-card-title{color:#fff}.uk-card-secondary.uk-card-hover:hover{background-color:#222;box-shadow:0 14px 25px rgba(0,0,0,.16)}.uk-card-small.uk-card-body,.uk-card-small .uk-card-body{padding:20px}.uk-card-small .uk-card-footer,.uk-card-small .uk-card-header{padding:13px 20px}@media (min-width:1200px){.uk-card-large.uk-card-body,.uk-card-large .uk-card-body{padding:70px}.uk-card-large .uk-card-footer,.uk-card-large .uk-card-header{padding:35px 70px}}.uk-card-body>.uk-nav-default{margin-left:-30px;margin-right:-30px}.uk-card-body>.uk-nav-default:only-child{margin-top:-15px;margin-bottom:-15px}.uk-card-body>.uk-nav-default .uk-nav-divider,.uk-card-body>.uk-nav-default .uk-nav-header,.uk-card-body>.uk-nav-default>li>a{padding-left:30px;padding-right:30px}.uk-card-body>.uk-nav-default .uk-nav-sub{padding-left:45px}@media (min-width:1200px){.uk-card-body>.uk-nav-default{margin-left:-40px;margin-right:-40px}.uk-card-body>.uk-nav-default:only-child{margin-top:-25px;margin-bottom:-25px}.uk-card-body>.uk-nav-default .uk-nav-divider,.uk-card-body>.uk-nav-default .uk-nav-header,.uk-card-body>.uk-nav-default>li>a{padding-left:40px;padding-right:40px}.uk-card-body>.uk-nav-default .uk-nav-sub{padding-left:55px}}.uk-card-small>.uk-nav-default{margin-left:-20px;margin-right:-20px}.uk-card-small>.uk-nav-default:only-child{margin-top:-5px;margin-bottom:-5px}.uk-card-small>.uk-nav-default .uk-nav-divider,.uk-card-small>.uk-nav-default .uk-nav-header,.uk-card-small>.uk-nav-default>li>a{padding-left:20px;padding-right:20px}.uk-card-small>.uk-nav-default .uk-nav-sub{padding-left:35px}@media (min-width:1200px){.uk-card-large>.uk-nav-default,.uk-card-large>.uk-nav-default:only-child{margin:0}.uk-card-large>.uk-nav-default .uk-nav-divider,.uk-card-large>.uk-nav-default .uk-nav-header,.uk-card-large>.uk-nav-default>li>a{padding-left:0;padding-right:0}.uk-card-large>.uk-nav-default .uk-nav-sub{padding-left:15px}}.uk-close{color:#999;transition:.1s ease-in-out;transition-property:color,opacity}.uk-close:focus,.uk-close:hover{color:#666;outline:none}.uk-spinner>*{animation:uk-spinner-rotate 1.4s linear infinite}@keyframes uk-spinner-rotate{0%{transform:rotate(0deg)}to{transform:rotate(270deg)}}.uk-spinner>*>*{stroke-dasharray:88px;stroke-dashoffset:0;transform-origin:center;animation:uk-spinner-dash 1.4s ease-in-out infinite;stroke-width:1;stroke-linecap:round}@keyframes uk-spinner-dash{0%{stroke-dashoffset:88px}50%{stroke-dashoffset:22px;transform:rotate(135deg)}to{stroke-dashoffset:88px;transform:rotate(450deg)}}.uk-totop{padding:5px;color:#999;transition:color .1s ease-in-out}.uk-totop:focus,.uk-totop:hover{color:#666;outline:none}.uk-totop:active{color:#333}.uk-marker{padding:5px;background:#222;color:#fff;border-radius:500px}.uk-marker:focus,.uk-marker:hover{color:#fff;outline:none}.uk-alert{position:relative;margin-bottom:20px;padding:15px 29px 15px 15px;background:#f8f8f8;color:#666}*+.uk-alert{margin-top:20px}.uk-alert>:last-child{margin-bottom:0}.uk-alert-close{position:absolute;top:20px;right:15px;color:inherit;opacity:.4}.uk-alert-close:first-child+*{margin-top:0}.uk-alert-close:focus,.uk-alert-close:hover{color:inherit;opacity:.8}.uk-alert-primary{background:#d8eafc;color:#1e87f0}.uk-alert-success{background:#edfbf6;color:#32d296}.uk-alert-warning{background:#fff6ee;color:#faa05a}.uk-alert-danger{background:#fef4f6;color:#f0506e}.uk-alert h1,.uk-alert h2,.uk-alert h3,.uk-alert h4,.uk-alert h5,.uk-alert h6{color:inherit}.uk-alert a:not([class]),.uk-alert a:not([class]):hover{color:inherit;text-decoration:underline}.uk-placeholder{margin-bottom:20px;padding:30px;background:transparent;border:1px dashed #e5e5e5}*+.uk-placeholder{margin-top:20px}.uk-placeholder>:last-child{margin-bottom:0}.uk-badge{box-sizing:border-box;min-width:22px;height:22px;padding:0 5px;border-radius:500px;vertical-align:middle;background:#1e87f0;color:#fff;font-size:.875rem;display:inline-flex;justify-content:center;align-items:center}.uk-badge:focus,.uk-badge:hover{color:#fff;text-decoration:none;outline:none}.uk-label{display:inline-block;padding:0 10px;background:#1e87f0;line-height:1.5;font-size:.875rem;color:#fff;vertical-align:middle;white-space:nowrap;border-radius:2px;text-transform:uppercase}.uk-label-success{background-color:#32d296;color:#fff}.uk-label-warning{background-color:#faa05a;color:#fff}.uk-label-danger{background-color:#f0506e;color:#fff}.uk-overlay{padding:30px}.uk-overlay>:last-child{margin-bottom:0}.uk-overlay-default{background:hsla(0,0%,100%,.8)}.uk-overlay-primary{background:rgba(34,34,34,.8)}.uk-article{display:flow-root}.uk-article>:last-child{margin-bottom:0}.uk-article+.uk-article{margin-top:70px}.uk-article-title{font-size:2.23125rem;line-height:1.2}@media (min-width:960px){.uk-article-title{font-size:2.625rem}}.uk-article-meta{font-size:.875rem;line-height:1.4;color:#999}.uk-article-meta a{color:#999}.uk-article-meta a:hover{color:#666;text-decoration:none}.uk-comment-body{display:flow-root;overflow-wrap:break-word;word-wrap:break-word}.uk-comment-header{display:flow-root;margin-bottom:20px}.uk-comment-body>:last-child,.uk-comment-header>:last-child{margin-bottom:0}.uk-comment-title{font-size:1.25rem;line-height:1.4}.uk-comment-meta{font-size:.875rem;line-height:1.4;color:#999}.uk-comment-list{padding:0;list-style:none}.uk-comment-list>:nth-child(n+2){margin-top:70px}.uk-comment-list .uk-comment~ul{margin:70px 0 0;padding-left:30px;list-style:none}@media (min-width:960px){.uk-comment-list .uk-comment~ul{padding-left:100px}}.uk-comment-list .uk-comment~ul>:nth-child(n+2){margin-top:70px}.uk-comment-primary{padding:30px;background-color:#f8f8f8}.uk-search{display:inline-block;position:relative;max-width:100%;margin:0}.uk-search-input::-webkit-search-cancel-button,.uk-search-input::-webkit-search-decoration{-webkit-appearance:none}.uk-search-input::-moz-placeholder{opacity:1}.uk-search-input{box-sizing:border-box;margin:0;border-radius:0;font:inherit;overflow:visible;-webkit-appearance:none;vertical-align:middle;width:100%;border:none;color:#666}.uk-search-input:focus{outline:none}.uk-search-input:-ms-input-placeholder{color:#999!important}.uk-search-input::placeholder{color:#999}.uk-search-icon:focus{outline:none}.uk-search .uk-search-icon{position:absolute;top:0;bottom:0;left:0;display:inline-flex;justify-content:center;align-items:center;color:#999}.uk-search .uk-search-icon:hover{color:#999}.uk-search .uk-search-icon:not(a):not(button):not(input){pointer-events:none}.uk-search .uk-search-icon-flip{right:0;left:auto}.uk-search-default{width:180px}.uk-search-default .uk-search-input{height:40px;padding-left:6px;padding-right:6px;background:transparent;border:1px solid #e5e5e5}.uk-search-default .uk-search-input:focus{background-color:transparent}.uk-search-default .uk-search-icon{width:40px}.uk-search-default .uk-search-icon:not(.uk-search-icon-flip)~.uk-search-input{padding-left:40px}.uk-search-default .uk-search-icon-flip~.uk-search-input{padding-right:40px}.uk-search-navbar{width:400px}.uk-search-navbar .uk-search-input{height:40px;background:transparent;font-size:1.5rem}.uk-search-navbar .uk-search-icon{width:40px}.uk-search-navbar .uk-search-icon:not(.uk-search-icon-flip)~.uk-search-input{padding-left:40px}.uk-search-navbar .uk-search-icon-flip~.uk-search-input{padding-right:40px}.uk-search-large{width:500px}.uk-search-large .uk-search-input{height:80px;background:transparent;font-size:2.625rem}.uk-search-large .uk-search-icon{width:80px}.uk-search-large .uk-search-icon:not(.uk-search-icon-flip)~.uk-search-input{padding-left:80px}.uk-search-large .uk-search-icon-flip~.uk-search-input{padding-right:80px}.uk-search-toggle{color:#999}.uk-search-toggle:focus,.uk-search-toggle:hover{color:#666}.uk-accordion{padding:0;list-style:none}.uk-accordion>:nth-child(n+2){margin-top:20px}.uk-accordion-title{display:block;font-size:1.25rem;line-height:1.4;color:#333;overflow:hidden}.uk-accordion-title:before{content:\"\";width:1.4em;height:1.4em;margin-left:10px;float:right;background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2213%22%20height%3D%2213%22%20viewBox%3D%220%200%2013%2013%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Crect%20fill%3D%22%23666%22%20width%3D%2213%22%20height%3D%221%22%20x%3D%220%22%20y%3D%226%22%20%2F%3E%0A%20%20%20%20%3Crect%20fill%3D%22%23666%22%20width%3D%221%22%20height%3D%2213%22%20x%3D%226%22%20y%3D%220%22%20%2F%3E%0A%3C%2Fsvg%3E\");background-repeat:no-repeat;background-position:50% 50%}.uk-open>.uk-accordion-title:before{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2213%22%20height%3D%2213%22%20viewBox%3D%220%200%2013%2013%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Crect%20fill%3D%22%23666%22%20width%3D%2213%22%20height%3D%221%22%20x%3D%220%22%20y%3D%226%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-accordion-title:focus,.uk-accordion-title:hover{color:#666;text-decoration:none;outline:none}.uk-accordion-content{display:flow-root;margin-top:20px}.uk-accordion-content>:last-child{margin-bottom:0}.uk-drop{display:none;position:absolute;z-index:1020;box-sizing:border-box;width:300px}.uk-drop.uk-open{display:block}[class*=uk-drop-top]{margin-top:-20px}[class*=uk-drop-bottom]{margin-top:20px}[class*=uk-drop-left]{margin-left:-20px}[class*=uk-drop-right]{margin-left:20px}.uk-drop-stack .uk-drop-grid>*{width:100%!important}.uk-dropdown{display:none;position:absolute;z-index:1020;box-sizing:border-box;min-width:200px;padding:25px;background:#fff;color:#666;box-shadow:0 5px 12px rgba(0,0,0,.15)}.uk-dropdown.uk-open{display:block}.uk-dropdown-nav{white-space:nowrap;font-size:.875rem}.uk-dropdown-nav>li>a{color:#999}.uk-dropdown-nav>li.uk-active>a,.uk-dropdown-nav>li>a:focus,.uk-dropdown-nav>li>a:hover{color:#666}.uk-dropdown-nav .uk-nav-header{color:#333}.uk-dropdown-nav .uk-nav-divider{border-top:1px solid #e5e5e5}.uk-dropdown-nav .uk-nav-sub a{color:#999}.uk-dropdown-nav .uk-nav-sub a:focus,.uk-dropdown-nav .uk-nav-sub a:hover,.uk-dropdown-nav .uk-nav-sub li.uk-active>a{color:#666}[class*=uk-dropdown-top]{margin-top:-10px}[class*=uk-dropdown-bottom]{margin-top:10px}[class*=uk-dropdown-left]{margin-left:-10px}[class*=uk-dropdown-right]{margin-left:10px}.uk-dropdown-stack .uk-dropdown-grid>*{width:100%!important}.uk-modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1010;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:15px;background:rgba(0,0,0,.6);opacity:0;transition:opacity .15s linear}@media (min-width:640px){.uk-modal{padding:50px 30px}}@media (min-width:960px){.uk-modal{padding-left:40px;padding-right:40px}}.uk-modal.uk-open{opacity:1}.uk-modal-page{overflow:hidden}.uk-modal-dialog{position:relative;box-sizing:border-box;margin:0 auto;width:600px;max-width:calc(100% - .01px)!important;background:#fff;opacity:0;transform:translateY(-100px);transition:.3s linear;transition-property:opacity,transform}.uk-open>.uk-modal-dialog{opacity:1;transform:translateY(0)}.uk-modal-container .uk-modal-dialog{width:1200px}.uk-modal-full{padding:0;background:none}.uk-modal-full .uk-modal-dialog{margin:0;width:100%;max-width:100%;transform:translateY(0)}.uk-modal-body{display:flow-root;padding:30px}.uk-modal-header{border-bottom:1px solid #e5e5e5}.uk-modal-footer,.uk-modal-header{display:flow-root;padding:15px 30px;background:#fff}.uk-modal-footer{border-top:1px solid #e5e5e5}.uk-modal-body>:last-child,.uk-modal-footer>:last-child,.uk-modal-header>:last-child{margin-bottom:0}.uk-modal-title{font-size:2rem;line-height:1.3}[class*=uk-modal-close-]{position:absolute;z-index:1010;top:10px;right:10px;padding:5px}[class*=uk-modal-close-]:first-child+*{margin-top:0}.uk-modal-close-outside{top:0;right:-5px;transform:translateY(-100%);color:#fff}.uk-modal-close-outside:hover{color:#fff}@media (min-width:960px){.uk-modal-close-outside{right:0;transform:translate(100%,-100%)}}.uk-modal-close-full{top:0;right:0;padding:20px;background:#fff}.uk-slideshow{-webkit-tap-highlight-color:transparent}.uk-slideshow-items{position:relative;z-index:0;margin:0;padding:0;list-style:none;overflow:hidden;-webkit-touch-callout:none}.uk-slideshow-items>*{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;will-change:transform,opacity;touch-action:pan-y}.uk-slideshow-items>:focus{outline:none}.uk-slideshow-items>:not(.uk-active){display:none}.uk-slider{-webkit-tap-highlight-color:transparent}.uk-slider-container{overflow:hidden}.uk-slider-container-offset{margin:-11px -25px -39px;padding:11px 25px 39px}.uk-slider-items{will-change:transform;position:relative}.uk-slider-items:not(.uk-grid){display:flex;margin:0;padding:0;list-style:none;-webkit-touch-callout:none}.uk-slider-items.uk-grid{flex-wrap:nowrap}.uk-slider-items>*{flex:none;max-width:100%;position:relative;touch-action:pan-y}.uk-slider-items>:focus{outline:none}.uk-sticky-fixed{z-index:980;box-sizing:border-box;margin:0!important;-webkit-backface-visibility:hidden;backface-visibility:hidden}.uk-sticky.uk-animation-reverse,.uk-sticky[class*=uk-animation-]{animation-duration:.2s}.uk-offcanvas{display:none;position:fixed;top:0;bottom:0;left:0;z-index:1000}.uk-offcanvas-flip .uk-offcanvas{right:0;left:auto}.uk-offcanvas-bar{position:absolute;top:0;bottom:0;left:-270px;box-sizing:border-box;width:270px;padding:20px;background:#222;overflow-y:auto;-webkit-overflow-scrolling:touch}@media (min-width:960px){.uk-offcanvas-bar{left:-350px;width:350px;padding:40px}}.uk-offcanvas-flip .uk-offcanvas-bar{left:auto;right:-270px}@media (min-width:960px){.uk-offcanvas-flip .uk-offcanvas-bar{right:-350px}}.uk-open>.uk-offcanvas-bar{left:0}.uk-offcanvas-flip .uk-open>.uk-offcanvas-bar{left:auto;right:0}.uk-offcanvas-bar-animation{transition:left .3s ease-out}.uk-offcanvas-flip .uk-offcanvas-bar-animation{transition-property:right}.uk-offcanvas-reveal{position:absolute;top:0;bottom:0;left:0;width:0;overflow:hidden;transition:width .3s ease-out}.uk-offcanvas-reveal .uk-offcanvas-bar{left:0}.uk-offcanvas-flip .uk-offcanvas-reveal .uk-offcanvas-bar{left:auto;right:0}.uk-open>.uk-offcanvas-reveal{width:270px}@media (min-width:960px){.uk-open>.uk-offcanvas-reveal{width:350px}}.uk-offcanvas-flip .uk-offcanvas-reveal{right:0;left:auto}.uk-offcanvas-close{position:absolute;z-index:1000;top:20px;right:20px;padding:5px}.uk-offcanvas-overlay{width:100vw;touch-action:none}.uk-offcanvas-overlay:before{content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,.1);opacity:0;transition:opacity .15s linear}.uk-offcanvas-overlay.uk-open:before{opacity:1}.uk-offcanvas-container,.uk-offcanvas-page{overflow-x:hidden}.uk-offcanvas-container{position:relative;left:0;transition:left .3s ease-out;box-sizing:border-box;width:100%}:not(.uk-offcanvas-flip).uk-offcanvas-container-animation{left:270px}.uk-offcanvas-flip.uk-offcanvas-container-animation{left:-270px}@media (min-width:960px){:not(.uk-offcanvas-flip).uk-offcanvas-container-animation{left:350px}.uk-offcanvas-flip.uk-offcanvas-container-animation{left:-350px}}.uk-switcher{margin:0;padding:0;list-style:none}.uk-switcher>:not(.uk-active){display:none}.uk-switcher>*>:last-child{margin-bottom:0}.uk-leader{overflow:hidden}.uk-leader-fill:after{display:inline-block;margin-left:15px;width:0;content:attr(data-fill);white-space:nowrap}.uk-leader-fill.uk-leader-hide:after{display:none}.uk-leader-fill-content:before{content:\".\"}.uk-notification{position:fixed;top:10px;left:10px;z-index:1040;box-sizing:border-box;width:350px}.uk-notification-bottom-right,.uk-notification-top-right{left:auto;right:10px}.uk-notification-bottom-center,.uk-notification-top-center{left:50%;margin-left:-175px}.uk-notification-bottom-center,.uk-notification-bottom-left,.uk-notification-bottom-right{top:auto;bottom:10px}@media (max-width:639px){.uk-notification{left:10px;right:10px;width:auto;margin:0}}.uk-notification-message{position:relative;padding:15px;background:#f8f8f8;color:#666;font-size:1.25rem;line-height:1.4;cursor:pointer}*+.uk-notification-message{margin-top:10px}.uk-notification-close{display:none;position:absolute;top:20px;right:15px}.uk-notification-message:hover .uk-notification-close{display:block}.uk-notification-message-primary{color:#1e87f0}.uk-notification-message-success{color:#32d296}.uk-notification-message-warning{color:#faa05a}.uk-notification-message-danger{color:#f0506e}.uk-tooltip{display:none;position:absolute;z-index:1030;top:0;box-sizing:border-box;max-width:200px;padding:3px 6px;background:#666;border-radius:2px;color:#fff;font-size:12px}.uk-tooltip.uk-active{display:block}[class*=uk-tooltip-top]{margin-top:-10px}[class*=uk-tooltip-bottom]{margin-top:10px}[class*=uk-tooltip-left]{margin-left:-10px}[class*=uk-tooltip-right]{margin-left:10px}.uk-sortable{position:relative}.uk-sortable>:last-child{margin-bottom:0}.uk-sortable-drag{position:fixed!important;z-index:1050!important;pointer-events:none}.uk-sortable-placeholder{opacity:0;pointer-events:none}.uk-sortable-empty{min-height:50px}.uk-sortable-handle:hover{cursor:move}.uk-countdown-number{font-variant-numeric:tabular-nums;font-size:2rem;line-height:.8}@media (min-width:640px){.uk-countdown-number{font-size:4rem}}@media (min-width:960px){.uk-countdown-number{font-size:6rem}}.uk-countdown-separator{font-size:1rem;line-height:1.6}@media (min-width:640px){.uk-countdown-separator{font-size:2rem}}@media (min-width:960px){.uk-countdown-separator{font-size:3rem}}.uk-grid{display:flex;flex-wrap:wrap;margin:0;padding:0;list-style:none}.uk-grid>*{margin:0}.uk-grid>*>:last-child{margin-bottom:0}.uk-grid{margin-left:-30px}.uk-grid>*{padding-left:30px}*+.uk-grid-margin,.uk-grid+.uk-grid,.uk-grid>.uk-grid-margin{margin-top:30px}@media (min-width:1200px){.uk-grid{margin-left:-40px}.uk-grid>*{padding-left:40px}*+.uk-grid-margin,.uk-grid+.uk-grid,.uk-grid>.uk-grid-margin{margin-top:40px}}.uk-grid-column-small,.uk-grid-small{margin-left:-15px}.uk-grid-column-small>*,.uk-grid-small>*{padding-left:15px}*+.uk-grid-margin-small,.uk-grid+.uk-grid-row-small,.uk-grid+.uk-grid-small,.uk-grid-row-small>.uk-grid-margin,.uk-grid-small>.uk-grid-margin{margin-top:15px}.uk-grid-column-medium,.uk-grid-medium{margin-left:-30px}.uk-grid-column-medium>*,.uk-grid-medium>*{padding-left:30px}*+.uk-grid-margin-medium,.uk-grid+.uk-grid-medium,.uk-grid+.uk-grid-row-medium,.uk-grid-medium>.uk-grid-margin,.uk-grid-row-medium>.uk-grid-margin{margin-top:30px}.uk-grid-column-large,.uk-grid-large{margin-left:-40px}.uk-grid-column-large>*,.uk-grid-large>*{padding-left:40px}*+.uk-grid-margin-large,.uk-grid+.uk-grid-large,.uk-grid+.uk-grid-row-large,.uk-grid-large>.uk-grid-margin,.uk-grid-row-large>.uk-grid-margin{margin-top:40px}@media (min-width:1200px){.uk-grid-column-large,.uk-grid-large{margin-left:-70px}.uk-grid-column-large>*,.uk-grid-large>*{padding-left:70px}*+.uk-grid-margin-large,.uk-grid+.uk-grid-large,.uk-grid+.uk-grid-row-large,.uk-grid-large>.uk-grid-margin,.uk-grid-row-large>.uk-grid-margin{margin-top:70px}}.uk-grid-collapse,.uk-grid-column-collapse{margin-left:0}.uk-grid-collapse>*,.uk-grid-column-collapse>*{padding-left:0}.uk-grid+.uk-grid-collapse,.uk-grid+.uk-grid-row-collapse,.uk-grid-collapse>.uk-grid-margin,.uk-grid-row-collapse>.uk-grid-margin{margin-top:0}.uk-grid-divider>*{position:relative}.uk-grid-divider>:not(.uk-first-column):before{content:\"\";position:absolute;top:0;bottom:0;border-left:1px solid #e5e5e5}.uk-grid-divider.uk-grid-stack>.uk-grid-margin:before{content:\"\";position:absolute;left:0;right:0;border-top:1px solid #e5e5e5}.uk-grid-divider{margin-left:-60px}.uk-grid-divider>*{padding-left:60px}.uk-grid-divider>:not(.uk-first-column):before{left:30px}.uk-grid-divider.uk-grid-stack>.uk-grid-margin{margin-top:60px}.uk-grid-divider.uk-grid-stack>.uk-grid-margin:before{top:-30px;left:60px}@media (min-width:1200px){.uk-grid-divider{margin-left:-80px}.uk-grid-divider>*{padding-left:80px}.uk-grid-divider>:not(.uk-first-column):before{left:40px}.uk-grid-divider.uk-grid-stack>.uk-grid-margin{margin-top:80px}.uk-grid-divider.uk-grid-stack>.uk-grid-margin:before{top:-40px;left:80px}}.uk-grid-divider.uk-grid-column-small,.uk-grid-divider.uk-grid-small{margin-left:-30px}.uk-grid-divider.uk-grid-column-small>*,.uk-grid-divider.uk-grid-small>*{padding-left:30px}.uk-grid-divider.uk-grid-column-small>:not(.uk-first-column):before,.uk-grid-divider.uk-grid-small>:not(.uk-first-column):before{left:15px}.uk-grid-divider.uk-grid-row-small.uk-grid-stack>.uk-grid-margin,.uk-grid-divider.uk-grid-small.uk-grid-stack>.uk-grid-margin{margin-top:30px}.uk-grid-divider.uk-grid-small.uk-grid-stack>.uk-grid-margin:before{top:-15px;left:30px}.uk-grid-divider.uk-grid-row-small.uk-grid-stack>.uk-grid-margin:before{top:-15px}.uk-grid-divider.uk-grid-column-small.uk-grid-stack>.uk-grid-margin:before{left:30px}.uk-grid-divider.uk-grid-column-medium,.uk-grid-divider.uk-grid-medium{margin-left:-60px}.uk-grid-divider.uk-grid-column-medium>*,.uk-grid-divider.uk-grid-medium>*{padding-left:60px}.uk-grid-divider.uk-grid-column-medium>:not(.uk-first-column):before,.uk-grid-divider.uk-grid-medium>:not(.uk-first-column):before{left:30px}.uk-grid-divider.uk-grid-medium.uk-grid-stack>.uk-grid-margin,.uk-grid-divider.uk-grid-row-medium.uk-grid-stack>.uk-grid-margin{margin-top:60px}.uk-grid-divider.uk-grid-medium.uk-grid-stack>.uk-grid-margin:before{top:-30px;left:60px}.uk-grid-divider.uk-grid-row-medium.uk-grid-stack>.uk-grid-margin:before{top:-30px}.uk-grid-divider.uk-grid-column-medium.uk-grid-stack>.uk-grid-margin:before{left:60px}.uk-grid-divider.uk-grid-column-large,.uk-grid-divider.uk-grid-large{margin-left:-80px}.uk-grid-divider.uk-grid-column-large>*,.uk-grid-divider.uk-grid-large>*{padding-left:80px}.uk-grid-divider.uk-grid-column-large>:not(.uk-first-column):before,.uk-grid-divider.uk-grid-large>:not(.uk-first-column):before{left:40px}.uk-grid-divider.uk-grid-large.uk-grid-stack>.uk-grid-margin,.uk-grid-divider.uk-grid-row-large.uk-grid-stack>.uk-grid-margin{margin-top:80px}.uk-grid-divider.uk-grid-large.uk-grid-stack>.uk-grid-margin:before{top:-40px;left:80px}.uk-grid-divider.uk-grid-row-large.uk-grid-stack>.uk-grid-margin:before{top:-40px}.uk-grid-divider.uk-grid-column-large.uk-grid-stack>.uk-grid-margin:before{left:80px}@media (min-width:1200px){.uk-grid-divider.uk-grid-column-large,.uk-grid-divider.uk-grid-large{margin-left:-140px}.uk-grid-divider.uk-grid-column-large>*,.uk-grid-divider.uk-grid-large>*{padding-left:140px}.uk-grid-divider.uk-grid-column-large>:not(.uk-first-column):before,.uk-grid-divider.uk-grid-large>:not(.uk-first-column):before{left:70px}.uk-grid-divider.uk-grid-large.uk-grid-stack>.uk-grid-margin,.uk-grid-divider.uk-grid-row-large.uk-grid-stack>.uk-grid-margin{margin-top:140px}.uk-grid-divider.uk-grid-large.uk-grid-stack>.uk-grid-margin:before{top:-70px;left:140px}.uk-grid-divider.uk-grid-row-large.uk-grid-stack>.uk-grid-margin:before{top:-70px}.uk-grid-divider.uk-grid-column-large.uk-grid-stack>.uk-grid-margin:before{left:140px}}.uk-grid-item-match,.uk-grid-match>*{display:flex;flex-wrap:wrap}.uk-grid-item-match>:not([class*=uk-width]),.uk-grid-match>*>:not([class*=uk-width]){box-sizing:border-box;width:100%;flex:auto}.uk-nav,.uk-nav ul{margin:0;padding:0;list-style:none}.uk-nav li>a{display:block;text-decoration:none}.uk-nav li>a:focus{outline:none}.uk-nav>li>a{padding:5px 0}ul.uk-nav-sub{padding:5px 0 5px 15px}.uk-nav-sub ul{padding-left:15px}.uk-nav-sub a{padding:2px 0}.uk-nav-parent-icon>.uk-parent>a:after{content:\"\";width:1.5em;height:1.5em;float:right;background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2214%22%20viewBox%3D%220%200%2014%2014%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolyline%20fill%3D%22none%22%20stroke%3D%22%23666%22%20stroke-width%3D%221.1%22%20points%3D%2210%201%204%207%2010%2013%22%20%2F%3E%0A%3C%2Fsvg%3E\");background-repeat:no-repeat;background-position:50% 50%}.uk-nav-parent-icon>.uk-parent.uk-open>a:after{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2214%22%20viewBox%3D%220%200%2014%2014%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolyline%20fill%3D%22none%22%20stroke%3D%22%23666%22%20stroke-width%3D%221.1%22%20points%3D%221%204%207%2010%2013%204%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-nav-header{padding:5px 0;text-transform:uppercase;font-size:.875rem}.uk-nav-header:not(:first-child){margin-top:20px}.uk-nav-divider{margin:5px 0}.uk-nav-default{font-size:.875rem}.uk-nav-default>li>a{color:#999}.uk-nav-default>li>a:focus,.uk-nav-default>li>a:hover{color:#666}.uk-nav-default .uk-nav-header,.uk-nav-default>li.uk-active>a{color:#333}.uk-nav-default .uk-nav-divider{border-top:1px solid #e5e5e5}.uk-nav-default .uk-nav-sub a{color:#999}.uk-nav-default .uk-nav-sub a:focus,.uk-nav-default .uk-nav-sub a:hover{color:#666}.uk-nav-default .uk-nav-sub li.uk-active>a{color:#333}.uk-nav-primary>li>a{font-size:1.5rem;line-height:1.5;color:#999}.uk-nav-primary>li>a:focus,.uk-nav-primary>li>a:hover{color:#666}.uk-nav-primary .uk-nav-header,.uk-nav-primary>li.uk-active>a{color:#333}.uk-nav-primary .uk-nav-divider{border-top:1px solid #e5e5e5}.uk-nav-primary .uk-nav-sub a{color:#999}.uk-nav-primary .uk-nav-sub a:focus,.uk-nav-primary .uk-nav-sub a:hover{color:#666}.uk-nav-primary .uk-nav-sub li.uk-active>a{color:#333}.uk-nav-center{text-align:center}.uk-nav-center .uk-nav-sub,.uk-nav-center .uk-nav-sub ul{padding-left:0}.uk-nav-center.uk-nav-parent-icon>.uk-parent>a:after{position:absolute}.uk-navbar{display:flex;position:relative}.uk-navbar-container:not(.uk-navbar-transparent){background:#f8f8f8}.uk-navbar-container>:after,.uk-navbar-container>:before{display:none!important}.uk-navbar-center,.uk-navbar-center-left>*,.uk-navbar-center-right>*,.uk-navbar-left,.uk-navbar-right{display:flex;align-items:center}.uk-navbar-right{margin-left:auto}.uk-navbar-center:only-child{margin-left:auto;margin-right:auto;position:relative}.uk-navbar-center:not(:only-child){position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:max-content;box-sizing:border-box;z-index:990}.uk-navbar-center-left,.uk-navbar-center-right{position:absolute;top:0}.uk-navbar-center-left{right:100%}.uk-navbar-center-right{left:100%}[class*=uk-navbar-center-]{width:max-content;box-sizing:border-box}.uk-navbar-nav{display:flex;margin:0;padding:0;list-style:none}.uk-navbar-center:only-child,.uk-navbar-left,.uk-navbar-right{flex-wrap:wrap}.uk-navbar-item,.uk-navbar-nav>li>a,.uk-navbar-toggle{display:flex;justify-content:center;align-items:center;box-sizing:border-box;min-height:80px;padding:0 15px;font-size:.875rem;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif;text-decoration:none}.uk-navbar-nav>li>a{color:#999;text-transform:uppercase;transition:.1s ease-in-out;transition-property:color,background-color}.uk-navbar-nav>li:hover>a,.uk-navbar-nav>li>a.uk-open,.uk-navbar-nav>li>a:focus{color:#666;outline:none}.uk-navbar-nav>li.uk-active>a,.uk-navbar-nav>li>a:active{color:#333}.uk-navbar-item{color:#666}.uk-navbar-toggle{color:#999}.uk-navbar-toggle.uk-open,.uk-navbar-toggle:focus,.uk-navbar-toggle:hover{color:#666;outline:none;text-decoration:none}.uk-navbar-subtitle{font-size:.875rem}.uk-navbar-dropdown{display:none;position:absolute;z-index:1020;box-sizing:border-box;width:200px;padding:25px;background:#fff;color:#666;box-shadow:0 5px 12px rgba(0,0,0,.15)}.uk-navbar-dropdown.uk-open{display:block}[class*=uk-navbar-dropdown-top]{margin-top:-15px}[class*=uk-navbar-dropdown-bottom]{margin-top:15px}[class*=uk-navbar-dropdown-left]{margin-left:-15px}[class*=uk-navbar-dropdown-right]{margin-left:15px}.uk-navbar-dropdown-grid{margin-left:-50px}.uk-navbar-dropdown-grid>*{padding-left:50px}.uk-navbar-dropdown-grid>.uk-grid-margin{margin-top:50px}.uk-navbar-dropdown-stack .uk-navbar-dropdown-grid>*{width:100%!important}.uk-navbar-dropdown-width-2:not(.uk-navbar-dropdown-stack){width:400px}.uk-navbar-dropdown-width-3:not(.uk-navbar-dropdown-stack){width:600px}.uk-navbar-dropdown-width-4:not(.uk-navbar-dropdown-stack){width:800px}.uk-navbar-dropdown-width-5:not(.uk-navbar-dropdown-stack){width:1000px}.uk-navbar-dropdown-dropbar{margin-top:0;margin-bottom:0;box-shadow:none}.uk-navbar-dropdown-nav{font-size:.875rem}.uk-navbar-dropdown-nav>li>a{color:#999}.uk-navbar-dropdown-nav>li>a:focus,.uk-navbar-dropdown-nav>li>a:hover{color:#666}.uk-navbar-dropdown-nav .uk-nav-header,.uk-navbar-dropdown-nav>li.uk-active>a{color:#333}.uk-navbar-dropdown-nav .uk-nav-divider{border-top:1px solid #e5e5e5}.uk-navbar-dropdown-nav .uk-nav-sub a{color:#999}.uk-navbar-dropdown-nav .uk-nav-sub a:focus,.uk-navbar-dropdown-nav .uk-nav-sub a:hover{color:#666}.uk-navbar-dropdown-nav .uk-nav-sub li.uk-active>a{color:#333}.uk-navbar-dropbar{background:#fff}.uk-navbar-dropbar-slide{position:absolute;z-index:980;left:0;right:0;box-shadow:0 5px 7px rgba(0,0,0,.05)}.uk-navbar-container>.uk-container .uk-navbar-left{margin-left:-15px;margin-right:-15px}.uk-navbar-container>.uk-container .uk-navbar-right{margin-right:-15px}.uk-navbar-dropdown-grid>*{position:relative}.uk-navbar-dropdown-grid>:not(.uk-first-column):before{content:\"\";position:absolute;top:0;bottom:0;left:25px;border-left:1px solid #e5e5e5}.uk-navbar-dropdown-grid.uk-grid-stack>.uk-grid-margin:before{content:\"\";position:absolute;top:-25px;left:50px;right:0;border-top:1px solid #e5e5e5}.uk-subnav{display:flex;flex-wrap:wrap;margin-left:-20px;padding:0;list-style:none}.uk-subnav>*{flex:none;padding-left:20px;position:relative}.uk-subnav>*>:first-child{display:block;color:#999;font-size:.875rem;text-transform:uppercase;transition:.1s ease-in-out;transition-property:color,background-color}.uk-subnav>*>a:focus,.uk-subnav>*>a:hover{color:#666;text-decoration:none;outline:none}.uk-subnav>.uk-active>a{color:#333}.uk-subnav-divider{margin-left:-41px}.uk-subnav-divider>*{display:flex;align-items:center}.uk-subnav-divider>:before{content:\"\";height:1.5em;margin-left:0;margin-right:20px;border-left:1px solid transparent}.uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before{border-left-color:#e5e5e5}.uk-subnav-pill>*>:first-child{padding:5px 10px;background:transparent;color:#999}.uk-subnav-pill>*>a:active,.uk-subnav-pill>*>a:focus,.uk-subnav-pill>*>a:hover{background-color:#f8f8f8;color:#666}.uk-subnav-pill>.uk-active>a{background-color:#1e87f0;color:#fff}.uk-subnav>.uk-disabled>a{color:#999}.uk-breadcrumb{padding:0;list-style:none}.uk-breadcrumb>*{display:contents}.uk-breadcrumb>*>*{font-size:.875rem;color:#999}.uk-breadcrumb>*>:focus,.uk-breadcrumb>*>:hover{color:#666;text-decoration:none}.uk-breadcrumb>:last-child>a:not([href]),.uk-breadcrumb>:last-child>span{color:#666}.uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before{content:\"/\";display:inline-block;margin:0 20px 0 16px;font-size:.875rem;color:#999}.uk-pagination{display:flex;flex-wrap:wrap;margin-left:0;padding:0;list-style:none}.uk-pagination>*{flex:none;padding-left:0;position:relative}.uk-pagination>*>*{display:block;padding:5px 10px;color:#999;transition:color .1s ease-in-out}.uk-pagination>*>:focus,.uk-pagination>*>:hover{color:#666;text-decoration:none}.uk-pagination>.uk-active>*{color:#666}.uk-pagination>.uk-disabled>*{color:#999}.uk-tab{display:flex;flex-wrap:wrap;margin-left:-20px;padding:0;list-style:none;position:relative}.uk-tab:before{content:\"\";position:absolute;bottom:0;left:20px;right:0;border-bottom:1px solid #e5e5e5}.uk-tab>*{flex:none;padding-left:20px;position:relative}.uk-tab>*>a{display:block;text-align:center;padding:5px 10px;color:#999;border-bottom:1px solid transparent;font-size:.875rem;text-transform:uppercase;transition:color .1s ease-in-out}.uk-tab>*>a:focus,.uk-tab>*>a:hover{color:#666;text-decoration:none}.uk-tab>.uk-active>a{color:#333;border-color:#1e87f0}.uk-tab>.uk-disabled>a{color:#999}.uk-tab-bottom:before{top:0;bottom:auto}.uk-tab-bottom>*>a{border-top:1px solid transparent;border-bottom:none}.uk-tab-left,.uk-tab-right{flex-direction:column;margin-left:0}.uk-tab-left>*,.uk-tab-right>*{padding-left:0}.uk-tab-left:before{left:auto;right:0}.uk-tab-left:before,.uk-tab-right:before{top:0;bottom:0;border-left:1px solid #e5e5e5;border-bottom:none}.uk-tab-right:before{left:0;right:auto}.uk-tab-left>*>a{text-align:left;border-right:1px solid transparent;border-bottom:none}.uk-tab-right>*>a{text-align:left;border-left:1px solid transparent;border-bottom:none}.uk-tab .uk-dropdown{margin-left:30px}.uk-slidenav{padding:5px 10px;color:hsla(0,0%,40%,.5);transition:color .1s ease-in-out}.uk-slidenav:focus,.uk-slidenav:hover{color:hsla(0,0%,40%,.9);outline:none}.uk-slidenav:active{color:hsla(0,0%,40%,.5)}.uk-slidenav-large{padding:10px}.uk-dotnav,.uk-slidenav-container{display:flex}.uk-dotnav{flex-wrap:wrap;margin:0;padding:0;list-style:none;margin-left:-12px}.uk-dotnav>*{flex:none;padding-left:12px}.uk-dotnav>*>*{display:block;box-sizing:border-box;width:10px;height:10px;border-radius:50%;background:transparent;text-indent:100%;overflow:hidden;white-space:nowrap;border:1px solid hsla(0,0%,40%,.4);transition:.2s ease-in-out;transition-property:background-color,border-color}.uk-dotnav>*>:focus,.uk-dotnav>*>:hover{background-color:hsla(0,0%,40%,.6);outline:none;border-color:transparent}.uk-dotnav>*>:active{background-color:hsla(0,0%,40%,.2);border-color:transparent}.uk-dotnav>.uk-active>*{background-color:hsla(0,0%,40%,.6);border-color:transparent}.uk-dotnav-vertical{flex-direction:column;margin-left:0;margin-top:-12px}.uk-dotnav-vertical>*{padding-left:0;padding-top:12px}.uk-thumbnav{display:flex;flex-wrap:wrap;margin:0;padding:0;list-style:none;margin-left:-15px}.uk-thumbnav>*{padding-left:15px}.uk-thumbnav>*>*{display:inline-block;position:relative}.uk-thumbnav>*>:after{content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;background:hsla(0,0%,100%,.4);transition:background-color .1s ease-in-out}.uk-thumbnav>*>:focus,.uk-thumbnav>*>:hover{outline:none}.uk-thumbnav>*>:focus:after,.uk-thumbnav>*>:hover:after,.uk-thumbnav>.uk-active>:after{background-color:transparent}.uk-thumbnav-vertical{flex-direction:column;margin-left:0;margin-top:-15px}.uk-thumbnav-vertical>*{padding-left:0;padding-top:15px}.uk-iconnav{display:flex;flex-wrap:wrap;margin:0;padding:0;list-style:none;margin-left:-10px}.uk-iconnav>*{padding-left:10px}.uk-iconnav>*>a{display:block;color:#999}.uk-iconnav>*>a:focus,.uk-iconnav>*>a:hover{color:#666;outline:none}.uk-iconnav>.uk-active>a{color:#666}.uk-iconnav-vertical{flex-direction:column;margin-left:0;margin-top:-10px}.uk-iconnav-vertical>*{padding-left:0;padding-top:10px}.uk-lightbox{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1010;background:#000;opacity:0;transition:opacity .15s linear;touch-action:pinch-zoom}.uk-lightbox.uk-open{display:block;opacity:1}.uk-lightbox-page{overflow:hidden}.uk-lightbox-items>*{position:absolute;top:0;right:0;bottom:0;left:0;display:none;justify-content:center;align-items:center;color:hsla(0,0%,100%,.7);will-change:transform,opacity}.uk-lightbox-items>*>*{max-width:100vw;max-height:100vh}.uk-lightbox-items>:focus{outline:none}.uk-lightbox-items>*>:not(iframe){width:auto;height:auto}.uk-lightbox-items>.uk-active{display:flex}.uk-lightbox-toolbar{padding:10px;background:rgba(0,0,0,.3)}.uk-lightbox-toolbar,.uk-lightbox-toolbar>*{color:hsla(0,0%,100%,.7)}.uk-lightbox-toolbar-icon{padding:5px;color:hsla(0,0%,100%,.7)}.uk-lightbox-toolbar-icon:hover{color:#fff}.uk-lightbox-button{box-sizing:border-box;width:50px;height:50px;background:rgba(0,0,0,.3);color:hsla(0,0%,100%,.7);display:inline-flex;justify-content:center;align-items:center}.uk-lightbox-button:focus,.uk-lightbox-button:hover{color:#fff}.uk-lightbox-caption:empty{display:none}.uk-lightbox-iframe{width:80%;height:80%}[class*=uk-animation-]{animation-duration:.5s;animation-timing-function:ease-out;animation-fill-mode:both}.uk-animation-fade{animation-name:uk-fade;animation-duration:.8s;animation-timing-function:linear}.uk-animation-scale-up{animation-name:uk-fade-scale-02}.uk-animation-scale-down{animation-name:uk-fade-scale-18}.uk-animation-slide-top{animation-name:uk-fade-top}.uk-animation-slide-bottom{animation-name:uk-fade-bottom}.uk-animation-slide-left{animation-name:uk-fade-left}.uk-animation-slide-right{animation-name:uk-fade-right}.uk-animation-slide-top-small{animation-name:uk-fade-top-small}.uk-animation-slide-bottom-small{animation-name:uk-fade-bottom-small}.uk-animation-slide-left-small{animation-name:uk-fade-left-small}.uk-animation-slide-right-small{animation-name:uk-fade-right-small}.uk-animation-slide-top-medium{animation-name:uk-fade-top-medium}.uk-animation-slide-bottom-medium{animation-name:uk-fade-bottom-medium}.uk-animation-slide-left-medium{animation-name:uk-fade-left-medium}.uk-animation-slide-right-medium{animation-name:uk-fade-right-medium}.uk-animation-kenburns{animation-name:uk-scale-kenburns;animation-duration:15s}.uk-animation-shake{animation-name:uk-shake}.uk-animation-stroke{animation-name:uk-stroke;stroke-dasharray:var(--uk-animation-stroke);animation-duration:2s}.uk-animation-reverse{animation-direction:reverse;animation-timing-function:ease-in}.uk-animation-fast{animation-duration:.1s}.uk-animation-toggle:not(:hover):not(:focus) [class*=uk-animation-]{animation-name:none}.uk-animation-toggle{-webkit-tap-highlight-color:transparent}.uk-animation-toggle:focus{outline:none}@keyframes uk-fade{0%{opacity:0}to{opacity:1}}@keyframes uk-fade-top{0%{opacity:0;transform:translateY(-100%)}to{opacity:1;transform:translateY(0)}}@keyframes uk-fade-bottom{0%{opacity:0;transform:translateY(100%)}to{opacity:1;transform:translateY(0)}}@keyframes uk-fade-left{0%{opacity:0;transform:translateX(-100%)}to{opacity:1;transform:translateX(0)}}@keyframes uk-fade-right{0%{opacity:0;transform:translateX(100%)}to{opacity:1;transform:translateX(0)}}@keyframes uk-fade-top-small{0%{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}@keyframes uk-fade-bottom-small{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@keyframes uk-fade-left-small{0%{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:translateX(0)}}@keyframes uk-fade-right-small{0%{opacity:0;transform:translateX(10px)}to{opacity:1;transform:translateX(0)}}@keyframes uk-fade-top-medium{0%{opacity:0;transform:translateY(-50px)}to{opacity:1;transform:translateY(0)}}@keyframes uk-fade-bottom-medium{0%{opacity:0;transform:translateY(50px)}to{opacity:1;transform:translateY(0)}}@keyframes uk-fade-left-medium{0%{opacity:0;transform:translateX(-50px)}to{opacity:1;transform:translateX(0)}}@keyframes uk-fade-right-medium{0%{opacity:0;transform:translateX(50px)}to{opacity:1;transform:translateX(0)}}@keyframes uk-fade-scale-02{0%{opacity:0;transform:scale(.2)}to{opacity:1;transform:scale(1)}}@keyframes uk-fade-scale-18{0%{opacity:0;transform:scale(1.8)}to{opacity:1;transform:scale(1)}}@keyframes uk-scale-kenburns{0%{transform:scale(1)}to{transform:scale(1.2)}}@keyframes uk-shake{0%,to{transform:translateX(0)}10%{transform:translateX(-9px)}20%{transform:translateX(8px)}30%{transform:translateX(-7px)}40%{transform:translateX(6px)}50%{transform:translateX(-5px)}60%{transform:translateX(4px)}70%{transform:translateX(-3px)}80%{transform:translateX(2px)}90%{transform:translateX(-1px)}}@keyframes uk-stroke{0%{stroke-dashoffset:var(--uk-animation-stroke)}to{stroke-dashoffset:0}}[class*=uk-child-width]>*{box-sizing:border-box;width:100%}.uk-child-width-1-2>*{width:50%}.uk-child-width-1-3>*{width:33.32223%}.uk-child-width-1-4>*{width:25%}.uk-child-width-1-5>*{width:20%}.uk-child-width-1-6>*{width:16.66389%}.uk-child-width-auto>*{width:auto}.uk-child-width-expand>:not([class*=uk-width]){flex:1;min-width:1px}@media (min-width:640px){.uk-child-width-1-1\\@s>*{width:100%}.uk-child-width-1-2\\@s>*{width:50%}.uk-child-width-1-3\\@s>*{width:33.32223%}.uk-child-width-1-4\\@s>*{width:25%}.uk-child-width-1-5\\@s>*{width:20%}.uk-child-width-1-6\\@s>*{width:16.66389%}.uk-child-width-auto\\@s>*{width:auto}.uk-child-width-expand\\@s>:not([class*=uk-width]){flex:1;min-width:1px}}@media (min-width:960px){.uk-child-width-1-1\\@m>*{width:100%}.uk-child-width-1-2\\@m>*{width:50%}.uk-child-width-1-3\\@m>*{width:33.32223%}.uk-child-width-1-4\\@m>*{width:25%}.uk-child-width-1-5\\@m>*{width:20%}.uk-child-width-1-6\\@m>*{width:16.66389%}.uk-child-width-auto\\@m>*{width:auto}.uk-child-width-expand\\@m>:not([class*=uk-width]){flex:1;min-width:1px}}@media (min-width:1200px){.uk-child-width-1-1\\@l>*{width:100%}.uk-child-width-1-2\\@l>*{width:50%}.uk-child-width-1-3\\@l>*{width:33.32223%}.uk-child-width-1-4\\@l>*{width:25%}.uk-child-width-1-5\\@l>*{width:20%}.uk-child-width-1-6\\@l>*{width:16.66389%}.uk-child-width-auto\\@l>*{width:auto}.uk-child-width-expand\\@l>:not([class*=uk-width]){flex:1;min-width:1px}}@media (min-width:1600px){.uk-child-width-1-1\\@xl>*{width:100%}.uk-child-width-1-2\\@xl>*{width:50%}.uk-child-width-1-3\\@xl>*{width:33.32223%}.uk-child-width-1-4\\@xl>*{width:25%}.uk-child-width-1-5\\@xl>*{width:20%}.uk-child-width-1-6\\@xl>*{width:16.66389%}.uk-child-width-auto\\@xl>*{width:auto}.uk-child-width-expand\\@xl>:not([class*=uk-width]){flex:1;min-width:1px}}[class*=uk-width]{box-sizing:border-box;width:100%;max-width:100%}.uk-width-1-2{width:50%}.uk-width-1-3{width:33.32223%}.uk-width-2-3{width:66.64445%}.uk-width-1-4{width:25%}.uk-width-3-4{width:75%}.uk-width-1-5{width:20%}.uk-width-2-5{width:40%}.uk-width-3-5{width:60%}.uk-width-4-5{width:80%}.uk-width-1-6{width:16.66389%}.uk-width-5-6{width:83.31945%}.uk-width-small{width:150px}.uk-width-medium{width:300px}.uk-width-large{width:450px}.uk-width-xlarge{width:600px}.uk-width-2xlarge{width:750px}.uk-width-auto{width:auto}.uk-width-expand{flex:1;min-width:1px}@media (min-width:640px){.uk-width-1-1\\@s{width:100%}.uk-width-1-2\\@s{width:50%}.uk-width-1-3\\@s{width:33.32223%}.uk-width-2-3\\@s{width:66.64445%}.uk-width-1-4\\@s{width:25%}.uk-width-3-4\\@s{width:75%}.uk-width-1-5\\@s{width:20%}.uk-width-2-5\\@s{width:40%}.uk-width-3-5\\@s{width:60%}.uk-width-4-5\\@s{width:80%}.uk-width-1-6\\@s{width:16.66389%}.uk-width-5-6\\@s{width:83.31945%}.uk-width-small\\@s{width:150px}.uk-width-medium\\@s{width:300px}.uk-width-large\\@s{width:450px}.uk-width-xlarge\\@s{width:600px}.uk-width-2xlarge\\@s{width:750px}.uk-width-auto\\@s{width:auto}.uk-width-expand\\@s{flex:1;min-width:1px}}@media (min-width:960px){.uk-width-1-1\\@m{width:100%}.uk-width-1-2\\@m{width:50%}.uk-width-1-3\\@m{width:33.32223%}.uk-width-2-3\\@m{width:66.64445%}.uk-width-1-4\\@m{width:25%}.uk-width-3-4\\@m{width:75%}.uk-width-1-5\\@m{width:20%}.uk-width-2-5\\@m{width:40%}.uk-width-3-5\\@m{width:60%}.uk-width-4-5\\@m{width:80%}.uk-width-1-6\\@m{width:16.66389%}.uk-width-5-6\\@m{width:83.31945%}.uk-width-small\\@m{width:150px}.uk-width-medium\\@m{width:300px}.uk-width-large\\@m{width:450px}.uk-width-xlarge\\@m{width:600px}.uk-width-2xlarge\\@m{width:750px}.uk-width-auto\\@m{width:auto}.uk-width-expand\\@m{flex:1;min-width:1px}}@media (min-width:1200px){.uk-width-1-1\\@l{width:100%}.uk-width-1-2\\@l{width:50%}.uk-width-1-3\\@l{width:33.32223%}.uk-width-2-3\\@l{width:66.64445%}.uk-width-1-4\\@l{width:25%}.uk-width-3-4\\@l{width:75%}.uk-width-1-5\\@l{width:20%}.uk-width-2-5\\@l{width:40%}.uk-width-3-5\\@l{width:60%}.uk-width-4-5\\@l{width:80%}.uk-width-1-6\\@l{width:16.66389%}.uk-width-5-6\\@l{width:83.31945%}.uk-width-small\\@l{width:150px}.uk-width-medium\\@l{width:300px}.uk-width-large\\@l{width:450px}.uk-width-xlarge\\@l{width:600px}.uk-width-2xlarge\\@l{width:750px}.uk-width-auto\\@l{width:auto}.uk-width-expand\\@l{flex:1;min-width:1px}}@media (min-width:1600px){.uk-width-1-1\\@xl{width:100%}.uk-width-1-2\\@xl{width:50%}.uk-width-1-3\\@xl{width:33.32223%}.uk-width-2-3\\@xl{width:66.64445%}.uk-width-1-4\\@xl{width:25%}.uk-width-3-4\\@xl{width:75%}.uk-width-1-5\\@xl{width:20%}.uk-width-2-5\\@xl{width:40%}.uk-width-3-5\\@xl{width:60%}.uk-width-4-5\\@xl{width:80%}.uk-width-1-6\\@xl{width:16.66389%}.uk-width-5-6\\@xl{width:83.31945%}.uk-width-small\\@xl{width:150px}.uk-width-medium\\@xl{width:300px}.uk-width-large\\@xl{width:450px}.uk-width-xlarge\\@xl{width:600px}.uk-width-2xlarge\\@xl{width:750px}.uk-width-auto\\@xl{width:auto}.uk-width-expand\\@xl{flex:1;min-width:1px}}[class*=uk-height]{box-sizing:border-box}.uk-height-1-1{height:100%}.uk-height-viewport{min-height:100vh}.uk-height-small{height:150px}.uk-height-medium{height:300px}.uk-height-large{height:450px}.uk-height-max-small{max-height:150px}.uk-height-max-medium{max-height:300px}.uk-height-max-large{max-height:450px}.uk-text-lead{font-size:1.5rem;line-height:1.5;color:#333}.uk-text-meta{font-size:.875rem;line-height:1.4;color:#999}.uk-text-meta a{color:#999}.uk-text-meta a:hover{color:#666;text-decoration:none}.uk-text-small{font-size:.875rem;line-height:1.5}.uk-text-large{font-size:1.5rem;line-height:1.5}.uk-text-default{font-size:16px;line-height:1.5}.uk-text-light{font-weight:300}.uk-text-normal{font-weight:400}.uk-text-bold{font-weight:700}.uk-text-lighter{font-weight:lighter}.uk-text-bolder{font-weight:bolder}.uk-text-italic{font-style:italic}.uk-text-capitalize{text-transform:capitalize!important}.uk-text-uppercase{text-transform:uppercase!important}.uk-text-lowercase{text-transform:lowercase!important}.uk-text-muted{color:#999!important}.uk-text-emphasis{color:#333!important}.uk-text-primary{color:#1e87f0!important}.uk-text-secondary{color:#222!important}.uk-text-success{color:#32d296!important}.uk-text-warning{color:#faa05a!important}.uk-text-danger{color:#f0506e!important}.uk-text-background{-webkit-background-clip:text;display:inline-block;color:#1e87f0!important}@supports (-webkit-background-clip:text){.uk-text-background{background-color:#1e87f0;color:transparent!important}}.uk-text-left{text-align:left!important}.uk-text-right{text-align:right!important}.uk-text-center{text-align:center!important}.uk-text-justify{text-align:justify!important}@media (min-width:640px){.uk-text-left\\@s{text-align:left!important}.uk-text-right\\@s{text-align:right!important}.uk-text-center\\@s{text-align:center!important}}@media (min-width:960px){.uk-text-left\\@m{text-align:left!important}.uk-text-right\\@m{text-align:right!important}.uk-text-center\\@m{text-align:center!important}}@media (min-width:1200px){.uk-text-left\\@l{text-align:left!important}.uk-text-right\\@l{text-align:right!important}.uk-text-center\\@l{text-align:center!important}}@media (min-width:1600px){.uk-text-left\\@xl{text-align:left!important}.uk-text-right\\@xl{text-align:right!important}.uk-text-center\\@xl{text-align:center!important}}.uk-text-top{vertical-align:top!important}.uk-text-middle{vertical-align:middle!important}.uk-text-bottom{vertical-align:bottom!important}.uk-text-baseline{vertical-align:baseline!important}.uk-text-nowrap,.uk-text-truncate{white-space:nowrap}.uk-text-truncate{max-width:100%;overflow:hidden;text-overflow:ellipsis}td.uk-text-truncate,th.uk-text-truncate{max-width:0}.uk-text-break{overflow-wrap:break-word;word-wrap:break-word}td.uk-text-break,th.uk-text-break{word-break:break-all}[class*=uk-column-]{column-gap:30px}@media (min-width:1200px){[class*=uk-column-]{column-gap:40px}}[class*=uk-column-] img{transform:translateZ(0)}.uk-column-divider{column-rule:1px solid #e5e5e5;column-gap:60px}@media (min-width:1200px){.uk-column-divider{column-gap:80px}}.uk-column-1-2{column-count:2}.uk-column-1-3{column-count:3}.uk-column-1-4{column-count:4}.uk-column-1-5{column-count:5}.uk-column-1-6{column-count:6}@media (min-width:640px){.uk-column-1-2\\@s{column-count:2}.uk-column-1-3\\@s{column-count:3}.uk-column-1-4\\@s{column-count:4}.uk-column-1-5\\@s{column-count:5}.uk-column-1-6\\@s{column-count:6}}@media (min-width:960px){.uk-column-1-2\\@m{column-count:2}.uk-column-1-3\\@m{column-count:3}.uk-column-1-4\\@m{column-count:4}.uk-column-1-5\\@m{column-count:5}.uk-column-1-6\\@m{column-count:6}}@media (min-width:1200px){.uk-column-1-2\\@l{column-count:2}.uk-column-1-3\\@l{column-count:3}.uk-column-1-4\\@l{column-count:4}.uk-column-1-5\\@l{column-count:5}.uk-column-1-6\\@l{column-count:6}}@media (min-width:1600px){.uk-column-1-2\\@xl{column-count:2}.uk-column-1-3\\@xl{column-count:3}.uk-column-1-4\\@xl{column-count:4}.uk-column-1-5\\@xl{column-count:5}.uk-column-1-6\\@xl{column-count:6}}.uk-column-span{column-span:all}.uk-cover{max-width:none;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}iframe.uk-cover{pointer-events:none}.uk-cover-container{overflow:hidden;position:relative}.uk-background-default{background-color:#fff}.uk-background-muted{background-color:#f8f8f8}.uk-background-primary{background-color:#1e87f0}.uk-background-secondary{background-color:#222}.uk-background-contain,.uk-background-cover,.uk-background-height-1-1,.uk-background-width-1-1{background-position:50% 50%;background-repeat:no-repeat}.uk-background-cover{background-size:cover}.uk-background-contain{background-size:contain}.uk-background-width-1-1{background-size:100%}.uk-background-height-1-1{background-size:auto 100%}.uk-background-top-left{background-position:0 0}.uk-background-top-center{background-position:50% 0}.uk-background-top-right{background-position:100% 0}.uk-background-center-left{background-position:0 50%}.uk-background-center-center{background-position:50% 50%}.uk-background-center-right{background-position:100% 50%}.uk-background-bottom-left{background-position:0 100%}.uk-background-bottom-center{background-position:50% 100%}.uk-background-bottom-right{background-position:100% 100%}.uk-background-norepeat{background-repeat:no-repeat}.uk-background-fixed{background-attachment:fixed;backface-visibility:hidden}@media (pointer:coarse){.uk-background-fixed{background-attachment:scroll}}@media (max-width:639px){.uk-background-image\\@s{background-image:none!important}}@media (max-width:959px){.uk-background-image\\@m{background-image:none!important}}@media (max-width:1199px){.uk-background-image\\@l{background-image:none!important}}@media (max-width:1599px){.uk-background-image\\@xl{background-image:none!important}}.uk-background-blend-multiply{background-blend-mode:multiply}.uk-background-blend-screen{background-blend-mode:screen}.uk-background-blend-overlay{background-blend-mode:overlay}.uk-background-blend-darken{background-blend-mode:darken}.uk-background-blend-lighten{background-blend-mode:lighten}.uk-background-blend-color-dodge{background-blend-mode:color-dodge}.uk-background-blend-color-burn{background-blend-mode:color-burn}.uk-background-blend-hard-light{background-blend-mode:hard-light}.uk-background-blend-soft-light{background-blend-mode:soft-light}.uk-background-blend-difference{background-blend-mode:difference}.uk-background-blend-exclusion{background-blend-mode:exclusion}.uk-background-blend-hue{background-blend-mode:hue}.uk-background-blend-saturation{background-blend-mode:saturation}.uk-background-blend-color{background-blend-mode:color}.uk-background-blend-luminosity{background-blend-mode:luminosity}[class*=uk-align]{display:block;margin-bottom:30px}*+[class*=uk-align]{margin-top:30px}.uk-align-center{margin-left:auto;margin-right:auto}.uk-align-left{margin-top:0;margin-right:30px;float:left}.uk-align-right{margin-top:0;margin-left:30px;float:right}@media (min-width:640px){.uk-align-left\\@s{margin-top:0;margin-right:30px;float:left}.uk-align-right\\@s{margin-top:0;margin-left:30px;float:right}}@media (min-width:960px){.uk-align-left\\@m{margin-top:0;margin-right:30px;float:left}.uk-align-right\\@m{margin-top:0;margin-left:30px;float:right}}@media (min-width:1200px){.uk-align-left\\@l{margin-top:0;float:left}.uk-align-right\\@l{margin-top:0;float:right}.uk-align-left,.uk-align-left\\@l,.uk-align-left\\@m,.uk-align-left\\@s{margin-right:40px}.uk-align-right,.uk-align-right\\@l,.uk-align-right\\@m,.uk-align-right\\@s{margin-left:40px}}@media (min-width:1600px){.uk-align-left\\@xl{margin-top:0;margin-right:40px;float:left}.uk-align-right\\@xl{margin-top:0;margin-left:40px;float:right}}.uk-svg,.uk-svg:not(.uk-preserve) [fill*=\"#\"]:not(.uk-preserve){fill:currentcolor}.uk-svg:not(.uk-preserve) [stroke*=\"#\"]:not(.uk-preserve){stroke:currentcolor}.uk-svg{transform:translate(0)}.uk-panel{display:flow-root;position:relative;box-sizing:border-box}.uk-panel>:last-child{margin-bottom:0}.uk-panel-scrollable{height:170px;padding:10px;border:1px solid #e5e5e5;overflow:auto;-webkit-overflow-scrolling:touch;resize:both}.uk-clearfix:before{content:\"\";display:table-cell}.uk-clearfix:after{content:\"\";display:table;clear:both}.uk-float-left{float:left}.uk-float-right{float:right}[class*=uk-float-]{max-width:100%}.uk-overflow-hidden{overflow:hidden}.uk-overflow-auto{overflow:auto;-webkit-overflow-scrolling:touch}.uk-overflow-auto>:last-child{margin-bottom:0}.uk-resize{resize:both}.uk-resize-vertical{resize:vertical}.uk-display-block{display:block!important}.uk-display-inline{display:inline!important}.uk-display-inline-block{display:inline-block!important}[class*=uk-inline]{display:inline-block;position:relative;max-width:100%;vertical-align:middle;-webkit-backface-visibility:hidden}.uk-inline-clip{overflow:hidden}.uk-preserve-width,.uk-preserve-width canvas,.uk-preserve-width img,.uk-preserve-width svg,.uk-preserve-width video{max-width:none}.uk-responsive-height,.uk-responsive-width{box-sizing:border-box}.uk-responsive-width{max-width:100%!important;height:auto}.uk-responsive-height{max-height:100%;width:auto;max-width:none}.uk-border-circle{border-radius:50%}.uk-border-pill{border-radius:500px}.uk-border-rounded{border-radius:5px}.uk-inline-clip[class*=uk-border-]{-webkit-transform:translateZ(0)}.uk-box-shadow-small{box-shadow:0 2px 8px rgba(0,0,0,.08)}.uk-box-shadow-medium{box-shadow:0 5px 15px rgba(0,0,0,.08)}.uk-box-shadow-large{box-shadow:0 14px 25px rgba(0,0,0,.16)}.uk-box-shadow-xlarge{box-shadow:0 28px 50px rgba(0,0,0,.16)}[class*=uk-box-shadow-hover]{transition:box-shadow .1s ease-in-out}.uk-box-shadow-hover-small:hover{box-shadow:0 2px 8px rgba(0,0,0,.08)}.uk-box-shadow-hover-medium:hover{box-shadow:0 5px 15px rgba(0,0,0,.08)}.uk-box-shadow-hover-large:hover{box-shadow:0 14px 25px rgba(0,0,0,.16)}.uk-box-shadow-hover-xlarge:hover{box-shadow:0 28px 50px rgba(0,0,0,.16)}@supports (filter:blur(0)){.uk-box-shadow-bottom{display:inline-block;position:relative;max-width:100%;vertical-align:middle}.uk-box-shadow-bottom:before{content:\"\";position:absolute;bottom:-30px;left:0;right:0;height:30px;border-radius:100%;background:#444;filter:blur(20px)}.uk-box-shadow-bottom>*{position:relative}}.uk-dropcap:first-letter,.uk-dropcap>p:first-of-type:first-letter{display:block;margin-right:10px;float:left;font-size:4.5em;line-height:1;margin-bottom:-2px}@-moz-document url-prefix(){.uk-dropcap:first-letter,.uk-dropcap>p:first-of-type:first-letter{margin-top:1.1%}}@supports (-ms-ime-align:auto){.uk-dropcap>p:first-of-type:first-letter{font-size:1em}}.uk-logo{font-size:1.5rem;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif;color:#666;text-decoration:none}.uk-logo:focus,.uk-logo:hover{color:#666;outline:none;text-decoration:none}.uk-logo-inverse{display:none}.uk-disabled{pointer-events:none}.uk-drag,.uk-drag *{cursor:move}.uk-drag iframe{pointer-events:none}.uk-dragover{box-shadow:0 0 20px hsla(0,0%,39%,.3)}.uk-blend-multiply{mix-blend-mode:multiply}.uk-blend-screen{mix-blend-mode:screen}.uk-blend-overlay{mix-blend-mode:overlay}.uk-blend-darken{mix-blend-mode:darken}.uk-blend-lighten{mix-blend-mode:lighten}.uk-blend-color-dodge{mix-blend-mode:color-dodge}.uk-blend-color-burn{mix-blend-mode:color-burn}.uk-blend-hard-light{mix-blend-mode:hard-light}.uk-blend-soft-light{mix-blend-mode:soft-light}.uk-blend-difference{mix-blend-mode:difference}.uk-blend-exclusion{mix-blend-mode:exclusion}.uk-blend-hue{mix-blend-mode:hue}.uk-blend-saturation{mix-blend-mode:saturation}.uk-blend-color{mix-blend-mode:color}.uk-blend-luminosity{mix-blend-mode:luminosity}.uk-transform-center{transform:translate(-50%,-50%)}.uk-transform-origin-top-left{transform-origin:0 0}.uk-transform-origin-top-center{transform-origin:50% 0}.uk-transform-origin-top-right{transform-origin:100% 0}.uk-transform-origin-center-left{transform-origin:0 50%}.uk-transform-origin-center-right{transform-origin:100% 50%}.uk-transform-origin-bottom-left{transform-origin:0 100%}.uk-transform-origin-bottom-center{transform-origin:50% 100%}.uk-transform-origin-bottom-right{transform-origin:100% 100%}.uk-flex{display:flex}.uk-flex-inline{display:inline-flex}.uk-flex-inline:after,.uk-flex-inline:before,.uk-flex:after,.uk-flex:before{display:none}.uk-flex-left{justify-content:flex-start}.uk-flex-center{justify-content:center}.uk-flex-right{justify-content:flex-end}.uk-flex-between{justify-content:space-between}.uk-flex-around{justify-content:space-around}@media (min-width:640px){.uk-flex-left\\@s{justify-content:flex-start}.uk-flex-center\\@s{justify-content:center}.uk-flex-right\\@s{justify-content:flex-end}.uk-flex-between\\@s{justify-content:space-between}.uk-flex-around\\@s{justify-content:space-around}}@media (min-width:960px){.uk-flex-left\\@m{justify-content:flex-start}.uk-flex-center\\@m{justify-content:center}.uk-flex-right\\@m{justify-content:flex-end}.uk-flex-between\\@m{justify-content:space-between}.uk-flex-around\\@m{justify-content:space-around}}@media (min-width:1200px){.uk-flex-left\\@l{justify-content:flex-start}.uk-flex-center\\@l{justify-content:center}.uk-flex-right\\@l{justify-content:flex-end}.uk-flex-between\\@l{justify-content:space-between}.uk-flex-around\\@l{justify-content:space-around}}@media (min-width:1600px){.uk-flex-left\\@xl{justify-content:flex-start}.uk-flex-center\\@xl{justify-content:center}.uk-flex-right\\@xl{justify-content:flex-end}.uk-flex-between\\@xl{justify-content:space-between}.uk-flex-around\\@xl{justify-content:space-around}}.uk-flex-stretch{align-items:stretch}.uk-flex-top{align-items:flex-start}.uk-flex-middle{align-items:center}.uk-flex-bottom{align-items:flex-end}.uk-flex-row{flex-direction:row}.uk-flex-row-reverse{flex-direction:row-reverse}.uk-flex-column{flex-direction:column}.uk-flex-column-reverse{flex-direction:column-reverse}.uk-flex-nowrap{flex-wrap:nowrap}.uk-flex-wrap{flex-wrap:wrap}.uk-flex-wrap-reverse{flex-wrap:wrap-reverse}.uk-flex-wrap-stretch{align-content:stretch}.uk-flex-wrap-top{align-content:flex-start}.uk-flex-wrap-middle{align-content:center}.uk-flex-wrap-bottom{align-content:flex-end}.uk-flex-wrap-between{align-content:space-between}.uk-flex-wrap-around{align-content:space-around}.uk-flex-first{order:-1}.uk-flex-last{order:99}@media (min-width:640px){.uk-flex-first\\@s{order:-1}.uk-flex-last\\@s{order:99}}@media (min-width:960px){.uk-flex-first\\@m{order:-1}.uk-flex-last\\@m{order:99}}@media (min-width:1200px){.uk-flex-first\\@l{order:-1}.uk-flex-last\\@l{order:99}}@media (min-width:1600px){.uk-flex-first\\@xl{order:-1}.uk-flex-last\\@xl{order:99}}.uk-flex-none{flex:none}.uk-flex-auto{flex:auto}.uk-flex-1{flex:1}.uk-margin{margin-bottom:20px}*+.uk-margin,.uk-margin-top{margin-top:20px!important}.uk-margin-bottom{margin-bottom:20px!important}.uk-margin-left{margin-left:20px!important}.uk-margin-right{margin-right:20px!important}.uk-margin-small{margin-bottom:10px}*+.uk-margin-small,.uk-margin-small-top{margin-top:10px!important}.uk-margin-small-bottom{margin-bottom:10px!important}.uk-margin-small-left{margin-left:10px!important}.uk-margin-small-right{margin-right:10px!important}.uk-margin-medium{margin-bottom:40px}*+.uk-margin-medium,.uk-margin-medium-top{margin-top:40px!important}.uk-margin-medium-bottom{margin-bottom:40px!important}.uk-margin-medium-left{margin-left:40px!important}.uk-margin-medium-right{margin-right:40px!important}.uk-margin-large{margin-bottom:40px}*+.uk-margin-large,.uk-margin-large-top{margin-top:40px!important}.uk-margin-large-bottom{margin-bottom:40px!important}.uk-margin-large-left{margin-left:40px!important}.uk-margin-large-right{margin-right:40px!important}@media (min-width:1200px){.uk-margin-large{margin-bottom:70px}*+.uk-margin-large,.uk-margin-large-top{margin-top:70px!important}.uk-margin-large-bottom{margin-bottom:70px!important}.uk-margin-large-left{margin-left:70px!important}.uk-margin-large-right{margin-right:70px!important}}.uk-margin-xlarge{margin-bottom:70px}*+.uk-margin-xlarge,.uk-margin-xlarge-top{margin-top:70px!important}.uk-margin-xlarge-bottom{margin-bottom:70px!important}.uk-margin-xlarge-left{margin-left:70px!important}.uk-margin-xlarge-right{margin-right:70px!important}@media (min-width:1200px){.uk-margin-xlarge{margin-bottom:140px}*+.uk-margin-xlarge,.uk-margin-xlarge-top{margin-top:140px!important}.uk-margin-xlarge-bottom{margin-bottom:140px!important}.uk-margin-xlarge-left{margin-left:140px!important}.uk-margin-xlarge-right{margin-right:140px!important}}.uk-margin-auto{margin-left:auto!important;margin-right:auto!important}.uk-margin-auto-top{margin-top:auto!important}.uk-margin-auto-bottom{margin-bottom:auto!important}.uk-margin-auto-left{margin-left:auto!important}.uk-margin-auto-right{margin-right:auto!important}.uk-margin-auto-vertical{margin-top:auto!important;margin-bottom:auto!important}@media (min-width:640px){.uk-margin-auto\\@s{margin-right:auto!important}.uk-margin-auto-left\\@s,.uk-margin-auto\\@s{margin-left:auto!important}.uk-margin-auto-right\\@s{margin-right:auto!important}}@media (min-width:960px){.uk-margin-auto\\@m{margin-right:auto!important}.uk-margin-auto-left\\@m,.uk-margin-auto\\@m{margin-left:auto!important}.uk-margin-auto-right\\@m{margin-right:auto!important}}@media (min-width:1200px){.uk-margin-auto\\@l{margin-right:auto!important}.uk-margin-auto-left\\@l,.uk-margin-auto\\@l{margin-left:auto!important}.uk-margin-auto-right\\@l{margin-right:auto!important}}@media (min-width:1600px){.uk-margin-auto\\@xl{margin-right:auto!important}.uk-margin-auto-left\\@xl,.uk-margin-auto\\@xl{margin-left:auto!important}.uk-margin-auto-right\\@xl{margin-right:auto!important}}.uk-margin-remove{margin:0!important}.uk-margin-remove-top{margin-top:0!important}.uk-margin-remove-bottom{margin-bottom:0!important}.uk-margin-remove-left{margin-left:0!important}.uk-margin-remove-right{margin-right:0!important}.uk-margin-remove-vertical{margin-top:0!important;margin-bottom:0!important}.uk-margin-remove-adjacent+*,.uk-margin-remove-first-child>:first-child{margin-top:0!important}.uk-margin-remove-last-child>:last-child{margin-bottom:0!important}@media (min-width:640px){.uk-margin-remove-left\\@s{margin-left:0!important}.uk-margin-remove-right\\@s{margin-right:0!important}}@media (min-width:960px){.uk-margin-remove-left\\@m{margin-left:0!important}.uk-margin-remove-right\\@m{margin-right:0!important}}@media (min-width:1200px){.uk-margin-remove-left\\@l{margin-left:0!important}.uk-margin-remove-right\\@l{margin-right:0!important}}@media (min-width:1600px){.uk-margin-remove-left\\@xl{margin-left:0!important}.uk-margin-remove-right\\@xl{margin-right:0!important}}.uk-padding{padding:30px}@media (min-width:1200px){.uk-padding{padding:40px}}.uk-padding-small{padding:15px}.uk-padding-large{padding:30px}@media (min-width:1200px){.uk-padding-large{padding:70px}}.uk-padding-remove{padding:0!important}.uk-padding-remove-top{padding-top:0!important}.uk-padding-remove-bottom{padding-bottom:0!important}.uk-padding-remove-left{padding-left:0!important}.uk-padding-remove-right{padding-right:0!important}.uk-padding-remove-vertical{padding-top:0!important;padding-bottom:0!important}.uk-padding-remove-horizontal{padding-left:0!important;padding-right:0!important}[class*=uk-position-bottom],[class*=uk-position-center],[class*=uk-position-left],[class*=uk-position-right],[class*=uk-position-top]{position:absolute!important;max-width:100%}.uk-position-top{top:0;left:0;right:0}.uk-position-bottom{bottom:0;left:0;right:0}.uk-position-left{top:0;bottom:0;left:0}.uk-position-right{top:0;bottom:0;right:0}.uk-position-top-left{top:0;left:0}.uk-position-top-right{top:0;right:0}.uk-position-bottom-left{bottom:0;left:0}.uk-position-bottom-right{bottom:0;right:0}.uk-position-center{top:50%;left:50%;transform:translate(-50%,-50%);width:max-content;max-width:100%;box-sizing:border-box}[class*=uk-position-center-left],[class*=uk-position-center-right]{top:50%;transform:translateY(-50%)}.uk-position-center-left{left:0}.uk-position-center-right{right:0}.uk-position-center-left-out{right:100%;width:max-content}.uk-position-center-right-out{left:100%;width:max-content}.uk-position-bottom-center,.uk-position-top-center{left:50%;transform:translateX(-50%);width:max-content;max-width:100%;box-sizing:border-box}.uk-position-top-center{top:0}.uk-position-bottom-center{bottom:0}.uk-position-cover{position:absolute;top:0;bottom:0;left:0;right:0}.uk-position-relative{position:relative!important}.uk-position-absolute{position:absolute!important}.uk-position-fixed{position:fixed!important}.uk-position-z-index{z-index:1}.uk-position-small{max-width:calc(100% - 30px);margin:15px}.uk-position-small.uk-position-center{transform:translate(-50%,-50%) translate(-15px,-15px)}.uk-position-small[class*=uk-position-center-left],.uk-position-small[class*=uk-position-center-right]{transform:translateY(-50%) translateY(-15px)}.uk-position-small.uk-position-bottom-center,.uk-position-small.uk-position-top-center{transform:translateX(-50%) translateX(-15px)}.uk-position-medium{max-width:calc(100% - 60px);margin:30px}.uk-position-medium.uk-position-center{transform:translate(-50%,-50%) translate(-30px,-30px)}.uk-position-medium[class*=uk-position-center-left],.uk-position-medium[class*=uk-position-center-right]{transform:translateY(-50%) translateY(-30px)}.uk-position-medium.uk-position-bottom-center,.uk-position-medium.uk-position-top-center{transform:translateX(-50%) translateX(-30px)}.uk-position-large{max-width:calc(100% - 60px);margin:30px}.uk-position-large.uk-position-center{transform:translate(-50%,-50%) translate(-30px,-30px)}.uk-position-large[class*=uk-position-center-left],.uk-position-large[class*=uk-position-center-right]{transform:translateY(-50%) translateY(-30px)}.uk-position-large.uk-position-bottom-center,.uk-position-large.uk-position-top-center{transform:translateX(-50%) translateX(-30px)}@media (min-width:1200px){.uk-position-large{max-width:calc(100% - 100px);margin:50px}.uk-position-large.uk-position-center{transform:translate(-50%,-50%) translate(-50px,-50px)}.uk-position-large[class*=uk-position-center-left],.uk-position-large[class*=uk-position-center-right]{transform:translateY(-50%) translateY(-50px)}.uk-position-large.uk-position-bottom-center,.uk-position-large.uk-position-top-center{transform:translateX(-50%) translateX(-50px)}}.uk-transition-toggle{-webkit-tap-highlight-color:transparent}.uk-transition-toggle:focus{outline:none}.uk-transition-fade,[class*=uk-transition-scale],[class*=uk-transition-slide]{transition:.3s ease-out;transition-property:opacity,transform,filter;opacity:0}.uk-transition-active.uk-active .uk-transition-fade,.uk-transition-toggle:focus .uk-transition-fade,.uk-transition-toggle:hover .uk-transition-fade{opacity:1}.uk-transition-scale-up{transform:scale(1)}.uk-transition-scale-down{transform:scale(1.03)}.uk-transition-active.uk-active .uk-transition-scale-up,.uk-transition-toggle:focus .uk-transition-scale-up,.uk-transition-toggle:hover .uk-transition-scale-up{opacity:1;transform:scale(1.03)}.uk-transition-active.uk-active .uk-transition-scale-down,.uk-transition-toggle:focus .uk-transition-scale-down,.uk-transition-toggle:hover .uk-transition-scale-down{opacity:1;transform:scale(1)}.uk-transition-slide-top{transform:translateY(-100%)}.uk-transition-slide-bottom{transform:translateY(100%)}.uk-transition-slide-left{transform:translateX(-100%)}.uk-transition-slide-right{transform:translateX(100%)}.uk-transition-slide-top-small{transform:translateY(-10px)}.uk-transition-slide-bottom-small{transform:translateY(10px)}.uk-transition-slide-left-small{transform:translateX(-10px)}.uk-transition-slide-right-small{transform:translateX(10px)}.uk-transition-slide-top-medium{transform:translateY(-50px)}.uk-transition-slide-bottom-medium{transform:translateY(50px)}.uk-transition-slide-left-medium{transform:translateX(-50px)}.uk-transition-slide-right-medium{transform:translateX(50px)}.uk-transition-active.uk-active [class*=uk-transition-slide],.uk-transition-toggle:focus [class*=uk-transition-slide],.uk-transition-toggle:hover [class*=uk-transition-slide]{opacity:1;transform:translate(0)}.uk-transition-opaque{opacity:1}.uk-transition-slow{transition-duration:.7s}.uk-hidden,[hidden]{display:none!important}@media (min-width:640px){.uk-hidden\\@s{display:none!important}}@media (min-width:960px){.uk-hidden\\@m{display:none!important}}@media (min-width:1200px){.uk-hidden\\@l{display:none!important}}@media (min-width:1600px){.uk-hidden\\@xl{display:none!important}}@media (max-width:639px){.uk-visible\\@s{display:none!important}}@media (max-width:959px){.uk-visible\\@m{display:none!important}}@media (max-width:1199px){.uk-visible\\@l{display:none!important}}@media (max-width:1599px){.uk-visible\\@xl{display:none!important}}.uk-invisible{visibility:hidden!important}.uk-visible-toggle:not(:hover):not(:focus) .uk-hidden-hover:not(:focus-within){position:absolute!important;width:0!important;height:0!important;padding:0!important;margin:0!important;overflow:hidden!important}.uk-visible-toggle:not(:hover):not(:focus) .uk-invisible-hover:not(:focus-within){opacity:0!important}.uk-visible-toggle{-webkit-tap-highlight-color:transparent}.uk-visible-toggle:focus{outline:none}@media (pointer:coarse){.uk-hidden-touch{display:none!important}}.uk-hidden-notouch{display:none!important}@media (pointer:coarse){.uk-hidden-notouch{display:block!important}}.uk-card-primary.uk-card-body,.uk-card-primary>:not([class*=uk-card-media]),.uk-card-secondary.uk-card-body,.uk-card-secondary>:not([class*=uk-card-media]),.uk-light,.uk-offcanvas-bar,.uk-overlay-primary,.uk-section-primary:not(.uk-preserve-color),.uk-section-secondary:not(.uk-preserve-color),.uk-tile-primary:not(.uk-preserve-color),.uk-tile-secondary:not(.uk-preserve-color){color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-link,.uk-card-primary.uk-card-body .uk-link-toggle:focus .uk-link,.uk-card-primary.uk-card-body .uk-link-toggle:hover .uk-link,.uk-card-primary.uk-card-body .uk-link:hover,.uk-card-primary.uk-card-body a,.uk-card-primary.uk-card-body a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-link,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-toggle:focus .uk-link,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-toggle:hover .uk-link,.uk-card-primary>:not([class*=uk-card-media]) .uk-link:hover,.uk-card-primary>:not([class*=uk-card-media]) a,.uk-card-primary>:not([class*=uk-card-media]) a:hover,.uk-card-secondary.uk-card-body .uk-link,.uk-card-secondary.uk-card-body .uk-link-toggle:focus .uk-link,.uk-card-secondary.uk-card-body .uk-link-toggle:hover .uk-link,.uk-card-secondary.uk-card-body .uk-link:hover,.uk-card-secondary.uk-card-body a,.uk-card-secondary.uk-card-body a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-toggle:focus .uk-link,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-toggle:hover .uk-link,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link:hover,.uk-card-secondary>:not([class*=uk-card-media]) a,.uk-card-secondary>:not([class*=uk-card-media]) a:hover,.uk-light .uk-link,.uk-light .uk-link-toggle:focus .uk-link,.uk-light .uk-link-toggle:hover .uk-link,.uk-light .uk-link:hover,.uk-light a,.uk-light a:hover,.uk-offcanvas-bar .uk-link,.uk-offcanvas-bar .uk-link-toggle:focus .uk-link,.uk-offcanvas-bar .uk-link-toggle:hover .uk-link,.uk-offcanvas-bar .uk-link:hover,.uk-offcanvas-bar a,.uk-offcanvas-bar a:hover,.uk-overlay-primary .uk-link,.uk-overlay-primary .uk-link-toggle:focus .uk-link,.uk-overlay-primary .uk-link-toggle:hover .uk-link,.uk-overlay-primary .uk-link:hover,.uk-overlay-primary a,.uk-overlay-primary a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-link,.uk-section-primary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link,.uk-section-primary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link,.uk-section-primary:not(.uk-preserve-color) .uk-link:hover,.uk-section-primary:not(.uk-preserve-color) a,.uk-section-primary:not(.uk-preserve-color) a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-link,.uk-section-secondary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link,.uk-section-secondary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link,.uk-section-secondary:not(.uk-preserve-color) .uk-link:hover,.uk-section-secondary:not(.uk-preserve-color) a,.uk-section-secondary:not(.uk-preserve-color) a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-link,.uk-tile-primary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link,.uk-tile-primary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link,.uk-tile-primary:not(.uk-preserve-color) .uk-link:hover,.uk-tile-primary:not(.uk-preserve-color) a,.uk-tile-primary:not(.uk-preserve-color) a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-link,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link,.uk-tile-secondary:not(.uk-preserve-color) .uk-link:hover,.uk-tile-secondary:not(.uk-preserve-color) a,.uk-tile-secondary:not(.uk-preserve-color) a:hover{color:#fff}.uk-card-primary.uk-card-body :not(pre)>code,.uk-card-primary.uk-card-body :not(pre)>kbd,.uk-card-primary.uk-card-body :not(pre)>samp,.uk-card-primary>:not([class*=uk-card-media]) :not(pre)>code,.uk-card-primary>:not([class*=uk-card-media]) :not(pre)>kbd,.uk-card-primary>:not([class*=uk-card-media]) :not(pre)>samp,.uk-card-secondary.uk-card-body :not(pre)>code,.uk-card-secondary.uk-card-body :not(pre)>kbd,.uk-card-secondary.uk-card-body :not(pre)>samp,.uk-card-secondary>:not([class*=uk-card-media]) :not(pre)>code,.uk-card-secondary>:not([class*=uk-card-media]) :not(pre)>kbd,.uk-card-secondary>:not([class*=uk-card-media]) :not(pre)>samp,.uk-light :not(pre)>code,.uk-light :not(pre)>kbd,.uk-light :not(pre)>samp,.uk-offcanvas-bar :not(pre)>code,.uk-offcanvas-bar :not(pre)>kbd,.uk-offcanvas-bar :not(pre)>samp,.uk-overlay-primary :not(pre)>code,.uk-overlay-primary :not(pre)>kbd,.uk-overlay-primary :not(pre)>samp,.uk-section-primary:not(.uk-preserve-color) :not(pre)>code,.uk-section-primary:not(.uk-preserve-color) :not(pre)>kbd,.uk-section-primary:not(.uk-preserve-color) :not(pre)>samp,.uk-section-secondary:not(.uk-preserve-color) :not(pre)>code,.uk-section-secondary:not(.uk-preserve-color) :not(pre)>kbd,.uk-section-secondary:not(.uk-preserve-color) :not(pre)>samp,.uk-tile-primary:not(.uk-preserve-color) :not(pre)>code,.uk-tile-primary:not(.uk-preserve-color) :not(pre)>kbd,.uk-tile-primary:not(.uk-preserve-color) :not(pre)>samp,.uk-tile-secondary:not(.uk-preserve-color) :not(pre)>code,.uk-tile-secondary:not(.uk-preserve-color) :not(pre)>kbd,.uk-tile-secondary:not(.uk-preserve-color) :not(pre)>samp{color:hsla(0,0%,100%,.7);background:hsla(0,0%,100%,.1)}.uk-card-primary.uk-card-body .uk-h1,.uk-card-primary.uk-card-body .uk-h2,.uk-card-primary.uk-card-body .uk-h3,.uk-card-primary.uk-card-body .uk-h4,.uk-card-primary.uk-card-body .uk-h5,.uk-card-primary.uk-card-body .uk-h6,.uk-card-primary.uk-card-body .uk-heading-2xlarge,.uk-card-primary.uk-card-body .uk-heading-large,.uk-card-primary.uk-card-body .uk-heading-medium,.uk-card-primary.uk-card-body .uk-heading-small,.uk-card-primary.uk-card-body .uk-heading-xlarge,.uk-card-primary.uk-card-body blockquote,.uk-card-primary.uk-card-body em,.uk-card-primary.uk-card-body h1,.uk-card-primary.uk-card-body h2,.uk-card-primary.uk-card-body h3,.uk-card-primary.uk-card-body h4,.uk-card-primary.uk-card-body h5,.uk-card-primary.uk-card-body h6,.uk-card-primary>:not([class*=uk-card-media]) .uk-h1,.uk-card-primary>:not([class*=uk-card-media]) .uk-h2,.uk-card-primary>:not([class*=uk-card-media]) .uk-h3,.uk-card-primary>:not([class*=uk-card-media]) .uk-h4,.uk-card-primary>:not([class*=uk-card-media]) .uk-h5,.uk-card-primary>:not([class*=uk-card-media]) .uk-h6,.uk-card-primary>:not([class*=uk-card-media]) .uk-heading-2xlarge,.uk-card-primary>:not([class*=uk-card-media]) .uk-heading-large,.uk-card-primary>:not([class*=uk-card-media]) .uk-heading-medium,.uk-card-primary>:not([class*=uk-card-media]) .uk-heading-small,.uk-card-primary>:not([class*=uk-card-media]) .uk-heading-xlarge,.uk-card-primary>:not([class*=uk-card-media]) blockquote,.uk-card-primary>:not([class*=uk-card-media]) em,.uk-card-primary>:not([class*=uk-card-media]) h1,.uk-card-primary>:not([class*=uk-card-media]) h2,.uk-card-primary>:not([class*=uk-card-media]) h3,.uk-card-primary>:not([class*=uk-card-media]) h4,.uk-card-primary>:not([class*=uk-card-media]) h5,.uk-card-primary>:not([class*=uk-card-media]) h6,.uk-card-secondary.uk-card-body .uk-h1,.uk-card-secondary.uk-card-body .uk-h2,.uk-card-secondary.uk-card-body .uk-h3,.uk-card-secondary.uk-card-body .uk-h4,.uk-card-secondary.uk-card-body .uk-h5,.uk-card-secondary.uk-card-body .uk-h6,.uk-card-secondary.uk-card-body .uk-heading-2xlarge,.uk-card-secondary.uk-card-body .uk-heading-large,.uk-card-secondary.uk-card-body .uk-heading-medium,.uk-card-secondary.uk-card-body .uk-heading-small,.uk-card-secondary.uk-card-body .uk-heading-xlarge,.uk-card-secondary.uk-card-body blockquote,.uk-card-secondary.uk-card-body em,.uk-card-secondary.uk-card-body h1,.uk-card-secondary.uk-card-body h2,.uk-card-secondary.uk-card-body h3,.uk-card-secondary.uk-card-body h4,.uk-card-secondary.uk-card-body h5,.uk-card-secondary.uk-card-body h6,.uk-card-secondary>:not([class*=uk-card-media]) .uk-h1,.uk-card-secondary>:not([class*=uk-card-media]) .uk-h2,.uk-card-secondary>:not([class*=uk-card-media]) .uk-h3,.uk-card-secondary>:not([class*=uk-card-media]) .uk-h4,.uk-card-secondary>:not([class*=uk-card-media]) .uk-h5,.uk-card-secondary>:not([class*=uk-card-media]) .uk-h6,.uk-card-secondary>:not([class*=uk-card-media]) .uk-heading-2xlarge,.uk-card-secondary>:not([class*=uk-card-media]) .uk-heading-large,.uk-card-secondary>:not([class*=uk-card-media]) .uk-heading-medium,.uk-card-secondary>:not([class*=uk-card-media]) .uk-heading-small,.uk-card-secondary>:not([class*=uk-card-media]) .uk-heading-xlarge,.uk-card-secondary>:not([class*=uk-card-media]) blockquote,.uk-card-secondary>:not([class*=uk-card-media]) em,.uk-card-secondary>:not([class*=uk-card-media]) h1,.uk-card-secondary>:not([class*=uk-card-media]) h2,.uk-card-secondary>:not([class*=uk-card-media]) h3,.uk-card-secondary>:not([class*=uk-card-media]) h4,.uk-card-secondary>:not([class*=uk-card-media]) h5,.uk-card-secondary>:not([class*=uk-card-media]) h6,.uk-light .uk-h1,.uk-light .uk-h2,.uk-light .uk-h3,.uk-light .uk-h4,.uk-light .uk-h5,.uk-light .uk-h6,.uk-light .uk-heading-2xlarge,.uk-light .uk-heading-large,.uk-light .uk-heading-medium,.uk-light .uk-heading-small,.uk-light .uk-heading-xlarge,.uk-light blockquote,.uk-light em,.uk-light h1,.uk-light h2,.uk-light h3,.uk-light h4,.uk-light h5,.uk-light h6,.uk-offcanvas-bar .uk-h1,.uk-offcanvas-bar .uk-h2,.uk-offcanvas-bar .uk-h3,.uk-offcanvas-bar .uk-h4,.uk-offcanvas-bar .uk-h5,.uk-offcanvas-bar .uk-h6,.uk-offcanvas-bar .uk-heading-2xlarge,.uk-offcanvas-bar .uk-heading-large,.uk-offcanvas-bar .uk-heading-medium,.uk-offcanvas-bar .uk-heading-small,.uk-offcanvas-bar .uk-heading-xlarge,.uk-offcanvas-bar blockquote,.uk-offcanvas-bar em,.uk-offcanvas-bar h1,.uk-offcanvas-bar h2,.uk-offcanvas-bar h3,.uk-offcanvas-bar h4,.uk-offcanvas-bar h5,.uk-offcanvas-bar h6,.uk-overlay-primary .uk-h1,.uk-overlay-primary .uk-h2,.uk-overlay-primary .uk-h3,.uk-overlay-primary .uk-h4,.uk-overlay-primary .uk-h5,.uk-overlay-primary .uk-h6,.uk-overlay-primary .uk-heading-2xlarge,.uk-overlay-primary .uk-heading-large,.uk-overlay-primary .uk-heading-medium,.uk-overlay-primary .uk-heading-small,.uk-overlay-primary .uk-heading-xlarge,.uk-overlay-primary blockquote,.uk-overlay-primary em,.uk-overlay-primary h1,.uk-overlay-primary h2,.uk-overlay-primary h3,.uk-overlay-primary h4,.uk-overlay-primary h5,.uk-overlay-primary h6,.uk-section-primary:not(.uk-preserve-color) .uk-h1,.uk-section-primary:not(.uk-preserve-color) .uk-h2,.uk-section-primary:not(.uk-preserve-color) .uk-h3,.uk-section-primary:not(.uk-preserve-color) .uk-h4,.uk-section-primary:not(.uk-preserve-color) .uk-h5,.uk-section-primary:not(.uk-preserve-color) .uk-h6,.uk-section-primary:not(.uk-preserve-color) .uk-heading-2xlarge,.uk-section-primary:not(.uk-preserve-color) .uk-heading-large,.uk-section-primary:not(.uk-preserve-color) .uk-heading-medium,.uk-section-primary:not(.uk-preserve-color) .uk-heading-small,.uk-section-primary:not(.uk-preserve-color) .uk-heading-xlarge,.uk-section-primary:not(.uk-preserve-color) blockquote,.uk-section-primary:not(.uk-preserve-color) em,.uk-section-primary:not(.uk-preserve-color) h1,.uk-section-primary:not(.uk-preserve-color) h2,.uk-section-primary:not(.uk-preserve-color) h3,.uk-section-primary:not(.uk-preserve-color) h4,.uk-section-primary:not(.uk-preserve-color) h5,.uk-section-primary:not(.uk-preserve-color) h6,.uk-section-secondary:not(.uk-preserve-color) .uk-h1,.uk-section-secondary:not(.uk-preserve-color) .uk-h2,.uk-section-secondary:not(.uk-preserve-color) .uk-h3,.uk-section-secondary:not(.uk-preserve-color) .uk-h4,.uk-section-secondary:not(.uk-preserve-color) .uk-h5,.uk-section-secondary:not(.uk-preserve-color) .uk-h6,.uk-section-secondary:not(.uk-preserve-color) .uk-heading-2xlarge,.uk-section-secondary:not(.uk-preserve-color) .uk-heading-large,.uk-section-secondary:not(.uk-preserve-color) .uk-heading-medium,.uk-section-secondary:not(.uk-preserve-color) .uk-heading-small,.uk-section-secondary:not(.uk-preserve-color) .uk-heading-xlarge,.uk-section-secondary:not(.uk-preserve-color) blockquote,.uk-section-secondary:not(.uk-preserve-color) em,.uk-section-secondary:not(.uk-preserve-color) h1,.uk-section-secondary:not(.uk-preserve-color) h2,.uk-section-secondary:not(.uk-preserve-color) h3,.uk-section-secondary:not(.uk-preserve-color) h4,.uk-section-secondary:not(.uk-preserve-color) h5,.uk-section-secondary:not(.uk-preserve-color) h6,.uk-tile-primary:not(.uk-preserve-color) .uk-h1,.uk-tile-primary:not(.uk-preserve-color) .uk-h2,.uk-tile-primary:not(.uk-preserve-color) .uk-h3,.uk-tile-primary:not(.uk-preserve-color) .uk-h4,.uk-tile-primary:not(.uk-preserve-color) .uk-h5,.uk-tile-primary:not(.uk-preserve-color) .uk-h6,.uk-tile-primary:not(.uk-preserve-color) .uk-heading-2xlarge,.uk-tile-primary:not(.uk-preserve-color) .uk-heading-large,.uk-tile-primary:not(.uk-preserve-color) .uk-heading-medium,.uk-tile-primary:not(.uk-preserve-color) .uk-heading-small,.uk-tile-primary:not(.uk-preserve-color) .uk-heading-xlarge,.uk-tile-primary:not(.uk-preserve-color) blockquote,.uk-tile-primary:not(.uk-preserve-color) em,.uk-tile-primary:not(.uk-preserve-color) h1,.uk-tile-primary:not(.uk-preserve-color) h2,.uk-tile-primary:not(.uk-preserve-color) h3,.uk-tile-primary:not(.uk-preserve-color) h4,.uk-tile-primary:not(.uk-preserve-color) h5,.uk-tile-primary:not(.uk-preserve-color) h6,.uk-tile-secondary:not(.uk-preserve-color) .uk-h1,.uk-tile-secondary:not(.uk-preserve-color) .uk-h2,.uk-tile-secondary:not(.uk-preserve-color) .uk-h3,.uk-tile-secondary:not(.uk-preserve-color) .uk-h4,.uk-tile-secondary:not(.uk-preserve-color) .uk-h5,.uk-tile-secondary:not(.uk-preserve-color) .uk-h6,.uk-tile-secondary:not(.uk-preserve-color) .uk-heading-2xlarge,.uk-tile-secondary:not(.uk-preserve-color) .uk-heading-large,.uk-tile-secondary:not(.uk-preserve-color) .uk-heading-medium,.uk-tile-secondary:not(.uk-preserve-color) .uk-heading-small,.uk-tile-secondary:not(.uk-preserve-color) .uk-heading-xlarge,.uk-tile-secondary:not(.uk-preserve-color) blockquote,.uk-tile-secondary:not(.uk-preserve-color) em,.uk-tile-secondary:not(.uk-preserve-color) h1,.uk-tile-secondary:not(.uk-preserve-color) h2,.uk-tile-secondary:not(.uk-preserve-color) h3,.uk-tile-secondary:not(.uk-preserve-color) h4,.uk-tile-secondary:not(.uk-preserve-color) h5,.uk-tile-secondary:not(.uk-preserve-color) h6{color:#fff}.uk-card-primary.uk-card-body blockquote footer,.uk-card-primary>:not([class*=uk-card-media]) blockquote footer,.uk-card-secondary.uk-card-body blockquote footer,.uk-card-secondary>:not([class*=uk-card-media]) blockquote footer,.uk-light blockquote footer,.uk-offcanvas-bar blockquote footer,.uk-overlay-primary blockquote footer,.uk-section-primary:not(.uk-preserve-color) blockquote footer,.uk-section-secondary:not(.uk-preserve-color) blockquote footer,.uk-tile-primary:not(.uk-preserve-color) blockquote footer,.uk-tile-secondary:not(.uk-preserve-color) blockquote footer{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-hr,.uk-card-primary.uk-card-body hr,.uk-card-primary>:not([class*=uk-card-media]) .uk-hr,.uk-card-primary>:not([class*=uk-card-media]) hr,.uk-card-secondary.uk-card-body .uk-hr,.uk-card-secondary.uk-card-body hr,.uk-card-secondary>:not([class*=uk-card-media]) .uk-hr,.uk-card-secondary>:not([class*=uk-card-media]) hr,.uk-light .uk-hr,.uk-light hr,.uk-offcanvas-bar .uk-hr,.uk-offcanvas-bar hr,.uk-overlay-primary .uk-hr,.uk-overlay-primary hr,.uk-section-primary:not(.uk-preserve-color) .uk-hr,.uk-section-primary:not(.uk-preserve-color) hr,.uk-section-secondary:not(.uk-preserve-color) .uk-hr,.uk-section-secondary:not(.uk-preserve-color) hr,.uk-tile-primary:not(.uk-preserve-color) .uk-hr,.uk-tile-primary:not(.uk-preserve-color) hr,.uk-tile-secondary:not(.uk-preserve-color) .uk-hr,.uk-tile-secondary:not(.uk-preserve-color) hr{border-top-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-link-muted a,.uk-card-primary.uk-card-body a.uk-link-muted,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-muted a,.uk-card-primary>:not([class*=uk-card-media]) a.uk-link-muted,.uk-card-secondary.uk-card-body .uk-link-muted a,.uk-card-secondary.uk-card-body a.uk-link-muted,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-muted a,.uk-card-secondary>:not([class*=uk-card-media]) a.uk-link-muted,.uk-light .uk-link-muted a,.uk-light a.uk-link-muted,.uk-offcanvas-bar .uk-link-muted a,.uk-offcanvas-bar a.uk-link-muted,.uk-overlay-primary .uk-link-muted a,.uk-overlay-primary a.uk-link-muted,.uk-section-primary:not(.uk-preserve-color) .uk-link-muted a,.uk-section-primary:not(.uk-preserve-color) a.uk-link-muted,.uk-section-secondary:not(.uk-preserve-color) .uk-link-muted a,.uk-section-secondary:not(.uk-preserve-color) a.uk-link-muted,.uk-tile-primary:not(.uk-preserve-color) .uk-link-muted a,.uk-tile-primary:not(.uk-preserve-color) a.uk-link-muted,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-muted a,.uk-tile-secondary:not(.uk-preserve-color) a.uk-link-muted{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-link-muted a:hover,.uk-card-primary.uk-card-body .uk-link-toggle:focus .uk-link-muted,.uk-card-primary.uk-card-body .uk-link-toggle:hover .uk-link-muted,.uk-card-primary.uk-card-body a.uk-link-muted:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-muted a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-toggle:focus .uk-link-muted,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-toggle:hover .uk-link-muted,.uk-card-primary>:not([class*=uk-card-media]) a.uk-link-muted:hover,.uk-card-secondary.uk-card-body .uk-link-muted a:hover,.uk-card-secondary.uk-card-body .uk-link-toggle:focus .uk-link-muted,.uk-card-secondary.uk-card-body .uk-link-toggle:hover .uk-link-muted,.uk-card-secondary.uk-card-body a.uk-link-muted:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-muted a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-toggle:focus .uk-link-muted,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-toggle:hover .uk-link-muted,.uk-card-secondary>:not([class*=uk-card-media]) a.uk-link-muted:hover,.uk-light .uk-link-muted a:hover,.uk-light .uk-link-toggle:focus .uk-link-muted,.uk-light .uk-link-toggle:hover .uk-link-muted,.uk-light a.uk-link-muted:hover,.uk-offcanvas-bar .uk-link-muted a:hover,.uk-offcanvas-bar .uk-link-toggle:focus .uk-link-muted,.uk-offcanvas-bar .uk-link-toggle:hover .uk-link-muted,.uk-offcanvas-bar a.uk-link-muted:hover,.uk-overlay-primary .uk-link-muted a:hover,.uk-overlay-primary .uk-link-toggle:focus .uk-link-muted,.uk-overlay-primary .uk-link-toggle:hover .uk-link-muted,.uk-overlay-primary a.uk-link-muted:hover,.uk-section-primary:not(.uk-preserve-color) .uk-link-muted a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-muted,.uk-section-primary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-muted,.uk-section-primary:not(.uk-preserve-color) a.uk-link-muted:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-link-muted a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-muted,.uk-section-secondary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-muted,.uk-section-secondary:not(.uk-preserve-color) a.uk-link-muted:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-link-muted a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-muted,.uk-tile-primary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-muted,.uk-tile-primary:not(.uk-preserve-color) a.uk-link-muted:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-muted a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-muted,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-muted,.uk-tile-secondary:not(.uk-preserve-color) a.uk-link-muted:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-link-text a:hover,.uk-card-primary.uk-card-body .uk-link-toggle:focus .uk-link-text,.uk-card-primary.uk-card-body .uk-link-toggle:hover .uk-link-text,.uk-card-primary.uk-card-body a.uk-link-text:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-text a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-toggle:focus .uk-link-text,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-toggle:hover .uk-link-text,.uk-card-primary>:not([class*=uk-card-media]) a.uk-link-text:hover,.uk-card-secondary.uk-card-body .uk-link-text a:hover,.uk-card-secondary.uk-card-body .uk-link-toggle:focus .uk-link-text,.uk-card-secondary.uk-card-body .uk-link-toggle:hover .uk-link-text,.uk-card-secondary.uk-card-body a.uk-link-text:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-text a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-toggle:focus .uk-link-text,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-toggle:hover .uk-link-text,.uk-card-secondary>:not([class*=uk-card-media]) a.uk-link-text:hover,.uk-light .uk-link-text a:hover,.uk-light .uk-link-toggle:focus .uk-link-text,.uk-light .uk-link-toggle:hover .uk-link-text,.uk-light a.uk-link-text:hover,.uk-offcanvas-bar .uk-link-text a:hover,.uk-offcanvas-bar .uk-link-toggle:focus .uk-link-text,.uk-offcanvas-bar .uk-link-toggle:hover .uk-link-text,.uk-offcanvas-bar a.uk-link-text:hover,.uk-overlay-primary .uk-link-text a:hover,.uk-overlay-primary .uk-link-toggle:focus .uk-link-text,.uk-overlay-primary .uk-link-toggle:hover .uk-link-text,.uk-overlay-primary a.uk-link-text:hover,.uk-section-primary:not(.uk-preserve-color) .uk-link-text a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-text,.uk-section-primary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-text,.uk-section-primary:not(.uk-preserve-color) a.uk-link-text:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-link-text a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-text,.uk-section-secondary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-text,.uk-section-secondary:not(.uk-preserve-color) a.uk-link-text:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-link-text a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-text,.uk-tile-primary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-text,.uk-tile-primary:not(.uk-preserve-color) a.uk-link-text:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-text a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-text,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-text,.uk-tile-secondary:not(.uk-preserve-color) a.uk-link-text:hover{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-link-heading a:hover,.uk-card-primary.uk-card-body .uk-link-toggle:focus .uk-link-heading,.uk-card-primary.uk-card-body .uk-link-toggle:hover .uk-link-heading,.uk-card-primary.uk-card-body a.uk-link-heading:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-heading a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-toggle:focus .uk-link-heading,.uk-card-primary>:not([class*=uk-card-media]) .uk-link-toggle:hover .uk-link-heading,.uk-card-primary>:not([class*=uk-card-media]) a.uk-link-heading:hover,.uk-card-secondary.uk-card-body .uk-link-heading a:hover,.uk-card-secondary.uk-card-body .uk-link-toggle:focus .uk-link-heading,.uk-card-secondary.uk-card-body .uk-link-toggle:hover .uk-link-heading,.uk-card-secondary.uk-card-body a.uk-link-heading:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-heading a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-toggle:focus .uk-link-heading,.uk-card-secondary>:not([class*=uk-card-media]) .uk-link-toggle:hover .uk-link-heading,.uk-card-secondary>:not([class*=uk-card-media]) a.uk-link-heading:hover,.uk-light .uk-link-heading a:hover,.uk-light .uk-link-toggle:focus .uk-link-heading,.uk-light .uk-link-toggle:hover .uk-link-heading,.uk-light a.uk-link-heading:hover,.uk-offcanvas-bar .uk-link-heading a:hover,.uk-offcanvas-bar .uk-link-toggle:focus .uk-link-heading,.uk-offcanvas-bar .uk-link-toggle:hover .uk-link-heading,.uk-offcanvas-bar a.uk-link-heading:hover,.uk-overlay-primary .uk-link-heading a:hover,.uk-overlay-primary .uk-link-toggle:focus .uk-link-heading,.uk-overlay-primary .uk-link-toggle:hover .uk-link-heading,.uk-overlay-primary a.uk-link-heading:hover,.uk-section-primary:not(.uk-preserve-color) .uk-link-heading a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-heading,.uk-section-primary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-heading,.uk-section-primary:not(.uk-preserve-color) a.uk-link-heading:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-link-heading a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-heading,.uk-section-secondary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-heading,.uk-section-secondary:not(.uk-preserve-color) a.uk-link-heading:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-link-heading a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-heading,.uk-tile-primary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-heading,.uk-tile-primary:not(.uk-preserve-color) a.uk-link-heading:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-heading a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-toggle:focus .uk-link-heading,.uk-tile-secondary:not(.uk-preserve-color) .uk-link-toggle:hover .uk-link-heading,.uk-tile-secondary:not(.uk-preserve-color) a.uk-link-heading:hover{color:#fff}.uk-card-primary.uk-card-body .uk-heading-divider,.uk-card-primary>:not([class*=uk-card-media]) .uk-heading-divider,.uk-card-secondary.uk-card-body .uk-heading-divider,.uk-card-secondary>:not([class*=uk-card-media]) .uk-heading-divider,.uk-light .uk-heading-divider,.uk-offcanvas-bar .uk-heading-divider,.uk-overlay-primary .uk-heading-divider,.uk-section-primary:not(.uk-preserve-color) .uk-heading-divider,.uk-section-secondary:not(.uk-preserve-color) .uk-heading-divider,.uk-tile-primary:not(.uk-preserve-color) .uk-heading-divider,.uk-tile-secondary:not(.uk-preserve-color) .uk-heading-divider{border-bottom-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-heading-bullet:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-heading-bullet:before,.uk-card-secondary.uk-card-body .uk-heading-bullet:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-heading-bullet:before,.uk-light .uk-heading-bullet:before,.uk-offcanvas-bar .uk-heading-bullet:before,.uk-overlay-primary .uk-heading-bullet:before,.uk-section-primary:not(.uk-preserve-color) .uk-heading-bullet:before,.uk-section-secondary:not(.uk-preserve-color) .uk-heading-bullet:before,.uk-tile-primary:not(.uk-preserve-color) .uk-heading-bullet:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-heading-bullet:before{border-left-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-heading-line>:after,.uk-card-primary.uk-card-body .uk-heading-line>:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-heading-line>:after,.uk-card-primary>:not([class*=uk-card-media]) .uk-heading-line>:before,.uk-card-secondary.uk-card-body .uk-heading-line>:after,.uk-card-secondary.uk-card-body .uk-heading-line>:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-heading-line>:after,.uk-card-secondary>:not([class*=uk-card-media]) .uk-heading-line>:before,.uk-light .uk-heading-line>:after,.uk-light .uk-heading-line>:before,.uk-offcanvas-bar .uk-heading-line>:after,.uk-offcanvas-bar .uk-heading-line>:before,.uk-overlay-primary .uk-heading-line>:after,.uk-overlay-primary .uk-heading-line>:before,.uk-section-primary:not(.uk-preserve-color) .uk-heading-line>:after,.uk-section-primary:not(.uk-preserve-color) .uk-heading-line>:before,.uk-section-secondary:not(.uk-preserve-color) .uk-heading-line>:after,.uk-section-secondary:not(.uk-preserve-color) .uk-heading-line>:before,.uk-tile-primary:not(.uk-preserve-color) .uk-heading-line>:after,.uk-tile-primary:not(.uk-preserve-color) .uk-heading-line>:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-heading-line>:after,.uk-tile-secondary:not(.uk-preserve-color) .uk-heading-line>:before{border-bottom-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-divider-icon,.uk-card-primary>:not([class*=uk-card-media]) .uk-divider-icon,.uk-card-secondary.uk-card-body .uk-divider-icon,.uk-card-secondary>:not([class*=uk-card-media]) .uk-divider-icon,.uk-light .uk-divider-icon,.uk-offcanvas-bar .uk-divider-icon,.uk-overlay-primary .uk-divider-icon,.uk-section-primary:not(.uk-preserve-color) .uk-divider-icon,.uk-section-secondary:not(.uk-preserve-color) .uk-divider-icon,.uk-tile-primary:not(.uk-preserve-color) .uk-divider-icon,.uk-tile-secondary:not(.uk-preserve-color) .uk-divider-icon{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22none%22%20stroke%3D%22rgba%28255,%20255,%20255,%200.2%29%22%20stroke-width%3D%222%22%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%227%22%20%2F%3E%0A%3C%2Fsvg%3E%0A\")}.uk-card-primary.uk-card-body .uk-divider-icon:after,.uk-card-primary.uk-card-body .uk-divider-icon:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-divider-icon:after,.uk-card-primary>:not([class*=uk-card-media]) .uk-divider-icon:before,.uk-card-secondary.uk-card-body .uk-divider-icon:after,.uk-card-secondary.uk-card-body .uk-divider-icon:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-divider-icon:after,.uk-card-secondary>:not([class*=uk-card-media]) .uk-divider-icon:before,.uk-light .uk-divider-icon:after,.uk-light .uk-divider-icon:before,.uk-offcanvas-bar .uk-divider-icon:after,.uk-offcanvas-bar .uk-divider-icon:before,.uk-overlay-primary .uk-divider-icon:after,.uk-overlay-primary .uk-divider-icon:before,.uk-section-primary:not(.uk-preserve-color) .uk-divider-icon:after,.uk-section-primary:not(.uk-preserve-color) .uk-divider-icon:before,.uk-section-secondary:not(.uk-preserve-color) .uk-divider-icon:after,.uk-section-secondary:not(.uk-preserve-color) .uk-divider-icon:before,.uk-tile-primary:not(.uk-preserve-color) .uk-divider-icon:after,.uk-tile-primary:not(.uk-preserve-color) .uk-divider-icon:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-divider-icon:after,.uk-tile-secondary:not(.uk-preserve-color) .uk-divider-icon:before{border-bottom-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-divider-small:after,.uk-card-primary>:not([class*=uk-card-media]) .uk-divider-small:after,.uk-card-secondary.uk-card-body .uk-divider-small:after,.uk-card-secondary>:not([class*=uk-card-media]) .uk-divider-small:after,.uk-light .uk-divider-small:after,.uk-offcanvas-bar .uk-divider-small:after,.uk-overlay-primary .uk-divider-small:after,.uk-section-primary:not(.uk-preserve-color) .uk-divider-small:after,.uk-section-secondary:not(.uk-preserve-color) .uk-divider-small:after,.uk-tile-primary:not(.uk-preserve-color) .uk-divider-small:after,.uk-tile-secondary:not(.uk-preserve-color) .uk-divider-small:after{border-top-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-divider-vertical,.uk-card-primary>:not([class*=uk-card-media]) .uk-divider-vertical,.uk-card-secondary.uk-card-body .uk-divider-vertical,.uk-card-secondary>:not([class*=uk-card-media]) .uk-divider-vertical,.uk-light .uk-divider-vertical,.uk-offcanvas-bar .uk-divider-vertical,.uk-overlay-primary .uk-divider-vertical,.uk-section-primary:not(.uk-preserve-color) .uk-divider-vertical,.uk-section-secondary:not(.uk-preserve-color) .uk-divider-vertical,.uk-tile-primary:not(.uk-preserve-color) .uk-divider-vertical,.uk-tile-secondary:not(.uk-preserve-color) .uk-divider-vertical{border-left-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-list-muted>:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-list-muted>:before,.uk-card-secondary.uk-card-body .uk-list-muted>:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-list-muted>:before,.uk-light .uk-list-muted>:before,.uk-offcanvas-bar .uk-list-muted>:before,.uk-overlay-primary .uk-list-muted>:before,.uk-section-primary:not(.uk-preserve-color) .uk-list-muted>:before,.uk-section-secondary:not(.uk-preserve-color) .uk-list-muted>:before,.uk-tile-primary:not(.uk-preserve-color) .uk-list-muted>:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-list-muted>:before{color:hsla(0,0%,100%,.5)!important}.uk-card-primary.uk-card-body .uk-list-emphasis>:before,.uk-card-primary.uk-card-body .uk-list-primary>:before,.uk-card-primary.uk-card-body .uk-list-secondary>:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-list-emphasis>:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-list-primary>:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-list-secondary>:before,.uk-card-secondary.uk-card-body .uk-list-emphasis>:before,.uk-card-secondary.uk-card-body .uk-list-primary>:before,.uk-card-secondary.uk-card-body .uk-list-secondary>:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-list-emphasis>:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-list-primary>:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-list-secondary>:before,.uk-light .uk-list-emphasis>:before,.uk-light .uk-list-primary>:before,.uk-light .uk-list-secondary>:before,.uk-offcanvas-bar .uk-list-emphasis>:before,.uk-offcanvas-bar .uk-list-primary>:before,.uk-offcanvas-bar .uk-list-secondary>:before,.uk-overlay-primary .uk-list-emphasis>:before,.uk-overlay-primary .uk-list-primary>:before,.uk-overlay-primary .uk-list-secondary>:before,.uk-section-primary:not(.uk-preserve-color) .uk-list-emphasis>:before,.uk-section-primary:not(.uk-preserve-color) .uk-list-primary>:before,.uk-section-primary:not(.uk-preserve-color) .uk-list-secondary>:before,.uk-section-secondary:not(.uk-preserve-color) .uk-list-emphasis>:before,.uk-section-secondary:not(.uk-preserve-color) .uk-list-primary>:before,.uk-section-secondary:not(.uk-preserve-color) .uk-list-secondary>:before,.uk-tile-primary:not(.uk-preserve-color) .uk-list-emphasis>:before,.uk-tile-primary:not(.uk-preserve-color) .uk-list-primary>:before,.uk-tile-primary:not(.uk-preserve-color) .uk-list-secondary>:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-list-emphasis>:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-list-primary>:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-list-secondary>:before{color:#fff!important}.uk-card-primary.uk-card-body .uk-list-bullet>:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-list-bullet>:before,.uk-card-secondary.uk-card-body .uk-list-bullet>:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-list-bullet>:before,.uk-light .uk-list-bullet>:before,.uk-offcanvas-bar .uk-list-bullet>:before,.uk-overlay-primary .uk-list-bullet>:before,.uk-section-primary:not(.uk-preserve-color) .uk-list-bullet>:before,.uk-section-secondary:not(.uk-preserve-color) .uk-list-bullet>:before,.uk-tile-primary:not(.uk-preserve-color) .uk-list-bullet>:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-list-bullet>:before{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%226%22%20height%3D%226%22%20viewBox%3D%220%200%206%206%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22rgba%28255,%20255,%20255,%200.7%29%22%20cx%3D%223%22%20cy%3D%223%22%20r%3D%223%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-card-primary.uk-card-body .uk-list-divider>:nth-child(n+2),.uk-card-primary>:not([class*=uk-card-media]) .uk-list-divider>:nth-child(n+2),.uk-card-secondary.uk-card-body .uk-list-divider>:nth-child(n+2),.uk-card-secondary>:not([class*=uk-card-media]) .uk-list-divider>:nth-child(n+2),.uk-light .uk-list-divider>:nth-child(n+2),.uk-offcanvas-bar .uk-list-divider>:nth-child(n+2),.uk-overlay-primary .uk-list-divider>:nth-child(n+2),.uk-section-primary:not(.uk-preserve-color) .uk-list-divider>:nth-child(n+2),.uk-section-secondary:not(.uk-preserve-color) .uk-list-divider>:nth-child(n+2),.uk-tile-primary:not(.uk-preserve-color) .uk-list-divider>:nth-child(n+2),.uk-tile-secondary:not(.uk-preserve-color) .uk-list-divider>:nth-child(n+2){border-top-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-list-striped>:nth-of-type(odd),.uk-card-primary>:not([class*=uk-card-media]) .uk-list-striped>:nth-of-type(odd),.uk-card-secondary.uk-card-body .uk-list-striped>:nth-of-type(odd),.uk-card-secondary>:not([class*=uk-card-media]) .uk-list-striped>:nth-of-type(odd),.uk-light .uk-list-striped>:nth-of-type(odd),.uk-offcanvas-bar .uk-list-striped>:nth-of-type(odd),.uk-overlay-primary .uk-list-striped>:nth-of-type(odd),.uk-section-primary:not(.uk-preserve-color) .uk-list-striped>:nth-of-type(odd),.uk-section-secondary:not(.uk-preserve-color) .uk-list-striped>:nth-of-type(odd),.uk-tile-primary:not(.uk-preserve-color) .uk-list-striped>:nth-of-type(odd),.uk-tile-secondary:not(.uk-preserve-color) .uk-list-striped>:nth-of-type(odd){border-top-color:hsla(0,0%,100%,.2);border-bottom-color:hsla(0,0%,100%,.2);background-color:hsla(0,0%,100%,.1)}.uk-card-primary.uk-card-body .uk-table th,.uk-card-primary>:not([class*=uk-card-media]) .uk-table th,.uk-card-secondary.uk-card-body .uk-table th,.uk-card-secondary>:not([class*=uk-card-media]) .uk-table th,.uk-light .uk-table th,.uk-offcanvas-bar .uk-table th,.uk-overlay-primary .uk-table th,.uk-section-primary:not(.uk-preserve-color) .uk-table th,.uk-section-secondary:not(.uk-preserve-color) .uk-table th,.uk-tile-primary:not(.uk-preserve-color) .uk-table th,.uk-tile-secondary:not(.uk-preserve-color) .uk-table th{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-table caption,.uk-card-primary>:not([class*=uk-card-media]) .uk-table caption,.uk-card-secondary.uk-card-body .uk-table caption,.uk-card-secondary>:not([class*=uk-card-media]) .uk-table caption,.uk-light .uk-table caption,.uk-offcanvas-bar .uk-table caption,.uk-overlay-primary .uk-table caption,.uk-section-primary:not(.uk-preserve-color) .uk-table caption,.uk-section-secondary:not(.uk-preserve-color) .uk-table caption,.uk-tile-primary:not(.uk-preserve-color) .uk-table caption,.uk-tile-secondary:not(.uk-preserve-color) .uk-table caption{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-table>tr.uk-active,.uk-card-primary.uk-card-body .uk-table tbody tr.uk-active,.uk-card-primary>:not([class*=uk-card-media]) .uk-table>tr.uk-active,.uk-card-primary>:not([class*=uk-card-media]) .uk-table tbody tr.uk-active,.uk-card-secondary.uk-card-body .uk-table>tr.uk-active,.uk-card-secondary.uk-card-body .uk-table tbody tr.uk-active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-table>tr.uk-active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-table tbody tr.uk-active,.uk-light .uk-table>tr.uk-active,.uk-light .uk-table tbody tr.uk-active,.uk-offcanvas-bar .uk-table>tr.uk-active,.uk-offcanvas-bar .uk-table tbody tr.uk-active,.uk-overlay-primary .uk-table>tr.uk-active,.uk-overlay-primary .uk-table tbody tr.uk-active,.uk-section-primary:not(.uk-preserve-color) .uk-table>tr.uk-active,.uk-section-primary:not(.uk-preserve-color) .uk-table tbody tr.uk-active,.uk-section-secondary:not(.uk-preserve-color) .uk-table>tr.uk-active,.uk-section-secondary:not(.uk-preserve-color) .uk-table tbody tr.uk-active,.uk-tile-primary:not(.uk-preserve-color) .uk-table>tr.uk-active,.uk-tile-primary:not(.uk-preserve-color) .uk-table tbody tr.uk-active,.uk-tile-secondary:not(.uk-preserve-color) .uk-table>tr.uk-active,.uk-tile-secondary:not(.uk-preserve-color) .uk-table tbody tr.uk-active{background:hsla(0,0%,100%,.08)}.uk-card-primary.uk-card-body .uk-table-divider>:first-child>tr:not(:first-child),.uk-card-primary.uk-card-body .uk-table-divider>:not(:first-child)>tr,.uk-card-primary.uk-card-body .uk-table-divider>tr:not(:first-child),.uk-card-primary>:not([class*=uk-card-media]) .uk-table-divider>:first-child>tr:not(:first-child),.uk-card-primary>:not([class*=uk-card-media]) .uk-table-divider>:not(:first-child)>tr,.uk-card-primary>:not([class*=uk-card-media]) .uk-table-divider>tr:not(:first-child),.uk-card-secondary.uk-card-body .uk-table-divider>:first-child>tr:not(:first-child),.uk-card-secondary.uk-card-body .uk-table-divider>:not(:first-child)>tr,.uk-card-secondary.uk-card-body .uk-table-divider>tr:not(:first-child),.uk-card-secondary>:not([class*=uk-card-media]) .uk-table-divider>:first-child>tr:not(:first-child),.uk-card-secondary>:not([class*=uk-card-media]) .uk-table-divider>:not(:first-child)>tr,.uk-card-secondary>:not([class*=uk-card-media]) .uk-table-divider>tr:not(:first-child),.uk-light .uk-table-divider>:first-child>tr:not(:first-child),.uk-light .uk-table-divider>:not(:first-child)>tr,.uk-light .uk-table-divider>tr:not(:first-child),.uk-offcanvas-bar .uk-table-divider>:first-child>tr:not(:first-child),.uk-offcanvas-bar .uk-table-divider>:not(:first-child)>tr,.uk-offcanvas-bar .uk-table-divider>tr:not(:first-child),.uk-overlay-primary .uk-table-divider>:first-child>tr:not(:first-child),.uk-overlay-primary .uk-table-divider>:not(:first-child)>tr,.uk-overlay-primary .uk-table-divider>tr:not(:first-child),.uk-section-primary:not(.uk-preserve-color) .uk-table-divider>:first-child>tr:not(:first-child),.uk-section-primary:not(.uk-preserve-color) .uk-table-divider>:not(:first-child)>tr,.uk-section-primary:not(.uk-preserve-color) .uk-table-divider>tr:not(:first-child),.uk-section-secondary:not(.uk-preserve-color) .uk-table-divider>:first-child>tr:not(:first-child),.uk-section-secondary:not(.uk-preserve-color) .uk-table-divider>:not(:first-child)>tr,.uk-section-secondary:not(.uk-preserve-color) .uk-table-divider>tr:not(:first-child),.uk-tile-primary:not(.uk-preserve-color) .uk-table-divider>:first-child>tr:not(:first-child),.uk-tile-primary:not(.uk-preserve-color) .uk-table-divider>:not(:first-child)>tr,.uk-tile-primary:not(.uk-preserve-color) .uk-table-divider>tr:not(:first-child),.uk-tile-secondary:not(.uk-preserve-color) .uk-table-divider>:first-child>tr:not(:first-child),.uk-tile-secondary:not(.uk-preserve-color) .uk-table-divider>:not(:first-child)>tr,.uk-tile-secondary:not(.uk-preserve-color) .uk-table-divider>tr:not(:first-child){border-top-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-table-striped>tr:nth-of-type(odd),.uk-card-primary.uk-card-body .uk-table-striped tbody tr:nth-of-type(odd),.uk-card-primary>:not([class*=uk-card-media]) .uk-table-striped>tr:nth-of-type(odd),.uk-card-primary>:not([class*=uk-card-media]) .uk-table-striped tbody tr:nth-of-type(odd),.uk-card-secondary.uk-card-body .uk-table-striped>tr:nth-of-type(odd),.uk-card-secondary.uk-card-body .uk-table-striped tbody tr:nth-of-type(odd),.uk-card-secondary>:not([class*=uk-card-media]) .uk-table-striped>tr:nth-of-type(odd),.uk-card-secondary>:not([class*=uk-card-media]) .uk-table-striped tbody tr:nth-of-type(odd),.uk-light .uk-table-striped>tr:nth-of-type(odd),.uk-light .uk-table-striped tbody tr:nth-of-type(odd),.uk-offcanvas-bar .uk-table-striped>tr:nth-of-type(odd),.uk-offcanvas-bar .uk-table-striped tbody tr:nth-of-type(odd),.uk-overlay-primary .uk-table-striped>tr:nth-of-type(odd),.uk-overlay-primary .uk-table-striped tbody tr:nth-of-type(odd),.uk-section-primary:not(.uk-preserve-color) .uk-table-striped>tr:nth-of-type(odd),.uk-section-primary:not(.uk-preserve-color) .uk-table-striped tbody tr:nth-of-type(odd),.uk-section-secondary:not(.uk-preserve-color) .uk-table-striped>tr:nth-of-type(odd),.uk-section-secondary:not(.uk-preserve-color) .uk-table-striped tbody tr:nth-of-type(odd),.uk-tile-primary:not(.uk-preserve-color) .uk-table-striped>tr:nth-of-type(odd),.uk-tile-primary:not(.uk-preserve-color) .uk-table-striped tbody tr:nth-of-type(odd),.uk-tile-secondary:not(.uk-preserve-color) .uk-table-striped>tr:nth-of-type(odd),.uk-tile-secondary:not(.uk-preserve-color) .uk-table-striped tbody tr:nth-of-type(odd){background:hsla(0,0%,100%,.1);border-top-color:hsla(0,0%,100%,.2);border-bottom-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-table-hover>tr:hover,.uk-card-primary.uk-card-body .uk-table-hover tbody tr:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-table-hover>tr:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-table-hover tbody tr:hover,.uk-card-secondary.uk-card-body .uk-table-hover>tr:hover,.uk-card-secondary.uk-card-body .uk-table-hover tbody tr:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-table-hover>tr:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-table-hover tbody tr:hover,.uk-light .uk-table-hover>tr:hover,.uk-light .uk-table-hover tbody tr:hover,.uk-offcanvas-bar .uk-table-hover>tr:hover,.uk-offcanvas-bar .uk-table-hover tbody tr:hover,.uk-overlay-primary .uk-table-hover>tr:hover,.uk-overlay-primary .uk-table-hover tbody tr:hover,.uk-section-primary:not(.uk-preserve-color) .uk-table-hover>tr:hover,.uk-section-primary:not(.uk-preserve-color) .uk-table-hover tbody tr:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-table-hover>tr:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-table-hover tbody tr:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-table-hover>tr:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-table-hover tbody tr:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-table-hover>tr:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-table-hover tbody tr:hover{background:hsla(0,0%,100%,.08)}.uk-card-primary.uk-card-body .uk-icon-link,.uk-card-primary>:not([class*=uk-card-media]) .uk-icon-link,.uk-card-secondary.uk-card-body .uk-icon-link,.uk-card-secondary>:not([class*=uk-card-media]) .uk-icon-link,.uk-light .uk-icon-link,.uk-offcanvas-bar .uk-icon-link,.uk-overlay-primary .uk-icon-link,.uk-section-primary:not(.uk-preserve-color) .uk-icon-link,.uk-section-secondary:not(.uk-preserve-color) .uk-icon-link,.uk-tile-primary:not(.uk-preserve-color) .uk-icon-link,.uk-tile-secondary:not(.uk-preserve-color) .uk-icon-link{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-active>.uk-icon-link,.uk-card-primary.uk-card-body .uk-icon-link:active,.uk-card-primary.uk-card-body .uk-icon-link:focus,.uk-card-primary.uk-card-body .uk-icon-link:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-active>.uk-icon-link,.uk-card-primary>:not([class*=uk-card-media]) .uk-icon-link:active,.uk-card-primary>:not([class*=uk-card-media]) .uk-icon-link:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-icon-link:hover,.uk-card-secondary.uk-card-body .uk-active>.uk-icon-link,.uk-card-secondary.uk-card-body .uk-icon-link:active,.uk-card-secondary.uk-card-body .uk-icon-link:focus,.uk-card-secondary.uk-card-body .uk-icon-link:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-active>.uk-icon-link,.uk-card-secondary>:not([class*=uk-card-media]) .uk-icon-link:active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-icon-link:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-icon-link:hover,.uk-light .uk-active>.uk-icon-link,.uk-light .uk-icon-link:active,.uk-light .uk-icon-link:focus,.uk-light .uk-icon-link:hover,.uk-offcanvas-bar .uk-active>.uk-icon-link,.uk-offcanvas-bar .uk-icon-link:active,.uk-offcanvas-bar .uk-icon-link:focus,.uk-offcanvas-bar .uk-icon-link:hover,.uk-overlay-primary .uk-active>.uk-icon-link,.uk-overlay-primary .uk-icon-link:active,.uk-overlay-primary .uk-icon-link:focus,.uk-overlay-primary .uk-icon-link:hover,.uk-section-primary:not(.uk-preserve-color) .uk-active>.uk-icon-link,.uk-section-primary:not(.uk-preserve-color) .uk-icon-link:active,.uk-section-primary:not(.uk-preserve-color) .uk-icon-link:focus,.uk-section-primary:not(.uk-preserve-color) .uk-icon-link:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-active>.uk-icon-link,.uk-section-secondary:not(.uk-preserve-color) .uk-icon-link:active,.uk-section-secondary:not(.uk-preserve-color) .uk-icon-link:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-icon-link:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-active>.uk-icon-link,.uk-tile-primary:not(.uk-preserve-color) .uk-icon-link:active,.uk-tile-primary:not(.uk-preserve-color) .uk-icon-link:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-icon-link:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-active>.uk-icon-link,.uk-tile-secondary:not(.uk-preserve-color) .uk-icon-link:active,.uk-tile-secondary:not(.uk-preserve-color) .uk-icon-link:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-icon-link:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-icon-button,.uk-card-primary>:not([class*=uk-card-media]) .uk-icon-button,.uk-card-secondary.uk-card-body .uk-icon-button,.uk-card-secondary>:not([class*=uk-card-media]) .uk-icon-button,.uk-light .uk-icon-button,.uk-offcanvas-bar .uk-icon-button,.uk-overlay-primary .uk-icon-button,.uk-section-primary:not(.uk-preserve-color) .uk-icon-button,.uk-section-secondary:not(.uk-preserve-color) .uk-icon-button,.uk-tile-primary:not(.uk-preserve-color) .uk-icon-button,.uk-tile-secondary:not(.uk-preserve-color) .uk-icon-button{background-color:hsla(0,0%,100%,.1);color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-icon-button:focus,.uk-card-primary.uk-card-body .uk-icon-button:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-icon-button:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-icon-button:hover,.uk-card-secondary.uk-card-body .uk-icon-button:focus,.uk-card-secondary.uk-card-body .uk-icon-button:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-icon-button:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-icon-button:hover,.uk-light .uk-icon-button:focus,.uk-light .uk-icon-button:hover,.uk-offcanvas-bar .uk-icon-button:focus,.uk-offcanvas-bar .uk-icon-button:hover,.uk-overlay-primary .uk-icon-button:focus,.uk-overlay-primary .uk-icon-button:hover,.uk-section-primary:not(.uk-preserve-color) .uk-icon-button:focus,.uk-section-primary:not(.uk-preserve-color) .uk-icon-button:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-icon-button:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-icon-button:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-icon-button:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-icon-button:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-icon-button:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-icon-button:hover{background-color:hsla(0,0%,95%,.1);color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-icon-button:active,.uk-card-primary>:not([class*=uk-card-media]) .uk-icon-button:active,.uk-card-secondary.uk-card-body .uk-icon-button:active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-icon-button:active,.uk-light .uk-icon-button:active,.uk-offcanvas-bar .uk-icon-button:active,.uk-overlay-primary .uk-icon-button:active,.uk-section-primary:not(.uk-preserve-color) .uk-icon-button:active,.uk-section-secondary:not(.uk-preserve-color) .uk-icon-button:active,.uk-tile-primary:not(.uk-preserve-color) .uk-icon-button:active,.uk-tile-secondary:not(.uk-preserve-color) .uk-icon-button:active{background-color:hsla(0,0%,90%,.1);color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-input,.uk-card-primary.uk-card-body .uk-select,.uk-card-primary.uk-card-body .uk-textarea,.uk-card-primary>:not([class*=uk-card-media]) .uk-input,.uk-card-primary>:not([class*=uk-card-media]) .uk-select,.uk-card-primary>:not([class*=uk-card-media]) .uk-textarea,.uk-card-secondary.uk-card-body .uk-input,.uk-card-secondary.uk-card-body .uk-select,.uk-card-secondary.uk-card-body .uk-textarea,.uk-card-secondary>:not([class*=uk-card-media]) .uk-input,.uk-card-secondary>:not([class*=uk-card-media]) .uk-select,.uk-card-secondary>:not([class*=uk-card-media]) .uk-textarea,.uk-light .uk-input,.uk-light .uk-select,.uk-light .uk-textarea,.uk-offcanvas-bar .uk-input,.uk-offcanvas-bar .uk-select,.uk-offcanvas-bar .uk-textarea,.uk-overlay-primary .uk-input,.uk-overlay-primary .uk-select,.uk-overlay-primary .uk-textarea,.uk-section-primary:not(.uk-preserve-color) .uk-input,.uk-section-primary:not(.uk-preserve-color) .uk-select,.uk-section-primary:not(.uk-preserve-color) .uk-textarea,.uk-section-secondary:not(.uk-preserve-color) .uk-input,.uk-section-secondary:not(.uk-preserve-color) .uk-select,.uk-section-secondary:not(.uk-preserve-color) .uk-textarea,.uk-tile-primary:not(.uk-preserve-color) .uk-input,.uk-tile-primary:not(.uk-preserve-color) .uk-select,.uk-tile-primary:not(.uk-preserve-color) .uk-textarea,.uk-tile-secondary:not(.uk-preserve-color) .uk-input,.uk-tile-secondary:not(.uk-preserve-color) .uk-select,.uk-tile-secondary:not(.uk-preserve-color) .uk-textarea{background-color:hsla(0,0%,100%,.1);color:hsla(0,0%,100%,.7);background-clip:padding-box;border-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-input:focus,.uk-card-primary.uk-card-body .uk-select:focus,.uk-card-primary.uk-card-body .uk-textarea:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-input:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-select:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-textarea:focus,.uk-card-secondary.uk-card-body .uk-input:focus,.uk-card-secondary.uk-card-body .uk-select:focus,.uk-card-secondary.uk-card-body .uk-textarea:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-input:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-select:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-textarea:focus,.uk-light .uk-input:focus,.uk-light .uk-select:focus,.uk-light .uk-textarea:focus,.uk-offcanvas-bar .uk-input:focus,.uk-offcanvas-bar .uk-select:focus,.uk-offcanvas-bar .uk-textarea:focus,.uk-overlay-primary .uk-input:focus,.uk-overlay-primary .uk-select:focus,.uk-overlay-primary .uk-textarea:focus,.uk-section-primary:not(.uk-preserve-color) .uk-input:focus,.uk-section-primary:not(.uk-preserve-color) .uk-select:focus,.uk-section-primary:not(.uk-preserve-color) .uk-textarea:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-input:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-select:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-textarea:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-input:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-select:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-textarea:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-input:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-select:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-textarea:focus{background-color:hsla(0,0%,100%,.1);color:hsla(0,0%,100%,.7);border-color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-input::-ms-input-placeholder,.uk-card-primary>:not([class*=uk-card-media]) .uk-input::-ms-input-placeholder,.uk-card-secondary.uk-card-body .uk-input::-ms-input-placeholder,.uk-card-secondary>:not([class*=uk-card-media]) .uk-input::-ms-input-placeholder,.uk-light .uk-input::-ms-input-placeholder,.uk-offcanvas-bar .uk-input::-ms-input-placeholder,.uk-overlay-primary .uk-input::-ms-input-placeholder,.uk-section-primary:not(.uk-preserve-color) .uk-input::-ms-input-placeholder,.uk-section-secondary:not(.uk-preserve-color) .uk-input::-ms-input-placeholder,.uk-tile-primary:not(.uk-preserve-color) .uk-input::-ms-input-placeholder,.uk-tile-secondary:not(.uk-preserve-color) .uk-input::-ms-input-placeholder{color:hsla(0,0%,100%,.5)!important}.uk-card-primary.uk-card-body .uk-input::placeholder,.uk-card-primary>:not([class*=uk-card-media]) .uk-input::placeholder,.uk-card-secondary.uk-card-body .uk-input::placeholder,.uk-card-secondary>:not([class*=uk-card-media]) .uk-input::placeholder,.uk-light .uk-input::placeholder,.uk-offcanvas-bar .uk-input::placeholder,.uk-overlay-primary .uk-input::placeholder,.uk-section-primary:not(.uk-preserve-color) .uk-input::placeholder,.uk-section-secondary:not(.uk-preserve-color) .uk-input::placeholder,.uk-tile-primary:not(.uk-preserve-color) .uk-input::placeholder,.uk-tile-secondary:not(.uk-preserve-color) .uk-input::placeholder{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-textarea::-ms-input-placeholder,.uk-card-primary>:not([class*=uk-card-media]) .uk-textarea::-ms-input-placeholder,.uk-card-secondary.uk-card-body .uk-textarea::-ms-input-placeholder,.uk-card-secondary>:not([class*=uk-card-media]) .uk-textarea::-ms-input-placeholder,.uk-light .uk-textarea::-ms-input-placeholder,.uk-offcanvas-bar .uk-textarea::-ms-input-placeholder,.uk-overlay-primary .uk-textarea::-ms-input-placeholder,.uk-section-primary:not(.uk-preserve-color) .uk-textarea::-ms-input-placeholder,.uk-section-secondary:not(.uk-preserve-color) .uk-textarea::-ms-input-placeholder,.uk-tile-primary:not(.uk-preserve-color) .uk-textarea::-ms-input-placeholder,.uk-tile-secondary:not(.uk-preserve-color) .uk-textarea::-ms-input-placeholder{color:hsla(0,0%,100%,.5)!important}.uk-card-primary.uk-card-body .uk-textarea::placeholder,.uk-card-primary>:not([class*=uk-card-media]) .uk-textarea::placeholder,.uk-card-secondary.uk-card-body .uk-textarea::placeholder,.uk-card-secondary>:not([class*=uk-card-media]) .uk-textarea::placeholder,.uk-light .uk-textarea::placeholder,.uk-offcanvas-bar .uk-textarea::placeholder,.uk-overlay-primary .uk-textarea::placeholder,.uk-section-primary:not(.uk-preserve-color) .uk-textarea::placeholder,.uk-section-secondary:not(.uk-preserve-color) .uk-textarea::placeholder,.uk-tile-primary:not(.uk-preserve-color) .uk-textarea::placeholder,.uk-tile-secondary:not(.uk-preserve-color) .uk-textarea::placeholder{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-select:not([multiple]):not([size]),.uk-card-primary>:not([class*=uk-card-media]) .uk-select:not([multiple]):not([size]),.uk-card-secondary.uk-card-body .uk-select:not([multiple]):not([size]),.uk-card-secondary>:not([class*=uk-card-media]) .uk-select:not([multiple]):not([size]),.uk-light .uk-select:not([multiple]):not([size]),.uk-offcanvas-bar .uk-select:not([multiple]):not([size]),.uk-overlay-primary .uk-select:not([multiple]):not([size]),.uk-section-primary:not(.uk-preserve-color) .uk-select:not([multiple]):not([size]),.uk-section-secondary:not(.uk-preserve-color) .uk-select:not([multiple]):not([size]),.uk-tile-primary:not(.uk-preserve-color) .uk-select:not([multiple]):not([size]),.uk-tile-secondary:not(.uk-preserve-color) .uk-select:not([multiple]):not([size]){background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2224%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22rgba%28255,%20255,%20255,%200.7%29%22%20points%3D%2212%201%209%206%2015%206%22%20%2F%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22rgba%28255,%20255,%20255,%200.7%29%22%20points%3D%2212%2013%209%208%2015%208%22%20%2F%3E%0A%3C%2Fsvg%3E%0A\")}.uk-card-primary.uk-card-body .uk-input[list]:focus,.uk-card-primary.uk-card-body .uk-input[list]:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-input[list]:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-input[list]:hover,.uk-card-secondary.uk-card-body .uk-input[list]:focus,.uk-card-secondary.uk-card-body .uk-input[list]:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-input[list]:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-input[list]:hover,.uk-light .uk-input[list]:focus,.uk-light .uk-input[list]:hover,.uk-offcanvas-bar .uk-input[list]:focus,.uk-offcanvas-bar .uk-input[list]:hover,.uk-overlay-primary .uk-input[list]:focus,.uk-overlay-primary .uk-input[list]:hover,.uk-section-primary:not(.uk-preserve-color) .uk-input[list]:focus,.uk-section-primary:not(.uk-preserve-color) .uk-input[list]:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-input[list]:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-input[list]:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-input[list]:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-input[list]:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-input[list]:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-input[list]:hover{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2224%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22rgba%28255,%20255,%20255,%200.7%29%22%20points%3D%2212%2012%208%206%2016%206%22%20%2F%3E%0A%3C%2Fsvg%3E%0A\")}.uk-card-primary.uk-card-body .uk-checkbox,.uk-card-primary.uk-card-body .uk-radio,.uk-card-primary>:not([class*=uk-card-media]) .uk-checkbox,.uk-card-primary>:not([class*=uk-card-media]) .uk-radio,.uk-card-secondary.uk-card-body .uk-checkbox,.uk-card-secondary.uk-card-body .uk-radio,.uk-card-secondary>:not([class*=uk-card-media]) .uk-checkbox,.uk-card-secondary>:not([class*=uk-card-media]) .uk-radio,.uk-light .uk-checkbox,.uk-light .uk-radio,.uk-offcanvas-bar .uk-checkbox,.uk-offcanvas-bar .uk-radio,.uk-overlay-primary .uk-checkbox,.uk-overlay-primary .uk-radio,.uk-section-primary:not(.uk-preserve-color) .uk-checkbox,.uk-section-primary:not(.uk-preserve-color) .uk-radio,.uk-section-secondary:not(.uk-preserve-color) .uk-checkbox,.uk-section-secondary:not(.uk-preserve-color) .uk-radio,.uk-tile-primary:not(.uk-preserve-color) .uk-checkbox,.uk-tile-primary:not(.uk-preserve-color) .uk-radio,.uk-tile-secondary:not(.uk-preserve-color) .uk-checkbox,.uk-tile-secondary:not(.uk-preserve-color) .uk-radio{background-color:hsla(0,0%,95%,.1);border-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-checkbox:focus,.uk-card-primary.uk-card-body .uk-radio:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-checkbox:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-radio:focus,.uk-card-secondary.uk-card-body .uk-checkbox:focus,.uk-card-secondary.uk-card-body .uk-radio:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-checkbox:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-radio:focus,.uk-light .uk-checkbox:focus,.uk-light .uk-radio:focus,.uk-offcanvas-bar .uk-checkbox:focus,.uk-offcanvas-bar .uk-radio:focus,.uk-overlay-primary .uk-checkbox:focus,.uk-overlay-primary .uk-radio:focus,.uk-section-primary:not(.uk-preserve-color) .uk-checkbox:focus,.uk-section-primary:not(.uk-preserve-color) .uk-radio:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-checkbox:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-radio:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-checkbox:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-radio:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-checkbox:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-radio:focus{border-color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-checkbox:checked,.uk-card-primary.uk-card-body .uk-checkbox:indeterminate,.uk-card-primary.uk-card-body .uk-radio:checked,.uk-card-primary>:not([class*=uk-card-media]) .uk-checkbox:checked,.uk-card-primary>:not([class*=uk-card-media]) .uk-checkbox:indeterminate,.uk-card-primary>:not([class*=uk-card-media]) .uk-radio:checked,.uk-card-secondary.uk-card-body .uk-checkbox:checked,.uk-card-secondary.uk-card-body .uk-checkbox:indeterminate,.uk-card-secondary.uk-card-body .uk-radio:checked,.uk-card-secondary>:not([class*=uk-card-media]) .uk-checkbox:checked,.uk-card-secondary>:not([class*=uk-card-media]) .uk-checkbox:indeterminate,.uk-card-secondary>:not([class*=uk-card-media]) .uk-radio:checked,.uk-light .uk-checkbox:checked,.uk-light .uk-checkbox:indeterminate,.uk-light .uk-radio:checked,.uk-offcanvas-bar .uk-checkbox:checked,.uk-offcanvas-bar .uk-checkbox:indeterminate,.uk-offcanvas-bar .uk-radio:checked,.uk-overlay-primary .uk-checkbox:checked,.uk-overlay-primary .uk-checkbox:indeterminate,.uk-overlay-primary .uk-radio:checked,.uk-section-primary:not(.uk-preserve-color) .uk-checkbox:checked,.uk-section-primary:not(.uk-preserve-color) .uk-checkbox:indeterminate,.uk-section-primary:not(.uk-preserve-color) .uk-radio:checked,.uk-section-secondary:not(.uk-preserve-color) .uk-checkbox:checked,.uk-section-secondary:not(.uk-preserve-color) .uk-checkbox:indeterminate,.uk-section-secondary:not(.uk-preserve-color) .uk-radio:checked,.uk-tile-primary:not(.uk-preserve-color) .uk-checkbox:checked,.uk-tile-primary:not(.uk-preserve-color) .uk-checkbox:indeterminate,.uk-tile-primary:not(.uk-preserve-color) .uk-radio:checked,.uk-tile-secondary:not(.uk-preserve-color) .uk-checkbox:checked,.uk-tile-secondary:not(.uk-preserve-color) .uk-checkbox:indeterminate,.uk-tile-secondary:not(.uk-preserve-color) .uk-radio:checked{background-color:#fff;border-color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-checkbox:checked:focus,.uk-card-primary.uk-card-body .uk-checkbox:indeterminate:focus,.uk-card-primary.uk-card-body .uk-radio:checked:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-checkbox:checked:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-checkbox:indeterminate:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-radio:checked:focus,.uk-card-secondary.uk-card-body .uk-checkbox:checked:focus,.uk-card-secondary.uk-card-body .uk-checkbox:indeterminate:focus,.uk-card-secondary.uk-card-body .uk-radio:checked:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-checkbox:checked:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-checkbox:indeterminate:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-radio:checked:focus,.uk-light .uk-checkbox:checked:focus,.uk-light .uk-checkbox:indeterminate:focus,.uk-light .uk-radio:checked:focus,.uk-offcanvas-bar .uk-checkbox:checked:focus,.uk-offcanvas-bar .uk-checkbox:indeterminate:focus,.uk-offcanvas-bar .uk-radio:checked:focus,.uk-overlay-primary .uk-checkbox:checked:focus,.uk-overlay-primary .uk-checkbox:indeterminate:focus,.uk-overlay-primary .uk-radio:checked:focus,.uk-section-primary:not(.uk-preserve-color) .uk-checkbox:checked:focus,.uk-section-primary:not(.uk-preserve-color) .uk-checkbox:indeterminate:focus,.uk-section-primary:not(.uk-preserve-color) .uk-radio:checked:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-checkbox:checked:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-checkbox:indeterminate:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-radio:checked:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-checkbox:checked:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-checkbox:indeterminate:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-radio:checked:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-checkbox:checked:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-checkbox:indeterminate:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-radio:checked:focus{background-color:#e6e6e6}.uk-card-primary.uk-card-body .uk-radio:checked,.uk-card-primary>:not([class*=uk-card-media]) .uk-radio:checked,.uk-card-secondary.uk-card-body .uk-radio:checked,.uk-card-secondary>:not([class*=uk-card-media]) .uk-radio:checked,.uk-light .uk-radio:checked,.uk-offcanvas-bar .uk-radio:checked,.uk-overlay-primary .uk-radio:checked,.uk-section-primary:not(.uk-preserve-color) .uk-radio:checked,.uk-section-secondary:not(.uk-preserve-color) .uk-radio:checked,.uk-tile-primary:not(.uk-preserve-color) .uk-radio:checked,.uk-tile-secondary:not(.uk-preserve-color) .uk-radio:checked{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22%23666%22%20cx%3D%228%22%20cy%3D%228%22%20r%3D%222%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-card-primary.uk-card-body .uk-checkbox:checked,.uk-card-primary>:not([class*=uk-card-media]) .uk-checkbox:checked,.uk-card-secondary.uk-card-body .uk-checkbox:checked,.uk-card-secondary>:not([class*=uk-card-media]) .uk-checkbox:checked,.uk-light .uk-checkbox:checked,.uk-offcanvas-bar .uk-checkbox:checked,.uk-overlay-primary .uk-checkbox:checked,.uk-section-primary:not(.uk-preserve-color) .uk-checkbox:checked,.uk-section-secondary:not(.uk-preserve-color) .uk-checkbox:checked,.uk-tile-primary:not(.uk-preserve-color) .uk-checkbox:checked,.uk-tile-secondary:not(.uk-preserve-color) .uk-checkbox:checked{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2211%22%20viewBox%3D%220%200%2014%2011%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23666%22%20points%3D%2212%201%205%207.5%202%205%201%205.5%205%2010%2013%201.5%22%20%2F%3E%0A%3C%2Fsvg%3E%0A\")}.uk-card-primary.uk-card-body .uk-checkbox:indeterminate,.uk-card-primary>:not([class*=uk-card-media]) .uk-checkbox:indeterminate,.uk-card-secondary.uk-card-body .uk-checkbox:indeterminate,.uk-card-secondary>:not([class*=uk-card-media]) .uk-checkbox:indeterminate,.uk-light .uk-checkbox:indeterminate,.uk-offcanvas-bar .uk-checkbox:indeterminate,.uk-overlay-primary .uk-checkbox:indeterminate,.uk-section-primary:not(.uk-preserve-color) .uk-checkbox:indeterminate,.uk-section-secondary:not(.uk-preserve-color) .uk-checkbox:indeterminate,.uk-tile-primary:not(.uk-preserve-color) .uk-checkbox:indeterminate,.uk-tile-secondary:not(.uk-preserve-color) .uk-checkbox:indeterminate{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Crect%20fill%3D%22%23666%22%20x%3D%223%22%20y%3D%228%22%20width%3D%2210%22%20height%3D%221%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-card-primary.uk-card-body .uk-form-label,.uk-card-primary>:not([class*=uk-card-media]) .uk-form-label,.uk-card-secondary.uk-card-body .uk-form-label,.uk-card-secondary>:not([class*=uk-card-media]) .uk-form-label,.uk-light .uk-form-label,.uk-offcanvas-bar .uk-form-label,.uk-overlay-primary .uk-form-label,.uk-section-primary:not(.uk-preserve-color) .uk-form-label,.uk-section-secondary:not(.uk-preserve-color) .uk-form-label,.uk-tile-primary:not(.uk-preserve-color) .uk-form-label,.uk-tile-secondary:not(.uk-preserve-color) .uk-form-label{color:#fff}.uk-card-primary.uk-card-body .uk-form-icon,.uk-card-primary>:not([class*=uk-card-media]) .uk-form-icon,.uk-card-secondary.uk-card-body .uk-form-icon,.uk-card-secondary>:not([class*=uk-card-media]) .uk-form-icon,.uk-light .uk-form-icon,.uk-offcanvas-bar .uk-form-icon,.uk-overlay-primary .uk-form-icon,.uk-section-primary:not(.uk-preserve-color) .uk-form-icon,.uk-section-secondary:not(.uk-preserve-color) .uk-form-icon,.uk-tile-primary:not(.uk-preserve-color) .uk-form-icon,.uk-tile-secondary:not(.uk-preserve-color) .uk-form-icon{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-form-icon:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-form-icon:hover,.uk-card-secondary.uk-card-body .uk-form-icon:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-form-icon:hover,.uk-light .uk-form-icon:hover,.uk-offcanvas-bar .uk-form-icon:hover,.uk-overlay-primary .uk-form-icon:hover,.uk-section-primary:not(.uk-preserve-color) .uk-form-icon:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-form-icon:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-form-icon:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-form-icon:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-button-default,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-default,.uk-card-secondary.uk-card-body .uk-button-default,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-default,.uk-light .uk-button-default,.uk-offcanvas-bar .uk-button-default,.uk-overlay-primary .uk-button-default,.uk-section-primary:not(.uk-preserve-color) .uk-button-default,.uk-section-secondary:not(.uk-preserve-color) .uk-button-default,.uk-tile-primary:not(.uk-preserve-color) .uk-button-default,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-default{background-color:transparent;color:#fff;border-color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-button-default.uk-active,.uk-card-primary.uk-card-body .uk-button-default:active,.uk-card-primary.uk-card-body .uk-button-default:focus,.uk-card-primary.uk-card-body .uk-button-default:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-default.uk-active,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-default:active,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-default:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-default:hover,.uk-card-secondary.uk-card-body .uk-button-default.uk-active,.uk-card-secondary.uk-card-body .uk-button-default:active,.uk-card-secondary.uk-card-body .uk-button-default:focus,.uk-card-secondary.uk-card-body .uk-button-default:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-default.uk-active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-default:active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-default:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-default:hover,.uk-light .uk-button-default.uk-active,.uk-light .uk-button-default:active,.uk-light .uk-button-default:focus,.uk-light .uk-button-default:hover,.uk-offcanvas-bar .uk-button-default.uk-active,.uk-offcanvas-bar .uk-button-default:active,.uk-offcanvas-bar .uk-button-default:focus,.uk-offcanvas-bar .uk-button-default:hover,.uk-overlay-primary .uk-button-default.uk-active,.uk-overlay-primary .uk-button-default:active,.uk-overlay-primary .uk-button-default:focus,.uk-overlay-primary .uk-button-default:hover,.uk-section-primary:not(.uk-preserve-color) .uk-button-default.uk-active,.uk-section-primary:not(.uk-preserve-color) .uk-button-default:active,.uk-section-primary:not(.uk-preserve-color) .uk-button-default:focus,.uk-section-primary:not(.uk-preserve-color) .uk-button-default:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-button-default.uk-active,.uk-section-secondary:not(.uk-preserve-color) .uk-button-default:active,.uk-section-secondary:not(.uk-preserve-color) .uk-button-default:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-button-default:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-button-default.uk-active,.uk-tile-primary:not(.uk-preserve-color) .uk-button-default:active,.uk-tile-primary:not(.uk-preserve-color) .uk-button-default:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-button-default:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-default.uk-active,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-default:active,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-default:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-default:hover{background-color:transparent;color:#fff;border-color:#fff}.uk-card-primary.uk-card-body .uk-button-primary,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-primary,.uk-card-secondary.uk-card-body .uk-button-primary,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-primary,.uk-light .uk-button-primary,.uk-offcanvas-bar .uk-button-primary,.uk-overlay-primary .uk-button-primary,.uk-section-primary:not(.uk-preserve-color) .uk-button-primary,.uk-section-secondary:not(.uk-preserve-color) .uk-button-primary,.uk-tile-primary:not(.uk-preserve-color) .uk-button-primary,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-primary{background-color:#fff;color:#666}.uk-card-primary.uk-card-body .uk-button-primary:focus,.uk-card-primary.uk-card-body .uk-button-primary:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-primary:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-primary:hover,.uk-card-secondary.uk-card-body .uk-button-primary:focus,.uk-card-secondary.uk-card-body .uk-button-primary:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-primary:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-primary:hover,.uk-light .uk-button-primary:focus,.uk-light .uk-button-primary:hover,.uk-offcanvas-bar .uk-button-primary:focus,.uk-offcanvas-bar .uk-button-primary:hover,.uk-overlay-primary .uk-button-primary:focus,.uk-overlay-primary .uk-button-primary:hover,.uk-section-primary:not(.uk-preserve-color) .uk-button-primary:focus,.uk-section-primary:not(.uk-preserve-color) .uk-button-primary:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-button-primary:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-button-primary:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-button-primary:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-button-primary:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-primary:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-primary:hover{background-color:#f2f2f2;color:#666}.uk-card-primary.uk-card-body .uk-button-primary.uk-active,.uk-card-primary.uk-card-body .uk-button-primary:active,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-primary.uk-active,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-primary:active,.uk-card-secondary.uk-card-body .uk-button-primary.uk-active,.uk-card-secondary.uk-card-body .uk-button-primary:active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-primary.uk-active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-primary:active,.uk-light .uk-button-primary.uk-active,.uk-light .uk-button-primary:active,.uk-offcanvas-bar .uk-button-primary.uk-active,.uk-offcanvas-bar .uk-button-primary:active,.uk-overlay-primary .uk-button-primary.uk-active,.uk-overlay-primary .uk-button-primary:active,.uk-section-primary:not(.uk-preserve-color) .uk-button-primary.uk-active,.uk-section-primary:not(.uk-preserve-color) .uk-button-primary:active,.uk-section-secondary:not(.uk-preserve-color) .uk-button-primary.uk-active,.uk-section-secondary:not(.uk-preserve-color) .uk-button-primary:active,.uk-tile-primary:not(.uk-preserve-color) .uk-button-primary.uk-active,.uk-tile-primary:not(.uk-preserve-color) .uk-button-primary:active,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-primary.uk-active,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-primary:active{background-color:#e6e6e6;color:#666}.uk-card-primary.uk-card-body .uk-button-secondary,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-secondary,.uk-card-secondary.uk-card-body .uk-button-secondary,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-secondary,.uk-light .uk-button-secondary,.uk-offcanvas-bar .uk-button-secondary,.uk-overlay-primary .uk-button-secondary,.uk-section-primary:not(.uk-preserve-color) .uk-button-secondary,.uk-section-secondary:not(.uk-preserve-color) .uk-button-secondary,.uk-tile-primary:not(.uk-preserve-color) .uk-button-secondary,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-secondary{background-color:#fff;color:#666}.uk-card-primary.uk-card-body .uk-button-secondary:focus,.uk-card-primary.uk-card-body .uk-button-secondary:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-secondary:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-secondary:hover,.uk-card-secondary.uk-card-body .uk-button-secondary:focus,.uk-card-secondary.uk-card-body .uk-button-secondary:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-secondary:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-secondary:hover,.uk-light .uk-button-secondary:focus,.uk-light .uk-button-secondary:hover,.uk-offcanvas-bar .uk-button-secondary:focus,.uk-offcanvas-bar .uk-button-secondary:hover,.uk-overlay-primary .uk-button-secondary:focus,.uk-overlay-primary .uk-button-secondary:hover,.uk-section-primary:not(.uk-preserve-color) .uk-button-secondary:focus,.uk-section-primary:not(.uk-preserve-color) .uk-button-secondary:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-button-secondary:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-button-secondary:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-button-secondary:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-button-secondary:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-secondary:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-secondary:hover{background-color:#f2f2f2;color:#666}.uk-card-primary.uk-card-body .uk-button-secondary.uk-active,.uk-card-primary.uk-card-body .uk-button-secondary:active,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-secondary.uk-active,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-secondary:active,.uk-card-secondary.uk-card-body .uk-button-secondary.uk-active,.uk-card-secondary.uk-card-body .uk-button-secondary:active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-secondary.uk-active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-secondary:active,.uk-light .uk-button-secondary.uk-active,.uk-light .uk-button-secondary:active,.uk-offcanvas-bar .uk-button-secondary.uk-active,.uk-offcanvas-bar .uk-button-secondary:active,.uk-overlay-primary .uk-button-secondary.uk-active,.uk-overlay-primary .uk-button-secondary:active,.uk-section-primary:not(.uk-preserve-color) .uk-button-secondary.uk-active,.uk-section-primary:not(.uk-preserve-color) .uk-button-secondary:active,.uk-section-secondary:not(.uk-preserve-color) .uk-button-secondary.uk-active,.uk-section-secondary:not(.uk-preserve-color) .uk-button-secondary:active,.uk-tile-primary:not(.uk-preserve-color) .uk-button-secondary.uk-active,.uk-tile-primary:not(.uk-preserve-color) .uk-button-secondary:active,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-secondary.uk-active,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-secondary:active{background-color:#e6e6e6;color:#666}.uk-card-primary.uk-card-body .uk-button-text,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-text,.uk-card-secondary.uk-card-body .uk-button-text,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-text,.uk-light .uk-button-text,.uk-offcanvas-bar .uk-button-text,.uk-overlay-primary .uk-button-text,.uk-section-primary:not(.uk-preserve-color) .uk-button-text,.uk-section-secondary:not(.uk-preserve-color) .uk-button-text,.uk-tile-primary:not(.uk-preserve-color) .uk-button-text,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-text{color:#fff}.uk-card-primary.uk-card-body .uk-button-text:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-text:before,.uk-card-secondary.uk-card-body .uk-button-text:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-text:before,.uk-light .uk-button-text:before,.uk-offcanvas-bar .uk-button-text:before,.uk-overlay-primary .uk-button-text:before,.uk-section-primary:not(.uk-preserve-color) .uk-button-text:before,.uk-section-secondary:not(.uk-preserve-color) .uk-button-text:before,.uk-tile-primary:not(.uk-preserve-color) .uk-button-text:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-text:before{border-bottom-color:#fff}.uk-card-primary.uk-card-body .uk-button-text:focus,.uk-card-primary.uk-card-body .uk-button-text:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-text:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-text:hover,.uk-card-secondary.uk-card-body .uk-button-text:focus,.uk-card-secondary.uk-card-body .uk-button-text:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-text:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-text:hover,.uk-light .uk-button-text:focus,.uk-light .uk-button-text:hover,.uk-offcanvas-bar .uk-button-text:focus,.uk-offcanvas-bar .uk-button-text:hover,.uk-overlay-primary .uk-button-text:focus,.uk-overlay-primary .uk-button-text:hover,.uk-section-primary:not(.uk-preserve-color) .uk-button-text:focus,.uk-section-primary:not(.uk-preserve-color) .uk-button-text:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-button-text:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-button-text:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-button-text:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-button-text:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-text:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-text:hover{color:#fff}.uk-card-primary.uk-card-body .uk-button-link,.uk-card-primary.uk-card-body .uk-button-text:disabled,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-link,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-text:disabled,.uk-card-secondary.uk-card-body .uk-button-link,.uk-card-secondary.uk-card-body .uk-button-text:disabled,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-link,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-text:disabled,.uk-light .uk-button-link,.uk-light .uk-button-text:disabled,.uk-offcanvas-bar .uk-button-link,.uk-offcanvas-bar .uk-button-text:disabled,.uk-overlay-primary .uk-button-link,.uk-overlay-primary .uk-button-text:disabled,.uk-section-primary:not(.uk-preserve-color) .uk-button-link,.uk-section-primary:not(.uk-preserve-color) .uk-button-text:disabled,.uk-section-secondary:not(.uk-preserve-color) .uk-button-link,.uk-section-secondary:not(.uk-preserve-color) .uk-button-text:disabled,.uk-tile-primary:not(.uk-preserve-color) .uk-button-link,.uk-tile-primary:not(.uk-preserve-color) .uk-button-text:disabled,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-link,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-text:disabled{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-button-link:focus,.uk-card-primary.uk-card-body .uk-button-link:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-link:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-button-link:hover,.uk-card-secondary.uk-card-body .uk-button-link:focus,.uk-card-secondary.uk-card-body .uk-button-link:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-link:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-button-link:hover,.uk-light .uk-button-link:focus,.uk-light .uk-button-link:hover,.uk-offcanvas-bar .uk-button-link:focus,.uk-offcanvas-bar .uk-button-link:hover,.uk-overlay-primary .uk-button-link:focus,.uk-overlay-primary .uk-button-link:hover,.uk-section-primary:not(.uk-preserve-color) .uk-button-link:focus,.uk-section-primary:not(.uk-preserve-color) .uk-button-link:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-button-link:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-button-link:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-button-link:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-button-link:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-link:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-button-link:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body.uk-card-badge,.uk-card-primary>:not([class*=uk-card-media]).uk-card-badge,.uk-card-secondary.uk-card-body.uk-card-badge,.uk-card-secondary>:not([class*=uk-card-media]).uk-card-badge,.uk-light.uk-card-badge,.uk-offcanvas-bar.uk-card-badge,.uk-overlay-primary.uk-card-badge,.uk-section-primary:not(.uk-preserve-color).uk-card-badge,.uk-section-secondary:not(.uk-preserve-color).uk-card-badge,.uk-tile-primary:not(.uk-preserve-color).uk-card-badge,.uk-tile-secondary:not(.uk-preserve-color).uk-card-badge{background-color:#fff;color:#666}.uk-card-primary.uk-card-body .uk-close,.uk-card-primary>:not([class*=uk-card-media]) .uk-close,.uk-card-secondary.uk-card-body .uk-close,.uk-card-secondary>:not([class*=uk-card-media]) .uk-close,.uk-light .uk-close,.uk-offcanvas-bar .uk-close,.uk-overlay-primary .uk-close,.uk-section-primary:not(.uk-preserve-color) .uk-close,.uk-section-secondary:not(.uk-preserve-color) .uk-close,.uk-tile-primary:not(.uk-preserve-color) .uk-close,.uk-tile-secondary:not(.uk-preserve-color) .uk-close{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-close:focus,.uk-card-primary.uk-card-body .uk-close:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-close:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-close:hover,.uk-card-secondary.uk-card-body .uk-close:focus,.uk-card-secondary.uk-card-body .uk-close:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-close:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-close:hover,.uk-light .uk-close:focus,.uk-light .uk-close:hover,.uk-offcanvas-bar .uk-close:focus,.uk-offcanvas-bar .uk-close:hover,.uk-overlay-primary .uk-close:focus,.uk-overlay-primary .uk-close:hover,.uk-section-primary:not(.uk-preserve-color) .uk-close:focus,.uk-section-primary:not(.uk-preserve-color) .uk-close:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-close:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-close:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-close:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-close:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-close:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-close:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-totop,.uk-card-primary>:not([class*=uk-card-media]) .uk-totop,.uk-card-secondary.uk-card-body .uk-totop,.uk-card-secondary>:not([class*=uk-card-media]) .uk-totop,.uk-light .uk-totop,.uk-offcanvas-bar .uk-totop,.uk-overlay-primary .uk-totop,.uk-section-primary:not(.uk-preserve-color) .uk-totop,.uk-section-secondary:not(.uk-preserve-color) .uk-totop,.uk-tile-primary:not(.uk-preserve-color) .uk-totop,.uk-tile-secondary:not(.uk-preserve-color) .uk-totop{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-totop:focus,.uk-card-primary.uk-card-body .uk-totop:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-totop:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-totop:hover,.uk-card-secondary.uk-card-body .uk-totop:focus,.uk-card-secondary.uk-card-body .uk-totop:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-totop:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-totop:hover,.uk-light .uk-totop:focus,.uk-light .uk-totop:hover,.uk-offcanvas-bar .uk-totop:focus,.uk-offcanvas-bar .uk-totop:hover,.uk-overlay-primary .uk-totop:focus,.uk-overlay-primary .uk-totop:hover,.uk-section-primary:not(.uk-preserve-color) .uk-totop:focus,.uk-section-primary:not(.uk-preserve-color) .uk-totop:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-totop:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-totop:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-totop:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-totop:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-totop:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-totop:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-totop:active,.uk-card-primary>:not([class*=uk-card-media]) .uk-totop:active,.uk-card-secondary.uk-card-body .uk-totop:active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-totop:active,.uk-light .uk-totop:active,.uk-offcanvas-bar .uk-totop:active,.uk-overlay-primary .uk-totop:active,.uk-section-primary:not(.uk-preserve-color) .uk-totop:active,.uk-section-secondary:not(.uk-preserve-color) .uk-totop:active,.uk-tile-primary:not(.uk-preserve-color) .uk-totop:active,.uk-tile-secondary:not(.uk-preserve-color) .uk-totop:active{color:#fff}.uk-card-primary.uk-card-body .uk-marker,.uk-card-primary>:not([class*=uk-card-media]) .uk-marker,.uk-card-secondary.uk-card-body .uk-marker,.uk-card-secondary>:not([class*=uk-card-media]) .uk-marker,.uk-light .uk-marker,.uk-offcanvas-bar .uk-marker,.uk-overlay-primary .uk-marker,.uk-section-primary:not(.uk-preserve-color) .uk-marker,.uk-section-secondary:not(.uk-preserve-color) .uk-marker,.uk-tile-primary:not(.uk-preserve-color) .uk-marker,.uk-tile-secondary:not(.uk-preserve-color) .uk-marker{background:#f8f8f8;color:#666}.uk-card-primary.uk-card-body .uk-marker:focus,.uk-card-primary.uk-card-body .uk-marker:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-marker:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-marker:hover,.uk-card-secondary.uk-card-body .uk-marker:focus,.uk-card-secondary.uk-card-body .uk-marker:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-marker:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-marker:hover,.uk-light .uk-marker:focus,.uk-light .uk-marker:hover,.uk-offcanvas-bar .uk-marker:focus,.uk-offcanvas-bar .uk-marker:hover,.uk-overlay-primary .uk-marker:focus,.uk-overlay-primary .uk-marker:hover,.uk-section-primary:not(.uk-preserve-color) .uk-marker:focus,.uk-section-primary:not(.uk-preserve-color) .uk-marker:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-marker:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-marker:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-marker:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-marker:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-marker:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-marker:hover{color:#666}.uk-card-primary.uk-card-body .uk-badge,.uk-card-primary>:not([class*=uk-card-media]) .uk-badge,.uk-card-secondary.uk-card-body .uk-badge,.uk-card-secondary>:not([class*=uk-card-media]) .uk-badge,.uk-light .uk-badge,.uk-offcanvas-bar .uk-badge,.uk-overlay-primary .uk-badge,.uk-section-primary:not(.uk-preserve-color) .uk-badge,.uk-section-secondary:not(.uk-preserve-color) .uk-badge,.uk-tile-primary:not(.uk-preserve-color) .uk-badge,.uk-tile-secondary:not(.uk-preserve-color) .uk-badge{background-color:#fff;color:#666}.uk-card-primary.uk-card-body .uk-badge:focus,.uk-card-primary.uk-card-body .uk-badge:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-badge:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-badge:hover,.uk-card-secondary.uk-card-body .uk-badge:focus,.uk-card-secondary.uk-card-body .uk-badge:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-badge:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-badge:hover,.uk-light .uk-badge:focus,.uk-light .uk-badge:hover,.uk-offcanvas-bar .uk-badge:focus,.uk-offcanvas-bar .uk-badge:hover,.uk-overlay-primary .uk-badge:focus,.uk-overlay-primary .uk-badge:hover,.uk-section-primary:not(.uk-preserve-color) .uk-badge:focus,.uk-section-primary:not(.uk-preserve-color) .uk-badge:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-badge:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-badge:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-badge:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-badge:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-badge:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-badge:hover{color:#666}.uk-card-primary.uk-card-body .uk-label,.uk-card-primary>:not([class*=uk-card-media]) .uk-label,.uk-card-secondary.uk-card-body .uk-label,.uk-card-secondary>:not([class*=uk-card-media]) .uk-label,.uk-light .uk-label,.uk-offcanvas-bar .uk-label,.uk-overlay-primary .uk-label,.uk-section-primary:not(.uk-preserve-color) .uk-label,.uk-section-secondary:not(.uk-preserve-color) .uk-label,.uk-tile-primary:not(.uk-preserve-color) .uk-label,.uk-tile-secondary:not(.uk-preserve-color) .uk-label{background-color:#fff;color:#666}.uk-card-primary.uk-card-body .uk-article-meta,.uk-card-primary>:not([class*=uk-card-media]) .uk-article-meta,.uk-card-secondary.uk-card-body .uk-article-meta,.uk-card-secondary>:not([class*=uk-card-media]) .uk-article-meta,.uk-light .uk-article-meta,.uk-offcanvas-bar .uk-article-meta,.uk-overlay-primary .uk-article-meta,.uk-section-primary:not(.uk-preserve-color) .uk-article-meta,.uk-section-secondary:not(.uk-preserve-color) .uk-article-meta,.uk-tile-primary:not(.uk-preserve-color) .uk-article-meta,.uk-tile-secondary:not(.uk-preserve-color) .uk-article-meta{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-search-input,.uk-card-primary>:not([class*=uk-card-media]) .uk-search-input,.uk-card-secondary.uk-card-body .uk-search-input,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search-input,.uk-light .uk-search-input,.uk-offcanvas-bar .uk-search-input,.uk-overlay-primary .uk-search-input,.uk-section-primary:not(.uk-preserve-color) .uk-search-input,.uk-section-secondary:not(.uk-preserve-color) .uk-search-input,.uk-tile-primary:not(.uk-preserve-color) .uk-search-input,.uk-tile-secondary:not(.uk-preserve-color) .uk-search-input{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-search-input:-ms-input-placeholder,.uk-card-primary>:not([class*=uk-card-media]) .uk-search-input:-ms-input-placeholder,.uk-card-secondary.uk-card-body .uk-search-input:-ms-input-placeholder,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search-input:-ms-input-placeholder,.uk-light .uk-search-input:-ms-input-placeholder,.uk-offcanvas-bar .uk-search-input:-ms-input-placeholder,.uk-overlay-primary .uk-search-input:-ms-input-placeholder,.uk-section-primary:not(.uk-preserve-color) .uk-search-input:-ms-input-placeholder,.uk-section-secondary:not(.uk-preserve-color) .uk-search-input:-ms-input-placeholder,.uk-tile-primary:not(.uk-preserve-color) .uk-search-input:-ms-input-placeholder,.uk-tile-secondary:not(.uk-preserve-color) .uk-search-input:-ms-input-placeholder{color:hsla(0,0%,100%,.5)!important}.uk-card-primary.uk-card-body .uk-search-input::placeholder,.uk-card-primary>:not([class*=uk-card-media]) .uk-search-input::placeholder,.uk-card-secondary.uk-card-body .uk-search-input::placeholder,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search-input::placeholder,.uk-light .uk-search-input::placeholder,.uk-offcanvas-bar .uk-search-input::placeholder,.uk-overlay-primary .uk-search-input::placeholder,.uk-section-primary:not(.uk-preserve-color) .uk-search-input::placeholder,.uk-section-secondary:not(.uk-preserve-color) .uk-search-input::placeholder,.uk-tile-primary:not(.uk-preserve-color) .uk-search-input::placeholder,.uk-tile-secondary:not(.uk-preserve-color) .uk-search-input::placeholder{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-search .uk-search-icon,.uk-card-primary.uk-card-body .uk-search .uk-search-icon:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-search .uk-search-icon,.uk-card-primary>:not([class*=uk-card-media]) .uk-search .uk-search-icon:hover,.uk-card-secondary.uk-card-body .uk-search .uk-search-icon,.uk-card-secondary.uk-card-body .uk-search .uk-search-icon:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search .uk-search-icon,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search .uk-search-icon:hover,.uk-light .uk-search .uk-search-icon,.uk-light .uk-search .uk-search-icon:hover,.uk-offcanvas-bar .uk-search .uk-search-icon,.uk-offcanvas-bar .uk-search .uk-search-icon:hover,.uk-overlay-primary .uk-search .uk-search-icon,.uk-overlay-primary .uk-search .uk-search-icon:hover,.uk-section-primary:not(.uk-preserve-color) .uk-search .uk-search-icon,.uk-section-primary:not(.uk-preserve-color) .uk-search .uk-search-icon:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-search .uk-search-icon,.uk-section-secondary:not(.uk-preserve-color) .uk-search .uk-search-icon:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-search .uk-search-icon,.uk-tile-primary:not(.uk-preserve-color) .uk-search .uk-search-icon:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-search .uk-search-icon,.uk-tile-secondary:not(.uk-preserve-color) .uk-search .uk-search-icon:hover{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-search-default .uk-search-input,.uk-card-primary>:not([class*=uk-card-media]) .uk-search-default .uk-search-input,.uk-card-secondary.uk-card-body .uk-search-default .uk-search-input,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search-default .uk-search-input,.uk-light .uk-search-default .uk-search-input,.uk-offcanvas-bar .uk-search-default .uk-search-input,.uk-overlay-primary .uk-search-default .uk-search-input,.uk-section-primary:not(.uk-preserve-color) .uk-search-default .uk-search-input,.uk-section-secondary:not(.uk-preserve-color) .uk-search-default .uk-search-input,.uk-tile-primary:not(.uk-preserve-color) .uk-search-default .uk-search-input,.uk-tile-secondary:not(.uk-preserve-color) .uk-search-default .uk-search-input{background-color:transparent;border-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-search-default .uk-search-input:focus,.uk-card-primary.uk-card-body .uk-search-large .uk-search-input,.uk-card-primary.uk-card-body .uk-search-navbar .uk-search-input,.uk-card-primary>:not([class*=uk-card-media]) .uk-search-default .uk-search-input:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-search-large .uk-search-input,.uk-card-primary>:not([class*=uk-card-media]) .uk-search-navbar .uk-search-input,.uk-card-secondary.uk-card-body .uk-search-default .uk-search-input:focus,.uk-card-secondary.uk-card-body .uk-search-large .uk-search-input,.uk-card-secondary.uk-card-body .uk-search-navbar .uk-search-input,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search-default .uk-search-input:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search-large .uk-search-input,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search-navbar .uk-search-input,.uk-light .uk-search-default .uk-search-input:focus,.uk-light .uk-search-large .uk-search-input,.uk-light .uk-search-navbar .uk-search-input,.uk-offcanvas-bar .uk-search-default .uk-search-input:focus,.uk-offcanvas-bar .uk-search-large .uk-search-input,.uk-offcanvas-bar .uk-search-navbar .uk-search-input,.uk-overlay-primary .uk-search-default .uk-search-input:focus,.uk-overlay-primary .uk-search-large .uk-search-input,.uk-overlay-primary .uk-search-navbar .uk-search-input,.uk-section-primary:not(.uk-preserve-color) .uk-search-default .uk-search-input:focus,.uk-section-primary:not(.uk-preserve-color) .uk-search-large .uk-search-input,.uk-section-primary:not(.uk-preserve-color) .uk-search-navbar .uk-search-input,.uk-section-secondary:not(.uk-preserve-color) .uk-search-default .uk-search-input:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-search-large .uk-search-input,.uk-section-secondary:not(.uk-preserve-color) .uk-search-navbar .uk-search-input,.uk-tile-primary:not(.uk-preserve-color) .uk-search-default .uk-search-input:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-search-large .uk-search-input,.uk-tile-primary:not(.uk-preserve-color) .uk-search-navbar .uk-search-input,.uk-tile-secondary:not(.uk-preserve-color) .uk-search-default .uk-search-input:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-search-large .uk-search-input,.uk-tile-secondary:not(.uk-preserve-color) .uk-search-navbar .uk-search-input{background-color:transparent}.uk-card-primary.uk-card-body .uk-search-toggle,.uk-card-primary>:not([class*=uk-card-media]) .uk-search-toggle,.uk-card-secondary.uk-card-body .uk-search-toggle,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search-toggle,.uk-light .uk-search-toggle,.uk-offcanvas-bar .uk-search-toggle,.uk-overlay-primary .uk-search-toggle,.uk-section-primary:not(.uk-preserve-color) .uk-search-toggle,.uk-section-secondary:not(.uk-preserve-color) .uk-search-toggle,.uk-tile-primary:not(.uk-preserve-color) .uk-search-toggle,.uk-tile-secondary:not(.uk-preserve-color) .uk-search-toggle{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-search-toggle:focus,.uk-card-primary.uk-card-body .uk-search-toggle:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-search-toggle:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-search-toggle:hover,.uk-card-secondary.uk-card-body .uk-search-toggle:focus,.uk-card-secondary.uk-card-body .uk-search-toggle:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search-toggle:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-search-toggle:hover,.uk-light .uk-search-toggle:focus,.uk-light .uk-search-toggle:hover,.uk-offcanvas-bar .uk-search-toggle:focus,.uk-offcanvas-bar .uk-search-toggle:hover,.uk-overlay-primary .uk-search-toggle:focus,.uk-overlay-primary .uk-search-toggle:hover,.uk-section-primary:not(.uk-preserve-color) .uk-search-toggle:focus,.uk-section-primary:not(.uk-preserve-color) .uk-search-toggle:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-search-toggle:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-search-toggle:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-search-toggle:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-search-toggle:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-search-toggle:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-search-toggle:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-accordion-title,.uk-card-primary>:not([class*=uk-card-media]) .uk-accordion-title,.uk-card-secondary.uk-card-body .uk-accordion-title,.uk-card-secondary>:not([class*=uk-card-media]) .uk-accordion-title,.uk-light .uk-accordion-title,.uk-offcanvas-bar .uk-accordion-title,.uk-overlay-primary .uk-accordion-title,.uk-section-primary:not(.uk-preserve-color) .uk-accordion-title,.uk-section-secondary:not(.uk-preserve-color) .uk-accordion-title,.uk-tile-primary:not(.uk-preserve-color) .uk-accordion-title,.uk-tile-secondary:not(.uk-preserve-color) .uk-accordion-title{color:#fff}.uk-card-primary.uk-card-body .uk-accordion-title:focus,.uk-card-primary.uk-card-body .uk-accordion-title:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-accordion-title:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-accordion-title:hover,.uk-card-secondary.uk-card-body .uk-accordion-title:focus,.uk-card-secondary.uk-card-body .uk-accordion-title:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-accordion-title:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-accordion-title:hover,.uk-light .uk-accordion-title:focus,.uk-light .uk-accordion-title:hover,.uk-offcanvas-bar .uk-accordion-title:focus,.uk-offcanvas-bar .uk-accordion-title:hover,.uk-overlay-primary .uk-accordion-title:focus,.uk-overlay-primary .uk-accordion-title:hover,.uk-section-primary:not(.uk-preserve-color) .uk-accordion-title:focus,.uk-section-primary:not(.uk-preserve-color) .uk-accordion-title:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-accordion-title:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-accordion-title:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-accordion-title:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-accordion-title:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-accordion-title:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-accordion-title:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-grid-divider>:not(.uk-first-column):before,.uk-card-primary>:not([class*=uk-card-media]) .uk-grid-divider>:not(.uk-first-column):before,.uk-card-secondary.uk-card-body .uk-grid-divider>:not(.uk-first-column):before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-grid-divider>:not(.uk-first-column):before,.uk-light .uk-grid-divider>:not(.uk-first-column):before,.uk-offcanvas-bar .uk-grid-divider>:not(.uk-first-column):before,.uk-overlay-primary .uk-grid-divider>:not(.uk-first-column):before,.uk-section-primary:not(.uk-preserve-color) .uk-grid-divider>:not(.uk-first-column):before,.uk-section-secondary:not(.uk-preserve-color) .uk-grid-divider>:not(.uk-first-column):before,.uk-tile-primary:not(.uk-preserve-color) .uk-grid-divider>:not(.uk-first-column):before,.uk-tile-secondary:not(.uk-preserve-color) .uk-grid-divider>:not(.uk-first-column):before{border-left-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before,.uk-card-secondary.uk-card-body .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before,.uk-light .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before,.uk-offcanvas-bar .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before,.uk-overlay-primary .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before,.uk-section-primary:not(.uk-preserve-color) .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before,.uk-section-secondary:not(.uk-preserve-color) .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before,.uk-tile-primary:not(.uk-preserve-color) .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-grid-divider.uk-grid-stack>.uk-grid-margin:before{border-top-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-nav-parent-icon>.uk-parent>a:after,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-parent-icon>.uk-parent>a:after,.uk-card-secondary.uk-card-body .uk-nav-parent-icon>.uk-parent>a:after,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-parent-icon>.uk-parent>a:after,.uk-light .uk-nav-parent-icon>.uk-parent>a:after,.uk-offcanvas-bar .uk-nav-parent-icon>.uk-parent>a:after,.uk-overlay-primary .uk-nav-parent-icon>.uk-parent>a:after,.uk-section-primary:not(.uk-preserve-color) .uk-nav-parent-icon>.uk-parent>a:after,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-parent-icon>.uk-parent>a:after,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-parent-icon>.uk-parent>a:after,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-parent-icon>.uk-parent>a:after{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2214%22%20viewBox%3D%220%200%2014%2014%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolyline%20fill%3D%22none%22%20stroke%3D%22rgba%28255,%20255,%20255,%200.7%29%22%20stroke-width%3D%221.1%22%20points%3D%2210%201%204%207%2010%2013%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-card-primary.uk-card-body .uk-nav-parent-icon>.uk-parent.uk-open>a:after,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-parent-icon>.uk-parent.uk-open>a:after,.uk-card-secondary.uk-card-body .uk-nav-parent-icon>.uk-parent.uk-open>a:after,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-parent-icon>.uk-parent.uk-open>a:after,.uk-light .uk-nav-parent-icon>.uk-parent.uk-open>a:after,.uk-offcanvas-bar .uk-nav-parent-icon>.uk-parent.uk-open>a:after,.uk-overlay-primary .uk-nav-parent-icon>.uk-parent.uk-open>a:after,.uk-section-primary:not(.uk-preserve-color) .uk-nav-parent-icon>.uk-parent.uk-open>a:after,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-parent-icon>.uk-parent.uk-open>a:after,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-parent-icon>.uk-parent.uk-open>a:after,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-parent-icon>.uk-parent.uk-open>a:after{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2214%22%20viewBox%3D%220%200%2014%2014%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolyline%20fill%3D%22none%22%20stroke%3D%22rgba%28255,%20255,%20255,%200.7%29%22%20stroke-width%3D%221.1%22%20points%3D%221%204%207%2010%2013%204%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-card-primary.uk-card-body .uk-nav-default>li>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-default>li>a,.uk-card-secondary.uk-card-body .uk-nav-default>li>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-default>li>a,.uk-light .uk-nav-default>li>a,.uk-offcanvas-bar .uk-nav-default>li>a,.uk-overlay-primary .uk-nav-default>li>a,.uk-section-primary:not(.uk-preserve-color) .uk-nav-default>li>a,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-default>li>a,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-default>li>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-default>li>a{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-nav-default>li>a:focus,.uk-card-primary.uk-card-body .uk-nav-default>li>a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-default>li>a:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-default>li>a:hover,.uk-card-secondary.uk-card-body .uk-nav-default>li>a:focus,.uk-card-secondary.uk-card-body .uk-nav-default>li>a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-default>li>a:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-default>li>a:hover,.uk-light .uk-nav-default>li>a:focus,.uk-light .uk-nav-default>li>a:hover,.uk-offcanvas-bar .uk-nav-default>li>a:focus,.uk-offcanvas-bar .uk-nav-default>li>a:hover,.uk-overlay-primary .uk-nav-default>li>a:focus,.uk-overlay-primary .uk-nav-default>li>a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-nav-default>li>a:focus,.uk-section-primary:not(.uk-preserve-color) .uk-nav-default>li>a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-default>li>a:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-default>li>a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-default>li>a:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-default>li>a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-default>li>a:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-default>li>a:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-nav-default .uk-nav-header,.uk-card-primary.uk-card-body .uk-nav-default>li.uk-active>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-header,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-default>li.uk-active>a,.uk-card-secondary.uk-card-body .uk-nav-default .uk-nav-header,.uk-card-secondary.uk-card-body .uk-nav-default>li.uk-active>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-header,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-default>li.uk-active>a,.uk-light .uk-nav-default .uk-nav-header,.uk-light .uk-nav-default>li.uk-active>a,.uk-offcanvas-bar .uk-nav-default .uk-nav-header,.uk-offcanvas-bar .uk-nav-default>li.uk-active>a,.uk-overlay-primary .uk-nav-default .uk-nav-header,.uk-overlay-primary .uk-nav-default>li.uk-active>a,.uk-section-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-header,.uk-section-primary:not(.uk-preserve-color) .uk-nav-default>li.uk-active>a,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-header,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-default>li.uk-active>a,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-header,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-default>li.uk-active>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-header,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-default>li.uk-active>a{color:#fff}.uk-card-primary.uk-card-body .uk-nav-default .uk-nav-divider,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-divider,.uk-card-secondary.uk-card-body .uk-nav-default .uk-nav-divider,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-divider,.uk-light .uk-nav-default .uk-nav-divider,.uk-offcanvas-bar .uk-nav-default .uk-nav-divider,.uk-overlay-primary .uk-nav-default .uk-nav-divider,.uk-section-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-divider,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-divider,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-divider,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-divider{border-top-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-nav-default .uk-nav-sub a,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-sub a,.uk-card-secondary.uk-card-body .uk-nav-default .uk-nav-sub a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-sub a,.uk-light .uk-nav-default .uk-nav-sub a,.uk-offcanvas-bar .uk-nav-default .uk-nav-sub a,.uk-overlay-primary .uk-nav-default .uk-nav-sub a,.uk-section-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-nav-default .uk-nav-sub a:focus,.uk-card-primary.uk-card-body .uk-nav-default .uk-nav-sub a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-sub a:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-sub a:hover,.uk-card-secondary.uk-card-body .uk-nav-default .uk-nav-sub a:focus,.uk-card-secondary.uk-card-body .uk-nav-default .uk-nav-sub a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-sub a:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-sub a:hover,.uk-light .uk-nav-default .uk-nav-sub a:focus,.uk-light .uk-nav-default .uk-nav-sub a:hover,.uk-offcanvas-bar .uk-nav-default .uk-nav-sub a:focus,.uk-offcanvas-bar .uk-nav-default .uk-nav-sub a:hover,.uk-overlay-primary .uk-nav-default .uk-nav-sub a:focus,.uk-overlay-primary .uk-nav-default .uk-nav-sub a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a:focus,.uk-section-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub a:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-nav-default .uk-nav-sub li.uk-active>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-sub li.uk-active>a,.uk-card-secondary.uk-card-body .uk-nav-default .uk-nav-sub li.uk-active>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-default .uk-nav-sub li.uk-active>a,.uk-light .uk-nav-default .uk-nav-sub li.uk-active>a,.uk-offcanvas-bar .uk-nav-default .uk-nav-sub li.uk-active>a,.uk-overlay-primary .uk-nav-default .uk-nav-sub li.uk-active>a,.uk-section-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub li.uk-active>a,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub li.uk-active>a,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub li.uk-active>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-default .uk-nav-sub li.uk-active>a{color:#fff}.uk-card-primary.uk-card-body .uk-nav-primary>li>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-primary>li>a,.uk-card-secondary.uk-card-body .uk-nav-primary>li>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-primary>li>a,.uk-light .uk-nav-primary>li>a,.uk-offcanvas-bar .uk-nav-primary>li>a,.uk-overlay-primary .uk-nav-primary>li>a,.uk-section-primary:not(.uk-preserve-color) .uk-nav-primary>li>a,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-primary>li>a,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-primary>li>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-primary>li>a{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-nav-primary>li>a:focus,.uk-card-primary.uk-card-body .uk-nav-primary>li>a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-primary>li>a:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-primary>li>a:hover,.uk-card-secondary.uk-card-body .uk-nav-primary>li>a:focus,.uk-card-secondary.uk-card-body .uk-nav-primary>li>a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-primary>li>a:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-primary>li>a:hover,.uk-light .uk-nav-primary>li>a:focus,.uk-light .uk-nav-primary>li>a:hover,.uk-offcanvas-bar .uk-nav-primary>li>a:focus,.uk-offcanvas-bar .uk-nav-primary>li>a:hover,.uk-overlay-primary .uk-nav-primary>li>a:focus,.uk-overlay-primary .uk-nav-primary>li>a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-nav-primary>li>a:focus,.uk-section-primary:not(.uk-preserve-color) .uk-nav-primary>li>a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-primary>li>a:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-primary>li>a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-primary>li>a:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-primary>li>a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-primary>li>a:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-primary>li>a:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-nav-primary .uk-nav-header,.uk-card-primary.uk-card-body .uk-nav-primary>li.uk-active>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-header,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-primary>li.uk-active>a,.uk-card-secondary.uk-card-body .uk-nav-primary .uk-nav-header,.uk-card-secondary.uk-card-body .uk-nav-primary>li.uk-active>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-header,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-primary>li.uk-active>a,.uk-light .uk-nav-primary .uk-nav-header,.uk-light .uk-nav-primary>li.uk-active>a,.uk-offcanvas-bar .uk-nav-primary .uk-nav-header,.uk-offcanvas-bar .uk-nav-primary>li.uk-active>a,.uk-overlay-primary .uk-nav-primary .uk-nav-header,.uk-overlay-primary .uk-nav-primary>li.uk-active>a,.uk-section-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-header,.uk-section-primary:not(.uk-preserve-color) .uk-nav-primary>li.uk-active>a,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-header,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-primary>li.uk-active>a,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-header,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-primary>li.uk-active>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-header,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-primary>li.uk-active>a{color:#fff}.uk-card-primary.uk-card-body .uk-nav-primary .uk-nav-divider,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-divider,.uk-card-secondary.uk-card-body .uk-nav-primary .uk-nav-divider,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-divider,.uk-light .uk-nav-primary .uk-nav-divider,.uk-offcanvas-bar .uk-nav-primary .uk-nav-divider,.uk-overlay-primary .uk-nav-primary .uk-nav-divider,.uk-section-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-divider,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-divider,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-divider,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-divider{border-top-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-nav-primary .uk-nav-sub a,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-sub a,.uk-card-secondary.uk-card-body .uk-nav-primary .uk-nav-sub a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-sub a,.uk-light .uk-nav-primary .uk-nav-sub a,.uk-offcanvas-bar .uk-nav-primary .uk-nav-sub a,.uk-overlay-primary .uk-nav-primary .uk-nav-sub a,.uk-section-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-nav-primary .uk-nav-sub a:focus,.uk-card-primary.uk-card-body .uk-nav-primary .uk-nav-sub a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-sub a:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-sub a:hover,.uk-card-secondary.uk-card-body .uk-nav-primary .uk-nav-sub a:focus,.uk-card-secondary.uk-card-body .uk-nav-primary .uk-nav-sub a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-sub a:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-sub a:hover,.uk-light .uk-nav-primary .uk-nav-sub a:focus,.uk-light .uk-nav-primary .uk-nav-sub a:hover,.uk-offcanvas-bar .uk-nav-primary .uk-nav-sub a:focus,.uk-offcanvas-bar .uk-nav-primary .uk-nav-sub a:hover,.uk-overlay-primary .uk-nav-primary .uk-nav-sub a:focus,.uk-overlay-primary .uk-nav-primary .uk-nav-sub a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a:focus,.uk-section-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub a:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-nav-primary .uk-nav-sub li.uk-active>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-sub li.uk-active>a,.uk-card-secondary.uk-card-body .uk-nav-primary .uk-nav-sub li.uk-active>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-nav-primary .uk-nav-sub li.uk-active>a,.uk-light .uk-nav-primary .uk-nav-sub li.uk-active>a,.uk-offcanvas-bar .uk-nav-primary .uk-nav-sub li.uk-active>a,.uk-overlay-primary .uk-nav-primary .uk-nav-sub li.uk-active>a,.uk-section-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub li.uk-active>a,.uk-section-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub li.uk-active>a,.uk-tile-primary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub li.uk-active>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-nav-primary .uk-nav-sub li.uk-active>a{color:#fff}.uk-card-primary.uk-card-body .uk-navbar-nav>li>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-nav>li>a,.uk-card-secondary.uk-card-body .uk-navbar-nav>li>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-nav>li>a,.uk-light .uk-navbar-nav>li>a,.uk-offcanvas-bar .uk-navbar-nav>li>a,.uk-overlay-primary .uk-navbar-nav>li>a,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-nav>li>a,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-nav>li>a,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-nav>li>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-nav>li>a{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-navbar-nav>li:hover>a,.uk-card-primary.uk-card-body .uk-navbar-nav>li>a.uk-open,.uk-card-primary.uk-card-body .uk-navbar-nav>li>a:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-nav>li:hover>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-nav>li>a.uk-open,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-nav>li>a:focus,.uk-card-secondary.uk-card-body .uk-navbar-nav>li:hover>a,.uk-card-secondary.uk-card-body .uk-navbar-nav>li>a.uk-open,.uk-card-secondary.uk-card-body .uk-navbar-nav>li>a:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-nav>li:hover>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-nav>li>a.uk-open,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-nav>li>a:focus,.uk-light .uk-navbar-nav>li:hover>a,.uk-light .uk-navbar-nav>li>a.uk-open,.uk-light .uk-navbar-nav>li>a:focus,.uk-offcanvas-bar .uk-navbar-nav>li:hover>a,.uk-offcanvas-bar .uk-navbar-nav>li>a.uk-open,.uk-offcanvas-bar .uk-navbar-nav>li>a:focus,.uk-overlay-primary .uk-navbar-nav>li:hover>a,.uk-overlay-primary .uk-navbar-nav>li>a.uk-open,.uk-overlay-primary .uk-navbar-nav>li>a:focus,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-nav>li:hover>a,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-nav>li>a.uk-open,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-nav>li>a:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-nav>li:hover>a,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-nav>li>a.uk-open,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-nav>li>a:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-nav>li:hover>a,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-nav>li>a.uk-open,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-nav>li>a:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-nav>li:hover>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-nav>li>a.uk-open,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-nav>li>a:focus{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-navbar-nav>li.uk-active>a,.uk-card-primary.uk-card-body .uk-navbar-nav>li>a:active,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-nav>li.uk-active>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-nav>li>a:active,.uk-card-secondary.uk-card-body .uk-navbar-nav>li.uk-active>a,.uk-card-secondary.uk-card-body .uk-navbar-nav>li>a:active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-nav>li.uk-active>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-nav>li>a:active,.uk-light .uk-navbar-nav>li.uk-active>a,.uk-light .uk-navbar-nav>li>a:active,.uk-offcanvas-bar .uk-navbar-nav>li.uk-active>a,.uk-offcanvas-bar .uk-navbar-nav>li>a:active,.uk-overlay-primary .uk-navbar-nav>li.uk-active>a,.uk-overlay-primary .uk-navbar-nav>li>a:active,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-nav>li.uk-active>a,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-nav>li>a:active,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-nav>li.uk-active>a,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-nav>li>a:active,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-nav>li.uk-active>a,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-nav>li>a:active,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-nav>li.uk-active>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-nav>li>a:active{color:#fff}.uk-card-primary.uk-card-body .uk-navbar-item,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-item,.uk-card-secondary.uk-card-body .uk-navbar-item,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-item,.uk-light .uk-navbar-item,.uk-offcanvas-bar .uk-navbar-item,.uk-overlay-primary .uk-navbar-item,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-item,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-item,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-item,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-item{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-navbar-toggle,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-toggle,.uk-card-secondary.uk-card-body .uk-navbar-toggle,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-toggle,.uk-light .uk-navbar-toggle,.uk-offcanvas-bar .uk-navbar-toggle,.uk-overlay-primary .uk-navbar-toggle,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-toggle,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-toggle,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-toggle,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-toggle{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-navbar-toggle.uk-open,.uk-card-primary.uk-card-body .uk-navbar-toggle:focus,.uk-card-primary.uk-card-body .uk-navbar-toggle:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-toggle.uk-open,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-toggle:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-navbar-toggle:hover,.uk-card-secondary.uk-card-body .uk-navbar-toggle.uk-open,.uk-card-secondary.uk-card-body .uk-navbar-toggle:focus,.uk-card-secondary.uk-card-body .uk-navbar-toggle:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-toggle.uk-open,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-toggle:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-navbar-toggle:hover,.uk-light .uk-navbar-toggle.uk-open,.uk-light .uk-navbar-toggle:focus,.uk-light .uk-navbar-toggle:hover,.uk-offcanvas-bar .uk-navbar-toggle.uk-open,.uk-offcanvas-bar .uk-navbar-toggle:focus,.uk-offcanvas-bar .uk-navbar-toggle:hover,.uk-overlay-primary .uk-navbar-toggle.uk-open,.uk-overlay-primary .uk-navbar-toggle:focus,.uk-overlay-primary .uk-navbar-toggle:hover,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-toggle.uk-open,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-toggle:focus,.uk-section-primary:not(.uk-preserve-color) .uk-navbar-toggle:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-toggle.uk-open,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-toggle:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-navbar-toggle:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-toggle.uk-open,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-toggle:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-navbar-toggle:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-toggle.uk-open,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-toggle:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-navbar-toggle:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-subnav>*>:first-child,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav>*>:first-child,.uk-card-secondary.uk-card-body .uk-subnav>*>:first-child,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav>*>:first-child,.uk-light .uk-subnav>*>:first-child,.uk-offcanvas-bar .uk-subnav>*>:first-child,.uk-overlay-primary .uk-subnav>*>:first-child,.uk-section-primary:not(.uk-preserve-color) .uk-subnav>*>:first-child,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav>*>:first-child,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav>*>:first-child,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav>*>:first-child{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-subnav>*>a:focus,.uk-card-primary.uk-card-body .uk-subnav>*>a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav>*>a:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav>*>a:hover,.uk-card-secondary.uk-card-body .uk-subnav>*>a:focus,.uk-card-secondary.uk-card-body .uk-subnav>*>a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav>*>a:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav>*>a:hover,.uk-light .uk-subnav>*>a:focus,.uk-light .uk-subnav>*>a:hover,.uk-offcanvas-bar .uk-subnav>*>a:focus,.uk-offcanvas-bar .uk-subnav>*>a:hover,.uk-overlay-primary .uk-subnav>*>a:focus,.uk-overlay-primary .uk-subnav>*>a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-subnav>*>a:focus,.uk-section-primary:not(.uk-preserve-color) .uk-subnav>*>a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav>*>a:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav>*>a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav>*>a:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav>*>a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav>*>a:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav>*>a:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-subnav>.uk-active>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav>.uk-active>a,.uk-card-secondary.uk-card-body .uk-subnav>.uk-active>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav>.uk-active>a,.uk-light .uk-subnav>.uk-active>a,.uk-offcanvas-bar .uk-subnav>.uk-active>a,.uk-overlay-primary .uk-subnav>.uk-active>a,.uk-section-primary:not(.uk-preserve-color) .uk-subnav>.uk-active>a,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav>.uk-active>a,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav>.uk-active>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav>.uk-active>a{color:#fff}.uk-card-primary.uk-card-body .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before,.uk-card-secondary.uk-card-body .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before,.uk-light .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before,.uk-offcanvas-bar .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before,.uk-overlay-primary .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before,.uk-section-primary:not(.uk-preserve-color) .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav-divider>:nth-child(n+2):not(.uk-first-column):before{border-left-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-subnav-pill>*>:first-child,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav-pill>*>:first-child,.uk-card-secondary.uk-card-body .uk-subnav-pill>*>:first-child,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav-pill>*>:first-child,.uk-light .uk-subnav-pill>*>:first-child,.uk-offcanvas-bar .uk-subnav-pill>*>:first-child,.uk-overlay-primary .uk-subnav-pill>*>:first-child,.uk-section-primary:not(.uk-preserve-color) .uk-subnav-pill>*>:first-child,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav-pill>*>:first-child,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav-pill>*>:first-child,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav-pill>*>:first-child{background-color:transparent;color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-subnav-pill>*>a:active,.uk-card-primary.uk-card-body .uk-subnav-pill>*>a:focus,.uk-card-primary.uk-card-body .uk-subnav-pill>*>a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav-pill>*>a:active,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav-pill>*>a:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav-pill>*>a:hover,.uk-card-secondary.uk-card-body .uk-subnav-pill>*>a:active,.uk-card-secondary.uk-card-body .uk-subnav-pill>*>a:focus,.uk-card-secondary.uk-card-body .uk-subnav-pill>*>a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav-pill>*>a:active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav-pill>*>a:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav-pill>*>a:hover,.uk-light .uk-subnav-pill>*>a:active,.uk-light .uk-subnav-pill>*>a:focus,.uk-light .uk-subnav-pill>*>a:hover,.uk-offcanvas-bar .uk-subnav-pill>*>a:active,.uk-offcanvas-bar .uk-subnav-pill>*>a:focus,.uk-offcanvas-bar .uk-subnav-pill>*>a:hover,.uk-overlay-primary .uk-subnav-pill>*>a:active,.uk-overlay-primary .uk-subnav-pill>*>a:focus,.uk-overlay-primary .uk-subnav-pill>*>a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-subnav-pill>*>a:active,.uk-section-primary:not(.uk-preserve-color) .uk-subnav-pill>*>a:focus,.uk-section-primary:not(.uk-preserve-color) .uk-subnav-pill>*>a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav-pill>*>a:active,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav-pill>*>a:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav-pill>*>a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav-pill>*>a:active,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav-pill>*>a:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav-pill>*>a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav-pill>*>a:active,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav-pill>*>a:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav-pill>*>a:hover{background-color:hsla(0,0%,100%,.1);color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-subnav-pill>.uk-active>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav-pill>.uk-active>a,.uk-card-secondary.uk-card-body .uk-subnav-pill>.uk-active>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav-pill>.uk-active>a,.uk-light .uk-subnav-pill>.uk-active>a,.uk-offcanvas-bar .uk-subnav-pill>.uk-active>a,.uk-overlay-primary .uk-subnav-pill>.uk-active>a,.uk-section-primary:not(.uk-preserve-color) .uk-subnav-pill>.uk-active>a,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav-pill>.uk-active>a,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav-pill>.uk-active>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav-pill>.uk-active>a{background-color:#fff;color:#666}.uk-card-primary.uk-card-body .uk-breadcrumb>*>*,.uk-card-primary.uk-card-body .uk-subnav>.uk-disabled>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-breadcrumb>*>*,.uk-card-primary>:not([class*=uk-card-media]) .uk-subnav>.uk-disabled>a,.uk-card-secondary.uk-card-body .uk-breadcrumb>*>*,.uk-card-secondary.uk-card-body .uk-subnav>.uk-disabled>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-breadcrumb>*>*,.uk-card-secondary>:not([class*=uk-card-media]) .uk-subnav>.uk-disabled>a,.uk-light .uk-breadcrumb>*>*,.uk-light .uk-subnav>.uk-disabled>a,.uk-offcanvas-bar .uk-breadcrumb>*>*,.uk-offcanvas-bar .uk-subnav>.uk-disabled>a,.uk-overlay-primary .uk-breadcrumb>*>*,.uk-overlay-primary .uk-subnav>.uk-disabled>a,.uk-section-primary:not(.uk-preserve-color) .uk-breadcrumb>*>*,.uk-section-primary:not(.uk-preserve-color) .uk-subnav>.uk-disabled>a,.uk-section-secondary:not(.uk-preserve-color) .uk-breadcrumb>*>*,.uk-section-secondary:not(.uk-preserve-color) .uk-subnav>.uk-disabled>a,.uk-tile-primary:not(.uk-preserve-color) .uk-breadcrumb>*>*,.uk-tile-primary:not(.uk-preserve-color) .uk-subnav>.uk-disabled>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-breadcrumb>*>*,.uk-tile-secondary:not(.uk-preserve-color) .uk-subnav>.uk-disabled>a{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-breadcrumb>*>:focus,.uk-card-primary.uk-card-body .uk-breadcrumb>*>:hover,.uk-card-primary.uk-card-body .uk-breadcrumb>:last-child>*,.uk-card-primary>:not([class*=uk-card-media]) .uk-breadcrumb>*>:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-breadcrumb>*>:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-breadcrumb>:last-child>*,.uk-card-secondary.uk-card-body .uk-breadcrumb>*>:focus,.uk-card-secondary.uk-card-body .uk-breadcrumb>*>:hover,.uk-card-secondary.uk-card-body .uk-breadcrumb>:last-child>*,.uk-card-secondary>:not([class*=uk-card-media]) .uk-breadcrumb>*>:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-breadcrumb>*>:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-breadcrumb>:last-child>*,.uk-light .uk-breadcrumb>*>:focus,.uk-light .uk-breadcrumb>*>:hover,.uk-light .uk-breadcrumb>:last-child>*,.uk-offcanvas-bar .uk-breadcrumb>*>:focus,.uk-offcanvas-bar .uk-breadcrumb>*>:hover,.uk-offcanvas-bar .uk-breadcrumb>:last-child>*,.uk-overlay-primary .uk-breadcrumb>*>:focus,.uk-overlay-primary .uk-breadcrumb>*>:hover,.uk-overlay-primary .uk-breadcrumb>:last-child>*,.uk-section-primary:not(.uk-preserve-color) .uk-breadcrumb>*>:focus,.uk-section-primary:not(.uk-preserve-color) .uk-breadcrumb>*>:hover,.uk-section-primary:not(.uk-preserve-color) .uk-breadcrumb>:last-child>*,.uk-section-secondary:not(.uk-preserve-color) .uk-breadcrumb>*>:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-breadcrumb>*>:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-breadcrumb>:last-child>*,.uk-tile-primary:not(.uk-preserve-color) .uk-breadcrumb>*>:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-breadcrumb>*>:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-breadcrumb>:last-child>*,.uk-tile-secondary:not(.uk-preserve-color) .uk-breadcrumb>*>:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-breadcrumb>*>:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-breadcrumb>:last-child>*{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-card-primary.uk-card-body .uk-pagination>*>*,.uk-card-primary>:not([class*=uk-card-media]) .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-card-primary>:not([class*=uk-card-media]) .uk-pagination>*>*,.uk-card-secondary.uk-card-body .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-card-secondary.uk-card-body .uk-pagination>*>*,.uk-card-secondary>:not([class*=uk-card-media]) .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-pagination>*>*,.uk-light .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-light .uk-pagination>*>*,.uk-offcanvas-bar .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-offcanvas-bar .uk-pagination>*>*,.uk-overlay-primary .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-overlay-primary .uk-pagination>*>*,.uk-section-primary:not(.uk-preserve-color) .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-section-primary:not(.uk-preserve-color) .uk-pagination>*>*,.uk-section-secondary:not(.uk-preserve-color) .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-section-secondary:not(.uk-preserve-color) .uk-pagination>*>*,.uk-tile-primary:not(.uk-preserve-color) .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-tile-primary:not(.uk-preserve-color) .uk-pagination>*>*,.uk-tile-secondary:not(.uk-preserve-color) .uk-breadcrumb>:nth-child(n+2):not(.uk-first-column):before,.uk-tile-secondary:not(.uk-preserve-color) .uk-pagination>*>*{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-pagination>*>:focus,.uk-card-primary.uk-card-body .uk-pagination>*>:hover,.uk-card-primary.uk-card-body .uk-pagination>.uk-active>*,.uk-card-primary>:not([class*=uk-card-media]) .uk-pagination>*>:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-pagination>*>:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-pagination>.uk-active>*,.uk-card-secondary.uk-card-body .uk-pagination>*>:focus,.uk-card-secondary.uk-card-body .uk-pagination>*>:hover,.uk-card-secondary.uk-card-body .uk-pagination>.uk-active>*,.uk-card-secondary>:not([class*=uk-card-media]) .uk-pagination>*>:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-pagination>*>:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-pagination>.uk-active>*,.uk-light .uk-pagination>*>:focus,.uk-light .uk-pagination>*>:hover,.uk-light .uk-pagination>.uk-active>*,.uk-offcanvas-bar .uk-pagination>*>:focus,.uk-offcanvas-bar .uk-pagination>*>:hover,.uk-offcanvas-bar .uk-pagination>.uk-active>*,.uk-overlay-primary .uk-pagination>*>:focus,.uk-overlay-primary .uk-pagination>*>:hover,.uk-overlay-primary .uk-pagination>.uk-active>*,.uk-section-primary:not(.uk-preserve-color) .uk-pagination>*>:focus,.uk-section-primary:not(.uk-preserve-color) .uk-pagination>*>:hover,.uk-section-primary:not(.uk-preserve-color) .uk-pagination>.uk-active>*,.uk-section-secondary:not(.uk-preserve-color) .uk-pagination>*>:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-pagination>*>:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-pagination>.uk-active>*,.uk-tile-primary:not(.uk-preserve-color) .uk-pagination>*>:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-pagination>*>:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-pagination>.uk-active>*,.uk-tile-secondary:not(.uk-preserve-color) .uk-pagination>*>:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-pagination>*>:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-pagination>.uk-active>*{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-pagination>.uk-disabled>*,.uk-card-primary>:not([class*=uk-card-media]) .uk-pagination>.uk-disabled>*,.uk-card-secondary.uk-card-body .uk-pagination>.uk-disabled>*,.uk-card-secondary>:not([class*=uk-card-media]) .uk-pagination>.uk-disabled>*,.uk-light .uk-pagination>.uk-disabled>*,.uk-offcanvas-bar .uk-pagination>.uk-disabled>*,.uk-overlay-primary .uk-pagination>.uk-disabled>*,.uk-section-primary:not(.uk-preserve-color) .uk-pagination>.uk-disabled>*,.uk-section-secondary:not(.uk-preserve-color) .uk-pagination>.uk-disabled>*,.uk-tile-primary:not(.uk-preserve-color) .uk-pagination>.uk-disabled>*,.uk-tile-secondary:not(.uk-preserve-color) .uk-pagination>.uk-disabled>*{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-tab:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-tab:before,.uk-card-secondary.uk-card-body .uk-tab:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-tab:before,.uk-light .uk-tab:before,.uk-offcanvas-bar .uk-tab:before,.uk-overlay-primary .uk-tab:before,.uk-section-primary:not(.uk-preserve-color) .uk-tab:before,.uk-section-secondary:not(.uk-preserve-color) .uk-tab:before,.uk-tile-primary:not(.uk-preserve-color) .uk-tab:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-tab:before{border-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-tab>*>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-tab>*>a,.uk-card-secondary.uk-card-body .uk-tab>*>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-tab>*>a,.uk-light .uk-tab>*>a,.uk-offcanvas-bar .uk-tab>*>a,.uk-overlay-primary .uk-tab>*>a,.uk-section-primary:not(.uk-preserve-color) .uk-tab>*>a,.uk-section-secondary:not(.uk-preserve-color) .uk-tab>*>a,.uk-tile-primary:not(.uk-preserve-color) .uk-tab>*>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-tab>*>a{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-tab>*>a:focus,.uk-card-primary.uk-card-body .uk-tab>*>a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-tab>*>a:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-tab>*>a:hover,.uk-card-secondary.uk-card-body .uk-tab>*>a:focus,.uk-card-secondary.uk-card-body .uk-tab>*>a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-tab>*>a:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-tab>*>a:hover,.uk-light .uk-tab>*>a:focus,.uk-light .uk-tab>*>a:hover,.uk-offcanvas-bar .uk-tab>*>a:focus,.uk-offcanvas-bar .uk-tab>*>a:hover,.uk-overlay-primary .uk-tab>*>a:focus,.uk-overlay-primary .uk-tab>*>a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-tab>*>a:focus,.uk-section-primary:not(.uk-preserve-color) .uk-tab>*>a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-tab>*>a:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-tab>*>a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-tab>*>a:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-tab>*>a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-tab>*>a:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-tab>*>a:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-tab>.uk-active>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-tab>.uk-active>a,.uk-card-secondary.uk-card-body .uk-tab>.uk-active>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-tab>.uk-active>a,.uk-light .uk-tab>.uk-active>a,.uk-offcanvas-bar .uk-tab>.uk-active>a,.uk-overlay-primary .uk-tab>.uk-active>a,.uk-section-primary:not(.uk-preserve-color) .uk-tab>.uk-active>a,.uk-section-secondary:not(.uk-preserve-color) .uk-tab>.uk-active>a,.uk-tile-primary:not(.uk-preserve-color) .uk-tab>.uk-active>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-tab>.uk-active>a{color:#fff;border-color:#fff}.uk-card-primary.uk-card-body .uk-tab>.uk-disabled>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-tab>.uk-disabled>a,.uk-card-secondary.uk-card-body .uk-tab>.uk-disabled>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-tab>.uk-disabled>a,.uk-light .uk-tab>.uk-disabled>a,.uk-offcanvas-bar .uk-tab>.uk-disabled>a,.uk-overlay-primary .uk-tab>.uk-disabled>a,.uk-section-primary:not(.uk-preserve-color) .uk-tab>.uk-disabled>a,.uk-section-secondary:not(.uk-preserve-color) .uk-tab>.uk-disabled>a,.uk-tile-primary:not(.uk-preserve-color) .uk-tab>.uk-disabled>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-tab>.uk-disabled>a{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-slidenav,.uk-card-primary>:not([class*=uk-card-media]) .uk-slidenav,.uk-card-secondary.uk-card-body .uk-slidenav,.uk-card-secondary>:not([class*=uk-card-media]) .uk-slidenav,.uk-light .uk-slidenav,.uk-offcanvas-bar .uk-slidenav,.uk-overlay-primary .uk-slidenav,.uk-section-primary:not(.uk-preserve-color) .uk-slidenav,.uk-section-secondary:not(.uk-preserve-color) .uk-slidenav,.uk-tile-primary:not(.uk-preserve-color) .uk-slidenav,.uk-tile-secondary:not(.uk-preserve-color) .uk-slidenav{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-slidenav:focus,.uk-card-primary.uk-card-body .uk-slidenav:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-slidenav:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-slidenav:hover,.uk-card-secondary.uk-card-body .uk-slidenav:focus,.uk-card-secondary.uk-card-body .uk-slidenav:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-slidenav:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-slidenav:hover,.uk-light .uk-slidenav:focus,.uk-light .uk-slidenav:hover,.uk-offcanvas-bar .uk-slidenav:focus,.uk-offcanvas-bar .uk-slidenav:hover,.uk-overlay-primary .uk-slidenav:focus,.uk-overlay-primary .uk-slidenav:hover,.uk-section-primary:not(.uk-preserve-color) .uk-slidenav:focus,.uk-section-primary:not(.uk-preserve-color) .uk-slidenav:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-slidenav:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-slidenav:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-slidenav:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-slidenav:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-slidenav:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-slidenav:hover{color:hsla(0,0%,100%,.95)}.uk-card-primary.uk-card-body .uk-slidenav:active,.uk-card-primary>:not([class*=uk-card-media]) .uk-slidenav:active,.uk-card-secondary.uk-card-body .uk-slidenav:active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-slidenav:active,.uk-light .uk-slidenav:active,.uk-offcanvas-bar .uk-slidenav:active,.uk-overlay-primary .uk-slidenav:active,.uk-section-primary:not(.uk-preserve-color) .uk-slidenav:active,.uk-section-secondary:not(.uk-preserve-color) .uk-slidenav:active,.uk-tile-primary:not(.uk-preserve-color) .uk-slidenav:active,.uk-tile-secondary:not(.uk-preserve-color) .uk-slidenav:active{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-dotnav>*>*,.uk-card-primary>:not([class*=uk-card-media]) .uk-dotnav>*>*,.uk-card-secondary.uk-card-body .uk-dotnav>*>*,.uk-card-secondary>:not([class*=uk-card-media]) .uk-dotnav>*>*,.uk-light .uk-dotnav>*>*,.uk-offcanvas-bar .uk-dotnav>*>*,.uk-overlay-primary .uk-dotnav>*>*,.uk-section-primary:not(.uk-preserve-color) .uk-dotnav>*>*,.uk-section-secondary:not(.uk-preserve-color) .uk-dotnav>*>*,.uk-tile-primary:not(.uk-preserve-color) .uk-dotnav>*>*,.uk-tile-secondary:not(.uk-preserve-color) .uk-dotnav>*>*{background-color:transparent;border-color:hsla(0,0%,100%,.9)}.uk-card-primary.uk-card-body .uk-dotnav>*>:focus,.uk-card-primary.uk-card-body .uk-dotnav>*>:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-dotnav>*>:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-dotnav>*>:hover,.uk-card-secondary.uk-card-body .uk-dotnav>*>:focus,.uk-card-secondary.uk-card-body .uk-dotnav>*>:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-dotnav>*>:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-dotnav>*>:hover,.uk-light .uk-dotnav>*>:focus,.uk-light .uk-dotnav>*>:hover,.uk-offcanvas-bar .uk-dotnav>*>:focus,.uk-offcanvas-bar .uk-dotnav>*>:hover,.uk-overlay-primary .uk-dotnav>*>:focus,.uk-overlay-primary .uk-dotnav>*>:hover,.uk-section-primary:not(.uk-preserve-color) .uk-dotnav>*>:focus,.uk-section-primary:not(.uk-preserve-color) .uk-dotnav>*>:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-dotnav>*>:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-dotnav>*>:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-dotnav>*>:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-dotnav>*>:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-dotnav>*>:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-dotnav>*>:hover{background-color:hsla(0,0%,100%,.9);border-color:transparent}.uk-card-primary.uk-card-body .uk-dotnav>*>:active,.uk-card-primary>:not([class*=uk-card-media]) .uk-dotnav>*>:active,.uk-card-secondary.uk-card-body .uk-dotnav>*>:active,.uk-card-secondary>:not([class*=uk-card-media]) .uk-dotnav>*>:active,.uk-light .uk-dotnav>*>:active,.uk-offcanvas-bar .uk-dotnav>*>:active,.uk-overlay-primary .uk-dotnav>*>:active,.uk-section-primary:not(.uk-preserve-color) .uk-dotnav>*>:active,.uk-section-secondary:not(.uk-preserve-color) .uk-dotnav>*>:active,.uk-tile-primary:not(.uk-preserve-color) .uk-dotnav>*>:active,.uk-tile-secondary:not(.uk-preserve-color) .uk-dotnav>*>:active{background-color:hsla(0,0%,100%,.5);border-color:transparent}.uk-card-primary.uk-card-body .uk-dotnav>.uk-active>*,.uk-card-primary>:not([class*=uk-card-media]) .uk-dotnav>.uk-active>*,.uk-card-secondary.uk-card-body .uk-dotnav>.uk-active>*,.uk-card-secondary>:not([class*=uk-card-media]) .uk-dotnav>.uk-active>*,.uk-light .uk-dotnav>.uk-active>*,.uk-offcanvas-bar .uk-dotnav>.uk-active>*,.uk-overlay-primary .uk-dotnav>.uk-active>*,.uk-section-primary:not(.uk-preserve-color) .uk-dotnav>.uk-active>*,.uk-section-secondary:not(.uk-preserve-color) .uk-dotnav>.uk-active>*,.uk-tile-primary:not(.uk-preserve-color) .uk-dotnav>.uk-active>*,.uk-tile-secondary:not(.uk-preserve-color) .uk-dotnav>.uk-active>*{background-color:hsla(0,0%,100%,.9);border-color:transparent}.uk-card-primary.uk-card-body .uk-iconnav>*>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-iconnav>*>a,.uk-card-secondary.uk-card-body .uk-iconnav>*>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-iconnav>*>a,.uk-light .uk-iconnav>*>a,.uk-offcanvas-bar .uk-iconnav>*>a,.uk-overlay-primary .uk-iconnav>*>a,.uk-section-primary:not(.uk-preserve-color) .uk-iconnav>*>a,.uk-section-secondary:not(.uk-preserve-color) .uk-iconnav>*>a,.uk-tile-primary:not(.uk-preserve-color) .uk-iconnav>*>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-iconnav>*>a{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-iconnav>*>a:focus,.uk-card-primary.uk-card-body .uk-iconnav>*>a:hover,.uk-card-primary.uk-card-body .uk-iconnav>.uk-active>a,.uk-card-primary.uk-card-body .uk-text-lead,.uk-card-primary>:not([class*=uk-card-media]) .uk-iconnav>*>a:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-iconnav>*>a:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-iconnav>.uk-active>a,.uk-card-primary>:not([class*=uk-card-media]) .uk-text-lead,.uk-card-secondary.uk-card-body .uk-iconnav>*>a:focus,.uk-card-secondary.uk-card-body .uk-iconnav>*>a:hover,.uk-card-secondary.uk-card-body .uk-iconnav>.uk-active>a,.uk-card-secondary.uk-card-body .uk-text-lead,.uk-card-secondary>:not([class*=uk-card-media]) .uk-iconnav>*>a:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-iconnav>*>a:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-iconnav>.uk-active>a,.uk-card-secondary>:not([class*=uk-card-media]) .uk-text-lead,.uk-light .uk-iconnav>*>a:focus,.uk-light .uk-iconnav>*>a:hover,.uk-light .uk-iconnav>.uk-active>a,.uk-light .uk-text-lead,.uk-offcanvas-bar .uk-iconnav>*>a:focus,.uk-offcanvas-bar .uk-iconnav>*>a:hover,.uk-offcanvas-bar .uk-iconnav>.uk-active>a,.uk-offcanvas-bar .uk-text-lead,.uk-overlay-primary .uk-iconnav>*>a:focus,.uk-overlay-primary .uk-iconnav>*>a:hover,.uk-overlay-primary .uk-iconnav>.uk-active>a,.uk-overlay-primary .uk-text-lead,.uk-section-primary:not(.uk-preserve-color) .uk-iconnav>*>a:focus,.uk-section-primary:not(.uk-preserve-color) .uk-iconnav>*>a:hover,.uk-section-primary:not(.uk-preserve-color) .uk-iconnav>.uk-active>a,.uk-section-primary:not(.uk-preserve-color) .uk-text-lead,.uk-section-secondary:not(.uk-preserve-color) .uk-iconnav>*>a:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-iconnav>*>a:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-iconnav>.uk-active>a,.uk-section-secondary:not(.uk-preserve-color) .uk-text-lead,.uk-tile-primary:not(.uk-preserve-color) .uk-iconnav>*>a:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-iconnav>*>a:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-iconnav>.uk-active>a,.uk-tile-primary:not(.uk-preserve-color) .uk-text-lead,.uk-tile-secondary:not(.uk-preserve-color) .uk-iconnav>*>a:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-iconnav>*>a:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-iconnav>.uk-active>a,.uk-tile-secondary:not(.uk-preserve-color) .uk-text-lead{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-text-meta,.uk-card-primary>:not([class*=uk-card-media]) .uk-text-meta,.uk-card-secondary.uk-card-body .uk-text-meta,.uk-card-secondary>:not([class*=uk-card-media]) .uk-text-meta,.uk-light .uk-text-meta,.uk-offcanvas-bar .uk-text-meta,.uk-overlay-primary .uk-text-meta,.uk-section-primary:not(.uk-preserve-color) .uk-text-meta,.uk-section-secondary:not(.uk-preserve-color) .uk-text-meta,.uk-tile-primary:not(.uk-preserve-color) .uk-text-meta,.uk-tile-secondary:not(.uk-preserve-color) .uk-text-meta{color:hsla(0,0%,100%,.5)}.uk-card-primary.uk-card-body .uk-text-muted,.uk-card-primary>:not([class*=uk-card-media]) .uk-text-muted,.uk-card-secondary.uk-card-body .uk-text-muted,.uk-card-secondary>:not([class*=uk-card-media]) .uk-text-muted,.uk-light .uk-text-muted,.uk-offcanvas-bar .uk-text-muted,.uk-overlay-primary .uk-text-muted,.uk-section-primary:not(.uk-preserve-color) .uk-text-muted,.uk-section-secondary:not(.uk-preserve-color) .uk-text-muted,.uk-tile-primary:not(.uk-preserve-color) .uk-text-muted,.uk-tile-secondary:not(.uk-preserve-color) .uk-text-muted{color:hsla(0,0%,100%,.5)!important}.uk-card-primary.uk-card-body .uk-text-emphasis,.uk-card-primary.uk-card-body .uk-text-primary,.uk-card-primary.uk-card-body .uk-text-secondary,.uk-card-primary>:not([class*=uk-card-media]) .uk-text-emphasis,.uk-card-primary>:not([class*=uk-card-media]) .uk-text-primary,.uk-card-primary>:not([class*=uk-card-media]) .uk-text-secondary,.uk-card-secondary.uk-card-body .uk-text-emphasis,.uk-card-secondary.uk-card-body .uk-text-primary,.uk-card-secondary.uk-card-body .uk-text-secondary,.uk-card-secondary>:not([class*=uk-card-media]) .uk-text-emphasis,.uk-card-secondary>:not([class*=uk-card-media]) .uk-text-primary,.uk-card-secondary>:not([class*=uk-card-media]) .uk-text-secondary,.uk-light .uk-text-emphasis,.uk-light .uk-text-primary,.uk-light .uk-text-secondary,.uk-offcanvas-bar .uk-text-emphasis,.uk-offcanvas-bar .uk-text-primary,.uk-offcanvas-bar .uk-text-secondary,.uk-overlay-primary .uk-text-emphasis,.uk-overlay-primary .uk-text-primary,.uk-overlay-primary .uk-text-secondary,.uk-section-primary:not(.uk-preserve-color) .uk-text-emphasis,.uk-section-primary:not(.uk-preserve-color) .uk-text-primary,.uk-section-primary:not(.uk-preserve-color) .uk-text-secondary,.uk-section-secondary:not(.uk-preserve-color) .uk-text-emphasis,.uk-section-secondary:not(.uk-preserve-color) .uk-text-primary,.uk-section-secondary:not(.uk-preserve-color) .uk-text-secondary,.uk-tile-primary:not(.uk-preserve-color) .uk-text-emphasis,.uk-tile-primary:not(.uk-preserve-color) .uk-text-primary,.uk-tile-primary:not(.uk-preserve-color) .uk-text-secondary,.uk-tile-secondary:not(.uk-preserve-color) .uk-text-emphasis,.uk-tile-secondary:not(.uk-preserve-color) .uk-text-primary,.uk-tile-secondary:not(.uk-preserve-color) .uk-text-secondary{color:#fff!important}.uk-card-primary.uk-card-body .uk-column-divider,.uk-card-primary>:not([class*=uk-card-media]) .uk-column-divider,.uk-card-secondary.uk-card-body .uk-column-divider,.uk-card-secondary>:not([class*=uk-card-media]) .uk-column-divider,.uk-light .uk-column-divider,.uk-offcanvas-bar .uk-column-divider,.uk-overlay-primary .uk-column-divider,.uk-section-primary:not(.uk-preserve-color) .uk-column-divider,.uk-section-secondary:not(.uk-preserve-color) .uk-column-divider,.uk-tile-primary:not(.uk-preserve-color) .uk-column-divider,.uk-tile-secondary:not(.uk-preserve-color) .uk-column-divider{column-rule-color:hsla(0,0%,100%,.2)}.uk-card-primary.uk-card-body .uk-logo,.uk-card-primary.uk-card-body .uk-logo:focus,.uk-card-primary.uk-card-body .uk-logo:hover,.uk-card-primary>:not([class*=uk-card-media]) .uk-logo,.uk-card-primary>:not([class*=uk-card-media]) .uk-logo:focus,.uk-card-primary>:not([class*=uk-card-media]) .uk-logo:hover,.uk-card-secondary.uk-card-body .uk-logo,.uk-card-secondary.uk-card-body .uk-logo:focus,.uk-card-secondary.uk-card-body .uk-logo:hover,.uk-card-secondary>:not([class*=uk-card-media]) .uk-logo,.uk-card-secondary>:not([class*=uk-card-media]) .uk-logo:focus,.uk-card-secondary>:not([class*=uk-card-media]) .uk-logo:hover,.uk-light .uk-logo,.uk-light .uk-logo:focus,.uk-light .uk-logo:hover,.uk-offcanvas-bar .uk-logo,.uk-offcanvas-bar .uk-logo:focus,.uk-offcanvas-bar .uk-logo:hover,.uk-overlay-primary .uk-logo,.uk-overlay-primary .uk-logo:focus,.uk-overlay-primary .uk-logo:hover,.uk-section-primary:not(.uk-preserve-color) .uk-logo,.uk-section-primary:not(.uk-preserve-color) .uk-logo:focus,.uk-section-primary:not(.uk-preserve-color) .uk-logo:hover,.uk-section-secondary:not(.uk-preserve-color) .uk-logo,.uk-section-secondary:not(.uk-preserve-color) .uk-logo:focus,.uk-section-secondary:not(.uk-preserve-color) .uk-logo:hover,.uk-tile-primary:not(.uk-preserve-color) .uk-logo,.uk-tile-primary:not(.uk-preserve-color) .uk-logo:focus,.uk-tile-primary:not(.uk-preserve-color) .uk-logo:hover,.uk-tile-secondary:not(.uk-preserve-color) .uk-logo,.uk-tile-secondary:not(.uk-preserve-color) .uk-logo:focus,.uk-tile-secondary:not(.uk-preserve-color) .uk-logo:hover{color:hsla(0,0%,100%,.7)}.uk-card-primary.uk-card-body .uk-logo>:not(.uk-logo-inverse):not(:only-of-type),.uk-card-primary>:not([class*=uk-card-media]) .uk-logo>:not(.uk-logo-inverse):not(:only-of-type),.uk-card-secondary.uk-card-body .uk-logo>:not(.uk-logo-inverse):not(:only-of-type),.uk-card-secondary>:not([class*=uk-card-media]) .uk-logo>:not(.uk-logo-inverse):not(:only-of-type),.uk-light .uk-logo>:not(.uk-logo-inverse):not(:only-of-type),.uk-offcanvas-bar .uk-logo>:not(.uk-logo-inverse):not(:only-of-type),.uk-overlay-primary .uk-logo>:not(.uk-logo-inverse):not(:only-of-type),.uk-section-primary:not(.uk-preserve-color) .uk-logo>:not(.uk-logo-inverse):not(:only-of-type),.uk-section-secondary:not(.uk-preserve-color) .uk-logo>:not(.uk-logo-inverse):not(:only-of-type),.uk-tile-primary:not(.uk-preserve-color) .uk-logo>:not(.uk-logo-inverse):not(:only-of-type),.uk-tile-secondary:not(.uk-preserve-color) .uk-logo>:not(.uk-logo-inverse):not(:only-of-type){display:none}.uk-card-primary.uk-card-body .uk-logo-inverse,.uk-card-primary>:not([class*=uk-card-media]) .uk-logo-inverse,.uk-card-secondary.uk-card-body .uk-logo-inverse,.uk-card-secondary>:not([class*=uk-card-media]) .uk-logo-inverse,.uk-light .uk-logo-inverse,.uk-offcanvas-bar .uk-logo-inverse,.uk-overlay-primary .uk-logo-inverse,.uk-section-primary:not(.uk-preserve-color) .uk-logo-inverse,.uk-section-secondary:not(.uk-preserve-color) .uk-logo-inverse,.uk-tile-primary:not(.uk-preserve-color) .uk-logo-inverse,.uk-tile-secondary:not(.uk-preserve-color) .uk-logo-inverse{display:inline}.uk-card-primary.uk-card-body .uk-accordion-title:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-accordion-title:before,.uk-card-secondary.uk-card-body .uk-accordion-title:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-accordion-title:before,.uk-light .uk-accordion-title:before,.uk-offcanvas-bar .uk-accordion-title:before,.uk-overlay-primary .uk-accordion-title:before,.uk-section-primary:not(.uk-preserve-color) .uk-accordion-title:before,.uk-section-secondary:not(.uk-preserve-color) .uk-accordion-title:before,.uk-tile-primary:not(.uk-preserve-color) .uk-accordion-title:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-accordion-title:before{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2213%22%20height%3D%2213%22%20viewBox%3D%220%200%2013%2013%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Crect%20fill%3D%22rgba%28255,%20255,%20255,%200.7%29%22%20width%3D%2213%22%20height%3D%221%22%20x%3D%220%22%20y%3D%226%22%20%2F%3E%0A%20%20%20%20%3Crect%20fill%3D%22rgba%28255,%20255,%20255,%200.7%29%22%20width%3D%221%22%20height%3D%2213%22%20x%3D%226%22%20y%3D%220%22%20%2F%3E%0A%3C%2Fsvg%3E\")}.uk-card-primary.uk-card-body .uk-open>.uk-accordion-title:before,.uk-card-primary>:not([class*=uk-card-media]) .uk-open>.uk-accordion-title:before,.uk-card-secondary.uk-card-body .uk-open>.uk-accordion-title:before,.uk-card-secondary>:not([class*=uk-card-media]) .uk-open>.uk-accordion-title:before,.uk-light .uk-open>.uk-accordion-title:before,.uk-offcanvas-bar .uk-open>.uk-accordion-title:before,.uk-overlay-primary .uk-open>.uk-accordion-title:before,.uk-section-primary:not(.uk-preserve-color) .uk-open>.uk-accordion-title:before,.uk-section-secondary:not(.uk-preserve-color) .uk-open>.uk-accordion-title:before,.uk-tile-primary:not(.uk-preserve-color) .uk-open>.uk-accordion-title:before,.uk-tile-secondary:not(.uk-preserve-color) .uk-open>.uk-accordion-title:before{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2213%22%20height%3D%2213%22%20viewBox%3D%220%200%2013%2013%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Crect%20fill%3D%22rgba%28255,%20255,%20255,%200.7%29%22%20width%3D%2213%22%20height%3D%221%22%20x%3D%220%22%20y%3D%226%22%20%2F%3E%0A%3C%2Fsvg%3E\")}html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}.runway,.runway-component{/*! bulma.io v0.9.0 | MIT License | github.com/jgthms/bulma *//*! minireset.css v0.0.6 | MIT License | github.com/jgthms/minireset.css */}@-webkit-keyframes spinAround{0%{transform:rotate(0)}to{transform:rotate(359deg)}}@keyframes spinAround{0%{transform:rotate(0)}to{transform:rotate(359deg)}}.runway-component .breadcrumb,.runway-component .button,.runway-component .delete,.runway-component .file,.runway-component .is-unselectable,.runway-component .modal-close,.runway-component .pagination-ellipsis,.runway-component .pagination-link,.runway-component .pagination-next,.runway-component .pagination-previous,.runway-component .tabs,.runway .breadcrumb,.runway .button,.runway .delete,.runway .file,.runway .is-unselectable,.runway .modal-close,.runway .pagination-ellipsis,.runway .pagination-link,.runway .pagination-next,.runway .pagination-previous,.runway .tabs{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.runway-component .navbar-link:not(.is-arrowless):after,.runway-component .select:not(.is-multiple):not(.is-loading):after,.runway .navbar-link:not(.is-arrowless):after,.runway .select:not(.is-multiple):not(.is-loading):after{border:3px solid transparent;border-radius:2px;border-right:0;border-top:0;content:\" \";display:block;height:.625em;margin-top:-.4375em;pointer-events:none;position:absolute;top:50%;transform:rotate(-45deg);transform-origin:center;width:.625em}.runway-component .block:not(:last-child),.runway-component .box:not(:last-child),.runway-component .breadcrumb:not(:last-child),.runway-component .content:not(:last-child),.runway-component .highlight:not(:last-child),.runway-component .level:not(:last-child),.runway-component .message:not(:last-child),.runway-component .notification:not(:last-child),.runway-component .pagination:not(:last-child),.runway-component .progress:not(:last-child),.runway-component .subtitle:not(:last-child),.runway-component .table-container:not(:last-child),.runway-component .table:not(:last-child),.runway-component .tabs:not(:last-child),.runway-component .title:not(:last-child),.runway .block:not(:last-child),.runway .box:not(:last-child),.runway .breadcrumb:not(:last-child),.runway .content:not(:last-child),.runway .highlight:not(:last-child),.runway .level:not(:last-child),.runway .message:not(:last-child),.runway .notification:not(:last-child),.runway .pagination:not(:last-child),.runway .progress:not(:last-child),.runway .subtitle:not(:last-child),.runway .table-container:not(:last-child),.runway .table:not(:last-child),.runway .tabs:not(:last-child),.runway .title:not(:last-child){margin-bottom:1.5rem}.runway-component .delete,.runway-component .modal-close,.runway .delete,.runway .modal-close{-moz-appearance:none;-webkit-appearance:none;background-color:hsla(0,0%,4%,.2);border:none;border-radius:290486px;cursor:pointer;pointer-events:auto;display:inline-block;flex-grow:0;flex-shrink:0;font-size:0;height:20px;max-height:20px;max-width:20px;min-height:20px;min-width:20px;outline:0;position:relative;vertical-align:top;width:20px}.runway-component .delete:after,.runway-component .delete:before,.runway-component .modal-close:after,.runway-component .modal-close:before,.runway .delete:after,.runway .delete:before,.runway .modal-close:after,.runway .modal-close:before{background-color:#fff;content:\"\";display:block;left:50%;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%) rotate(45deg);transform-origin:center center}.runway-component .delete:before,.runway-component .modal-close:before,.runway .delete:before,.runway .modal-close:before{height:2px;width:50%}.runway-component .delete:after,.runway-component .modal-close:after,.runway .delete:after,.runway .modal-close:after{height:50%;width:2px}.runway-component .delete:focus,.runway-component .delete:hover,.runway-component .modal-close:focus,.runway-component .modal-close:hover,.runway .delete:focus,.runway .delete:hover,.runway .modal-close:focus,.runway .modal-close:hover{background-color:hsla(0,0%,4%,.3)}.runway-component .delete:active,.runway-component .modal-close:active,.runway .delete:active,.runway .modal-close:active{background-color:hsla(0,0%,4%,.4)}.runway-component .is-small.delete,.runway-component .is-small.modal-close,.runway .is-small.delete,.runway .is-small.modal-close{height:16px;max-height:16px;max-width:16px;min-height:16px;min-width:16px;width:16px}.runway-component .is-medium.delete,.runway-component .is-medium.modal-close,.runway .is-medium.delete,.runway .is-medium.modal-close{height:24px;max-height:24px;max-width:24px;min-height:24px;min-width:24px;width:24px}.runway-component .is-large.delete,.runway-component .is-large.modal-close,.runway .is-large.delete,.runway .is-large.modal-close{height:32px;max-height:32px;max-width:32px;min-height:32px;min-width:32px;width:32px}.runway-component .button.is-loading:after,.runway-component .control.is-loading:after,.runway-component .loader,.runway-component .select.is-loading:after,.runway .button.is-loading:after,.runway .control.is-loading:after,.runway .loader,.runway .select.is-loading:after{-webkit-animation:spinAround .5s infinite linear;animation:spinAround .5s infinite linear;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em}.runway-component .hero-video,.runway-component .image.is-1by1 .has-ratio,.runway-component .image.is-1by1 img,.runway-component .image.is-1by2 .has-ratio,.runway-component .image.is-1by2 img,.runway-component .image.is-1by3 .has-ratio,.runway-component .image.is-1by3 img,.runway-component .image.is-2by1 .has-ratio,.runway-component .image.is-2by1 img,.runway-component .image.is-2by3 .has-ratio,.runway-component .image.is-2by3 img,.runway-component .image.is-3by1 .has-ratio,.runway-component .image.is-3by1 img,.runway-component .image.is-3by2 .has-ratio,.runway-component .image.is-3by2 img,.runway-component .image.is-3by4 .has-ratio,.runway-component .image.is-3by4 img,.runway-component .image.is-3by5 .has-ratio,.runway-component .image.is-3by5 img,.runway-component .image.is-4by3 .has-ratio,.runway-component .image.is-4by3 img,.runway-component .image.is-4by5 .has-ratio,.runway-component .image.is-4by5 img,.runway-component .image.is-5by3 .has-ratio,.runway-component .image.is-5by3 img,.runway-component .image.is-5by4 .has-ratio,.runway-component .image.is-5by4 img,.runway-component .image.is-9by16 .has-ratio,.runway-component .image.is-9by16 img,.runway-component .image.is-16by9 .has-ratio,.runway-component .image.is-16by9 img,.runway-component .image.is-square .has-ratio,.runway-component .image.is-square img,.runway-component .is-overlay,.runway-component .modal,.runway-component .modal-background,.runway .hero-video,.runway .image.is-1by1 .has-ratio,.runway .image.is-1by1 img,.runway .image.is-1by2 .has-ratio,.runway .image.is-1by2 img,.runway .image.is-1by3 .has-ratio,.runway .image.is-1by3 img,.runway .image.is-2by1 .has-ratio,.runway .image.is-2by1 img,.runway .image.is-2by3 .has-ratio,.runway .image.is-2by3 img,.runway .image.is-3by1 .has-ratio,.runway .image.is-3by1 img,.runway .image.is-3by2 .has-ratio,.runway .image.is-3by2 img,.runway .image.is-3by4 .has-ratio,.runway .image.is-3by4 img,.runway .image.is-3by5 .has-ratio,.runway .image.is-3by5 img,.runway .image.is-4by3 .has-ratio,.runway .image.is-4by3 img,.runway .image.is-4by5 .has-ratio,.runway .image.is-4by5 img,.runway .image.is-5by3 .has-ratio,.runway .image.is-5by3 img,.runway .image.is-5by4 .has-ratio,.runway .image.is-5by4 img,.runway .image.is-9by16 .has-ratio,.runway .image.is-9by16 img,.runway .image.is-16by9 .has-ratio,.runway .image.is-16by9 img,.runway .image.is-square .has-ratio,.runway .image.is-square img,.runway .is-overlay,.runway .modal,.runway .modal-background{bottom:0;left:0;position:absolute;right:0;top:0}.runway-component .button,.runway-component .file-cta,.runway-component .file-name,.runway-component .input,.runway-component .pagination-ellipsis,.runway-component .pagination-link,.runway-component .pagination-next,.runway-component .pagination-previous,.runway-component .select select,.runway-component .textarea,.runway .button,.runway .file-cta,.runway .file-name,.runway .input,.runway .pagination-ellipsis,.runway .pagination-link,.runway .pagination-next,.runway .pagination-previous,.runway .select select,.runway .textarea{-moz-appearance:none;-webkit-appearance:none;align-items:center;border:1px solid transparent;border-radius:4px;box-shadow:none;display:inline-flex;font-size:1rem;height:2.5em;justify-content:flex-start;line-height:1.5;padding:calc(.5em - 1px) calc(.75em - 1px);position:relative;vertical-align:top}.runway-component .button:active,.runway-component .button:focus,.runway-component .file-cta:active,.runway-component .file-cta:focus,.runway-component .file-name:active,.runway-component .file-name:focus,.runway-component .input:active,.runway-component .input:focus,.runway-component .is-active.button,.runway-component .is-active.file-cta,.runway-component .is-active.file-name,.runway-component .is-active.input,.runway-component .is-active.pagination-ellipsis,.runway-component .is-active.pagination-link,.runway-component .is-active.pagination-next,.runway-component .is-active.pagination-previous,.runway-component .is-active.textarea,.runway-component .is-focused.button,.runway-component .is-focused.file-cta,.runway-component .is-focused.file-name,.runway-component .is-focused.input,.runway-component .is-focused.pagination-ellipsis,.runway-component .is-focused.pagination-link,.runway-component .is-focused.pagination-next,.runway-component .is-focused.pagination-previous,.runway-component .is-focused.textarea,.runway-component .pagination-ellipsis:active,.runway-component .pagination-ellipsis:focus,.runway-component .pagination-link:active,.runway-component .pagination-link:focus,.runway-component .pagination-next:active,.runway-component .pagination-next:focus,.runway-component .pagination-previous:active,.runway-component .pagination-previous:focus,.runway-component .select select.is-active,.runway-component .select select.is-focused,.runway-component .select select:active,.runway-component .select select:focus,.runway-component .textarea:active,.runway-component .textarea:focus,.runway .button:active,.runway .button:focus,.runway .file-cta:active,.runway .file-cta:focus,.runway .file-name:active,.runway .file-name:focus,.runway .input:active,.runway .input:focus,.runway .is-active.button,.runway .is-active.file-cta,.runway .is-active.file-name,.runway .is-active.input,.runway .is-active.pagination-ellipsis,.runway .is-active.pagination-link,.runway .is-active.pagination-next,.runway .is-active.pagination-previous,.runway .is-active.textarea,.runway .is-focused.button,.runway .is-focused.file-cta,.runway .is-focused.file-name,.runway .is-focused.input,.runway .is-focused.pagination-ellipsis,.runway .is-focused.pagination-link,.runway .is-focused.pagination-next,.runway .is-focused.pagination-previous,.runway .is-focused.textarea,.runway .pagination-ellipsis:active,.runway .pagination-ellipsis:focus,.runway .pagination-link:active,.runway .pagination-link:focus,.runway .pagination-next:active,.runway .pagination-next:focus,.runway .pagination-previous:active,.runway .pagination-previous:focus,.runway .select select.is-active,.runway .select select.is-focused,.runway .select select:active,.runway .select select:focus,.runway .textarea:active,.runway .textarea:focus{outline:0}.runway-component .button[disabled],.runway-component .file-cta[disabled],.runway-component .file-name[disabled],.runway-component .input[disabled],.runway-component .pagination-ellipsis[disabled],.runway-component .pagination-link[disabled],.runway-component .pagination-next[disabled],.runway-component .pagination-previous[disabled],.runway-component .select fieldset[disabled] select,.runway-component .select select[disabled],.runway-component .textarea[disabled],.runway-component fieldset[disabled] .button,.runway-component fieldset[disabled] .file-cta,.runway-component fieldset[disabled] .file-name,.runway-component fieldset[disabled] .input,.runway-component fieldset[disabled] .pagination-ellipsis,.runway-component fieldset[disabled] .pagination-link,.runway-component fieldset[disabled] .pagination-next,.runway-component fieldset[disabled] .pagination-previous,.runway-component fieldset[disabled] .select select,.runway-component fieldset[disabled] .textarea,.runway .button[disabled],.runway .file-cta[disabled],.runway .file-name[disabled],.runway .input[disabled],.runway .pagination-ellipsis[disabled],.runway .pagination-link[disabled],.runway .pagination-next[disabled],.runway .pagination-previous[disabled],.runway .select fieldset[disabled] select,.runway .select select[disabled],.runway .textarea[disabled],.runway fieldset[disabled] .button,.runway fieldset[disabled] .file-cta,.runway fieldset[disabled] .file-name,.runway fieldset[disabled] .input,.runway fieldset[disabled] .pagination-ellipsis,.runway fieldset[disabled] .pagination-link,.runway fieldset[disabled] .pagination-next,.runway fieldset[disabled] .pagination-previous,.runway fieldset[disabled] .select select,.runway fieldset[disabled] .textarea{cursor:not-allowed}.runway-component blockquote,.runway-component body,.runway-component dd,.runway-component dl,.runway-component dt,.runway-component fieldset,.runway-component figure,.runway-component h1,.runway-component h2,.runway-component h3,.runway-component h4,.runway-component h5,.runway-component h6,.runway-component hr,.runway-component html,.runway-component iframe,.runway-component legend,.runway-component li,.runway-component ol,.runway-component p,.runway-component pre,.runway-component textarea,.runway-component ul,.runway blockquote,.runway body,.runway dd,.runway dl,.runway dt,.runway fieldset,.runway figure,.runway h1,.runway h2,.runway h3,.runway h4,.runway h5,.runway h6,.runway hr,.runway html,.runway iframe,.runway legend,.runway li,.runway ol,.runway p,.runway pre,.runway textarea,.runway ul{margin:0;padding:0}.runway-component h1,.runway-component h2,.runway-component h3,.runway-component h4,.runway-component h5,.runway-component h6,.runway h1,.runway h2,.runway h3,.runway h4,.runway h5,.runway h6{font-size:100%;font-weight:400}.runway-component ul,.runway ul{list-style:none}.runway-component button,.runway-component input,.runway-component select,.runway-component textarea,.runway button,.runway input,.runway select,.runway textarea{margin:0}.runway-component img,.runway-component video,.runway img,.runway video{height:auto;max-width:100%}.runway-component iframe,.runway iframe{border:0}.runway-component table,.runway table{border-collapse:collapse;border-spacing:0}.runway-component td,.runway-component th,.runway td,.runway th{padding:0}.runway-component td:not([align]),.runway-component th:not([align]),.runway td:not([align]),.runway th:not([align]){text-align:inherit}.runway-component html,.runway html{background-color:#fff;font-size:16px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;min-width:300px;overflow-x:hidden;overflow-y:scroll;text-rendering:optimizeLegibility;-webkit-text-size-adjust:100%;-moz-text-size-adjust:100%;-ms-text-size-adjust:100%;text-size-adjust:100%}.runway-component article,.runway-component aside,.runway-component figure,.runway-component footer,.runway-component header,.runway-component hgroup,.runway-component section,.runway article,.runway aside,.runway figure,.runway footer,.runway header,.runway hgroup,.runway section{display:block}.runway-component body,.runway-component button,.runway-component input,.runway-component select,.runway-component textarea,.runway body,.runway button,.runway input,.runway select,.runway textarea{font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif}.runway-component code,.runway-component pre,.runway code,.runway pre{-moz-osx-font-smoothing:auto;-webkit-font-smoothing:auto;font-family:monospace}.runway-component body,.runway body{color:#4a4a4a;font-size:1em;font-weight:400;line-height:1.5}.runway-component a,.runway a{color:#3273dc;cursor:pointer;text-decoration:none}.runway-component a strong,.runway a strong{color:currentColor}.runway-component a:hover,.runway a:hover{color:#363636}.runway-component code,.runway code{background-color:#f5f5f5;color:#f14668;font-size:.875em;font-weight:400;padding:.25em .5em}.runway-component hr,.runway hr{background-color:#f5f5f5;border:none;display:block;height:2px;margin:1.5rem 0}.runway-component img,.runway img{height:auto;max-width:100%}.runway-component input[type=checkbox],.runway-component input[type=radio],.runway input[type=checkbox],.runway input[type=radio]{vertical-align:baseline}.runway-component small,.runway small{font-size:.875em}.runway-component span,.runway span{font-style:inherit;font-weight:inherit}.runway-component strong,.runway strong{color:#363636;font-weight:700}.runway-component fieldset,.runway fieldset{border:none}.runway-component pre,.runway pre{-webkit-overflow-scrolling:touch;background-color:#f5f5f5;color:#4a4a4a;font-size:.875em;overflow-x:auto;padding:1.25rem 1.5rem;white-space:pre;word-wrap:normal}.runway-component pre code,.runway pre code{background-color:transparent;color:currentColor;font-size:1em;padding:0}.runway-component table td,.runway-component table th,.runway table td,.runway table th{vertical-align:top}.runway-component table td:not([align]),.runway-component table th:not([align]),.runway table td:not([align]),.runway table th:not([align]){text-align:inherit}.runway-component table th,.runway table th{color:#363636}.runway-component .box,.runway .box{background-color:#fff;border-radius:6px;box-shadow:0 .5em 1em -.125em hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.02);color:#4a4a4a;display:block;padding:1.25rem}.runway-component a.box:focus,.runway-component a.box:hover,.runway a.box:focus,.runway a.box:hover{box-shadow:0 .5em 1em -.125em hsla(0,0%,4%,.1),0 0 0 1px #3273dc}.runway-component a.box:active,.runway a.box:active{box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2),0 0 0 1px #3273dc}.runway-component .button,.runway .button{background-color:#fff;border-color:#dbdbdb;border-width:1px;color:#363636;cursor:pointer;justify-content:center;padding:calc(.5em - 1px) 1em;text-align:center;white-space:nowrap}.runway-component .button strong,.runway .button strong{color:inherit}.runway-component .button .icon,.runway-component .button .icon.is-large,.runway-component .button .icon.is-medium,.runway-component .button .icon.is-small,.runway .button .icon,.runway .button .icon.is-large,.runway .button .icon.is-medium,.runway .button .icon.is-small{height:1.5em;width:1.5em}.runway-component .button .icon:first-child:not(:last-child),.runway .button .icon:first-child:not(:last-child){margin-left:calc(-.5em - 1px);margin-right:.25em}.runway-component .button .icon:last-child:not(:first-child),.runway .button .icon:last-child:not(:first-child){margin-left:.25em;margin-right:calc(-.5em - 1px)}.runway-component .button .icon:first-child:last-child,.runway .button .icon:first-child:last-child{margin-left:calc(-.5em - 1px);margin-right:calc(-.5em - 1px)}.runway-component .button.is-hovered,.runway-component .button:hover,.runway .button.is-hovered,.runway .button:hover{border-color:#b5b5b5;color:#363636}.runway-component .button.is-focused,.runway-component .button:focus,.runway .button.is-focused,.runway .button:focus{border-color:#3273dc;color:#363636}.runway-component .button.is-focused:not(:active),.runway-component .button:focus:not(:active),.runway .button.is-focused:not(:active),.runway .button:focus:not(:active){box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.runway-component .button.is-active,.runway-component .button:active,.runway .button.is-active,.runway .button:active{border-color:#4a4a4a;color:#363636}.runway-component .button.is-text,.runway .button.is-text{background-color:transparent;border-color:transparent;color:#4a4a4a;text-decoration:underline}.runway-component .button.is-text.is-focused,.runway-component .button.is-text.is-hovered,.runway-component .button.is-text:focus,.runway-component .button.is-text:hover,.runway .button.is-text.is-focused,.runway .button.is-text.is-hovered,.runway .button.is-text:focus,.runway .button.is-text:hover{background-color:#f5f5f5;color:#363636}.runway-component .button.is-text.is-active,.runway-component .button.is-text:active,.runway .button.is-text.is-active,.runway .button.is-text:active{background-color:#e8e8e8;color:#363636}.runway-component .button.is-text[disabled],.runway-component fieldset[disabled] .button.is-text,.runway .button.is-text[disabled],.runway fieldset[disabled] .button.is-text{background-color:transparent;border-color:transparent;box-shadow:none}.runway-component .button.is-white,.runway .button.is-white{background-color:#fff;border-color:transparent;color:#0a0a0a}.runway-component .button.is-white.is-hovered,.runway-component .button.is-white:hover,.runway .button.is-white.is-hovered,.runway .button.is-white:hover{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.runway-component .button.is-white.is-focused,.runway-component .button.is-white:focus,.runway .button.is-white.is-focused,.runway .button.is-white:focus{border-color:transparent;color:#0a0a0a}.runway-component .button.is-white.is-focused:not(:active),.runway-component .button.is-white:focus:not(:active),.runway .button.is-white.is-focused:not(:active),.runway .button.is-white:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.runway-component .button.is-white.is-active,.runway-component .button.is-white:active,.runway .button.is-white.is-active,.runway .button.is-white:active{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.runway-component .button.is-white[disabled],.runway-component fieldset[disabled] .button.is-white,.runway .button.is-white[disabled],.runway fieldset[disabled] .button.is-white{background-color:#fff;border-color:transparent;box-shadow:none}.runway-component .button.is-white.is-inverted,.runway .button.is-white.is-inverted{background-color:#0a0a0a;color:#fff}.runway-component .button.is-white.is-inverted.is-hovered,.runway-component .button.is-white.is-inverted:hover,.runway .button.is-white.is-inverted.is-hovered,.runway .button.is-white.is-inverted:hover{background-color:#000}.runway-component .button.is-white.is-inverted[disabled],.runway-component fieldset[disabled] .button.is-white.is-inverted,.runway .button.is-white.is-inverted[disabled],.runway fieldset[disabled] .button.is-white.is-inverted{background-color:#0a0a0a;border-color:transparent;box-shadow:none;color:#fff}.runway-component .button.is-white.is-loading:after,.runway .button.is-white.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.runway-component .button.is-white.is-outlined,.runway .button.is-white.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.runway-component .button.is-white.is-outlined.is-focused,.runway-component .button.is-white.is-outlined.is-hovered,.runway-component .button.is-white.is-outlined:focus,.runway-component .button.is-white.is-outlined:hover,.runway .button.is-white.is-outlined.is-focused,.runway .button.is-white.is-outlined.is-hovered,.runway .button.is-white.is-outlined:focus,.runway .button.is-white.is-outlined:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.runway-component .button.is-white.is-outlined.is-loading:after,.runway .button.is-white.is-outlined.is-loading:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-white.is-outlined.is-loading.is-focused:after,.runway-component .button.is-white.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-white.is-outlined.is-loading:focus:after,.runway-component .button.is-white.is-outlined.is-loading:hover:after,.runway .button.is-white.is-outlined.is-loading.is-focused:after,.runway .button.is-white.is-outlined.is-loading.is-hovered:after,.runway .button.is-white.is-outlined.is-loading:focus:after,.runway .button.is-white.is-outlined.is-loading:hover:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.runway-component .button.is-white.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-white.is-outlined,.runway .button.is-white.is-outlined[disabled],.runway fieldset[disabled] .button.is-white.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.runway-component .button.is-white.is-inverted.is-outlined,.runway .button.is-white.is-inverted.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.runway-component .button.is-white.is-inverted.is-outlined.is-focused,.runway-component .button.is-white.is-inverted.is-outlined.is-hovered,.runway-component .button.is-white.is-inverted.is-outlined:focus,.runway-component .button.is-white.is-inverted.is-outlined:hover,.runway .button.is-white.is-inverted.is-outlined.is-focused,.runway .button.is-white.is-inverted.is-outlined.is-hovered,.runway .button.is-white.is-inverted.is-outlined:focus,.runway .button.is-white.is-inverted.is-outlined:hover{background-color:#0a0a0a;color:#fff}.runway-component .button.is-white.is-inverted.is-outlined.is-loading.is-focused:after,.runway-component .button.is-white.is-inverted.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-white.is-inverted.is-outlined.is-loading:focus:after,.runway-component .button.is-white.is-inverted.is-outlined.is-loading:hover:after,.runway .button.is-white.is-inverted.is-outlined.is-loading.is-focused:after,.runway .button.is-white.is-inverted.is-outlined.is-loading.is-hovered:after,.runway .button.is-white.is-inverted.is-outlined.is-loading:focus:after,.runway .button.is-white.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-white.is-inverted.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-white.is-inverted.is-outlined,.runway .button.is-white.is-inverted.is-outlined[disabled],.runway fieldset[disabled] .button.is-white.is-inverted.is-outlined{background-color:transparent;border-color:#0a0a0a;box-shadow:none;color:#0a0a0a}.runway-component .button.is-black,.runway .button.is-black{background-color:#0a0a0a;border-color:transparent;color:#fff}.runway-component .button.is-black.is-hovered,.runway-component .button.is-black:hover,.runway .button.is-black.is-hovered,.runway .button.is-black:hover{background-color:#040404;border-color:transparent;color:#fff}.runway-component .button.is-black.is-focused,.runway-component .button.is-black:focus,.runway .button.is-black.is-focused,.runway .button.is-black:focus{border-color:transparent;color:#fff}.runway-component .button.is-black.is-focused:not(:active),.runway-component .button.is-black:focus:not(:active),.runway .button.is-black.is-focused:not(:active),.runway .button.is-black:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.runway-component .button.is-black.is-active,.runway-component .button.is-black:active,.runway .button.is-black.is-active,.runway .button.is-black:active{background-color:#000;border-color:transparent;color:#fff}.runway-component .button.is-black[disabled],.runway-component fieldset[disabled] .button.is-black,.runway .button.is-black[disabled],.runway fieldset[disabled] .button.is-black{background-color:#0a0a0a;border-color:transparent;box-shadow:none}.runway-component .button.is-black.is-inverted,.runway .button.is-black.is-inverted{background-color:#fff;color:#0a0a0a}.runway-component .button.is-black.is-inverted.is-hovered,.runway-component .button.is-black.is-inverted:hover,.runway .button.is-black.is-inverted.is-hovered,.runway .button.is-black.is-inverted:hover{background-color:#f2f2f2}.runway-component .button.is-black.is-inverted[disabled],.runway-component fieldset[disabled] .button.is-black.is-inverted,.runway .button.is-black.is-inverted[disabled],.runway fieldset[disabled] .button.is-black.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#0a0a0a}.runway-component .button.is-black.is-loading:after,.runway .button.is-black.is-loading:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-black.is-outlined,.runway .button.is-black.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.runway-component .button.is-black.is-outlined.is-focused,.runway-component .button.is-black.is-outlined.is-hovered,.runway-component .button.is-black.is-outlined:focus,.runway-component .button.is-black.is-outlined:hover,.runway .button.is-black.is-outlined.is-focused,.runway .button.is-black.is-outlined.is-hovered,.runway .button.is-black.is-outlined:focus,.runway .button.is-black.is-outlined:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.runway-component .button.is-black.is-outlined.is-loading:after,.runway .button.is-black.is-outlined.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.runway-component .button.is-black.is-outlined.is-loading.is-focused:after,.runway-component .button.is-black.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-black.is-outlined.is-loading:focus:after,.runway-component .button.is-black.is-outlined.is-loading:hover:after,.runway .button.is-black.is-outlined.is-loading.is-focused:after,.runway .button.is-black.is-outlined.is-loading.is-hovered:after,.runway .button.is-black.is-outlined.is-loading:focus:after,.runway .button.is-black.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-black.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-black.is-outlined,.runway .button.is-black.is-outlined[disabled],.runway fieldset[disabled] .button.is-black.is-outlined{background-color:transparent;border-color:#0a0a0a;box-shadow:none;color:#0a0a0a}.runway-component .button.is-black.is-inverted.is-outlined,.runway .button.is-black.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.runway-component .button.is-black.is-inverted.is-outlined.is-focused,.runway-component .button.is-black.is-inverted.is-outlined.is-hovered,.runway-component .button.is-black.is-inverted.is-outlined:focus,.runway-component .button.is-black.is-inverted.is-outlined:hover,.runway .button.is-black.is-inverted.is-outlined.is-focused,.runway .button.is-black.is-inverted.is-outlined.is-hovered,.runway .button.is-black.is-inverted.is-outlined:focus,.runway .button.is-black.is-inverted.is-outlined:hover{background-color:#fff;color:#0a0a0a}.runway-component .button.is-black.is-inverted.is-outlined.is-loading.is-focused:after,.runway-component .button.is-black.is-inverted.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-black.is-inverted.is-outlined.is-loading:focus:after,.runway-component .button.is-black.is-inverted.is-outlined.is-loading:hover:after,.runway .button.is-black.is-inverted.is-outlined.is-loading.is-focused:after,.runway .button.is-black.is-inverted.is-outlined.is-loading.is-hovered:after,.runway .button.is-black.is-inverted.is-outlined.is-loading:focus:after,.runway .button.is-black.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.runway-component .button.is-black.is-inverted.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-black.is-inverted.is-outlined,.runway .button.is-black.is-inverted.is-outlined[disabled],.runway fieldset[disabled] .button.is-black.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.runway-component .button.is-light,.runway .button.is-light{background-color:#f5f5f5;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .button.is-light.is-hovered,.runway-component .button.is-light:hover,.runway .button.is-light.is-hovered,.runway .button.is-light:hover{background-color:#eee;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .button.is-light.is-focused,.runway-component .button.is-light:focus,.runway .button.is-light.is-focused,.runway .button.is-light:focus{border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .button.is-light.is-focused:not(:active),.runway-component .button.is-light:focus:not(:active),.runway .button.is-light.is-focused:not(:active),.runway .button.is-light:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.runway-component .button.is-light.is-active,.runway-component .button.is-light:active,.runway .button.is-light.is-active,.runway .button.is-light:active{background-color:#e8e8e8;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .button.is-light[disabled],.runway-component fieldset[disabled] .button.is-light,.runway .button.is-light[disabled],.runway fieldset[disabled] .button.is-light{background-color:#f5f5f5;border-color:transparent;box-shadow:none}.runway-component .button.is-light.is-inverted,.runway .button.is-light.is-inverted{background-color:rgba(0,0,0,.7);color:#f5f5f5}.runway-component .button.is-light.is-inverted.is-hovered,.runway-component .button.is-light.is-inverted:hover,.runway .button.is-light.is-inverted.is-hovered,.runway .button.is-light.is-inverted:hover{background-color:rgba(0,0,0,.7)}.runway-component .button.is-light.is-inverted[disabled],.runway-component fieldset[disabled] .button.is-light.is-inverted,.runway .button.is-light.is-inverted[disabled],.runway fieldset[disabled] .button.is-light.is-inverted{background-color:rgba(0,0,0,.7);border-color:transparent;box-shadow:none;color:#f5f5f5}.runway-component .button.is-light.is-loading:after,.runway .button.is-light.is-loading:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.runway-component .button.is-light.is-outlined,.runway .button.is-light.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.runway-component .button.is-light.is-outlined.is-focused,.runway-component .button.is-light.is-outlined.is-hovered,.runway-component .button.is-light.is-outlined:focus,.runway-component .button.is-light.is-outlined:hover,.runway .button.is-light.is-outlined.is-focused,.runway .button.is-light.is-outlined.is-hovered,.runway .button.is-light.is-outlined:focus,.runway .button.is-light.is-outlined:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:rgba(0,0,0,.7)}.runway-component .button.is-light.is-outlined.is-loading:after,.runway .button.is-light.is-outlined.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.runway-component .button.is-light.is-outlined.is-loading.is-focused:after,.runway-component .button.is-light.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-light.is-outlined.is-loading:focus:after,.runway-component .button.is-light.is-outlined.is-loading:hover:after,.runway .button.is-light.is-outlined.is-loading.is-focused:after,.runway .button.is-light.is-outlined.is-loading.is-hovered:after,.runway .button.is-light.is-outlined.is-loading:focus:after,.runway .button.is-light.is-outlined.is-loading:hover:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.runway-component .button.is-light.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-light.is-outlined,.runway .button.is-light.is-outlined[disabled],.runway fieldset[disabled] .button.is-light.is-outlined{background-color:transparent;border-color:#f5f5f5;box-shadow:none;color:#f5f5f5}.runway-component .button.is-light.is-inverted.is-outlined,.runway .button.is-light.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);color:rgba(0,0,0,.7)}.runway-component .button.is-light.is-inverted.is-outlined.is-focused,.runway-component .button.is-light.is-inverted.is-outlined.is-hovered,.runway-component .button.is-light.is-inverted.is-outlined:focus,.runway-component .button.is-light.is-inverted.is-outlined:hover,.runway .button.is-light.is-inverted.is-outlined.is-focused,.runway .button.is-light.is-inverted.is-outlined.is-hovered,.runway .button.is-light.is-inverted.is-outlined:focus,.runway .button.is-light.is-inverted.is-outlined:hover{background-color:rgba(0,0,0,.7);color:#f5f5f5}.runway-component .button.is-light.is-inverted.is-outlined.is-loading.is-focused:after,.runway-component .button.is-light.is-inverted.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-light.is-inverted.is-outlined.is-loading:focus:after,.runway-component .button.is-light.is-inverted.is-outlined.is-loading:hover:after,.runway .button.is-light.is-inverted.is-outlined.is-loading.is-focused:after,.runway .button.is-light.is-inverted.is-outlined.is-loading.is-hovered:after,.runway .button.is-light.is-inverted.is-outlined.is-loading:focus:after,.runway .button.is-light.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.runway-component .button.is-light.is-inverted.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-light.is-inverted.is-outlined,.runway .button.is-light.is-inverted.is-outlined[disabled],.runway fieldset[disabled] .button.is-light.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);box-shadow:none;color:rgba(0,0,0,.7)}.runway-component .button.is-dark,.runway .button.is-dark{background-color:#363636;border-color:transparent;color:#fff}.runway-component .button.is-dark.is-hovered,.runway-component .button.is-dark:hover,.runway .button.is-dark.is-hovered,.runway .button.is-dark:hover{background-color:#2f2f2f;border-color:transparent;color:#fff}.runway-component .button.is-dark.is-focused,.runway-component .button.is-dark:focus,.runway .button.is-dark.is-focused,.runway .button.is-dark:focus{border-color:transparent;color:#fff}.runway-component .button.is-dark.is-focused:not(:active),.runway-component .button.is-dark:focus:not(:active),.runway .button.is-dark.is-focused:not(:active),.runway .button.is-dark:focus:not(:active){box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.runway-component .button.is-dark.is-active,.runway-component .button.is-dark:active,.runway .button.is-dark.is-active,.runway .button.is-dark:active{background-color:#292929;border-color:transparent;color:#fff}.runway-component .button.is-dark[disabled],.runway-component fieldset[disabled] .button.is-dark,.runway .button.is-dark[disabled],.runway fieldset[disabled] .button.is-dark{background-color:#363636;border-color:transparent;box-shadow:none}.runway-component .button.is-dark.is-inverted,.runway .button.is-dark.is-inverted{background-color:#fff;color:#363636}.runway-component .button.is-dark.is-inverted.is-hovered,.runway-component .button.is-dark.is-inverted:hover,.runway .button.is-dark.is-inverted.is-hovered,.runway .button.is-dark.is-inverted:hover{background-color:#f2f2f2}.runway-component .button.is-dark.is-inverted[disabled],.runway-component fieldset[disabled] .button.is-dark.is-inverted,.runway .button.is-dark.is-inverted[disabled],.runway fieldset[disabled] .button.is-dark.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#363636}.runway-component .button.is-dark.is-loading:after,.runway .button.is-dark.is-loading:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-dark.is-outlined,.runway .button.is-dark.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.runway-component .button.is-dark.is-outlined.is-focused,.runway-component .button.is-dark.is-outlined.is-hovered,.runway-component .button.is-dark.is-outlined:focus,.runway-component .button.is-dark.is-outlined:hover,.runway .button.is-dark.is-outlined.is-focused,.runway .button.is-dark.is-outlined.is-hovered,.runway .button.is-dark.is-outlined:focus,.runway .button.is-dark.is-outlined:hover{background-color:#363636;border-color:#363636;color:#fff}.runway-component .button.is-dark.is-outlined.is-loading:after,.runway .button.is-dark.is-outlined.is-loading:after{border-color:transparent transparent #363636 #363636!important}.runway-component .button.is-dark.is-outlined.is-loading.is-focused:after,.runway-component .button.is-dark.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-dark.is-outlined.is-loading:focus:after,.runway-component .button.is-dark.is-outlined.is-loading:hover:after,.runway .button.is-dark.is-outlined.is-loading.is-focused:after,.runway .button.is-dark.is-outlined.is-loading.is-hovered:after,.runway .button.is-dark.is-outlined.is-loading:focus:after,.runway .button.is-dark.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-dark.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-dark.is-outlined,.runway .button.is-dark.is-outlined[disabled],.runway fieldset[disabled] .button.is-dark.is-outlined{background-color:transparent;border-color:#363636;box-shadow:none;color:#363636}.runway-component .button.is-dark.is-inverted.is-outlined,.runway .button.is-dark.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.runway-component .button.is-dark.is-inverted.is-outlined.is-focused,.runway-component .button.is-dark.is-inverted.is-outlined.is-hovered,.runway-component .button.is-dark.is-inverted.is-outlined:focus,.runway-component .button.is-dark.is-inverted.is-outlined:hover,.runway .button.is-dark.is-inverted.is-outlined.is-focused,.runway .button.is-dark.is-inverted.is-outlined.is-hovered,.runway .button.is-dark.is-inverted.is-outlined:focus,.runway .button.is-dark.is-inverted.is-outlined:hover{background-color:#fff;color:#363636}.runway-component .button.is-dark.is-inverted.is-outlined.is-loading.is-focused:after,.runway-component .button.is-dark.is-inverted.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-dark.is-inverted.is-outlined.is-loading:focus:after,.runway-component .button.is-dark.is-inverted.is-outlined.is-loading:hover:after,.runway .button.is-dark.is-inverted.is-outlined.is-loading.is-focused:after,.runway .button.is-dark.is-inverted.is-outlined.is-loading.is-hovered:after,.runway .button.is-dark.is-inverted.is-outlined.is-loading:focus:after,.runway .button.is-dark.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #363636 #363636!important}.runway-component .button.is-dark.is-inverted.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-dark.is-inverted.is-outlined,.runway .button.is-dark.is-inverted.is-outlined[disabled],.runway fieldset[disabled] .button.is-dark.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.runway-component .button.is-primary,.runway .button.is-primary{background-color:#00d1b2;border-color:transparent;color:#fff}.runway-component .button.is-primary.is-hovered,.runway-component .button.is-primary:hover,.runway .button.is-primary.is-hovered,.runway .button.is-primary:hover{background-color:#00c4a7;border-color:transparent;color:#fff}.runway-component .button.is-primary.is-focused,.runway-component .button.is-primary:focus,.runway .button.is-primary.is-focused,.runway .button.is-primary:focus{border-color:transparent;color:#fff}.runway-component .button.is-primary.is-focused:not(:active),.runway-component .button.is-primary:focus:not(:active),.runway .button.is-primary.is-focused:not(:active),.runway .button.is-primary:focus:not(:active){box-shadow:0 0 0 .125em rgba(0,209,178,.25)}.runway-component .button.is-primary.is-active,.runway-component .button.is-primary:active,.runway .button.is-primary.is-active,.runway .button.is-primary:active{background-color:#00b89c;border-color:transparent;color:#fff}.runway-component .button.is-primary[disabled],.runway-component fieldset[disabled] .button.is-primary,.runway .button.is-primary[disabled],.runway fieldset[disabled] .button.is-primary{background-color:#00d1b2;border-color:transparent;box-shadow:none}.runway-component .button.is-primary.is-inverted,.runway .button.is-primary.is-inverted{background-color:#fff;color:#00d1b2}.runway-component .button.is-primary.is-inverted.is-hovered,.runway-component .button.is-primary.is-inverted:hover,.runway .button.is-primary.is-inverted.is-hovered,.runway .button.is-primary.is-inverted:hover{background-color:#f2f2f2}.runway-component .button.is-primary.is-inverted[disabled],.runway-component fieldset[disabled] .button.is-primary.is-inverted,.runway .button.is-primary.is-inverted[disabled],.runway fieldset[disabled] .button.is-primary.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#00d1b2}.runway-component .button.is-primary.is-loading:after,.runway .button.is-primary.is-loading:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-primary.is-outlined,.runway .button.is-primary.is-outlined{background-color:transparent;border-color:#00d1b2;color:#00d1b2}.runway-component .button.is-primary.is-outlined.is-focused,.runway-component .button.is-primary.is-outlined.is-hovered,.runway-component .button.is-primary.is-outlined:focus,.runway-component .button.is-primary.is-outlined:hover,.runway .button.is-primary.is-outlined.is-focused,.runway .button.is-primary.is-outlined.is-hovered,.runway .button.is-primary.is-outlined:focus,.runway .button.is-primary.is-outlined:hover{background-color:#00d1b2;border-color:#00d1b2;color:#fff}.runway-component .button.is-primary.is-outlined.is-loading:after,.runway .button.is-primary.is-outlined.is-loading:after{border-color:transparent transparent #00d1b2 #00d1b2!important}.runway-component .button.is-primary.is-outlined.is-loading.is-focused:after,.runway-component .button.is-primary.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-primary.is-outlined.is-loading:focus:after,.runway-component .button.is-primary.is-outlined.is-loading:hover:after,.runway .button.is-primary.is-outlined.is-loading.is-focused:after,.runway .button.is-primary.is-outlined.is-loading.is-hovered:after,.runway .button.is-primary.is-outlined.is-loading:focus:after,.runway .button.is-primary.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-primary.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-primary.is-outlined,.runway .button.is-primary.is-outlined[disabled],.runway fieldset[disabled] .button.is-primary.is-outlined{background-color:transparent;border-color:#00d1b2;box-shadow:none;color:#00d1b2}.runway-component .button.is-primary.is-inverted.is-outlined,.runway .button.is-primary.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.runway-component .button.is-primary.is-inverted.is-outlined.is-focused,.runway-component .button.is-primary.is-inverted.is-outlined.is-hovered,.runway-component .button.is-primary.is-inverted.is-outlined:focus,.runway-component .button.is-primary.is-inverted.is-outlined:hover,.runway .button.is-primary.is-inverted.is-outlined.is-focused,.runway .button.is-primary.is-inverted.is-outlined.is-hovered,.runway .button.is-primary.is-inverted.is-outlined:focus,.runway .button.is-primary.is-inverted.is-outlined:hover{background-color:#fff;color:#00d1b2}.runway-component .button.is-primary.is-inverted.is-outlined.is-loading.is-focused:after,.runway-component .button.is-primary.is-inverted.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-primary.is-inverted.is-outlined.is-loading:focus:after,.runway-component .button.is-primary.is-inverted.is-outlined.is-loading:hover:after,.runway .button.is-primary.is-inverted.is-outlined.is-loading.is-focused:after,.runway .button.is-primary.is-inverted.is-outlined.is-loading.is-hovered:after,.runway .button.is-primary.is-inverted.is-outlined.is-loading:focus:after,.runway .button.is-primary.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #00d1b2 #00d1b2!important}.runway-component .button.is-primary.is-inverted.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-primary.is-inverted.is-outlined,.runway .button.is-primary.is-inverted.is-outlined[disabled],.runway fieldset[disabled] .button.is-primary.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.runway-component .button.is-primary.is-light,.runway .button.is-primary.is-light{background-color:#ebfffc;color:#00947e}.runway-component .button.is-primary.is-light.is-hovered,.runway-component .button.is-primary.is-light:hover,.runway .button.is-primary.is-light.is-hovered,.runway .button.is-primary.is-light:hover{background-color:#defffa;border-color:transparent;color:#00947e}.runway-component .button.is-primary.is-light.is-active,.runway-component .button.is-primary.is-light:active,.runway .button.is-primary.is-light.is-active,.runway .button.is-primary.is-light:active{background-color:#d1fff8;border-color:transparent;color:#00947e}.runway-component .button.is-link,.runway .button.is-link{background-color:#3273dc;border-color:transparent;color:#fff}.runway-component .button.is-link.is-hovered,.runway-component .button.is-link:hover,.runway .button.is-link.is-hovered,.runway .button.is-link:hover{background-color:#276cda;border-color:transparent;color:#fff}.runway-component .button.is-link.is-focused,.runway-component .button.is-link:focus,.runway .button.is-link.is-focused,.runway .button.is-link:focus{border-color:transparent;color:#fff}.runway-component .button.is-link.is-focused:not(:active),.runway-component .button.is-link:focus:not(:active),.runway .button.is-link.is-focused:not(:active),.runway .button.is-link:focus:not(:active){box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.runway-component .button.is-link.is-active,.runway-component .button.is-link:active,.runway .button.is-link.is-active,.runway .button.is-link:active{background-color:#2366d1;border-color:transparent;color:#fff}.runway-component .button.is-link[disabled],.runway-component fieldset[disabled] .button.is-link,.runway .button.is-link[disabled],.runway fieldset[disabled] .button.is-link{background-color:#3273dc;border-color:transparent;box-shadow:none}.runway-component .button.is-link.is-inverted,.runway .button.is-link.is-inverted{background-color:#fff;color:#3273dc}.runway-component .button.is-link.is-inverted.is-hovered,.runway-component .button.is-link.is-inverted:hover,.runway .button.is-link.is-inverted.is-hovered,.runway .button.is-link.is-inverted:hover{background-color:#f2f2f2}.runway-component .button.is-link.is-inverted[disabled],.runway-component fieldset[disabled] .button.is-link.is-inverted,.runway .button.is-link.is-inverted[disabled],.runway fieldset[disabled] .button.is-link.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#3273dc}.runway-component .button.is-link.is-loading:after,.runway .button.is-link.is-loading:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-link.is-outlined,.runway .button.is-link.is-outlined{background-color:transparent;border-color:#3273dc;color:#3273dc}.runway-component .button.is-link.is-outlined.is-focused,.runway-component .button.is-link.is-outlined.is-hovered,.runway-component .button.is-link.is-outlined:focus,.runway-component .button.is-link.is-outlined:hover,.runway .button.is-link.is-outlined.is-focused,.runway .button.is-link.is-outlined.is-hovered,.runway .button.is-link.is-outlined:focus,.runway .button.is-link.is-outlined:hover{background-color:#3273dc;border-color:#3273dc;color:#fff}.runway-component .button.is-link.is-outlined.is-loading:after,.runway .button.is-link.is-outlined.is-loading:after{border-color:transparent transparent #3273dc #3273dc!important}.runway-component .button.is-link.is-outlined.is-loading.is-focused:after,.runway-component .button.is-link.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-link.is-outlined.is-loading:focus:after,.runway-component .button.is-link.is-outlined.is-loading:hover:after,.runway .button.is-link.is-outlined.is-loading.is-focused:after,.runway .button.is-link.is-outlined.is-loading.is-hovered:after,.runway .button.is-link.is-outlined.is-loading:focus:after,.runway .button.is-link.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-link.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-link.is-outlined,.runway .button.is-link.is-outlined[disabled],.runway fieldset[disabled] .button.is-link.is-outlined{background-color:transparent;border-color:#3273dc;box-shadow:none;color:#3273dc}.runway-component .button.is-link.is-inverted.is-outlined,.runway .button.is-link.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.runway-component .button.is-link.is-inverted.is-outlined.is-focused,.runway-component .button.is-link.is-inverted.is-outlined.is-hovered,.runway-component .button.is-link.is-inverted.is-outlined:focus,.runway-component .button.is-link.is-inverted.is-outlined:hover,.runway .button.is-link.is-inverted.is-outlined.is-focused,.runway .button.is-link.is-inverted.is-outlined.is-hovered,.runway .button.is-link.is-inverted.is-outlined:focus,.runway .button.is-link.is-inverted.is-outlined:hover{background-color:#fff;color:#3273dc}.runway-component .button.is-link.is-inverted.is-outlined.is-loading.is-focused:after,.runway-component .button.is-link.is-inverted.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-link.is-inverted.is-outlined.is-loading:focus:after,.runway-component .button.is-link.is-inverted.is-outlined.is-loading:hover:after,.runway .button.is-link.is-inverted.is-outlined.is-loading.is-focused:after,.runway .button.is-link.is-inverted.is-outlined.is-loading.is-hovered:after,.runway .button.is-link.is-inverted.is-outlined.is-loading:focus:after,.runway .button.is-link.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #3273dc #3273dc!important}.runway-component .button.is-link.is-inverted.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-link.is-inverted.is-outlined,.runway .button.is-link.is-inverted.is-outlined[disabled],.runway fieldset[disabled] .button.is-link.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.runway-component .button.is-link.is-light,.runway .button.is-link.is-light{background-color:#eef3fc;color:#2160c4}.runway-component .button.is-link.is-light.is-hovered,.runway-component .button.is-link.is-light:hover,.runway .button.is-link.is-light.is-hovered,.runway .button.is-link.is-light:hover{background-color:#e3ecfa;border-color:transparent;color:#2160c4}.runway-component .button.is-link.is-light.is-active,.runway-component .button.is-link.is-light:active,.runway .button.is-link.is-light.is-active,.runway .button.is-link.is-light:active{background-color:#d8e4f8;border-color:transparent;color:#2160c4}.runway-component .button.is-info,.runway .button.is-info{background-color:#3298dc;border-color:transparent;color:#fff}.runway-component .button.is-info.is-hovered,.runway-component .button.is-info:hover,.runway .button.is-info.is-hovered,.runway .button.is-info:hover{background-color:#2793da;border-color:transparent;color:#fff}.runway-component .button.is-info.is-focused,.runway-component .button.is-info:focus,.runway .button.is-info.is-focused,.runway .button.is-info:focus{border-color:transparent;color:#fff}.runway-component .button.is-info.is-focused:not(:active),.runway-component .button.is-info:focus:not(:active),.runway .button.is-info.is-focused:not(:active),.runway .button.is-info:focus:not(:active){box-shadow:0 0 0 .125em rgba(50,152,220,.25)}.runway-component .button.is-info.is-active,.runway-component .button.is-info:active,.runway .button.is-info.is-active,.runway .button.is-info:active{background-color:#238cd1;border-color:transparent;color:#fff}.runway-component .button.is-info[disabled],.runway-component fieldset[disabled] .button.is-info,.runway .button.is-info[disabled],.runway fieldset[disabled] .button.is-info{background-color:#3298dc;border-color:transparent;box-shadow:none}.runway-component .button.is-info.is-inverted,.runway .button.is-info.is-inverted{background-color:#fff;color:#3298dc}.runway-component .button.is-info.is-inverted.is-hovered,.runway-component .button.is-info.is-inverted:hover,.runway .button.is-info.is-inverted.is-hovered,.runway .button.is-info.is-inverted:hover{background-color:#f2f2f2}.runway-component .button.is-info.is-inverted[disabled],.runway-component fieldset[disabled] .button.is-info.is-inverted,.runway .button.is-info.is-inverted[disabled],.runway fieldset[disabled] .button.is-info.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#3298dc}.runway-component .button.is-info.is-loading:after,.runway .button.is-info.is-loading:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-info.is-outlined,.runway .button.is-info.is-outlined{background-color:transparent;border-color:#3298dc;color:#3298dc}.runway-component .button.is-info.is-outlined.is-focused,.runway-component .button.is-info.is-outlined.is-hovered,.runway-component .button.is-info.is-outlined:focus,.runway-component .button.is-info.is-outlined:hover,.runway .button.is-info.is-outlined.is-focused,.runway .button.is-info.is-outlined.is-hovered,.runway .button.is-info.is-outlined:focus,.runway .button.is-info.is-outlined:hover{background-color:#3298dc;border-color:#3298dc;color:#fff}.runway-component .button.is-info.is-outlined.is-loading:after,.runway .button.is-info.is-outlined.is-loading:after{border-color:transparent transparent #3298dc #3298dc!important}.runway-component .button.is-info.is-outlined.is-loading.is-focused:after,.runway-component .button.is-info.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-info.is-outlined.is-loading:focus:after,.runway-component .button.is-info.is-outlined.is-loading:hover:after,.runway .button.is-info.is-outlined.is-loading.is-focused:after,.runway .button.is-info.is-outlined.is-loading.is-hovered:after,.runway .button.is-info.is-outlined.is-loading:focus:after,.runway .button.is-info.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-info.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-info.is-outlined,.runway .button.is-info.is-outlined[disabled],.runway fieldset[disabled] .button.is-info.is-outlined{background-color:transparent;border-color:#3298dc;box-shadow:none;color:#3298dc}.runway-component .button.is-info.is-inverted.is-outlined,.runway .button.is-info.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.runway-component .button.is-info.is-inverted.is-outlined.is-focused,.runway-component .button.is-info.is-inverted.is-outlined.is-hovered,.runway-component .button.is-info.is-inverted.is-outlined:focus,.runway-component .button.is-info.is-inverted.is-outlined:hover,.runway .button.is-info.is-inverted.is-outlined.is-focused,.runway .button.is-info.is-inverted.is-outlined.is-hovered,.runway .button.is-info.is-inverted.is-outlined:focus,.runway .button.is-info.is-inverted.is-outlined:hover{background-color:#fff;color:#3298dc}.runway-component .button.is-info.is-inverted.is-outlined.is-loading.is-focused:after,.runway-component .button.is-info.is-inverted.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-info.is-inverted.is-outlined.is-loading:focus:after,.runway-component .button.is-info.is-inverted.is-outlined.is-loading:hover:after,.runway .button.is-info.is-inverted.is-outlined.is-loading.is-focused:after,.runway .button.is-info.is-inverted.is-outlined.is-loading.is-hovered:after,.runway .button.is-info.is-inverted.is-outlined.is-loading:focus:after,.runway .button.is-info.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #3298dc #3298dc!important}.runway-component .button.is-info.is-inverted.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-info.is-inverted.is-outlined,.runway .button.is-info.is-inverted.is-outlined[disabled],.runway fieldset[disabled] .button.is-info.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.runway-component .button.is-info.is-light,.runway .button.is-info.is-light{background-color:#eef6fc;color:#1d72aa}.runway-component .button.is-info.is-light.is-hovered,.runway-component .button.is-info.is-light:hover,.runway .button.is-info.is-light.is-hovered,.runway .button.is-info.is-light:hover{background-color:#e3f1fa;border-color:transparent;color:#1d72aa}.runway-component .button.is-info.is-light.is-active,.runway-component .button.is-info.is-light:active,.runway .button.is-info.is-light.is-active,.runway .button.is-info.is-light:active{background-color:#d8ebf8;border-color:transparent;color:#1d72aa}.runway-component .button.is-success,.runway .button.is-success{background-color:#48c774;border-color:transparent;color:#fff}.runway-component .button.is-success.is-hovered,.runway-component .button.is-success:hover,.runway .button.is-success.is-hovered,.runway .button.is-success:hover{background-color:#3ec46d;border-color:transparent;color:#fff}.runway-component .button.is-success.is-focused,.runway-component .button.is-success:focus,.runway .button.is-success.is-focused,.runway .button.is-success:focus{border-color:transparent;color:#fff}.runway-component .button.is-success.is-focused:not(:active),.runway-component .button.is-success:focus:not(:active),.runway .button.is-success.is-focused:not(:active),.runway .button.is-success:focus:not(:active){box-shadow:0 0 0 .125em rgba(72,199,116,.25)}.runway-component .button.is-success.is-active,.runway-component .button.is-success:active,.runway .button.is-success.is-active,.runway .button.is-success:active{background-color:#3abb67;border-color:transparent;color:#fff}.runway-component .button.is-success[disabled],.runway-component fieldset[disabled] .button.is-success,.runway .button.is-success[disabled],.runway fieldset[disabled] .button.is-success{background-color:#48c774;border-color:transparent;box-shadow:none}.runway-component .button.is-success.is-inverted,.runway .button.is-success.is-inverted{background-color:#fff;color:#48c774}.runway-component .button.is-success.is-inverted.is-hovered,.runway-component .button.is-success.is-inverted:hover,.runway .button.is-success.is-inverted.is-hovered,.runway .button.is-success.is-inverted:hover{background-color:#f2f2f2}.runway-component .button.is-success.is-inverted[disabled],.runway-component fieldset[disabled] .button.is-success.is-inverted,.runway .button.is-success.is-inverted[disabled],.runway fieldset[disabled] .button.is-success.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#48c774}.runway-component .button.is-success.is-loading:after,.runway .button.is-success.is-loading:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-success.is-outlined,.runway .button.is-success.is-outlined{background-color:transparent;border-color:#48c774;color:#48c774}.runway-component .button.is-success.is-outlined.is-focused,.runway-component .button.is-success.is-outlined.is-hovered,.runway-component .button.is-success.is-outlined:focus,.runway-component .button.is-success.is-outlined:hover,.runway .button.is-success.is-outlined.is-focused,.runway .button.is-success.is-outlined.is-hovered,.runway .button.is-success.is-outlined:focus,.runway .button.is-success.is-outlined:hover{background-color:#48c774;border-color:#48c774;color:#fff}.runway-component .button.is-success.is-outlined.is-loading:after,.runway .button.is-success.is-outlined.is-loading:after{border-color:transparent transparent #48c774 #48c774!important}.runway-component .button.is-success.is-outlined.is-loading.is-focused:after,.runway-component .button.is-success.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-success.is-outlined.is-loading:focus:after,.runway-component .button.is-success.is-outlined.is-loading:hover:after,.runway .button.is-success.is-outlined.is-loading.is-focused:after,.runway .button.is-success.is-outlined.is-loading.is-hovered:after,.runway .button.is-success.is-outlined.is-loading:focus:after,.runway .button.is-success.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-success.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-success.is-outlined,.runway .button.is-success.is-outlined[disabled],.runway fieldset[disabled] .button.is-success.is-outlined{background-color:transparent;border-color:#48c774;box-shadow:none;color:#48c774}.runway-component .button.is-success.is-inverted.is-outlined,.runway .button.is-success.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.runway-component .button.is-success.is-inverted.is-outlined.is-focused,.runway-component .button.is-success.is-inverted.is-outlined.is-hovered,.runway-component .button.is-success.is-inverted.is-outlined:focus,.runway-component .button.is-success.is-inverted.is-outlined:hover,.runway .button.is-success.is-inverted.is-outlined.is-focused,.runway .button.is-success.is-inverted.is-outlined.is-hovered,.runway .button.is-success.is-inverted.is-outlined:focus,.runway .button.is-success.is-inverted.is-outlined:hover{background-color:#fff;color:#48c774}.runway-component .button.is-success.is-inverted.is-outlined.is-loading.is-focused:after,.runway-component .button.is-success.is-inverted.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-success.is-inverted.is-outlined.is-loading:focus:after,.runway-component .button.is-success.is-inverted.is-outlined.is-loading:hover:after,.runway .button.is-success.is-inverted.is-outlined.is-loading.is-focused:after,.runway .button.is-success.is-inverted.is-outlined.is-loading.is-hovered:after,.runway .button.is-success.is-inverted.is-outlined.is-loading:focus:after,.runway .button.is-success.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #48c774 #48c774!important}.runway-component .button.is-success.is-inverted.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-success.is-inverted.is-outlined,.runway .button.is-success.is-inverted.is-outlined[disabled],.runway fieldset[disabled] .button.is-success.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.runway-component .button.is-success.is-light,.runway .button.is-success.is-light{background-color:#effaf3;color:#257942}.runway-component .button.is-success.is-light.is-hovered,.runway-component .button.is-success.is-light:hover,.runway .button.is-success.is-light.is-hovered,.runway .button.is-success.is-light:hover{background-color:#e6f7ec;border-color:transparent;color:#257942}.runway-component .button.is-success.is-light.is-active,.runway-component .button.is-success.is-light:active,.runway .button.is-success.is-light.is-active,.runway .button.is-success.is-light:active{background-color:#dcf4e4;border-color:transparent;color:#257942}.runway-component .button.is-warning,.runway .button.is-warning{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .button.is-warning.is-hovered,.runway-component .button.is-warning:hover,.runway .button.is-warning.is-hovered,.runway .button.is-warning:hover{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .button.is-warning.is-focused,.runway-component .button.is-warning:focus,.runway .button.is-warning.is-focused,.runway .button.is-warning:focus{border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .button.is-warning.is-focused:not(:active),.runway-component .button.is-warning:focus:not(:active),.runway .button.is-warning.is-focused:not(:active),.runway .button.is-warning:focus:not(:active){box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.runway-component .button.is-warning.is-active,.runway-component .button.is-warning:active,.runway .button.is-warning.is-active,.runway .button.is-warning:active{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .button.is-warning[disabled],.runway-component fieldset[disabled] .button.is-warning,.runway .button.is-warning[disabled],.runway fieldset[disabled] .button.is-warning{background-color:#ffdd57;border-color:transparent;box-shadow:none}.runway-component .button.is-warning.is-inverted,.runway .button.is-warning.is-inverted{background-color:rgba(0,0,0,.7);color:#ffdd57}.runway-component .button.is-warning.is-inverted.is-hovered,.runway-component .button.is-warning.is-inverted:hover,.runway .button.is-warning.is-inverted.is-hovered,.runway .button.is-warning.is-inverted:hover{background-color:rgba(0,0,0,.7)}.runway-component .button.is-warning.is-inverted[disabled],.runway-component fieldset[disabled] .button.is-warning.is-inverted,.runway .button.is-warning.is-inverted[disabled],.runway fieldset[disabled] .button.is-warning.is-inverted{background-color:rgba(0,0,0,.7);border-color:transparent;box-shadow:none;color:#ffdd57}.runway-component .button.is-warning.is-loading:after,.runway .button.is-warning.is-loading:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.runway-component .button.is-warning.is-outlined,.runway .button.is-warning.is-outlined{background-color:transparent;border-color:#ffdd57;color:#ffdd57}.runway-component .button.is-warning.is-outlined.is-focused,.runway-component .button.is-warning.is-outlined.is-hovered,.runway-component .button.is-warning.is-outlined:focus,.runway-component .button.is-warning.is-outlined:hover,.runway .button.is-warning.is-outlined.is-focused,.runway .button.is-warning.is-outlined.is-hovered,.runway .button.is-warning.is-outlined:focus,.runway .button.is-warning.is-outlined:hover{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.runway-component .button.is-warning.is-outlined.is-loading:after,.runway .button.is-warning.is-outlined.is-loading:after{border-color:transparent transparent #ffdd57 #ffdd57!important}.runway-component .button.is-warning.is-outlined.is-loading.is-focused:after,.runway-component .button.is-warning.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-warning.is-outlined.is-loading:focus:after,.runway-component .button.is-warning.is-outlined.is-loading:hover:after,.runway .button.is-warning.is-outlined.is-loading.is-focused:after,.runway .button.is-warning.is-outlined.is-loading.is-hovered:after,.runway .button.is-warning.is-outlined.is-loading:focus:after,.runway .button.is-warning.is-outlined.is-loading:hover:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.runway-component .button.is-warning.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-warning.is-outlined,.runway .button.is-warning.is-outlined[disabled],.runway fieldset[disabled] .button.is-warning.is-outlined{background-color:transparent;border-color:#ffdd57;box-shadow:none;color:#ffdd57}.runway-component .button.is-warning.is-inverted.is-outlined,.runway .button.is-warning.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);color:rgba(0,0,0,.7)}.runway-component .button.is-warning.is-inverted.is-outlined.is-focused,.runway-component .button.is-warning.is-inverted.is-outlined.is-hovered,.runway-component .button.is-warning.is-inverted.is-outlined:focus,.runway-component .button.is-warning.is-inverted.is-outlined:hover,.runway .button.is-warning.is-inverted.is-outlined.is-focused,.runway .button.is-warning.is-inverted.is-outlined.is-hovered,.runway .button.is-warning.is-inverted.is-outlined:focus,.runway .button.is-warning.is-inverted.is-outlined:hover{background-color:rgba(0,0,0,.7);color:#ffdd57}.runway-component .button.is-warning.is-inverted.is-outlined.is-loading.is-focused:after,.runway-component .button.is-warning.is-inverted.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-warning.is-inverted.is-outlined.is-loading:focus:after,.runway-component .button.is-warning.is-inverted.is-outlined.is-loading:hover:after,.runway .button.is-warning.is-inverted.is-outlined.is-loading.is-focused:after,.runway .button.is-warning.is-inverted.is-outlined.is-loading.is-hovered:after,.runway .button.is-warning.is-inverted.is-outlined.is-loading:focus:after,.runway .button.is-warning.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #ffdd57 #ffdd57!important}.runway-component .button.is-warning.is-inverted.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-warning.is-inverted.is-outlined,.runway .button.is-warning.is-inverted.is-outlined[disabled],.runway fieldset[disabled] .button.is-warning.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);box-shadow:none;color:rgba(0,0,0,.7)}.runway-component .button.is-warning.is-light,.runway .button.is-warning.is-light{background-color:#fffbeb;color:#947600}.runway-component .button.is-warning.is-light.is-hovered,.runway-component .button.is-warning.is-light:hover,.runway .button.is-warning.is-light.is-hovered,.runway .button.is-warning.is-light:hover{background-color:#fff8de;border-color:transparent;color:#947600}.runway-component .button.is-warning.is-light.is-active,.runway-component .button.is-warning.is-light:active,.runway .button.is-warning.is-light.is-active,.runway .button.is-warning.is-light:active{background-color:#fff6d1;border-color:transparent;color:#947600}.runway-component .button.is-danger,.runway .button.is-danger{background-color:#f14668;border-color:transparent;color:#fff}.runway-component .button.is-danger.is-hovered,.runway-component .button.is-danger:hover,.runway .button.is-danger.is-hovered,.runway .button.is-danger:hover{background-color:#f03a5f;border-color:transparent;color:#fff}.runway-component .button.is-danger.is-focused,.runway-component .button.is-danger:focus,.runway .button.is-danger.is-focused,.runway .button.is-danger:focus{border-color:transparent;color:#fff}.runway-component .button.is-danger.is-focused:not(:active),.runway-component .button.is-danger:focus:not(:active),.runway .button.is-danger.is-focused:not(:active),.runway .button.is-danger:focus:not(:active){box-shadow:0 0 0 .125em rgba(241,70,104,.25)}.runway-component .button.is-danger.is-active,.runway-component .button.is-danger:active,.runway .button.is-danger.is-active,.runway .button.is-danger:active{background-color:#ef2e55;border-color:transparent;color:#fff}.runway-component .button.is-danger[disabled],.runway-component fieldset[disabled] .button.is-danger,.runway .button.is-danger[disabled],.runway fieldset[disabled] .button.is-danger{background-color:#f14668;border-color:transparent;box-shadow:none}.runway-component .button.is-danger.is-inverted,.runway .button.is-danger.is-inverted{background-color:#fff;color:#f14668}.runway-component .button.is-danger.is-inverted.is-hovered,.runway-component .button.is-danger.is-inverted:hover,.runway .button.is-danger.is-inverted.is-hovered,.runway .button.is-danger.is-inverted:hover{background-color:#f2f2f2}.runway-component .button.is-danger.is-inverted[disabled],.runway-component fieldset[disabled] .button.is-danger.is-inverted,.runway .button.is-danger.is-inverted[disabled],.runway fieldset[disabled] .button.is-danger.is-inverted{background-color:#fff;border-color:transparent;box-shadow:none;color:#f14668}.runway-component .button.is-danger.is-loading:after,.runway .button.is-danger.is-loading:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-danger.is-outlined,.runway .button.is-danger.is-outlined{background-color:transparent;border-color:#f14668;color:#f14668}.runway-component .button.is-danger.is-outlined.is-focused,.runway-component .button.is-danger.is-outlined.is-hovered,.runway-component .button.is-danger.is-outlined:focus,.runway-component .button.is-danger.is-outlined:hover,.runway .button.is-danger.is-outlined.is-focused,.runway .button.is-danger.is-outlined.is-hovered,.runway .button.is-danger.is-outlined:focus,.runway .button.is-danger.is-outlined:hover{background-color:#f14668;border-color:#f14668;color:#fff}.runway-component .button.is-danger.is-outlined.is-loading:after,.runway .button.is-danger.is-outlined.is-loading:after{border-color:transparent transparent #f14668 #f14668!important}.runway-component .button.is-danger.is-outlined.is-loading.is-focused:after,.runway-component .button.is-danger.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-danger.is-outlined.is-loading:focus:after,.runway-component .button.is-danger.is-outlined.is-loading:hover:after,.runway .button.is-danger.is-outlined.is-loading.is-focused:after,.runway .button.is-danger.is-outlined.is-loading.is-hovered:after,.runway .button.is-danger.is-outlined.is-loading:focus:after,.runway .button.is-danger.is-outlined.is-loading:hover:after{border-color:transparent transparent #fff #fff!important}.runway-component .button.is-danger.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-danger.is-outlined,.runway .button.is-danger.is-outlined[disabled],.runway fieldset[disabled] .button.is-danger.is-outlined{background-color:transparent;border-color:#f14668;box-shadow:none;color:#f14668}.runway-component .button.is-danger.is-inverted.is-outlined,.runway .button.is-danger.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.runway-component .button.is-danger.is-inverted.is-outlined.is-focused,.runway-component .button.is-danger.is-inverted.is-outlined.is-hovered,.runway-component .button.is-danger.is-inverted.is-outlined:focus,.runway-component .button.is-danger.is-inverted.is-outlined:hover,.runway .button.is-danger.is-inverted.is-outlined.is-focused,.runway .button.is-danger.is-inverted.is-outlined.is-hovered,.runway .button.is-danger.is-inverted.is-outlined:focus,.runway .button.is-danger.is-inverted.is-outlined:hover{background-color:#fff;color:#f14668}.runway-component .button.is-danger.is-inverted.is-outlined.is-loading.is-focused:after,.runway-component .button.is-danger.is-inverted.is-outlined.is-loading.is-hovered:after,.runway-component .button.is-danger.is-inverted.is-outlined.is-loading:focus:after,.runway-component .button.is-danger.is-inverted.is-outlined.is-loading:hover:after,.runway .button.is-danger.is-inverted.is-outlined.is-loading.is-focused:after,.runway .button.is-danger.is-inverted.is-outlined.is-loading.is-hovered:after,.runway .button.is-danger.is-inverted.is-outlined.is-loading:focus:after,.runway .button.is-danger.is-inverted.is-outlined.is-loading:hover:after{border-color:transparent transparent #f14668 #f14668!important}.runway-component .button.is-danger.is-inverted.is-outlined[disabled],.runway-component fieldset[disabled] .button.is-danger.is-inverted.is-outlined,.runway .button.is-danger.is-inverted.is-outlined[disabled],.runway fieldset[disabled] .button.is-danger.is-inverted.is-outlined{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.runway-component .button.is-danger.is-light,.runway .button.is-danger.is-light{background-color:#feecf0;color:#cc0f35}.runway-component .button.is-danger.is-light.is-hovered,.runway-component .button.is-danger.is-light:hover,.runway .button.is-danger.is-light.is-hovered,.runway .button.is-danger.is-light:hover{background-color:#fde0e6;border-color:transparent;color:#cc0f35}.runway-component .button.is-danger.is-light.is-active,.runway-component .button.is-danger.is-light:active,.runway .button.is-danger.is-light.is-active,.runway .button.is-danger.is-light:active{background-color:#fcd4dc;border-color:transparent;color:#cc0f35}.runway-component .button.is-small,.runway .button.is-small{border-radius:2px;font-size:.75rem}.runway-component .button.is-normal,.runway .button.is-normal{font-size:1rem}.runway-component .button.is-medium,.runway .button.is-medium{font-size:1.25rem}.runway-component .button.is-large,.runway .button.is-large{font-size:1.5rem}.runway-component .button[disabled],.runway-component fieldset[disabled] .button,.runway .button[disabled],.runway fieldset[disabled] .button{background-color:#fff;border-color:#dbdbdb;box-shadow:none;opacity:.5}.runway-component .button.is-fullwidth,.runway .button.is-fullwidth{display:flex;width:100%}.runway-component .button.is-loading,.runway .button.is-loading{color:transparent!important;pointer-events:none}.runway-component .button.is-loading:after,.runway .button.is-loading:after{position:absolute;left:calc(50% - 0.5em);top:calc(50% - 0.5em);position:absolute!important}.runway-component .button.is-static,.runway .button.is-static{background-color:#f5f5f5;border-color:#dbdbdb;color:#7a7a7a;box-shadow:none;pointer-events:none}.runway-component .button.is-rounded,.runway .button.is-rounded{border-radius:290486px;padding-left:1.25em;padding-right:1.25em}.runway-component .buttons,.runway .buttons{align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start}.runway-component .buttons .button,.runway .buttons .button{margin-bottom:.5rem}.runway-component .buttons .button:not(:last-child):not(.is-fullwidth),.runway .buttons .button:not(:last-child):not(.is-fullwidth){margin-right:.5rem}.runway-component .buttons:last-child,.runway .buttons:last-child{margin-bottom:-.5rem}.runway-component .buttons:not(:last-child),.runway .buttons:not(:last-child){margin-bottom:1rem}.runway-component .buttons.are-small .button:not(.is-normal):not(.is-medium):not(.is-large),.runway .buttons.are-small .button:not(.is-normal):not(.is-medium):not(.is-large){border-radius:2px;font-size:.75rem}.runway-component .buttons.are-medium .button:not(.is-small):not(.is-normal):not(.is-large),.runway .buttons.are-medium .button:not(.is-small):not(.is-normal):not(.is-large){font-size:1.25rem}.runway-component .buttons.are-large .button:not(.is-small):not(.is-normal):not(.is-medium),.runway .buttons.are-large .button:not(.is-small):not(.is-normal):not(.is-medium){font-size:1.5rem}.runway-component .buttons.has-addons .button:not(:first-child),.runway .buttons.has-addons .button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.runway-component .buttons.has-addons .button:not(:last-child),.runway .buttons.has-addons .button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.runway-component .buttons.has-addons .button:last-child,.runway .buttons.has-addons .button:last-child{margin-right:0}.runway-component .buttons.has-addons .button.is-hovered,.runway-component .buttons.has-addons .button:hover,.runway .buttons.has-addons .button.is-hovered,.runway .buttons.has-addons .button:hover{z-index:2}.runway-component .buttons.has-addons .button.is-active,.runway-component .buttons.has-addons .button.is-focused,.runway-component .buttons.has-addons .button.is-selected,.runway-component .buttons.has-addons .button:active,.runway-component .buttons.has-addons .button:focus,.runway .buttons.has-addons .button.is-active,.runway .buttons.has-addons .button.is-focused,.runway .buttons.has-addons .button.is-selected,.runway .buttons.has-addons .button:active,.runway .buttons.has-addons .button:focus{z-index:3}.runway-component .buttons.has-addons .button.is-active:hover,.runway-component .buttons.has-addons .button.is-focused:hover,.runway-component .buttons.has-addons .button.is-selected:hover,.runway-component .buttons.has-addons .button:active:hover,.runway-component .buttons.has-addons .button:focus:hover,.runway .buttons.has-addons .button.is-active:hover,.runway .buttons.has-addons .button.is-focused:hover,.runway .buttons.has-addons .button.is-selected:hover,.runway .buttons.has-addons .button:active:hover,.runway .buttons.has-addons .button:focus:hover{z-index:4}.runway-component .buttons.has-addons .button.is-expanded,.runway .buttons.has-addons .button.is-expanded{flex-grow:1;flex-shrink:1}.runway-component .buttons.is-centered,.runway .buttons.is-centered{justify-content:center}.runway-component .buttons.is-centered:not(.has-addons) .button:not(.is-fullwidth),.runway .buttons.is-centered:not(.has-addons) .button:not(.is-fullwidth){margin-left:.25rem;margin-right:.25rem}.runway-component .buttons.is-right,.runway .buttons.is-right{justify-content:flex-end}.runway-component .buttons.is-right:not(.has-addons) .button:not(.is-fullwidth),.runway .buttons.is-right:not(.has-addons) .button:not(.is-fullwidth){margin-left:.25rem;margin-right:.25rem}.runway-component .container,.runway .container{flex-grow:1;margin:0 auto;position:relative;width:auto}.runway-component .container.is-fluid,.runway .container.is-fluid{max-width:none;padding-left:32px;padding-right:32px;width:100%}@media screen and (min-width:1024px){.runway-component .container,.runway .container{max-width:960px}}@media screen and (max-width:1215px){.runway-component .container.is-widescreen,.runway .container.is-widescreen{max-width:1152px}}@media screen and (max-width:1407px){.runway-component .container.is-fullhd,.runway .container.is-fullhd{max-width:1344px}}@media screen and (min-width:1216px){.runway-component .container,.runway .container{max-width:1152px}}@media screen and (min-width:1408px){.runway-component .container,.runway .container{max-width:1344px}}.runway-component .content li+li,.runway .content li+li{margin-top:.25em}.runway-component .content blockquote:not(:last-child),.runway-component .content dl:not(:last-child),.runway-component .content ol:not(:last-child),.runway-component .content p:not(:last-child),.runway-component .content pre:not(:last-child),.runway-component .content table:not(:last-child),.runway-component .content ul:not(:last-child),.runway .content blockquote:not(:last-child),.runway .content dl:not(:last-child),.runway .content ol:not(:last-child),.runway .content p:not(:last-child),.runway .content pre:not(:last-child),.runway .content table:not(:last-child),.runway .content ul:not(:last-child){margin-bottom:1em}.runway-component .content h1,.runway-component .content h2,.runway-component .content h3,.runway-component .content h4,.runway-component .content h5,.runway-component .content h6,.runway .content h1,.runway .content h2,.runway .content h3,.runway .content h4,.runway .content h5,.runway .content h6{color:#363636;font-weight:600;line-height:1.125}.runway-component .content h1,.runway .content h1{font-size:2em;margin-bottom:.5em}.runway-component .content h1:not(:first-child),.runway .content h1:not(:first-child){margin-top:1em}.runway-component .content h2,.runway .content h2{font-size:1.75em;margin-bottom:.5714em}.runway-component .content h2:not(:first-child),.runway .content h2:not(:first-child){margin-top:1.1428em}.runway-component .content h3,.runway .content h3{font-size:1.5em;margin-bottom:.6666em}.runway-component .content h3:not(:first-child),.runway .content h3:not(:first-child){margin-top:1.3333em}.runway-component .content h4,.runway .content h4{font-size:1.25em;margin-bottom:.8em}.runway-component .content h5,.runway .content h5{font-size:1.125em;margin-bottom:.8888em}.runway-component .content h6,.runway .content h6{font-size:1em;margin-bottom:1em}.runway-component .content blockquote,.runway .content blockquote{background-color:#f5f5f5;border-left:5px solid #dbdbdb;padding:1.25em 1.5em}.runway-component .content ol,.runway .content ol{list-style-position:outside;margin-left:2em;margin-top:1em}.runway-component .content ol:not([type]),.runway .content ol:not([type]){list-style-type:decimal}.runway-component .content ol:not([type]).is-lower-alpha,.runway .content ol:not([type]).is-lower-alpha{list-style-type:lower-alpha}.runway-component .content ol:not([type]).is-lower-roman,.runway .content ol:not([type]).is-lower-roman{list-style-type:lower-roman}.runway-component .content ol:not([type]).is-upper-alpha,.runway .content ol:not([type]).is-upper-alpha{list-style-type:upper-alpha}.runway-component .content ol:not([type]).is-upper-roman,.runway .content ol:not([type]).is-upper-roman{list-style-type:upper-roman}.runway-component .content ul,.runway .content ul{list-style:disc outside;margin-left:2em;margin-top:1em}.runway-component .content ul ul,.runway .content ul ul{list-style-type:circle;margin-top:.5em}.runway-component .content ul ul ul,.runway .content ul ul ul{list-style-type:square}.runway-component .content dd,.runway .content dd{margin-left:2em}.runway-component .content figure,.runway .content figure{margin-left:2em;margin-right:2em;text-align:center}.runway-component .content figure:not(:first-child),.runway .content figure:not(:first-child){margin-top:2em}.runway-component .content figure:not(:last-child),.runway .content figure:not(:last-child){margin-bottom:2em}.runway-component .content figure img,.runway .content figure img{display:inline-block}.runway-component .content figure figcaption,.runway .content figure figcaption{font-style:italic}.runway-component .content pre,.runway .content pre{-webkit-overflow-scrolling:touch;overflow-x:auto;padding:1.25em 1.5em;white-space:pre;word-wrap:normal}.runway-component .content sub,.runway-component .content sup,.runway .content sub,.runway .content sup{font-size:75%}.runway-component .content table,.runway .content table{width:100%}.runway-component .content table td,.runway-component .content table th,.runway .content table td,.runway .content table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.runway-component .content table th,.runway .content table th{color:#363636}.runway-component .content table th:not([align]),.runway .content table th:not([align]){text-align:inherit}.runway-component .content table thead td,.runway-component .content table thead th,.runway .content table thead td,.runway .content table thead th{border-width:0 0 2px;color:#363636}.runway-component .content table tfoot td,.runway-component .content table tfoot th,.runway .content table tfoot td,.runway .content table tfoot th{border-width:2px 0 0;color:#363636}.runway-component .content table tbody tr:last-child td,.runway-component .content table tbody tr:last-child th,.runway .content table tbody tr:last-child td,.runway .content table tbody tr:last-child th{border-bottom-width:0}.runway-component .content .tabs li+li,.runway .content .tabs li+li{margin-top:0}.runway-component .content.is-small,.runway .content.is-small{font-size:.75rem}.runway-component .content.is-medium,.runway .content.is-medium{font-size:1.25rem}.runway-component .content.is-large,.runway .content.is-large{font-size:1.5rem}.runway-component .icon,.runway .icon{align-items:center;display:inline-flex;justify-content:center;height:1.5rem;width:1.5rem}.runway-component .icon.is-small,.runway .icon.is-small{height:1rem;width:1rem}.runway-component .icon.is-medium,.runway .icon.is-medium{height:2rem;width:2rem}.runway-component .icon.is-large,.runway .icon.is-large{height:3rem;width:3rem}.runway-component .image,.runway .image{display:block;position:relative}.runway-component .image img,.runway .image img{display:block;height:auto;width:100%}.runway-component .image img.is-rounded,.runway .image img.is-rounded{border-radius:290486px}.runway-component .image.is-fullwidth,.runway .image.is-fullwidth{width:100%}.runway-component .image.is-1by1 .has-ratio,.runway-component .image.is-1by1 img,.runway-component .image.is-1by2 .has-ratio,.runway-component .image.is-1by2 img,.runway-component .image.is-1by3 .has-ratio,.runway-component .image.is-1by3 img,.runway-component .image.is-2by1 .has-ratio,.runway-component .image.is-2by1 img,.runway-component .image.is-2by3 .has-ratio,.runway-component .image.is-2by3 img,.runway-component .image.is-3by1 .has-ratio,.runway-component .image.is-3by1 img,.runway-component .image.is-3by2 .has-ratio,.runway-component .image.is-3by2 img,.runway-component .image.is-3by4 .has-ratio,.runway-component .image.is-3by4 img,.runway-component .image.is-3by5 .has-ratio,.runway-component .image.is-3by5 img,.runway-component .image.is-4by3 .has-ratio,.runway-component .image.is-4by3 img,.runway-component .image.is-4by5 .has-ratio,.runway-component .image.is-4by5 img,.runway-component .image.is-5by3 .has-ratio,.runway-component .image.is-5by3 img,.runway-component .image.is-5by4 .has-ratio,.runway-component .image.is-5by4 img,.runway-component .image.is-9by16 .has-ratio,.runway-component .image.is-9by16 img,.runway-component .image.is-16by9 .has-ratio,.runway-component .image.is-16by9 img,.runway-component .image.is-square .has-ratio,.runway-component .image.is-square img,.runway .image.is-1by1 .has-ratio,.runway .image.is-1by1 img,.runway .image.is-1by2 .has-ratio,.runway .image.is-1by2 img,.runway .image.is-1by3 .has-ratio,.runway .image.is-1by3 img,.runway .image.is-2by1 .has-ratio,.runway .image.is-2by1 img,.runway .image.is-2by3 .has-ratio,.runway .image.is-2by3 img,.runway .image.is-3by1 .has-ratio,.runway .image.is-3by1 img,.runway .image.is-3by2 .has-ratio,.runway .image.is-3by2 img,.runway .image.is-3by4 .has-ratio,.runway .image.is-3by4 img,.runway .image.is-3by5 .has-ratio,.runway .image.is-3by5 img,.runway .image.is-4by3 .has-ratio,.runway .image.is-4by3 img,.runway .image.is-4by5 .has-ratio,.runway .image.is-4by5 img,.runway .image.is-5by3 .has-ratio,.runway .image.is-5by3 img,.runway .image.is-5by4 .has-ratio,.runway .image.is-5by4 img,.runway .image.is-9by16 .has-ratio,.runway .image.is-9by16 img,.runway .image.is-16by9 .has-ratio,.runway .image.is-16by9 img,.runway .image.is-square .has-ratio,.runway .image.is-square img{height:100%;width:100%}.runway-component .image.is-1by1,.runway-component .image.is-square,.runway .image.is-1by1,.runway .image.is-square{padding-top:100%}.runway-component .image.is-5by4,.runway .image.is-5by4{padding-top:80%}.runway-component .image.is-4by3,.runway .image.is-4by3{padding-top:75%}.runway-component .image.is-3by2,.runway .image.is-3by2{padding-top:66.6666%}.runway-component .image.is-5by3,.runway .image.is-5by3{padding-top:60%}.runway-component .image.is-16by9,.runway .image.is-16by9{padding-top:56.25%}.runway-component .image.is-2by1,.runway .image.is-2by1{padding-top:50%}.runway-component .image.is-3by1,.runway .image.is-3by1{padding-top:33.3333%}.runway-component .image.is-4by5,.runway .image.is-4by5{padding-top:125%}.runway-component .image.is-3by4,.runway .image.is-3by4{padding-top:133.3333%}.runway-component .image.is-2by3,.runway .image.is-2by3{padding-top:150%}.runway-component .image.is-3by5,.runway .image.is-3by5{padding-top:166.6666%}.runway-component .image.is-9by16,.runway .image.is-9by16{padding-top:177.7777%}.runway-component .image.is-1by2,.runway .image.is-1by2{padding-top:200%}.runway-component .image.is-1by3,.runway .image.is-1by3{padding-top:300%}.runway-component .image.is-16x16,.runway .image.is-16x16{height:16px;width:16px}.runway-component .image.is-24x24,.runway .image.is-24x24{height:24px;width:24px}.runway-component .image.is-32x32,.runway .image.is-32x32{height:32px;width:32px}.runway-component .image.is-48x48,.runway .image.is-48x48{height:48px;width:48px}.runway-component .image.is-64x64,.runway .image.is-64x64{height:64px;width:64px}.runway-component .image.is-96x96,.runway .image.is-96x96{height:96px;width:96px}.runway-component .image.is-128x128,.runway .image.is-128x128{height:128px;width:128px}.runway-component .notification,.runway .notification{background-color:#f5f5f5;border-radius:4px;position:relative;padding:1.25rem 2.5rem 1.25rem 1.5rem}.runway-component .notification a:not(.button):not(.dropdown-item),.runway .notification a:not(.button):not(.dropdown-item){color:currentColor;text-decoration:underline}.runway-component .notification strong,.runway .notification strong{color:currentColor}.runway-component .notification code,.runway-component .notification pre,.runway .notification code,.runway .notification pre{background:#fff}.runway-component .notification pre code,.runway .notification pre code{background:0 0}.runway-component .notification>.delete,.runway .notification>.delete{right:.5rem;position:absolute;top:.5rem}.runway-component .notification .content,.runway-component .notification .subtitle,.runway-component .notification .title,.runway .notification .content,.runway .notification .subtitle,.runway .notification .title{color:currentColor}.runway-component .notification.is-white,.runway .notification.is-white{background-color:#fff;color:#0a0a0a}.runway-component .notification.is-black,.runway .notification.is-black{background-color:#0a0a0a;color:#fff}.runway-component .notification.is-light,.runway .notification.is-light{background-color:#f5f5f5;color:rgba(0,0,0,.7)}.runway-component .notification.is-dark,.runway .notification.is-dark{background-color:#363636;color:#fff}.runway-component .notification.is-primary,.runway .notification.is-primary{background-color:#00d1b2;color:#fff}.runway-component .notification.is-primary.is-light,.runway .notification.is-primary.is-light{background-color:#ebfffc;color:#00947e}.runway-component .notification.is-link,.runway .notification.is-link{background-color:#3273dc;color:#fff}.runway-component .notification.is-link.is-light,.runway .notification.is-link.is-light{background-color:#eef3fc;color:#2160c4}.runway-component .notification.is-info,.runway .notification.is-info{background-color:#3298dc;color:#fff}.runway-component .notification.is-info.is-light,.runway .notification.is-info.is-light{background-color:#eef6fc;color:#1d72aa}.runway-component .notification.is-success,.runway .notification.is-success{background-color:#48c774;color:#fff}.runway-component .notification.is-success.is-light,.runway .notification.is-success.is-light{background-color:#effaf3;color:#257942}.runway-component .notification.is-warning,.runway .notification.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.runway-component .notification.is-warning.is-light,.runway .notification.is-warning.is-light{background-color:#fffbeb;color:#947600}.runway-component .notification.is-danger,.runway .notification.is-danger{background-color:#f14668;color:#fff}.runway-component .notification.is-danger.is-light,.runway .notification.is-danger.is-light{background-color:#feecf0;color:#cc0f35}.runway-component .progress,.runway .progress{-moz-appearance:none;-webkit-appearance:none;border:none;border-radius:290486px;display:block;height:1rem;overflow:hidden;padding:0;width:100%}.runway-component .progress::-webkit-progress-bar,.runway .progress::-webkit-progress-bar{background-color:#ededed}.runway-component .progress::-webkit-progress-value,.runway .progress::-webkit-progress-value{background-color:#4a4a4a}.runway-component .progress::-moz-progress-bar,.runway .progress::-moz-progress-bar{background-color:#4a4a4a}.runway-component .progress::-ms-fill,.runway .progress::-ms-fill{background-color:#4a4a4a;border:none}.runway-component .progress.is-white::-webkit-progress-value,.runway .progress.is-white::-webkit-progress-value{background-color:#fff}.runway-component .progress.is-white::-moz-progress-bar,.runway .progress.is-white::-moz-progress-bar{background-color:#fff}.runway-component .progress.is-white::-ms-fill,.runway .progress.is-white::-ms-fill{background-color:#fff}.runway-component .progress.is-white:indeterminate,.runway .progress.is-white:indeterminate{background-image:linear-gradient(90deg,#fff 30%,#ededed 0)}.runway-component .progress.is-black::-webkit-progress-value,.runway .progress.is-black::-webkit-progress-value{background-color:#0a0a0a}.runway-component .progress.is-black::-moz-progress-bar,.runway .progress.is-black::-moz-progress-bar{background-color:#0a0a0a}.runway-component .progress.is-black::-ms-fill,.runway .progress.is-black::-ms-fill{background-color:#0a0a0a}.runway-component .progress.is-black:indeterminate,.runway .progress.is-black:indeterminate{background-image:linear-gradient(90deg,#0a0a0a 30%,#ededed 0)}.runway-component .progress.is-light::-webkit-progress-value,.runway .progress.is-light::-webkit-progress-value{background-color:#f5f5f5}.runway-component .progress.is-light::-moz-progress-bar,.runway .progress.is-light::-moz-progress-bar{background-color:#f5f5f5}.runway-component .progress.is-light::-ms-fill,.runway .progress.is-light::-ms-fill{background-color:#f5f5f5}.runway-component .progress.is-light:indeterminate,.runway .progress.is-light:indeterminate{background-image:linear-gradient(90deg,#f5f5f5 30%,#ededed 0)}.runway-component .progress.is-dark::-webkit-progress-value,.runway .progress.is-dark::-webkit-progress-value{background-color:#363636}.runway-component .progress.is-dark::-moz-progress-bar,.runway .progress.is-dark::-moz-progress-bar{background-color:#363636}.runway-component .progress.is-dark::-ms-fill,.runway .progress.is-dark::-ms-fill{background-color:#363636}.runway-component .progress.is-dark:indeterminate,.runway .progress.is-dark:indeterminate{background-image:linear-gradient(90deg,#363636 30%,#ededed 0)}.runway-component .progress.is-primary::-webkit-progress-value,.runway .progress.is-primary::-webkit-progress-value{background-color:#00d1b2}.runway-component .progress.is-primary::-moz-progress-bar,.runway .progress.is-primary::-moz-progress-bar{background-color:#00d1b2}.runway-component .progress.is-primary::-ms-fill,.runway .progress.is-primary::-ms-fill{background-color:#00d1b2}.runway-component .progress.is-primary:indeterminate,.runway .progress.is-primary:indeterminate{background-image:linear-gradient(90deg,#00d1b2 30%,#ededed 0)}.runway-component .progress.is-link::-webkit-progress-value,.runway .progress.is-link::-webkit-progress-value{background-color:#3273dc}.runway-component .progress.is-link::-moz-progress-bar,.runway .progress.is-link::-moz-progress-bar{background-color:#3273dc}.runway-component .progress.is-link::-ms-fill,.runway .progress.is-link::-ms-fill{background-color:#3273dc}.runway-component .progress.is-link:indeterminate,.runway .progress.is-link:indeterminate{background-image:linear-gradient(90deg,#3273dc 30%,#ededed 0)}.runway-component .progress.is-info::-webkit-progress-value,.runway .progress.is-info::-webkit-progress-value{background-color:#3298dc}.runway-component .progress.is-info::-moz-progress-bar,.runway .progress.is-info::-moz-progress-bar{background-color:#3298dc}.runway-component .progress.is-info::-ms-fill,.runway .progress.is-info::-ms-fill{background-color:#3298dc}.runway-component .progress.is-info:indeterminate,.runway .progress.is-info:indeterminate{background-image:linear-gradient(90deg,#3298dc 30%,#ededed 0)}.runway-component .progress.is-success::-webkit-progress-value,.runway .progress.is-success::-webkit-progress-value{background-color:#48c774}.runway-component .progress.is-success::-moz-progress-bar,.runway .progress.is-success::-moz-progress-bar{background-color:#48c774}.runway-component .progress.is-success::-ms-fill,.runway .progress.is-success::-ms-fill{background-color:#48c774}.runway-component .progress.is-success:indeterminate,.runway .progress.is-success:indeterminate{background-image:linear-gradient(90deg,#48c774 30%,#ededed 0)}.runway-component .progress.is-warning::-webkit-progress-value,.runway .progress.is-warning::-webkit-progress-value{background-color:#ffdd57}.runway-component .progress.is-warning::-moz-progress-bar,.runway .progress.is-warning::-moz-progress-bar{background-color:#ffdd57}.runway-component .progress.is-warning::-ms-fill,.runway .progress.is-warning::-ms-fill{background-color:#ffdd57}.runway-component .progress.is-warning:indeterminate,.runway .progress.is-warning:indeterminate{background-image:linear-gradient(90deg,#ffdd57 30%,#ededed 0)}.runway-component .progress.is-danger::-webkit-progress-value,.runway .progress.is-danger::-webkit-progress-value{background-color:#f14668}.runway-component .progress.is-danger::-moz-progress-bar,.runway .progress.is-danger::-moz-progress-bar{background-color:#f14668}.runway-component .progress.is-danger::-ms-fill,.runway .progress.is-danger::-ms-fill{background-color:#f14668}.runway-component .progress.is-danger:indeterminate,.runway .progress.is-danger:indeterminate{background-image:linear-gradient(90deg,#f14668 30%,#ededed 0)}.runway-component .progress:indeterminate,.runway .progress:indeterminate{-webkit-animation-duration:1.5s;animation-duration:1.5s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:moveIndeterminate;animation-name:moveIndeterminate;-webkit-animation-timing-function:linear;animation-timing-function:linear;background-color:#ededed;background-image:linear-gradient(90deg,#4a4a4a 30%,#ededed 0);background-position:0 0;background-repeat:no-repeat;background-size:150% 150%}.runway-component .progress:indeterminate::-webkit-progress-bar,.runway .progress:indeterminate::-webkit-progress-bar{background-color:transparent}.runway-component .progress:indeterminate::-moz-progress-bar,.runway .progress:indeterminate::-moz-progress-bar{background-color:transparent}.runway-component .progress.is-small,.runway .progress.is-small{height:.75rem}.runway-component .progress.is-medium,.runway .progress.is-medium{height:1.25rem}.runway-component .progress.is-large,.runway .progress.is-large{height:1.5rem}@-webkit-keyframes moveIndeterminate{0%{background-position:200% 0}to{background-position:-200% 0}}@keyframes moveIndeterminate{0%{background-position:200% 0}to{background-position:-200% 0}}.runway-component .table,.runway .table{background-color:#fff;color:#363636}.runway-component .table td,.runway-component .table th,.runway .table td,.runway .table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.runway-component .table td.is-white,.runway-component .table th.is-white,.runway .table td.is-white,.runway .table th.is-white{background-color:#fff;border-color:#fff;color:#0a0a0a}.runway-component .table td.is-black,.runway-component .table th.is-black,.runway .table td.is-black,.runway .table th.is-black{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.runway-component .table td.is-light,.runway-component .table th.is-light,.runway .table td.is-light,.runway .table th.is-light{background-color:#f5f5f5;border-color:#f5f5f5;color:rgba(0,0,0,.7)}.runway-component .table td.is-dark,.runway-component .table th.is-dark,.runway .table td.is-dark,.runway .table th.is-dark{background-color:#363636;border-color:#363636;color:#fff}.runway-component .table td.is-primary,.runway-component .table th.is-primary,.runway .table td.is-primary,.runway .table th.is-primary{background-color:#00d1b2;border-color:#00d1b2;color:#fff}.runway-component .table td.is-link,.runway-component .table th.is-link,.runway .table td.is-link,.runway .table th.is-link{background-color:#3273dc;border-color:#3273dc;color:#fff}.runway-component .table td.is-info,.runway-component .table th.is-info,.runway .table td.is-info,.runway .table th.is-info{background-color:#3298dc;border-color:#3298dc;color:#fff}.runway-component .table td.is-success,.runway-component .table th.is-success,.runway .table td.is-success,.runway .table th.is-success{background-color:#48c774;border-color:#48c774;color:#fff}.runway-component .table td.is-warning,.runway-component .table th.is-warning,.runway .table td.is-warning,.runway .table th.is-warning{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.runway-component .table td.is-danger,.runway-component .table th.is-danger,.runway .table td.is-danger,.runway .table th.is-danger{background-color:#f14668;border-color:#f14668;color:#fff}.runway-component .table td.is-narrow,.runway-component .table th.is-narrow,.runway .table td.is-narrow,.runway .table th.is-narrow{white-space:nowrap;width:1%}.runway-component .table td.is-selected,.runway-component .table th.is-selected,.runway .table td.is-selected,.runway .table th.is-selected{background-color:#00d1b2;color:#fff}.runway-component .table td.is-selected a,.runway-component .table td.is-selected strong,.runway-component .table th.is-selected a,.runway-component .table th.is-selected strong,.runway .table td.is-selected a,.runway .table td.is-selected strong,.runway .table th.is-selected a,.runway .table th.is-selected strong{color:currentColor}.runway-component .table td.is-vcentered,.runway-component .table th.is-vcentered,.runway .table td.is-vcentered,.runway .table th.is-vcentered{vertical-align:middle}.runway-component .table th,.runway .table th{color:#363636}.runway-component .table th:not([align]),.runway .table th:not([align]){text-align:inherit}.runway-component .table tr.is-selected,.runway .table tr.is-selected{background-color:#00d1b2;color:#fff}.runway-component .table tr.is-selected a,.runway-component .table tr.is-selected strong,.runway .table tr.is-selected a,.runway .table tr.is-selected strong{color:currentColor}.runway-component .table tr.is-selected td,.runway-component .table tr.is-selected th,.runway .table tr.is-selected td,.runway .table tr.is-selected th{border-color:#fff;color:currentColor}.runway-component .table thead,.runway .table thead{background-color:transparent}.runway-component .table thead td,.runway-component .table thead th,.runway .table thead td,.runway .table thead th{border-width:0 0 2px;color:#363636}.runway-component .table tfoot,.runway .table tfoot{background-color:transparent}.runway-component .table tfoot td,.runway-component .table tfoot th,.runway .table tfoot td,.runway .table tfoot th{border-width:2px 0 0;color:#363636}.runway-component .table tbody,.runway .table tbody{background-color:transparent}.runway-component .table tbody tr:last-child td,.runway-component .table tbody tr:last-child th,.runway .table tbody tr:last-child td,.runway .table tbody tr:last-child th{border-bottom-width:0}.runway-component .table.is-bordered td,.runway-component .table.is-bordered th,.runway .table.is-bordered td,.runway .table.is-bordered th{border-width:1px}.runway-component .table.is-bordered tr:last-child td,.runway-component .table.is-bordered tr:last-child th,.runway .table.is-bordered tr:last-child td,.runway .table.is-bordered tr:last-child th{border-bottom-width:1px}.runway-component .table.is-fullwidth,.runway .table.is-fullwidth{width:100%}.runway-component .table.is-hoverable.is-striped tbody tr:not(.is-selected):hover,.runway-component .table.is-hoverable tbody tr:not(.is-selected):hover,.runway .table.is-hoverable.is-striped tbody tr:not(.is-selected):hover,.runway .table.is-hoverable tbody tr:not(.is-selected):hover{background-color:#fafafa}.runway-component .table.is-hoverable.is-striped tbody tr:not(.is-selected):hover:nth-child(2n),.runway .table.is-hoverable.is-striped tbody tr:not(.is-selected):hover:nth-child(2n){background-color:#f5f5f5}.runway-component .table.is-narrow td,.runway-component .table.is-narrow th,.runway .table.is-narrow td,.runway .table.is-narrow th{padding:.25em .5em}.runway-component .table.is-striped tbody tr:not(.is-selected):nth-child(2n),.runway .table.is-striped tbody tr:not(.is-selected):nth-child(2n){background-color:#fafafa}.runway-component .table-container,.runway .table-container{-webkit-overflow-scrolling:touch;overflow:auto;overflow-y:hidden;max-width:100%}.runway-component .tags,.runway .tags{align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start}.runway-component .tags .tag,.runway .tags .tag{margin-bottom:.5rem}.runway-component .tags .tag:not(:last-child),.runway .tags .tag:not(:last-child){margin-right:.5rem}.runway-component .tags:last-child,.runway .tags:last-child{margin-bottom:-.5rem}.runway-component .tags:not(:last-child),.runway .tags:not(:last-child){margin-bottom:1rem}.runway-component .tags.are-medium .tag:not(.is-normal):not(.is-large),.runway .tags.are-medium .tag:not(.is-normal):not(.is-large){font-size:1rem}.runway-component .tags.are-large .tag:not(.is-normal):not(.is-medium),.runway .tags.are-large .tag:not(.is-normal):not(.is-medium){font-size:1.25rem}.runway-component .tags.is-centered,.runway .tags.is-centered{justify-content:center}.runway-component .tags.is-centered .tag,.runway .tags.is-centered .tag{margin-right:.25rem;margin-left:.25rem}.runway-component .tags.is-right,.runway .tags.is-right{justify-content:flex-end}.runway-component .tags.is-right .tag:not(:first-child),.runway .tags.is-right .tag:not(:first-child){margin-left:.5rem}.runway-component .tags.has-addons .tag,.runway-component .tags.is-right .tag:not(:last-child),.runway .tags.has-addons .tag,.runway .tags.is-right .tag:not(:last-child){margin-right:0}.runway-component .tags.has-addons .tag:not(:first-child),.runway .tags.has-addons .tag:not(:first-child){margin-left:0;border-top-left-radius:0;border-bottom-left-radius:0}.runway-component .tags.has-addons .tag:not(:last-child),.runway .tags.has-addons .tag:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.runway-component .tag:not(body),.runway .tag:not(body){align-items:center;background-color:#f5f5f5;border-radius:4px;color:#4a4a4a;display:inline-flex;font-size:.75rem;height:2em;justify-content:center;line-height:1.5;padding-left:.75em;padding-right:.75em;white-space:nowrap}.runway-component .tag:not(body) .delete,.runway .tag:not(body) .delete{margin-left:.25rem;margin-right:-.375rem}.runway-component .tag:not(body).is-white,.runway .tag:not(body).is-white{background-color:#fff;color:#0a0a0a}.runway-component .tag:not(body).is-black,.runway .tag:not(body).is-black{background-color:#0a0a0a;color:#fff}.runway-component .tag:not(body).is-light,.runway .tag:not(body).is-light{background-color:#f5f5f5;color:rgba(0,0,0,.7)}.runway-component .tag:not(body).is-dark,.runway .tag:not(body).is-dark{background-color:#363636;color:#fff}.runway-component .tag:not(body).is-primary,.runway .tag:not(body).is-primary{background-color:#00d1b2;color:#fff}.runway-component .tag:not(body).is-primary.is-light,.runway .tag:not(body).is-primary.is-light{background-color:#ebfffc;color:#00947e}.runway-component .tag:not(body).is-link,.runway .tag:not(body).is-link{background-color:#3273dc;color:#fff}.runway-component .tag:not(body).is-link.is-light,.runway .tag:not(body).is-link.is-light{background-color:#eef3fc;color:#2160c4}.runway-component .tag:not(body).is-info,.runway .tag:not(body).is-info{background-color:#3298dc;color:#fff}.runway-component .tag:not(body).is-info.is-light,.runway .tag:not(body).is-info.is-light{background-color:#eef6fc;color:#1d72aa}.runway-component .tag:not(body).is-success,.runway .tag:not(body).is-success{background-color:#48c774;color:#fff}.runway-component .tag:not(body).is-success.is-light,.runway .tag:not(body).is-success.is-light{background-color:#effaf3;color:#257942}.runway-component .tag:not(body).is-warning,.runway .tag:not(body).is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.runway-component .tag:not(body).is-warning.is-light,.runway .tag:not(body).is-warning.is-light{background-color:#fffbeb;color:#947600}.runway-component .tag:not(body).is-danger,.runway .tag:not(body).is-danger{background-color:#f14668;color:#fff}.runway-component .tag:not(body).is-danger.is-light,.runway .tag:not(body).is-danger.is-light{background-color:#feecf0;color:#cc0f35}.runway-component .tag:not(body).is-normal,.runway .tag:not(body).is-normal{font-size:.75rem}.runway-component .tag:not(body).is-medium,.runway .tag:not(body).is-medium{font-size:1rem}.runway-component .tag:not(body).is-large,.runway .tag:not(body).is-large{font-size:1.25rem}.runway-component .tag:not(body) .icon:first-child:not(:last-child),.runway .tag:not(body) .icon:first-child:not(:last-child){margin-left:-.375em;margin-right:.1875em}.runway-component .tag:not(body) .icon:last-child:not(:first-child),.runway .tag:not(body) .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:-.375em}.runway-component .tag:not(body) .icon:first-child:last-child,.runway .tag:not(body) .icon:first-child:last-child{margin-left:-.375em;margin-right:-.375em}.runway-component .tag:not(body).is-delete,.runway .tag:not(body).is-delete{margin-left:1px;padding:0;position:relative;width:2em}.runway-component .tag:not(body).is-delete:after,.runway-component .tag:not(body).is-delete:before,.runway .tag:not(body).is-delete:after,.runway .tag:not(body).is-delete:before{background-color:currentColor;content:\"\";display:block;left:50%;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%) rotate(45deg);transform-origin:center center}.runway-component .tag:not(body).is-delete:before,.runway .tag:not(body).is-delete:before{height:1px;width:50%}.runway-component .tag:not(body).is-delete:after,.runway .tag:not(body).is-delete:after{height:50%;width:1px}.runway-component .tag:not(body).is-delete:focus,.runway-component .tag:not(body).is-delete:hover,.runway .tag:not(body).is-delete:focus,.runway .tag:not(body).is-delete:hover{background-color:#e8e8e8}.runway-component .tag:not(body).is-delete:active,.runway .tag:not(body).is-delete:active{background-color:#dbdbdb}.runway-component .tag:not(body).is-rounded,.runway .tag:not(body).is-rounded{border-radius:290486px}.runway-component a.tag:hover,.runway a.tag:hover{text-decoration:underline}.runway-component .subtitle,.runway-component .title,.runway .subtitle,.runway .title{word-break:break-word}.runway-component .subtitle em,.runway-component .subtitle span,.runway-component .title em,.runway-component .title span,.runway .subtitle em,.runway .subtitle span,.runway .title em,.runway .title span{font-weight:inherit}.runway-component .subtitle sub,.runway-component .subtitle sup,.runway-component .title sub,.runway-component .title sup,.runway .subtitle sub,.runway .subtitle sup,.runway .title sub,.runway .title sup{font-size:.75em}.runway-component .subtitle .tag,.runway-component .title .tag,.runway .subtitle .tag,.runway .title .tag{vertical-align:middle}.runway-component .title,.runway .title{color:#363636;font-size:2rem;font-weight:600;line-height:1.125}.runway-component .title strong,.runway .title strong{color:inherit;font-weight:inherit}.runway-component .title+.highlight,.runway .title+.highlight{margin-top:-.75rem}.runway-component .title:not(.is-spaced)+.subtitle,.runway .title:not(.is-spaced)+.subtitle{margin-top:-1.25rem}.runway-component .title.is-1,.runway .title.is-1{font-size:3rem}.runway-component .title.is-2,.runway .title.is-2{font-size:2.5rem}.runway-component .title.is-3,.runway .title.is-3{font-size:2rem}.runway-component .title.is-4,.runway .title.is-4{font-size:1.5rem}.runway-component .title.is-5,.runway .title.is-5{font-size:1.25rem}.runway-component .title.is-6,.runway .title.is-6{font-size:1rem}.runway-component .title.is-7,.runway .title.is-7{font-size:.75rem}.runway-component .subtitle,.runway .subtitle{color:#4a4a4a;font-size:1.25rem;font-weight:400;line-height:1.25}.runway-component .subtitle strong,.runway .subtitle strong{color:#363636;font-weight:600}.runway-component .subtitle:not(.is-spaced)+.title,.runway .subtitle:not(.is-spaced)+.title{margin-top:-1.25rem}.runway-component .subtitle.is-1,.runway .subtitle.is-1{font-size:3rem}.runway-component .subtitle.is-2,.runway .subtitle.is-2{font-size:2.5rem}.runway-component .subtitle.is-3,.runway .subtitle.is-3{font-size:2rem}.runway-component .subtitle.is-4,.runway .subtitle.is-4{font-size:1.5rem}.runway-component .subtitle.is-5,.runway .subtitle.is-5{font-size:1.25rem}.runway-component .subtitle.is-6,.runway .subtitle.is-6{font-size:1rem}.runway-component .subtitle.is-7,.runway .subtitle.is-7{font-size:.75rem}.runway-component .heading,.runway .heading{display:block;font-size:11px;letter-spacing:1px;margin-bottom:5px;text-transform:uppercase}.runway-component .highlight,.runway .highlight{font-weight:400;max-width:100%;overflow:hidden;padding:0}.runway-component .highlight pre,.runway .highlight pre{overflow:auto;max-width:100%}.runway-component .number,.runway .number{align-items:center;background-color:#f5f5f5;border-radius:290486px;display:inline-flex;font-size:1.25rem;height:2em;justify-content:center;margin-right:1.5rem;min-width:2.5em;padding:.25rem .5rem;text-align:center;vertical-align:top}.runway-component .input,.runway-component .select select,.runway-component .textarea,.runway .input,.runway .select select,.runway .textarea{background-color:#fff;border-color:#dbdbdb;border-radius:4px;color:#363636}.runway-component .input::-moz-placeholder,.runway-component .select select::-moz-placeholder,.runway-component .textarea::-moz-placeholder,.runway .input::-moz-placeholder,.runway .select select::-moz-placeholder,.runway .textarea::-moz-placeholder{color:rgba(54,54,54,.3)}.runway-component .input::-webkit-input-placeholder,.runway-component .select select::-webkit-input-placeholder,.runway-component .textarea::-webkit-input-placeholder,.runway .input::-webkit-input-placeholder,.runway .select select::-webkit-input-placeholder,.runway .textarea::-webkit-input-placeholder{color:rgba(54,54,54,.3)}.runway-component .input:-moz-placeholder,.runway-component .select select:-moz-placeholder,.runway-component .textarea:-moz-placeholder,.runway .input:-moz-placeholder,.runway .select select:-moz-placeholder,.runway .textarea:-moz-placeholder{color:rgba(54,54,54,.3)}.runway-component .input:-ms-input-placeholder,.runway-component .select select:-ms-input-placeholder,.runway-component .textarea:-ms-input-placeholder,.runway .input:-ms-input-placeholder,.runway .select select:-ms-input-placeholder,.runway .textarea:-ms-input-placeholder{color:rgba(54,54,54,.3)}.runway-component .input:hover,.runway-component .is-hovered.input,.runway-component .is-hovered.textarea,.runway-component .select select.is-hovered,.runway-component .select select:hover,.runway-component .textarea:hover,.runway .input:hover,.runway .is-hovered.input,.runway .is-hovered.textarea,.runway .select select.is-hovered,.runway .select select:hover,.runway .textarea:hover{border-color:#b5b5b5}.runway-component .input:active,.runway-component .input:focus,.runway-component .is-active.input,.runway-component .is-active.textarea,.runway-component .is-focused.input,.runway-component .is-focused.textarea,.runway-component .select select.is-active,.runway-component .select select.is-focused,.runway-component .select select:active,.runway-component .select select:focus,.runway-component .textarea:active,.runway-component .textarea:focus,.runway .input:active,.runway .input:focus,.runway .is-active.input,.runway .is-active.textarea,.runway .is-focused.input,.runway .is-focused.textarea,.runway .select select.is-active,.runway .select select.is-focused,.runway .select select:active,.runway .select select:focus,.runway .textarea:active,.runway .textarea:focus{border-color:#3273dc;box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.runway-component .input[disabled],.runway-component .select fieldset[disabled] select,.runway-component .select select[disabled],.runway-component .textarea[disabled],.runway-component fieldset[disabled] .input,.runway-component fieldset[disabled] .select select,.runway-component fieldset[disabled] .textarea,.runway .input[disabled],.runway .select fieldset[disabled] select,.runway .select select[disabled],.runway .textarea[disabled],.runway fieldset[disabled] .input,.runway fieldset[disabled] .select select,.runway fieldset[disabled] .textarea{background-color:#f5f5f5;border-color:#f5f5f5;box-shadow:none;color:#7a7a7a}.runway-component .input[disabled]::-moz-placeholder,.runway-component .select fieldset[disabled] select::-moz-placeholder,.runway-component .select select[disabled]::-moz-placeholder,.runway-component .textarea[disabled]::-moz-placeholder,.runway-component fieldset[disabled] .input::-moz-placeholder,.runway-component fieldset[disabled] .select select::-moz-placeholder,.runway-component fieldset[disabled] .textarea::-moz-placeholder,.runway .input[disabled]::-moz-placeholder,.runway .select fieldset[disabled] select::-moz-placeholder,.runway .select select[disabled]::-moz-placeholder,.runway .textarea[disabled]::-moz-placeholder,.runway fieldset[disabled] .input::-moz-placeholder,.runway fieldset[disabled] .select select::-moz-placeholder,.runway fieldset[disabled] .textarea::-moz-placeholder{color:hsla(0,0%,48%,.3)}.runway-component .input[disabled]::-webkit-input-placeholder,.runway-component .select fieldset[disabled] select::-webkit-input-placeholder,.runway-component .select select[disabled]::-webkit-input-placeholder,.runway-component .textarea[disabled]::-webkit-input-placeholder,.runway-component fieldset[disabled] .input::-webkit-input-placeholder,.runway-component fieldset[disabled] .select select::-webkit-input-placeholder,.runway-component fieldset[disabled] .textarea::-webkit-input-placeholder,.runway .input[disabled]::-webkit-input-placeholder,.runway .select fieldset[disabled] select::-webkit-input-placeholder,.runway .select select[disabled]::-webkit-input-placeholder,.runway .textarea[disabled]::-webkit-input-placeholder,.runway fieldset[disabled] .input::-webkit-input-placeholder,.runway fieldset[disabled] .select select::-webkit-input-placeholder,.runway fieldset[disabled] .textarea::-webkit-input-placeholder{color:hsla(0,0%,48%,.3)}.runway-component .input[disabled]:-moz-placeholder,.runway-component .select fieldset[disabled] select:-moz-placeholder,.runway-component .select select[disabled]:-moz-placeholder,.runway-component .textarea[disabled]:-moz-placeholder,.runway-component fieldset[disabled] .input:-moz-placeholder,.runway-component fieldset[disabled] .select select:-moz-placeholder,.runway-component fieldset[disabled] .textarea:-moz-placeholder,.runway .input[disabled]:-moz-placeholder,.runway .select fieldset[disabled] select:-moz-placeholder,.runway .select select[disabled]:-moz-placeholder,.runway .textarea[disabled]:-moz-placeholder,.runway fieldset[disabled] .input:-moz-placeholder,.runway fieldset[disabled] .select select:-moz-placeholder,.runway fieldset[disabled] .textarea:-moz-placeholder{color:hsla(0,0%,48%,.3)}.runway-component .input[disabled]:-ms-input-placeholder,.runway-component .select fieldset[disabled] select:-ms-input-placeholder,.runway-component .select select[disabled]:-ms-input-placeholder,.runway-component .textarea[disabled]:-ms-input-placeholder,.runway-component fieldset[disabled] .input:-ms-input-placeholder,.runway-component fieldset[disabled] .select select:-ms-input-placeholder,.runway-component fieldset[disabled] .textarea:-ms-input-placeholder,.runway .input[disabled]:-ms-input-placeholder,.runway .select fieldset[disabled] select:-ms-input-placeholder,.runway .select select[disabled]:-ms-input-placeholder,.runway .textarea[disabled]:-ms-input-placeholder,.runway fieldset[disabled] .input:-ms-input-placeholder,.runway fieldset[disabled] .select select:-ms-input-placeholder,.runway fieldset[disabled] .textarea:-ms-input-placeholder{color:hsla(0,0%,48%,.3)}.runway-component .input,.runway-component .textarea,.runway .input,.runway .textarea{box-shadow:inset 0 .0625em .125em hsla(0,0%,4%,.05);max-width:100%;width:100%}.runway-component .input[readonly],.runway-component .textarea[readonly],.runway .input[readonly],.runway .textarea[readonly]{box-shadow:none}.runway-component .is-white.input,.runway-component .is-white.textarea,.runway .is-white.input,.runway .is-white.textarea{border-color:#fff}.runway-component .is-white.input:active,.runway-component .is-white.input:focus,.runway-component .is-white.is-active.input,.runway-component .is-white.is-active.textarea,.runway-component .is-white.is-focused.input,.runway-component .is-white.is-focused.textarea,.runway-component .is-white.textarea:active,.runway-component .is-white.textarea:focus,.runway .is-white.input:active,.runway .is-white.input:focus,.runway .is-white.is-active.input,.runway .is-white.is-active.textarea,.runway .is-white.is-focused.input,.runway .is-white.is-focused.textarea,.runway .is-white.textarea:active,.runway .is-white.textarea:focus{box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.runway-component .is-black.input,.runway-component .is-black.textarea,.runway .is-black.input,.runway .is-black.textarea{border-color:#0a0a0a}.runway-component .is-black.input:active,.runway-component .is-black.input:focus,.runway-component .is-black.is-active.input,.runway-component .is-black.is-active.textarea,.runway-component .is-black.is-focused.input,.runway-component .is-black.is-focused.textarea,.runway-component .is-black.textarea:active,.runway-component .is-black.textarea:focus,.runway .is-black.input:active,.runway .is-black.input:focus,.runway .is-black.is-active.input,.runway .is-black.is-active.textarea,.runway .is-black.is-focused.input,.runway .is-black.is-focused.textarea,.runway .is-black.textarea:active,.runway .is-black.textarea:focus{box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.runway-component .is-light.input,.runway-component .is-light.textarea,.runway .is-light.input,.runway .is-light.textarea{border-color:#f5f5f5}.runway-component .is-light.input:active,.runway-component .is-light.input:focus,.runway-component .is-light.is-active.input,.runway-component .is-light.is-active.textarea,.runway-component .is-light.is-focused.input,.runway-component .is-light.is-focused.textarea,.runway-component .is-light.textarea:active,.runway-component .is-light.textarea:focus,.runway .is-light.input:active,.runway .is-light.input:focus,.runway .is-light.is-active.input,.runway .is-light.is-active.textarea,.runway .is-light.is-focused.input,.runway .is-light.is-focused.textarea,.runway .is-light.textarea:active,.runway .is-light.textarea:focus{box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.runway-component .is-dark.input,.runway-component .is-dark.textarea,.runway .is-dark.input,.runway .is-dark.textarea{border-color:#363636}.runway-component .is-dark.input:active,.runway-component .is-dark.input:focus,.runway-component .is-dark.is-active.input,.runway-component .is-dark.is-active.textarea,.runway-component .is-dark.is-focused.input,.runway-component .is-dark.is-focused.textarea,.runway-component .is-dark.textarea:active,.runway-component .is-dark.textarea:focus,.runway .is-dark.input:active,.runway .is-dark.input:focus,.runway .is-dark.is-active.input,.runway .is-dark.is-active.textarea,.runway .is-dark.is-focused.input,.runway .is-dark.is-focused.textarea,.runway .is-dark.textarea:active,.runway .is-dark.textarea:focus{box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.runway-component .is-primary.input,.runway-component .is-primary.textarea,.runway .is-primary.input,.runway .is-primary.textarea{border-color:#00d1b2}.runway-component .is-primary.input:active,.runway-component .is-primary.input:focus,.runway-component .is-primary.is-active.input,.runway-component .is-primary.is-active.textarea,.runway-component .is-primary.is-focused.input,.runway-component .is-primary.is-focused.textarea,.runway-component .is-primary.textarea:active,.runway-component .is-primary.textarea:focus,.runway .is-primary.input:active,.runway .is-primary.input:focus,.runway .is-primary.is-active.input,.runway .is-primary.is-active.textarea,.runway .is-primary.is-focused.input,.runway .is-primary.is-focused.textarea,.runway .is-primary.textarea:active,.runway .is-primary.textarea:focus{box-shadow:0 0 0 .125em rgba(0,209,178,.25)}.runway-component .is-link.input,.runway-component .is-link.textarea,.runway .is-link.input,.runway .is-link.textarea{border-color:#3273dc}.runway-component .is-link.input:active,.runway-component .is-link.input:focus,.runway-component .is-link.is-active.input,.runway-component .is-link.is-active.textarea,.runway-component .is-link.is-focused.input,.runway-component .is-link.is-focused.textarea,.runway-component .is-link.textarea:active,.runway-component .is-link.textarea:focus,.runway .is-link.input:active,.runway .is-link.input:focus,.runway .is-link.is-active.input,.runway .is-link.is-active.textarea,.runway .is-link.is-focused.input,.runway .is-link.is-focused.textarea,.runway .is-link.textarea:active,.runway .is-link.textarea:focus{box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.runway-component .is-info.input,.runway-component .is-info.textarea,.runway .is-info.input,.runway .is-info.textarea{border-color:#3298dc}.runway-component .is-info.input:active,.runway-component .is-info.input:focus,.runway-component .is-info.is-active.input,.runway-component .is-info.is-active.textarea,.runway-component .is-info.is-focused.input,.runway-component .is-info.is-focused.textarea,.runway-component .is-info.textarea:active,.runway-component .is-info.textarea:focus,.runway .is-info.input:active,.runway .is-info.input:focus,.runway .is-info.is-active.input,.runway .is-info.is-active.textarea,.runway .is-info.is-focused.input,.runway .is-info.is-focused.textarea,.runway .is-info.textarea:active,.runway .is-info.textarea:focus{box-shadow:0 0 0 .125em rgba(50,152,220,.25)}.runway-component .is-success.input,.runway-component .is-success.textarea,.runway .is-success.input,.runway .is-success.textarea{border-color:#48c774}.runway-component .is-success.input:active,.runway-component .is-success.input:focus,.runway-component .is-success.is-active.input,.runway-component .is-success.is-active.textarea,.runway-component .is-success.is-focused.input,.runway-component .is-success.is-focused.textarea,.runway-component .is-success.textarea:active,.runway-component .is-success.textarea:focus,.runway .is-success.input:active,.runway .is-success.input:focus,.runway .is-success.is-active.input,.runway .is-success.is-active.textarea,.runway .is-success.is-focused.input,.runway .is-success.is-focused.textarea,.runway .is-success.textarea:active,.runway .is-success.textarea:focus{box-shadow:0 0 0 .125em rgba(72,199,116,.25)}.runway-component .is-warning.input,.runway-component .is-warning.textarea,.runway .is-warning.input,.runway .is-warning.textarea{border-color:#ffdd57}.runway-component .is-warning.input:active,.runway-component .is-warning.input:focus,.runway-component .is-warning.is-active.input,.runway-component .is-warning.is-active.textarea,.runway-component .is-warning.is-focused.input,.runway-component .is-warning.is-focused.textarea,.runway-component .is-warning.textarea:active,.runway-component .is-warning.textarea:focus,.runway .is-warning.input:active,.runway .is-warning.input:focus,.runway .is-warning.is-active.input,.runway .is-warning.is-active.textarea,.runway .is-warning.is-focused.input,.runway .is-warning.is-focused.textarea,.runway .is-warning.textarea:active,.runway .is-warning.textarea:focus{box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.runway-component .is-danger.input,.runway-component .is-danger.textarea,.runway .is-danger.input,.runway .is-danger.textarea{border-color:#f14668}.runway-component .is-danger.input:active,.runway-component .is-danger.input:focus,.runway-component .is-danger.is-active.input,.runway-component .is-danger.is-active.textarea,.runway-component .is-danger.is-focused.input,.runway-component .is-danger.is-focused.textarea,.runway-component .is-danger.textarea:active,.runway-component .is-danger.textarea:focus,.runway .is-danger.input:active,.runway .is-danger.input:focus,.runway .is-danger.is-active.input,.runway .is-danger.is-active.textarea,.runway .is-danger.is-focused.input,.runway .is-danger.is-focused.textarea,.runway .is-danger.textarea:active,.runway .is-danger.textarea:focus{box-shadow:0 0 0 .125em rgba(241,70,104,.25)}.runway-component .is-small.input,.runway-component .is-small.textarea,.runway .is-small.input,.runway .is-small.textarea{border-radius:2px;font-size:.75rem}.runway-component .is-medium.input,.runway-component .is-medium.textarea,.runway .is-medium.input,.runway .is-medium.textarea{font-size:1.25rem}.runway-component .is-large.input,.runway-component .is-large.textarea,.runway .is-large.input,.runway .is-large.textarea{font-size:1.5rem}.runway-component .is-fullwidth.input,.runway-component .is-fullwidth.textarea,.runway .is-fullwidth.input,.runway .is-fullwidth.textarea{display:block;width:100%}.runway-component .is-inline.input,.runway-component .is-inline.textarea,.runway .is-inline.input,.runway .is-inline.textarea{display:inline;width:auto}.runway-component .input.is-rounded,.runway .input.is-rounded{border-radius:290486px;padding-left:calc((.75em - 1px) + .375em);padding-right:calc((.75em - 1px) + .375em)}.runway-component .input.is-static,.runway .input.is-static{background-color:transparent;border-color:transparent;box-shadow:none;padding-left:0;padding-right:0}.runway-component .textarea,.runway .textarea{display:block;max-width:100%;min-width:100%;padding:calc(.75em - 1px);resize:vertical}.runway-component .textarea:not([rows]),.runway .textarea:not([rows]){max-height:40em;min-height:8em}.runway-component .textarea[rows],.runway .textarea[rows]{height:auto}.runway-component .textarea.has-fixed-size,.runway .textarea.has-fixed-size{resize:none}.runway-component .checkbox,.runway-component .radio,.runway .checkbox,.runway .radio{cursor:pointer;display:inline-block;line-height:1.25;position:relative}.runway-component .checkbox input,.runway-component .radio input,.runway .checkbox input,.runway .radio input{cursor:pointer}.runway-component .checkbox:hover,.runway-component .radio:hover,.runway .checkbox:hover,.runway .radio:hover{color:#363636}.runway-component .checkbox[disabled],.runway-component .radio[disabled],.runway-component fieldset[disabled] .checkbox,.runway-component fieldset[disabled] .radio,.runway .checkbox[disabled],.runway .radio[disabled],.runway fieldset[disabled] .checkbox,.runway fieldset[disabled] .radio{color:#7a7a7a;cursor:not-allowed}.runway-component .radio+.radio,.runway .radio+.radio{margin-left:.5em}.runway-component .select,.runway .select{display:inline-block;max-width:100%;position:relative;vertical-align:top}.runway-component .select:not(.is-multiple),.runway .select:not(.is-multiple){height:2.5em}.runway-component .select:not(.is-multiple):not(.is-loading):after,.runway .select:not(.is-multiple):not(.is-loading):after{border-color:#3273dc;right:1.125em;z-index:4}.runway-component .select.is-rounded select,.runway .select.is-rounded select{border-radius:290486px;padding-left:1em}.runway-component .select select,.runway .select select{cursor:pointer;display:block;font-size:1em;max-width:100%;outline:0}.runway-component .select select::-ms-expand,.runway .select select::-ms-expand{display:none}.runway-component .select select[disabled]:hover,.runway-component fieldset[disabled] .select select:hover,.runway .select select[disabled]:hover,.runway fieldset[disabled] .select select:hover{border-color:#f5f5f5}.runway-component .select select:not([multiple]),.runway .select select:not([multiple]){padding-right:2.5em}.runway-component .select select[multiple],.runway .select select[multiple]{height:auto;padding:0}.runway-component .select select[multiple] option,.runway .select select[multiple] option{padding:.5em 1em}.runway-component .select:not(.is-multiple):not(.is-loading):hover:after,.runway .select:not(.is-multiple):not(.is-loading):hover:after{border-color:#363636}.runway-component .select.is-white:not(:hover):after,.runway-component .select.is-white select,.runway .select.is-white:not(:hover):after,.runway .select.is-white select{border-color:#fff}.runway-component .select.is-white select.is-hovered,.runway-component .select.is-white select:hover,.runway .select.is-white select.is-hovered,.runway .select.is-white select:hover{border-color:#f2f2f2}.runway-component .select.is-white select.is-active,.runway-component .select.is-white select.is-focused,.runway-component .select.is-white select:active,.runway-component .select.is-white select:focus,.runway .select.is-white select.is-active,.runway .select.is-white select.is-focused,.runway .select.is-white select:active,.runway .select.is-white select:focus{box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.runway-component .select.is-black:not(:hover):after,.runway-component .select.is-black select,.runway .select.is-black:not(:hover):after,.runway .select.is-black select{border-color:#0a0a0a}.runway-component .select.is-black select.is-hovered,.runway-component .select.is-black select:hover,.runway .select.is-black select.is-hovered,.runway .select.is-black select:hover{border-color:#000}.runway-component .select.is-black select.is-active,.runway-component .select.is-black select.is-focused,.runway-component .select.is-black select:active,.runway-component .select.is-black select:focus,.runway .select.is-black select.is-active,.runway .select.is-black select.is-focused,.runway .select.is-black select:active,.runway .select.is-black select:focus{box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.runway-component .select.is-light:not(:hover):after,.runway-component .select.is-light select,.runway .select.is-light:not(:hover):after,.runway .select.is-light select{border-color:#f5f5f5}.runway-component .select.is-light select.is-hovered,.runway-component .select.is-light select:hover,.runway .select.is-light select.is-hovered,.runway .select.is-light select:hover{border-color:#e8e8e8}.runway-component .select.is-light select.is-active,.runway-component .select.is-light select.is-focused,.runway-component .select.is-light select:active,.runway-component .select.is-light select:focus,.runway .select.is-light select.is-active,.runway .select.is-light select.is-focused,.runway .select.is-light select:active,.runway .select.is-light select:focus{box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.runway-component .select.is-dark:not(:hover):after,.runway-component .select.is-dark select,.runway .select.is-dark:not(:hover):after,.runway .select.is-dark select{border-color:#363636}.runway-component .select.is-dark select.is-hovered,.runway-component .select.is-dark select:hover,.runway .select.is-dark select.is-hovered,.runway .select.is-dark select:hover{border-color:#292929}.runway-component .select.is-dark select.is-active,.runway-component .select.is-dark select.is-focused,.runway-component .select.is-dark select:active,.runway-component .select.is-dark select:focus,.runway .select.is-dark select.is-active,.runway .select.is-dark select.is-focused,.runway .select.is-dark select:active,.runway .select.is-dark select:focus{box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.runway-component .select.is-primary:not(:hover):after,.runway-component .select.is-primary select,.runway .select.is-primary:not(:hover):after,.runway .select.is-primary select{border-color:#00d1b2}.runway-component .select.is-primary select.is-hovered,.runway-component .select.is-primary select:hover,.runway .select.is-primary select.is-hovered,.runway .select.is-primary select:hover{border-color:#00b89c}.runway-component .select.is-primary select.is-active,.runway-component .select.is-primary select.is-focused,.runway-component .select.is-primary select:active,.runway-component .select.is-primary select:focus,.runway .select.is-primary select.is-active,.runway .select.is-primary select.is-focused,.runway .select.is-primary select:active,.runway .select.is-primary select:focus{box-shadow:0 0 0 .125em rgba(0,209,178,.25)}.runway-component .select.is-link:not(:hover):after,.runway-component .select.is-link select,.runway .select.is-link:not(:hover):after,.runway .select.is-link select{border-color:#3273dc}.runway-component .select.is-link select.is-hovered,.runway-component .select.is-link select:hover,.runway .select.is-link select.is-hovered,.runway .select.is-link select:hover{border-color:#2366d1}.runway-component .select.is-link select.is-active,.runway-component .select.is-link select.is-focused,.runway-component .select.is-link select:active,.runway-component .select.is-link select:focus,.runway .select.is-link select.is-active,.runway .select.is-link select.is-focused,.runway .select.is-link select:active,.runway .select.is-link select:focus{box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.runway-component .select.is-info:not(:hover):after,.runway-component .select.is-info select,.runway .select.is-info:not(:hover):after,.runway .select.is-info select{border-color:#3298dc}.runway-component .select.is-info select.is-hovered,.runway-component .select.is-info select:hover,.runway .select.is-info select.is-hovered,.runway .select.is-info select:hover{border-color:#238cd1}.runway-component .select.is-info select.is-active,.runway-component .select.is-info select.is-focused,.runway-component .select.is-info select:active,.runway-component .select.is-info select:focus,.runway .select.is-info select.is-active,.runway .select.is-info select.is-focused,.runway .select.is-info select:active,.runway .select.is-info select:focus{box-shadow:0 0 0 .125em rgba(50,152,220,.25)}.runway-component .select.is-success:not(:hover):after,.runway-component .select.is-success select,.runway .select.is-success:not(:hover):after,.runway .select.is-success select{border-color:#48c774}.runway-component .select.is-success select.is-hovered,.runway-component .select.is-success select:hover,.runway .select.is-success select.is-hovered,.runway .select.is-success select:hover{border-color:#3abb67}.runway-component .select.is-success select.is-active,.runway-component .select.is-success select.is-focused,.runway-component .select.is-success select:active,.runway-component .select.is-success select:focus,.runway .select.is-success select.is-active,.runway .select.is-success select.is-focused,.runway .select.is-success select:active,.runway .select.is-success select:focus{box-shadow:0 0 0 .125em rgba(72,199,116,.25)}.runway-component .select.is-warning:not(:hover):after,.runway-component .select.is-warning select,.runway .select.is-warning:not(:hover):after,.runway .select.is-warning select{border-color:#ffdd57}.runway-component .select.is-warning select.is-hovered,.runway-component .select.is-warning select:hover,.runway .select.is-warning select.is-hovered,.runway .select.is-warning select:hover{border-color:#ffd83d}.runway-component .select.is-warning select.is-active,.runway-component .select.is-warning select.is-focused,.runway-component .select.is-warning select:active,.runway-component .select.is-warning select:focus,.runway .select.is-warning select.is-active,.runway .select.is-warning select.is-focused,.runway .select.is-warning select:active,.runway .select.is-warning select:focus{box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.runway-component .select.is-danger:not(:hover):after,.runway-component .select.is-danger select,.runway .select.is-danger:not(:hover):after,.runway .select.is-danger select{border-color:#f14668}.runway-component .select.is-danger select.is-hovered,.runway-component .select.is-danger select:hover,.runway .select.is-danger select.is-hovered,.runway .select.is-danger select:hover{border-color:#ef2e55}.runway-component .select.is-danger select.is-active,.runway-component .select.is-danger select.is-focused,.runway-component .select.is-danger select:active,.runway-component .select.is-danger select:focus,.runway .select.is-danger select.is-active,.runway .select.is-danger select.is-focused,.runway .select.is-danger select:active,.runway .select.is-danger select:focus{box-shadow:0 0 0 .125em rgba(241,70,104,.25)}.runway-component .select.is-small,.runway .select.is-small{border-radius:2px;font-size:.75rem}.runway-component .select.is-medium,.runway .select.is-medium{font-size:1.25rem}.runway-component .select.is-large,.runway .select.is-large{font-size:1.5rem}.runway-component .select.is-disabled:after,.runway .select.is-disabled:after{border-color:#7a7a7a}.runway-component .select.is-fullwidth,.runway-component .select.is-fullwidth select,.runway .select.is-fullwidth,.runway .select.is-fullwidth select{width:100%}.runway-component .select.is-loading:after,.runway .select.is-loading:after{margin-top:0;position:absolute;right:.625em;top:.625em;transform:none}.runway-component .select.is-loading.is-small:after,.runway .select.is-loading.is-small:after{font-size:.75rem}.runway-component .select.is-loading.is-medium:after,.runway .select.is-loading.is-medium:after{font-size:1.25rem}.runway-component .select.is-loading.is-large:after,.runway .select.is-loading.is-large:after{font-size:1.5rem}.runway-component .file,.runway .file{align-items:stretch;display:flex;justify-content:flex-start;position:relative}.runway-component .file.is-white .file-cta,.runway .file.is-white .file-cta{background-color:#fff;border-color:transparent;color:#0a0a0a}.runway-component .file.is-white.is-hovered .file-cta,.runway-component .file.is-white:hover .file-cta,.runway .file.is-white.is-hovered .file-cta,.runway .file.is-white:hover .file-cta{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.runway-component .file.is-white.is-focused .file-cta,.runway-component .file.is-white:focus .file-cta,.runway .file.is-white.is-focused .file-cta,.runway .file.is-white:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,100%,.25);color:#0a0a0a}.runway-component .file.is-white.is-active .file-cta,.runway-component .file.is-white:active .file-cta,.runway .file.is-white.is-active .file-cta,.runway .file.is-white:active .file-cta{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.runway-component .file.is-black .file-cta,.runway .file.is-black .file-cta{background-color:#0a0a0a;border-color:transparent;color:#fff}.runway-component .file.is-black.is-hovered .file-cta,.runway-component .file.is-black:hover .file-cta,.runway .file.is-black.is-hovered .file-cta,.runway .file.is-black:hover .file-cta{background-color:#040404;border-color:transparent;color:#fff}.runway-component .file.is-black.is-focused .file-cta,.runway-component .file.is-black:focus .file-cta,.runway .file.is-black.is-focused .file-cta,.runway .file.is-black:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,4%,.25);color:#fff}.runway-component .file.is-black.is-active .file-cta,.runway-component .file.is-black:active .file-cta,.runway .file.is-black.is-active .file-cta,.runway .file.is-black:active .file-cta{background-color:#000;border-color:transparent;color:#fff}.runway-component .file.is-light .file-cta,.runway .file.is-light .file-cta{background-color:#f5f5f5;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .file.is-light.is-hovered .file-cta,.runway-component .file.is-light:hover .file-cta,.runway .file.is-light.is-hovered .file-cta,.runway .file.is-light:hover .file-cta{background-color:#eee;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .file.is-light.is-focused .file-cta,.runway-component .file.is-light:focus .file-cta,.runway .file.is-light.is-focused .file-cta,.runway .file.is-light:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,96%,.25);color:rgba(0,0,0,.7)}.runway-component .file.is-light.is-active .file-cta,.runway-component .file.is-light:active .file-cta,.runway .file.is-light.is-active .file-cta,.runway .file.is-light:active .file-cta{background-color:#e8e8e8;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .file.is-dark .file-cta,.runway .file.is-dark .file-cta{background-color:#363636;border-color:transparent;color:#fff}.runway-component .file.is-dark.is-hovered .file-cta,.runway-component .file.is-dark:hover .file-cta,.runway .file.is-dark.is-hovered .file-cta,.runway .file.is-dark:hover .file-cta{background-color:#2f2f2f;border-color:transparent;color:#fff}.runway-component .file.is-dark.is-focused .file-cta,.runway-component .file.is-dark:focus .file-cta,.runway .file.is-dark.is-focused .file-cta,.runway .file.is-dark:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(54,54,54,.25);color:#fff}.runway-component .file.is-dark.is-active .file-cta,.runway-component .file.is-dark:active .file-cta,.runway .file.is-dark.is-active .file-cta,.runway .file.is-dark:active .file-cta{background-color:#292929;border-color:transparent;color:#fff}.runway-component .file.is-primary .file-cta,.runway .file.is-primary .file-cta{background-color:#00d1b2;border-color:transparent;color:#fff}.runway-component .file.is-primary.is-hovered .file-cta,.runway-component .file.is-primary:hover .file-cta,.runway .file.is-primary.is-hovered .file-cta,.runway .file.is-primary:hover .file-cta{background-color:#00c4a7;border-color:transparent;color:#fff}.runway-component .file.is-primary.is-focused .file-cta,.runway-component .file.is-primary:focus .file-cta,.runway .file.is-primary.is-focused .file-cta,.runway .file.is-primary:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(0,209,178,.25);color:#fff}.runway-component .file.is-primary.is-active .file-cta,.runway-component .file.is-primary:active .file-cta,.runway .file.is-primary.is-active .file-cta,.runway .file.is-primary:active .file-cta{background-color:#00b89c;border-color:transparent;color:#fff}.runway-component .file.is-link .file-cta,.runway .file.is-link .file-cta{background-color:#3273dc;border-color:transparent;color:#fff}.runway-component .file.is-link.is-hovered .file-cta,.runway-component .file.is-link:hover .file-cta,.runway .file.is-link.is-hovered .file-cta,.runway .file.is-link:hover .file-cta{background-color:#276cda;border-color:transparent;color:#fff}.runway-component .file.is-link.is-focused .file-cta,.runway-component .file.is-link:focus .file-cta,.runway .file.is-link.is-focused .file-cta,.runway .file.is-link:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(50,115,220,.25);color:#fff}.runway-component .file.is-link.is-active .file-cta,.runway-component .file.is-link:active .file-cta,.runway .file.is-link.is-active .file-cta,.runway .file.is-link:active .file-cta{background-color:#2366d1;border-color:transparent;color:#fff}.runway-component .file.is-info .file-cta,.runway .file.is-info .file-cta{background-color:#3298dc;border-color:transparent;color:#fff}.runway-component .file.is-info.is-hovered .file-cta,.runway-component .file.is-info:hover .file-cta,.runway .file.is-info.is-hovered .file-cta,.runway .file.is-info:hover .file-cta{background-color:#2793da;border-color:transparent;color:#fff}.runway-component .file.is-info.is-focused .file-cta,.runway-component .file.is-info:focus .file-cta,.runway .file.is-info.is-focused .file-cta,.runway .file.is-info:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(50,152,220,.25);color:#fff}.runway-component .file.is-info.is-active .file-cta,.runway-component .file.is-info:active .file-cta,.runway .file.is-info.is-active .file-cta,.runway .file.is-info:active .file-cta{background-color:#238cd1;border-color:transparent;color:#fff}.runway-component .file.is-success .file-cta,.runway .file.is-success .file-cta{background-color:#48c774;border-color:transparent;color:#fff}.runway-component .file.is-success.is-hovered .file-cta,.runway-component .file.is-success:hover .file-cta,.runway .file.is-success.is-hovered .file-cta,.runway .file.is-success:hover .file-cta{background-color:#3ec46d;border-color:transparent;color:#fff}.runway-component .file.is-success.is-focused .file-cta,.runway-component .file.is-success:focus .file-cta,.runway .file.is-success.is-focused .file-cta,.runway .file.is-success:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(72,199,116,.25);color:#fff}.runway-component .file.is-success.is-active .file-cta,.runway-component .file.is-success:active .file-cta,.runway .file.is-success.is-active .file-cta,.runway .file.is-success:active .file-cta{background-color:#3abb67;border-color:transparent;color:#fff}.runway-component .file.is-warning .file-cta,.runway .file.is-warning .file-cta{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .file.is-warning.is-hovered .file-cta,.runway-component .file.is-warning:hover .file-cta,.runway .file.is-warning.is-hovered .file-cta,.runway .file.is-warning:hover .file-cta{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .file.is-warning.is-focused .file-cta,.runway-component .file.is-warning:focus .file-cta,.runway .file.is-warning.is-focused .file-cta,.runway .file.is-warning:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(255,221,87,.25);color:rgba(0,0,0,.7)}.runway-component .file.is-warning.is-active .file-cta,.runway-component .file.is-warning:active .file-cta,.runway .file.is-warning.is-active .file-cta,.runway .file.is-warning:active .file-cta{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.runway-component .file.is-danger .file-cta,.runway .file.is-danger .file-cta{background-color:#f14668;border-color:transparent;color:#fff}.runway-component .file.is-danger.is-hovered .file-cta,.runway-component .file.is-danger:hover .file-cta,.runway .file.is-danger.is-hovered .file-cta,.runway .file.is-danger:hover .file-cta{background-color:#f03a5f;border-color:transparent;color:#fff}.runway-component .file.is-danger.is-focused .file-cta,.runway-component .file.is-danger:focus .file-cta,.runway .file.is-danger.is-focused .file-cta,.runway .file.is-danger:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(241,70,104,.25);color:#fff}.runway-component .file.is-danger.is-active .file-cta,.runway-component .file.is-danger:active .file-cta,.runway .file.is-danger.is-active .file-cta,.runway .file.is-danger:active .file-cta{background-color:#ef2e55;border-color:transparent;color:#fff}.runway-component .file.is-small,.runway .file.is-small{font-size:.75rem}.runway-component .file.is-medium,.runway .file.is-medium{font-size:1.25rem}.runway-component .file.is-medium .file-icon .fa,.runway .file.is-medium .file-icon .fa{font-size:21px}.runway-component .file.is-large,.runway .file.is-large{font-size:1.5rem}.runway-component .file.is-large .file-icon .fa,.runway .file.is-large .file-icon .fa{font-size:28px}.runway-component .file.has-name .file-cta,.runway .file.has-name .file-cta{border-bottom-right-radius:0;border-top-right-radius:0}.runway-component .file.has-name .file-name,.runway .file.has-name .file-name{border-bottom-left-radius:0;border-top-left-radius:0}.runway-component .file.has-name.is-empty .file-cta,.runway .file.has-name.is-empty .file-cta{border-radius:4px}.runway-component .file.has-name.is-empty .file-name,.runway .file.has-name.is-empty .file-name{display:none}.runway-component .file.is-boxed .file-label,.runway .file.is-boxed .file-label{flex-direction:column}.runway-component .file.is-boxed .file-cta,.runway .file.is-boxed .file-cta{flex-direction:column;height:auto;padding:1em 3em}.runway-component .file.is-boxed .file-name,.runway .file.is-boxed .file-name{border-width:0 1px 1px}.runway-component .file.is-boxed .file-icon,.runway .file.is-boxed .file-icon{height:1.5em;width:1.5em}.runway-component .file.is-boxed .file-icon .fa,.runway .file.is-boxed .file-icon .fa{font-size:21px}.runway-component .file.is-boxed.is-small .file-icon .fa,.runway .file.is-boxed.is-small .file-icon .fa{font-size:14px}.runway-component .file.is-boxed.is-medium .file-icon .fa,.runway .file.is-boxed.is-medium .file-icon .fa{font-size:28px}.runway-component .file.is-boxed.is-large .file-icon .fa,.runway .file.is-boxed.is-large .file-icon .fa{font-size:35px}.runway-component .file.is-boxed.has-name .file-cta,.runway .file.is-boxed.has-name .file-cta{border-radius:4px 4px 0 0}.runway-component .file.is-boxed.has-name .file-name,.runway .file.is-boxed.has-name .file-name{border-radius:0 0 4px 4px;border-width:0 1px 1px}.runway-component .file.is-centered,.runway .file.is-centered{justify-content:center}.runway-component .file.is-fullwidth .file-label,.runway .file.is-fullwidth .file-label{width:100%}.runway-component .file.is-fullwidth .file-name,.runway .file.is-fullwidth .file-name{flex-grow:1;max-width:none}.runway-component .file.is-right,.runway .file.is-right{justify-content:flex-end}.runway-component .file.is-right .file-cta,.runway .file.is-right .file-cta{border-radius:0 4px 4px 0}.runway-component .file.is-right .file-name,.runway .file.is-right .file-name{border-radius:4px 0 0 4px;border-width:1px 0 1px 1px;order:-1}.runway-component .file-label,.runway .file-label{align-items:stretch;display:flex;cursor:pointer;justify-content:flex-start;overflow:hidden;position:relative}.runway-component .file-label:hover .file-cta,.runway .file-label:hover .file-cta{background-color:#eee;color:#363636}.runway-component .file-label:hover .file-name,.runway .file-label:hover .file-name{border-color:#d5d5d5}.runway-component .file-label:active .file-cta,.runway .file-label:active .file-cta{background-color:#e8e8e8;color:#363636}.runway-component .file-label:active .file-name,.runway .file-label:active .file-name{border-color:#cfcfcf}.runway-component .file-input,.runway .file-input{height:100%;left:0;opacity:0;outline:0;position:absolute;top:0;width:100%}.runway-component .file-cta,.runway-component .file-name,.runway .file-cta,.runway .file-name{border-color:#dbdbdb;border-radius:4px;font-size:1em;padding-left:1em;padding-right:1em;white-space:nowrap}.runway-component .file-cta,.runway .file-cta{background-color:#f5f5f5;color:#4a4a4a}.runway-component .file-name,.runway .file-name{border-color:#dbdbdb;border-style:solid;border-width:1px 1px 1px 0;display:block;max-width:16em;overflow:hidden;text-align:inherit;text-overflow:ellipsis}.runway-component .file-icon,.runway .file-icon{align-items:center;display:flex;height:1em;justify-content:center;margin-right:.5em;width:1em}.runway-component .file-icon .fa,.runway .file-icon .fa{font-size:14px}.runway-component .label,.runway .label{color:#363636;display:block;font-size:1rem;font-weight:700}.runway-component .label:not(:last-child),.runway .label:not(:last-child){margin-bottom:.5em}.runway-component .label.is-small,.runway .label.is-small{font-size:.75rem}.runway-component .label.is-medium,.runway .label.is-medium{font-size:1.25rem}.runway-component .label.is-large,.runway .label.is-large{font-size:1.5rem}.runway-component .help,.runway .help{display:block;font-size:.75rem;margin-top:.25rem}.runway-component .help.is-white,.runway .help.is-white{color:#fff}.runway-component .help.is-black,.runway .help.is-black{color:#0a0a0a}.runway-component .help.is-light,.runway .help.is-light{color:#f5f5f5}.runway-component .help.is-dark,.runway .help.is-dark{color:#363636}.runway-component .help.is-primary,.runway .help.is-primary{color:#00d1b2}.runway-component .help.is-link,.runway .help.is-link{color:#3273dc}.runway-component .help.is-info,.runway .help.is-info{color:#3298dc}.runway-component .help.is-success,.runway .help.is-success{color:#48c774}.runway-component .help.is-warning,.runway .help.is-warning{color:#ffdd57}.runway-component .help.is-danger,.runway .help.is-danger{color:#f14668}.runway-component .field:not(:last-child),.runway .field:not(:last-child){margin-bottom:.75rem}.runway-component .field.has-addons,.runway .field.has-addons{display:flex;justify-content:flex-start}.runway-component .field.has-addons .control:not(:last-child),.runway .field.has-addons .control:not(:last-child){margin-right:-1px}.runway-component .field.has-addons .control:not(:first-child):not(:last-child) .button,.runway-component .field.has-addons .control:not(:first-child):not(:last-child) .input,.runway-component .field.has-addons .control:not(:first-child):not(:last-child) .select select,.runway .field.has-addons .control:not(:first-child):not(:last-child) .button,.runway .field.has-addons .control:not(:first-child):not(:last-child) .input,.runway .field.has-addons .control:not(:first-child):not(:last-child) .select select{border-radius:0}.runway-component .field.has-addons .control:first-child:not(:only-child) .button,.runway-component .field.has-addons .control:first-child:not(:only-child) .input,.runway-component .field.has-addons .control:first-child:not(:only-child) .select select,.runway .field.has-addons .control:first-child:not(:only-child) .button,.runway .field.has-addons .control:first-child:not(:only-child) .input,.runway .field.has-addons .control:first-child:not(:only-child) .select select{border-bottom-right-radius:0;border-top-right-radius:0}.runway-component .field.has-addons .control:last-child:not(:only-child) .button,.runway-component .field.has-addons .control:last-child:not(:only-child) .input,.runway-component .field.has-addons .control:last-child:not(:only-child) .select select,.runway .field.has-addons .control:last-child:not(:only-child) .button,.runway .field.has-addons .control:last-child:not(:only-child) .input,.runway .field.has-addons .control:last-child:not(:only-child) .select select{border-bottom-left-radius:0;border-top-left-radius:0}.runway-component .field.has-addons .control .button:not([disabled]).is-hovered,.runway-component .field.has-addons .control .button:not([disabled]):hover,.runway-component .field.has-addons .control .input:not([disabled]).is-hovered,.runway-component .field.has-addons .control .input:not([disabled]):hover,.runway-component .field.has-addons .control .select select:not([disabled]).is-hovered,.runway-component .field.has-addons .control .select select:not([disabled]):hover,.runway .field.has-addons .control .button:not([disabled]).is-hovered,.runway .field.has-addons .control .button:not([disabled]):hover,.runway .field.has-addons .control .input:not([disabled]).is-hovered,.runway .field.has-addons .control .input:not([disabled]):hover,.runway .field.has-addons .control .select select:not([disabled]).is-hovered,.runway .field.has-addons .control .select select:not([disabled]):hover{z-index:2}.runway-component .field.has-addons .control .button:not([disabled]).is-active,.runway-component .field.has-addons .control .button:not([disabled]).is-focused,.runway-component .field.has-addons .control .button:not([disabled]):active,.runway-component .field.has-addons .control .button:not([disabled]):focus,.runway-component .field.has-addons .control .input:not([disabled]).is-active,.runway-component .field.has-addons .control .input:not([disabled]).is-focused,.runway-component .field.has-addons .control .input:not([disabled]):active,.runway-component .field.has-addons .control .input:not([disabled]):focus,.runway-component .field.has-addons .control .select select:not([disabled]).is-active,.runway-component .field.has-addons .control .select select:not([disabled]).is-focused,.runway-component .field.has-addons .control .select select:not([disabled]):active,.runway-component .field.has-addons .control .select select:not([disabled]):focus,.runway .field.has-addons .control .button:not([disabled]).is-active,.runway .field.has-addons .control .button:not([disabled]).is-focused,.runway .field.has-addons .control .button:not([disabled]):active,.runway .field.has-addons .control .button:not([disabled]):focus,.runway .field.has-addons .control .input:not([disabled]).is-active,.runway .field.has-addons .control .input:not([disabled]).is-focused,.runway .field.has-addons .control .input:not([disabled]):active,.runway .field.has-addons .control .input:not([disabled]):focus,.runway .field.has-addons .control .select select:not([disabled]).is-active,.runway .field.has-addons .control .select select:not([disabled]).is-focused,.runway .field.has-addons .control .select select:not([disabled]):active,.runway .field.has-addons .control .select select:not([disabled]):focus{z-index:3}.runway-component .field.has-addons .control .button:not([disabled]).is-active:hover,.runway-component .field.has-addons .control .button:not([disabled]).is-focused:hover,.runway-component .field.has-addons .control .button:not([disabled]):active:hover,.runway-component .field.has-addons .control .button:not([disabled]):focus:hover,.runway-component .field.has-addons .control .input:not([disabled]).is-active:hover,.runway-component .field.has-addons .control .input:not([disabled]).is-focused:hover,.runway-component .field.has-addons .control .input:not([disabled]):active:hover,.runway-component .field.has-addons .control .input:not([disabled]):focus:hover,.runway-component .field.has-addons .control .select select:not([disabled]).is-active:hover,.runway-component .field.has-addons .control .select select:not([disabled]).is-focused:hover,.runway-component .field.has-addons .control .select select:not([disabled]):active:hover,.runway-component .field.has-addons .control .select select:not([disabled]):focus:hover,.runway .field.has-addons .control .button:not([disabled]).is-active:hover,.runway .field.has-addons .control .button:not([disabled]).is-focused:hover,.runway .field.has-addons .control .button:not([disabled]):active:hover,.runway .field.has-addons .control .button:not([disabled]):focus:hover,.runway .field.has-addons .control .input:not([disabled]).is-active:hover,.runway .field.has-addons .control .input:not([disabled]).is-focused:hover,.runway .field.has-addons .control .input:not([disabled]):active:hover,.runway .field.has-addons .control .input:not([disabled]):focus:hover,.runway .field.has-addons .control .select select:not([disabled]).is-active:hover,.runway .field.has-addons .control .select select:not([disabled]).is-focused:hover,.runway .field.has-addons .control .select select:not([disabled]):active:hover,.runway .field.has-addons .control .select select:not([disabled]):focus:hover{z-index:4}.runway-component .field.has-addons .control.is-expanded,.runway .field.has-addons .control.is-expanded{flex-grow:1;flex-shrink:1}.runway-component .field.has-addons.has-addons-centered,.runway .field.has-addons.has-addons-centered{justify-content:center}.runway-component .field.has-addons.has-addons-right,.runway .field.has-addons.has-addons-right{justify-content:flex-end}.runway-component .field.has-addons.has-addons-fullwidth .control,.runway .field.has-addons.has-addons-fullwidth .control{flex-grow:1;flex-shrink:0}.runway-component .field.is-grouped,.runway .field.is-grouped{display:flex;justify-content:flex-start}.runway-component .field.is-grouped>.control,.runway .field.is-grouped>.control{flex-shrink:0}.runway-component .field.is-grouped>.control:not(:last-child),.runway .field.is-grouped>.control:not(:last-child){margin-bottom:0;margin-right:.75rem}.runway-component .field.is-grouped>.control.is-expanded,.runway .field.is-grouped>.control.is-expanded{flex-grow:1;flex-shrink:1}.runway-component .field.is-grouped.is-grouped-centered,.runway .field.is-grouped.is-grouped-centered{justify-content:center}.runway-component .field.is-grouped.is-grouped-right,.runway .field.is-grouped.is-grouped-right{justify-content:flex-end}.runway-component .field.is-grouped.is-grouped-multiline,.runway .field.is-grouped.is-grouped-multiline{flex-wrap:wrap}.runway-component .field.is-grouped.is-grouped-multiline>.control:last-child,.runway-component .field.is-grouped.is-grouped-multiline>.control:not(:last-child),.runway .field.is-grouped.is-grouped-multiline>.control:last-child,.runway .field.is-grouped.is-grouped-multiline>.control:not(:last-child){margin-bottom:.75rem}.runway-component .field.is-grouped.is-grouped-multiline:last-child,.runway .field.is-grouped.is-grouped-multiline:last-child{margin-bottom:-.75rem}.runway-component .field.is-grouped.is-grouped-multiline:not(:last-child),.runway .field.is-grouped.is-grouped-multiline:not(:last-child){margin-bottom:0}@media print,screen and (min-width:769px){.runway-component .field.is-horizontal,.runway .field.is-horizontal{display:flex}}.runway-component .field-label .label,.runway .field-label .label{font-size:inherit}@media screen and (max-width:768px){.runway-component .field-label,.runway .field-label{margin-bottom:.5rem}}@media print,screen and (min-width:769px){.runway-component .field-label,.runway .field-label{flex-basis:0;flex-grow:1;flex-shrink:0;margin-right:1.5rem;text-align:right}.runway-component .field-label.is-small,.runway .field-label.is-small{font-size:.75rem;padding-top:.375em}.runway-component .field-label.is-normal,.runway .field-label.is-normal{padding-top:.375em}.runway-component .field-label.is-medium,.runway .field-label.is-medium{font-size:1.25rem;padding-top:.375em}.runway-component .field-label.is-large,.runway .field-label.is-large{font-size:1.5rem;padding-top:.375em}}.runway-component .field-body .field .field,.runway .field-body .field .field{margin-bottom:0}@media print,screen and (min-width:769px){.runway-component .field-body,.runway .field-body{display:flex;flex-basis:0;flex-grow:5;flex-shrink:1}.runway-component .field-body .field,.runway .field-body .field{margin-bottom:0}.runway-component .field-body>.field,.runway .field-body>.field{flex-shrink:1}.runway-component .field-body>.field:not(.is-narrow),.runway .field-body>.field:not(.is-narrow){flex-grow:1}.runway-component .field-body>.field:not(:last-child),.runway .field-body>.field:not(:last-child){margin-right:.75rem}}.runway-component .control,.runway .control{box-sizing:border-box;clear:both;font-size:1rem;position:relative;text-align:inherit}.runway-component .control.has-icons-left .input:focus~.icon,.runway-component .control.has-icons-left .select:focus~.icon,.runway-component .control.has-icons-right .input:focus~.icon,.runway-component .control.has-icons-right .select:focus~.icon,.runway .control.has-icons-left .input:focus~.icon,.runway .control.has-icons-left .select:focus~.icon,.runway .control.has-icons-right .input:focus~.icon,.runway .control.has-icons-right .select:focus~.icon{color:#4a4a4a}.runway-component .control.has-icons-left .input.is-small~.icon,.runway-component .control.has-icons-left .select.is-small~.icon,.runway-component .control.has-icons-right .input.is-small~.icon,.runway-component .control.has-icons-right .select.is-small~.icon,.runway .control.has-icons-left .input.is-small~.icon,.runway .control.has-icons-left .select.is-small~.icon,.runway .control.has-icons-right .input.is-small~.icon,.runway .control.has-icons-right .select.is-small~.icon{font-size:.75rem}.runway-component .control.has-icons-left .input.is-medium~.icon,.runway-component .control.has-icons-left .select.is-medium~.icon,.runway-component .control.has-icons-right .input.is-medium~.icon,.runway-component .control.has-icons-right .select.is-medium~.icon,.runway .control.has-icons-left .input.is-medium~.icon,.runway .control.has-icons-left .select.is-medium~.icon,.runway .control.has-icons-right .input.is-medium~.icon,.runway .control.has-icons-right .select.is-medium~.icon{font-size:1.25rem}.runway-component .control.has-icons-left .input.is-large~.icon,.runway-component .control.has-icons-left .select.is-large~.icon,.runway-component .control.has-icons-right .input.is-large~.icon,.runway-component .control.has-icons-right .select.is-large~.icon,.runway .control.has-icons-left .input.is-large~.icon,.runway .control.has-icons-left .select.is-large~.icon,.runway .control.has-icons-right .input.is-large~.icon,.runway .control.has-icons-right .select.is-large~.icon{font-size:1.5rem}.runway-component .control.has-icons-left .icon,.runway-component .control.has-icons-right .icon,.runway .control.has-icons-left .icon,.runway .control.has-icons-right .icon{color:#dbdbdb;height:2.5em;pointer-events:none;position:absolute;top:0;width:2.5em;z-index:4}.runway-component .control.has-icons-left .input,.runway-component .control.has-icons-left .select select,.runway .control.has-icons-left .input,.runway .control.has-icons-left .select select{padding-left:2.5em}.runway-component .control.has-icons-left .icon.is-left,.runway .control.has-icons-left .icon.is-left{left:0}.runway-component .control.has-icons-right .input,.runway-component .control.has-icons-right .select select,.runway .control.has-icons-right .input,.runway .control.has-icons-right .select select{padding-right:2.5em}.runway-component .control.has-icons-right .icon.is-right,.runway .control.has-icons-right .icon.is-right{right:0}.runway-component .control.is-loading:after,.runway .control.is-loading:after{position:absolute!important;right:.625em;top:.625em;z-index:4}.runway-component .control.is-loading.is-small:after,.runway .control.is-loading.is-small:after{font-size:.75rem}.runway-component .control.is-loading.is-medium:after,.runway .control.is-loading.is-medium:after{font-size:1.25rem}.runway-component .control.is-loading.is-large:after,.runway .control.is-loading.is-large:after{font-size:1.5rem}.runway-component .breadcrumb,.runway .breadcrumb{font-size:1rem;white-space:nowrap}.runway-component .breadcrumb a,.runway .breadcrumb a{align-items:center;color:#3273dc;display:flex;justify-content:center;padding:0 .75em}.runway-component .breadcrumb a:hover,.runway .breadcrumb a:hover{color:#363636}.runway-component .breadcrumb li,.runway .breadcrumb li{align-items:center;display:flex}.runway-component .breadcrumb li:first-child a,.runway .breadcrumb li:first-child a{padding-left:0}.runway-component .breadcrumb li.is-active a,.runway .breadcrumb li.is-active a{color:#363636;cursor:default;pointer-events:none}.runway-component .breadcrumb li+li:before,.runway .breadcrumb li+li:before{color:#b5b5b5;content:\"/\"}.runway-component .breadcrumb ol,.runway-component .breadcrumb ul,.runway .breadcrumb ol,.runway .breadcrumb ul{align-items:flex-start;display:flex;flex-wrap:wrap;justify-content:flex-start}.runway-component .breadcrumb .icon:first-child,.runway .breadcrumb .icon:first-child{margin-right:.5em}.runway-component .breadcrumb .icon:last-child,.runway .breadcrumb .icon:last-child{margin-left:.5em}.runway-component .breadcrumb.is-centered ol,.runway-component .breadcrumb.is-centered ul,.runway .breadcrumb.is-centered ol,.runway .breadcrumb.is-centered ul{justify-content:center}.runway-component .breadcrumb.is-right ol,.runway-component .breadcrumb.is-right ul,.runway .breadcrumb.is-right ol,.runway .breadcrumb.is-right ul{justify-content:flex-end}.runway-component .breadcrumb.is-small,.runway .breadcrumb.is-small{font-size:.75rem}.runway-component .breadcrumb.is-medium,.runway .breadcrumb.is-medium{font-size:1.25rem}.runway-component .breadcrumb.is-large,.runway .breadcrumb.is-large{font-size:1.5rem}.runway-component .breadcrumb.has-arrow-separator li+li:before,.runway .breadcrumb.has-arrow-separator li+li:before{content:\"\\2192\"}.runway-component .breadcrumb.has-bullet-separator li+li:before,.runway .breadcrumb.has-bullet-separator li+li:before{content:\"\\2022\"}.runway-component .breadcrumb.has-dot-separator li+li:before,.runway .breadcrumb.has-dot-separator li+li:before{content:\"\\B7\"}.runway-component .breadcrumb.has-succeeds-separator li+li:before,.runway .breadcrumb.has-succeeds-separator li+li:before{content:\"\\227B\"}.runway-component .card,.runway .card{background-color:#fff;box-shadow:0 .5em 1em -.125em hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.02);color:#4a4a4a;max-width:100%;position:relative}.runway-component .card-header,.runway .card-header{background-color:transparent;align-items:stretch;box-shadow:0 .125em .25em hsla(0,0%,4%,.1);display:flex}.runway-component .card-header-title,.runway .card-header-title{align-items:center;color:#363636;display:flex;flex-grow:1;font-weight:700;padding:.75rem 1rem}.runway-component .card-header-title.is-centered,.runway .card-header-title.is-centered{justify-content:center}.runway-component .card-header-icon,.runway .card-header-icon{align-items:center;cursor:pointer;display:flex;justify-content:center;padding:.75rem 1rem}.runway-component .card-image,.runway .card-image{display:block;position:relative}.runway-component .card-content,.runway .card-content{background-color:transparent;padding:1.5rem}.runway-component .card-footer,.runway .card-footer{background-color:transparent;border-top:1px solid #ededed;align-items:stretch;display:flex}.runway-component .card-footer-item,.runway .card-footer-item{align-items:center;display:flex;flex-basis:0;flex-grow:1;flex-shrink:0;justify-content:center;padding:.75rem}.runway-component .card-footer-item:not(:last-child),.runway .card-footer-item:not(:last-child){border-right:1px solid #ededed}.runway-component .card .media:not(:last-child),.runway .card .media:not(:last-child){margin-bottom:1.5rem}.runway-component .dropdown,.runway .dropdown{display:inline-flex;position:relative;vertical-align:top}.runway-component .dropdown.is-active .dropdown-menu,.runway-component .dropdown.is-hoverable:hover .dropdown-menu,.runway .dropdown.is-active .dropdown-menu,.runway .dropdown.is-hoverable:hover .dropdown-menu{display:block}.runway-component .dropdown.is-right .dropdown-menu,.runway .dropdown.is-right .dropdown-menu{left:auto;right:0}.runway-component .dropdown.is-up .dropdown-menu,.runway .dropdown.is-up .dropdown-menu{bottom:100%;padding-bottom:4px;padding-top:0;top:auto}.runway-component .dropdown-menu,.runway .dropdown-menu{display:none;left:0;min-width:12rem;padding-top:4px;position:absolute;top:100%;z-index:20}.runway-component .dropdown-content,.runway .dropdown-content{background-color:#fff;border-radius:4px;box-shadow:0 .5em 1em -.125em hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.02);padding-bottom:.5rem;padding-top:.5rem}.runway-component .dropdown-item,.runway .dropdown-item{color:#4a4a4a;display:block;font-size:.875rem;line-height:1.5;padding:.375rem 1rem;position:relative}.runway-component a.dropdown-item,.runway-component button.dropdown-item,.runway a.dropdown-item,.runway button.dropdown-item{padding-right:3rem;text-align:inherit;white-space:nowrap;width:100%}.runway-component a.dropdown-item:hover,.runway-component button.dropdown-item:hover,.runway a.dropdown-item:hover,.runway button.dropdown-item:hover{background-color:#f5f5f5;color:#0a0a0a}.runway-component a.dropdown-item.is-active,.runway-component button.dropdown-item.is-active,.runway a.dropdown-item.is-active,.runway button.dropdown-item.is-active{background-color:#3273dc;color:#fff}.runway-component .dropdown-divider,.runway .dropdown-divider{background-color:#ededed;border:none;display:block;height:1px;margin:.5rem 0}.runway-component .level,.runway .level{align-items:center;justify-content:space-between}.runway-component .level code,.runway .level code{border-radius:4px}.runway-component .level img,.runway .level img{display:inline-block;vertical-align:top}.runway-component .level.is-mobile,.runway-component .level.is-mobile .level-left,.runway-component .level.is-mobile .level-right,.runway .level.is-mobile,.runway .level.is-mobile .level-left,.runway .level.is-mobile .level-right{display:flex}.runway-component .level.is-mobile .level-left+.level-right,.runway .level.is-mobile .level-left+.level-right{margin-top:0}.runway-component .level.is-mobile .level-item:not(:last-child),.runway .level.is-mobile .level-item:not(:last-child){margin-bottom:0;margin-right:.75rem}.runway-component .level.is-mobile .level-item:not(.is-narrow),.runway .level.is-mobile .level-item:not(.is-narrow){flex-grow:1}@media print,screen and (min-width:769px){.runway-component .level,.runway .level{display:flex}.runway-component .level>.level-item:not(.is-narrow),.runway .level>.level-item:not(.is-narrow){flex-grow:1}}.runway-component .level-item,.runway .level-item{align-items:center;display:flex;flex-basis:auto;flex-grow:0;flex-shrink:0;justify-content:center}.runway-component .level-item .subtitle,.runway-component .level-item .title,.runway .level-item .subtitle,.runway .level-item .title{margin-bottom:0}@media screen and (max-width:768px){.runway-component .level-item:not(:last-child),.runway .level-item:not(:last-child){margin-bottom:.75rem}}.runway-component .level-left,.runway-component .level-right,.runway .level-left,.runway .level-right{flex-basis:auto;flex-grow:0;flex-shrink:0}.runway-component .level-left .level-item.is-flexible,.runway-component .level-right .level-item.is-flexible,.runway .level-left .level-item.is-flexible,.runway .level-right .level-item.is-flexible{flex-grow:1}@media print,screen and (min-width:769px){.runway-component .level-left .level-item:not(:last-child),.runway-component .level-right .level-item:not(:last-child),.runway .level-left .level-item:not(:last-child),.runway .level-right .level-item:not(:last-child){margin-right:.75rem}}.runway-component .level-left,.runway .level-left{align-items:center;justify-content:flex-start}@media screen and (max-width:768px){.runway-component .level-left+.level-right,.runway .level-left+.level-right{margin-top:1.5rem}}@media print,screen and (min-width:769px){.runway-component .level-left,.runway .level-left{display:flex}}.runway-component .level-right,.runway .level-right{align-items:center;justify-content:flex-end}@media print,screen and (min-width:769px){.runway-component .level-right,.runway .level-right{display:flex}}.runway-component .media,.runway .media{align-items:flex-start;display:flex;text-align:inherit}.runway-component .media .content:not(:last-child),.runway .media .content:not(:last-child){margin-bottom:.75rem}.runway-component .media .media,.runway .media .media{border-top:1px solid hsla(0,0%,86%,.5);display:flex;padding-top:.75rem}.runway-component .media .media .content:not(:last-child),.runway-component .media .media .control:not(:last-child),.runway .media .media .content:not(:last-child),.runway .media .media .control:not(:last-child){margin-bottom:.5rem}.runway-component .media .media .media,.runway .media .media .media{padding-top:.5rem}.runway-component .media .media .media+.media,.runway .media .media .media+.media{margin-top:.5rem}.runway-component .media+.media,.runway .media+.media{border-top:1px solid hsla(0,0%,86%,.5);margin-top:1rem;padding-top:1rem}.runway-component .media.is-large+.media,.runway .media.is-large+.media{margin-top:1.5rem;padding-top:1.5rem}.runway-component .media-left,.runway-component .media-right,.runway .media-left,.runway .media-right{flex-basis:auto;flex-grow:0;flex-shrink:0}.runway-component .media-left,.runway .media-left{margin-right:1rem}.runway-component .media-right,.runway .media-right{margin-left:1rem}.runway-component .media-content,.runway .media-content{flex-basis:auto;flex-grow:1;flex-shrink:1;text-align:inherit}@media screen and (max-width:768px){.runway-component .media-content,.runway .media-content{overflow-x:auto}}.runway-component .menu,.runway .menu{font-size:1rem}.runway-component .menu.is-small,.runway .menu.is-small{font-size:.75rem}.runway-component .menu.is-medium,.runway .menu.is-medium{font-size:1.25rem}.runway-component .menu.is-large,.runway .menu.is-large{font-size:1.5rem}.runway-component .menu-list,.runway .menu-list{line-height:1.25}.runway-component .menu-list a,.runway .menu-list a{border-radius:2px;color:#4a4a4a;display:block;padding:.5em .75em}.runway-component .menu-list a:hover,.runway .menu-list a:hover{background-color:#f5f5f5;color:#363636}.runway-component .menu-list a.is-active,.runway .menu-list a.is-active{background-color:#3273dc;color:#fff}.runway-component .menu-list li ul,.runway .menu-list li ul{border-left:1px solid #dbdbdb;margin:.75em;padding-left:.75em}.runway-component .menu-label,.runway .menu-label{color:#7a7a7a;font-size:.75em;letter-spacing:.1em;text-transform:uppercase}.runway-component .menu-label:not(:first-child),.runway .menu-label:not(:first-child){margin-top:1em}.runway-component .menu-label:not(:last-child),.runway .menu-label:not(:last-child){margin-bottom:1em}.runway-component .message,.runway .message{background-color:#f5f5f5;border-radius:4px;font-size:1rem}.runway-component .message strong,.runway .message strong{color:currentColor}.runway-component .message a:not(.button):not(.tag):not(.dropdown-item),.runway .message a:not(.button):not(.tag):not(.dropdown-item){color:currentColor;text-decoration:underline}.runway-component .message.is-small,.runway .message.is-small{font-size:.75rem}.runway-component .message.is-medium,.runway .message.is-medium{font-size:1.25rem}.runway-component .message.is-large,.runway .message.is-large{font-size:1.5rem}.runway-component .message.is-white,.runway .message.is-white{background-color:#fff}.runway-component .message.is-white .message-header,.runway .message.is-white .message-header{background-color:#fff;color:#0a0a0a}.runway-component .message.is-white .message-body,.runway .message.is-white .message-body{border-color:#fff}.runway-component .message.is-black,.runway .message.is-black{background-color:#fafafa}.runway-component .message.is-black .message-header,.runway .message.is-black .message-header{background-color:#0a0a0a;color:#fff}.runway-component .message.is-black .message-body,.runway .message.is-black .message-body{border-color:#0a0a0a}.runway-component .message.is-light,.runway .message.is-light{background-color:#fafafa}.runway-component .message.is-light .message-header,.runway .message.is-light .message-header{background-color:#f5f5f5;color:rgba(0,0,0,.7)}.runway-component .message.is-light .message-body,.runway .message.is-light .message-body{border-color:#f5f5f5}.runway-component .message.is-dark,.runway .message.is-dark{background-color:#fafafa}.runway-component .message.is-dark .message-header,.runway .message.is-dark .message-header{background-color:#363636;color:#fff}.runway-component .message.is-dark .message-body,.runway .message.is-dark .message-body{border-color:#363636}.runway-component .message.is-primary,.runway .message.is-primary{background-color:#ebfffc}.runway-component .message.is-primary .message-header,.runway .message.is-primary .message-header{background-color:#00d1b2;color:#fff}.runway-component .message.is-primary .message-body,.runway .message.is-primary .message-body{border-color:#00d1b2;color:#00947e}.runway-component .message.is-link,.runway .message.is-link{background-color:#eef3fc}.runway-component .message.is-link .message-header,.runway .message.is-link .message-header{background-color:#3273dc;color:#fff}.runway-component .message.is-link .message-body,.runway .message.is-link .message-body{border-color:#3273dc;color:#2160c4}.runway-component .message.is-info,.runway .message.is-info{background-color:#eef6fc}.runway-component .message.is-info .message-header,.runway .message.is-info .message-header{background-color:#3298dc;color:#fff}.runway-component .message.is-info .message-body,.runway .message.is-info .message-body{border-color:#3298dc;color:#1d72aa}.runway-component .message.is-success,.runway .message.is-success{background-color:#effaf3}.runway-component .message.is-success .message-header,.runway .message.is-success .message-header{background-color:#48c774;color:#fff}.runway-component .message.is-success .message-body,.runway .message.is-success .message-body{border-color:#48c774;color:#257942}.runway-component .message.is-warning,.runway .message.is-warning{background-color:#fffbeb}.runway-component .message.is-warning .message-header,.runway .message.is-warning .message-header{background-color:#ffdd57;color:rgba(0,0,0,.7)}.runway-component .message.is-warning .message-body,.runway .message.is-warning .message-body{border-color:#ffdd57;color:#947600}.runway-component .message.is-danger,.runway .message.is-danger{background-color:#feecf0}.runway-component .message.is-danger .message-header,.runway .message.is-danger .message-header{background-color:#f14668;color:#fff}.runway-component .message.is-danger .message-body,.runway .message.is-danger .message-body{border-color:#f14668;color:#cc0f35}.runway-component .message-header,.runway .message-header{align-items:center;background-color:#4a4a4a;border-radius:4px 4px 0 0;color:#fff;display:flex;font-weight:700;justify-content:space-between;line-height:1.25;padding:.75em 1em;position:relative}.runway-component .message-header .delete,.runway .message-header .delete{flex-grow:0;flex-shrink:0;margin-left:.75em}.runway-component .message-header+.message-body,.runway .message-header+.message-body{border-width:0;border-top-left-radius:0;border-top-right-radius:0}.runway-component .message-body,.runway .message-body{border-color:#dbdbdb;border-radius:4px;border-style:solid;border-width:0 0 0 4px;color:#4a4a4a;padding:1.25em 1.5em}.runway-component .message-body code,.runway-component .message-body pre,.runway .message-body code,.runway .message-body pre{background-color:#fff}.runway-component .message-body pre code,.runway .message-body pre code{background-color:transparent}.runway-component .modal,.runway .modal{align-items:center;display:none;flex-direction:column;justify-content:center;overflow:hidden;position:fixed;z-index:40}.runway-component .modal.is-active,.runway .modal.is-active{display:flex}.runway-component .modal-background,.runway .modal-background{background-color:hsla(0,0%,4%,.86)}.runway-component .modal-card,.runway-component .modal-content,.runway .modal-card,.runway .modal-content{margin:0 20px;max-height:calc(100vh - 160px);overflow:auto;position:relative;width:100%}@media print,screen and (min-width:769px){.runway-component .modal-card,.runway-component .modal-content,.runway .modal-card,.runway .modal-content{margin:0 auto;max-height:calc(100vh - 40px);width:640px}}.runway-component .modal-close,.runway .modal-close{background:0 0;height:40px;position:fixed;right:20px;top:20px;width:40px}.runway-component .modal-card,.runway .modal-card{display:flex;flex-direction:column;max-height:calc(100vh - 40px);overflow:hidden;-ms-overflow-y:visible}.runway-component .modal-card-foot,.runway-component .modal-card-head,.runway .modal-card-foot,.runway .modal-card-head{align-items:center;background-color:#f5f5f5;display:flex;flex-shrink:0;justify-content:flex-start;padding:20px;position:relative}.runway-component .modal-card-head,.runway .modal-card-head{border-bottom:1px solid #dbdbdb;border-top-left-radius:6px;border-top-right-radius:6px}.runway-component .modal-card-title,.runway .modal-card-title{color:#363636;flex-grow:1;flex-shrink:0;font-size:1.5rem;line-height:1}.runway-component .modal-card-foot,.runway .modal-card-foot{border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:1px solid #dbdbdb}.runway-component .modal-card-foot .button:not(:last-child),.runway .modal-card-foot .button:not(:last-child){margin-right:.5em}.runway-component .modal-card-body,.runway .modal-card-body{-webkit-overflow-scrolling:touch;background-color:#fff;flex-grow:1;flex-shrink:1;overflow:auto;padding:20px}.runway-component .navbar,.runway .navbar{background-color:#fff;min-height:3.25rem;position:relative;z-index:30}.runway-component .navbar.is-white,.runway .navbar.is-white{background-color:#fff;color:#0a0a0a}.runway-component .navbar.is-white .navbar-brand .navbar-link,.runway-component .navbar.is-white .navbar-brand>.navbar-item,.runway .navbar.is-white .navbar-brand .navbar-link,.runway .navbar.is-white .navbar-brand>.navbar-item{color:#0a0a0a}.runway-component .navbar.is-white .navbar-brand .navbar-link.is-active,.runway-component .navbar.is-white .navbar-brand .navbar-link:focus,.runway-component .navbar.is-white .navbar-brand .navbar-link:hover,.runway-component .navbar.is-white .navbar-brand>a.navbar-item.is-active,.runway-component .navbar.is-white .navbar-brand>a.navbar-item:focus,.runway-component .navbar.is-white .navbar-brand>a.navbar-item:hover,.runway .navbar.is-white .navbar-brand .navbar-link.is-active,.runway .navbar.is-white .navbar-brand .navbar-link:focus,.runway .navbar.is-white .navbar-brand .navbar-link:hover,.runway .navbar.is-white .navbar-brand>a.navbar-item.is-active,.runway .navbar.is-white .navbar-brand>a.navbar-item:focus,.runway .navbar.is-white .navbar-brand>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.runway-component .navbar.is-white .navbar-brand .navbar-link:after,.runway .navbar.is-white .navbar-brand .navbar-link:after{border-color:#0a0a0a}.runway-component .navbar.is-white .navbar-burger,.runway .navbar.is-white .navbar-burger{color:#0a0a0a}@media screen and (min-width:1024px){.runway-component .navbar.is-white .navbar-end .navbar-link,.runway-component .navbar.is-white .navbar-end>.navbar-item,.runway-component .navbar.is-white .navbar-start .navbar-link,.runway-component .navbar.is-white .navbar-start>.navbar-item,.runway .navbar.is-white .navbar-end .navbar-link,.runway .navbar.is-white .navbar-end>.navbar-item,.runway .navbar.is-white .navbar-start .navbar-link,.runway .navbar.is-white .navbar-start>.navbar-item{color:#0a0a0a}.runway-component .navbar.is-white .navbar-end .navbar-link.is-active,.runway-component .navbar.is-white .navbar-end .navbar-link:focus,.runway-component .navbar.is-white .navbar-end .navbar-link:hover,.runway-component .navbar.is-white .navbar-end>a.navbar-item.is-active,.runway-component .navbar.is-white .navbar-end>a.navbar-item:focus,.runway-component .navbar.is-white .navbar-end>a.navbar-item:hover,.runway-component .navbar.is-white .navbar-start .navbar-link.is-active,.runway-component .navbar.is-white .navbar-start .navbar-link:focus,.runway-component .navbar.is-white .navbar-start .navbar-link:hover,.runway-component .navbar.is-white .navbar-start>a.navbar-item.is-active,.runway-component .navbar.is-white .navbar-start>a.navbar-item:focus,.runway-component .navbar.is-white .navbar-start>a.navbar-item:hover,.runway .navbar.is-white .navbar-end .navbar-link.is-active,.runway .navbar.is-white .navbar-end .navbar-link:focus,.runway .navbar.is-white .navbar-end .navbar-link:hover,.runway .navbar.is-white .navbar-end>a.navbar-item.is-active,.runway .navbar.is-white .navbar-end>a.navbar-item:focus,.runway .navbar.is-white .navbar-end>a.navbar-item:hover,.runway .navbar.is-white .navbar-start .navbar-link.is-active,.runway .navbar.is-white .navbar-start .navbar-link:focus,.runway .navbar.is-white .navbar-start .navbar-link:hover,.runway .navbar.is-white .navbar-start>a.navbar-item.is-active,.runway .navbar.is-white .navbar-start>a.navbar-item:focus,.runway .navbar.is-white .navbar-start>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.runway-component .navbar.is-white .navbar-end .navbar-link:after,.runway-component .navbar.is-white .navbar-start .navbar-link:after,.runway .navbar.is-white .navbar-end .navbar-link:after,.runway .navbar.is-white .navbar-start .navbar-link:after{border-color:#0a0a0a}.runway-component .navbar.is-white .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-white .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar.is-white .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar.is-white .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-white .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar.is-white .navbar-item.has-dropdown:hover .navbar-link{background-color:#f2f2f2;color:#0a0a0a}.runway-component .navbar.is-white .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-white .navbar-dropdown a.navbar-item.is-active{background-color:#fff;color:#0a0a0a}}.runway-component .navbar.is-black,.runway .navbar.is-black{background-color:#0a0a0a;color:#fff}.runway-component .navbar.is-black .navbar-brand .navbar-link,.runway-component .navbar.is-black .navbar-brand>.navbar-item,.runway .navbar.is-black .navbar-brand .navbar-link,.runway .navbar.is-black .navbar-brand>.navbar-item{color:#fff}.runway-component .navbar.is-black .navbar-brand .navbar-link.is-active,.runway-component .navbar.is-black .navbar-brand .navbar-link:focus,.runway-component .navbar.is-black .navbar-brand .navbar-link:hover,.runway-component .navbar.is-black .navbar-brand>a.navbar-item.is-active,.runway-component .navbar.is-black .navbar-brand>a.navbar-item:focus,.runway-component .navbar.is-black .navbar-brand>a.navbar-item:hover,.runway .navbar.is-black .navbar-brand .navbar-link.is-active,.runway .navbar.is-black .navbar-brand .navbar-link:focus,.runway .navbar.is-black .navbar-brand .navbar-link:hover,.runway .navbar.is-black .navbar-brand>a.navbar-item.is-active,.runway .navbar.is-black .navbar-brand>a.navbar-item:focus,.runway .navbar.is-black .navbar-brand>a.navbar-item:hover{background-color:#000;color:#fff}.runway-component .navbar.is-black .navbar-brand .navbar-link:after,.runway .navbar.is-black .navbar-brand .navbar-link:after{border-color:#fff}.runway-component .navbar.is-black .navbar-burger,.runway .navbar.is-black .navbar-burger{color:#fff}@media screen and (min-width:1024px){.runway-component .navbar.is-black .navbar-end .navbar-link,.runway-component .navbar.is-black .navbar-end>.navbar-item,.runway-component .navbar.is-black .navbar-start .navbar-link,.runway-component .navbar.is-black .navbar-start>.navbar-item,.runway .navbar.is-black .navbar-end .navbar-link,.runway .navbar.is-black .navbar-end>.navbar-item,.runway .navbar.is-black .navbar-start .navbar-link,.runway .navbar.is-black .navbar-start>.navbar-item{color:#fff}.runway-component .navbar.is-black .navbar-end .navbar-link.is-active,.runway-component .navbar.is-black .navbar-end .navbar-link:focus,.runway-component .navbar.is-black .navbar-end .navbar-link:hover,.runway-component .navbar.is-black .navbar-end>a.navbar-item.is-active,.runway-component .navbar.is-black .navbar-end>a.navbar-item:focus,.runway-component .navbar.is-black .navbar-end>a.navbar-item:hover,.runway-component .navbar.is-black .navbar-start .navbar-link.is-active,.runway-component .navbar.is-black .navbar-start .navbar-link:focus,.runway-component .navbar.is-black .navbar-start .navbar-link:hover,.runway-component .navbar.is-black .navbar-start>a.navbar-item.is-active,.runway-component .navbar.is-black .navbar-start>a.navbar-item:focus,.runway-component .navbar.is-black .navbar-start>a.navbar-item:hover,.runway .navbar.is-black .navbar-end .navbar-link.is-active,.runway .navbar.is-black .navbar-end .navbar-link:focus,.runway .navbar.is-black .navbar-end .navbar-link:hover,.runway .navbar.is-black .navbar-end>a.navbar-item.is-active,.runway .navbar.is-black .navbar-end>a.navbar-item:focus,.runway .navbar.is-black .navbar-end>a.navbar-item:hover,.runway .navbar.is-black .navbar-start .navbar-link.is-active,.runway .navbar.is-black .navbar-start .navbar-link:focus,.runway .navbar.is-black .navbar-start .navbar-link:hover,.runway .navbar.is-black .navbar-start>a.navbar-item.is-active,.runway .navbar.is-black .navbar-start>a.navbar-item:focus,.runway .navbar.is-black .navbar-start>a.navbar-item:hover{background-color:#000;color:#fff}.runway-component .navbar.is-black .navbar-end .navbar-link:after,.runway-component .navbar.is-black .navbar-start .navbar-link:after,.runway .navbar.is-black .navbar-end .navbar-link:after,.runway .navbar.is-black .navbar-start .navbar-link:after{border-color:#fff}.runway-component .navbar.is-black .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-black .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar.is-black .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar.is-black .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-black .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar.is-black .navbar-item.has-dropdown:hover .navbar-link{background-color:#000;color:#fff}.runway-component .navbar.is-black .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-black .navbar-dropdown a.navbar-item.is-active{background-color:#0a0a0a;color:#fff}}.runway-component .navbar.is-light,.runway .navbar.is-light{background-color:#f5f5f5;color:rgba(0,0,0,.7)}.runway-component .navbar.is-light .navbar-brand .navbar-link,.runway-component .navbar.is-light .navbar-brand>.navbar-item,.runway .navbar.is-light .navbar-brand .navbar-link,.runway .navbar.is-light .navbar-brand>.navbar-item{color:rgba(0,0,0,.7)}.runway-component .navbar.is-light .navbar-brand .navbar-link.is-active,.runway-component .navbar.is-light .navbar-brand .navbar-link:focus,.runway-component .navbar.is-light .navbar-brand .navbar-link:hover,.runway-component .navbar.is-light .navbar-brand>a.navbar-item.is-active,.runway-component .navbar.is-light .navbar-brand>a.navbar-item:focus,.runway-component .navbar.is-light .navbar-brand>a.navbar-item:hover,.runway .navbar.is-light .navbar-brand .navbar-link.is-active,.runway .navbar.is-light .navbar-brand .navbar-link:focus,.runway .navbar.is-light .navbar-brand .navbar-link:hover,.runway .navbar.is-light .navbar-brand>a.navbar-item.is-active,.runway .navbar.is-light .navbar-brand>a.navbar-item:focus,.runway .navbar.is-light .navbar-brand>a.navbar-item:hover{background-color:#e8e8e8;color:rgba(0,0,0,.7)}.runway-component .navbar.is-light .navbar-brand .navbar-link:after,.runway .navbar.is-light .navbar-brand .navbar-link:after{border-color:rgba(0,0,0,.7)}.runway-component .navbar.is-light .navbar-burger,.runway .navbar.is-light .navbar-burger{color:rgba(0,0,0,.7)}@media screen and (min-width:1024px){.runway-component .navbar.is-light .navbar-end .navbar-link,.runway-component .navbar.is-light .navbar-end>.navbar-item,.runway-component .navbar.is-light .navbar-start .navbar-link,.runway-component .navbar.is-light .navbar-start>.navbar-item,.runway .navbar.is-light .navbar-end .navbar-link,.runway .navbar.is-light .navbar-end>.navbar-item,.runway .navbar.is-light .navbar-start .navbar-link,.runway .navbar.is-light .navbar-start>.navbar-item{color:rgba(0,0,0,.7)}.runway-component .navbar.is-light .navbar-end .navbar-link.is-active,.runway-component .navbar.is-light .navbar-end .navbar-link:focus,.runway-component .navbar.is-light .navbar-end .navbar-link:hover,.runway-component .navbar.is-light .navbar-end>a.navbar-item.is-active,.runway-component .navbar.is-light .navbar-end>a.navbar-item:focus,.runway-component .navbar.is-light .navbar-end>a.navbar-item:hover,.runway-component .navbar.is-light .navbar-start .navbar-link.is-active,.runway-component .navbar.is-light .navbar-start .navbar-link:focus,.runway-component .navbar.is-light .navbar-start .navbar-link:hover,.runway-component .navbar.is-light .navbar-start>a.navbar-item.is-active,.runway-component .navbar.is-light .navbar-start>a.navbar-item:focus,.runway-component .navbar.is-light .navbar-start>a.navbar-item:hover,.runway .navbar.is-light .navbar-end .navbar-link.is-active,.runway .navbar.is-light .navbar-end .navbar-link:focus,.runway .navbar.is-light .navbar-end .navbar-link:hover,.runway .navbar.is-light .navbar-end>a.navbar-item.is-active,.runway .navbar.is-light .navbar-end>a.navbar-item:focus,.runway .navbar.is-light .navbar-end>a.navbar-item:hover,.runway .navbar.is-light .navbar-start .navbar-link.is-active,.runway .navbar.is-light .navbar-start .navbar-link:focus,.runway .navbar.is-light .navbar-start .navbar-link:hover,.runway .navbar.is-light .navbar-start>a.navbar-item.is-active,.runway .navbar.is-light .navbar-start>a.navbar-item:focus,.runway .navbar.is-light .navbar-start>a.navbar-item:hover{background-color:#e8e8e8;color:rgba(0,0,0,.7)}.runway-component .navbar.is-light .navbar-end .navbar-link:after,.runway-component .navbar.is-light .navbar-start .navbar-link:after,.runway .navbar.is-light .navbar-end .navbar-link:after,.runway .navbar.is-light .navbar-start .navbar-link:after{border-color:rgba(0,0,0,.7)}.runway-component .navbar.is-light .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-light .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar.is-light .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar.is-light .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-light .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar.is-light .navbar-item.has-dropdown:hover .navbar-link{background-color:#e8e8e8;color:rgba(0,0,0,.7)}.runway-component .navbar.is-light .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-light .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:rgba(0,0,0,.7)}}.runway-component .navbar.is-dark,.runway .navbar.is-dark{background-color:#363636;color:#fff}.runway-component .navbar.is-dark .navbar-brand .navbar-link,.runway-component .navbar.is-dark .navbar-brand>.navbar-item,.runway .navbar.is-dark .navbar-brand .navbar-link,.runway .navbar.is-dark .navbar-brand>.navbar-item{color:#fff}.runway-component .navbar.is-dark .navbar-brand .navbar-link.is-active,.runway-component .navbar.is-dark .navbar-brand .navbar-link:focus,.runway-component .navbar.is-dark .navbar-brand .navbar-link:hover,.runway-component .navbar.is-dark .navbar-brand>a.navbar-item.is-active,.runway-component .navbar.is-dark .navbar-brand>a.navbar-item:focus,.runway-component .navbar.is-dark .navbar-brand>a.navbar-item:hover,.runway .navbar.is-dark .navbar-brand .navbar-link.is-active,.runway .navbar.is-dark .navbar-brand .navbar-link:focus,.runway .navbar.is-dark .navbar-brand .navbar-link:hover,.runway .navbar.is-dark .navbar-brand>a.navbar-item.is-active,.runway .navbar.is-dark .navbar-brand>a.navbar-item:focus,.runway .navbar.is-dark .navbar-brand>a.navbar-item:hover{background-color:#292929;color:#fff}.runway-component .navbar.is-dark .navbar-brand .navbar-link:after,.runway .navbar.is-dark .navbar-brand .navbar-link:after{border-color:#fff}.runway-component .navbar.is-dark .navbar-burger,.runway .navbar.is-dark .navbar-burger{color:#fff}@media screen and (min-width:1024px){.runway-component .navbar.is-dark .navbar-end .navbar-link,.runway-component .navbar.is-dark .navbar-end>.navbar-item,.runway-component .navbar.is-dark .navbar-start .navbar-link,.runway-component .navbar.is-dark .navbar-start>.navbar-item,.runway .navbar.is-dark .navbar-end .navbar-link,.runway .navbar.is-dark .navbar-end>.navbar-item,.runway .navbar.is-dark .navbar-start .navbar-link,.runway .navbar.is-dark .navbar-start>.navbar-item{color:#fff}.runway-component .navbar.is-dark .navbar-end .navbar-link.is-active,.runway-component .navbar.is-dark .navbar-end .navbar-link:focus,.runway-component .navbar.is-dark .navbar-end .navbar-link:hover,.runway-component .navbar.is-dark .navbar-end>a.navbar-item.is-active,.runway-component .navbar.is-dark .navbar-end>a.navbar-item:focus,.runway-component .navbar.is-dark .navbar-end>a.navbar-item:hover,.runway-component .navbar.is-dark .navbar-start .navbar-link.is-active,.runway-component .navbar.is-dark .navbar-start .navbar-link:focus,.runway-component .navbar.is-dark .navbar-start .navbar-link:hover,.runway-component .navbar.is-dark .navbar-start>a.navbar-item.is-active,.runway-component .navbar.is-dark .navbar-start>a.navbar-item:focus,.runway-component .navbar.is-dark .navbar-start>a.navbar-item:hover,.runway .navbar.is-dark .navbar-end .navbar-link.is-active,.runway .navbar.is-dark .navbar-end .navbar-link:focus,.runway .navbar.is-dark .navbar-end .navbar-link:hover,.runway .navbar.is-dark .navbar-end>a.navbar-item.is-active,.runway .navbar.is-dark .navbar-end>a.navbar-item:focus,.runway .navbar.is-dark .navbar-end>a.navbar-item:hover,.runway .navbar.is-dark .navbar-start .navbar-link.is-active,.runway .navbar.is-dark .navbar-start .navbar-link:focus,.runway .navbar.is-dark .navbar-start .navbar-link:hover,.runway .navbar.is-dark .navbar-start>a.navbar-item.is-active,.runway .navbar.is-dark .navbar-start>a.navbar-item:focus,.runway .navbar.is-dark .navbar-start>a.navbar-item:hover{background-color:#292929;color:#fff}.runway-component .navbar.is-dark .navbar-end .navbar-link:after,.runway-component .navbar.is-dark .navbar-start .navbar-link:after,.runway .navbar.is-dark .navbar-end .navbar-link:after,.runway .navbar.is-dark .navbar-start .navbar-link:after{border-color:#fff}.runway-component .navbar.is-dark .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-dark .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar.is-dark .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar.is-dark .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-dark .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar.is-dark .navbar-item.has-dropdown:hover .navbar-link{background-color:#292929;color:#fff}.runway-component .navbar.is-dark .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-dark .navbar-dropdown a.navbar-item.is-active{background-color:#363636;color:#fff}}.runway-component .navbar.is-primary,.runway .navbar.is-primary{background-color:#00d1b2;color:#fff}.runway-component .navbar.is-primary .navbar-brand .navbar-link,.runway-component .navbar.is-primary .navbar-brand>.navbar-item,.runway .navbar.is-primary .navbar-brand .navbar-link,.runway .navbar.is-primary .navbar-brand>.navbar-item{color:#fff}.runway-component .navbar.is-primary .navbar-brand .navbar-link.is-active,.runway-component .navbar.is-primary .navbar-brand .navbar-link:focus,.runway-component .navbar.is-primary .navbar-brand .navbar-link:hover,.runway-component .navbar.is-primary .navbar-brand>a.navbar-item.is-active,.runway-component .navbar.is-primary .navbar-brand>a.navbar-item:focus,.runway-component .navbar.is-primary .navbar-brand>a.navbar-item:hover,.runway .navbar.is-primary .navbar-brand .navbar-link.is-active,.runway .navbar.is-primary .navbar-brand .navbar-link:focus,.runway .navbar.is-primary .navbar-brand .navbar-link:hover,.runway .navbar.is-primary .navbar-brand>a.navbar-item.is-active,.runway .navbar.is-primary .navbar-brand>a.navbar-item:focus,.runway .navbar.is-primary .navbar-brand>a.navbar-item:hover{background-color:#00b89c;color:#fff}.runway-component .navbar.is-primary .navbar-brand .navbar-link:after,.runway .navbar.is-primary .navbar-brand .navbar-link:after{border-color:#fff}.runway-component .navbar.is-primary .navbar-burger,.runway .navbar.is-primary .navbar-burger{color:#fff}@media screen and (min-width:1024px){.runway-component .navbar.is-primary .navbar-end .navbar-link,.runway-component .navbar.is-primary .navbar-end>.navbar-item,.runway-component .navbar.is-primary .navbar-start .navbar-link,.runway-component .navbar.is-primary .navbar-start>.navbar-item,.runway .navbar.is-primary .navbar-end .navbar-link,.runway .navbar.is-primary .navbar-end>.navbar-item,.runway .navbar.is-primary .navbar-start .navbar-link,.runway .navbar.is-primary .navbar-start>.navbar-item{color:#fff}.runway-component .navbar.is-primary .navbar-end .navbar-link.is-active,.runway-component .navbar.is-primary .navbar-end .navbar-link:focus,.runway-component .navbar.is-primary .navbar-end .navbar-link:hover,.runway-component .navbar.is-primary .navbar-end>a.navbar-item.is-active,.runway-component .navbar.is-primary .navbar-end>a.navbar-item:focus,.runway-component .navbar.is-primary .navbar-end>a.navbar-item:hover,.runway-component .navbar.is-primary .navbar-start .navbar-link.is-active,.runway-component .navbar.is-primary .navbar-start .navbar-link:focus,.runway-component .navbar.is-primary .navbar-start .navbar-link:hover,.runway-component .navbar.is-primary .navbar-start>a.navbar-item.is-active,.runway-component .navbar.is-primary .navbar-start>a.navbar-item:focus,.runway-component .navbar.is-primary .navbar-start>a.navbar-item:hover,.runway .navbar.is-primary .navbar-end .navbar-link.is-active,.runway .navbar.is-primary .navbar-end .navbar-link:focus,.runway .navbar.is-primary .navbar-end .navbar-link:hover,.runway .navbar.is-primary .navbar-end>a.navbar-item.is-active,.runway .navbar.is-primary .navbar-end>a.navbar-item:focus,.runway .navbar.is-primary .navbar-end>a.navbar-item:hover,.runway .navbar.is-primary .navbar-start .navbar-link.is-active,.runway .navbar.is-primary .navbar-start .navbar-link:focus,.runway .navbar.is-primary .navbar-start .navbar-link:hover,.runway .navbar.is-primary .navbar-start>a.navbar-item.is-active,.runway .navbar.is-primary .navbar-start>a.navbar-item:focus,.runway .navbar.is-primary .navbar-start>a.navbar-item:hover{background-color:#00b89c;color:#fff}.runway-component .navbar.is-primary .navbar-end .navbar-link:after,.runway-component .navbar.is-primary .navbar-start .navbar-link:after,.runway .navbar.is-primary .navbar-end .navbar-link:after,.runway .navbar.is-primary .navbar-start .navbar-link:after{border-color:#fff}.runway-component .navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-primary .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-primary .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link{background-color:#00b89c;color:#fff}.runway-component .navbar.is-primary .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-primary .navbar-dropdown a.navbar-item.is-active{background-color:#00d1b2;color:#fff}}.runway-component .navbar.is-link,.runway .navbar.is-link{background-color:#3273dc;color:#fff}.runway-component .navbar.is-link .navbar-brand .navbar-link,.runway-component .navbar.is-link .navbar-brand>.navbar-item,.runway .navbar.is-link .navbar-brand .navbar-link,.runway .navbar.is-link .navbar-brand>.navbar-item{color:#fff}.runway-component .navbar.is-link .navbar-brand .navbar-link.is-active,.runway-component .navbar.is-link .navbar-brand .navbar-link:focus,.runway-component .navbar.is-link .navbar-brand .navbar-link:hover,.runway-component .navbar.is-link .navbar-brand>a.navbar-item.is-active,.runway-component .navbar.is-link .navbar-brand>a.navbar-item:focus,.runway-component .navbar.is-link .navbar-brand>a.navbar-item:hover,.runway .navbar.is-link .navbar-brand .navbar-link.is-active,.runway .navbar.is-link .navbar-brand .navbar-link:focus,.runway .navbar.is-link .navbar-brand .navbar-link:hover,.runway .navbar.is-link .navbar-brand>a.navbar-item.is-active,.runway .navbar.is-link .navbar-brand>a.navbar-item:focus,.runway .navbar.is-link .navbar-brand>a.navbar-item:hover{background-color:#2366d1;color:#fff}.runway-component .navbar.is-link .navbar-brand .navbar-link:after,.runway .navbar.is-link .navbar-brand .navbar-link:after{border-color:#fff}.runway-component .navbar.is-link .navbar-burger,.runway .navbar.is-link .navbar-burger{color:#fff}@media screen and (min-width:1024px){.runway-component .navbar.is-link .navbar-end .navbar-link,.runway-component .navbar.is-link .navbar-end>.navbar-item,.runway-component .navbar.is-link .navbar-start .navbar-link,.runway-component .navbar.is-link .navbar-start>.navbar-item,.runway .navbar.is-link .navbar-end .navbar-link,.runway .navbar.is-link .navbar-end>.navbar-item,.runway .navbar.is-link .navbar-start .navbar-link,.runway .navbar.is-link .navbar-start>.navbar-item{color:#fff}.runway-component .navbar.is-link .navbar-end .navbar-link.is-active,.runway-component .navbar.is-link .navbar-end .navbar-link:focus,.runway-component .navbar.is-link .navbar-end .navbar-link:hover,.runway-component .navbar.is-link .navbar-end>a.navbar-item.is-active,.runway-component .navbar.is-link .navbar-end>a.navbar-item:focus,.runway-component .navbar.is-link .navbar-end>a.navbar-item:hover,.runway-component .navbar.is-link .navbar-start .navbar-link.is-active,.runway-component .navbar.is-link .navbar-start .navbar-link:focus,.runway-component .navbar.is-link .navbar-start .navbar-link:hover,.runway-component .navbar.is-link .navbar-start>a.navbar-item.is-active,.runway-component .navbar.is-link .navbar-start>a.navbar-item:focus,.runway-component .navbar.is-link .navbar-start>a.navbar-item:hover,.runway .navbar.is-link .navbar-end .navbar-link.is-active,.runway .navbar.is-link .navbar-end .navbar-link:focus,.runway .navbar.is-link .navbar-end .navbar-link:hover,.runway .navbar.is-link .navbar-end>a.navbar-item.is-active,.runway .navbar.is-link .navbar-end>a.navbar-item:focus,.runway .navbar.is-link .navbar-end>a.navbar-item:hover,.runway .navbar.is-link .navbar-start .navbar-link.is-active,.runway .navbar.is-link .navbar-start .navbar-link:focus,.runway .navbar.is-link .navbar-start .navbar-link:hover,.runway .navbar.is-link .navbar-start>a.navbar-item.is-active,.runway .navbar.is-link .navbar-start>a.navbar-item:focus,.runway .navbar.is-link .navbar-start>a.navbar-item:hover{background-color:#2366d1;color:#fff}.runway-component .navbar.is-link .navbar-end .navbar-link:after,.runway-component .navbar.is-link .navbar-start .navbar-link:after,.runway .navbar.is-link .navbar-end .navbar-link:after,.runway .navbar.is-link .navbar-start .navbar-link:after{border-color:#fff}.runway-component .navbar.is-link .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-link .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar.is-link .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar.is-link .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-link .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar.is-link .navbar-item.has-dropdown:hover .navbar-link{background-color:#2366d1;color:#fff}.runway-component .navbar.is-link .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-link .navbar-dropdown a.navbar-item.is-active{background-color:#3273dc;color:#fff}}.runway-component .navbar.is-info,.runway .navbar.is-info{background-color:#3298dc;color:#fff}.runway-component .navbar.is-info .navbar-brand .navbar-link,.runway-component .navbar.is-info .navbar-brand>.navbar-item,.runway .navbar.is-info .navbar-brand .navbar-link,.runway .navbar.is-info .navbar-brand>.navbar-item{color:#fff}.runway-component .navbar.is-info .navbar-brand .navbar-link.is-active,.runway-component .navbar.is-info .navbar-brand .navbar-link:focus,.runway-component .navbar.is-info .navbar-brand .navbar-link:hover,.runway-component .navbar.is-info .navbar-brand>a.navbar-item.is-active,.runway-component .navbar.is-info .navbar-brand>a.navbar-item:focus,.runway-component .navbar.is-info .navbar-brand>a.navbar-item:hover,.runway .navbar.is-info .navbar-brand .navbar-link.is-active,.runway .navbar.is-info .navbar-brand .navbar-link:focus,.runway .navbar.is-info .navbar-brand .navbar-link:hover,.runway .navbar.is-info .navbar-brand>a.navbar-item.is-active,.runway .navbar.is-info .navbar-brand>a.navbar-item:focus,.runway .navbar.is-info .navbar-brand>a.navbar-item:hover{background-color:#238cd1;color:#fff}.runway-component .navbar.is-info .navbar-brand .navbar-link:after,.runway .navbar.is-info .navbar-brand .navbar-link:after{border-color:#fff}.runway-component .navbar.is-info .navbar-burger,.runway .navbar.is-info .navbar-burger{color:#fff}@media screen and (min-width:1024px){.runway-component .navbar.is-info .navbar-end .navbar-link,.runway-component .navbar.is-info .navbar-end>.navbar-item,.runway-component .navbar.is-info .navbar-start .navbar-link,.runway-component .navbar.is-info .navbar-start>.navbar-item,.runway .navbar.is-info .navbar-end .navbar-link,.runway .navbar.is-info .navbar-end>.navbar-item,.runway .navbar.is-info .navbar-start .navbar-link,.runway .navbar.is-info .navbar-start>.navbar-item{color:#fff}.runway-component .navbar.is-info .navbar-end .navbar-link.is-active,.runway-component .navbar.is-info .navbar-end .navbar-link:focus,.runway-component .navbar.is-info .navbar-end .navbar-link:hover,.runway-component .navbar.is-info .navbar-end>a.navbar-item.is-active,.runway-component .navbar.is-info .navbar-end>a.navbar-item:focus,.runway-component .navbar.is-info .navbar-end>a.navbar-item:hover,.runway-component .navbar.is-info .navbar-start .navbar-link.is-active,.runway-component .navbar.is-info .navbar-start .navbar-link:focus,.runway-component .navbar.is-info .navbar-start .navbar-link:hover,.runway-component .navbar.is-info .navbar-start>a.navbar-item.is-active,.runway-component .navbar.is-info .navbar-start>a.navbar-item:focus,.runway-component .navbar.is-info .navbar-start>a.navbar-item:hover,.runway .navbar.is-info .navbar-end .navbar-link.is-active,.runway .navbar.is-info .navbar-end .navbar-link:focus,.runway .navbar.is-info .navbar-end .navbar-link:hover,.runway .navbar.is-info .navbar-end>a.navbar-item.is-active,.runway .navbar.is-info .navbar-end>a.navbar-item:focus,.runway .navbar.is-info .navbar-end>a.navbar-item:hover,.runway .navbar.is-info .navbar-start .navbar-link.is-active,.runway .navbar.is-info .navbar-start .navbar-link:focus,.runway .navbar.is-info .navbar-start .navbar-link:hover,.runway .navbar.is-info .navbar-start>a.navbar-item.is-active,.runway .navbar.is-info .navbar-start>a.navbar-item:focus,.runway .navbar.is-info .navbar-start>a.navbar-item:hover{background-color:#238cd1;color:#fff}.runway-component .navbar.is-info .navbar-end .navbar-link:after,.runway-component .navbar.is-info .navbar-start .navbar-link:after,.runway .navbar.is-info .navbar-end .navbar-link:after,.runway .navbar.is-info .navbar-start .navbar-link:after{border-color:#fff}.runway-component .navbar.is-info .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-info .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar.is-info .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar.is-info .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-info .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar.is-info .navbar-item.has-dropdown:hover .navbar-link{background-color:#238cd1;color:#fff}.runway-component .navbar.is-info .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-info .navbar-dropdown a.navbar-item.is-active{background-color:#3298dc;color:#fff}}.runway-component .navbar.is-success,.runway .navbar.is-success{background-color:#48c774;color:#fff}.runway-component .navbar.is-success .navbar-brand .navbar-link,.runway-component .navbar.is-success .navbar-brand>.navbar-item,.runway .navbar.is-success .navbar-brand .navbar-link,.runway .navbar.is-success .navbar-brand>.navbar-item{color:#fff}.runway-component .navbar.is-success .navbar-brand .navbar-link.is-active,.runway-component .navbar.is-success .navbar-brand .navbar-link:focus,.runway-component .navbar.is-success .navbar-brand .navbar-link:hover,.runway-component .navbar.is-success .navbar-brand>a.navbar-item.is-active,.runway-component .navbar.is-success .navbar-brand>a.navbar-item:focus,.runway-component .navbar.is-success .navbar-brand>a.navbar-item:hover,.runway .navbar.is-success .navbar-brand .navbar-link.is-active,.runway .navbar.is-success .navbar-brand .navbar-link:focus,.runway .navbar.is-success .navbar-brand .navbar-link:hover,.runway .navbar.is-success .navbar-brand>a.navbar-item.is-active,.runway .navbar.is-success .navbar-brand>a.navbar-item:focus,.runway .navbar.is-success .navbar-brand>a.navbar-item:hover{background-color:#3abb67;color:#fff}.runway-component .navbar.is-success .navbar-brand .navbar-link:after,.runway .navbar.is-success .navbar-brand .navbar-link:after{border-color:#fff}.runway-component .navbar.is-success .navbar-burger,.runway .navbar.is-success .navbar-burger{color:#fff}@media screen and (min-width:1024px){.runway-component .navbar.is-success .navbar-end .navbar-link,.runway-component .navbar.is-success .navbar-end>.navbar-item,.runway-component .navbar.is-success .navbar-start .navbar-link,.runway-component .navbar.is-success .navbar-start>.navbar-item,.runway .navbar.is-success .navbar-end .navbar-link,.runway .navbar.is-success .navbar-end>.navbar-item,.runway .navbar.is-success .navbar-start .navbar-link,.runway .navbar.is-success .navbar-start>.navbar-item{color:#fff}.runway-component .navbar.is-success .navbar-end .navbar-link.is-active,.runway-component .navbar.is-success .navbar-end .navbar-link:focus,.runway-component .navbar.is-success .navbar-end .navbar-link:hover,.runway-component .navbar.is-success .navbar-end>a.navbar-item.is-active,.runway-component .navbar.is-success .navbar-end>a.navbar-item:focus,.runway-component .navbar.is-success .navbar-end>a.navbar-item:hover,.runway-component .navbar.is-success .navbar-start .navbar-link.is-active,.runway-component .navbar.is-success .navbar-start .navbar-link:focus,.runway-component .navbar.is-success .navbar-start .navbar-link:hover,.runway-component .navbar.is-success .navbar-start>a.navbar-item.is-active,.runway-component .navbar.is-success .navbar-start>a.navbar-item:focus,.runway-component .navbar.is-success .navbar-start>a.navbar-item:hover,.runway .navbar.is-success .navbar-end .navbar-link.is-active,.runway .navbar.is-success .navbar-end .navbar-link:focus,.runway .navbar.is-success .navbar-end .navbar-link:hover,.runway .navbar.is-success .navbar-end>a.navbar-item.is-active,.runway .navbar.is-success .navbar-end>a.navbar-item:focus,.runway .navbar.is-success .navbar-end>a.navbar-item:hover,.runway .navbar.is-success .navbar-start .navbar-link.is-active,.runway .navbar.is-success .navbar-start .navbar-link:focus,.runway .navbar.is-success .navbar-start .navbar-link:hover,.runway .navbar.is-success .navbar-start>a.navbar-item.is-active,.runway .navbar.is-success .navbar-start>a.navbar-item:focus,.runway .navbar.is-success .navbar-start>a.navbar-item:hover{background-color:#3abb67;color:#fff}.runway-component .navbar.is-success .navbar-end .navbar-link:after,.runway-component .navbar.is-success .navbar-start .navbar-link:after,.runway .navbar.is-success .navbar-end .navbar-link:after,.runway .navbar.is-success .navbar-start .navbar-link:after{border-color:#fff}.runway-component .navbar.is-success .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-success .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar.is-success .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar.is-success .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-success .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar.is-success .navbar-item.has-dropdown:hover .navbar-link{background-color:#3abb67;color:#fff}.runway-component .navbar.is-success .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-success .navbar-dropdown a.navbar-item.is-active{background-color:#48c774;color:#fff}}.runway-component .navbar.is-warning,.runway .navbar.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.runway-component .navbar.is-warning .navbar-brand .navbar-link,.runway-component .navbar.is-warning .navbar-brand>.navbar-item,.runway .navbar.is-warning .navbar-brand .navbar-link,.runway .navbar.is-warning .navbar-brand>.navbar-item{color:rgba(0,0,0,.7)}.runway-component .navbar.is-warning .navbar-brand .navbar-link.is-active,.runway-component .navbar.is-warning .navbar-brand .navbar-link:focus,.runway-component .navbar.is-warning .navbar-brand .navbar-link:hover,.runway-component .navbar.is-warning .navbar-brand>a.navbar-item.is-active,.runway-component .navbar.is-warning .navbar-brand>a.navbar-item:focus,.runway-component .navbar.is-warning .navbar-brand>a.navbar-item:hover,.runway .navbar.is-warning .navbar-brand .navbar-link.is-active,.runway .navbar.is-warning .navbar-brand .navbar-link:focus,.runway .navbar.is-warning .navbar-brand .navbar-link:hover,.runway .navbar.is-warning .navbar-brand>a.navbar-item.is-active,.runway .navbar.is-warning .navbar-brand>a.navbar-item:focus,.runway .navbar.is-warning .navbar-brand>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.runway-component .navbar.is-warning .navbar-brand .navbar-link:after,.runway .navbar.is-warning .navbar-brand .navbar-link:after{border-color:rgba(0,0,0,.7)}.runway-component .navbar.is-warning .navbar-burger,.runway .navbar.is-warning .navbar-burger{color:rgba(0,0,0,.7)}@media screen and (min-width:1024px){.runway-component .navbar.is-warning .navbar-end .navbar-link,.runway-component .navbar.is-warning .navbar-end>.navbar-item,.runway-component .navbar.is-warning .navbar-start .navbar-link,.runway-component .navbar.is-warning .navbar-start>.navbar-item,.runway .navbar.is-warning .navbar-end .navbar-link,.runway .navbar.is-warning .navbar-end>.navbar-item,.runway .navbar.is-warning .navbar-start .navbar-link,.runway .navbar.is-warning .navbar-start>.navbar-item{color:rgba(0,0,0,.7)}.runway-component .navbar.is-warning .navbar-end .navbar-link.is-active,.runway-component .navbar.is-warning .navbar-end .navbar-link:focus,.runway-component .navbar.is-warning .navbar-end .navbar-link:hover,.runway-component .navbar.is-warning .navbar-end>a.navbar-item.is-active,.runway-component .navbar.is-warning .navbar-end>a.navbar-item:focus,.runway-component .navbar.is-warning .navbar-end>a.navbar-item:hover,.runway-component .navbar.is-warning .navbar-start .navbar-link.is-active,.runway-component .navbar.is-warning .navbar-start .navbar-link:focus,.runway-component .navbar.is-warning .navbar-start .navbar-link:hover,.runway-component .navbar.is-warning .navbar-start>a.navbar-item.is-active,.runway-component .navbar.is-warning .navbar-start>a.navbar-item:focus,.runway-component .navbar.is-warning .navbar-start>a.navbar-item:hover,.runway .navbar.is-warning .navbar-end .navbar-link.is-active,.runway .navbar.is-warning .navbar-end .navbar-link:focus,.runway .navbar.is-warning .navbar-end .navbar-link:hover,.runway .navbar.is-warning .navbar-end>a.navbar-item.is-active,.runway .navbar.is-warning .navbar-end>a.navbar-item:focus,.runway .navbar.is-warning .navbar-end>a.navbar-item:hover,.runway .navbar.is-warning .navbar-start .navbar-link.is-active,.runway .navbar.is-warning .navbar-start .navbar-link:focus,.runway .navbar.is-warning .navbar-start .navbar-link:hover,.runway .navbar.is-warning .navbar-start>a.navbar-item.is-active,.runway .navbar.is-warning .navbar-start>a.navbar-item:focus,.runway .navbar.is-warning .navbar-start>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.runway-component .navbar.is-warning .navbar-end .navbar-link:after,.runway-component .navbar.is-warning .navbar-start .navbar-link:after,.runway .navbar.is-warning .navbar-end .navbar-link:after,.runway .navbar.is-warning .navbar-start .navbar-link:after{border-color:rgba(0,0,0,.7)}.runway-component .navbar.is-warning .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-warning .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar.is-warning .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar.is-warning .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-warning .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar.is-warning .navbar-item.has-dropdown:hover .navbar-link{background-color:#ffd83d;color:rgba(0,0,0,.7)}.runway-component .navbar.is-warning .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-warning .navbar-dropdown a.navbar-item.is-active{background-color:#ffdd57;color:rgba(0,0,0,.7)}}.runway-component .navbar.is-danger,.runway .navbar.is-danger{background-color:#f14668;color:#fff}.runway-component .navbar.is-danger .navbar-brand .navbar-link,.runway-component .navbar.is-danger .navbar-brand>.navbar-item,.runway .navbar.is-danger .navbar-brand .navbar-link,.runway .navbar.is-danger .navbar-brand>.navbar-item{color:#fff}.runway-component .navbar.is-danger .navbar-brand .navbar-link.is-active,.runway-component .navbar.is-danger .navbar-brand .navbar-link:focus,.runway-component .navbar.is-danger .navbar-brand .navbar-link:hover,.runway-component .navbar.is-danger .navbar-brand>a.navbar-item.is-active,.runway-component .navbar.is-danger .navbar-brand>a.navbar-item:focus,.runway-component .navbar.is-danger .navbar-brand>a.navbar-item:hover,.runway .navbar.is-danger .navbar-brand .navbar-link.is-active,.runway .navbar.is-danger .navbar-brand .navbar-link:focus,.runway .navbar.is-danger .navbar-brand .navbar-link:hover,.runway .navbar.is-danger .navbar-brand>a.navbar-item.is-active,.runway .navbar.is-danger .navbar-brand>a.navbar-item:focus,.runway .navbar.is-danger .navbar-brand>a.navbar-item:hover{background-color:#ef2e55;color:#fff}.runway-component .navbar.is-danger .navbar-brand .navbar-link:after,.runway .navbar.is-danger .navbar-brand .navbar-link:after{border-color:#fff}.runway-component .navbar.is-danger .navbar-burger,.runway .navbar.is-danger .navbar-burger{color:#fff}@media screen and (min-width:1024px){.runway-component .navbar.is-danger .navbar-end .navbar-link,.runway-component .navbar.is-danger .navbar-end>.navbar-item,.runway-component .navbar.is-danger .navbar-start .navbar-link,.runway-component .navbar.is-danger .navbar-start>.navbar-item,.runway .navbar.is-danger .navbar-end .navbar-link,.runway .navbar.is-danger .navbar-end>.navbar-item,.runway .navbar.is-danger .navbar-start .navbar-link,.runway .navbar.is-danger .navbar-start>.navbar-item{color:#fff}.runway-component .navbar.is-danger .navbar-end .navbar-link.is-active,.runway-component .navbar.is-danger .navbar-end .navbar-link:focus,.runway-component .navbar.is-danger .navbar-end .navbar-link:hover,.runway-component .navbar.is-danger .navbar-end>a.navbar-item.is-active,.runway-component .navbar.is-danger .navbar-end>a.navbar-item:focus,.runway-component .navbar.is-danger .navbar-end>a.navbar-item:hover,.runway-component .navbar.is-danger .navbar-start .navbar-link.is-active,.runway-component .navbar.is-danger .navbar-start .navbar-link:focus,.runway-component .navbar.is-danger .navbar-start .navbar-link:hover,.runway-component .navbar.is-danger .navbar-start>a.navbar-item.is-active,.runway-component .navbar.is-danger .navbar-start>a.navbar-item:focus,.runway-component .navbar.is-danger .navbar-start>a.navbar-item:hover,.runway .navbar.is-danger .navbar-end .navbar-link.is-active,.runway .navbar.is-danger .navbar-end .navbar-link:focus,.runway .navbar.is-danger .navbar-end .navbar-link:hover,.runway .navbar.is-danger .navbar-end>a.navbar-item.is-active,.runway .navbar.is-danger .navbar-end>a.navbar-item:focus,.runway .navbar.is-danger .navbar-end>a.navbar-item:hover,.runway .navbar.is-danger .navbar-start .navbar-link.is-active,.runway .navbar.is-danger .navbar-start .navbar-link:focus,.runway .navbar.is-danger .navbar-start .navbar-link:hover,.runway .navbar.is-danger .navbar-start>a.navbar-item.is-active,.runway .navbar.is-danger .navbar-start>a.navbar-item:focus,.runway .navbar.is-danger .navbar-start>a.navbar-item:hover{background-color:#ef2e55;color:#fff}.runway-component .navbar.is-danger .navbar-end .navbar-link:after,.runway-component .navbar.is-danger .navbar-start .navbar-link:after,.runway .navbar.is-danger .navbar-end .navbar-link:after,.runway .navbar.is-danger .navbar-start .navbar-link:after{border-color:#fff}.runway-component .navbar.is-danger .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-danger .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar.is-danger .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar.is-danger .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-danger .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar.is-danger .navbar-item.has-dropdown:hover .navbar-link{background-color:#ef2e55;color:#fff}.runway-component .navbar.is-danger .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-danger .navbar-dropdown a.navbar-item.is-active{background-color:#f14668;color:#fff}}.runway-component .navbar>.container,.runway .navbar>.container{align-items:stretch;display:flex;min-height:3.25rem;width:100%}.runway-component .navbar.has-shadow,.runway .navbar.has-shadow{box-shadow:0 2px 0 0 #f5f5f5}.runway-component .navbar.is-fixed-bottom,.runway-component .navbar.is-fixed-top,.runway .navbar.is-fixed-bottom,.runway .navbar.is-fixed-top{left:0;position:fixed;right:0;z-index:30}.runway-component .navbar.is-fixed-bottom,.runway .navbar.is-fixed-bottom{bottom:0}.runway-component .navbar.is-fixed-bottom.has-shadow,.runway .navbar.is-fixed-bottom.has-shadow{box-shadow:0 -2px 0 0 #f5f5f5}.runway-component .navbar.is-fixed-top,.runway .navbar.is-fixed-top{top:0}.runway-component body.has-navbar-fixed-top,.runway-component html.has-navbar-fixed-top,.runway body.has-navbar-fixed-top,.runway html.has-navbar-fixed-top{padding-top:3.25rem}.runway-component body.has-navbar-fixed-bottom,.runway-component html.has-navbar-fixed-bottom,.runway body.has-navbar-fixed-bottom,.runway html.has-navbar-fixed-bottom{padding-bottom:3.25rem}.runway-component .navbar-brand,.runway-component .navbar-tabs,.runway .navbar-brand,.runway .navbar-tabs{align-items:stretch;display:flex;flex-shrink:0;min-height:3.25rem}.runway-component .navbar-brand a.navbar-item:focus,.runway-component .navbar-brand a.navbar-item:hover,.runway .navbar-brand a.navbar-item:focus,.runway .navbar-brand a.navbar-item:hover{background-color:transparent}.runway-component .navbar-tabs,.runway .navbar-tabs{-webkit-overflow-scrolling:touch;max-width:100vw;overflow-x:auto;overflow-y:hidden}.runway-component .navbar-burger,.runway .navbar-burger{color:#4a4a4a;cursor:pointer;display:block;height:3.25rem;position:relative;width:3.25rem;margin-left:auto}.runway-component .navbar-burger span,.runway .navbar-burger span{background-color:currentColor;display:block;height:1px;left:calc(50% - 8px);position:absolute;transform-origin:center;transition-duration:86ms;transition-property:background-color,opacity,transform;transition-timing-function:ease-out;width:16px}.runway-component .navbar-burger span:first-child,.runway .navbar-burger span:first-child{top:calc(50% - 6px)}.runway-component .navbar-burger span:nth-child(2),.runway .navbar-burger span:nth-child(2){top:calc(50% - 1px)}.runway-component .navbar-burger span:nth-child(3),.runway .navbar-burger span:nth-child(3){top:calc(50% + 4px)}.runway-component .navbar-burger:hover,.runway .navbar-burger:hover{background-color:rgba(0,0,0,.05)}.runway-component .navbar-burger.is-active span:first-child,.runway .navbar-burger.is-active span:first-child{transform:translateY(5px) rotate(45deg)}.runway-component .navbar-burger.is-active span:nth-child(2),.runway .navbar-burger.is-active span:nth-child(2){opacity:0}.runway-component .navbar-burger.is-active span:nth-child(3),.runway .navbar-burger.is-active span:nth-child(3){transform:translateY(-5px) rotate(-45deg)}.runway-component .navbar-menu,.runway .navbar-menu{display:none}.runway-component .navbar-item,.runway-component .navbar-link,.runway .navbar-item,.runway .navbar-link{color:#4a4a4a;display:block;line-height:1.5;padding:.5rem .75rem;position:relative}.runway-component .navbar-item .icon:only-child,.runway-component .navbar-link .icon:only-child,.runway .navbar-item .icon:only-child,.runway .navbar-link .icon:only-child{margin-left:-.25rem;margin-right:-.25rem}.runway-component .navbar-link,.runway-component a.navbar-item,.runway .navbar-link,.runway a.navbar-item{cursor:pointer}.runway-component .navbar-link.is-active,.runway-component .navbar-link:focus,.runway-component .navbar-link:focus-within,.runway-component .navbar-link:hover,.runway-component a.navbar-item.is-active,.runway-component a.navbar-item:focus,.runway-component a.navbar-item:focus-within,.runway-component a.navbar-item:hover,.runway .navbar-link.is-active,.runway .navbar-link:focus,.runway .navbar-link:focus-within,.runway .navbar-link:hover,.runway a.navbar-item.is-active,.runway a.navbar-item:focus,.runway a.navbar-item:focus-within,.runway a.navbar-item:hover{background-color:#fafafa;color:#3273dc}.runway-component .navbar-item,.runway .navbar-item{flex-grow:0;flex-shrink:0}.runway-component .navbar-item img,.runway .navbar-item img{max-height:1.75rem}.runway-component .navbar-item.has-dropdown,.runway .navbar-item.has-dropdown{padding:0}.runway-component .navbar-item.is-expanded,.runway .navbar-item.is-expanded{flex-grow:1;flex-shrink:1}.runway-component .navbar-item.is-tab,.runway .navbar-item.is-tab{border-bottom:1px solid transparent;min-height:3.25rem;padding-bottom:calc(.5rem - 1px)}.runway-component .navbar-item.is-tab:focus,.runway-component .navbar-item.is-tab:hover,.runway .navbar-item.is-tab:focus,.runway .navbar-item.is-tab:hover{background-color:transparent;border-bottom-color:#3273dc}.runway-component .navbar-item.is-tab.is-active,.runway .navbar-item.is-tab.is-active{background-color:transparent;border-bottom-color:#3273dc;border-bottom-style:solid;border-bottom-width:3px;color:#3273dc;padding-bottom:calc(.5rem - 3px)}.runway-component .navbar-content,.runway .navbar-content{flex-grow:1;flex-shrink:1}.runway-component .navbar-link:not(.is-arrowless),.runway .navbar-link:not(.is-arrowless){padding-right:2.5em}.runway-component .navbar-link:not(.is-arrowless):after,.runway .navbar-link:not(.is-arrowless):after{border-color:#3273dc;margin-top:-.375em;right:1.125em}.runway-component .navbar-dropdown,.runway .navbar-dropdown{font-size:.875rem;padding-bottom:.5rem;padding-top:.5rem}.runway-component .navbar-dropdown .navbar-item,.runway .navbar-dropdown .navbar-item{padding-left:1.5rem;padding-right:1.5rem}.runway-component .navbar-divider,.runway .navbar-divider{background-color:#f5f5f5;border:none;display:none;height:2px;margin:.5rem 0}@media screen and (max-width:1023px){.runway-component .navbar>.container,.runway .navbar>.container{display:block}.runway-component .navbar-brand .navbar-item,.runway-component .navbar-tabs .navbar-item,.runway .navbar-brand .navbar-item,.runway .navbar-tabs .navbar-item{align-items:center;display:flex}.runway-component .navbar-link:after,.runway .navbar-link:after{display:none}.runway-component .navbar-menu,.runway .navbar-menu{background-color:#fff;box-shadow:0 8px 16px hsla(0,0%,4%,.1);padding:.5rem 0}.runway-component .navbar-menu.is-active,.runway .navbar-menu.is-active{display:block}.runway-component .navbar.is-fixed-bottom-touch,.runway-component .navbar.is-fixed-top-touch,.runway .navbar.is-fixed-bottom-touch,.runway .navbar.is-fixed-top-touch{left:0;position:fixed;right:0;z-index:30}.runway-component .navbar.is-fixed-bottom-touch,.runway .navbar.is-fixed-bottom-touch{bottom:0}.runway-component .navbar.is-fixed-bottom-touch.has-shadow,.runway .navbar.is-fixed-bottom-touch.has-shadow{box-shadow:0 -2px 3px hsla(0,0%,4%,.1)}.runway-component .navbar.is-fixed-top-touch,.runway .navbar.is-fixed-top-touch{top:0}.runway-component .navbar.is-fixed-top-touch .navbar-menu,.runway-component .navbar.is-fixed-top .navbar-menu,.runway .navbar.is-fixed-top-touch .navbar-menu,.runway .navbar.is-fixed-top .navbar-menu{-webkit-overflow-scrolling:touch;max-height:calc(100vh - 3.25rem);overflow:auto}.runway-component body.has-navbar-fixed-top-touch,.runway-component html.has-navbar-fixed-top-touch,.runway body.has-navbar-fixed-top-touch,.runway html.has-navbar-fixed-top-touch{padding-top:3.25rem}.runway-component body.has-navbar-fixed-bottom-touch,.runway-component html.has-navbar-fixed-bottom-touch,.runway body.has-navbar-fixed-bottom-touch,.runway html.has-navbar-fixed-bottom-touch{padding-bottom:3.25rem}}@media screen and (min-width:1024px){.runway-component .navbar,.runway-component .navbar-end,.runway-component .navbar-menu,.runway-component .navbar-start,.runway .navbar,.runway .navbar-end,.runway .navbar-menu,.runway .navbar-start{align-items:stretch;display:flex}.runway-component .navbar,.runway .navbar{min-height:3.25rem}.runway-component .navbar.is-spaced,.runway .navbar.is-spaced{padding:1rem 2rem}.runway-component .navbar.is-spaced .navbar-end,.runway-component .navbar.is-spaced .navbar-start,.runway .navbar.is-spaced .navbar-end,.runway .navbar.is-spaced .navbar-start{align-items:center}.runway-component .navbar.is-spaced .navbar-link,.runway-component .navbar.is-spaced a.navbar-item,.runway .navbar.is-spaced .navbar-link,.runway .navbar.is-spaced a.navbar-item{border-radius:4px}.runway-component .navbar.is-transparent .navbar-link.is-active,.runway-component .navbar.is-transparent .navbar-link:focus,.runway-component .navbar.is-transparent .navbar-link:hover,.runway-component .navbar.is-transparent a.navbar-item.is-active,.runway-component .navbar.is-transparent a.navbar-item:focus,.runway-component .navbar.is-transparent a.navbar-item:hover,.runway .navbar.is-transparent .navbar-link.is-active,.runway .navbar.is-transparent .navbar-link:focus,.runway .navbar.is-transparent .navbar-link:hover,.runway .navbar.is-transparent a.navbar-item.is-active,.runway .navbar.is-transparent a.navbar-item:focus,.runway .navbar.is-transparent a.navbar-item:hover{background-color:transparent!important}.runway-component .navbar.is-transparent .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:focus-within .navbar-link,.runway-component .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:focus .navbar-link,.runway-component .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:hover .navbar-link,.runway .navbar.is-transparent .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:focus-within .navbar-link,.runway .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:focus .navbar-link,.runway .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:hover .navbar-link{background-color:transparent!important}.runway-component .navbar.is-transparent .navbar-dropdown a.navbar-item:focus,.runway-component .navbar.is-transparent .navbar-dropdown a.navbar-item:hover,.runway .navbar.is-transparent .navbar-dropdown a.navbar-item:focus,.runway .navbar.is-transparent .navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.runway-component .navbar.is-transparent .navbar-dropdown a.navbar-item.is-active,.runway .navbar.is-transparent .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#3273dc}.runway-component .navbar-burger,.runway .navbar-burger{display:none}.runway-component .navbar-item,.runway-component .navbar-link,.runway .navbar-item,.runway .navbar-link{align-items:center;display:flex}.runway-component .navbar-item.has-dropdown,.runway .navbar-item.has-dropdown{align-items:stretch}.runway-component .navbar-item.has-dropdown-up .navbar-link:after,.runway .navbar-item.has-dropdown-up .navbar-link:after{transform:rotate(135deg) translate(.25em,-.25em)}.runway-component .navbar-item.has-dropdown-up .navbar-dropdown,.runway .navbar-item.has-dropdown-up .navbar-dropdown{border-bottom:2px solid #dbdbdb;border-radius:6px 6px 0 0;border-top:none;bottom:100%;box-shadow:0 -8px 8px hsla(0,0%,4%,.1);top:auto}.runway-component .navbar-item.is-active .navbar-dropdown,.runway-component .navbar-item.is-hoverable:focus-within .navbar-dropdown,.runway-component .navbar-item.is-hoverable:focus .navbar-dropdown,.runway-component .navbar-item.is-hoverable:hover .navbar-dropdown,.runway .navbar-item.is-active .navbar-dropdown,.runway .navbar-item.is-hoverable:focus-within .navbar-dropdown,.runway .navbar-item.is-hoverable:focus .navbar-dropdown,.runway .navbar-item.is-hoverable:hover .navbar-dropdown{display:block}.runway-component .navbar-item.is-active .navbar-dropdown.is-boxed,.runway-component .navbar-item.is-hoverable:focus-within .navbar-dropdown.is-boxed,.runway-component .navbar-item.is-hoverable:focus .navbar-dropdown.is-boxed,.runway-component .navbar-item.is-hoverable:hover .navbar-dropdown.is-boxed,.runway-component .navbar.is-spaced .navbar-item.is-active .navbar-dropdown,.runway-component .navbar.is-spaced .navbar-item.is-hoverable:focus-within .navbar-dropdown,.runway-component .navbar.is-spaced .navbar-item.is-hoverable:focus .navbar-dropdown,.runway-component .navbar.is-spaced .navbar-item.is-hoverable:hover .navbar-dropdown,.runway .navbar-item.is-active .navbar-dropdown.is-boxed,.runway .navbar-item.is-hoverable:focus-within .navbar-dropdown.is-boxed,.runway .navbar-item.is-hoverable:focus .navbar-dropdown.is-boxed,.runway .navbar-item.is-hoverable:hover .navbar-dropdown.is-boxed,.runway .navbar.is-spaced .navbar-item.is-active .navbar-dropdown,.runway .navbar.is-spaced .navbar-item.is-hoverable:focus-within .navbar-dropdown,.runway .navbar.is-spaced .navbar-item.is-hoverable:focus .navbar-dropdown,.runway .navbar.is-spaced .navbar-item.is-hoverable:hover .navbar-dropdown{opacity:1;pointer-events:auto;transform:translateY(0)}.runway-component .navbar-menu,.runway .navbar-menu{flex-grow:1;flex-shrink:0}.runway-component .navbar-start,.runway .navbar-start{justify-content:flex-start;margin-right:auto}.runway-component .navbar-end,.runway .navbar-end{justify-content:flex-end;margin-left:auto}.runway-component .navbar-dropdown,.runway .navbar-dropdown{background-color:#fff;border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:2px solid #dbdbdb;box-shadow:0 8px 8px hsla(0,0%,4%,.1);display:none;font-size:.875rem;left:0;min-width:100%;position:absolute;top:100%;z-index:20}.runway-component .navbar-dropdown .navbar-item,.runway .navbar-dropdown .navbar-item{padding:.375rem 1rem;white-space:nowrap}.runway-component .navbar-dropdown a.navbar-item,.runway .navbar-dropdown a.navbar-item{padding-right:3rem}.runway-component .navbar-dropdown a.navbar-item:focus,.runway-component .navbar-dropdown a.navbar-item:hover,.runway .navbar-dropdown a.navbar-item:focus,.runway .navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.runway-component .navbar-dropdown a.navbar-item.is-active,.runway .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#3273dc}.runway-component .navbar-dropdown.is-boxed,.runway-component .navbar.is-spaced .navbar-dropdown,.runway .navbar-dropdown.is-boxed,.runway .navbar.is-spaced .navbar-dropdown{border-radius:6px;border-top:none;box-shadow:0 8px 8px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);display:block;opacity:0;pointer-events:none;top:calc(100% + -4px);transform:translateY(-5px);transition-duration:86ms;transition-property:opacity,transform}.runway-component .navbar-dropdown.is-right,.runway .navbar-dropdown.is-right{left:auto;right:0}.runway-component .navbar-divider,.runway .navbar-divider{display:block}.runway-component .container>.navbar .navbar-brand,.runway-component .navbar>.container .navbar-brand,.runway .container>.navbar .navbar-brand,.runway .navbar>.container .navbar-brand{margin-left:-.75rem}.runway-component .container>.navbar .navbar-menu,.runway-component .navbar>.container .navbar-menu,.runway .container>.navbar .navbar-menu,.runway .navbar>.container .navbar-menu{margin-right:-.75rem}.runway-component .navbar.is-fixed-bottom-desktop,.runway-component .navbar.is-fixed-top-desktop,.runway .navbar.is-fixed-bottom-desktop,.runway .navbar.is-fixed-top-desktop{left:0;position:fixed;right:0;z-index:30}.runway-component .navbar.is-fixed-bottom-desktop,.runway .navbar.is-fixed-bottom-desktop{bottom:0}.runway-component .navbar.is-fixed-bottom-desktop.has-shadow,.runway .navbar.is-fixed-bottom-desktop.has-shadow{box-shadow:0 -2px 3px hsla(0,0%,4%,.1)}.runway-component .navbar.is-fixed-top-desktop,.runway .navbar.is-fixed-top-desktop{top:0}.runway-component body.has-navbar-fixed-top-desktop,.runway-component html.has-navbar-fixed-top-desktop,.runway body.has-navbar-fixed-top-desktop,.runway html.has-navbar-fixed-top-desktop{padding-top:3.25rem}.runway-component body.has-navbar-fixed-bottom-desktop,.runway-component html.has-navbar-fixed-bottom-desktop,.runway body.has-navbar-fixed-bottom-desktop,.runway html.has-navbar-fixed-bottom-desktop{padding-bottom:3.25rem}.runway-component body.has-spaced-navbar-fixed-top,.runway-component html.has-spaced-navbar-fixed-top,.runway body.has-spaced-navbar-fixed-top,.runway html.has-spaced-navbar-fixed-top{padding-top:5.25rem}.runway-component body.has-spaced-navbar-fixed-bottom,.runway-component html.has-spaced-navbar-fixed-bottom,.runway body.has-spaced-navbar-fixed-bottom,.runway html.has-spaced-navbar-fixed-bottom{padding-bottom:5.25rem}.runway-component .navbar-link.is-active,.runway-component a.navbar-item.is-active,.runway .navbar-link.is-active,.runway a.navbar-item.is-active{color:#0a0a0a}.runway-component .navbar-link.is-active:not(:focus):not(:hover),.runway-component a.navbar-item.is-active:not(:focus):not(:hover),.runway .navbar-link.is-active:not(:focus):not(:hover),.runway a.navbar-item.is-active:not(:focus):not(:hover){background-color:transparent}.runway-component .navbar-item.has-dropdown.is-active .navbar-link,.runway-component .navbar-item.has-dropdown:focus .navbar-link,.runway-component .navbar-item.has-dropdown:hover .navbar-link,.runway .navbar-item.has-dropdown.is-active .navbar-link,.runway .navbar-item.has-dropdown:focus .navbar-link,.runway .navbar-item.has-dropdown:hover .navbar-link{background-color:#fafafa}}.runway-component .hero.is-fullheight-with-navbar,.runway .hero.is-fullheight-with-navbar{min-height:calc(100vh - 3.25rem)}.runway-component .pagination,.runway .pagination{font-size:1rem;margin:-.25rem}.runway-component .pagination.is-small,.runway .pagination.is-small{font-size:.75rem}.runway-component .pagination.is-medium,.runway .pagination.is-medium{font-size:1.25rem}.runway-component .pagination.is-large,.runway .pagination.is-large{font-size:1.5rem}.runway-component .pagination.is-rounded .pagination-next,.runway-component .pagination.is-rounded .pagination-previous,.runway .pagination.is-rounded .pagination-next,.runway .pagination.is-rounded .pagination-previous{padding-left:1em;padding-right:1em;border-radius:290486px}.runway-component .pagination.is-rounded .pagination-link,.runway .pagination.is-rounded .pagination-link{border-radius:290486px}.runway-component .pagination,.runway-component .pagination-list,.runway .pagination,.runway .pagination-list{align-items:center;display:flex;justify-content:center;text-align:center}.runway-component .pagination-ellipsis,.runway-component .pagination-link,.runway-component .pagination-next,.runway-component .pagination-previous,.runway .pagination-ellipsis,.runway .pagination-link,.runway .pagination-next,.runway .pagination-previous{font-size:1em;justify-content:center;margin:.25rem;padding-left:.5em;padding-right:.5em;text-align:center}.runway-component .pagination-link,.runway-component .pagination-next,.runway-component .pagination-previous,.runway .pagination-link,.runway .pagination-next,.runway .pagination-previous{border-color:#dbdbdb;color:#363636;min-width:2.5em}.runway-component .pagination-link:hover,.runway-component .pagination-next:hover,.runway-component .pagination-previous:hover,.runway .pagination-link:hover,.runway .pagination-next:hover,.runway .pagination-previous:hover{border-color:#b5b5b5;color:#363636}.runway-component .pagination-link:focus,.runway-component .pagination-next:focus,.runway-component .pagination-previous:focus,.runway .pagination-link:focus,.runway .pagination-next:focus,.runway .pagination-previous:focus{border-color:#3273dc}.runway-component .pagination-link:active,.runway-component .pagination-next:active,.runway-component .pagination-previous:active,.runway .pagination-link:active,.runway .pagination-next:active,.runway .pagination-previous:active{box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2)}.runway-component .pagination-link[disabled],.runway-component .pagination-next[disabled],.runway-component .pagination-previous[disabled],.runway .pagination-link[disabled],.runway .pagination-next[disabled],.runway .pagination-previous[disabled]{background-color:#dbdbdb;border-color:#dbdbdb;box-shadow:none;color:#7a7a7a;opacity:.5}.runway-component .pagination-next,.runway-component .pagination-previous,.runway .pagination-next,.runway .pagination-previous{padding-left:.75em;padding-right:.75em;white-space:nowrap}.runway-component .pagination-link.is-current,.runway .pagination-link.is-current{background-color:#3273dc;border-color:#3273dc;color:#fff}.runway-component .pagination-ellipsis,.runway .pagination-ellipsis{color:#b5b5b5;pointer-events:none}.runway-component .pagination-list,.runway .pagination-list{flex-wrap:wrap}@media screen and (max-width:768px){.runway-component .pagination,.runway .pagination{flex-wrap:wrap}.runway-component .pagination-list li,.runway-component .pagination-next,.runway-component .pagination-previous,.runway .pagination-list li,.runway .pagination-next,.runway .pagination-previous{flex-grow:1;flex-shrink:1}}@media print,screen and (min-width:769px){.runway-component .pagination-list,.runway .pagination-list{flex-grow:1;flex-shrink:1;justify-content:flex-start;order:1}.runway-component .pagination-previous,.runway .pagination-previous{order:2}.runway-component .pagination-next,.runway .pagination-next{order:3}.runway-component .pagination,.runway .pagination{justify-content:space-between}.runway-component .pagination.is-centered .pagination-previous,.runway .pagination.is-centered .pagination-previous{order:1}.runway-component .pagination.is-centered .pagination-list,.runway .pagination.is-centered .pagination-list{justify-content:center;order:2}.runway-component .pagination.is-centered .pagination-next,.runway .pagination.is-centered .pagination-next{order:3}.runway-component .pagination.is-right .pagination-previous,.runway .pagination.is-right .pagination-previous{order:1}.runway-component .pagination.is-right .pagination-next,.runway .pagination.is-right .pagination-next{order:2}.runway-component .pagination.is-right .pagination-list,.runway .pagination.is-right .pagination-list{justify-content:flex-end;order:3}}.runway-component .panel,.runway .panel{border-radius:6px;box-shadow:0 .5em 1em -.125em hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.02);font-size:1rem}.runway-component .panel:not(:last-child),.runway .panel:not(:last-child){margin-bottom:1.5rem}.runway-component .panel.is-white .panel-heading,.runway .panel.is-white .panel-heading{background-color:#fff;color:#0a0a0a}.runway-component .panel.is-white .panel-tabs a.is-active,.runway .panel.is-white .panel-tabs a.is-active{border-bottom-color:#fff}.runway-component .panel.is-white .panel-block.is-active .panel-icon,.runway .panel.is-white .panel-block.is-active .panel-icon{color:#fff}.runway-component .panel.is-black .panel-heading,.runway .panel.is-black .panel-heading{background-color:#0a0a0a;color:#fff}.runway-component .panel.is-black .panel-tabs a.is-active,.runway .panel.is-black .panel-tabs a.is-active{border-bottom-color:#0a0a0a}.runway-component .panel.is-black .panel-block.is-active .panel-icon,.runway .panel.is-black .panel-block.is-active .panel-icon{color:#0a0a0a}.runway-component .panel.is-light .panel-heading,.runway .panel.is-light .panel-heading{background-color:#f5f5f5;color:rgba(0,0,0,.7)}.runway-component .panel.is-light .panel-tabs a.is-active,.runway .panel.is-light .panel-tabs a.is-active{border-bottom-color:#f5f5f5}.runway-component .panel.is-light .panel-block.is-active .panel-icon,.runway .panel.is-light .panel-block.is-active .panel-icon{color:#f5f5f5}.runway-component .panel.is-dark .panel-heading,.runway .panel.is-dark .panel-heading{background-color:#363636;color:#fff}.runway-component .panel.is-dark .panel-tabs a.is-active,.runway .panel.is-dark .panel-tabs a.is-active{border-bottom-color:#363636}.runway-component .panel.is-dark .panel-block.is-active .panel-icon,.runway .panel.is-dark .panel-block.is-active .panel-icon{color:#363636}.runway-component .panel.is-primary .panel-heading,.runway .panel.is-primary .panel-heading{background-color:#00d1b2;color:#fff}.runway-component .panel.is-primary .panel-tabs a.is-active,.runway .panel.is-primary .panel-tabs a.is-active{border-bottom-color:#00d1b2}.runway-component .panel.is-primary .panel-block.is-active .panel-icon,.runway .panel.is-primary .panel-block.is-active .panel-icon{color:#00d1b2}.runway-component .panel.is-link .panel-heading,.runway .panel.is-link .panel-heading{background-color:#3273dc;color:#fff}.runway-component .panel.is-link .panel-tabs a.is-active,.runway .panel.is-link .panel-tabs a.is-active{border-bottom-color:#3273dc}.runway-component .panel.is-link .panel-block.is-active .panel-icon,.runway .panel.is-link .panel-block.is-active .panel-icon{color:#3273dc}.runway-component .panel.is-info .panel-heading,.runway .panel.is-info .panel-heading{background-color:#3298dc;color:#fff}.runway-component .panel.is-info .panel-tabs a.is-active,.runway .panel.is-info .panel-tabs a.is-active{border-bottom-color:#3298dc}.runway-component .panel.is-info .panel-block.is-active .panel-icon,.runway .panel.is-info .panel-block.is-active .panel-icon{color:#3298dc}.runway-component .panel.is-success .panel-heading,.runway .panel.is-success .panel-heading{background-color:#48c774;color:#fff}.runway-component .panel.is-success .panel-tabs a.is-active,.runway .panel.is-success .panel-tabs a.is-active{border-bottom-color:#48c774}.runway-component .panel.is-success .panel-block.is-active .panel-icon,.runway .panel.is-success .panel-block.is-active .panel-icon{color:#48c774}.runway-component .panel.is-warning .panel-heading,.runway .panel.is-warning .panel-heading{background-color:#ffdd57;color:rgba(0,0,0,.7)}.runway-component .panel.is-warning .panel-tabs a.is-active,.runway .panel.is-warning .panel-tabs a.is-active{border-bottom-color:#ffdd57}.runway-component .panel.is-warning .panel-block.is-active .panel-icon,.runway .panel.is-warning .panel-block.is-active .panel-icon{color:#ffdd57}.runway-component .panel.is-danger .panel-heading,.runway .panel.is-danger .panel-heading{background-color:#f14668;color:#fff}.runway-component .panel.is-danger .panel-tabs a.is-active,.runway .panel.is-danger .panel-tabs a.is-active{border-bottom-color:#f14668}.runway-component .panel.is-danger .panel-block.is-active .panel-icon,.runway .panel.is-danger .panel-block.is-active .panel-icon{color:#f14668}.runway-component .panel-block:not(:last-child),.runway-component .panel-tabs:not(:last-child),.runway .panel-block:not(:last-child),.runway .panel-tabs:not(:last-child){border-bottom:1px solid #ededed}.runway-component .panel-heading,.runway .panel-heading{background-color:#ededed;border-radius:6px 6px 0 0;color:#363636;font-size:1.25em;font-weight:700;line-height:1.25;padding:.75em 1em}.runway-component .panel-tabs,.runway .panel-tabs{align-items:flex-end;display:flex;font-size:.875em;justify-content:center}.runway-component .panel-tabs a,.runway .panel-tabs a{border-bottom:1px solid #dbdbdb;margin-bottom:-1px;padding:.5em}.runway-component .panel-tabs a.is-active,.runway .panel-tabs a.is-active{border-bottom-color:#4a4a4a;color:#363636}.runway-component .panel-list a,.runway .panel-list a{color:#4a4a4a}.runway-component .panel-list a:hover,.runway .panel-list a:hover{color:#3273dc}.runway-component .panel-block,.runway .panel-block{align-items:center;color:#363636;display:flex;justify-content:flex-start;padding:.5em .75em}.runway-component .panel-block input[type=checkbox],.runway .panel-block input[type=checkbox]{margin-right:.75em}.runway-component .panel-block>.control,.runway .panel-block>.control{flex-grow:1;flex-shrink:1;width:100%}.runway-component .panel-block.is-wrapped,.runway .panel-block.is-wrapped{flex-wrap:wrap}.runway-component .panel-block.is-active,.runway .panel-block.is-active{border-left-color:#3273dc;color:#363636}.runway-component .panel-block.is-active .panel-icon,.runway .panel-block.is-active .panel-icon{color:#3273dc}.runway-component .panel-block:last-child,.runway .panel-block:last-child{border-bottom-left-radius:6px;border-bottom-right-radius:6px}.runway-component a.panel-block,.runway-component label.panel-block,.runway a.panel-block,.runway label.panel-block{cursor:pointer}.runway-component a.panel-block:hover,.runway-component label.panel-block:hover,.runway a.panel-block:hover,.runway label.panel-block:hover{background-color:#f5f5f5}.runway-component .panel-icon,.runway .panel-icon{display:inline-block;font-size:14px;height:1em;line-height:1em;text-align:center;vertical-align:top;width:1em;color:#7a7a7a;margin-right:.75em}.runway-component .panel-icon .fa,.runway .panel-icon .fa{font-size:inherit;line-height:inherit}.runway-component .tabs,.runway .tabs{-webkit-overflow-scrolling:touch;align-items:stretch;display:flex;font-size:1rem;justify-content:space-between;overflow:hidden;overflow-x:auto;white-space:nowrap}.runway-component .tabs a,.runway .tabs a{align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;color:#4a4a4a;display:flex;justify-content:center;margin-bottom:-1px;padding:.5em 1em;vertical-align:top}.runway-component .tabs a:hover,.runway .tabs a:hover{border-bottom-color:#363636;color:#363636}.runway-component .tabs li,.runway .tabs li{display:block}.runway-component .tabs li.is-active a,.runway .tabs li.is-active a{border-bottom-color:#3273dc;color:#3273dc}.runway-component .tabs ul,.runway .tabs ul{align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;display:flex;flex-grow:1;flex-shrink:0;justify-content:flex-start}.runway-component .tabs ul.is-left,.runway .tabs ul.is-left{padding-right:.75em}.runway-component .tabs ul.is-center,.runway .tabs ul.is-center{flex:none;justify-content:center;padding-left:.75em;padding-right:.75em}.runway-component .tabs ul.is-right,.runway .tabs ul.is-right{justify-content:flex-end;padding-left:.75em}.runway-component .tabs .icon:first-child,.runway .tabs .icon:first-child{margin-right:.5em}.runway-component .tabs .icon:last-child,.runway .tabs .icon:last-child{margin-left:.5em}.runway-component .tabs.is-centered ul,.runway .tabs.is-centered ul{justify-content:center}.runway-component .tabs.is-right ul,.runway .tabs.is-right ul{justify-content:flex-end}.runway-component .tabs.is-boxed a,.runway .tabs.is-boxed a{border:1px solid transparent;border-radius:4px 4px 0 0}.runway-component .tabs.is-boxed a:hover,.runway .tabs.is-boxed a:hover{background-color:#f5f5f5;border-bottom-color:#dbdbdb}.runway-component .tabs.is-boxed li.is-active a,.runway .tabs.is-boxed li.is-active a{background-color:#fff;border-color:#dbdbdb;border-bottom-color:transparent!important}.runway-component .tabs.is-fullwidth li,.runway .tabs.is-fullwidth li{flex-grow:1;flex-shrink:0}.runway-component .tabs.is-toggle a,.runway .tabs.is-toggle a{border:1px solid #dbdbdb;margin-bottom:0;position:relative}.runway-component .tabs.is-toggle a:hover,.runway .tabs.is-toggle a:hover{background-color:#f5f5f5;border-color:#b5b5b5;z-index:2}.runway-component .tabs.is-toggle li+li,.runway .tabs.is-toggle li+li{margin-left:-1px}.runway-component .tabs.is-toggle li:first-child a,.runway .tabs.is-toggle li:first-child a{border-top-left-radius:4px;border-bottom-left-radius:4px}.runway-component .tabs.is-toggle li:last-child a,.runway .tabs.is-toggle li:last-child a{border-top-right-radius:4px;border-bottom-right-radius:4px}.runway-component .tabs.is-toggle li.is-active a,.runway .tabs.is-toggle li.is-active a{background-color:#3273dc;border-color:#3273dc;color:#fff;z-index:1}.runway-component .tabs.is-toggle ul,.runway .tabs.is-toggle ul{border-bottom:none}.runway-component .tabs.is-toggle.is-toggle-rounded li:first-child a,.runway .tabs.is-toggle.is-toggle-rounded li:first-child a{border-bottom-left-radius:290486px;border-top-left-radius:290486px;padding-left:1.25em}.runway-component .tabs.is-toggle.is-toggle-rounded li:last-child a,.runway .tabs.is-toggle.is-toggle-rounded li:last-child a{border-bottom-right-radius:290486px;border-top-right-radius:290486px;padding-right:1.25em}.runway-component .tabs.is-small,.runway .tabs.is-small{font-size:.75rem}.runway-component .tabs.is-medium,.runway .tabs.is-medium{font-size:1.25rem}.runway-component .tabs.is-large,.runway .tabs.is-large{font-size:1.5rem}.runway-component .column,.runway .column{display:block;flex-basis:0;flex-grow:1;flex-shrink:1;padding:.75rem}.runway-component .columns.is-mobile>.column.is-narrow,.runway .columns.is-mobile>.column.is-narrow{flex:none}.runway-component .columns.is-mobile>.column.is-full,.runway .columns.is-mobile>.column.is-full{flex:none;width:100%}.runway-component .columns.is-mobile>.column.is-three-quarters,.runway .columns.is-mobile>.column.is-three-quarters{flex:none;width:75%}.runway-component .columns.is-mobile>.column.is-two-thirds,.runway .columns.is-mobile>.column.is-two-thirds{flex:none;width:66.6666%}.runway-component .columns.is-mobile>.column.is-half,.runway .columns.is-mobile>.column.is-half{flex:none;width:50%}.runway-component .columns.is-mobile>.column.is-one-third,.runway .columns.is-mobile>.column.is-one-third{flex:none;width:33.3333%}.runway-component .columns.is-mobile>.column.is-one-quarter,.runway .columns.is-mobile>.column.is-one-quarter{flex:none;width:25%}.runway-component .columns.is-mobile>.column.is-one-fifth,.runway .columns.is-mobile>.column.is-one-fifth{flex:none;width:20%}.runway-component .columns.is-mobile>.column.is-two-fifths,.runway .columns.is-mobile>.column.is-two-fifths{flex:none;width:40%}.runway-component .columns.is-mobile>.column.is-three-fifths,.runway .columns.is-mobile>.column.is-three-fifths{flex:none;width:60%}.runway-component .columns.is-mobile>.column.is-four-fifths,.runway .columns.is-mobile>.column.is-four-fifths{flex:none;width:80%}.runway-component .columns.is-mobile>.column.is-offset-three-quarters,.runway .columns.is-mobile>.column.is-offset-three-quarters{margin-left:75%}.runway-component .columns.is-mobile>.column.is-offset-two-thirds,.runway .columns.is-mobile>.column.is-offset-two-thirds{margin-left:66.6666%}.runway-component .columns.is-mobile>.column.is-offset-half,.runway .columns.is-mobile>.column.is-offset-half{margin-left:50%}.runway-component .columns.is-mobile>.column.is-offset-one-third,.runway .columns.is-mobile>.column.is-offset-one-third{margin-left:33.3333%}.runway-component .columns.is-mobile>.column.is-offset-one-quarter,.runway .columns.is-mobile>.column.is-offset-one-quarter{margin-left:25%}.runway-component .columns.is-mobile>.column.is-offset-one-fifth,.runway .columns.is-mobile>.column.is-offset-one-fifth{margin-left:20%}.runway-component .columns.is-mobile>.column.is-offset-two-fifths,.runway .columns.is-mobile>.column.is-offset-two-fifths{margin-left:40%}.runway-component .columns.is-mobile>.column.is-offset-three-fifths,.runway .columns.is-mobile>.column.is-offset-three-fifths{margin-left:60%}.runway-component .columns.is-mobile>.column.is-offset-four-fifths,.runway .columns.is-mobile>.column.is-offset-four-fifths{margin-left:80%}.runway-component .columns.is-mobile>.column.is-0,.runway .columns.is-mobile>.column.is-0{flex:none;width:0}.runway-component .columns.is-mobile>.column.is-offset-0,.runway .columns.is-mobile>.column.is-offset-0{margin-left:0}.runway-component .columns.is-mobile>.column.is-1,.runway .columns.is-mobile>.column.is-1{flex:none;width:8.33333%}.runway-component .columns.is-mobile>.column.is-offset-1,.runway .columns.is-mobile>.column.is-offset-1{margin-left:8.33333%}.runway-component .columns.is-mobile>.column.is-2,.runway .columns.is-mobile>.column.is-2{flex:none;width:16.66667%}.runway-component .columns.is-mobile>.column.is-offset-2,.runway .columns.is-mobile>.column.is-offset-2{margin-left:16.66667%}.runway-component .columns.is-mobile>.column.is-3,.runway .columns.is-mobile>.column.is-3{flex:none;width:25%}.runway-component .columns.is-mobile>.column.is-offset-3,.runway .columns.is-mobile>.column.is-offset-3{margin-left:25%}.runway-component .columns.is-mobile>.column.is-4,.runway .columns.is-mobile>.column.is-4{flex:none;width:33.33333%}.runway-component .columns.is-mobile>.column.is-offset-4,.runway .columns.is-mobile>.column.is-offset-4{margin-left:33.33333%}.runway-component .columns.is-mobile>.column.is-5,.runway .columns.is-mobile>.column.is-5{flex:none;width:41.66667%}.runway-component .columns.is-mobile>.column.is-offset-5,.runway .columns.is-mobile>.column.is-offset-5{margin-left:41.66667%}.runway-component .columns.is-mobile>.column.is-6,.runway .columns.is-mobile>.column.is-6{flex:none;width:50%}.runway-component .columns.is-mobile>.column.is-offset-6,.runway .columns.is-mobile>.column.is-offset-6{margin-left:50%}.runway-component .columns.is-mobile>.column.is-7,.runway .columns.is-mobile>.column.is-7{flex:none;width:58.33333%}.runway-component .columns.is-mobile>.column.is-offset-7,.runway .columns.is-mobile>.column.is-offset-7{margin-left:58.33333%}.runway-component .columns.is-mobile>.column.is-8,.runway .columns.is-mobile>.column.is-8{flex:none;width:66.66667%}.runway-component .columns.is-mobile>.column.is-offset-8,.runway .columns.is-mobile>.column.is-offset-8{margin-left:66.66667%}.runway-component .columns.is-mobile>.column.is-9,.runway .columns.is-mobile>.column.is-9{flex:none;width:75%}.runway-component .columns.is-mobile>.column.is-offset-9,.runway .columns.is-mobile>.column.is-offset-9{margin-left:75%}.runway-component .columns.is-mobile>.column.is-10,.runway .columns.is-mobile>.column.is-10{flex:none;width:83.33333%}.runway-component .columns.is-mobile>.column.is-offset-10,.runway .columns.is-mobile>.column.is-offset-10{margin-left:83.33333%}.runway-component .columns.is-mobile>.column.is-11,.runway .columns.is-mobile>.column.is-11{flex:none;width:91.66667%}.runway-component .columns.is-mobile>.column.is-offset-11,.runway .columns.is-mobile>.column.is-offset-11{margin-left:91.66667%}.runway-component .columns.is-mobile>.column.is-12,.runway .columns.is-mobile>.column.is-12{flex:none;width:100%}.runway-component .columns.is-mobile>.column.is-offset-12,.runway .columns.is-mobile>.column.is-offset-12{margin-left:100%}@media screen and (max-width:768px){.runway-component .column.is-narrow-mobile,.runway .column.is-narrow-mobile{flex:none}.runway-component .column.is-full-mobile,.runway .column.is-full-mobile{flex:none;width:100%}.runway-component .column.is-three-quarters-mobile,.runway .column.is-three-quarters-mobile{flex:none;width:75%}.runway-component .column.is-two-thirds-mobile,.runway .column.is-two-thirds-mobile{flex:none;width:66.6666%}.runway-component .column.is-half-mobile,.runway .column.is-half-mobile{flex:none;width:50%}.runway-component .column.is-one-third-mobile,.runway .column.is-one-third-mobile{flex:none;width:33.3333%}.runway-component .column.is-one-quarter-mobile,.runway .column.is-one-quarter-mobile{flex:none;width:25%}.runway-component .column.is-one-fifth-mobile,.runway .column.is-one-fifth-mobile{flex:none;width:20%}.runway-component .column.is-two-fifths-mobile,.runway .column.is-two-fifths-mobile{flex:none;width:40%}.runway-component .column.is-three-fifths-mobile,.runway .column.is-three-fifths-mobile{flex:none;width:60%}.runway-component .column.is-four-fifths-mobile,.runway .column.is-four-fifths-mobile{flex:none;width:80%}.runway-component .column.is-offset-three-quarters-mobile,.runway .column.is-offset-three-quarters-mobile{margin-left:75%}.runway-component .column.is-offset-two-thirds-mobile,.runway .column.is-offset-two-thirds-mobile{margin-left:66.6666%}.runway-component .column.is-offset-half-mobile,.runway .column.is-offset-half-mobile{margin-left:50%}.runway-component .column.is-offset-one-third-mobile,.runway .column.is-offset-one-third-mobile{margin-left:33.3333%}.runway-component .column.is-offset-one-quarter-mobile,.runway .column.is-offset-one-quarter-mobile{margin-left:25%}.runway-component .column.is-offset-one-fifth-mobile,.runway .column.is-offset-one-fifth-mobile{margin-left:20%}.runway-component .column.is-offset-two-fifths-mobile,.runway .column.is-offset-two-fifths-mobile{margin-left:40%}.runway-component .column.is-offset-three-fifths-mobile,.runway .column.is-offset-three-fifths-mobile{margin-left:60%}.runway-component .column.is-offset-four-fifths-mobile,.runway .column.is-offset-four-fifths-mobile{margin-left:80%}.runway-component .column.is-0-mobile,.runway .column.is-0-mobile{flex:none;width:0}.runway-component .column.is-offset-0-mobile,.runway .column.is-offset-0-mobile{margin-left:0}.runway-component .column.is-1-mobile,.runway .column.is-1-mobile{flex:none;width:8.33333%}.runway-component .column.is-offset-1-mobile,.runway .column.is-offset-1-mobile{margin-left:8.33333%}.runway-component .column.is-2-mobile,.runway .column.is-2-mobile{flex:none;width:16.66667%}.runway-component .column.is-offset-2-mobile,.runway .column.is-offset-2-mobile{margin-left:16.66667%}.runway-component .column.is-3-mobile,.runway .column.is-3-mobile{flex:none;width:25%}.runway-component .column.is-offset-3-mobile,.runway .column.is-offset-3-mobile{margin-left:25%}.runway-component .column.is-4-mobile,.runway .column.is-4-mobile{flex:none;width:33.33333%}.runway-component .column.is-offset-4-mobile,.runway .column.is-offset-4-mobile{margin-left:33.33333%}.runway-component .column.is-5-mobile,.runway .column.is-5-mobile{flex:none;width:41.66667%}.runway-component .column.is-offset-5-mobile,.runway .column.is-offset-5-mobile{margin-left:41.66667%}.runway-component .column.is-6-mobile,.runway .column.is-6-mobile{flex:none;width:50%}.runway-component .column.is-offset-6-mobile,.runway .column.is-offset-6-mobile{margin-left:50%}.runway-component .column.is-7-mobile,.runway .column.is-7-mobile{flex:none;width:58.33333%}.runway-component .column.is-offset-7-mobile,.runway .column.is-offset-7-mobile{margin-left:58.33333%}.runway-component .column.is-8-mobile,.runway .column.is-8-mobile{flex:none;width:66.66667%}.runway-component .column.is-offset-8-mobile,.runway .column.is-offset-8-mobile{margin-left:66.66667%}.runway-component .column.is-9-mobile,.runway .column.is-9-mobile{flex:none;width:75%}.runway-component .column.is-offset-9-mobile,.runway .column.is-offset-9-mobile{margin-left:75%}.runway-component .column.is-10-mobile,.runway .column.is-10-mobile{flex:none;width:83.33333%}.runway-component .column.is-offset-10-mobile,.runway .column.is-offset-10-mobile{margin-left:83.33333%}.runway-component .column.is-11-mobile,.runway .column.is-11-mobile{flex:none;width:91.66667%}.runway-component .column.is-offset-11-mobile,.runway .column.is-offset-11-mobile{margin-left:91.66667%}.runway-component .column.is-12-mobile,.runway .column.is-12-mobile{flex:none;width:100%}.runway-component .column.is-offset-12-mobile,.runway .column.is-offset-12-mobile{margin-left:100%}}@media print,screen and (min-width:769px){.runway-component .column.is-narrow,.runway-component .column.is-narrow-tablet,.runway .column.is-narrow,.runway .column.is-narrow-tablet{flex:none}.runway-component .column.is-full,.runway-component .column.is-full-tablet,.runway .column.is-full,.runway .column.is-full-tablet{flex:none;width:100%}.runway-component .column.is-three-quarters,.runway-component .column.is-three-quarters-tablet,.runway .column.is-three-quarters,.runway .column.is-three-quarters-tablet{flex:none;width:75%}.runway-component .column.is-two-thirds,.runway-component .column.is-two-thirds-tablet,.runway .column.is-two-thirds,.runway .column.is-two-thirds-tablet{flex:none;width:66.6666%}.runway-component .column.is-half,.runway-component .column.is-half-tablet,.runway .column.is-half,.runway .column.is-half-tablet{flex:none;width:50%}.runway-component .column.is-one-third,.runway-component .column.is-one-third-tablet,.runway .column.is-one-third,.runway .column.is-one-third-tablet{flex:none;width:33.3333%}.runway-component .column.is-one-quarter,.runway-component .column.is-one-quarter-tablet,.runway .column.is-one-quarter,.runway .column.is-one-quarter-tablet{flex:none;width:25%}.runway-component .column.is-one-fifth,.runway-component .column.is-one-fifth-tablet,.runway .column.is-one-fifth,.runway .column.is-one-fifth-tablet{flex:none;width:20%}.runway-component .column.is-two-fifths,.runway-component .column.is-two-fifths-tablet,.runway .column.is-two-fifths,.runway .column.is-two-fifths-tablet{flex:none;width:40%}.runway-component .column.is-three-fifths,.runway-component .column.is-three-fifths-tablet,.runway .column.is-three-fifths,.runway .column.is-three-fifths-tablet{flex:none;width:60%}.runway-component .column.is-four-fifths,.runway-component .column.is-four-fifths-tablet,.runway .column.is-four-fifths,.runway .column.is-four-fifths-tablet{flex:none;width:80%}.runway-component .column.is-offset-three-quarters,.runway-component .column.is-offset-three-quarters-tablet,.runway .column.is-offset-three-quarters,.runway .column.is-offset-three-quarters-tablet{margin-left:75%}.runway-component .column.is-offset-two-thirds,.runway-component .column.is-offset-two-thirds-tablet,.runway .column.is-offset-two-thirds,.runway .column.is-offset-two-thirds-tablet{margin-left:66.6666%}.runway-component .column.is-offset-half,.runway-component .column.is-offset-half-tablet,.runway .column.is-offset-half,.runway .column.is-offset-half-tablet{margin-left:50%}.runway-component .column.is-offset-one-third,.runway-component .column.is-offset-one-third-tablet,.runway .column.is-offset-one-third,.runway .column.is-offset-one-third-tablet{margin-left:33.3333%}.runway-component .column.is-offset-one-quarter,.runway-component .column.is-offset-one-quarter-tablet,.runway .column.is-offset-one-quarter,.runway .column.is-offset-one-quarter-tablet{margin-left:25%}.runway-component .column.is-offset-one-fifth,.runway-component .column.is-offset-one-fifth-tablet,.runway .column.is-offset-one-fifth,.runway .column.is-offset-one-fifth-tablet{margin-left:20%}.runway-component .column.is-offset-two-fifths,.runway-component .column.is-offset-two-fifths-tablet,.runway .column.is-offset-two-fifths,.runway .column.is-offset-two-fifths-tablet{margin-left:40%}.runway-component .column.is-offset-three-fifths,.runway-component .column.is-offset-three-fifths-tablet,.runway .column.is-offset-three-fifths,.runway .column.is-offset-three-fifths-tablet{margin-left:60%}.runway-component .column.is-offset-four-fifths,.runway-component .column.is-offset-four-fifths-tablet,.runway .column.is-offset-four-fifths,.runway .column.is-offset-four-fifths-tablet{margin-left:80%}.runway-component .column.is-0,.runway-component .column.is-0-tablet,.runway .column.is-0,.runway .column.is-0-tablet{flex:none;width:0}.runway-component .column.is-offset-0,.runway-component .column.is-offset-0-tablet,.runway .column.is-offset-0,.runway .column.is-offset-0-tablet{margin-left:0}.runway-component .column.is-1,.runway-component .column.is-1-tablet,.runway .column.is-1,.runway .column.is-1-tablet{flex:none;width:8.33333%}.runway-component .column.is-offset-1,.runway-component .column.is-offset-1-tablet,.runway .column.is-offset-1,.runway .column.is-offset-1-tablet{margin-left:8.33333%}.runway-component .column.is-2,.runway-component .column.is-2-tablet,.runway .column.is-2,.runway .column.is-2-tablet{flex:none;width:16.66667%}.runway-component .column.is-offset-2,.runway-component .column.is-offset-2-tablet,.runway .column.is-offset-2,.runway .column.is-offset-2-tablet{margin-left:16.66667%}.runway-component .column.is-3,.runway-component .column.is-3-tablet,.runway .column.is-3,.runway .column.is-3-tablet{flex:none;width:25%}.runway-component .column.is-offset-3,.runway-component .column.is-offset-3-tablet,.runway .column.is-offset-3,.runway .column.is-offset-3-tablet{margin-left:25%}.runway-component .column.is-4,.runway-component .column.is-4-tablet,.runway .column.is-4,.runway .column.is-4-tablet{flex:none;width:33.33333%}.runway-component .column.is-offset-4,.runway-component .column.is-offset-4-tablet,.runway .column.is-offset-4,.runway .column.is-offset-4-tablet{margin-left:33.33333%}.runway-component .column.is-5,.runway-component .column.is-5-tablet,.runway .column.is-5,.runway .column.is-5-tablet{flex:none;width:41.66667%}.runway-component .column.is-offset-5,.runway-component .column.is-offset-5-tablet,.runway .column.is-offset-5,.runway .column.is-offset-5-tablet{margin-left:41.66667%}.runway-component .column.is-6,.runway-component .column.is-6-tablet,.runway .column.is-6,.runway .column.is-6-tablet{flex:none;width:50%}.runway-component .column.is-offset-6,.runway-component .column.is-offset-6-tablet,.runway .column.is-offset-6,.runway .column.is-offset-6-tablet{margin-left:50%}.runway-component .column.is-7,.runway-component .column.is-7-tablet,.runway .column.is-7,.runway .column.is-7-tablet{flex:none;width:58.33333%}.runway-component .column.is-offset-7,.runway-component .column.is-offset-7-tablet,.runway .column.is-offset-7,.runway .column.is-offset-7-tablet{margin-left:58.33333%}.runway-component .column.is-8,.runway-component .column.is-8-tablet,.runway .column.is-8,.runway .column.is-8-tablet{flex:none;width:66.66667%}.runway-component .column.is-offset-8,.runway-component .column.is-offset-8-tablet,.runway .column.is-offset-8,.runway .column.is-offset-8-tablet{margin-left:66.66667%}.runway-component .column.is-9,.runway-component .column.is-9-tablet,.runway .column.is-9,.runway .column.is-9-tablet{flex:none;width:75%}.runway-component .column.is-offset-9,.runway-component .column.is-offset-9-tablet,.runway .column.is-offset-9,.runway .column.is-offset-9-tablet{margin-left:75%}.runway-component .column.is-10,.runway-component .column.is-10-tablet,.runway .column.is-10,.runway .column.is-10-tablet{flex:none;width:83.33333%}.runway-component .column.is-offset-10,.runway-component .column.is-offset-10-tablet,.runway .column.is-offset-10,.runway .column.is-offset-10-tablet{margin-left:83.33333%}.runway-component .column.is-11,.runway-component .column.is-11-tablet,.runway .column.is-11,.runway .column.is-11-tablet{flex:none;width:91.66667%}.runway-component .column.is-offset-11,.runway-component .column.is-offset-11-tablet,.runway .column.is-offset-11,.runway .column.is-offset-11-tablet{margin-left:91.66667%}.runway-component .column.is-12,.runway-component .column.is-12-tablet,.runway .column.is-12,.runway .column.is-12-tablet{flex:none;width:100%}.runway-component .column.is-offset-12,.runway-component .column.is-offset-12-tablet,.runway .column.is-offset-12,.runway .column.is-offset-12-tablet{margin-left:100%}}@media screen and (max-width:1023px){.runway-component .column.is-narrow-touch,.runway .column.is-narrow-touch{flex:none}.runway-component .column.is-full-touch,.runway .column.is-full-touch{flex:none;width:100%}.runway-component .column.is-three-quarters-touch,.runway .column.is-three-quarters-touch{flex:none;width:75%}.runway-component .column.is-two-thirds-touch,.runway .column.is-two-thirds-touch{flex:none;width:66.6666%}.runway-component .column.is-half-touch,.runway .column.is-half-touch{flex:none;width:50%}.runway-component .column.is-one-third-touch,.runway .column.is-one-third-touch{flex:none;width:33.3333%}.runway-component .column.is-one-quarter-touch,.runway .column.is-one-quarter-touch{flex:none;width:25%}.runway-component .column.is-one-fifth-touch,.runway .column.is-one-fifth-touch{flex:none;width:20%}.runway-component .column.is-two-fifths-touch,.runway .column.is-two-fifths-touch{flex:none;width:40%}.runway-component .column.is-three-fifths-touch,.runway .column.is-three-fifths-touch{flex:none;width:60%}.runway-component .column.is-four-fifths-touch,.runway .column.is-four-fifths-touch{flex:none;width:80%}.runway-component .column.is-offset-three-quarters-touch,.runway .column.is-offset-three-quarters-touch{margin-left:75%}.runway-component .column.is-offset-two-thirds-touch,.runway .column.is-offset-two-thirds-touch{margin-left:66.6666%}.runway-component .column.is-offset-half-touch,.runway .column.is-offset-half-touch{margin-left:50%}.runway-component .column.is-offset-one-third-touch,.runway .column.is-offset-one-third-touch{margin-left:33.3333%}.runway-component .column.is-offset-one-quarter-touch,.runway .column.is-offset-one-quarter-touch{margin-left:25%}.runway-component .column.is-offset-one-fifth-touch,.runway .column.is-offset-one-fifth-touch{margin-left:20%}.runway-component .column.is-offset-two-fifths-touch,.runway .column.is-offset-two-fifths-touch{margin-left:40%}.runway-component .column.is-offset-three-fifths-touch,.runway .column.is-offset-three-fifths-touch{margin-left:60%}.runway-component .column.is-offset-four-fifths-touch,.runway .column.is-offset-four-fifths-touch{margin-left:80%}.runway-component .column.is-0-touch,.runway .column.is-0-touch{flex:none;width:0}.runway-component .column.is-offset-0-touch,.runway .column.is-offset-0-touch{margin-left:0}.runway-component .column.is-1-touch,.runway .column.is-1-touch{flex:none;width:8.33333%}.runway-component .column.is-offset-1-touch,.runway .column.is-offset-1-touch{margin-left:8.33333%}.runway-component .column.is-2-touch,.runway .column.is-2-touch{flex:none;width:16.66667%}.runway-component .column.is-offset-2-touch,.runway .column.is-offset-2-touch{margin-left:16.66667%}.runway-component .column.is-3-touch,.runway .column.is-3-touch{flex:none;width:25%}.runway-component .column.is-offset-3-touch,.runway .column.is-offset-3-touch{margin-left:25%}.runway-component .column.is-4-touch,.runway .column.is-4-touch{flex:none;width:33.33333%}.runway-component .column.is-offset-4-touch,.runway .column.is-offset-4-touch{margin-left:33.33333%}.runway-component .column.is-5-touch,.runway .column.is-5-touch{flex:none;width:41.66667%}.runway-component .column.is-offset-5-touch,.runway .column.is-offset-5-touch{margin-left:41.66667%}.runway-component .column.is-6-touch,.runway .column.is-6-touch{flex:none;width:50%}.runway-component .column.is-offset-6-touch,.runway .column.is-offset-6-touch{margin-left:50%}.runway-component .column.is-7-touch,.runway .column.is-7-touch{flex:none;width:58.33333%}.runway-component .column.is-offset-7-touch,.runway .column.is-offset-7-touch{margin-left:58.33333%}.runway-component .column.is-8-touch,.runway .column.is-8-touch{flex:none;width:66.66667%}.runway-component .column.is-offset-8-touch,.runway .column.is-offset-8-touch{margin-left:66.66667%}.runway-component .column.is-9-touch,.runway .column.is-9-touch{flex:none;width:75%}.runway-component .column.is-offset-9-touch,.runway .column.is-offset-9-touch{margin-left:75%}.runway-component .column.is-10-touch,.runway .column.is-10-touch{flex:none;width:83.33333%}.runway-component .column.is-offset-10-touch,.runway .column.is-offset-10-touch{margin-left:83.33333%}.runway-component .column.is-11-touch,.runway .column.is-11-touch{flex:none;width:91.66667%}.runway-component .column.is-offset-11-touch,.runway .column.is-offset-11-touch{margin-left:91.66667%}.runway-component .column.is-12-touch,.runway .column.is-12-touch{flex:none;width:100%}.runway-component .column.is-offset-12-touch,.runway .column.is-offset-12-touch{margin-left:100%}}@media screen and (min-width:1024px){.runway-component .column.is-narrow-desktop,.runway .column.is-narrow-desktop{flex:none}.runway-component .column.is-full-desktop,.runway .column.is-full-desktop{flex:none;width:100%}.runway-component .column.is-three-quarters-desktop,.runway .column.is-three-quarters-desktop{flex:none;width:75%}.runway-component .column.is-two-thirds-desktop,.runway .column.is-two-thirds-desktop{flex:none;width:66.6666%}.runway-component .column.is-half-desktop,.runway .column.is-half-desktop{flex:none;width:50%}.runway-component .column.is-one-third-desktop,.runway .column.is-one-third-desktop{flex:none;width:33.3333%}.runway-component .column.is-one-quarter-desktop,.runway .column.is-one-quarter-desktop{flex:none;width:25%}.runway-component .column.is-one-fifth-desktop,.runway .column.is-one-fifth-desktop{flex:none;width:20%}.runway-component .column.is-two-fifths-desktop,.runway .column.is-two-fifths-desktop{flex:none;width:40%}.runway-component .column.is-three-fifths-desktop,.runway .column.is-three-fifths-desktop{flex:none;width:60%}.runway-component .column.is-four-fifths-desktop,.runway .column.is-four-fifths-desktop{flex:none;width:80%}.runway-component .column.is-offset-three-quarters-desktop,.runway .column.is-offset-three-quarters-desktop{margin-left:75%}.runway-component .column.is-offset-two-thirds-desktop,.runway .column.is-offset-two-thirds-desktop{margin-left:66.6666%}.runway-component .column.is-offset-half-desktop,.runway .column.is-offset-half-desktop{margin-left:50%}.runway-component .column.is-offset-one-third-desktop,.runway .column.is-offset-one-third-desktop{margin-left:33.3333%}.runway-component .column.is-offset-one-quarter-desktop,.runway .column.is-offset-one-quarter-desktop{margin-left:25%}.runway-component .column.is-offset-one-fifth-desktop,.runway .column.is-offset-one-fifth-desktop{margin-left:20%}.runway-component .column.is-offset-two-fifths-desktop,.runway .column.is-offset-two-fifths-desktop{margin-left:40%}.runway-component .column.is-offset-three-fifths-desktop,.runway .column.is-offset-three-fifths-desktop{margin-left:60%}.runway-component .column.is-offset-four-fifths-desktop,.runway .column.is-offset-four-fifths-desktop{margin-left:80%}.runway-component .column.is-0-desktop,.runway .column.is-0-desktop{flex:none;width:0}.runway-component .column.is-offset-0-desktop,.runway .column.is-offset-0-desktop{margin-left:0}.runway-component .column.is-1-desktop,.runway .column.is-1-desktop{flex:none;width:8.33333%}.runway-component .column.is-offset-1-desktop,.runway .column.is-offset-1-desktop{margin-left:8.33333%}.runway-component .column.is-2-desktop,.runway .column.is-2-desktop{flex:none;width:16.66667%}.runway-component .column.is-offset-2-desktop,.runway .column.is-offset-2-desktop{margin-left:16.66667%}.runway-component .column.is-3-desktop,.runway .column.is-3-desktop{flex:none;width:25%}.runway-component .column.is-offset-3-desktop,.runway .column.is-offset-3-desktop{margin-left:25%}.runway-component .column.is-4-desktop,.runway .column.is-4-desktop{flex:none;width:33.33333%}.runway-component .column.is-offset-4-desktop,.runway .column.is-offset-4-desktop{margin-left:33.33333%}.runway-component .column.is-5-desktop,.runway .column.is-5-desktop{flex:none;width:41.66667%}.runway-component .column.is-offset-5-desktop,.runway .column.is-offset-5-desktop{margin-left:41.66667%}.runway-component .column.is-6-desktop,.runway .column.is-6-desktop{flex:none;width:50%}.runway-component .column.is-offset-6-desktop,.runway .column.is-offset-6-desktop{margin-left:50%}.runway-component .column.is-7-desktop,.runway .column.is-7-desktop{flex:none;width:58.33333%}.runway-component .column.is-offset-7-desktop,.runway .column.is-offset-7-desktop{margin-left:58.33333%}.runway-component .column.is-8-desktop,.runway .column.is-8-desktop{flex:none;width:66.66667%}.runway-component .column.is-offset-8-desktop,.runway .column.is-offset-8-desktop{margin-left:66.66667%}.runway-component .column.is-9-desktop,.runway .column.is-9-desktop{flex:none;width:75%}.runway-component .column.is-offset-9-desktop,.runway .column.is-offset-9-desktop{margin-left:75%}.runway-component .column.is-10-desktop,.runway .column.is-10-desktop{flex:none;width:83.33333%}.runway-component .column.is-offset-10-desktop,.runway .column.is-offset-10-desktop{margin-left:83.33333%}.runway-component .column.is-11-desktop,.runway .column.is-11-desktop{flex:none;width:91.66667%}.runway-component .column.is-offset-11-desktop,.runway .column.is-offset-11-desktop{margin-left:91.66667%}.runway-component .column.is-12-desktop,.runway .column.is-12-desktop{flex:none;width:100%}.runway-component .column.is-offset-12-desktop,.runway .column.is-offset-12-desktop{margin-left:100%}}@media screen and (min-width:1216px){.runway-component .column.is-narrow-widescreen,.runway .column.is-narrow-widescreen{flex:none}.runway-component .column.is-full-widescreen,.runway .column.is-full-widescreen{flex:none;width:100%}.runway-component .column.is-three-quarters-widescreen,.runway .column.is-three-quarters-widescreen{flex:none;width:75%}.runway-component .column.is-two-thirds-widescreen,.runway .column.is-two-thirds-widescreen{flex:none;width:66.6666%}.runway-component .column.is-half-widescreen,.runway .column.is-half-widescreen{flex:none;width:50%}.runway-component .column.is-one-third-widescreen,.runway .column.is-one-third-widescreen{flex:none;width:33.3333%}.runway-component .column.is-one-quarter-widescreen,.runway .column.is-one-quarter-widescreen{flex:none;width:25%}.runway-component .column.is-one-fifth-widescreen,.runway .column.is-one-fifth-widescreen{flex:none;width:20%}.runway-component .column.is-two-fifths-widescreen,.runway .column.is-two-fifths-widescreen{flex:none;width:40%}.runway-component .column.is-three-fifths-widescreen,.runway .column.is-three-fifths-widescreen{flex:none;width:60%}.runway-component .column.is-four-fifths-widescreen,.runway .column.is-four-fifths-widescreen{flex:none;width:80%}.runway-component .column.is-offset-three-quarters-widescreen,.runway .column.is-offset-three-quarters-widescreen{margin-left:75%}.runway-component .column.is-offset-two-thirds-widescreen,.runway .column.is-offset-two-thirds-widescreen{margin-left:66.6666%}.runway-component .column.is-offset-half-widescreen,.runway .column.is-offset-half-widescreen{margin-left:50%}.runway-component .column.is-offset-one-third-widescreen,.runway .column.is-offset-one-third-widescreen{margin-left:33.3333%}.runway-component .column.is-offset-one-quarter-widescreen,.runway .column.is-offset-one-quarter-widescreen{margin-left:25%}.runway-component .column.is-offset-one-fifth-widescreen,.runway .column.is-offset-one-fifth-widescreen{margin-left:20%}.runway-component .column.is-offset-two-fifths-widescreen,.runway .column.is-offset-two-fifths-widescreen{margin-left:40%}.runway-component .column.is-offset-three-fifths-widescreen,.runway .column.is-offset-three-fifths-widescreen{margin-left:60%}.runway-component .column.is-offset-four-fifths-widescreen,.runway .column.is-offset-four-fifths-widescreen{margin-left:80%}.runway-component .column.is-0-widescreen,.runway .column.is-0-widescreen{flex:none;width:0}.runway-component .column.is-offset-0-widescreen,.runway .column.is-offset-0-widescreen{margin-left:0}.runway-component .column.is-1-widescreen,.runway .column.is-1-widescreen{flex:none;width:8.33333%}.runway-component .column.is-offset-1-widescreen,.runway .column.is-offset-1-widescreen{margin-left:8.33333%}.runway-component .column.is-2-widescreen,.runway .column.is-2-widescreen{flex:none;width:16.66667%}.runway-component .column.is-offset-2-widescreen,.runway .column.is-offset-2-widescreen{margin-left:16.66667%}.runway-component .column.is-3-widescreen,.runway .column.is-3-widescreen{flex:none;width:25%}.runway-component .column.is-offset-3-widescreen,.runway .column.is-offset-3-widescreen{margin-left:25%}.runway-component .column.is-4-widescreen,.runway .column.is-4-widescreen{flex:none;width:33.33333%}.runway-component .column.is-offset-4-widescreen,.runway .column.is-offset-4-widescreen{margin-left:33.33333%}.runway-component .column.is-5-widescreen,.runway .column.is-5-widescreen{flex:none;width:41.66667%}.runway-component .column.is-offset-5-widescreen,.runway .column.is-offset-5-widescreen{margin-left:41.66667%}.runway-component .column.is-6-widescreen,.runway .column.is-6-widescreen{flex:none;width:50%}.runway-component .column.is-offset-6-widescreen,.runway .column.is-offset-6-widescreen{margin-left:50%}.runway-component .column.is-7-widescreen,.runway .column.is-7-widescreen{flex:none;width:58.33333%}.runway-component .column.is-offset-7-widescreen,.runway .column.is-offset-7-widescreen{margin-left:58.33333%}.runway-component .column.is-8-widescreen,.runway .column.is-8-widescreen{flex:none;width:66.66667%}.runway-component .column.is-offset-8-widescreen,.runway .column.is-offset-8-widescreen{margin-left:66.66667%}.runway-component .column.is-9-widescreen,.runway .column.is-9-widescreen{flex:none;width:75%}.runway-component .column.is-offset-9-widescreen,.runway .column.is-offset-9-widescreen{margin-left:75%}.runway-component .column.is-10-widescreen,.runway .column.is-10-widescreen{flex:none;width:83.33333%}.runway-component .column.is-offset-10-widescreen,.runway .column.is-offset-10-widescreen{margin-left:83.33333%}.runway-component .column.is-11-widescreen,.runway .column.is-11-widescreen{flex:none;width:91.66667%}.runway-component .column.is-offset-11-widescreen,.runway .column.is-offset-11-widescreen{margin-left:91.66667%}.runway-component .column.is-12-widescreen,.runway .column.is-12-widescreen{flex:none;width:100%}.runway-component .column.is-offset-12-widescreen,.runway .column.is-offset-12-widescreen{margin-left:100%}}@media screen and (min-width:1408px){.runway-component .column.is-narrow-fullhd,.runway .column.is-narrow-fullhd{flex:none}.runway-component .column.is-full-fullhd,.runway .column.is-full-fullhd{flex:none;width:100%}.runway-component .column.is-three-quarters-fullhd,.runway .column.is-three-quarters-fullhd{flex:none;width:75%}.runway-component .column.is-two-thirds-fullhd,.runway .column.is-two-thirds-fullhd{flex:none;width:66.6666%}.runway-component .column.is-half-fullhd,.runway .column.is-half-fullhd{flex:none;width:50%}.runway-component .column.is-one-third-fullhd,.runway .column.is-one-third-fullhd{flex:none;width:33.3333%}.runway-component .column.is-one-quarter-fullhd,.runway .column.is-one-quarter-fullhd{flex:none;width:25%}.runway-component .column.is-one-fifth-fullhd,.runway .column.is-one-fifth-fullhd{flex:none;width:20%}.runway-component .column.is-two-fifths-fullhd,.runway .column.is-two-fifths-fullhd{flex:none;width:40%}.runway-component .column.is-three-fifths-fullhd,.runway .column.is-three-fifths-fullhd{flex:none;width:60%}.runway-component .column.is-four-fifths-fullhd,.runway .column.is-four-fifths-fullhd{flex:none;width:80%}.runway-component .column.is-offset-three-quarters-fullhd,.runway .column.is-offset-three-quarters-fullhd{margin-left:75%}.runway-component .column.is-offset-two-thirds-fullhd,.runway .column.is-offset-two-thirds-fullhd{margin-left:66.6666%}.runway-component .column.is-offset-half-fullhd,.runway .column.is-offset-half-fullhd{margin-left:50%}.runway-component .column.is-offset-one-third-fullhd,.runway .column.is-offset-one-third-fullhd{margin-left:33.3333%}.runway-component .column.is-offset-one-quarter-fullhd,.runway .column.is-offset-one-quarter-fullhd{margin-left:25%}.runway-component .column.is-offset-one-fifth-fullhd,.runway .column.is-offset-one-fifth-fullhd{margin-left:20%}.runway-component .column.is-offset-two-fifths-fullhd,.runway .column.is-offset-two-fifths-fullhd{margin-left:40%}.runway-component .column.is-offset-three-fifths-fullhd,.runway .column.is-offset-three-fifths-fullhd{margin-left:60%}.runway-component .column.is-offset-four-fifths-fullhd,.runway .column.is-offset-four-fifths-fullhd{margin-left:80%}.runway-component .column.is-0-fullhd,.runway .column.is-0-fullhd{flex:none;width:0}.runway-component .column.is-offset-0-fullhd,.runway .column.is-offset-0-fullhd{margin-left:0}.runway-component .column.is-1-fullhd,.runway .column.is-1-fullhd{flex:none;width:8.33333%}.runway-component .column.is-offset-1-fullhd,.runway .column.is-offset-1-fullhd{margin-left:8.33333%}.runway-component .column.is-2-fullhd,.runway .column.is-2-fullhd{flex:none;width:16.66667%}.runway-component .column.is-offset-2-fullhd,.runway .column.is-offset-2-fullhd{margin-left:16.66667%}.runway-component .column.is-3-fullhd,.runway .column.is-3-fullhd{flex:none;width:25%}.runway-component .column.is-offset-3-fullhd,.runway .column.is-offset-3-fullhd{margin-left:25%}.runway-component .column.is-4-fullhd,.runway .column.is-4-fullhd{flex:none;width:33.33333%}.runway-component .column.is-offset-4-fullhd,.runway .column.is-offset-4-fullhd{margin-left:33.33333%}.runway-component .column.is-5-fullhd,.runway .column.is-5-fullhd{flex:none;width:41.66667%}.runway-component .column.is-offset-5-fullhd,.runway .column.is-offset-5-fullhd{margin-left:41.66667%}.runway-component .column.is-6-fullhd,.runway .column.is-6-fullhd{flex:none;width:50%}.runway-component .column.is-offset-6-fullhd,.runway .column.is-offset-6-fullhd{margin-left:50%}.runway-component .column.is-7-fullhd,.runway .column.is-7-fullhd{flex:none;width:58.33333%}.runway-component .column.is-offset-7-fullhd,.runway .column.is-offset-7-fullhd{margin-left:58.33333%}.runway-component .column.is-8-fullhd,.runway .column.is-8-fullhd{flex:none;width:66.66667%}.runway-component .column.is-offset-8-fullhd,.runway .column.is-offset-8-fullhd{margin-left:66.66667%}.runway-component .column.is-9-fullhd,.runway .column.is-9-fullhd{flex:none;width:75%}.runway-component .column.is-offset-9-fullhd,.runway .column.is-offset-9-fullhd{margin-left:75%}.runway-component .column.is-10-fullhd,.runway .column.is-10-fullhd{flex:none;width:83.33333%}.runway-component .column.is-offset-10-fullhd,.runway .column.is-offset-10-fullhd{margin-left:83.33333%}.runway-component .column.is-11-fullhd,.runway .column.is-11-fullhd{flex:none;width:91.66667%}.runway-component .column.is-offset-11-fullhd,.runway .column.is-offset-11-fullhd{margin-left:91.66667%}.runway-component .column.is-12-fullhd,.runway .column.is-12-fullhd{flex:none;width:100%}.runway-component .column.is-offset-12-fullhd,.runway .column.is-offset-12-fullhd{margin-left:100%}}.runway-component .columns,.runway .columns{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.runway-component .columns:last-child,.runway .columns:last-child{margin-bottom:-.75rem}.runway-component .columns:not(:last-child),.runway .columns:not(:last-child){margin-bottom:0.75rem}.runway-component .columns.is-centered,.runway .columns.is-centered{justify-content:center}.runway-component .columns.is-gapless,.runway .columns.is-gapless{margin-left:0;margin-right:0;margin-top:0}.runway-component .columns.is-gapless>.column,.runway .columns.is-gapless>.column{margin:0;padding:0!important}.runway-component .columns.is-gapless:not(:last-child),.runway .columns.is-gapless:not(:last-child){margin-bottom:1.5rem}.runway-component .columns.is-gapless:last-child,.runway .columns.is-gapless:last-child{margin-bottom:0}.runway-component .columns.is-mobile,.runway .columns.is-mobile{display:flex}.runway-component .columns.is-multiline,.runway .columns.is-multiline{flex-wrap:wrap}.runway-component .columns.is-vcentered,.runway .columns.is-vcentered{align-items:center}@media print,screen and (min-width:769px){.runway-component .columns:not(.is-desktop),.runway .columns:not(.is-desktop){display:flex}}@media screen and (min-width:1024px){.runway-component .columns.is-desktop,.runway .columns.is-desktop{display:flex}}.runway-component .columns.is-variable,.runway .columns.is-variable{--columnGap:0.75rem;margin-left:calc(-1 * var(--columnGap));margin-right:calc(-1 * var(--columnGap))}.runway-component .columns.is-variable .column,.runway .columns.is-variable .column{padding-left:var(--columnGap);padding-right:var(--columnGap)}.runway-component .columns.is-variable.is-0,.runway .columns.is-variable.is-0{--columnGap:0rem}@media screen and (max-width:768px){.runway-component .columns.is-variable.is-0-mobile,.runway .columns.is-variable.is-0-mobile{--columnGap:0rem}}@media print,screen and (min-width:769px){.runway-component .columns.is-variable.is-0-tablet,.runway .columns.is-variable.is-0-tablet{--columnGap:0rem}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .columns.is-variable.is-0-tablet-only,.runway .columns.is-variable.is-0-tablet-only{--columnGap:0rem}}@media screen and (max-width:1023px){.runway-component .columns.is-variable.is-0-touch,.runway .columns.is-variable.is-0-touch{--columnGap:0rem}}@media screen and (min-width:1024px){.runway-component .columns.is-variable.is-0-desktop,.runway .columns.is-variable.is-0-desktop{--columnGap:0rem}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .columns.is-variable.is-0-desktop-only,.runway .columns.is-variable.is-0-desktop-only{--columnGap:0rem}}@media screen and (min-width:1216px){.runway-component .columns.is-variable.is-0-widescreen,.runway .columns.is-variable.is-0-widescreen{--columnGap:0rem}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .columns.is-variable.is-0-widescreen-only,.runway .columns.is-variable.is-0-widescreen-only{--columnGap:0rem}}@media screen and (min-width:1408px){.runway-component .columns.is-variable.is-0-fullhd,.runway .columns.is-variable.is-0-fullhd{--columnGap:0rem}}.runway-component .columns.is-variable.is-1,.runway .columns.is-variable.is-1{--columnGap:0.25rem}@media screen and (max-width:768px){.runway-component .columns.is-variable.is-1-mobile,.runway .columns.is-variable.is-1-mobile{--columnGap:0.25rem}}@media print,screen and (min-width:769px){.runway-component .columns.is-variable.is-1-tablet,.runway .columns.is-variable.is-1-tablet{--columnGap:0.25rem}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .columns.is-variable.is-1-tablet-only,.runway .columns.is-variable.is-1-tablet-only{--columnGap:0.25rem}}@media screen and (max-width:1023px){.runway-component .columns.is-variable.is-1-touch,.runway .columns.is-variable.is-1-touch{--columnGap:0.25rem}}@media screen and (min-width:1024px){.runway-component .columns.is-variable.is-1-desktop,.runway .columns.is-variable.is-1-desktop{--columnGap:0.25rem}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .columns.is-variable.is-1-desktop-only,.runway .columns.is-variable.is-1-desktop-only{--columnGap:0.25rem}}@media screen and (min-width:1216px){.runway-component .columns.is-variable.is-1-widescreen,.runway .columns.is-variable.is-1-widescreen{--columnGap:0.25rem}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .columns.is-variable.is-1-widescreen-only,.runway .columns.is-variable.is-1-widescreen-only{--columnGap:0.25rem}}@media screen and (min-width:1408px){.runway-component .columns.is-variable.is-1-fullhd,.runway .columns.is-variable.is-1-fullhd{--columnGap:0.25rem}}.runway-component .columns.is-variable.is-2,.runway .columns.is-variable.is-2{--columnGap:0.5rem}@media screen and (max-width:768px){.runway-component .columns.is-variable.is-2-mobile,.runway .columns.is-variable.is-2-mobile{--columnGap:0.5rem}}@media print,screen and (min-width:769px){.runway-component .columns.is-variable.is-2-tablet,.runway .columns.is-variable.is-2-tablet{--columnGap:0.5rem}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .columns.is-variable.is-2-tablet-only,.runway .columns.is-variable.is-2-tablet-only{--columnGap:0.5rem}}@media screen and (max-width:1023px){.runway-component .columns.is-variable.is-2-touch,.runway .columns.is-variable.is-2-touch{--columnGap:0.5rem}}@media screen and (min-width:1024px){.runway-component .columns.is-variable.is-2-desktop,.runway .columns.is-variable.is-2-desktop{--columnGap:0.5rem}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .columns.is-variable.is-2-desktop-only,.runway .columns.is-variable.is-2-desktop-only{--columnGap:0.5rem}}@media screen and (min-width:1216px){.runway-component .columns.is-variable.is-2-widescreen,.runway .columns.is-variable.is-2-widescreen{--columnGap:0.5rem}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .columns.is-variable.is-2-widescreen-only,.runway .columns.is-variable.is-2-widescreen-only{--columnGap:0.5rem}}@media screen and (min-width:1408px){.runway-component .columns.is-variable.is-2-fullhd,.runway .columns.is-variable.is-2-fullhd{--columnGap:0.5rem}}.runway-component .columns.is-variable.is-3,.runway .columns.is-variable.is-3{--columnGap:0.75rem}@media screen and (max-width:768px){.runway-component .columns.is-variable.is-3-mobile,.runway .columns.is-variable.is-3-mobile{--columnGap:0.75rem}}@media print,screen and (min-width:769px){.runway-component .columns.is-variable.is-3-tablet,.runway .columns.is-variable.is-3-tablet{--columnGap:0.75rem}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .columns.is-variable.is-3-tablet-only,.runway .columns.is-variable.is-3-tablet-only{--columnGap:0.75rem}}@media screen and (max-width:1023px){.runway-component .columns.is-variable.is-3-touch,.runway .columns.is-variable.is-3-touch{--columnGap:0.75rem}}@media screen and (min-width:1024px){.runway-component .columns.is-variable.is-3-desktop,.runway .columns.is-variable.is-3-desktop{--columnGap:0.75rem}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .columns.is-variable.is-3-desktop-only,.runway .columns.is-variable.is-3-desktop-only{--columnGap:0.75rem}}@media screen and (min-width:1216px){.runway-component .columns.is-variable.is-3-widescreen,.runway .columns.is-variable.is-3-widescreen{--columnGap:0.75rem}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .columns.is-variable.is-3-widescreen-only,.runway .columns.is-variable.is-3-widescreen-only{--columnGap:0.75rem}}@media screen and (min-width:1408px){.runway-component .columns.is-variable.is-3-fullhd,.runway .columns.is-variable.is-3-fullhd{--columnGap:0.75rem}}.runway-component .columns.is-variable.is-4,.runway .columns.is-variable.is-4{--columnGap:1rem}@media screen and (max-width:768px){.runway-component .columns.is-variable.is-4-mobile,.runway .columns.is-variable.is-4-mobile{--columnGap:1rem}}@media print,screen and (min-width:769px){.runway-component .columns.is-variable.is-4-tablet,.runway .columns.is-variable.is-4-tablet{--columnGap:1rem}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .columns.is-variable.is-4-tablet-only,.runway .columns.is-variable.is-4-tablet-only{--columnGap:1rem}}@media screen and (max-width:1023px){.runway-component .columns.is-variable.is-4-touch,.runway .columns.is-variable.is-4-touch{--columnGap:1rem}}@media screen and (min-width:1024px){.runway-component .columns.is-variable.is-4-desktop,.runway .columns.is-variable.is-4-desktop{--columnGap:1rem}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .columns.is-variable.is-4-desktop-only,.runway .columns.is-variable.is-4-desktop-only{--columnGap:1rem}}@media screen and (min-width:1216px){.runway-component .columns.is-variable.is-4-widescreen,.runway .columns.is-variable.is-4-widescreen{--columnGap:1rem}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .columns.is-variable.is-4-widescreen-only,.runway .columns.is-variable.is-4-widescreen-only{--columnGap:1rem}}@media screen and (min-width:1408px){.runway-component .columns.is-variable.is-4-fullhd,.runway .columns.is-variable.is-4-fullhd{--columnGap:1rem}}.runway-component .columns.is-variable.is-5,.runway .columns.is-variable.is-5{--columnGap:1.25rem}@media screen and (max-width:768px){.runway-component .columns.is-variable.is-5-mobile,.runway .columns.is-variable.is-5-mobile{--columnGap:1.25rem}}@media print,screen and (min-width:769px){.runway-component .columns.is-variable.is-5-tablet,.runway .columns.is-variable.is-5-tablet{--columnGap:1.25rem}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .columns.is-variable.is-5-tablet-only,.runway .columns.is-variable.is-5-tablet-only{--columnGap:1.25rem}}@media screen and (max-width:1023px){.runway-component .columns.is-variable.is-5-touch,.runway .columns.is-variable.is-5-touch{--columnGap:1.25rem}}@media screen and (min-width:1024px){.runway-component .columns.is-variable.is-5-desktop,.runway .columns.is-variable.is-5-desktop{--columnGap:1.25rem}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .columns.is-variable.is-5-desktop-only,.runway .columns.is-variable.is-5-desktop-only{--columnGap:1.25rem}}@media screen and (min-width:1216px){.runway-component .columns.is-variable.is-5-widescreen,.runway .columns.is-variable.is-5-widescreen{--columnGap:1.25rem}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .columns.is-variable.is-5-widescreen-only,.runway .columns.is-variable.is-5-widescreen-only{--columnGap:1.25rem}}@media screen and (min-width:1408px){.runway-component .columns.is-variable.is-5-fullhd,.runway .columns.is-variable.is-5-fullhd{--columnGap:1.25rem}}.runway-component .columns.is-variable.is-6,.runway .columns.is-variable.is-6{--columnGap:1.5rem}@media screen and (max-width:768px){.runway-component .columns.is-variable.is-6-mobile,.runway .columns.is-variable.is-6-mobile{--columnGap:1.5rem}}@media print,screen and (min-width:769px){.runway-component .columns.is-variable.is-6-tablet,.runway .columns.is-variable.is-6-tablet{--columnGap:1.5rem}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .columns.is-variable.is-6-tablet-only,.runway .columns.is-variable.is-6-tablet-only{--columnGap:1.5rem}}@media screen and (max-width:1023px){.runway-component .columns.is-variable.is-6-touch,.runway .columns.is-variable.is-6-touch{--columnGap:1.5rem}}@media screen and (min-width:1024px){.runway-component .columns.is-variable.is-6-desktop,.runway .columns.is-variable.is-6-desktop{--columnGap:1.5rem}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .columns.is-variable.is-6-desktop-only,.runway .columns.is-variable.is-6-desktop-only{--columnGap:1.5rem}}@media screen and (min-width:1216px){.runway-component .columns.is-variable.is-6-widescreen,.runway .columns.is-variable.is-6-widescreen{--columnGap:1.5rem}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .columns.is-variable.is-6-widescreen-only,.runway .columns.is-variable.is-6-widescreen-only{--columnGap:1.5rem}}@media screen and (min-width:1408px){.runway-component .columns.is-variable.is-6-fullhd,.runway .columns.is-variable.is-6-fullhd{--columnGap:1.5rem}}.runway-component .columns.is-variable.is-7,.runway .columns.is-variable.is-7{--columnGap:1.75rem}@media screen and (max-width:768px){.runway-component .columns.is-variable.is-7-mobile,.runway .columns.is-variable.is-7-mobile{--columnGap:1.75rem}}@media print,screen and (min-width:769px){.runway-component .columns.is-variable.is-7-tablet,.runway .columns.is-variable.is-7-tablet{--columnGap:1.75rem}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .columns.is-variable.is-7-tablet-only,.runway .columns.is-variable.is-7-tablet-only{--columnGap:1.75rem}}@media screen and (max-width:1023px){.runway-component .columns.is-variable.is-7-touch,.runway .columns.is-variable.is-7-touch{--columnGap:1.75rem}}@media screen and (min-width:1024px){.runway-component .columns.is-variable.is-7-desktop,.runway .columns.is-variable.is-7-desktop{--columnGap:1.75rem}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .columns.is-variable.is-7-desktop-only,.runway .columns.is-variable.is-7-desktop-only{--columnGap:1.75rem}}@media screen and (min-width:1216px){.runway-component .columns.is-variable.is-7-widescreen,.runway .columns.is-variable.is-7-widescreen{--columnGap:1.75rem}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .columns.is-variable.is-7-widescreen-only,.runway .columns.is-variable.is-7-widescreen-only{--columnGap:1.75rem}}@media screen and (min-width:1408px){.runway-component .columns.is-variable.is-7-fullhd,.runway .columns.is-variable.is-7-fullhd{--columnGap:1.75rem}}.runway-component .columns.is-variable.is-8,.runway .columns.is-variable.is-8{--columnGap:2rem}@media screen and (max-width:768px){.runway-component .columns.is-variable.is-8-mobile,.runway .columns.is-variable.is-8-mobile{--columnGap:2rem}}@media print,screen and (min-width:769px){.runway-component .columns.is-variable.is-8-tablet,.runway .columns.is-variable.is-8-tablet{--columnGap:2rem}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .columns.is-variable.is-8-tablet-only,.runway .columns.is-variable.is-8-tablet-only{--columnGap:2rem}}@media screen and (max-width:1023px){.runway-component .columns.is-variable.is-8-touch,.runway .columns.is-variable.is-8-touch{--columnGap:2rem}}@media screen and (min-width:1024px){.runway-component .columns.is-variable.is-8-desktop,.runway .columns.is-variable.is-8-desktop{--columnGap:2rem}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .columns.is-variable.is-8-desktop-only,.runway .columns.is-variable.is-8-desktop-only{--columnGap:2rem}}@media screen and (min-width:1216px){.runway-component .columns.is-variable.is-8-widescreen,.runway .columns.is-variable.is-8-widescreen{--columnGap:2rem}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .columns.is-variable.is-8-widescreen-only,.runway .columns.is-variable.is-8-widescreen-only{--columnGap:2rem}}@media screen and (min-width:1408px){.runway-component .columns.is-variable.is-8-fullhd,.runway .columns.is-variable.is-8-fullhd{--columnGap:2rem}}.runway-component .tile,.runway .tile{align-items:stretch;display:block;flex-basis:0;flex-grow:1;flex-shrink:1;min-height:-webkit-min-content;min-height:-moz-min-content;min-height:min-content}.runway-component .tile.is-ancestor,.runway .tile.is-ancestor{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.runway-component .tile.is-ancestor:last-child,.runway .tile.is-ancestor:last-child{margin-bottom:-.75rem}.runway-component .tile.is-ancestor:not(:last-child),.runway .tile.is-ancestor:not(:last-child){margin-bottom:.75rem}.runway-component .tile.is-child,.runway .tile.is-child{margin:0!important}.runway-component .tile.is-parent,.runway .tile.is-parent{padding:.75rem}.runway-component .tile.is-vertical,.runway .tile.is-vertical{flex-direction:column}.runway-component .tile.is-vertical>.tile.is-child:not(:last-child),.runway .tile.is-vertical>.tile.is-child:not(:last-child){margin-bottom:1.5rem!important}@media print,screen and (min-width:769px){.runway-component .tile:not(.is-child),.runway .tile:not(.is-child){display:flex}.runway-component .tile.is-1,.runway .tile.is-1{flex:none;width:8.33333%}.runway-component .tile.is-2,.runway .tile.is-2{flex:none;width:16.66667%}.runway-component .tile.is-3,.runway .tile.is-3{flex:none;width:25%}.runway-component .tile.is-4,.runway .tile.is-4{flex:none;width:33.33333%}.runway-component .tile.is-5,.runway .tile.is-5{flex:none;width:41.66667%}.runway-component .tile.is-6,.runway .tile.is-6{flex:none;width:50%}.runway-component .tile.is-7,.runway .tile.is-7{flex:none;width:58.33333%}.runway-component .tile.is-8,.runway .tile.is-8{flex:none;width:66.66667%}.runway-component .tile.is-9,.runway .tile.is-9{flex:none;width:75%}.runway-component .tile.is-10,.runway .tile.is-10{flex:none;width:83.33333%}.runway-component .tile.is-11,.runway .tile.is-11{flex:none;width:91.66667%}.runway-component .tile.is-12,.runway .tile.is-12{flex:none;width:100%}}.runway-component .has-text-white,.runway .has-text-white{color:#fff!important}.runway-component a.has-text-white:focus,.runway-component a.has-text-white:hover,.runway a.has-text-white:focus,.runway a.has-text-white:hover{color:#e6e6e6!important}.runway-component .has-background-white,.runway .has-background-white{background-color:#fff!important}.runway-component .has-text-black,.runway .has-text-black{color:#0a0a0a!important}.runway-component a.has-text-black:focus,.runway-component a.has-text-black:hover,.runway a.has-text-black:focus,.runway a.has-text-black:hover{color:#000!important}.runway-component .has-background-black,.runway .has-background-black{background-color:#0a0a0a!important}.runway-component .has-text-light,.runway .has-text-light{color:#f5f5f5!important}.runway-component a.has-text-light:focus,.runway-component a.has-text-light:hover,.runway a.has-text-light:focus,.runway a.has-text-light:hover{color:#dbdbdb!important}.runway-component .has-background-light,.runway .has-background-light{background-color:#f5f5f5!important}.runway-component .has-text-dark,.runway .has-text-dark{color:#363636!important}.runway-component a.has-text-dark:focus,.runway-component a.has-text-dark:hover,.runway a.has-text-dark:focus,.runway a.has-text-dark:hover{color:#1c1c1c!important}.runway-component .has-background-dark,.runway .has-background-dark{background-color:#363636!important}.runway-component .has-text-primary,.runway .has-text-primary{color:#00d1b2!important}.runway-component a.has-text-primary:focus,.runway-component a.has-text-primary:hover,.runway a.has-text-primary:focus,.runway a.has-text-primary:hover{color:#009e86!important}.runway-component .has-background-primary,.runway .has-background-primary{background-color:#00d1b2!important}.runway-component .has-text-primary-light,.runway .has-text-primary-light{color:#ebfffc!important}.runway-component a.has-text-primary-light:focus,.runway-component a.has-text-primary-light:hover,.runway a.has-text-primary-light:focus,.runway a.has-text-primary-light:hover{color:#b8fff4!important}.runway-component .has-background-primary-light,.runway .has-background-primary-light{background-color:#ebfffc!important}.runway-component .has-text-primary-dark,.runway .has-text-primary-dark{color:#00947e!important}.runway-component a.has-text-primary-dark:focus,.runway-component a.has-text-primary-dark:hover,.runway a.has-text-primary-dark:focus,.runway a.has-text-primary-dark:hover{color:#00c7a9!important}.runway-component .has-background-primary-dark,.runway .has-background-primary-dark{background-color:#00947e!important}.runway-component .has-text-link,.runway .has-text-link{color:#3273dc!important}.runway-component a.has-text-link:focus,.runway-component a.has-text-link:hover,.runway a.has-text-link:focus,.runway a.has-text-link:hover{color:#205bbc!important}.runway-component .has-background-link,.runway .has-background-link{background-color:#3273dc!important}.runway-component .has-text-link-light,.runway .has-text-link-light{color:#eef3fc!important}.runway-component a.has-text-link-light:focus,.runway-component a.has-text-link-light:hover,.runway a.has-text-link-light:focus,.runway a.has-text-link-light:hover{color:#c2d5f5!important}.runway-component .has-background-link-light,.runway .has-background-link-light{background-color:#eef3fc!important}.runway-component .has-text-link-dark,.runway .has-text-link-dark{color:#2160c4!important}.runway-component a.has-text-link-dark:focus,.runway-component a.has-text-link-dark:hover,.runway a.has-text-link-dark:focus,.runway a.has-text-link-dark:hover{color:#3b79de!important}.runway-component .has-background-link-dark,.runway .has-background-link-dark{background-color:#2160c4!important}.runway-component .has-text-info,.runway .has-text-info{color:#3298dc!important}.runway-component a.has-text-info:focus,.runway-component a.has-text-info:hover,.runway a.has-text-info:focus,.runway a.has-text-info:hover{color:#207dbc!important}.runway-component .has-background-info,.runway .has-background-info{background-color:#3298dc!important}.runway-component .has-text-info-light,.runway .has-text-info-light{color:#eef6fc!important}.runway-component a.has-text-info-light:focus,.runway-component a.has-text-info-light:hover,.runway a.has-text-info-light:focus,.runway a.has-text-info-light:hover{color:#c2e0f5!important}.runway-component .has-background-info-light,.runway .has-background-info-light{background-color:#eef6fc!important}.runway-component .has-text-info-dark,.runway .has-text-info-dark{color:#1d72aa!important}.runway-component a.has-text-info-dark:focus,.runway-component a.has-text-info-dark:hover,.runway a.has-text-info-dark:focus,.runway a.has-text-info-dark:hover{color:#248fd6!important}.runway-component .has-background-info-dark,.runway .has-background-info-dark{background-color:#1d72aa!important}.runway-component .has-text-success,.runway .has-text-success{color:#48c774!important}.runway-component a.has-text-success:focus,.runway-component a.has-text-success:hover,.runway a.has-text-success:focus,.runway a.has-text-success:hover{color:#34a85c!important}.runway-component .has-background-success,.runway .has-background-success{background-color:#48c774!important}.runway-component .has-text-success-light,.runway .has-text-success-light{color:#effaf3!important}.runway-component a.has-text-success-light:focus,.runway-component a.has-text-success-light:hover,.runway a.has-text-success-light:focus,.runway a.has-text-success-light:hover{color:#c8eed6!important}.runway-component .has-background-success-light,.runway .has-background-success-light{background-color:#effaf3!important}.runway-component .has-text-success-dark,.runway .has-text-success-dark{color:#257942!important}.runway-component a.has-text-success-dark:focus,.runway-component a.has-text-success-dark:hover,.runway a.has-text-success-dark:focus,.runway a.has-text-success-dark:hover{color:#31a058!important}.runway-component .has-background-success-dark,.runway .has-background-success-dark{background-color:#257942!important}.runway-component .has-text-warning,.runway .has-text-warning{color:#ffdd57!important}.runway-component a.has-text-warning:focus,.runway-component a.has-text-warning:hover,.runway a.has-text-warning:focus,.runway a.has-text-warning:hover{color:#ffd324!important}.runway-component .has-background-warning,.runway .has-background-warning{background-color:#ffdd57!important}.runway-component .has-text-warning-light,.runway .has-text-warning-light{color:#fffbeb!important}.runway-component a.has-text-warning-light:focus,.runway-component a.has-text-warning-light:hover,.runway a.has-text-warning-light:focus,.runway a.has-text-warning-light:hover{color:#fff1b8!important}.runway-component .has-background-warning-light,.runway .has-background-warning-light{background-color:#fffbeb!important}.runway-component .has-text-warning-dark,.runway .has-text-warning-dark{color:#947600!important}.runway-component a.has-text-warning-dark:focus,.runway-component a.has-text-warning-dark:hover,.runway a.has-text-warning-dark:focus,.runway a.has-text-warning-dark:hover{color:#c79f00!important}.runway-component .has-background-warning-dark,.runway .has-background-warning-dark{background-color:#947600!important}.runway-component .has-text-danger,.runway .has-text-danger{color:#f14668!important}.runway-component a.has-text-danger:focus,.runway-component a.has-text-danger:hover,.runway a.has-text-danger:focus,.runway a.has-text-danger:hover{color:#ee1742!important}.runway-component .has-background-danger,.runway .has-background-danger{background-color:#f14668!important}.runway-component .has-text-danger-light,.runway .has-text-danger-light{color:#feecf0!important}.runway-component a.has-text-danger-light:focus,.runway-component a.has-text-danger-light:hover,.runway a.has-text-danger-light:focus,.runway a.has-text-danger-light:hover{color:#fabdc9!important}.runway-component .has-background-danger-light,.runway .has-background-danger-light{background-color:#feecf0!important}.runway-component .has-text-danger-dark,.runway .has-text-danger-dark{color:#cc0f35!important}.runway-component a.has-text-danger-dark:focus,.runway-component a.has-text-danger-dark:hover,.runway a.has-text-danger-dark:focus,.runway a.has-text-danger-dark:hover{color:#ee2049!important}.runway-component .has-background-danger-dark,.runway .has-background-danger-dark{background-color:#cc0f35!important}.runway-component .has-text-black-bis,.runway .has-text-black-bis{color:#121212!important}.runway-component .has-background-black-bis,.runway .has-background-black-bis{background-color:#121212!important}.runway-component .has-text-black-ter,.runway .has-text-black-ter{color:#242424!important}.runway-component .has-background-black-ter,.runway .has-background-black-ter{background-color:#242424!important}.runway-component .has-text-grey-darker,.runway .has-text-grey-darker{color:#363636!important}.runway-component .has-background-grey-darker,.runway .has-background-grey-darker{background-color:#363636!important}.runway-component .has-text-grey-dark,.runway .has-text-grey-dark{color:#4a4a4a!important}.runway-component .has-background-grey-dark,.runway .has-background-grey-dark{background-color:#4a4a4a!important}.runway-component .has-text-grey,.runway .has-text-grey{color:#7a7a7a!important}.runway-component .has-background-grey,.runway .has-background-grey{background-color:#7a7a7a!important}.runway-component .has-text-grey-light,.runway .has-text-grey-light{color:#b5b5b5!important}.runway-component .has-background-grey-light,.runway .has-background-grey-light{background-color:#b5b5b5!important}.runway-component .has-text-grey-lighter,.runway .has-text-grey-lighter{color:#dbdbdb!important}.runway-component .has-background-grey-lighter,.runway .has-background-grey-lighter{background-color:#dbdbdb!important}.runway-component .has-text-white-ter,.runway .has-text-white-ter{color:#f5f5f5!important}.runway-component .has-background-white-ter,.runway .has-background-white-ter{background-color:#f5f5f5!important}.runway-component .has-text-white-bis,.runway .has-text-white-bis{color:#fafafa!important}.runway-component .has-background-white-bis,.runway .has-background-white-bis{background-color:#fafafa!important}.runway-component .is-clearfix:after,.runway .is-clearfix:after{clear:both;content:\" \";display:table}.runway-component .is-pulled-left,.runway .is-pulled-left{float:left!important}.runway-component .is-pulled-right,.runway .is-pulled-right{float:right!important}.runway-component .is-radiusless,.runway .is-radiusless{border-radius:0!important}.runway-component .is-shadowless,.runway .is-shadowless{box-shadow:none!important}.runway-component .is-clipped,.runway .is-clipped{overflow:hidden!important}.runway-component .is-relative,.runway .is-relative{position:relative!important}.runway-component .is-marginless,.runway .is-marginless{margin:0!important}.runway-component .is-paddingless,.runway .is-paddingless{padding:0!important}.runway-component .mt-0,.runway .mt-0{margin-top:0!important}.runway-component .mr-0,.runway .mr-0{margin-right:0!important}.runway-component .mb-0,.runway .mb-0{margin-bottom:0!important}.runway-component .ml-0,.runway .ml-0{margin-left:0!important}.runway-component .mx-0,.runway .mx-0{margin-left:0!important;margin-right:0!important}.runway-component .my-0,.runway .my-0{margin-top:0!important;margin-bottom:0!important}.runway-component .mt-1,.runway .mt-1{margin-top:.25rem!important}.runway-component .mr-1,.runway .mr-1{margin-right:.25rem!important}.runway-component .mb-1,.runway .mb-1{margin-bottom:.25rem!important}.runway-component .ml-1,.runway .ml-1{margin-left:.25rem!important}.runway-component .mx-1,.runway .mx-1{margin-left:.25rem!important;margin-right:.25rem!important}.runway-component .my-1,.runway .my-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.runway-component .mt-2,.runway .mt-2{margin-top:.5rem!important}.runway-component .mr-2,.runway .mr-2{margin-right:.5rem!important}.runway-component .mb-2,.runway .mb-2{margin-bottom:.5rem!important}.runway-component .ml-2,.runway .ml-2{margin-left:.5rem!important}.runway-component .mx-2,.runway .mx-2{margin-left:.5rem!important;margin-right:.5rem!important}.runway-component .my-2,.runway .my-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.runway-component .mt-3,.runway .mt-3{margin-top:.75rem!important}.runway-component .mr-3,.runway .mr-3{margin-right:.75rem!important}.runway-component .mb-3,.runway .mb-3{margin-bottom:.75rem!important}.runway-component .ml-3,.runway .ml-3{margin-left:.75rem!important}.runway-component .mx-3,.runway .mx-3{margin-left:.75rem!important;margin-right:.75rem!important}.runway-component .my-3,.runway .my-3{margin-top:.75rem!important;margin-bottom:.75rem!important}.runway-component .mt-4,.runway .mt-4{margin-top:1rem!important}.runway-component .mr-4,.runway .mr-4{margin-right:1rem!important}.runway-component .mb-4,.runway .mb-4{margin-bottom:1rem!important}.runway-component .ml-4,.runway .ml-4{margin-left:1rem!important}.runway-component .mx-4,.runway .mx-4{margin-left:1rem!important;margin-right:1rem!important}.runway-component .my-4,.runway .my-4{margin-top:1rem!important;margin-bottom:1rem!important}.runway-component .mt-5,.runway .mt-5{margin-top:1.5rem!important}.runway-component .mr-5,.runway .mr-5{margin-right:1.5rem!important}.runway-component .mb-5,.runway .mb-5{margin-bottom:1.5rem!important}.runway-component .ml-5,.runway .ml-5{margin-left:1.5rem!important}.runway-component .mx-5,.runway .mx-5{margin-left:1.5rem!important;margin-right:1.5rem!important}.runway-component .my-5,.runway .my-5{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.runway-component .mt-6,.runway .mt-6{margin-top:3rem!important}.runway-component .mr-6,.runway .mr-6{margin-right:3rem!important}.runway-component .mb-6,.runway .mb-6{margin-bottom:3rem!important}.runway-component .ml-6,.runway .ml-6{margin-left:3rem!important}.runway-component .mx-6,.runway .mx-6{margin-left:3rem!important;margin-right:3rem!important}.runway-component .my-6,.runway .my-6{margin-top:3rem!important;margin-bottom:3rem!important}.runway-component .pt-0,.runway .pt-0{padding-top:0!important}.runway-component .pr-0,.runway .pr-0{padding-right:0!important}.runway-component .pb-0,.runway .pb-0{padding-bottom:0!important}.runway-component .pl-0,.runway .pl-0{padding-left:0!important}.runway-component .px-0,.runway .px-0{padding-left:0!important;padding-right:0!important}.runway-component .py-0,.runway .py-0{padding-top:0!important;padding-bottom:0!important}.runway-component .pt-1,.runway .pt-1{padding-top:.25rem!important}.runway-component .pr-1,.runway .pr-1{padding-right:.25rem!important}.runway-component .pb-1,.runway .pb-1{padding-bottom:.25rem!important}.runway-component .pl-1,.runway .pl-1{padding-left:.25rem!important}.runway-component .px-1,.runway .px-1{padding-left:.25rem!important;padding-right:.25rem!important}.runway-component .py-1,.runway .py-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.runway-component .pt-2,.runway .pt-2{padding-top:.5rem!important}.runway-component .pr-2,.runway .pr-2{padding-right:.5rem!important}.runway-component .pb-2,.runway .pb-2{padding-bottom:.5rem!important}.runway-component .pl-2,.runway .pl-2{padding-left:.5rem!important}.runway-component .px-2,.runway .px-2{padding-left:.5rem!important;padding-right:.5rem!important}.runway-component .py-2,.runway .py-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.runway-component .pt-3,.runway .pt-3{padding-top:.75rem!important}.runway-component .pr-3,.runway .pr-3{padding-right:.75rem!important}.runway-component .pb-3,.runway .pb-3{padding-bottom:.75rem!important}.runway-component .pl-3,.runway .pl-3{padding-left:.75rem!important}.runway-component .px-3,.runway .px-3{padding-left:.75rem!important;padding-right:.75rem!important}.runway-component .py-3,.runway .py-3{padding-top:.75rem!important;padding-bottom:.75rem!important}.runway-component .pt-4,.runway .pt-4{padding-top:1rem!important}.runway-component .pr-4,.runway .pr-4{padding-right:1rem!important}.runway-component .pb-4,.runway .pb-4{padding-bottom:1rem!important}.runway-component .pl-4,.runway .pl-4{padding-left:1rem!important}.runway-component .px-4,.runway .px-4{padding-left:1rem!important;padding-right:1rem!important}.runway-component .py-4,.runway .py-4{padding-top:1rem!important;padding-bottom:1rem!important}.runway-component .pt-5,.runway .pt-5{padding-top:1.5rem!important}.runway-component .pr-5,.runway .pr-5{padding-right:1.5rem!important}.runway-component .pb-5,.runway .pb-5{padding-bottom:1.5rem!important}.runway-component .pl-5,.runway .pl-5{padding-left:1.5rem!important}.runway-component .px-5,.runway .px-5{padding-left:1.5rem!important;padding-right:1.5rem!important}.runway-component .py-5,.runway .py-5{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.runway-component .pt-6,.runway .pt-6{padding-top:3rem!important}.runway-component .pr-6,.runway .pr-6{padding-right:3rem!important}.runway-component .pb-6,.runway .pb-6{padding-bottom:3rem!important}.runway-component .pl-6,.runway .pl-6{padding-left:3rem!important}.runway-component .px-6,.runway .px-6{padding-left:3rem!important;padding-right:3rem!important}.runway-component .py-6,.runway .py-6{padding-top:3rem!important;padding-bottom:3rem!important}.runway-component .is-size-1,.runway .is-size-1{font-size:3rem!important}.runway-component .is-size-2,.runway .is-size-2{font-size:2.5rem!important}.runway-component .is-size-3,.runway .is-size-3{font-size:2rem!important}.runway-component .is-size-4,.runway .is-size-4{font-size:1.5rem!important}.runway-component .is-size-5,.runway .is-size-5{font-size:1.25rem!important}.runway-component .is-size-6,.runway .is-size-6{font-size:1rem!important}.runway-component .is-size-7,.runway .is-size-7{font-size:.75rem!important}@media screen and (max-width:768px){.runway-component .is-size-1-mobile,.runway .is-size-1-mobile{font-size:3rem!important}.runway-component .is-size-2-mobile,.runway .is-size-2-mobile{font-size:2.5rem!important}.runway-component .is-size-3-mobile,.runway .is-size-3-mobile{font-size:2rem!important}.runway-component .is-size-4-mobile,.runway .is-size-4-mobile{font-size:1.5rem!important}.runway-component .is-size-5-mobile,.runway .is-size-5-mobile{font-size:1.25rem!important}.runway-component .is-size-6-mobile,.runway .is-size-6-mobile{font-size:1rem!important}.runway-component .is-size-7-mobile,.runway .is-size-7-mobile{font-size:.75rem!important}}@media print,screen and (min-width:769px){.runway-component .is-size-1-tablet,.runway .is-size-1-tablet{font-size:3rem!important}.runway-component .is-size-2-tablet,.runway .is-size-2-tablet{font-size:2.5rem!important}.runway-component .is-size-3-tablet,.runway .is-size-3-tablet{font-size:2rem!important}.runway-component .is-size-4-tablet,.runway .is-size-4-tablet{font-size:1.5rem!important}.runway-component .is-size-5-tablet,.runway .is-size-5-tablet{font-size:1.25rem!important}.runway-component .is-size-6-tablet,.runway .is-size-6-tablet{font-size:1rem!important}.runway-component .is-size-7-tablet,.runway .is-size-7-tablet{font-size:.75rem!important}}@media screen and (max-width:1023px){.runway-component .is-size-1-touch,.runway .is-size-1-touch{font-size:3rem!important}.runway-component .is-size-2-touch,.runway .is-size-2-touch{font-size:2.5rem!important}.runway-component .is-size-3-touch,.runway .is-size-3-touch{font-size:2rem!important}.runway-component .is-size-4-touch,.runway .is-size-4-touch{font-size:1.5rem!important}.runway-component .is-size-5-touch,.runway .is-size-5-touch{font-size:1.25rem!important}.runway-component .is-size-6-touch,.runway .is-size-6-touch{font-size:1rem!important}.runway-component .is-size-7-touch,.runway .is-size-7-touch{font-size:.75rem!important}}@media screen and (min-width:1024px){.runway-component .is-size-1-desktop,.runway .is-size-1-desktop{font-size:3rem!important}.runway-component .is-size-2-desktop,.runway .is-size-2-desktop{font-size:2.5rem!important}.runway-component .is-size-3-desktop,.runway .is-size-3-desktop{font-size:2rem!important}.runway-component .is-size-4-desktop,.runway .is-size-4-desktop{font-size:1.5rem!important}.runway-component .is-size-5-desktop,.runway .is-size-5-desktop{font-size:1.25rem!important}.runway-component .is-size-6-desktop,.runway .is-size-6-desktop{font-size:1rem!important}.runway-component .is-size-7-desktop,.runway .is-size-7-desktop{font-size:.75rem!important}}@media screen and (min-width:1216px){.runway-component .is-size-1-widescreen,.runway .is-size-1-widescreen{font-size:3rem!important}.runway-component .is-size-2-widescreen,.runway .is-size-2-widescreen{font-size:2.5rem!important}.runway-component .is-size-3-widescreen,.runway .is-size-3-widescreen{font-size:2rem!important}.runway-component .is-size-4-widescreen,.runway .is-size-4-widescreen{font-size:1.5rem!important}.runway-component .is-size-5-widescreen,.runway .is-size-5-widescreen{font-size:1.25rem!important}.runway-component .is-size-6-widescreen,.runway .is-size-6-widescreen{font-size:1rem!important}.runway-component .is-size-7-widescreen,.runway .is-size-7-widescreen{font-size:.75rem!important}}@media screen and (min-width:1408px){.runway-component .is-size-1-fullhd,.runway .is-size-1-fullhd{font-size:3rem!important}.runway-component .is-size-2-fullhd,.runway .is-size-2-fullhd{font-size:2.5rem!important}.runway-component .is-size-3-fullhd,.runway .is-size-3-fullhd{font-size:2rem!important}.runway-component .is-size-4-fullhd,.runway .is-size-4-fullhd{font-size:1.5rem!important}.runway-component .is-size-5-fullhd,.runway .is-size-5-fullhd{font-size:1.25rem!important}.runway-component .is-size-6-fullhd,.runway .is-size-6-fullhd{font-size:1rem!important}.runway-component .is-size-7-fullhd,.runway .is-size-7-fullhd{font-size:.75rem!important}}.runway-component .has-text-centered,.runway .has-text-centered{text-align:center!important}.runway-component .has-text-justified,.runway .has-text-justified{text-align:justify!important}.runway-component .has-text-left,.runway .has-text-left{text-align:left!important}.runway-component .has-text-right,.runway .has-text-right{text-align:right!important}@media screen and (max-width:768px){.runway-component .has-text-centered-mobile,.runway .has-text-centered-mobile{text-align:center!important}}@media print,screen and (min-width:769px){.runway-component .has-text-centered-tablet,.runway .has-text-centered-tablet{text-align:center!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .has-text-centered-tablet-only,.runway .has-text-centered-tablet-only{text-align:center!important}}@media screen and (max-width:1023px){.runway-component .has-text-centered-touch,.runway .has-text-centered-touch{text-align:center!important}}@media screen and (min-width:1024px){.runway-component .has-text-centered-desktop,.runway .has-text-centered-desktop{text-align:center!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .has-text-centered-desktop-only,.runway .has-text-centered-desktop-only{text-align:center!important}}@media screen and (min-width:1216px){.runway-component .has-text-centered-widescreen,.runway .has-text-centered-widescreen{text-align:center!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .has-text-centered-widescreen-only,.runway .has-text-centered-widescreen-only{text-align:center!important}}@media screen and (min-width:1408px){.runway-component .has-text-centered-fullhd,.runway .has-text-centered-fullhd{text-align:center!important}}@media screen and (max-width:768px){.runway-component .has-text-justified-mobile,.runway .has-text-justified-mobile{text-align:justify!important}}@media print,screen and (min-width:769px){.runway-component .has-text-justified-tablet,.runway .has-text-justified-tablet{text-align:justify!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .has-text-justified-tablet-only,.runway .has-text-justified-tablet-only{text-align:justify!important}}@media screen and (max-width:1023px){.runway-component .has-text-justified-touch,.runway .has-text-justified-touch{text-align:justify!important}}@media screen and (min-width:1024px){.runway-component .has-text-justified-desktop,.runway .has-text-justified-desktop{text-align:justify!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .has-text-justified-desktop-only,.runway .has-text-justified-desktop-only{text-align:justify!important}}@media screen and (min-width:1216px){.runway-component .has-text-justified-widescreen,.runway .has-text-justified-widescreen{text-align:justify!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .has-text-justified-widescreen-only,.runway .has-text-justified-widescreen-only{text-align:justify!important}}@media screen and (min-width:1408px){.runway-component .has-text-justified-fullhd,.runway .has-text-justified-fullhd{text-align:justify!important}}@media screen and (max-width:768px){.runway-component .has-text-left-mobile,.runway .has-text-left-mobile{text-align:left!important}}@media print,screen and (min-width:769px){.runway-component .has-text-left-tablet,.runway .has-text-left-tablet{text-align:left!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .has-text-left-tablet-only,.runway .has-text-left-tablet-only{text-align:left!important}}@media screen and (max-width:1023px){.runway-component .has-text-left-touch,.runway .has-text-left-touch{text-align:left!important}}@media screen and (min-width:1024px){.runway-component .has-text-left-desktop,.runway .has-text-left-desktop{text-align:left!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .has-text-left-desktop-only,.runway .has-text-left-desktop-only{text-align:left!important}}@media screen and (min-width:1216px){.runway-component .has-text-left-widescreen,.runway .has-text-left-widescreen{text-align:left!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .has-text-left-widescreen-only,.runway .has-text-left-widescreen-only{text-align:left!important}}@media screen and (min-width:1408px){.runway-component .has-text-left-fullhd,.runway .has-text-left-fullhd{text-align:left!important}}@media screen and (max-width:768px){.runway-component .has-text-right-mobile,.runway .has-text-right-mobile{text-align:right!important}}@media print,screen and (min-width:769px){.runway-component .has-text-right-tablet,.runway .has-text-right-tablet{text-align:right!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .has-text-right-tablet-only,.runway .has-text-right-tablet-only{text-align:right!important}}@media screen and (max-width:1023px){.runway-component .has-text-right-touch,.runway .has-text-right-touch{text-align:right!important}}@media screen and (min-width:1024px){.runway-component .has-text-right-desktop,.runway .has-text-right-desktop{text-align:right!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .has-text-right-desktop-only,.runway .has-text-right-desktop-only{text-align:right!important}}@media screen and (min-width:1216px){.runway-component .has-text-right-widescreen,.runway .has-text-right-widescreen{text-align:right!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .has-text-right-widescreen-only,.runway .has-text-right-widescreen-only{text-align:right!important}}@media screen and (min-width:1408px){.runway-component .has-text-right-fullhd,.runway .has-text-right-fullhd{text-align:right!important}}.runway-component .is-capitalized,.runway .is-capitalized{text-transform:capitalize!important}.runway-component .is-lowercase,.runway .is-lowercase{text-transform:lowercase!important}.runway-component .is-uppercase,.runway .is-uppercase{text-transform:uppercase!important}.runway-component .is-italic,.runway .is-italic{font-style:italic!important}.runway-component .has-text-weight-light,.runway .has-text-weight-light{font-weight:300!important}.runway-component .has-text-weight-normal,.runway .has-text-weight-normal{font-weight:400!important}.runway-component .has-text-weight-medium,.runway .has-text-weight-medium{font-weight:500!important}.runway-component .has-text-weight-semibold,.runway .has-text-weight-semibold{font-weight:600!important}.runway-component .has-text-weight-bold,.runway .has-text-weight-bold{font-weight:700!important}.runway-component .is-family-primary,.runway-component .is-family-sans-serif,.runway-component .is-family-secondary,.runway .is-family-primary,.runway .is-family-sans-serif,.runway .is-family-secondary{font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif!important}.runway-component .is-family-code,.runway-component .is-family-monospace,.runway .is-family-code,.runway .is-family-monospace{font-family:monospace!important}.runway-component .is-block,.runway .is-block{display:block!important}@media screen and (max-width:768px){.runway-component .is-block-mobile,.runway .is-block-mobile{display:block!important}}@media print,screen and (min-width:769px){.runway-component .is-block-tablet,.runway .is-block-tablet{display:block!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .is-block-tablet-only,.runway .is-block-tablet-only{display:block!important}}@media screen and (max-width:1023px){.runway-component .is-block-touch,.runway .is-block-touch{display:block!important}}@media screen and (min-width:1024px){.runway-component .is-block-desktop,.runway .is-block-desktop{display:block!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .is-block-desktop-only,.runway .is-block-desktop-only{display:block!important}}@media screen and (min-width:1216px){.runway-component .is-block-widescreen,.runway .is-block-widescreen{display:block!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .is-block-widescreen-only,.runway .is-block-widescreen-only{display:block!important}}@media screen and (min-width:1408px){.runway-component .is-block-fullhd,.runway .is-block-fullhd{display:block!important}}.runway-component .is-flex,.runway .is-flex{display:flex!important}@media screen and (max-width:768px){.runway-component .is-flex-mobile,.runway .is-flex-mobile{display:flex!important}}@media print,screen and (min-width:769px){.runway-component .is-flex-tablet,.runway .is-flex-tablet{display:flex!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .is-flex-tablet-only,.runway .is-flex-tablet-only{display:flex!important}}@media screen and (max-width:1023px){.runway-component .is-flex-touch,.runway .is-flex-touch{display:flex!important}}@media screen and (min-width:1024px){.runway-component .is-flex-desktop,.runway .is-flex-desktop{display:flex!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .is-flex-desktop-only,.runway .is-flex-desktop-only{display:flex!important}}@media screen and (min-width:1216px){.runway-component .is-flex-widescreen,.runway .is-flex-widescreen{display:flex!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .is-flex-widescreen-only,.runway .is-flex-widescreen-only{display:flex!important}}@media screen and (min-width:1408px){.runway-component .is-flex-fullhd,.runway .is-flex-fullhd{display:flex!important}}.runway-component .is-inline,.runway .is-inline{display:inline!important}@media screen and (max-width:768px){.runway-component .is-inline-mobile,.runway .is-inline-mobile{display:inline!important}}@media print,screen and (min-width:769px){.runway-component .is-inline-tablet,.runway .is-inline-tablet{display:inline!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .is-inline-tablet-only,.runway .is-inline-tablet-only{display:inline!important}}@media screen and (max-width:1023px){.runway-component .is-inline-touch,.runway .is-inline-touch{display:inline!important}}@media screen and (min-width:1024px){.runway-component .is-inline-desktop,.runway .is-inline-desktop{display:inline!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .is-inline-desktop-only,.runway .is-inline-desktop-only{display:inline!important}}@media screen and (min-width:1216px){.runway-component .is-inline-widescreen,.runway .is-inline-widescreen{display:inline!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .is-inline-widescreen-only,.runway .is-inline-widescreen-only{display:inline!important}}@media screen and (min-width:1408px){.runway-component .is-inline-fullhd,.runway .is-inline-fullhd{display:inline!important}}.runway-component .is-inline-block,.runway .is-inline-block{display:inline-block!important}@media screen and (max-width:768px){.runway-component .is-inline-block-mobile,.runway .is-inline-block-mobile{display:inline-block!important}}@media print,screen and (min-width:769px){.runway-component .is-inline-block-tablet,.runway .is-inline-block-tablet{display:inline-block!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .is-inline-block-tablet-only,.runway .is-inline-block-tablet-only{display:inline-block!important}}@media screen and (max-width:1023px){.runway-component .is-inline-block-touch,.runway .is-inline-block-touch{display:inline-block!important}}@media screen and (min-width:1024px){.runway-component .is-inline-block-desktop,.runway .is-inline-block-desktop{display:inline-block!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .is-inline-block-desktop-only,.runway .is-inline-block-desktop-only{display:inline-block!important}}@media screen and (min-width:1216px){.runway-component .is-inline-block-widescreen,.runway .is-inline-block-widescreen{display:inline-block!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .is-inline-block-widescreen-only,.runway .is-inline-block-widescreen-only{display:inline-block!important}}@media screen and (min-width:1408px){.runway-component .is-inline-block-fullhd,.runway .is-inline-block-fullhd{display:inline-block!important}}.runway-component .is-inline-flex,.runway .is-inline-flex{display:inline-flex!important}@media screen and (max-width:768px){.runway-component .is-inline-flex-mobile,.runway .is-inline-flex-mobile{display:inline-flex!important}}@media print,screen and (min-width:769px){.runway-component .is-inline-flex-tablet,.runway .is-inline-flex-tablet{display:inline-flex!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .is-inline-flex-tablet-only,.runway .is-inline-flex-tablet-only{display:inline-flex!important}}@media screen and (max-width:1023px){.runway-component .is-inline-flex-touch,.runway .is-inline-flex-touch{display:inline-flex!important}}@media screen and (min-width:1024px){.runway-component .is-inline-flex-desktop,.runway .is-inline-flex-desktop{display:inline-flex!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .is-inline-flex-desktop-only,.runway .is-inline-flex-desktop-only{display:inline-flex!important}}@media screen and (min-width:1216px){.runway-component .is-inline-flex-widescreen,.runway .is-inline-flex-widescreen{display:inline-flex!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .is-inline-flex-widescreen-only,.runway .is-inline-flex-widescreen-only{display:inline-flex!important}}@media screen and (min-width:1408px){.runway-component .is-inline-flex-fullhd,.runway .is-inline-flex-fullhd{display:inline-flex!important}}.runway-component .is-hidden,.runway .is-hidden{display:none!important}.runway-component .is-sr-only,.runway .is-sr-only{border:none!important;clip:rect(0,0,0,0)!important;height:.01em!important;overflow:hidden!important;padding:0!important;position:absolute!important;white-space:nowrap!important;width:.01em!important}@media screen and (max-width:768px){.runway-component .is-hidden-mobile,.runway .is-hidden-mobile{display:none!important}}@media print,screen and (min-width:769px){.runway-component .is-hidden-tablet,.runway .is-hidden-tablet{display:none!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .is-hidden-tablet-only,.runway .is-hidden-tablet-only{display:none!important}}@media screen and (max-width:1023px){.runway-component .is-hidden-touch,.runway .is-hidden-touch{display:none!important}}@media screen and (min-width:1024px){.runway-component .is-hidden-desktop,.runway .is-hidden-desktop{display:none!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .is-hidden-desktop-only,.runway .is-hidden-desktop-only{display:none!important}}@media screen and (min-width:1216px){.runway-component .is-hidden-widescreen,.runway .is-hidden-widescreen{display:none!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .is-hidden-widescreen-only,.runway .is-hidden-widescreen-only{display:none!important}}@media screen and (min-width:1408px){.runway-component .is-hidden-fullhd,.runway .is-hidden-fullhd{display:none!important}}.runway-component .is-invisible,.runway .is-invisible{visibility:hidden!important}@media screen and (max-width:768px){.runway-component .is-invisible-mobile,.runway .is-invisible-mobile{visibility:hidden!important}}@media print,screen and (min-width:769px){.runway-component .is-invisible-tablet,.runway .is-invisible-tablet{visibility:hidden!important}}@media screen and (min-width:769px) and (max-width:1023px){.runway-component .is-invisible-tablet-only,.runway .is-invisible-tablet-only{visibility:hidden!important}}@media screen and (max-width:1023px){.runway-component .is-invisible-touch,.runway .is-invisible-touch{visibility:hidden!important}}@media screen and (min-width:1024px){.runway-component .is-invisible-desktop,.runway .is-invisible-desktop{visibility:hidden!important}}@media screen and (min-width:1024px) and (max-width:1215px){.runway-component .is-invisible-desktop-only,.runway .is-invisible-desktop-only{visibility:hidden!important}}@media screen and (min-width:1216px){.runway-component .is-invisible-widescreen,.runway .is-invisible-widescreen{visibility:hidden!important}}@media screen and (min-width:1216px) and (max-width:1407px){.runway-component .is-invisible-widescreen-only,.runway .is-invisible-widescreen-only{visibility:hidden!important}}@media screen and (min-width:1408px){.runway-component .is-invisible-fullhd,.runway .is-invisible-fullhd{visibility:hidden!important}}.runway-component .hero,.runway .hero{align-items:stretch;display:flex;flex-direction:column;justify-content:space-between}.runway-component .hero .navbar,.runway .hero .navbar{background:0 0}.runway-component .hero .tabs ul,.runway .hero .tabs ul{border-bottom:none}.runway-component .hero.is-white,.runway .hero.is-white{background-color:#fff;color:#0a0a0a}.runway-component .hero.is-white a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway-component .hero.is-white strong,.runway .hero.is-white a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway .hero.is-white strong{color:inherit}.runway-component .hero.is-white .title,.runway .hero.is-white .title{color:#0a0a0a}.runway-component .hero.is-white .subtitle,.runway .hero.is-white .subtitle{color:hsla(0,0%,4%,.9)}.runway-component .hero.is-white .subtitle a:not(.button),.runway-component .hero.is-white .subtitle strong,.runway .hero.is-white .subtitle a:not(.button),.runway .hero.is-white .subtitle strong{color:#0a0a0a}@media screen and (max-width:1023px){.runway-component .hero.is-white .navbar-menu,.runway .hero.is-white .navbar-menu{background-color:#fff}}.runway-component .hero.is-white .navbar-item,.runway-component .hero.is-white .navbar-link,.runway .hero.is-white .navbar-item,.runway .hero.is-white .navbar-link{color:hsla(0,0%,4%,.7)}.runway-component .hero.is-white .navbar-link.is-active,.runway-component .hero.is-white .navbar-link:hover,.runway-component .hero.is-white a.navbar-item.is-active,.runway-component .hero.is-white a.navbar-item:hover,.runway .hero.is-white .navbar-link.is-active,.runway .hero.is-white .navbar-link:hover,.runway .hero.is-white a.navbar-item.is-active,.runway .hero.is-white a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.runway-component .hero.is-white .tabs a,.runway .hero.is-white .tabs a{color:#0a0a0a;opacity:.9}.runway-component .hero.is-white .tabs a:hover,.runway-component .hero.is-white .tabs li.is-active a,.runway .hero.is-white .tabs a:hover,.runway .hero.is-white .tabs li.is-active a{opacity:1}.runway-component .hero.is-white .tabs.is-boxed a,.runway-component .hero.is-white .tabs.is-toggle a,.runway .hero.is-white .tabs.is-boxed a,.runway .hero.is-white .tabs.is-toggle a{color:#0a0a0a}.runway-component .hero.is-white .tabs.is-boxed a:hover,.runway-component .hero.is-white .tabs.is-toggle a:hover,.runway .hero.is-white .tabs.is-boxed a:hover,.runway .hero.is-white .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.runway-component .hero.is-white .tabs.is-boxed li.is-active a,.runway-component .hero.is-white .tabs.is-boxed li.is-active a:hover,.runway-component .hero.is-white .tabs.is-toggle li.is-active a,.runway-component .hero.is-white .tabs.is-toggle li.is-active a:hover,.runway .hero.is-white .tabs.is-boxed li.is-active a,.runway .hero.is-white .tabs.is-boxed li.is-active a:hover,.runway .hero.is-white .tabs.is-toggle li.is-active a,.runway .hero.is-white .tabs.is-toggle li.is-active a:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.runway-component .hero.is-white.is-bold,.runway .hero.is-white.is-bold{background-image:linear-gradient(141deg,#e6e6e6,#fff 71%,#fff)}@media screen and (max-width:768px){.runway-component .hero.is-white.is-bold .navbar-menu,.runway .hero.is-white.is-bold .navbar-menu{background-image:linear-gradient(141deg,#e6e6e6,#fff 71%,#fff)}}.runway-component .hero.is-black,.runway .hero.is-black{background-color:#0a0a0a;color:#fff}.runway-component .hero.is-black a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway-component .hero.is-black strong,.runway .hero.is-black a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway .hero.is-black strong{color:inherit}.runway-component .hero.is-black .title,.runway .hero.is-black .title{color:#fff}.runway-component .hero.is-black .subtitle,.runway .hero.is-black .subtitle{color:hsla(0,0%,100%,.9)}.runway-component .hero.is-black .subtitle a:not(.button),.runway-component .hero.is-black .subtitle strong,.runway .hero.is-black .subtitle a:not(.button),.runway .hero.is-black .subtitle strong{color:#fff}@media screen and (max-width:1023px){.runway-component .hero.is-black .navbar-menu,.runway .hero.is-black .navbar-menu{background-color:#0a0a0a}}.runway-component .hero.is-black .navbar-item,.runway-component .hero.is-black .navbar-link,.runway .hero.is-black .navbar-item,.runway .hero.is-black .navbar-link{color:hsla(0,0%,100%,.7)}.runway-component .hero.is-black .navbar-link.is-active,.runway-component .hero.is-black .navbar-link:hover,.runway-component .hero.is-black a.navbar-item.is-active,.runway-component .hero.is-black a.navbar-item:hover,.runway .hero.is-black .navbar-link.is-active,.runway .hero.is-black .navbar-link:hover,.runway .hero.is-black a.navbar-item.is-active,.runway .hero.is-black a.navbar-item:hover{background-color:#000;color:#fff}.runway-component .hero.is-black .tabs a,.runway .hero.is-black .tabs a{color:#fff;opacity:.9}.runway-component .hero.is-black .tabs a:hover,.runway-component .hero.is-black .tabs li.is-active a,.runway .hero.is-black .tabs a:hover,.runway .hero.is-black .tabs li.is-active a{opacity:1}.runway-component .hero.is-black .tabs.is-boxed a,.runway-component .hero.is-black .tabs.is-toggle a,.runway .hero.is-black .tabs.is-boxed a,.runway .hero.is-black .tabs.is-toggle a{color:#fff}.runway-component .hero.is-black .tabs.is-boxed a:hover,.runway-component .hero.is-black .tabs.is-toggle a:hover,.runway .hero.is-black .tabs.is-boxed a:hover,.runway .hero.is-black .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.runway-component .hero.is-black .tabs.is-boxed li.is-active a,.runway-component .hero.is-black .tabs.is-boxed li.is-active a:hover,.runway-component .hero.is-black .tabs.is-toggle li.is-active a,.runway-component .hero.is-black .tabs.is-toggle li.is-active a:hover,.runway .hero.is-black .tabs.is-boxed li.is-active a,.runway .hero.is-black .tabs.is-boxed li.is-active a:hover,.runway .hero.is-black .tabs.is-toggle li.is-active a,.runway .hero.is-black .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.runway-component .hero.is-black.is-bold,.runway .hero.is-black.is-bold{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}@media screen and (max-width:768px){.runway-component .hero.is-black.is-bold .navbar-menu,.runway .hero.is-black.is-bold .navbar-menu{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}}.runway-component .hero.is-light,.runway .hero.is-light{background-color:#f5f5f5;color:rgba(0,0,0,.7)}.runway-component .hero.is-light a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway-component .hero.is-light strong,.runway .hero.is-light a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway .hero.is-light strong{color:inherit}.runway-component .hero.is-light .title,.runway .hero.is-light .title{color:rgba(0,0,0,.7)}.runway-component .hero.is-light .subtitle,.runway .hero.is-light .subtitle{color:rgba(0,0,0,.9)}.runway-component .hero.is-light .subtitle a:not(.button),.runway-component .hero.is-light .subtitle strong,.runway .hero.is-light .subtitle a:not(.button),.runway .hero.is-light .subtitle strong{color:rgba(0,0,0,.7)}@media screen and (max-width:1023px){.runway-component .hero.is-light .navbar-menu,.runway .hero.is-light .navbar-menu{background-color:#f5f5f5}}.runway-component .hero.is-light .navbar-item,.runway-component .hero.is-light .navbar-link,.runway .hero.is-light .navbar-item,.runway .hero.is-light .navbar-link{color:rgba(0,0,0,.7)}.runway-component .hero.is-light .navbar-link.is-active,.runway-component .hero.is-light .navbar-link:hover,.runway-component .hero.is-light a.navbar-item.is-active,.runway-component .hero.is-light a.navbar-item:hover,.runway .hero.is-light .navbar-link.is-active,.runway .hero.is-light .navbar-link:hover,.runway .hero.is-light a.navbar-item.is-active,.runway .hero.is-light a.navbar-item:hover{background-color:#e8e8e8;color:rgba(0,0,0,.7)}.runway-component .hero.is-light .tabs a,.runway .hero.is-light .tabs a{color:rgba(0,0,0,.7);opacity:.9}.runway-component .hero.is-light .tabs a:hover,.runway-component .hero.is-light .tabs li.is-active a,.runway .hero.is-light .tabs a:hover,.runway .hero.is-light .tabs li.is-active a{opacity:1}.runway-component .hero.is-light .tabs.is-boxed a,.runway-component .hero.is-light .tabs.is-toggle a,.runway .hero.is-light .tabs.is-boxed a,.runway .hero.is-light .tabs.is-toggle a{color:rgba(0,0,0,.7)}.runway-component .hero.is-light .tabs.is-boxed a:hover,.runway-component .hero.is-light .tabs.is-toggle a:hover,.runway .hero.is-light .tabs.is-boxed a:hover,.runway .hero.is-light .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.runway-component .hero.is-light .tabs.is-boxed li.is-active a,.runway-component .hero.is-light .tabs.is-boxed li.is-active a:hover,.runway-component .hero.is-light .tabs.is-toggle li.is-active a,.runway-component .hero.is-light .tabs.is-toggle li.is-active a:hover,.runway .hero.is-light .tabs.is-boxed li.is-active a,.runway .hero.is-light .tabs.is-boxed li.is-active a:hover,.runway .hero.is-light .tabs.is-toggle li.is-active a,.runway .hero.is-light .tabs.is-toggle li.is-active a:hover{background-color:rgba(0,0,0,.7);border-color:rgba(0,0,0,.7);color:#f5f5f5}.runway-component .hero.is-light.is-bold,.runway .hero.is-light.is-bold{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}@media screen and (max-width:768px){.runway-component .hero.is-light.is-bold .navbar-menu,.runway .hero.is-light.is-bold .navbar-menu{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}}.runway-component .hero.is-dark,.runway .hero.is-dark{background-color:#363636;color:#fff}.runway-component .hero.is-dark a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway-component .hero.is-dark strong,.runway .hero.is-dark a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway .hero.is-dark strong{color:inherit}.runway-component .hero.is-dark .title,.runway .hero.is-dark .title{color:#fff}.runway-component .hero.is-dark .subtitle,.runway .hero.is-dark .subtitle{color:hsla(0,0%,100%,.9)}.runway-component .hero.is-dark .subtitle a:not(.button),.runway-component .hero.is-dark .subtitle strong,.runway .hero.is-dark .subtitle a:not(.button),.runway .hero.is-dark .subtitle strong{color:#fff}@media screen and (max-width:1023px){.runway-component .hero.is-dark .navbar-menu,.runway .hero.is-dark .navbar-menu{background-color:#363636}}.runway-component .hero.is-dark .navbar-item,.runway-component .hero.is-dark .navbar-link,.runway .hero.is-dark .navbar-item,.runway .hero.is-dark .navbar-link{color:hsla(0,0%,100%,.7)}.runway-component .hero.is-dark .navbar-link.is-active,.runway-component .hero.is-dark .navbar-link:hover,.runway-component .hero.is-dark a.navbar-item.is-active,.runway-component .hero.is-dark a.navbar-item:hover,.runway .hero.is-dark .navbar-link.is-active,.runway .hero.is-dark .navbar-link:hover,.runway .hero.is-dark a.navbar-item.is-active,.runway .hero.is-dark a.navbar-item:hover{background-color:#292929;color:#fff}.runway-component .hero.is-dark .tabs a,.runway .hero.is-dark .tabs a{color:#fff;opacity:.9}.runway-component .hero.is-dark .tabs a:hover,.runway-component .hero.is-dark .tabs li.is-active a,.runway .hero.is-dark .tabs a:hover,.runway .hero.is-dark .tabs li.is-active a{opacity:1}.runway-component .hero.is-dark .tabs.is-boxed a,.runway-component .hero.is-dark .tabs.is-toggle a,.runway .hero.is-dark .tabs.is-boxed a,.runway .hero.is-dark .tabs.is-toggle a{color:#fff}.runway-component .hero.is-dark .tabs.is-boxed a:hover,.runway-component .hero.is-dark .tabs.is-toggle a:hover,.runway .hero.is-dark .tabs.is-boxed a:hover,.runway .hero.is-dark .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.runway-component .hero.is-dark .tabs.is-boxed li.is-active a,.runway-component .hero.is-dark .tabs.is-boxed li.is-active a:hover,.runway-component .hero.is-dark .tabs.is-toggle li.is-active a,.runway-component .hero.is-dark .tabs.is-toggle li.is-active a:hover,.runway .hero.is-dark .tabs.is-boxed li.is-active a,.runway .hero.is-dark .tabs.is-boxed li.is-active a:hover,.runway .hero.is-dark .tabs.is-toggle li.is-active a,.runway .hero.is-dark .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#363636}.runway-component .hero.is-dark.is-bold,.runway .hero.is-dark.is-bold{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}@media screen and (max-width:768px){.runway-component .hero.is-dark.is-bold .navbar-menu,.runway .hero.is-dark.is-bold .navbar-menu{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}}.runway-component .hero.is-primary,.runway .hero.is-primary{background-color:#00d1b2;color:#fff}.runway-component .hero.is-primary a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway-component .hero.is-primary strong,.runway .hero.is-primary a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway .hero.is-primary strong{color:inherit}.runway-component .hero.is-primary .title,.runway .hero.is-primary .title{color:#fff}.runway-component .hero.is-primary .subtitle,.runway .hero.is-primary .subtitle{color:hsla(0,0%,100%,.9)}.runway-component .hero.is-primary .subtitle a:not(.button),.runway-component .hero.is-primary .subtitle strong,.runway .hero.is-primary .subtitle a:not(.button),.runway .hero.is-primary .subtitle strong{color:#fff}@media screen and (max-width:1023px){.runway-component .hero.is-primary .navbar-menu,.runway .hero.is-primary .navbar-menu{background-color:#00d1b2}}.runway-component .hero.is-primary .navbar-item,.runway-component .hero.is-primary .navbar-link,.runway .hero.is-primary .navbar-item,.runway .hero.is-primary .navbar-link{color:hsla(0,0%,100%,.7)}.runway-component .hero.is-primary .navbar-link.is-active,.runway-component .hero.is-primary .navbar-link:hover,.runway-component .hero.is-primary a.navbar-item.is-active,.runway-component .hero.is-primary a.navbar-item:hover,.runway .hero.is-primary .navbar-link.is-active,.runway .hero.is-primary .navbar-link:hover,.runway .hero.is-primary a.navbar-item.is-active,.runway .hero.is-primary a.navbar-item:hover{background-color:#00b89c;color:#fff}.runway-component .hero.is-primary .tabs a,.runway .hero.is-primary .tabs a{color:#fff;opacity:.9}.runway-component .hero.is-primary .tabs a:hover,.runway-component .hero.is-primary .tabs li.is-active a,.runway .hero.is-primary .tabs a:hover,.runway .hero.is-primary .tabs li.is-active a{opacity:1}.runway-component .hero.is-primary .tabs.is-boxed a,.runway-component .hero.is-primary .tabs.is-toggle a,.runway .hero.is-primary .tabs.is-boxed a,.runway .hero.is-primary .tabs.is-toggle a{color:#fff}.runway-component .hero.is-primary .tabs.is-boxed a:hover,.runway-component .hero.is-primary .tabs.is-toggle a:hover,.runway .hero.is-primary .tabs.is-boxed a:hover,.runway .hero.is-primary .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.runway-component .hero.is-primary .tabs.is-boxed li.is-active a,.runway-component .hero.is-primary .tabs.is-boxed li.is-active a:hover,.runway-component .hero.is-primary .tabs.is-toggle li.is-active a,.runway-component .hero.is-primary .tabs.is-toggle li.is-active a:hover,.runway .hero.is-primary .tabs.is-boxed li.is-active a,.runway .hero.is-primary .tabs.is-boxed li.is-active a:hover,.runway .hero.is-primary .tabs.is-toggle li.is-active a,.runway .hero.is-primary .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#00d1b2}.runway-component .hero.is-primary.is-bold,.runway .hero.is-primary.is-bold{background-image:linear-gradient(141deg,#009e6c,#00d1b2 71%,#00e7eb)}@media screen and (max-width:768px){.runway-component .hero.is-primary.is-bold .navbar-menu,.runway .hero.is-primary.is-bold .navbar-menu{background-image:linear-gradient(141deg,#009e6c,#00d1b2 71%,#00e7eb)}}.runway-component .hero.is-link,.runway .hero.is-link{background-color:#3273dc;color:#fff}.runway-component .hero.is-link a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway-component .hero.is-link strong,.runway .hero.is-link a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway .hero.is-link strong{color:inherit}.runway-component .hero.is-link .title,.runway .hero.is-link .title{color:#fff}.runway-component .hero.is-link .subtitle,.runway .hero.is-link .subtitle{color:hsla(0,0%,100%,.9)}.runway-component .hero.is-link .subtitle a:not(.button),.runway-component .hero.is-link .subtitle strong,.runway .hero.is-link .subtitle a:not(.button),.runway .hero.is-link .subtitle strong{color:#fff}@media screen and (max-width:1023px){.runway-component .hero.is-link .navbar-menu,.runway .hero.is-link .navbar-menu{background-color:#3273dc}}.runway-component .hero.is-link .navbar-item,.runway-component .hero.is-link .navbar-link,.runway .hero.is-link .navbar-item,.runway .hero.is-link .navbar-link{color:hsla(0,0%,100%,.7)}.runway-component .hero.is-link .navbar-link.is-active,.runway-component .hero.is-link .navbar-link:hover,.runway-component .hero.is-link a.navbar-item.is-active,.runway-component .hero.is-link a.navbar-item:hover,.runway .hero.is-link .navbar-link.is-active,.runway .hero.is-link .navbar-link:hover,.runway .hero.is-link a.navbar-item.is-active,.runway .hero.is-link a.navbar-item:hover{background-color:#2366d1;color:#fff}.runway-component .hero.is-link .tabs a,.runway .hero.is-link .tabs a{color:#fff;opacity:.9}.runway-component .hero.is-link .tabs a:hover,.runway-component .hero.is-link .tabs li.is-active a,.runway .hero.is-link .tabs a:hover,.runway .hero.is-link .tabs li.is-active a{opacity:1}.runway-component .hero.is-link .tabs.is-boxed a,.runway-component .hero.is-link .tabs.is-toggle a,.runway .hero.is-link .tabs.is-boxed a,.runway .hero.is-link .tabs.is-toggle a{color:#fff}.runway-component .hero.is-link .tabs.is-boxed a:hover,.runway-component .hero.is-link .tabs.is-toggle a:hover,.runway .hero.is-link .tabs.is-boxed a:hover,.runway .hero.is-link .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.runway-component .hero.is-link .tabs.is-boxed li.is-active a,.runway-component .hero.is-link .tabs.is-boxed li.is-active a:hover,.runway-component .hero.is-link .tabs.is-toggle li.is-active a,.runway-component .hero.is-link .tabs.is-toggle li.is-active a:hover,.runway .hero.is-link .tabs.is-boxed li.is-active a,.runway .hero.is-link .tabs.is-boxed li.is-active a:hover,.runway .hero.is-link .tabs.is-toggle li.is-active a,.runway .hero.is-link .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#3273dc}.runway-component .hero.is-link.is-bold,.runway .hero.is-link.is-bold{background-image:linear-gradient(141deg,#1577c6,#3273dc 71%,#4366e5)}@media screen and (max-width:768px){.runway-component .hero.is-link.is-bold .navbar-menu,.runway .hero.is-link.is-bold .navbar-menu{background-image:linear-gradient(141deg,#1577c6,#3273dc 71%,#4366e5)}}.runway-component .hero.is-info,.runway .hero.is-info{background-color:#3298dc;color:#fff}.runway-component .hero.is-info a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway-component .hero.is-info strong,.runway .hero.is-info a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway .hero.is-info strong{color:inherit}.runway-component .hero.is-info .title,.runway .hero.is-info .title{color:#fff}.runway-component .hero.is-info .subtitle,.runway .hero.is-info .subtitle{color:hsla(0,0%,100%,.9)}.runway-component .hero.is-info .subtitle a:not(.button),.runway-component .hero.is-info .subtitle strong,.runway .hero.is-info .subtitle a:not(.button),.runway .hero.is-info .subtitle strong{color:#fff}@media screen and (max-width:1023px){.runway-component .hero.is-info .navbar-menu,.runway .hero.is-info .navbar-menu{background-color:#3298dc}}.runway-component .hero.is-info .navbar-item,.runway-component .hero.is-info .navbar-link,.runway .hero.is-info .navbar-item,.runway .hero.is-info .navbar-link{color:hsla(0,0%,100%,.7)}.runway-component .hero.is-info .navbar-link.is-active,.runway-component .hero.is-info .navbar-link:hover,.runway-component .hero.is-info a.navbar-item.is-active,.runway-component .hero.is-info a.navbar-item:hover,.runway .hero.is-info .navbar-link.is-active,.runway .hero.is-info .navbar-link:hover,.runway .hero.is-info a.navbar-item.is-active,.runway .hero.is-info a.navbar-item:hover{background-color:#238cd1;color:#fff}.runway-component .hero.is-info .tabs a,.runway .hero.is-info .tabs a{color:#fff;opacity:.9}.runway-component .hero.is-info .tabs a:hover,.runway-component .hero.is-info .tabs li.is-active a,.runway .hero.is-info .tabs a:hover,.runway .hero.is-info .tabs li.is-active a{opacity:1}.runway-component .hero.is-info .tabs.is-boxed a,.runway-component .hero.is-info .tabs.is-toggle a,.runway .hero.is-info .tabs.is-boxed a,.runway .hero.is-info .tabs.is-toggle a{color:#fff}.runway-component .hero.is-info .tabs.is-boxed a:hover,.runway-component .hero.is-info .tabs.is-toggle a:hover,.runway .hero.is-info .tabs.is-boxed a:hover,.runway .hero.is-info .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.runway-component .hero.is-info .tabs.is-boxed li.is-active a,.runway-component .hero.is-info .tabs.is-boxed li.is-active a:hover,.runway-component .hero.is-info .tabs.is-toggle li.is-active a,.runway-component .hero.is-info .tabs.is-toggle li.is-active a:hover,.runway .hero.is-info .tabs.is-boxed li.is-active a,.runway .hero.is-info .tabs.is-boxed li.is-active a:hover,.runway .hero.is-info .tabs.is-toggle li.is-active a,.runway .hero.is-info .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#3298dc}.runway-component .hero.is-info.is-bold,.runway .hero.is-info.is-bold{background-image:linear-gradient(141deg,#159dc6,#3298dc 71%,#4389e5)}@media screen and (max-width:768px){.runway-component .hero.is-info.is-bold .navbar-menu,.runway .hero.is-info.is-bold .navbar-menu{background-image:linear-gradient(141deg,#159dc6,#3298dc 71%,#4389e5)}}.runway-component .hero.is-success,.runway .hero.is-success{background-color:#48c774;color:#fff}.runway-component .hero.is-success a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway-component .hero.is-success strong,.runway .hero.is-success a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway .hero.is-success strong{color:inherit}.runway-component .hero.is-success .title,.runway .hero.is-success .title{color:#fff}.runway-component .hero.is-success .subtitle,.runway .hero.is-success .subtitle{color:hsla(0,0%,100%,.9)}.runway-component .hero.is-success .subtitle a:not(.button),.runway-component .hero.is-success .subtitle strong,.runway .hero.is-success .subtitle a:not(.button),.runway .hero.is-success .subtitle strong{color:#fff}@media screen and (max-width:1023px){.runway-component .hero.is-success .navbar-menu,.runway .hero.is-success .navbar-menu{background-color:#48c774}}.runway-component .hero.is-success .navbar-item,.runway-component .hero.is-success .navbar-link,.runway .hero.is-success .navbar-item,.runway .hero.is-success .navbar-link{color:hsla(0,0%,100%,.7)}.runway-component .hero.is-success .navbar-link.is-active,.runway-component .hero.is-success .navbar-link:hover,.runway-component .hero.is-success a.navbar-item.is-active,.runway-component .hero.is-success a.navbar-item:hover,.runway .hero.is-success .navbar-link.is-active,.runway .hero.is-success .navbar-link:hover,.runway .hero.is-success a.navbar-item.is-active,.runway .hero.is-success a.navbar-item:hover{background-color:#3abb67;color:#fff}.runway-component .hero.is-success .tabs a,.runway .hero.is-success .tabs a{color:#fff;opacity:.9}.runway-component .hero.is-success .tabs a:hover,.runway-component .hero.is-success .tabs li.is-active a,.runway .hero.is-success .tabs a:hover,.runway .hero.is-success .tabs li.is-active a{opacity:1}.runway-component .hero.is-success .tabs.is-boxed a,.runway-component .hero.is-success .tabs.is-toggle a,.runway .hero.is-success .tabs.is-boxed a,.runway .hero.is-success .tabs.is-toggle a{color:#fff}.runway-component .hero.is-success .tabs.is-boxed a:hover,.runway-component .hero.is-success .tabs.is-toggle a:hover,.runway .hero.is-success .tabs.is-boxed a:hover,.runway .hero.is-success .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.runway-component .hero.is-success .tabs.is-boxed li.is-active a,.runway-component .hero.is-success .tabs.is-boxed li.is-active a:hover,.runway-component .hero.is-success .tabs.is-toggle li.is-active a,.runway-component .hero.is-success .tabs.is-toggle li.is-active a:hover,.runway .hero.is-success .tabs.is-boxed li.is-active a,.runway .hero.is-success .tabs.is-boxed li.is-active a:hover,.runway .hero.is-success .tabs.is-toggle li.is-active a,.runway .hero.is-success .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#48c774}.runway-component .hero.is-success.is-bold,.runway .hero.is-success.is-bold{background-image:linear-gradient(141deg,#29b342,#48c774 71%,#56d296)}@media screen and (max-width:768px){.runway-component .hero.is-success.is-bold .navbar-menu,.runway .hero.is-success.is-bold .navbar-menu{background-image:linear-gradient(141deg,#29b342,#48c774 71%,#56d296)}}.runway-component .hero.is-warning,.runway .hero.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.runway-component .hero.is-warning a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway-component .hero.is-warning strong,.runway .hero.is-warning a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway .hero.is-warning strong{color:inherit}.runway-component .hero.is-warning .title,.runway .hero.is-warning .title{color:rgba(0,0,0,.7)}.runway-component .hero.is-warning .subtitle,.runway .hero.is-warning .subtitle{color:rgba(0,0,0,.9)}.runway-component .hero.is-warning .subtitle a:not(.button),.runway-component .hero.is-warning .subtitle strong,.runway .hero.is-warning .subtitle a:not(.button),.runway .hero.is-warning .subtitle strong{color:rgba(0,0,0,.7)}@media screen and (max-width:1023px){.runway-component .hero.is-warning .navbar-menu,.runway .hero.is-warning .navbar-menu{background-color:#ffdd57}}.runway-component .hero.is-warning .navbar-item,.runway-component .hero.is-warning .navbar-link,.runway .hero.is-warning .navbar-item,.runway .hero.is-warning .navbar-link{color:rgba(0,0,0,.7)}.runway-component .hero.is-warning .navbar-link.is-active,.runway-component .hero.is-warning .navbar-link:hover,.runway-component .hero.is-warning a.navbar-item.is-active,.runway-component .hero.is-warning a.navbar-item:hover,.runway .hero.is-warning .navbar-link.is-active,.runway .hero.is-warning .navbar-link:hover,.runway .hero.is-warning a.navbar-item.is-active,.runway .hero.is-warning a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.runway-component .hero.is-warning .tabs a,.runway .hero.is-warning .tabs a{color:rgba(0,0,0,.7);opacity:.9}.runway-component .hero.is-warning .tabs a:hover,.runway-component .hero.is-warning .tabs li.is-active a,.runway .hero.is-warning .tabs a:hover,.runway .hero.is-warning .tabs li.is-active a{opacity:1}.runway-component .hero.is-warning .tabs.is-boxed a,.runway-component .hero.is-warning .tabs.is-toggle a,.runway .hero.is-warning .tabs.is-boxed a,.runway .hero.is-warning .tabs.is-toggle a{color:rgba(0,0,0,.7)}.runway-component .hero.is-warning .tabs.is-boxed a:hover,.runway-component .hero.is-warning .tabs.is-toggle a:hover,.runway .hero.is-warning .tabs.is-boxed a:hover,.runway .hero.is-warning .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.runway-component .hero.is-warning .tabs.is-boxed li.is-active a,.runway-component .hero.is-warning .tabs.is-boxed li.is-active a:hover,.runway-component .hero.is-warning .tabs.is-toggle li.is-active a,.runway-component .hero.is-warning .tabs.is-toggle li.is-active a:hover,.runway .hero.is-warning .tabs.is-boxed li.is-active a,.runway .hero.is-warning .tabs.is-boxed li.is-active a:hover,.runway .hero.is-warning .tabs.is-toggle li.is-active a,.runway .hero.is-warning .tabs.is-toggle li.is-active a:hover{background-color:rgba(0,0,0,.7);border-color:rgba(0,0,0,.7);color:#ffdd57}.runway-component .hero.is-warning.is-bold,.runway .hero.is-warning.is-bold{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}@media screen and (max-width:768px){.runway-component .hero.is-warning.is-bold .navbar-menu,.runway .hero.is-warning.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}}.runway-component .hero.is-danger,.runway .hero.is-danger{background-color:#f14668;color:#fff}.runway-component .hero.is-danger a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway-component .hero.is-danger strong,.runway .hero.is-danger a:not(.button):not(.dropdown-item):not(.tag):not(.pagination-link.is-current),.runway .hero.is-danger strong{color:inherit}.runway-component .hero.is-danger .title,.runway .hero.is-danger .title{color:#fff}.runway-component .hero.is-danger .subtitle,.runway .hero.is-danger .subtitle{color:hsla(0,0%,100%,.9)}.runway-component .hero.is-danger .subtitle a:not(.button),.runway-component .hero.is-danger .subtitle strong,.runway .hero.is-danger .subtitle a:not(.button),.runway .hero.is-danger .subtitle strong{color:#fff}@media screen and (max-width:1023px){.runway-component .hero.is-danger .navbar-menu,.runway .hero.is-danger .navbar-menu{background-color:#f14668}}.runway-component .hero.is-danger .navbar-item,.runway-component .hero.is-danger .navbar-link,.runway .hero.is-danger .navbar-item,.runway .hero.is-danger .navbar-link{color:hsla(0,0%,100%,.7)}.runway-component .hero.is-danger .navbar-link.is-active,.runway-component .hero.is-danger .navbar-link:hover,.runway-component .hero.is-danger a.navbar-item.is-active,.runway-component .hero.is-danger a.navbar-item:hover,.runway .hero.is-danger .navbar-link.is-active,.runway .hero.is-danger .navbar-link:hover,.runway .hero.is-danger a.navbar-item.is-active,.runway .hero.is-danger a.navbar-item:hover{background-color:#ef2e55;color:#fff}.runway-component .hero.is-danger .tabs a,.runway .hero.is-danger .tabs a{color:#fff;opacity:.9}.runway-component .hero.is-danger .tabs a:hover,.runway-component .hero.is-danger .tabs li.is-active a,.runway .hero.is-danger .tabs a:hover,.runway .hero.is-danger .tabs li.is-active a{opacity:1}.runway-component .hero.is-danger .tabs.is-boxed a,.runway-component .hero.is-danger .tabs.is-toggle a,.runway .hero.is-danger .tabs.is-boxed a,.runway .hero.is-danger .tabs.is-toggle a{color:#fff}.runway-component .hero.is-danger .tabs.is-boxed a:hover,.runway-component .hero.is-danger .tabs.is-toggle a:hover,.runway .hero.is-danger .tabs.is-boxed a:hover,.runway .hero.is-danger .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.runway-component .hero.is-danger .tabs.is-boxed li.is-active a,.runway-component .hero.is-danger .tabs.is-boxed li.is-active a:hover,.runway-component .hero.is-danger .tabs.is-toggle li.is-active a,.runway-component .hero.is-danger .tabs.is-toggle li.is-active a:hover,.runway .hero.is-danger .tabs.is-boxed li.is-active a,.runway .hero.is-danger .tabs.is-boxed li.is-active a:hover,.runway .hero.is-danger .tabs.is-toggle li.is-active a,.runway .hero.is-danger .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#f14668}.runway-component .hero.is-danger.is-bold,.runway .hero.is-danger.is-bold{background-image:linear-gradient(141deg,#fa0a62,#f14668 71%,#f7595f)}@media screen and (max-width:768px){.runway-component .hero.is-danger.is-bold .navbar-menu,.runway .hero.is-danger.is-bold .navbar-menu{background-image:linear-gradient(141deg,#fa0a62,#f14668 71%,#f7595f)}}.runway-component .hero.is-small .hero-body,.runway .hero.is-small .hero-body{padding:1.5rem}@media print,screen and (min-width:769px){.runway-component .hero.is-medium .hero-body,.runway .hero.is-medium .hero-body{padding:9rem 1.5rem}}@media print,screen and (min-width:769px){.runway-component .hero.is-large .hero-body,.runway .hero.is-large .hero-body{padding:18rem 1.5rem}}.runway-component .hero.is-fullheight-with-navbar .hero-body,.runway-component .hero.is-fullheight .hero-body,.runway-component .hero.is-halfheight .hero-body,.runway .hero.is-fullheight-with-navbar .hero-body,.runway .hero.is-fullheight .hero-body,.runway .hero.is-halfheight .hero-body{align-items:center;display:flex}.runway-component .hero.is-fullheight-with-navbar .hero-body>.container,.runway-component .hero.is-fullheight .hero-body>.container,.runway-component .hero.is-halfheight .hero-body>.container,.runway .hero.is-fullheight-with-navbar .hero-body>.container,.runway .hero.is-fullheight .hero-body>.container,.runway .hero.is-halfheight .hero-body>.container{flex-grow:1;flex-shrink:1}.runway-component .hero.is-halfheight,.runway .hero.is-halfheight{min-height:50vh}.runway-component .hero.is-fullheight,.runway .hero.is-fullheight{min-height:100vh}.runway-component .hero-video,.runway .hero-video{overflow:hidden}.runway-component .hero-video video,.runway .hero-video video{left:50%;min-height:100%;min-width:100%;position:absolute;top:50%;transform:translate3d(-50%,-50%,0)}.runway-component .hero-video.is-transparent,.runway .hero-video.is-transparent{opacity:.3}@media screen and (max-width:768px){.runway-component .hero-video,.runway .hero-video{display:none}}.runway-component .hero-buttons,.runway .hero-buttons{margin-top:1.5rem}@media screen and (max-width:768px){.runway-component .hero-buttons .button,.runway .hero-buttons .button{display:flex}.runway-component .hero-buttons .button:not(:last-child),.runway .hero-buttons .button:not(:last-child){margin-bottom:.75rem}}@media print,screen and (min-width:769px){.runway-component .hero-buttons,.runway .hero-buttons{display:flex;justify-content:center}.runway-component .hero-buttons .button:not(:last-child),.runway .hero-buttons .button:not(:last-child){margin-right:1.5rem}}.runway-component .hero-foot,.runway-component .hero-head,.runway .hero-foot,.runway .hero-head{flex-grow:0;flex-shrink:0}.runway-component .hero-body,.runway .hero-body{flex-grow:1;flex-shrink:0;padding:3rem 1.5rem}.runway-component .section,.runway .section{padding:3rem 1.5rem}@media screen and (min-width:1024px){.runway-component .section.is-medium,.runway .section.is-medium{padding:9rem 1.5rem}.runway-component .section.is-large,.runway .section.is-large{padding:18rem 1.5rem}}.runway-component .footer,.runway .footer{background-color:#fafafa;padding:3rem 1.5rem 6rem}@font-face{font-family:verlag-book;font-weight:400;src:url(" + escape(__webpack_require__(309)) + ")}@font-face{font-family:verlag;font-weight:500;src:url(" + escape(__webpack_require__(310)) + ")}@font-face{font-family:verlag-black;src:url(" + escape(__webpack_require__(311)) + ")}@font-face{font-family:didot;src:url(" + escape(__webpack_require__(312)) + ");font-weight:400;font-style:normal}@font-face{font-family:didot;src:url(" + escape(__webpack_require__(313)) + ");font-weight:700;font-style:normal}body,html{margin:0}#runway-app{min-height:200px}.runway{font-family:verlag-book,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif}.runway .layout{display:flex;width:100%;height:100%}.runway .layout .layout-item{height:100%}.runway .layout .layout-item.grow{flex-grow:1}.runway table.table,.runway table.table.is-marginless th{background:none}.runway table.table.is-marginless td{background:none;border:none;padding:2px;margin:0}.runway .uk-slideshow{position:relative}.runway .info-modal{text-align:center}.runway .info-modal .modal-content{position:relative}.runway .info-modal .modal-content p{margin-bottom:10px}.runway .info-modal .modal-content .modal-close{position:absolute;right:10px;top:10px}.runway .info-modal .modal-content .modal-close:after,.runway .info-modal .modal-content .modal-close:before{background-color:#333}.runway .info-modal .modal-title{font-size:22px;font-family:Didot}.runway .loading-modal .modal-background{background-color:hsla(0,0%,4%,.5);backdrop-filter:saturate(180%) blur(20px)}.runway .loading-modal.modal{z-index:99}.runway .loading-modal .sp{width:32px;height:32px;clear:both;margin:20px auto}.runway .loading-modal .sp-circle{border:4px solid rgba(0,0,0,.25);border-top:4px solid #000;border-radius:50%;-webkit-animation:spCircRot .6s infinite linear;animation:spCircRot .6s infinite linear}.runway .general-spinner .sp{width:32px;height:32px;clear:both;margin:20px auto}.runway .general-spinner .sp-circle{border:4px solid rgba(0,0,0,.25);border-top:4px solid #000;border-radius:50%;-webkit-animation:spCircRot .6s infinite linear;animation:spCircRot .6s infinite linear}@-webkit-keyframes spCircRot{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes spCircRot{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.runway .is-hoverable{cursor:pointer}.runway .is-opacity-0{opacity:0}.runway tr.is-hoverable:hover td{background:hsla(0,0%,4%,.1)!important}.runway tr.is-hoverable:hover td:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px}.runway tr.is-hoverable:hover td:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px}.runway .box{border-radius:2px}.runway .selector{display:flex;padding:30px;align-items:center;text-align:center;justify-content:space-around;max-width:900px;margin:0 auto 200px}.runway .selector img{padding:20px;transition:transform .2s ease-in-out}.runway .selector img:hover{transition:transform .2s ease-in-out;transform:scale(1.01);filter:drop-shadow(2px 4px 6px black)}.runway .is-flex-center{justify-content:center;align-items:center}.runway .title-section{margin-top:10px;text-align:center}.runway .title-section h3{font-family:Didot;font-size:34px;color:#406750}.runway .title-section p{font-family:verlag-book;font-size:24px;text-align:center;max-width:75ch;margin:20px auto;font-weight:300}.runway .modal.is-full{top:0;justify-content:flex-start}.runway .modal.is-full .modal-content{top:0;height:100vh;width:100%;background:#fff;max-height:100vh}.runway .modal.is-full .modal-content .box{overflow:scroll}.runway .amenities,.runway .amenities .amenity{display:flex;align-items:center}.runway .amenities .amenity{margin-right:10px}.runway .amenities .amenity:last-of-type{margin-right:0}.runway .amenities .amenity img{margin-right:5px}.runway .amenities .amenity span{font-size:13px;font-weight:500;line-height:normal}@keyframes pulse{0%{transform:scale(0);opacity:0}33%{transform:scale(1);opacity:1}to{transform:scale(3);opacity:0}}.runway .pulse{position:relative}.runway .pulse:after,.runway .pulse:before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;background:hsla(96,18%,78%,.2);border-radius:50%;width:60px;height:60px;opacity:0;margin:auto}.runway .pulse:before{animation:pulse 1.5s infinite linear}.runway .pulse:after{animation:pulse 2s .4s infinite linear}.runway .pulse:hover:after,.runway .pulse:hover:before{display:none}.runway .is-clipped{overflow:hidden}.runway .border-bar{background:url(" + escape(__webpack_require__(314)) + ");background-size:cover;background-position:100%;display:flex;height:50px}.runway .border-bar .left-item{flex-grow:1;display:flex;align-items:center}.runway .border-bar .title{color:#fff;font-size:18px;margin-left:15px;font-family:didot;font-weight:300}.runway .border-bar .right-item{display:flex;align-items:center}.runway .border-bar .button{text-transform:uppercase;padding:15px 21px;height:50px;max-width:200px}.runway .border-bar .buttons{margin-bottom:0}.runway .border-bar .buttons .button{margin-bottom:0;border:none;color:#fff;background:#c6d2be}.runway .border-bar .buttons .button.is-active{background:#406750}.elementor-lightbox .elementor-lightbox-image,.elementor-lightbox .elementor-video-container{background:#fff}.uk-tooltip{background:#c6d2be;padding:15px;color:#333;font-family:verlag-book;font-size:16px;text-align:center}.lightbox .lb-image{object-fit:contain;background:#fff}#swal2-title,.swal2-content{font-family:verlag-book}.selector-container{display:flex;flex-direction:column;align-items:center;justify-content:center}.selector-container .journey-selector-tile{background-color:#fefefe;border:2px solid #526a5c;padding:3px;margin:5px}.selector-container .journey-selector-tile .journey-selector-inner{background-color:#dee7d6;border:5px solid #526a5c;padding:15px 35px}.selector-container .journey-selector-tile .journey-selector-inner .selector-title{color:#000;font-family:Didot;font-size:27px;font-weight:900;width:250px}.selector-container .journey-selector-tile :hover{background-color:#ce6149;border-color:#ce6149}.selector-container .journey-selector-tile :hover .selector-title{color:#fff}.selector-container :hover{border-color:#ce6149}.selector-container .selector-tooltip{display:flex;align-items:center;justify-content:center;background-color:#dee7d6;color:#000;margin-top:2rem;padding:7px;position:absolute;top:20rem;width:210px;height:120px}.selector-container .selector-tooltip p{font-size:16px;line-height:1.6}.runway .button{border-radius:1px;font-size:14px;font-weight:500;font-family:verlag-book,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif;align-items:center;justify-content:center}.runway .button i{margin-right:10px}.runway .button.app-primary{background:#406750;border-color:#406750;color:#fff}.runway .button.app-primary:hover{color:#406750;background:hsla(96,18%,78%,.9);border-color:transparent}.runway .button.app-enquiry{background:#eebe64}.runway .button.app-highlight{background:#d3624f;border-color:#d3624f;color:#fff}.runway .button.app-highlight:hover{color:#d3624f;background:rgba(211,98,79,.5);border-color:rgba(211,98,79,.5)}.runway .button.app-accent{background:#c6d2be;border-color:#c6d2be;color:#222}.runway .button.app-accent:hover{color:#c6d2be;background:rgba(64,103,80,.9);border-color:transparent}.runway .field .input{border-color:#6c6c6c}.runway .field .input::placeholder{color:#6c6c6c;text-transform:capitalize}.runway .field .input.is-disabled{background:none}.runway .field .icon i{color:#406750}.runway .side-panel{width:100px;background:#406750;height:100vh;padding:15px 0 15px 15px}.runway .side-panel .menu-items,.runway .side-panel .menu-items .menu-item{display:flex;align-items:center;justify-content:center;flex-direction:column}.runway .side-panel .menu-items .menu-item{font-family:Gotham Book;color:#c6d2be;font-size:11px;text-transform:uppercase;text-align:center;padding:15px 30px 15px 15px;cursor:pointer;width:100%;height:auto;text-decoration:none}.runway .side-panel .menu-items .menu-item.is-active{background:#c6d2be;color:#fff;border-radius:10px 0 0 10px}.runway .side-panel .menu-items .menu-item img{width:30px;margin-bottom:10px;height:auto;margin:auto;margin-bottom:5px}.runway .panel-body .table .is-active td{background:hsla(96,18%,78%,.4)}.runway .panel-body .table .is-active td:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px}.runway .panel-body .table .is-active td:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px}.runway .extended-panel{padding:15px;background:#c6d2be;min-height:100vh;height:100%;width:350px;height:100vh;position:relative}.runway .extended-panel .panel-header-section{display:flex;align-items:flex-end}.runway .extended-panel .panel-header-section .left-item{flex-grow:1}.runway .extended-panel .filter-reset{background:#333;border-radius:50%;height:24px;width:24px;display:flex;align-items:center;justify-content:center;color:#fff}.runway .extended-panel .panel-title{padding:15px 0 20px;font-size:24px;font-family:Didot;font-weight:400;line-height:normal;color:#365744}.runway .extended-panel .panel-subtitle{font-size:14px;line-height:normal}.runway .extended-panel .panel-body{background:#fff;padding:10px;margin-top:10px}.runway .extended-panel .panel-body .panel-body-title{font-size:16px;font-weight:500;margin-bottom:10px}.runway .extended-panel .panel-body .scrollable{height:100%;max-height:calc(100vh - 470px);overflow-y:auto}.runway .extended-panel .panel-body .scrollable .table{position:relative}.runway .extended-panel .panel-body .scrollable .table td{text-align:center;font-feature-settings:\"pnum\" on,\"lnum\" on}.runway .right-panel{height:100vh;height:100%;overflow-y:scroll;padding:15px;width:350px;position:absolute;right:0;z-index:4;top:0;background:#fff}.runway #map,.runway .map{height:100vh;width:100%;position:relative}.runway .lot-select-popup{background:#fff;padding:20px 10px;text-align:center;box-shadow:0 .5em 1em -.125em hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.02)}.runway .lot-select-popup:after{position:absolute;content:\" \";width:0;height:0;border-left:20px solid transparent;border-right:20px solid transparent;border-top:20px solid #fff;bottom:-19px;left:0;right:0;margin:auto}.runway .lot-select-popup .pop-title{font-size:28px;border-bottom:1px solid #ddd;font-family:Didot;text-transform:uppercase;padding-bottom:20px;margin-bottom:10px;color:#406750}.runway .lot-select-popup .pop-dim{display:flex}.runway .lot-select-popup .pop-dim div{padding:7px}.runway .lot-select-popup .pop-dim div p{font-size:14px;text-transform:uppercase}.runway .lot-select-popup .pop-dim div p:first-of-type{color:#406750}.runway .lot-select-popup img{margin-top:10px;height:40px;width:auto;text-align:center}.runway .custom-control{position:absolute;right:0;top:0;margin:10px;top:100px;z-index:9;background:#fff;padding:8px;border-radius:4px;height:30px;width:30px;box-shadow:0 0 0 2px rgba(0,0,0,.1);display:flex;align-items:center;justify-content:center;cursor:pointer}.runway .custom-control:hover{background-color:#aaa}.runway .custom-control a{line-height:0;font-size:14px;color:#333}.runway .packages #map,.runway .townhomes #map{width:calc(100% - 350px)}.runway .mobile-label-header,.runway .mobile-panel-header{display:none}.runway #amenity-map .map-labels .label-item.available span,.runway #map .map-labels .label-item.available span,.runway .map .map-labels .label-item.available span{background:#f0cd89}.runway #amenity-map .map-labels .label-item.hold span,.runway #map .map-labels .label-item.hold span,.runway .map .map-labels .label-item.hold span{background:#86abb5}.runway #amenity-map .map-labels .label-item.sold span,.runway #map .map-labels .label-item.sold span,.runway .map .map-labels .label-item.sold span{background:#c3958e}.runway #amenity-map .map-labels .label-item.spec span,.runway #map .map-labels .label-item.spec span,.runway .map .map-labels .label-item.spec span{background:#688e9f}.runway #amenity-map .map-labels .label-item.model span,.runway #map .map-labels .label-item.model span,.runway .map .map-labels .label-item.model span{background:#a57183}.runway #amenity-map .map-labels .label-item.future-release span,.runway #map .map-labels .label-item.future-release span,.runway .map .map-labels .label-item.future-release span{background:#fff7eb}.runway #amenity-map .map-labels .label-item.lotsize-45 span,.runway #map .map-labels .label-item.lotsize-45 span,.runway .map .map-labels .label-item.lotsize-45 span{background:#eebe64}.runway #amenity-map .map-labels .label-item.lotsize-50 span,.runway #map .map-labels .label-item.lotsize-50 span,.runway .map .map-labels .label-item.lotsize-50 span{background:#add5ee}.runway #amenity-map .map-labels .label-item.lotsize-60 span,.runway #map .map-labels .label-item.lotsize-60 span,.runway .map .map-labels .label-item.lotsize-60 span{background:#ffab97}.runway #amenity-map .map-labels .label-item.lotsize-70 span,.runway #map .map-labels .label-item.lotsize-70 span,.runway .map .map-labels .label-item.lotsize-70 span{background:#e6ceba}.runway #amenity-map .desktop-label,.runway #map .desktop-label,.runway .map .desktop-label{position:absolute;left:0;top:0;display:flex;align-items:flex-start;justify-content:center;flex-direction:column;background:#fff;margin:10px;z-index:11;padding:10px;box-shadow:0 0 0 2px rgba(0,0,0,.1);border-radius:6px}.runway #amenity-map .desktop-label .label-item,.runway #map .desktop-label .label-item,.runway .map .desktop-label .label-item{display:flex;align-items:center;justify-content:center;margin-right:20px}.runway #amenity-map .desktop-label .label-item span,.runway #map .desktop-label .label-item span,.runway .map .desktop-label .label-item span{height:12px;width:12px;margin-right:10px;border-radius:50%;background:#fff}@media only screen and (max-width:1024px){.runway #map{width:100%;height:calc(100vh - 80px - 32px);height:calc((var(--vh, 1vh) * 100) - 80px - 32px)}.runway .land #map,.runway .packages #map,.runway .townhomes #map{width:100%;height:calc(50vh - 32px);height:calc((var(--vh, 1vh) * 50) - 32px)}.runway .right-panel{top:unset;left:0;bottom:0;height:calc(50vh - 80px);height:calc((var(--vh, 1vh) * 50) - 80px);width:100%;display:flex;flex-direction:column;align-content:center;justify-content:flex-start;z-index:20;padding:15px;background:#f2f2f2;position:absolute}.runway .right-panel .mobile-panel-header{display:flex;align-items:center;justify-content:center;padding:10px}.runway .right-panel .mobile-panel-header .left-item{font-size:14px;flex-grow:1}.runway .right-panel .package-cards{width:100%;min-width:300px;padding:10px;margin-top:10px;margin-left:auto;margin-right:auto}.runway .mobile-label-header{position:absolute;top:0;display:flex;align-items:center;justify-content:center;background:#fff;width:100%;padding:4px 0;z-index:11}.runway .mobile-label-header .label-item{display:flex;align-items:center;justify-content:center;margin-right:20px}.runway .mobile-label-header .label-item span{height:12px;width:12px;margin-right:10px;border-radius:50%;background:#fff}.runway .mobile-lot-list{padding:10px;background:#fff}.runway .mobile-lot-list .table thead tr td{font-size:12px;font-weight:500;border-bottom:1px solid #c6d2be}.runway .mobile-lot-list .table tr td{text-align:center}.runway .mobile-bottom-panel{background:#f2f2f2;z-index:20;position:absolute;left:0;bottom:0;height:calc(50vh - 80px);height:calc((var(--vh, 1vh) * 50) - 80px);width:100%;display:flex;flex-direction:column;align-content:center;justify-content:flex-start;padding:15px}.runway .mobile-bottom-panel .mobile-panel-header{display:flex;align-items:center;justify-content:center}.runway .mobile-bottom-panel .mobile-panel-header .left-item{font-size:14px;flex-grow:1}.runway .mobile-bottom-panel .scrollable{width:100%;height:auto;overflow-y:auto}.runway .mobile-bottom-panel .list-container{padding:10px;background:#fff;margin-top:10px;height:100%}.runway .mobile-bottom-panel .list-container .table thead tr td{font-size:12px;font-weight:500;border-bottom:1px solid #c6d2be}.runway .mobile-bottom-panel .list-container .table tr td{text-align:center}}.runway .filter-section .label{font-size:14px;text-transform:uppercase;margin-bottom:0;margin-bottom:5px}.runway .filter-section .filter-item{margin-bottom:20px}.runway .filter-section .filter-buttons .button{font-size:10px;font-weight:500}.runway .filter-section .filter-buttons .button.is-active{background:#c6d2be;border-color:#c6d2be}.runway .filter-section .builder-width{max-width:100%}.runway .irs.irs--flat .irs-from{cursor:pointer;background:#fff;border-radius:99999px;font-size:12px;color:#333;border:1px solid #333;z-index:9}.runway .irs.irs--flat .irs-from:before{display:none}.runway .irs.irs--flat .irs-to{cursor:pointer;background:#fff;border-radius:99999px;font-size:12px;color:#333;border:1px solid #333;z-index:9}.runway .irs.irs--flat .irs-to:before{display:none}.runway .irs.irs--flat .irs-single{cursor:pointer;background:#fff;border-radius:99999px;font-size:12px;color:#333;border:1px solid #333;z-index:9}.runway .irs.irs--flat .irs-single:before{display:none}.runway .irs.irs--flat .irs-line{top:4px}.runway .irs.irs--flat .irs-max,.runway .irs.irs--flat .irs-min{display:none}.runway .irs.irs--flat .irs-bar{top:4px;z-index:7;background:#c6d2be}.runway .filter-collapse,.runway .irs.irs--flat .irs-handle,.runway .mobile-filter{display:none}@media only screen and (max-width:1024px){.runway .lot-panel{position:relative}.runway .lot-panel .delete{position:absolute;top:5px;right:5px}.runway .filter-collapse{display:flex;align-items:center;justify-content:center;height:34px;width:34px;position:absolute;background:#406750;border-radius:50%;padding:5px;top:0;left:0;z-index:9;margin:5px}.runway .filter-collapse i{color:#fff;font-size:18px}.runway .filter-section .filter-collapse{position:relative}.runway .filter-section .delete{position:absolute;top:5px;right:5px}.runway .filter-section .filters{display:none}.runway .filter-section .filters.is-active{display:block}.runway .lot-filter-panel{display:none}.runway .lot-filter-panel.is-active{display:block}}.lot-panel .extended-panel .panel-body .table thead tr th{font-size:14px;text-align:center}.lot-panel .extended-panel .panel-body .table .spacer td{font-size:5px}.lot-panel .extended-panel .panel-body .table .is-active td{background:hsla(96,18%,78%,.4)}.lot-panel .extended-panel .panel-body .table .is-active td:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px}.lot-panel .extended-panel .panel-body .table .is-active td:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px}.runway #leaflet-map{height:500px;width:100%;z-index:3}.runway .layout .layout-item.package-panel{height:100vh;overflow:scroll;width:300px}.runway .package-cards{height:100%}.runway .uk-slideshow,.runway .uk-slideshow .uk-slideshow-items{outline:none;transition:height .5s}.runway .is-active .home-card{border:5px solid #f6b468}.runway .uk-slider-items{display:flex;align-items:center;justify-content:center}.runway .uk-slider-items .home-card{width:350px}.runway .home-card{margin-bottom:10px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.runway .home-card .facade-image{position:relative}.runway .home-card .facade-image img{object-fit:cover}.runway .home-card .facade-image .marker-overlay{position:absolute;right:5px;top:5px;height:30px;width:30px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:#406750}.runway .home-card .facade-image .marker-overlay a i{color:#fff}.runway .home-card .card-info{padding:10px}.runway .home-card .card-info .columns{margin-bottom:10px}.runway .home-card .card-info .design{line-height:normal}.runway .home-card .card-info .design .design{font-family:Didot;font-size:20px;color:#406750}.runway .home-card .card-info .design .facade{font-size:13px}.runway .home-card .card-info .price{margin:3px 0;text-align:right}.runway .home-card .card-info .price .f{font-size:11px;text-transform:uppercase;text-align:right}.runway .home-card .card-info .price .p{font-size:30px;color:#406750;font-weight:500;text-align:right}.runway .home-card .card-info .dimension{margin-bottom:10px;line-height:normal}.runway .home-card .card-info .dimension:last-of-type{margin-bottom:0}.runway .home-card .card-info .dimension .t{font-size:11px;color:#406750;font-weight:500;text-transform:uppercase}.runway .home-card .card-info .dimension .d{font-size:22px;font-weight:500}.runway .home-card .card-info .dimension .d small{font-size:12px}.runway .home-select-popup{background:#fff;max-width:320px;position:absolute;top:15px}.runway .home-select-popup .facade-image img{object-fit:cover}.runway .home-select-popup .modal-close{right:5px;top:5px;background:rgba(51,51,51,.7)}.runway .home-select-popup:after{position:absolute;content:\" \";width:0;height:0;border-left:20px solid transparent;border-right:20px solid transparent;border-top:20px solid #fff;bottom:-19px;left:0;right:0;margin:auto}.runway .home-select-popup .card-info{padding:10px 10px 15px;text-align:center}.runway .home-select-popup .card-info .columns{margin-bottom:10px;text-align:left}.runway .home-select-popup .card-info .design{line-height:normal}.runway .home-select-popup .card-info .design .design{font-family:Didot;font-size:22px;color:#406750}.runway .home-select-popup .card-info .design .facade{font-size:13px}.runway .home-select-popup .card-info .price{margin:20px 0;text-align:right}.runway .home-select-popup .card-info .price .f{font-size:14px;text-transform:uppercase;text-align:right}.runway .home-select-popup .card-info .price .p{font-size:30px;color:#406750;font-weight:500;text-align:right}.runway .home-select-popup .card-info .dimensions{display:flex;flex-wrap:wrap}.runway .home-select-popup .card-info .dimension{margin-bottom:10px;line-height:normal;width:33%;padding-right:10px}.runway .home-select-popup .card-info .dimension:last-of-type{margin-bottom:0}.runway .home-select-popup .card-info .dimension .t{font-size:11px;color:#406750;text-transform:uppercase}.runway .home-select-popup .card-info .dimension .d{font-size:14px;line-height:20px}.runway .home-select-popup .card-info .dimension .d small{font-size:12px}.runway .home-select-popup .explore{font-size:15px;text-align:center;color:#406750;letter-spacing:2px}.runway .home-select-popup .explore-btns{display:flex;justify-content:space-around}.runway .home-select-popup .explore-btns .explore{padding-bottom:0;border:none}.runway .section-header{display:flex}.runway .section-header .left-item{flex-grow:1}.runway .section-header .right-item a{color:#333;margin:0 10px}.runway .section-header .right-item a.is-inactive{color:#ddd;cursor:default}.runway .facade-popup{background:#fff;box-shadow:1px 3px 10px 3px #333}.runway .facade-popup img{display:block}.runway .facade-popup:after{position:absolute;content:\" \";width:0;height:0;border-left:14px solid transparent;border-right:14px solid transparent;border-top:12px solid #fff;bottom:-12px;left:0;right:0;margin:auto}.runway #amenity-map{height:100vh;width:100%}.runway .marker{display:flex;border-radius:999999px;align-items:center;justify-content:flex-start;transition:max-width .4s;max-width:32px;width:32px;text-overflow:ellipsis;white-space:nowrap}.runway .marker i{padding:5px;color:#4a84c2}.runway .marker img{padding:2px}.runway .marker p{display:none;padding:0 10px}.runway .marker.marker-is-active{max-width:300px;width:auto;background:#fff;box-shadow:0 0 9px 5px rgba(0,0,0,.2)}.runway .marker.marker-is-active p{display:flex}.runway .marker.marker-is-active:after{position:absolute;content:\" \";width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-top:10px solid #fff;bottom:-6px;left:0;right:0;margin:auto}.runway .marker#marker-is-active{transition:max-width .3s ease-in-out;max-width:300px;width:auto;z-index:99;background:#d2f1de;box-shadow:0 0 9px 5px rgba(0,0,0,.2)}.runway .marker#marker-is-active p{display:flex}.runway .marker#marker-is-active:after{position:absolute;content:\" \";width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-top:10px solid #d2f1de;bottom:-6px;left:0;right:0;margin:auto}.runway .marker:hover{transition:max-width .3s ease-in-out;max-width:300px;width:auto;z-index:99;background:#fff}.runway .marker:hover p{display:flex}.runway .mapboxgl-marker{cursor:pointer}.runway .place-info{position:relative;padding:15px;width:350px;background:#fff}.runway .place-info.layout-item{height:100vh;overflow-y:scroll}.runway .place-info .modal-close{top:0;right:0;margin:10px;position:absolute}.runway .place-info .modal-close:after,.runway .place-info .modal-close:before{background:#333}.runway .place-info .places-info-title{font-size:24px;margin-top:20px;line-height:normal}.runway .place-info .places-info-subtitle{font-size:16px;line-height:normal;margin-bottom:10px}.runway .place-info .gallery{margin-top:20px;margin-bottom:20px}.runway .place-info .gallery .columns{margin:0;padding:0}.runway .place-info .gallery .columns .column{margin-bottom:0;margin-top:0;padding-bottom:10px;padding-top:0}.runway .place-info .columns img{height:100%;width:100%;object-fit:cover}.runway .place-info .places-info-description{font-size:16px;font-weight:300}.runway .place-info a{color:#333;text-decoration:underline;margin:10px 0;font-size:12px}.runway .place-info .direction-buttons .buttons{margin:0}.runway .place-info .direction-buttons .button{background:#ddd}.runway .place-info .direction-buttons .button.is-active{background:#406750}.runway .place-info .route-summary{display:flex}.runway .place-info .route-summary .left-item{flex-grow:1}.runway .place-info .route-summary .left-item p{font-size:14px;font-weight:500}.runway .place-info .route-summary .right-item{width:60px}.runway .place-info .route-summary .right-item p{font-size:14px;color:#7a7a7a}.runway .place-info .route-summary .right-item p:first-of-type{font-size:14px;font-weight:500;color:#44965c}.runway .place-info hr{margin:.5rem 0}.runway .place-info .steps{margin-top:10px}.runway .place-info .steps table td{padding:2px;vertical-align:middle}.runway .place-info .steps table td:first-of-type{padding:0}.runway .place-info .steps table td.instruction{font-size:16px}.runway .place-info .steps table td img{width:100%}.runway .places-buttons{display:flex;justify-content:space-evenly;align-items:center}.runway .places-buttons img{height:30px}.runway .places-buttons a.is-active img{border:3px solid #fff;border-radius:50%;height:35px;width:35px}.runway .direction-buttons{display:flex;justify-content:space-between}.runway .direction-buttons .buttons{margin-top:10px;margin-bottom:10px;width:100%;display:flex}.runway .direction-buttons .buttons .button{flex-grow:1;border-color:transparent}.runway .direction-buttons .buttons .button.is-active{background:#406750}.runway .direction-buttons .buttons .button:first-of-type{border-top-left-radius:9999px;border-bottom-left-radius:9999px}.runway .direction-buttons .buttons .button:last-of-type{border-top-right-radius:9999px;border-bottom-right-radius:9999px}.runway .direction-buttons .buttons .button img{height:15px;object-fit:contain}.runway .places-search{background:#fff;padding:15px}.runway .places-search .flex-item{display:flex}.runway .places-search .flex-item .left-item{flex-grow:1;display:flex;flex-direction:column}.runway .places-search .flex-item .left-item .field{margin-bottom:.75rem}.runway .places-search .flex-item .left-item .label{font-weight:300;font-size:12px;margin-left:10px}.runway .places-search .flex-item.is-reverse .left-item{flex-flow:column-reverse}.runway .places-search .swap-item{padding:0 5px}.runway .places-search .prediction-box{max-height:400px;overflow-y:scroll;font-size:15px;color:#333;padding:10px;border-bottom-left-radius:12px;border-bottom-right-radius:12px}.runway .places-search .prediction-box i{color:#ddd}.runway .places-search .prediction-box tr{cursor:pointer}.runway .places-search .prediction-box tr td{border:none}.runway .places-search .prediction-box tr:hover td{color:#c6d2be}.runway .places-search .travel-time{margin:15px auto;background:hsla(96,18%,78%,.5);padding:10px;display:flex;font-size:14px;align-items:center}.runway .places-search .travel-time a{color:#333}.runway .places-search .travel-time a:hover{color:#c6d2be}.runway .places-search .travel-time .left{flex-grow:1}.runway .places-search .travel-time .time{font-weight:500;font-size:14px;line-height:normal;margin-bottom:0}.runway .places-search .travel-time .distance{font-size:14px}.runway .steps{max-height:49vh;overflow-y:auto}.runway .steps table tr td{border:none;font-size:14px}.runway .steps table tr td img{width:auto;height:30px;object-fit:contain}.runway .steps .instruction{font-size:14px}.runway .amenity-map-container{position:relative}.runway .direction-popup{top:0;left:0;margin:10px;z-index:49;position:absolute;background:#406750;color:#f1f1f1;display:flex;justify-content:center;align-items:center;padding:20px 15px 10px;border-radius:8px}.runway .direction-popup .close-container{position:relative}.runway .direction-popup .modal-close{position:absolute;top:0;right:0;margin:5px}.runway .direction-popup img{height:30px}.runway .direction-popup .right-item{flex-grow:1;margin-left:10px}.runway .direction-popup .right-item p{font-size:14px;line-height:normal;margin:0}.runway .direction-popup .right-item .time{font-size:16px;font-weight:500}.runway .panel-body.places{max-height:700px;padding:8px}.runway .panel-body.places .table tr td{min-width:24px;padding:5px}.runway .panel-body.places .table tr td:first-of-type{padding-left:7px}.runway .panel-body.places .table tr td:last-of-type{padding-right:7px}.runway .panel-body.places .table tr td img{width:20px;height:auto}.runway .panel-body.places .table tr td p{line-height:normal;font-size:10px}.runway .panel-body.places .table tr td p.name{font-weight:500;font-size:12px}.runway .panel-body.places .table tr td p.time{font-weight:500;font-size:11px}.runway .panel-body.places .table tr.is-active td{background:hsla(96,18%,78%,.4)}.runway .panel-body.places .table tr.is-active td:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px}.runway .panel-body.places .table tr.is-active td:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px}.runway .responsive-panel{display:none}.runway .active-venue .marker{display:none;opacity:0}.runway .active-venue .marker#marker-is-active{display:flex;opacity:1}@media only screen and (max-width:1024px){.runway #amenity-map{height:450px}.runway .marker#marker-is-active p{display:none}.runway .marker#marker-is-active:after,.runway .marker#marker-is-active:before{content:none}.runway .layout{height:auto;display:block;overflow-x:hidden}.runway .responsive-panel .place-info-container{height:100%;overflow-y:scroll;padding-bottom:50px}.runway .responsive-panel .place-info{position:relative;height:100%}.runway .responsive-panel .place-info .places-info-title{font-size:20px;max-width:80%;margin-top:0}.runway .responsive-panel .modal-close{top:0;right:0;margin:10px;position:absolute}.runway .responsive-panel{user-select:none;touch-action:none;position:absolute;width:100%;padding:17px 15px;z-index:49;background:#c6d2be;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;height:350px;bottom:-290px;transform:translateY(0)}.runway .responsive-panel.is-active{transition:transform .4s}.runway .responsive-panel .slider-container{position:relative;display:flex;align-items:center;justify-content:center;width:100%;touch-action:none;pointer-events:none}.runway .responsive-panel .slider-container .slide-indicator{pointer-events:none;touch-action:none;top:0;position:absolute;background:rgba(64,103,80,.9);width:65px;height:5px;border-radius:9999px;left:0;right:0;margin:-10px auto}.runway .responsive-panel .steps img{height:25px}.runway .responsive-panel .bottom-panel-body{width:100%;height:100%}.runway .responsive-panel .places-buttons{width:100%}.runway .responsive-panel .panel-body.places{max-height:180px}.runway .responsive-panel .panel-body{background:#fff;height:100%;padding:15px}.runway .responsive-panel .panel-body .panel-body-title{font-size:16px;font-weight:500;margin-bottom:10px}.runway .responsive-panel .panel-body .scrollable{max-height:130px;height:100%;overflow-y:scroll}.runway .responsive-panel .panel-body .scrollable .table{position:relative}.runway .responsive-panel .panel-body .scrollable .table.is-fixed{width:218px;margin-left:auto;margin-right:auto}.runway .responsive-panel .panel-body .scrollable .table.is-fixed thead tr{position:fixed}.runway .responsive-panel .panel-body .scrollable .table.is-fixed thead tr th{width:72.66667px;background:#fff;border-color:#c6d2be;font-size:9px;font-family:Gotham Book;padding:3px}.runway .responsive-panel .panel-body .scrollable .table.is-fixed td{width:33%;font-size:12px}}.runway .search-mobile{display:none}@media only screen and (max-width:1024px){.runway .search-mobile{display:flex;flex-direction:column;height:calc(100vh - 80px);top:80px;width:100%;position:absolute;z-index:51;background:#c6d2be;padding:20px;overflow:hidden}.runway .search-mobile .mobile-menu-title{font-size:24px;font-weight:500}.runway .responsive-panel.direction-panel,.runway .responsive-panel.direction-panel .direction-buttons{user-select:none;touch-action:none}.runway .responsive-panel.direction-panel .direction-buttons .buttons{margin-top:2px}.runway .responsive-panel .steps{max-height:130px;overflow-y:scroll}}.runway .places{height:calc(100% - 100px);overflow-y:scroll}.runway .places .categories-title{font-size:18px;font-family:verlag;font-weight:500;color:#365744;display:flex;align-items:center;margin-bottom:10px;padding-bottom:10px;border-bottom:1px solid rgba(64,103,80,.2);text-transform:uppercase}.runway .places .categories-title img{margin-right:10px;width:25px;height:auto}.runway .places .uk-accordion-content{padding-left:30px;padding-bottom:10px}.runway .places .uk-accordion-content a{display:block;color:#365744;font-family:verlag-black;margin-bottom:10px;text-transform:uppercase;font-size:12px}.runway .places .uk-accordion-content a.is-active{color:#d3624f}.runway .is-hidden-t,.runway .mobile-header,.runway .mobile-menu,.runway .mobile-router{display:none}@media only screen and (max-width:1024px){.runway .modal-content{height:100vh;max-height:100vh;width:100%}.runway .modal-content .box{background:none;box-shadow:none}.runway .modal-content .mobile-popup-header{display:flex}.runway .info-modal .modal-content{background:#f1f1f1}.runway #svg-map{height:280px}.runway .side-panel{display:none}.runway .place-info{position:relative;width:100%}.runway .place-info .modal-close{position:absolute}.runway .place-info .places-info-title{margin-top:0}.runway .places{height:calc(100% - 50px)}.runway .extended-panel{min-height:auto;width:100%;height:280px;overflow-y:scroll;overflow-x:hidden}.runway .extended-panel .panel-title{padding:5px}.runway .extended-panel ::-webkit-scrollbar{width:10px}.runway .extended-panel ::-webkit-scrollbar-track{background:#f1f1f1;border-radius:5px}.runway .extended-panel ::-webkit-scrollbar-thumb{background:#406750;border-radius:5px}.runway .extended-panel.travel-panel{height:350px}.runway .layout{height:auto;display:flex;flex-direction:column}.runway .layout .amenity-map-container,.runway .layout .layout-item{height:100%}.runway .mobile-header{background:#406750;height:80px;align-items:center;padding:15px}.runway .mobile-header .left-item{flex-grow:1}.runway .mobile-header .right-item a{color:#f1f1f1;font-size:24px;margin-left:10px}.runway .mobile-menu{z-index:99;width:100%;background:#406750;display:flex}.runway .mobile-menu div{width:100%}.runway .mobile-menu .menu-items{display:flex;align-items:center;width:100%}.runway .mobile-menu .menu-items .menu-item{display:flex;font-family:Gotham Book;color:#98b8ab;font-size:16px;text-transform:uppercase;text-align:center;cursor:pointer;width:100%;height:auto;text-decoration:none;align-items:center;margin-right:10px;padding:10px}.runway .mobile-menu .menu-items .menu-item.is-active{background:#c6d2be;color:#406750}.runway .mobile-menu .menu-items .menu-item img{width:20px;height:20px;margin-right:5px;margin-bottom:5px}.runway .is-hidden-x{display:none}.runway .is-hidden-t{display:block}.runway .selector{flex-wrap:wrap;margin:0 auto}.runway .container{padding-left:10px;padding-right:10px}.runway .uk-slider-items{justify-content:flex-start}.runway .uk-slider-items>.column{width:100%}.runway .uk-slider-items .home-card{margin:auto}}body.lb-disable-scrolling{overflow:hidden}.lightboxOverlay{position:absolute;top:0;left:0;z-index:9999;background-color:#000;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;display:none}.lightbox{position:absolute;left:0;width:100%;z-index:10000;text-align:center;line-height:0;font-weight:400;outline:none}.lightbox .lb-image{display:block;height:auto;max-width:inherit;max-height:none;border-radius:3px;border:4px solid #fff}.lightbox a img{border:none}.lb-outerContainer{position:relative;*zoom:1;width:250px;height:250px;margin:0 auto;border-radius:4px;background-color:#fff}.lb-outerContainer:after{content:\"\";display:table;clear:both}.lb-loader{position:absolute;top:43%;left:0;height:25%;width:100%;text-align:center;line-height:0}.lb-cancel{display:block;width:32px;height:32px;margin:0 auto;background:url(" + escape(__webpack_require__(315)) + ") no-repeat}.lb-nav{position:absolute;top:0;left:0;height:100%;width:100%;z-index:10}.lb-container>.nav{left:0}.lb-nav a{outline:none;background-image:url(\"data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==\")}.lb-next,.lb-prev{height:100%;cursor:pointer;display:block}.lb-nav a.lb-prev{width:34%;left:0;float:left;background:url(" + escape(__webpack_require__(316)) + ") left 48% no-repeat;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transition:opacity .6s;-moz-transition:opacity .6s;-o-transition:opacity .6s;transition:opacity .6s}.lb-nav a.lb-prev:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.lb-nav a.lb-next{width:64%;right:0;float:right;background:url(" + escape(__webpack_require__(317)) + ") right 48% no-repeat;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transition:opacity .6s;-moz-transition:opacity .6s;-o-transition:opacity .6s;transition:opacity .6s}.lb-nav a.lb-next:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.lb-dataContainer{margin:0 auto;padding-top:5px;*zoom:1;width:100%;border-bottom-left-radius:4px;border-bottom-right-radius:4px}.lb-dataContainer:after{content:\"\";display:table;clear:both}.lb-data{padding:0 4px;color:#ccc;font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif}.lb-data .lb-details{width:85%;float:left;text-align:left;line-height:1.1em}.lb-data .lb-caption{font-size:13px;font-weight:700;line-height:1em}.lb-data .lb-caption a{color:#4ae}.lb-data .lb-number{display:block;clear:left;padding-bottom:1em;font-size:12px;color:#999}.lb-data .lb-close{display:block;float:right;width:30px;height:30px;background:url(" + escape(__webpack_require__(318)) + ") 100% 0 no-repeat;text-align:right;outline:none;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;-webkit-transition:opacity .2s;-moz-transition:opacity .2s;-o-transition:opacity .2s;transition:opacity .2s}.lb-data .lb-close:hover{cursor:pointer;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.runway .package-detail-grid{font-family:verlag-book,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif;box-sizing:border-box;margin-bottom:40px}.runway .package-detail-grid .header-bar{box-shadow:0 .5em 1em -.125em hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.02);padding:5px 20px 15px}.runway .package-detail-grid .header-bar .header-container{display:flex;flex-wrap:wrap}.runway .package-detail-grid .header-bar .button{min-width:100px;text-transform:uppercase;padding:15px 21px;height:40px;margin-right:20px;margin-top:10px}.runway .package-detail-grid .title-section{margin-top:20px}.runway .package-detail-grid .box{padding:0}.runway .package-detail-grid .box .box-header{background:#406750;color:#fff;padding:12px 20px;font-family:verlag-black;text-transform:uppercase}.runway .package-detail-grid .box .box-body{padding:20px}.runway .package-detail-grid .facade-box.box{padding:0}.runway .package-detail-grid .facade-box img{display:block;width:100%}.runway .package-detail-grid .add-favorite{margin-top:20px;padding:20px;display:flex;background:#000;color:#fff;align-items:center;justify-content:center;cursor:pointer}.runway .package-detail-grid .add-favorite span{margin:0;padding:0;font-size:22px;line-height:normal}.runway .package-detail-grid .add-favorite i{margin-right:10px;font-size:22px}.runway .package-detail-grid .add-favorite.is-favorite{cursor:default;background:#303030}.runway .package-detail-grid .boxes{margin-top:20px}.runway .package-detail-grid .boxes table td{padding:5px 0}.runway .package-detail-grid .boxes table td:first-of-type{padding-right:35px}.runway .package-detail-grid .package-detail{padding:20px}.runway .package-detail-grid .package-detail .product{font-weight:100;text-transform:uppercase;font-size:32px;line-height:normal;margin:0;padding:0;font-family:Didot;color:#406750}.runway .package-detail-grid .package-detail .elevation{font-size:20px;text-transform:uppercase}.runway .package-detail-grid .package-detail .builder-name{font-weight:100;color:#333;text-transform:uppercase;font-size:18px;margin:0}.runway .package-detail-grid .package-detail .price{margin-top:10px;font-size:28px}.runway .package-detail-grid .package-detail .price .from{font-size:14px;text-transform:uppercase}.runway .package-detail-grid .package-detail .available-date{font-size:22px;color:#c6d2be;text-transform:uppercase;margin-top:10px}.runway .package-detail-grid .package-detail .address{color:#3c3c3c;font-size:22px}.runway .package-detail-grid .package-detail .lot-info{font-size:20px}.runway .package-detail-grid .package-detail .est-text{font-size:12px}.runway .package-detail-grid .package-detail .button{width:100%;font-size:18px}.runway .package-detail-grid .floorplan-section img{width:100%;height:auto;max-height:700px;display:block;margin:auto;object-fit:contain}.runway .package-detail-grid .amenities{display:flex;margin-left:20px;align-items:center}.runway .package-detail-grid .amenities .amenity{margin-right:10px;display:flex;align-items:center}.runway .package-detail-grid .amenities .amenity:last-of-type{margin-right:0}.runway .package-detail-grid .amenities .amenity span{margin-left:5px;font-size:20px}.runway .package-detail-grid .lot-fit-dimensions .dim-title{margin:0;padding:0;font-size:12px;text-transform:uppercase;color:#406750}.runway .package-detail-grid .lot-fit-dimensions .dim{font-size:22px}.runway .package-detail-grid .disclaimer-box .box-body{font-size:12px}.runway .package-detail-grid .interior-section img{object-fit:cover}.runway .package-detail-grid .gallery-section img{height:200px;width:100%;object-fit:cover;display:block}.runway .share-box{position:absolute;left:0;right:0;margin:auto;height:50px;padding:0;background:#000;border:1px solid #000;display:none;align-items:center;justify-content:space-evenly;top:50px;z-index:9;border-radius:5px}.runway .share-box a,.runway .share-box i{color:#fff;flex-grow:1;flex:1}.runway .share-box input{position:absolute;z-index:-999;opacity:0}.runway .share-box.is-visible{display:flex}.runway #linkcp{position:absolute;background:#000;color:#fff;padding:5px 10px;left:-7px!important;right:0;top:-50px;font-size:16px;margin:auto;z-index:99;border-radius:7px;text-align:center;width:fit-content;display:none}.runway #linkcp.is-visible{display:block}.runway .share-box:after{content:\"\";position:absolute;top:-11px;left:0;right:0;margin:auto;border-style:solid;border-color:#000 transparent;display:block;width:0;z-index:1;border-width:0 15px 15px}.runway .facade-list-page{padding:0;margin-top:20px}.runway .facade-list-page .container{display:flex}.runway .facade-list-page .info{padding:15px 20px;display:flex;font-size:20px;box-shadow:0 -2px 12px 1px rgba(0,0,0,.08)}.runway .facade-list-page .info .left-item{flex-grow:1;display:flex}.runway .facade-list-page .info .left-item p{color:#406750;font-size:28px;font-family:Didot}.runway .facade-list-page .info .left-item .amenities{display:flex;margin-left:20px;align-items:center}.runway .facade-list-page .info .left-item .amenities .amenity{margin-right:10px;display:flex;align-items:center}.runway .facade-list-page .info .left-item .amenities .amenity span{margin-left:5px}.runway .facade-list-page .info .left-item .amenities .amenity:last-of-type{margin-right:0}.runway .facade-list-page .info .right-item p{font-family:verlag-book;font-size:28px;color:#406750}.runway .facade-list-page .active-facade{position:relative}.runway .facade-list-page .active-facade img{display:block;max-height:600px;width:auto;object-fit:cover}.runway .facade-list-page .active-facade .facade-name{height:40px;position:absolute;bottom:-40px;background:#c6d2be;display:flex;align-items:center;right:0;cursor:pointer}.runway .facade-list-page .active-facade .facade-name:hover{color:#c6d2be;background:#406750}.runway .facade-list-page .active-facade .facade-name p{padding:0 20px}.runway .facade-list-page .active-facade .facade-name .icon{padding:0 20px;height:100%;background:#406750}.runway .facade-list-page .active-facade .facade-name .icon i{color:#fff}.runway .facade-list-page .facade-list{width:200px;margin-right:10px}.runway .facade-list-page .facade-list img{width:200px;height:auto;object-fit:cover;cursor:pointer;border:5px solid #fff}.runway .facade-list-page .facade-list img.is-active{border:5px solid #f6b468}@media only screen and (max-width:1024px){.runway .facade-list-page .container{display:flex;flex-direction:column-reverse}.runway .facade-list-page .container .facade-list{margin-top:10px;width:100%;margin-right:0;display:flex;flex-wrap:wrap}}.runway .header-image img{width:100%;height:auto;object-fit:contain;display:block}@-webkit-keyframes scale{50%{transform:scale(.99)}}@-webkit-keyframes opacity{0%{opacity:.2}50%{opacity:.4}to{opacity:.2}}.runway .journey-nav-container{background:#eef1eb}.runway .navigation-bar{display:flex;align-items:center;justify-content:space-evenly;padding:20px 0}.runway .navigation-bar .nav{display:flex;align-items:center;justify-content:center;font-family:Didot}.runway .navigation-bar .nav img{height:35px;width:40px;object-fit:contain}.runway .navigation-bar .nav svg{height:42px;width:auto}.runway .navigation-bar .nav text{text-transform:uppercase;font-size:21px}.runway .navigation-bar .nav .num,.runway .navigation-bar .nav circle,.runway .navigation-bar .nav path{opacity:0}.runway .navigation-bar .nav.prev{background-repeat:no-repeat;background-size:contain;opacity:.5;cursor:pointer}.runway .navigation-bar .nav.prev path{opacity:.5}.runway .navigation-bar .nav.prev .num,.runway .navigation-bar .nav.prev circle{opacity:1}.runway .navigation-bar .nav.current{background-repeat:no-repeat;background-size:contain}.runway .navigation-bar .nav.current .num,.runway .navigation-bar .nav.current circle,.runway .navigation-bar .nav.current path{opacity:1}.runway .navigation-bar .nav.next circle,.runway .navigation-bar .nav.next path{opacity:.3}.runway .navigation-bar .nav.next .num{opacity:1}.runway .navigation-bar .nav a{text-align:center;color:#585f6c}.runway .navigation-bar .nav a span{font-family:Didot;font-weight:700;line-height:normal;font-size:25px}@media screen and (max-width:800px){.runway .navigation-bar .nav,.runway .navigation-bar .nav img{display:none}.runway .navigation-bar .nav.current,.runway .navigation-bar .nav.next{display:block}.runway .navigation-bar .nav.prev{display:none}}@media screen and (max-width:600px){.runway .navigation-bar .nav.next,.runway .navigation-bar .nav.prev,.runway .navigation-bar .nav img{display:none}}.runway .slider-container{padding:20px;background:#406750}.runway .slider-container .title{color:#fff;text-transform:uppercase;font-size:16px;text-align:center;margin-bottom:10px}.runway .slider-container .r-column{padding:.75rem}.runway .slider-container .slidenav-buttons{position:relative;bottom:230px;color:#000;background-color:#fff;opacity:.7;border-radius:25px}.runway .slider-container .slidenav-left{left:1%}.runway .slider-container .slidenav-right{right:-95%}.runway .home-list .container{padding:0 20px}.runway .filter-section{margin-top:20px;margin-bottom:20px}.runway .filter-section .slider{min-width:300px}.runway .filter-section .buttons .button.is-active{background:#c6d2be;border-color:#c6d2be}.runway .back-box{display:flex;justify-content:center;margin-top:15px}.runway .back-box .button{margin:0 10px;padding:20px;overflow:hidden}.runway .home-detail{font-family:verlag-book,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif;box-sizing:border-box}.runway .home-detail .slider-container{margin-top:20px;margin-bottom:20px}.runway .home-detail .container{max-width:1100px}.runway .home-detail .title-section{margin-top:20px}.runway .home-detail .box{padding:0}.runway .home-detail .box .box-header{background:#406750;color:#fff;padding:12px 20px;font-family:verlag-black;text-transform:uppercase}.runway .home-detail .box .box-body{padding:20px}.runway .home-detail .facade-box.box{padding:0}.runway .home-detail .facade-box img{display:block;width:100%}.runway .home-detail .add-favorite{margin-top:20px;padding:20px;display:flex;background:#000;color:#fff;align-items:center;justify-content:center;cursor:pointer}.runway .home-detail .add-favorite span{margin:0;padding:0;font-size:22px;line-height:normal}.runway .home-detail .add-favorite i{margin-right:10px;font-size:22px}.runway .home-detail .add-favorite.is-favorite{cursor:default;background:#303030}.runway .home-detail .boxes{margin-top:20px}.runway .home-detail .boxes table td{padding:5px 0}.runway .home-detail .boxes table td:first-of-type{padding-right:35px}.runway .home-detail .package-detail{padding:20px}.runway .home-detail .package-detail .product{font-weight:100;text-transform:uppercase;font-size:32px;line-height:normal;margin:0;padding:0;font-family:Didot;color:#406750}.runway .home-detail .package-detail .elevation{font-size:20px;text-transform:uppercase}.runway .home-detail .package-detail .builder-name{font-weight:100;color:#333;text-transform:uppercase;font-size:18px;margin:0}.runway .home-detail .package-detail .price{margin-top:10px;font-size:28px}.runway .home-detail .package-detail .price .from{font-size:14px;text-transform:uppercase}.runway .home-detail .package-detail .available-date{font-size:22px;color:#c6d2be;text-transform:uppercase;margin-top:10px}.runway .home-detail .package-detail .address{color:#3c3c3c;font-size:22px}.runway .home-detail .package-detail .lot-info{font-size:20px}.runway .home-detail .package-detail .est-text{font-size:12px}.runway .home-detail .package-detail .button{width:100%;font-size:18px}.runway .home-detail .floorplan-section img{width:100%;height:auto;max-height:700px;display:block;margin:auto;object-fit:contain}.runway .home-detail .amenities{display:flex;margin-left:20px;align-items:center}.runway .home-detail .amenities .amenity{margin-right:10px;display:flex;align-items:center}.runway .home-detail .amenities .amenity:last-of-type{margin-right:0}.runway .home-detail .amenities .amenity span{margin-left:5px;font-size:20px}.runway .home-detail .lot-fit-dimensions .dim-title{margin:0;padding:0;font-size:12px;text-transform:uppercase;color:#406750}.runway .home-detail .lot-fit-dimensions .dim{font-size:22px}.runway .home-detail .disclaimer-box .box-body{font-size:12px}.runway .home-detail .interior-section img{object-fit:cover}.runway .home-detail .gallery-section img{height:200px;width:100%;object-fit:cover;display:block}.runway .spechomes-list .filter-section{margin-top:20px}.runway .favorites-modal .modal-close{z-index:999;background:#d3624f}.runway .favorites-container .container{margin-top:40px}.runway .favorites-page .map{height:calc(100vh - 50px)}.runway .favorites-page .direction-panel{width:250px;height:calc(100vh - 50px);background:#c6d2be;padding:20px}.runway .favorites-page .direction-panel .heading{display:flex}.runway .favorites-page .direction-panel .heading p{font-size:20px;font-family:Didot;font-weight:500;text-transform:none;color:#406750}.runway .favorites-page .direction-panel .table{margin-top:20px;background:#fff}.runway .favorites-page .direction-panel .table td{padding:8px}.runway .favorites-page .direction-panel .table img{height:auto;width:60px;object-fit:contain}.runway .cards-list{width:350px;height:calc(100vh - 60px);position:relative}.runway .cards-list .list-nav{display:flex;align-items:center;justify-content:space-between}.runway .cards-list .list-nav p{font-size:20px;font-family:Didot}.runway .cards-list .cards{height:100%;padding:15px;overflow-y:scroll}.runway .package-card{margin-bottom:10px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.runway .package-card .facade-image{position:relative}.runway .package-card .facade-image img{object-fit:cover}.runway .package-card .facade-image .marker-overlay{position:absolute;top:5px;height:30px;width:30px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:#406750}.runway .package-card .facade-image .marker-overlay.left{left:5px}.runway .package-card .facade-image .marker-overlay.right{right:5px}.runway .package-card .facade-image .marker-overlay a i{color:#fff}.runway .package-card .facade-image .marker-overlay.is-active{background:#f62}.runway .package-card .card-info{padding:10px}.runway .package-card .card-info .columns{margin-bottom:10px}.runway .package-card .card-info .amenities{display:flex;align-items:center}.runway .package-card .card-info .amenities .amenity{margin-right:10px;display:flex;align-items:center}.runway .package-card .card-info .amenities .amenity:last-of-type{margin-right:0}.runway .package-card .card-info .amenities .amenity img{margin-right:5px}.runway .package-card .card-info .amenities .amenity span{font-size:13px;font-weight:500;line-height:normal}.runway .package-card .card-info .design{line-height:normal}.runway .package-card .card-info .design .design{font-family:Didot;font-size:20px;color:#406750}.runway .package-card .card-info .design .facade{font-size:13px}.runway .package-card .card-info .price{margin:3px 0;text-align:right}.runway .package-card .card-info .price .f{font-size:11px;text-transform:uppercase;text-align:right}.runway .package-card .card-info .price .p{font-size:30px;color:#406750;font-weight:500;text-align:right}.runway .package-card .card-info .dimension{margin-bottom:10px;line-height:normal}.runway .package-card .card-info .dimension:last-of-type{margin-bottom:0}.runway .package-card .card-info .dimension .t{font-size:11px;color:#406750;font-weight:500;text-transform:uppercase}.runway .package-card .card-info .dimension .d{font-size:22px;font-weight:500}.runway .package-card .card-info .dimension .d small{font-size:12px}.runway .enquire-modal .box{background:#fff}.runway .enquire-modal .box h4{font-size:22px;font-family:Didot;margin-bottom:20px}.runway .enquire-modal .box .input{background:hsla(39,80%,66%,.9);border:none;border-radius:0;color:#333}.runway .enquire-modal .box .button{text-transform:uppercase}.runway .enquire-modal .box .radio{display:flex;align-items:center;min-height:25px}.runway .enquire-modal .box .radio input{margin-right:10px}.runway .enquire-modal .box .radio+.radio{margin-left:0}.runway .enquire-modal .box .radio-group{background:hsla(39,80%,66%,.9);padding:5px}.runway .enquire-modal .box .select{border-radius:0;color:#333}.runway .enquire-modal .box .select select{border-radius:0;background:hsla(39,80%,66%,.9);border:0}", ""]);

// exports


/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Gotham-Book.otf?9019ab71e2d2d6cc3c9f4140cb27a618";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Verlag-Book.otf?ea144141cb709880612a4ec9348c2d7c";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Verlag-Bold.otf?8c4f8f796dd04103f26d9a0baf919122";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Verlag-Black.otf?0f6863f88ee91bfe5a83a1363acfbb76";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Didot.woff?2c3c92fd54e35dc99bdb7a98e1cb0f3c";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Didot-Bold.woff?c5bdeb74785d703994268addb8f066d4";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "border.png?f8a0d25c7e28e88294b72605e11bd309";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "loading.gif?2299ad0b3f63413f026dfec20c205b8f";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "prev.png?84b76dee6b27b795e89e3649078a11c2";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "next.png?31f15875975aab69085470aabbfec802";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "close.png?d9d2d0b1308cb694aa8116915592e2a9";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(320)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 320 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js